webpackJsonp([0],{

/***/ "++Dq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSEigenleistungKubikmeterDaten = /** @class */ (function (_super) {
    __extends(TSEigenleistungKubikmeterDaten, _super);
    function TSEigenleistungKubikmeterDaten() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._deleted = false;
        return _this;
    }
    Object.defineProperty(TSEigenleistungKubikmeterDaten.prototype, "kubikmeter", {
        get: function () {
            return this._kubikmeter;
        },
        set: function (value) {
            this._kubikmeter = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistungKubikmeterDaten.prototype, "betrag", {
        get: function () {
            return this._betrag;
        },
        set: function (value) {
            this._betrag = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistungKubikmeterDaten.prototype, "deleted", {
        get: function () {
            return this._deleted;
        },
        set: function (value) {
            this._deleted = value;
        },
        enumerable: true,
        configurable: true
    });
    TSEigenleistungKubikmeterDaten.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.kubikmeter = restObject.kubikmeter;
        this.betrag = restObject.betrag;
        this.deleted = restObject.deleted;
        return this;
    };
    TSEigenleistungKubikmeterDaten.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.kubikmeter = this.kubikmeter;
        restObject.betrag = this.betrag;
        restObject.deleted = this.deleted;
        return restObject;
    };
    TSEigenleistungKubikmeterDaten.getDeserializer = function (eigenleistung) {
        return new TSEigenleistungKubikmeterDaten().deserialize(eigenleistung);
    };
    TSEigenleistungKubikmeterDaten.getSerializer = function (eigenleistung) {
        return eigenleistung.serialize(eigenleistung);
    };
    return TSEigenleistungKubikmeterDaten;
}(TSAbstractEntity_1.default));
exports.default = TSEigenleistungKubikmeterDaten;


/***/ }),

/***/ "+0wl":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("WMNn");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-status-change-history-list.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-status-change-history-list.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "+4Yc":
/***/ (function(module, exports) {

module.exports = "<div class=\"dv-accordion-tab-title\" ng-click=\"vmt.vma.toggleTab(vmt.tabid)\" ng-class=\"{'tab-open': vmt.vma.isTagOpen(vmt.tabid), 'tab-close': !vmt.vma.isTagOpen(vmt.tabid)}\" ng-transclude=\"title\"> {{vmt.title}} </div> <div class=\"dv-accordion-tab-content\" ng-show=\"vmt.vma.isTagOpen(vmt.tabid)\" ng-transclude=\"body\"> </div> ";

/***/ }),

/***/ "+5XP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSBegruendungsCode;
(function (TSBegruendungsCode) {
    TSBegruendungsCode[TSBegruendungsCode["BG_1"] = 'BG_1'] = "BG_1";
    TSBegruendungsCode[TSBegruendungsCode["BG_10"] = 'BG_10'] = "BG_10";
    TSBegruendungsCode[TSBegruendungsCode["BG_11"] = 'BG_11'] = "BG_11";
    TSBegruendungsCode[TSBegruendungsCode["BG_12"] = 'BG_12'] = "BG_12";
    TSBegruendungsCode[TSBegruendungsCode["BG_13"] = 'BG_13'] = "BG_13";
    TSBegruendungsCode[TSBegruendungsCode["BG_14"] = 'BG_14'] = "BG_14";
    TSBegruendungsCode[TSBegruendungsCode["BG_15"] = 'BG_15'] = "BG_15";
    TSBegruendungsCode[TSBegruendungsCode["BG_16"] = 'BG_16'] = "BG_16";
    TSBegruendungsCode[TSBegruendungsCode["BG_17"] = 'BG_17'] = "BG_17";
    TSBegruendungsCode[TSBegruendungsCode["BG_18"] = 'BG_18'] = "BG_18";
    TSBegruendungsCode[TSBegruendungsCode["BG_19"] = 'BG_19'] = "BG_19";
    TSBegruendungsCode[TSBegruendungsCode["BG_20"] = 'BG_20'] = "BG_20";
    TSBegruendungsCode[TSBegruendungsCode["BG_21"] = 'BG_21'] = "BG_21";
    TSBegruendungsCode[TSBegruendungsCode["BG_22"] = 'BG_22'] = "BG_22";
    TSBegruendungsCode[TSBegruendungsCode["BG_23"] = 'BG_23'] = "BG_23";
    TSBegruendungsCode[TSBegruendungsCode["BG_24"] = 'BG_24'] = "BG_24";
    TSBegruendungsCode[TSBegruendungsCode["BG_25"] = 'BG_25'] = "BG_25";
    TSBegruendungsCode[TSBegruendungsCode["BG_26"] = 'BG_26'] = "BG_26";
    TSBegruendungsCode[TSBegruendungsCode["BG_27"] = 'BG_27'] = "BG_27";
    TSBegruendungsCode[TSBegruendungsCode["BG_28"] = 'BG_28'] = "BG_28";
    TSBegruendungsCode[TSBegruendungsCode["BG_29"] = 'BG_29'] = "BG_29";
    TSBegruendungsCode[TSBegruendungsCode["BG_30"] = 'BG_30'] = "BG_30";
    TSBegruendungsCode[TSBegruendungsCode["BG_31"] = 'BG_31'] = "BG_31";
    TSBegruendungsCode[TSBegruendungsCode["BG_32"] = 'BG_32'] = "BG_32";
    TSBegruendungsCode[TSBegruendungsCode["BG_33"] = 'BG_33'] = "BG_33";
    TSBegruendungsCode[TSBegruendungsCode["BG_34"] = 'BG_34'] = "BG_34";
    TSBegruendungsCode[TSBegruendungsCode["BG_35"] = 'BG_35'] = "BG_35";
    TSBegruendungsCode[TSBegruendungsCode["BG_36"] = 'BG_36'] = "BG_36";
    TSBegruendungsCode[TSBegruendungsCode["BG_37"] = 'BG_37'] = "BG_37";
    TSBegruendungsCode[TSBegruendungsCode["BG_38"] = 'BG_38'] = "BG_38";
    TSBegruendungsCode[TSBegruendungsCode["BG_39"] = 'BG_39'] = "BG_39";
    TSBegruendungsCode[TSBegruendungsCode["BG_40"] = 'BG_40'] = "BG_40";
    TSBegruendungsCode[TSBegruendungsCode["BG_41"] = 'BG_41'] = "BG_41";
    TSBegruendungsCode[TSBegruendungsCode["BG_42"] = 'BG_42'] = "BG_42";
    TSBegruendungsCode[TSBegruendungsCode["BG_45"] = 'BG_45'] = "BG_45";
    TSBegruendungsCode[TSBegruendungsCode["BG_46"] = 'BG_46'] = "BG_46";
    TSBegruendungsCode[TSBegruendungsCode["BG_47"] = 'BG_47'] = "BG_47";
    TSBegruendungsCode[TSBegruendungsCode["BG_48"] = 'BG_48'] = "BG_48";
    TSBegruendungsCode[TSBegruendungsCode["BG_49"] = 'BG_49'] = "BG_49";
    TSBegruendungsCode[TSBegruendungsCode["BG_50"] = 'BG_50'] = "BG_50";
    TSBegruendungsCode[TSBegruendungsCode["BG_52"] = 'BG_52'] = "BG_52";
    TSBegruendungsCode[TSBegruendungsCode["BG_54"] = 'BG_54'] = "BG_54";
    TSBegruendungsCode[TSBegruendungsCode["BG_55"] = 'BG_55'] = "BG_55";
    TSBegruendungsCode[TSBegruendungsCode["BG_56"] = 'BG_56'] = "BG_56";
    TSBegruendungsCode[TSBegruendungsCode["BG_57"] = 'BG_57'] = "BG_57";
    TSBegruendungsCode[TSBegruendungsCode["BG_58"] = 'BG_58'] = "BG_58";
    TSBegruendungsCode[TSBegruendungsCode["BG_59"] = 'BG_59'] = "BG_59";
    TSBegruendungsCode[TSBegruendungsCode["BG_80"] = 'BG_80'] = "BG_80";
    TSBegruendungsCode[TSBegruendungsCode["BG_81"] = 'BG_81'] = "BG_81";
    TSBegruendungsCode[TSBegruendungsCode["BG_82"] = 'BG_82'] = "BG_82";
    TSBegruendungsCode[TSBegruendungsCode["BG_83"] = 'BG_83'] = "BG_83";
    TSBegruendungsCode[TSBegruendungsCode["BG_84"] = 'BG_84'] = "BG_84";
    TSBegruendungsCode[TSBegruendungsCode["BG_85"] = 'BG_85'] = "BG_85";
    TSBegruendungsCode[TSBegruendungsCode["BG_86"] = 'BG_86'] = "BG_86";
    TSBegruendungsCode[TSBegruendungsCode["BG_62"] = 'BG_62'] = "BG_62";
    TSBegruendungsCode[TSBegruendungsCode["BG_76"] = 'BG_76'] = "BG_76";
    TSBegruendungsCode[TSBegruendungsCode["BG_66"] = 'BG_66'] = "BG_66";
    TSBegruendungsCode[TSBegruendungsCode["BG_69"] = 'BG_69'] = "BG_69";
    TSBegruendungsCode[TSBegruendungsCode["BG_70"] = 'BG_70'] = "BG_70";
    TSBegruendungsCode[TSBegruendungsCode["BG_71"] = 'BG_71'] = "BG_71";
    TSBegruendungsCode[TSBegruendungsCode["BG_72"] = 'BG_72'] = "BG_72";
    TSBegruendungsCode[TSBegruendungsCode["BG_73"] = 'BG_73'] = "BG_73";
    TSBegruendungsCode[TSBegruendungsCode["BG_74"] = 'BG_74'] = "BG_74";
    TSBegruendungsCode[TSBegruendungsCode["BG_75"] = 'BG_75'] = "BG_75";
    TSBegruendungsCode[TSBegruendungsCode["BG_79"] = 'BG_79'] = "BG_79";
    TSBegruendungsCode[TSBegruendungsCode["BG_87"] = 'BG_87'] = "BG_87";
    TSBegruendungsCode[TSBegruendungsCode["BG_90"] = 'BG_90'] = "BG_90";
    TSBegruendungsCode[TSBegruendungsCode["BG_91"] = 'BG_91'] = "BG_91";
    TSBegruendungsCode[TSBegruendungsCode["BG_92"] = 'BG_92'] = "BG_92";
    TSBegruendungsCode[TSBegruendungsCode["BG_93"] = 'BG_93'] = "BG_93";
    TSBegruendungsCode[TSBegruendungsCode["BG_95"] = 'BG_95'] = "BG_95";
    TSBegruendungsCode[TSBegruendungsCode["BG_98"] = 'BG_98'] = "BG_98";
    /****************** Neue Begründungscodes ********************/
    TSBegruendungsCode[TSBegruendungsCode["BGN_10"] = 'BGN_10'] = "BGN_10";
    TSBegruendungsCode[TSBegruendungsCode["BGN_11"] = 'BGN_11'] = "BGN_11";
    TSBegruendungsCode[TSBegruendungsCode["BGN_12"] = 'BGN_12'] = "BGN_12";
    TSBegruendungsCode[TSBegruendungsCode["BGN_20"] = 'BGN_20'] = "BGN_20";
    TSBegruendungsCode[TSBegruendungsCode["BGN_21"] = 'BGN_21'] = "BGN_21";
    TSBegruendungsCode[TSBegruendungsCode["BGN_22"] = 'BGN_22'] = "BGN_22";
    TSBegruendungsCode[TSBegruendungsCode["BGN_23"] = 'BGN_23'] = "BGN_23";
    TSBegruendungsCode[TSBegruendungsCode["BGN_30"] = 'BGN_30'] = "BGN_30";
    TSBegruendungsCode[TSBegruendungsCode["BGN_31"] = 'BGN_31'] = "BGN_31";
    TSBegruendungsCode[TSBegruendungsCode["BGN_32"] = 'BGN_32'] = "BGN_32";
    TSBegruendungsCode[TSBegruendungsCode["BGN_33"] = 'BGN_33'] = "BGN_33";
    TSBegruendungsCode[TSBegruendungsCode["BGN_34"] = 'BGN_34'] = "BGN_34";
    TSBegruendungsCode[TSBegruendungsCode["BGN_40"] = 'BGN_40'] = "BGN_40";
    TSBegruendungsCode[TSBegruendungsCode["BGN_41"] = 'BGN_41'] = "BGN_41";
    TSBegruendungsCode[TSBegruendungsCode["BGN_42"] = 'BGN_42'] = "BGN_42";
    TSBegruendungsCode[TSBegruendungsCode["BGN_43"] = 'BGN_43'] = "BGN_43";
    TSBegruendungsCode[TSBegruendungsCode["BGN_60"] = 'BGN_60'] = "BGN_60";
    TSBegruendungsCode[TSBegruendungsCode["BGN_61"] = 'BGN_61'] = "BGN_61";
    TSBegruendungsCode[TSBegruendungsCode["BGN_62"] = 'BGN_62'] = "BGN_62";
    TSBegruendungsCode[TSBegruendungsCode["BGN_63"] = 'BGN_63'] = "BGN_63";
    TSBegruendungsCode[TSBegruendungsCode["BGN_64"] = 'BGN_64'] = "BGN_64";
    TSBegruendungsCode[TSBegruendungsCode["BGN_65"] = 'BGN_65'] = "BGN_65";
    TSBegruendungsCode[TSBegruendungsCode["BGN_66"] = 'BGN_66'] = "BGN_66";
    TSBegruendungsCode[TSBegruendungsCode["BGN_67"] = 'BGN_67'] = "BGN_67";
    TSBegruendungsCode[TSBegruendungsCode["BGN_68"] = 'BGN_68'] = "BGN_68";
    TSBegruendungsCode[TSBegruendungsCode["BGN_69"] = 'BGN_69'] = "BGN_69";
    TSBegruendungsCode[TSBegruendungsCode["BGN_70"] = 'BGN_70'] = "BGN_70";
    TSBegruendungsCode[TSBegruendungsCode["BGN_71"] = 'BGN_71'] = "BGN_71";
    TSBegruendungsCode[TSBegruendungsCode["BGN_72"] = 'BGN_72'] = "BGN_72";
    TSBegruendungsCode[TSBegruendungsCode["BGN_73"] = 'BGN_73'] = "BGN_73";
    TSBegruendungsCode[TSBegruendungsCode["BGN_80"] = 'BGN_80'] = "BGN_80";
    TSBegruendungsCode[TSBegruendungsCode["BGN_81"] = 'BGN_81'] = "BGN_81";
    TSBegruendungsCode[TSBegruendungsCode["BGN_82"] = 'BGN_82'] = "BGN_82";
    TSBegruendungsCode[TSBegruendungsCode["BGN_90"] = 'BGN_90'] = "BGN_90";
    TSBegruendungsCode[TSBegruendungsCode["BGN_91"] = 'BGN_91'] = "BGN_91";
    TSBegruendungsCode[TSBegruendungsCode["BGN_92"] = 'BGN_92'] = "BGN_92";
    TSBegruendungsCode[TSBegruendungsCode["BGN_93"] = 'BGN_93'] = "BGN_93";
    TSBegruendungsCode[TSBegruendungsCode["BGN_94"] = 'BGN_94'] = "BGN_94";
})(TSBegruendungsCode = exports.TSBegruendungsCode || (exports.TSBegruendungsCode = {}));
function getCodesFS() {
    return [
        TSBegruendungsCode.BGN_10,
        TSBegruendungsCode.BGN_11,
        TSBegruendungsCode.BGN_12,
        TSBegruendungsCode.BGN_20,
        TSBegruendungsCode.BGN_21,
        TSBegruendungsCode.BGN_22,
        TSBegruendungsCode.BGN_23,
        TSBegruendungsCode.BGN_30,
        TSBegruendungsCode.BGN_31,
        TSBegruendungsCode.BGN_32,
        TSBegruendungsCode.BGN_33,
        TSBegruendungsCode.BGN_34,
        TSBegruendungsCode.BGN_40,
        TSBegruendungsCode.BGN_41,
        TSBegruendungsCode.BGN_42,
        TSBegruendungsCode.BGN_43,
        TSBegruendungsCode.BGN_60,
        TSBegruendungsCode.BGN_61,
        TSBegruendungsCode.BGN_62,
        TSBegruendungsCode.BGN_63,
        TSBegruendungsCode.BGN_64,
        TSBegruendungsCode.BGN_65,
        TSBegruendungsCode.BGN_66,
        TSBegruendungsCode.BGN_67,
        TSBegruendungsCode.BGN_68,
        TSBegruendungsCode.BGN_69,
        TSBegruendungsCode.BGN_70,
        TSBegruendungsCode.BGN_71,
        TSBegruendungsCode.BGN_72,
        TSBegruendungsCode.BGN_73,
        TSBegruendungsCode.BGN_80,
        TSBegruendungsCode.BGN_81,
        TSBegruendungsCode.BGN_82,
        TSBegruendungsCode.BGN_90,
        TSBegruendungsCode.BGN_91,
        TSBegruendungsCode.BGN_92,
        TSBegruendungsCode.BGN_93,
        TSBegruendungsCode.BGN_94,
    ];
}
exports.getCodesFS = getCodesFS;
function getTSBegruendungsCode() {
    return [
        TSBegruendungsCode.BG_1,
        TSBegruendungsCode.BG_10,
        TSBegruendungsCode.BG_11,
        TSBegruendungsCode.BG_12,
        TSBegruendungsCode.BG_13,
        TSBegruendungsCode.BG_14,
        TSBegruendungsCode.BG_15,
        TSBegruendungsCode.BG_16,
        TSBegruendungsCode.BG_17,
        TSBegruendungsCode.BG_18,
        TSBegruendungsCode.BG_19,
        TSBegruendungsCode.BG_20,
        TSBegruendungsCode.BG_21,
        TSBegruendungsCode.BG_22,
        TSBegruendungsCode.BG_23,
        TSBegruendungsCode.BG_24,
        TSBegruendungsCode.BG_25,
        TSBegruendungsCode.BG_26,
        TSBegruendungsCode.BG_27,
        TSBegruendungsCode.BG_28,
        TSBegruendungsCode.BG_29,
        TSBegruendungsCode.BG_30,
        TSBegruendungsCode.BG_31,
        TSBegruendungsCode.BG_32,
        TSBegruendungsCode.BG_33,
        TSBegruendungsCode.BG_34,
        TSBegruendungsCode.BG_35,
        TSBegruendungsCode.BG_36,
        TSBegruendungsCode.BG_37,
        TSBegruendungsCode.BG_38,
        TSBegruendungsCode.BG_39,
        TSBegruendungsCode.BG_40,
        TSBegruendungsCode.BG_41,
        TSBegruendungsCode.BG_42,
        TSBegruendungsCode.BG_45,
        TSBegruendungsCode.BG_46,
        TSBegruendungsCode.BG_47,
        TSBegruendungsCode.BG_48,
        TSBegruendungsCode.BG_49,
        TSBegruendungsCode.BG_50,
        TSBegruendungsCode.BG_52,
        TSBegruendungsCode.BG_54,
        TSBegruendungsCode.BG_55,
        TSBegruendungsCode.BG_56,
        TSBegruendungsCode.BG_57,
        TSBegruendungsCode.BG_58,
        TSBegruendungsCode.BG_59,
        TSBegruendungsCode.BG_80,
        TSBegruendungsCode.BG_81,
        TSBegruendungsCode.BG_82,
        TSBegruendungsCode.BG_83,
        TSBegruendungsCode.BG_84,
        TSBegruendungsCode.BG_85,
        TSBegruendungsCode.BG_86,
        TSBegruendungsCode.BG_62,
        TSBegruendungsCode.BG_76,
        TSBegruendungsCode.BG_66,
        TSBegruendungsCode.BG_69,
        TSBegruendungsCode.BG_70,
        TSBegruendungsCode.BG_71,
        TSBegruendungsCode.BG_72,
        TSBegruendungsCode.BG_73,
        TSBegruendungsCode.BG_74,
        TSBegruendungsCode.BG_75,
        TSBegruendungsCode.BG_79,
        TSBegruendungsCode.BG_87,
        TSBegruendungsCode.BG_90,
        TSBegruendungsCode.BG_91,
        TSBegruendungsCode.BG_92,
        TSBegruendungsCode.BG_93,
        TSBegruendungsCode.BG_95,
        TSBegruendungsCode.BG_98,
    ];
}
exports.getTSBegruendungsCode = getTSBegruendungsCode;
function begruendungsCodePrefix() {
    return 'TSBegruendungsCode_';
}
exports.begruendungsCodePrefix = begruendungsCodePrefix;
function begruendungsCodeShortPostfix() {
    return '_kurz';
}
exports.begruendungsCodeShortPostfix = begruendungsCodeShortPostfix;
function begruendungsCodeLongPostfix() {
    return '_lang';
}
exports.begruendungsCodeLongPostfix = begruendungsCodeLongPostfix;


/***/ }),

/***/ "+9RC":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("v/cP");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./cockpit.module.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./cockpit.module.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "+CD4":
/***/ (function(module, exports) {

module.exports = "<ng-map map-type-id=\"HYBRID\" map-type-control-options=\"{mapTypeIds: ['HYBRID', 'TERRAIN'], style: 'DEFAULT'}\" zoom=\"{{vm.getZoom()}}\" on-click=\"vm.addMarker(vm)\" center=\"{{vm.getCenter()}}\" map-initialized=\"vm.onMapLoaded()\" street-view-control=\"false\" default-style=\"true\"> <marker ng-repeat=\"p in vm.positions\" position=\"{{p.pos}}\" title=\"pos: {{p.pos}}\" draggable=\"true\" on-dragend=\"vm.addMarker(vm)\"></marker> </ng-map> ";

/***/ }),

/***/ "+E2v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var template = __webpack_require__("Dw14");
__webpack_require__("Qf4C");
var DvInputContainerComponentConfig = /** @class */ (function () {
    function DvInputContainerComponentConfig() {
        this.transclude = true;
        this.template = template;
        this.controller = DvInputContainerController;
        this.controllerAs = 'vm';
    }
    return DvInputContainerComponentConfig;
}());
exports.DvInputContainerComponentConfig = DvInputContainerComponentConfig;
var DvInputContainerController = /** @class */ (function () {
    /* @ngInject */
    function DvInputContainerController() {
    }
    DvInputContainerController.$inject = [];
    return DvInputContainerController;
}());
exports.DvInputContainerController = DvInputContainerController;


/***/ }),

/***/ "+MRX":
/***/ (function(module, exports) {

module.exports = "<div class=\"{{vm.clazz}}\" ng-form=\"inputForm\"> <dv-input-container> <label for=\"{{vm.name}}\" class=\"md-no-float\" data-translate=\"{{vm.label}}\"></label> <input name=\"{{vm.name}}\" id=\"{{vm.name}}\" ng-model=\"vm.model\" class=\"form-control\" dv-max-length ng-required=\"vm.valueRequired\" placeholder=\"{{vm.placeholder}}\" ng-pattern=\"vm.inputPattern\"/> <dv-error-messages for=\"inputForm[vm.name]\"></dv-error-messages> <dv-bisher ng-if=\"vm.showBisher()\" gs=\"vm.bisherGs\" fs=\"vm.bisherFs\" for=\"inputForm[vm.name]\" property=\"{{vm.bisherProperty}}\"></dv-bisher> </dv-input-container> </div> ";

/***/ }),

/***/ "+Rne":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header modal-header--map\"> <h2 class=\"modal-title\" data-translate=\"SET_MARKER\" ng-if=\"!vm.reado\"></h2> <h2 class=\"modal-title\" data-translate=\"SET_MARKER_READONLY\" ng-if=\"vm.reado\"></h2> <span data-translate=\"MAP_HELPTEXT\" ng-if=\"!vm.reado\"></span> </div> <div class=\"modal-body modal-body--map\"> <dv-geoadmin-map lat=\"vm.lat\" lon=\"vm.lon\" on-edit=\"vm.positionChanged(lon, lat)\" readonly=\"vm.reado\"></dv-geoadmin-map> </div> <div class=\"modal-footer modal-footer--map\"> <button class=\"btn btn-serf\" ng-click=\"vm.ok()\" ng-if=\"!vm.reado\"> <span data-translate=\"OK\"></span> </button> <button class=\"btn btn-serf\" ng-click=\"vm.cancel()\" ng-if=\"vm.reado\"> <span data-translate=\"ZURUECK\"></span> </button> </div> ";

/***/ }),

/***/ "+agi":
/***/ (function(module, exports) {

module.exports = "<div class=\"dummyAuthentication-view row\"> <h3 class=\"col-md-5 col-md-offset-3\"> Wählen Sie bitte einen Benutzer aus. </h3> <div class=\"col-md-5 col-md-offset-3\"> <div class=\"first-row panel panel-default\" ng-repeat=\"user in vm.usersList\"> <div class=\"mark-hover panel-body\" ng-click=\"vm.logIn(user)\" ng-bind=\"user.vorname + ' ' + user.nachname + ', ' + user.email + ', ' + 'Rolle ' + (user.getRoleKey() | translate) + ' '\n                          + user.institution.name + user.traegerschaft.name\"></div> </div> <div class=\"first-row panel panel-default\"> <div class=\"mark-hover panel-body\" ng-click=\"vm.logIn(vm.superadmin)\" ng-hide=\"!vm.devMode\" ng-bind=\"vm.superadmin.vorname + ' ' + vm.superadmin.nachname + ', ' + vm.superadmin.email + ', ' + 'Rolle ' + (vm.superadmin.getRoleKey() | translate) + ' '\n                          + vm.superadmin.institution.name + vm.superadmin.traegerschaft.name\"></div> </div> </div> </div> ";

/***/ }),

/***/ "+c/h":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "dv-zahlungsauftrag-list .header-row{white-space:nowrap}dv-zahlungsauftrag-list:focus{outline:none}", ""]);

// exports


/***/ }),

/***/ "+hxN":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("mhZf");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./zahlungen.module.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./zahlungen.module.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "+iIj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("K/3j");
var DVGemeindeTypeaheadComponentConfig = /** @class */ (function () {
    function DVGemeindeTypeaheadComponentConfig() {
        this.transclude = false;
        this.bindings = {
            selectedGemeinde: '=',
            inputName: '@?',
            inputPlaceholder: '@?',
            label: '@',
            clazz: '@',
            ngRequired: '<',
            bisherFs: '<?',
            bisherGs: '<?',
            excludeKantonGr: '<?'
        };
        this.template = __webpack_require__("JriT");
        this.controller = DvGemTypeaheadController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return DVGemeindeTypeaheadComponentConfig;
}());
exports.DVGemeindeTypeaheadComponentConfig = DVGemeindeTypeaheadComponentConfig;
var DvGemTypeaheadController = /** @class */ (function () {
    function DvGemTypeaheadController($log, $q, gemeindeRS) {
        this.$log = $log;
        this.$q = $q;
        this.gemeindeRS = gemeindeRS;
        this.valueRequired = true; // default required
    }
    DvGemTypeaheadController.prototype.$onInit = function () {
        if (this.ngRequired !== undefined) {
            this.valueRequired = this.ngRequired;
        }
    };
    DvGemTypeaheadController.prototype.loadSuggestElements = function (searchString) {
        return this.gemeindeRS.readGemeindeSuggestion(searchString, this.excludeKantonGr).then(function (response) {
            return response;
        });
    };
    DvGemTypeaheadController.prototype.showBisher = function () {
        return (this.bisherFs !== undefined && this.bisherGs !== undefined);
    };
    DvGemTypeaheadController.$inject = ['$log', '$q', 'GemeindeRS'];
    return DvGemTypeaheadController;
}());
exports.DvGemTypeaheadController = DvGemTypeaheadController;


/***/ }),

/***/ "+wrW":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("DXk2");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-alert-box.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-alert-box.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "/8We":
/***/ (function(module, exports) {

module.exports = "<div class=\"container benutzerverwaltung-view\"> <div class=\"row add-button-buffer\"> <div class=\"col-md-12\"> <button ng-click=\"vm.addBenutzer()\" ui-sref=\"benutzereditanlaufstelle({anlaufstelleId: vm.selectedAnlaufstelle.id})\" class=\"btn btn-serf-red\"> <span class=\"fa fa-plus btn-ico\"></span> <span data-translate=\"BENUTZERVERWALTUNG_ADD\"> </span> </button> </div> </div> <div class=\"row\"> <div class=\"col-md-12\"> <h2> <span data-translate=\"BENUTZERVERWALTUNG_ANLAUFSTELLE_VERWALTER\"></span> <span ng-if=\"vm.hasExactlyOneAllowedAnnahmestelle() == true\" ng-bind=\"vm.allowedAnlaufstellen[0].name\"></span> </h2> </div> </div> <div class=\"row\" ng-if=\"vm.hasExactlyOneAllowedAnnahmestelle() == false\"> <div class=\"col-md-6\"> <div class=\"form-group\"> <label data-translate=\"ANLAUFSTELLE_TO_EDIT\" for=\"anlaufstelleToManage\"> </label> <select name=\"anlaufstelle\" id=\"anlaufstelleToManage\" ng-model=\"vm.selectedAnlaufstelle\" class=\"form-control dv-table__input\" ng-options=\"currAnlaufst.name for currAnlaufst in vm.allowedAnlaufstellen \" ng-change=\"vm.changedAnlaufstelle()\"> </select> </div> </div> </div> <div class=\"row\"> <div class=\"col-md-12\"> <dv-benutzer-list benutzerlist=\"vm.benutzerToShow\" show-actions=\"false\" on-edit=\"vm.editBenutzer(benutzer, event)\"> </dv-benutzer-list> </div> </div> </div> ";

/***/ }),

/***/ "/GH9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSEigenleistungDaten_1 = __importDefault(__webpack_require__("xwY2"));
var TSEigenleistungKubikmeterDaten_1 = __importDefault(__webpack_require__("++Dq"));
var TSEigenleistungLiterDaten_1 = __importDefault(__webpack_require__("h81c"));
var TSEigenleistungStundenDaten_1 = __importDefault(__webpack_require__("mzmr"));
var TSEigenleistung = /** @class */ (function (_super) {
    __extends(TSEigenleistung, _super);
    function TSEigenleistung() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._eigenleistungStundenDaten = [];
        return _this;
    }
    Object.defineProperty(TSEigenleistung.prototype, "eigenleistungDatenGS", {
        get: function () {
            return this._eigenleistungDatenGS;
        },
        set: function (value) {
            this._eigenleistungDatenGS = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistung.prototype, "eigenleistungDatenFS", {
        get: function () {
            return this._eigenleistungDatenFS;
        },
        set: function (value) {
            this._eigenleistungDatenFS = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistung.prototype, "berechtigterBetrag", {
        get: function () {
            return this._berechtigterBetrag;
        },
        set: function (value) {
            this._berechtigterBetrag = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistung.prototype, "eigenleistungStundenDaten", {
        get: function () {
            return this._eigenleistungStundenDaten;
        },
        set: function (value) {
            this._eigenleistungStundenDaten = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistung.prototype, "eigenleistungKubikmeterDaten", {
        get: function () {
            return this._eigenleistungKubikmeterDaten;
        },
        set: function (value) {
            this._eigenleistungKubikmeterDaten = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistung.prototype, "eigenleistungLiterDaten", {
        get: function () {
            return this._eigenleistungLiterDaten;
        },
        set: function (value) {
            this._eigenleistungLiterDaten = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistung.prototype, "schaetzung", {
        get: function () {
            return this._schaetzung;
        },
        set: function (value) {
            this._schaetzung = value;
        },
        enumerable: true,
        configurable: true
    });
    TSEigenleistung.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.berechtigterBetrag = restObject.berechtigterBetrag;
        this.schaetzung = restObject.schaetzung;
        this.eigenleistungDatenFS = this.deserializeOrCreate(restObject.eigenleistungDatenFS, new TSEigenleistungDaten_1.default());
        this.eigenleistungDatenGS = this.deserializeOrNull(restObject.eigenleistungDatenGS, new TSEigenleistungDaten_1.default());
        if (restObject.eigenleistungStundenDaten) {
            this.eigenleistungStundenDaten = restObject.eigenleistungStundenDaten.map(TSEigenleistungStundenDaten_1.default.getDeserializer);
        }
        this.eigenleistungKubikmeterDaten = this.deserializeOrNull(restObject.eigenleistungKubikmeterDaten, new TSEigenleistungKubikmeterDaten_1.default());
        this.eigenleistungLiterDaten = this.deserializeOrNull(restObject.eigenleistungLiterDaten, new TSEigenleistungLiterDaten_1.default());
        return this;
    };
    TSEigenleistung.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.berechtigterBetrag = this.berechtigterBetrag;
        restObject.schaetzung = this.schaetzung;
        restObject.eigenleistungDatenGS = this.serializeOrInit(this.eigenleistungDatenGS, restObject.eigenleistungDatenGS);
        restObject.eigenleistungDatenFS = this.serializeOrInit(this.eigenleistungDatenFS, restObject.eigenleistungDatenFS);
        restObject.eigenleistungStundenDaten = this.arrayToRestObject(this.eigenleistungStundenDaten);
        restObject.eigenleistungKubikmeterDaten = this.serializeOrInit(this.eigenleistungKubikmeterDaten, restObject.eigenleistungKubikmeterDaten);
        restObject.eigenleistungLiterDaten = this.serializeOrInit(this.eigenleistungLiterDaten, restObject.eigenleistungLiterDaten);
        return restObject;
    };
    TSEigenleistung.prototype.getArbeitsstundenTotal = function () {
        var total = 0;
        if (this.eigenleistungStundenDaten !== undefined) {
            try {
                for (var _a = __values(this.eigenleistungStundenDaten), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var eigenleistungStundenDaten = _b.value;
                    if (eigenleistungStundenDaten && eigenleistungStundenDaten.arbeitsstunden && !eigenleistungStundenDaten.deleted) {
                        total += eigenleistungStundenDaten.arbeitsstunden;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return total;
        var e_1, _c;
    };
    TSEigenleistung.prototype.isHolz = function () {
        return this.eigenleistungKubikmeterDaten !== undefined;
    };
    TSEigenleistung.prototype.isTreibstoff = function () {
        return this.eigenleistungDatenFS.isTreibstoff();
    };
    TSEigenleistung.prototype.getMengeTotal = function () {
        var total = 0;
        if (this.eigenleistungKubikmeterDaten !== undefined && this.eigenleistungKubikmeterDaten.kubikmeter && !this.eigenleistungKubikmeterDaten.deleted) {
            total += this.eigenleistungKubikmeterDaten.kubikmeter;
        }
        return total;
    };
    TSEigenleistung.prototype.getBetragTotal = function () {
        var total = 0;
        if (this.eigenleistungStundenDaten !== undefined) {
            try {
                for (var _a = __values(this.eigenleistungStundenDaten), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var eigenleistungStundenDaten = _b.value;
                    if (eigenleistungStundenDaten && eigenleistungStundenDaten.betrag && !eigenleistungStundenDaten.deleted) {
                        total += eigenleistungStundenDaten.betrag;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        if (this.eigenleistungKubikmeterDaten !== undefined && this.eigenleistungKubikmeterDaten.betrag && !this.eigenleistungKubikmeterDaten.deleted) {
            total += this.eigenleistungKubikmeterDaten.betrag;
        }
        if (this.eigenleistungLiterDaten !== undefined && this.eigenleistungLiterDaten.betrag && !this.eigenleistungLiterDaten.deleted) {
            total += this.eigenleistungLiterDaten.betrag;
        }
        return total;
        var e_2, _c;
    };
    TSEigenleistung.prototype.getDateRange = function () {
        var minDate;
        var maxDate;
        if (this.eigenleistungStundenDaten !== undefined) {
            try {
                for (var _a = __values(this.eigenleistungStundenDaten), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var eigenleistungStundenDaten = _b.value;
                    if (eigenleistungStundenDaten && eigenleistungStundenDaten.datum && !eigenleistungStundenDaten.deleted) {
                        if (minDate === undefined || minDate > eigenleistungStundenDaten.datum) {
                            minDate = eigenleistungStundenDaten.datum;
                        }
                        if (maxDate === undefined || maxDate < eigenleistungStundenDaten.datum) {
                            maxDate = eigenleistungStundenDaten.datum;
                        }
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        if (minDate && maxDate) {
            if (minDate === maxDate) {
                return minDate.format('DD.MM.YY');
            }
            return minDate.format('DD.MM.YY') + ' - ' + maxDate.format('DD.MM.YY');
        }
        return '';
        var e_3, _c;
    };
    TSEigenleistung.getDeserializer = function (eigenleistung) {
        return new TSEigenleistung().deserialize(eigenleistung);
    };
    TSEigenleistung.getSerializer = function (eigenleistung) {
        return eigenleistung.serialize(eigenleistung);
    };
    return TSEigenleistung;
}(TSAbstractEntity_1.default));
exports.default = TSEigenleistung;


/***/ }),

/***/ "/GOx":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("xQrf");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-adresse.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-adresse.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "/PKM":
/***/ (function(module, exports) {

module.exports = "<div class=\"row\"> <div class=\"col-sm-12\"> <h2 class=\"h2-gesuchsteller\"> <span ng-if=\"vm.angabe\" class=\"h2-prefix\">{{vm.angabe | translate}}</span> <span data-translate=\"ANGABEN_ZUR_GESELLSCHAFT\" ng-if=\"vm.gesellschaft\"></span> <span data-translate=\"ANGABEN_ZUR_GENOSSENSCHAFT\" ng-if=\"!vm.gesellschaft\"></span> </h2> </div> </div> <div ng-form=\"genossenschaft\"> <div class=\"form-group\"> <div class=\"row\"> <dv-string-input model=\"vm.getModel().genossenschaftDatenFS.name\" bisher-gs=\"vm.getModel().genossenschaftDatenGS\" bisher-fs=\"vm.getModel().genossenschaftDatenFS\" bisher-property=\"name\" name=\"{{vm.name}}_namegenossenschaft\" label=\"{{vm.getName()}}\" clazz=\"col-sm-4\"> </dv-string-input> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <dv-adresse adresse=\"vm.getModel().genossenschaftDatenFS.adresse\" bisher-gs=\"vm.getModel().genossenschaftDatenGS\" bisher-fs=\"vm.getModel().genossenschaftDatenFS\" prefix=\"{{vm.name}}_adresse\"></dv-adresse> </div> </div> <div class=\"row\" ng-if=\"!vm.gesellschaft && !vm.zweitperson\"> <div class=\"col-sm-12\"> <div class=\"form-group\"> <div class=\"radio\"> <label> <input ng-value=\"true\" aria-label=\"STEUERPFLICHTIG\" required ng-model=\"vm.getModel().genossenschaftDatenFS.isSteuerpflichtig\" type=\"radio\" name=\"{{vm.name}}_steuerplicht\" ng-change=\"vm.steuerpflichtChanged()\"> <span data-translate=\"{{vm.getSteuerpflichtName()}}\"></span> </label> </div> <div class=\"radio\"> <label> <input ng-value=\"false\" aria-label=\"NICHT_STEUERPFLICHTIG\" required ng-model=\"vm.getModel().genossenschaftDatenFS.isSteuerpflichtig\" type=\"radio\" name=\"{{vm.name}}_steuerpflicht\" ng-change=\"vm.steuerpflichtChanged()\"> <span data-translate=\"{{vm.getNichtSteuerpflichtName()}}\"></span> </label> <div> <dv-error-messages for=\"genossenschaft[vm.name + '_steuerpflicht']\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().genossenschaftDatenGS\" fs=\"vm.getModel().genossenschaftDatenFS\" for=\"genossenschaft[vm.name + '_steuerpflicht']\" property=\"isSteuerpflichtig\"></dv-bisher> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "/PRC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAnlaufstelleType_1 = __webpack_require__("hYoR");
var TSKantonCode_1 = __webpack_require__("vEoF");
var TSRole_1 = __webpack_require__("MleR");
var AnlaufstelleUtil_1 = __importDefault(__webpack_require__("720h"));
var template = __webpack_require__("e606");
__webpack_require__("65dZ");
var DVAnlaufstelleListComponentConfig = /** @class */ (function () {
    function DVAnlaufstelleListComponentConfig() {
        this.transclude = false;
        this.bindings = {
            anlaufstellen: '=',
            itemsByPage: '<',
            onEdit: '&',
        };
        this.template = template;
        this.controller = DVAnlaufstelleListController;
        this.controllerAs = 'vm';
    }
    return DVAnlaufstelleListComponentConfig;
}());
exports.DVAnlaufstelleListComponentConfig = DVAnlaufstelleListComponentConfig;
var DVAnlaufstelleListController = /** @class */ (function () {
    /* @ngInject */
    function DVAnlaufstelleListController($filter, $log, CONSTANTS, $scope, roleUtilService, $window, $translate, applicationPropertyRS) {
        this.$filter = $filter;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.$scope = $scope;
        this.roleUtilService = roleUtilService;
        this.$window = $window;
        this.$translate = $translate;
        this.applicationPropertyRS = applicationPropertyRS;
        this.anlaufstellen = []; //Liste die im Gui angezeigt wird
        this.vereinbarungValid = 0;
        this.initViewModel();
    }
    DVAnlaufstelleListController.prototype.initViewModel = function () {
    };
    DVAnlaufstelleListController.prototype.$onInit = function () {
        var _this = this;
        this.applicationPropertyRS.getVereinbarungValidYears().then(function (response) {
            _this.vereinbarungValid = response;
        });
        this.anlaufstellen = this.anlaufstellen.filter(AnlaufstelleUtil_1.default.isNotImportiert);
    };
    DVAnlaufstelleListController.prototype.getFilterroles = function () {
        return this.roleUtilService.getAllRolesButGesuchstellerArray();
    };
    DVAnlaufstelleListController.prototype.editClicked = function (anlaufstelleToEdit, event) {
        this.onEdit({ anlaufstelle: anlaufstelleToEdit, event: event });
    };
    DVAnlaufstelleListController.prototype.translateAktiv = function (inaktiv) {
        return inaktiv ? (this.$translate.instant('INAKTIV')) : (this.$translate.instant('AKTIV'));
    };
    DVAnlaufstelleListController.prototype.translateRoles = function (roles) {
        var _this = this;
        var prefix = TSRole_1.rolePrefix();
        return roles.map(function (element) {
            return _this.$translate.instant(prefix + TSRole_1.TSRole[element]);
        }).join(', ');
    };
    DVAnlaufstelleListController.prototype.translateRole = function (role) {
        var prefix = TSRole_1.rolePrefix();
        return this.$translate.instant(prefix + TSRole_1.TSRole[role]);
    };
    DVAnlaufstelleListController.prototype.getColumnsNumber = function () {
        var element = angular.element('.dv-anlaufstelle-list .header-row').first();
        if (element) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 12;
    };
    DVAnlaufstelleListController.prototype.getAnlaufstelleTypes = function () {
        return TSAnlaufstelleType_1.getTSAnlaufstelleTypeValues();
    };
    /**
     * Alle TSKantonCode fuer das Filterdropdown
     * @returns {Array<key: string; code: TSKantonCode>}
     */
    DVAnlaufstelleListController.prototype.getKantone = function () {
        var _this = this;
        var kantonCodes = TSKantonCode_1.getKantonCodeList();
        var kantonNamesAndCodes = [];
        kantonCodes.forEach(function (code) {
            kantonNamesAndCodes.push({
                key: _this.$translate.instant(code.toString()),
                code: code,
            });
        });
        kantonNamesAndCodes.sort(function (a, b) { return a.code.toString().localeCompare(b.code.toString()); });
        return kantonNamesAndCodes;
    };
    DVAnlaufstelleListController.prototype.getGemeinden = function (gemeinden) {
        var val = '';
        gemeinden.forEach(function (gemeinde) {
            val += gemeinde.name + '\n';
        });
        return val;
    };
    DVAnlaufstelleListController.prototype.isInvalidVereinbarung = function (row) {
        return row.isInvalidVereinbarung(this.vereinbarungValid);
    };
    DVAnlaufstelleListController.$inject = ['$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', '$translate', 'ApplicationPropertyRS'];
    return DVAnlaufstelleListController;
}());
exports.DVAnlaufstelleListController = DVAnlaufstelleListController;


/***/ }),

/***/ "/atl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSBeitragPreFilterDTO = /** @class */ (function () {
    function TSBeitragPreFilterDTO(status) {
        this.status = status;
    }
    return TSBeitragPreFilterDTO;
}());
exports.default = TSBeitragPreFilterDTO;


/***/ }),

/***/ "/fjL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSKulturart;
(function (TSKulturart) {
    TSKulturart[TSKulturart["WIESEWEIDE"] = 'WIESEWEIDE'] = "WIESEWEIDE";
    TSKulturart[TSKulturart["ACKERLAND"] = 'ACKERLAND'] = "ACKERLAND";
    TSKulturart[TSKulturart["ANDERE"] = 'ANDERE'] = "ANDERE";
})(TSKulturart = exports.TSKulturart || (exports.TSKulturart = {}));
function getTSKulturartValues() {
    return [
        TSKulturart.WIESEWEIDE,
        TSKulturart.ACKERLAND,
        TSKulturart.ANDERE
    ];
}
exports.getTSKulturartValues = getTSKulturartValues;
function kulturartPrefix() {
    return 'TSKulturart_';
}
exports.kulturartPrefix = kulturartPrefix;


/***/ }),

/***/ "/gTe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSDocumentType;
(function (TSDocumentType) {
    TSDocumentType[TSDocumentType["GENERAL_DOC"] = 'GENERAL_DOC'] = "GENERAL_DOC";
    TSDocumentType[TSDocumentType["SCHADEN_DOC"] = 'SCHADEN_DOC'] = "SCHADEN_DOC";
    TSDocumentType[TSDocumentType["VORLEISTUNG_DOC"] = 'VORLEISTUNG_DOC'] = "VORLEISTUNG_DOC";
    TSDocumentType[TSDocumentType["FREMDKOSTEN_DOC"] = 'FREMDKOSTEN_DOC'] = "FREMDKOSTEN_DOC";
    TSDocumentType[TSDocumentType["ANLAUFSTELLE_DOC"] = 'ANLAUFSTELLE_DOC'] = "ANLAUFSTELLE_DOC";
    TSDocumentType[TSDocumentType["VERSICHERUNGSBEITRAG_DOC"] = 'VERSICHERUNGSBEITRAG_DOC'] = "VERSICHERUNGSBEITRAG_DOC";
    TSDocumentType[TSDocumentType["GESUCHSTELLER_DOC"] = 'GESUCHSTELLER_DOC'] = "GESUCHSTELLER_DOC";
    TSDocumentType[TSDocumentType["ZWEITPERSON_DOC"] = 'ZWEITPERSON_DOC'] = "ZWEITPERSON_DOC";
    TSDocumentType[TSDocumentType["TMP_DECKBLATT"] = 'TMP_DECKBLATT'] = "TMP_DECKBLATT";
    TSDocumentType[TSDocumentType["FONDSSUISSE_DOC"] = 'FONDSSUISSE_DOC'] = "FONDSSUISSE_DOC";
    TSDocumentType[TSDocumentType["AUFWAENDE_DOC"] = 'AUFWAENDE_DOC'] = "AUFWAENDE_DOC";
    TSDocumentType[TSDocumentType["SCHAETZUNG_DOC"] = 'SCHAETZUNG_DOC'] = "SCHAETZUNG_DOC";
    TSDocumentType[TSDocumentType["EIGENLEISTUNG_DOC"] = 'EIGENLEISTUNG_DOC'] = "EIGENLEISTUNG_DOC";
})(TSDocumentType = exports.TSDocumentType || (exports.TSDocumentType = {}));
function getDocumentTypes() {
    return [
        TSDocumentType.GENERAL_DOC,
        TSDocumentType.SCHADEN_DOC,
        TSDocumentType.VORLEISTUNG_DOC,
        TSDocumentType.FREMDKOSTEN_DOC,
        TSDocumentType.ANLAUFSTELLE_DOC,
        TSDocumentType.VERSICHERUNGSBEITRAG_DOC,
        TSDocumentType.GESUCHSTELLER_DOC,
        TSDocumentType.ZWEITPERSON_DOC,
        TSDocumentType.TMP_DECKBLATT,
        TSDocumentType.FONDSSUISSE_DOC,
        TSDocumentType.AUFWAENDE_DOC,
        TSDocumentType.SCHAETZUNG_DOC,
        TSDocumentType.EIGENLEISTUNG_DOC,
    ];
}
exports.getDocumentTypes = getDocumentTypes;


/***/ }),

/***/ "/jrf":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("lDyE");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./statistik.module.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./statistik.module.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "/sPZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var template = __webpack_require__("Evg8");
__webpack_require__("rzx8");
var PasswordResetComponentConfig = /** @class */ (function () {
    function PasswordResetComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = PasswordResetViewController;
        this.controllerAs = 'vm';
    }
    return PasswordResetComponentConfig;
}());
exports.PasswordResetComponentConfig = PasswordResetComponentConfig;
var PasswordResetViewController = /** @class */ (function () {
    function PasswordResetViewController($state, $stateParams, $window, $httpParamSerializer, $timeout, benutzerRS, $location, $log, errorService, CONSTANTS, $translate) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$window = $window;
        this.$httpParamSerializer = $httpParamSerializer;
        this.$timeout = $timeout;
        this.benutzerRS = benutzerRS;
        this.$location = $location;
        this.$log = $log;
        this.errorService = errorService;
        this.CONSTANTS = CONSTANTS;
        this.$translate = $translate;
    }
    PasswordResetViewController.prototype.$onInit = function () {
    };
    PasswordResetViewController.prototype.resetClicked = function () {
        var _this = this;
        this.errorService.clearError('ERROR_LOGIN');
        if (this.form.$valid) {
            this.benutzerRS.createAndSendPasswordResetToken(this.email)
                .then(function () {
                var successmsg = _this.$translate.instant('LOGIN_PW_REST_SENT'); //wir bekommen immer success zurueck
                _this.errorService.addMesageAsInfo(successmsg);
            });
        }
        else {
            this.$log.debug('Form was not valid');
        }
    };
    PasswordResetViewController.$inject = ['$state', '$stateParams', '$window', '$httpParamSerializer', '$timeout', 'BenutzerRS',
        '$location', '$log', 'ErrorService', 'CONSTANTS', '$translate'];
    return PasswordResetViewController;
}());
exports.PasswordResetViewController = PasswordResetViewController;


/***/ }),

/***/ "07Me":
/***/ (function(module, exports) {

module.exports = "<div class=\"benutzer-reg-view container\"> <form name=\"vm.form\" novalidate unsaved-warning-form> <div class=\"row marginTop20\"> <div class=\"col-sm-12\"> <h1> <span data-translate=\"BENUTZER_ERSTELLEN\" ng-if=\"vm.benutzer.isNew()\"></span> <span data-translate=\"BENUTZERPROFIL\" ng-if=\"!vm.benutzer.isNew()\"></span> </h1> </div> </div> <dv-benutzerprofil benutzer=\"vm.benutzer\" hide-password-entry=\"true\" double-email-entry=\"true\"> </dv-benutzerprofil> <div class=\"row\"> <div class=\"col-sm-12\"> <p data-translate=\"BENUTZERROLLEN_ANLAUFSTELLE_HINWEIS\"></p> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <div class=\"row mainbuttons\"> <div class=\"col-sm-2 col-sm-offset-4\"> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.cancelBenutzeredit()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> <fieldset ng-disabled=\"vm.viewReadonly\"> <div class=\"col-sm-2\"> <dv-loading-button type=\"submit\" button-click=\"vm.submit()\" button-class=\"btn btn-serf\"> <span data-translate=\"BENUTZER_SPEICHERN\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </fieldset> </div> </div> </div> <div class=\"row marginTop20\" ng-if=\"!vm.benutzer.isNew()\"> <div class=\"col-sm-12\"> <dv-input-container> <div class=\"checkbox\"> <label> <input ng-true-value=\"true\" ng-false-value=\"false\" ng-model=\"vm.benutzer.inaktiv\" type=\"checkbox\" name=\"inactive\" class=\"input-element\"> <span class=\"md-no-float\" data-translate=\"BENUTZER_DEAKTIVIEREN\"></span> <dv-error-messages for=\"vm.form.inactive\"></dv-error-messages> </label> </div> </dv-input-container> </div> </div> </form> </div> ";

/***/ }),

/***/ "0Is4":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("Y+TE");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./passwordChangeView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./passwordChangeView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "0Jor":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".benutzer-reg-view .captcha-error{color:#ff2b59}.benutzer-reg-view form:not(.ng-submitted) .captcha-error{display:none}", ""]);

// exports


/***/ }),

/***/ "0MNX":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "0OWN":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */", ""]);

// exports


/***/ }),

/***/ "0P1y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAdresse_1 = __importDefault(__webpack_require__("aL5m"));
var TSPasswordData_1 = __importDefault(__webpack_require__("3CBU"));
var TSAnlaufstelleWithUsers_1 = __importDefault(__webpack_require__("em2S"));
anlaufstelleverwaltungRun.$inject = ['RouterHelper'];
/* @ngInject */
function anlaufstelleverwaltungRun(routerHelper) {
    routerHelper.configureStates(getStates());
}
exports.anlaufstelleverwaltungRun = anlaufstelleverwaltungRun;
function getStates() {
    return [
        new SerfAnlaufstelleVerwaltungState(),
        new SerfAnlaufstelleState(),
        new SerfAnlaufstelleRegistrierungState(),
    ];
}
var SerfAnlaufstelleVerwaltungState = /** @class */ (function () {
    function SerfAnlaufstelleVerwaltungState() {
        this.name = 'anlaufstelleverwaltung';
        this.template = '<dv-anlaufstelleverwaltung-view anlaufstellen="$resolve.anlaufstelleList" '
            + 'vereinbarung-missing="$resolve.vereinbarungMissingList" ></dv-anlaufstelleverwaltung-view>';
        this.url = '/anlaufstelleverwaltung/';
        this.resolve = {
            anlaufstelleList: loadAnlaufstellen,
            vereinbarungMissingList: loadMissingVereinbarungAnlaufstellen
        };
        this.params = { missingVereinbarungAnlaufstelle: null, bla: null };
    }
    return SerfAnlaufstelleVerwaltungState;
}());
exports.SerfAnlaufstelleVerwaltungState = SerfAnlaufstelleVerwaltungState;
var SerfAnlaufstelleState = /** @class */ (function () {
    function SerfAnlaufstelleState() {
        this.name = 'anlaufstelle';
        this.template = '<dv-anlaufstelle-view anlaufstelle="$resolve.anlaufstelle"></dv-anlaufstelle-view>';
        this.url = '/anlaufstelle/:anlaufstelleId';
        this.resolve = {
            anlaufstelle: getAnlaufstelle
        };
        this.params = { createNew: null, anlaufstelle: null, anlaufstelleId: null };
    }
    return SerfAnlaufstelleState;
}());
exports.SerfAnlaufstelleState = SerfAnlaufstelleState;
var SerfAnlaufstelleRegistrierungState = /** @class */ (function () {
    function SerfAnlaufstelleRegistrierungState() {
        this.name = 'anlaufstelleregistrierung';
        this.template = '<dv-anlaufstelle-registrierung-view  site-key="$resolve.siteKey"></dv-anlaufstelle-registrierung-view>';
        this.url = '/anlaufstelleregistrierung';
        this.resolve = {
            siteKey: loadSiteKey
        };
    }
    return SerfAnlaufstelleRegistrierungState;
}());
exports.SerfAnlaufstelleRegistrierungState = SerfAnlaufstelleRegistrierungState;
var IAnlaufstelleStateParams = /** @class */ (function () {
    function IAnlaufstelleStateParams() {
    }
    return IAnlaufstelleStateParams;
}());
exports.IAnlaufstelleStateParams = IAnlaufstelleStateParams;
var IAnlaufstelleVerwaltungParams = /** @class */ (function () {
    function IAnlaufstelleVerwaltungParams() {
    }
    return IAnlaufstelleVerwaltungParams;
}());
exports.IAnlaufstelleVerwaltungParams = IAnlaufstelleVerwaltungParams;
loadSiteKey.$inject = ['ApplicationPropertyRS'];
function loadSiteKey(ApplicationPropertyRS) {
    return ApplicationPropertyRS.getRecaptchaSiteKey();
}
exports.loadSiteKey = loadSiteKey;
loadAnlaufstellen.$inject = ['AnlaufstelleRS', 'AuthServiceRS', 'BenutzerRS', 'RoleUtilService', '$q'];
function loadAnlaufstellen(AnlaufstelleRS, AuthServiceRS, BenutzerRS, RoleUtilService, $q) {
    if (AuthServiceRS.isOneOfRoles(RoleUtilService.getAdministratorRoles())) {
        return AnlaufstelleRS.getAllAnlaufstellen();
    }
    else if (AuthServiceRS.isOneOfRoles(RoleUtilService.getAnlaufstelleVerwalterRoles())) {
        var principal = AuthServiceRS.getPrincipal();
        if (principal) {
            return BenutzerRS.getAnlaufstellenForBenutzer(principal.id);
        }
    }
    return $q.when([]);
}
exports.loadAnlaufstellen = loadAnlaufstellen;
loadMissingVereinbarungAnlaufstellen.$inject = ['$stateParams', '$q'];
function loadMissingVereinbarungAnlaufstellen($stateParams, $q) {
    if ($stateParams) {
        return $q.when($stateParams.missingVereinbarungAnlaufstelle);
    }
    return $q.when([]);
}
exports.loadMissingVereinbarungAnlaufstellen = loadMissingVereinbarungAnlaufstellen;
getAnlaufstelle.$inject = ['$stateParams', '$q', 'AnlaufstelleRS', '$log'];
var createAnlaufstelle = function () {
    var anlaufstelle = new TSAnlaufstelleWithUsers_1.default();
    anlaufstelle.adresse = new TSAdresse_1.default();
    anlaufstelle.verwalter = undefined;
    anlaufstelle.gemeinden = [];
    anlaufstelle.sachbearbeiter = [];
    anlaufstelle.schaetzer = [];
    return anlaufstelle;
};
function getAnlaufstelle($stateParams, $q, anlaufstelleRS, log) {
    var _this = this;
    if ($stateParams) {
        var anlaufstelleIdParam = $stateParams.anlaufstelleId;
        var passedAnlaufstelle = $stateParams.anlaufstelle;
        var createNew = $stateParams.createNew;
        if (createNew) {
            return $q.when(createAnlaufstelle());
        }
        // if (passedAnlaufstelle) {
        //     return $q.when(passedAnlaufstelle);
        // }
        if (anlaufstelleIdParam) {
            return anlaufstelleRS.findAnlaufstelleWithUsers(anlaufstelleIdParam).then(function (response) {
                if (response !== undefined && response.verwalter !== undefined) {
                    response.verwalter.passwordData = new TSPasswordData_1.default(response.verwalter.email);
                    return response;
                }
                else {
                    return _this.$q.when(createAnlaufstelle());
                }
            });
        }
    }
    log.error('Can`t open requested anlaufstelle. Creating a new anlaufstelle object' + $stateParams);
    var deferred = $q.defer();
    deferred.resolve(createAnlaufstelle());
    return deferred.promise;
}
exports.getAnlaufstelle = getAnlaufstelle;


/***/ }),

/***/ "0YHJ":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("IZSa");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-schaden.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-schaden.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "0jch":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSAbstractPersonEntity = /** @class */ (function (_super) {
    __extends(TSAbstractPersonEntity, _super);
    function TSAbstractPersonEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSAbstractPersonEntity.prototype, "anrede", {
        get: function () {
            return this._anrede;
        },
        set: function (value) {
            this._anrede = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAbstractPersonEntity.prototype, "korrespondenzsprache", {
        get: function () {
            return this._korrespondenzsprache;
        },
        set: function (value) {
            this._korrespondenzsprache = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAbstractPersonEntity.prototype, "vorname", {
        get: function () {
            return this._vorname;
        },
        set: function (value) {
            this._vorname = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAbstractPersonEntity.prototype, "nachname", {
        get: function () {
            return this._nachname;
        },
        set: function (value) {
            this._nachname = value;
        },
        enumerable: true,
        configurable: true
    });
    TSAbstractPersonEntity.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.nachname = restObject.nachname;
        this.vorname = restObject.vorname;
        this.korrespondenzsprache = restObject.korrespondenzsprache;
        this.anrede = restObject.anrede;
        return this;
    };
    TSAbstractPersonEntity.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.nachname = this.nachname;
        restObject.vorname = this.vorname;
        restObject.korrespondenzsprache = this.korrespondenzsprache;
        restObject.anrede = this.anrede;
        return restObject;
    };
    return TSAbstractPersonEntity;
}(TSAbstractEntity_1.default));
exports.default = TSAbstractPersonEntity;


/***/ }),

/***/ "15/d":
/***/ (function(module, exports) {

module.exports = " <form class=\"dv-iban\" name=\"vm.form\" novalidate role=\"form\" unsaved-warning-form> <div class=\"{{vm.clazz}}\" ng-form=\"inputForm\"> <dv-input-container> <label for=\"{{vm.name}}\" class=\"md-no-float\" data-translate=\"{{vm.label}}\"></label> <input name=\"{{vm.name}}\" id=\"{{vm.name}}\" ng-model=\"vm.model\" class=\"form-control\" dv-max-length ng-required=\"vm.valueRequired\" placeholder=\"{{vm.placeholder}}\" ng-blur=\"vm.handleBlur($event)\"> <dv-error-messages for=\"inputForm[vm.name]\"></dv-error-messages> <dv-bisher ng-if=\"vm.showBisher()\" gs=\"vm.bisherGs\" fs=\"vm.bisherFs\" for=\"inputForm[vm.name]\" property=\"{{vm.bisherProperty}}\"></dv-bisher> </dv-input-container> </div> </form> ";

/***/ }),

/***/ "17QL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var TSGemeinde_1 = __importDefault(__webpack_require__("nKms"));
var TSVersicherungsbeitragDTO = /** @class */ (function () {
    function TSVersicherungsbeitragDTO() {
    }
    Object.defineProperty(TSVersicherungsbeitragDTO.prototype, "schadendatum", {
        get: function () {
            return this._schadendatum;
        },
        set: function (value) {
            this._schadendatum = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitragDTO.prototype, "status", {
        get: function () {
            return this._status;
        },
        set: function (value) {
            this._status = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitragDTO.prototype, "policeNummer", {
        get: function () {
            return this._policeNummer;
        },
        set: function (value) {
            this._policeNummer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitragDTO.prototype, "externalSchadenNr", {
        get: function () {
            return this._externalSchadenNr;
        },
        set: function (value) {
            this._externalSchadenNr = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitragDTO.prototype, "schadenArt", {
        get: function () {
            return this._schadenArt;
        },
        set: function (value) {
            this._schadenArt = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitragDTO.prototype, "gemeinde", {
        get: function () {
            return this._gemeinde;
        },
        set: function (value) {
            this._gemeinde = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitragDTO.prototype, "versicherungsbeitragId", {
        get: function () {
            return this._versicherungsbeitragId;
        },
        set: function (value) {
            this._versicherungsbeitragId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitragDTO.prototype, "betrag", {
        get: function () {
            return this._betrag;
        },
        set: function (value) {
            this._betrag = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitragDTO.prototype, "versicherungName", {
        get: function () {
            return this._versicherungName;
        },
        set: function (value) {
            this._versicherungName = value;
        },
        enumerable: true,
        configurable: true
    });
    TSVersicherungsbeitragDTO.prototype.deserialize = function (restObject) {
        this.versicherungsbeitragId = restObject.versicherungsbeitragId;
        this.externalSchadenNr = restObject.externalSchadenNr;
        this.schadenArt = restObject.schadenArt;
        this.schadendatum = DateUtil_1.default.localDateToMoment(restObject.schadendatum);
        this.status = restObject.status;
        this.policeNummer = restObject.policeNummer;
        this.gemeinde = this.deserializeOrNull(restObject.gemeinde, new TSGemeinde_1.default());
        this.betrag = restObject.betrag;
        this.versicherungName = restObject.versicherungName;
        return this;
    };
    TSVersicherungsbeitragDTO.prototype.deserializeOrNull = function (restObject, obj) {
        if (restObject) {
            return obj.deserialize(restObject);
        }
        else {
            return undefined;
        }
    };
    return TSVersicherungsbeitragDTO;
}());
exports.default = TSVersicherungsbeitragDTO;


/***/ }),

/***/ "1Gel":
/***/ (function(module, exports) {

module.exports = " <div class=\"dv-alert-box {{vm.alertTypeClass}} {{vm.sizeClass}}\"> <div class=\"dv-alert-box__message\" ng-transclude> </div> </div> ";

/***/ }),

/***/ "1Zuw":
/***/ (function(module, exports) {

module.exports = "<div> <h2 data-translate=\"LEISTUNGSEMPFAENGER\"></h2> <div class=\"row\"> <div class=\"col-sm-3 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"KONTO_INHABER\"> </label> <div class=\"noselect\" ng-bind=\"vm.inhaberName\"></div> </dv-input-container> </div> <div class=\"col-sm-3 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"IBAN\"> </label> <div class=\"noselect\" ng-bind=\"vm.iban\"></div> </dv-input-container> </div> </div> </div> ";

/***/ }),

/***/ "1iG2":
/***/ (function(module, exports) {

module.exports = "<div class=\"dvb-loading-button\"> <span ng-disabled=\"vm.buttonDisabled || vm.isDisabled\"> <button type=\"{{vm.type}}\" aria-label=\"{{vm.ariaLabel}}\" class=\"{{vm.buttonClass}}\" id=\"{{vm.inputId}}\" ng-click=\"vm.buttonClicked($event)\" ng-disabled=\"vm.buttonDisabled || vm.isDisabled\"> <ng-transclude></ng-transclude> </button> </span> </div> ";

/***/ }),

/***/ "1mB+":
/***/ (function(module, exports) {

module.exports = "<div class=\"dv-inspektorat-list\"> <div class=\"table-responsive\"> <table st-table=\"displayedCollection\" st-safe-src=\"vm.inspektorat\" st-delay=\"20\" class=\"table fixedtable table-hover\" id=\"{{vm.tableId}}\" title=\"{{vm.tableTitle}}\" dv-st-table-refresh> <thead> <tr class=\"header-row\"> <th st-sort-default=\"true\" st-sort=\"name\" class=\"sortable\" data-translate=\"NAME\"></th> <th st-sort=\"kanton\" class=\"sortable row-type\" data-translate=\"KANTON\"></th> <th st-sort=\"verwalter.email\" class=\"sortable row-amtsstelleName\" data-translate=\"EMAIL\"></th> </tr> <tr> <th> <input st-search=\"name\" class=\"form-control dv-table__input\" type=\"text\"/> </th> <th> <div class=\"dv-select-style\"> <select st-input-event=\"change\" name=\"kanton\" id=\"kanton\" st-search=\"kanton\" class=\"form-control dv-table__input\" ng-options=\"kanton.code.toString() for kanton in vm.getKantone() track by kanton.code\" ng-model=\"vm.selectedKanton\"> <option value=\"\">{{\"ALLE\" | translate}}</option> </select> </div> </th> <th> <input st-search=\"verwalter.email\" class=\"form-control dv-table__input\" type=\"text\"/> </th> </tr> </thead> <tbody> <tr ng-repeat=\"row in displayedCollection\" st-select-row=\"row\" st-select-mode=\"single\" ng-click=\"vm.editClicked(row, $event)\"> <td class=\"ellipsis\" title=\"{{row.name}}\" ng-bind=\"row.name\"></td> <td class=\"ellipsis\" title=\"{{row.kanton  | translate}}\" ng-bind=\"row.kanton\"></td> <td class=\"ellipsis\" title=\"{{row.verwalter.email}}\" ng-bind=\"row.verwalter.email\"></td> </tr> <tr> </tr><tr ng-if=\"displayedCollection === undefined || displayedCollection.length === 0\"> <td colspan=\"{{vm.getColumnsNumber()}}\" class=\"empty-table\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> <tfoot> <tr> <td colspan=\"{{vm.getColumnsNumber()}}\" class=\"text-center\"> <div st-pagination=\"\" st-items-by-page=\"30\" st-displayed-pages=\"10\"></div> </td> </tr> </tfoot> </table> </div> </div> ";

/***/ }),

/***/ "1zBu":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".inspektorat-view .add-button{margin-top:22px;float:none;min-width:40px}", ""]);

// exports


/***/ }),

/***/ "1zRb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractModelController_1 = __importDefault(__webpack_require__("VDYy"));
var gesuch_route_1 = __webpack_require__("J6sl");
var TSAnlaufstelleType_1 = __webpack_require__("hYoR");
var TSKantonCode_1 = __webpack_require__("vEoF");
var TSRole_1 = __webpack_require__("MleR");
var TSAdresse_1 = __importDefault(__webpack_require__("aL5m"));
var TSAnlaufstelleWithUsers_1 = __importDefault(__webpack_require__("em2S"));
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
var TSPasswordData_1 = __importDefault(__webpack_require__("3CBU"));
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
var template = __webpack_require__("Gto4");
__webpack_require__("C6dp");
var AnlaufstelleRegistrierungViewComponentConfig = /** @class */ (function () {
    function AnlaufstelleRegistrierungViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = AnlaufstelleRegistrierungViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            siteKey: '<'
        };
    }
    return AnlaufstelleRegistrierungViewComponentConfig;
}());
exports.AnlaufstelleRegistrierungViewComponentConfig = AnlaufstelleRegistrierungViewComponentConfig;
var AnlaufstelleRegistrierungViewController = /** @class */ (function (_super) {
    __extends(AnlaufstelleRegistrierungViewController, _super);
    /* @ngInject */
    function AnlaufstelleRegistrierungViewController(dvBernUtil, $q, $scope, $log, $state, anlaufstelleRS, passwordStrengthService, errorService, schadenfallModelManager, roleUtilService, authService, dvDialog, pageNames) {
        var _this = _super.call(this, $scope) || this;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$log = $log;
        _this.$state = $state;
        _this.anlaufstelleRS = anlaufstelleRS;
        _this.passwordStrengthService = passwordStrengthService;
        _this.errorService = errorService;
        _this.roleUtilService = roleUtilService;
        _this.authService = authService;
        _this.dvDialog = dvDialog;
        _this.pageNames = pageNames;
        _this.createNew = true;
        _this.anlaufstelle = new TSAnlaufstelleWithUsers_1.default();
        _this.anlaufstelle.adresse = new TSAdresse_1.default();
        _this.anlaufstelle.gemeinden = []; //could maybe do this directly in TSAnlaufstelle
        var verwalterToCreate = new TSBenutzer_1.default();
        verwalterToCreate.roles.push(TSRole_1.TSRole.ANLAUFSTELLE_VERWALTER);
        verwalterToCreate.inaktiv = false;
        verwalterToCreate.passwordData = new TSPasswordData_1.default(verwalterToCreate.email);
        _this.anlaufstelle.verwalter = verwalterToCreate;
        return _this;
    }
    AnlaufstelleRegistrierungViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        //eigentlich muessen wir hier nicht kopieren da wir nur neu erstellen aber es schadet ja auch nicht
        this.initialModel = this.anlaufstelle;
        this.model = angular.copy(this.anlaufstelle);
    };
    AnlaufstelleRegistrierungViewController.prototype.getTSAnlaufstelleTypeValues = function () {
        return TSAnlaufstelleType_1.getTSAnlaufstelleTypeValues();
    };
    AnlaufstelleRegistrierungViewController.prototype.save = function () {
        var _this = this;
        this.cleanUnnecessaryFields();
        var passwordValid = this.checkPassword();
        if (this.isModelValid() && this.model && this.model.verwalter && passwordValid) {
            this.model.verwalter.recaptchaResponse = this.recaptchaResponse;
            this.anlaufstelleRS.createAnlaufstelleRegistration(this.model).then(function (response) {
                var abschlussState = new gesuch_route_1.IAbschlussStateParams();
                abschlussState.titleText = 'ABSCHLUSS_TITLE_ANLAUFSTELLE_REG';
                abschlussState.messageText = 'ABSCHLUSS_TEXT_ANLAUFSTELLE_REG';
                abschlussState.buttonText = 'OK';
                abschlussState.stateToGoTo = 'loginanlaufstelle';
                _this.$state.go(_this.pageNames.ABSCHLUSS, abschlussState);
            });
        }
        else {
            this.$log.debug('Form was not valid');
        }
    };
    AnlaufstelleRegistrierungViewController.prototype.cleanUnnecessaryFields = function () {
        if (this.isKantonType()) {
            this.model.gemeinden = [];
        }
        else {
            this.model.kanton = undefined; //wenn wir den Kanton nicht brauchen nullen wir ihn
        }
    };
    AnlaufstelleRegistrierungViewController.prototype.addGemeinde = function () {
        if (this.gemeindeToAdd) {
            this.model.gemeinden.push(this.gemeindeToAdd);
        }
        this.gemeindeToAdd = undefined;
    };
    AnlaufstelleRegistrierungViewController.prototype.deleteClicked = function (gemeindeToDelete, event) {
        var index = DVBernUtil_1.default.getIndexOfElementwithID(gemeindeToDelete, this.model.gemeinden);
        if (index > -1) {
            this.model.gemeinden.splice(index, 1);
        }
    };
    AnlaufstelleRegistrierungViewController.prototype.isKantonType = function () {
        return this.model.anlaufstelleType !== undefined && this.model.anlaufstelleType === TSAnlaufstelleType_1.TSAnlaufstelleType.KANTON;
    };
    AnlaufstelleRegistrierungViewController.prototype.cancel = function () {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('loginanlaufstelle');
    };
    AnlaufstelleRegistrierungViewController.prototype.kantonList = function () {
        return TSKantonCode_1.getKantonCodeList();
    };
    AnlaufstelleRegistrierungViewController.prototype.translateKanton = function (kantonCode) {
        return TSKantonCode_1.TSKantonCode[kantonCode];
    };
    AnlaufstelleRegistrierungViewController.prototype.captchaEnabled = function () {
        // return true;
        if (this.siteKey !== undefined && this.siteKey !== null) {
            return true;
        }
        return false;
    };
    AnlaufstelleRegistrierungViewController.prototype.checkPassword = function () {
        var anlaufstelle = this.getModel();
        if (anlaufstelle && anlaufstelle.verwalter && anlaufstelle.verwalter.passwordData) {
            var passwordData = anlaufstelle.verwalter.passwordData;
            if (passwordData) {
                return this.passwordStrengthService.checkIfValid(passwordData.password, passwordData.passwordRepeat);
            }
        }
        return false;
    };
    AnlaufstelleRegistrierungViewController.$inject = ['DVBernUtil', '$q', '$scope', '$log', '$state', 'AnlaufstelleRS', 'PasswordStrengthService',
        'ErrorService', 'SchadenfallModelManager', 'RoleUtilService', 'AuthServiceRS', 'DvDialog', 'PAGE_NAMES'];
    return AnlaufstelleRegistrierungViewController;
}(abstractModelController_1.default));
exports.AnlaufstelleRegistrierungViewController = AnlaufstelleRegistrierungViewController;


/***/ }),

/***/ "2/9y":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("0Jor");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./benutzerRegView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./benutzerRegView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "21xJ":
/***/ (function(module, exports) {

module.exports = " <div class=\"container\"> <form role=\"form\" name=\"vm.form\" novalidate class=\"row marginTop20 col-md-12\"> <fieldset dv-show-allowed-roles=\"vm.getRolesAllowedForBankdaten()\" dv-show-element dv-show-expression=\"!!vm.model.gesuchsteller.rechtsform\" ng-disabled=\"vm.isSchadenFallReadonly()\"> <div class=\"row\"> <div class=\"col-sm-12\"> <h2 class=\"h2-gesuchsteller\"> <span class=\"h2-prefix\" ng-if=\"vm.showTitlePrefix()\">{{vm.model.gesuchsteller.eigentumsverhaeltnis | translate}}</span> <span data-translate=\"BANKANGABEN\"></span> </h2> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <div class=\"form-group\"> <div class=\"row\"> <dv-iban-input bisher-fs=\"vm.model.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung\" bisher-gs=\"vm.model.gesuchsteller.finanzangaben.finanzangabenDatenGS.bankverbindung\" bisher-property=\"iban\" clazz=\"col-sm-4\" label=\"IBAN\" model=\"vm.model.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung.iban\" name=\"gesuchsteller-iban\" placeholder=\"CHPP CCCC CKKK KKKK KKKK K\"> </dv-iban-input> </div> <div class=\"row\"> <dv-string-input bisher-fs=\"vm.model.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung\" bisher-gs=\"vm.model.gesuchsteller.finanzangaben.finanzangabenDatenGS.bankverbindung\" bisher-property=\"inhaberName\" clazz=\"col-sm-4\" label=\"KONTO_INHABER\" model=\"vm.model.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung.inhaberName\" name=\"gesuchsteller-inhaberName\"> </dv-string-input> <dv-string-input bisher-fs=\"vm.model.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung\" bisher-gs=\"vm.model.gesuchsteller.finanzangaben.finanzangabenDatenGS.bankverbindung\" bisher-property=\"inhaberPLZ\" clazz=\"col-sm-2 clearfix\" label=\"KONTO_INHABER_PLZ\" model=\"vm.model.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung.inhaberPLZ\" name=\"gesuchsteller-inhaberPLZ\"> </dv-string-input> <dv-string-input bisher-fs=\"vm.model.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung\" bisher-gs=\"vm.model.gesuchsteller.finanzangaben.finanzangabenDatenGS.bankverbindung\" bisher-property=\"inhaberOrt\" clazz=\"col-sm-4\" label=\"KONTO_INHABER_ORT\" model=\"vm.model.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung.inhaberOrt\" name=\"gesuchsteller-inhaberOrt\"> </dv-string-input> </div> </div> </div> </div> <div class=\"row mainbuttons\"> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.cancel()\"> <span data-translate=\"ZURUECK\"></span> </button> <dv-loading-button button-class=\"btn btn-serf\" button-click=\"vm.saveBankverbindung()\" type=\"submit\" class=\"col-sm-2\"> <span data-translate=\"SAVE\"></span> </dv-loading-button> </div> </fieldset> </form> </div> ";

/***/ }),

/***/ "29W2":
/***/ (function(module, exports) {

module.exports = " <ul ng-class=\"['nav', 'nav-tabs', 'dv-versicherung-navigation', {'navbar-sticky':vm.sticky}]\" role=\"navigation\"> <li class=\"dv-versicherung-navigation__li\"> <h1 ng-bind=\"vm.title\" class=\"dv-versicherung-navigation__title\" ng-class=\"{'dv-versicherung-navigation__stickytitle':vm.sticky}\"></h1> <span ng-bind=\"vm.status | translate\" class=\"dv-versicherung-navigation__status\" ng-if=\"!vm.sticky\"></span> </li> <li ui-sref-active=\"active\" ng-if=\"!vm.versBeitragId\"> <a class=\"dv-versicherung-navigation__a\" ui-sref=\"versicherungsbeitragschaden({createNew: 'true'})\" translate=\"NAV_VERSICHERUNG_ERFASSEN\"> </a> </li> <li ui-sref-active=\"active\" ng-if=\"vm.versBeitragId\"> <a class=\"dv-versicherung-navigation__a\" ui-sref=\"versicherungsbeitragschaden({versicherungsbeitragId: vm.versBeitragId,createNew: 'false'})\" translate=\"NAV_VERSICHERUNG_ERFASSEN\"> </a> </li> <li ui-sref-active=\"active\" ng-if=\"vm.versBeitragId\"> <a class=\"dv-versicherung-navigation__a\" ui-sref=\"versicherungbeitragversicherter({versicherungsbeitragId: vm.versBeitragId})\" translate=\"NAV_VERSICHERUNG_VERSICHERTER\"> </a> </li> <li ui-sref-active=\"active\" ng-if=\"vm.versBeitragId && vm.isInBearbeitung()\"> <a class=\"dv-versicherung-navigation__a\" ui-sref=\"versicherungbeitragbeitrag({versicherungsbeitragId: vm.versBeitragId})\" translate=\"NAV_VERSICHERUNG_BEITRAG\"> </a> </li> </ul> ";

/***/ }),

/***/ "2EdY":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("kwWi");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./benutzerverwaltung.module.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./benutzerverwaltung.module.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "2Swo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractModelController_1 = __importDefault(__webpack_require__("VDYy"));
var TSDokumentType_1 = __webpack_require__("/gTe");
var TSEigentumsverhaeltnis_1 = __webpack_require__("PSWS");
var TSVersicherungsbeitragStatus_1 = __webpack_require__("jJP+");
var TSGesuchsteller_1 = __importDefault(__webpack_require__("o8Fj"));
var TSVersicherungsbeitrag_1 = __importDefault(__webpack_require__("fGC3"));
var styles = __webpack_require__("kEdQ");
var template = __webpack_require__("Nx9a");
var VersicherungsbeitragVersicherterViewComponentConfig = /** @class */ (function () {
    function VersicherungsbeitragVersicherterViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = VersicherungsbeitragVersicherterViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            versicherungsbeitrag: '<'
        };
    }
    return VersicherungsbeitragVersicherterViewComponentConfig;
}());
exports.VersicherungsbeitragVersicherterViewComponentConfig = VersicherungsbeitragVersicherterViewComponentConfig;
var VersicherungsbeitragVersicherterViewController = /** @class */ (function (_super) {
    __extends(VersicherungsbeitragVersicherterViewController, _super);
    /* @ngInject */
    function VersicherungsbeitragVersicherterViewController(dvBernUtil, $q, $scope, $translate, $log, $state, versicherungsbeitragModelManager, versicherungRS) {
        var _this = _super.call(this, $scope) || this;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$translate = $translate;
        _this.$log = $log;
        _this.$state = $state;
        _this.versicherungsbeitragModelManager = versicherungsbeitragModelManager;
        _this.versicherungRS = versicherungRS;
        _this.possibleVersicherungen = [];
        _this.doctype = TSDokumentType_1.TSDocumentType.VERSICHERUNGSBEITRAG_DOC;
        return _this;
    }
    VersicherungsbeitragVersicherterViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        if (!this.versicherungsbeitrag) {
            this.versicherungsbeitrag = new TSVersicherungsbeitrag_1.default();
            // this.versicherungsbeitrag.versicherungsbeitragDatenFS = new TSVersicherungsbeitragDaten();
            // this.versicherungsbeitrag.versicherungsbeitragStundenDaten = [];
            this.$log.warn('initialized versicherungsbeitrag to edit directly in view, should pass versicherungsbeitrag to edit along');
        }
        else {
            this.initialModel = this.versicherungsbeitrag;
            this.model = angular.copy(this.versicherungsbeitrag);
        }
        this.readonly = !TSVersicherungsbeitragStatus_1.isStatusInBearbeitung(this.model.status);
        if (!this.model.gesuchsteller) {
            this.model.gesuchsteller = new TSGesuchsteller_1.default();
        }
        this.model.gesuchsteller.eigentumsverhaeltnis = TSEigentumsverhaeltnis_1.TSEigentumsverhaeltnis.VERSICHERTER;
    };
    VersicherungsbeitragVersicherterViewController.prototype.saveVersicherungsbeitrag = function () {
        var _this = this;
        if (this.isModelValid() && this.model) {
            this.model.gesuchsteller.cleanup();
            this.model.status = TSVersicherungsbeitragStatus_1.TSVersicherungsbeitragStatus.IN_BEARBEITUNG_FS; //nach speichern in Zustand Bearbeitung
            this.versicherungsbeitragModelManager.saveVersicherungsbeitrag(this.getModel()).then(function (result) {
                _this.$state.go('versicherungbeitragbeitrag', { versicherungsbeitragId: result.id });
            });
        }
        else {
            this.$log.debug('Form was not valid');
        }
    };
    VersicherungsbeitragVersicherterViewController.prototype.cancelVersicherungsbeitrag = function () {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('versicherungsbeitraege');
    };
    VersicherungsbeitragVersicherterViewController.prototype.getViewTitle = function () {
        return this.dvBernUtil.getVersicherungsbeitragViewTitle(this.model);
    };
    VersicherungsbeitragVersicherterViewController.$inject = ['DVBernUtil', '$q', '$scope', '$translate', '$log', '$state', 'VersicherungsbeitragModelManager', 'VersicherungRS'];
    return VersicherungsbeitragVersicherterViewController;
}(abstractModelController_1.default));
exports.VersicherungsbeitragVersicherterViewController = VersicherungsbeitragVersicherterViewController;


/***/ }),

/***/ "2nkm":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("Yg+e");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-error-messages.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-error-messages.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "2oh6":
/***/ (function(module, exports) {

module.exports = " <div dv-scroll-nav> <dv-gesuch-navigation title=\"{{vm.getViewTitle()}}\" schadenfall-id=\"{{vm.schadenfall.id}}\" status=\"{{vm.schadenfall.status}}\" sticky=\"sticky\" herkunft=\"{{vm.schadenfall.schadenfallHerkunft}}\"> </dv-gesuch-navigation> <div ng-class=\"['aufwaende-view', 'container', {'container-sticky':sticky}]\" ng-if=\"vm.isSchadenFallVisible()\"> <h2 class=\"marginTop0\"> <span data-translate=\"DIE_AUFWAENDE\" ng-if=\"!vm.schaetzung\"></span> <span data-translate=\"DIE_SCHAETZUNG\" ng-if=\"vm.schaetzung\"></span> </h2> <form role=\"form\" name=\"vm.aufwandForm\" class=\"\" novalidate unsaved-warning-form> <dv-input-container class=\"kommentar-feld\" ng-if=\"vm.schaetzung\"> <label class=\"md-no-float marginTop20\" for=\"vorgeseheneMassnahmen\" data-translate=\"SCHADEN_VORGESEHENE_MASSNAHMEN\"> </label> <textarea name=\"vorgeseheneMassnahmen\" class=\"form-control input-element\" rows=\"6\" id=\"vorgeseheneMassnahmen\" ng-model=\"vm.model.schaeden[0].schadenDatenFS.vorgeseheneMassnahmen\" ng-required=\"vm.isGeschaetzteMassnahmenRequired()\" ng-disabled=\"vm.isSchadenFallReadonly()\" maxlength=\"4000\">\n                </textarea> <dv-error-messages for=\"vm.aufwandForm.vorgeseheneMassnahmen\"></dv-error-messages> <dv-bisher gs=\"vm.schadenfall.schaeden[0].schadenDatenGS\" fs=\"vm.schadenfall.schaeden[0].schadenDatenFS\" property=\"vorgeseheneMassnahmen\" for=\"vm.aufwandForm.vorgeseheneMassnahmen\" textarea> </dv-bisher> </dv-input-container> <div class=\"col-sm-12\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getAllRolesButGesuchstellerArray()\" dv-show-expression=\"vm.showSubventioniert\"> <div class=\"row\"> <div class=\"col-sm-12\"> <span data-translate=\"SUBVENTIONIERT_DURCH\"></span> </div> <div class=\"col-sm-12\"> <dv-input-container> <div class=\"radio-inline\"> <label> <input type=\"radio\" ng-value=\"true\" name=\"subventioniertja\" ng-model=\"vm.model.schaeden[0].schadenDatenFS.otherwieseSubventionierbar\" ng-disabled=\"vm.isSchadenFallReadonly()\" ng-required=\"true\"> <span data-translate=\"LABEL_JA\"></span> </label> </div> <div class=\"radio-inline\"> <label> <input type=\"radio\" name=\"subventioniertja\" ng-value=\"false\" ng-model=\"vm.model.schaeden[0].schadenDatenFS.otherwieseSubventionierbar\" ng-disabled=\"vm.isSchadenFallReadonly()\" ng-required=\"true\"> <span data-translate=\"LABEL_NEIN\"></span> </label> </div> <dv-error-messages for=\"vm.formschaden.subventioniertja\"> </dv-error-messages> </dv-input-container> </div> </div> </div> <fieldset ng-if=\"vm.isSchadenFallVisible()\" ng-disabled=\"vm.isSchadenFallReadonly()\" class=\"row col-sm-12\"> <dv-loading-button button-class=\"btn btn-sub-serf\" button-click=\"vm.saveAufwaendeSchaden()\" type=\"submit\"> <span data-translate=\"BEENDEN_SPEICHERN\"></span> </dv-loading-button> </fieldset> </form> <div class=\"row\" ng-if=\"!vm.schaetzung\"> <div class=\"col-sm-12\"> <h2 class=\"marginTop60\"> <span data-translate=\"EIGENLEISTUNGEN\"></span> </h2> <div ng-if=\"!vm.isSchadenFallReadonly()\"> <button type=\"button\" ng-click=\"vm.addEigenleistung()\" class=\"btn btn-serf-red\"> <span class=\"fa fa-plus btn-ico\"></span> <span data-translate=\"EIGENLEISTUNG_ADD\"></span> </button> </div> </div> <div class=\"col-sm-12\"> <dv-eigenleistungen-list eigenleistungen=\"vm.relevanteEigenleistungen\" schadenfall=\"vm.schadenfall\" on-delete=\"vm.deleteEigenleistung(eigenleistung, event)\" on-edit=\"vm.editEigenleistung(eigenleistung, event)\" readonly=\"vm.isSchadenFallReadonly()\" schaetzung=\"vm.schaetzung\"> </dv-eigenleistungen-list> </div> </div> <div class=\"row marginTop20\"> <div class=\"col-sm-12\"> <div class=\"h2 clearfix\"> <span data-translate=\"FREMDKOSTEN\" ng-if=\"!vm.schaetzung\"></span> <span data-translate=\"SCHAETZUNG\" ng-if=\"vm.schaetzung\"></span> </div> <div ng-if=\"!vm.isSchadenFallReadonly()\"> <button type=\"button\" ng-click=\"vm.addFremdkosten()\" class=\"btn btn-serf-red\"> <span class=\"fa fa-plus btn-ico\"></span> <span data-translate=\"AUFWAND_FREMDKOSTEN_ADD\" ng-if=\"!vm.schaetzung\"></span> <span data-translate=\"SCHAETZUNG_ADD\" ng-if=\"vm.schaetzung\"></span> </button> </div> </div> <div class=\"col-sm-12\"> <dv-fremdkosten-list fremdkosten=\"vm.relevanteFremdkosten\" schadenfall=\"vm.schadenfall\" on-delete=\"vm.deleteFremdkosten(fremdkosten, event)\" on-edit=\"vm.editFremdkosten(fremdkosten, event)\" readonly=\"vm.isSchadenFallReadonly()\" schaetzung=\"vm.schaetzung\"> </dv-fremdkosten-list> </div> </div> <div class=\"row marginTop20\"> <div class=\"col-sm-12\"> <div class=\"h2 clearfix\"> <span data-translate=\"VORLEISTUNGEN\"></span> </div> <div ng-if=\"!vm.isSchadenFallReadonly()\"> <button type=\"button\" ng-click=\"vm.addVorleistung()\" class=\"btn btn-serf-red\"> <span class=\"fa fa-plus btn-ico\"></span> <span data-translate=\"VORLEISTUNG_ADD\"></span> </button> </div> </div> <div class=\"col-sm-12\"> <dv-vorleistungen-list vorleistungen=\"vm.relevanteVorleistungen\" schadenfall=\"vm.schadenfall\" on-delete=\"vm.deleteVorleistung(vorleistung, event)\" on-edit=\"vm.editVorleistung(vorleistung, event)\" readonly=\"vm.isSchadenFallReadonly()\" schaetzung=\"vm.schaetzung\"> </dv-vorleistungen-list> </div> </div> <div class=\"row marginTop20\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getRolesAllowedForSchaetzer()\"> <div class=\"col-sm-12\"> <div class=\"h2 clearfix\"> <span data-translate=\"TOTAL\"></span> </div> </div> <div class=\"col-sm-12\"> <table class=\"table table-alt\" title=\"{{'TOTAL' | translate}}\"> <tbody> <tr ng-if=\"!vm.schaetzung\"> <td data-translate=\"EIGENLEISTUNGEN\" ng-if=\"!vm.schaetzung\"> </td> <td class=\"text-right mono rowBody-betrag\"> {{vm.schadenfall.getEigenleistungenTotal(vm.schaetzung) | number: 2}} </td> <td class=\"rowBody-actions\"></td> </tr> <tr> <td data-translate=\"FREMDKOSTEN\" ng-if=\"!vm.schaetzung\"></td> <td data-translate=\"SCHAETZUNG\" ng-if=\"vm.schaetzung\"></td> <td class=\"text-right mono rowBody-betrag\"> {{vm.schadenfall.getFremdkostenTotal(vm.schaetzung) | number: 2}} </td> <td class=\"rowBody-actions\"></td> </tr> <tr> <td data-translate=\"VORLEISTUNGEN\"></td> <td class=\"text-right mono rowBody-betrag\"> - {{vm.schadenfall.getVorleistungenTotal(vm.schaetzung) | number: 2}} </td> <td class=\"rowBody-actions\"></td> </tr> </tbody> <tfoot> <tr class=\"tr-highlight\" ng-if=\"!vm.schaetzung\"> <td data-translate=\"ABRECHNUNGS_BETRAG\"></td> <td class=\"text-right mono rowBody-betrag\"> {{vm.schadenfall.getAbrechnungsbetrag(false) | number: 2}} </td> <td class=\"rowBody-actions\"></td> </tr> <tr class=\"tr-highlight\"> <td data-translate=\"TOTAL_SCHAETZUNG\"></td> <td class=\"text-right mono rowBody-betrag\"> {{vm.schadenfall.getAbrechnungsbetrag(true) | number: 2}} </td> <td class=\"rowBody-actions\"></td> </tr> <tr dv-show-expression=\"!vm.schaetzung\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getRolesAllowedForSchaetzer()\"> <td data-translate=\"GESCHAETZTER_MEHRWERT\"> </td> <td class=\"text-right mono\"> <dv-input-container class=\"text-right mono\"> <dv-valueinput input-id=\"geschaetzterMehrwert\" name=\"geschaetzterMehrwert\" input-name=\"geschaetzterMehrwert\" ng-model=\"vm.schadenfall.schaeden[0].schadenDatenFS.geschaetzterMehrwert\" ng-required=\"false\" ng-disabled=\"vm.isSchadenFallReadonly()\" allow-negative=\"false\" fixed-decimals=\"2\" always-format-with-two-decimals=\"true\" float=\"true\" class=\"bigger-font rowBody-betrag\"> </dv-valueinput> </dv-input-container> </td> <td class=\"rowBody-actions\"> <div ng-if=\"!vm.schaetzung\"> <dv-loading-button type=\"submit\" button-click=\"vm.saveAufwaendeSchaden()\" button-class=\"btn btn-serf pull-right\"> <span data-translate=\"SAVE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </td> </tr> </tfoot> </table> </div> </div> <div class=\"row marginTop20\"> <div class=\"col-md-12\"> <fieldset ng-disabled=\"vm.isSchadenFallReadonly()\"> <h2> <span ng-if=\"vm.schaetzung\" data-translate=\"BILDER_DOKUMENTE\"></span> <span ng-if=\"!vm.schaetzung\" data-translate=\"BILDER_DOKUMENTE_WIEDERHERSTELLUNG\"></span> </h2> <dv-dokumentupload schadenfallid=\"vm.schadenfall.id\" on-doc-removed=\"vm.onDocRemoved(document)\" on-doc-added=\"vm.onDocAdded(document)\" parentid=\"vm.schadenfall.id\" document-type=\"vm.doctype\" readonly=\"vm.isSchadenFallReadonly()\" begleit-text=\"{{vm.getBegleitTextCode()}}\"> </dv-dokumentupload> </fieldset> </div> </div> <form role=\"form\" name=\"vm.form\" novalidate class=\"row marginTop20 col-md-12\" ng-if=\"!vm.schaetzung\"> <fieldset dv-show-allowed-roles=\"vm.getRolesAllowedForBankdaten()\" dv-show-element dv-show-expression=\"!!vm.schadenfall.gesuchsteller.rechtsform\" ng-disabled=\"true\"> <div class=\"row\"> <div class=\"col-sm-12\"> <h2 class=\"h2-gesuchsteller\"> <span class=\"h2-prefix\" ng-if=\"vm.isShowTitlePrefix()\">{{vm.schadenfall.gesuchsteller.eigentumsverhaeltnis | translate}}</span> <span data-translate=\"BANKANGABEN\"></span> </h2> </div> </div> </fieldset> <div dv-show-allowed-roles=\"vm.getRolesAllowedForBankdaten()\" dv-show-element dv-show-expression=\"!!vm.schadenfall.gesuchsteller.rechtsform\" style=\"margin-bottom:20px\"> <dv-loading-button button-class=\"btn btn-serf\" button-click=\"vm.editBankkonto()\" type=\"submit\"> <span data-translate=\"BANKKONTO_EDITIEREN\"></span> </dv-loading-button> </div> <fieldset dv-show-allowed-roles=\"vm.getRolesAllowedForBankdaten()\" dv-show-element dv-show-expression=\"!!vm.schadenfall.gesuchsteller.rechtsform\" ng-disabled=\"true\"> <div class=\"row\"> <div class=\"col-sm-12\"> <div class=\"form-group\"> <div class=\"row\"> <dv-iban-input bisher-fs=\"vm.schadenfall.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung\" bisher-gs=\"vm.schadenfall.gesuchsteller.finanzangaben.finanzangabenDatenGS.bankverbindung\" bisher-property=\"iban\" clazz=\"col-sm-4\" label=\"IBAN\" model=\"vm.schadenfall.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung.iban\" name=\"gesuchsteller-iban\" placeholder=\"CHPP CCCC CKKK KKKK KKKK K\"> </dv-iban-input> </div> <div class=\"row\"> <dv-string-input bisher-fs=\"vm.schadenfall.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung\" bisher-gs=\"vm.schadenfall.gesuchsteller.finanzangaben.finanzangabenDatenGS.bankverbindung\" bisher-property=\"inhaberName\" clazz=\"col-sm-4\" label=\"KONTO_INHABER\" model=\"vm.schadenfall.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung.inhaberName\" name=\"gesuchsteller-inhaberName\"> </dv-string-input> <dv-string-input bisher-fs=\"vm.schadenfall.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung\" bisher-gs=\"vm.schadenfall.gesuchsteller.finanzangaben.finanzangabenDatenGS.bankverbindung\" bisher-property=\"inhaberPLZ\" clazz=\"col-sm-2 clearfix\" label=\"KONTO_INHABER_PLZ\" model=\"vm.schadenfall.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung.inhaberPLZ\" name=\"gesuchsteller-inhaberPLZ\"> </dv-string-input> <dv-string-input bisher-fs=\"vm.schadenfall.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung\" bisher-gs=\"vm.schadenfall.gesuchsteller.finanzangaben.finanzangabenDatenGS.bankverbindung\" bisher-property=\"inhaberOrt\" clazz=\"col-sm-4\" label=\"KONTO_INHABER_ORT\" model=\"vm.schadenfall.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung.inhaberOrt\" name=\"gesuchsteller-inhaberOrt\"> </dv-string-input> </div> </div> </div> </div> </fieldset> </form> <div class=\"row marginTop20\"> <div class=\"col-sm-12\"> <div class=\"h2 clearfix\"> <span data-translate=\"BEMERKUNGEN\"></span> </div> <div ng-if=\"!vm.isSchadenFallReadonly()\" class=\"marginBottom60\"> <dv-bemerkung-erfassen ng-if=\"!vm.isSchadenFallReadonly()\" schadenfall-id=\"vm.schadenfall.id\" scope=\"vm.scope\"></dv-bemerkung-erfassen> </div> <div> <dv-bemerkung-list system-bemerkungen=\"vm.schadenfall.systemBemerkungen\" benutzer-bemerkungen=\"vm.schadenfall.benutzerBemerkungen\" transition-bemerkungen=\"vm.schadenfall.transitionBemerkungen\" scope-to-show=\"vm.scopeToShow\" schadenfall-id=\"vm.schadenfall.id\" readonly=\"vm.isSchadenFallReadonly()\"></dv-bemerkung-list> </div> </div> </div> <form role=\"form\" name=\"vm.form\" class=\"row marginTop20\" novalidate> <div class=\"row\" ng-if=\"vm.isFreigabeVisible()\"> <div class=\"checklist\"> <div class=\"h2 clearfix\"> <span data-translate=\"CHECKLISTE\"></span> </div> <dv-checklist checklist-points=\"vm.getChecklistEntries()\" on-checkstatus-chaged=\"vm.checklistStatusChanged(allchecked)\"></dv-checklist> </div> </div> </form> </div> <fieldset> <div class=\"row freigebenfs\" ng-if=\"vm.isFreigabeVisible()\"> <div class=\"col-sm-12\"> <div class=\"row\"> <div class=\"col-sm-12 schadenevents\"> <dv-input-container> <div class=\"radio\" ng-repeat=\"schadenfallEvent in vm.getSchadenfallEvents()\"> <label> <input ng-value=\"schadenfallEvent\" aria-label=\"{{schadenfallEvent}}\" ng-model=\"vm.schadenfallEvent\" ng-disabled=\"vm.isFreigabeDisabled()\" type=\"radio\" name=\"schadenfallEvent\" ng-required=\"true\" class=\"input-element\"> <span>{{schadenfallEvent | translate}}</span> </label> </div> </dv-input-container> </div> </div> </div> <div class=\"mainbuttons-freigeben\"> <div> <dv-loading-button type=\"submit\" button-click=\"vm.next()\" button-class=\"btn btn-serf\" button-disabled=\"!vm.schadenfallEvent\"> <span data-translate=\"FREIGEBEN\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </div> </fieldset> </div> ";

/***/ }),

/***/ "2uaK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
__webpack_require__("fjOH");
var core_module_1 = __webpack_require__("u87A");
__webpack_require__("Emwh");
var schadenfaelle_route_1 = __webpack_require__("DBv6");
var schadenfaelleListView_1 = __webpack_require__("aRbG");
exports.SerfWebSchadenfaelle = angular.module('serfWeb.schadenfaelle', [core_module_1.SerfWebCore.name])
    .component('schadenfaelleView', new schadenfaelleListView_1.SchadenfaelleListViewComponentConfig())
    .run(schadenfaelle_route_1.schadenfaelleRun);
exports.default = exports.SerfWebSchadenfaelle;


/***/ }),

/***/ "2uqJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSBemerkungSichtbarkeit;
(function (TSBemerkungSichtbarkeit) {
    TSBemerkungSichtbarkeit[TSBemerkungSichtbarkeit["ALLE"] = 'ALLE'] = "ALLE";
    TSBemerkungSichtbarkeit[TSBemerkungSichtbarkeit["INTERN"] = 'INTERN'] = "INTERN";
    TSBemerkungSichtbarkeit[TSBemerkungSichtbarkeit["FONDSSUISSE"] = 'FONDSSUISSE'] = "FONDSSUISSE";
})(TSBemerkungSichtbarkeit = exports.TSBemerkungSichtbarkeit || (exports.TSBemerkungSichtbarkeit = {}));
function getTSBemerkungSichtbarkeitValues() {
    return [
        TSBemerkungSichtbarkeit.FONDSSUISSE,
        TSBemerkungSichtbarkeit.INTERN,
        TSBemerkungSichtbarkeit.ALLE,
    ];
}
exports.getTSBemerkungSichtbarkeitValues = getTSBemerkungSichtbarkeitValues;


/***/ }),

/***/ "2zEh":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("WRab");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./aufwaendeView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./aufwaendeView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3/Vo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var moment_1 = __importDefault(__webpack_require__("PJh5"));
var TSAbstractBemerkungEntity_1 = __importDefault(__webpack_require__("NwLi"));
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
var TSBenutzerBemerkung = /** @class */ (function (_super) {
    __extends(TSBenutzerBemerkung, _super);
    function TSBenutzerBemerkung() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSBenutzerBemerkung.prototype, "besitzer", {
        get: function () {
            return this._besitzer;
        },
        set: function (value) {
            this._besitzer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBenutzerBemerkung.prototype, "scope", {
        get: function () {
            return this._scope;
        },
        set: function (value) {
            this._scope = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBenutzerBemerkung.prototype, "sichtbarkeit", {
        get: function () {
            return this._sichtbarkeit;
        },
        set: function (value) {
            this._sichtbarkeit = value;
        },
        enumerable: true,
        configurable: true
    });
    TSBenutzerBemerkung.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.scope = restObject.scope;
        this.sichtbarkeit = restObject.sichtbarkeit;
        this.besitzer = this.deserializeOrNull(restObject.besitzer, new TSBenutzer_1.default());
        return this;
    };
    TSBenutzerBemerkung.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.scope = this.scope;
        restObject.sichtbarkeit = this.sichtbarkeit;
        restObject.besitzer = this.serializeOrInit(this.besitzer, restObject.besitzer);
        return restObject;
    };
    TSBenutzerBemerkung.prototype.getBesitzerName = function () {
        if (this.besitzer && this.besitzer.getFullName()) {
            return this.besitzer.getFullName();
        }
        return ' ';
    };
    TSBenutzerBemerkung.prototype.getTimestampErstellt = function () {
        if (this.timestampErstellt) {
            return this.timestampErstellt;
        }
        return moment_1.default();
    };
    TSBenutzerBemerkung.prototype.getBemerkungScope = function () {
        return this.scope;
    };
    TSBenutzerBemerkung.prototype.getBesitzer = function () {
        return this.besitzer;
    };
    TSBenutzerBemerkung.getDeserializer = function (benutzerBemerkung) {
        return new TSBenutzerBemerkung().deserialize(benutzerBemerkung);
    };
    TSBenutzerBemerkung.getSerializer = function (benutzerBemerkung) {
        return benutzerBemerkung.serialize(benutzerBemerkung);
    };
    return TSBenutzerBemerkung;
}(TSAbstractBemerkungEntity_1.default));
exports.default = TSBenutzerBemerkung;


/***/ }),

/***/ "3494":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSVorleistungDaten_1 = __importDefault(__webpack_require__("3Ly2"));
var TSVorleistung = /** @class */ (function (_super) {
    __extends(TSVorleistung, _super);
    function TSVorleistung() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._documentIdsToConnect = [];
        return _this;
    }
    TSVorleistung.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.vorleistungDatenFS = this.deserializeOrCreate(restObject.vorleistungDatenFS, new TSVorleistungDaten_1.default());
        this.vorleistungDatenGS = this.deserializeOrNull(restObject.vorleistungDatenGS, new TSVorleistungDaten_1.default());
        this.schaetzung = restObject.schaetzung;
        return this;
    };
    TSVorleistung.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.vorleistungDatenGS = this.serializeOrInit(this.vorleistungDatenGS, restObject.vorleistungDatenGS);
        restObject.vorleistungDatenFS = this.serializeOrInit(this.vorleistungDatenFS, restObject.vorleistungDatenFS);
        restObject.schaetzung = this.schaetzung;
        return restObject;
    };
    Object.defineProperty(TSVorleistung.prototype, "vorleistungDatenGS", {
        get: function () {
            return this._vorleistungDatenGS;
        },
        set: function (value) {
            this._vorleistungDatenGS = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVorleistung.prototype, "vorleistungDatenFS", {
        get: function () {
            return this._vorleistungDatenFS;
        },
        set: function (value) {
            this._vorleistungDatenFS = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVorleistung.prototype, "documentIdsToConnect", {
        get: function () {
            return this._documentIdsToConnect;
        },
        set: function (value) {
            this._documentIdsToConnect = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVorleistung.prototype, "schaetzung", {
        get: function () {
            return this._schaetzung;
        },
        set: function (value) {
            this._schaetzung = value;
        },
        enumerable: true,
        configurable: true
    });
    TSVorleistung.getDeserializer = function (vorleistung) {
        return new TSVorleistung().deserialize(vorleistung);
    };
    TSVorleistung.getSerializer = function (vorleistung) {
        return vorleistung.serialize(vorleistung);
    };
    return TSVorleistung;
}(TSAbstractEntity_1.default));
exports.default = TSVorleistung;


/***/ }),

/***/ "3Bji":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("Q+7X");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-geoadmin-search.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-geoadmin-search.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3CBU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSPasswordData = /** @class */ (function () {
    function TSPasswordData(email, resetToken) {
        this._email = email;
        this._resetToken = resetToken;
    }
    Object.defineProperty(TSPasswordData.prototype, "password", {
        get: function () {
            return this._password;
        },
        set: function (value) {
            this._password = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSPasswordData.prototype, "passwordRepeat", {
        get: function () {
            return this._passwordRepeat;
        },
        set: function (value) {
            this._passwordRepeat = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSPasswordData.prototype, "email", {
        get: function () {
            return this._email;
        },
        set: function (value) {
            this._email = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSPasswordData.prototype, "resetToken", {
        get: function () {
            return this._resetToken;
        },
        set: function (value) {
            this._resetToken = value;
        },
        enumerable: true,
        configurable: true
    });
    TSPasswordData.prototype.serialize = function (restObject) {
        restObject.email = this.email;
        restObject.resetToken = this.resetToken;
        restObject.password = this.password;
        restObject.passwordRepeat = this.passwordRepeat;
        return restObject;
    };
    TSPasswordData.prototype.deserialize = function (restObject) {
        this._resetToken = restObject.resetToken;
        this._password = restObject.password;
        this._passwordRepeat = restObject.passwordRepeat;
        this._email = restObject.email;
        return this;
    };
    return TSPasswordData;
}());
exports.default = TSPasswordData;


/***/ }),

/***/ "3Ly2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSVorleistungDaten = /** @class */ (function (_super) {
    __extends(TSVorleistungDaten, _super);
    function TSVorleistungDaten() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSVorleistungDaten.prototype, "policeNr", {
        get: function () {
            return this._policeNr;
        },
        set: function (value) {
            this._policeNr = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVorleistungDaten.prototype, "betrag", {
        get: function () {
            return this._betrag;
        },
        set: function (value) {
            this._betrag = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVorleistungDaten.prototype, "berechtigterBetrag", {
        get: function () {
            return this._berechtigterBetrag;
        },
        set: function (value) {
            this._berechtigterBetrag = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVorleistungDaten.prototype, "vorleistungenArt", {
        get: function () {
            return this._vorleistungenArt;
        },
        set: function (value) {
            this._vorleistungenArt = value;
        },
        enumerable: true,
        configurable: true
    });
    TSVorleistungDaten.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.vorleistungenArt = restObject.vorleistungenArt;
        this.policeNr = restObject.policeNr;
        this.betrag = restObject.betrag;
        this.berechtigterBetrag = restObject.berechtigterBetrag;
        return this;
    };
    TSVorleistungDaten.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.vorleistungenArt = this.vorleistungenArt;
        restObject.policeNr = this.policeNr;
        restObject.betrag = this.betrag;
        restObject.berechtigterBetrag = this.berechtigterBetrag;
        return restObject;
    };
    return TSVorleistungDaten;
}(TSAbstractEntity_1.default));
exports.default = TSVorleistungDaten;


/***/ }),

/***/ "3Tvv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var OkCancelController_1 = __webpack_require__("r+7B");
var OkHtmlDialogController_1 = __webpack_require__("U0eN");
var TSSerfProperty_1 = __importDefault(__webpack_require__("MbEi"));
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
__webpack_require__("iGoB");
var template = __webpack_require__("50/w");
var okCancelTemplate = __webpack_require__("CYbW");
var okHtmlDialogTemplate = __webpack_require__("ncnt");
var KonfigurationViewComponentConfig = /** @class */ (function () {
    function KonfigurationViewComponentConfig() {
        this.transclude = false;
        this.bindings = {
            serfProperties: '<',
            sachbearbeiterList: '<',
            adminList: '<'
        };
        this.template = template;
        this.controller = KonfigurationViewController;
        this.controllerAs = 'vm';
    }
    return KonfigurationViewComponentConfig;
}());
exports.KonfigurationViewComponentConfig = KonfigurationViewComponentConfig;
var KonfigurationViewController = /** @class */ (function () {
    /* @ngInject */
    function KonfigurationViewController(fondssuisseRS, MAX_LENGTH, dvDialog, authServiceRS, serfPropertyRS, benutzerRS) {
        this.fondssuisseRS = fondssuisseRS;
        this.dvDialog = dvDialog;
        this.authServiceRS = authServiceRS;
        this.serfPropertyRS = serfPropertyRS;
        this.benutzerRS = benutzerRS;
        this.serfProperty = new TSSerfProperty_1.default();
        this.length = MAX_LENGTH;
    }
    KonfigurationViewController.prototype.$onInit = function () {
    };
    KonfigurationViewController.prototype.submitSerfProperty = function () {
        var _this = this;
        //testen ob aktuelles property schon gespeichert ist
        if (this.serfProperty && this.serfProperty.name) {
            if (!this.serfProperty.isNew()) {
                this.serfPropertyRS.update(this.serfProperty.name, this.serfProperty.value)
                    .then(function (response) {
                    var index = DVBernUtil_1.default.getIndexOfElementwithIDById(response.id, _this.serfProperties);
                    _this.serfProperties[index] = response;
                });
            }
            else {
                this.serfPropertyRS.create(this.serfProperty.name, this.serfProperty.value)
                    .then(function (response) {
                    _this.serfProperties = _this.serfProperties.concat(response);
                });
            }
            this.resetForm();
        }
    };
    KonfigurationViewController.prototype.removeSerfProperty = function (serfProperty) {
        var _this = this;
        if (serfProperty.name) {
            this.serfPropertyRS.remove(serfProperty.name).then(function (reponse) {
                var index = _this.serfProperties.indexOf(serfProperty);
                if (index !== -1) {
                    _this.serfProperties.splice(index, 1);
                    _this.resetForm();
                }
            });
        }
    };
    KonfigurationViewController.prototype.editSerfProperty = function (serfProperty) {
        this.serfProperty = serfProperty;
    };
    KonfigurationViewController.prototype.removeBetroffeneRole = function () {
        var _this = this;
        if (this.benutzerEmail) {
            this.benutzerRS.removeBetroffeneRole(this.benutzerEmail).then(function (response) {
                return _this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController_1.OkHtmlDialogController, {
                    title: 'FS_BETROFFENE_ROLLE_ENTFERNEN',
                    text: 'BETROFFENE_ROLLE_ENTFERNT'
                }).then(function () {
                    //do nothin
                });
            });
        }
        else {
            return this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController_1.OkHtmlDialogController, {
                title: 'EMAIL_UNGUELTIG',
                text: 'BITTE_EMAIL'
            });
        }
        return null;
    };
    KonfigurationViewController.prototype.resetForm = function () {
        this.serfProperty = new TSSerfProperty_1.default();
    };
    KonfigurationViewController.prototype.addFSSachbearbeiter = function () {
        var _this = this;
        if (this.sachbearbeiterToAdd) {
            this.fondssuisseRS.addFSSachbearbeiterRole(this.sachbearbeiterToAdd.id)
                .then(function (user) {
                if (user !== undefined) {
                    var index = DVBernUtil_1.default.getIndexOfElementwithID(user, _this.sachbearbeiterList);
                    if (index === -1) {
                        _this.sachbearbeiterList.push(user);
                    } //else do nothing
                }
            });
        }
        this.sachbearbeiterToAdd = undefined;
    };
    KonfigurationViewController.prototype.addFSAdmin = function () {
        var _this = this;
        if (this.adminToAdd) {
            this.fondssuisseRS.addFSAdminRole(this.adminToAdd.id)
                .then(function (user) {
                if (user !== undefined) {
                    var index = DVBernUtil_1.default.getIndexOfElementwithID(user, _this.adminList);
                    if (index === -1) {
                        _this.adminList.push(user);
                    } //else do nothing
                }
            });
        }
        this.adminToAdd = undefined;
    };
    KonfigurationViewController.prototype.removeSachbearbeiter = function (benutzer, event) {
        var _this = this;
        this.fondssuisseRS.removeFSSachbearbeiterRole(benutzer.id).then(function (response) {
            if (benutzer) {
                var arrWithoutEle = _this.sachbearbeiterList.filter(function (currentBen) { return currentBen !== benutzer; });
                _this.sachbearbeiterList = arrWithoutEle;
            }
        });
    };
    KonfigurationViewController.prototype.removeAdmin = function (benutzer, event) {
        var _this = this;
        var loggedInUser = this.authServiceRS.getPrincipal();
        //wenn man sich selber die Rolle wegnimmt zeigen wir noch eine Warnung
        if (loggedInUser && loggedInUser.id === benutzer.id) {
            var text = 'CONFIRM_ROLE_REMOVAL';
            this.dvDialog.showDialog(okCancelTemplate, OkCancelController_1.OkCancelController, { text: text })
                .then(function () {
                _this.triggerRemoveFSAdminRole(benutzer);
            })
                .catch(function () {
            });
        }
        else {
            this.triggerRemoveFSAdminRole(benutzer);
        }
    };
    KonfigurationViewController.prototype.triggerRemoveFSAdminRole = function (benutzer) {
        var _this = this;
        this.fondssuisseRS.removeFSAdminRole(benutzer.id).then(function (response) {
            if (benutzer) {
                var arrWithoutEle = _this.adminList.filter(function (currentBen) { return currentBen !== benutzer; });
                _this.adminList = arrWithoutEle;
            }
        });
    };
    KonfigurationViewController.prototype.getVersion = function () {
        return "2.7.0";
    };
    KonfigurationViewController.prototype.getBuildtimestamp = function () {
        return "2026-09-21T12:06:11.057Z";
    };
    KonfigurationViewController.$inject = ['FondssuisseRS', 'MAX_LENGTH', 'DvDialog', 'AuthServiceRS', 'SerfPropertyRS', 'BenutzerRS'];
    return KonfigurationViewController;
}());
exports.KonfigurationViewController = KonfigurationViewController;


/***/ }),

/***/ "3UQ6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "3irw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isInstanceOfHasUnconnectedDocuments(object) {
    return 'documentIdsToConnect' in object;
}
exports.isInstanceOfHasUnconnectedDocuments = isInstanceOfHasUnconnectedDocuments;


/***/ }),

/***/ "3nXf":
/***/ (function(module, exports) {

module.exports = " <ul class=\"dvb-version list-inline no-margin\"> <li><i class=\"fa fa-copyright\"></i> DV Bern AG <span ng-bind=\"vm.currentYear\"></span></li> <li ng-if=\"vm.showSingleVersion\" class=\"version\" data-translate=\"VERSION_INFO_SINGLE\" data-translate-value-version=\"{{vm.frontendVersion}}\"></li> <li ng-if=\"!vm.showSingleVersion\" class=\"version\" data-translate=\"VERSION_INFO\" data-translate-value-frontend-version=\"{{vm.frontendVersion}}\" data-translate-value-backend-version=\"{{vm.backendVersion}}\"> </li> <li ng-if=\"!vm.dontShowAllDetails\"><i><span ng-bind=\"vm.buildTime | amDateFormat : 'DD.MM.YYYY HH:MM:SS'\"></span></i> </li><li ng-if=\"!vm.dontShowAllDetails\"><i><span ng-bind=\"vm.clientEnvironment\"></span></i> </li></ul> ";

/***/ }),

/***/ "3oUo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSSprache;
(function (TSSprache) {
    TSSprache[TSSprache["DEUTSCH"] = 'DEUTSCH'] = "DEUTSCH";
    TSSprache[TSSprache["FRANZOESISCH"] = 'FRANZOESISCH'] = "FRANZOESISCH";
    TSSprache[TSSprache["ITALIENISCH"] = 'ITALIENISCH'] = "ITALIENISCH";
})(TSSprache = exports.TSSprache || (exports.TSSprache = {}));
function getTSSpracheValues() {
    return [
        TSSprache.DEUTSCH,
        TSSprache.FRANZOESISCH,
        TSSprache.ITALIENISCH,
    ];
}
exports.getTSSpracheValues = getTSSpracheValues;
function getLanguageMap() {
    var map = new Map();
    map.set('de', TSSprache.DEUTSCH);
    map.set('fr', TSSprache.FRANZOESISCH);
    map.set('it', TSSprache.ITALIENISCH);
    return map;
}
exports.getLanguageMap = getLanguageMap;
function getLanguageByKey(key) {
    var map = getLanguageMap();
    var returnValue = map.get(key);
    if (returnValue) {
        return returnValue;
    }
    else {
        return TSSprache.DEUTSCH;
    }
}
exports.getLanguageByKey = getLanguageByKey;


/***/ }),

/***/ "3px/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.versicherungsbeitrag-beitrag-view .btn-beitrag-loeschen{margin-top:24px}.versicherungsbeitrag-beitrag-view .beitragadd.ng-enter,.versicherungsbeitrag-beitrag-view .beitragadd.ng-leave{-webkit-transition:opacity .4s ease-in-out;transition:opacity .4s ease-in-out}.versicherungsbeitrag-beitrag-view .beitragadd.ng-enter,.versicherungsbeitrag-beitrag-view .beitragadd.ng-leave.ng-leave-active{opacity:0}.versicherungsbeitrag-beitrag-view .beitragadd.ng-enter.ng-enter-active,.versicherungsbeitrag-beitrag-view .beitragadd.ng-leave{opacity:1}", ""]);

// exports


/***/ }),

/***/ "3wrz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSVorleistung_1 = __importDefault(__webpack_require__("3494"));
/**
 * Service zum verwalten von Vorleistung Angaben
 *
 */
var VorleistungRS = /** @class */ (function () {
    /* @ngInject */
    function VorleistungRS($http, CONSTANTS, $q, $rootScope, $log) {
        this.$http = $http;
        this.CONSTANTS = CONSTANTS;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$log = $log;
    }
    VorleistungRS.prototype.saveVorleistung = function (schadenfallId, vorleistung) {
        if (vorleistung) {
            var restVorleistung = vorleistung.serialize({});
            return this.$http.put(this.CONSTANTS.REST_API + 'vorleistungen/' + encodeURIComponent(schadenfallId), restVorleistung)
                .then(function (response) {
                if (response.data !== undefined) {
                    return new TSVorleistung_1.default().deserialize(response.data);
                }
                else {
                    return undefined;
                }
            });
        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    };
    VorleistungRS.prototype.deleteVorleistung = function (vorleistung) {
        return this.$http.delete(this.CONSTANTS.REST_API + 'vorleistungen/' + encodeURIComponent(vorleistung.id))
            .then(function (response) {
            return response;
        });
    };
    VorleistungRS.$inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];
    return VorleistungRS;
}());
exports.default = VorleistungRS;


/***/ }),

/***/ "3zgS":
/***/ (function(module, exports) {

module.exports = "<h2 data-translate=\"AUSZAHLUNG\"></h2> <div class=\"row\"> <div class=\"col-sm-3 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"ERSTELLT_VON\"> </label> <div class=\"noselect\" ng-bind=\"vm.zahlungsauftrag.besitzerName\"></div> </dv-input-container> </div> <div class=\"col-sm-3 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"ERSTELLT_AM\"> </label> <div class=\"noselect\" ng-bind=\"vm.zahlungsauftrag.timestampErstellt | amDateFormat : 'DD.MM.YYYY'\"></div> </dv-input-container> </div> <div class=\"col-sm-3 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"DATUM_FAELLIG\"> </label> <div class=\"noselect\" ng-bind=\"vm.zahlungsauftrag.datumFaellig  | amDateFormat : 'DD.MM.YYYY'\"></div> </dv-input-container> </div> <div class=\"col-sm-3 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"REF_BUCHHALTUNG\"> </label> <div class=\"noselect\" ng-bind=\"vm.zahlungsauftrag.ref\"></div> </dv-input-container> </div> </div> ";

/***/ }),

/***/ "4K5/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "4NcG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var TSErfassungsArt_1 = __webpack_require__("X/T9");
var TSRole_1 = __webpack_require__("MleR");
var TSSchadenfallEvent_1 = __webpack_require__("cKO2");
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var TSStatuswechsel_1 = __importDefault(__webpack_require__("o20y"));
var StatuswechselService = /** @class */ (function () {
    /* @ngInject */
    function StatuswechselService($log, pageNames, begrundugnscodeMapperService) {
        this.$log = $log;
        this.pageNames = pageNames;
        this.begrundugnscodeMapperService = begrundugnscodeMapperService;
        this.statusMap = [];
        var inBearbeitungASWechsel = new TSStatuswechsel_1.default(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE), ['CHECK_BEARBEITUNG_AS_1', 'CHECK_BEARBEITUNG_AS_2', 'CHECK_BEARBEITUNG_AS_3', 'CHECK_BEARBEITUNG_AS_4'], [TSSchadenfallEvent_1.TSSchadenfallEvent.ANLAUFSTELLE_BASISPRUEFUNG_OK, TSSchadenfallEvent_1.TSSchadenfallEvent.STICHENTSCHEID_ANGEFORDERT], [TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.SUPER_ADMIN], pageNames.SCHADENMELDUNG, [TSErfassungsArt_1.TSErfassungsArt.ONLINE, TSErfassungsArt_1.TSErfassungsArt.PAPIER]);
        this.statusMap.push(inBearbeitungASWechsel);
        var inBearbeitungASStichentscheidFS = new TSStatuswechsel_1.default(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, //In Bearbeitung bei fondssuisse für Ablehnung
        this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS), ['CHECK_IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS_1'], [TSSchadenfallEvent_1.TSSchadenfallEvent.STICHENTSCHEID_OK, TSSchadenfallEvent_1.TSSchadenfallEvent.ABLEHNUNG], [TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.SUPER_ADMIN], pageNames.SCHADENMELDUNG, [TSErfassungsArt_1.TSErfassungsArt.ONLINE, TSErfassungsArt_1.TSErfassungsArt.PAPIER]);
        this.statusMap.push(inBearbeitungASStichentscheidFS);
        var schaetzungDurchgefuehrtWechsel = new TSStatuswechsel_1.default(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER), ['CHECK_AUFTRAG_SCHAETZER_1', 'CHECK_AUFTRAG_SCHAETZER_2', 'CHECK_AUFTRAG_SCHAETZER_3', 'CHECK_AUFTRAG_SCHAETZER_4'], [TSSchadenfallEvent_1.TSSchadenfallEvent.SCHAETZUNG_DURCHGEFUEHRT], [TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.SUPER_ADMIN], pageNames.SCHAETZUNG, [TSErfassungsArt_1.TSErfassungsArt.ONLINE, TSErfassungsArt_1.TSErfassungsArt.PAPIER]);
        this.statusMap.push(schaetzungDurchgefuehrtWechsel);
        var ueberpruefungAnlaufstelleWechsel = new TSStatuswechsel_1.default(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE), ['CHECK_UEBERPRUEFUNG_AS_1', 'CHECK_UEBERPRUEFUNG_AS_2', 'CHECK_UEBERPRUEFUNG_AS_3', 'CHECK_UEBERPRUEFUNG_AS_4'], [TSSchadenfallEvent_1.TSSchadenfallEvent.ANLAUFSTELLE_SCHAETZUNG_OK, TSSchadenfallEvent_1.TSSchadenfallEvent.STICHENTSCHEID_ANGEFORDERT, TSSchadenfallEvent_1.TSSchadenfallEvent.ZURUECK_AN_SCHAETZER], [TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.SUPER_ADMIN], pageNames.SCHAETZUNG, [TSErfassungsArt_1.TSErfassungsArt.ONLINE, TSErfassungsArt_1.TSErfassungsArt.PAPIER]);
        this.statusMap.push(ueberpruefungAnlaufstelleWechsel);
        var ueberpruefungASStichentscheidFS = new TSStatuswechsel_1.default(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, //Überprüfung bei fondssuisse für Ablehnung
        this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS), ['CHECK_UEBERPRUEFUNG_AS_STICHENTSCHEID_FS_1'], [TSSchadenfallEvent_1.TSSchadenfallEvent.STICHENTSCHEID_OK, TSSchadenfallEvent_1.TSSchadenfallEvent.ABLEHNUNG], [TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.SUPER_ADMIN], pageNames.SCHAETZUNG, [TSErfassungsArt_1.TSErfassungsArt.ONLINE, TSErfassungsArt_1.TSErfassungsArt.PAPIER]);
        this.statusMap.push(ueberpruefungASStichentscheidFS);
        var ueberpruefungFSWechselOnline = new TSStatuswechsel_1.default(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE), ['CHECK_UEBERPRUEFUNG_FS_1', 'CHECK_UEBERPRUEFUNG_FS_2', 'CHECK_UEBERPRUEFUNG_FS_3', 'CHECK_UEBERPRUEFUNG_FS_4',
            'CHECK_UEBERPRUEFUNG_FS_5', 'CHECK_UEBERPRUEFUNG_FS_6', 'CHECK_UEBERPRUEFUNG_FS_7', 'CHECK_UEBERPRUEFUNG_FS_8',
            'CHECK_UEBERPRUEFUNG_FS_9', 'CHECK_UEBERPRUEFUNG_FS_11', 'CHECK_UEBERPRUEFUNG_FS_12', 'CHECK_UEBERPRUEFUNG_FS_13'], [TSSchadenfallEvent_1.TSSchadenfallEvent.FS_UEBERPRUEFUNG_OK, TSSchadenfallEvent_1.TSSchadenfallEvent.FS_UEBERPRUEFUNG_MANGELHAFT, TSSchadenfallEvent_1.TSSchadenfallEvent.ABLEHNUNG], [TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.SUPER_ADMIN], pageNames.SCHAETZUNG, [TSErfassungsArt_1.TSErfassungsArt.ONLINE]);
        this.statusMap.push(ueberpruefungFSWechselOnline);
        var ueberpruefungFSWechselPapier = new TSStatuswechsel_1.default(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE), ['CHECK_UEBERPRUEFUNG_FS_1', 'CHECK_UEBERPRUEFUNG_FS_2', 'CHECK_UEBERPRUEFUNG_FS_3', 'CHECK_UEBERPRUEFUNG_FS_4',
            'CHECK_UEBERPRUEFUNG_FS_5', 'CHECK_UEBERPRUEFUNG_FS_6', 'CHECK_UEBERPRUEFUNG_FS_7', 'CHECK_UEBERPRUEFUNG_FS_8',
            'CHECK_UEBERPRUEFUNG_FS_9', 'CHECK_UEBERPRUEFUNG_FS_11', 'CHECK_UEBERPRUEFUNG_FS_12', 'CHECK_UEBERPRUEFUNG_FS_13'], [TSSchadenfallEvent_1.TSSchadenfallEvent.FS_UEBERPRUEFUNG_OK_PAPIER, TSSchadenfallEvent_1.TSSchadenfallEvent.FS_UEBERPRUEFUNG_MANGELHAFT, TSSchadenfallEvent_1.TSSchadenfallEvent.ABLEHNUNG], [TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.SUPER_ADMIN], pageNames.SCHAETZUNG, [TSErfassungsArt_1.TSErfassungsArt.PAPIER]);
        this.statusMap.push(ueberpruefungFSWechselPapier);
        var wiederherstellungWechsel = new TSStatuswechsel_1.default(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG), ['CHECK_WIEDERHERSTELLUG_1', 'CHECK_WIEDERHERSTELLUG_2', 'CHECK_WIEDERHERSTELLUG_3', 'CHECK_WIEDERHERSTELLUG_4', 'CHECK_WIEDERHERSTELLUG_5'], [TSSchadenfallEvent_1.TSSchadenfallEvent.WIEDERHERSTELLUNG_AUSGEFUEHRT], [TSRole_1.TSRole.BETROFFENER, TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER, TSRole_1.TSRole.SUPER_ADMIN], pageNames.AUFWAENDE, [TSErfassungsArt_1.TSErfassungsArt.ONLINE]);
        this.statusMap.push(wiederherstellungWechsel);
        var ueberpruefungSchaetzerOnline = new TSStatuswechsel_1.default(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER), ['CHECK_UEBERPRUEFUNG_SCHAETZER_1', 'CHECK_UEBERPRUEFUNG_SCHAETZER_2', 'CHECK_UEBERPRUEFUNG_SCHAETZER_3',
            'CHECK_UEBERPRUEFUNG_SCHAETZER_4', 'CHECK_UEBERPRUEFUNG_SCHAETZER_5'], [TSSchadenfallEvent_1.TSSchadenfallEvent.WIEDERHERSTELLUNG_GEPRUEFT, TSSchadenfallEvent_1.TSSchadenfallEvent.WIEDERHERSTELLUNG_MANGELHAFT], [TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.SUPER_ADMIN], pageNames.AUFWAENDE, [TSErfassungsArt_1.TSErfassungsArt.ONLINE]);
        this.statusMap.push(ueberpruefungSchaetzerOnline);
        var ueberpruefungSchaetzerPapier = new TSStatuswechsel_1.default(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER), ['CHECK_UEBERPRUEFUNG_SCHAETZER_1', 'CHECK_UEBERPRUEFUNG_SCHAETZER_2', 'CHECK_UEBERPRUEFUNG_SCHAETZER_3',
            'CHECK_UEBERPRUEFUNG_SCHAETZER_4', 'CHECK_UEBERPRUEFUNG_SCHAETZER_5'], [TSSchadenfallEvent_1.TSSchadenfallEvent.WIEDERHERSTELLUNG_GEPRUEFT_PAPIER], [TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.SUPER_ADMIN], pageNames.AUFWAENDE, [TSErfassungsArt_1.TSErfassungsArt.PAPIER]);
        this.statusMap.push(ueberpruefungSchaetzerPapier);
        var schadenBehobenAbrechnung = new TSStatuswechsel_1.default(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN), ['CHECK_SCHADENBEHOBEN_ABR_1', 'CHECK_SCHADENBEHOBEN_ABR_2', 'CHECK_SCHADENBEHOBEN_ABR_3', 'CHECK_SCHADENBEHOBEN_ABR_4'], [TSSchadenfallEvent_1.TSSchadenfallEvent.ABRECHNUNG_OK, TSSchadenfallEvent_1.TSSchadenfallEvent.ABRECHNUNG_MANGELHAFT, TSSchadenfallEvent_1.TSSchadenfallEvent.ABLEHNUNG], [TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.SUPER_ADMIN], pageNames.ENTSCHAEDIGUNG, [TSErfassungsArt_1.TSErfassungsArt.ONLINE, TSErfassungsArt_1.TSErfassungsArt.PAPIER]);
        this.statusMap.push(schadenBehobenAbrechnung);
        var freigabeFSPapier = new TSStatuswechsel_1.default(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS), ['CHECK_UEBERPRUEFUNG_AS_1', 'CHECK_UEBERPRUEFUNG_AS_2', 'CHECK_UEBERPRUEFUNG_AS_3', 'CHECK_UEBERPRUEFUNG_AS_4',
            'CHECK_AUFTRAG_SCHAETZER_1', 'CHECK_AUFTRAG_SCHAETZER_2', 'CHECK_AUFTRAG_SCHAETZER_3', 'CHECK_AUFTRAG_SCHAETZER_4'], [TSSchadenfallEvent_1.TSSchadenfallEvent.FREIGABE_PAPIER_FS_6, TSSchadenfallEvent_1.TSSchadenfallEvent.FREIGABE_PAPIER_FS_9], [TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.SUPER_ADMIN], pageNames.SCHADENMELDUNG, [TSErfassungsArt_1.TSErfassungsArt.PAPIER]);
        this.statusMap.push(freigabeFSPapier);
    }
    /**
     *
     * @param {TSSchadenfallStatus} currentStatus
     * @return {TSStatuswechsel} Object containing metadata like alalowed roles and keys for the checklist for the
     *         state that the schadenfall is in
     */
    StatuswechselService.prototype.getStatuswechselMetadata = function (currentStatus, erfassungsart) {
        var foundWechsel = this.statusMap
            .filter(function (value) { return value.status === currentStatus; })
            .filter(function (value) { return value.allowedErfassungsArt.indexOf(erfassungsart) !== -1; });
        if (foundWechsel.length === 0) {
            return undefined;
        }
        else {
            if (foundWechsel.length > 1) {
                this.$log.error('found more than one possible StatusWechsel');
            }
            return foundWechsel[0];
        }
    };
    StatuswechselService.$inject = ['$log', 'PAGE_NAMES', 'BegruendungscodeMapperService'];
    return StatuswechselService;
}());
exports.default = StatuswechselService;


/***/ }),

/***/ "4Vie":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSSchadenObjektDaten_1 = __importDefault(__webpack_require__("ivjz"));
var TSSchadenDaten = /** @class */ (function (_super) {
    __extends(TSSchadenDaten, _super);
    function TSSchadenDaten() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSSchadenDaten.prototype, "schadendatum", {
        get: function () {
            return this._schadendatum;
        },
        set: function (value) {
            this._schadendatum = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "ort", {
        get: function () {
            return this._ort;
        },
        set: function (value) {
            this._ort = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "mapLongitude", {
        get: function () {
            return this._mapLongitude;
        },
        set: function (value) {
            this._mapLongitude = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "mapLatitude", {
        get: function () {
            return this._mapLatitude;
        },
        set: function (value) {
            this._mapLatitude = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "beschrieb", {
        get: function () {
            return this._beschrieb;
        },
        set: function (value) {
            this._beschrieb = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "flurname", {
        get: function () {
            return this._flurname;
        },
        set: function (value) {
            this._flurname = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "parzellennummer", {
        get: function () {
            return this._parzellennummer;
        },
        set: function (value) {
            this._parzellennummer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "vorgeseheneMassnahmen", {
        get: function () {
            return this._vorgeseheneMassnahmen;
        },
        set: function (value) {
            this._vorgeseheneMassnahmen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "geschaetzteKosten", {
        get: function () {
            return this._geschaetzteKosten;
        },
        set: function (value) {
            this._geschaetzteKosten = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "geschaetzterMehrwert", {
        get: function () {
            return this._geschaetzterMehrwert;
        },
        set: function (value) {
            this._geschaetzterMehrwert = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "geschaedigteFlaeche", {
        get: function () {
            return this._geschaedigteFlaeche;
        },
        set: function (value) {
            this._geschaedigteFlaeche = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "schadenArt", {
        get: function () {
            return this._schadenArt;
        },
        set: function (value) {
            this._schadenArt = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "schadenObjekt", {
        get: function () {
            return this._schadenObjekt;
        },
        set: function (value) {
            this._schadenObjekt = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "schadenObjektDaten", {
        get: function () {
            return this._schadenObjektDaten;
        },
        set: function (value) {
            this._schadenObjektDaten = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "coordinatesAsString", {
        get: function () {
            if (this.mapLatitude && this.mapLongitude) {
                var latstring = (Number(this.mapLatitude)).toFixed(9);
                var longstring = (Number(this.mapLongitude)).toFixed(9);
                return latstring + ' / ' + longstring;
            }
            else {
                return '- / -';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "coordinatesAsLV95String", {
        get: function () {
            if (this.mapLatitude && this.mapLongitude) {
                // umrechnen in lv95 Schweizer-Koordinaten
                // @ts-ignore
                var swissCoordLV95 = ol.proj.transform([this.mapLongitude, this.mapLatitude], 'EPSG:4326', 'EPSG:2056');
                return this.getAprostropheString(swissCoordLV95[0]) + ' / ' + this.getAprostropheString(swissCoordLV95[1]);
            }
            else {
                return '- / -';
            }
        },
        enumerable: true,
        configurable: true
    });
    TSSchadenDaten.prototype.getAprostropheString = function (swissCoordLV95) {
        var s = swissCoordLV95.toFixed(0);
        return s.substr(0, 1) + '\'' + s.substr(1, 3) + '\'' + s.substr(4, 3);
    };
    Object.defineProperty(TSSchadenDaten.prototype, "schadenArtAndere", {
        get: function () {
            return this._schadenArtAndere;
        },
        set: function (value) {
            this._schadenArtAndere = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "otherwieseSubventionierbar", {
        get: function () {
            return this._otherwieseSubventionierbar;
        },
        set: function (value) {
            this._otherwieseSubventionierbar = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "offerte", {
        get: function () {
            return this._offerte;
        },
        set: function (value) {
            this._offerte = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenDaten.prototype, "arbeiten", {
        get: function () {
            return this._arbeiten;
        },
        set: function (value) {
            this._arbeiten = value;
        },
        enumerable: true,
        configurable: true
    });
    TSSchadenDaten.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.schadendatum = DateUtil_1.default.localDateToMoment(restObject.schadendatum);
        this.ort = restObject.ort;
        this.mapLongitude = restObject.mapLongitude;
        this.mapLatitude = restObject.mapLatitude;
        this.beschrieb = restObject.beschrieb;
        this.flurname = restObject.flurname;
        this.parzellennummer = restObject.parzellennummer;
        this.vorgeseheneMassnahmen = restObject.vorgeseheneMassnahmen;
        this.geschaetzteKosten = restObject.geschaetzteKosten;
        this.geschaetzterMehrwert = restObject.geschaetzterMehrwert;
        this.geschaedigteFlaeche = restObject.geschaedigteFlaeche;
        this.schadenArt = restObject.schadenArt;
        this.schadenObjekt = restObject.schadenObjekt;
        this.schadenObjektDaten = this.deserializeOrCreate(restObject.schadenObjektDaten, new TSSchadenObjektDaten_1.default());
        this.schadenArtAndere = restObject.schadenArtAndere;
        this.otherwieseSubventionierbar = restObject.otherwieseSubventionierbar;
        this.offerte = restObject.offerte;
        this.arbeiten = restObject.arbeiten;
        return this;
    };
    TSSchadenDaten.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        if (this.schadendatum) {
            restObject.schadendatum = DateUtil_1.default.momentToLocalDate(this.schadendatum);
        }
        restObject.ort = this.ort;
        restObject.mapLongitude = this.mapLongitude;
        restObject.mapLatitude = this.mapLatitude;
        restObject.beschrieb = this.beschrieb;
        restObject.flurname = this.flurname;
        restObject.parzellennummer = this.parzellennummer;
        restObject.vorgeseheneMassnahmen = this.vorgeseheneMassnahmen;
        restObject.geschaetzteKosten = this.geschaetzteKosten;
        restObject.geschaetzterMehrwert = this.geschaetzterMehrwert;
        restObject.geschaedigteFlaeche = this.geschaedigteFlaeche;
        restObject.schadenArt = this.schadenArt;
        restObject.schadenObjekt = this.schadenObjekt;
        restObject.schadenObjektDaten = this.serializeOrInit(this.schadenObjektDaten, restObject.schadenObjektDaten);
        restObject.schadenArtAndere = this.schadenArtAndere;
        restObject.otherwieseSubventionierbar = this.otherwieseSubventionierbar;
        restObject.offerte = this.offerte;
        restObject.arbeiten = this.arbeiten;
        return restObject;
    };
    return TSSchadenDaten;
}(TSAbstractEntity_1.default));
exports.default = TSSchadenDaten;


/***/ }),

/***/ "4YmB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAuthEvent_1 = __webpack_require__("L0QB");
var TSRole_1 = __webpack_require__("MleR");
var TSUser_1 = __importDefault(__webpack_require__("9qK+"));
var AuthServiceRS = /** @class */ (function () {
    /* @ngInject */
    function AuthServiceRS($http, CONSTANTS, $q, $timeout, $cookies, base64, httpBuffer, $rootScope, $log) {
        this.$http = $http;
        this.CONSTANTS = CONSTANTS;
        this.$q = $q;
        this.$timeout = $timeout;
        this.$cookies = $cookies;
        this.base64 = base64;
        this.httpBuffer = httpBuffer;
        this.$rootScope = $rootScope;
        this.$log = $log;
    }
    AuthServiceRS.prototype.getPrincipal = function () {
        return this.principal;
    };
    AuthServiceRS.prototype.getPrincipalRoles = function () {
        if (this.principal) {
            return this.principal.roles;
        }
        return undefined;
    };
    AuthServiceRS.prototype.loginRequest = function (userCredentials) {
        var _this = this;
        if (userCredentials) {
            var objToPost = userCredentials.serialize({});
            return this.$http.post(this.CONSTANTS.REST_API + 'auth/login', objToPost)
                .then(function (response) {
                // try to reload buffered requests
                _this.httpBuffer.retryAll(function (config) {
                    return config;
                });
                //ensure that there is ALWAYS a logout-event before the login-event by throwing it right before login
                _this.$rootScope.$broadcast(TSAuthEvent_1.TSAuthEvent[TSAuthEvent_1.TSAuthEvent.LOGOUT_SUCCESS], 'logged out before logging in in');
                return _this.$timeout(function () {
                    try {
                        _this.initWithCookie();
                        return _this.principal;
                    }
                    catch (e) {
                        return _this.$q.reject();
                    }
                }, 100);
            });
        }
        this.$log.error('passed no credentials, no login request sent');
        return this.$q.when(undefined);
    };
    ;
    AuthServiceRS.prototype.initWithCookie = function () {
        var _this = this;
        var authIdbase64 = this.$cookies.get('authId');
        if (authIdbase64) {
            try {
                // zuerst  uri decodieren und dann erst base 64
                var authData = JSON.parse(window.atob(decodeURIComponent(authIdbase64)));
                this.principal = new TSUser_1.default(authData.vorname, authData.name, '', authData.email, authData.roles);
                this.principal.id = authData.id;
                this.$timeout(function () {
                    _this.$rootScope.$broadcast(TSAuthEvent_1.TSAuthEvent[TSAuthEvent_1.TSAuthEvent.LOGIN_SUCCESS], 'logged in');
                    var roles = (_this.principal ? _this.principal.roles : []);
                    _this.$log.debug('Logged in as user ' + (_this.principal ? _this.principal.email : '') + ' with roles ' + roles + ' highest role is ' + _this.getHighestRoleOfBenutzer(roles));
                }); //bei login muessen wir warten bis angular alle componenten erstellt hat bevor wir das event werfen
                return true;
            }
            catch (e) {
                console.log('cookie decoding failed');
            }
        }
        return false;
    };
    ;
    AuthServiceRS.prototype.logoutRequest = function () {
        var _this = this;
        return this.$http.post(this.CONSTANTS.REST_API + 'auth/logout', null).then(function (res) {
            _this.principal = undefined;
            _this.$rootScope.$broadcast(TSAuthEvent_1.TSAuthEvent[TSAuthEvent_1.TSAuthEvent.LOGOUT_SUCCESS], 'logged out');
            return res;
        });
    };
    ;
    /**
     * Gibt die am privilegierteste Rolle des  Benutzers zurueck.
     */
    AuthServiceRS.prototype.getHighestRoleOfBenutzer = function (roles) {
        var hasSuperAdmin = false;
        var hasAdmin = false;
        var hasFondssuisse = false;
        var hasAnlaufstelleVerwalter = false;
        var hasAnlaufstelleSachbearb = false;
        var hasSchaetzer = false;
        var hasGesuchsteller = false;
        var hasKantonVerwalter = false;
        var hasKantonInspektor = false;
        var hasUnassigned = false;
        try {
            for (var roles_1 = __values(roles), roles_1_1 = roles_1.next(); !roles_1_1.done; roles_1_1 = roles_1.next()) {
                var currRole = roles_1_1.value;
                if (currRole === TSRole_1.TSRole.SUPER_ADMIN) {
                    hasSuperAdmin = true;
                }
                else if (currRole === TSRole_1.TSRole.FONDSSUISSE_ADMIN) {
                    hasAdmin = true;
                }
                else if (currRole === TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER) {
                    hasFondssuisse = true;
                }
                else if (currRole === TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER) {
                    hasAnlaufstelleSachbearb = true;
                }
                else if (currRole === TSRole_1.TSRole.ANLAUFSTELLE_VERWALTER) {
                    hasAnlaufstelleVerwalter = true;
                }
                else if (currRole === TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER) {
                    hasSchaetzer = true;
                }
                else if (currRole === TSRole_1.TSRole.KANTON_VERWALTER) {
                    hasKantonVerwalter = true;
                }
                else if (currRole === TSRole_1.TSRole.KANTON_INSPEKTOR) {
                    hasKantonInspektor = true;
                }
                else if (currRole === TSRole_1.TSRole.BETROFFENER) {
                    hasGesuchsteller = true;
                }
                else if (currRole === TSRole_1.TSRole.UNASSIGNED_ROLE) {
                    hasUnassigned = true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (roles_1_1 && !roles_1_1.done && (_a = roles_1.return)) _a.call(roles_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (hasSuperAdmin) {
            return TSRole_1.TSRole.SUPER_ADMIN;
        }
        else if (hasAdmin) {
            return TSRole_1.TSRole.FONDSSUISSE_ADMIN;
        }
        else if (hasFondssuisse) {
            return TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER;
        }
        else if (hasAnlaufstelleSachbearb) {
            return TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER;
        }
        else if (hasAnlaufstelleVerwalter) {
            return TSRole_1.TSRole.ANLAUFSTELLE_VERWALTER;
        }
        else if (hasSchaetzer) {
            return TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER;
        }
        else if (hasKantonVerwalter) {
            return TSRole_1.TSRole.KANTON_VERWALTER;
        }
        else if (hasKantonInspektor) {
            return TSRole_1.TSRole.KANTON_INSPEKTOR;
        }
        else if (hasGesuchsteller) {
            return TSRole_1.TSRole.BETROFFENER;
        }
        else if (hasUnassigned) {
            return TSRole_1.TSRole.UNASSIGNED_ROLE;
        }
        return TSRole_1.TSRole.UNASSIGNED_ROLE;
        var e_1, _a;
    };
    /**
     * Gibt true zurueck, wenn der eingelogte Benutzer die gegebene Role hat. Fuer undefined Werte wird immer false zurueckgegeben.
     */
    AuthServiceRS.prototype.isRole = function (role) {
        if (role && this.principal) {
            return this.principal.roles.filter(function (currRole) { return currRole === role; }).length !== 0;
        }
        return false;
    };
    /**
     * gibt true zurueck wenn der aktuelle Benutzer eine der uebergebenen Rollen innehat
     */
    AuthServiceRS.prototype.isOneOfRoles = function (roles) {
        if (roles !== undefined && roles !== null && this.principal) {
            for (var i = 0; i < roles.length; i++) {
                var role = roles[i];
                if (this.isRole(role)) {
                    return true;
                }
            }
        }
        return false;
    };
    AuthServiceRS.prototype.isLoggedId = function () {
        return this.getPrincipal() ? true : false;
    };
    AuthServiceRS.$inject = ['$http', 'CONSTANTS', '$q', '$timeout', '$cookies', 'base64', 'httpBuffer', '$rootScope', '$log'];
    return AuthServiceRS;
}());
exports.default = AuthServiceRS;


/***/ }),

/***/ "4j5k":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("wMVE");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-schadenfaelle-list.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-schadenfaelle-list.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "4wPR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var template = __webpack_require__("6IWY");
var DvAccordionComponentConfig = /** @class */ (function () {
    function DvAccordionComponentConfig() {
        this.transclude = true;
        this.template = template;
        this.controller = DvAccordionController;
        this.controllerAs = 'vma';
        this.bindings = {
            allowMultipleSections: '<',
            selectedTabIds: '<'
        };
    }
    return DvAccordionComponentConfig;
}());
exports.DvAccordionComponentConfig = DvAccordionComponentConfig;
var DvAccordionController = /** @class */ (function () {
    /* @ngInject */
    function DvAccordionController($scope) {
        this.$scope = $scope;
        this.accordion = [];
        this.selectedTabIds = [];
    }
    DvAccordionController.prototype.$onInit = function () {
        var _this = this;
        // erlaubt dass man von Anfang an, mehrere Tabs oeffnet, wenn man eine bestimmte Mitteilung oeffnen will
        this.initView();
        this.$scope.$watchCollection(function () {
            return _this.selectedTabIds;
        }, function (newValue, oldValue) {
            _this.initView();
        });
    };
    DvAccordionController.prototype.initView = function () {
        if (this.selectedTabIds) {
            try {
                for (var _a = __values(this.selectedTabIds), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var selectedTabId = _b.value;
                    this.openTag(selectedTabId);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var e_1, _c;
    };
    DvAccordionController.prototype.toggleTab = function (i) {
        if (this.isTagOpen(i)) {
            this.closeTag(i);
        }
        else {
            this.openTag(i);
        }
    };
    DvAccordionController.prototype.openTag = function (i) {
        if (!this.allowMultipleSections) {
            this.accordion = [];
        }
        this.accordion.push(i);
    };
    DvAccordionController.prototype.closeTag = function (i) {
        this.accordion.splice(this.accordion.indexOf(i), 1);
    };
    DvAccordionController.prototype.isTagOpen = function (i) {
        return this.accordion.indexOf(i) > -1;
    };
    DvAccordionController.$inject = ['$scope'];
    return DvAccordionController;
}());
exports.DvAccordionController = DvAccordionController;


/***/ }),

/***/ "50/w":
/***/ (function(module, exports) {

module.exports = "<div class=\"container\"> <div class=\"row\"> <div class=\"col-sm-12\"> <div class=\"page-header\"> <h1 data-translate=\"KONFIGURATION\"></h1> </div> <h2> <span data-translate=\"FS_SACHBEARBEITER_ZUTEILEN\"></span> </h2> </div> <div class=\"col-xs-8\"> <div class=\"gemeinde\"> <dv-benutzer-typeahead selected-benutzer=\"vm.sachbearbeiterToAdd\" input-name=\"sachbearbeiterName\" input-placeholder=\"START_TYPING\" label=\"\" ng-required=\"false\"> </dv-benutzer-typeahead> </div> </div> <div class=\"col-xs-4\"> <button ng-click=\"vm.addFSSachbearbeiter()\" class=\"btn btn-sub-serf add-person-button\" type=\"button\"> <i class=\"fa fa-plus\"></i> </button> </div> <div class=\"col-sm-12\"> <dv-benutzer-list benutzerlist=\"vm.sachbearbeiterList\" show-role=\"false\" show-filter=\"false\" on-delete=\"vm.removeSachbearbeiter(benutzer, event)\"></dv-benutzer-list> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <h2> <span data-translate=\"FS_ADMIN_ZUTEILEN\"></span> </h2> </div> <div class=\"col-xs-8\"> <div class=\"gemeinde\"> <dv-benutzer-typeahead selected-benutzer=\"vm.adminToAdd\" input-name=\"adminName\" input-placeholder=\"START_TYPING\" label=\"\" ng-required=\"false\"> </dv-benutzer-typeahead> </div> </div> <div class=\"col-xs-4\"> <button ng-click=\"vm.addFSAdmin()\" class=\"btn btn-sub-serf add-person-button\" type=\"button\"> <i class=\"fa fa-plus\"></i> </button> </div> <div class=\"col-sm-12\"> <dv-benutzer-list benutzerlist=\"vm.adminList\" show-role=\"false\" show-filter=\"false\" on-delete=\"vm.removeAdmin(benutzer, event)\"></dv-benutzer-list> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <h2> <span data-translate=\"FS_BETROFFENE_ROLLE_ENTFERNEN\"></span> </h2> </div> <div class=\"form-group\"> <div class=\"col-xs-12\"> <label for=\"emailBetroffeneRolle\"> <span data-translate=\"EMAIL\"></span> </label> </div> <div class=\"col-xs-8\"> <input type=\"email\" id=\"emailBetroffeneRolle\" ng-model=\"vm.benutzerEmail\" dv-max-length class=\"form-control\" placeholder=\"hans.muster@fondsuisse.ch\"> </div> <div class=\"col-xs-4\"> <button type=\"button\" class=\"btn btn-serf-red\" ng-click=\"vm.removeBetroffeneRole()\"> <span data-translate=\"FS_ROLLE_ENTFERNEN\"></span> </button> </div> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <div class=\"marginTop20\"> <h2 data-translate=\"SERF_PROPERTIES\"></h2> </div> <table st-table=\"serfProperties\" st-safe-src=\"vm.serfProperties\" st-delay=\"20\" class=\"table table-striped\"> <thead> <tr> <th st-sort=\"name\" class=\"sortable\" data-translate=\"PROPERTY_NAME\"></th> <th st-sort=\"value\" class=\"sortable\" data-translate=\"PROPERTY_TEXT\"></th> <th st-sort=\"timestampErstellt\" class=\"sortable\" data-translate=\"TIMEMUTIERT\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"serfProperty in serfProperties\" st-select-row=\"serfProperty\" st-select-mode=\"single\" ng-click=\"vm.editSerfProperty(serfProperty)\"> <td ng-bind=\"serfProperty.name\"></td> <td ng-bind=\"serfProperty.value\"></td> <td ng-bind=\"serfProperty.timestampMutiert | amDateFormat : 'DD.MM.YYYY'\"></td> </tr> </tbody> </table> <div class=\"panel panel-default\" ng-if=\"vm.serfProperty.name\"> <form name=\"vm.serfPropertyform\" role=\"form\" class=\"form panel-body\" novalidate> <div class=\"form-group\"> <label data-translate=\"PROPERTY_NAME\" for=\"propName\"> </label> <input id=\"propName\" type=\"text\" name=\"propertyName\" ng-model=\"vm.serfProperty.name\" dv-max-length class=\"form-control\" required ng-disabled=\"vm.serfProperty.timestampErstellt\"> <dv-error-messages for=\"vm.form.propertyName\"></dv-error-messages> </div> <div class=\"form-group\" ng-class=\"{'has-error':vm.form.propertyValue.$invalid}\"> <label data-translate=\"PROPERTY_TEXT\" for=\"propVal\"> </label> <input id=\"propVal\" type=\"text\" name=\"propertyValue\" ng-model=\"vm.serfProperty.value\" dv-max-length class=\"form-control\"> <dv-error-messages for=\"vm.form.propertyValue\"></dv-error-messages> </div> <div class=\"btn-group\" role=\"group\"> <button class=\"btn btn-default\" type=\"submit\" ng-click=\"vm.serfPropertyform.$valid && vm.submitSerfProperty()\"> <span data-translate=\"SAVE\"></span> </button> <a href=\"javascript:\" type=\"button\" class=\"btn btn-default\" id=\"cancelLink\" unsaved-warning-clear ng-click=\"vm.resetForm(); vm.serfPropertyform.$setPristine();serfPropertyform.$setUntouched();\"> <span data-translate=\"CANCEL\"></span> </a> </div> </form> </div> </div> </div> <div class=\"row\"> <div class=\"col-sm-8 col-sm-offset-2\"> <dv-version></dv-version> </div> </div> </div> ";

/***/ }),

/***/ "507y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
statistikRun.$inject = ['RouterHelper'];
/* @ngInject */
function statistikRun(routerHelper) {
    routerHelper.configureStates(getStates());
}
exports.statistikRun = statistikRun;
function getStates() {
    return [
        {
            name: 'statistik',
            template: '<dv-statistik-view></dv-statistik-view>',
            url: '/statistik'
        },
    ];
}


/***/ }),

/***/ "59zb":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("iLJJ");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./eigenleistungView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./eigenleistungView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "5MYH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("/GOx");
var AdresseComponentConfig = /** @class */ (function () {
    function AdresseComponentConfig() {
        this.transclude = false;
        this.bindings = {
            adresse: '=',
            bisherFs: '<?',
            bisherGs: '<?',
            prefix: '@',
        };
        this.template = __webpack_require__("Xeva");
        this.controller = DvAdresseController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return AdresseComponentConfig;
}());
exports.AdresseComponentConfig = AdresseComponentConfig;
var DvAdresseController = /** @class */ (function () {
    /* @ngInject */
    function DvAdresseController($translate) {
        this.$translate = $translate;
    }
    DvAdresseController.prototype.resetForm = function () {
        this.adresse = undefined;
    };
    DvAdresseController.prototype.getModel = function () {
        return this.adresse;
    };
    DvAdresseController.prototype.showBisher = function () {
        return (this.bisherFs !== undefined && this.bisherGs !== undefined);
    };
    DvAdresseController.prototype.displayLegacyAdresse = function () {
        return this.adresse.adresse1 === undefined || this.adresse.adresse1 === null;
    };
    DvAdresseController.$inject = ['$translate'];
    return DvAdresseController;
}());
exports.DvAdresseController = DvAdresseController;


/***/ }),

/***/ "5kWG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var TSAuthEvent_1 = __webpack_require__("L0QB");
var TSVersicherungsbeitragStatus_1 = __webpack_require__("jJP+");
var TSVersicherungsbeitrag_1 = __importDefault(__webpack_require__("fGC3"));
var VersicherungsbeitragModelManager = /** @class */ (function () {
    /* @ngInject */
    function VersicherungsbeitragModelManager(versicherungsbeitragRS, log, $q, CONSTANTS, $rootScope, beitragRS, errorService) {
        var _this = this;
        this.versicherungsbeitragRS = versicherungsbeitragRS;
        this.log = log;
        this.$q = $q;
        this.CONSTANTS = CONSTANTS;
        this.$rootScope = $rootScope;
        this.beitragRS = beitragRS;
        this.errorService = errorService;
        $rootScope.$on(TSAuthEvent_1.TSAuthEvent[TSAuthEvent_1.TSAuthEvent.LOGOUT_SUCCESS], function () {
            _this.setVersicherungsbeitrag(undefined);
            _this.log.debug('Cleared Versicherungsbeitrag on logout');
        });
    }
    VersicherungsbeitragModelManager.prototype.initNewVersicherungsbeitrag = function () {
        this.versicherungsbeitrag = new TSVersicherungsbeitrag_1.default().init();
        return this.$q.when(this.versicherungsbeitrag);
    };
    /**
     * Je nach dem welche Rolle der Benutzer hat, wird das Gesuch aus der DB anders geholt.
     * Fuer Institutionen z.B. wird das Gesuch nur mit den relevanten Daten geholt
     */
    VersicherungsbeitragModelManager.prototype.openVersicherungsbeitrag = function (versicherungsbeitragId) {
        var _this = this;
        return this.versicherungsbeitragRS.findVersicherungsbeitrag(versicherungsbeitragId)
            .then(function (response) {
            _this.setVersicherungsbeitrag(response);
            return response;
        });
    };
    VersicherungsbeitragModelManager.prototype.setVersicherungsbeitrag = function (versicherungsbeitrag) {
        this.versicherungsbeitrag = versicherungsbeitrag;
    };
    VersicherungsbeitragModelManager.prototype.getVersicherungsbeitrag = function () {
        return this.versicherungsbeitrag;
    };
    /**
     *
     * @param versicherungsbeitragId id die geprueft wird
     * @return {boolean} True wenn der aktuelle Versicherungsbeitrag die gegebene id hat
     */
    VersicherungsbeitragModelManager.prototype.isVersicherungsbeitrag = function (versicherungsbeitragId) {
        if (this.versicherungsbeitrag) {
            return this.versicherungsbeitrag.id === versicherungsbeitragId;
        }
        return false;
    };
    VersicherungsbeitragModelManager.prototype.reloadVersicherungsbeitrag = function () {
        var _this = this;
        if (this.versicherungsbeitrag) {
            return this.versicherungsbeitragRS.findVersicherungsbeitrag(this.versicherungsbeitrag.id).then(function (versicherungsbeitragResp) {
                _this.setVersicherungsbeitrag(versicherungsbeitragResp);
                return _this.versicherungsbeitrag;
            });
        }
        return this.$q.when(this.versicherungsbeitrag);
    };
    /**
     * Update das Gesuch
     * @returns {IPromise<TSGesuch>}
     */
    VersicherungsbeitragModelManager.prototype.updateVersicherungsbeitrag = function () {
        var _this = this;
        if (this.versicherungsbeitrag) {
            return this.versicherungsbeitragRS.update(this.versicherungsbeitrag).then(function (gesuchResponse) {
                _this.versicherungsbeitrag = gesuchResponse;
                return _this.versicherungsbeitrag;
            });
        }
        else {
            throw 'ILLEGAL_STATE';
        }
    };
    /**
     * Returns true if the Versicherungsbeitrag has the given status
     * @param status
     * @returns {boolean}
     */
    VersicherungsbeitragModelManager.prototype.isVersicherungsbeitragStatus = function (status) {
        if (this.versicherungsbeitrag) {
            return this.versicherungsbeitrag.status === status;
        }
        return false;
    };
    VersicherungsbeitragModelManager.prototype.clearVersicherungsbeitrag = function () {
        this.versicherungsbeitrag = undefined;
    };
    VersicherungsbeitragModelManager.prototype.saveVersicherungsbeitrag = function (versicherungsbeitrag) {
        var _this = this;
        return this.versicherungsbeitragRS.update(versicherungsbeitrag).then(function (schadResp) {
            _this.versicherungsbeitrag = schadResp;
            return _this.versicherungsbeitrag;
        });
    };
    VersicherungsbeitragModelManager.prototype.deleteBeitrag = function () {
        var _this = this;
        if (this.versicherungsbeitrag) {
            return this.versicherungsbeitragRS.deleteBeitrag(this.versicherungsbeitrag.id).then(function (response) {
                return _this.clearBeitrag();
            });
        }
        this.log.error('could not delete Beitrag because no versicherungsbeitrag is managed');
        this.errorService.addMesageAsError('ERROR_UNEXPECTED');
        return this.$q.when(new TSVersicherungsbeitrag_1.default());
    };
    VersicherungsbeitragModelManager.prototype.clearBeitrag = function () {
        if (this.versicherungsbeitrag) {
            this.versicherungsbeitrag.beitrag = undefined;
            this.versicherungsbeitrag.status = TSVersicherungsbeitragStatus_1.TSVersicherungsbeitragStatus.IN_BEARBEITUNG_FS;
            return this.versicherungsbeitrag;
        }
        return new TSVersicherungsbeitrag_1.default;
    };
    VersicherungsbeitragModelManager.prototype.saveVersicherungsbeitragBeitrag = function (beitragToSave) {
        var _this = this;
        if (this.versicherungsbeitrag) {
            return this.beitragRS.saveVersicherungsbeitragBeitrag(this.versicherungsbeitrag.id, beitragToSave)
                .then(function (storedBeitrag) {
                if (_this.versicherungsbeitrag) {
                    _this.versicherungsbeitrag.beitrag = storedBeitrag;
                    _this.versicherungsbeitrag.status = TSVersicherungsbeitragStatus_1.TSVersicherungsbeitragStatus.AUSZAHLUNG;
                }
                return storedBeitrag;
            });
        }
        this.log.error('could not save Beitrag because no versicherungsbeitrag is managed');
        this.errorService.addMesageAsError('ERROR_UNEXPECTED');
        return this.$q.when(beitragToSave);
    };
    VersicherungsbeitragModelManager.$inject = ['VersicherungsbeitragRS', '$log', '$q', 'CONSTANTS', '$rootScope', 'BeitragRS', 'ErrorService'];
    return VersicherungsbeitragModelManager;
}());
exports.default = VersicherungsbeitragModelManager;


/***/ }),

/***/ "5y55":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("Gb7M");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./dvb-error-messages-panel.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./dvb-error-messages-panel.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "63CK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSAuthLoginElement = /** @class */ (function () {
    function TSAuthLoginElement(username, password) {
        this._username = username;
        this._password = password;
    }
    Object.defineProperty(TSAuthLoginElement.prototype, "username", {
        get: function () {
            return this._username;
        },
        set: function (value) {
            this._username = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAuthLoginElement.prototype, "password", {
        get: function () {
            return this._password;
        },
        set: function (value) {
            this._password = value;
        },
        enumerable: true,
        configurable: true
    });
    TSAuthLoginElement.prototype.deserialize = function (restObject) {
        this._username = restObject.username;
        this._password = restObject.password;
        return this;
    };
    TSAuthLoginElement.prototype.serialize = function (restObject) {
        restObject.username = this.username;
        restObject.password = this.password;
        return restObject;
    };
    return TSAuthLoginElement;
}());
exports.default = TSAuthLoginElement;


/***/ }),

/***/ "65dZ":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("vTTU");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-anlaufstelle-list.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-anlaufstelle-list.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "6BF3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSSprache_1 = __webpack_require__("3oUo");
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
var TSPasswordData_1 = __importDefault(__webpack_require__("3CBU"));
__webpack_require__("2/9y");
var template = __webpack_require__("K73C");
var BenutzerRegViewComponentConfig = /** @class */ (function () {
    function BenutzerRegViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = BenutzerRegViewViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            siteKey: '<'
        };
    }
    return BenutzerRegViewComponentConfig;
}());
exports.BenutzerRegViewComponentConfig = BenutzerRegViewComponentConfig;
var BenutzerRegViewViewController = /** @class */ (function () {
    /* @ngInject */
    function BenutzerRegViewViewController(benutzerRS, $log, errorService, $scope, $state, passwordStrengthService, $translate) {
        this.benutzerRS = benutzerRS;
        this.$log = $log;
        this.errorService = errorService;
        this.$scope = $scope;
        this.$state = $state;
        this.passwordStrengthService = passwordStrengthService;
        this.$translate = $translate;
    }
    BenutzerRegViewViewController.prototype.$onInit = function () {
        var _this = this;
        this.initModel();
        //        watch for langualge changes so we can set the korrespondenzsspr
        this.$scope.$watch(function () {
            return _this.$translate.use();
        }, function () {
            _this.initLanguage();
            _this.$translate.proposedLanguage();
        });
    };
    BenutzerRegViewViewController.prototype.initModel = function () {
        this.benutzer = new TSBenutzer_1.default();
        this.benutzer.passwordData = new TSPasswordData_1.default('');
        this.initLanguage();
    };
    BenutzerRegViewViewController.prototype.initLanguage = function () {
        var lang = this.$translate.use();
        //init lang, bisschen hacky
        if (lang === 'fr') {
            this.benutzer.korrespondenzsprache = TSSprache_1.TSSprache.FRANZOESISCH;
            this.recaptchaLanguage = 'fr-CH';
        }
        else if (lang === 'it') {
            this.benutzer.korrespondenzsprache = TSSprache_1.TSSprache.ITALIENISCH;
            this.recaptchaLanguage = 'it-CH';
        }
        else {
            this.benutzer.korrespondenzsprache = TSSprache_1.TSSprache.DEUTSCH;
            this.recaptchaLanguage = 'de-CH';
        }
    };
    BenutzerRegViewViewController.prototype.submit = function () {
        var _this = this;
        if (this.form.$valid && this.benutzer.passwordData && this.passwordStrengthService.checkIfValid(this.benutzer.passwordData.password, this.benutzer.passwordData.passwordRepeat)) {
            this.benutzer.recaptchaResponse = this.recaptchaResponse;
            if (this.recaptchaResponse === undefined) {
                this.errorService.addMesageAsError('ERROR_CAPTCHA_REQ');
            }
            this.benutzerRS.createNewBasicBenutzeraccount(this.benutzer).then(function (storedBenutzer) {
                _this.benutzer = storedBenutzer;
                _this.benutzer.passwordData = new TSPasswordData_1.default(_this.benutzer.email);
                _this.errorService.addMesageAsInfoWithArgs('BENUTZER_REC_SUCCESS', _this.benutzer.email);
                _this.form.$setPristine();
                _this.form.$setUntouched();
                _this.$state.go('start');
            });
        }
        else {
            this.$log.debug('Form was not valid');
        }
    };
    BenutzerRegViewViewController.prototype.captchaEnabled = function () {
        if (this.siteKey !== undefined && this.siteKey !== null) {
            return true;
        }
        return false;
    };
    BenutzerRegViewViewController.$inject = ['BenutzerRS', '$log', 'ErrorService', '$scope', '$state', 'PasswordStrengthService', '$translate'];
    return BenutzerRegViewViewController;
}());
exports.BenutzerRegViewViewController = BenutzerRegViewViewController;


/***/ }),

/***/ "6Dkx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
__webpack_require__("fjOH");
var core_module_1 = __webpack_require__("u87A");
__webpack_require__("+9RC");
var cockpit_route_1 = __webpack_require__("Ciwb");
var cockpitView_1 = __webpack_require__("sX8E");
exports.SerfWebCockpit = angular.module('serfWeb.cockpit', [core_module_1.SerfWebCore.name])
    .component('cockpitView', new cockpitView_1.CockpitViewComponentConfig())
    .run(cockpit_route_1.cockpitRun);
exports.default = exports.SerfWebCockpit;


/***/ }),

/***/ "6IWY":
/***/ (function(module, exports) {

module.exports = "<ng-transclude></ng-transclude> ";

/***/ }),

/***/ "6IdE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSPasswordData_1 = __importDefault(__webpack_require__("3CBU"));
var template = __webpack_require__("xFtX");
__webpack_require__("0Is4");
var PasswordChangedComponentConfig = /** @class */ (function () {
    function PasswordChangedComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = PasswordChangedViewController;
        this.controllerAs = 'vm';
    }
    return PasswordChangedComponentConfig;
}());
exports.PasswordChangedComponentConfig = PasswordChangedComponentConfig;
var PasswordChangedViewController = /** @class */ (function () {
    function PasswordChangedViewController($state, $stateParams, benutzerRS, $location, $log, errorService, CONSTANTS, $translate, $timeout, passwordStrengthService) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.benutzerRS = benutzerRS;
        this.$location = $location;
        this.$log = $log;
        this.errorService = errorService;
        this.CONSTANTS = CONSTANTS;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.passwordStrengthService = passwordStrengthService;
    }
    PasswordChangedViewController.prototype.$onInit = function () {
        this.errorService.clearAll();
        var email = '';
        if (this.$stateParams.email) {
            email = decodeURIComponent(this.$stateParams.email);
        }
        var token = this.$stateParams.changetoken || '';
        this.model = new TSPasswordData_1.default(email, token);
    };
    PasswordChangedViewController.prototype.saveClicked = function () {
        var _this = this;
        this.errorService.clearAll();
        if (this.passwordStrengthService.checkIfValid(this.model.password, this.model.passwordRepeat)) {
            this.benutzerRS.resetPassword(this.model)
                .then(function () {
                var successmsg = _this.$translate.instant('LOGIN_CHANGED');
                _this.errorService.addMesageAsInfo(successmsg);
                _this.$state.go('start');
                _this.$timeout(function () {
                    _this.errorService.clearAll();
                }, 5000);
            }).catch(function () {
                _this.errorService.addMesageAsError(_this.$translate.instant(('ERROR_PW_CHANGE')));
            });
        }
    };
    PasswordChangedViewController.$inject = ['$state', '$stateParams', 'BenutzerRS',
        '$location', '$log', 'ErrorService', 'CONSTANTS', '$translate', '$timeout', 'PasswordStrengthService'];
    return PasswordChangedViewController;
}());
exports.PasswordChangedViewController = PasswordChangedViewController;


/***/ }),

/***/ "6Ppe":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".dv-dokumentupload{margin-bottom:40px}.dv-dokumentupload__link,.dv-dokumentupload__link:focus,.dv-dokumentupload__link:hover{text-decoration:none}.dv-dokumentupload__thumbs{display:flex}.dv-dokumentupload__thumbelement{border:none;margin-right:30px;height:190px}.dv-dokumentupload__thumbcontent{width:150px;overflow:hidden}.dv-dokumentupload__thumbimage{position:relative;height:150px}.dv-dokumentupload__thumbnoimage{position:relative;height:150px;left:25%;margin-left:-15%}.dv-dokumentupload__thumbfilename{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.dv-dokumentupload__thumbfilesize{float:left}.dv-dokumentupload__thumbdelete{float:right}.dv-dokumentupload .dv-dokumentalert{border-top-width:1px;margin-top:10px;margin-left:-10px}", ""]);

// exports


/***/ }),

/***/ "6ZDT":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "dv-tooltip{font-size:1.6rem}dv-tooltip i:focus{outline:0;color:#687276}dv-tooltip:hover i{color:#bc2500}", ""]);

// exports


/***/ }),

/***/ "6bjF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSAdresse_1 = __importDefault(__webpack_require__("aL5m"));
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
var TSAnlaufstelle_1 = __importDefault(__webpack_require__("B4Ew"));
var TSInspektorat = /** @class */ (function (_super) {
    __extends(TSInspektorat, _super);
    function TSInspektorat() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._inspektoren = [];
        return _this;
    }
    Object.defineProperty(TSInspektorat.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSInspektorat.prototype, "adresse", {
        get: function () {
            return this._adresse;
        },
        set: function (value) {
            this._adresse = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSInspektorat.prototype, "active", {
        get: function () {
            return this._active;
        },
        set: function (value) {
            this._active = value;
        },
        enumerable: true,
        configurable: true
    });
    TSInspektorat.deserializeArray = function (data) {
        var inspektoratArray = [];
        if (data && Array.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                inspektoratArray[i] = new TSInspektorat().deserialize(data[i]);
            }
        }
        else {
            inspektoratArray[0] = new TSInspektorat().deserialize(data);
        }
        return inspektoratArray;
    };
    Object.defineProperty(TSInspektorat.prototype, "verwalter", {
        get: function () {
            return this._verwalter;
        },
        set: function (value) {
            this._verwalter = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSInspektorat.prototype, "kanton", {
        get: function () {
            return this._kanton;
        },
        set: function (value) {
            this._kanton = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSInspektorat.prototype, "abteilung", {
        get: function () {
            return this._abteilung;
        },
        set: function (value) {
            this._abteilung = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSInspektorat.prototype, "anlaufstellen", {
        get: function () {
            return this._anlaufstellen;
        },
        set: function (value) {
            this._anlaufstellen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSInspektorat.prototype, "inspektoren", {
        get: function () {
            return this._inspektoren;
        },
        set: function (value) {
            this._inspektoren = value;
        },
        enumerable: true,
        configurable: true
    });
    TSInspektorat.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.name = restObject.name;
        this.abteilung = restObject.abteilung;
        this.adresse = this.deserializeOrCreate(restObject.adresse, new TSAdresse_1.default());
        this.active = restObject.active;
        this.verwalter = this.deserializeOrCreate(restObject.verwalter, new TSBenutzer_1.default());
        this.kanton = restObject.kanton;
        if (restObject.anlaufstellen) {
            this.anlaufstellen = restObject.anlaufstellen.map(TSAnlaufstelle_1.default.getDeserializer);
        }
        if (restObject.inspektoren) {
            this.inspektoren = restObject.inspektoren.map(TSBenutzer_1.default.getDeserializer);
        }
        return this;
    };
    TSInspektorat.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.name = this.name;
        restObject.abteilung = this.abteilung;
        restObject.adresse = this.serializeOrInit(this.adresse, restObject.adresse);
        restObject.active = this.active;
        restObject.verwalter = this.serializeOrInit(this.verwalter, restObject.verwalter);
        restObject.kanton = this.kanton;
        restObject.anlaufstellen = this.arrayToRestObject(this.anlaufstellen);
        restObject.inspektoren = this.arrayToRestObject(this.inspektoren);
        return restObject;
    };
    return TSInspektorat;
}(TSAbstractEntity_1.default));
exports.default = TSInspektorat;


/***/ }),

/***/ "6l5m":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "720h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright © 2019 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var AnlaufstelleUtil = /** @class */ (function () {
    function AnlaufstelleUtil() {
    }
    AnlaufstelleUtil.isNotImportiert = function (anlaufstelle) {
        return anlaufstelle.id !== AnlaufstelleUtil.IMPORTIERTE_ANLAUFSTELLE_ID;
    };
    AnlaufstelleUtil.IMPORTIERTE_ANLAUFSTELLE_ID = 'c856122f-4d20-bbbb-cccc-fcc5e7831614';
    return AnlaufstelleUtil;
}());
exports.default = AnlaufstelleUtil;


/***/ }),

/***/ "74j4":
/***/ (function(module, exports) {

module.exports = " <div class=\"vorleistung-view container\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <div class=\"dv-input-container-medium marginTop20\"> <fieldset ng-disabled=\"vm.isVorleistungReadonly()\" ng-if=\"vm.isSchadenFallVisible()\"> <div class=\"form-group row\"> <div class=\"col-sm-12\"> <h2> <span data-translate=\"VORLEISTUNG_ADD\"></span> </h2> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <dv-vorleistung vorleistung=\"vm.getModel()\" readonly=\"vm.isSchadenFallReadonly()\"></dv-vorleistung> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <h2> <span data-translate=\"BILDER_DOKUMENTE\"></span> </h2> <dv-dokumentupload schadenfallid=\"vm.schadenfallId\" parentid=\"vm.getModel().id\" document-type=\"vm.doctype\" on-doc-removed=\"vm.onDocRemoved(document)\" on-doc-added=\"vm.onDocAdded(document)\" readonly=\"vm.isVorleistungReadonly()\" begleit-text=\"AUFWAND_VORLEISTUNGEN_UPLOAD_TXT\"> </dv-dokumentupload> </div> </div> </fieldset> <div class=\"col-sm-12\"> <div class=\"row mainbuttons\"> <div> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.cancelVorleistung()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> <div> <dv-loading-button type=\"submit\" button-click=\"vm.saveVorleistung()\" button-class=\"btn btn-serf\"> <span data-translate=\"SAVE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </div> </div> </form> </div> ";

/***/ }),

/***/ "7K99":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("eLUI");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-map.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-map.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "7L/8":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2020 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.text-value-title{font-size:13px;font-weight:700;font-family:sans-serif;text-align:center;margin-top:7px}.text-value-value{font-size:45px;font-weight:700;text-align:center;margin-top:20px;color:#bc2500}", ""]);

// exports


/***/ }),

/***/ "7MRA":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("l6pO");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./benutzerEditAnlaufstelleView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./benutzerEditAnlaufstelleView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "7RdN":
/***/ (function(module, exports) {

module.exports = " <div class=\"schaden-view\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <div class=\"row\"> <div class=\"col-sm-12\" ng-if=\"vm.isMehrSchadenAnsicht()\"> <h2> <span ng-if=\"!vm.schaden.schadenDatenFS.schadenObjekt\" data-translate=\"NEUER_SCHADEN\"></span> <span ng-if=\"vm.schaden.schadenDatenFS.schadenObjekt\" data-translate=\"SCHADEN_NAME\" data-translate-value-objekt=\"{{vm.schaden.schadenDatenFS.schadenObjekt | translate}}\" data-translate-value-datum=\"{{vm.schaden.schadenDatenFS.schadendatum | amDateFormat : 'DD.MM.YYYY'}}\"> </span> </h2> </div> <div class=\"col-sm-12\"> <dv-schaden schaden=\"vm.schaden\" schadenfall-id=\"vm.schadenfallId\" readonly=\"vm.readonly\" show-geschaetztekosten=\"vm.showGeschaetztekosten()\"></dv-schaden> </div> <div class=\"col-sm-12 marginBottom60\" ng-if=\"vm.showZustimmungSteuerpruefung()\"> <dv-input-container> <div class=\"checkbox\"> <label> <input class=\"input-element\" id=\"gesuchsteller-zustimmungPruefungFondsuisse\" name=\"zustimmungPruefungFondsuisse\" ng-disabled=\"vm.getZustimmungGesuchstellerReadonly()\" ng-model=\"vm.schadenfall.gesuchsteller.finanzangaben.zustimmungPruefungFondsuisse\" ng-required=\"true\" ng-value=\"zustimmungPruefungFondsuisse\" type=\"checkbox\"> <span class=\"md-no-float\" ng-bind=\"vm.getZustimmungPruefungFondsuisseText()\"></span> <dv-error-messages for=\"vm.form.zustimmungPruefungFondsuisse\"></dv-error-messages> </label> </div> </dv-input-container> </div> <div class=\"col-sm-12\"> <fieldset ng-disabled=\"vm.isSchadenFallReadonly()\"> <h2> <span data-translate=\"BILDER_DOKUMENTE\"></span> </h2> <dv-dokumentupload schadenfallid=\"vm.schadenfallId\" on-doc-removed=\"vm.onDocRemoved(document)\" on-doc-added=\"vm.onDocAdded(document)\" parentid=\"vm.schaden.id\" document-type=\"vm.doctype\" readonly=\"vm.isSchadenFallReadonly()\"> </dv-dokumentupload> </fieldset> </div> <div class=\"col-sm-12\" ng-if=\"vm.isMehrSchadenAnsicht()\"> <div class=\"row mainbuttons\"> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.goBack()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> </div> </div> </form> </div> ";

/***/ }),

/***/ "7UW1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("bb2W");
var AuszahlungComponentConfig = /** @class */ (function () {
    function AuszahlungComponentConfig() {
        this.transclude = false;
        this.bindings = {
            zahlungsauftrag: '<'
        };
        this.template = __webpack_require__("3zgS");
        this.controller = DvAuszahlungController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return AuszahlungComponentConfig;
}());
exports.AuszahlungComponentConfig = AuszahlungComponentConfig;
var DvAuszahlungController = /** @class */ (function () {
    /* @ngInject */
    function DvAuszahlungController() {
    }
    DvAuszahlungController.$inject = [];
    return DvAuszahlungController;
}());
exports.DvAuszahlungController = DvAuszahlungController;


/***/ }),

/***/ "7eCW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractBemerkungEntity_1 = __importDefault(__webpack_require__("NwLi"));
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
var moment_1 = __importDefault(__webpack_require__("PJh5"));
var TSBegruendungsCode_1 = __webpack_require__("+5XP");
var TSTransitionBemerkung = /** @class */ (function (_super) {
    __extends(TSTransitionBemerkung, _super);
    function TSTransitionBemerkung() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSTransitionBemerkung.prototype, "besitzer", {
        get: function () {
            return this._besitzer;
        },
        set: function (value) {
            this._besitzer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSTransitionBemerkung.prototype, "scope", {
        get: function () {
            return this._scope;
        },
        set: function (value) {
            this._scope = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSTransitionBemerkung.prototype, "preStatus", {
        get: function () {
            return this._preStatus;
        },
        set: function (value) {
            this._preStatus = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSTransitionBemerkung.prototype, "postStatus", {
        get: function () {
            return this._postStatus;
        },
        set: function (value) {
            this._postStatus = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSTransitionBemerkung.prototype, "begruendungsCode", {
        get: function () {
            return this._begruendungsCode;
        },
        set: function (value) {
            this._begruendungsCode = value;
        },
        enumerable: true,
        configurable: true
    });
    TSTransitionBemerkung.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.scope = restObject.scope;
        this.besitzer = this.deserializeOrNull(restObject.besitzer, new TSBenutzer_1.default());
        this.begruendungsCode = restObject.begruendungsCode;
        this.postStatus = restObject.postStatus;
        this.preStatus = restObject.preStatus;
        return this;
    };
    TSTransitionBemerkung.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.scope = this.scope;
        restObject.besitzer = this.serializeOrInit(this.besitzer, restObject.besitzer);
        restObject.begruendungsCode = this.begruendungsCode;
        restObject.postStatus = this.postStatus;
        restObject.preStatus = this.preStatus;
        return restObject;
    };
    TSTransitionBemerkung.prototype.getBesitzerName = function () {
        if (this.besitzer && this.besitzer.getFullName()) {
            return this.besitzer.getFullName();
        }
        return ' ';
    };
    TSTransitionBemerkung.prototype.getTimestampErstellt = function () {
        if (this.timestampErstellt) {
            return this.timestampErstellt;
        }
        return moment_1.default();
    };
    TSTransitionBemerkung.prototype.getBemerkungScope = function () {
        return this.scope;
    };
    TSTransitionBemerkung.prototype.getBesitzer = function () {
        return this.besitzer;
    };
    TSTransitionBemerkung.prototype.getBegruendung = function () {
        if (this.begruendungsCode) {
            return TSBegruendungsCode_1.begruendungsCodePrefix() + this.begruendungsCode + TSBegruendungsCode_1.begruendungsCodeShortPostfix();
        }
        return undefined;
    };
    TSTransitionBemerkung.prototype.getPreStatus = function () {
        return this.preStatus;
    };
    TSTransitionBemerkung.prototype.getPostStatus = function () {
        return this.postStatus;
    };
    TSTransitionBemerkung.getDeserializer = function (benutzerBemerkung) {
        return new TSTransitionBemerkung().deserialize(benutzerBemerkung);
    };
    TSTransitionBemerkung.getSerializer = function (benutzerBemerkung) {
        return benutzerBemerkung.serialize(benutzerBemerkung);
    };
    return TSTransitionBemerkung;
}(TSAbstractBemerkungEntity_1.default));
exports.default = TSTransitionBemerkung;


/***/ }),

/***/ "7ibs":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */", ""]);

// exports


/***/ }),

/***/ "7lVO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var OkHtmlDialogController_1 = __webpack_require__("U0eN");
var TSBemerkungScope_1 = __webpack_require__("Oh5v");
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var abstractModelManagerController_1 = __importDefault(__webpack_require__("S1yE"));
var template = __webpack_require__("21xJ");
var okHtmlDialogTempl = __webpack_require__("ncnt");
var BankkontoViewComponentConfig = /** @class */ (function () {
    function BankkontoViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = BankkontoViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            schadenfall: '<',
        };
    }
    return BankkontoViewComponentConfig;
}());
exports.BankkontoViewComponentConfig = BankkontoViewComponentConfig;
var BankkontoViewController = /** @class */ (function (_super) {
    __extends(BankkontoViewController, _super);
    /* @ngInject */
    function BankkontoViewController(dvDialog, dvBernUtil, schadenfallModelManager, $q, $scope, $state) {
        var _this = _super.call(this, schadenfallModelManager, $scope, $state.current.name) || this;
        _this.dvDialog = dvDialog;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$state = $state;
        _this.scopeToShow = [];
        _this.scope = TSBemerkungScope_1.TSBemerkungScope.BEMERKUNG_VIEW;
        return _this;
    }
    BankkontoViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        if (!this.schadenfall) {
            console.error('no schadenfall passed to view');
        }
        else {
            this.initialModel = this.schadenfall;
            this.model = angular.copy(this.schadenfall);
        }
    };
    BankkontoViewController.prototype.getViewTitle = function () {
        return this.dvBernUtil.getViewTitle(this.schadenfall);
    };
    BankkontoViewController.prototype.isShowTitlePrefix = function () {
        return this.dvBernUtil.isShowTitlePrefix(this.schadenfall.gesuchsteller);
    };
    BankkontoViewController.prototype.getRolesAllowedForBankdaten = function () {
        return this.dvBernUtil.getRolesAllowedForBankdaten();
    };
    BankkontoViewController.prototype.saveBankverbindung = function () {
        var _this = this;
        if (this.isModelValid() && this.model) {
            if (this.model.status === TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN || this.model.status === TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG) {
                this.dvDialog.showDialog(okHtmlDialogTempl, OkHtmlDialogController_1.OkHtmlDialogController, {
                    title: '',
                    text: 'BEITRAG_SCHON_ERFASST',
                }).then(function () {
                    _this.save();
                });
            }
            else {
                this.save();
            }
        }
    };
    BankkontoViewController.prototype.save = function () {
        var _this = this;
        var response = this.schadenfallModelManager.saveBankverbindung(this.model);
        this.form.$setPristine();
        this.form.$setUntouched();
        if (response) {
            response.then(function () { return _this.navigateBack(); });
        }
    };
    BankkontoViewController.prototype.cancel = function () {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.navigateBack();
    };
    BankkontoViewController.prototype.navigateBack = function () {
        var params = { schadenfallId: this.schadenfall.id };
        this.$state.go('aufwaende', params);
    };
    BankkontoViewController.$inject = [
        'DvDialog',
        'DVBernUtil',
        'SchadenfallModelManager',
        '$q',
        '$scope',
        '$state',
    ];
    return BankkontoViewController;
}(abstractModelManagerController_1.default));
exports.BankkontoViewController = BankkontoViewController;


/***/ }),

/***/ "7uwI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("R/YX");
var template = __webpack_require__("uAg/");
var MigrationViewComponentConfig = /** @class */ (function () {
    function MigrationViewComponentConfig() {
        this.transclude = false;
        this.bindings = {};
        this.template = template;
        this.controller = MigrationViewController;
        this.controllerAs = 'vm';
    }
    return MigrationViewComponentConfig;
}());
exports.MigrationViewComponentConfig = MigrationViewComponentConfig;
var MigrationViewController = /** @class */ (function () {
    /* @ngInject */
    function MigrationViewController(migrationRS) {
        this.migrationRS = migrationRS;
    }
    MigrationViewController.prototype.$onInit = function () {
    };
    MigrationViewController.prototype.importschadenfaelle = function () {
        this.migrationRS.importSchadenfaelle();
    };
    MigrationViewController.prototype.importGemeinden = function () {
        this.migrationRS.importGemeinden();
    };
    MigrationViewController.prototype.importPersonen = function () {
        this.migrationRS.importPersonen();
    };
    MigrationViewController.prototype.importGesuchsteller = function () {
        this.migrationRS.importGesuchsteller(this.personId);
    };
    MigrationViewController.prototype.importBeitragForSchaden = function () {
        this.migrationRS.importBeitragForSchadenfall(this.schadenId);
    };
    MigrationViewController.$inject = ['MigrationRS'];
    return MigrationViewController;
}());
exports.MigrationViewController = MigrationViewController;


/***/ }),

/***/ "7xmh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.dv-schaeden-list .row-schadend-objekt{width:20%}.dv-schaeden-list .row-genauer-ort{width:30%}.dv-schaeden-list .row-datum-stichtag,.dv-schaeden-list .row-geschaetzte-kosten{width:20%}.dv-schaeden-list .row-actions{min-width:100px;width:10%}.dv-schaeden-list .green{color:#4ccb69}.dv-schaeden-list .yellow{color:#dcc100}.dv-schaeden-list .red{color:#bc2500}", ""]);

// exports


/***/ }),

/***/ "8/Tw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSRole_1 = __webpack_require__("MleR");
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var IsNeuInStatusService = /** @class */ (function () {
    /* @ngInject */
    function IsNeuInStatusService($log) {
        this.$log = $log;
        this._map = new Map();
        /*IsNeuInStatus für Superadmin*/
        var isNeuInStatusSuperadmin = new Map();
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole_1.TSRole.SUPER_ADMIN, isNeuInStatusSuperadmin);
        var isNeuInStatusfsAdmin = new Map();
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, true);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, true);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, true);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, true);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, true);
        this._map.set(TSRole_1.TSRole.FONDSSUISSE_ADMIN, isNeuInStatusfsAdmin);
        var isNeuInStatusfsSachbearbeiter = new Map();
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, true);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, true);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, true);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, true);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, true);
        this._map.set(TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER, isNeuInStatusfsSachbearbeiter);
        var isNeuInStatusAnlaufstelleSachbearbeiter = new Map();
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, true);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, true);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, true);
        this._map.set(TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER, isNeuInStatusAnlaufstelleSachbearbeiter);
        var isNeuInStatusAnlaufstelleVerwalter = new Map();
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, true);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, true);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, true);
        this._map.set(TSRole_1.TSRole.ANLAUFSTELLE_VERWALTER, isNeuInStatusAnlaufstelleVerwalter);
        var isNeuInStatusAnlaufstelleSchaetzer = new Map();
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, true);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, true);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, true);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, true);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, true);
        this._map.set(TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER, isNeuInStatusAnlaufstelleSchaetzer);
        var isNeuInStatusKantonInspektor = new Map();
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, false);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, true);
        this._map.set(TSRole_1.TSRole.KANTON_INSPEKTOR, isNeuInStatusKantonInspektor);
        var isNeuInStatusKantonVerwalter = new Map();
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, false);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, true);
        this._map.set(TSRole_1.TSRole.KANTON_VERWALTER, isNeuInStatusKantonVerwalter);
        var isNeuInStatusBetroffener = new Map();
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole_1.TSRole.BETROFFENER, isNeuInStatusBetroffener);
    }
    IsNeuInStatusService.prototype.isIsNeuInStatusVisibleForStatusAndRole = function (role, status) {
        if (role) {
            return this.getIsNeuInStatus(role, status);
        }
        else {
            this.$log.warn('no role passed');
            return false;
        }
    };
    IsNeuInStatusService.prototype.getIsNeuInStatus = function (role, status) {
        if (role) {
            var isNeuInStatusForRole = this._map.get(role);
            if (isNeuInStatusForRole) {
                var o = isNeuInStatusForRole.get(status);
                if (o) {
                    return o;
                }
                return false;
            }
            else {
                this.$log.error('no isNeuInStatus definitions for role ' + role);
            }
        }
        return false;
    };
    IsNeuInStatusService.$inject = ['$log'];
    return IsNeuInStatusService;
}());
exports.default = IsNeuInStatusService;


/***/ }),

/***/ "851e":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright © 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt\n * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n */.modal-header--bemerkung{padding:10px 58px}.modal-header--bemerkung span{font-size:16px;line-height:25px;letter-spacing:1px;font-weight:700}.modal-header--bemerkung label{padding-top:30px}.modal-body--bemerkung{padding:0 58px}.modal-footer--bemerkung{text-align:center;padding:30px}@media(min-width:1025px){.bemerkung-modal-window .modal-dialog{width:60%;height:700px;left:50%;top:50%;transform:translate(-50%,-50%)!important;margin:0}.bemerkung-modal-window button.close{margin-right:-42px}}", ""]);

// exports


/***/ }),

/***/ "8KBA":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"> <h3 class=\"modal-title\" style=\"float:left\">{{ vm.title }}</h3> <button type=\"button\" class=\"close\" ng-click=\"vm.no()\">&times;</button> </div> <div class=\"modal-body\"> {{ vm.text }} </div> <div class=\"modal-footer\"> <button class=\"btn btn-serf\" ng-click=\"vm.no()\" data-translate=\"LABEL_NEIN\"></button> <button class=\"btn btn-serf\" ng-click=\"vm.yes()\" data-translate=\"LABEL_JA\"></button> </div> ";

/***/ }),

/***/ "8Mxj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var template = __webpack_require__("NDtb");
var DvHomeIconComponentConfig = /** @class */ (function () {
    function DvHomeIconComponentConfig() {
        this.transclude = false;
        this.bindings = {};
        this.template = template;
        this.controller = DvHomeIconController;
        this.controllerAs = 'vm';
    }
    return DvHomeIconComponentConfig;
}());
exports.DvHomeIconComponentConfig = DvHomeIconComponentConfig;
var DvHomeIconController = /** @class */ (function () {
    function DvHomeIconController($state) {
        this.$state = $state;
    }
    DvHomeIconController.prototype.goBackHome = function () {
        this.$state.go('gesuchstellerDashboard');
    };
    DvHomeIconController.$inject = ['$state'];
    return DvHomeIconController;
}());
exports.DvHomeIconController = DvHomeIconController;


/***/ }),

/***/ "8WYw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSAuthEvent_1 = __webpack_require__("L0QB");
var HttpAuthInterceptor = /** @class */ (function () {
    /* @ngInject */
    function HttpAuthInterceptor($rootScope, $q, CONSTANTS, httpBuffer) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.CONSTANTS = CONSTANTS;
        this.httpBuffer = httpBuffer;
        this.responseError = function (rejection) {
            switch (rejection.status) {
                case 401:
                    // exclude requests from the login form
                    if (rejection.config && rejection.config.url === _this.CONSTANTS.REST_API + 'auth/login') {
                        return _this.$q.reject(rejection);
                    }
                    // all requests that failed due to notAuthenticated are appended to httpBuffer. Use httpBuffer.retryAll to submit them.
                    var deferred = _this.$q.defer();
                    _this.httpBuffer.append(rejection.config, deferred);
                    _this.$rootScope.$broadcast(TSAuthEvent_1.TSAuthEvent[TSAuthEvent_1.TSAuthEvent.NOT_AUTHENTICATED], rejection);
                    return deferred.promise;
                case 403:
                    _this.$rootScope.$broadcast(TSAuthEvent_1.TSAuthEvent[TSAuthEvent_1.TSAuthEvent.NOT_AUTHORISED], rejection);
                    return _this.$q.reject(rejection);
            }
            return _this.$q.reject(rejection);
        };
    }
    HttpAuthInterceptor.$inject = ['$rootScope', '$q', 'CONSTANTS', 'httpBuffer'];
    return HttpAuthInterceptor;
}());
exports.default = HttpAuthInterceptor;


/***/ }),

/***/ "8xVf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9+RF":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".benutzerverwaltung-view.container{width:auto}", ""]);

// exports


/***/ }),

/***/ "9/Ng":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("fctY");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./adminView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./adminView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "92KJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSErrorLevel;
(function (TSErrorLevel) {
    TSErrorLevel[TSErrorLevel["SEVERE"] = 'SEVERE'] = "SEVERE";
    TSErrorLevel[TSErrorLevel["WARNING"] = 'WARNING'] = "WARNING";
    TSErrorLevel[TSErrorLevel["INFO"] = 'INFO'] = "INFO";
})(TSErrorLevel = exports.TSErrorLevel || (exports.TSErrorLevel = {}));


/***/ }),

/***/ "92sy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RemoveDialogController = /** @class */ (function () {
    function RemoveDialogController($uibModalInstance, $translate, title, text) {
        this.$uibModalInstance = $uibModalInstance;
        if (text !== undefined && text !== null) {
            this.deleteText = $translate.instant(text);
        }
        else {
            this.deleteText = $translate.instant('LOESCHEN_DIALOG_TEXT');
        }
        if (title !== undefined && title !== null) {
            this.title = $translate.instant(title);
        }
        else {
            this.title = $translate.instant('LOESCHEN_DIALOG_TITLE');
        }
    }
    RemoveDialogController.prototype.hide = function () {
        return this.$uibModalInstance.close();
    };
    RemoveDialogController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    ;
    RemoveDialogController.$inject = ['$uibModalInstance', '$translate', 'title', 'text'];
    return RemoveDialogController;
}());
exports.RemoveDialogController = RemoveDialogController;


/***/ }),

/***/ "97eG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSRole_1 = __webpack_require__("MleR");
var template = __webpack_require__("wP+2");
__webpack_require__("r5mD");
var DVSchadenListComponentConfig = /** @class */ (function () {
    function DVSchadenListComponentConfig() {
        this.transclude = false;
        this.bindings = {
            schaeden: '=',
            onEdit: '&',
            onDelete: '&',
            readonly: '<',
        };
        this.template = template;
        this.controller = DVSchadenListController;
        this.controllerAs = 'vm';
    }
    return DVSchadenListComponentConfig;
}());
exports.DVSchadenListComponentConfig = DVSchadenListComponentConfig;
var DVSchadenListController = /** @class */ (function () {
    /* @ngInject */
    function DVSchadenListController($filter, $log, CONSTANTS, $scope, roleUtilService, $window, $translate) {
        this.$filter = $filter;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.$scope = $scope;
        this.roleUtilService = roleUtilService;
        this.$window = $window;
        this.$translate = $translate;
        this.schaeden = []; //Liste die im Gui angezeigt wird
        this.initViewModel();
    }
    DVSchadenListController.prototype.initViewModel = function () {
    };
    DVSchadenListController.prototype.$onInit = function () {
    };
    DVSchadenListController.prototype.calcTotalSchaden = function () {
        var total = 0;
        if (this.schaeden !== undefined) {
            try {
                for (var _a = __values(this.schaeden), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var obj = _b.value;
                    if (obj && obj.schadenDatenFS && obj.schadenDatenFS.geschaetzteKosten) {
                        total += obj.schadenDatenFS.geschaetzteKosten;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return total;
        var e_1, _c;
    };
    DVSchadenListController.prototype.getFilterroles = function () {
        return this.roleUtilService.getAllRolesButGesuchstellerArray();
    };
    DVSchadenListController.prototype.editClicked = function (schadenToEdit, event) {
        this.onEdit({ schaden: schadenToEdit, event: event });
    };
    DVSchadenListController.prototype.deleteClicked = function (schadenToDelete, event) {
        this.onDelete({ schaden: schadenToDelete, event: event });
    };
    DVSchadenListController.prototype.translateAktiv = function (inaktiv) {
        return inaktiv ? (this.$translate.instant('INAKTIV')) : (this.$translate.instant('AKTIV'));
    };
    DVSchadenListController.prototype.translateRoles = function (roles) {
        var _this = this;
        var prefix = TSRole_1.rolePrefix();
        return roles.map(function (element) {
            return _this.$translate.instant(prefix + TSRole_1.TSRole[element]);
        }).join(', ');
    };
    DVSchadenListController.prototype.translateRole = function (role) {
        var prefix = TSRole_1.rolePrefix();
        return this.$translate.instant(prefix + TSRole_1.TSRole[role]);
    };
    DVSchadenListController.prototype.getColumnsNumber = function () {
        var element = angular.element('.dv-schaeden-list .header-row').first();
        if (element && element.get(0)) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 5;
    };
    DVSchadenListController.$inject = ['$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', '$translate'];
    return DVSchadenListController;
}());
exports.DVSchadenListController = DVSchadenListController;


/***/ }),

/***/ "9Qvs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var IbanInputComponentConfig = /** @class */ (function () {
    function IbanInputComponentConfig() {
        this.transclude = false;
        this.bindings = {
            model: '=',
            name: '@',
            label: '@',
            clazz: '@',
            placeholder: '@',
            ngRequired: '<',
            bisherFs: '<?',
            bisherGs: '<?',
            bisherProperty: '@?'
        };
        this.template = __webpack_require__("15/d");
        this.controller = DvIbanInputController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return IbanInputComponentConfig;
}());
exports.IbanInputComponentConfig = IbanInputComponentConfig;
var DvIbanInputController = /** @class */ (function () {
    function DvIbanInputController(errorService) {
        this.errorService = errorService;
        this.valueRequired = true; // default required
    }
    DvIbanInputController.prototype.$onInit = function () {
        if (this.ngRequired !== undefined) {
            this.valueRequired = this.ngRequired;
        }
    };
    DvIbanInputController.prototype.showBisher = function () {
        return (this.bisherGs !== undefined && this.bisherFs !== undefined && this.bisherProperty !== undefined);
    };
    DvIbanInputController.prototype.handleBlur = function (event) {
        if (this.model) {
            this.model = this.model.toUpperCase();
            this.handleIbanChange();
        }
    };
    DvIbanInputController.prototype.validateIban = function (iban) {
        var isIbanFormatValid = false;
        var isIbanModuloValid = false;
        this.errorService.clearAll();
        iban = iban.replace(/ /g, '').toUpperCase();
        // IBAN Validation
        var ibanRegex = /^CH\d{2}[0-9a-zA-Z]{17}$/;
        if (ibanRegex.test(iban)) {
            isIbanFormatValid = true;
        }
        // Es darf keine QR-IBAN sein
        // keine 3 an der dritten Stelle
        var qrIbanRegex = /^CH\d{2}3[0-9a-zA-Z]{16}$/;
        if (qrIbanRegex.test(iban)) {
            isIbanFormatValid = false;
        }
        isIbanModuloValid = this.checkIbanModulo(iban);
        return isIbanFormatValid && isIbanModuloValid;
    };
    DvIbanInputController.prototype.checkIbanModulo = function (iban) {
        // Modulo 97 Validation ohne BigInt
        var rearrangedIban = iban.slice(4) + iban.slice(0, 4);
        var numericIban = rearrangedIban.replace(/[A-Z]/g, function (match) { return (match.charCodeAt(0) - 55).toString(); });
        var remainder = numericIban;
        while (remainder.length > 2) {
            var block = remainder.slice(0, 9);
            remainder = (parseInt(block, 10) % 97).toString() + remainder.slice(block.length);
        }
        return parseInt(remainder, 10) % 97 === 1;
        // Modulo 97 validation mit BigInt
        // const rearrangedIban = iban.slice(4) + iban.slice(0, 4);
        // const numericIban = rearrangedIban.replace(/[A-Z]/g, (match) => (match.charCodeAt(0) - 55).toString());
        // const remainder = BigInt(numericIban) % 97;
        // return remainder === 1;
    };
    DvIbanInputController.prototype.handleIbanChange = function () {
        if (this.model && !this.validateIban(this.model)) {
            // Handle invalid IBAN
            this.errorService.addMesageAsError('ERROR_IBAN_FORMAT');
        }
    };
    DvIbanInputController.$inject = ['ErrorService'];
    return DvIbanInputController;
}());
exports.DvIbanInputController = DvIbanInputController;


/***/ }),

/***/ "9cS4":
/***/ (function(module, exports) {

module.exports = {"FILTER_ZURUECKSETZEN":"Filter zurücksetzen","ABSCHLUSS_TITLE":"Vielen Dank","ABSCHLUSS_TEXT":"Ihr Schadenfall wurde erfolgreich übermittelt. Wir überprüfen und leiten diesen an die entsprechende Anlaufstelle weiter.","ABSCHLUSS_TITLE_ANLAUFSTELLE_REG":"Vielen Dank für Ihre Anmeldung!","ABSCHLUSS_TEXT_ANLAUFSTELLE_REG":"Sie erhalten in Kürze eine E-Mail mit Hinweisen, um Ihr Benutzerkonto zu aktivieren. Weitere Angaben zur Freischaltung Ihres Kontos erhalten Sie nach erfolgreichem Login.","ABSCHLUSS_BUTTON_TEXT":"Zur Übersicht","EIGENLEISTUNG_ADD":"Eigenleistung hinzufügen","SCHAETZUNG_ADD":"Schätzung hinzufügen","VORLEISTUNG_ADD":"Vorleistung hinzufügen","AUFWAND_VORLEISTUNGEN_UPLOAD_TXT":"Bitte erfassen Sie hier Belege für die Vorleistungen.","ALLE":"alle","ALLE_TITLE":"Alle","AKTIV":"aktiv","ADMIN":"Admin","BANK":"Bank","TS_REPORTYPE_AUSZAHLUNG":"Auszahlungs Statistik","TS_REPORTYPE_SCHADEN":"Schaden Statistik","TS_REPORTYPE_ALLE":"Alle Gesuchsdaten","TS_REPORTYPE_AUSZAHLUNG_KANTON":"Auszahlungs Statistik","DATUM_AUSZAHLUNG_VON":"Auszahlungsdatum von","DATUM_AUSZAHLUNG_BIS":"Auszahlungsdatum bis","DATUM_GESUCH_VON":"Gesuchsdatum von","DATUM_GESUCH_BIS":"Gesuchsdatum bis","DATUM_EREIGNIS_VON":"Ereignisdatum von","DATUM_EREIGNIS_BIS":"Ereignisdatum bis","DATUM_AUSZAHLUNG_PARAM":"Auszahlungsdatum: ","DATUM_GESUCH_PARAM":"Gesuchsdatum: ","DATUM_EREIGNIS_PARAM":"Ereignisdatum: ","ARBEITSSTUNDEN":"Arbeitsstunden","ANLAUFSTELLE_TO_EDIT":"Wählen Sie die zu verwaltende Anlaufstelle.","ANLAUFSTELLE_ADD":"Anlaufstelle hinzufügen","ANLAUFSTELLENVERWALTUNG_ANLAUFSTELLE":"Anlaufstellen","AUFWAND_FREMDKOSTEN_ADD":"Fremdkosten hinzufügen","AUFWAND_FREMDKOSTEN_REMOVE":"Wollen Sie die Fremdkosten wirklich löschen?","AUFWAND_FREMDKOSTEN_UPLOAD_TXT":"Bitte erfassen Sie die Rechnungen und Zahlungsquittungen (Bank, Post).","AUFWAND_EIGENLEISTUNGEN_UPLOAD_TXT":"Bitte erfassen Sie den Beleg für die Eigenleistungen (Stundenrapport).","AKTION":"Aktion","BENUTZER_REC_SUCCESS":"Das Benutzerkonto wurde erstellt. Es wurde eine E-Mail verschickt in dem beschrieben ist, wie das Benutzerkonto freigeschaltet werden kann.","BENUTZER_CREATED_SUCCESS":"Das Benutzerkonto wurde erstellt und verifiziert. Sie können sich mit den gemachten Angaben einloggen.","VERWALTER_REC_SUCCESS":"Das Benutzerkonto für den Anlaufstellen-Verwalter wurde erstellt. Bitte teilen Sie dem Verwalter das Passwort mit.","BENUTZERVERWALTUNG_ANLAUFSTELLE_VERWALTER":"Benutzerverwaltung Anlaufstelle","BENUTZERROLLE":"Benutzerrolle","BENUTZERVERWALTUNG_ADD":"Benutzer hinzufügen","BENUTZER_SPEICHERN":"Benutzer speichern","BENUTZERPROFIL":"Benutzerprofil","BENUTZERROLLEN_HINWEIS":"Um dem Benutzerrollen zuzuordnen, erfassen Sie zuerst den Benutzer und fügen Sie ihn auf der Seite der Anlaufstelle dann zu den Schätzern oder Sachbearbeitern hinzu.","BENUTZERROLLEN_ANLAUFSTELLE_HINWEIS":"Um dem Benutzer Rollen zuzuordnen, erfassen Sie zuerst den Benutzer und fügen Sie Ihn auf der Seite der Anlaufstelle dann zu den Schaetzern oder Sachbearbeitern hinzu.","BENUTZER_ERSTELLEN":"neuen Benutzer erstellen","BENUTZER_DEAKTIVIEREN":"Benutzer deaktivieren","BETRAG_BERECHTIGT":"Berechtigter Betrag","CONFIRM_VERWALTERCHANGE":"Achtung: Wenn Sie selber die verantworltiche Person sind, haben Sie nach der Änderung derseleben möglicherweise keinen Zugriff auf die Anlaufstelle mehr.","DELETE":"Löschen","JAHRGANG":"Jahrgang","BETRAG":"Betrag","BETRAG_CHF":"Betrag in CHF","ANZAHL_STUNDEN":"Anz. Std.","ANZAHL_KUBIKMETER":"Anz. m3","BETRAG_HOLZ_CHF":"Betrag für Holz in CHF","BETRAG_TREIBSTOFF_CHF":"Betrag für Treibstoff in CHF","EDIT":"Editieren","PROPERTY_NAME":"Name","PROPERTY_TEXT":"Text","TIMEERSTELLT":"Erstellungsdatum","TIMEMUTIERT":"Geändert","SIZE":"Grösse","Land_AD":"Andorra","Land_AE":"Vereinigte Arabische Emirate","Land_AF":"Afghanistan","Land_AG":"Antigua und Barbuda","Land_AI":"Anguilla","Land_AL":"Albanien","Land_AM":"Armenien","Land_AN":"Niederländische Antillen","Land_AO":"Angola","Land_AQ":"Antarktis","Land_AR":"Argentinien","Land_AS":"Amerikanisch Samoa","Land_AT":"Österreich","Land_AU":"Australien","Land_AW":"Aruba","Land_AX":"Åland Inseln","Land_AZ":"Aserbaidschan","Land_BA":"Bosnien und Herzegowina","Land_BB":"Barbados","Land_BD":"Bangladesch","Land_BE":"Belgien","Land_BF":"Burkina Faso","Land_BG":"Bulgarien","Land_BH":"Bahrain","Land_BI":"Burundi","Land_BJ":"Benin","Land_BL":"St. Barthélemy","Land_BM":"Bermuda","Land_BN":"Brunei Darussalam","Land_BO":"Bolivien","Land_BR":"Brasilien","Land_BS":"Bahamas","Land_BT":"Bhutan","Land_BV":"Bouvetinsel","Land_BW":"Botswana","Land_BY":"Weißrussland","Land_BZ":"Belize","Land_CA":"Kanada","Land_CC":"Kokosinseln","Land_CD":"Kongo, Dem. Rep.","Land_CF":"Zentralafrikanische Republik","Land_CG":"Kongo","Land_CH":"Schweiz","Land_CI":"Côte d'Ivoire","Land_CK":"Cookinseln","Land_CL":"Chile","Land_CM":"Kamerun","Land_CN":"China","Land_CO":"Kolumbien","Land_CR":"Costa Rica","Land_CS":"Serbien und Montenegro","Land_CU":"Kuba","Land_CV":"Kap Verde","Land_CX":"Weihnachtsinsel","Land_CY":"Zypern","Land_CZ":"Tschechische Republik","Land_DE":"Deutschland","Land_DJ":"Dschibuti","Land_DK":"Dänemark","Land_DM":"Dominica","Land_DO":"Dominikanische Republik","Land_DZ":"Algerien","Land_EC":"Ecuador","Land_EE":"Estland","Land_EG":"Ägypten","Land_EH":"Westsahara","Land_ER":"Eritrea","Land_ES":"Spanien","Land_ET":"Äthiopien","Land_FI":"Finnland","Land_FJ":"Fidschi","Land_FK":"Falklandinseln","Land_FM":"Mikronesien","Land_FO":"Färöer","Land_FR":"Frankreich","Land_GA":"Gabun","Land_GB":"Vereinigtes Königreich","Land_GD":"Grenada","Land_GE":"Georgien","Land_GF":"Französisch-Guayana","Land_GG":"Guernsey","Land_GH":"Ghana","Land_GI":"Gibraltar","Land_GL":"Grönland","Land_GM":"Gambia","Land_GN":"Guinea","Land_GP":"Guadeloupe","Land_GQ":"Äquatorialguinea","Land_GR":"Griechenland","Land_GS":"Südgeorgien und die Südlichen Sandwichinseln","Land_GT":"Guatemala","Land_GU":"Guam","Land_GW":"Guinea-Bissau","Land_GY":"Guyana","Land_HK":"Hongkong","Land_HM":"Heard und McDonaldinseln","Land_HN":"Honduras","Land_HR":"Kroatien","Land_HT":"Haiti","Land_HU":"Ungarn","Land_ID":"Indonesien","Land_IE":"Irland","Land_IL":"Israel","Land_IM":"Isle of Man","Land_IN":"Indien","Land_IO":"Britisches Territorium im Indischen Ozean","Land_IQ":"Irak","Land_IR":"Iran, Islam. Rep.","Land_IS":"Island","Land_IT":"Italien","Land_JE":"Jersey","Land_JM":"Jamaika","Land_JO":"Jordanien","Land_JP":"Japan","Land_KE":"Kenia","Land_KG":"Kirgisistan","Land_KH":"Kambodscha","Land_KI":"Kiribati","Land_KM":"Komoren","Land_KN":"St. Kitts und Nevis","Land_KP":"Korea, Dem. Volksrep.","Land_KR":"Korea, Rep.","Land_KW":"Kuwait","Land_KY":"Kaimaninseln","Land_KZ":"Kasachstan","Land_LA":"Laos, Dem. Volksrep.","Land_LB":"Libanon","Land_LC":"St. Lucia","Land_LI":"Liechtenstein","Land_LK":"Sri Lanka","Land_LR":"Liberia","Land_LS":"Lesotho","Land_LT":"Litauen","Land_LU":"Luxemburg","Land_LV":"Lettland","Land_LY":"Libysch-Arabische Dschamahirija","Land_MA":"Marokko","Land_MC":"Monaco","Land_MD":"Moldawien","Land_ME":"Montenegro","Land_MF":"St. Martin","Land_MG":"Madagaskar","Land_MH":"Marshallinseln","Land_MK":"Mazedonien, ehemalige jugoslawische Republik","Land_ML":"Mali","Land_MM":"Myanmar","Land_MN":"Mongolei","Land_MO":"Macao","Land_MP":"Nördliche Marianen","Land_MQ":"Martinique","Land_MR":"Mauretanien","Land_MS":"Montserrat","Land_MT":"Malta","Land_MU":"Mauritius","Land_MV":"Malediven","Land_MW":"Malawi","Land_MX":"Mexiko","Land_MY":"Malaysia","Land_MZ":"Mosambik","Land_NA":"Namibia","Land_NC":"Neukaledonien","Land_NE":"Niger","Land_NF":"Norfolkinsel","Land_NG":"Nigeria","Land_NI":"Nicaragua","Land_NICHTAERKANNT":"Nicht anerkannt","Land_NL":"Niederlande","Land_NO":"Norwegen","Land_NP":"Nepal","Land_NR":"Nauru","Land_NU":"Niue","Land_NZ":"Neuseeland","Land_OM":"Oman","Land_PA":"Panama","Land_PE":"Peru","Land_PF":"Französisch-Polynesien","Land_PG":"Papua-Neuguinea","Land_PH":"Philippinen","Land_PK":"Pakistan","Land_PL":"Polen","Land_PM":"St. Pierre und Miquelon","Land_PN":"Pitcairninseln","Land_PR":"Puerto Rico","Land_PS":"Palästinensische Autonomiegebiete","Land_PT":"Portugal","Land_PW":"Palau","Land_PY":"Paraguay","Land_QA":"Katar","Land_RE":"Réunion","Land_RO":"Rumänien","Land_RS":"Serbien","Land_RU":"Russische Föderation","Land_RW":"Ruanda","Land_SA":"Saudi-Arabien","Land_SB":"Salomonen","Land_SC":"Seychellen","Land_SD":"Sudan","Land_SE":"Schweden","Land_SG":"Singapur","Land_SH":"St. Helena","Land_SI":"Slowenien","Land_SJ":"Svalbard und Jan Mayen","Land_SK":"Slowakei","Land_SL":"Sierra Leone","Land_SM":"San Marino","Land_SN":"Senegal","Land_SO":"Somalia","Land_SR":"Suriname","Land_ST":"São Tomé und Príncipe","Land_STAATENLOS":"Staatenlos","Land_SV":"El Salvador","Land_SY":"Syrien, Arab. Rep.","Land_SZ":"Swasiland","Land_TC":"Turks- und Caicosinseln","Land_TD":"Tschad","Land_TF":"Französische Süd- und Antarktisgebiete","Land_TG":"Togo","Land_TH":"Thailand","Land_TJ":"Tadschikistan","Land_TK":"Tokelau","Land_TL":"Timor-Leste","Land_TM":"Turkmenistan","Land_TN":"Tunesien","Land_TO":"Tonga","Land_TR":"Türkei","Land_TT":"Trinidad und Tobago","Land_TV":"Tuvalu","Land_TW":"Taiwan","Land_TZ":"Tansania, Vereinigte Rep.","Land_UA":"Ukraine","Land_UG":"Uganda","Land_UM":"Amerikanisch-Ozeanien","Land_UNBEKANNT":"Unbekannt","Land_US":"Vereinigte Staaten von Amerika","Land_UY":"Uruguay","Land_UZ":"Usbekistan","Land_VA":"Vatikanstadt","Land_VC":"St. Vincent und die Grenadinen","Land_VE":"Venezuela","Land_VG":"Britische Jungferninseln","Land_VI":"Amerikanische Jungferninseln","Land_VN":"Vietnam","Land_VU":"Vanuatu","Land_WF":"Wallis und Futuna","Land_WS":"Samoa","Land_XZ":"Kosovo","Land_YE":"Jemen","Land_YT":"Mayotte","Land_ZA":"Südafrika","Land_ZM":"Sambia","Land_ZW":"Simbabwe","MENU_LOGOUT":"Abmelden","SAVE":"Speichern","WEITER":"Weiter","CANCEL":"Abbrechen","LOGIN_REGISTER_ANLAUFSTELLE":"Neue Anlaufstelle registrieren","LOGIN_BACK_TOANMELDUNG":"zurück zur Anmeldung","LOGIN_BTN":"Login","LOGIN_BTN_ANFORDERN":"Anfordern","LOGIN_CHANGED":"Das Passwort wurde geändert.","LOGIN_EMAIL":"E-Mail","LOGIN_EMAIL_REPEAT":"E-Mail wiederholen","LOGIN_EXISTING_USER":"Mit registriertem Benutzerkonto einloggen","LOGIN_DAMAGE_NOTICE_TITLE":"Hinweis:","LOGIN_DAMAGE_NOTICE_TEXT":"Für Schäden in den Kantonen (AR, GR, NW) ist die Schadenmeldung direkt beim jeweiligen Kanton einzureichen. Weitere Informationen finden Sie ","LOGIN_DAMAGE_NOTICE_LINK":"hier","LOGIN_DAMAGE_NOTICE_URL":"https://www.fondssuisse.ch/de/gesuche-und-beitraege/zustaendigkeiten","LOGIN_NO_ACCOUNT_YET":"Noch kein Benutzerkonto für Betroffene?","LOGIN_GEMEINDE":"Anmeldung für Gemeinden bitte hier klicken: ","LOGING_FORGOT_PASSWORT":"Passwort vergessen","LOGIN_PASSWD":"Passwort","LOGIN_PASSWD_REP":"Passwort wiederholen","LOGIN_PW_REST_SENT":"Es wurde eine E-Mail mit Hinweisen an die angegebene E-Mail-Adresse geschickt.","LOGIN_RESET_PW_TITLE":"Probleme bei der Anmeldung?","LOGIN_RESET_PW_TEXT":"Bitte geben Sie die E-Mail-Adresse ein, die Sie bei fondssuisse registriert haben. Wir senden Ihnen anschliessend Anweisungen, damit alles wieder funktioniert.","LOGIN_RESET_PW_BUTTON":"Passwort ändern","LOGIN_SET_NEW_PASSWORD_TITLE":"Benutzerpasswort setzen","LOGIN_SET_NEW_PASSWORD_TEXT":"Bitte setzen Sie das neue Passwort (min. 8 Zeichen, davon mindestens 1 Zahl).","LOGIN_REGISTER_GS":"Registrieren als Betroffener","LOGIN_REGISTER_GEMEINDE":"Registrieren für Gemeinden","MAX_ERFASSUNGS_BETRAG":"Maximaler Erfassungsbetrag","REGISTER":"Registrieren","LOGIN_USERNAME":"Benutzername","ERROR_REQUIRED":"Feld wird benötigt","ERROR_COORDINATES":"Bitte bestimmen Sie ein Punkt auf der Karte.","ERROR_DOCCOUNT":"Es werden Dokumente benötigt. Bitte laden sie mindestens {{count}} Dokument(e) hoch.","ERROR_REQUIRED_ONE_OF_THEM":"Eines der Felder wird benötigt.","ERROR_VERTRAG_REQUIRED":"Um eine Platzbestätigung anzufordern, müssen Sie einen Vertrag mit der betreffenden Institution abgeschlossen haben.","ERROR_MIN":"Minimalwert unterschritten.","ERROR_MIN_LENG":"Eingabe zu kurz.","ERROR_MAX_LENG":"Eingabe zu lang.","ERROR_EMAIL":"Keine gültige E-Mail-Adresse.","ERROR_EMAIL_SAME":"Die E-Mail-Adresse muss zweimal gleich eingegeben werden.","ERROR_FORMAT":"Falsches Format","ERROR_IBAN_FORMAT":"IBAN ist ungültig","ERROR_DATE":"Falsches Datumsformat","ERROR_MAX":"Maximaler Wert überschritten.","ERROR_NUMBER":"Falsches Zahlenformat","ERROR_NO_LEISTUNG_ENTERED":"Es wurde kein Aufwand / keine Leistung eingegeben. Wollen Sie wirklich freigeben?","ERROR_LEISTUNG_COMPULSORY":"Es wurde kein Aufwand / keine Leistung eingegeben. Bitte geben Sie mindestens eine Leistung an.","ERROR_NO_BANKKONTO_ENTERED":"Die Bankangaben müssen eingegeben werden.","ERROR_NO_FUNCTIONAL_ROLE":"Diesem Benutzer wurde noch keine Funktion zugeteilt.","ERROR_NO_SCHAETZER":"Sie müssen dem Gesuch mindestens einen Schätzer zuweisen um es weiterleiten zu können.","ERROR_NO_SCHAETZUNG":"Es wurde noch keine Schätzung erfasst. Sind Sie sicher, dass Sie den Fall übermitteln wollen?","ERROR_NO_STEUERDATENPRUEFUNG":"Bitte bestätigen Sie auf der vorherigen Seite, dass die Finanzangaben geprüft wurden.","ERROR_NO_BEITRAG":"Es muss mindestens ein Beitrag erfasst sein.","ERROR_VALUE":"Wert zu gross oder falsch formatiert.","ERROR_FUTURE":"Datum liegt in der Zukunft.","ERROR_PAST":"Datum liegt in der Vergangenheit.","ERROR_UNEXPECTED":"Es ist ein unerwarteter Fehler aufgetreten.","ERROR_LOGIN":"Gültige E-Mail-Adresse und Passwort eingeben.","ERROR_PW_CHANGE":"Das Passwort konnte nicht geändert werden.","ERROR_PW_SAME":"Bitte geben Sie das neue Passwort zweimal gleich ein.","ERROR_PW_RESTRICTIONS":"Das Passwort muss mindestens 8 Zeichen umfassen und mindestens eine Zahl und einen Buchstaben enthalten.","ERROR_UNAUTHORIZED":"Aktion nicht erlaubt!","ERROR_NO_BEITRAEGE":"Es wurden noch keine Beiträge ausgewählt.","ERROR_NO_SUBVENTIONIERT_FLAG":"Angaben Subventionen ja/nein fehlen","ERROR_WALD":"Betroffene Fläche oder Holzmenge muss angegeben werden","FIRMA":"Firma","BESCHREIBUNG":"Beschreibung","FREIGEBEN":"Gesuch absenden","FREIGEBEN_PAPIER":"Gesuch absenden","FIRMENSITZ":"Firmensitz","LEISTUNGSART":"Leistungsart","RECHNUNGSNUMMER":"Rechnungs Nr.","RECHNUNGSDATUM":"Rechnungsdatum","RECHNUNGSBETRAG":"Rechnungsbetrag in CHF","DATE_PLACEHOLDER":"tt.mm.jjjj","DATEPICKER_EXAMPLE":"Datepicker Beispiel","KEIN_EINTRAG":"Keine Einträge vorhanden","VALUEINPUT_EXAMPLE":"Valueinput Beispiel","TOOLTIP_HELP_TITLE":"tooltip help title","TOOLTIP_HELP_TEXT":"Tooltip help title","MENU_SCHADENFAELLE":"Schadenfälle","MENU_COCKPIT":"Cockpit","MENU_ARCHIV":"Archiv","MENU_BENUTZERVERWALTUNG":"Benutzerverw.","MENU_ANLAUFSTELLE":"Anlaufstelle","MENU_ZAHLUNGEN":"Zahlungen","MENU_STATISTIK":"Statistik","MENU_GESUCH_ERFASSEN":"Gesuch erfassen","NAV_GESUCH_ERFASSEN":"Betroffene","NAV_SCHADENMELDUNG":"Schadenmeldung","NAV_AUFWAENDE":"Aufwände","NAV_SCHAETZUNG":"Schadenschätzung","SACHBEARBEITER_ZUTEILEN":"Sachbearbeiter zuteilen","SCHAETZER_ADD":"Schätzer hinzufügen","DIE_SCHAETZER":"Die Schätzer","SCHAETZER_ZUTEILEN":"Schätzer zuteilen","TESTFALL_ERSTELLEN":"Test Schadenfall {{gsname}} einfügen","TESTPAGE":"Testpage","TSEigenleistungArt_HANDARBEIT":"Handarbeit","TSEigenleistungArt_HANDARBEIT_PAUSCHAL":"Handarbeit Stundenrapport","TSEigenleistungArt_TERRA_TRAC_SUB44KW":"Terra Trac 30 bis 44 kW (41 - 60 PS)","TSEigenleistungArt_TERRA_TRAC_SUB74KW":"Terra Trac 45 bis 73 kW (61 - 100 PS)","TSEigenleistungArt_TELESKOPLADER":"Teleskoplader (inkl. Anbaugerät)","TSEigenleistungArt_KLEINBAGGER_1_5T_BIS_3T":"Kleinbagger 1.5t bis 3t","TSEigenleistungArt_KLEINBAGGER_3_5T_BIS_6T":"Kleinbagger 3.5t bis 6t","TSEigenleistungArt_KLEINBAGGER_7T_BIS_10T_SCHREITBAGGER":"Kleinbagger 7t bis 10t / Schreitbagger","TSEigenleistungArt_RAUPENKARETTE":"Raupenkarette","TSEigenleistungArt_RAUPENTRANSPORTER_1_5T_BIS_4T":"Raupentransporter 1.5t bis 4t","TSEigenleistungArt_TREIBSTOFF":"Kleingeräte (Effektiver Treibstoffverbrauch pro Liter)","TSEigenleistungArt_TRAKTOR_SUB44KW":"Traktor 30 bis 44 kW (41 - 60 PS)","TSEigenleistungArt_TRAKTOR_SUB74KW":"Traktor 45 bis 73 kW (61 - 100 PS)","TSEigenleistungArt_TRAKTOR_AB74KW":"Traktor über 74 kW (ab 100 PS)","TSEigenleistungArt_TRAKTOR_AB74KW_KIPPER":"Traktor über 74 kW (über 100 PS) mit hydr. Kipper","TSEigenleistungArt_TRAKTOR":"Traktor über 44 kW (ab 61 PS)","TSEigenleistungArt_TRAKTOR_4WD_SUB44KW":"Traktor, 4-Radantrieb 30 bis 44 kW (41 - 60 PS)","TSEigenleistungArt_TRAKTOR_4WD":"Traktor, 4-Radantrieb über 44 kW (ab 61 PS)","TSEigenleistungArt_TRANSPORTER":"Transporter mit Brücke","TSEigenleistungArt_TRANSPORTER_KIPPBRUECKE":"Transporter über 74 kW (über 100 PS) mit Kippbrücke","TSEigenleistungArt_ANHAENGER":"Anhänger zu Traktor/Transporter","TSEigenleistungArt_FRONTLADER":"Frontlader mit Erdschaufel","TSEigenleistungArt_HECKSCHAUFEL_PLANIERSCHILD":"Heckschaufel / Planierschild","TSEigenleistungArt_ANBAUSEILWINDE":"Anbauseilwinde","TSEigenleistungArt_HOLZ":"Holz aus eigenem Bestand pro m3","TSEigenleistungArt_HOLZ_AUF_PLATZ":"Holz aus eigenem Wald pro m3 auf Platz geliefert","TSEigenleistungArt_BAGGER_1500":"Bagger bis 1.5t","TSEigenleistungArt_BAGGER_BIS5000":"Bagger 2t bis 5t","TSEigenleistungArt_BAGGER_AB5000":"Bagger ab 5-6t","TSEigenleistungArt_RAUPENTRANSPORTER":"Raupentransporter","TSEigenleistungArt_KETTENSAEGE":"Kettensäge","TSEigenleistungArt_ANDERE":"Andere","TSLeistugnsart_MATERIAL":"Material","TSLeistugnsart_UNTERNEHMERRECHNUNG":"Unternehmerrechnung","TSLeistugnsart_MIETE":"Miete","TSLeistugnsart_OFFERTE":"Offerte","TSLeistugnsart_HOLZ":"Holz","TSLeistugnsart_PAUSCHAL":"Schätzung pauschal","TSRole_SUPER_ADMIN":"Superadmin","TSRole_FONDSSUISSE_ADMIN":"fondssuisse Admin","TSRole_FONDSSUISSE_SACHBEARBEITER":"fondssuisse Sachbearbeiter","TSRole_KANTON_VERWALTER":"Kanton Verwalter","TSRole_KANTON_INSPEKTOR":"Kanton Experte","TSRole_ANLAUFSTELLE_SACHBEARBEITER":"Anlaufstelle Sachbearbeiter","TSRole_ANLAUFSTELLE_VERWALTER":"Anlaufstelle Verwalter","TSRole_ANLAUFSTELLE_SCHAETZER":"Anlaufstelle Schätzer","TSRole_BETROFFENER":"Betroffene","BETROFFENE":"Betroffene","TSRole_UNASSIGNED_ROLE":"N/A","TSVorleistungArt_HAGELVERSICHERUNG":"Hagelversicherung","TSVorleistungArt_GEBAEUDEVERSICHERUNG":"Gebäudeversicherung","TSVorleistungArt_PRIVATVERSICHERUNG":"Privatversicherung","TSVorleistungArt_SUBVENTION":"Subventionen","TSVorleistungArt_SPENDE":"Spende","TSVorleistungArt_ANDERE":"Andere","TOTAL_EIGENLEISTUNGEN":"Total Aufwände zu Lasten des Gesuchstellers CHF {{totalel | number : 0}}","NEU":"Neues Gesuch (Online)","NEU_PAPIER_ANLAUFSTELLE":"Neues Gesuch (Papier)","NEU_PAPIER_FS":"Neues Gesuch (Papier; FS)","IMPORTIERT":"Importiert","IN_BEARBEITUNG_ANLAUFSTELLE":"In Bearbeitung bei Anlaufstelle","IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS":"In Bearbeitung bei fondssuisse für Ablehnung","AUFTRAG_SCHAETZER":"Auftrag Schätzer","SCHAETZUNG_DURCHGEFUEHRT":"Schätzung abgeschlossen","IN_BEARBEITUNG_FS":"In Bearbeitung bei fondssuisse","INAKTIV":"inaktiv","UEBERPRUEFUNG_ANLAUFSTELLE":"Überprüfung bei Anlaufstellen","UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS":"Überprüfung bei fondssuisse für Ablehnung","UEBERPRUEFUNG_FONDSSUISSE":"Überprüfung bei fondssuisse","WIEDERHERSTELLUNG":"Wiederherstellung","UEBERPRUEFUNG_SCHAETZER":"Überprüfung bei Schätzer","SCHADEN_BEHOBEN_ABRECHNEN":"Schaden behoben, abrechnen.","ABGELEHNT_ANLAUFSTELLE":"Abgelehnt durch Anlaufstelle","ABGELEHNT_FONDSSUISSE":"Abgelehnt durch fondssuisse","EIGENLEISTUNG_LOESCHEN":"Wollen Sie die Eigenleistung wirklich löschen?","EIGENLEISTUNG_BETRAG_BERECHTIGT":"Ber. Betrag","SCHADEN_BEHOBEN":"Schaden behoben","ABRECHNEN":"Abrechnen","AUSZAHLUNG":"Bereit zur Auszahlung","ABGESCHLOSSEN":"Abgeschlossen","IMPORTIERT_VERSICHERUNG":"Importierter Versicherungsfall - ","IMPORTIERT_FONDSSUISSE":"Importierter Fall - ","ABGELEHNT":"Abgelehnt","GRUNDEIGENTUEMER":"Grundeigentümer","PAECHTER":"Pächter","GENOSSENSCHAFT":"Genossenschaft","TSEigentumsverhaeltnis_PAECHTER":"Pächter","TSEigentumsverhaeltnis_GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER":"Grundeigentümer als Selbstbewirtschafter","TSEigentumsverhaeltnis_GRUNDEIGENTUEMER":"Grundeigentümer mit Pächter","ANDERE_KOERPERSCHAFT":"andere Körperschaft","NATUERLICHE_PERSON":"Natürliche Person","MEHRPERSONENGESELLSCHAFT":"Mehrpersonengesellschaft","MEINE_SCHADENFAELLE":"Meine Schadenfälle","NICHT_ZUGETEILT":"Nicht zugeteilt","OFFENE":"Offene","ABGESCHLOSSENE":"Abgeschlossene","FALL":"Fall","GESUCHSTELLER":"Gesuchsteller","EREIGNIS":"Ereignis","ANLAUFSTELLE":"Anlaufstelle","ORT":"Ort","DATUM":"Datum","STATUS":"Status","DECKBLATT":"PDF","VERANTWORTLICHER":"Verantwortlicher","EIGENTUMSVERHAELTNISSE_GESUCHSTELLER":"Eigentumsverhältnisse Gesuchsteller","EIGENTUMSVERHAELTNISSE_VERSICHERTER":"Eigentumsverhältnisse Versicherter","EIGENTUMSVERHAELTNISSE_TITLE":"Eigentumsverhältnisse","KONTAKTANGABEN_GESUCHSTELLER":"Kontaktangaben Gesuchsteller","KONTAKTANGABEN_TITLE":"Kontaktangaben","KORRESPONDENZSPRACHE":"Korrespondenzsprache","SPRACHE":"Sprache","VORNAME":"Vorname","NAME":"Name","STRASSE":"Strasse","PLZ":"PLZ","EMAIL":"E-Mail","INIVTATION_EMAIL":"E-Mail der hinzuzufügenden Person","EMAIL_VERIFIED":"Ihr Benutzerkonto wurde freigeschaltet. Sie können sich nun einloggen.","ADRESSE_STRASSE":"Strasse","ADRESSE_HAUSNUMMER":"Hausnummer","ADRESSE_PLZ":"PLZ","ADRESSE_ORT":"Ort","ADRESSE_ZUSATZ":"Adresszusatz","ADRESSE_1":"Adresse 1","ADRESSE_2":"Adresse 2","ADRESSE_3":"Adresse 3","TELEFON":"Telefon (Mobil- oder Festnetz)","ANREDE":"Anrede","HERR":"Herr","FRAU":"Frau","FINANZIELLE_VERHAELTNISSE":"Finanzielle Verhältnisse","STEUERJAHR":"Steuerjahr","STEUERBARES_EINKOMMEN":"Steuerbares Einkommen","STEUERBARES_VERMOEGEN":"Steuerbares Vermögen","GEWINN":"Gewinn","KAPITAL":"Kapital","ZUSTIMMUNG_STEUERPRUEFUNG":"Ich ermächtige die Gemeinde / den Kanton die Steuerfaktoren zu kontrollieren resp. im Gesuch an fondssuisse zu ergänzen und im Schaden-Portal zu speichern.","ZUSTIMMUNG_PRUEFUNG_FONDSUISSE":"Ich bin einverstanden, dass Angaben und Informationen im Zusammenhang mit dem Beitragsgesuch durch alle beteiligten Stellen/Ämter eingeholt, geprüft und an fondssuisse weitergegeben werden.","ZUSTIMMUNG_PRUEFUNG_FONDSUISSE_GENOSSENSCHAFT":"Wir sind einverstanden, dass Angaben und Informationen im Zusammenhang mit dem Beitragsgesuch durch alle beteiligten Stellen/Ämter eingeholt, geprüft und an fondssuisse weitergegeben werden.","BANKANGABEN":"Bankangaben","KONTAKTANGABEN_EIGENTUEMER":"Kontaktangaben Eigentümer","NEUER_SCHADENFALL":"Neuer Schadenfall","ANGABEN_ZUR_GENOSSENSCHAFT":"Angaben zur Genossenschaft","ANGABEN_ZUR_GESELLSCHAFT":"Angaben zur Gesellschaft","ANGABEN_ZUR_TITLE":"Angaben zur {{title}}","KONTAKTANGABEN_GENOSSENSCHAFT":"Kontaktangaben Genossenschaft","KONTAKTANGABEN_KOERPERSCHAFT":"Kontaktangaben Körperschaft","STEUERPFLICHT_GESELLSCHAFT":"Die Gesellschaft ist steuerpflichtig","NICHT_STEUERPFLICHT_GESELLSCHAFT":"Die Gesellschaft ist nicht steuerpflichtig","STEUERPFLICHT_GENOSSENSCHAFT":"Die Genossenschaft ist steuerpflichtig","NICHT_STEUERPFLICHT_GENOSSENSCHAFT":"Die Genossenschaft ist nicht steuerpflichtig","GENOSSENSCHAFT_NAME":"Name der Genossenschaft","GESELLSCHAFT_NAME":"Name der Gesellschaft","ANGABEN_ZUR_KOERPERSCHAFT":"Angaben zur Körperschaft","ART_DER_KOERPERSCHAFT":"Art der Körperschaft","EINZELNE_STEUERPLICHTGE_PERSONEN":"Die Körperschaft besteht aus einzelnen, steuerpflichtigen Personen.","KOLLEKTIVE_STEUERPFLICHT":"Die Körperschaft ist ein Kollektiv und ist steuerpflichtig.","KOERPERSCHAFT_NICHT_STEUERPFLICHTIG":"Die Körperschaft ist nicht steuerpflichtig.","MINIMAL_SCHADEN":"Aufgrund der Einkommens- und Vermögensverhältnisse werden Abzüge vom Schaden berechnet. Ihr Abzug beträgt CHF {{abzug}}.-","MINIMAL_SCHADEN_EINKOMMEN":"Bei Einkommen über 200'000.- entfällt der Anspruch auf Entschädigung.","MINIMAL_SCHADEN_VERMOEGEN":"Bei Vermögen über 2'000'000.- entfällt der Anspruch auf Entschädigung.","MINIMAL_SCHADEN_VERMOEGEN_2026":"Bei Vermögen über 2'500'000.- entfällt der Anspruch auf Entschädigung.","FRUEHERER_SCHADENFALL":"Ich habe früher bereits einen Schadenfall gemeldet.","FRUEHERER_SCHADENFALL_PAPIER":"Hat der Betroffene bereits früher einen Schadenfall gemeldet?","DAS_GESUCH":"Der Schaden","DIE_SCHAETZUNG":"Die Schätzung","DIE_AUFWAENDE":"Die Aufwände","SCHADENEREIGNIS":"Schadenereignis","SCHADENORT":"Schadenort (Gemeinde)","START_TYPING":"Für Vorschläge beginnen Sie zu tippen.","NEUER_SCHADEN":"Neuer Schaden","DIE_SCHAEDEN":"Die Schäden","SCHADEN_NAME":"Schaden an {{objekt}} vom {{datum}}","BEITRAG_READONLY":"Beitrag {{art}} vom {{datum}}","SCHADEN":"Schaden","GENAUER_ORT":"Genauer Ort des Schadens","VERSICHERUNG_VORHANDEN":"Ich habe eine Versicherung für diese Parzelle.","VERSICHERUNG_GEMELDET":"Ich habe meiner Versicherung den Schaden bereits gemeldet.","DATUM_STICHTAG":"Schadendatum","PARZELLENNUMMER":"Parzellen Nr.","ART_DES_SCHADENDS":"Art des Schadens","SCHADEND_OBJEKT":"Geschädigtes Objekt","SCHADEN_VORGESEHENE_MASSNAHMEN":"Kurzbeschreibung, vorgesehene Massnahmen","ERROR_NO_SCHADEN_VORGESEHENE_MASSNAHMEN":"Keine Kurzbeschreibung, vorgesehene Massnahmen erfasst","BESCHRIEB":"Beschrieb","GESCHAETZTE_KOSTEN":"Geschätzte Kosten in CHF","GESCHAETZTER_MEHRWERT":"Geschätzter Mehrwert / Abzug nicht anrechenbar [%]","BERECHNUNGSDETAIL_ANSCHAUEN":"Berechnungsdetail anschauen","HINZUFUEGEN":"Anhang hinzufügen","LABEL_JA":"ja","LABEL_OK":"OK","LABEL_NEIN":"nein","FILE_LOESCHEN":"Wollen Sie das Dokument wirklich löschen?","FILE_ZU_GROSS":"Datei zu gross. Maximale Dateigrösse beträgt 10MB.","FILETYPE_NICHT_ERLAUBT":"Dieser Dateityp ist nicht erlaubt.","SCHADEN_HINZUFUEGEN":"Schaden hinzufügen","SCHADEN_ERSTELLEN":"Schaden hinzufügen","NUR_EIN_SCHADEN":"Es kann nur ein Schaden erfasst werden","SCHADEN_LOESCHEN":"Schaden löschen","SCHADEN_SPEICHERN":"Schaden speichern","SCHADENFALL_LOESCHEN":"Schadenfall löschen","SCHADENFALL_LOESCHEN_TEXT":"Wollen Sie den Schadenfall löschen? Dies kann nicht mehr rückgängig gemacht werden.","SCHADENFALL_BEENDEN_SPEICHERN_TEXT":"Achtung! Das Gesuch wird gespeichert, ist jedoch nicht abgeschickt und eingereicht. Dazu klicken Sie bitte auf „Gesuch absenden“.","SCHADENFALL_BEENDEN_SPEICHERN_TITLE":"Schadenfall speichern?","BERECHNUNGSDETAIL":"Berechnungsdetail","BERECHNUNGSDETAIL_EXPLANATION":"Hinweis:\n Liegt das Schadendatum vor dem 1. Mai 2026, gelten abweichende Berechnungsregeln. Sobald das massgebende Schadendatum vorliegt, werden die Abzüge automatisch gemäss den für dieses Schadendatum gültigen Regelungen neu berechnet und aktualisiert. \n \n Aufgrund Ihrer Angaben zur finanziellen Situation kommt folgendes Berechnungsschema zur Anwendung:","BERECHNUNGSDETAIL_TOTAL":"Total Abzüge","IHRE_ANGABEN":"Ihre Angaben","EINKOMMEN":"Einkommen","VERMOEGEN":"Vermögen","VORLEISTUNGEN":"Vorleistungen","VORLEISTUNG_ART":"Art/Typ","VORLEISTUNG_POLICE_NR":"Police Nr.","VORLEISTUNG_LOESCHEN":"Wollen Sie diese Vorleistung wirklich löschen?","SCHADENMINIMUM":"Ermittelter Schaden im Minimum","MINDESTAUSZAHLUNG":"Mindestauszahlung","ABZUEGE_EINKOMMEN":"Abzüge Einkommen","ABZUEGE_VERMOEGEN":"Abzüge Vermögen","BILDER_DOKUMENTE":"Bilder & Dokumente","BILDER_DOKUMENTE_WIEDERHERSTELLUNG":"Bilder & Dokumente zur Wiederherstellung","UPLOAD_TEXT":"Laden Sie hier bitte Fotos, Berichte und Offerten hoch.","KULTURLAND":"Kulturland","OBSTBAUM_REBSTOECKE":"Obstbäume, Rebstöcke","STRASSEN_WEGE":"Strassen, Wege","BRUECKEN_DURCHLAESSE":"Brücken, Durchlässe","UFER_BACHBAUTEN":"Ufer, Bachbauten","STUETZMAUER_REBMAUERN":"Stützmauer, Rebmauern","STEUERDATEN_GEPRUEFT":"Die Finanzangaben des Gesuchstellers sind überprüft und ev. korrigiert/ergänzt.","HAUSUMSCHWUNG":"Hausumschwung","EINFRIEDUNG":"Einfriedung","LEITUNGEN_AUSSERHALB_DER_GEBAEUDE":"Leitungen ausserhalb der Gebäude","WALD":"Wald","KULTURART":"Kulturart","FLAECHE_ARE":"betroffene Fläche (Aren)","HOLZ_MENGE":"Holzmenge (m3)","FLAECHE_M2":"Fläche (m2)","ANZAHL":"Anzahl","SORTE":"Sorte","ALTER":"Alter (ca.)","LETZTEINSTANDSTELLUNG":"letzte Instandstellung (Jahr)","LAENGE":"Länge (m)","BREITE":"Breite (m)","HOEHE":"Höhe (m)","KOORDINATEN":"Koordinaten","BAUART":"Bauart","SCHADEN_MATERIAL":"Material (m3)","ART":"Art","AUFWAENDE":"Aufwände","SCHADENFALL":"Schadenfall","ZURUECK":"zurück","SCHAETZUNG":"Schätzung","EIGENLEISTUNGEN":"Eigenleistungen","EIGENLEISTUNG":"Eigenleistung","TOTAL":"Total","OFFERTEN":"Offerten","FREMDKOSTEN":"Fremdkosten","BEZEICHNUNG":"Bezeichnung","POSITION_AUF_KARTE":"Position auf Karte","SET_MARKER":"Bitte markieren Sie den genauen Schadenort auf der Karte.","SET_MARKER_READONLY":"Schadenort auf der Karte (kann nicht editiert werden)","CREATE_PROFIL":"Benutzerprofil erstellen","IHR_ABZUG":"Ihr Abzug","MAP_HELPTEXT":"Um mehr Details auf der Karte anzuzeigen, zoomen Sie die Karte heran. Um die Schadenposition zu markieren kann durch klicken in der Karte ein Marker gesetzt werden.","SCHADENFALL_STATUS_CHANGED":"Status hat geändert","SCHADENFALL_CREATED":"Schadenfall wurde im System erstellt.","SYSTEM_MELDUNG":"Meldung durch System","BEMERKUNGEN":"Bemerkungen","BEMERKUNG":"Bemerkung","BEMERKUNG_ERFASSEN":"Bemerkung speichern","BEMERKUNG_UPDATE":"Bemerkung aktualisieren","NEUE_BEMERKUNG_ERFASSEN":"neue Bemerkung erfassen","BEMERKUNG_REMOVE":"Wollen Sie die Bemerkung wirklich löschen?","MITTEILUNGEN_NOCH_KEINE":"Es wurden noch keine Bemerkungen erfasst.","STATUS_CHANGE_HISTORY":"Die Sachbearbeiter","ABBRECHEN":"abbrechen","AUSFUEHREN":"Ausführen","FREIGABE_BEMERKUNG_TEXT":"Der Schadenfall erfüllt alle Kriterien. Akzeptieren und zur Wiederherstellung an den Gesuchsteller freigeben.","FREIGABE_BEMERKUNG_GESUCHSTELLER_TEXT":"Wenn Sie den Schadenfall freigeben, wird er zur weiteren Bearbeitung an die zuständige Anlaufstelle weitergegeben. Sie können danach keine Änderungen mehr vornehmen. Wollen Sie wirklich freigeben?","FREIGABE_BEMERKUNG_ANLAUFSTELLE_TEXT":"Sie geben das Gesuch frei. Danach ist das Gesuch in Ihrer Schadenfallliste zu finden.","BEGRUENDUNG":"Begründung","STATUSUEBERGANG_VON":"Statusübergang von","NACH":"nach","TSBegruendungsCode_BG_1_kurz":"Gesuch berücksichtigen","TSBegruendungsCode_BG_1_lang":"Gesuch berücksichtigen","TSBegruendungsCode_BG_10_kurz":"bezahlt","TSBegruendungsCode_BG_10_lang":"bezahlt","TSBegruendungsCode_BG_11_kurz":"Akontozahlung, Rest nach Abrechnung.","TSBegruendungsCode_BG_11_lang":"Akontozahlung. Die restliche Entschädigung wird nach Vorliegen der Abrechnung ausbezahlt.","TSBegruendungsCode_BG_12_kurz":"Teil durch Schweiz. Hagelversicherung gedeckt","TSBegruendungsCode_BG_12_lang":"Ein Teil des Schadens wurde durch die Schweiz. Hagel-Versicherungs-Gesellschaft gedeckt.","TSBegruendungsCode_BG_13_kurz":"Teil durch Versicherungsleistungen gedeckt","TSBegruendungsCode_BG_13_lang":"Ein Teil des Schadens ist durch Versicherungsleistungen gedeckt.","TSBegruendungsCode_BG_14_kurz":"Reduzierte Entschädigung, z.T. versicherbar","TSBegruendungsCode_BG_14_lang":"Reduzierte Entschädigung, es handelt sich um einen zum Teil versicherbaren Schaden.","TSBegruendungsCode_BG_15_kurz":"Entsch. zugunsten Pächter, Rest z.L. Eigentümer","TSBegruendungsCode_BG_15_lang":"Entschädigung zugunsten des Pächters. Der restliche Schaden muss unseres Erachtens vom Eigentümer übernommen werden.","TSBegruendungsCode_BG_16_kurz":"Nicht alle Beteiligten beitragsberechtigt","TSBegruendungsCode_BG_16_lang":"Aufgrund unserer Richtlinien können nicht alle Beteiligten bezw. Perimeterpflichtigen berücksichtigt werden.","TSBegruendungsCode_BG_17_kurz":"Ausnahme, Abzug E/V würde Beitrag ausschliessen","TSBegruendungsCode_BG_17_lang":"Berücksichtigung im Sinne einer Ausnahme, da aufgrund des Einkommens und/oder Vermögens kein Beitrag gewährt werden könnte.","TSBegruendungsCode_BG_18_kurz":"Ausnahme,    Schaden in Zukunft nicht mehr berücks.","TSBegruendungsCode_BG_18_lang":"Im Sinne einer Ausnahme, in Zukunft werden derartige Schäden nicht mehr berücksichtigt.","TSBegruendungsCode_BG_19_kurz":"Ausnahme ohne Präjudiz für künftige ähnl. Fälle","TSBegruendungsCode_BG_19_lang":"Im Sinne einer Ausnahme und ohne Präjudiz für künftige ähnliche Fälle.","TSBegruendungsCode_BG_20_kurz":"Nicht beitragsberechtigte Schäden","TSBegruendungsCode_BG_20_lang":"Nicht beitragsberechtigter Schaden.","TSBegruendungsCode_BG_21_kurz":"Ausser Betracht fallende Schäden","TSBegruendungsCode_BG_21_lang":"Ausser Betracht fallende Schäden (\"Richtlinien\" Art. 11 bis 13).","TSBegruendungsCode_BG_22_kurz":"Versicherbare Schäden","TSBegruendungsCode_BG_22_lang":"Es handelt sich um einen versicherbaren Schaden (\"Richtlinien\" Art. 11).","TSBegruendungsCode_BG_23_kurz":"Unbedeutende Schäden (keine WH oder durch Dritte)","TSBegruendungsCode_BG_23_lang":"Der Schaden ist unbedeutend (es wurden keine Wiederherstellungsarbeiten ausgeführt) oder er wurde durch Dritte behoben.","TSBegruendungsCode_BG_24_kurz":"Nicht durch Elementarereignis oder Dritte verurs.","TSBegruendungsCode_BG_24_lang":"Der Schaden wurde nicht durch ein Elementarereignis oder durch Dritte verursacht.","TSBegruendungsCode_BG_25_kurz":"Durch andere Beiträge oder Versicherung gedeckt","TSBegruendungsCode_BG_25_lang":"Der Schaden wird durch Subventionen oder andere Beiträge gedeckt.","TSBegruendungsCode_BG_26_kurz":"Künstl. Erdbewegungen/menschl. Einwirkung","TSBegruendungsCode_BG_26_lang":"Schaden infolge künstlicher Erdbewegungen, mangelhafter Anlagen, vernachlässigtem Unterhalt oder anderer direkter oder indirekter menschlicher Einwirkung.","TSBegruendungsCode_BG_27_kurz":"Schaden an im Bau befindlichen Kunstbauten","TSBegruendungsCode_BG_27_lang":"Schaden an im Bau befindlichen Kunstbauten.","TSBegruendungsCode_BG_28_kurz":"In kurzen Zeitabständen wiederkehrender Schaden","TSBegruendungsCode_BG_28_lang":"In kurzen Zeitabständen wiederkehrender Schaden (\"Richtlinien\" Art. 12, Absatz 3).","TSBegruendungsCode_BG_29_kurz":"Voraussehbarer Schaden","TSBegruendungsCode_BG_29_lang":"Der Schaden war voraussehbar, er hätte durch rechtzeitige zumutbare Massnahmen verhindert werden können (mangelhafter Unterhalt oder mangelnde Sorgfalt).","TSBegruendungsCode_BG_30_kurz":"Fortgesetzte Einwirkung","TSBegruendungsCode_BG_30_lang":"Nicht auf eine Einwirkung von aussergewöhnlicher Heftigkeit oder auf fortgesetzte Einwirkung zurückzuführender Schaden.","TSBegruendungsCode_BG_31_kurz":"Tierische oder pflanzliche Schädlinge","TSBegruendungsCode_BG_31_lang":"Durch tierische oder pflanzliche Schädlinge verursachter Schaden.","TSBegruendungsCode_BG_32_kurz":"Schneedruck, Hagel, Feuer am Wald","TSBegruendungsCode_BG_32_lang":"Durch Schneedruck, Hagel oder Feuer am Wald entstandene Schäden fallen ausser Betracht (\"Richtlinien\" Art. 12, Absatz 7).","TSBegruendungsCode_BG_33_kurz":"Einzelne Waldbäume werden nicht entschädigt","TSBegruendungsCode_BG_33_lang":"Einzelne Waldbäume werden nicht entschädigt.","TSBegruendungsCode_BG_34_kurz":"Dürre, Nässe (Kanalisationsrückstau), Frost","TSBegruendungsCode_BG_34_lang":"Schäden infolge Dürre, Nässe (Kanalisationsrückstau) oder Frost können nicht berücksichtigt werden. (\"Richtlinien\" Art. 12)","TSBegruendungsCode_BG_35_kurz":"Abschwemmen von Kies an Strassen und Plätzen","TSBegruendungsCode_BG_35_lang":"Abschwemmen von Kies an Strassen und Plätzen wird nicht entschädigt.","TSBegruendungsCode_BG_36_kurz":"Allg. Wertverminderung/Lohn- und Verdienstausfall","TSBegruendungsCode_BG_36_lang":"Die allgemeine Wertverminderung eines Grundstückes oder Lohn- und Verdienstausfälle, die mit einem Schadenereignis in Zusammenhang stehen, können nicht entschädigt werden.","TSBegruendungsCode_BG_37_kurz":"Normaler Unterhalt/rein vorsorglich","TSBegruendungsCode_BG_37_lang":"Normaler Unterhalt oder rein vorsorgliche Massnahmen können nicht unterstützt werden.","TSBegruendungsCode_BG_38_kurz":"Ersetzt durch eine andere Schadenmeldung","TSBegruendungsCode_BG_38_lang":"Ersetzt durch eine andere Schadenmeldung.","TSBegruendungsCode_BG_39_kurz":"Nach Ablauf der Anmeldefrist von 3 Mt.eingereicht","TSBegruendungsCode_BG_39_lang":"Die Schadenmeldung wurde nach Ablauf der Anmeldefrist von 3 Monaten eingereicht (\"Richtlinien\" Art. 16).","TSBegruendungsCode_BG_40_kurz":"Nicht beitragsberechtigter Geschädigter","TSBegruendungsCode_BG_40_lang":"Nicht beitragsberechtigter Geschädigter (\"Richtlinien\" Art. 7).","TSBegruendungsCode_BG_41_kurz":"Abzug E/V grösser als ermittelter Schaden","TSBegruendungsCode_BG_41_lang":"Der zu verrechnende Abzug wegen Einkommen und/oder Vermögen übersteigt den ermittelten Schadenbetrag (\"Richtlinien\" Art. 23).","TSBegruendungsCode_BG_42_kurz":"Wegen zu hohem E/V nicht beitragsberechtigt","TSBegruendungsCode_BG_42_lang":"Wegen zu hohem Einkommen und/oder Vermögen nicht beitragsberechtigt (Richtlinien Art. 23).","TSBegruendungsCode_BG_45_kurz":"Nicht beitragsber., wir entschädigen Pächter","TSBegruendungsCode_BG_45_lang":"Nicht beitragsberechtigt, wir entschädigen den Pächter.","TSBegruendungsCode_BG_46_kurz":"Schaden muss vom Eigentümer übernommen werden","TSBegruendungsCode_BG_46_lang":"Der Schaden muss vom Eigentümer übernommen werden.","TSBegruendungsCode_BG_47_kurz":"Abr./Unterl. innerhalb gesetzter Frist nicht erh.","TSBegruendungsCode_BG_47_lang":"Wir haben die Abrechnung innerhalb der gesetzten Frist nicht erhalten.","TSBegruendungsCode_BG_48_kurz":"Schaden erreicht nicht Minimalbetrag","TSBegruendungsCode_BG_48_lang":"Der Schaden erreicht nicht den Minimalbetrag (\"Richtlinien\" Art. 22).","TSBegruendungsCode_BG_49_kurz":"abgeschrieben","TSBegruendungsCode_BG_49_lang":"Die auf 100 % Schädigungsgrad umgerechnete Schadenfläche ist kleiner als 25 Aren.","TSBegruendungsCode_BG_50_kurz":"Steuerfaktoren fehlen","TSBegruendungsCode_BG_50_lang":"Wir benötigen die Steuerfaktoren (Einkommen und Vermögen, nach Sozialabzügen).","TSBegruendungsCode_BG_52_kurz":"Nur Steuerausscheidung/benötigen Faktoren Domizil","TSBegruendungsCode_BG_52_lang":"Es wurde nur die Steuerausscheidung angegeben. Wir benötigen die Steuerfaktoren des Domizils.","TSBegruendungsCode_BG_54_kurz":"Namen/Steuerfaktoren der einzelnen Geschwister","TSBegruendungsCode_BG_54_lang":"Wir benötigen die Namen sowie die Steuerfaktoren der einzelnen Geschwister.","TSBegruendungsCode_BG_55_kurz":"Namen/Steuerfaktoren der einzelnen Erben","TSBegruendungsCode_BG_55_lang":"Wir benötigen die Namen sowie die Steuerfaktoren der einzelnen Erben.","TSBegruendungsCode_BG_56_kurz":"Steuerfaktoren der Erben oder des Nutzniessers","TSBegruendungsCode_BG_56_lang":"Wir benötigen die Steuerfaktoren der einzelnen Erben oder des Nutzniessers, wenn dieser den Schaden allein zu tragen hat.","TSBegruendungsCode_BG_57_kurz":"Steuerfaktoren der einzelnen Beteiligten","TSBegruendungsCode_BG_57_lang":"Wir benötigen die Steuerfaktoren der einzelnen Beteiligten/Perimeterpflichtigen.","TSBegruendungsCode_BG_58_kurz":"Faktoren melden, wenn neue Veranl. rechtskräftig","TSBegruendungsCode_BG_58_lang":"Bitte Steuerfaktoren melden, sobald die neue Veranlagung rechtskräftig ist.","TSBegruendungsCode_BG_59_kurz":"Steuerfaktoren vertauscht eingetragen?","TSBegruendungsCode_BG_59_lang":"Unseres Erachtens wurden die Steuerfaktoren in der Schadenanzeige vertauscht eingetragen. Bitte neu melden.","TSBegruendungsCode_BG_62_kurz":"Benötigen approx. Schadenschätzung","TSBegruendungsCode_BG_62_lang":"Wir benötigen eine approximative Schadenschätzung gemäss Art. 18 der \"Richtlinien\" (detaillierte Beschreibung des Schadens, evtl. Skizze oder Fotos, mutmassliche Instandstellungkosten).","TSBegruendungsCode_BG_66_kurz":"Subventionsprojekt, erwarten Schlussabrechnung","TSBegruendungsCode_BG_66_lang":"Subventionsprojekt. Nach Beendigung der Arbeiten erwarten wir die Schlussabrechnung. Wenn die Restkosten von mehreren Beteiligten übernommen werden müssen, ist der Kostenverteiler beizulegen.","TSBegruendungsCode_BG_69_kurz":"Muss durch Forstdienst behandelt werden","TSBegruendungsCode_BG_69_lang":"Der Schaden muss durch den Forstdienst behandelt werden. Es werden nur noch Härtefälle berücksichtigt (wenn die Rüst- und Aufräumungskosten durch Subventionen und Holzerlös nicht gedeckt werden können).","TSBegruendungsCode_BG_70_kurz":"Benötigen Abrechnung mit Belegen","TSBegruendungsCode_BG_70_lang":"Zur Festsetzung der Entschädigung benötigen wir nach Ausführung der Arbeiten eine detaillierte Abrechnung: Eigenleistungen, Fremdkosten, Vorleistungen; inklusive Kopien von Rechnungen und Zahlungsbelegen. Diese Angaben und Dokumente erfassen Sie bitte im Menüpunkt \"Aufwände\" und laden dazu die nötigen Dokumente hoch. Wenn die Restkosten von mehreren Beteiligten übernommen werden müssen, laden Sie bitte auch ein Dokument mit dem entsprechenden Kostenverteiler hoch. Bei Subventionsprojekten benötigen wir zudem die Beitragszusicherung und die Beitragsabrechnung. Die Instandstellungsarbeiten sollten soweit zumutbar und sinnvoll, mit betriebseigenen Mitteln ausgeführt werden. Zusätzliche Informationen: www.fondssuisse.ch","TSBegruendungsCode_BG_71_kurz":"Benötigen Rechnungen/Zahlungsbelege","TSBegruendungsCode_BG_71_lang":"Zur Festsetzung der Entschädigung benötigen wir die quittierten Unternehmer- und/oder Materialrechnungen resp. die Zahlungsbelege der Rechnung.","TSBegruendungsCode_BG_72_kurz":"Benötigen Abrechnung (Eigenleistung, Fremdkosten","TSBegruendungsCode_BG_72_lang":"Zur Festsetzung der Entschädigung benötigen wir eine detaillierte Abrechnung über die ausgeführten Instandstellungsarbeiten: Liste der Handarbeits- und Maschinenstunden, Kopien von Rechnungen und Zahlungsbelegen. Informationen und Formular \"Stundenrapport\": www.fondssuisse.ch","TSBegruendungsCode_BG_73_kurz":"Benötigen Subventionsabrechnung","TSBegruendungsCode_BG_73_lang":"Zur Festsetzung der Entschädigung benötigen wir eine detaillierte Abrechnung mit Belegen: Gesamtkosten / Subventionen von Bund, Kanton und/oder Gemeinde / Restkosten zulasten der Beteiligten.","TSBegruendungsCode_BG_74_kurz":"Benötigen Abrechnung der Hagelversicherung","TSBegruendungsCode_BG_74_lang":"Zur Festsetzung der Entschädigung benötigen wir eine detaillierte Abrechnung (Gesamtkosten und Leistung der Hagelversicherung, Abrechnung der Hagelversicherung bitte ebenfalls beilegen).","TSBegruendungsCode_BG_75_kurz":"Wir erwarten die Abrechnung.","TSBegruendungsCode_BG_75_lang":"Wir erwarten die Abrechnung.","TSBegruendungsCode_BG_76_kurz":"Benötigen Wiederherstellungs-Offerte","TSBegruendungsCode_BG_76_lang":"Wir bitten Sie, uns eine Wiederherstellungsofferte zukommen zu lassen.","TSBegruendungsCode_BG_79_kurz":"Beitr. kann nicht festgelegt werden, Abklärungen","TSBegruendungsCode_BG_79_lang":"Aufgrund der vorliegenden Angaben/Unterlagen kann die Entschädigung noch nicht festgelegt werden.","TSBegruendungsCode_BG_80_kurz":"Teil des Schadens durch Versicherung gedeckt?","TSBegruendungsCode_BG_80_lang":"Bitte abklären, ob zumindest ein Teil des Schadens duch Versicherungsleistungen gedeckt wird.","TSBegruendungsCode_BG_81_kurz":"Muss der Hagelversicherung gemeldet werden","TSBegruendungsCode_BG_81_lang":"Der Schaden muss der Hagelversicherung gemeldet werden.","TSBegruendungsCode_BG_82_kurz":"Muss der Mobiliarversicherung gemeldet werden.","TSBegruendungsCode_BG_82_lang":"Der Schaden muss der Mobiliarversicherung gemeldet werden.","TSBegruendungsCode_BG_83_kurz":"Muss der Gebäudeversicherung gemeldet werden","TSBegruendungsCode_BG_83_lang":"Der Schaden muss der Gebäudeversicherung gemeldet werden.","TSBegruendungsCode_BG_84_kurz":"Schaden durch Hagelversicherung gedeckt?","TSBegruendungsCode_BG_84_lang":"Wird der Schaden (mindestens teilweise) durch die Schweizerische Hagel-Versicherungs-Gesellschaft gedeckt?","TSBegruendungsCode_BG_85_kurz":"Wiederherstellung subventionierbar?","TSBegruendungsCode_BG_85_lang":"Werden die Wiederherstellungsarbeiten durch Bund, Kanton und/oder die Gemeinde subventioniert?","TSBegruendungsCode_BG_86_kurz":"Schaden Mel.amt melden, evtl. subventionierbar","TSBegruendungsCode_BG_86_lang":"Bitte den Schaden dem Meliorationsamt melden, die Wiederherstellungsarbeiten sind evtl. subventionierbar.","TSBegruendungsCode_BG_87_kurz":"U.E sollte sich Gemeinde an WHK beteiligen","TSBegruendungsCode_BG_87_lang":"Unseres Erachtens sollte sich die Gemeinde an den Wiederherstellungskosten beteiligen. Wir bitten um Ihre Stellungnahme.","TSBegruendungsCode_BG_90_kurz":"Teil z.L. Eigentümer, -> Steuerfaktoren melden","TSBegruendungsCode_BG_90_lang":"Wir haben das Gesuch geprüft und erwarten die Abrechnung. Max. anrechenbare Kosten 1'000.-.","TSBegruendungsCode_BG_91_kurz":"Teil z.L. Eigentümer, -> Name und Steuerfaktoren","TSBegruendungsCode_BG_91_lang":"Unseres Erachtens muss der Schaden mindestens teilweise vom Eigentümer übernommen werden. Wir bitten Sie, uns seinen Namen, die Adresse und die Steuerfaktoren anzugeben.","TSBegruendungsCode_BG_92_kurz":"Teil z.L. Eigentümer, -> Stellungnahme","TSBegruendungsCode_BG_92_lang":"Unseres Erachtens muss der Schaden mindestens teilweise vom Eigentümer übernommen werden (z.B. Unternehmerarbeiten, Verlust von Kulturland). Wir bitten um Ihre Stellungnahme.","TSBegruendungsCode_BG_93_kurz":"Frist 3 Monate für Abrechnung","TSBegruendungsCode_BG_93_lang":"Wir haben die Abrechnung bis heute nicht erhalten. Ohne Ihren Gegenbericht innert drei Monaten betrachten wir das Gesuch als erledigt.","TSBegruendungsCode_BG_95_kurz":"Wir erwarten Ihren Bericht","TSBegruendungsCode_BG_95_lang":"Wir erwarten Ihren Bericht.","TSBegruendungsCode_BG_98_kurz":"Zerst. Obstbäume -> Bestätigung Neupflanzung nötig.","TSBegruendungsCode_BG_98_lang":"Die zerstörten Obstbäume werden erst entschädigt, wenn die Neupflanzung erfolgt ist. Wir erwarten die entsprechende Bestätigung.","TSBegruendungsCode_BGN_10_kurz":"10 - Namen/Steuerfaktoren der einzelnen Beteiligten","TSBegruendungsCode_BGN_10_lang":"Wir benötigen die Namen sowie die Steuerfaktoren der einzelnen \n- Geschwister. \n- Erben. \n- Erben oder des Nutzniessers, wenn dieser den Schaden allein zu tragen hat. \n\nWir benötigen die Steuerfaktoren der einzelnen Beteiligten/Perimeterpflichtigen. \n\nBitte laden Sie die erwähnten Belege im Schaden-Portal hoch.","TSBegruendungsCode_BGN_11_kurz":"11 - Teil z.L. Eigentümer, Steuerfaktoren melden / Stellungnahme","TSBegruendungsCode_BGN_11_lang":"Unseres Erachtens muss der Schaden mindestens teilweise vom Eigentümer übernommen werden. Wir bitten Sie, uns seinen Namen, die Adresse und die Steuerfaktoren anzugeben. Bitte laden Sie die erwähnten Belege im Schaden-Portal hoch.\n\nUnseres Erachtens muss der Schaden mindestens teilweise vom Eigentümer übernommen werden (z.B. Unternehmerarbeiten, Verlust von Kulturland). Wir bitten um Ihre Antwort/Stellungnahme.","TSBegruendungsCode_BGN_12_kurz":"12 - Benötigen Kostenverteiler mit %-Anteilen","TSBegruendungsCode_BGN_12_lang":"Wir benötigen das Mitgliederverzeichnis mit den prozentualen Kostenanteilen der Beteiligten (Perimeterverzeichnis).\n\nWir benötigen die Statuten und… / …sowie die Statuten.\n\n… sowie bei geringer Zahl deren Steuerfaktoren.\n\nWir benötigen das Verzeichnis der Anstösser mit dem (Unterhalts-) Kostenverteiler (Perimeterverzeichnis).\n\nZur Festsetzung des Beitrages an die Restkosten benötigen wir das Mitgliederverzeichnis mit den prozentualen Kostenanteilen der Beteiligten (Perimeterverzeichnis).\n\nBesten Dank für die Abklärungen. Anstelle des vertraulich behandelten Mitgliederverzeichnisses benötigen wir demzufolge die Angabe der Anzahl Mitglieder, aufgeteilt nach natürlichen Personen, privat-rechtlicher und öffentlich-rechtlicher Körperschaften sowie die Statuten, um den Beitrag festsetzen zu können.","TSBegruendungsCode_BGN_20_kurz":"20 - Schätzung unvollständig, benötigen Zusatzangaben / Offerte","TSBegruendungsCode_BGN_20_lang":"Wir benötigen folgende Informationen/Dokumente: genauere Schadenbeschreibung, Fotos, Schadenschätzung, …\n\nDie Schadenschätzung ist zu pauschal. Zur Beurteilung des Gesuches benötigen wir:\n- eine genauere Beschreibung (Skizze, Masse und die angekündigten Fotos), \n- eine Wiederherstellungsofferte sowie\n- das Mitgliederverzeichnis mit den prozentualen Kostenanteilen (ev. Statuten).\nWird allenfalls ein Teil des Schadens durch Versicherungsleistungen gedeckt?\n\nWie gross war die beschädigte Fläche?\n\nWir bitten Sie, uns eine Wiederherstellungsofferte (Zweitofferte) zukommen zu lassen. \n\nWir empfehlen, weitere Offerten einzuholen.\n\nBitte laden Sie die erwähnten Belege im Schaden-Portal hoch.","TSBegruendungsCode_BGN_21_kurz":"21 - Schätzung hoch, kostengünstigere Lösung möglich?","TSBegruendungsCode_BGN_21_lang":"Die geschätzten Wiederherstellungskosten scheinen hoch. Wäre eine kostengünstigere Lösung möglich?\n\nDie Instandstellungsmassnahmen müssen – soweit zumutbar und sinnvoll – durch den Betroffenen mit betriebseigenen Mitteln ausgeführt werden.\n\nDie geschätzten Kosten erscheinen für die angegebene Fläche (Ertragswert) sehr hoch. Bitte begründen Sie dies. Ohne Begründung werden wir die Erfahrungswerte für diese Fläche anwenden.\n\nDie geschätzten Wiederherstellungskosten sind im Verhältnis zum Ertragswert der beschädigten Fläche zu hoch, wir können höchstens die Hälfte des Schätzungsbetrages anrechnen. Wäre eine kostengünstigere Lösung möglich?\n\nWir empfehlen, weitere Offerten / eine Zweit-Offerte einzuholen.\n\n…unverhältnismässig hoch / im Vergleich zur Schadenfläche\n\n…im Verhältnis zum Ertragswert der beschädigten Fläche zu hoch\n\n…in keinem Verhältnis zur Schadenfläche bzw. beschädigten Weglänge\n\n…im Vergleich mit der Grösse des verlorenen Kulturlandes hoch\n\n…es muss eine kostengünstigere Lösung gefunden werden.\n\n…Ev. nur teilweise Instandstellung?\n\n…Unter Umständen kann der Gesuchsteller bei den Arbeiten mitwirken und so mittels Hilfsarbeiten die Gesamtkosten reduzieren.","TSBegruendungsCode_BGN_22_kurz":"22 - Teil des Schadens durch Versicherung gedeckt?","TSBegruendungsCode_BGN_22_lang":"Bitte abklären, ob zumindest ein Teil des Schadens durch Versicherungsleistungen gedeckt wird.\n\nDer Schaden muss der Hagelversicherung / Mobiliarversicherung    / Gebäudeversicherung / Privatversicherung gemeldet werden.\n\nWird der Schaden (mindestens teilweise) durch die Schweizer Hagel gedeckt?","TSBegruendungsCode_BGN_23_kurz":"23 - Wiederherstellung subventionierbar? / Beteiligung Gemeinde ?","TSBegruendungsCode_BGN_23_lang":"Werden die Wiederherstellungsarbeiten durch Bund, Kanton und/oder die Gemeinde subventioniert?\n\nBitte den Schaden dem Meliorationsamt melden, die Wiederherstellungsarbeiten sind evtl. subventionierbar.\n\nUnseres Erachtens sollte sich die Gemeinde an den Wiederherstellungskosten beteiligen. Wir bitten um Ihre Antwort/Stellungnahme.","TSBegruendungsCode_BGN_30_kurz":"30 - Benötigen Abrechnung mit Belegen","TSBegruendungsCode_BGN_30_lang":"Die Wiederherstellungsarbeiten können im Rahmen der Schätzung ausgeführt werden. Die anrechenbaren Kosten werden aufgrund der Abrechnung festgelegt. (fondssuisse vergütet in der Regel 80% des anrechenbaren Betrags.) Mehrkosten gegenüber der Schätzung bleiben unberücksichtigt, wenn sie nicht stichhaltig begründet werden können.\n\nZur Festsetzung der Entschädigung benötigen wir nach Ausführung der Arbeiten eine detaillierte Abrechnung: Eigenleistungen, Fremdkosten, Vorleistungen; inklusive Kopien von Rechnungen und Zahlungsbelegen.\nDiese Angaben und Dokumente erfassen Sie bitte im Menüpunkt \\Aufwände\\ und laden dazu die nötigen Dokumente hoch.\n\nWenn die Restkosten von mehreren Beteiligten übernommen werden müssen, laden Sie bitte auch ein Dokument mit dem entsprechenden Kostenverteiler hoch. Bei Subventionsprojekten benötigen wir zudem die Beitragszusicherung und die Beitragsabrechnung. Die Instandstellungsarbeiten sollten, soweit zumutbar und sinnvoll, mit betriebseigenen Mitteln ausgeführt werden. Zusätzliche Informationen: www.fondssuisse.ch","TSBegruendungsCode_BGN_31_kurz":"31 - Benötigen Abrechnung der Versicherung","TSBegruendungsCode_BGN_31_lang":"Zur Festsetzung der Entschädigung benötigen wir nach Ausführung der Arbeiten eine detaillierte Abrechnung (Gesamtkosten und Leistung der Hagelversicherung, Abrechnung der Hagelversicherung bitte ebenfalls beilegen). Diese Angaben und Dokumente erfassen Sie bitte im Menüpunkt \\Aufwände\\ und laden dazu die nötigen Dokumente hoch. \nWenn die Restkosten von mehreren Beteiligten übernommen werden müssen, laden Sie bitte auch ein Dokument mit dem entsprechenden Kostenverteiler hoch. Die Instandstellungsarbeiten sollten soweit zumutbar und sinnvoll, mit betriebseigenen Mitteln ausgeführt werden. Zusätzliche Informationen: www.fondssuisse.ch","TSBegruendungsCode_BGN_32_kurz":"32 - Subventionsprojekt, erwarten Subventionsabrechnung","TSBegruendungsCode_BGN_32_lang":"Subventionsprojekt. Nach Beendigung der Arbeiten erwarten wir die Schlussabrechnung mit Belegen: Gesamtkosten / Subventionen von Bund, Kanton und/oder Gemeinde / Restkosten zulasten der Beteiligten. Diese Angaben und Dokumente erfassen Sie bitte im Menüpunkt \\Aufwände\\ und laden dazu die nötigen Dokumente hoch. Wenn die Restkosten von mehreren Beteiligten übernommen werden müssen, laden Sie bitte auch ein Dokument mit dem entsprechenden Kostenverteiler hoch.","TSBegruendungsCode_BGN_33_kurz":"33 - Schätzung hoch, sollte kostengünstiger werden","TSBegruendungsCode_BGN_33_lang":"Die geschätzten Wiederherstellungskosten sind im Vergleich zur angegebenen Schadenfläche sehr hoch. Im Rahmen unserer Beitragspraxis (Erfahrungswerte) können wir maximal CHF XXX-- pro Are. d.h. max. XXX als Schadensumme anerkennen. \nNach Ausführung der Arbeiten erwarten wir die Abrechnung.\n\n…Wir können voraussichtlich nicht die vollen Kosten anerkennen.\n\n…Unseres Erachtens müssten die Instandstellungsarbeiten um mind. einen Viertel günstiger ausfallen.\n\n…Wir können nur eine minimale Instandstellung mit einfachen Mitteln unterstützen.\n\n…Mehrwerte gegenüber dem vorherigen Zustand (wie neues Betonfundament, Retromuren) können nicht voll angerechnet werden\n\n…Verbesserungen sowie vorsorgliche Massnahmen können für einen Fondsbeitrag nicht berücksichtigt werden.\n\n…Für die saisonal mitbedingten Schäden an Rebmauern (Winterfrost, Alter) rechnen wir max. CHF 350.00/m2 an. Die Entschädigung beträgt inkl. Leistung des Kantons 70 % davon oder CHF 245.00/m2.\n…Für die unvorhersehbaren Elementarschäden an Rebmauern (Unwetter, Erdrutsch) rechnen wir max. CHF 500.00/m2 an. Die Entschädigung beträgt inkl. Leistung des Kantons 70 % davon oder Fr. 350.00/m2. \n\n…viel zu hoch. Im Verhältnis zum Ertragswert der betroffenen Fläche lassen sich keine teuren Massnahmen rechtfertigen (vgl. Richtlinien fondssuisse Art. 19, Absätze 4 und 9). Wir könnten höchstens CHF 9’000.00 anerkennen (Beitrag 60 % davon = max. CHF 5’400.00). \n\n…Aufgrund des Ertragswertes der überführten Flächen können wir höchstens CHF 18'000.00 Instandstellungskosten anerkennen, abzüglich CHF 8'600.00 Einkommensabzug, anrechenbar total maximal CHF 9'400.00 (Beitrag 60 % = CHF 5'640.00).\n\n…Aufgrund von Alter und Zustand des zerstörten Zauns können wir voraussichtlich höchstens die Hälfte der Wiederherstellungskosten als Schaden anerkennen.\n\n…Aufgrund der Schadenbeschreibung und der eingereichten Offerten können wir voraussichtlich max. CHF 24'000.00 als Schaden anrechnen (Beitrag 70% inkl. Kanton = max. CHF 16'800.00).","TSBegruendungsCode_BGN_34_kurz":"34 - Benötigen Abrechnung – teilweise versicherbar","TSBegruendungsCode_BGN_34_lang":"Es handelt sich um einen zumindest zum Teil versicherbaren Schaden (Graspauschalversicherung der Schweizer Hagel, bis CHF 1'000.-/ha versicherte Grasfläche). Der Beitrag fondssuisse wird deshalb reduziert sein.\n\nDie Wiederherstellungsarbeiten können im Rahmen der Schätzung ausgeführt werden. Die anrechenbaren Kosten werden aufgrund der Abrechnung festgelegt. (fondssuisse vergütet in der Regel 80% des anrechenbaren Betrags.) Mehrkosten gegenüber der Schätzung bleiben unberücksichtigt, wenn sie nicht stichhaltig begründet werden können.\n\nZur Festsetzung der Entschädigung benötigen wir nach Ausführung der Arbeiten eine detaillierte Abrechnung: Eigenleistungen, Fremdkosten, Vorleistungen; inklusive Kopien von Rechnungen und Zahlungsbelegen.\nDiese Angaben und Dokumente erfassen Sie bitte im Menüpunkt \\Aufwände\\ und laden dazu die nötigen Dokumente hoch.\n\nWenn die Restkosten von mehreren Beteiligten übernommen werden müssen, laden Sie bitte auch ein Dokument mit dem entsprechenden Kostenverteiler hoch. Bei Subventionsprojekten benötigen wir zudem die Beitragszusicherung und die Beitragsabrechnung. Die Instandstellungsarbeiten sollten, soweit zumutbar und sinnvoll, mit betriebseigenen Mitteln ausgeführt werden. Zusätzliche Informationen: www.fondssuisse.ch.","TSBegruendungsCode_BGN_40_kurz":"40 - Bitte Aufwände erfassen (Abrechnung nicht erfasst bzw. unvollständig)","TSBegruendungsCode_BGN_40_lang":"Bitte erfassen Sie unter Aufwände die Kosten für die Wiederherstellung. Zur Festsetzung der Entschädigung benötigen wir die Zahlungsbelege/-quittungen der Unternehmer- und/oder Materialrechnungen","TSBegruendungsCode_BGN_41_kurz":"41 - Benötigen Rechnungen bzw. Zahlungsbelege","TSBegruendungsCode_BGN_41_lang":"Zur Festsetzung der Entschädigung benötigen wir die Zahlungsbelege/-quittungen der Unternehmer- und/oder Materialrechnungen. Bitte laden Sie die erwähnten Belege im Schaden-Portal hoch.","TSBegruendungsCode_BGN_42_kurz":"42 - Kosten hoch bzw. höher als Schätzung","TSBegruendungsCode_BGN_42_lang":"Die Wiederherstellungskosten sind im Vergleich mit dem Ertragswert sehr hoch.\n\nDie angegebenen Kosten sind wesentlich höher als die ursprüngliche Schätzung.\n\nBitte begründen Sie dies. Ohne Begründung orientieren wir uns bei der Abrechnung an der Schätzung.","TSBegruendungsCode_BGN_43_kurz":"43 - Beitr. kann nicht festgelegt werden, Abklärungen","TSBegruendungsCode_BGN_43_lang":"Aufgrund der vorliegenden Angaben/Unterlagen kann die Entschädigung noch nicht festgelegt werden. \n\nBitte laden Sie die nötigen Belege im Schaden-Portal hoch.","TSBegruendungsCode_BGN_60_kurz":"60 - Nicht beitragsberechtigt / Kriterien nicht erfüllt","TSBegruendungsCode_BGN_60_lang":"Betroffene/Schaden nicht beitragsberechtigt»\n\nGesuch nicht berücksichtigen»\n\nGewisse Kriterien für einen Beitrag an den Schaden sind nicht erfüllt.","TSBegruendungsCode_BGN_61_kurz":"61 - Versicherbare Schäden","TSBegruendungsCode_BGN_61_lang":"Es handelt sich um einen versicherbaren Schaden (Richtlinien fondssuisse Art. 11).","TSBegruendungsCode_BGN_62_kurz":"62 - Unbedeutende Schäden (keine WH oder durch Dritte)","TSBegruendungsCode_BGN_62_lang":"Der Schaden ist unbedeutend (es wurden keine Wiederherstellungsarbeiten ausgeführt) oder er wurde durch Dritte behoben.","TSBegruendungsCode_BGN_63_kurz":"63 - Nicht durch Elementarereignis oder durch Dritte verursacht","TSBegruendungsCode_BGN_63_lang":"Der Schaden wurde nicht durch ein Elementarereignis oder durch Dritte verursacht.","TSBegruendungsCode_BGN_64_kurz":"64 - Durch andere Beiträge oder durch Versicherung gedeckt","TSBegruendungsCode_BGN_64_lang":"Der Schaden wird durch Versicherungsleistungen, Subventionen oder andere Beiträge gedeckt. \n\nDer Schaden ist durch die Leistungen der Schweizer Hagel gedeckt.\n\n… Der Selbstbehalt fällt ausser Betracht. (kann nicht zusätzlich angerechnet werden.) / Auf den Selbstbehalt können wir nicht eintreten (Richtlinien Art. 11 Abs. 1, versicherbare Schäden).\n\nDie Kosten sind zu nahezu 90 % durch die Leistungen der Hagelversicherung und den Strukturverbesserungsbeitrag gedeckt (vgl. Richtlinien Art. 19 Abs. 7). Die Restkosten erscheinen angesichts der grossen Mitgliederzahl tragbar.\n\nDer Schaden ist durch die Leistungen der \n- Abteilung Strukturverbesserungen und Produktion (ASP)\n- GVB Privatversicherungen AG (GVB Plus)\n- durch die Beiträge von Bund, Kanton und Gemeinde gedeckt.","TSBegruendungsCode_BGN_65_kurz":"65 - Ausser Betracht fallende Schäden (Art. 12) und Weitere Ausschlüsse (Art. 13)","TSBegruendungsCode_BGN_65_lang":"Schaden infolge künstlicher Erdbewegungen, mangelhafter Anlagen, vernachlässigtem Unterhalt oder anderer direkter oder indirekter menschlicher Einwirkung wird gemäss Art. 12 Abs. 4 Richtlinien fondssuisse nicht berücksichtigt.\n\nSchaden an im Bau befindlichen Kunstbauten wird gemäss Art. 13 Abs. 2 Richtlinien fondssuisse nicht berücksichtigt.\n\nDer Schaden war voraussehbar, er hätte durch rechtzeitige zumutbare Massnahmen verhindert werden können (mangelhafter Unterhalt oder mangelnde Sorgfalt) (Richtlinien fondssuisse Art. 12 Abs. 1).\n\nDurch tierische oder pflanzliche Schädlinge verursachter Schaden wird gemäss Art. 12 Abs. 5 Richtlinien fondssuisse nicht berücksichtigt.\n\nDurch Schneedruck, Hagel oder Feuer am Wald entstandene Schäden fallen ausser Betracht (Richtlinien fondssuisse Art. 12, Absatz 7).\n\nEinzelne Waldbäume werden nicht entschädigt.\n\nSchäden infolge Dürre, Nässe (Kanalisationsrückstau) oder Frost können nicht berücksichtigt werden (Richtlinien fondssuisse Art. 12 Abs. 6).\n\nDie allgemeine Wertverminderung eines Grundstückes oder Lohn- und Verdienstausfälle, die mit einem Schadenereignis in Zusammenhang stehen, können nicht entschädigt werden (Richtlinien fondssuisse Art. 13 Abs. 1).","TSBegruendungsCode_BGN_66_kurz":"66 - In kurzen Zeitabständen wiederkehrender Schaden","TSBegruendungsCode_BGN_66_lang":"In kurzen Zeitabständen wiederkehrender Schaden, kann gemäss Richtlinien fondssuisse (Art. 12, Abs. 3) nicht berücksichtigt werden.","TSBegruendungsCode_BGN_67_kurz":"67 - Fortgesetzte Einwirkung","TSBegruendungsCode_BGN_67_lang":"Nicht auf eine Einwirkung von aussergewöhnlicher Heftigkeit oder auf fortgesetzte Einwirkung zurückzuführender Schaden, kann gemäss Richtlinien fondssuisse (Art. 12, Abs. 2) nicht berücksichtigt werden.","TSBegruendungsCode_BGN_68_kurz":"68 - Abschwemmen von Kies an Strassen und Plätzen","TSBegruendungsCode_BGN_68_lang":"Abschwemmen von Kies an Strassen und Plätzen wird nicht entschädigt (Richtlinien fondssuisse Art. 13, Absatz 4).","TSBegruendungsCode_BGN_69_kurz":"69 - Normaler Unterhalt / rein vorsorglich","TSBegruendungsCode_BGN_69_lang":"Normaler Unterhalt oder rein vorsorgliche Massnahmen können nicht unterstützt werden (Richtlinien fondssuisse Art. 13).\n\nBei der Sickerleitung handelt es sich um eine rein vorsorgliche Massnahme und Neuanlage, die wir nicht berücksichtigen können (Richtlinien fondssuisse Art. 13 Abs. 6).","TSBegruendungsCode_BGN_70_kurz":"70 - Nicht beitragsberechtigter Geschädigter","TSBegruendungsCode_BGN_70_lang":"Gemäss Richtlinien fondssuisse Art. 7 nicht beitragsberechtigt.","TSBegruendungsCode_BGN_71_kurz":"71 - Abzug Einkommen/Vermögen grösser als ermittelter Schaden","TSBegruendungsCode_BGN_71_lang":"Der Abzug wegen Einkommen und/oder Vermögen übersteigt den ermittelten Schadenbetrag (Richtlinien fondssuisse Art. 23).\n\nDer Einkommens- und/oder Vermögensabzug übersteigt den ermittelten Schadenbetrag (Richtlinien fondssuisse Art. 23).","TSBegruendungsCode_BGN_72_kurz":"72 - Wegen zu hohem Einkommen/Vermögennicht beitragsberechtigt","TSBegruendungsCode_BGN_72_lang":"Wegen zu hohem Einkommen und/oder Vermögen nicht beitragsberechtigt (gemäss Richtlinien fondssuisse Art. 23).","TSBegruendungsCode_BGN_73_kurz":"73 - Schaden erreicht nicht Minimalbetrag","TSBegruendungsCode_BGN_73_lang":"Der Schaden erreicht nicht den Minimalbetrag von CHF 600.00 resp. CHF 1’000.00; gemäss Richtlinien fondssuisse Art. 22 erhalten Sie von fondssuisse deshalb keinen Beitrag.","TSBegruendungsCode_BGN_80_kurz":"80 - Nach Ablauf der Anmeldefrist eingereicht","TSBegruendungsCode_BGN_80_lang":"Die Schadenmeldung wurde nach Ablauf der Anmeldefrist von 3 Monaten eingereicht. Gemäss Richtlinien fondssuisse Art. 16 erhalten Sie von fondssuisse deshalb keinen Beitrag.","TSBegruendungsCode_BGN_81_kurz":"81 - Ersetzt durch eine andere Schadenmeldung","TSBegruendungsCode_BGN_81_lang":"Ersetzt durch eine andere Schadenmeldung. \n\nWird über Schadenfall … abgerechnet.","TSBegruendungsCode_BGN_82_kurz":"82 - Abrechnung / Unterlagen nicht erhalten","TSBegruendungsCode_BGN_82_lang":"Wir haben die Abrechnung / Unterlagen [innerhalb der gesetzten Frist] nicht erhalten.","TSBegruendungsCode_BGN_90_kurz":"90 - Reduzierte Entschädigung, z.T. versicherbar / durch Versicherungsleistungen gedeckt","TSBegruendungsCode_BGN_90_lang":"Ein Teil des Schadens ist durch Versicherungsleistungen gedeckt.\n\nReduzierte Entschädigung, es handelt sich um einen zum Teil versicherbaren Schaden.","TSBegruendungsCode_BGN_91_kurz":"91 - Reduzierte Entschädigung, Abzug Mehrwert / Unterhalt / vorsorglich","TSBegruendungsCode_BGN_91_lang":"Beitrag an die Wiederherstellung des vorherigen Zustandes, abzüglich Anteil\n- vorsorglich\n- Normalunterhalt\n- Verbesserung \n- Mehrwert/Neuwert\n(ca. XX%).\n\nAbzug ca. 20% für Mehrwert/Neuwert gemäss Zusicherung.","TSBegruendungsCode_BGN_92_kurz":"92 - Nicht alle Beteiligten beitragsberechtigt","TSBegruendungsCode_BGN_92_lang":"Aufgrund unserer Richtlinien können nicht alle Beteiligten bzw. Perimeterpflichtigen berücksichtigt werden. Aus diesem Grund erhalten Sie von fondssuisse einen reduzierten Beitrag. (Nicht berücksichtigt: … mit …% Kostenanteil / Berücksichtigt werden die Privatpersonen mit einem Anteil von …%.)","TSBegruendungsCode_BGN_93_kurz":"93 – Ausnahme, ohne Präjudiz für künftige ähnl. Fälle","TSBegruendungsCode_BGN_93_lang":"Im Sinne einer Ausnahme und ohne Präjudiz für künftige ähnliche Fälle.","TSBegruendungsCode_BGN_94_kurz":"94 - Teilabrechnung, bitte zweites Gesuch erfassen","TSBegruendungsCode_BGN_94_lang":"Bitte erfassen Sie ein zweites Gesuch für diesen Fall (mit Verweis) für die weiteren Aufwendungen / Eigenarbeiten und die Schlussabrechnung.","NAV_ENTSCHAEDIGUNG":"Entschädigung","BEITRAG_CREATE":"Beitrag hinzufügen","BEITRAG_ADD":"Beitrag hinzufügen","TSBeitragArt_FONDSSUISSE":"fondssuisse","TSBeitragArt_FONDSSUISSE_2023":"fondssuisse","TSBeitragArt_KANTON":"Kanton","TSBeitragArt_HOCHGEBIRGE":"Hochgebirge","TSBeitragArt_VERSICHERUNG":"Versicherung","TSBeitragStatus_AUSGEFUEHRT":"Ausgeführt","TSBeitragStatus_PENDENT":"Pendent","TSBeitragStatus_NICHT_FREIGEGEBEN":"Nicht freigegeben","BEITRAG_ART":"Beitragstyp","BANKNAME":"Bank","BEITRAEGE":"Beiträge","BEITRAG_LOESCHEN":"Wollen Sie diesen Beitrag löschen?","BEITRAG_LOESCHEN_BUTTON":"Beitrag löschen","ERMITTELTER_SCHADEN":"Ermittelter Schaden","ERMITTELTER_SCHADEN_SPEICHERN":"Ermittelter Schaden speichern","ERMITTELTER_SCHADEN_CHANGED_TEXT":"Die Beiträge müssen aktualisiert werden, da die Werte des ermittelten Schaden aktualisiert worden sind.","NICHT_BERECHTIGTER_ANTEIL":"Nicht berechtigter Anteil [%]","ABRECHNUNGS_BETRAG":"Abrechnungsbetrag","TOTAL_SCHAETZUNG":"Total Schätzung","ABRECHNUNG":"Abrechnung","ABZUG_EINKOMMEN":"Abzug für Einkommen / Gewinn","ABZUG_VERMOEGEN":"Abzug für Vermögen / Kapital","ABZUG_ANTEIL":"Abzug nicht berechtigter Anteil","ABZUG_EV":"Abzug für Einkommen / Vermögen","ABZUG_VORLEISTUNG":"Abzug für Vorleistung","ANRECHENBARER_SCHADEN":"Anrechenbarer Schaden","ENTSCHAEDIGEN":"Entschädigen","CHECKLISTE":"Checkliste","LEISTUNGSEMPFAENGER":"Leistungsempfänger","GESCHAEDIGTER":"Geschädigter","BETRAG_BESTIMMEN":"Betrag bestimmen","CHECK_SCHADENBEHOBEN_ABR_1":"Der Schaden wurde wiederhergestellt (Arbeiten ausgeführt)?","CHECK_SCHADENBEHOBEN_ABR_2":"Entspricht die Instandstellung der Anmeldung? Mehr-/Minderarbeiten?","CHECK_SCHADENBEHOBEN_ABR_3":"Abrechnung vollständig? Plausibel?","CHECK_SCHADENBEHOBEN_ABR_4":"Vorleistungen? Spenden? (alles deklariert?)","PROZENTSATZ_BEITRAG":"{{prozentsatz}} %","LABEL_KEINE_ANGABE":"Keine Angabe","MIGRATION":"Migration","ERROR_PARSE":"kann nicht gefunden werden","NO_RESULTS_FOUND":"keine Resultate gefunden","GEMEINDE":"Gemeinde","KANTON":"Kanton","ART_ANLAUFSTELLE":"Art der Anlaufstelle","TYPE":"Typ","VEREINBARUNG_AKZEPTIERT":"Vereinbarung akzeptiert","NEUE_ANLAUFSTELLE":"Neue Anlaufstelle","NUR_LESEBERECHTIGT":"Nur leseberechtigt","ANLAUFSTELLE_DEAKTIVIEREN":"Anlaufstelle deaktivieren","VERSION_INFO":"Version: Client {{frontendVersion}} / Server: {{backendVersion}}","VERSION_INFO_SINGLE":"Version {{version}}","ANLAUFSTELLE_EDITIEREN":"Anlaufstelle editieren","NAME_DER_ANLAUFSTELLE":"Name der Anlaufstelle","NAME_ZUSATZ":"Zusatz","VERANTWORTLICHE_PERSON":"Verantwortliche Person","GEMEINDE_HINZUFUEGEN":"Gemeinde hinzufügen","GEMEINDE_FUER_ANLAUFSTELLE":"Gemeinde für Anlaufstelle","VEREINBARUNG":"Vereinbarung","KANTONALER_BEITRAG":"Kantonaler Beitrag","FS_UEBERPRUEFUNG_OK":"Der Schadenfall erfüllt alle Beitragsbedingungen. Akzeptieren und zur Wiederherstellung an den Gesuchsteller freigeben.","FS_UEBERPRUEFUNG_OK_PAPIER":"Der Schadenfall erfüllt alle Kriterien. Akzeptieren und zur Wiederherstellung an den Schätzer freigeben.","FS_UEBERPRUEFUNG_MANGELHAFT":"Der Schadenfall ist unvollständig. An Schätzer zur Ergänzung mit Nachricht weiterleiten.","ABLEHNUNG":"Der Schadenfall erfüllt die Beitragsbedingungen nicht. Ablehnen und den Gesuchsteller informieren.","ANLAUFSTELLE_BASISPRUEFUNG_OK":"Erfüllt Beitragsvoraussetzungen: An den Schätzer weiterleiten.","ANLAUFSTELLE_SCHAETZUNG_OK":"Erfüllt Beitragsvoraussetzungen: Als angenommen an fondssuisse weiterleiten.","ZURUECK_AN_SCHAETZER":"Zurück an Schätzer weiterleiten.","STICHENTSCHEID_ANGEFORDERT":"Erfüllt Beitragsvoraussetzungen nicht: Zur Ablehnung an fondssuisse weiterleiten.","STICHENTSCHEID_OK":"Der Schadenfall erfüllt die Beitragsbedingungen","FREIGABE_PAPIER_FS_6":"Freigabe Papiergesuch nach Überprüfung bei fondssuisse","FREIGABE_PAPIER_FS_9":"Freigabe Papiergesuch nach Schaden behoben, abrechnen","CHECK_IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS_1":"Geprüft","CHECK_AUFTRAG_SCHAETZER_1":"Schaden festgestellt.","CHECK_AUFTRAG_SCHAETZER_2":"Beschreibung überprüft/ergänzt.","CHECK_AUFTRAG_SCHAETZER_3":"Schätzung erstellt.","CHECK_AUFTRAG_SCHAETZER_4":"Wird der Schaden subventioniert?","CHECK_UEBERPRUEFUNG_FS_1":"Gesuchsteller berechtigt? (Richtlinien Art. 6/7) Eigentümer/Pächter?","CHECK_UEBERPRUEFUNG_FS_2":"Finanzielle Verhältnisse? (Art. 23)","CHECK_UEBERPRUEFUNG_FS_3":"Perimeter/Beteiligte?","CHECK_UEBERPRUEFUNG_FS_4":"Schadenereignis (-ursache/-objekt)? (Art. 9/10) berücksichtigt?","CHECK_UEBERPRUEFUNG_FS_5":"Schaden versicherbar? (Art. 11)","CHECK_UEBERPRUEFUNG_FS_6":"Ausser Betracht fallende Ereignisse? (Art. 12) weitere Ausschlüsse? (Art. 13)","CHECK_UEBERPRUEFUNG_FS_7":"Weitere Beitragsmöglichkeiten?","CHECK_UEBERPRUEFUNG_FS_8":"Schadendokumentation nachvollziehbar?","CHECK_UEBERPRUEFUNG_FS_9":"Fehlende Angaben?","CHECK_UEBERPRUEFUNG_FS_10":"Schadendimension, vorgeschlagene Massnahmen, Schätzung plausibel?","CHECK_UEBERPRUEFUNG_FS_11":"Offene Punkte, Fragen?","CHECK_UEBERPRUEFUNG_FS_12":"Unterstützen ja/nein?","CHECK_UEBERPRUEFUNG_FS_13":"Einschränkungen, Kostendach? Hinweise?","CHECK_BEARBEITUNG_AS_1":"Die Personalien des Gesuchstellers wurden kontrolliert (identifiziert).","CHECK_BEARBEITUNG_AS_2":"Das Einkommen und das Vermögen für Steuerjahr (am Domizil) wurden kontrolliert.","CHECK_BEARBEITUNG_AS_3":"Grundstück (Schadenort) befindet sich in der Gemeinde.","CHECK_BEARBEITUNG_AS_4":"Schätzer zugewiesen?","CHECK_UEBERPRUEFUNG_AS_1":"Angaben des Betroffenen vollständig.","CHECK_UEBERPRUEFUNG_AS_2":"Angaben Schaden vollständig/korrekt.","CHECK_UEBERPRUEFUNG_AS_3":"Der Gesuchsteller ist der Geschädigte (Eigentumsverhältnisse).","CHECK_UEBERPRUEFUNG_AS_4":"Gibt es andere /weitere Unterstützungsmöglichkeiten (Subventionen, Beiträge, Spenden)?","CHECK_UEBERPRUEFUNG_AS_STICHENTSCHEID_FS_1":"Geprüft","CHECK_UEBERPRUEFUNG_SCHAETZER_1":"Der Schaden wurde wiederhergestellt (Arbeiten ausgeführt)?","CHECK_UEBERPRUEFUNG_SCHAETZER_2":"Entspricht die Instandstellung der Anmeldung? Mehr-/Minderarbeiten?","CHECK_UEBERPRUEFUNG_SCHAETZER_3":"Abrechnung vollständig? Plausibel?","CHECK_UEBERPRUEFUNG_SCHAETZER_4":"Vorleistungen? Spenden? (alles deklariert?)","CHECK_UEBERPRUEFUNG_SCHAETZER_5":"Korrekturen, Kommentare?","CHECK_WIEDERHERSTELLUG_1":"Wiederherstellung des vorherigen Zustands","CHECK_WIEDERHERSTELLUG_2":"Möglichst mit betriebseigenen Mitteln, so kostengünstig wie möglich.","CHECK_WIEDERHERSTELLUG_3":"Eigenleistungen rapportieren","CHECK_WIEDERHERSTELLUG_4":"Fremdleistungen, Rechnungen bezahlen, Zahlungsquittungen erfassen","CHECK_WIEDERHERSTELLUG_5":"Arbeiten abgeschlossen?","CHECK_AUSZAHLUNG_1":"Begründungstexte/Kommentare gelesen","CHECK_AUSZAHLUNG_2":"Zahlungsadresse/-konto kontrolliert (vorhanden)","CHECK_AUSZAHLUNG_3":"Zahlungskonto? Liquidität vorhanden?","WIEDERHERSTELLUNG_AUSGEFUEHRT":"Alle Wiederherstellungsarbeiten sind abgeschlossen, die Aufwände sind vollständig erfasst und überprüft. An Schätzer zur Prüfung zuweisen.","VEREINBARUNG_HOCHLADEN":"Vereinbarung hochladen","APPLICATION_PROPERTIES":"Application Properties","SERF_PROPERTIES":"Fondssuisse Properties","TESTDATEN":"Testdaten","DEUTSCH":"Deutsch","FRANZOESISCH":"Französisch","ITALIENISCH":"Italienisch","FONDSSUISSE_DOKUMENTE":"Fondssuisse Dokumente","WIEDERHERSTELLUNG_GEPRUEFT":"Alle Wiederherstellungsarbeiten sind abgeschlossen, die Aufwände sind vollständig erfasst und überprüft. An fondssuisse zur Prüfung zuweisen.","WIEDERHERSTELLUNG_GEPRUEFT_PAPIER":"Alle Wiederherstellungsarbeiten sind abgeschlossen, die Aufwände sind vollständig erfasst und überprüft. An fondssuisse zur Prüfung zuweisen.","WIEDERHERSTELLUNG_MANGELHAFT":"An den Gesuchsteller zurückweisen mit der Bitte um Ergänzungen.","ALLES_KONTOLLIERT":"Alle oben genannten Punkte wurden kontrolliert.","ABTEILUNG":"Abteilung","ABRECHNUNG_OK":"Abrechnung OK","ABRECHNUNG_MANGELHAFT":"Abrechnung braucht Ergänzungen","TSSchadenArt_ERDRUTSCH":"Erdrutsch","TSSchadenArt_UEBERSCHWEMMUNG":"Überschwemmung","TSSchadenArt_UEBERFUEHRUNG":"Überführung / Übersarrung","TSSchadenArt_RUEFE":"Rüfe","TSSchadenArt_LAWINE":"Lawine","TSSchadenArt_SCHNEEDRUCK":"Schneedruck","TSSchadenArt_STURMWIND":"Sturmwind","TSSchadenArt_FELSSTURZ":"Felssturz","TSSchadenArt_STEINSCHLAG":"Steinschlag","TSSchadenArt_TROCKENHEIT":"Trockenheit","TSSchadenArt_ANDERE":"Andere","ART_DES_SCHADENDS_ANDERE":"Art des Schadens Freitext","GEMEINDEN":"Gemeinden","VEREINBARUNG_STEPTS_TITLE":"Nächste Schritte zur Freischaltung Ihrer Anlaufstelle:","VEREIBARUNG_STEP1":"1. Schritt","VEREIBARUNG_STEP1_TEXT":"Dokument \"Authentifizierung Anlaufstelle\" herunterladen (<a href='https://fondssuisse.cmsbox.ch/download/pictures/d5/5wkylpa9ai7j97tofa91wufswklvh8/authentifizierung_anlaufstelle.pdf'>pdf</a>) und ausdrucken.","VEREIBARUNG_STEP2":"2. Schritt","VEREIBARUNG_STEP2_TEXT":"Dokument unterschreiben und per Post an fondssuisse senden.","VEREIBARUNG_STEP3":"3. Schritt","VEREIBARUNG_STEP3_TEXT":"Benutzer administrieren.","VEREINBARUNG_ABGELAUFEN_WARNUNG":"Die rot markierten Anlaufstellen sind aktuell ungültig. Bitte laden Sie die Vereinbarung (<a href='https://www.fondssuisse.ch/download/pictures/d5/5wkylpa9ai7j97tofa91wufswklvh8/authentifizierung_anlaufstelle.pdf'>pdf</a>) herunter und schicken Sie sie unterschrieben an fondssuisse.","NICHT_FREIGEGEBEN":"Nicht freigegebene Beiträge","PENDENT":"Pendente Beiträge","AUSGEFUEHRT":"Ausgeführte Zahlungen","BEITRAG":"Beitrag","EMPFAENGER":"Empfänger","FREIGEBEN_DIALOG":"Wollen Sie die gewählten {{anzahl | number : 0}} Beiträge wirklich freigeben?","AUSFUEHREN_DIALOG":"Wollen Sie die gewählten {{anzahl | number : 0}} Beiträge wirklich ausführen?","REF_BUCHHALTUNG":"Ref# Buchhaltung","DATUM_FAELLIG":"Fälligkeit","LINK_ANLAUFSTELLE":"Anlaufstelle auswählen","ANLAUFSTELLE_WECHSELN":"Anlaufstelle wechseln","BENUTZER_ERSTELLT":"Benutzer erstellt","ANZ_EMPFAENGER":"Anz. Empfänger","ZAHLUNGEN_AUSGEFUEHRT":"Ausgeführte Zahlungen","ISO_DATEI":"ISO Datei","BEITRAEGELISTE":"Beiträgeliste","DOWNLOAD_ISO":"Download ISO Datei","SCHADENFALL_PDF":"Schadenfall PDF","DOWNLOAD_DECKBLATT":"Download PDF","DOWNLOAD_BEITRAEGE":"Download Beiträgeliste","NAV_BEMERKUNG":"Bemerkungen","NUR_FONDSSUISSE":"Hier können Dokumente hochgeladen werden, die nur fondssuisse sehen kann.","MELDUNGEN_DURCH_SYSTEM":"Meldungen durch das System","MANUELL_ERFASSTE_MELDUNG":"Manuell erfasste Meldungen","STATUS_MELDUNGEN":"Statusübergangs Meldungen","INTERNE_BEMERKUNG":"interne Bemerkung","BEITRAG_EFFEKTIV":"Effektiver Beitrag","ERSTELLT_VON":"Erstellt von","ERSTELLT_AM":"Erstellt am","BERECHNUNG_BETRAG":"Berechnung Betrag","SYSTEM_KONFIGURATION":"System Konfiguration","KONFIGURATION":"Konfiguration","FS_SACHBEARBEITER_ZUTEILEN":"Fondssuisse Sachbearbeiter verwalten","FS_ADMIN_ZUTEILEN":"Fondssuisse Administratoren verwalten","FS_BETROFFENE_ROLLE_ENTFERNEN":"Fondsuisse Betroffene Rolle entfernen","FS_ROLLE_ENTFERNEN":"Rolle entfernen","BETROFFENE_ROLLE_ENTFERNT":"Die Betroffene Rolle konnte erfolgreich entfernt werden.","EMAIL_UNGUELTIG":"E-Mail Adresse ist ungültig","BITTE_EMAIL":"Bitte eine gültige E-Mail Adresse angeben.","CONFIRM_ROLE_REMOVAL":"Wollen Sie die Admin Rolle wirklich abgeben? Sie können die Konfiguration danach nicht mehr benutzen.","SENDABLEHNUNGMAIL":"send Ablehnung Mail","SENDSCHADENFALLFREIGEGEBENMESSAGE":"send Schadenfall freigegeben Message","SENDBETROFFENEWIEDERHERSTELLUNGBEWILLIGTMAIL":"send Betroffene Wiederherstellung bewilligt Mail","SENDAUSZAHLUNGSMAIL":"send Auszahlungsmail","SENDSCHADENFALLFREIGEGEBENFORANLAUFSTELLEMESSAGE":"send Schadenfall freigegeben for Anlaufstelle Message","SENDSCHAETZERABRECHNUNGMANGELHAFTMAIL":"send Schaetzer Abrechnung mangelhaft Mail","SENDSCHAETZERAUFWAENDEREADYFORVERIFICATIONMAIL":"send Schaetzer Aufwaende ready for verification Mail","SENDSCHAETZERWIEDERHERSTELLUNGBEWILLIGTMAIL":"send Schaetzer Wiederherstellung bewilligt Mail","SENDUEBERPRUEFUNGMANGELHAFTMAIL":"send Ueberpruefung Mangelhaft Mail","SENDWIEDERHERSTELLUNGANGABENMANGELHAFTMAIL":"send Wiederherstellungangaben mangelhaft Mail","SENDSCHAETZERZUGEWIESENMAIL":"send Schaetzer zugewiesen Mail","SENDSCHADENFALLUEBERPRUEFUNGFSFORINSPEKTORATMESSAGE":"send Schadenfall Ueberpruefung FS Kant. Amtsstelle","SENDSCHADENFALLSCHADENBEHOBENFORINSPEKTORATMESSAGE":"send Schadenfall Schaden behoben Kant. Amtsstelle","TESTMAIL":"Mail Tests","NEUES_INSPEKTORAT":"Neue Kant. Amtsstelle","INSPEKTORAT_EDITIEREN":"Kantonale Amtsstelle editieren","INSPEKTORAT_DEAKTIVIEREN":"Kantonale Amtsstelle deaktivieren","NAME_DES_INSPEKTORAT":"Name der kantonalen Amtsstelle","ANLAUFSTELLE_HINZUFUEGEN":"Anlaufstelle hinzufügen","INSPEKTOREN_ZUTEILEN":"Kantonale Experten zuteilen","ANLAUFSTELLEN_FUER_INSPEKTORAT":"Anlaufstellen für Kantonale Amtsstelle","INSPEKTORAT_ADD":"Kantonale Amtsstelle hinzufügen","INSPEKTORAT":"Kantonale Amtsstelle","MENU_INSPEKTORAT":"Kant. Anlaufstelle","MENU_VERSICHERUNGSBEITRAEGE":"Vers.-Beiträge","SUBVENTIONIERT_DURCH":"Werden für die Wiederherstellungskosten bei Bund, Kanton und/oder die Gemeinde Subventionen beantragt?","OFFERTE":"Es wurde eine Offerte angefragt / erstellt.","ARBEITEN":"Es wurden bereits Arbeiten in die Wege geleitet / ausgeführt.","BEENDEN_SPEICHERN":"Speichern","NOCH_NICHT_GESCHAETZT":"noch nicht geschätzt","GESUCH_SPEICHERN":"Ereignis speichern","UNSAVED_WARNING":"Achtung: Sie haben noch ungespeicherte Änderungen, die verlorengehen wenn Sie die Seite verlassen.","VORHERIGER_WERT":"Ursprüngliche eingegebener Wert","UNSAVED_WARNING_RELOAD":"Achtung: Sie haben noch ungespeicherte Änderungen, die verlorengehen wenn Sie die Seite neu laden.","KUBIKMETER":"Kubikmeter","KUBIKMETER_ERFASSEN":"Kubikmeter erfassen","LITER":"Liter","LITER_ERFASSEN":"Liter erfassen","KUBIKMETER_HINZUFUEGEN":"Betrag für m3 berechnen","STUNDEN_HINZUFUEGEN":"Stunden hinzufügen","TSKulturart_WIESEWEIDE":"Wiese / Weide","TSKulturart_ACKERLAND":"Ackerland","TSKulturart_ANDERE":"Andere","VERSICHERUNGSBEITRAEGE":"Versicherungsbeiträge","VERSICHERUNGSBEITRAG_CREATE":"Versicherungsbeitrag hinzufügen","VERSICHERUNGSBEITRAG_ERFASSEN":"Versicherungsbeitrag erfassen","VERS_BEITR_EXT_SCHADENNR":"Ext. Schadennummer","VERSICHERUNG":"Versicherung","VERSICHERUNG_ART":"Art der Versicherung","SCHADENDATUM":"Schadendatum","NAV_VERSICHERUNG_ERFASSEN":"Schaden","NAV_VERSICHERUNG_BEITRAG":"Beitrag","NAV_VERSICHERUNG_VERSICHERTER":"Versicherter","EXTERNAL_SCHADEN_NR":"Ext. Schaden Nummer","POLICE_NUMMER":"Police Nummer","SCHADEN_GEMEINDE":"Schaden Gemeinde","PROZENTSATZ":"Prozentsatz","WIEDERHERSTELLUNGSKOSTEN":"Wiederherstellungskosten","ERMITTELTERSCHADEN":"Ermittelter Schaden","BEITRAG_BERECHTIGT":"Berechtigter Beitrag","BEITRAG_HINZUFUEGEN":"Beitrag hinzufügen","VERSICHERUNGSBEITRAG_KOSTEN":"Kosten","VERSICHERUNGSBEITRAG_SCHADENABRECHNUNG":"Schadenabrechnung","RECHTSFORM":"Rechtsform","GESUCHSTELLER_TITLE":"Angaben zum {{eigentumsverhaeltnis}}","RECHTSFORM_TITLE":"Rechtsform","VERSICHERUNGSBEITRAG_FALL_ERSTELLEN":"Test Versicherungsbeitrag einfügen","BITTE_HOCHLADEN":"Bitte laden Sie folgende Dokumente hoch","REQUIRED":"Pflicht","OPTIONAL":"Optional","MITGLIEDERVERZEICHNIS":"Mitgliederverzeichnis","JAHRESRECHNUNG":"Jahresrechnung","IMPORTIERTE":"Importierte","PACHTVERTRAG":"Pachtvertrag","KONTO_INHABER":"Begünstigter","KONTO_INHABER_PLZ":"PLZ","KONTO_INHABER_ORT":"Ort","VON":"von","BIS":"bis","ZUSTIMMUNG_STEUERPRUEFUNG_GENOSSENSCHAFT":"Wir ermächtigen die Gemeinde, die Finanzangaben zu kontrollieren bzw. im Gesuch an fondssuisse zu ergänzen und im Schaden-Portal zu speichern.","JAHR":"Jahr","STEUERFAKTOREN":"Namen und Steuerfaktoren aller Beteiligten","BENUTZER_ROLLEN_LOESCHEN":"Benutzer-Rollen löschen","BETROFFENE_ROLLE":"Betroffene Rolle","STATISTIK":"Statistik","BatchJobStatus_REQUESTED":"Statistik angefordert","BatchJobStatus_RUNNING":"Statistik wird erstellt","BatchJobStatus_FINISHED":"Bereit zum Download","BatchJobStatus_FAILED":"Nicht erfolgreich abgeschlossen","STARTED_GENERATION":"Der Report wird erstellt","ERROR_DATE_BEFORE_TO":"FEHLER: das \"Bis\"-Datum liegt vor dem \"Von\"-Datum","ERSTELLT":"Erstellt","BEENDET":"Beendet","TYP":"Typ","PARAMETER":"Parameter","GESTARTET":"Gestartet","SHOW_JOBS":"Zeige Alle Batchjobs","GENERIEREN":"Generieren","PDF_GENERIEREN":"PDF Generieren","ReportType_beitragReport":"Beitragsbericht","DEV_FUNCTIONS":"Softwareentwickler Funktionen anzeigen","RECREATE_ZAHLUNGSAUFTR_EXCEL_REPORT":"Zahlungsauftrag Excel neu generieren","DOKUMENT_DOWNLOAD":" Dokument herunterladen","ZH":"Zürich","BE":"Bern","LU":"Luzern","UR":"Uri","SZ":"Schwyz","OW":"Obwalden","NW":"Nidwalden","GL":"Glarus","ZG":"Zug","FR":"Freiburg","SO":"Solothurn","BS":"Basel-Stadt","BL":"Basel-Landschaft","SH":"Schaffhausen","AR":"Appenzell Innerhoden","AI":"Appenzell Ausserrhoden","SG":"St. Gallen","GR":"Graubünden","AG":"Aargau","TG":"Thurgau","TI":"Tessin","VD":"Waadt","VS":"Wallis","NE":"Neuenburg","GE":"Genf","JU":"Jura","KOSTEN_GESCH":"Schätzung","SICHTBARKEIT":"Sichtbarkeit","INTERN":"intern","FONDSSUISSE":"fondssuisse","STATUS_AKTUALISIEREN":"Status aktualisieren","STATUS_AKTUALISIEREN_TEXT":"Sie sind im Begriff den Status dieses Schadenfalls manuell zu ändern.","ZEITBEREICH":"Zeitbereich wählen","TSCockpitSelect_":"Zeitbereich wählen","TSCockpitSelect_LETZER_MONAT":"Letzter Monat","TSCockpitSelect_DATUM_BEREICH":"Datum Bereich","DATUM_VON":"Datum von","DATUM_BIS":"Datum bis","ANWENDEN":"Anwenden","COCKPIT_STATUS_TITLE":"Status der Schadenfälle","COCKPIT_KANTON_TITLE":"Gesuche pro Kanton","COCKPIT_ERFASSUNGSART_TITLE":"Gesuche pro Erfassungsart","COCKPIT_SCHADENART_TITLE":"Schadenarten","COCKPIT_GESCHAETZTE_KOSTEN_TITLE":"Geschätzte Kosten","COCKPIT_ANZAHL_GESUCHE":"Anzahl Gesuche","COCKPIT_ANZAHL_NEUE_GESUCHE":"Anzahl neue Gesuche","short_DEUTSCH":"DE","short_FRANZOESISCH":"FR","short_ITALIENISCH":"IT","AUFAWENDE_DOC_BEGLEITTEXT":"Bitte laden Sie hier Dokumente und Bilder zur Wiederherstellung hoch.","TITLE_DUPLICATED_HANDARBEITER":"Duplizierte Person","DUPLICATED_HANDARBEITER_MESSAGE":"Bitte verwenden Sie den früher erfassten Eigenleistung Eintrag über diese Person.","EIGENLEISTUNG_DESCRIPTION":"Beschreibung der Leistung / des Gerätes","STUNDENANSATZ":"Stundenansatz","ANZAHL_STUNDEN_":"Anzahl Stunden","BANKKONTO_EDITIEREN":"Bankangaben editieren","BEITRAG_SCHON_ERFASST":"Achtung, Beitrag schon erfasst, dieser muss neu generiert werden"}

/***/ }),

/***/ "9qK+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSRole_1 = __webpack_require__("MleR");
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
/**
 * Entspricht ungefaehr den Felder die ueber JaxAuthAccessElement in das Cookie gesetzt werden
 */
var TSUser = /** @class */ (function (_super) {
    __extends(TSUser, _super);
    function TSUser(vorname, nachname, password, email, role) {
        var _this = _super.call(this) || this;
        _this._roles = [];
        _this._vorname = vorname;
        _this._nachname = nachname;
        _this._password = password;
        _this._email = email;
        if (role !== undefined) {
            _this._roles = role;
        }
        else {
            _this._roles = [];
        }
        return _this;
    }
    Object.defineProperty(TSUser.prototype, "nachname", {
        get: function () {
            return this._nachname;
        },
        set: function (value) {
            this._nachname = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSUser.prototype, "vorname", {
        get: function () {
            return this._vorname;
        },
        set: function (value) {
            this._vorname = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSUser.prototype, "password", {
        get: function () {
            return this._password;
        },
        set: function (value) {
            this._password = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSUser.prototype, "email", {
        get: function () {
            return this._email;
        },
        set: function (value) {
            this._email = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSUser.prototype, "roles", {
        get: function () {
            return this._roles;
        },
        set: function (value) {
            this._roles = value;
        },
        enumerable: true,
        configurable: true
    });
    TSUser.prototype.getFullName = function () {
        return (this.vorname ? this.vorname : '') + ' ' + (this.nachname ? this.nachname : '');
    };
    TSUser.prototype.getRoleKey = function () {
        return TSRole_1.rolePrefix() + this.roles;
    };
    TSUser.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this._vorname = restObject.vorname;
        this._nachname = restObject.nachname;
        this._password = restObject.password;
        this._email = restObject.email;
        this._roles = restObject.roles;
        return this;
    };
    TSUser.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.vorname = this.vorname;
        restObject.nachname = this.nachname;
        restObject.password = this.password;
        restObject.email = this.email;
        restObject.roles = this.roles;
        return restObject;
    };
    return TSUser;
}(TSAbstractEntity_1.default));
exports.default = TSUser;


/***/ }),

/***/ "9rlH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSKantonCode_1 = __webpack_require__("vEoF");
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var TSSprache_1 = __webpack_require__("3oUo");
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
var RemoveDialogController_1 = __webpack_require__("92sy");
var template = __webpack_require__("z6rp");
__webpack_require__("4j5k");
var removeDialogTemplate = __webpack_require__("YTLw");
var DVSchadenfaelleListConfig = /** @class */ (function () {
    function DVSchadenfaelleListConfig() {
        this.transclude = false;
        this.bindings = {
            onEdit: '&',
            onDeckblatt: '&?',
            onDelete: '&?',
            onFilterChange: '&',
            prefilter: '=',
            tabindex: '@',
            selectedtab: '=',
            verantwortliche: '<',
            onVerantwortlicherChange: '&',
            showVerantwortlicherFilter: '<',
            changeVerantwortlicherEnabled: '<',
        };
        this.template = template;
        this.controller = DVSchadenfaelleListController;
        this.controllerAs = 'vm';
    }
    return DVSchadenfaelleListConfig;
}());
exports.DVSchadenfaelleListConfig = DVSchadenfaelleListConfig;
var DVSchadenfaelleListController = /** @class */ (function () {
    /* @ngInject */
    function DVSchadenfaelleListController($filter, $log, CONSTANTS, $scope, roleUtilService, $window, $translate, filterPersistenceService, dvDialog, overdueService, authServiceRS, isNeuInStatusService, schadenfallModelManager) {
        var _this = this;
        this.$filter = $filter;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.$scope = $scope;
        this.roleUtilService = roleUtilService;
        this.$window = $window;
        this.$translate = $translate;
        this.filterPersistenceService = filterPersistenceService;
        this.dvDialog = dvDialog;
        this.overdueService = overdueService;
        this.authServiceRS = authServiceRS;
        this.isNeuInStatusService = isNeuInStatusService;
        this.schadenfallModelManager = schadenfallModelManager;
        this.verantwortlicheForFilter = [];
        this.displayedCollection = []; //Liste die im Gui angezeigt wird
        this.showResetFilter = false;
        this.nichtZugeteiltMarker = 'NICHT_ZUGETEILT';
        this.defaultTableFilterState = {
            sort: {},
            search: {},
            pagination: { start: 0, totalItemCount: 0, number: 30 },
        };
        this.callServer = function (tableFilterState) {
            //wenn aktuelles tab nicht gewaehltes ist machen wir nichts
            if (_this.selectedtab !== parseInt(_this.tabindex)) {
                return;
            }
            var pagination = tableFilterState.pagination;
            _this.pagination = pagination;
            if (_this.onFilterChange && angular.isFunction(_this.onFilterChange)) {
                _this.onFilterChange({
                    tableState: tableFilterState,
                    prefilter: _this.prefilter,
                }).then(function (result) {
                    if (result) {
                        tableFilterState.pagination.totalItemCount = result.totalResultSize;
                        tableFilterState.pagination.numberOfPages = Math.ceil(result.totalResultSize / tableFilterState.pagination.number);
                        _this.displayedCollection = new Array().concat(result.schadenfallDTOs);
                    }
                    return _this.displayedCollection;
                }).then(function (dtos) {
                    if (dtos) {
                        dtos.forEach(function (dto) {
                            _this.schadenfallModelManager.openSchadenfall(dto.schadenfallId).then(function (schadenfall) {
                                dto.totalSchaetzung = schadenfall.getAbrechnungsbetrag(true);
                            });
                        });
                    }
                });
            }
            else {
                _this.$log.info('no callback function spcified for filtering');
            }
        };
        this.initViewModel();
    }
    DVSchadenfaelleListController.prototype.initViewModel = function () {
    };
    DVSchadenfaelleListController.prototype.$onInit = function () {
        var _this = this;
        if (this.verantwortliche === undefined || this.verantwortliche === null) {
            this.$log.debug('list of verantwortliche is empty');
            this.verantwortliche = [];
        }
        // this creates a dummy element for the filter header; this could be done using ng-repeat on the option element but that is slow in ie.
        if (this.verantwortliche) {
            var nichtZugeteiltElements = void 0;
            angular.copy(this.verantwortliche, this.verantwortlicheForFilter);
            nichtZugeteiltElements = this.verantwortliche.filter(function (entry) {
                return entry.email === _this.nichtZugeteiltMarker;
            });
            if (nichtZugeteiltElements.length === 0) {
                var nichtZugeteiltDummy = new TSBenutzer_1.default();
                nichtZugeteiltDummy.email = this.nichtZugeteiltMarker;
                nichtZugeteiltDummy.nachname = this.$translate.instant(this.nichtZugeteiltMarker);
                this.verantwortlicheForFilter = [nichtZugeteiltDummy].concat(this.verantwortlicheForFilter);
            }
        }
    };
    DVSchadenfaelleListController.prototype.editClicked = function (schadenfallEdit, event) {
        this.onEdit({ schadenfall: schadenfallEdit, event: event });
    };
    /**
     * Alle TSSchadenfaelleStatus fuer das Filterdropdown
     * @returns {Array<TSSchadenfaelleStatus>}
     */
    DVSchadenfaelleListController.prototype.getSchadenfaelleStatus = function () {
        if (this.prefilter.filterStatus && this.prefilter.status) {
            return this.prefilter.status;
        }
        else {
            return TSSchadenfallStatus_1.getTSSchadenfallStatusalues();
        }
    };
    /**
     * Alle TSKantonCode fuer das Filterdropdown
     * @returns {Array<key: string; code: TSKantonCode>}
     */
    DVSchadenfaelleListController.prototype.getKantone = function () {
        var _this = this;
        var kantonCodes = TSKantonCode_1.getKantonCodeList();
        var kantonNamesAndCodes = [];
        kantonCodes.forEach(function (code) {
            kantonNamesAndCodes.push({
                key: _this.$translate.instant(code.toString()),
                code: code,
            });
        });
        kantonNamesAndCodes.sort(function (a, b) { return a.code.toString().localeCompare(b.code.toString()); });
        return kantonNamesAndCodes;
    };
    /**
     * Alle TSSchadenfaelleStatus fuer das Filterdropdown
     * @returns {Array<TSSchadenfaelleStatus>}
     */
    DVSchadenfaelleListController.prototype.getAlleVerantwortliche = function () {
        return this.verantwortliche;
    };
    DVSchadenfaelleListController.prototype.getColumnsNumber = function () {
        var element = angular.element('.dv-schadenfaelle-list.' + this.getClass() + ' .header-row').first();
        if (element && element.get(0)) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 8;
    };
    DVSchadenfaelleListController.prototype.updateVerantwortlicher = function (schadenfallId, verantwortlicher) {
        if (this.onVerantwortlicherChange && angular.isFunction(this.onVerantwortlicherChange)) {
            this.onVerantwortlicherChange({
                schadenfallId: schadenfallId,
                verantwortlicher: verantwortlicher,
            });
        }
        else {
            this.$log.info('no callback function specified for changing verantwortlicher');
        }
    };
    DVSchadenfaelleListController.prototype.getClass = function () {
        return 'tab-nr-' + this.tabindex;
    };
    DVSchadenfaelleListController.prototype.getVerantwortlicher = function (verantwortlicherEmail) {
        if (!verantwortlicherEmail) {
            return this.$translate.instant(this.nichtZugeteiltMarker);
        }
        else {
            try {
                for (var _a = __values(this.verantwortliche), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var verantwortlicher = _b.value;
                    if (verantwortlicher.email === verantwortlicherEmail) {
                        return verantwortlicher.getFullName();
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return '';
        var e_1, _c;
    };
    DVSchadenfaelleListController.prototype.resetFilter = function () {
        this.filterPersistenceService.deleteFilter("st-table-" + this.tabindex);
    };
    DVSchadenfaelleListController.prototype.deckblattClicked = function (schadenfallEdit, event) {
        this.onDeckblatt({ schadenfall: schadenfallEdit, event: event });
    };
    DVSchadenfaelleListController.prototype.isInStatusNEU = function (schadenFallStatus) {
        var statusNeu = TSSchadenfallStatus_1.getTSSchadenfallStatusNeu();
        return statusNeu.some(function (status) { return status === schadenFallStatus; });
    };
    DVSchadenfaelleListController.prototype.deleteSchadenfallClicked = function (schadenFall, event) {
        var _this = this;
        this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController_1.RemoveDialogController, {
            text: 'SCHADENFALL_LOESCHEN_TEXT',
            title: 'SCHADEN_LOESCHEN',
        }).then(function () {
            _this.onDelete({ schadenfallId: schadenFall.schadenfallId, event: event });
        }).catch(function (reason) {
            console.error('error could not delete schaden', reason);
        });
    };
    DVSchadenfaelleListController.prototype.translateSprache = function (sprache) {
        if (sprache === undefined) {
            return '-';
        }
        return this.$translate.instant(TSSprache_1.TSSprache[sprache]);
    };
    DVSchadenfaelleListController.prototype.getTSSpracheValues = function () {
        return TSSprache_1.getTSSpracheValues();
    };
    DVSchadenfaelleListController.prototype.translateTSSpracheShort = function (sprache) {
        var prefix = 'short_';
        return this.$translate.instant(prefix + TSSprache_1.TSSprache[sprache]);
    };
    DVSchadenfaelleListController.prototype.shouldHighlightOverdueSchadenfall = function (fall) {
        var roles = this.authServiceRS.getPrincipalRoles();
        if (roles) {
            var highestRoleOfBenutzer = this.authServiceRS.getHighestRoleOfBenutzer(roles);
            var status = fall.status;
            var overdueVisibleForStatusAndRole = this.overdueService.isOverdueVisibleForStatusAndRole(highestRoleOfBenutzer, status);
            return !!fall.isOverdue && overdueVisibleForStatusAndRole;
        }
        return false;
    };
    DVSchadenfaelleListController.prototype.shouldHighlightIsNeuInStatusSchadenfall = function (fall) {
        var roles = this.authServiceRS.getPrincipalRoles();
        if (roles) {
            var highestRoleOfBenutzer = this.authServiceRS.getHighestRoleOfBenutzer(roles);
            var status = fall.status;
            var isNeuInStatusVisibleForStatusAndRole = this.isNeuInStatusService.isIsNeuInStatusVisibleForStatusAndRole(highestRoleOfBenutzer, status);
            return !!fall.newInStatus && isNeuInStatusVisibleForStatusAndRole;
        }
        return false;
    };
    DVSchadenfaelleListController.$inject = [
        '$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', '$translate', 'FilterPersistenceService', 'DvDialog',
        'OverdueService', 'AuthServiceRS', 'IsNeuInStatusService', 'SchadenfallModelManager',
    ];
    return DVSchadenfaelleListController;
}());
exports.DVSchadenfaelleListController = DVSchadenfaelleListController;


/***/ }),

/***/ "A3+6":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("KK6q");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./menubar.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./menubar.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "AFTI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSVorleistungArt_1 = __webpack_require__("B37a");
var template = __webpack_require__("WsA+");
__webpack_require__("IBDo");
var DVVorleistungenListComponentConfig = /** @class */ (function () {
    function DVVorleistungenListComponentConfig() {
        this.transclude = false;
        this.bindings = {
            vorleistungen: '=',
            schadenfall: '<',
            onEdit: '&',
            onDelete: '&',
            readonly: '<',
            schaetzung: '<',
        };
        this.template = template;
        this.controller = DVVorleistungenListController;
        this.controllerAs = 'vm';
    }
    return DVVorleistungenListComponentConfig;
}());
exports.DVVorleistungenListComponentConfig = DVVorleistungenListComponentConfig;
var DVVorleistungenListController = /** @class */ (function () {
    /* @ngInject */
    function DVVorleistungenListController($filter, $log, CONSTANTS, $scope, roleUtilService, $window, $translate, $timeout, schadenfallModelManager) {
        this.$filter = $filter;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.$scope = $scope;
        this.roleUtilService = roleUtilService;
        this.$window = $window;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.schadenfallModelManager = schadenfallModelManager;
        this.colnumber = undefined;
        this.vorleistungen = []; //Liste die im Gui angezeigt wird
        this.initViewModel();
    }
    DVVorleistungenListController.prototype.initViewModel = function () {
    };
    DVVorleistungenListController.prototype.$onInit = function () {
        var _this = this;
        this.$timeout(function () {
            _this.initColNumber();
        });
        this.calculateBerechtigterBetragForOldCases();
    };
    DVVorleistungenListController.prototype.calculateBerechtigterBetragForOldCases = function () {
        // the following calculation is for handling old cases, where Berechtigter Betrag belongs to each Vorleistung, not to the Schadenfall
        if (this.schadenfall.berechtigterBetragVorleistungen === null || this.schadenfall.berechtigterBetragVorleistungen === 0) {
            this.schadenfall.berechtigterBetragVorleistungen = this.vorleistungen.reduce(function (accumulator, currentValue) { return accumulator + currentValue.vorleistungDatenFS.berechtigterBetrag; }, 0);
        }
    };
    DVVorleistungenListController.prototype.getFilterroles = function () {
        return this.roleUtilService.getAllRolesButGesuchstellerArray();
    };
    DVVorleistungenListController.prototype.editClicked = function (vorleistungToEdit, event) {
        this.onEdit({ vorleistung: vorleistungToEdit, event: event });
    };
    DVVorleistungenListController.prototype.deleteClicked = function (vorleistungToDelete, event) {
        this.onDelete({ vorleistung: vorleistungToDelete, event: event });
    };
    DVVorleistungenListController.prototype.translateVorleistungArt = function (vorleistungArt) {
        var prefix = TSVorleistungArt_1.vorleistungArtPrefix();
        return this.$translate.instant(prefix + TSVorleistungArt_1.TSVorleistungArt[vorleistungArt]);
    };
    DVVorleistungenListController.prototype.getColumnsNumber = function () {
        if (this.colnumber === undefined) {
            this.initColNumber();
        }
        return this.colnumber;
    };
    DVVorleistungenListController.prototype.initColNumber = function () {
        var element = angular.element('.dv-vorleistungen-list .header-row').first();
        if (element) {
            this.colnumber = element.get(0).childElementCount;
        }
        else {
            //could not determine actual number, just returing an approximation
            this.colnumber = 5;
        }
    };
    DVVorleistungenListController.prototype.calcTotalBetrag = function () {
        var total = 0;
        if (this.vorleistungen !== undefined) {
            try {
                for (var _a = __values(this.vorleistungen), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var obj = _b.value;
                    if (obj && obj.vorleistungDatenFS && obj.vorleistungDatenFS.betrag) {
                        total += obj.vorleistungDatenFS.betrag;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return total;
        var e_1, _c;
    };
    DVVorleistungenListController.prototype.speichernGesuch = function () {
        if (this.schadenfall) {
            this.schadenfallModelManager.saveSchadenfall(this.schadenfall);
        }
    };
    DVVorleistungenListController.$inject = [
        '$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', '$translate',
        '$timeout', 'SchadenfallModelManager',
    ];
    return DVVorleistungenListController;
}());
exports.DVVorleistungenListController = DVVorleistungenListController;


/***/ }),

/***/ "APRe":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header modal-header--bemerkung\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">&times;</button> </div> <div class=\"modal-body modal-header--bemerkung\"> <div class=\"clearfix\"> <span class=\"text\" ng-bind=\"vm.text\"></span> </div> <div ng-if=\"vm.showBegruendung && vm.begruendungscodeOptions.length > 0\"> <label data-translate=\"BEGRUENDUNG\" for=\"defaultText\"></label> <select name=\"schadenObjekt\" id=\"defaultText\" ng-model=\"vm.begruendung\" class=\"form-control\" ng-options=\"vm.getTranslationForCode(obj) for obj in vm.begruendungscodeOptions\" ng-change=\"vm.writeLongTranslationToBemerkung()\"> ng-required=\"true\"> </select> </div> <div ng-if=\"vm.showBemerkung\"> <label data-translate=\"BEMERKUNG\" for=\"newBemerkung\"> </label> <textarea title=\"{{NEUE_BEMERKUNG_ERFASSEN | translate}}\" name=\"newBemerkung\" id=\"newBemerkung\" class=\"form-control input-element\" rows=\"6\" ng-model=\"vm.bemerkung\" maxlength=\"4000\">\n            </textarea> </div> </div> <div class=\"modal-footer modal-footer--bemerkung\"> <div class=\"mainbuttons\"> <div> <button class=\"btn btn-sub-serf\" ng-click=\"vm.cancel()\"> <span data-translate=\"ABBRECHEN\"></span> </button> </div> <div> <button class=\"btn btn-serf\" ng-click=\"vm.ok()\"> <span data-translate=\"AUSFUEHREN\"></span> </button> </div> </div> </div> ";

/***/ }),

/***/ "ARKx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSZahlungsauftraegeSearchresultDTO_1 = __importDefault(__webpack_require__("i6dW"));
var TSZahlungsauftragDTO_1 = __importDefault(__webpack_require__("eHYE"));
/**
 * Service zum verwalten von Zahlungsauftrag Angaben
 *
 */
var ZahlungsauftragRS = /** @class */ (function () {
    /* @ngInject */
    function ZahlungsauftragRS($http, CONSTANTS, $q, $rootScope, $log) {
        this.$http = $http;
        this.CONSTANTS = CONSTANTS;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$log = $log;
        this.serviceURL = this.CONSTANTS.REST_API + 'zahlungsauftrag';
    }
    ZahlungsauftragRS.prototype.searchZahlungsauftraege = function (zahlungsauftraegeSearch) {
        var _this = this;
        return this.$http.post(this.serviceURL + '/search/', zahlungsauftraegeSearch, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            _this.$log.debug('PARSING zahlungsauftraege REST array object', response.data);
            return new TSZahlungsauftraegeSearchresultDTO_1.default().deserialize(response.data);
        });
    };
    ZahlungsauftragRS.prototype.getZahlungsauftraegeForBeitrag = function (beitragId) {
        var _this = this;
        return this.$http.get(this.serviceURL + '/beitrag/' + encodeURIComponent(beitragId))
            .then(function (response) {
            _this.$log.debug('PARSING gesuch REST object ', response.data);
            return new TSZahlungsauftragDTO_1.default().deserialize(response.data);
        });
    };
    ZahlungsauftragRS.prototype.regenerateExcel = function (zahlungsauftragId) {
        return this.$http.get(this.serviceURL + '/regenerateExcelReportZahlungAuftrag/' + encodeURIComponent(zahlungsauftragId))
            .then(function (response) {
            return (response.data ? response.data.id : '');
        });
    };
    ZahlungsauftragRS.$inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];
    return ZahlungsauftragRS;
}());
exports.default = ZahlungsauftragRS;


/***/ }),

/***/ "Adl6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PasswordStrengthService = /** @class */ (function () {
    /* @ngInject */
    function PasswordStrengthService(errorService, $log) {
        this.errorService = errorService;
        this.$log = $log;
    }
    PasswordStrengthService.prototype.checkIfValid = function (password, passwordRepeat) {
        this.errorService.clearAll();
        if (password === undefined || passwordRepeat === undefined) {
            this.$log.debug('not all passwords were defined');
            return false;
        }
        if (password !== passwordRepeat) {
            this.errorService.addMesageAsError('ERROR_PW_SAME');
            return false;
        }
        if (!this.hasNumber(password)) {
            this.errorService.addMesageAsError('ERROR_PW_RESTRICTIONS');
            return false;
        }
        if (!this.hasChar(password)) {
            this.errorService.addMesageAsError('ERROR_PW_RESTRICTIONS');
            return false;
        }
        if (!this.isLongEnough(password)) {
            this.errorService.addMesageAsError('ERROR_PW_RESTRICTIONS');
            return false;
        }
        return true;
    };
    PasswordStrengthService.prototype.hasNumber = function (passwd) {
        var matches = passwd.match(/\d+/g);
        if (matches != null) {
            return true;
        }
        return false;
    };
    PasswordStrengthService.prototype.hasChar = function (passwd) {
        var matches = passwd.match(/[A-Za-z]+/g);
        if (matches != null) {
            return true;
        }
        return false;
    };
    PasswordStrengthService.prototype.isLongEnough = function (passwd) {
        if (passwd.length < 8) {
            return false;
        }
        return true;
    };
    PasswordStrengthService.$inject = ['ErrorService', '$log'];
    return PasswordStrengthService;
}());
exports.default = PasswordStrengthService;


/***/ }),

/***/ "ArUG":
/***/ (function(module, exports) {

module.exports = "<div dv-scroll-nav> <dv-gesuch-navigation title=\"{{vm.getViewTitle()}}\" schadenfall-id=\"{{vm.schadenfall.id}}\" status=\"{{vm.schadenfall.status}}\" sticky=\"sticky\" herkunft=\"{{vm.schadenfall.schadenfallHerkunft}}\"></dv-gesuch-navigation> <div ng-class=\"['bemerkung-view', 'container', {'container-sticky':sticky}]\" ng-if=\"vm.isSchadenFallVisibleAndNotNew()\"> <div class=\"row marginBottom60\"> <div class=\"col-sm-12\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getAllRolesButGesuchstellerAndKanton()\"> <h2 class=\"marginTop0\"> <span data-translate=\"SCHADENFALL_PDF\"></span> </h2> <dv-loading-button button-class=\"btn btn-serf-red\" button-click=\"vm.downloadPDF(event)\" type=\"button\"> <span data-translate=\"PDF_GENERIEREN\"></span> </dv-loading-button> </div> </div> <div class=\"row marginBottom20\"> <div class=\"col-sm-12\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\"> <h2 class=\"marginTop0\"> <span data-translate=\"FONDSSUISSE_DOKUMENTE\"></span> </h2> <dv-dokumentupload schadenfallid=\"vm.schadenfall.id\" parentid=\"vm.getModel().id\" on-doc-removed=\"vm.onDocRemoved(document)\" on-doc-added=\"vm.onDocAdded(document)\" document-type=\"vm.doctype\" begleit-text=\"NUR_FONDSSUISSE\" readonly=\"false\"> </dv-dokumentupload> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <h2 class=\"marginTop0\"> <span data-translate=\"NAV_BEMERKUNG\"></span> </h2> </div> </div> <div class=\"row\"> <div class=\"col-md-12\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <div ng-if=\"!vm.isSchadenFallReadonly()\" class=\"marginBottom60\"> <dv-bemerkung-erfassen schadenfall-id=\"vm.schadenfall.id\" scope=\"vm.scope\"></dv-bemerkung-erfassen> </div> </form> </div> </div> <div class=\"row\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getAllRolesButGesuchsteller()\"> <div class=\"col-xs-4\"> <dv-input-container> <div class=\"checkbox\"> <label> <input ng-value=\"true\" ng-model=\"vm.showBenutzerBemerkungen\" type=\"checkbox\" name=\"benutzerbem\" class=\"input-element\"> <span class=\"md-no-float\" data-translate=\"MANUELL_ERFASSTE_MELDUNG\"></span> </label> </div> </dv-input-container> </div> <div class=\"col-xs-4\"> <dv-input-container> <div class=\"checkbox\"> <label> <input ng-value=\"true\" ng-model=\"vm.showTransitionBemerkungen\" type=\"checkbox\" name=\"transition\" class=\"input-element\"> <span class=\"md-no-float\" data-translate=\"STATUS_MELDUNGEN\"></span> </label> </div> </dv-input-container> </div> <div class=\"col-xs-4\"> <dv-input-container> <div class=\"checkbox\"> <label> <input ng-value=\"false\" ng-model=\"vm.showSystemBemerkungen\" type=\"checkbox\" name=\"system\" class=\"input-element\"> <span class=\"md-no-float\" data-translate=\"MELDUNGEN_DURCH_SYSTEM\"></span> </label> </div> </dv-input-container> </div> </div> <div class=\"marginTop20\"> <dv-bemerkung-list system-bemerkungen=\"vm.schadenfall.systemBemerkungen\" benutzer-bemerkungen=\"vm.schadenfall.benutzerBemerkungen\" transition-bemerkungen=\"vm.schadenfall.transitionBemerkungen\" scope-to-show=\"vm.scopeToShow\" schadenfall-id=\"vm.schadenfall.id\" readonly=\"vm.isSchadenFallReadonly()\" disable-system-bemerkung=\"!vm.showSystemBemerkungen\" disable-transition-bemerkung=\"!vm.showTransitionBemerkungen\" disable-benutzer-bemerkung=\"!vm.showBenutzerBemerkungen\"></dv-bemerkung-list> </div> </div> </div> ";

/***/ }),

/***/ "AtDi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSBegruendungsCode_1 = __webpack_require__("+5XP");
var style = __webpack_require__("oGEB");
var BemerkungDialogController = /** @class */ (function () {
    function BemerkungDialogController($uibModalInstance, $translate, text, begrundungscodeOptions, showBegruendung, showBemerkung) {
        this.$uibModalInstance = $uibModalInstance;
        this.$translate = $translate;
        this.showBegruendung = showBegruendung;
        this.showBemerkung = showBemerkung;
        if (text !== undefined && text !== null) {
            this.text = $translate.instant(text);
        }
        else {
            this.text = 'test';
        }
        if (begrundungscodeOptions === undefined) {
            this.begruendungscodeOptions = TSBegruendungsCode_1.getTSBegruendungsCode();
        }
        else {
            this.begruendungscodeOptions = begrundungscodeOptions;
        }
    }
    BemerkungDialogController.prototype.ok = function () {
        //this.$uibModalInstance.close({lat: this.lat, lon: this.lon});
        this.$uibModalInstance.close({ begruendung: this.begruendung, bemerkung: this.bemerkung });
    };
    ;
    BemerkungDialogController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    ;
    BemerkungDialogController.prototype.writeLongTranslationToBemerkung = function () {
        this.bemerkung = this.getLongTranslationFroCode(this.begruendung);
    };
    BemerkungDialogController.prototype.getLongTranslationFroCode = function (code) {
        var translationKey = TSBegruendungsCode_1.begruendungsCodePrefix() + code + TSBegruendungsCode_1.begruendungsCodeLongPostfix();
        return this.$translate.instant(translationKey);
    };
    BemerkungDialogController.prototype.getTranslationForCode = function (code) {
        var translationKey = TSBegruendungsCode_1.begruendungsCodePrefix() + code + TSBegruendungsCode_1.begruendungsCodeShortPostfix();
        return this.$translate.instant(translationKey);
    };
    BemerkungDialogController.$inject = ['$uibModalInstance', '$translate', 'text', 'begrundungscodeOptions', 'showBegruendung', 'showBemerkung'];
    return BemerkungDialogController;
}());
exports.BemerkungDialogController = BemerkungDialogController;


/***/ }),

/***/ "AwNx":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("lKR4");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-bemerkung-list.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-bemerkung-list.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "AxEI":
/***/ (function(module, exports) {

module.exports = "<div class=\"container anlaufstelleverwaltung-view\"> <div class=\"row\" ng-if=\"!vm.checkIfHasNeverHadVereinbarung() && vm.hasAnlaufstelleWithInvalidVereinbarung()\"> <div class=\"col-md-12\"> <p ng-bind-html=\"vm.getVereinbarungText()\"></p> </div> </div> <div class=\"row vereinbarung-steps\" ng-if=\"vm.checkIfHasNeverHadVereinbarung()\"> <div class=\"col-md-12\"> <h3 data-translate=\"VEREINBARUNG_STEPTS_TITLE\"></h3> <div class=\"marginTop20\"> <h4 data-translate=\"VEREIBARUNG_STEP1\"></h4> <span ng-bind-html=\"vm.getVereinbarungStep1Text()\"></span> </div> <div class=\"marginTop20\"> <h4 data-translate=\"VEREIBARUNG_STEP2\"></h4> <span data-translate=\"VEREIBARUNG_STEP2_TEXT\"></span> </div> <div class=\"marginTop20\"> <h4 data-translate=\"VEREIBARUNG_STEP3\"></h4> <span data-translate=\"VEREIBARUNG_STEP3_TEXT\"></span> </div> </div> </div> <div class=\"row add-button-buffer\"> <div class=\"col-md-12\"> <button ng-click=\"vm.addAnlaufstelle()\" class=\"btn btn-serf-red\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getAdministratorRoles()\"> <span class=\"fa fa-plus btn-ico\"></span> <span data-translate=\"ANLAUFSTELLE_ADD\"> </span> </button> </div> </div> <div class=\"row\"> <div class=\"col-md-12\"> <dv-anlaufstelle-list anlaufstellen=\"vm.anlaufstellen\" on-edit=\"vm.editAnlaufstelle(anlaufstelle, event)\"> </dv-anlaufstelle-list> </div> </div> </div> ";

/***/ }),

/***/ "AzNd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.dv-gemeinde-typeahead__no-results-msg{margin-top:30px}", ""]);

// exports


/***/ }),

/***/ "B37a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSVorleistungArt;
(function (TSVorleistungArt) {
    TSVorleistungArt[TSVorleistungArt["HAGELVERSICHERUNG"] = 'HAGELVERSICHERUNG'] = "HAGELVERSICHERUNG";
    TSVorleistungArt[TSVorleistungArt["GEBAEUDEVERSICHERUNG"] = 'GEBAEUDEVERSICHERUNG'] = "GEBAEUDEVERSICHERUNG";
    TSVorleistungArt[TSVorleistungArt["PRIVATVERSICHERUNG"] = 'PRIVATVERSICHERUNG'] = "PRIVATVERSICHERUNG";
    TSVorleistungArt[TSVorleistungArt["SUBVENTION"] = 'SUBVENTION'] = "SUBVENTION";
    TSVorleistungArt[TSVorleistungArt["SPENDE"] = 'SPENDE'] = "SPENDE";
    TSVorleistungArt[TSVorleistungArt["ANDERE"] = 'ANDERE'] = "ANDERE";
})(TSVorleistungArt = exports.TSVorleistungArt || (exports.TSVorleistungArt = {}));
function getTSVorleistungArten() {
    return [
        TSVorleistungArt.HAGELVERSICHERUNG,
        TSVorleistungArt.GEBAEUDEVERSICHERUNG,
        TSVorleistungArt.PRIVATVERSICHERUNG,
        TSVorleistungArt.SUBVENTION,
        TSVorleistungArt.SPENDE,
        TSVorleistungArt.ANDERE
    ];
}
exports.getTSVorleistungArten = getTSVorleistungArten;
function vorleistungArtPrefix() {
    return 'TSVorleistungArt_';
}
exports.vorleistungArtPrefix = vorleistungArtPrefix;


/***/ }),

/***/ "B4Ew":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(__webpack_require__("PJh5"));
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var TSAnlaufstelleType_1 = __webpack_require__("hYoR");
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSAdresse_1 = __importDefault(__webpack_require__("aL5m"));
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
var TSGemeinde_1 = __importDefault(__webpack_require__("nKms"));
var TSAnlaufstelle = /** @class */ (function (_super) {
    __extends(TSAnlaufstelle, _super);
    function TSAnlaufstelle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._documentIdsToConnect = [];
        _this.maximumLengthOfGemeindeList = 120;
        return _this;
    }
    Object.defineProperty(TSAnlaufstelle.prototype, "jurisdiction", {
        get: function () {
            switch (this._anlaufstelleType) {
                case TSAnlaufstelleType_1.TSAnlaufstelleType.KANTON:
                    return this._kanton ? this._kanton.toString() + (" (" + this._name + ")") : "" + this.name;
                case TSAnlaufstelleType_1.TSAnlaufstelleType.GEMEINDE:
                    if (this._gemeinden) {
                        var blkStr_1 = [];
                        this._gemeinden.forEach(function (g) { return blkStr_1.push(g.name); });
                        var result = blkStr_1.join(', ');
                        if (result.length > this.maximumLengthOfGemeindeList) {
                            result = result.slice(0, this.maximumLengthOfGemeindeList - 1) + '...';
                        }
                        return result + (" (" + this._name + ")");
                    }
                    return "" + this.name;
            }
            return "" + this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAnlaufstelle.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAnlaufstelle.prototype, "kantonOrKantoneFromGemeinden", {
        get: function () {
            if (this._kanton) {
                return this._kanton.toString();
            }
            else {
                return this._gemeinden.map(function (gem) { return gem.kanton; }).join(', ');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAnlaufstelle.prototype, "adresse", {
        get: function () {
            return this._adresse;
        },
        set: function (value) {
            this._adresse = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAnlaufstelle.prototype, "active", {
        get: function () {
            return this._active;
        },
        set: function (value) {
            this._active = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAnlaufstelle.prototype, "anlaufstelleType", {
        get: function () {
            return this._anlaufstelleType;
        },
        set: function (value) {
            this._anlaufstelleType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAnlaufstelle.prototype, "vereinbarungAkzeptiert", {
        get: function () {
            return this._vereinbarungAkzeptiert;
        },
        set: function (value) {
            this._vereinbarungAkzeptiert = value;
        },
        enumerable: true,
        configurable: true
    });
    TSAnlaufstelle.deserializeArray = function (data) {
        var anlaufstelleArray = [];
        if (data && Array.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                anlaufstelleArray[i] = new TSAnlaufstelle().deserialize(data[i]);
            }
        }
        else {
            anlaufstelleArray[0] = new TSAnlaufstelle().deserialize(data);
        }
        return anlaufstelleArray;
    };
    Object.defineProperty(TSAnlaufstelle.prototype, "verwalter", {
        get: function () {
            return this._verwalter;
        },
        set: function (value) {
            this._verwalter = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAnlaufstelle.prototype, "kanton", {
        get: function () {
            return this._kanton;
        },
        set: function (value) {
            this._kanton = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAnlaufstelle.prototype, "gemeinden", {
        get: function () {
            return this._gemeinden;
        },
        set: function (value) {
            this._gemeinden = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAnlaufstelle.prototype, "abteilung", {
        get: function () {
            return this._abteilung;
        },
        set: function (value) {
            this._abteilung = value;
        },
        enumerable: true,
        configurable: true
    });
    TSAnlaufstelle.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.name = restObject.name;
        this.abteilung = restObject.abteilung;
        this.adresse = this.deserializeOrCreate(restObject.adresse, new TSAdresse_1.default());
        this.active = restObject.active;
        this.anlaufstelleType = restObject.anlaufstelleType;
        this.vereinbarungAkzeptiert = DateUtil_1.default.localDateToMoment(restObject.vereinbarungAkzeptiert);
        this.verwalter = this.deserializeOrCreate(restObject.verwalter, new TSBenutzer_1.default());
        this.kanton = restObject.kanton;
        if (restObject.gemeinden) {
            this.gemeinden = restObject.gemeinden.map(TSGemeinde_1.default.getDeserializer);
        }
        return this;
    };
    TSAnlaufstelle.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.name = this.name;
        restObject.abteilung = this.abteilung;
        restObject.adresse = this.serializeOrInit(this.adresse, restObject.adresse);
        restObject.active = this.active;
        restObject.anlaufstelleType = this.anlaufstelleType;
        if (this.vereinbarungAkzeptiert) {
            restObject.vereinbarungAkzeptiert = DateUtil_1.default.momentToLocalDate(this.vereinbarungAkzeptiert);
        }
        restObject.verwalter = this.serializeOrInit(this.verwalter, restObject.verwalter);
        restObject.kanton = this.kanton;
        restObject.gemeinden = this.arrayToRestObject(this.gemeinden);
        return restObject;
    };
    Object.defineProperty(TSAnlaufstelle.prototype, "documentIdsToConnect", {
        get: function () {
            return this._documentIdsToConnect;
        },
        set: function (value) {
            this._documentIdsToConnect = value;
        },
        enumerable: true,
        configurable: true
    });
    TSAnlaufstelle.prototype.isInvalidVereinbarung = function (numberOfYearsValid) {
        if (this.vereinbarungAkzeptiert === undefined
            || this.vereinbarungAkzeptiert === null) {
            return true;
        }
        else {
            var ablaufdatum = moment_1.default(this.vereinbarungAkzeptiert).add(numberOfYearsValid, 'years');
            return ablaufdatum.isBefore(DateUtil_1.default.now());
        }
    };
    TSAnlaufstelle.getDeserializer = function (anlaufstelle) {
        return new TSAnlaufstelle().deserialize(anlaufstelle);
    };
    return TSAnlaufstelle;
}(TSAbstractEntity_1.default));
exports.default = TSAnlaufstelle;


/***/ }),

/***/ "BCxF":
/***/ (function(module, exports) {

module.exports = "<div dv-scroll-nav> <dv-gesuch-navigation herkunft=\"{{vm.model.schadenfallHerkunft}}\" schadenfall-id=\"{{vm.model.id}}\" status=\"{{vm.model.status}}\" sticky=\"sticky\" title=\"{{vm.getViewTitle()}}\"></dv-gesuch-navigation> <div ng-class=\"['schadenfall-view', 'container', {'container-sticky':sticky}]\"> <form name=\"vm.form\" ng-if=\"vm.isSchadenFallVisible()\" novalidate role=\"form\" unsaved-warning-form> <fieldset ng-disabled=\"vm.isSchadenFallReadonly()\"> <div class=\"row\"> <div class=\"col-sm-12\"> <h2 class=\"marginTop0\"> <span data-translate=\"DAS_GESUCH\"></span> </h2> <div class=\"row\"> <dv-string-input bisher-fs=\"vm.model.schadenfallDatenFS\" bisher-gs=\"vm.model.schadenfallDatenGS\" bisher-property=\"titel\" clazz=\"col-sm-6\" label=\"SCHADENEREIGNIS\" model=\"vm.model.schadenfallDatenFS.titel\" name=\"titel\"> </dv-string-input> <div class=\"col-sm-6\"> <dv-gemeinde-typeahead bisher-fs=\"vm.model.schadenfallDatenFS.gemeinde\" bisher-gs=\"vm.model.schadenfallDatenGS.gemeinde\" input-name=\"gemeindeName\" input-placeholder=\"START_TYPING\" label=\"SCHADENORT\" selected-gemeinde=\"vm.model.schadenfallDatenFS.gemeinde\" exclude-kanton-gr=\"true\"></dv-gemeinde-typeahead> </div> </div> <fieldset class=\"row\" dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\" dv-show-element dv-show-expression=\"vm.showManuelleAnlaufstellenZuweisungFS()\"> <div class=\"col-sm-6\"> <dv-input-container> <dv-anlaufstelle-typeahead input-name=\"anlaufstellenSelect\" input-placeholder=\"START_TYPING\" label=\"ANLAUFSTELLE_WECHSELN\" selected-anlaufstelle=\"vm.model.anlaufstelle\"></dv-anlaufstelle-typeahead> </dv-input-container> </div> </fieldset> </div> </div> </fieldset> <fieldset ng-disabled=\"false\" ng-if=\"vm.isSchadenFallVisible() && vm.isOnlyOneSchadenVorhanden()\"> <dv-schaden-edit-view schaden=\"vm.model.schaeden[0]\" schadenfall=\"vm.model\" on-save=\"vm.speichernGesuch()\" readonly=\"vm.isSchadenFallReadonly()\"> </dv-schaden-edit-view> </fieldset> <div class=\"row marginTop20\" ng-if=\"vm.isEreignisSaved() && !vm.isOnlyOneSchadenVorhanden()\"> <fieldset class=\"col-sm-12\" ng-disabled=\"vm.isSchadenFallReadonly()\" ng-if=\"vm.isSchadenFallVisible()\"> <div class=\"h2\"> <span data-translate=\"DIE_SCHAEDEN\"></span> </div> <div ng-if=\"!vm.isSchadenFallReadonly()\"> <button class=\"btn btn-serf-red\" ng-click=\"vm.addSchaden()\" ng-disabled=\"vm.hasSchaeden()\" type=\"submit\"> <span class=\"fa fa-flash btn-ico\"></span> <span data-translate=\"SCHADEN_ERSTELLEN\" ng-if=\"!vm.hasSchaeden()\"></span> <span data-translate=\"SCHADEN_HINZUFUEGEN\" ng-if=\"vm.hasSchaeden()\"></span> </button> <span class=\"marginLeft10\" data-translate=\"NUR_EIN_SCHADEN\" ng-if=\"vm.hasSchaeden()\"></span> </div> </fieldset> <div class=\"col-sm-12\"> <dv-schaden-list on-delete=\"vm.deleteSchaden(schaden, event)\" on-edit=\"vm.editSchaden(schaden, event)\" readonly=\"vm.isSchadenFallReadonly()\" schadenfall-id=\"vm.schadenfall.id\" schaeden=\"vm.schadenfall.schaeden\"> </dv-schaden-list> </div> </div> <fieldset class=\"row marginTop20\" dv-show-allowed-roles=\"vm.roleUtilService.getRolesAllowedForSchaetzer()\" dv-show-element dv-show-expression=\"vm.showSchaetzerZuweisung()\"> <div class=\"col-sm-12\"> <div class=\"h2\"> <span data-translate=\"DIE_SCHAETZER\"></span> </div> </div> <div class=\"col-xs-4\" ng-if=\"!vm.isSchadenFallReadonly()\"> <dv-input-container> <label class=\"md-no-float\" for=\"schaetzerSelect\"></label> <select class=\"form-control\" id=\"schaetzerSelect\" name=\"schaetzerSelection\" ng-model=\"vm.selectedSchaetzer\" ng-options=\"schaetzer.getFullName() for schaetzer in vm.getAvailableSchaezter() \" ng-required=\"false\"> </select> <dv-error-messages for=\"form.schaetzerSelection\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-xs-2\" ng-if=\"!vm.isSchadenFallReadonly()\"> <button class=\"btn btn-serf-red add-schaetzer-button\" ng-click=\"vm.addSchaetzer()\" ng-disabled=\"vm.selectedSchaetzer === undefined\" type=\"button\"> <span class=\"fa fa-plus btn-ico\"></span> <span data-translate=\"SCHAETZER_ADD\"></span> </button> </div> <div class=\"col-sm-12\"> <dv-benutzer-list benutzerlist=\"vm.schadenfall.schaetzer\" on-delete=\"vm.removeSchaetzer(benutzer,event)\" show-actions=\"!vm.isSchadenFallReadonly()\" show-filter=\"false\" show-role=\"false\"> </dv-benutzer-list> </div> </fieldset> <div ng-if=\"!vm.isSchadenFallNeu()\"> <div class=\"col-sm-12 row marginTop20\"> <div class=\"h2\"> <span data-translate=\"STATUS_CHANGE_HISTORY\"></span> </div> </div> <div> <dv-status-change-history-list schadenfall-id=\"vm.schadenfall.id\" scope-to-show=\"vm.scopeToShow\" transition-bemerkungen=\"vm.schadenfall.transitionBemerkungen\"></dv-status-change-history-list> </div> </div> <fieldset class=\"row marginTop20\" dv-show-allowed-roles=\"vm.roleUtilService.getSuperAdminRoles()\" dv-show-element dv-show-expression=\"vm.isEreignisSaved()\"> <div class=\"col-sm-12\"> <div class=\"h2\"> <span data-translate=\"STATUS\"></span> </div> </div> <div class=\"col-sm-4\"> <dv-input-container> <label class=\"md-no-float\" for=\"statusSelect\"></label> <select class=\"form-control\" id=\"statusSelect\" name=\"statusSelection\" ng-model=\"vm.model.status\" ng-options=\"status | translate for status in vm.getSchadenfallStatusList() track by status\" ng-required=\"false\"> </select> </dv-input-container> </div> <div class=\"col-xs-2\" ng-if=\"!vm.isSchadenFallReadonly()\"> <button class=\"btn btn-serf-red add-schaetzer-button\" ng-click=\"vm.updateStatus()\" ng-disabled=\"vm.model.status === undefined || vm.model.status === vm.initialModel.status\" type=\"button\"> <span data-translate=\"STATUS_AKTUALISIEREN\"></span> </button> </div> </fieldset> </form> <fieldset ng-if=\"vm.isSchadenFallVisible()\"> <form novalidate> <div class=\"row\"> <div class=\"col-md-12\"> <div class=\"row marginTop20\" ng-disabled=\"vm.isSchadenFallReadonly()\"> <div class=\"col-sm-12\"> <div class=\"h2 clearfix\"> <span data-translate=\"BEMERKUNGEN\"></span> </div> <div class=\"marginBottom60\" ng-if=\"!vm.isSchadenFallReadonly()\"> <dv-bemerkung-erfassen ng-if=\"!vm.isSchadenFallReadonly()\" schadenfall-id=\"vm.schadenfall.id\" scope=\"vm.scope\"></dv-bemerkung-erfassen> </div> <div> <dv-bemerkung-list benutzer-bemerkungen=\"vm.schadenfall.benutzerBemerkungen\" readonly=\"vm.isSchadenFallReadonly()\" schadenfall-id=\"vm.schadenfall.id\" scope-to-show=\"vm.scopeToShow\" system-bemerkungen=\"vm.schadenfall.systemBemerkungen\" transition-bemerkungen=\"vm.schadenfall.transitionBemerkungen\"></dv-bemerkung-list> </div> </div> </div> </div> </div> <fieldset ng-if=\"vm.canLoeschen()\"> <div class=\"mainbuttons-freigeben marginTop60\"> <dv-loading-button button-class=\"btn btn-sub-serf btn-loeschen\" button-click=\"vm.schadenfallloeschen()\" button-disabled=\"!vm.canLoeschen()\" type=\"submit\"> <span class=\"text-uppercase\" data-translate=\"SCHADENFALL_LOESCHEN\"></span> </dv-loading-button> </div> </fieldset> <div class=\"row marginTop60\" ng-if=\"vm.isFreigabeVisible()\"> <div class=\"checklist\"> <div class=\"h2 clearfix\"> <span data-translate=\"CHECKLISTE\"></span> </div> <dv-checklist checklist-points=\"vm.getChecklistEntries()\" on-checkstatus-chaged=\"vm.checklistStatusChanged(allchecked)\"></dv-checklist> </div> </div> </form> </fieldset> <fieldset ng-if=\"vm.isSchadenFallVisible()\" ng-disabled=\"vm.isSchadenFallReadonly()\"> <div class=\"row mainbuttons\"> <dv-loading-button button-class=\"btn btn-sub-serf\" button-click=\"vm.beenden()\" type=\"submit\"> <span data-translate=\"BEENDEN_SPEICHERN\"></span> </dv-loading-button> </div> </fieldset> <div ng-if=\"vm.isSchadenFallVisible()\"> <fieldset ng-disabled=\"vm.isSchadenFallReadonly()\"> <div class=\"row mainbuttons\" dv-show-allowed-roles=\"vm.roleUtilService.getGesuchstellerRoles()\" dv-show-element dv-show-expression=\"vm.freigebenGS()\"> <dv-loading-button button-class=\"btn btn-serf\" button-click=\"vm.next()\" type=\"submit\"> <span class=\"text-uppercase\" data-translate=\"FREIGEBEN\"></span> </dv-loading-button> </div> </fieldset> <fieldset ng-disabled=\"vm.isSchadenFallReadonly()\"> <div class=\"row mainbuttons\" dv-show-allowed-roles=\"vm.roleUtilService.getAnlaufstelleRoles()\" dv-show-element dv-show-expression=\"vm.freigebenAnlaufstelle()\"> <dv-loading-button button-class=\"btn btn-serf\" button-click=\"vm.next()\" type=\"submit\"> <span class=\"text-uppercase\" data-translate=\"FREIGEBEN_PAPIER\"></span> </dv-loading-button> </div> </fieldset> <fieldset ng-disabled=\"vm.isSchadenFallReadonly()\"> <div class=\"row freigebenfs\" ng-if=\"vm.isFreigabeVisible()\"> <div class=\"col-sm-12\"> <div class=\"row\"> <div class=\"col-sm-12 schadenevents\"> <dv-input-container> <div class=\"radio\" ng-repeat=\"schadenfallEvent in vm.getSchadenfallEvents()\"> <label> <input aria-label=\"{{schadenfallEvent}}\" class=\"input-element notRequiredForFreigabe\" name=\"schadenfallEvent\" ng-disabled=\"vm.isFreigabeDisabled()\" ng-model=\"vm.schadenfallEvent\" ng-required=\"true\" ng-value=\"schadenfallEvent\" type=\"radio\"> <span>{{schadenfallEvent | translate}}</span> </label> </div> </dv-input-container> </div> </div> </div> <div class=\"mainbuttons-freigeben\"> <dv-loading-button button-class=\"btn btn-serf\" button-click=\"vm.next()\" button-disabled=\"!vm.schadenfallEvent\" type=\"submit\"> <span class=\"text-uppercase\" data-translate=\"FREIGEBEN\"></span> </dv-loading-button> </div> </div> </fieldset> </div> </div> </div> ";

/***/ }),

/***/ "BH0P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSRole_1 = __webpack_require__("MleR");
var AuthenticationUtil = /** @class */ (function () {
    function AuthenticationUtil() {
    }
    /**
     *  Navigiert basierend auf der Rolle zu einer anderen Startseite
     */
    AuthenticationUtil.navigateToStartPageForRole = function (role, $state) {
        if (role === TSRole_1.TSRole.SUPER_ADMIN) {
            $state.go('admin');
        }
        else if (role === TSRole_1.TSRole.FONDSSUISSE_ADMIN || role === TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER || role === TSRole_1.TSRole.BETROFFENER
            || role === TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER || role === TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER) {
            $state.go('schadenfaelle');
        }
        else if (role === TSRole_1.TSRole.ANLAUFSTELLE_VERWALTER) {
            $state.go('anlaufstelleverwaltung');
        }
        else if (role === TSRole_1.TSRole.KANTON_INSPEKTOR) {
            $state.go('schadenfaelle');
        }
        else if (role === TSRole_1.TSRole.KANTON_VERWALTER) {
            $state.go('inspektoratverwaltung');
        }
        else {
            console.error('Achtung, keine Startpage definiert fuer Rolle ', role);
        }
    };
    return AuthenticationUtil;
}());
exports.default = AuthenticationUtil;


/***/ }),

/***/ "BawY":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("TnNA");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-fremdkosten-list.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-fremdkosten-list.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Bftz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSBeitragStatus_1 = __webpack_require__("RtaT");
/*
 * Copyright © 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSBankverbindung_1 = __importDefault(__webpack_require__("iMHU"));
var TSBeitrag = /** @class */ (function (_super) {
    __extends(TSBeitrag, _super);
    function TSBeitrag() {
        var _this = _super.call(this) || this;
        /*transient*/
        _this._selected = false;
        _this.beitragStatus = TSBeitragStatus_1.TSBeitragStatus.NICHT_FREIGEGEBEN;
        return _this;
    }
    TSBeitrag.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.beitragArt = restObject.beitragArt;
        this.beitragType = restObject.beitragType;
        this.beitragStatus = restObject.beitragStatus;
        this.beitrag = restObject.beitrag;
        this.importiertAbzugEV = restObject.importiertAbzugEV;
        this.vorname = restObject.vorname;
        this.name = restObject.name;
        this.bankverbindung = this.deserializeOrCreate(restObject.bankverbindung, new TSBankverbindung_1.default());
        this.bemerkung = restObject.bemerkung;
        this.sachbearbeiterMaxUeberschritten = restObject.sachbearbeiterMaxUeberschritten;
        return this;
    };
    TSBeitrag.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.beitragArt = this.beitragArt;
        restObject.beitragType = this.beitragType;
        restObject.beitragStatus = this.beitragStatus;
        restObject.beitrag = this.beitrag;
        restObject.importiertAbzugEV = this.importiertAbzugEV;
        restObject.vorname = this.vorname;
        restObject.name = this.name;
        restObject.bankverbindung = this.serializeOrInit(this.bankverbindung, restObject.bankverbindung);
        restObject.bemerkung = this.bemerkung;
        return restObject;
    };
    Object.defineProperty(TSBeitrag.prototype, "beitragArt", {
        get: function () {
            return this._beitragArt;
        },
        set: function (value) {
            this._beitragArt = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitrag.prototype, "beitrag", {
        get: function () {
            return this._beitrag;
        },
        set: function (value) {
            this._beitrag = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitrag.prototype, "importiertAbzugEV", {
        get: function () {
            return this._importiertAbzugEV;
        },
        set: function (value) {
            this._importiertAbzugEV = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitrag.prototype, "vorname", {
        get: function () {
            return this._vorname;
        },
        set: function (value) {
            this._vorname = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitrag.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitrag.prototype, "bankverbindung", {
        get: function () {
            return this._bankverbindung;
        },
        set: function (value) {
            this._bankverbindung = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitrag.prototype, "bemerkung", {
        get: function () {
            return this._bemerkung;
        },
        set: function (value) {
            this._bemerkung = value;
        },
        enumerable: true,
        configurable: true
    });
    TSBeitrag.prototype.getFullname = function () {
        if (this.vorname) {
            return this.vorname + ' ' + this.name;
        }
        return this.name;
    };
    TSBeitrag.prototype.getBeguenstigterName = function () {
        if (this._bankverbindung) {
            return this._bankverbindung.inhaberName;
        }
        return this.getFullname();
    };
    Object.defineProperty(TSBeitrag.prototype, "beitragStatus", {
        get: function () {
            return this._beitragStatus;
        },
        set: function (value) {
            this._beitragStatus = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitrag.prototype, "selected", {
        get: function () {
            return this._selected;
        },
        set: function (value) {
            this._selected = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitrag.prototype, "sachbearbeiterMaxUeberschritten", {
        get: function () {
            return this._sachbearbeiterMaxUeberschritten;
        },
        set: function (value) {
            this._sachbearbeiterMaxUeberschritten = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitrag.prototype, "beitragType", {
        get: function () {
            return this._beitragType;
        },
        set: function (value) {
            this._beitragType = value;
        },
        enumerable: true,
        configurable: true
    });
    TSBeitrag.getDeserializer = function (beitrag) {
        return new TSBeitrag().deserialize(beitrag);
    };
    TSBeitrag.getSerializer = function (beitrag) {
        return beitrag.serialize(beitrag);
    };
    return TSBeitrag;
}(TSAbstractEntity_1.default));
exports.default = TSBeitrag;


/***/ }),

/***/ "Bk8f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var styles = __webpack_require__("C7VL");
var template = __webpack_require__("JAde");
var AbschlussViewComponentConfig = /** @class */ (function () {
    function AbschlussViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = AbschlussViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            titleText: '<',
            messageText: '<',
            buttonText: '<',
            stateToGoTo: '<',
        };
    }
    return AbschlussViewComponentConfig;
}());
exports.AbschlussViewComponentConfig = AbschlussViewComponentConfig;
var AbschlussViewController = /** @class */ (function () {
    /* @ngInject */
    function AbschlussViewController($scope, $translate, $log, $state) {
        this.$translate = $translate;
        this.$log = $log;
        this.$state = $state;
    }
    AbschlussViewController.prototype.$onInit = function () {
        if (!this.titleText) {
            this.titleText = 'ABSCHLUSS_TITLE';
        }
        if (!this.messageText) {
            this.messageText = 'ABSCHLUSS_TEXT';
        }
        if (!this.buttonText) {
            this.buttonText = 'ABSCHLUSS_BUTTON_TEXT';
        }
        if (!this.stateToGoTo) {
            this.stateToGoTo = 'schadenfaelle';
        }
    };
    AbschlussViewController.prototype.getInfoTitle = function () {
        return this.$translate.instant(this.titleText);
    };
    AbschlussViewController.prototype.getInfoText = function () {
        return this.$translate.instant(this.messageText);
    };
    AbschlussViewController.prototype.getButtonText = function () {
        return this.$translate.instant(this.buttonText);
    };
    AbschlussViewController.prototype.navigate = function () {
        this.$state.go(this.stateToGoTo);
    };
    AbschlussViewController.$inject = ['$scope', '$translate', '$log', '$state'];
    return AbschlussViewController;
}());
exports.AbschlussViewController = AbschlussViewController;


/***/ }),

/***/ "C6dp":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("OUBf");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./anlaufstelleRegistrierungView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./anlaufstelleRegistrierungView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "C7VL":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("xj3l");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./abschlussView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./abschlussView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "C9tV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("lRDB");
var TSAnrede_1 = __webpack_require__("h+M8");
var TSSprache_1 = __webpack_require__("3oUo");
var template = __webpack_require__("RJX8");
var DVBenutzerprofilComponentConfig = /** @class */ (function () {
    function DVBenutzerprofilComponentConfig() {
        this.transclude = false;
        this.bindings = {
            benutzer: '=',
            readonly: '<',
            hidePasswordEntry: '<',
            doubleEmailEntry: '<',
            pwChangeWithButton: '<',
            onChangePassword: '&',
            noEmailEntry: '<',
            phoneRequired: '<',
        };
        this.template = template;
        this.controller = DVBenutzerprofilController;
        this.controllerAs = 'vm';
        this.bindToController = true;
    }
    return DVBenutzerprofilComponentConfig;
}());
exports.DVBenutzerprofilComponentConfig = DVBenutzerprofilComponentConfig;
var DVBenutzerprofilController = /** @class */ (function () {
    function DVBenutzerprofilController($scope, CONSTANTS) {
        this.$scope = $scope;
        this.CONSTANTS = CONSTANTS;
        this.pressedChangePassword = false;
        this.noEmailEntry = false;
        this.phoneRequired = false;
        this.pattern = this.CONSTANTS.PATTERN_PHONE_OPTIONAL;
    }
    DVBenutzerprofilController.prototype.$onInit = function () {
        var _this = this;
        if (this.benutzer && this.benutzer.passwordData) {
            this.$scope.$watch(function () {
                return _this.benutzer.passwordData.email;
            }, function () {
                if (_this.benutzer.passwordData.email) {
                    _this.benutzer.email = _this.benutzer.passwordData.email;
                }
                else {
                    _this.benutzer.email = '';
                }
            });
        }
        if (this.readonly === undefined) {
            this.readonly = false;
        }
        if (this.hidePasswordEntry === undefined) {
            this.hidePasswordEntry = false;
        }
        if (this.doubleEmailEntry === undefined) {
            this.doubleEmailEntry = false;
        }
        if (this.pwChangeWithButton === undefined) {
            this.pwChangeWithButton = false;
        }
        if (this.noEmailEntry === undefined) {
            this.noEmailEntry = false;
        }
        this.pwChangerEmailVisible = !this.doubleEmailEntry; //wenn wir email schon zweimal eingeben lassen dann brauchts das nicht mehr
        //if user was already sotred we are in edit mode, so we can set the repetition email to the current value
        if (this.benutzer && !this.benutzer.isNew()) {
            this.benutzer.emailRepeat = this.benutzer.email;
        }
        if (this.phoneRequired === undefined) {
            this.phoneRequired = false;
        }
    };
    DVBenutzerprofilController.prototype.getTSAnredeValues = function () {
        return TSAnrede_1.getTSAnredeValues();
    };
    DVBenutzerprofilController.prototype.getModel = function () {
        return this.benutzer;
    };
    DVBenutzerprofilController.prototype.getTSSpracheValues = function () {
        return TSSprache_1.getTSSpracheValues();
    };
    DVBenutzerprofilController.prototype.changePassword = function (event) {
        this.pressedChangePassword = true;
        this.onChangePassword({ event: event });
    };
    DVBenutzerprofilController.$inject = ['$scope', 'CONSTANTS'];
    return DVBenutzerprofilController;
}());
exports.DVBenutzerprofilController = DVBenutzerprofilController;


/***/ }),

/***/ "CVPs":
/***/ (function(module, exports) {

module.exports = "<dv-input-container ng-form=\"typeaheadForm\" class=\"dv-benutzer-typeahead\"> <label for=\"{{vm.inputName}}\" class=\"md-no-float\" data-translate=\"{{vm.label}}\"></label> <input name=\"{{vm.inputName}}\" id=\"{{vm.inputName}}\" ng-model=\"vm.selectedBenutzer\" placeholder=\"{{vm.inputPlaceholder | translate}}\" uib-typeahead=\"benutzer as (benutzer.email + ' (' + benutzer.getFullName()+ ')') for benutzer in vm.loadSuggestElements($viewValue)\" typeahead-loading=\"loadingLocations\" typeahead-editable=\"false\" typeahead-select-on-exact=\"true\" ng-required=\"vm.valueRequired\" ng-disabled=\"vm.inputDisabled\" typeahead-select-on-blur=\"true\" autocomplete=\"false\" typeahead-no-results=\"noResults\" class=\"form-control\"> <i ng-show=\"loadingLocations\" class=\"glyphicon glyphicon-refresh\"></i> <dv-error-messages for=\"typeaheadForm[vm.inputName]\"></dv-error-messages> <div ng-show=\"noResults\" class=\"dv-benutzer-typeahead__no-results-msg\"> <i class=\"glyphicon glyphicon-remove\"></i> {{\"NO_RESULTS_FOUND\" | translate}} </div> </dv-input-container> ";

/***/ }),

/***/ "CYbW":
/***/ (function(module, exports) {

module.exports = " <div class=\"modal-header\"> <h3 class=\"modal-title\" style=\"float:left\">{{ vm.title }}</h3> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> </div> <div class=\"modal-body\"> {{ vm.text }} </div> <div class=\"modal-footer\"> <button class=\"btn btn-serf\" ng-click=\"vm.cancel()\" data-translate=\"ABBRECHEN\"></button> <button class=\"btn btn-serf\" ng-click=\"vm.ok()\">OK</button> </div> ";

/***/ }),

/***/ "CbzH":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("n/H1");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-pie-charts.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-pie-charts.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "CcdS":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "dv-versicherungsbeitrag-list .header-row{white-space:nowrap}dv-versicherungsbeitrag-list:focus{outline:none}dv-versicherungsbeitrag-list .row-ext-schadennr{width:25%}dv-versicherungsbeitrag-list .row-schadendatum,dv-versicherungsbeitrag-list .row-versicherung{width:10%}dv-versicherungsbeitrag-list .row-beitrag{width:15%}dv-versicherungsbeitrag-list .row-status{width:200px}dv-versicherungsbeitrag-list .row-actions{width:90px}", ""]);

// exports


/***/ }),

/***/ "CiKD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSSchadenfallStatus;
(function (TSSchadenfallStatus) {
    TSSchadenfallStatus[TSSchadenfallStatus["NEU"] = 'NEU'] = "NEU";
    TSSchadenfallStatus[TSSchadenfallStatus["NEU_PAPIER_ANLAUFSTELLE"] = 'NEU_PAPIER_ANLAUFSTELLE'] = "NEU_PAPIER_ANLAUFSTELLE";
    TSSchadenfallStatus[TSSchadenfallStatus["NEU_PAPIER_FS"] = 'NEU_PAPIER_FS'] = "NEU_PAPIER_FS";
    TSSchadenfallStatus[TSSchadenfallStatus["IN_BEARBEITUNG_ANLAUFSTELLE"] = 'IN_BEARBEITUNG_ANLAUFSTELLE'] = "IN_BEARBEITUNG_ANLAUFSTELLE";
    TSSchadenfallStatus[TSSchadenfallStatus["IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS"] = 'IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS'] = "IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS";
    TSSchadenfallStatus[TSSchadenfallStatus["AUFTRAG_SCHAETZER"] = 'AUFTRAG_SCHAETZER'] = "AUFTRAG_SCHAETZER";
    TSSchadenfallStatus[TSSchadenfallStatus["UEBERPRUEFUNG_ANLAUFSTELLE"] = 'UEBERPRUEFUNG_ANLAUFSTELLE'] = "UEBERPRUEFUNG_ANLAUFSTELLE";
    TSSchadenfallStatus[TSSchadenfallStatus["UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS"] = 'UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS'] = "UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS";
    TSSchadenfallStatus[TSSchadenfallStatus["UEBERPRUEFUNG_FONDSSUISSE"] = 'UEBERPRUEFUNG_FONDSSUISSE'] = "UEBERPRUEFUNG_FONDSSUISSE";
    TSSchadenfallStatus[TSSchadenfallStatus["WIEDERHERSTELLUNG"] = 'WIEDERHERSTELLUNG'] = "WIEDERHERSTELLUNG";
    TSSchadenfallStatus[TSSchadenfallStatus["UEBERPRUEFUNG_SCHAETZER"] = 'UEBERPRUEFUNG_SCHAETZER'] = "UEBERPRUEFUNG_SCHAETZER";
    TSSchadenfallStatus[TSSchadenfallStatus["SCHADEN_BEHOBEN_ABRECHNEN"] = 'SCHADEN_BEHOBEN_ABRECHNEN'] = "SCHADEN_BEHOBEN_ABRECHNEN";
    TSSchadenfallStatus[TSSchadenfallStatus["AUSZAHLUNG"] = 'AUSZAHLUNG'] = "AUSZAHLUNG";
    TSSchadenfallStatus[TSSchadenfallStatus["ABGESCHLOSSEN"] = 'ABGESCHLOSSEN'] = "ABGESCHLOSSEN";
    TSSchadenfallStatus[TSSchadenfallStatus["ABGELEHNT_ANLAUFSTELLE"] = 'ABGELEHNT_ANLAUFSTELLE'] = "ABGELEHNT_ANLAUFSTELLE";
    TSSchadenfallStatus[TSSchadenfallStatus["ABGELEHNT_FONDSSUISSE"] = 'ABGELEHNT_FONDSSUISSE'] = "ABGELEHNT_FONDSSUISSE";
    TSSchadenfallStatus[TSSchadenfallStatus["IMPORTIERT"] = 'IMPORTIERT'] = "IMPORTIERT";
})(TSSchadenfallStatus = exports.TSSchadenfallStatus || (exports.TSSchadenfallStatus = {}));
function getTSSchadenfallStatusalues() {
    return [
        TSSchadenfallStatus.NEU,
        TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE,
        TSSchadenfallStatus.NEU_PAPIER_FS,
        TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE,
        TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS,
        TSSchadenfallStatus.AUFTRAG_SCHAETZER,
        TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE,
        TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS,
        TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE,
        TSSchadenfallStatus.WIEDERHERSTELLUNG,
        TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER,
        TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN,
        TSSchadenfallStatus.AUSZAHLUNG,
        TSSchadenfallStatus.ABGESCHLOSSEN,
        TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE,
        TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE,
    ];
}
exports.getTSSchadenfallStatusalues = getTSSchadenfallStatusalues;
function getTSSchadenfallStatusOffen() {
    return [
        TSSchadenfallStatus.NEU,
        TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE,
        TSSchadenfallStatus.NEU_PAPIER_FS,
        TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE,
        TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS,
        TSSchadenfallStatus.AUFTRAG_SCHAETZER,
        TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE,
        TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS,
        TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE,
        TSSchadenfallStatus.WIEDERHERSTELLUNG,
        TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER,
        TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN,
        TSSchadenfallStatus.AUSZAHLUNG,
    ];
}
exports.getTSSchadenfallStatusOffen = getTSSchadenfallStatusOffen;
function getTSSchadenfallStatusGeschlossen() {
    return [
        TSSchadenfallStatus.ABGESCHLOSSEN,
        TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE,
        TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE,
    ];
}
exports.getTSSchadenfallStatusGeschlossen = getTSSchadenfallStatusGeschlossen;
function getTSSchadenfallStatusNeu() {
    return [
        TSSchadenfallStatus.NEU,
        TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE,
        TSSchadenfallStatus.NEU_PAPIER_FS,
    ];
}
exports.getTSSchadenfallStatusNeu = getTSSchadenfallStatusNeu;
/**
 * Returns true when the status of the Gesuch is Geschlossen
 * @returns {boolean}
 */
function isStatusGeschlossen(status) {
    return isInStatus(status, getTSSchadenfallStatusGeschlossen());
}
exports.isStatusGeschlossen = isStatusGeschlossen;
function isInStatus(status, statusArray) {
    try {
        for (var statusArray_1 = __values(statusArray), statusArray_1_1 = statusArray_1.next(); !statusArray_1_1.done; statusArray_1_1 = statusArray_1.next()) {
            var istatus = statusArray_1_1.value;
            if (istatus === status) {
                return true;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (statusArray_1_1 && !statusArray_1_1.done && (_a = statusArray_1.return)) _a.call(statusArray_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
    var e_1, _a;
}
exports.isInStatus = isInStatus;


/***/ }),

/***/ "Ciwb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
cockpitRun.$inject = ['RouterHelper'];
/* @ngInject */
function cockpitRun(routerHelper) {
    routerHelper.configureStates(getStates());
}
exports.cockpitRun = cockpitRun;
function getStates() {
    return [
        {
            name: 'cockpit',
            template: '<cockpit-view flex="auto" class="overflow-scroll"></cockpit-view>',
            url: '/cockpit',
        },
    ];
}


/***/ }),

/***/ "CuBj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/comp-5.d9f03315e3046455b6c7e0ca9f336ce5.jpg";

/***/ }),

/***/ "D/ui":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__("PJh5");
var VereinbarungAkzeptiertService = /** @class */ (function () {
    /* @ngInject */
    function VereinbarungAkzeptiertService(errorService, $log, authService, roleUtilService, benutzerRS, anlaufstelleRS, CONSTANTS, $state, applicationPropertyRS) {
        this.errorService = errorService;
        this.$log = $log;
        this.authService = authService;
        this.roleUtilService = roleUtilService;
        this.benutzerRS = benutzerRS;
        this.anlaufstelleRS = anlaufstelleRS;
        this.CONSTANTS = CONSTANTS;
        this.$state = $state;
        this.applicationPropertyRS = applicationPropertyRS;
        this.vereinbarungValid = 0;
    }
    VereinbarungAkzeptiertService.prototype.$onInit = function () {
        var _this = this;
        this.applicationPropertyRS.getVereinbarungValidYears().then(function (response) {
            _this.vereinbarungValid = response;
        });
    };
    VereinbarungAkzeptiertService.prototype.checkVereinbarungAkzeptiert = function () {
        var _this = this;
        var isAnlaufstelleVerwalter = this.authService.isOneOfRoles(this.roleUtilService.getAnlaufstelleVerwalterOnlyRole());
        if (isAnlaufstelleVerwalter) {
            var principal = this.authService.getPrincipal();
            if (principal !== undefined) {
                //anlaufstellen lesen fuer die der benutzer der verwalter ist
                this.benutzerRS.getAnlaufstellenForBenutzer(principal.id).then(function (anlaufstellen) {
                    var missingVereinbarungAnlaufstellen = _this.filterAbgelaufeneAnlaufstellen(anlaufstellen);
                    if (missingVereinbarungAnlaufstellen.length !== 0) {
                        _this.$log.warn('Not all Vereinbarungen are akzeptiert, redirecting to page Anlaufstellenverwaltung');
                        var verwaltungParams = void 0;
                        verwaltungParams = { missingVereinbarungAnlaufstelle: missingVereinbarungAnlaufstellen };
                        _this.$state.go('anlaufstelleverwaltung', verwaltungParams);
                    }
                });
            }
            //checken ob die anlaufs
        }
    };
    VereinbarungAkzeptiertService.prototype.filterAbgelaufeneAnlaufstellen = function (anlaufstellen) {
        var invalidAnlaufstellen = [];
        try {
            for (var anlaufstellen_1 = __values(anlaufstellen), anlaufstellen_1_1 = anlaufstellen_1.next(); !anlaufstellen_1_1.done; anlaufstellen_1_1 = anlaufstellen_1.next()) {
                var currAnlaufstelle = anlaufstellen_1_1.value;
                var akzeptiertDate = currAnlaufstelle.vereinbarungAkzeptiert;
                //wenn noch nicht akzeptiert oder schon abgelaufen
                if (akzeptiertDate === undefined
                    || akzeptiertDate.add(this.vereinbarungValid, 'years').isBefore(moment())) {
                    invalidAnlaufstellen.push(currAnlaufstelle);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (anlaufstellen_1_1 && !anlaufstellen_1_1.done && (_a = anlaufstellen_1.return)) _a.call(anlaufstellen_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return invalidAnlaufstellen;
        var e_1, _a;
    };
    VereinbarungAkzeptiertService.$inject = ['ErrorService', '$log', 'AuthServiceRS', 'RoleUtilService', 'BenutzerRS', 'AnlaufstelleRS', 'CONSTANTS', '$state',
        'ApplicationPropertyRS'];
    return VereinbarungAkzeptiertService;
}());
exports.default = VereinbarungAkzeptiertService;


/***/ }),

/***/ "D882":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("1zBu");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./inspektoratView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./inspektoratView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "DBv6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
schadenfaelleRun.$inject = ['RouterHelper'];
/* @ngInject */
function schadenfaelleRun(routerHelper) {
    routerHelper.configureStates(getStates());
}
exports.schadenfaelleRun = schadenfaelleRun;
function getStates() {
    return [
        {
            name: 'schadenfaelle',
            template: '<schadenfaelle-view flex="auto" class="overflow-scroll" verantwortliche="$resolve.verantwortliche"></schadenfaelle-view>',
            url: '/schadenfaelle',
            resolve: {
                verantwortliche: getPossibleVerantworltiche
            }
        },
    ];
}
getPossibleVerantworltiche.$inject = ['BenutzerRS'];
/* @ngInject */
function getPossibleVerantworltiche(benutzerRS) {
    return benutzerRS.possibleVerantwortliche();
}
exports.getPossibleVerantworltiche = getPossibleVerantworltiche;


/***/ }),

/***/ "DO1Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSBeitrag_1 = __importDefault(__webpack_require__("Bftz"));
var TSBeitragDTO = /** @class */ (function () {
    function TSBeitragDTO() {
    }
    Object.defineProperty(TSBeitragDTO.prototype, "fallNummer", {
        get: function () {
            return this._fallNummer;
        },
        set: function (value) {
            this._fallNummer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitragDTO.prototype, "ereignis", {
        get: function () {
            return this._ereignis;
        },
        set: function (value) {
            this._ereignis = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitragDTO.prototype, "amtsstelleName", {
        get: function () {
            return this._amtsstelleName;
        },
        set: function (value) {
            this._amtsstelleName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitragDTO.prototype, "ort", {
        get: function () {
            return this._ort;
        },
        set: function (value) {
            this._ort = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitragDTO.prototype, "schadenfallId", {
        get: function () {
            return this._schadenfallId;
        },
        set: function (value) {
            this._schadenfallId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitragDTO.prototype, "beitraege", {
        get: function () {
            return this._beitraege;
        },
        set: function (value) {
            this._beitraege = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitragDTO.prototype, "ermittelterSchaden", {
        get: function () {
            return this._ermittelterSchaden;
        },
        set: function (value) {
            this._ermittelterSchaden = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitragDTO.prototype, "beitragType", {
        get: function () {
            return this._beitragType;
        },
        set: function (value) {
            this._beitragType = value;
        },
        enumerable: true,
        configurable: true
    });
    TSBeitragDTO.prototype.extractGroupLabel = function () {
        var label = this.ort + '_' + this.fallNummer;
        if (this.ereignis !== undefined && this.ereignis !== null) {
            label += ' (' + this.ereignis + ')';
        }
        return label;
    };
    TSBeitragDTO.prototype.deserialize = function (restObject) {
        this.schadenfallId = restObject.schadenfallId;
        this.fallNummer = restObject.fallNummer;
        this.ereignis = restObject.ereignis;
        this.amtsstelleName = restObject.amtsstelleName;
        this.ermittelterSchaden = restObject.ermittelterSchaden;
        this.ort = restObject.ort;
        this.beitragType = restObject.beitragType;
        if (restObject.beitraege) {
            this.beitraege = restObject.beitraege.map(TSBeitrag_1.default.getDeserializer);
        }
        return this;
    };
    return TSBeitragDTO;
}());
exports.default = TSBeitragDTO;


/***/ }),

/***/ "DQJl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSHTTPEvent;
(function (TSHTTPEvent) {
    TSHTTPEvent[TSHTTPEvent["REQUEST_FINISHED"] = 'REQUEST_FINISHED'] = "REQUEST_FINISHED";
})(TSHTTPEvent = exports.TSHTTPEvent || (exports.TSHTTPEvent = {}));


/***/ }),

/***/ "DVWU":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".dv-input-container{width:100%}.dv-input-container .form-control{width:80%}", ""]);

// exports


/***/ }),

/***/ "DX+K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
__webpack_require__("fjOH");
var core_module_1 = __webpack_require__("u87A");
__webpack_require__("xdej");
var admin_route_1 = __webpack_require__("hgNu");
var adminView_1 = __webpack_require__("h/iD");
var konfigurationView_1 = __webpack_require__("3Tvv");
var migrationView_1 = __webpack_require__("7uwI");
var MigrationRS_rest_1 = __webpack_require__("HcmZ");
var testFaelleRS_rest_1 = __webpack_require__("bOI/");
exports.SerfWebAdmin = angular.module('serfWeb.admin', [core_module_1.SerfWebCore.name, 'smart-table', 'ui.bootstrap'])
    .service('TestFaelleRS', testFaelleRS_rest_1.TestFaelleRS)
    .service('MigrationRS', MigrationRS_rest_1.MigrationRS)
    .component('dvAdminView', new adminView_1.AdminViewComponentConfig())
    .component('dvKonfigurationView', new konfigurationView_1.KonfigurationViewComponentConfig())
    .component('dvMigrationView', new migrationView_1.MigrationViewComponentConfig())
    .run(admin_route_1.adminRun);
exports.default = exports.SerfWebAdmin;


/***/ }),

/***/ "DXk2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright © 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt\n * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n */.dv-alert-box{opacity:1;display:flex;margin-top:10px;margin-bottom:5px;padding:16px;border-radius:5px;font-size:14px;letter-spacing:1px;font-weight:400;height:auto;transition:all .25s ease;line-height:normal}.dv-alert-box.ng-active{opacity:1}.dv-alert-box.ng-inactive{opacity:0;height:0;margin:0;padding:0}.dv-alert-box:before{font-family:FontAwesome,sans-serif;content:\"\";width:17px;height:17px;background-size:100% 100%;float:left;margin-right:16px;flex-grow:0;flex-shrink:0;align-self:flex-start}.dv-alert-box__message{display:flex;flex-direction:column;min-height:19px;flex-grow:1;line-height:normal;font-family:Overpass,sans-serif}.dv-alert-box--input-alert{padding:6px 5px 5px;height:25px;transform-origin:top;transform:scaleY(1);font-size:11px;letter-spacing:.8px;margin-bottom:-25px;transition:all .25s ease;margin-top:0;border-radius:0;border:1px solid #000;border-top-width:0}.dv-alert-box--input-alert:before{width:15px;height:15px;margin-right:6px}.dv-alert-box--input-alert.ng-enter,.dv-alert-box--input-alert.ng-enter-prepare{transition:all .25s linear;opacity:0;transform:scaleY(0);transform-origin:top}.dv-alert-box--input-alert.ng-enter.ng-enter-active{opacity:1;transform:scaleY(1)}.dv-alert-box--input-alert.ng-leave{transition:all .3s linear;opacity:1;transform:scaleY(1)}.dv-alert-box--input-alert.ng-leave.ng-leave-active{opacity:0;transform:scaleY(0)}.dv-alert-box--input-alert.ng-active{opacity:1;transform:scaleY(1);margin-bottom:-25px}.dv-alert-box--input-alert.ng-inactive{opacity:0;height:25px;margin-bottom:-25px;margin-top:0;padding:6px 5px 5px;transform:scaleY(0)}.dv-alert-box--has-margin{margin-bottom:0}.dv-alert-box--is-textarea{height:auto;word-wrap:break-word;white-space:pre-line}.dv-alert-box--small{padding:6px;font-size:11px;letter-spacing:.8px}.dv-alert-box--small:before{width:15px;height:15px;margin-right:6px}.dv-alert-box--error{background:rgba(255,43,89,.3);border-color:#ff2b59}.dv-alert-box--error:before{content:\"\\F06A\";color:#ff2b59}.dv-alert-box--error .dv-alert-box__message{color:#ff2b59}.dv-alert-box--error--opaque{background:#ff2b59}.dv-alert-box--error--opaque:before{content:\"\\F06A\";color:#fff}.dv-alert-box--error--opaque .dv-alert-box__message{color:#fff}.dv-alert-box--warning{background:rgba(220,193,0,.3);border-color:#dcc100}.dv-alert-box--warning:before{content:\"\\F071\";color:#dcc100}.dv-alert-box--warning .dv-alert-box__message{color:#dcc100}.dv-alert-box--history{background:hsla(0,0%,40%,.3);border-color:#666}.dv-alert-box--history:before{content:\"\\F1DA\";color:#666}.dv-alert-box--history .dv-alert-box__message{color:#666}.dv-alert-box--info{background:rgba(76,157,203,.3);border-color:#4c9dcb}.dv-alert-box--info:before{content:\"\\F05A\";color:#4c9dcb}.dv-alert-box--info .dv-alert-box__message{color:#4c9dcb}.dv-alert-box--success{background:rgba(76,203,105,.3);border-color:#4ccb69}.dv-alert-box--success:before{content:\"\\F058\";color:#4ccb69}.dv-alert-box--success .dv-alert-box__message{color:#4ccb69}", ""]);

// exports


/***/ }),

/***/ "DZJ0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSReportType_1 = __webpack_require__("jLGy");
var TSStatistikParameterType_1 = __webpack_require__("TvPS");
var TSReportTypeDTO_1 = __importDefault(__webpack_require__("oH1F"));
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
var TSRole_1 = __webpack_require__("MleR");
var template = __webpack_require__("XyUR");
var StatistikViewComponentConfig = /** @class */ (function () {
    function StatistikViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = StatistikViewController;
        this.controllerAs = 'vm';
    }
    return StatistikViewComponentConfig;
}());
exports.StatistikViewComponentConfig = StatistikViewComponentConfig;
var StatistikViewController = /** @class */ (function () {
    /* @ngInject */
    function StatistikViewController(reportAsyncRS, downloadRS, batchJobRS, errorService, $log, $interval, roleUtilService, $translate, authServiceRS) {
        this.reportAsyncRS = reportAsyncRS;
        this.downloadRS = downloadRS;
        this.batchJobRS = batchJobRS;
        this.errorService = errorService;
        this.$log = $log;
        this.$interval = $interval;
        this.roleUtilService = roleUtilService;
        this.$translate = $translate;
        this.authServiceRS = authServiceRS;
        this.TSStatistikParameterType = TSStatistikParameterType_1.TSStatistikParameterType;
        this.reportTypeDTO = new TSReportTypeDTO_1.default();
    }
    StatistikViewController.prototype.$onInit = function () {
        this.refreshUserJobs();
        this.initBatchJobPolling();
        // Inspektor only can generate Auszahlung for Kanton
        if (!this.authServiceRS.isRole(TSRole_1.TSRole.FONDSSUISSE_ADMIN)) {
            this.reportTypeDTO.reportType = TSReportType_1.TSReportType.AUSZAHLUNG_KANTON;
        }
    };
    StatistikViewController.prototype.$onDestroy = function () {
        if (this.polling) {
            this.$interval.cancel(this.polling);
            this.$log.debug('canceld job polling');
        }
    };
    StatistikViewController.prototype.initBatchJobPolling = function () {
        var _this = this;
        // check all 8 seconds for the state
        var delay = 12000;
        this.polling = this.$interval(function () { return _this.refreshUserJobs(); }, delay);
    };
    StatistikViewController.prototype.refreshUserJobs = function () {
        var _this = this;
        this.batchJobRS.getBatchJobsOfUser().then(function (response) {
            _this.userjobs = response;
        });
    };
    StatistikViewController.prototype.generateStatistik = function (type) {
        var _this = this;
        if (!this.form.$valid) {
            return;
        }
        this.$log.debug('Validated Form: ' + this.form.$name);
        if ((this.reportTypeDTO.auszahlungsDatumVon && this.reportTypeDTO.auszahlungsDatumBis) &&
            (this.reportTypeDTO.auszahlungsDatumBis < this.reportTypeDTO.auszahlungsDatumVon)) {
            this.errorService.addMesageAsError('ERROR_DATE_BEFORE_TO');
            throw new Error("to cannot be behind from " + this.reportTypeDTO.auszahlungsDatumVon + " > " + this.reportTypeDTO.auszahlungsDatumBis);
        }
        if ((this.reportTypeDTO.ereignisDatumVon && this.reportTypeDTO.ereignisDatumBis) &&
            (this.reportTypeDTO.ereignisDatumBis < this.reportTypeDTO.ereignisDatumVon)) {
            this.errorService.addMesageAsError('ERROR_DATE_BEFORE_TO');
            throw new Error("to cannot be behind from " + this.reportTypeDTO.ereignisDatumVon + " > " + this.reportTypeDTO.ereignisDatumBis);
        }
        if ((this.reportTypeDTO.gesuchDatumVon && this.reportTypeDTO.gesuchDatumBis) &&
            (this.reportTypeDTO.gesuchDatumBis < this.reportTypeDTO.gesuchDatumVon)) {
            this.errorService.addMesageAsError('ERROR_DATE_BEFORE_TO');
            throw new Error("to cannot be behind from " + this.reportTypeDTO.gesuchDatumVon + " > " + this.reportTypeDTO.gesuchDatumBis);
        }
        var reportTypeDTOtoSend = new TSReportTypeDTO_1.default();
        reportTypeDTOtoSend.reportType = this.reportTypeDTO.reportType;
        switch (reportTypeDTOtoSend.reportType) {
            case TSReportType_1.TSReportType.SCHADEN:
            case TSReportType_1.TSReportType.ALLE:
                reportTypeDTOtoSend.ereignisDatumVon = this.reportTypeDTO.ereignisDatumVon;
                reportTypeDTOtoSend.ereignisDatumBis = this.reportTypeDTO.ereignisDatumBis;
                reportTypeDTOtoSend.gesuchDatumVon = this.reportTypeDTO.gesuchDatumVon;
                reportTypeDTOtoSend.gesuchDatumBis = this.reportTypeDTO.gesuchDatumBis;
                break;
            case TSReportType_1.TSReportType.AUSZAHLUNG:
            case TSReportType_1.TSReportType.AUSZAHLUNG_KANTON:
                reportTypeDTOtoSend.auszahlungsDatumVon = this.reportTypeDTO.auszahlungsDatumVon;
                reportTypeDTOtoSend.auszahlungsDatumBis = this.reportTypeDTO.auszahlungsDatumBis;
                reportTypeDTOtoSend.ereignisDatumVon = this.reportTypeDTO.ereignisDatumVon;
                reportTypeDTOtoSend.ereignisDatumBis = this.reportTypeDTO.ereignisDatumBis;
                reportTypeDTOtoSend.gesuchDatumVon = this.reportTypeDTO.gesuchDatumVon;
                reportTypeDTOtoSend.gesuchDatumBis = this.reportTypeDTO.gesuchDatumBis;
                break;
        }
        switch (type) {
            case TSStatistikParameterType_1.TSStatistikParameterType.TEST:
                this.reportAsyncRS.getReport(reportTypeDTOtoSend)
                    .then(function (batchExecutionId) {
                    _this.informReportGenerationStarted(batchExecutionId);
                });
                this.form.$setPristine();
                return;
            default:
                throw new Error("unknown TSStatistikParameterType: " + type);
        }
    };
    StatistikViewController.prototype.downloadClicked = function (row) {
        var _this = this;
        if (DVBernUtil_1.default.isNullOrUndefined(row) || DVBernUtil_1.default.isNullOrUndefined(row.execution)) {
            return;
        }
        if (DVBernUtil_1.default.isNullOrUndefined(row.execution.batchStatus) || row.execution.batchStatus !== 'COMPLETED') {
            this.$log.info('batch-job is not yet finnished');
            return;
        }
        this.$log.debug('download dokument with id ' + row.serfDokumentId);
        var win = this.downloadRS.prepareDownloadWindow();
        this.downloadRS.getAccessTokenDocumentById(row.serfDokumentId).then(function (downloadFile) {
            _this.$log.debug('accessToken: ' + downloadFile.accessToken);
            _this.downloadRS.startDownload(downloadFile.accessToken, 'report.xlsx', false, win);
        });
    };
    StatistikViewController.prototype.informReportGenerationStarted = function (batchExecutionId) {
        this.$log.debug('executionID: ' + batchExecutionId);
        this.errorService.addMesageAsInfo('STARTED_GENERATION');
        this.refreshUserJobs();
    };
    /**
     * helper methode die es dem Admin erlaubt alle jobs zu sehen
     */
    StatistikViewController.prototype.showAllJobs = function () {
        var _this = this;
        this.batchJobRS.getAllJobs().then(function (result) {
            var res = [];
            res = res.concat(result.map(function (value) {
                return value.execution || undefined;
            }));
            _this.allJobs = res;
        });
    };
    StatistikViewController.prototype.getTSReportTypeValues = function () {
        return TSReportType_1.getTSReportTypeValuesWhitoutKanton();
    };
    StatistikViewController.prototype.displayAuszahlungsDatum = function () {
        return TSReportType_1.displayAuszahlungsDatumMap.get(this.reportTypeDTO.reportType);
    };
    StatistikViewController.prototype.displayEreignisDatum = function () {
        return TSReportType_1.displayEreignisDatumMap.get(this.reportTypeDTO.reportType);
    };
    StatistikViewController.prototype.displayGesuchsDatum = function () {
        return TSReportType_1.displayGesuchsDatumMap.get(this.reportTypeDTO.reportType);
    };
    StatistikViewController.prototype.getFormattedDate = function (s) {
        var mom = DateUtil_1.default.localDateToMoment(s.substring(0, 10));
        if (mom) {
            return DateUtil_1.default.momentToLocalDateFormat(mom, 'DD.MM.YYYY');
        }
        return '';
    };
    StatistikViewController.prototype.isDate = function (params, dateType) {
        switch (dateType) {
            case 'AD':
                return !!params.ADV && !!params.ADB;
            case 'ED':
                return !!params.EDV && !!params.EDB;
            case 'GD':
                return !!params.GDV && !!params.GDB;
            default:
                return false;
        }
    };
    StatistikViewController.prototype.getParams = function (params) {
        var returnString = '';
        var separator = ' - ';
        var endOfLine = '\n';
        if (this.isDate(params, 'AD')) {
            returnString += this.$translate.instant('DATUM_AUSZAHLUNG_PARAM');
            returnString += this.getFormattedDate(params.ADV);
            returnString += separator;
            returnString += this.getFormattedDate(params.ADB);
            returnString += endOfLine;
        }
        if (this.isDate(params, 'ED')) {
            returnString += this.$translate.instant('DATUM_EREIGNIS_PARAM');
            returnString += this.getFormattedDate(params.EDV);
            returnString += separator;
            returnString += this.getFormattedDate(params.EDB);
            returnString += endOfLine;
        }
        if (this.isDate(params, 'GD')) {
            returnString += this.$translate.instant('DATUM_GESUCH_PARAM');
            returnString += this.getFormattedDate(params.GDV);
            returnString += separator;
            returnString += this.getFormattedDate(params.GDB);
            returnString += endOfLine;
        }
        return returnString;
    };
    StatistikViewController.$inject = [
        'ReportAsyncRS',
        'DownloadRS',
        'BatchJobRS',
        'ErrorService',
        '$log',
        '$interval',
        'RoleUtilService',
        '$translate',
        'AuthServiceRS'
    ];
    return StatistikViewController;
}());
exports.StatistikViewController = StatistikViewController;


/***/ }),

/***/ "DdPR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSFile_1 = __importDefault(__webpack_require__("bB+v"));
var TSDokument = /** @class */ (function (_super) {
    __extends(TSDokument, _super);
    function TSDokument() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSDokument.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        return this;
    };
    TSDokument.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        return restObject;
    };
    return TSDokument;
}(TSFile_1.default));
exports.default = TSDokument;


/***/ }),

/***/ "DkCC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var KoerperschaftComponentConfig = /** @class */ (function () {
    function KoerperschaftComponentConfig() {
        this.transclude = false;
        this.bindings = {
            model: '=',
            name: '@',
            angabe: '@'
        };
        this.template = __webpack_require__("FD72");
        this.controller = DvKoerperschaftController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return KoerperschaftComponentConfig;
}());
exports.KoerperschaftComponentConfig = KoerperschaftComponentConfig;
var DvKoerperschaftController = /** @class */ (function () {
    function DvKoerperschaftController() {
    }
    DvKoerperschaftController.prototype.getModel = function () {
        return this.model;
    };
    return DvKoerperschaftController;
}());
exports.DvKoerperschaftController = DvKoerperschaftController;


/***/ }),

/***/ "DlJU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractModelController_1 = __importDefault(__webpack_require__("VDYy"));
var TSRole_1 = __webpack_require__("MleR");
__webpack_require__("7MRA");
var template = __webpack_require__("07Me");
/**
 * Diese Komponente diente dazu Benutzer einer bestimmten Anlaufstelle zu editieren, wahrscheinlich ist dies
 * nun gar nicht mehr noetig da wir die Benutzerverwaltung separat fuehren.
 * Diese component kann somit erstmal als deprecated betrachtet werden. Allenfalls koennen wir sie spaeter auch loeschen
 * @deprecated
 */
var BenutzerEditAnlaufstelleComponentConfig = /** @class */ (function () {
    function BenutzerEditAnlaufstelleComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = BenutzerEditAnlaufstelleViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            anlaufstelle: '<',
            benutzer: '<',
            sachbearbeiterList: '<',
            schaetzerList: '<'
        };
    }
    return BenutzerEditAnlaufstelleComponentConfig;
}());
exports.BenutzerEditAnlaufstelleComponentConfig = BenutzerEditAnlaufstelleComponentConfig;
var BenutzerEditAnlaufstelleViewController = /** @class */ (function (_super) {
    __extends(BenutzerEditAnlaufstelleViewController, _super);
    /* @ngInject */
    function BenutzerEditAnlaufstelleViewController($stateParams, anlaufstelleRS, $log, errorService, $window, $state, passwordStrengthService, $scope, roleUtilService, $translate, benutzerRS) {
        var _this = _super.call(this, $scope) || this;
        _this.$stateParams = $stateParams;
        _this.anlaufstelleRS = anlaufstelleRS;
        _this.$log = $log;
        _this.errorService = errorService;
        _this.$window = $window;
        _this.$state = $state;
        _this.passwordStrengthService = passwordStrengthService;
        _this.roleUtilService = roleUtilService;
        _this.$translate = $translate;
        _this.benutzerRS = benutzerRS;
        _this.viewReadonly = false;
        return _this;
    }
    BenutzerEditAnlaufstelleViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        this.initialModel = this.benutzer;
        this.model = angular.copy(this.benutzer);
    };
    BenutzerEditAnlaufstelleViewController.prototype.initModel = function () {
        //unused
        var benutzer = this.initialModel;
        if (benutzer && benutzer.roles.length === 0) {
            //wenn wir keine rollen haben setzen wir mal eine
            benutzer.roles.push(TSRole_1.TSRole.UNASSIGNED_ROLE);
        }
    };
    BenutzerEditAnlaufstelleViewController.prototype.submit = function () {
        var _this = this;
        if (this.form.$valid && this.anlaufstelle && this.benutzer && this.checkEmailRepeated()) {
            this.benutzerRS.createOrUpdateBenutzeraccount(this.benutzer).then(function (storedBenutzer) {
                if (storedBenutzer !== undefined) {
                    if (_this.benutzer.isNew()) {
                        // this.benutzer.passwordData = new TSPasswordData(this.benutzer.email);
                        _this.errorService.addMesageAsInfoWithArgs('BENUTZER_REC_SUCCESS', _this.benutzer.email);
                    }
                    else {
                        if (_this.benutzer.email !== storedBenutzer.email) {
                            _this.errorService.addMesageAsInfoWithArgs('BENUTZER_UPDATE_EMAIL_INFO', _this.benutzer.email);
                        }
                    }
                    _this.benutzer = storedBenutzer;
                    _this.form.$setPristine();
                    _this.form.$setUntouched();
                    _this.$state.go('benutzerverwaltunganlaufstelle');
                }
                else {
                    _this.$log.error('could not save new benutzer for anlaufstelle ' + _this.anlaufstelle);
                }
            });
        }
        else {
            this.$log.debug('Form was not valid');
        }
    };
    BenutzerEditAnlaufstelleViewController.prototype.cancelBenutzeredit = function () {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
    };
    BenutzerEditAnlaufstelleViewController.prototype.getRoles = function () {
        return this.roleUtilService.getAnlaufstelleSubuserRolesOnly();
    };
    BenutzerEditAnlaufstelleViewController.prototype.translateRole = function (val) {
        return this.$translate.instant(TSRole_1.rolePrefix() + val);
    };
    BenutzerEditAnlaufstelleViewController.prototype.checkEmailRepeated = function () {
        var repeatValid = this.benutzer.checkEmailRepeated();
        if (!repeatValid) {
            this.errorService.addMesageAsError('ERROR_EMAIL_SAME');
            return false;
        }
        return true;
    };
    BenutzerEditAnlaufstelleViewController.$inject = ['$stateParams', 'AnlaufstelleRS', '$log', 'ErrorService', '$window', '$state',
        'PasswordStrengthService', '$scope', 'RoleUtilService', '$translate', 'BenutzerRS'];
    return BenutzerEditAnlaufstelleViewController;
}(abstractModelController_1.default));
exports.BenutzerEditAnlaufstelleViewController = BenutzerEditAnlaufstelleViewController;


/***/ }),

/***/ "Ds1G":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de": "DOkx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ds1G";

/***/ }),

/***/ "Dw14":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"> <ng-transclude></ng-transclude> </div> ";

/***/ }),

/***/ "E8BN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSBankverbindung_1 = __importDefault(__webpack_require__("iMHU"));
var TSFinanzangabenDaten = /** @class */ (function (_super) {
    __extends(TSFinanzangabenDaten, _super);
    function TSFinanzangabenDaten() {
        var _this = _super.call(this) || this;
        _this.bankverbindung = new TSBankverbindung_1.default();
        return _this;
    }
    Object.defineProperty(TSFinanzangabenDaten.prototype, "steuerjahr", {
        get: function () {
            return this._steuerjahr;
        },
        set: function (value) {
            this._steuerjahr = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFinanzangabenDaten.prototype, "einkommenGewinn", {
        get: function () {
            return this._einkommenGewinn;
        },
        set: function (value) {
            this._einkommenGewinn = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFinanzangabenDaten.prototype, "vermoegenKapital", {
        get: function () {
            return this._vermoegenKapital;
        },
        set: function (value) {
            this._vermoegenKapital = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFinanzangabenDaten.prototype, "bankverbindung", {
        get: function () {
            return this._bankverbindung;
        },
        set: function (value) {
            this._bankverbindung = value;
        },
        enumerable: true,
        configurable: true
    });
    TSFinanzangabenDaten.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.einkommenGewinn = restObject.einkommenGewinn;
        this.steuerjahr = restObject.steuerjahr;
        this.vermoegenKapital = restObject.vermoegenKapital;
        this.bankverbindung = this.deserializeOrCreate(restObject.bankverbindung, new TSBankverbindung_1.default());
        return this;
    };
    TSFinanzangabenDaten.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.einkommenGewinn = this.einkommenGewinn;
        restObject.steuerjahr = this.steuerjahr;
        restObject.vermoegenKapital = this.vermoegenKapital;
        restObject.bankverbindung = this.serializeOrInit(this.bankverbindung, restObject.bankverbindung);
        return restObject;
    };
    TSFinanzangabenDaten.getDeserializer = function (finanzangabenDaten) {
        return new TSFinanzangabenDaten().deserialize(finanzangabenDaten);
    };
    return TSFinanzangabenDaten;
}(TSAbstractEntity_1.default));
exports.default = TSFinanzangabenDaten;


/***/ }),

/***/ "EBY0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("JnPV");
var LeistungsempfaengerComponentConfig = /** @class */ (function () {
    function LeistungsempfaengerComponentConfig() {
        this.transclude = false;
        this.bindings = {
            inhaberName: '<',
            bankName: '<',
            iban: '<',
        };
        this.template = __webpack_require__("1Zuw");
        this.controller = DvLeistungsempfaengerController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return LeistungsempfaengerComponentConfig;
}());
exports.LeistungsempfaengerComponentConfig = LeistungsempfaengerComponentConfig;
var DvLeistungsempfaengerController = /** @class */ (function () {
    /* @ngInject */
    function DvLeistungsempfaengerController() {
    }
    DvLeistungsempfaengerController.$inject = [];
    return DvLeistungsempfaengerController;
}());
exports.DvLeistungsempfaengerController = DvLeistungsempfaengerController;


/***/ }),

/***/ "EUJE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSRechtsform;
(function (TSRechtsform) {
    TSRechtsform[TSRechtsform["NATUERLICHE_PERSON"] = 'NATUERLICHE_PERSON'] = "NATUERLICHE_PERSON";
    TSRechtsform[TSRechtsform["GENOSSENSCHAFT"] = 'GENOSSENSCHAFT'] = "GENOSSENSCHAFT";
    TSRechtsform[TSRechtsform["ANDERE_KOERPERSCHAFT"] = 'ANDERE_KOERPERSCHAFT'] = "ANDERE_KOERPERSCHAFT";
    TSRechtsform[TSRechtsform["MEHRPERSONENGESELLSCHAFT"] = 'MEHRPERSONENGESELLSCHAFT'] = "MEHRPERSONENGESELLSCHAFT";
})(TSRechtsform = exports.TSRechtsform || (exports.TSRechtsform = {}));
function getAllTSRechtsformValues() {
    return [
        TSRechtsform.NATUERLICHE_PERSON,
        TSRechtsform.GENOSSENSCHAFT,
        TSRechtsform.MEHRPERSONENGESELLSCHAFT,
        TSRechtsform.ANDERE_KOERPERSCHAFT
    ];
}
exports.getAllTSRechtsformValues = getAllTSRechtsformValues;
function getTSRechtsformValues() {
    return [
        TSRechtsform.NATUERLICHE_PERSON,
        TSRechtsform.GENOSSENSCHAFT,
        TSRechtsform.MEHRPERSONENGESELLSCHAFT,
    ];
}
exports.getTSRechtsformValues = getTSRechtsformValues;
function getTSRechtsformValuesForZweitpersonGrundeigentuemer() {
    return getAllTSRechtsformValues();
}
exports.getTSRechtsformValuesForZweitpersonGrundeigentuemer = getTSRechtsformValuesForZweitpersonGrundeigentuemer;


/***/ }),

/***/ "EVhI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSBatchJobInformation_1 = __importDefault(__webpack_require__("NMnI"));
/**
 * DTO fuer einen WorkJob
 */
var TSWorkJob = /** @class */ (function (_super) {
    __extends(TSWorkJob, _super);
    function TSWorkJob() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSWorkJob.prototype, "workJobType", {
        get: function () {
            return this._workJobType;
        },
        set: function (value) {
            this._workJobType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSWorkJob.prototype, "startinguser", {
        get: function () {
            return this._startinguser;
        },
        set: function (value) {
            this._startinguser = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSWorkJob.prototype, "batchJobStatus", {
        get: function () {
            return this._batchJobStatus;
        },
        set: function (value) {
            this._batchJobStatus = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSWorkJob.prototype, "params", {
        get: function () {
            return this._params;
        },
        set: function (value) {
            this._params = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSWorkJob.prototype, "executionId", {
        get: function () {
            return this._executionId;
        },
        set: function (value) {
            this._executionId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSWorkJob.prototype, "requestURI", {
        get: function () {
            return this._requestURI;
        },
        set: function (value) {
            this._requestURI = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSWorkJob.prototype, "resultData", {
        get: function () {
            return this._resultData;
        },
        set: function (value) {
            this._resultData = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSWorkJob.prototype, "execution", {
        get: function () {
            return this._execution;
        },
        set: function (value) {
            this._execution = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSWorkJob.prototype, "serfDokumentId", {
        get: function () {
            return this._serfDokumentId;
        },
        set: function (value) {
            this._serfDokumentId = value;
        },
        enumerable: true,
        configurable: true
    });
    TSWorkJob.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.startinguser = restObject.startinguser;
        this.batchJobStatus = restObject.batchJobStatus;
        this.executionId = restObject.executionId;
        this.params = JSON.parse(restObject.params);
        this.workJobType = restObject.workJobType;
        this.resultData = restObject.resultData;
        this.requestURI = restObject.requestURI;
        this.serfDokumentId = restObject.serfDokumentId;
        this.execution = this.deserializeOrCreate(restObject.execution, new TSBatchJobInformation_1.default());
        return this;
    };
    TSWorkJob.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.params = this.params;
        return restObject;
    };
    TSWorkJob.deserializeArray = function (data) {
        var workJobArray = [];
        if (data) {
            for (var i = 0; i < data.length; i++) {
                workJobArray[i] = new TSWorkJob().deserialize(data[i]);
            }
        }
        else {
            workJobArray[0] = new TSWorkJob().deserialize(data);
        }
        return workJobArray;
    };
    return TSWorkJob;
}(TSAbstractEntity_1.default));
exports.default = TSWorkJob;


/***/ }),

/***/ "EWa8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSEigenleistungArt;
(function (TSEigenleistungArt) {
    TSEigenleistungArt[TSEigenleistungArt["HANDARBEIT"] = 'HANDARBEIT'] = "HANDARBEIT";
    TSEigenleistungArt[TSEigenleistungArt["HANDARBEIT_PAUSCHAL"] = 'HANDARBEIT_PAUSCHAL'] = "HANDARBEIT_PAUSCHAL";
    TSEigenleistungArt[TSEigenleistungArt["TRAKTOR_SUB44KW"] = 'TRAKTOR_SUB44KW'] = "TRAKTOR_SUB44KW";
    TSEigenleistungArt[TSEigenleistungArt["TRAKTOR_SUB74KW"] = 'TRAKTOR_SUB74KW'] = "TRAKTOR_SUB74KW";
    TSEigenleistungArt[TSEigenleistungArt["TRAKTOR_AB74KW"] = 'TRAKTOR_AB74KW'] = "TRAKTOR_AB74KW";
    TSEigenleistungArt[TSEigenleistungArt["TRAKTOR_AB74KW_KIPPER"] = 'TRAKTOR_AB74KW_KIPPER'] = "TRAKTOR_AB74KW_KIPPER";
    TSEigenleistungArt[TSEigenleistungArt["TRAKTOR"] = 'TRAKTOR'] = "TRAKTOR";
    TSEigenleistungArt[TSEigenleistungArt["TRAKTOR_4WD_SUB44KW"] = 'TRAKTOR_4WD_SUB44KW'] = "TRAKTOR_4WD_SUB44KW";
    TSEigenleistungArt[TSEigenleistungArt["TRAKTOR_4WD"] = 'TRAKTOR_4WD'] = "TRAKTOR_4WD";
    TSEigenleistungArt[TSEigenleistungArt["TRANSPORTER"] = 'TRANSPORTER'] = "TRANSPORTER";
    TSEigenleistungArt[TSEigenleistungArt["TRANSPORTER_KIPPBRUECKE"] = 'TRANSPORTER_KIPPBRUECKE'] = "TRANSPORTER_KIPPBRUECKE";
    TSEigenleistungArt[TSEigenleistungArt["ANHAENGER"] = 'ANHAENGER'] = "ANHAENGER";
    TSEigenleistungArt[TSEigenleistungArt["FRONTLADER"] = 'FRONTLADER'] = "FRONTLADER";
    TSEigenleistungArt[TSEigenleistungArt["HECKSCHAUFEL_PLANIERSCHILD"] = 'HECKSCHAUFEL_PLANIERSCHILD'] = "HECKSCHAUFEL_PLANIERSCHILD";
    TSEigenleistungArt[TSEigenleistungArt["ANBAUSEILWINDE"] = 'ANBAUSEILWINDE'] = "ANBAUSEILWINDE";
    TSEigenleistungArt[TSEigenleistungArt["HOLZ"] = 'HOLZ'] = "HOLZ";
    TSEigenleistungArt[TSEigenleistungArt["HOLZ_AUF_PLATZ"] = 'HOLZ_AUF_PLATZ'] = "HOLZ_AUF_PLATZ";
    TSEigenleistungArt[TSEigenleistungArt["BAGGER_1500"] = 'BAGGER_1500'] = "BAGGER_1500";
    TSEigenleistungArt[TSEigenleistungArt["BAGGER_BIS5000"] = 'BAGGER_BIS5000'] = "BAGGER_BIS5000";
    TSEigenleistungArt[TSEigenleistungArt["BAGGER_AB5000"] = 'BAGGER_AB5000'] = "BAGGER_AB5000";
    TSEigenleistungArt[TSEigenleistungArt["RAUPENTRANSPORTER"] = 'RAUPENTRANSPORTER'] = "RAUPENTRANSPORTER";
    TSEigenleistungArt[TSEigenleistungArt["KETTENSAEGE"] = 'KETTENSAEGE'] = "KETTENSAEGE";
    TSEigenleistungArt[TSEigenleistungArt["TERRA_TRAC_SUB44KW"] = 'TERRA_TRAC_SUB44KW'] = "TERRA_TRAC_SUB44KW";
    TSEigenleistungArt[TSEigenleistungArt["TERRA_TRAC_SUB74KW"] = 'TERRA_TRAC_SUB74KW'] = "TERRA_TRAC_SUB74KW";
    TSEigenleistungArt[TSEigenleistungArt["TELESKOPLADER"] = 'TELESKOPLADER'] = "TELESKOPLADER";
    TSEigenleistungArt[TSEigenleistungArt["KLEINBAGGER_1_5T_BIS_3T"] = 'KLEINBAGGER_1_5T_BIS_3T'] = "KLEINBAGGER_1_5T_BIS_3T";
    TSEigenleistungArt[TSEigenleistungArt["KLEINBAGGER_3_5T_BIS_6T"] = 'KLEINBAGGER_3_5T_BIS_6T'] = "KLEINBAGGER_3_5T_BIS_6T";
    TSEigenleistungArt[TSEigenleistungArt["KLEINBAGGER_7T_BIS_10T_SCHREITBAGGER"] = 'KLEINBAGGER_7T_BIS_10T_SCHREITBAGGER'] = "KLEINBAGGER_7T_BIS_10T_SCHREITBAGGER";
    TSEigenleistungArt[TSEigenleistungArt["RAUPENKARETTE"] = 'RAUPENKARETTE'] = "RAUPENKARETTE";
    TSEigenleistungArt[TSEigenleistungArt["RAUPENTRANSPORTER_1_5T_BIS_4T"] = 'RAUPENTRANSPORTER_1_5T_BIS_4T'] = "RAUPENTRANSPORTER_1_5T_BIS_4T";
    TSEigenleistungArt[TSEigenleistungArt["TREIBSTOFF"] = 'TREIBSTOFF'] = "TREIBSTOFF";
    TSEigenleistungArt[TSEigenleistungArt["ANDERE"] = 'ANDERE'] = "ANDERE";
})(TSEigenleistungArt = exports.TSEigenleistungArt || (exports.TSEigenleistungArt = {}));
exports.EigenleistungsAnsatzMapVor2023 = new Map([
    [TSEigenleistungArt.HANDARBEIT, 25],
    [TSEigenleistungArt.TRAKTOR_SUB44KW, 30],
    [TSEigenleistungArt.TRAKTOR_SUB74KW, 35],
    [TSEigenleistungArt.TRAKTOR_AB74KW, 40],
    [TSEigenleistungArt.TRAKTOR, 24],
    [TSEigenleistungArt.TRAKTOR_4WD_SUB44KW, 23],
    [TSEigenleistungArt.TRAKTOR_4WD, 27],
    [TSEigenleistungArt.TRANSPORTER, 40],
    [TSEigenleistungArt.ANHAENGER, 15],
    [TSEigenleistungArt.FRONTLADER, 15],
    [TSEigenleistungArt.HECKSCHAUFEL_PLANIERSCHILD, 10],
    [TSEigenleistungArt.ANBAUSEILWINDE, 10],
    [TSEigenleistungArt.BAGGER_1500, 35],
    [TSEigenleistungArt.BAGGER_BIS5000, 45],
    [TSEigenleistungArt.BAGGER_AB5000, 50],
    [TSEigenleistungArt.RAUPENTRANSPORTER, 20],
    [TSEigenleistungArt.KETTENSAEGE, 15],
    [TSEigenleistungArt.HOLZ, 80],
]);
exports.EigenleistungsAnsatzMapAb2023 = new Map([
    [TSEigenleistungArt.HANDARBEIT, 30],
    [TSEigenleistungArt.TRAKTOR_SUB44KW, 32],
    [TSEigenleistungArt.TRAKTOR_SUB74KW, 40],
    [TSEigenleistungArt.TRAKTOR_AB74KW, 60],
    [TSEigenleistungArt.TRAKTOR, 24],
    [TSEigenleistungArt.TRAKTOR_4WD_SUB44KW, 23],
    [TSEigenleistungArt.TRAKTOR_4WD, 27],
    [TSEigenleistungArt.TRANSPORTER, 55],
    [TSEigenleistungArt.ANHAENGER, 20],
    [TSEigenleistungArt.FRONTLADER, 15],
    [TSEigenleistungArt.HECKSCHAUFEL_PLANIERSCHILD, 10],
    [TSEigenleistungArt.ANBAUSEILWINDE, 10],
    [TSEigenleistungArt.BAGGER_1500, 35],
    [TSEigenleistungArt.BAGGER_BIS5000, 45],
    [TSEigenleistungArt.BAGGER_AB5000, 50],
    [TSEigenleistungArt.RAUPENTRANSPORTER, 20],
    [TSEigenleistungArt.KETTENSAEGE, 15],
    [TSEigenleistungArt.HOLZ, 80],
]);
exports.EigenleistungsAnsatzMapAb2026 = new Map([
    [TSEigenleistungArt.HANDARBEIT, 30],
    [TSEigenleistungArt.TRAKTOR_SUB44KW, 50],
    [TSEigenleistungArt.TRAKTOR_SUB74KW, 60],
    [TSEigenleistungArt.TRAKTOR_AB74KW_KIPPER, 100],
    [TSEigenleistungArt.TERRA_TRAC_SUB44KW, 65],
    [TSEigenleistungArt.TERRA_TRAC_SUB74KW, 75],
    [TSEigenleistungArt.TRANSPORTER_KIPPBRUECKE, 90],
    [TSEigenleistungArt.TELESKOPLADER, 60],
    [TSEigenleistungArt.KLEINBAGGER_1_5T_BIS_3T, 40],
    [TSEigenleistungArt.KLEINBAGGER_3_5T_BIS_6T, 50],
    [TSEigenleistungArt.KLEINBAGGER_7T_BIS_10T_SCHREITBAGGER, 70],
    [TSEigenleistungArt.RAUPENKARETTE, 25],
    [TSEigenleistungArt.RAUPENTRANSPORTER_1_5T_BIS_4T, 50],
    [TSEigenleistungArt.HOLZ_AUF_PLATZ, 80],
    [TSEigenleistungArt.TREIBSTOFF, 15],
]);
var preAb2026EigenleistungsArtValues = [
    TSEigenleistungArt.HANDARBEIT,
    TSEigenleistungArt.HANDARBEIT_PAUSCHAL,
    TSEigenleistungArt.TRAKTOR_SUB44KW,
    TSEigenleistungArt.TRAKTOR_SUB74KW,
    TSEigenleistungArt.TRAKTOR_AB74KW,
    TSEigenleistungArt.TRANSPORTER,
    TSEigenleistungArt.ANHAENGER,
    TSEigenleistungArt.FRONTLADER,
    TSEigenleistungArt.HECKSCHAUFEL_PLANIERSCHILD,
    TSEigenleistungArt.ANBAUSEILWINDE,
    TSEigenleistungArt.BAGGER_1500,
    TSEigenleistungArt.BAGGER_BIS5000,
    TSEigenleistungArt.BAGGER_AB5000,
    TSEigenleistungArt.RAUPENTRANSPORTER,
    TSEigenleistungArt.KETTENSAEGE,
    TSEigenleistungArt.HOLZ,
    TSEigenleistungArt.ANDERE,
];
var ab2026EigenleistungsArtValues = [
    TSEigenleistungArt.HANDARBEIT,
    TSEigenleistungArt.HANDARBEIT_PAUSCHAL,
    TSEigenleistungArt.TRAKTOR_SUB44KW,
    TSEigenleistungArt.TRAKTOR_SUB74KW,
    TSEigenleistungArt.TRAKTOR_AB74KW_KIPPER,
    TSEigenleistungArt.TRANSPORTER_KIPPBRUECKE,
    TSEigenleistungArt.TERRA_TRAC_SUB44KW,
    TSEigenleistungArt.TERRA_TRAC_SUB74KW,
    TSEigenleistungArt.TELESKOPLADER,
    TSEigenleistungArt.KLEINBAGGER_1_5T_BIS_3T,
    TSEigenleistungArt.KLEINBAGGER_3_5T_BIS_6T,
    TSEigenleistungArt.KLEINBAGGER_7T_BIS_10T_SCHREITBAGGER,
    TSEigenleistungArt.RAUPENKARETTE,
    TSEigenleistungArt.RAUPENTRANSPORTER_1_5T_BIS_4T,
    TSEigenleistungArt.HOLZ_AUF_PLATZ,
    TSEigenleistungArt.TREIBSTOFF,
    TSEigenleistungArt.ANDERE,
];
var YEAR_2026 = '2026-04-30';
function getEigenleistungsArtValues(schadendatum) {
    if (schadendatum !== undefined && schadendatum.isAfter(YEAR_2026)) {
        return __spread(ab2026EigenleistungsArtValues);
    }
    return __spread(preAb2026EigenleistungsArtValues);
}
exports.getEigenleistungsArtValues = getEigenleistungsArtValues;
function eigenleistungPrefix() {
    return 'TSEigenleistungArt_';
}
exports.eigenleistungPrefix = eigenleistungPrefix;
function getEigenleistungsAnsatz(art, schadendatum) {
    var ansatz;
    if (schadendatum !== undefined && schadendatum.isAfter(YEAR_2026)) {
        ansatz = exports.EigenleistungsAnsatzMapAb2026.get(art);
    }
    else if (schadendatum !== undefined && schadendatum.isAfter('2022-12-31')) {
        ansatz = exports.EigenleistungsAnsatzMapAb2023.get(art);
    }
    else {
        ansatz = exports.EigenleistungsAnsatzMapVor2023.get(art);
    }
    return ansatz === undefined ? 0 : ansatz;
}
exports.getEigenleistungsAnsatz = getEigenleistungsAnsatz;


/***/ }),

/***/ "Emwh":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("cixw");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./schadenfaelle.module.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./schadenfaelle.module.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ErVO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Enum mit den moeglichen Berechtigungen die ein Benutzer auf einer bestimmten page haben kann
 */
var TSBerechtigung;
(function (TSBerechtigung) {
    TSBerechtigung[TSBerechtigung["EDIT"] = 'EDIT'] = "EDIT";
    TSBerechtigung[TSBerechtigung["READONLY"] = 'READONLY'] = "READONLY";
    TSBerechtigung[TSBerechtigung["NO_ACCESS"] = 'NO_ACCESS'] = "NO_ACCESS";
})(TSBerechtigung = exports.TSBerechtigung || (exports.TSBerechtigung = {}));
function getTSBerechtigung() {
    return [
        TSBerechtigung.EDIT,
        TSBerechtigung.READONLY,
        TSBerechtigung.NO_ACCESS
    ];
}
exports.getTSBerechtigung = getTSBerechtigung;


/***/ }),

/***/ "Etn9":
/***/ (function(module, exports) {

module.exports = " <div class=\"chart-container\"> <canvas id=\"{{vm.chartid}}\"></canvas> </div> <div class=\"legend-con\" id=\"{{vm.chartid}}-legend\"></div> ";

/***/ }),

/***/ "Evg8":
/***/ (function(module, exports) {

module.exports = "<div class=\"authentication-view background-gs-5\"> <div class=\"authentication-view__loginbox\"> <form name=\"vm.form\" role=\"form\" class=\"authentication-view__loginbox-form\" novalidate style=\"height:100%\"> <div class=\"authentication-view__loginbox-center\"> <div class=\"authentication-view__regbox authentication-view__regbox--transparent authentication-view__regbox--reset\"> <span translate=\"LOGIN_RESET_PW_TITLE\"></span> </div> <div class=\"authentication-view__text\" translate=\"LOGIN_RESET_PW_TEXT\"></div> <div class=\"form-group authentication-view__loginbox-form-group\"> <label for=\"email_ID\" translate=\"LOGIN_EMAIL\"></label> <input id=\"email_ID\" type=\"email\" name=\"email\" ng-model=\"vm.email\" dv-max-length class=\"form-control authentication-view__loginbox-input\" required placeholder=\"hans.muster@example.com\" ng-pattern=\"vm.CONSTANTS.PATTERN_EMAIL\"> <dv-error-messages for=\"vm.form.email\" opaque class=\"error\"></dv-error-messages> </div> <button type=\"submit\" ng-click=\"vm.resetClicked()\" class=\"btn btn-serf authentication-view__button\" translate=\"LOGIN_BTN_ANFORDERN\"></button> <a class=\"authentication-view__link authentication-view__link--italic\" translate=\"LOGIN_BACK_TOANMELDUNG\" ui-sref=\"login\"></a> </div> </form> </div> </div> ";

/***/ }),

/***/ "F1gm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
__webpack_require__("fjOH");
var core_module_1 = __webpack_require__("u87A");
__webpack_require__("+hxN");
var zahlungen_route_1 = __webpack_require__("mDSf");
var zahlungenListView_1 = __webpack_require__("Y71P");
exports.SerfWebZahlungen = angular.module('serfWeb.zahlungen', [core_module_1.SerfWebCore.name])
    .component('zahlungenView', new zahlungenListView_1.ZahlungenListViewComponentConfig())
    .run(zahlungen_route_1.zahlungenRun);
exports.default = exports.SerfWebZahlungen;


/***/ }),

/***/ "F8yL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSBemerkungScope_1 = __webpack_require__("Oh5v");
var TSDokumentType_1 = __webpack_require__("/gTe");
var abstractModelManagerController_1 = __importDefault(__webpack_require__("S1yE"));
var template = __webpack_require__("ArUG");
var BemerkungViewComponentConfig = /** @class */ (function () {
    function BemerkungViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = BemerkungViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            schadenfall: '<'
        };
    }
    return BemerkungViewComponentConfig;
}());
exports.BemerkungViewComponentConfig = BemerkungViewComponentConfig;
var BemerkungViewController = /** @class */ (function (_super) {
    __extends(BemerkungViewController, _super);
    /* @ngInject */
    function BemerkungViewController(dvBernUtil, schadenfallModelManager, $q, $scope, $state, dvDialog, $translate, roleUtilService, schadenfallRS, downloadRS) {
        var _this = _super.call(this, schadenfallModelManager, $scope, $state.current.name) || this;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$state = $state;
        _this.dvDialog = dvDialog;
        _this.$translate = $translate;
        _this.roleUtilService = roleUtilService;
        _this.schadenfallRS = schadenfallRS;
        _this.downloadRS = downloadRS;
        _this.scopeToShow = [];
        _this.scope = TSBemerkungScope_1.TSBemerkungScope.BEMERKUNG_VIEW;
        _this.showBenutzerBemerkungen = true;
        _this.showTransitionBemerkungen = true;
        _this.showSystemBemerkungen = false;
        _this.doctype = TSDokumentType_1.TSDocumentType.FONDSSUISSE_DOC;
        return _this;
    }
    BemerkungViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        if (!this.schadenfall) {
            console.error('no schadenfall passed to view');
        }
        else {
            this.initialModel = this.schadenfall;
            this.model = angular.copy(this.schadenfall);
        }
    };
    BemerkungViewController.prototype.getViewTitle = function () {
        return this.dvBernUtil.getViewTitle(this.schadenfall);
    };
    BemerkungViewController.prototype.downloadPDF = function (event) {
        var _this = this;
        this.schadenfallRS.generateDeckblatt(this.schadenfall.id).then(function (result) {
            console.log(result);
            _this.downloadRS.getAccessTokenDocument(_this.schadenfall.id, TSDokumentType_1.TSDocumentType.TMP_DECKBLATT, result.id).then(function (result) {
                var win = _this.downloadRS.prepareDownloadWindow();
                _this.downloadRS.startDownload(result.accessToken, result.filename, false, win);
            });
        });
    };
    BemerkungViewController.$inject = ['DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$state', 'DvDialog', '$translate', 'RoleUtilService', 'SchadenfallRS', 'DownloadRS'];
    return BemerkungViewController;
}(abstractModelManagerController_1.default));
exports.BemerkungViewController = BemerkungViewController;


/***/ }),

/***/ "FD72":
/***/ (function(module, exports) {

module.exports = "<div class=\"row\"> <div class=\"col-sm-12\"> <h2 class=\"h2-gesuchsteller\"> <span ng-if=\"vm.angabe\" class=\"h2-prefix\">{{vm.angabe | translate}}</span> <span data-translate=\"ANGABEN_ZUR_KOERPERSCHAFT\"></span> </h2> </div> </div> <div ng-form=\"koerperschaftForm\"> <div class=\"row\"> <dv-string-input model=\"vm.getModel().koerperschaftDatenFS.koerperschaftArt\" bisher-gs=\"vm.getModel().koerperschaftDatenGS\" bisher-fs=\"vm.getModel().koerperschaftDatenFS\" bisher-property=\"koerperschaftArt\" name=\"{{vm.name}}_koerperschaftArt\" label=\"ART_DER_KOERPERSCHAFT\" clazz=\"col-sm-6\"> </dv-string-input> </div> </div> ";

/***/ }),

/***/ "FldB":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.dv-eigenleistungen-list .rowHeader-anzahl,.dv-eigenleistungen-list .rowHeader-berechtigterBetrag,.dv-eigenleistungen-list .rowHeader-betrag,.dv-eigenleistungen-list .rowHeader-datum{width:15%}.dv-eigenleistungen-list .rowHeader-actions{width:130px}.dv-eigenleistungen-list .rowBody-actions{text-align:center}.dv-eigenleistungen-list .rowBody-actions button{width:30px}", ""]);

// exports


/***/ }),

/***/ "Fvau":
/***/ (function(module, exports) {

module.exports = "<div ng-form=\"vm.passwordChangeForm\" class=\"dv-password-changer\"> <fieldset> <div class=\"row\"> <div ng-if=\"vm.isEmailVisible()\" ng-class=\"{'col-sm-4': vm.isEmailVisible(), 'col-sm-6': !vm.isEmailVisible()}\"> <dv-input-container> <label for=\"email_ID\" class=\"col-form-label text\" translate=\"LOGIN_EMAIL\"></label> <input id=\"email_ID\" type=\"email\" name=\"email\" ng-model=\"vm.passworddata.email\" dv-max-length class=\"form-control\" required placeholder=\"hans.muster@example.com\" ng-pattern=\"vm.CONSTANTS.PATTERN_EMAIL\" ng-disabled=\"vm.isEmaildisabled()\"> <dv-error-messages for=\"vm.passwordChangeForm.email\" class=\"error\"></dv-error-messages> </dv-input-container> </div> <div ng-class=\"{'col-sm-4': vm.isEmailVisible(), 'col-sm-6': !vm.isEmailVisible()}\"> <dv-input-container> <label for=\"passwordFirst\" class=\"col-form-label text\" translate=\"LOGIN_PASSWD\"></label> <input id=\"passwordFirst\" type=\"password\" name=\"pwd1\" ng-model=\"vm.passworddata.password\" autocomplete=\"off\" dv-max-length class=\"form-control\" ng-required=\"vm.required\"> <dv-error-messages for=\"vm.passwordChangeForm.pwd1\" class=\"error\"></dv-error-messages> </dv-input-container> </div> <div ng-class=\"{'col-sm-4': vm.isEmailVisible(), 'col-sm-6': !vm.isEmailVisible()}\"> <dv-input-container> <label for=\"passwordrepeat\" class=\"col-form-label text\" translate=\"LOGIN_PASSWD_REP\"></label> <input id=\"passwordrepeat\" type=\"password\" name=\"pwd2\" ng-model=\"vm.passworddata.passwordRepeat\" dv-max-length class=\"form-control\" ng-required=\"vm.required\" autocomplete=\"off\"> <dv-error-messages for=\"vm.passwordChangeForm.pwd2\" class=\"error\"></dv-error-messages> </dv-input-container> </div> </div> </fieldset> </div> ";

/***/ }),

/***/ "GI1D":
/***/ (function(module, exports) {

module.exports = "<div class=\"dv-benutzer-list table-responsive\"> <div> <table class=\"table fixedtable table-hover\" dv-st-table-refresh id=\"{{vm.tableId}}\" st-delay=\"20\" st-safe-src=\"vm.benutzerlist\" st-table=\"displayedCollection\" title=\"{{vm.tableTitle}}\"> <thead> <tr class=\"header-row\"> <th class=\"sortable row-vorname\" data-translate=\"VORNAME\" st-sort=\"vorname\"></th> <th class=\"sortable row-nachname\" data-translate=\"NAME\" st-sort=\"nachname\"></th> <th class=\"sortable row-benutzerrolle\" data-translate=\"BENUTZERROLLE\" ng-if=\"vm.showRole\" st-sort=\"roles\"></th> <th class=\"sortable row-anlaufstelle\" data-translate=\"ANLAUFSTELLE\" ng-if=\"vm.showAnlaufstelleAndKanton\" st-sort=\"anlaufstelleList\"></th> <th class=\"sortable row-kanton\" data-translate=\"KANTON\" ng-if=\"vm.showAnlaufstelleAndKanton\" st-sort=\"kantonList\"></th> <th class=\"sortable row-email\" data-translate=\"EMAIL\" st-sort=\"email\"></th> <th class=\"sortable row-telefon\" data-translate=\"TELEFON\" st-sort=\"telefon\"></th> <th class=\"sortable row-status\" data-translate=\"STATUS\" st-sort=\"inaktiv\"></th> <th class=\"sortable row-sprache\" data-translate=\"SPRACHE\" st-sort=\"sprache\"></th> <th class=\"row-action\" ng-if=\"vm.showActions\"></th> </tr> <tr ng-if=\"vm.showFilter\"> <th><input class=\"form-control dv-table__input\" st-search=\"vorname\" type=\"text\"/></th> <th> <input class=\"form-control dv-table__input\" st-search=\"nachname\" type=\"text\"/> </th> <th ng-if=\"vm.showRole\"> <div class=\"dv-select-style\"> <select class=\"form-control dv-table__input\" id=\"role\" name=\"role\" ng-model=\"vm.selectedStatus\" ng-options=\"vm.translateRole(role) for role in vm.getFilterroles() track by role\" st-input-event=\"change\" st-search=\"roles\"> <option value=\"\">{{\"ALLE\" | translate}}</option> </select> </div> </th> <th><input class=\"form-control dv-table__input\" st-search=\"anlaufstelleList\" type=\"text\"/></th> <th><input class=\"form-control dv-table__input\" st-search=\"kantonList\" type=\"text\"/></th> <th> <input class=\"form-control dv-table__input\" st-search=\"email\" type=\"text\"/> </th> <th> <input class=\"form-control dv-table__input\" st-search=\"telefon\" type=\"text\"/> </th> <th> <div class=\"dv-select-style\"> <select class=\"form-control dv-table__input\" id=\"inactive\" name=\"inaktiv\" st-input-event=\"change\" st-search=\"inaktiv\"> <option value=\"\">{{\"ALLE\" | translate}}</option> <option value=\"false\">{{\"AKTIV\" | translate}}</option> <option value=\"true\">{{\"INAKTIV\" | translate}}</option> </select> </div> </th> <th> <div class=\"dv-select-style\"> <select class=\"form-control dv-table__input\" id=\"korrespondenzsprache\" name=\"korrespondenzsprache\" ng-model=\"vm.selectedSprache\" ng-options=\"vm.translateSprache(korrespondenzsprache) for korrespondenzsprache in vm.getTSSpracheValues() track by korrespondenzsprache\" st-input-event=\"change\" st-search=\"korrespondenzsprache\"> <option value=\"\">{{\"ALLE\" | translate}}</option> </select> </div> </th> <th class=\"row-action\" ng-if=\"vm.showActions\"></th> </tr> </thead> <tbody> <tr ng-click=\"vm.editClicked(row, $event)\" ng-repeat=\"row in displayedCollection\" st-select-mode=\"single\" st-select-row=\"row\"> <td class=\"ellipsis\" ng-bind=\"row.vorname\" title=\"{{row.vorname}}\"></td> <td class=\"ellipsis\" ng-bind=\"row.nachname\" title=\"{{row.nachname}}\"></td> <td class=\"ellipsis\" ng-bind=\"vm.translateRoles(row.roles)\" ng-if=\"vm.showRole\" title=\"{{row.roles}}\"></td> <td class=\"ellipsis\" ng-bind=\"row.anlaufstelleList\" ng-if=\"vm.showAnlaufstelleAndKanton\" title=\"{{row.anlaufstelleList}}\"></td> <td class=\"ellipsis\" ng-bind=\"row.kantonList\" ng-if=\"vm.showAnlaufstelleAndKanton\" title=\"{{row.kantonList}}\"></td> <td class=\"ellipsis\" ng-bind=\"row.email\" title=\"{{row.email}}\"></td> <td class=\"ellipsis\" ng-bind=\"row.telefon\" title=\"{{row.telefon}}\"></td> <td class=\"ellipsis\" ng-bind=\"vm.translateAktiv(row.inaktiv)\" title=\"{{row.inaktiv}}\"></td> <td class=\"ellipsis\" ng-bind=\"vm.translateSprache(row.korrespondenzsprache)\" title=\"{{row.korrespondenzsprache}}\"></td> <td class=\"text-center\" ng-if=\"vm.showActions\"> <button class=\"btn-link pull-right\" ng-click=\"vm.deleteClicked(row, $event)\" type=\"button\"> <span class=\"fa fa-trash-o\" title=\"{{'DELETE' | translate}}\"></span> </button> </td> </tr> <tr> </tr><tr ng-if=\"displayedCollection === undefined || displayedCollection.length === 0\"> <td class=\"empty-table\" colspan=\"{{vm.getColumnsNumber()}}\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> <tfoot> </tfoot> </table> </div> </div> ";

/***/ }),

/***/ "GJ89":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * service that manages the golobal window variable for piwik
 */
var PiwikService = /** @class */ (function () {
    // child array
    /* @ngInject */
    function PiwikService($window) {
        this.$window = $window;
        this._paq = []; //this seems to be a piwik config array of arrays thing that has a string as key in the first entry of every
    }
    PiwikService.prototype.getPiwikUrl = function () {
        return 'https://piwik.dvbern.ch/';
    };
    Object.defineProperty(PiwikService.prototype, "paq", {
        get: function () {
            return this._paq;
        },
        set: function (value) {
            this._paq = value;
        },
        enumerable: true,
        configurable: true
    });
    PiwikService.prototype.push = function (pairArr) {
        this.$window['_paq'] = this.$window['_paq'] || [];
        this.$window['_paq'].push(pairArr);
    };
    PiwikService.$inject = ['$window'];
    return PiwikService;
}());
exports.default = PiwikService;


/***/ }),

/***/ "GOMC":
/***/ (function(module, exports) {

module.exports = " <div dv-scroll-nav> <dv-versicherung-navigation title=\"{{vm.getViewTitle()}}\" vers-beitrag-id=\"{{vm.model.id}}\" status=\"{{vm.model.status}}\" sticky=\"sticky\"></dv-versicherung-navigation> <div ng-class=\"['versicherungsbeitrag-beitrag-view', 'container', {'container-sticky':sticky}]\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <fieldset ng-disabled=\"vm.readonly || vm.model.beitrag !== undefined\"> <div class=\"row marginTop0\"> <div class=\"col-sm-12\"> <h1> <span data-translate=\"VERSICHERUNGSBEITRAG_KOSTEN\"></span> </h1> </div> </div> <div class=\"row\"> <div class=\"col-sm-4\"> <dv-input-container> <label data-translate=\"WIEDERHERSTELLUNGSKOSTEN\" for=\"wiederherstellungskosten\"></label> <dv-valueinput input-id=\"wiederherstellungskosten\" name=\"wiederherstellungskosten\" input-name=\"wiederherstellungskosten\" ng-model=\"vm.model.wiederherstellungskosten\" ng-required=\"false\" allow-negative=\"false\" class=\"input-element\"> </dv-valueinput> <dv-error-messages for=\"vm.form.wiederherstellungskosten\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-4\"> <dv-input-container> <label data-translate=\"ERMITTELTERSCHADEN\" for=\"ermittelterSchaden\"></label> <dv-valueinput input-id=\"ermittelterSchaden\" name=\"ermittelterSchaden\" input-name=\"ermittelterSchaden\" ng-model=\"vm.model.ermittelterSchaden\" ng-required=\"true\" allow-negative=\"false\" class=\"input-element\"> </dv-valueinput> <dv-error-messages for=\"vm.form.ermittelterSchaden\"></dv-error-messages> </dv-input-container> </div> </div> <div class=\"row\"> <div class=\"row-sm-12\"> <div class=\"row mainbuttons\"> <div> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.cancelVersicherungsbeitrag()\"> <span data-translate=\"CANCEL\"></span> </button> </div> <div ng-if=\"!vm.isSchadenFallReadonly()\"> <dv-loading-button type=\"submit\" button-click=\"vm.saveVersicherungsbeitrag()\" button-disabled=\"vm.model.beitrag !== undefined\" button-class=\"btn btn-serf\"> <span data-translate=\"SAVE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </div> </div> <div class=\"row\"> <div class=\"col-sm-12 beitragadd\" ng-if=\"vm.addAllowed()\"> <button type=\"submit\" ng-click=\"vm.addBeitrag()\" class=\"btn btn-serf-red\"> <span class=\"fa fa-plus btn-ico\"></span> <span data-translate=\"BEITRAG_HINZUFUEGEN\"></span> </button> </div> </div> </fieldset> </form> <hr/> <dv-versicherungsbeitrag-beitrag versicherungsbeitrag=\"vm.model\" zahlungsauftrag=\"vm.zahlungsauftrag\" on-beitrag-save=\"vm.saveVersicherungsBeitragBeitrag()\" on-beitrag-cancel=\"vm.cancelVersicherungsbeitragbeitrag()\" beitrag-readonly=\"vm.isBeitragReadonly()\"></dv-versicherungsbeitrag-beitrag> <div class=\"col-sm-4 marginTop20\" ng-if=\"vm.model.beitrag && !vm.model.beitrag.isNew() && !vm.isBeitragReadonly()\"> <div> <dv-loading-button type=\"button\" button-click=\"vm.deleteBeitrag()\" button-class=\"btn btn-serf-red btn-beitrag-loeschen\"> <span class=\"fa fa-trash-o btn-ico\"></span> <span data-translate=\"BEITRAG_LOESCHEN_BUTTON\"></span> </dv-loading-button> </div> </div> </div> </div> ";

/***/ }),

/***/ "GUZW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSGemeinde_1 = __importDefault(__webpack_require__("nKms"));
var TSSchadenfallDaten = /** @class */ (function (_super) {
    __extends(TSSchadenfallDaten, _super);
    function TSSchadenfallDaten() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSSchadenfallDaten.prototype, "titel", {
        get: function () {
            return this._titel;
        },
        set: function (value) {
            this._titel = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDaten.prototype, "gemeinde", {
        get: function () {
            return this._gemeinde;
        },
        set: function (value) {
            this._gemeinde = value;
        },
        enumerable: true,
        configurable: true
    });
    TSSchadenfallDaten.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.titel = restObject.titel;
        this.gemeinde = this.deserializeOrNull(restObject.gemeinde, new TSGemeinde_1.default());
        return this;
    };
    TSSchadenfallDaten.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.titel = this.titel;
        restObject.gemeinde = this.serializeOrInit(this.gemeinde, restObject.gemeinde);
        return restObject;
    };
    return TSSchadenfallDaten;
}(TSAbstractEntity_1.default));
exports.default = TSSchadenfallDaten;


/***/ }),

/***/ "GZC1":
/***/ (function(module, exports) {

module.exports = " <div dv-scroll-nav> <dv-gesuch-navigation title=\"{{vm.getViewTitle()}}\" schadenfall-id=\"{{vm.schadenfall.id}}\" status=\"{{vm.schadenfall.status}}\" sticky=\"sticky\" herkunft=\"{{vm.schadenfall.schadenfallHerkunft}}\"></dv-gesuch-navigation> <div ng-class=\"['entschaedigung-view', 'container', {'container-sticky':sticky}]\" ng-if=\"vm.isSchadenFallVisible()\"> <div class=\"row\"> <div class=\"col-sm-12\"> <h2 class=\"marginTop0\"> <span data-translate=\"ABRECHNUNG\"></span> </h2> </div> <div class=\"col-sm-12\"> <table class=\"table table-alt\" title=\"{{'TOTAL' | translate}}\"> <thead> </thead><tbody> <tr> <td data-translate=\"EIGENLEISTUNGEN\"></td> <td class=\"text-right mono\"> {{vm.schadenfall.getFinalEigenleistungenTotal() | number: 2}} </td> </tr> <tr> <td data-translate=\"FREMDKOSTEN\"></td> <td class=\"text-right mono\"> {{vm.schadenfall.getFinalFremdkostenTotal() | number: 2}} </td> </tr> <tr> <td data-translate=\"VORLEISTUNGEN\"></td> <td class=\"text-right mono\"> - {{vm.schadenfall.getFinalVorleistungenTotal() | number: 2}} </td> </tr> </tbody> <tfoot> <form role=\"form\" name=\"vm.ermittelterSchadenForm\" novalidate> <tr class=\"tr-highlight\"> <td data-translate=\"ABRECHNUNGS_BETRAG\"></td> <td class=\"text-right mono\"> {{vm.schadenfall.getAbrechnungsbetrag(false) | number: 2}} </td> </tr> <tr dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\"> <td data-translate=\"TOTAL_SCHAETZUNG\"> </td> <td class=\"text-right mono\"> {{vm.schadenfall.getAbrechnungsbetrag(true) | number: 2}} </td> </tr> <tr dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\"> <td data-translate=\"GESCHAETZTER_MEHRWERT\"> </td> <td class=\"text-right mono\"> {{vm.schadenfall.schaeden[0].schadenDatenFS.geschaetzterMehrwert | number: 2}} </td> </tr> <tr class=\"tr-highlight tr-highlight--noborder\"> <td data-translate=\"ERMITTELTER_SCHADEN\"></td> <td class=\"text-right mono col-sm-2\" style=\"padding:0\"> <dv-input-container class=\"text-right mono\"> <dv-valueinput input-id=\"ermittelterSchaden\" ng-disabled=\"vm.isSchadenFallReadonly()\" name=\"ermittelterSchaden\" input-name=\"ermittelterSchaden\" ng-model=\"vm.model.ermittelterSchaden\" allow-negative=\"false\" ng-required=\"true\" float=\"true\" fixed-decimals=\"2\" class=\"text-right bigger-font\"> </dv-valueinput> <dv-error-messages for=\"vm.ermittelterSchadenForm.ermittelterSchaden\"></dv-error-messages> </dv-input-container> </td> </tr> <tr class=\"tr-highlight tr-highlight--noborder\"> <td data-translate=\"NICHT_BERECHTIGTER_ANTEIL\"></td> <td class=\"text-right mono col-sm-2\" style=\"padding:0\"> <dv-input-container class=\"text-right mono\"> <dv-valueinput input-id=\"nichtBerechtigterAnteil\" ng-disabled=\"vm.isSchadenFallReadonly()\" name=\"nichtBerechtigterAnteil\" input-name=\"nichtBerechtigterAnteil\" ng-model=\"vm.model.nichtBerechtigterAnteil\" allow-negative=\"false\" float=\"true\" fixed-decimals=\"2\" class=\"text-right bigger-font\"> </dv-valueinput> <dv-error-messages for=\"vm.ermittelterSchadenForm.nichtBerechtigterAnteil\"></dv-error-messages> </dv-input-container> </td> </tr> </form> </tfoot> </table> <dv-loading-button type=\"submit\" button-click=\"vm.saveErmittelterSchaden()\" button-class=\"btn btn-serf-red\" button-disabled=\"vm.isSchadenFallReadonly()\"> <span data-translate=\"ERMITTELTER_SCHADEN_SPEICHERN\"></span> </dv-loading-button> </div> </div> <div class=\"row marginTop20\"> <div class=\"col-sm-12\"> <h2> <span data-translate=\"BEITRAEGE\"></span> </h2> <div dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\"> <button type=\"button\" ng-click=\"vm.addBeitrag()\" class=\"btn btn-serf-red\" ng-disabled=\"vm.cannotAddBeitraege()\"> <span class=\"fa fa-plus btn-ico\"></span> <span data-translate=\"BEITRAG_ADD\" ng-if=\"vm.hasBeitraege()\"></span> <span data-translate=\"BEITRAG_CREATE\" ng-if=\"!vm.hasBeitraege()\"></span> </button> </div> </div> <div class=\"col-sm-12\"> <div class=\"dv-beitraege-list\"> <div class=\"table-responsive\"> <table st-table=\"displayedCollection\" st-safe-src=\"vm.schadenfall.beitraege\" st-delay=\"20\" class=\"table fixedtable table-hover\" id=\"{{vm.tableId}}\" title=\"{{vm.tableTitle}}\" dv-st-table-refresh> <thead> <tr class=\"header-row\"> <th data-translate=\"DATUM\" style=\"min-width:100px\"></th> <th data-translate=\"BEITRAG_ART\" style=\"min-width:150px\"></th> <th data-translate=\"KONTO_INHABER\"></th> <th data-translate=\"BETRAG\" class=\"text-right\"></th> <th data-translate=\"STATUS\" style=\"width:170px\"></th> <th class=\"row-actions\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"row in displayedCollection\" st-select-row=\"row\" st-select-mode=\"single\"> <td class=\"ellipsis\" title=\"{{row.id}}\" ng-bind=\"row.timestampErstellt | amDateFormat : 'DD.MM.YYYY' \"></td> <td class=\"ellipsis\" title=\"{{'TSBeitragArt_' + row.beitragArt | translate}}\" ng-bind=\"'TSBeitragArt_' + row.beitragArt | translate\"></td> <td class=\"ellipsis\" title=\"{{row.getBeguenstigterName()}}\" ng-bind=\"row.getBeguenstigterName()\"></td> <td class=\"ellipsis text-right mono\" title=\"{{row.beitrag | currency: 'CHF'}}\" ng-bind=\"row.beitrag | currency: 'CHF'\"></td> <td class=\"ellipsis\" title=\"{{'TSBeitragStatus_' + row.beitragStatus | translate}}\" ng-bind=\"'TSBeitragStatus_' + row.beitragStatus | translate\"></td> <td> <button ng-click=\"vm.deleteBeitrag(row)\" class=\"btn-link pull-right\" ng-if=\"!vm.isSchadenFallReadonly() && !vm.isAusgefuehrt(row)\"> <span class=\"fa fa-trash-o\" title=\"{{'DELETE' | translate}}\"></span> </button> <button ng-click=\"vm.editClicked(row, $event)\" class=\"btn-link pull-right\"> <span class=\"fa fa-eye\" title=\"{{'EDIT' | translate}}\"></span> </button> </td> </tr> <tr ng-if=\"displayedCollection === undefined || displayedCollection.length === 0\"> <td colspan=\"6\" class=\"empty-table\" data-translate=\"KEIN_EINTRAG\"></td> </tr> </tbody> <tfoot> <tr class=\"tr-highlight\"> <td colspan=\"3\" data-translate=\"TOTAL\"></td> <td class=\"text-right mono\" ng-bind=\"vm.getTotal()| currency: 'CHF'\"></td> <td colspan=\"2\"></td> </tr> </tfoot> </table> </div> </div> </div> </div> <form role=\"form\" name=\"vm.form\" class=\"row marginTop20\" novalidate> <div class=\"row\" ng-if=\"vm.isFreigabeVisible()\"> <div class=\"checklist\"> <div class=\"h2 clearfix\"> <span data-translate=\"CHECKLISTE\"></span> </div> <dv-checklist on-checkstatus-chaged=\"vm.checklistStatusChanged(allchecked)\" checklist-points=\"vm.getChecklistEntries()\"></dv-checklist> </div> </div> </form> </div> <fieldset class=\"\" ng-disabled=\"vm.isSchadenFallReadonly()\"> <div class=\"row freigebenfs\" ng-if=\"vm.isFreigabeVisible()\"> <div class=\"col-sm-12\"> <div class=\"row\"> <div class=\"col-sm-12 schadenevents\"> <dv-input-container> <div class=\"radio\" ng-repeat=\"schadenfallEvent in vm.getSchadenfallEvents()\"> <label> <input ng-value=\"schadenfallEvent\" aria-label=\"{{schadenfallEvent}}\" ng-model=\"vm.schadenfallEvent\" ng-disabled=\"vm.isFreigabeDisabled()\" type=\"radio\" name=\"schadenfallEvent\" ng-required=\"true\" class=\"input-element\"> <span>{{schadenfallEvent | translate}}</span> </label> </div> </dv-input-container> </div> </div> </div> <div class=\"mainbuttons-freigeben\"> <div> <button class=\"btn btn-serf btn-zurueck\" ng-click=\"vm.back()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> <dv-loading-button type=\"submit\" button-click=\"vm.next()\" button-class=\"btn btn-serf\" button-disabled=\"!vm.schadenfallEvent\"> <span data-translate=\"FREIGEBEN\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </fieldset> </div> ";

/***/ }),

/***/ "Gb7M":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".dvb-error-messages-panel{height:auto;color:#000;background-color:#fff}.dvb-error-messages-panel--info{color:#4c9dcb;background-color:rgba(76,157,203,.3)}.dvb-error-messages-panel--info__icon,.dvb-error-messages-panel--info__icon--close{color:#4c9dcb}.dvb-error-messages-panel--info__icon:after{content:\"\\F05A\";font-family:FontAwesome,sans-serif}.dvb-error-messages-panel--warning{color:#dcc100;background-color:rgba(220,193,0,.3)}.dvb-error-messages-panel--warning__icon,.dvb-error-messages-panel--warning__icon--close{color:#dcc100}.dvb-error-messages-panel--warning__icon:after{content:\"\\F071\";font-family:FontAwesome,sans-serif}.dvb-error-messages-panel--danger{color:#ff2b59;background-color:rgba(255,43,89,.3)}.dvb-error-messages-panel--danger__icon,.dvb-error-messages-panel--danger__icon--close{color:#ff2b59}.dvb-error-messages-panel--danger__icon:after{content:\"\\F06A\";font-family:FontAwesome,sans-serif}.dvb-error-messages-panel--success{color:#4cca69;background-color:rgba(76,202,105,.3)}.dvb-error-messages-panel--success__icon,.dvb-error-messages-panel--success__icon--close{color:#4cca69}.dvb-error-messages-panel--success__icon:after{content:\"\\F058\";font-family:FontAwesome,sans-serif}.dvb-error-messages-panel__icon--alert{margin-right:50px}.dvb-error-messages-panel__icon--close{position:absolute;left:100%;margin-left:-36px}.dvb-error-messages-panel__container{display:flex;align-items:center;justify-content:center;min-height:55px}", ""]);

// exports


/***/ }),

/***/ "GbIU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSBeitraegeSearchresultDTO_1 = __importDefault(__webpack_require__("Y2Uj"));
var TSBeitrag_1 = __importDefault(__webpack_require__("Bftz"));
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
/**
 * Service zum verwalten von Beitrag Angaben
 *
 */
var BeitragRS = /** @class */ (function () {
    /* @ngInject */
    function BeitragRS($http, CONSTANTS, $q, $rootScope, $log) {
        this.$http = $http;
        this.CONSTANTS = CONSTANTS;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$log = $log;
        this.serviceURL = this.CONSTANTS.REST_API + 'beitrag';
    }
    BeitragRS.prototype.saveSchadenfallBeitrag = function (schadenfallId, beitrag) {
        if (beitrag) {
            var restBeitrag = beitrag.serialize({});
            return this.$http.put(this.CONSTANTS.REST_API + 'beitrag/schadenfallbeitrag/' + encodeURIComponent(schadenfallId), restBeitrag)
                .then(function (response) {
                if (response.data !== undefined) {
                    return new TSBeitrag_1.default().deserialize(response.data);
                }
                return undefined;
            });
        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    };
    BeitragRS.prototype.saveVersicherungsbeitragBeitrag = function (VersicherungsbeitragId, beitrag) {
        if (beitrag) {
            var restBeitrag = beitrag.serialize({});
            return this.$http.put(this.CONSTANTS.REST_API + 'beitrag/versicherungsbeitrag/' + encodeURIComponent(VersicherungsbeitragId), restBeitrag)
                .then(function (response) {
                if (response.data !== undefined) {
                    return new TSBeitrag_1.default().deserialize(response.data);
                }
                return undefined;
            });
        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    };
    BeitragRS.prototype.deleteBeitrag = function (beitrag) {
        return this.$http.delete(this.CONSTANTS.REST_API + 'beitrag/' + encodeURIComponent(beitrag.id))
            .then(function (response) {
            return response;
        });
    };
    BeitragRS.prototype.searchBeitraege = function (beitraegeSearch, prefilter) {
        var _this = this;
        beitraegeSearch.prefilter = prefilter;
        return this.$http.post(this.serviceURL + '/search/', beitraegeSearch, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            _this.$log.debug('PARSING beitraege REST array object', response.data);
            return new TSBeitraegeSearchresultDTO_1.default().deserialize(response.data);
        });
    };
    BeitragRS.prototype.beitraegeFreigeben = function (ids) {
        return this.$http.post(this.serviceURL + '/freigeben/', ids, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            return response;
        });
    };
    BeitragRS.prototype.beitraegeAusfuehren = function (ids, ref, datumFaellig) {
        return this.$http.post(this.serviceURL + '/ausfuehren/' + ref + '/' + DateUtil_1.default.momentToLocalDate(datumFaellig), ids, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            return response;
        });
    };
    BeitragRS.$inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];
    return BeitragRS;
}());
exports.default = BeitragRS;


/***/ }),

/***/ "Gbao":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSInspektorat_1 = __importDefault(__webpack_require__("6bjF"));
/**
 * Service zum verwalten von Inspektorat.
 */
var InspektoratRS = /** @class */ (function () {
    /* @ngInject */
    function InspektoratRS($http, CONSTANTS, $q, $rootScope, $log) {
        this.$http = $http;
        this.CONSTANTS = CONSTANTS;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$log = $log;
    }
    InspektoratRS.prototype.getAllInspektorat = function () {
        var _this = this;
        return this.$http.get(this.CONSTANTS.REST_API + 'inspektorat/')
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING Inspektoratn REST  object', response.data);
                return TSInspektorat_1.default.deserializeArray(response.data);
            }
            else {
                return [];
            }
        });
    };
    InspektoratRS.prototype.findInspektorat = function (inspektoratId) {
        var _this = this;
        return this.$http.get(this.CONSTANTS.REST_API + 'inspektorat/' + encodeURIComponent(inspektoratId))
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING TSInspektorat REST  object', response.data);
                return new TSInspektorat_1.default().deserialize(response.data);
            }
            else {
                return undefined;
            }
        });
    };
    InspektoratRS.prototype.createOrUpdate = function (inspektorat) {
        if (inspektorat) {
            var restInspektorat = inspektorat.serialize({});
            return this.$http.put(this.CONSTANTS.REST_API + 'inspektorat/', restInspektorat)
                .then(function (response) {
                if (response.data !== undefined) {
                    return new TSInspektorat_1.default().deserialize(response.data);
                }
                else {
                    return undefined;
                }
            });
        }
        this.$log.error('passed no data, no createOrUpdate request sent');
        return this.$q.when(undefined);
    };
    InspektoratRS.$inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];
    return InspektoratRS;
}());
exports.default = InspektoratRS;


/***/ }),

/***/ "Gh6o":
/***/ (function(module, exports) {

module.exports = " <div class=\"chart-container\"> <canvas id=\"{{vm.chartid}}\"></canvas> </div> ";

/***/ }),

/***/ "Gj8C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSErrorEvent_1 = __webpack_require__("NVeR");
var TSErrorLevel_1 = __webpack_require__("92KJ");
var TSErrorType_1 = __webpack_require__("NSBJ");
var TSExceptionReport_1 = __importDefault(__webpack_require__("PnIR"));
var ErrorService = /** @class */ (function () {
    /* @ngInject */
    function ErrorService($rootScope) {
        this.$rootScope = $rootScope;
        this.errors = [];
    }
    /**
     * @returns {Array|DvbError}
     */
    ErrorService.prototype.getErrors = function () {
        return angular.copy(this.errors);
    };
    /**
     * Clears all stored errors
     */
    ErrorService.prototype.clearAll = function () {
        this.errors = [];
        this.$rootScope.$broadcast(TSErrorEvent_1.TSMessageEvent[TSErrorEvent_1.TSMessageEvent.CLEAR]);
    };
    ErrorService.prototype.clearAllOfSeverity = function (severity) {
        var cleared = this.errors.filter(function (e) {
            return e.severity !== severity;
        });
        if (cleared.length !== this.errors.length) {
            this.errors = cleared;
            this.$rootScope.$broadcast(TSErrorEvent_1.TSMessageEvent[TSErrorEvent_1.TSMessageEvent.ERROR_UPDATE], this.errors);
        }
    };
    /** clear specific error
     * @param {string} msgKey
     */
    ErrorService.prototype.clearError = function (msgKey) {
        if (typeof msgKey !== 'string') {
            return;
        }
        var cleared = this.errors.filter(function (e) {
            return e.msgKey !== msgKey;
        });
        if (cleared.length !== this.errors.length) {
            this.errors = cleared;
            this.$rootScope.$broadcast(TSErrorEvent_1.TSMessageEvent[TSErrorEvent_1.TSMessageEvent.ERROR_UPDATE], this.errors);
        }
    };
    /**
     * This can be used to add a client-siede global error
     * @param {string} msgKey translation key
     * @param {Object} [args] message parameters
     */
    ErrorService.prototype.addValidationError = function (msgKey, args) {
        var err = TSExceptionReport_1.default.createClientSideError(TSErrorLevel_1.TSErrorLevel.SEVERE, msgKey, args);
        this.addDvbError(err);
    };
    ErrorService.prototype.containsError = function (dvbError) {
        return this.errors.some(function (error) { return error.msgKey === dvbError.msgKey; });
    };
    ErrorService.prototype.addDvbError = function (dvbError) {
        if (dvbError && dvbError.isValid()) {
            if (!this.containsError(dvbError)) {
                this.errors.push(dvbError);
                var udateEvent = (dvbError.severity === TSErrorLevel_1.TSErrorLevel.INFO) ? TSErrorEvent_1.TSMessageEvent.INFO_UPDATE : TSErrorEvent_1.TSMessageEvent.ERROR_UPDATE;
                this.$rootScope.$broadcast(TSErrorEvent_1.TSMessageEvent[udateEvent], this.errors);
            }
        }
        else {
            console.log('could not display received TSExceptionReport ' + dvbError);
        }
    };
    ErrorService.prototype.addMesageAsError = function (msg) {
        var error = new TSExceptionReport_1.default(TSErrorType_1.TSErrorType.INTERNAL, TSErrorLevel_1.TSErrorLevel.SEVERE, msg, null);
        this.addDvbError(error);
    };
    ErrorService.prototype.addMesageAsInfo = function (msg) {
        var error = new TSExceptionReport_1.default(TSErrorType_1.TSErrorType.INTERNAL, TSErrorLevel_1.TSErrorLevel.INFO, msg, null);
        this.addDvbError(error);
    };
    ErrorService.prototype.addMesageAsInfoWithArgs = function (msg, args) {
        var error = new TSExceptionReport_1.default(TSErrorType_1.TSErrorType.INTERNAL, TSErrorLevel_1.TSErrorLevel.INFO, msg, args);
        this.addDvbError(error);
    };
    /**
     * @param {boolean} isValid when FALSE a new validationError is added. Otherwise the validationError is cleared
     * @param {string} msgKey
     * @param {Object} [args]
     */
    ErrorService.prototype.handleValidationError = function (isValid, msgKey, args) {
        if (!!isValid) {
            this.clearError(msgKey);
        }
        else {
            this.addValidationError(msgKey, args);
        }
    };
    /**
     * @param {DvbError} dvbError adds a DvbError to the errors
     */
    ErrorService.prototype.handleError = function (dvbError) {
        this.addDvbError(dvbError);
    };
    /**
     * @param {DvbError} dvbErrors adds all Errors to the errors service
     */
    ErrorService.prototype.handleErrors = function (dvbErrors) {
        if (dvbErrors) {
            try {
                for (var dvbErrors_1 = __values(dvbErrors), dvbErrors_1_1 = dvbErrors_1.next(); !dvbErrors_1_1.done; dvbErrors_1_1 = dvbErrors_1.next()) {
                    var err = dvbErrors_1_1.value;
                    this.addDvbError(err);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (dvbErrors_1_1 && !dvbErrors_1_1.done && (_a = dvbErrors_1.return)) _a.call(dvbErrors_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var e_1, _a;
    };
    ErrorService.$inject = ['$rootScope'];
    return ErrorService;
}());
exports.default = ErrorService;


/***/ }),

/***/ "GoBd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var Raven = __webpack_require__("/Hyb");
var TSAuthEvent_1 = __webpack_require__("L0QB");
var TSErfassungsArt_1 = __webpack_require__("X/T9");
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var TSBenutzerBemerkung_1 = __importDefault(__webpack_require__("3/Vo"));
var TSSchadenfall_1 = __importDefault(__webpack_require__("mUaf"));
var TSTransitionBemerkung_1 = __importDefault(__webpack_require__("7eCW"));
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
var SchadenfallModelManager = /** @class */ (function () {
    /* @ngInject */
    function SchadenfallModelManager(schadenfallRS, schadenRS, log, authServiceRS, errorService, $q, CONSTANTS, $rootScope, roleUtilService, fremdkostenRS, eigenleistungenRS, vorleistungenRS, bemerkungRS, beitragRS, berechtigungsService) {
        var _this = this;
        this.schadenfallRS = schadenfallRS;
        this.schadenRS = schadenRS;
        this.log = log;
        this.authServiceRS = authServiceRS;
        this.errorService = errorService;
        this.$q = $q;
        this.CONSTANTS = CONSTANTS;
        this.$rootScope = $rootScope;
        this.roleUtilService = roleUtilService;
        this.fremdkostenRS = fremdkostenRS;
        this.eigenleistungenRS = eigenleistungenRS;
        this.vorleistungenRS = vorleistungenRS;
        this.bemerkungRS = bemerkungRS;
        this.beitragRS = beitragRS;
        this.berechtigungsService = berechtigungsService;
        $rootScope.$on(TSAuthEvent_1.TSAuthEvent[TSAuthEvent_1.TSAuthEvent.LOGOUT_SUCCESS], function () {
            _this.setSchadenfall(undefined);
            _this.log.debug('Cleared gesuch on logout');
        });
    }
    SchadenfallModelManager.prototype.initNewSchadenfall = function () {
        this.schadenfall = new TSSchadenfall_1.default().init();
        if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getGesuchstellerOnlyRoles())) {
            this.schadenfall.status = TSSchadenfallStatus_1.TSSchadenfallStatus.NEU;
            this.schadenfall.erfassungsart = TSErfassungsArt_1.TSErfassungsArt.ONLINE;
        }
        else if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getFondssuisseRoles())) {
            this.schadenfall.status = TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS;
            this.schadenfall.erfassungsart = TSErfassungsArt_1.TSErfassungsArt.PAPIER;
            this.schadenfall.gesuchsteller.finanzangaben.zustimmungSteuerpruefung = true; // bei erstperson sind finanzangaben sicher da
            this.schadenfall.gesuchsteller.finanzangaben.zustimmungPruefungFondsuisse = true;
        }
        else if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getAnlaufstelleRoles())) {
            this.schadenfall.status = TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE;
            this.schadenfall.erfassungsart = TSErfassungsArt_1.TSErfassungsArt.PAPIER;
            this.schadenfall.gesuchsteller.finanzangaben.zustimmungSteuerpruefung = true; // bei erstperson sind finanzangaben sicher da
            this.schadenfall.gesuchsteller.finanzangaben.zustimmungPruefungFondsuisse = true;
        }
        return this.$q.when(this.schadenfall);
    };
    /**
     * Je nach dem welche Rolle der Benutzer hat, wird das Gesuch aus der DB anders geholt.
     * Fuer Institutionen z.B. wird das Gesuch nur mit den relevanten Daten geholt
     */
    SchadenfallModelManager.prototype.openSchadenfall = function (schadenfallId) {
        var _this = this;
        return this.schadenfallRS.findSchadenfall(schadenfallId)
            .then(function (response) {
            _this.setSchadenfall(response);
            return response;
        });
    };
    SchadenfallModelManager.prototype.setSchadenfall = function (schadenfall) {
        Raven.setTagsContext({
            schadenfallId: schadenfall ? schadenfall.getFallnummerWithZeros() : undefined,
            schadenfallStatus: schadenfall ? schadenfall.status : undefined,
        });
        this.schadenfall = schadenfall;
    };
    SchadenfallModelManager.prototype.getSchadenfall = function () {
        return this.schadenfall;
    };
    /**
     *
     * @param schadenfallId id die geprueft wird
     * @return {boolean} True wenn der aktuelle Schadenfall die gegebene id hat
     */
    SchadenfallModelManager.prototype.isSchadenfall = function (schadenfallId) {
        if (this.schadenfall) {
            return this.schadenfall.id === schadenfallId;
        }
        return false;
    };
    SchadenfallModelManager.prototype.reloadSchadenfall = function () {
        var _this = this;
        if (this.schadenfall) {
            return this.schadenfallRS.findSchadenfall(this.schadenfall.id).then(function (schadenfallResp) {
                _this.setSchadenfall(schadenfallResp);
                return _this.schadenfall;
            });
        }
        return this.$q.when(this.schadenfall);
    };
    /**
     * Update das Gesuch
     * @returns {IPromise<TSSchadenfall>}
     */
    SchadenfallModelManager.prototype.updateSchadenfall = function () {
        var _this = this;
        if (this.schadenfall) {
            return this.schadenfallRS.update(this.schadenfall).then(function (schadResp) {
                _this.setSchadenfall(schadResp);
                return _this.getSchadenfall();
            });
        }
        else {
            throw 'ILLEGAL_STATE';
        }
    };
    SchadenfallModelManager.prototype.saveBankverbindung = function (schadenfall) {
        var _this = this;
        if (schadenfall) {
            return this.schadenfallRS.updateBankverbindung(schadenfall).then(function (response) {
                // it is necessary to load Schadenfall again so the instance contains the changes in Bankverbindung
                return _this.openSchadenfall(schadenfall.id).then(function () {
                    return response;
                });
            });
        }
        return;
    };
    SchadenfallModelManager.prototype.setUserAsFallVerantwortlicher = function (user) {
        if (this.schadenfall) {
            console.log('not yet implemented set  verantwortlicher');
        }
    };
    SchadenfallModelManager.prototype.getFallVerantwortlicher = function () {
        if (this.schadenfall) {
            console.log('not yet implemented');
            return undefined;
            //            return this.schadenfall.verantwortlicher
        }
        return undefined;
    };
    /**
     * Returns true if the Schadenfall has the given status
     * @param status
     * @returns {boolean}
     */
    SchadenfallModelManager.prototype.isSchadenfallStatus = function (status) {
        if (this.schadenfall) {
            return this.schadenfall.status === status;
        }
        return false;
    };
    SchadenfallModelManager.prototype.clearSchadenfall = function () {
        this.setSchadenfall(undefined);
    };
    SchadenfallModelManager.prototype.saveSchadenfall = function (schadenfall) {
        var _this = this;
        return this.schadenfallRS.update(schadenfall).then(function (schadResp) {
            _this.setSchadenfall(schadResp);
            return _this.getSchadenfall();
        });
    };
    SchadenfallModelManager.prototype.handleTransition = function (schadenfall, scope, begruendungsCode, bemerkung, event) {
        var _this = this;
        return this.schadenfallRS.handleTransition(schadenfall, scope, begruendungsCode, bemerkung, event).then(function (schadResp) {
            _this.setSchadenfall(schadResp);
            return _this.getSchadenfall();
        });
    };
    // handleTransition nur mit schadenfallId
    SchadenfallModelManager.prototype.handleTransitionForId = function (schadenfallId, scope, begruendungsCode, bemerkung, event) {
        var _this = this;
        return this.schadenfallRS.handleTransitionForId(schadenfallId, scope, begruendungsCode, bemerkung, event).then(function (schadResp) {
            _this.setSchadenfall(schadResp);
            return _this.getSchadenfall();
        });
    };
    SchadenfallModelManager.prototype.deleteSchaden = function (schadenfall, schaden) {
        var _this = this;
        return this.schadenRS.deleteSchaden(schadenfall.id, schaden.id).then(function (resp) {
            var index = DVBernUtil_1.default.getIndexOfElementwithID(schaden, schadenfall.schaeden);
            if (index > -1) {
                schadenfall.schaeden.splice(index, 1);
            }
            _this.setSchadenfall(schadenfall);
            return _this.getSchadenfall();
        });
    };
    SchadenfallModelManager.prototype.saveSchaden = function (schadenenToSave) {
        if (this.schadenfall) {
            var schadenenList_1;
            if (this.schadenfall.schaeden == null || this.schadenfall.schaeden === undefined) {
                schadenenList_1 = [];
                this.schadenfall.schaeden = schadenenList_1;
            }
            else {
                schadenenList_1 = this.schadenfall.schaeden;
            }
            return this.schadenRS.saveSchaden(this.schadenfall.id, schadenenToSave)
                .then(function (storedSchaden) {
                if (!schadenenToSave.isNew()) { //gespeichertes entity war nicht neu
                    var i = DVBernUtil_1.default.getIndexOfElementwithID(schadenenToSave, schadenenList_1);
                    if (i >= 0) {
                        schadenenList_1[i] = storedSchaden;
                    }
                }
                else {
                    schadenenList_1.push(storedSchaden); //zur Liste hinzufuegen
                }
                return storedSchaden;
            });
        }
        this.log.error('could not save Schaden because no schadenfall is managed');
        return this.$q.when(schadenenToSave);
    };
    SchadenfallModelManager.prototype.saveBemerkung = function (bemerkungToSave, schadenfallId) {
        var _this = this;
        if (bemerkungToSave instanceof TSBenutzerBemerkung_1.default) {
            if (this.schadenfall && schadenfallId && schadenfallId === this.schadenfall.id) {
                return this.saveInList(schadenfallId, this.schadenfall.benutzerBemerkungen, bemerkungToSave, function (schadenfallId, bem) {
                    return _this.bemerkungRS.saveBenutzerBemerkung(schadenfallId, bem);
                });
            }
        }
        else if (bemerkungToSave instanceof TSTransitionBemerkung_1.default) {
            if (this.schadenfall && schadenfallId && schadenfallId === this.schadenfall.id) {
                return this.saveInList(schadenfallId, this.schadenfall.transitionBemerkungen, bemerkungToSave, function (schadenfallId, bem) {
                    return _this.bemerkungRS.saveTransitionBemerkung(schadenfallId, bem);
                });
            }
        }
        this.log.error('could not save Bemerkung because no schadenfall is managed');
        return this.$q.when(bemerkungToSave);
    };
    SchadenfallModelManager.prototype.saveInList = function (schadenfallId, listToStoreIn, objectToSave, saveFunction) {
        var benutzerBemerkungen;
        if (listToStoreIn === null || listToStoreIn === undefined) {
            benutzerBemerkungen = [];
            listToStoreIn = benutzerBemerkungen;
        }
        else {
            benutzerBemerkungen = listToStoreIn;
        }
        return saveFunction(schadenfallId, objectToSave)
            .then(function (storedObject) {
            if (!objectToSave.isNew()) { //gespeichertes entity war nicht neu
                var i = DVBernUtil_1.default.getIndexOfElementwithID(objectToSave, benutzerBemerkungen);
                if (i >= 0) {
                    benutzerBemerkungen[i] = storedObject;
                }
            }
            else {
                benutzerBemerkungen.push(storedObject); //zur Liste hinzufuegen
            }
            return storedObject;
        });
    };
    SchadenfallModelManager.prototype.removeBemerkung = function (bemerkung, schadenfallId) {
        if (bemerkung instanceof TSBenutzerBemerkung_1.default) {
            if (this.schadenfall && this.schadenfall.benutzerBemerkungen !== undefined && schadenfallId === this.schadenfall.id) {
                var benutzerBemerkungen_1 = this.schadenfall.benutzerBemerkungen;
                var i_1 = DVBernUtil_1.default.getIndexOfElementwithID(bemerkung, benutzerBemerkungen_1);
                if (i_1 >= 0) {
                    if (bemerkung.isNew()) {
                        benutzerBemerkungen_1.splice(i_1, 1); //remove element
                        return this.$q.when(undefined);
                    }
                    else {
                        this.bemerkungRS.deleteBenutzerBemerkung(bemerkung.id).then(function (response) {
                            benutzerBemerkungen_1.splice(i_1, 1); //remove element
                            return response;
                        });
                    }
                }
            }
        }
        else if (bemerkung instanceof TSTransitionBemerkung_1.default) {
            if (this.schadenfall && this.schadenfall.transitionBemerkungen !== undefined && schadenfallId === this.schadenfall.id) {
                var transitionBemerkung_1 = this.schadenfall.transitionBemerkungen;
                var i_2 = DVBernUtil_1.default.getIndexOfElementwithID(bemerkung, transitionBemerkung_1);
                if (i_2 >= 0) {
                    if (bemerkung.isNew()) {
                        transitionBemerkung_1.splice(i_2, 1); //remove element
                        return this.$q.when(undefined);
                    }
                    else {
                        this.bemerkungRS.deleteTransitionBemerkung(bemerkung.id).then(function (response) {
                            transitionBemerkung_1.splice(i_2, 1); //remove element
                            return response;
                        });
                    }
                }
            }
        }
        return this.$q.when(undefined);
    };
    SchadenfallModelManager.prototype.saveFremdkosten = function (fremdkostenToSave) {
        if (this.schadenfall) {
            var fremdkostenList_1;
            if (this.schadenfall.fremdkosten == null || this.schadenfall.fremdkosten === undefined) {
                fremdkostenList_1 = [];
                this.schadenfall.fremdkosten = fremdkostenList_1;
            }
            else {
                fremdkostenList_1 = this.schadenfall.fremdkosten;
            }
            return this.fremdkostenRS.saveFremdkosten(this.schadenfall.id, fremdkostenToSave)
                .then(function (storedFremdkosten) {
                if (!fremdkostenToSave.isNew()) { //gespeichertes entity war nicht neu
                    var i = DVBernUtil_1.default.getIndexOfElementwithID(fremdkostenToSave, fremdkostenList_1);
                    if (i >= 0) {
                        fremdkostenList_1[i] = storedFremdkosten;
                    }
                }
                else {
                    fremdkostenList_1.push(storedFremdkosten); //neuen Schadenfall anfuegen
                }
                return storedFremdkosten;
            });
        }
        this.log.error('could not save Fremdkosten because no schadenfall is managed');
        return this.$q.when(fremdkostenToSave);
    };
    SchadenfallModelManager.prototype.removeFremdkosten = function (fremdkosten) {
        if (this.schadenfall && this.schadenfall.fremdkosten !== undefined) {
            var fremdkostenList_2 = this.schadenfall.fremdkosten;
            var i_3 = DVBernUtil_1.default.getIndexOfElementwithID(fremdkosten, fremdkostenList_2);
            if (i_3 >= 0) {
                if (fremdkosten.isNew()) {
                    fremdkostenList_2.splice(i_3, 1); //remove element
                    return this.$q.when(undefined);
                }
                else {
                    return this.fremdkostenRS.deleteFremdkosten(fremdkosten).then(function (response) {
                        fremdkostenList_2.splice(i_3, 1); //remove element
                        return response;
                    });
                }
            }
        }
        return this.$q.when(undefined);
    };
    SchadenfallModelManager.prototype.saveVorleistung = function (vorleistungToSave) {
        if (this.schadenfall) {
            var vorleistungList_1;
            if (this.schadenfall.vorleistungen == null || this.schadenfall.vorleistungen === undefined) {
                vorleistungList_1 = [];
                this.schadenfall.vorleistungen = vorleistungList_1;
            }
            else {
                vorleistungList_1 = this.schadenfall.vorleistungen;
            }
            return this.vorleistungenRS.saveVorleistung(this.schadenfall.id, vorleistungToSave)
                .then(function (storedVorleistung) {
                if (!vorleistungToSave.isNew()) { //gespeichertes entity war nicht neu
                    var i = DVBernUtil_1.default.getIndexOfElementwithID(vorleistungToSave, vorleistungList_1);
                    if (i >= 0) {
                        vorleistungList_1[i] = storedVorleistung;
                    }
                }
                else {
                    vorleistungList_1.push(storedVorleistung); //zur Liste hinzufuegen
                }
                return storedVorleistung;
            });
        }
        this.log.error('could not save Vorleistung because no schadenfall is managed');
        this.errorService.addMesageAsError('ERROR_UNEXPECTED');
        return this.$q.when(vorleistungToSave);
    };
    SchadenfallModelManager.prototype.removeVorleistung = function (vorleistung) {
        if (this.schadenfall && this.schadenfall.vorleistungen !== undefined) {
            var vorleistungList_2 = this.schadenfall.vorleistungen;
            var i_4 = DVBernUtil_1.default.getIndexOfElementwithID(vorleistung, vorleistungList_2);
            if (i_4 >= 0) {
                if (vorleistung.isNew()) {
                    vorleistungList_2.splice(i_4, 1); //remove element
                    return this.$q.when(undefined);
                }
                else {
                    return this.vorleistungenRS.deleteVorleistung(vorleistung).then(function (response) {
                        vorleistungList_2.splice(i_4, 1); //remove element
                        return response;
                    });
                }
            }
        }
        return this.$q.when(undefined);
    };
    SchadenfallModelManager.prototype.saveEigenleistungen = function (eigenleistungenToSave) {
        if (this.schadenfall) {
            var eigenleistungenList_1;
            if (this.schadenfall.eigenleistungen == null || this.schadenfall.eigenleistungen === undefined) {
                eigenleistungenList_1 = [];
                this.schadenfall.eigenleistungen = eigenleistungenList_1;
            }
            else {
                eigenleistungenList_1 = this.schadenfall.eigenleistungen;
            }
            return this.eigenleistungenRS.saveEigenleistungen(this.schadenfall.id, eigenleistungenToSave)
                .then(function (storedEigenleistungen) {
                if (!eigenleistungenToSave.isNew()) { //gespeichertes entity war nicht neu
                    var i = DVBernUtil_1.default.getIndexOfElementwithID(eigenleistungenToSave, eigenleistungenList_1);
                    if (i >= 0) {
                        eigenleistungenList_1[i] = storedEigenleistungen;
                    }
                }
                else {
                    eigenleistungenList_1.push(storedEigenleistungen); //zur Liste hinzufuegen
                }
                return storedEigenleistungen;
            });
        }
        this.log.error('could not save Fremdkosten because no schadenfall is managed');
        return this.$q.when(eigenleistungenToSave);
    };
    SchadenfallModelManager.prototype.removeEigenleistung = function (eigenleistung) {
        if (this.schadenfall && this.schadenfall.eigenleistungen !== undefined) {
            var eigenleistungenList_2 = this.schadenfall.eigenleistungen;
            var i_5 = DVBernUtil_1.default.getIndexOfElementwithID(eigenleistung, eigenleistungenList_2);
            if (i_5 >= 0) {
                if (eigenleistung.isNew()) {
                    eigenleistungenList_2.splice(i_5, 1); //remove element
                    return this.$q.when(undefined);
                }
                else {
                    return this.eigenleistungenRS.deleteEigenleistung(eigenleistung).then(function (response) {
                        eigenleistungenList_2.splice(i_5, 1); //remove element
                        return response;
                    });
                }
            }
        }
        return this.$q.when(undefined);
    };
    SchadenfallModelManager.prototype.saveBeitrag = function (beitragToSave) {
        if (this.schadenfall) {
            var beitragList_1;
            if (this.schadenfall.beitraege == null || this.schadenfall.beitraege === undefined) {
                beitragList_1 = [];
                this.schadenfall.beitraege = beitragList_1;
            }
            else {
                beitragList_1 = this.schadenfall.beitraege;
            }
            return this.beitragRS.saveSchadenfallBeitrag(this.schadenfall.id, beitragToSave)
                .then(function (storedBeitrag) {
                if (!beitragToSave.isNew()) { //gespeichertes entity war nicht neu
                    var i = DVBernUtil_1.default.getIndexOfElementwithID(beitragToSave, beitragList_1);
                    if (i >= 0) {
                        beitragList_1[i] = storedBeitrag;
                    }
                }
                else {
                    beitragList_1.push(storedBeitrag); //zur Liste hinzufuegen
                }
                return storedBeitrag;
            });
        }
        this.log.error('could not save Beitrag because no schadenfall is managed');
        this.errorService.addMesageAsError('ERROR_UNEXPECTED');
        return this.$q.when(beitragToSave);
    };
    SchadenfallModelManager.prototype.removeBeitrag = function (beitrag) {
        if (this.schadenfall && this.schadenfall.beitraege !== undefined) {
            var beitragList_2 = this.schadenfall.beitraege;
            var i_6 = DVBernUtil_1.default.getIndexOfElementwithID(beitrag, beitragList_2);
            if (i_6 >= 0) {
                if (beitrag.isNew()) {
                    beitragList_2.splice(i_6, 1); //remove element
                    return this.$q.when(undefined);
                }
                else {
                    this.beitragRS.deleteBeitrag(beitrag).then(function (response) {
                        beitragList_2.splice(i_6, 1); //remove element
                        return response;
                    });
                }
            }
        }
        return this.$q.when(undefined);
    };
    SchadenfallModelManager.prototype.isSchadenReadonly = function (pageName) {
        var _this = this;
        var fall = this.schadenfall;
        if (fall && this.authServiceRS.getPrincipalRoles()) {
            var roles = this.authServiceRS.getPrincipalRoles();
            var status_1 = fall.status;
            if (roles === undefined || fall === undefined || status_1 === undefined) {
                return true;
            }
            else {
                //wir testen alle rollen ob wir bei irgend einer readonly false haben. wenn ja dann sind wir nicht
                // readonly
                return roles.map(function (value) { return _this.berechtigungsService.isStatusReadonlyForRole(value, status_1, pageName); })
                    .filter(function (isReadonly) { return isReadonly === false; }).length === 0;
            }
        }
        return false;
    };
    SchadenfallModelManager.prototype.isSchadenVisible = function (pageName) {
        var _this = this;
        var fall = this.schadenfall;
        if (fall && this.authServiceRS.getPrincipalRoles()) {
            var roles = this.authServiceRS.getPrincipalRoles();
            var status_2 = fall.status;
            if (roles === undefined || fall === undefined || status_2 === undefined) {
                return true;
            }
            else {
                //wir testen alle rollen ob wir bei irgend einer Access hat. wenn ja dann sind wir visible
                // roles.forEach(value => console.log('visibility of page  ' + pageName + ' for role ' + value,
                //     this.berechtigungsService.isStatusVisibleForRole(value, status, pageName)));
                return roles.map(function (value) { return _this.berechtigungsService.isStatusVisibleForRole(value, status_2, pageName); })
                    .filter(function (isVisible) { return isVisible === true; }).length !== 0;
            }
        }
        return false;
    };
    SchadenfallModelManager.prototype.isSchadenVisibleAndNotNew = function (pageName) {
        return this.isSchadenVisible(pageName) && !(this.schadenfall && this.schadenfall.isNew());
    };
    SchadenfallModelManager.prototype.isStatusAbAuftragSchaetzer = function () {
        return this.schadenfall !== undefined && this.schadenfall.status !== TSSchadenfallStatus_1.TSSchadenfallStatus.NEU &&
            this.schadenfall.status !== TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE &&
            this.schadenfall.status !== TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS &&
            this.schadenfall.status !== TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE &&
            this.schadenfall.status !== TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS;
    };
    SchadenfallModelManager.prototype.isStatusAfterNeu = function () {
        return this.schadenfall !== undefined && this.schadenfall.status !== TSSchadenfallStatus_1.TSSchadenfallStatus.NEU;
    };
    SchadenfallModelManager.prototype.isStatusNeuPapierFS = function () {
        return this.schadenfall !== undefined && this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS;
    };
    SchadenfallModelManager.prototype.addSchaetzer = function (selectedSchaetzer) {
        var _this = this;
        if (this.schadenfall) {
            return this.schadenfallRS.addSchaetzer(this.schadenfall.id, selectedSchaetzer.id).then(function (response) {
                if (selectedSchaetzer !== undefined && _this.schadenfall) {
                    _this.schadenfall.schaetzer = _this.schadenfall.schaetzer.concat(selectedSchaetzer);
                }
            });
        }
        return this.$q.reject(undefined);
    };
    SchadenfallModelManager.prototype.removeSchaetzer = function (selectedSchaetzer) {
        if (this.schadenfall) {
            var schaetzerList_1 = this.schadenfall.schaetzer;
            var i_7 = DVBernUtil_1.default.getIndexOfElementwithID(selectedSchaetzer, schaetzerList_1);
            if (i_7 >= 0) {
                return this.schadenfallRS.removeSchaetzer(this.schadenfall.id, selectedSchaetzer.id).then(function (response) {
                    schaetzerList_1.splice(i_7, 1);
                });
            }
        }
        return this.$q.reject(undefined);
    };
    SchadenfallModelManager.prototype.updateStatus = function (selectedStatus) {
        var _this = this;
        if (this.schadenfall) {
            return this.schadenfallRS.updateStatus(this.schadenfall.id, selectedStatus).then(function (schadResp) {
                _this.setSchadenfall(schadResp);
                return _this.getSchadenfall();
            });
        }
        return this.$q.reject(undefined);
    };
    SchadenfallModelManager.$inject = [
        'SchadenfallRS', 'SchadenRS', '$log', 'AuthServiceRS', 'ErrorService', '$q', 'CONSTANTS', '$rootScope',
        'RoleUtilService', 'FremdkostenRS', 'EigenleistungenRS', 'VorleistungenRS', 'BemerkungRS', 'BeitragRS', 'BerechtigungsService',
    ];
    return SchadenfallModelManager;
}());
exports.default = SchadenfallModelManager;


/***/ }),

/***/ "Gto4":
/***/ (function(module, exports) {

module.exports = "<div class=\"anlaufstelle-view container\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <div class=\"dv-input-container-medium marginTop20\"> <div class=\"form-group row\"> <div class=\"col-sm-12\"> <h1> <span data-translate=\"NEUE_ANLAUFSTELLE\" ng-if=\"vm.createNew\"></span> <span data-translate=\"ANLAUFSTELLE_EDITIEREN\" ng-if=\"!vm.createNew\"></span> </h1> </div> <div class=\"col-sm-12\"> <dv-input-container> <div class=\"radio-inline\" ng-repeat=\"anlaufstelleType in vm.getTSAnlaufstelleTypeValues()\"> <label> <input ng-value=\"anlaufstelleType\" aria-label=\"{{anrede}}\" ng-model=\"vm.getModel().anlaufstelleType\" type=\"radio\" name=\"anlaufstelleType\" ng-required=\"true\" class=\"input-element\"> <span>{{anlaufstelleType | translate}}</span> </label> </div> <dv-error-messages for=\"vm.form.anlaufstelleType\"></dv-error-messages> </dv-input-container> </div> <dv-string-input model=\"vm.getModel().name\" name=\"name\" label=\"NAME_DER_ANLAUFSTELLE\" clazz=\"col-sm-6\"> </dv-string-input> <dv-string-input model=\"vm.getModel().abteilung\" name=\"abteilung\" label=\"ABTEILUNG\" clazz=\"col-sm-6\" ng-required=\"false\"> </dv-string-input> <div class=\"col-sm-12\"> <dv-adresse adresse=\"vm.getModel().adresse\" prefix=\"anlaufstelle_adresse\"></dv-adresse> </div> <div class=\"col-sm-6\" ng-if=\"vm.isKantonType()\"> <div class=\"form-group\"> <label data-translate=\"KANTON\" for=\"anlaufstelleKanton\"> </label> <select name=\"anlaufstelleKanton\" id=\"anlaufstelleKanton\" ng-model=\"vm.getModel().kanton\" class=\"form-control dv-table__input\" ng-options=\"vm.translateKanton(currKanton) for currKanton in vm.kantonList() \"> </select> </div> </div> <fieldset class=\"col-sm-12\" ng-if=\"!vm.isKantonType()\"> <div class=\"row\"> <div class=\"col-sm-12\"> <h2> <span data-translate=\"GEMEINDE_HINZUFUEGEN\"></span> </h2> </div> <div class=\"col-xs-8\"> <div class=\"gemeinde\"> <dv-gemeinde-typeahead selected-gemeinde=\"vm.gemeindeToAdd\" input-name=\"gemeindeName\" input-placeholder=\"START_TYPING\" label=\"\" ng-required=\"false\"> </dv-gemeinde-typeahead> </div> </div> <div class=\"col-xs-4\"> <button ng-click=\"vm.addGemeinde()\" class=\"btn btn-sub-serf add-gemeinde-button\" type=\"button\"> <i class=\"fa fa-plus\"></i> </button> </div> <div class=\"col-sm-12\"> <table st-table=\"displayedCollection\" st-safe-src=\"vm.getModel().gemeinden\" st-delay=\"20\" class=\"table fixedtable table-hover\" id=\"gemeinden\" title=\"gemeinden\" dv-st-table-refresh> <thead> <tr class=\"header-row\"> <th class=\"row-name\" data-translate=\"GEMEINDE_FUER_ANLAUFSTELLE\"></th> <th class=\"row-actions\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"row in displayedCollection\" st-select-row=\"row\" st-select-mode=\"single\"> <td class=\"ellipsis\" title=\"{{row.name}}\" ng-bind=\"row.name\"></td> <td class=\"clearfix\"> <button ng-click=\"vm.deleteClicked(row, $event)\" class=\"btn-link pull-right\"> <span class=\"fa fa-trash-o\" title=\"{{'DELETE' | translate}}\"></span> </button> </td> </tr> <tr> </tr><tr ng-if=\"displayedCollection === undefined || displayedCollection.length === 0\"> <td colspan=\"2\" class=\"empty-table\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> <tfoot> </tfoot> </table> </div> </div> </fieldset> <fieldset class=\"col-sm-12\"> <div class=\"row\"> <div class=\"col-sm-12\"> <h2> <span data-translate=\"VERANTWORTLICHE_PERSON\"></span> </h2> </div> <div class=\"col-sm-12\"> <dv-benutzerprofil benutzer=\"vm.model.verwalter\"></dv-benutzerprofil> </div> </div> </fieldset> <fieldset class=\"col-sm-12\"> <div class=\"row\"> <div ng-if=\"vm.captchaEnabled()\" class=\"col-sm-12 form-group\"> <div vc-recaptcha name=\"recaptcha\" key=\"vm.siteKey\" ng-model=\"vm.recaptchaResponse\" class=\"input-element\" lang=\"vm.recaptchaLanguage\"></div> <div ng-messages=\"vm.form\" class=\"captcha-error\"> <div ng-message=\"recaptcha\" role=\"alert\" data-translate=\"ERROR_REQUIRED\"></div> </div> </div> </div> </fieldset> <div class=\"col-sm-12\"> <div class=\"row mainbuttons\"> <div class=\"col-sm-2 col-sm-offset-4\"> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.cancel()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> <div class=\"col-sm-2\"> <dv-loading-button type=\"submit\" button-click=\"vm.save()\" button-class=\"btn btn-serf\"> <span data-translate=\"SAVE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </div> </div> </div> </form> </div> ";

/***/ }),

/***/ "H9WF":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("+c/h");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-zahlungsauftrag-list.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-zahlungsauftrag-list.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "HCMu":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".anlaufstelle-view .add-gemeinde-button{margin-top:22px;float:none;min-width:40px}", ""]);

// exports


/***/ }),

/***/ "HEVe":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("VD7B");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-geoadmin-map.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-geoadmin-map.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "HI9D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = " <div class=\"menubar\"> <nav class=\"navbar navbar-serf navbar-static-top\" role=\"navigation\"> <div class=\"navbar-header\"> <button class=\"navbar-toggle\" ng-click=\"vm.isNavOpen = !vm.isNavOpen\" type=\"button\"> <span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> </button> <a class=\"navbar-brand\" href=\"https://www.fondssuisse.ch\"> <img src=\"" + __webpack_require__("oMHv") + "\"/> </a> </div> <div class=\"navbar-collapse collapse\" uib-collapse=\"!vm.isNavOpen\"> <ul class=\"nav navbar-nav\" ng-if=\"vm.isLoggedIn()\"> <li dv-show-allowed-roles=\"vm.roleUtilService.getRolesForSchadenfaelle()\" dv-show-element ui-sref-active=\"active\"> <a data-translate=\"MENU_SCHADENFAELLE\" ng-click=\"vm.isNavOpen = false\" ui-sref=\"schadenfaelle\"></a> </li> <li dv-show-allowed-roles=\"vm.roleUtilService.getAnlaufstelleVerwalterRoles()\" dv-show-element ui-sref-active=\"active\"> <a data-translate=\"MENU_ANLAUFSTELLE\" ng-click=\"vm.isNavOpen = false\" ui-sref=\"anlaufstelleverwaltung\"></a> </li> <li dv-show-allowed-roles=\"vm.roleUtilService.getInspektoratVerwalterRoles()\" dv-show-element ui-sref-active=\"active\"> <a data-translate=\"MENU_INSPEKTORAT\" ng-click=\"vm.isNavOpen = false\" ui-sref=\"inspektoratverwaltung\"></a> </li> <li dv-show-allowed-roles=\"vm.roleUtilService.getAdministratorRoles()\" dv-show-element ui-sref-active=\"active\"> <a data-translate=\"MENU_BENUTZERVERWALTUNG\" ng-click=\"vm.isNavOpen = false\" ui-sref=\"benutzerverwaltung\"></a> </li> <li dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\" dv-show-element ui-sref-active=\"active\"> <a data-translate=\"MENU_VERSICHERUNGSBEITRAEGE\" ng-click=\"vm.isNavOpen = false\" ui-sref=\"versicherungsbeitraege\"></a> </li> <li dv-show-allowed-roles=\"vm.roleUtilService.getAdministratorRoles()\" dv-show-element ui-sref-active=\"active\"> <a data-translate=\"MENU_ZAHLUNGEN\" ng-click=\"vm.isNavOpen = false\" ui-sref=\"zahlungen\"></a> </li> <li dv-show-allowed-roles=\"vm.roleUtilService.getStatistikRoles()\" dv-show-element ui-sref-active=\"active\"> <a data-translate=\"MENU_STATISTIK\" ng-click=\"vm.isNavOpen = false\" ui-sref=\"statistik\"></a> </li> <li dv-show-allowed-roles=\"vm.roleUtilService.getRolesForCockpit()\" dv-show-element ui-sref-active=\"active\"> <a data-translate=\"MENU_COCKPIT\" ng-click=\"vm.isNavOpen = false\" ui-sref=\"cockpit\"></a> </li> </ul> <ul class=\"nav navbar-nav navbar-right\"> <li dv-show-allowed-roles=\"vm.roleUtilService.getAllowedToCreateSchadenfallRoles()\" dv-show-element ui-sref-active=\"active\"> <a class=\"navbar-fancy-button\" href=\"#\" ng-click=\"vm.isNavOpen = false\" ng-show=\"vm.isLoggedIn()\" ui-sref=\"gesucherstellen({createNew: true, schadenfallId: null})\"> <i class=\"fa fa-plus\"></i> <span data-translate=\"MENU_GESUCH_ERFASSEN\"> </span> </a> </li> <li on-toggle=\"toggled(open)\" uib-dropdown> <a aria-expanded=\"false\" aria-haspopup=\"true\" href=\"#\" id=\"currentUserDropdown\" style=\"text-transform:none\" uib-dropdown-toggle> <span ng-show=\"vm.isLoggedIn()\"><i class=\"fa fa-user\"></i></span> <span ng-show=\"!vm.isLoggedIn()\" style=\"text-transform:uppercase\">{{vm.getCurrentLang()}}</span> <span class=\"caret\"></span></a> <ul aria-labelledby=\"simple-dropdown\" class=\"dropdown-menu\" uib-dropdown-menu> <li ng-show=\"vm.isLoggedIn()\"><span class=\"dropdown__user\"><i class=\"fa fa-user\"></i> {{vm.displayName}}</span> </li> <li ng-show=\"vm.isLoggedIn()\"><a data-translate=\"BENUTZERPROFIL\" ng-click=\"vm.isNavOpen = false\" ui-sref=\"profile\"></a></li> <div class=\"languagebox\" ng-class=\"{'languagebox--single': !vm.isLoggedIn()}\"> <a ng-class=\"{'active': vm.isLangActive('de')}\" ng-click=\"vm.changeLang('de')\">De</a> <a ng-class=\"{'active': vm.isLangActive('fr')}\" ng-click=\"vm.changeLang('fr')\">Fr</a> <a ng-class=\"{'active': vm.isLangActive('it')}\" ng-click=\"vm.changeLang('it')\">It</a> </div> <li ng-show=\"vm.isLoggedIn()\"><a data-translate=\"KONFIGURATION\" dv-show-allowed-roles=\"vm.roleUtilService.getAdministratorRoles()\" dv-show-element ng-click=\"vm.isNavOpen = false\" ui-sref=\"konfiguration\"></a> </li> <li ng-show=\"vm.isLoggedIn()\"><a data-translate=\"SYSTEM_KONFIGURATION\" dv-show-allowed-roles=\"vm.roleUtilService.getSuperAdminRoles()\" dv-show-element ng-click=\"vm.isNavOpen = false\" ui-sref=\"admin\"></a> </li> <li ng-show=\"vm.isLoggedIn()\"><a data-translate=\"TESTPAGE\" dv-show-allowed-roles=\"vm.roleUtilService.getSuperAdminRoles()\" dv-show-element ng-click=\"vm.isNavOpen = false\" ui-sref=\"testpage\"></a></li> <li ng-show=\"vm.isLoggedIn()\"><a data-translate=\"MIGRATION\" dv-show-allowed-roles=\"vm.roleUtilService.getSuperAdminRoles()\" dv-show-element ng-click=\"vm.isNavOpen = false\" ui-sref=\"migration\"></a></li> <li ng-show=\"vm.isLoggedIn()\"><a ng-click=\"vm.isNavOpen = false; vm.logout();\" translate=\"MENU_LOGOUT\"></a></li> </ul> </li> </ul> </div> </nav> </div> ";

/***/ }),

/***/ "HVSw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/comp-3.01cad7fe2b46ab5292c73dabf7f65a03.jpg";

/***/ }),

/***/ "HXt9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSBankverbindung_1 = __importDefault(__webpack_require__("iMHU"));
var TSDokument_1 = __importDefault(__webpack_require__("DdPR"));
var TSSchaden_1 = __importDefault(__webpack_require__("k04f"));
var TSSchadenfaelleSearchresultDTO_1 = __importDefault(__webpack_require__("WjXM"));
var TSSchadenfall_1 = __importDefault(__webpack_require__("mUaf"));
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
var SchadenfallRS = /** @class */ (function () {
    /* @ngInject */
    function SchadenfallRS($http, REST_API, $log, $q, $translate) {
        this.$log = $log;
        this.$q = $q;
        this.$translate = $translate;
        this.serviceURL = REST_API + 'schadenfall';
        this.http = $http;
    }
    SchadenfallRS.prototype.searchSchadenfaelle = function (schadenfallSearch, prefilter) {
        var _this = this;
        schadenfallSearch.prefilter = prefilter;
        return this.http.post(this.serviceURL + '/search/', schadenfallSearch, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            _this.$log.debug('PARSING schadenfaelle REST array object', response.data);
            return new TSSchadenfaelleSearchresultDTO_1.default().deserialize(response.data);
        });
    };
    SchadenfallRS.prototype.findSchadenfall = function (schadenfallID) {
        var _this = this;
        return this.http.get(this.serviceURL + '/' + encodeURIComponent(schadenfallID))
            .then(function (response) {
            _this.$log.debug('PARSING gesuch REST object ', response.data);
            return new TSSchadenfall_1.default().deserialize(response.data);
        });
    };
    SchadenfallRS.prototype.update = function (schadenfall) {
        DVBernUtil_1.default.setBankverbindungUndefinedIfNoIban(schadenfall);
        var sentGesuch = {};
        sentGesuch = schadenfall.serialize(sentGesuch);
        this.$log.debug('sending Schadenfall:');
        this.$log.debug(sentGesuch);
        return this.http.put(this.serviceURL, sentGesuch, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return new TSSchadenfall_1.default().deserialize(response.data);
        });
    };
    SchadenfallRS.prototype.updateBankverbindung = function (schadenfall) {
        var serializedSchadenfall = schadenfall.serialize({});
        return this.http.put(this.serviceURL + "/bank", serializedSchadenfall).then(function (response) {
            return new TSBankverbindung_1.default().deserialize(response.data);
        });
    };
    SchadenfallRS.prototype.addSchaden = function (schadenfallId) {
        var _this = this;
        return this.http.post(this.serviceURL + '/addSchaden/' + encodeURIComponent(schadenfallId), null, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            _this.$log.debug('PARSING schaden REST array object', response.data);
            return new TSSchaden_1.default().deserialize(response.data);
        });
    };
    SchadenfallRS.prototype.deleteSchaden = function (schadenfallId, schadenId) {
        return this.http.delete(this.serviceURL + '/deleteSchaden/' + encodeURIComponent(schadenfallId) + '/' + encodeURIComponent(schadenId), {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    };
    SchadenfallRS.prototype.handleTransition = function (schadenfall, scope, begruendungsCode, bemerkung, event) {
        DVBernUtil_1.default.setBankverbindungUndefinedIfNoIban(schadenfall);
        var sentGesuch = {};
        sentGesuch = schadenfall.serialize(sentGesuch);
        this.$log.debug('sending Schadenfall:');
        this.$log.debug(sentGesuch);
        return this.http.post(this.serviceURL + '/transition', sentGesuch, {
            params: {
                begruendungsCode: begruendungsCode,
                bemerkung: bemerkung,
                event: event,
                scope: scope,
            },
        }).then(function (response) {
            return new TSSchadenfall_1.default().deserialize(response.data);
        });
    };
    // handleTransition nur mit schadenfallId
    SchadenfallRS.prototype.handleTransitionForId = function (schadenfallId, scope, begruendungsCode, bemerkung, event) {
        this.$log.debug('sending SchadenfallId:');
        this.$log.debug(schadenfallId);
        return this.http.post(this.serviceURL + '/transition/schadenfall', schadenfallId, {
            params: {
                begruendungsCode: begruendungsCode,
                bemerkung: bemerkung,
                event: event,
                scope: scope,
            },
        }).then(function (response) {
            return new TSSchadenfall_1.default().deserialize(response.data);
        });
    };
    SchadenfallRS.prototype.updateVerantwortlicher = function (schadenfallId, verantwortlicher) {
        var _this = this;
        //empty post with query params
        return this.http.post(this.serviceURL + '/verantwortlicher', null, {
            params: {
                schadenfallId: schadenfallId,
                verantwortlicher: verantwortlicher,
            },
        }).then(function (response) {
            return _this.$q.defer().resolve(); //void promise zurueckgeben
        });
    };
    SchadenfallRS.prototype.addSchaetzer = function (schadenfallId, selectedSchaetzerId) {
        var _this = this;
        return this.http.post(this.serviceURL + '/schaetzer', null, {
            params: {
                schadenfallId: schadenfallId,
                selectedSchaetzerId: selectedSchaetzerId,
            },
        }).then(function (response) {
            return _this.$q.defer().resolve(); //void promise zurueckgeben
        });
    };
    SchadenfallRS.prototype.removeSchaetzer = function (schadenfallId, selectedSchaetzerId) {
        var _this = this;
        return this.http.delete(this.serviceURL + '/schaetzer', {
            params: {
                schadenfallId: schadenfallId,
                selectedSchaetzerId: selectedSchaetzerId,
            },
        }).then(function (response) {
            return _this.$q.defer().resolve(); //void promise zurueckgeben
        });
    };
    SchadenfallRS.prototype.generateDeckblatt = function (schadenfallID) {
        var _this = this;
        return this.http.get(this.serviceURL + "/deckblatt/" + this.$translate.use() + "/" + encodeURIComponent(schadenfallID))
            .then(function (response) {
            _this.$log.debug('PARSING gesuch REST object ', response.data);
            return new TSDokument_1.default().deserialize(response.data);
        });
    };
    SchadenfallRS.prototype.updateStatus = function (schadenfallId, selectedStatus) {
        return this.http.post(this.serviceURL + "/status", null, {
            params: {
                schadenfallId: schadenfallId,
                status: selectedStatus,
            },
        }).then(function (response) {
            return new TSSchadenfall_1.default().deserialize(response.data);
        });
    };
    SchadenfallRS.$inject = ['$http', 'REST_API', '$log', '$q', '$translate'];
    return SchadenfallRS;
}());
exports.default = SchadenfallRS;


/***/ }),

/***/ "HZPH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSEigenleistung_1 = __importDefault(__webpack_require__("/GH9"));
var TSEigenleistungDaten_1 = __importDefault(__webpack_require__("xwY2"));
var abstractModelManagerController_1 = __importDefault(__webpack_require__("S1yE"));
var styles = __webpack_require__("59zb");
var template = __webpack_require__("iN5/");
var EigenleistungEditViewComponentConfig = /** @class */ (function () {
    function EigenleistungEditViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = EigenleistungViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            eigenleistung: '<',
            schadenfallId: '<',
            schaetzung: '<',
        };
    }
    return EigenleistungEditViewComponentConfig;
}());
exports.EigenleistungEditViewComponentConfig = EigenleistungEditViewComponentConfig;
var EigenleistungViewController = /** @class */ (function (_super) {
    __extends(EigenleistungViewController, _super);
    /* @ngInject */
    function EigenleistungViewController(dvBernUtil, schadenfallModelManager, $q, $scope, $translate, $log, $state, $stateParams) {
        var _this = _super.call(this, schadenfallModelManager, $scope, $state.current.name) || this;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$translate = $translate;
        _this.$log = $log;
        _this.$state = $state;
        _this.$stateParams = $stateParams;
        return _this;
    }
    EigenleistungViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        if (!this.eigenleistung) {
            this.eigenleistung = new TSEigenleistung_1.default();
            this.eigenleistung.schaetzung = this.schaetzung;
            this.eigenleistung.eigenleistungDatenFS = new TSEigenleistungDaten_1.default();
            this.eigenleistung.eigenleistungStundenDaten = [];
            this.$log.warn('initialized eigenleistung to edit directly in view, should pass eigenleistung to edit along');
        }
        else {
            this.initialModel = this.eigenleistung;
            this.model = angular.copy(this.eigenleistung);
        }
        this.readonly = this.schadenfallModelManager.isSchadenReadonly('eigenleistungen');
        var schadenfall = this.schadenfallModelManager.getSchadenfall();
        if (schadenfall) {
            this.schadenfallStatus = schadenfall.status;
            this.schadenfall = schadenfall;
        }
        this.saveDisabled = false;
    };
    EigenleistungViewController.prototype.saveEigenleistungen = function () {
        var _this = this;
        if (this.isModelValid() && this.eigenleistung) {
            this.schadenfallModelManager.saveEigenleistungen(this.getModel()).then(function (result) {
                _this.navigateAway();
            });
        }
        else {
            this.$log.debug('Form was not valid');
        }
    };
    EigenleistungViewController.prototype.cancelEigenleistungen = function () {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.navigateAway();
    };
    EigenleistungViewController.prototype.navigateAway = function () {
        var nextPage = this.schaetzung ? 'schaetzung' : 'aufwaende';
        this.$state.go(nextPage, { schadenfallId: this.schadenfallId });
    };
    EigenleistungViewController.$inject = ['DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$log', '$state'];
    return EigenleistungViewController;
}(abstractModelManagerController_1.default));
exports.EigenleistungViewController = EigenleistungViewController;


/***/ }),

/***/ "HbSP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright © 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSBeitragArt;
(function (TSBeitragArt) {
    TSBeitragArt[TSBeitragArt["FONDSSUISSE"] = 'FONDSSUISSE'] = "FONDSSUISSE";
    TSBeitragArt[TSBeitragArt["FONDSSUISSE_2023"] = 'FONDSSUISSE_2023'] = "FONDSSUISSE_2023";
    TSBeitragArt[TSBeitragArt["KANTON"] = 'KANTON'] = "KANTON";
    TSBeitragArt[TSBeitragArt["HOCHGEBIRGE"] = 'HOCHGEBIRGE'] = "HOCHGEBIRGE";
    TSBeitragArt[TSBeitragArt["VERSICHERUNG"] = 'VERSICHERUNG'] = "VERSICHERUNG";
})(TSBeitragArt = exports.TSBeitragArt || (exports.TSBeitragArt = {}));
var year2023 = 2023;
function getTSBeitragArtSchadenfallValues() {
    return [
        TSBeitragArt.FONDSSUISSE,
        TSBeitragArt.FONDSSUISSE_2023,
        TSBeitragArt.KANTON,
        TSBeitragArt.HOCHGEBIRGE,
    ];
}
exports.getTSBeitragArtSchadenfallValues = getTSBeitragArtSchadenfallValues;
function getTSBeitragArtValues() {
    return [
        TSBeitragArt.FONDSSUISSE,
        TSBeitragArt.FONDSSUISSE_2023,
        TSBeitragArt.KANTON,
        TSBeitragArt.HOCHGEBIRGE,
        TSBeitragArt.VERSICHERUNG,
    ];
}
exports.getTSBeitragArtValues = getTSBeitragArtValues;
function getDefaultTSBeitragArtValues() {
    return [
        TSBeitragArt.FONDSSUISSE_2023,
        TSBeitragArt.KANTON,
        TSBeitragArt.HOCHGEBIRGE,
    ];
}
exports.getDefaultTSBeitragArtValues = getDefaultTSBeitragArtValues;
function getTSBeitragArtValuesByYear(year) {
    var beitragArts = [
        TSBeitragArt.KANTON,
    ];
    if (year >= year2023) {
        beitragArts.splice(0, 0, TSBeitragArt.FONDSSUISSE_2023);
    }
    else {
        beitragArts.splice(0, 0, TSBeitragArt.FONDSSUISSE);
        beitragArts.splice(2, 0, TSBeitragArt.HOCHGEBIRGE);
    }
    return beitragArts;
}
exports.getTSBeitragArtValuesByYear = getTSBeitragArtValuesByYear;
function beitragArtPrefix() {
    return 'TSBeitragArt_';
}
exports.beitragArtPrefix = beitragArtPrefix;
function beitragPropertySuffix() {
    return '_BEITRAG';
}
exports.beitragPropertySuffix = beitragPropertySuffix;


/***/ }),

/***/ "HcmZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MigrationRS = /** @class */ (function () {
    /* @ngInject */
    function MigrationRS($http, REST_API) {
        this.serviceURL = REST_API + 'migration';
        this.http = $http;
    }
    MigrationRS.prototype.getServiceName = function () {
        return 'MigrationRS';
    };
    MigrationRS.prototype.importSchadenfaelle = function () {
        return this.http.get(this.serviceURL + '/import/schadenfaelle');
    };
    MigrationRS.prototype.importGemeinden = function () {
        return this.http.get(this.serviceURL + '/import/gemeinden');
    };
    MigrationRS.prototype.importPersonen = function () {
        return this.http.get(this.serviceURL + '/import/personen');
    };
    MigrationRS.prototype.importGesuchsteller = function (personId) {
        return this.http.get(this.serviceURL + '/import/person/' + encodeURIComponent(personId));
    };
    MigrationRS.prototype.importBeitragForSchadenfall = function (schadenId) {
        return this.http.get(this.serviceURL + '/import/beitraege/' + encodeURIComponent(schadenId));
    };
    MigrationRS.$inject = ['$http', 'REST_API'];
    return MigrationRS;
}());
exports.MigrationRS = MigrationRS;


/***/ }),

/***/ "HgSf":
/***/ (function(module, exports) {

module.exports = "<input type=\"text\" id=\"{{vm.inputId}}\" ng-model=\"vm.valueinput\" class=\"form-control dvDatepicker\" ng-change=\"vm.removeNotDigits()\" ng-blur=\"vm.updateModelValueBlur()\" ng-focus=\"vm.handleFocus($event)\" ng-required=\"vm.valueRequired\" ng-trim=\"false\" ng-disabled=\"vm.ngDisabled\" name=\"{{vm.inputName}}\"/> ";

/***/ }),

/***/ "HsPv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSVersionCheckEvent_1 = __webpack_require__("QJYW");
/**
 * this interceptor boradcasts a  VERSION_MATCH or VERSION_MISMATCH event whenever a rest service responds
 */
var HttpVersionInterceptor = /** @class */ (function () {
    /* @ngInject */
    function HttpVersionInterceptor($rootScope, $q, CONSTANTS, $log) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.CONSTANTS = CONSTANTS;
        this.$log = $log;
        //interceptor methode
        this.response = function (response) {
            if (response.headers && response.config && response.config.url.indexOf(_this.CONSTANTS.REST_API) === 0 && !response.config.cache) {
                _this.updateBackendVersion(response.headers('x-serf-version'));
            }
            return response;
        };
    }
    /**
     * @param {*} newVersion
     */
    HttpVersionInterceptor.prototype.updateBackendVersion = function (newVersion) {
        if (newVersion !== this.backendVersion) {
            this.backendVersion = newVersion;
            if (!this.hasVersionCompatibility(this.frontendVersion(), this.backendVersion)) {
                this.$log.warn('Versions of Frontend and Backend do not match');
                this.$rootScope.$broadcast(TSVersionCheckEvent_1.TSVersionCheckEvent[TSVersionCheckEvent_1.TSVersionCheckEvent.VERSION_MISMATCH]);
            }
            else {
                //could throw match event here but currently there is no action we want to perform when it matches
            }
        }
    };
    HttpVersionInterceptor.prototype.hasVersionCompatibility = function (frontendVersion, backendVersion) {
        // Wir erwarten, dass die Versionsnummern im Frontend und Backend immer synchronisiert werden
        return frontendVersion === backendVersion;
    };
    /**
     * @return {string}
     */
    HttpVersionInterceptor.prototype.frontendVersion = function () {
        return "2.7.0";
    };
    HttpVersionInterceptor.prototype.getBackendVersion = function () {
        return this.backendVersion;
    };
    HttpVersionInterceptor.prototype.getBuildTime = function () {
        return "2026-09-21T12:06:11.057Z";
    };
    HttpVersionInterceptor.prototype.getClientEnv = function () {
        return "production";
    };
    HttpVersionInterceptor.$inject = ['$rootScope', '$q', 'CONSTANTS', '$log'];
    return HttpVersionInterceptor;
}());
exports.default = HttpVersionInterceptor;


/***/ }),

/***/ "HxSG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSDokumentType_1 = __webpack_require__("/gTe");
var TSErfassungsArt_1 = __webpack_require__("X/T9");
var TSRechtsform_1 = __webpack_require__("EUJE");
var TSSchadenObjekt_1 = __webpack_require__("eUxz");
var TSSchaden_1 = __importDefault(__webpack_require__("k04f"));
var TSSchadenDaten_1 = __importDefault(__webpack_require__("4Vie"));
var styles = __webpack_require__("h81B");
var template = __webpack_require__("7RdN");
var SchadenEditViewComponentConfig = /** @class */ (function () {
    function SchadenEditViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = SchadenViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            schaden: '<',
            readonly: '<',
            schadenfall: '<',
            mehrSchadenAnsicht: '<',
        };
    }
    return SchadenEditViewComponentConfig;
}());
exports.SchadenEditViewComponentConfig = SchadenEditViewComponentConfig;
var SchadenViewController = /** @class */ (function () {
    /* @ngInject */
    function SchadenViewController(dvBernUtil, schadenfallModelManager, $q, $scope, $translate, $log, $state, authServiceRS, roleUtilService) {
        this.dvBernUtil = dvBernUtil;
        this.schadenfallModelManager = schadenfallModelManager;
        this.$q = $q;
        this.$translate = $translate;
        this.$log = $log;
        this.$state = $state;
        this.authServiceRS = authServiceRS;
        this.roleUtilService = roleUtilService;
        this.doctype = TSDokumentType_1.TSDocumentType.SCHADEN_DOC;
    }
    SchadenViewController.prototype.$onInit = function () {
        if (this.schadenfall) {
            this.schadenfallId = this.schadenfall.id;
            this.$log.debug('Edit or createOrUpdate Schaden on Schadenfall ' + this.schadenfallId);
        }
        else {
            this.$log.error('No schadenfall!');
        }
        if (!this.schaden) {
            this.schaden = new TSSchaden_1.default();
            this.schaden.schadenDatenFS = new TSSchadenDaten_1.default();
            this.$log.warn('initialized schaden to edit directly in view, should pass schaden to edit along');
        }
    };
    SchadenViewController.prototype.goBack = function () {
        this.$state.go('schadenmeldung', { schadenfallId: this.schadenfallId });
    };
    SchadenViewController.prototype.showGeschaetztekosten = function () {
        return (this.schadenfallModelManager.isStatusAfterNeu() || this.schadenfallModelManager.isStatusNeuPapierFS()) && this.isGeschaetzteKostenAvailable();
    };
    SchadenViewController.prototype.isGeschaetzteKostenAvailable = function () {
        return !!(this.schaden && this.schaden.schadenDatenFS && this.schaden.schadenDatenFS.geschaetzteKosten);
    };
    SchadenViewController.prototype.requiredGeschaetzteKostenAndMassnahmen = function () {
        return this.schadenfallModelManager.isStatusAbAuftragSchaetzer() || this.schadenfallModelManager.isStatusNeuPapierFS();
    };
    /***
     * spezialvalidierung fuer wald da hier 2 felder gleichzeitg fuer die validierung
     * betrachtet werden
     */
    SchadenViewController.prototype.isWaldValid = function () {
        if (this.schaden.schadenDatenFS.schadenObjekt === TSSchadenObjekt_1.TSSchadenObjektTyp.WALD) {
            var formschaden = this.form['vm.formschaden'];
            if (!this.schaden.schadenDatenFS.schadenObjektDaten.flaecheAre && !this.schaden.schadenDatenFS.schadenObjektDaten.holzMenge) {
                formschaden['waldvalidation'].$setValidity('wald', false);
                return false;
            }
            else {
                formschaden['waldvalidation'].$setValidity('wald', true);
            }
        }
        return true;
    };
    SchadenViewController.prototype.isMehrSchadenAnsicht = function () {
        return this.mehrSchadenAnsicht === 'true';
    };
    SchadenViewController.prototype.showZustimmungSteuerpruefung = function () {
        return !(this.schadenfall.erfassungsart === TSErfassungsArt_1.TSErfassungsArt.PAPIER);
    };
    SchadenViewController.prototype.getZustimmungPruefungFondsuisseText = function () {
        if (this.isGenossenschaft()) {
            return this.$translate.instant('ZUSTIMMUNG_PRUEFUNG_FONDSUISSE_GENOSSENSCHAFT');
        }
        else {
            return this.$translate.instant('ZUSTIMMUNG_PRUEFUNG_FONDSUISSE');
        }
    };
    SchadenViewController.prototype.isGenossenschaft = function () {
        return this.schadenfall.gesuchsteller.rechtsform === TSRechtsform_1.TSRechtsform.GENOSSENSCHAFT;
    };
    SchadenViewController.prototype.getZustimmungGesuchstellerReadonly = function () {
        return !this.authServiceRS.isOneOfRoles(this.roleUtilService.getGesuchstellerOnlyRoles());
    };
    SchadenViewController.$inject = ['DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$log', '$state', 'AuthServiceRS', 'RoleUtilService'];
    return SchadenViewController;
}());
exports.SchadenViewController = SchadenViewController;


/***/ }),

/***/ "Hyp1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSErrorEvent_1 = __webpack_require__("NVeR");
var TSErrorLevel_1 = __webpack_require__("92KJ");
var templ = __webpack_require__("Ua0Y");
var style = __webpack_require__("5y55");
var DvErrorMessagesPanelComponentConfig = /** @class */ (function () {
    function DvErrorMessagesPanelComponentConfig() {
        this.scope = {};
        this.template = templ;
        this.controller = DvErrorMessagesPanelComponent;
        this.controllerAs = 'vm';
    }
    return DvErrorMessagesPanelComponentConfig;
}());
exports.DvErrorMessagesPanelComponentConfig = DvErrorMessagesPanelComponentConfig;
/**
 * component that can display error messages
 */
var DvErrorMessagesPanelComponent = /** @class */ (function () {
    /* @ngInject */
    function DvErrorMessagesPanelComponent($scope, errorService) {
        var _this = this;
        this.$scope = $scope;
        this.errorService = errorService;
        this.errors = [];
        this.displayMessages = function (event, errors) {
            _this.errors = errors;
            _this.show();
        };
    }
    DvErrorMessagesPanelComponent.prototype.$onInit = function () {
        var _this = this;
        this.$scope.$on(TSErrorEvent_1.TSMessageEvent[TSErrorEvent_1.TSMessageEvent.ERROR_UPDATE], this.displayMessages);
        this.$scope.$on(TSErrorEvent_1.TSMessageEvent[TSErrorEvent_1.TSMessageEvent.INFO_UPDATE], this.displayMessages);
        this.$scope.$on(TSErrorEvent_1.TSMessageEvent[TSErrorEvent_1.TSMessageEvent.CLEAR], function () {
            _this.errors = [];
        });
    };
    DvErrorMessagesPanelComponent.prototype.show = function () {
        // this.element.show();
        angular.element('dvb-error-messages-panel').show(); //besser als $element injection fuer tests
    };
    DvErrorMessagesPanelComponent.prototype.clear = function () {
        this.errorService.clearAll();
    };
    ;
    DvErrorMessagesPanelComponent.prototype.messageStyle = function () {
        var returnClass = '';
        try {
            for (var _a = __values(this.errors), _b = _a.next(); !_b.done; _b = _a.next()) {
                var error = _b.value;
                switch (error.severity) {
                    case TSErrorLevel_1.TSErrorLevel.INFO:
                        returnClass = DvErrorMessagesPanelComponent.classprefix + '--info';
                        break;
                    case TSErrorLevel_1.TSErrorLevel.WARNING:
                        returnClass = DvErrorMessagesPanelComponent.classprefix + '--warning';
                        break;
                    case TSErrorLevel_1.TSErrorLevel.SEVERE:
                        returnClass = DvErrorMessagesPanelComponent.classprefix + '--danger';
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return returnClass;
        var e_1, _c;
    };
    DvErrorMessagesPanelComponent.classprefix = 'dvb-error-messages-panel';
    DvErrorMessagesPanelComponent.$inject = ['$scope', 'ErrorService'];
    return DvErrorMessagesPanelComponent;
}());
exports.DvErrorMessagesPanelComponent = DvErrorMessagesPanelComponent;


/***/ }),

/***/ "I486":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */", ""]);

// exports


/***/ }),

/***/ "I78z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
__webpack_require__("fjOH");
var core_module_1 = __webpack_require__("u87A");
__webpack_require__("fE7S");
var bankkontoView_1 = __webpack_require__("7lVO");
var gesuchErstellenView_1 = __webpack_require__("JrvS");
var gesuch_route_1 = __webpack_require__("J6sl");
var dv_fremdkosten_1 = __webpack_require__("ob86");
var schadenfallView_1 = __webpack_require__("Pb3x");
var aufwaendeView_1 = __webpack_require__("SX6k");
var eigenleistungView_1 = __webpack_require__("HZPH");
var dv_eigenleistungen_1 = __webpack_require__("QsPS");
var vorleistungView_1 = __webpack_require__("ew9Y");
var dv_vorleistung_1 = __webpack_require__("WDU8");
var schadenView_1 = __webpack_require__("HxSG");
var fremdkostenView_1 = __webpack_require__("T5Im");
var bemerkungView_1 = __webpack_require__("F8yL");
var entschaedigungView_1 = __webpack_require__("PQ0J");
var beitragView_1 = __webpack_require__("i1EG");
var abschlussView_1 = __webpack_require__("Bk8f");
exports.SerfWebGesuch = angular.module('serfWeb.gesuch', [core_module_1.SerfWebCore.name])
    .component('dvGesuchErstellenView', new gesuchErstellenView_1.GesuchErstellenViewComponentConfig())
    .component('dvBemerkungView', new bemerkungView_1.BemerkungViewComponentConfig())
    .component('dvFremdkosten', new dv_fremdkosten_1.DVFremdkostenComponentConfig())
    .component('dvEigenleistungen', new dv_eigenleistungen_1.DVEigenleistungenComponentConfig())
    .component('dvSchadenfallView', new schadenfallView_1.SchadenfallViewComponentConfig())
    .component('dvAbschlussView', new abschlussView_1.AbschlussViewComponentConfig())
    .component('dvAufwaendeView', new aufwaendeView_1.AufwaendeViewComponentConfig())
    .component('dvEigenleistungEditView', new eigenleistungView_1.EigenleistungEditViewComponentConfig())
    .component('dvSchadenEditView', new schadenView_1.SchadenEditViewComponentConfig())
    .component('dvVorleistungEditView', new vorleistungView_1.VorleistungEditViewComponentConfig())
    .component('dvFremdkostenEditView', new fremdkostenView_1.FremdkostenEditViewComponentConfig())
    .component('dvVorleistung', new dv_vorleistung_1.DVVorleistungComponentConfig())
    .component('dvEntschaedigungView', new entschaedigungView_1.EntschaedigungViewComponentConfig())
    .component('dvBeitragView', new beitragView_1.BeitragEditViewComponentConfig())
    .component('dvBankkontoView', new bankkontoView_1.BankkontoViewComponentConfig())
    .run(gesuch_route_1.gesuchRun);
exports.default = exports.SerfWebGesuch;


/***/ }),

/***/ "I7ot":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSCockpitResult_1 = __importDefault(__webpack_require__("PaWj"));
var TSCockpitResultDTO = /** @class */ (function () {
    function TSCockpitResultDTO() {
        this._cockpitResult = [];
        this._name = 'Keine Resultate';
    }
    Object.defineProperty(TSCockpitResultDTO.prototype, "cockpitResult", {
        get: function () {
            return this._cockpitResult;
        },
        set: function (value) {
            this._cockpitResult = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSCockpitResultDTO.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    TSCockpitResultDTO.prototype.parseCockpitResultDTOs = function (data) {
        var results = [];
        if (data && Array.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                if (data[i]) {
                    results[i] = new TSCockpitResult_1.default().deserialize(data[i]);
                }
            }
        }
        else {
            results[0] = new TSCockpitResult_1.default().deserialize(data);
        }
        return results;
    };
    TSCockpitResultDTO.prototype.deserialize = function (restObject) {
        this.cockpitResult = this.parseCockpitResultDTOs(restObject.cockpitResults);
        this.name = restObject.name;
        return this;
    };
    return TSCockpitResultDTO;
}());
exports.default = TSCockpitResultDTO;


/***/ }),

/***/ "IBDo":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("stLe");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-vorleistungen-list.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-vorleistungen-list.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "IGio":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSVersicherung_1 = __importDefault(__webpack_require__("aku3"));
var VersicherungRS = /** @class */ (function () {
    /* @ngInject */
    function VersicherungRS($http, REST_API, $log, $q) {
        this.$log = $log;
        this.$q = $q;
        this.serviceURL = REST_API + 'versicherungen';
        this.http = $http;
    }
    VersicherungRS.prototype.findActiveVersicherungen = function () {
        var _this = this;
        var config = { cache: true };
        return this.http.get(this.serviceURL, config)
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING versicherungen REST  object', response.data);
                return TSVersicherung_1.default.deserializeArray(response.data);
            }
            else {
                return [];
            }
        });
    };
    VersicherungRS.$inject = ['$http', 'REST_API', '$log', '$q'];
    return VersicherungRS;
}());
exports.default = VersicherungRS;


/***/ }),

/***/ "IPSF":
/***/ (function(module, exports) {

module.exports = "<div> <div class=\"modal-body\"> {{ vm.text }} </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok()\">OK</button> </div> </div> ";

/***/ }),

/***/ "ITlK":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("ZH1W");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-password-changer.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-password-changer.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "IZSa":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".map-button{width:40px;min-width:40px;height:39px}.map-control,.map-control.ng-invalid,form.ng-submitted .map-control.ng-invalid{padding:0}.lat-long{color:#9ca2a5;display:inline-block;line-height:40px}.map-button-div{position:relative;margin-top:-40px;margin-left:50px}dv-schaden .walderror{margin-top:-55px;margin-bottom:30px}@media(min-width:1025px){dv-schaden .walderror{margin-top:-30px}}", ""]);

// exports


/***/ }),

/***/ "Iksp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
var admin_module_1 = __webpack_require__("DX+K");
var anlaufstelleverwaltung_module_1 = __webpack_require__("O5jG");
var authentication_module_1 = __webpack_require__("Lcj6");
var benutzerverwaltung_module_1 = __webpack_require__("vWOL");
var core_module_1 = __webpack_require__("u87A");
var gesuch_module_1 = __webpack_require__("I78z");
var inspektoratverwaltung_module_1 = __webpack_require__("ZhGZ");
var schadenfaelle_module_1 = __webpack_require__("2uaK");
var statistik_module_1 = __webpack_require__("Qseh");
var testpage_module_1 = __webpack_require__("lAb2");
var versicherungsbeitraege_module_1 = __importDefault(__webpack_require__("lquy"));
var zahlungen_module_1 = __webpack_require__("F1gm");
var cockpit_module_1 = __importDefault(__webpack_require__("6Dkx"));
var dependencies = [
    /* Angular modules */
    /* shared DVBern modules */
    core_module_1.SerfWebCore.name,
    admin_module_1.SerfWebAdmin.name,
    authentication_module_1.SerfWebAuthentication.name,
    testpage_module_1.SerfWebTestpage.name,
    schadenfaelle_module_1.SerfWebSchadenfaelle.name,
    benutzerverwaltung_module_1.SerfWebBenutzerverwaltung.name,
    anlaufstelleverwaltung_module_1.SerfWebAnlaufstelleverwaltung.name,
    zahlungen_module_1.SerfWebZahlungen.name,
    versicherungsbeitraege_module_1.default.name,
    statistik_module_1.SerfWebStatistik.name,
    gesuch_module_1.SerfWebGesuch.name,
    inspektoratverwaltung_module_1.SerfWebInspektoratverwaltung.name,
    cockpit_module_1.default.name,
    /* 3rd-party modules */
    'ui.bootstrap',
];
exports.default = angular.module('serfWeb', dependencies);


/***/ }),

/***/ "IlcK":
/***/ (function(module, exports) {

module.exports = "<div class=\"table-responsive dv-zahlungen-list\" ng-class=\"vm.getClass()\"> <table st-table=\"vm.displayedCollection\" st-delay=\"20\" st-pipe=\"vm.callServer\" class=\"table fixedtable table-hover\" id=\"{{vm.tableId}}\" title=\"{{vm.tableTitle}}\" dv-st-table-refresh> <thead> <tr class=\"header-row\"> <th class=\"row-datum\" data-translate=\"DATUM\"></th> <th st-sort=\"fallNummer\" class=\"sortable row-fallnr\" data-translate=\"FALL\"></th> <th class=\"row-beitragArt\" data-translate=\"BEITRAG_ART\"></th> <th class=\"row-ermittelterSchaden text-right\" data-translate=\"ERMITTELTER_SCHADEN\"></th> <th class=\"row-beitrag text-right\" data-translate=\"BETRAG_CHF\"></th> <th class=\"row-empfaenger\" data-translate=\"BETROFFENE\"></th> <th class=\"row-inhaber\" data-translate=\"KONTO_INHABER\"></th> <th class=\"row-actions\"></th> </tr> <tr> <th> <div> <input st-search=\"beitragDatumVon\" class=\"form-control dv-table__input dateinputtable\" type=\"text\" placeholder=\"{{'VON' | translate}}\"/> <input st-search=\"beitragDatumBis\" class=\"form-control dv-table__input dateinputtable\" type=\"text\" placeholder=\"{{'BIS' | translate}}\"/> </div> </th> <th><input st-search=\"fallNummer\" class=\"form-control dv-table__input\" type=\"text\" max=\"999999\"/></th> <th> <div class=\"dv-select-style\"> <select st-input-event=\"change\" name=\"beitragArt\" id=\"beitragArt\" st-search=\"beitragArt\" class=\"form-control dv-table__input\" ng-options=\"vm.getTSBeitragArtTranslate(beitragArt) for beitragArt in vm.getTSBeitragArtValues() track by beitragArt\" ng-model=\"vm.selectedStatus\"> <option value=\"\">{{\"ALLE\" | translate}}</option> </select> </div> </th> <th> <div> </div> </th> <th> <div> <input st-search=\"beitragVon\" class=\"form-control dv-table__input dateinputtable\" type=\"text\" placeholder=\"{{'VON' | translate}}\"/> <input st-search=\"beitragBis\" class=\"form-control dv-table__input dateinputtable\" type=\"text\" placeholder=\"{{'BIS' | translate}}\"/> </div> </th> <th> <input st-search=\"empfaenger\" class=\"form-control dv-table__input\" type=\"text\"/> </th> <th> <input st-search=\"inhaber\" class=\"form-control dv-table__input\" type=\"text\"/> </th> <th class=\"right\"> <div class=\"checkbox checkbox-alle\"> <label> <input ng-true-value=\"true\" ng-false-value=\"false\" ng-model=\"vm.alleCheckbox\" ng-change=\"vm.alleChanged()\" type=\"checkbox\" name=\"alle\"> <span data-translate=\"ALLE\"></span> </label> </div> </th> </tr> </thead> <tbody> <tr ng-repeat-start=\"row in vm.displayedCollection\" class=\"beitraggrundrow\" ng-click=\"vm.editClicked(row, $event)\"> <td class=\"ellipsis\" title=\"{{row.fallNummer}}\" ng-bind=\"row.extractGroupLabel()\" colspan=\"7\"></td> <td class=\"ellipsis right\" title=\"{{row.beitraege.length}}\" ng-bind=\"row.beitraege.length\"></td> </tr> <tr class=\"dateientable\" ng-repeat=\"beitrag in row.beitraege  | orderBy: 'timestampUpload'\" ng-click=\"vm.editClickedBeitrag(row, beitrag, $event)\" ng-class=\"{'marked-row' :beitrag.sachbearbeiterMaxUeberschritten}\"> <td class=\"ellipsis\" title=\"{{beitrag.timestampErstellt | amDateFormat : 'DD.MM.YYYY'}}\" ng-bind=\"beitrag.timestampErstellt| amDateFormat : 'DD.MM.YYYY'\"></td> <td class=\"ellipsis\" title=\"{{row.fallNummer}}\" ng-bind=\"row.fallNummer\"></td> <td class=\"ellipsis\" title=\"{{vm.getTSBeitragArtTranslate(beitrag.beitragArt)}}\" ng-bind=\"vm.getTSBeitragArtTranslate(beitrag.beitragArt)\"></td> <td class=\"ellipsis mono text-right\" title=\"{{row.ermittelterSchaden | number: 2}}\" ng-bind=\"row.ermittelterSchaden| number: 2\"></td> <td class=\"ellipsis mono text-right\" title=\"{{beitrag.beitrag  | number: 2}}\" ng-bind=\"beitrag.beitrag | number: 2\"></td> <td class=\"ellipsis\" title=\"{{beitrag.getFullname()}}\" ng-bind=\"beitrag.getFullname()\"></td> <td class=\"ellipsis\" title=\"{{beitrag.bankverbindung.inhaberName}}\" ng-bind=\"beitrag.bankverbindung.inhaberName\"></td> <td class=\"right\"> <div class=\"checkbox checkbox-intable\"> <label ng-click=\"$event.stopPropagation()\"> <input ng-true-value=\"true\" ng-false-value=\"false\" ng-model=\"beitrag.selected\" type=\"checkbox\" name=\"alle\"> <span></span> </label> </div> </td> </tr> <tr ng-repeat-end></tr> <tr ng-if=\"vm.displayedCollection.length === 0\"> <td colspan=\"{{vm.getColumnsNumber()}}\" class=\"empty-table\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> <tfoot> <tr> <td colspan=\"{{vm.getColumnsNumber()}}\" class=\"text-center\"> <div st-pagination=\"\" st-items-by-page=\"200\" st-displayed-pages=\"10\"></div> </td> </tr> </tfoot> </table> </div> <div class=\"row\" ng-if=\"vm.freigebenMode\"> <div class=\"mainbuttons\"> <dv-loading-button type=\"submit\" button-click=\"vm.doFreigeben()\" button-class=\"btn btn-serf\"> <span data-translate=\"FREIGEBEN\"></span> </dv-loading-button> </div> </div> <div class=\"row\" ng-if=\"vm.ausfuehrenMode\"> <form role=\"form\" name=\"vm.form\" class=\"row marginTop20\" novalidate> <div class=\"col-sm-12\"> <dv-string-input model=\"vm.ref\" name=\"ref\" label=\"REF_BUCHHALTUNG\" clazz=\"col-sm-4\"> </dv-string-input> <div class=\"col-sm-4\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"DATUM_FAELLIG\"></label> <dv-datepicker input-id=\"datumFaellig\" name=\"datumFaellig\" ng-model=\"vm.datumFaellig\" ng-required=\"true\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" check-past=\"true\"> </dv-datepicker> <dv-error-messages for=\"vm.form.datumFaellig\"></dv-error-messages> </dv-input-container> </div> </div> <div class=\"row\"> <div class=\"checklist\"> <div class=\"h2 clearfix\"> <span data-translate=\"CHECKLISTE\"></span> </div> <dv-checklist on-checkstatus-chaged=\"vm.checklistStatusChanged(allchecked)\" checklist-points=\"vm.getChecklistEntries()\" all-checked=\"vm.allChecked\"> </dv-checklist> </div> </div> <div class=\"row freigebenfs\"> <div class=\"mainbuttons-freigeben marginTop80\"> <dv-loading-button type=\"submit\" button-click=\"vm.doAusfuehren()\" button-class=\"btn btn-serf\" button-disabled=\"vm.disabledAusfuehren()\"> <span data-translate=\"AUSFUEHREN\"></span> </dv-loading-button> </div> </div> </form> </div> ";

/***/ }),

/***/ "J/Xo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSRole_1 = __webpack_require__("MleR");
var template = __webpack_require__("ZnYd");
__webpack_require__("+0wl");
var DVStatusChangeHistoryComponentConfig = /** @class */ (function () {
    function DVStatusChangeHistoryComponentConfig() {
        this.transclude = false;
        this.bindings = {
            transitionBemerkungen: '=',
            scopeToShow: '<',
            schadenfallId: '<',
        };
        this.template = template;
        this.controller = DVStatusChangeHistory;
        this.controllerAs = 'vm';
    }
    return DVStatusChangeHistoryComponentConfig;
}());
exports.DVStatusChangeHistoryComponentConfig = DVStatusChangeHistoryComponentConfig;
var DVStatusChangeHistory = /** @class */ (function () {
    /* @ngInject */
    function DVStatusChangeHistory($scope) {
        this.$scope = $scope;
        this.transitionBemerkungen = [];
        this.sachbearbeiter = [];
        this.scopeToShow = [];
    }
    DVStatusChangeHistory.prototype.$onInit = function () {
        var _this = this;
        this.initView();
        this.$scope.$watchCollection(function () {
            return _this.transitionBemerkungen;
        }, function (newValue, oldValue) {
            if ((newValue.length !== oldValue.length)) {
                _this.initView();
            }
        });
    };
    DVStatusChangeHistory.prototype.initView = function () {
        this.sachbearbeiter = this.removeDuplicatedSachbearbeiter(this.transitionBemerkungen);
        this.sachbearbeiter = this.sortSachbearbeiter();
        if (this.scopeToShow && this.scopeToShow.length > 0) {
            this.sachbearbeiter = this.sachbearbeiter
                .filter(this.filterByRole());
        }
    };
    DVStatusChangeHistory.prototype.removeDuplicatedSachbearbeiter = function (array) {
        var newArray = array.map((function (elem) { return ([elem.getBesitzer().id, elem]); }));
        var newMap = new Map(newArray);
        return __spread(newMap.values());
    };
    DVStatusChangeHistory.prototype.sortSachbearbeiter = function () {
        return this.sachbearbeiter.sort(function (bemerkung1, bemerkung2) {
            if (bemerkung1.timestampErstellt && bemerkung2.timestampErstellt) {
                if (bemerkung1.timestampErstellt > bemerkung2.timestampErstellt) {
                    return -1;
                }
                if (bemerkung1.timestampErstellt < bemerkung2.timestampErstellt) {
                    return 1;
                }
            }
            return 0;
        });
    };
    DVStatusChangeHistory.prototype.filterByRole = function () {
        return function (bemerkung) {
            var sachb = bemerkung.getBesitzer();
            return (sachb && (sachb.roles.includes(TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER)
                || sachb.roles.includes(TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER)
                || sachb.roles.includes(TSRole_1.TSRole.ANLAUFSTELLE_VERWALTER)
                || sachb.roles.includes(TSRole_1.TSRole.FONDSSUISSE_ADMIN)
                || sachb.roles.includes(TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER)));
        };
    };
    ;
    DVStatusChangeHistory.$inject = [
        '$scope',
    ];
    return DVStatusChangeHistory;
}());
exports.DVStatusChangeHistory = DVStatusChangeHistory;


/***/ }),

/***/ "J0Q0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSSprache_1 = __webpack_require__("3oUo");
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
var TSPasswordData_1 = __importDefault(__webpack_require__("3CBU"));
var template = __webpack_require__("uemi");
var InvitedUserProfileComponentConfig = /** @class */ (function () {
    function InvitedUserProfileComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = InvitedUserProfileViewController;
        this.controllerAs = 'vm';
    }
    return InvitedUserProfileComponentConfig;
}());
exports.InvitedUserProfileComponentConfig = InvitedUserProfileComponentConfig;
/**
 * this component allows to edit userprofile data without through a token link
 */
var InvitedUserProfileViewController = /** @class */ (function () {
    function InvitedUserProfileViewController($state, $stateParams, benutzerRS, $location, $log, errorService, CONSTANTS, $translate, $timeout, passwordStrengthService) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.benutzerRS = benutzerRS;
        this.$location = $location;
        this.$log = $log;
        this.errorService = errorService;
        this.CONSTANTS = CONSTANTS;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.passwordStrengthService = passwordStrengthService;
    }
    InvitedUserProfileViewController.prototype.$onInit = function () {
        this.errorService.clearAll();
        var email = '';
        if (this.$stateParams.email) {
            email = decodeURIComponent(this.$stateParams.email);
        }
        var token = this.$stateParams.changetoken || '';
        this.model = new TSPasswordData_1.default(email, token);
        var lang = TSSprache_1.TSSprache.DEUTSCH;
        if (this.$stateParams.lang) {
            lang = TSSprache_1.getLanguageByKey(decodeURIComponent(this.$stateParams.lang));
        }
        //aus sicherheitsgruenden lesen wir hier den user der zu dem token gehoert NICHT aus der db
        this.benutzerToEdit = this.initEmptyBenutzerWithToken(email, token, lang);
    };
    InvitedUserProfileViewController.prototype.initEmptyBenutzerWithToken = function (email, token, lang) {
        var createdBenutzer = new TSBenutzer_1.default();
        createdBenutzer.passwordData = new TSPasswordData_1.default(email, token);
        createdBenutzer.korrespondenzsprache = lang;
        return createdBenutzer;
    };
    InvitedUserProfileViewController.$inject = ['$state', '$stateParams', 'BenutzerRS',
        '$location', '$log', 'ErrorService', 'CONSTANTS', '$translate', '$timeout', 'PasswordStrengthService'];
    return InvitedUserProfileViewController;
}());
exports.InvitedUserProfileViewController = InvitedUserProfileViewController;


/***/ }),

/***/ "J6sl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSBeitrag_1 = __importDefault(__webpack_require__("Bftz"));
var TSEigenleistung_1 = __importDefault(__webpack_require__("/GH9"));
var TSEigenleistungDaten_1 = __importDefault(__webpack_require__("xwY2"));
var TSFremdkosten_1 = __importDefault(__webpack_require__("csNn"));
var TSFremdkostenDaten_1 = __importDefault(__webpack_require__("u0Wo"));
var TSSchaden_1 = __importDefault(__webpack_require__("k04f"));
var TSSchadenDaten_1 = __importDefault(__webpack_require__("4Vie"));
var TSSchadenObjektDaten_1 = __importDefault(__webpack_require__("ivjz"));
var TSVorleistung_1 = __importDefault(__webpack_require__("3494"));
var TSVorleistungDaten_1 = __importDefault(__webpack_require__("3Ly2"));
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
gesuchRun.$inject = ['RouterHelper', 'PAGE_NAMES'];
/* @ngInject */
function gesuchRun(routerHelper, pageNames) {
    if (pageNames === undefined) {
        console.error('Page Names must be injected');
    }
    routerHelper.configureStates(getStates(pageNames));
}
exports.gesuchRun = gesuchRun;
function getStates(pageNames) {
    return [
        new SerfBemerkungState(pageNames.BEMERKUNG),
        new SerfGesuchErstellenState(pageNames.GESUCHERSTELLEN),
        new SerfAbschlussState(pageNames.ABSCHLUSS),
        new SerfSchadenmeldungState(pageNames.SCHADENMELDUNG),
        new SerfSchadenState(pageNames.SCHADEN),
        new SerfAufwaendeState(pageNames.AUFWAENDE),
        new SerfSchaetzungState(pageNames.SCHAETZUNG),
        new SerfEigenleistungenState(pageNames.EIGENLEISTUNGEN),
        new SerfVorleistungState(pageNames.VORLEISTUNG),
        new SerfFremdkostenState(pageNames.FREMDKOSTEN),
        new SerfEntschaedigungState(pageNames.ENTSCHAEDIGUNG),
        new SerfBeitragState(pageNames.BEITRAG),
        new SerfBankkontoState(pageNames.BANKKONTO),
    ];
}
//STATES
var SerfBemerkungState = /** @class */ (function () {
    function SerfBemerkungState(statename) {
        this.name = 'bemerkung';
        this.template = '<dv-bemerkung-view schadenfall="$resolve.schadenfall"></dv-bemerkung-view>';
        this.url = '/bemerkung/:schadenfallId';
        this.resolve = {
            schadenfall: getSchadenfall,
        };
        this.name = statename;
    }
    return SerfBemerkungState;
}());
exports.SerfBemerkungState = SerfBemerkungState;
var SerfGesuchErstellenState = /** @class */ (function () {
    function SerfGesuchErstellenState(statename) {
        this.name = 'gesucherstellen';
        this.template = '<dv-gesuch-erstellen-view schadenfall="$resolve.schadenfall"></dv-gesuch-erstellen-view>';
        this.url = '/gesucherstellen/:createNew/:schadenfallId';
        this.resolve = {
            schadenfall: getOrCreateSchadenfall,
        };
        this.name = statename;
    }
    return SerfGesuchErstellenState;
}());
exports.SerfGesuchErstellenState = SerfGesuchErstellenState;
var SerfSchadenmeldungState = /** @class */ (function () {
    function SerfSchadenmeldungState(statename) {
        this.name = 'schadenmeldung';
        this.template = '<dv-schadenfall-view schadenfall="$resolve.schadenfall"></dv-schadenfall-view>';
        this.url = '/schadenmeldung/:schadenfallId';
        this.resolve = {
            schadenfall: getSchadenfall,
        };
        this.name = statename;
    }
    return SerfSchadenmeldungState;
}());
exports.SerfSchadenmeldungState = SerfSchadenmeldungState;
var SerfAbschlussState = /** @class */ (function () {
    function SerfAbschlussState(statename) {
        this.name = 'abschluss';
        this.template = '<dv-abschluss-view title-text="$resolve.titleText" message-text="$resolve.messageText" '
            + 'button-text="$resolve.buttonText" state-to-go-to="$resolve.stateToGoTo"></dv-abschluss-view>';
        this.url = '/abschluss';
        this.resolve = {
            titleText: getTitleText,
            messageText: getMsgText,
            buttonText: getButtonText,
            stateToGoTo: getStateToGo,
        };
        this.params = { titleText: null, messageText: null, buttonText: null, stateToGoTo: null };
        this.name = statename;
    }
    return SerfAbschlussState;
}());
exports.SerfAbschlussState = SerfAbschlussState;
var SerfAufwaendeState = /** @class */ (function () {
    function SerfAufwaendeState(statename) {
        this.name = 'aufwaende';
        this.template = '<dv-aufwaende-view schadenfall="$resolve.schadenfall" schaetzung="false"></dv-aufwaende-view>';
        this.url = '/aufwaende/:schadenfallId';
        this.resolve = {
            schadenfall: getSchadenfall,
        };
        this.name = statename;
    }
    return SerfAufwaendeState;
}());
exports.SerfAufwaendeState = SerfAufwaendeState;
var SerfSchaetzungState = /** @class */ (function () {
    function SerfSchaetzungState(statename) {
        this.name = 'schaetzung';
        this.template = '<dv-aufwaende-view schadenfall="$resolve.schadenfall" schaetzung="true"></dv-aufwaende-view>';
        this.url = '/schaetzung/:schadenfallId';
        this.resolve = {
            schadenfall: getSchadenfall,
        };
        this.name = statename;
    }
    return SerfSchaetzungState;
}());
exports.SerfSchaetzungState = SerfSchaetzungState;
var SerfEigenleistungenState = /** @class */ (function () {
    function SerfEigenleistungenState(statename) {
        this.name = 'eigenleistungen';
        this.template = '<dv-eigenleistung-edit-view eigenleistung="$resolve.eigenleistung" '
            + 'schadenfall-id="$resolve.schadenfallId" schaetzung="$resolve.schaetzung"></dv-eigenleistung-edit-view>';
        this.resolve = {
            eigenleistung: getEigenleistung,
            schadenfallId: extractSchadenfallId,
            schaetzung: isSchaetzung,
        };
        this.url = '/aufwaende/schadenfallId/eigenleistungen/:eigenleistungId?schaetzung';
        this.params = { eigenleistung: null, schadenfallId: null, eigenleistungId: null, schaetzung: null };
        this.name = statename;
    }
    return SerfEigenleistungenState;
}());
exports.SerfEigenleistungenState = SerfEigenleistungenState;
var SerfSchadenState = /** @class */ (function () {
    function SerfSchadenState(statename) {
        this.name = 'schaden';
        this.template = '<dv-schaden-edit-view schaden="$resolve.schaden" '
            + 'schadenfall-id="$resolve.schadenfallId" mehr-schaden-ansicht="true" readonly="false"></dv-schaden-edit-view>';
        this.url = '/schadenfall/:schadenfallId/schaden/:schadenId';
        this.resolve = {
            schaden: getSchaden,
            schadenfallId: extractSchadenfallId,
        };
        this.params = { schaden: null, schadenfallId: null, schadenId: null };
        this.name = statename;
    }
    return SerfSchadenState;
}());
exports.SerfSchadenState = SerfSchadenState;
var SerfVorleistungState = /** @class */ (function () {
    function SerfVorleistungState(statename) {
        this.name = 'vorleistung';
        this.template = '<dv-vorleistung-edit-view vorleistung="$resolve.vorleistung" '
            + 'schadenfall-id="$resolve.schadenfallId" schaetzung="$resolve.schaetzung"></dv-vorleistung-edit-view>';
        this.url = '/aufwaende/:schadenfallId/vorleistungen/:vorleistungId?schaetzung';
        this.resolve = {
            vorleistung: getVorleistung,
            schadenfallId: extractSchadenfallId,
            schaetzung: isSchaetzung,
        };
        this.params = { vorleistung: null, schadenfallId: null, vorleistungId: null, schaetzung: null };
        this.name = statename;
    }
    return SerfVorleistungState;
}());
exports.SerfVorleistungState = SerfVorleistungState;
var SerfFremdkostenState = /** @class */ (function () {
    function SerfFremdkostenState(statename) {
        this.name = 'fremdkosten';
        this.template = '<dv-fremdkosten-edit-view fremdkosten="$resolve.fremdkosten" '
            + 'schadenfall-id="$resolve.schadenfallId" schaetzung="$resolve.schaetzung"></dv-fremdkosten-edit-view>';
        this.url = '/aufwaende/:schadenfallId/fremdkosten/:fremdkostenId?schaetzung';
        this.resolve = {
            fremdkosten: getFremdkosten,
            schadenfallId: extractSchadenfallId,
            schaetzung: isSchaetzung,
        };
        this.params = { fremdkosten: null, schadenfallId: null, fremdkostenId: null, schaetzung: null };
        this.name = statename;
    }
    return SerfFremdkostenState;
}());
exports.SerfFremdkostenState = SerfFremdkostenState;
var SerfEntschaedigungState = /** @class */ (function () {
    function SerfEntschaedigungState(statename) {
        this.name = 'entschaedigung';
        this.template = '<dv-entschaedigung-view schadenfall="$resolve.schadenfall"></dv-entschaedigung-view>';
        this.url = '/entschaedigung/:schadenfallId';
        this.resolve = {
            schadenfall: getSchadenfall,
        };
        this.name = statename;
    }
    return SerfEntschaedigungState;
}());
exports.SerfEntschaedigungState = SerfEntschaedigungState;
var SerfBeitragState = /** @class */ (function () {
    function SerfBeitragState(statename) {
        this.name = 'beitrag';
        this.template = '<dv-beitrag-view beitrag="$resolve.beitrag" schadenfall="$resolve.schadenfall"></dv-beitrag-view>';
        this.url = '/entschaedigung/:schadenfallId/beitrag/:beitragId';
        this.resolve = {
            beitrag: getBeitrag,
            schadenfall: getSchadenfall,
        };
        this.params = { beitrag: null, schadenfall: null, beitragId: null };
        this.name = statename;
    }
    return SerfBeitragState;
}());
exports.SerfBeitragState = SerfBeitragState;
var SerfBankkontoState = /** @class */ (function () {
    function SerfBankkontoState(statename) {
        this.name = 'bankkonto';
        this.template = '<dv-bankkonto-view schadenfall="$resolve.schadenfall"></dv-bankkonto-view>';
        this.url = '/bankkonto/:schadenfallId';
        this.resolve = {
            schadenfall: getSchadenfall,
        };
        this.name = statename;
    }
    return SerfBankkontoState;
}());
exports.SerfBankkontoState = SerfBankkontoState;
var INewFallStateParams = /** @class */ (function () {
    function INewFallStateParams() {
    }
    return INewFallStateParams;
}());
exports.INewFallStateParams = INewFallStateParams;
var IAbschlussStateParams = /** @class */ (function () {
    function IAbschlussStateParams() {
    }
    return IAbschlussStateParams;
}());
exports.IAbschlussStateParams = IAbschlussStateParams;
var IFallStateParams = /** @class */ (function () {
    function IFallStateParams() {
    }
    return IFallStateParams;
}());
exports.IFallStateParams = IFallStateParams;
var IEigenleistungeStateParams = /** @class */ (function () {
    function IEigenleistungeStateParams() {
    }
    return IEigenleistungeStateParams;
}());
exports.IEigenleistungeStateParams = IEigenleistungeStateParams;
var ISchadenStateParams = /** @class */ (function () {
    function ISchadenStateParams() {
    }
    return ISchadenStateParams;
}());
exports.ISchadenStateParams = ISchadenStateParams;
var IFremdkostenStateParams = /** @class */ (function () {
    function IFremdkostenStateParams() {
    }
    return IFremdkostenStateParams;
}());
exports.IFremdkostenStateParams = IFremdkostenStateParams;
var IVorleistungStateParams = /** @class */ (function () {
    function IVorleistungStateParams() {
    }
    return IVorleistungStateParams;
}());
exports.IVorleistungStateParams = IVorleistungStateParams;
var IBeitragStateParams = /** @class */ (function () {
    function IBeitragStateParams() {
    }
    return IBeitragStateParams;
}());
exports.IBeitragStateParams = IBeitragStateParams;
getTitleText.$inject = ['$stateParams'];
function getTitleText($stateParams) {
    if ($stateParams) {
        return $stateParams.titleText;
    }
    return undefined;
}
exports.getTitleText = getTitleText;
getMsgText.$inject = ['$stateParams'];
function getMsgText($stateParams) {
    if ($stateParams) {
        return $stateParams.messageText;
    }
    return undefined;
}
exports.getMsgText = getMsgText;
getButtonText.$inject = ['$stateParams'];
function getButtonText($stateParams) {
    if ($stateParams) {
        return $stateParams.buttonText;
    }
    return undefined;
}
exports.getButtonText = getButtonText;
isSchaetzung.$inject = ['$stateParams'];
function isSchaetzung($stateParams) {
    if ($stateParams) {
        // === 'true' is necessary, because $stateParams.schaetzung is a string
        // and "false" would also evaluates as true
        return $stateParams.schaetzung === 'true';
    }
    return false;
}
exports.isSchaetzung = isSchaetzung;
getStateToGo.$inject = ['$stateParams'];
function getStateToGo($stateParams) {
    if ($stateParams) {
        return $stateParams.stateToGoTo;
    }
    return undefined;
}
exports.getStateToGo = getStateToGo;
// FIXME dieses $inject wird ignoriert, d.h, der Parameter der Funktion muss exact dem Namen des Services entsprechen
// (Grossbuchstaben am Anfang). Warum?
getOrCreateSchadenfall.$inject = ['$stateParams', '$q', 'SchadenfallModelManager'];
/* @ngInject */
function getOrCreateSchadenfall($stateParams, $q, schadenfallModelManager) {
    if ($stateParams) {
        var schadenfallIdParam = $stateParams.schadenfallId;
        var createNewParam = $stateParams.createNew;
        if (createNewParam === 'false' && schadenfallIdParam) {
            return schadenfallModelManager.openSchadenfall(schadenfallIdParam);
        }
    }
    return schadenfallModelManager.initNewSchadenfall();
}
exports.getOrCreateSchadenfall = getOrCreateSchadenfall;
getSchadenfall.$inject = ['$stateParams', '$q', 'SchadenfallModelManager', '$log'];
/* @ngInject */
function getSchadenfall($stateParams, $q, schadenfallModelManager, log) {
    if ($stateParams) {
        var schadenfallIdParam = $stateParams.schadenfallId;
        if (schadenfallIdParam) {
            if (schadenfallModelManager.isSchadenfall(schadenfallIdParam)) {
                return $q.when(schadenfallModelManager.getSchadenfall()); //we already checked for null, hence !
            }
            else {
                return schadenfallModelManager.openSchadenfall(schadenfallIdParam);
            }
        }
    }
    log.error('Can`t open schadenfall on view!!! createOrUpdate a new one...');
    return schadenfallModelManager.initNewSchadenfall();
}
exports.getSchadenfall = getSchadenfall;
getEigenleistung.$inject = ['$stateParams', '$q', 'SchadenfallModelManager', '$log'];
/* @ngInject */
function getEigenleistung($stateParams, $q, schadenfallModelManager, log) {
    if ($stateParams) {
        var schaetzung_1 = $stateParams.schaetzung === 'true';
        var schadenfallIdParam = $stateParams.schadenfallId;
        var eigenleistungenIdParam_1 = $stateParams.eigenleistungId;
        var passedEigenleistung = $stateParams.eigenleistung;
        if (passedEigenleistung) {
            return $q.when(passedEigenleistung);
        }
        if (schadenfallIdParam && eigenleistungenIdParam_1) {
            var schadenfallProm = void 0;
            if (schadenfallModelManager.isSchadenfall(schadenfallIdParam)) {
                schadenfallProm = $q.when(schadenfallModelManager.getSchadenfall());
            }
            else {
                schadenfallProm = schadenfallModelManager.openSchadenfall(schadenfallIdParam);
            }
            return schadenfallProm.then(function (schadenfall) {
                var eigenleistungen = schadenfall.eigenleistungen || [];
                var i = DVBernUtil_1.default.getIndexOfElementwithIDById(eigenleistungenIdParam_1, eigenleistungen);
                if (i >= 0) {
                    return $q.when(eigenleistungen[i]);
                }
                else {
                    log.error('Can`t open requested eigenleistungen on schadenfall. creating a new one...');
                    return $q.when(createNewEigenleistungObj(schaetzung_1));
                }
            });
        }
    }
    log.error('Can`t open requested schadenfall. creating a new eigenleistungo object');
    return $q.when(createNewEigenleistungObj(false));
}
exports.getEigenleistung = getEigenleistung;
getSchaden.$inject = ['$stateParams', '$q', 'SchadenfallModelManager', '$log'];
/* @ngInject */
function getSchaden($stateParams, $q, schadenfallModelManager, log) {
    if ($stateParams) {
        var schadenfallIdParam = $stateParams.schadenfallId;
        var schaedenIdParam_1 = $stateParams.schadenId;
        var passedSchaden = $stateParams.schaden;
        if (passedSchaden) {
            return $q.when(passedSchaden);
        }
        if (schadenfallIdParam && schaedenIdParam_1) {
            var schadenfallProm = void 0;
            if (schadenfallModelManager.isSchadenfall(schadenfallIdParam)) {
                schadenfallProm = $q.when(schadenfallModelManager.getSchadenfall());
            }
            else {
                schadenfallProm = schadenfallModelManager.openSchadenfall(schadenfallIdParam);
            }
            return schadenfallProm.then(function (schadenfall) {
                var schaeden = schadenfall.schaeden || [];
                var i = DVBernUtil_1.default.getIndexOfElementwithIDById(schaedenIdParam_1, schaeden);
                if (i >= 0) {
                    return $q.when(schaeden[i]);
                }
                else {
                    log.error('Can`t open requested schaeden on schadenfall. creating a new one...');
                    return $q.when(createNewSchadenObj());
                }
            });
        }
    }
    log.error('Can`t open requested schadenfall. creating a new schaden object');
    return $q.when(createNewSchadenObj());
}
exports.getSchaden = getSchaden;
getVorleistung.$inject = ['$stateParams', '$q', 'SchadenfallModelManager', '$log'];
/* @ngInject */
function getVorleistung($stateParams, $q, schadenfallModelManager, log) {
    if ($stateParams) {
        var schadenfallIdParam = $stateParams.schadenfallId;
        var vorleistungIdParam_1 = $stateParams.vorleistungId;
        var passedVorleistung = $stateParams.vorleistung;
        if (passedVorleistung) {
            return $q.when(passedVorleistung);
        }
        if (schadenfallIdParam && vorleistungIdParam_1) {
            var schadenfallProm = void 0;
            if (schadenfallModelManager.isSchadenfall(schadenfallIdParam)) {
                schadenfallProm = $q.when(schadenfallModelManager.getSchadenfall());
            }
            else {
                schadenfallProm = schadenfallModelManager.openSchadenfall(schadenfallIdParam);
            }
            return schadenfallProm.then(function (schadenfall) {
                var vorleistungen = schadenfall.vorleistungen || [];
                var i = DVBernUtil_1.default.getIndexOfElementwithIDById(vorleistungIdParam_1, vorleistungen);
                if (i >= 0) {
                    return $q.when(vorleistungen[i]);
                }
                else {
                    log.error('Can`t open requested vorleistungen on schadenfall. creating a new one...');
                    return $q.when(createNewVorleistungObj());
                }
            });
        }
    }
    log.error('Can`t open requested schadenfall. creating a new vorleistung object');
    return $q.when(createNewVorleistungObj());
}
exports.getVorleistung = getVorleistung;
getBeitrag.$inject = ['$stateParams', '$q', 'SchadenfallModelManager', '$log'];
/* @ngInject */
function getBeitrag($stateParams, $q, schadenfallModelManager, log) {
    if ($stateParams) {
        var schadenfallIdParam = $stateParams.schadenfallId;
        var beitragIdParam_1 = $stateParams.beitragId;
        var passedBeitrag = $stateParams.beitrag;
        if (passedBeitrag) {
            return $q.when(passedBeitrag);
        }
        if (schadenfallIdParam && beitragIdParam_1) {
            var schadenfallProm = void 0;
            if (schadenfallModelManager.isSchadenfall(schadenfallIdParam)) {
                schadenfallProm = $q.when(schadenfallModelManager.getSchadenfall());
            }
            else {
                schadenfallProm = schadenfallModelManager.openSchadenfall(schadenfallIdParam);
            }
            return schadenfallProm.then(function (schadenfall) {
                var beitraege = schadenfall.beitraege || [];
                var i = DVBernUtil_1.default.getIndexOfElementwithIDById(beitragIdParam_1, beitraege);
                if (i >= 0) {
                    return $q.when(beitraege[i]);
                }
                else {
                    log.error('Can`t open requested beitrag on schadenfall. creating a new one...');
                    return $q.when(createNewBeitragObj());
                }
            });
        }
    }
    log.error('Can`t open requested schadenfall. creating a new beitrag object');
    return $q.when(createNewBeitragObj());
}
exports.getBeitrag = getBeitrag;
getFremdkosten.$inject = ['$stateParams', '$q', 'SchadenfallModelManager', '$log'];
/* @ngInject */
function getFremdkosten($stateParams, $q, schadenfallModelManager, log) {
    if ($stateParams) {
        var schadenfallIdParam = $stateParams.schadenfallId;
        var fremdkostenIdParam_1 = $stateParams.fremdkostenId;
        var passedFremdkosten = $stateParams.fremdkosten;
        var schaetzung_2 = $stateParams.schaetzung === 'true';
        if (passedFremdkosten) {
            return $q.when(passedFremdkosten);
        }
        if (schadenfallIdParam && fremdkostenIdParam_1) {
            var schadenfallProm = void 0;
            if (schadenfallModelManager.isSchadenfall(schadenfallIdParam)) {
                schadenfallProm = $q.when(schadenfallModelManager.getSchadenfall());
            }
            else {
                schadenfallProm = schadenfallModelManager.openSchadenfall(schadenfallIdParam);
            }
            return schadenfallProm.then(function (schadenfall) {
                var fremdkosten = schadenfall.fremdkosten || [];
                var i = DVBernUtil_1.default.getIndexOfElementwithIDById(fremdkostenIdParam_1, fremdkosten);
                if (i >= 0) {
                    return $q.when(fremdkosten[i]);
                }
                else {
                    log.error('Can`t open requested fremdkosten on schadenfall. creating a new one...');
                    return $q.when(createNewFremdkostenObj(schaetzung_2));
                }
            });
        }
    }
    log.error('Can`t open requested schadenfall. creating a new fremdkosten object');
    return $q.when(createNewFremdkostenObj(false));
}
exports.getFremdkosten = getFremdkosten;
extractSchadenfallId.$inject = ['$stateParams', '$q', '$log'];
function extractSchadenfallId($stateParams, $q, log) {
    return $q.when($stateParams.schadenfallId);
}
exports.extractSchadenfallId = extractSchadenfallId;
function createNewEigenleistungObj(schaetzung) {
    var eigenleistungen = new TSEigenleistung_1.default();
    eigenleistungen.schaetzung = schaetzung;
    eigenleistungen.eigenleistungDatenFS = new TSEigenleistungDaten_1.default();
    return eigenleistungen;
}
function createNewSchadenObj() {
    var schaden = new TSSchaden_1.default();
    schaden.schadenDatenFS = new TSSchadenDaten_1.default();
    schaden.schadenDatenFS.schadenObjektDaten = new TSSchadenObjektDaten_1.default();
    return schaden;
}
function createNewVorleistungObj() {
    var vorleistung = new TSVorleistung_1.default();
    vorleistung.vorleistungDatenFS = new TSVorleistungDaten_1.default();
    return vorleistung;
}
function createNewBeitragObj() {
    var beitrag = new TSBeitrag_1.default();
    return beitrag;
}
function createNewFremdkostenObj(schaetzung) {
    var fremdkosten = new TSFremdkosten_1.default();
    fremdkosten.schaetzung = schaetzung;
    fremdkosten.fremdkostenDatenFS = new TSFremdkostenDaten_1.default();
    return fremdkosten;
}


/***/ }),

/***/ "JACS":
/***/ (function(module, exports) {

module.exports = "<div class=\"container\"> <div class=\"row\"> <div class=\"col-sm-12\"> <div class=\"page-header\"> <h1 data-translate=\"ADMIN\"></h1> </div> <div class=\"marginTop20\"> <h2 data-translate=\"APPLICATION_PROPERTIES\"></h2> </div> <table st-table=\"displayedCollection\" st-safe-src=\"vm.applicationProperties\" st-delay=\"20\" class=\"table table-striped\"> <thead> <tr> <th st-sort=\"name\" class=\"sortable\" data-translate=\"PROPERTY_NAME\"></th> <th st-sort=\"value\" class=\"sortable\" data-translate=\"PROPERTY_TEXT\"></th> <th st-sort=\"timestampErstellt\" class=\"sortable\" data-translate=\"TIMEMUTIERT\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"row in displayedCollection\" st-select-row=\"row\" st-select-mode=\"single\" ng-click=\"vm.editRow(row)\"> <td ng-bind=\"row.name\"></td> <td ng-bind=\"row.value\"></td> <td ng-bind=\"row.timestampMutiert | amDateFormat : 'DD.MM.YYYY'\"></td> </tr> </tbody> </table> <div class=\"panel panel-default\" ng-if=\"vm.applicationProperty.name\"> <form name=\"vm.form\" role=\"form\" class=\"form panel-body\" novalidate> <div class=\"form-group\"> <label data-translate=\"PROPERTY_NAME\" for=\"propName\"> </label> <input id=\"propName\" type=\"text\" name=\"propertyName\" ng-model=\"vm.applicationProperty.name\" dv-max-length class=\"form-control\" required ng-disabled=\"vm.applicationProperty.timestampErstellt\"> <dv-error-messages for=\"vm.form.propertyName\"></dv-error-messages> </div> <div class=\"form-group\" ng-class=\"{'has-error':vm.form.propertyValue.$invalid}\"> <label data-translate=\"PROPERTY_TEXT\" for=\"propVal\"> </label> <input id=\"propVal\" type=\"text\" name=\"propertyValue\" ng-model=\"vm.applicationProperty.value\" dv-max-length class=\"form-control\"> <dv-error-messages for=\"vm.form.propertyValue\"></dv-error-messages> </div> <div class=\"btn-group\" role=\"group\"> <button class=\"btn btn-default\" type=\"submit\" ng-click=\"vm.form.$valid && vm.submit()\"> <span data-translate=\"SAVE\"></span> </button> <a href=\"javascript:\" type=\"button\" class=\"btn btn-default\" id=\"cancelLink\" unsaved-warning-clear ng-click=\"vm.resetForm(); vm.form.$setPristine();form.$setUntouched();\"> <span data-translate=\"CANCEL\"></span> </a> </div> </form> </div> <div class=\"marginTop20\"> <h2 data-translate=\"TESTDATEN\"></h2> </div> <div class=\"form-group\"> <label data-translate=\"Status\" for=\"schadenfallStatusList\"> </label> <select class=\"form-control\" name=\"schadenfallStatusList\" id=\"schadenfallStatusList\" ng-model=\"vm.schadenfallStatus\" ng-options=\"status | translate for status in vm.getSchadenfallStatusList() track by status\"> </select> </div> <div class=\"form-group\"> <label data-translate=\"Anlaufstelle\" for=\"anlaufstelleList\"> </label> <select class=\"form-control\" name=\"anlaufstelleList\" id=\"anlaufstelleList\" ng-model=\"vm.anlaufstelle\" ng-options=\"anlaufstelle.name for anlaufstelle in vm.getAnlaufstelleList() track by anlaufstelle.id\"> </select> </div> <div class=\"form-group\"> <label data-translate=\"Besitzer\" for=\"besitzerList\"> </label> <select class=\"form-control\" name=\"besitzerList\" id=\"besitzerList\" ng-model=\"vm.besitzer\" ng-options=\"besitzer.getFullName() for besitzer in vm.getBesitzerList() track by besitzer.id\"> </select> </div> <div class=\"form-group\"> <label data-translate=\"Anzahl\" for=\"anzahl\"> </label> <input class=\"form-control\" id=\"anzahl\" type=\"text\" name=\"anzahl\" ng-model=\"vm.anzahl\" dv-max-length> </div> <form name=\"vm.exampleForm\" role=\"form\" class=\"\" novalidate> <div class=\"list-group\"> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.createTestFallType('1')\"> <span class=\"fa fa-plus-circle\"></span> <span data-translate=\"TESTFALL_ERSTELLEN\" data-translate-value-gsname=\"Pächter\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.createTestFallType('2')\"> <span class=\"fa fa-plus-circle\"></span> <span data-translate=\"TESTFALL_ERSTELLEN\" data-translate-value-gsname=\"Grundeigentümer mit Pächter\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.createTestFallType('3')\"> <span class=\"fa fa-plus-circle\"></span> <span data-translate=\"TESTFALL_ERSTELLEN\" data-translate-value-gsname=\"Grundeigentümer als Selbstbewirtschafter\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.createVersicherungsbeitragFallTest()\"> <span class=\"fa fa-plus-circle\"></span> <span data-translate=\"VERSICHERUNGSBEITRAG_FALL_ERSTELLEN\" data-translate-value-gsname=\"Körperschaft\"></span> </button> </div> <div class=\"marginTop20\"> <h2 data-translate=\"TESTMAIL\"></h2> </div> <div class=\"form-group\"> <label data-translate=\"SCHADENFALL\" for=\"schadenfall\"> </label> <input class=\"form-control\" id=\"schadenfall\" type=\"text\" name=\"schadenfall\" ng-model=\"vm.schadenfallnummer\" placeholder=\"Fallnummer\" dv-max-length> </div> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.sendTestMail('SENDABLEHNUNGMAIL')\"> <span class=\"fa fa-mail-forward\"></span> <span data-translate=\"SENDABLEHNUNGMAIL\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.sendTestMail('SENDSCHADENFALLFREIGEGEBENMESSAGE')\"> <span class=\"fa fa-mail-forward\"></span> <span data-translate=\"SENDSCHADENFALLFREIGEGEBENMESSAGE\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.sendTestMail('SENDBETROFFENEWIEDERHERSTELLUNGBEWILLIGTMAIL')\"> <span class=\"fa fa-mail-forward\"></span> <span data-translate=\"SENDBETROFFENEWIEDERHERSTELLUNGBEWILLIGTMAIL\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.sendTestMail('SENDAUSZAHLUNGSMAIL')\"> <span class=\"fa fa-mail-forward\"></span> <span data-translate=\"SENDAUSZAHLUNGSMAIL\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.sendTestMail('SENDSCHADENFALLFREIGEGEBENFORANLAUFSTELLEMESSAGE')\"> <span class=\"fa fa-mail-forward\"></span> <span data-translate=\"SENDSCHADENFALLFREIGEGEBENFORANLAUFSTELLEMESSAGE\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.sendTestMail('SENDSCHAETZERABRECHNUNGMANGELHAFTMAIL')\"> <span class=\"fa fa-mail-forward\"></span> <span data-translate=\"SENDSCHAETZERABRECHNUNGMANGELHAFTMAIL\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.sendTestMail('SENDSCHAETZERAUFWAENDEREADYFORVERIFICATIONMAIL')\"> <span class=\"fa fa-mail-forward\"></span> <span data-translate=\"SENDSCHAETZERAUFWAENDEREADYFORVERIFICATIONMAIL\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.sendTestMail('SENDSCHAETZERWIEDERHERSTELLUNGBEWILLIGTMAIL')\"> <span class=\"fa fa-mail-forward\"></span> <span data-translate=\"SENDSCHAETZERWIEDERHERSTELLUNGBEWILLIGTMAIL\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.sendTestMail('SENDUEBERPRUEFUNGMANGELHAFTMAIL')\"> <span class=\"fa fa-mail-forward\"></span> <span data-translate=\"SENDUEBERPRUEFUNGMANGELHAFTMAIL\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.sendTestMail('SENDWIEDERHERSTELLUNGANGABENMANGELHAFTMAIL')\"> <span class=\"fa fa-mail-forward\"></span> <span data-translate=\"SENDWIEDERHERSTELLUNGANGABENMANGELHAFTMAIL\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.sendTestMail('SENDSCHAETZERZUGEWIESENMAIL')\"> <span class=\"fa fa-mail-forward\"></span> <span data-translate=\"SENDSCHAETZERZUGEWIESENMAIL\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.sendTestMail('SENDSCHADENFALLUEBERPRUEFUNGFSFORINSPEKTORATMESSAGE')\"> <span class=\"fa fa-mail-forward\"></span> <span data-translate=\"SENDSCHADENFALLUEBERPRUEFUNGFSFORINSPEKTORATMESSAGE\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.sendTestMail('SENDSCHADENFALLSCHADENBEHOBENFORINSPEKTORATMESSAGE')\"> <span class=\"fa fa-mail-forward\"></span> <span data-translate=\"SENDSCHADENFALLSCHADENBEHOBENFORINSPEKTORATMESSAGE\"></span> </button> <button type=\"button\" class=\"list-group-item\" ng-click=\"vm.sendTestMail('TESTISSCHADENFALLOVERDUEBATCHJOB')\"> <span class=\"fa fa-mail-forward\"></span> <span>test Schadenfall fällig Batchjob (Schadenfallnummer irrelevant)</span> </button> <div class=\"form-group row marginTop20\"> <div class=\"col-md-6\"> <label data-translate=\"DEV_FUNCTIONS\" for=\"devFunctions\"></label> <input id=\"devFunctions\" type=\"checkbox\" ng-model=\"vm.devFunctionsEnabled\"> </div> </div> <div ng-show=\"vm.devFunctionsEnabled\"> <div class=\"marginTop20\"> <h2 data-translate=\"BENUTZER_ROLLEN_LOESCHEN\"></h2> </div> <div class=\"form-group row\"> <div class=\"col-md-6\"> <input type=\"email\" ng-model=\"vm.benutzerEmail\" dv-max-length class=\"form-control\" placeholder=\"contact.powerpuffgirls@heroes.com\"> </div> <div class=\"col-md-6\"> <button type=\"button\" ng-click=\"vm.removeBetroffeneRole()\" class=\"btn btn-serf-red\"> <span data-translate=\"BETROFFENE_ROLLE\"></span> </button> <button type=\"button\" ng-click=\"vm.resetUserRoles()\" class=\"btn btn-serf-red\"> <span class=\"fa fa-bomb btn-ico\"></span> <span data-translate=\"ALLE_TITLE\"></span> </button> </div> </div> <div class=\"marginTop20\"> <h2 data-translate=\"RECREATE_ZAHLUNGSAUFTR_EXCEL_REPORT\"></h2> </div> <div class=\"form-group row\"> <div class=\"col-md-6\"> <input type=\"text\" ng-model=\"vm.zahlungsAuftragId\" class=\"form-control\" placeholder=\"uuid of Zahlungsauftrag\"> </div> <div class=\"col-md-6\"> <button type=\"button\" ng-click=\"vm.recreateZahlungsauftragExcel()\" class=\"btn btn-serf-red\"> <span class=\"fa fa-recycle btn-ico\"></span> <span data-translate=\"RECREATE\"></span> </button> </div> </div> </div> </form> </div> </div> <div class=\"row marginTop20\"> <div class=\"col-sm-8 col-sm-offset-2\"> <dv-version></dv-version> </div> </div> </div> ";

/***/ }),

/***/ "JAde":
/***/ (function(module, exports) {

module.exports = " <div class=\"abschluss-view container\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <div class=\"dv-input-container-medium marginTop20\"> <div class=\"form-group row\"> <div class=\"col-sm-12\"> <h2> <span ng-bind=\"vm.getInfoTitle()\"></span> </h2> </div> </div> <div class=\"form-group row\"> <div class=\"col-sm-12\"> <p> <span ng-bind=\"vm.getInfoText()\"></span> </p> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> </div> <div class=\"col-sm-12\"> <div class=\"row mainbuttons\"> <div class=\"col-sm-2 col-sm-offset-6\"> <button type=\"button\" class=\"btn btn-serf\" ng-click=\"vm.navigate()\"> <span ng-bind=\"vm.getButtonText()\"></span> </button> </div> </div> </div> </div> </div></form> </div> ";

/***/ }),

/***/ "JRTc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ShowTooltipController_1 = __webpack_require__("Uq6U");
var template = __webpack_require__("L6K3");
__webpack_require__("ObPT");
var showTooltipTemplate = __webpack_require__("IPSF");
var DvTooltipComponentConfig = /** @class */ (function () {
    function DvTooltipComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = DvTooltipController;
        this.controllerAs = 'vm';
        this.bindings = {
            text: '<'
        };
    }
    return DvTooltipComponentConfig;
}());
exports.DvTooltipComponentConfig = DvTooltipComponentConfig;
var DvTooltipController = /** @class */ (function () {
    /* @ngInject */
    function DvTooltipController($translate, DvDialog) {
        this.$translate = $translate;
        this.DvDialog = DvDialog;
    }
    DvTooltipController.prototype.showTooltip = function (text) {
        this.DvDialog.showDialog(showTooltipTemplate, ShowTooltipController_1.ShowTooltipController, {
            text: text
        });
    };
    DvTooltipController.$inject = ['$translate', 'DvDialog'];
    return DvTooltipController;
}());
exports.DvTooltipController = DvTooltipController;


/***/ }),

/***/ "JSQ2":
/***/ (function(module, exports) {

module.exports = " <div dv-scroll-nav> <dv-gesuch-navigation herkunft=\"{{vm.model.schadenfallHerkunft}}\" schadenfall-id=\"{{vm.model.id}}\" status=\"{{vm.model.status}}\" sticky=\"sticky\" title=\"{{vm.getViewTitle()}}\"></dv-gesuch-navigation> <div ng-class=\"['gesuchErstellen-view', 'container', {'container-sticky':sticky}]\"> <form class=\"\" name=\"vm.form\" novalidate role=\"form\" unsaved-warning-form> <fieldset ng-disabled=\"vm.isSchadenFallReadonly()\" ng-if=\"vm.isSchadenFallVisible()\"> <fieldset class=\"row\" dv-show-allowed-roles=\"vm.roleUtilService.getAllowedToCreatePapierSchadenfallRoles()\" dv-show-element dv-show-expression=\"vm.showManuelleAnlaufstellenZuweisungPapier()\"> <div class=\"form-group\"> <div class=\"col-sm-4\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"LINK_ANLAUFSTELLE\" for=\"anlaufstellenSelect\"></label> <select class=\"form-control\" id=\"anlaufstellenSelect\" name=\"anlaufstellenSelect\" ng-model=\"vm.model.anlaufstelle\" ng-options=\"anlaufstelle.jurisdiction for anlaufstelle in vm.possibleAnlaufstellen track by  anlaufstelle.id\" ng-required=\"true\"> </select> <dv-error-messages for=\"vm.form.anlaufstellenSelect\"></dv-error-messages> </dv-input-container> </div> </div> </fieldset> <div class=\"row\"> <div class=\"col-sm-12\"> <h2 class=\"marginTop0\"> <span ng-bind=\"vm.name\"></span> <span data-translate=\"EIGENTUMSVERHAELTNISSE_GESUCHSTELLER\" data-translate-value-eigentumsverhaeltnis=\"{{vm.model.eigentumsverhaeltnis | translate}}\"></span> </h2> </div> <div class=\"col-sm-4\"> <div class=\"form-group\"> <div class=\"dv-select-style\"> <select class=\"form-control\" id=\"{{vm.prefix}}_eigentumsverhaeltnis\" name=\"eigentumsverhaeltnis\" ng-change=\"vm.changedEigentumsverhaeltinis()\" ng-model=\"vm.model.gesuchsteller.eigentumsverhaeltnis\" ng-options=\"vm.translateEigentumsverhaeltnisForSelect(eigentumsverhaeltnis) for eigentumsverhaeltnis in vm.getTSEigentumsverhaeltnisse() \" ng-required=\"true\"> </select> <dv-error-messages for=\"vm.form.eigentumsverhaeltnis\"></dv-error-messages> </div> </div> </div> </div> <dv-gesuchsteller email-not-required=\"vm.isPapiergesuch()\" erfassungsart=\"vm.model.erfassungsart\" importiert=\"vm.isImportiert()\" model=\"vm.model.gesuchsteller\" name=\"TODO NAME GESUCHSTELLER\" ng-if=\"vm.model.gesuchsteller.eigentumsverhaeltnis\" phone-required=\"vm.isPhoneRequired()\" prefix=\"gesuchsteller\" ermittelter-schaden=\"vm.model.ermittelterSchaden\" schadendatum=\"vm.model.schaeden.length > 0 ? vm.model.schaeden[0].schadenDatenFS.schadendatum : undefined\" schadenfall-id=\"vm.model.id\" status=\"vm.model.status\"> </dv-gesuchsteller> <dv-gesuchsteller email-not-required=\"vm.isPapiergesuch()\" erfassungsart=\"vm.model.erfassungsart\" model=\"vm.model.zweitperson\" name=\"TODO NAME ZWEITPERSON\" ng-if=\"vm.displayZweitperson()\" phone-required=\"vm.isPhoneRequired()\" prefix=\"zweitperson\" ermittelter-schaden=\"vm.model.ermittelterSchaden\" schadendatum=\"vm.model.schaeden.length > 0 ? vm.model.schaeden[0].schadenDatenFS.schadendatum : undefined\" schadenfall-id=\"vm.model.id\" status=\"vm.model.status\"> </dv-gesuchsteller> <div class=\"row\" ng-if=\"!vm.isSchadenFallReadonly()\"> <div class=\"mainbuttons\"> <dv-loading-button button-class=\"btn btn-serf\" button-click=\"vm.next()\" ng-if=\"vm.isInStatusNeu()\" type=\"submit\"> <span data-translate=\"WEITER\"></span> </dv-loading-button> <dv-loading-button button-class=\"btn btn-serf\" button-click=\"vm.next()\" ng-if=\"!vm.isInStatusNeu()\" type=\"submit\"> <span data-translate=\"SAVE\"></span> </dv-loading-button> </div> </div> </fieldset> </form> </div> </div> ";

/***/ }),

/***/ "JWBy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DVRoleElementController = /** @class */ (function () {
    /* @ngInject */
    function DVRoleElementController(authServiceRS) {
        this.authServiceRS = authServiceRS;
    }
    /**
     * Gibt true zurueck wenn die Rolle der Benutzer eraubt ist den Element zu sehen und die zusaetzliche Expression true ist.
     */
    DVRoleElementController.prototype.checkValidity = function () {
        return this.checkRoles() && this.checkExpression();
    };
    /**
     * Die Rollen muessen gesetzt sein, wenn diese Direktive verwendet wird. Sollten die Rollen nicht gesetzt sein, wird das Element ausgeblendet
     * @returns {boolean}
     */
    DVRoleElementController.prototype.checkRoles = function () {
        if (this.dvAllowedRoles) {
            return this.authServiceRS.isOneOfRoles(this.dvAllowedRoles);
        }
        return false;
    };
    /**
     * Diese Methode gibt einfach den Wert von expression zurueck. Hier koennte man aber auch etwas berechnen wenn noetig
     * @returns {boolean} wenn die expression is null oder undefined gibt es true zurueck. Sonst gibt es den Wert von expression zurueck
     */
    DVRoleElementController.prototype.checkExpression = function () {
        if (this.dvExpression === undefined || this.dvExpression === null) {
            return true;
        }
        return (this.dvExpression === true);
    };
    DVRoleElementController.$inject = ['AuthServiceRS'];
    return DVRoleElementController;
}());
exports.DVRoleElementController = DVRoleElementController;


/***/ }),

/***/ "JaKC":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".berechnungsdetail--currency:before{content:\"CHF \"}", ""]);

// exports


/***/ }),

/***/ "JlIQ":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("Xdl5");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-version.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-version.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "JnPV":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("nHss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-leistungsempfaenger.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-leistungsempfaenger.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "JriT":
/***/ (function(module, exports) {

module.exports = " <dv-input-container ng-form=\"typeaheadForm\" class=\"dv-gemeinde-typeahead\"> <label for=\"{{vm.inputName}}\" class=\"md-no-float\" data-translate=\"{{vm.label}}\"></label> <input name=\"{{vm.inputName}}\" id=\"{{vm.inputName}}\" ng-model=\"vm.selectedGemeinde\" placeholder=\"{{vm.inputPlaceholder | translate}}\" uib-typeahead=\"gemeinde as gemeinde.name for gemeinde in vm.loadSuggestElements($viewValue)\" typeahead-loading=\"loadingLocations\" typeahead-editable=\"false\" typeahead-select-on-exact=\"true\" ng-required=\"vm.valueRequired\" typeahead-select-on-blur=\"true\" autocomplete=\"off\" typeahead-no-results=\"noResults\" class=\"form-control\"> <i ng-show=\"loadingLocations\" class=\"glyphicon glyphicon-refresh\"></i> <dv-error-messages for=\"typeaheadForm[vm.inputName]\"></dv-error-messages> <dv-bisher ng-if=\"vm.showBisher()\" gs=\"vm.bisherGs\" fs=\"vm.bisherFs\" for=\"typeaheadForm[vm.inputName]\" property=\"name\"></dv-bisher> <div ng-show=\"noResults\" class=\"dv-gemeinde-typeahead__no-results-msg\"> <i class=\"glyphicon glyphicon-remove\"></i> {{\"NO_RESULTS_FOUND\" | translate}} </div> </dv-input-container> ";

/***/ }),

/***/ "JrvS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__("OMJi");
var TSEigentumsverhaeltnis_1 = __webpack_require__("PSWS");
var TSErfassungsArt_1 = __webpack_require__("X/T9");
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var TSGesuchsteller_1 = __importDefault(__webpack_require__("o8Fj"));
var AnlaufstelleUtil_1 = __importDefault(__webpack_require__("720h"));
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
var abstractModelManagerController_1 = __importDefault(__webpack_require__("S1yE"));
var template = __webpack_require__("JSQ2");
var berechnungsTemplate = __webpack_require__("lL5G");
var GesuchErstellenViewComponentConfig = /** @class */ (function () {
    function GesuchErstellenViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = GesuchErstellenViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            schadenfall: '<',
        };
    }
    return GesuchErstellenViewComponentConfig;
}());
exports.GesuchErstellenViewComponentConfig = GesuchErstellenViewComponentConfig;
var GesuchErstellenViewController = /** @class */ (function (_super) {
    __extends(GesuchErstellenViewController, _super);
    /* @ngInject */
    function GesuchErstellenViewController(dvBernUtil, schadenfallModelManager, $q, $scope, $state, dvDialog, roleUtilService, authServiceRS, benutzerRS, anlaufstelleRS, $translate) {
        var _this = _super.call(this, schadenfallModelManager, $scope, $state.current.name) || this;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$state = $state;
        _this.dvDialog = dvDialog;
        _this.roleUtilService = roleUtilService;
        _this.authServiceRS = authServiceRS;
        _this.benutzerRS = benutzerRS;
        _this.anlaufstelleRS = anlaufstelleRS;
        _this.$translate = $translate;
        _this.currentYear = new Date().getFullYear();
        _this.possibleAnlaufstellen = [];
        _this.displayAnlaufstellenSelect = true;
        return _this;
    }
    GesuchErstellenViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        this.initialModel = angular.copy(this.schadenfall);
        this.model = angular.copy(this.schadenfall);
        if (!this.model.zweitperson) {
            this.model.zweitperson = new TSGesuchsteller_1.default(true);
        }
        this.model.zweitperson.isZweitperson = true;
        this.changedEigentumsverhaeltinis();
        this.loadAvailableAnlaufstellen();
    };
    GesuchErstellenViewController.prototype.loadAvailableAnlaufstellen = function () {
        var _this = this;
        var benutzer = this.authServiceRS.getPrincipal();
        if (benutzer && benutzer.id) {
            if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getAdministratorRoles())) {
                //admin hat alle zur auswahl
                this.anlaufstelleRS.getAllAnlaufstellen().then(function (response) {
                    _this.possibleAnlaufstellen = _this.possibleAnlaufstellen.concat(response);
                    _this.possibleAnlaufstellen = _this.possibleAnlaufstellen.filter(AnlaufstelleUtil_1.default.isNotImportiert);
                    _this.displayAnlaufstellenSelect = _this.model.anlaufstelle === undefined;
                });
            }
            else if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getFondssuisseRoles()) &&
                (this.model.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS)) {
                //auch FS Sachbearbeiter darf im richtigen Zustand anlaufstelle zuweisen
                this.anlaufstelleRS.getAllAnlaufstellen().then(function (response) {
                    _this.possibleAnlaufstellen = _this.possibleAnlaufstellen.concat(response);
                    _this.possibleAnlaufstellen = _this.possibleAnlaufstellen.filter(AnlaufstelleUtil_1.default.isNotImportiert);
                    _this.displayAnlaufstellenSelect = _this.model.anlaufstelle === undefined;
                });
            }
            else if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getAnlaufstelleRoles())) {
                this.benutzerRS.getAnlaufstellenForSachbearbeiter(benutzer.id).then(function (response) {
                    _this.possibleAnlaufstellen = _this.possibleAnlaufstellen.concat(response);
                    _this.possibleAnlaufstellen = _this.possibleAnlaufstellen.filter(AnlaufstelleUtil_1.default.isNotImportiert);
                    if (_this.possibleAnlaufstellen.length === 1 && _this.model.anlaufstelle === undefined) {
                        _this.model.anlaufstelle = _this.possibleAnlaufstellen[0];
                    }
                    _this.displayAnlaufstellenSelect = _this.model.anlaufstelle === undefined;
                });
            }
        }
    };
    GesuchErstellenViewController.prototype.showManuelleAnlaufstellenZuweisungPapier = function () {
        return this.model.erfassungsart === TSErfassungsArt_1.TSErfassungsArt.PAPIER
            && this.displayAnlaufstellenSelect
            && (this.model.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE || this.model.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS);
    };
    GesuchErstellenViewController.prototype.getViewTitle = function () {
        return this.dvBernUtil.getViewTitle(this.model);
    };
    GesuchErstellenViewController.prototype.next = function () {
        this.speichernGo('schadenmeldung');
    };
    GesuchErstellenViewController.prototype.beenden = function () {
        this.speichernGo('schadenfaelle');
    };
    GesuchErstellenViewController.prototype.isImportiert = function () {
        return !util_1.isNullOrUndefined(this.model.schadenfallHerkunft);
    };
    GesuchErstellenViewController.prototype.speichernGo = function (to) {
        var _this = this;
        to = to || 'schadenmeldung';
        if (this.isGesuchValid() && this.model) {
            this.model.cleanupGesuchsteller();
            this.schadenfallModelManager.saveSchadenfall(this.model).then(function (response) {
                if (to === 'schadenmeldung') {
                    _this.$state.go(to, { schadenfallId: response.id });
                }
                else {
                    _this.$state.go(to);
                }
            });
        }
    };
    /**
     * Diese Methode prueft ob das Form valid ist. Sollte es nicht valid sein wird das erste fehlende Element gesucht
     * und fokusiert, damit der Benutzer nicht scrollen muss, um den Fehler zu finden.
     * Am Ende wird this.form.$valid zurueckgegeben
     */
    GesuchErstellenViewController.prototype.isGesuchValid = function () {
        if (!this.form.$valid) {
            DVBernUtil_1.default.focusFirstInvalidInput();
        }
        return this.form.$valid;
    };
    GesuchErstellenViewController.prototype.isInStatusNeu = function () {
        return this.model.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU || this.model.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE;
    };
    GesuchErstellenViewController.prototype.isSchadenFallNeuOnline = function () {
        if (this.model) {
            return this.model.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU; //papier hat neu_papier
        }
        return false;
    };
    GesuchErstellenViewController.prototype.getTSEigentumsverhaeltnisse = function () {
        return TSEigentumsverhaeltnis_1.getTSEigentumsverhaeltnisValuesSchadenfall();
    };
    GesuchErstellenViewController.prototype.changedEigentumsverhaeltinis = function () {
        if (this.model && this.model && this.model.gesuchsteller.eigentumsverhaeltnis) {
            if (this.model.zweitperson !== undefined) {
                switch (this.model.gesuchsteller.eigentumsverhaeltnis) {
                    case TSEigentumsverhaeltnis_1.TSEigentumsverhaeltnis.GRUNDEIGENTUEMER:
                        this.model.zweitperson.eigentumsverhaeltnis = TSEigentumsverhaeltnis_1.TSEigentumsverhaeltnis.PAECHTER;
                        break;
                    case TSEigentumsverhaeltnis_1.TSEigentumsverhaeltnis.PAECHTER:
                        this.model.zweitperson.eigentumsverhaeltnis = TSEigentumsverhaeltnis_1.TSEigentumsverhaeltnis.GRUNDEIGENTUEMER;
                        break;
                    default:
                        this.model.zweitperson.eigentumsverhaeltnis = TSEigentumsverhaeltnis_1.TSEigentumsverhaeltnis.PAECHTER;
                        break;
                }
            }
            else {
                console.error('zweitperson should be initialized');
            }
        }
    };
    GesuchErstellenViewController.prototype.displayZweitperson = function () {
        return !(this.model.gesuchsteller.eigentumsverhaeltnis === TSEigentumsverhaeltnis_1.TSEigentumsverhaeltnis.GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER) && this.model.gesuchsteller.rechtsform !== undefined;
    };
    GesuchErstellenViewController.prototype.translateEigentumsverhaeltnisForSelect = function (etv) {
        var prefix = TSEigentumsverhaeltnis_1.eigentumsverhaeltnisPrefix();
        return this.$translate.instant(prefix + TSEigentumsverhaeltnis_1.TSEigentumsverhaeltnis[etv]);
    };
    GesuchErstellenViewController.$inject = [
        'DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$state', 'DvDialog',
        'RoleUtilService', 'AuthServiceRS', 'BenutzerRS', 'AnlaufstelleRS', '$translate',
    ];
    return GesuchErstellenViewController;
}(abstractModelManagerController_1.default));
exports.GesuchErstellenViewController = GesuchErstellenViewController;


/***/ }),

/***/ "K/3j":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("TkjQ");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./dv-gemeinde-typeahead.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./dv-gemeinde-typeahead.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "K73C":
/***/ (function(module, exports) {

module.exports = "<div class=\"benutzer-reg-view container\"> <div class=\"row\"> <div class=\"col-sm-10\"> <div class=\"page-header\"> <h1 translate=\"CREATE_PROFIL\"></h1> </div> </div> </div> <form name=\"vm.form\" unsaved-warning-form=\"\" role=\"form\" novalidate> <dv-benutzerprofil benutzer=\"vm.benutzer\" phone-required=\"true\"></dv-benutzerprofil> <div class=\"row\"> <div ng-if=\"vm.captchaEnabled()\" class=\"col-sm-10 form-group\"> <div vc-recaptcha name=\"recaptcha\" key=\"vm.siteKey\" ng-model=\"vm.recaptchaResponse\" class=\"input-element\" lang=\"vm.recaptchaLanguage\"></div> <div ng-messages=\"vm.form\" class=\"captcha-error\"> <div ng-message=\"recaptcha\" role=\"alert\" data-translate=\"ERROR_REQUIRED\"></div> </div> </div> </div> <div class=\"col-sm-10 form-group\"> <dv-loading-button button-class=\"btn btn-serf pull-right\" type=\"submit\" button-click=\"vm.submit()\"> <span data-translate=\"REGISTER\"></span> </dv-loading-button> </div> </form> </div> ";

/***/ }),

/***/ "K7pJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("nu1j");
var template = __webpack_require__("RFsg");
var DvGesuchNavigationComponentConfig = /** @class */ (function () {
    function DvGesuchNavigationComponentConfig() {
        this.transclude = true;
        this.bindings = {
            schadenfallId: '@',
            title: '@?',
            status: '@',
            herkunft: '@',
            sticky: '<',
        };
        this.template = template;
        this.controller = DvGesuchNavigationController;
        this.controllerAs = 'vm';
    }
    return DvGesuchNavigationComponentConfig;
}());
exports.DvGesuchNavigationComponentConfig = DvGesuchNavigationComponentConfig;
var DvGesuchNavigationController = /** @class */ (function () {
    function DvGesuchNavigationController($state, routerHelper, roleUtilService, schadenfallModelManager, pageNames) {
        this.$state = $state;
        this.routerHelper = routerHelper;
        this.roleUtilService = roleUtilService;
        this.schadenfallModelManager = schadenfallModelManager;
        this.pageNames = pageNames;
    }
    DvGesuchNavigationController.prototype.$onInit = function () {
    };
    DvGesuchNavigationController.prototype.showEntschaedigung = function () {
        return this.schadenfallModelManager.isSchadenVisible(this.pageNames.ENTSCHAEDIGUNG);
    };
    DvGesuchNavigationController.prototype.showAufwaende = function () {
        return this.schadenfallModelManager.isSchadenVisible(this.pageNames.AUFWAENDE);
    };
    DvGesuchNavigationController.prototype.showSchaetzung = function () {
        return this.schadenfallModelManager.isSchadenVisible(this.pageNames.SCHAETZUNG);
    };
    DvGesuchNavigationController.prototype.showBemerkung = function () {
        return this.schadenfallModelManager.isSchadenVisibleAndNotNew(this.pageNames.BEMERKUNG);
    };
    DvGesuchNavigationController.$inject = ['$state', 'RouterHelper', 'RoleUtilService', 'SchadenfallModelManager', 'PAGE_NAMES'];
    return DvGesuchNavigationController;
}());
exports.DvGesuchNavigationController = DvGesuchNavigationController;


/***/ }),

/***/ "KDKC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSBegruendungsCode_1 = __webpack_require__("+5XP");
var TSSchadenfallEvent_1 = __webpack_require__("cKO2");
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var BegruendungscodeMapperService = /** @class */ (function () {
    /* @ngInject */
    function BegruendungscodeMapperService(errorService, $log) {
        this.errorService = errorService;
        this.$log = $log;
        this.schadenfallToBegruendungscode = new Map();
        this.keineCodes = [];
        this.fsCodes = TSBegruendungsCode_1.getCodesFS();
        this.initialize();
    }
    BegruendungscodeMapperService.prototype.initialize = function () {
        var codesForInBearbeitungAS = new Map([
            [TSSchadenfallEvent_1.TSSchadenfallEvent.ANLAUFSTELLE_BASISPRUEFUNG_OK, this.keineCodes],
            [TSSchadenfallEvent_1.TSSchadenfallEvent.STICHENTSCHEID_ANGEFORDERT, this.keineCodes]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, codesForInBearbeitungAS);
        var codesForInBearbeitungASStichentscheidFS = new Map([
            [TSSchadenfallEvent_1.TSSchadenfallEvent.STICHENTSCHEID_OK, this.fsCodes],
            [TSSchadenfallEvent_1.TSSchadenfallEvent.ABLEHNUNG, this.fsCodes]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, codesForInBearbeitungASStichentscheidFS);
        var codesForAuftragSchaetzer = new Map([
            [TSSchadenfallEvent_1.TSSchadenfallEvent.SCHAETZUNG_DURCHGEFUEHRT, this.keineCodes]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, codesForAuftragSchaetzer);
        var codesForUeberpruefungAS = new Map([
            [TSSchadenfallEvent_1.TSSchadenfallEvent.ZURUECK_AN_SCHAETZER, this.keineCodes],
            [TSSchadenfallEvent_1.TSSchadenfallEvent.ANLAUFSTELLE_SCHAETZUNG_OK, this.keineCodes],
            [TSSchadenfallEvent_1.TSSchadenfallEvent.STICHENTSCHEID_ANGEFORDERT, this.keineCodes]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, codesForUeberpruefungAS);
        var codesForUeberpruefungASStichentscheidFS = new Map([
            [TSSchadenfallEvent_1.TSSchadenfallEvent.STICHENTSCHEID_OK, this.fsCodes],
            [TSSchadenfallEvent_1.TSSchadenfallEvent.ABLEHNUNG, this.fsCodes]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, codesForUeberpruefungASStichentscheidFS);
        var codesForUeberpruefungFS = new Map([
            [TSSchadenfallEvent_1.TSSchadenfallEvent.FS_UEBERPRUEFUNG_OK, this.fsCodes],
            [TSSchadenfallEvent_1.TSSchadenfallEvent.FS_UEBERPRUEFUNG_OK_PAPIER, this.fsCodes],
            [TSSchadenfallEvent_1.TSSchadenfallEvent.FS_UEBERPRUEFUNG_MANGELHAFT, this.fsCodes],
            [TSSchadenfallEvent_1.TSSchadenfallEvent.ABLEHNUNG, this.fsCodes]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, codesForUeberpruefungFS);
        var codesForWiederherstellung = new Map([
            [TSSchadenfallEvent_1.TSSchadenfallEvent.WIEDERHERSTELLUNG_AUSGEFUEHRT, []],
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, codesForWiederherstellung);
        var codesForUeberpruefungSchaeter = new Map([
            [TSSchadenfallEvent_1.TSSchadenfallEvent.WIEDERHERSTELLUNG_GEPRUEFT, this.keineCodes],
            [TSSchadenfallEvent_1.TSSchadenfallEvent.WIEDERHERSTELLUNG_GEPRUEFT_PAPIER, this.keineCodes],
            [TSSchadenfallEvent_1.TSSchadenfallEvent.WIEDERHERSTELLUNG_MANGELHAFT, this.keineCodes]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, codesForUeberpruefungSchaeter);
        var codesForAbrechnen = new Map([
            [TSSchadenfallEvent_1.TSSchadenfallEvent.ABRECHNUNG_OK, this.fsCodes],
            [TSSchadenfallEvent_1.TSSchadenfallEvent.ABRECHNUNG_MANGELHAFT, this.fsCodes],
            [TSSchadenfallEvent_1.TSSchadenfallEvent.ABLEHNUNG, this.fsCodes],
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, codesForAbrechnen);
        var codesForNeuPapierFS = new Map([
            [TSSchadenfallEvent_1.TSSchadenfallEvent.FREIGABE_PAPIER_FS_6, []],
            [TSSchadenfallEvent_1.TSSchadenfallEvent.FREIGABE_PAPIER_FS_9, []]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, codesForNeuPapierFS);
    };
    BegruendungscodeMapperService.prototype.initBegruedungscodesForStatus = function (schadenfallStatus) {
        var possibleBegrundungscodes = this.schadenfallToBegruendungscode.get(schadenfallStatus);
        if (possibleBegrundungscodes === undefined) {
            this.$log.error('requested Begruendungscode list for status that has no such codes defined ' + schadenfallStatus);
            throw new Error('no Begruendungscode available for status ' + schadenfallStatus);
        }
        return possibleBegrundungscodes;
    };
    BegruendungscodeMapperService.$inject = ['ErrorService', '$log'];
    return BegruendungscodeMapperService;
}());
exports.default = BegruendungscodeMapperService;


/***/ }),

/***/ "KK6q":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "KuoJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/comp-2.5c2828ac69c787280d684c205c90c2cc.jpg";

/***/ }),

/***/ "L0QB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSAuthEvent;
(function (TSAuthEvent) {
    TSAuthEvent[TSAuthEvent["LOGIN_SUCCESS"] = 'LOGIN_SUCCESS'] = "LOGIN_SUCCESS";
    TSAuthEvent[TSAuthEvent["LOGIN_FAILED"] = 'LOGIN_FAILED'] = "LOGIN_FAILED";
    TSAuthEvent[TSAuthEvent["LOGOUT_SUCCESS"] = 'LOGOUT_SUCCESS'] = "LOGOUT_SUCCESS";
    TSAuthEvent[TSAuthEvent["LOGOUT_FAILED"] = 'LOGOUT_FAILED'] = "LOGOUT_FAILED";
    TSAuthEvent[TSAuthEvent["NOT_AUTHENTICATED"] = 'NOT_AUTHENTICATED'] = "NOT_AUTHENTICATED";
    TSAuthEvent[TSAuthEvent["NOT_AUTHORISED"] = 'NOT_AUTHORISED'] = "NOT_AUTHORISED";
    TSAuthEvent[TSAuthEvent["CHANGE_USER"] = 'CHANGE_USER'] = "CHANGE_USER";
})(TSAuthEvent = exports.TSAuthEvent || (exports.TSAuthEvent = {}));


/***/ }),

/***/ "L6K3":
/***/ (function(module, exports) {

module.exports = "<i aria-label=\"Tooltip\" class=\"fa fa-info-circle\" aria-hidden=\"false\" ng-click=\"vm.showTooltip(vm.text)\"></i> ";

/***/ }),

/***/ "LBP/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSLeistungsart;
(function (TSLeistungsart) {
    TSLeistungsart[TSLeistungsart["UNTERNEHMERRECHNUNG"] = 'UNTERNEHMERRECHNUNG'] = "UNTERNEHMERRECHNUNG";
    TSLeistungsart[TSLeistungsart["OFFERTE"] = 'OFFERTE'] = "OFFERTE";
    TSLeistungsart[TSLeistungsart["MATERIAL"] = 'MATERIAL'] = "MATERIAL";
    TSLeistungsart[TSLeistungsart["HOLZ"] = 'HOLZ'] = "HOLZ";
    TSLeistungsart[TSLeistungsart["PAUSCHAL"] = 'PAUSCHAL'] = "PAUSCHAL";
    TSLeistungsart[TSLeistungsart["MIETE"] = 'MIETE'] = "MIETE";
})(TSLeistungsart = exports.TSLeistungsart || (exports.TSLeistungsart = {}));
function getLeistungsartValues(forSchaetzung) {
    var array = new Array();
    if (forSchaetzung) {
        array.push(TSLeistungsart.PAUSCHAL);
        array.push(TSLeistungsart.OFFERTE);
        array.push(TSLeistungsart.HOLZ);
    }
    else {
        array.push(TSLeistungsart.UNTERNEHMERRECHNUNG);
    }
    array.push(TSLeistungsart.MATERIAL);
    array.push(TSLeistungsart.MIETE);
    return array;
}
exports.getLeistungsartValues = getLeistungsartValues;
function leistungsartPrefix() {
    return 'TSLeistugnsart_';
}
exports.leistungsartPrefix = leistungsartPrefix;


/***/ }),

/***/ "LG2F":
/***/ (function(module, exports) {

module.exports = "<h2 ng-if=\"vm.readonly\" data-translate=\"BERECHNUNG_BETRAG\"></h2> <h2 ng-if=\"!vm.readonly\" data-translate=\"BETRAG_BESTIMMEN\"></h2> <div class=\"row\"> <div class=\"col-sm-5\"> <table class=\"table table-alt\"> <tbody> <tr> <td data-translate=\"ERMITTELTER_SCHADEN\"></td> <td class=\"text-right mono\" ng-bind=\"vm.ermittelterSchaden| number: 2\"> </td> </tr> <tr ng-if=\"!vm.useImportiertAbzugEV()\"> <td data-translate=\"ABZUG_EINKOMMEN\"></td> <td class=\"text-right mono\"> - {{vm.einkommensabzug | number: 2}} </td> </tr> <tr ng-if=\"!vm.useImportiertAbzugEV()\"> <td data-translate=\"ABZUG_VERMOEGEN\"></td> <td class=\"text-right mono\"> - {{vm.vermoegenssabzug | number: 2}} </td> </tr> <tr ng-if=\"!vm.useImportiertAbzugEV()\"> <td data-translate=\"ABZUG_ANTEIL\"></td> <td class=\"text-right mono\"> - {{vm.nichtBerechtigterAnteil | number: 2}} </td> </tr> <tr ng-if=\"vm.useImportiertAbzugEV()\"> <td data-translate=\"ABZUG_EV\"></td> <td class=\"text-right mono\"> - {{vm.importiertAbzugEV | number: 2}} </td> </tr> </tbody> <tfoot> <tr class=\"tr-highlight\" ng-if=\"!vm.useImportiertAbzugEV()\"> <td data-translate=\"ANRECHENBARER_SCHADEN\"></td> <td class=\"text-right mono\"> {{vm.anrechenbarerSchaden| number: 2}} </td> </tr> <tr class=\"tr-highlight\" ng-if=\"vm.useImportiertAbzugEV()\"> <td data-translate=\"ANRECHENBARER_SCHADEN\"></td> <td class=\"text-right mono\"> {{(vm.ermittelterSchaden - vm.importiertAbzugEV) | number: 2}} </td> </tr> <tr class=\"tr-highlight tr-highlight--noborder\" ng-if=\"vm.useImportiertAbzugEV()\"> <td class=\"mono\" data-translate=\"PROZENTSATZ_BEITRAG\" translate-values=\"{ prozentsatz: (60)}\"></td> <td class=\"text-right mono\"> {{(vm.ermittelterSchaden - vm.importiertAbzugEV) * 0.8 | number: 2}} </td> </tr> <tr class=\"tr-highlight tr-highlight--noborder\" ng-if=\"vm.prozentsatz\"> <td class=\"mono\" data-translate=\"PROZENTSATZ_BEITRAG\" translate-values=\"{ prozentsatz: (vm.prozentsatz)}\"></td> <td class=\"text-right mono\"> {{vm.betragVorschlag| number: 2}} </td> </tr> <tr ng-if=\"vm.readonly\" class=\"tr-highlight\"> <td data-translate=\"BEITRAG_EFFEKTIV\"></td> <td class=\"text-right mono\"> {{vm.beitrag | number: 2}} </td> </tr> </tfoot> </table> </div> </div> ";

/***/ }),

/***/ "LP7T":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".mark-hover:hover{background-color:#8df}.first-row{margin-top:2rem}", ""]);

// exports


/***/ }),

/***/ "LSA/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractModelController_1 = __importDefault(__webpack_require__("VDYy"));
var TSRole_1 = __webpack_require__("MleR");
var TSPasswordData_1 = __importDefault(__webpack_require__("3CBU"));
var template = __webpack_require__("tfhF");
var BenutzerProfilViewComponentConfig = /** @class */ (function () {
    function BenutzerProfilViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = BenutzerProfilViewViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            benutzer: '<',
            forcePasswordChange: '<',
            noEmailEntry: '<',
            phoneRequired: '<?',
        };
    }
    return BenutzerProfilViewComponentConfig;
}());
exports.BenutzerProfilViewComponentConfig = BenutzerProfilViewComponentConfig;
var BenutzerProfilViewViewController = /** @class */ (function (_super) {
    __extends(BenutzerProfilViewViewController, _super);
    /* @ngInject */
    function BenutzerProfilViewViewController($stateParams, $log, errorService, $window, $state, passwordStrengthService, $scope, roleUtilService, $translate, benutzerRS) {
        var _this = _super.call(this, $scope) || this;
        _this.$stateParams = $stateParams;
        _this.$log = $log;
        _this.errorService = errorService;
        _this.$window = $window;
        _this.$state = $state;
        _this.passwordStrengthService = passwordStrengthService;
        _this.roleUtilService = roleUtilService;
        _this.$translate = $translate;
        _this.benutzerRS = benutzerRS;
        _this.viewReadonly = false;
        _this.noEmailEntry = false;
        _this.phoneRequired = false;
        return _this;
    }
    BenutzerProfilViewViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        if (this.forcePasswordChange === undefined) {
            this.forcePasswordChange = false;
        }
        this.initModel();
    };
    BenutzerProfilViewViewController.prototype.initModel = function () {
        this.initialModel = this.benutzer;
        this.model = angular.copy(this.benutzer);
        if (this.forcePasswordChange === true) { // simulate click
            this.onChangePasswd(null);
        }
    };
    BenutzerProfilViewViewController.prototype.submit = function () {
        var _this = this;
        var passwordValid = this.checkPassword();
        if (this.form.$valid && this.getModel() && this.checkEmailRepeated() && passwordValid) {
            // wenn forcePasswordChange gesetzt ist hanelt es sich um einen neu eigeladenen user
            this.benutzerRS.updateOwnUser(this.model, this.forcePasswordChange).then(function (storedBenutzer) {
                if (storedBenutzer !== undefined) {
                    if (_this.getModel().isNew()) {
                        // this.benutzer.passwordData = new TSPasswordData(this.benutzer.email);
                        var msgKey = _this.forcePasswordChange ? 'BENUTZER_CREATED_SUCCESS' : 'BENUTZER_REC_SUCCESS';
                        _this.errorService.addMesageAsInfoWithArgs(msgKey, _this.benutzer.email);
                    }
                    else {
                        if (_this.getModel().email !== storedBenutzer.email) {
                            _this.errorService.addMesageAsInfoWithArgs('BENUTZER_UPDATE_EMAIL_INFO', _this.benutzer.email);
                        }
                    }
                    _this.benutzer = storedBenutzer;
                    _this.initModel();
                    _this.form.$setPristine();
                    _this.form.$setUntouched();
                    _this.$state.go('start');
                }
                else {
                    _this.$log.error('could not save new benutzer ' + _this.getModel());
                }
            });
        }
        else {
            this.$log.debug('Form was not valid');
        }
    };
    BenutzerProfilViewViewController.prototype.cancelBenutzeredit = function () {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('start');
    };
    BenutzerProfilViewViewController.prototype.getRoles = function () {
        return this.roleUtilService.getAnlaufstelleSubuserRolesOnly();
    };
    BenutzerProfilViewViewController.prototype.translateRole = function (val) {
        return this.$translate.instant(TSRole_1.rolePrefix() + val);
    };
    BenutzerProfilViewViewController.prototype.checkEmailRepeated = function () {
        if (this.noEmailEntry) {
            return true;
        }
        var repeatValid = this.getModel().checkEmailRepeated();
        if (!repeatValid) {
            this.errorService.addMesageAsError('ERROR_EMAIL_SAME');
            return false;
        }
        return true;
    };
    BenutzerProfilViewViewController.prototype.onChangePasswd = function (event) {
        this.passwordChangeInitialized = true;
        console.log('password data', this.getModel().passwordData);
        if (this.getModel().passwordData === undefined || this.getModel().passwordData === null) {
            this.getModel().passwordData = new TSPasswordData_1.default(this.getModel().email);
        }
    };
    BenutzerProfilViewViewController.prototype.checkPassword = function () {
        if (this.passwordChangeInitialized) {
            var passwordData = this.getModel().passwordData;
            if (passwordData) {
                return this.passwordStrengthService.checkIfValid(passwordData.password, passwordData.passwordRepeat);
            }
            return false;
        }
        return true;
    };
    BenutzerProfilViewViewController.$inject = ['$stateParams', '$log', 'ErrorService', '$window', '$state',
        'PasswordStrengthService', '$scope', 'RoleUtilService', '$translate', 'BenutzerRS'];
    return BenutzerProfilViewViewController;
}(abstractModelController_1.default));
exports.BenutzerProfilViewViewController = BenutzerProfilViewViewController;


/***/ }),

/***/ "LYXy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/comp-1.2d56074dabcfc75dcc7c554c3b272f66.jpg";

/***/ }),

/***/ "LcGa":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("4K5/");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./anlaufstelleverwaltung.module.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./anlaufstelleverwaltung.module.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Lcj6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var authentication_route_1 = __webpack_require__("xmie");
var dummyAuthenticaton_1 = __webpack_require__("Z1HC");
var invitedUserProfileView_1 = __webpack_require__("J0Q0");
var authenticaton_1 = __webpack_require__("U22j");
var passwordChangeView_1 = __webpack_require__("6IdE");
var passwordResetView_1 = __webpack_require__("/sPZ");
var startView_1 = __webpack_require__("bKPl");
var verifyView_1 = __webpack_require__("SbSG");
var AuthServiceRS_rest_1 = __importDefault(__webpack_require__("4YmB"));
var HttpAuthInterceptor_1 = __importDefault(__webpack_require__("8WYw"));
var HttpBuffer_1 = __importDefault(__webpack_require__("uuxi"));
exports.SerfWebAuthentication = angular.module('dvbAngular.authentication', ['ngCookies', 'utf8-base64'])
    .run(authentication_route_1.authenticationRun)
    .service('HttpAuthInterceptor', HttpAuthInterceptor_1.default)
    .service('AuthServiceRS', AuthServiceRS_rest_1.default)
    .service('AuthServiceRS', AuthServiceRS_rest_1.default)
    .service('httpBuffer', HttpBuffer_1.default)
    .component('startView', new startView_1.StartComponentConfig())
    .component('dummyAuthenticationView', new dummyAuthenticaton_1.DummyAuthenticationComponentConfig())
    .component('passwordResetView', new passwordResetView_1.PasswordResetComponentConfig())
    .component('passwordChangeView', new passwordChangeView_1.PasswordChangedComponentConfig())
    .component('invitedUserProfileView', new invitedUserProfileView_1.InvitedUserProfileComponentConfig())
    .component('verifyView', new verifyView_1.VerifyComponentConfig())
    .component('authenticationView', new authenticaton_1.AuthenticationComponentConfig());


/***/ }),

/***/ "Lpwx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSVersicherungsbeitragStatus_1 = __webpack_require__("jJP+");
var template = __webpack_require__("ULxs");
__webpack_require__("V0kl");
var removeDialogTemplate = __webpack_require__("YTLw");
var DVVersicherungsbeitragListConfig = /** @class */ (function () {
    function DVVersicherungsbeitragListConfig() {
        this.transclude = false;
        this.bindings = {
            onFilterChange: '&',
            onEdit: '&',
        };
        this.template = template;
        this.controller = DVVersicherungsbeitragListController;
        this.controllerAs = 'vm';
    }
    return DVVersicherungsbeitragListConfig;
}());
exports.DVVersicherungsbeitragListConfig = DVVersicherungsbeitragListConfig;
var DVVersicherungsbeitragListController = /** @class */ (function () {
    /* @ngInject */
    function DVVersicherungsbeitragListController($log, CONSTANTS) {
        var _this = this;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.displayedCollection = []; //Liste die im Gui angezeigt wird
        this.defaultTableFilterState = {
            sort: {},
            search: {},
            pagination: { start: 0, totalItemCount: 0, number: 30 }
        };
        this.callServer = function (tableFilterState) {
            _this.tableFilterState = tableFilterState;
            _this.pagination = tableFilterState.pagination;
            if (_this.onFilterChange && angular.isFunction(_this.onFilterChange)) {
                _this.onFilterChange({
                    tableState: tableFilterState
                }).then(function (result) {
                    if (result) {
                        tableFilterState.pagination.totalItemCount = result.totalResultSize;
                        tableFilterState.pagination.numberOfPages = Math.ceil(result.totalResultSize / tableFilterState.pagination.number);
                        _this.displayedCollection = new Array().concat(result.versicherungsbeitragDTOs);
                    }
                });
            }
            else {
                _this.$log.info('no callback function spcified for filtering');
            }
        };
        this.initViewModel();
    }
    DVVersicherungsbeitragListController.prototype.initViewModel = function () {
    };
    DVVersicherungsbeitragListController.prototype.$onInit = function () {
    };
    DVVersicherungsbeitragListController.prototype.editClicked = function (versicherungsBeitragFallDTO, event) {
        this.onEdit({ versicherungsbeitrag: versicherungsBeitragFallDTO, event: event });
    };
    DVVersicherungsbeitragListController.prototype.getColumnsNumber = function () {
        var element = angular.element('.dv-versicherungsbeitrag-list .header-row').first();
        if (element && element.get(0)) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 7;
    };
    DVVersicherungsbeitragListController.prototype.getVersicherungsbeitraegeStatus = function () {
        return TSVersicherungsbeitragStatus_1.getTSVersicherungsbeitragStatusalues();
    };
    DVVersicherungsbeitragListController.$inject = ['$log', 'CONSTANTS'];
    return DVVersicherungsbeitragListController;
}());
exports.DVVersicherungsbeitragListController = DVVersicherungsbeitragListController;


/***/ }),

/***/ "Lr2U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var IHasUnconnectedDocuments_1 = __webpack_require__("3irw");
var TSAbstractEntity = /** @class */ (function () {
    function TSAbstractEntity() {
    }
    Object.defineProperty(TSAbstractEntity.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (id) {
            this._id = id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAbstractEntity.prototype, "timestampErstellt", {
        get: function () {
            return this._timestampErstellt;
        },
        set: function (timestampErstellt) {
            this._timestampErstellt = timestampErstellt;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAbstractEntity.prototype, "timestampMutiert", {
        get: function () {
            return this._timestampMutiert;
        },
        set: function (timestampMutiert) {
            this._timestampMutiert = timestampMutiert;
        },
        enumerable: true,
        configurable: true
    });
    TSAbstractEntity.prototype.isNew = function () {
        return !this._timestampErstellt;
    };
    TSAbstractEntity.prototype.deserialize = function (restObject) {
        this.id = restObject.id;
        this.timestampErstellt = DateUtil_1.default.localDateTimeToMoment(restObject.timestampErstellt);
        this.timestampMutiert = DateUtil_1.default.localDateTimeToMoment(restObject.timestampMutiert);
        if (IHasUnconnectedDocuments_1.isInstanceOfHasUnconnectedDocuments(this)) {
            this.documentIdsToConnect = restObject.documentIdsToConnect || [];
        }
        return this;
    };
    TSAbstractEntity.prototype.serialize = function (restObject) {
        restObject.id = this.id;
        if (this.timestampErstellt) {
            restObject.timestampErstellt = DateUtil_1.default.momentToLocalDateTime(this.timestampErstellt);
        }
        if (this.timestampMutiert) {
            restObject.timestampMutiert = DateUtil_1.default.momentToLocalDateTime(this.timestampMutiert);
        }
        if (IHasUnconnectedDocuments_1.isInstanceOfHasUnconnectedDocuments(this) && this.documentIdsToConnect) {
            restObject.documentIdsToConnect = this.documentIdsToConnect;
        }
        return restObject;
    };
    TSAbstractEntity.prototype.deserializeOrCreate = function (restObject, obj) {
        if (restObject) {
            return obj.deserialize(restObject);
        }
        else {
            return obj;
        }
    };
    TSAbstractEntity.prototype.deserializeOrNull = function (restObject, obj) {
        if (restObject) {
            return obj.deserialize(restObject);
        }
        else {
            return undefined;
        }
    };
    TSAbstractEntity.prototype.serializeOrInit = function (object, restObject) {
        if (object) {
            return object.serialize({});
        }
        else {
            return undefined;
        }
    };
    TSAbstractEntity.prototype.arrayToRestObject = function (array) {
        var list = [];
        if (array) {
            for (var i = 0; i < array.length; i++) {
                list[i] = this.serializeOrInit(array[i], list[i]);
            }
        }
        return list;
    };
    TSAbstractEntity.prototype.isEmptyString = function (str) {
        return (!str || 0 === str.length);
    };
    TSAbstractEntity.prototype.getOptionalString = function (str) {
        if (this.isEmptyString(str)) {
            return undefined;
        }
        return str;
    };
    return TSAbstractEntity;
}());
exports.default = TSAbstractEntity;


/***/ }),

/***/ "M07A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("oPJU");
var DVAnlaufstelleTypeaheadComponentConfig = /** @class */ (function () {
    function DVAnlaufstelleTypeaheadComponentConfig() {
        this.transclude = false;
        this.bindings = {
            selectedAnlaufstelle: '=',
            inputName: '@?',
            inputPlaceholder: '@?',
            inputDisabled: '<?',
            label: '@',
            clazz: '@',
            ngRequired: '<',
        };
        this.template = __webpack_require__("Mx7Y");
        this.controller = DvAnlaufstelleTypeaheadController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return DVAnlaufstelleTypeaheadComponentConfig;
}());
exports.DVAnlaufstelleTypeaheadComponentConfig = DVAnlaufstelleTypeaheadComponentConfig;
var DvAnlaufstelleTypeaheadController = /** @class */ (function () {
    function DvAnlaufstelleTypeaheadController($log, $q, anlaufstelleRS, authServiceRS, roleUtilService) {
        this.$log = $log;
        this.$q = $q;
        this.anlaufstelleRS = anlaufstelleRS;
        this.authServiceRS = authServiceRS;
        this.roleUtilService = roleUtilService;
        this.valueRequired = true; // default required
    }
    DvAnlaufstelleTypeaheadController.prototype.$onInit = function () {
        if (this.ngRequired !== undefined) {
            this.valueRequired = this.ngRequired;
        }
        if (this.inputDisabled === undefined) {
            this.inputDisabled = false;
        }
    };
    DvAnlaufstelleTypeaheadController.prototype.loadSuggestElements = function (searchString) {
        return this.anlaufstelleRS.readAnlaufstellenSuggestion(searchString).then(function (response) {
            return response;
        });
    };
    DvAnlaufstelleTypeaheadController.$inject = ['$log', '$q', 'AnlaufstelleRS', 'AuthServiceRS'];
    return DvAnlaufstelleTypeaheadController;
}());
exports.DvAnlaufstelleTypeaheadController = DvAnlaufstelleTypeaheadController;


/***/ }),

/***/ "MEsq":
/***/ (function(module, exports) {

module.exports = " <div class=\"beitrag-view container\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <div class=\"row\"> <div class=\"col-sm-12\"> <h2> <span ng-if=\"!vm.readonly\" data-translate=\"BEITRAG_ADD\"></span> <span ng-if=\"vm.readonly\" data-translate=\"BEITRAG_READONLY\" data-translate-value-art=\"{{vm.getModel().beitragArt | translate}}\" data-translate-value-datum=\"{{vm.getModel().timestampErstellt | amDateFormat : 'DD.MM.YYYY'}}\"> </span> </h2> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <div class=\"row\" ng-if=\"!vm.readonly\"> <div class=\"col-sm-3 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"BEITRAG_ART\" for=\"beitragArt_ID\"> </label> <select name=\"beitragArt\" id=\"beitragArt_ID\" ng-model=\"vm.getModel().beitragArt\" class=\"form-control\" ng-options=\"vm.translateBeitragArt(art) for art in vm.getAvailableTSBeitragArtValues() track by art\" ng-required=\"true\" ng-change=\"vm.updateBeitragArt()\"> </select> <dv-error-messages for=\"vm.form.beitragArt\"></dv-error-messages> </dv-input-container> </div> </div> <dv-leistungsempfaenger inhaber-name=\"vm.getBankVerbindung().inhaberName\" bank-name=\"vm.getBankVerbindung().bankName\" iban=\"vm.getBankVerbindung().iban\"></dv-leistungsempfaenger> <dv-betrag readonly=\"vm.readonly\" ermittelter-schaden=\"vm.schadenfall.getErmittelterSchaden()\" einkommensabzug=\"vm.schadenfall.gesuchsteller.getEinkommensabzug()\" vermoegenssabzug=\"vm.schadenfall.gesuchsteller.getVermoegenssabzug(vm.schadenfall.schaeden.length > 0 ? vm.schadenfall.schaeden[0].schadenDatenFS.schadendatum : undefined, vm.schadenfall.getErmittelterSchaden())\" nicht-berechtigter-anteil=\"vm.schadenfall.getCalculatedNichtBerechtigterAnteil()\" anrechenbarer-schaden=\"vm.schadenfall.getAnrechenbarerSchaden()\" betrag-vorschlag=\"vm.betragVorschlag\" prozentsatz=\"vm.prozentsatz\" beitrag=\"vm.getModel().beitrag\" importiert-abzug-e-v=\"vm.getModel().importiertAbzugEV\" schadenfallherkunft=\"vm.schadenfall.schadenfallHerkunft\"></dv-betrag> <div class=\"row\" ng-if=\"!vm.readonly\"> <div class=\"col-sm-3\"> <dv-input-container> <label data-translate=\"BETRAG_CHF\" for=\"beitrag_ID\"></label> <dv-valueinput input-id=\"beitrag_ID\" name=\"beitrag\" input-name=\"beitrag\" ng-model=\"vm.getModel().beitrag\" ng-required=\"true\" float=\"true\" fixed-decimals=\"2\" allow-negative=\"true\" class=\"input-element\"> </dv-valueinput> <dv-error-messages for=\"vm.form.beitrag\"></dv-error-messages> </dv-input-container> </div> </div> <div ng-if=\"vm.readonly && vm.zahlungsauftrag\"> <dv-auszahlung zahlungsauftrag=\"vm.zahlungsauftrag\"></dv-auszahlung> </div> <h2 data-translate=\"BEMERKUNG\" aria-hidden> </h2> <div class=\"row\"> <div class=\"col-sm-9\"> <dv-input-container> <textarea name=\"bemerkung\" class=\"form-control input-element\" rows=\"6\" id=\"bemerkung_ID\" ng-model=\"vm.getModel().bemerkung\" ng-required=\"false\" maxlength=\"4000\" aria-labelledby=\"{{'BEMERKUNG' | translate}}\" ng-readonly=\"vm.readonly\"></textarea> <dv-error-messages for=\"vm.form.bemerkung\"></dv-error-messages> </dv-input-container> </div> </div> <div class=\"row mainbuttons\"> <div> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.cancelBeitrag()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> <div ng-if=\"!vm.readonly\"> <dv-loading-button type=\"submit\" button-click=\"vm.saveBeitrag()\" button-class=\"btn btn-serf\"> <span data-translate=\"SAVE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </div> </div> </form> </div> ";

/***/ }),

/***/ "MGBK":
/***/ (function(module, exports) {

module.exports = "<div class=\"table-responsive dv-zahlungsauftrag-list\" ng-class=\"vm.getClass()\"> <table st-table=\"vm.displayedCollection\" st-delay=\"20\" st-pipe=\"vm.callServer\" class=\"table fixedtable table-hover\" id=\"{{vm.tableId}}\" title=\"{{vm.tableTitle}}\" dv-st-table-refresh> <thead> <tr class=\"header-row\"> <th st-sort=\"besitzerName\" class=\"sortable row-besitzerName\" data-translate=\"BENUTZER_ERSTELLT\"></th> <th st-sort=\"ref\" class=\"sortable row-ref\" data-translate=\"REF_BUCHHALTUNG\"></th> <th st-sort-default=\"true\" st-sort=\"timestampErstellt\" class=\"sortable row-timestampErstellt\" data-translate=\"DATUM\"></th> <th class=\"row-empfaenger\" data-translate=\"ANZ_EMPFAENGER\"></th> <th st-sort=\"beitrag\" class=\"sortable row-beitrag\" data-translate=\"BEITRAG\"></th> <th data-translate=\"ISO_DATEI\"></th> <th data-translate=\"BEITRAEGELISTE\"></th> </tr> <tr> <th> <div class=\"dv-select-style\"> <select st-input-event=\"change\" name=\"verantwortlicherSelect\" st-search=\"besitzer\" class=\"form-control dv-table__input\" ng-options=\"benutzer.email as benutzer.getFullName() for benutzer in vm.moeglicheBesitzerForFilter track by benutzer.email\" ng-model=\"vm.selectedBesitzer\"> <option value=\"\">{{\"ALLE\" | translate}}</option> </select> </div> </th> <th> <input st-search=\"ref\" class=\"form-control dv-table__input\" type=\"text\"/> </th> <th> <div> <input st-search=\"datumVon\" class=\"form-control dv-table__input dateinputtable\" type=\"text\" placeholder=\"{{'VON' | translate}}\"/> <input st-search=\"datumBis\" class=\"form-control dv-table__input dateinputtable\" type=\"text\" placeholder=\"{{'BIS' | translate}}\"/> </div> </th> <th> </th> <th> <div> <input st-search=\"beitragVon\" class=\"form-control dv-table__input dateinputtable\" type=\"text\" placeholder=\"{{'VON' | translate}}\"/> <input st-search=\"beitragBis\" class=\"form-control dv-table__input dateinputtable\" type=\"text\" placeholder=\"{{'BIS' | translate}}\"/> </div> </th> </tr> </thead> <tbody> <tr class=\"dateientable\" ng-repeat=\"z in vm.displayedCollection  | orderBy: 'timestampUpload'\"> <td class=\"ellipsis\" title=\"{{z.besitzerName}}\" ng-bind=\"z.besitzerName\"></td> <td class=\"ellipsis\" title=\"{{z.ref}}\" ng-bind=\"z.ref\"></td> <td class=\"ellipsis\" title=\"{{z.timestampErstellt | amDateFormat : 'DD.MM.YYYY'}}\" ng-bind=\"z.timestampErstellt| amDateFormat : 'DD.MM.YYYY'\"></td> <td class=\"ellipsis text-center\" title=\"{{z.empfaenger}}\" ng-bind=\"z.empfaenger\"></td> <td class=\"ellipsis mono text-right\" title=\"{{z.beitrag  | number: 2}}\" ng-bind=\"z.beitrag | number: 2\"></td> <td class=\"clearfix\"> <button ng-click=\"vm.downloadIso(z.painfileId)\" class=\"btn-link\"> <span class=\"fa fa-download\" title=\"{{'DOWNLOAD_ISO' | translate}}\"></span> </button> </td> <td class=\"clearfix\"> <button ng-click=\"vm.downloadExcel(z.excelExportId)\" class=\"btn-link\"> <span class=\"fa fa-download\" title=\"{{'DOWNLOAD_BEITRAEGE' | translate}}\"></span> </button> </td> </tr> <tr ng-if=\"vm.displayedCollection.length === 0\"> <td colspan=\"{{vm.getColumnsNumber()}}\" class=\"empty-table\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> <tfoot> <tr> <td colspan=\"{{vm.getColumnsNumber()}}\" class=\"text-center\"> <div st-pagination=\"\" st-items-by-page=\"30\" st-displayed-pages=\"10\"></div> </td> </tr> </tfoot> </table> </div> ";

/***/ }),

/***/ "MHRu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSRole_1 = __webpack_require__("MleR");
var TSSprache_1 = __webpack_require__("3oUo");
var template = __webpack_require__("GI1D");
__webpack_require__("W/s/");
var DVBenutzerListComponentConfig = /** @class */ (function () {
    function DVBenutzerListComponentConfig() {
        this.transclude = false;
        this.bindings = {
            benutzerlist: '=',
            itemsByPage: '<',
            onEdit: '&',
            onDelete: '&',
            showRole: '<',
            showAnlaufstelleAndKanton: '<',
            showActions: '<',
            showFilter: '<'
        };
        this.template = template;
        this.controller = DVBenutzerListController;
        this.controllerAs = 'vm';
    }
    return DVBenutzerListComponentConfig;
}());
exports.DVBenutzerListComponentConfig = DVBenutzerListComponentConfig;
var DVBenutzerListController = /** @class */ (function () {
    /* @ngInject */
    function DVBenutzerListController($filter, $log, CONSTANTS, $scope, roleUtilService, $window, $translate) {
        this.$filter = $filter;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.$scope = $scope;
        this.roleUtilService = roleUtilService;
        this.$window = $window;
        this.$translate = $translate;
        this.benutzerlist = []; //Liste die im Gui angezeigt wird
        this.initViewModel();
    }
    DVBenutzerListController.prototype.initViewModel = function () {
    };
    DVBenutzerListController.prototype.$onInit = function () {
        if (this.showRole === undefined) {
            this.showRole = true;
        }
        if (this.showFilter === undefined) {
            this.showFilter = true;
        }
        if (this.showActions === undefined) {
            this.showActions = true;
        }
    };
    DVBenutzerListController.prototype.getFilterroles = function () {
        return this.roleUtilService.removeRoles(this.roleUtilService.getAllRolesWithNAButGesuchstellerArray(), [TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.SUPER_ADMIN]);
    };
    DVBenutzerListController.prototype.editClicked = function (benutzerToEdit, event) {
        this.onEdit({ benutzer: benutzerToEdit, event: event });
    };
    DVBenutzerListController.prototype.deleteClicked = function (benutzerToDelete, event) {
        this.onDelete({ benutzer: benutzerToDelete, event: event });
    };
    DVBenutzerListController.prototype.translateAktiv = function (inaktiv) {
        if (inaktiv === undefined) {
            return '-';
        }
        return inaktiv ? (this.$translate.instant('INAKTIV')) : (this.$translate.instant('AKTIV'));
    };
    DVBenutzerListController.prototype.translateSprache = function (sprache) {
        if (sprache === undefined) {
            return '-';
        }
        return this.$translate.instant(TSSprache_1.TSSprache[sprache]);
    };
    DVBenutzerListController.prototype.translateRoles = function (roles) {
        var _this = this;
        var prefix = TSRole_1.rolePrefix();
        return roles.map(function (element) {
            return _this.$translate.instant(prefix + TSRole_1.TSRole[element]);
        }).join(', ');
    };
    DVBenutzerListController.prototype.translateRole = function (role) {
        var prefix = TSRole_1.rolePrefix();
        return this.$translate.instant(prefix + TSRole_1.TSRole[role]);
    };
    DVBenutzerListController.prototype.getColumnsNumber = function () {
        var element = angular.element('.dv-benutzer-list .header-row').first();
        if (element) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 12;
    };
    DVBenutzerListController.prototype.getTSSpracheValues = function () {
        return TSSprache_1.getTSSpracheValues();
    };
    DVBenutzerListController.$inject = ['$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', '$translate'];
    return DVBenutzerListController;
}());
exports.DVBenutzerListController = DVBenutzerListController;


/***/ }),

/***/ "MQFV":
/***/ (function(module, exports) {

module.exports = "<div ng-form=\"kontaktpersonForm\"> <div class=\"row\"> <div ng-class=\"(vm.dontShowKorrespondenzsprache) ? 'col-sm-12' : 'col-sm-4'\"> <dv-input-container> <div> <label class=\"md-no-float\" data-translate=\"ANREDE\"></label> </div> <div class=\"radio-inline\" ng-repeat=\"anrede in vm.getTSAnredeValues()\"> <label> <input aria-label=\"{{anrede}}\" class=\"input-element\" name=\"{{vm.name}}_anrede\" ng-model=\"vm.getModel().gesuchsPersonDatenFS.anrede\" ng-required=\"true\" ng-value=\"anrede\" type=\"radio\"> <span>{{anrede | translate}}</span> </label> </div> <dv-error-messages for=\"kontaktpersonForm[vm.name + '_anrede']\"></dv-error-messages> <dv-bisher for=\"kontaktpersonForm[vm.name + '_anrede']\" fs=\"vm.getModel().gesuchsPersonDatenFS\" gs=\"vm.getModel().gesuchsPersonDatenGS\" property=\"anrede\"></dv-bisher> </dv-input-container> </div> <div class=\"col-sm-4\" ng-if=\"!vm.dontShowKorrespondenzsprache\"> <dv-input-container> <div> <label class=\"md-no-float\" data-translate=\"KORRESPONDENZSPRACHE\" for=\"{{vm.name}}_sprache\"></label> </div> <div> <select class=\"form-control\" id=\"{{vm.name}}_sprache\" name=\"{{vm.name}}_sprache\" ng-model=\"vm.getModel().gesuchsPersonDatenFS.korrespondenzsprache\" ng-options=\"(sprache| translate) for sprache in vm.getTSSpracheValues() \" ng-required=\"true\"> </select> <dv-error-messages for=\"kontaktpersonForm[vm.name + '_sprache']\"></dv-error-messages> <dv-bisher for=\"kontaktpersonForm[vm.name + '_sprache']\" fs=\"vm.getModel().gesuchsPersonDatenFS\" gs=\"vm.getModel().gesuchsPersonDatenGS\" property=\"korrespondenzsprache\"></dv-bisher> </div> </dv-input-container> </div> </div> <div class=\"row\"> <dv-string-input bisher-fs=\"vm.getModel().gesuchsPersonDatenFS\" bisher-gs=\"vm.getModel().gesuchsPersonDatenGS\" bisher-property=\"nachname\" clazz=\"col-sm-4\" label=\"NAME\" model=\"vm.getModel().gesuchsPersonDatenFS.nachname\" name=\"{{vm.name}}_nachname\"> </dv-string-input> <dv-string-input bisher-fs=\"vm.getModel().gesuchsPersonDatenFS\" bisher-gs=\"vm.getModel().gesuchsPersonDatenGS\" bisher-property=\"vorname\" clazz=\"col-sm-4\" label=\"VORNAME\" model=\"vm.getModel().gesuchsPersonDatenFS.vorname\" name=\"{{vm.name}}_vorname\"> </dv-string-input> <div class=\"col-sm-12\" ng-if=\"!vm.dontShowAdresse\"> <dv-adresse adresse=\"vm.getModel().gesuchsPersonDatenFS.adresse\" bisher-fs=\"vm.getModel().gesuchsPersonDatenFS\" bisher-gs=\"vm.getModel().gesuchsPersonDatenGS\" prefix=\"{{vm.name}}_adresse\"></dv-adresse> </div> </div> <div class=\"row\"> <div class=\"col-sm-4 dv-input-container-medium\" ng-if=\"!vm.dontShowEmail\"> <dv-input-container> <label data-translate=\"EMAIL\" for=\"email_ID\"> </label> <input class=\"form-control\" dv-max-length id=\"email_ID\" name=\"email\" ng-model=\"vm.getModel().gesuchsPersonDatenFS.mail\" ng-required=\"!vm.emailNotRequired\" type=\"email\" ng-pattern=\"vm.CONSTANTS.PATTERN_EMAIL\"> <dv-error-messages class=\"error\" for=\"kontaktpersonForm.email\"></dv-error-messages> <dv-bisher for=\"kontaktpersonForm.email\" fs=\"vm.getModel().gesuchsPersonDatenFS\" gs=\"vm.getModel().gesuchsPersonDatenGS\" property=\"mail\"></dv-bisher> </dv-input-container> </div> <div class=\"col-sm-4\"> <dv-input-container class=\"secondColumn\"> <label data-translate=\"TELEFON\" for=\"tel_ID\"> </label> <input class=\"form-control\" dv-max-length id=\"tel_ID\" name=\"telefon\" ng-model=\"vm.getModel().gesuchsPersonDatenFS.telefon\" ng-required=\"vm.phoneRequired\" type=\"text\" ng-pattern=\"vm.CONSTANTS.PATTERN_PHONE\"> <dv-error-messages class=\"error\" for=\"kontaktpersonForm.telefon\"></dv-error-messages> <dv-bisher for=\"kontaktpersonForm.telefon\" forcestring fs=\"vm.getModel().gesuchsPersonDatenFS\" gs=\"vm.getModel().gesuchsPersonDatenGS\" property=\"telefon\"></dv-bisher> </dv-input-container> </div> </div> </div> ";

/***/ }),

/***/ "MbEi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSSerfProperty = /** @class */ (function (_super) {
    __extends(TSSerfProperty, _super);
    function TSSerfProperty(name, value) {
        var _this = _super.call(this) || this;
        _this._name = name;
        _this._value = value;
        return _this;
    }
    Object.defineProperty(TSSerfProperty.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (name) {
            this._name = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSerfProperty.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    TSSerfProperty.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.value = restObject.value;
        this.name = restObject.name;
        return this;
    };
    TSSerfProperty.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.name = this.name;
        restObject.value = this.value;
        return restObject;
    };
    return TSSerfProperty;
}(TSAbstractEntity_1.default));
exports.default = TSSerfProperty;


/***/ }),

/***/ "MeFL":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */", ""]);

// exports


/***/ }),

/***/ "MleR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSRole;
(function (TSRole) {
    TSRole[TSRole["SUPER_ADMIN"] = 'SUPER_ADMIN'] = "SUPER_ADMIN";
    TSRole[TSRole["FONDSSUISSE_ADMIN"] = 'FONDSSUISSE_ADMIN'] = "FONDSSUISSE_ADMIN";
    TSRole[TSRole["FONDSSUISSE_SACHBEARBEITER"] = 'FONDSSUISSE_SACHBEARBEITER'] = "FONDSSUISSE_SACHBEARBEITER";
    TSRole[TSRole["ANLAUFSTELLE_VERWALTER"] = 'ANLAUFSTELLE_VERWALTER'] = "ANLAUFSTELLE_VERWALTER";
    TSRole[TSRole["ANLAUFSTELLE_SACHBEARBEITER"] = 'ANLAUFSTELLE_SACHBEARBEITER'] = "ANLAUFSTELLE_SACHBEARBEITER";
    TSRole[TSRole["ANLAUFSTELLE_SCHAETZER"] = 'ANLAUFSTELLE_SCHAETZER'] = "ANLAUFSTELLE_SCHAETZER";
    TSRole[TSRole["KANTON_VERWALTER"] = 'KANTON_VERWALTER'] = "KANTON_VERWALTER";
    TSRole[TSRole["KANTON_INSPEKTOR"] = 'KANTON_INSPEKTOR'] = "KANTON_INSPEKTOR";
    TSRole[TSRole["BETROFFENER"] = 'BETROFFENER'] = "BETROFFENER";
    TSRole[TSRole["UNASSIGNED_ROLE"] = 'UNASSIGNED_ROLE'] = "UNASSIGNED_ROLE";
})(TSRole = exports.TSRole || (exports.TSRole = {}));
function getTSRoleValues() {
    return [
        TSRole.SUPER_ADMIN,
        TSRole.FONDSSUISSE_ADMIN,
        TSRole.FONDSSUISSE_SACHBEARBEITER,
        TSRole.ANLAUFSTELLE_SACHBEARBEITER,
        TSRole.ANLAUFSTELLE_VERWALTER,
        TSRole.ANLAUFSTELLE_SCHAETZER,
        TSRole.KANTON_VERWALTER,
        TSRole.KANTON_INSPEKTOR,
        TSRole.BETROFFENER,
        TSRole.UNASSIGNED_ROLE,
    ];
}
exports.getTSRoleValues = getTSRoleValues;
function rolePrefix() {
    return 'TSRole_';
}
exports.rolePrefix = rolePrefix;


/***/ }),

/***/ "Mnzi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("/jXN");
__webpack_require__("1Ygk");
__webpack_require__("jUXO");
configure.$inject = ['$translateProvider', '$injector', '$httpProvider', '$logProvider', '$locationProvider', '$compileProvider'];
/* @ngInject */
function configure($translateProvider, $injector, $httpProvider, $logProvider, $locationProvider, $compileProvider) {
    //Translation Provider configuration
    var translProp = __webpack_require__("9cS4");
    var translPropFr = __webpack_require__("n2BN");
    var translPropIt = __webpack_require__("QwOf");
    // In case you have issues with double-escaped parameters, check out this issue:
    // https://github.com/angular-translate/angular-translate/issues/1101
    $translateProvider.useSanitizeValueStrategy('escapeParameters');
    $translateProvider
        .translations('de', translProp)
        .translations('fr', translPropFr) //add all translations at the beginning, this could maybe be done lazy
        .translations('it', translPropIt)
        .registerAvailableLanguageKeys(['de', 'fr', 'it'], {
        'de*': 'de',
        'fr*': 'fr',
        'it*': 'it',
        '*': 'de'
    })
        .fallbackLanguage('de')
        .determinePreferredLanguage();
    // remember language
    $translateProvider.useLocalStorage();
    // Dirty Check configuration (nur wenn plugin vorhanden)
    if ($injector.has('unsavedWarningsConfigProvider')) {
        var unsavedWarningsConfigProvider = $injector.get('unsavedWarningsConfigProvider');
        unsavedWarningsConfigProvider.useTranslateService = true;
        unsavedWarningsConfigProvider.logEnabled = false;
        unsavedWarningsConfigProvider.navigateMessage = 'UNSAVED_WARNING';
        unsavedWarningsConfigProvider.reloadMessage = 'UNSAVED_WARNING_RELOAD';
    }
    //Configuration of $http service
    $httpProvider.interceptors.push('HttpErrorInterceptor');
    $httpProvider.interceptors.push('HttpVersionInterceptor');
    $httpProvider.interceptors.push('HttpAuthInterceptor');
    $httpProvider.interceptors.push('HttpResponseInterceptor');
    $locationProvider.hashPrefix('');
    // disable debug log messages in production
    if (true) {
        $logProvider.debugEnabled(false);
        $compileProvider.debugInfoEnabled(false);
    }
    else {
        $logProvider.debugEnabled(true);
    }
}
exports.configure = configure;


/***/ }),

/***/ "Mx7Y":
/***/ (function(module, exports) {

module.exports = "<dv-input-container ng-form=\"typeaheadForm\" class=\"dv-anlaufstelle-typeahead\"> <label for=\"{{vm.inputName}}\" class=\"md-no-float\" data-translate=\"{{vm.label}}\"></label> <input name=\"{{vm.inputName}}\" id=\"{{vm.inputName}}\" ng-model=\"vm.selectedAnlaufstelle\" placeholder=\"{{vm.inputPlaceholder | translate}}\" uib-typeahead=\"anlaufstelle as (anlaufstelle.name) for anlaufstelle in vm.loadSuggestElements($viewValue)\" typeahead-loading=\"loadingLocations\" typeahead-editable=\"false\" typeahead-select-on-exact=\"true\" ng-required=\"vm.valueRequired\" ng-disabled=\"vm.inputDisabled\" typeahead-select-on-blur=\"true\" autocomplete=\"off\" typeahead-no-results=\"noResults\" class=\"form-control\"> <i ng-show=\"loadingLocations\" class=\"glyphicon glyphicon-refresh\"></i> <dv-error-messages for=\"typeaheadForm[vm.inputName]\"></dv-error-messages> <div ng-show=\"noResults\" class=\"dv-anlaufstelle-typeahead__no-results-msg\"> <i class=\"glyphicon glyphicon-remove\"></i> {{\"NO_RESULTS_FOUND\" | translate}} </div> </dv-input-container> ";

/***/ }),

/***/ "NDtb":
/***/ (function(module, exports) {

module.exports = "<span ng-click=\"vm.goBackHome()\" class=\"fa fa-home logo-house fa-lg\"> </span> ";

/***/ }),

/***/ "NMnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Ki-Tax: System for the management of external childcare subsidies
 * Copyright (C) 2017 City of Bern Switzerland
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * DTO fuer die Infos zu einem BatchJob
 */
var TSBatchJobInformation = /** @class */ (function () {
    function TSBatchJobInformation() {
    }
    Object.defineProperty(TSBatchJobInformation.prototype, "batchStatus", {
        get: function () {
            return this._batchStatus;
        },
        set: function (value) {
            this._batchStatus = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBatchJobInformation.prototype, "createTime", {
        get: function () {
            return this._createTime;
        },
        set: function (value) {
            this._createTime = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBatchJobInformation.prototype, "endTime", {
        get: function () {
            return this._endTime;
        },
        set: function (value) {
            this._endTime = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBatchJobInformation.prototype, "executionId", {
        get: function () {
            return this._executionId;
        },
        set: function (value) {
            this._executionId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBatchJobInformation.prototype, "exitStatus", {
        get: function () {
            return this._exitStatus;
        },
        set: function (value) {
            this._exitStatus = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBatchJobInformation.prototype, "jobName", {
        get: function () {
            return this._jobName;
        },
        set: function (value) {
            this._jobName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBatchJobInformation.prototype, "lastUpdatedTime", {
        get: function () {
            return this._lastUpdatedTime;
        },
        set: function (value) {
            this._lastUpdatedTime = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBatchJobInformation.prototype, "startTime", {
        get: function () {
            return this._startTime;
        },
        set: function (value) {
            this._startTime = value;
        },
        enumerable: true,
        configurable: true
    });
    TSBatchJobInformation.prototype.deserialize = function (restObject) {
        this.batchStatus = restObject.batchStatus;
        this.createTime = restObject.createTime;
        this.endTime = restObject.endTime;
        this.executionId = restObject.executionId;
        this.jobName = restObject.jobName;
        this.lastUpdatedTime = restObject.lastUpdatedTime;
        this.startTime = restObject.startTime;
        return this;
    };
    TSBatchJobInformation.prototype.serialize = function (restObject) {
        return restObject;
    };
    return TSBatchJobInformation;
}());
exports.default = TSBatchJobInformation;


/***/ }),

/***/ "NRA0":
/***/ (function(module, exports) {

module.exports = "<div class=\"authentication-view\" ng-class=\"vm.getBackground()\"> <div class=\"authentication-view__loginbox\"> <form class=\"authentication-view__loginbox-form\" name=\"vm.form\" novalidate role=\"form\" style=\"height:auto\"> <div class=\"authentication-view__loginbox-center\"> <div class=\"authentication-view__regbox authentication-view__regbox--transparent marginTop20\"> <span class=\"authentication-view__regbox__content authentication-view__link\"> <span translate=\"LOGIN_EXISTING_USER\"></span> </span> </div> <div class=\"form-group authentication-view__loginbox-form-group\"> <label for=\"username-input\" translate=\"LOGIN_EMAIL\"></label> <input autofocus class=\"form-control authentication-view__loginbox-input\" id=\"username-input\" name=\"username\" ng-model=\"vm.loginCedentials.username\" required> <dv-error-messages class=\"error\" for=\"vm.form.username\"></dv-error-messages> </div> <div class=\"form-group authentication-view__loginbox-form-group\"> <label for=\"example-password-input\" translate=\"LOGIN_PASSWD\"></label> <input class=\"form-control authentication-view__loginbox-input\" id=\"example-password-input\" name=\"password\" ng-model=\"vm.loginCedentials.password\" required type=\"password\"> <dv-error-messages class=\"error\" for=\"vm.form.password\"></dv-error-messages> </div> <a class=\"authentication-view__link authentication-view__link--italic\" translate=\"LOGING_FORGOT_PASSWORT\" ui-sref=\"passwordreset\"></a> <button class=\"btn btn-serf authentication-view__button authentication-view__login_button\" ng-click=\"vm.loginClicked()\" translate=\"LOGIN_BTN\" type=\"submit\"></button> <dv-alert-box alert-type=\"info\" class=\"authentication-view__login-hinweis\"> <strong translate=\"LOGIN_DAMAGE_NOTICE_TITLE\"></strong> <br> <span translate=\"LOGIN_DAMAGE_NOTICE_TEXT\"></span> <a ng-href=\"{{ 'LOGIN_DAMAGE_NOTICE_URL' | translate }}\" rel=\"noopener noreferrer\" target=\"_blank\" translate=\"LOGIN_DAMAGE_NOTICE_LINK\"></a> </dv-alert-box> <span class=\"authentication-view__infotext\" ng-if=\"vm.isBenutzerRegVisible()\"> <span translate=\"LOGIN_NO_ACCOUNT_YET\"></span> </span> <a class=\"btn btn-serf authentication-view__button marginBottom20\" ng-if=\"vm.isBenutzerRegVisible()\" ui-sref=\"benutzerregistrierung\"> <span class=\"text\" translate=\"LOGIN_REGISTER_GS\"></span> </a> <span class=\"authentication-view__infotext_gemeinde\"> <span translate=\"LOGIN_GEMEINDE\"></span> </span> <a class=\"btn btn-serf authentication-view__button marginBottom60\" ui-sref=\"anlaufstelleregistrierung\"> <span translate=\"LOGIN_REGISTER_ANLAUFSTELLE\"></span> </a> </div> </form> </div> <div class=\"marginTop20\"> <dv-version dont-show-all-details=\"true\"></dv-version> </div> </div> ";

/***/ }),

/***/ "NSBJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSErrorType;
(function (TSErrorType) {
    TSErrorType[TSErrorType["CLIENT_SIDE"] = 'CLIENT_SIDE'] = "CLIENT_SIDE";
    TSErrorType[TSErrorType["VALIDATION"] = 'VALIDATION'] = "VALIDATION";
    TSErrorType[TSErrorType["INTERNAL"] = 'INTERNAL'] = "INTERNAL";
    TSErrorType[TSErrorType["BADREQUEST"] = 'BADREQUEST'] = "BADREQUEST";
})(TSErrorType = exports.TSErrorType || (exports.TSErrorType = {}));


/***/ }),

/***/ "NVeR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSMessageEvent;
(function (TSMessageEvent) {
    TSMessageEvent[TSMessageEvent["ERROR_UPDATE"] = 'ERROR_UPDATE'] = "ERROR_UPDATE";
    TSMessageEvent[TSMessageEvent["INFO_UPDATE"] = 'INFO_UPDATE'] = "INFO_UPDATE";
    TSMessageEvent[TSMessageEvent["CLEAR"] = 'CLEAR'] = "CLEAR";
})(TSMessageEvent = exports.TSMessageEvent || (exports.TSMessageEvent = {}));


/***/ }),

/***/ "NkuY":
/***/ (function(module, exports) {

module.exports = "<div class=\"anlaufstelle-view container\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <div class=\"dv-input-container-medium marginTop20\"> <div class=\"form-group row\"> <div class=\"col-sm-12\"> <h1> <span data-translate=\"NEUE_ANLAUFSTELLE\" ng-if=\"vm.createNew\"></span> <span data-translate=\"ANLAUFSTELLE_EDITIEREN\" ng-if=\"!vm.createNew\"></span> </h1> </div> <div class=\"col-sm-12\"> <dv-input-container> <div class=\"radio-inline\" ng-repeat=\"anlaufstelleType in vm.getTSAnlaufstelleTypeValues()\"> <label> <input ng-value=\"anlaufstelleType\" aria-label=\"{{anrede}}\" ng-model=\"vm.getModel().anlaufstelleType\" type=\"radio\" name=\"anlaufstelleType\" ng-required=\"true\" class=\"input-element\"> <span>{{anlaufstelleType | translate}}</span> </label> </div> <dv-error-messages for=\"vm.form.anlaufstelleType\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-12\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getAdministratorRoles()\"> <dv-input-container> <div class=\"checkbox\"> <label> <input ng-true-value=\"false\" ng-false-value=\"true\" ng-model=\"vm.getModel().active\" type=\"checkbox\" name=\"active\" class=\"input-element\"> <span class=\"md-no-float\" data-translate=\"ANLAUFSTELLE_DEAKTIVIEREN\"></span> <dv-error-messages for=\"vm.form.active\"></dv-error-messages> </label> </div> </dv-input-container> </div> <dv-string-input model=\"vm.getModel().name\" name=\"name\" label=\"NAME_DER_ANLAUFSTELLE\" clazz=\"col-sm-6\"> </dv-string-input> <dv-string-input model=\"vm.getModel().abteilung\" name=\"abteilung\" label=\"ABTEILUNG\" clazz=\"col-sm-6\" ng-required=\"false\"> </dv-string-input> <div class=\"col-sm-12\"> <dv-adresse adresse=\"vm.getModel().adresse\" prefix=\"anlaufstelle_adresse\"></dv-adresse> </div> <div class=\"col-sm-6\" ng-if=\"vm.isKantonType()\"> <div class=\"form-group\"> <label data-translate=\"KANTON\" for=\"anlaufstelleKanton\"> </label> <select name=\"anlaufstelleKanton\" id=\"anlaufstelleKanton\" ng-model=\"vm.getModel().kanton\" class=\"form-control dv-table__input\" ng-options=\"vm.translateKanton(currKanton) for currKanton in vm.kantonList() \"> </select> </div> </div> <div class=\"col-sm-12\"> <h2> <span data-translate=\"VERANTWORTLICHE_PERSON\"></span> </h2> </div> <div class=\"col-sm-6\"> <dv-benutzer-typeahead selected-benutzer=\"vm.getModel().verwalter\" input-name=\"verwalterName\" input-placeholder=\"START_TYPING\" label=\"\" input-disabled=\"vm.disableVerwalterselection\" ng-required=\"true\"> </dv-benutzer-typeahead> </div> <div class=\"col-sm-6\" ng-if=\"vm.disableVerwalterselection\"> <button ng-click=\"vm.enableVerwalterselection()\" class=\"btn btn-sub-serf add-gemeinde-button\" type=\"button\"> <i class=\"fa fa-pencil\" title=\"Verantwortliche Person anpassen\"></i> </button> </div> <fieldset class=\"col-sm-12\" ng-if=\"!vm.isKantonType()\"> <div class=\"row\"> <div class=\"col-sm-12\"> <h2> <span data-translate=\"GEMEINDE_HINZUFUEGEN\"></span> </h2> </div> <div class=\"col-xs-8\"> <div class=\"gemeinde\"> <dv-gemeinde-typeahead selected-gemeinde=\"vm.gemeindeToAdd\" input-name=\"gemeindeName\" input-placeholder=\"START_TYPING\" label=\"\" ng-required=\"false\"> </dv-gemeinde-typeahead> </div> </div> <div class=\"col-xs-4\"> <button ng-click=\"vm.addGemeinde()\" class=\"btn btn-serf-red add-gemeinde-button\" type=\"button\"> <i class=\"fa fa-plus\"></i> </button> </div> <div class=\"col-sm-12\"> <table st-table=\"displayedCollection\" st-safe-src=\"vm.getModel().gemeinden\" st-delay=\"20\" class=\"table fixedtable table-hover\" id=\"gemeinden\" title=\"gemeinden\" dv-st-table-refresh> <thead> <tr class=\"header-row\"> <th class=\"row-name\" data-translate=\"GEMEINDE_FUER_ANLAUFSTELLE\"></th> <th class=\"row-actions\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"row in displayedCollection\" st-select-row=\"row\" st-select-mode=\"single\"> <td class=\"ellipsis\" title=\"{{row.name}}\" ng-bind=\"row.name\"></td> <td class=\"clearfix\"> <button ng-click=\"vm.deleteClicked(row, $event)\" class=\"btn-link pull-right\" type=\"button\"> <span class=\"fa fa-trash-o\" title=\"{{'DELETE' | translate}}\"></span> </button> </td> </tr> <tr> </tr><tr ng-if=\"displayedCollection === undefined || displayedCollection.length === 0\"> <td colspan=\"2\" class=\"empty-table\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> <tfoot> </tfoot> </table> </div> </div> </fieldset> <fieldset class=\"col-sm-12\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getAdministratorRoles()\"> <div class=\"row\"> <div class=\"col-sm-12\"> <h2> <span data-translate=\"VEREINBARUNG\"></span> </h2> </div> <div class=\"col-sm-4\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"VEREINBARUNG_AKZEPTIERT\" for=\"vereinbarungAkzeptiert\"></label> <dv-datepicker input-id=\"vereinbarungAkzeptiert\" name=\"vereinbarungAkzeptiert\" ng-model=\"vm.getModel().vereinbarungAkzeptiert\" ng-required=\"false\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" check-future=\"true\"> </dv-datepicker> <dv-error-messages for=\"vm.form.vereinbarungAkzeptiert\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-12\"> <dv-dokumentupload parentid=\"vm.getModel().id\" on-doc-removed=\"vm.onDocRemoved(document)\" on-doc-added=\"vm.onDocAdded(document)\" document-type=\"vm.doctype\" disable-begleittext=\"true\" button-symbol=\"fa-upload\" button-text=\"{{'VEREINBARUNG_HOCHLADEN' | translate}}\"></dv-dokumentupload> </div> </div> </fieldset> <div class=\"col-sm-12\"> <h2> <span data-translate=\"SACHBEARBEITER_ZUTEILEN\"></span> </h2> </div> <div class=\"col-xs-8\"> <div class=\"gemeinde\"> <dv-input-container> <label for=\"sachbearbeiterEmail\" class=\"md-no-float\" data-translate=\"INIVTATION_EMAIL\"></label> <div class=\"form-group\"> <input name=\"sachbearbeiterEmail\" id=\"sachbearbeiterEmail\" ng-model=\"vm.sachbearbeiterToAdd.email\" type=\"email\" ng-pattern=\"vm.CONSTANTS.PATTERN_EMAIL\" ng-required=\"false\" ng-disabled=\"false\" autocomplete=\"false\" class=\"form-control\"> <dv-error-messages for=\"vm.form.sachbearbeiterEmail\" class=\"error\"></dv-error-messages> </div> </dv-input-container> </div> </div> <div class=\"col-xs-4\"> <button ng-click=\"vm.addSachbearbeiter()\" class=\"btn btn-serf-red add-gemeinde-button\" type=\"button\"> <i class=\"fa fa-plus\"></i> </button> </div> <div class=\"col-sm-12\"> <dv-benutzer-list benutzerlist=\"vm.getSachbearbeiter()\" show-role=\"false\" show-filter=\"false\" on-delete=\"vm.removeSachbearbeiter(benutzer, event)\"></dv-benutzer-list> </div> <div class=\"col-sm-12\"> <h2> <span data-translate=\"SCHAETZER_ZUTEILEN\"></span> </h2> </div> <div class=\"col-xs-8\"> <div class=\"gemeinde\"> <dv-input-container> <label for=\"schaetzerEmail\" class=\"md-no-float\" data-translate=\"INIVTATION_EMAIL\"></label> <input name=\"schaetzerEmail\" id=\"schaetzerEmail\" ng-model=\"vm.schaetzerToAdd.email\" type=\"email\" ng-pattern=\"vm.CONSTANTS.PATTERN_EMAIL\" vm.CONSTANTS.PATTERN_EMAIL ng-required=\"false\" ng-disabled=\"false\" autocomplete=\"false\" class=\"form-control\"> <dv-error-messages for=\"vm.form.schaetzerEmail\" class=\"error\"></dv-error-messages> </dv-input-container> </div> </div> <div class=\"col-xs-4\"> <button ng-click=\"vm.addSchaetzer()\" class=\"btn btn-serf-red add-gemeinde-button\" type=\"button\"> <i class=\"fa fa-plus\"></i> </button> </div> <div class=\"col-sm-12\"> <dv-benutzer-list benutzerlist=\"vm.getSchaetzer()\" show-role=\"false\" show-filter=\"false\" on-delete=\"vm.removeSchaetzer(benutzer,event)\"></dv-benutzer-list> </div> <div class=\"col-sm-12\"> <div class=\"row mainbuttons\"> <div class=\"col-sm-2 col-sm-offset-4\"> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.cancel()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> <div class=\"col-sm-2\"> <dv-loading-button type=\"submit\" button-click=\"vm.save()\" button-class=\"btn btn-serf\"> <span data-translate=\"SAVE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </div> </div> </div> </form> </div> ";

/***/ }),

/***/ "NmJP":
/***/ (function(module, exports) {

module.exports = " <input type=\"number\" inputmode=\"numeric\" class=\"select-page\" ng-model=\"inputPage\" ng-change=\"selectPage(inputPage)\"> ";

/***/ }),

/***/ "NwLi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSBemerkungScope_1 = __webpack_require__("Oh5v");
var TSAbstractBemerkungEntity = /** @class */ (function (_super) {
    __extends(TSAbstractBemerkungEntity, _super);
    function TSAbstractBemerkungEntity() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // transient
        _this._editMode = false;
        return _this;
    }
    Object.defineProperty(TSAbstractBemerkungEntity.prototype, "bemerkung", {
        get: function () {
            return this._bemerkung;
        },
        set: function (value) {
            this._bemerkung = value;
        },
        enumerable: true,
        configurable: true
    });
    TSAbstractBemerkungEntity.prototype.getBesitzerName = function () {
        return '';
    };
    TSAbstractBemerkungEntity.prototype.getBesitzer = function () {
        return undefined;
    };
    TSAbstractBemerkungEntity.prototype.getPreStatus = function () {
        return undefined;
    };
    TSAbstractBemerkungEntity.prototype.getPostStatus = function () {
        return undefined;
    };
    TSAbstractBemerkungEntity.prototype.getBegruendung = function () {
        return undefined;
    };
    TSAbstractBemerkungEntity.prototype.getBemerkungScope = function () {
        return TSBemerkungScope_1.TSBemerkungScope.SYSTEM;
    };
    TSAbstractBemerkungEntity.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.bemerkung = restObject.bemerkung;
        return this;
    };
    TSAbstractBemerkungEntity.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.bemerkung = this.bemerkung;
        return restObject;
    };
    Object.defineProperty(TSAbstractBemerkungEntity.prototype, "editMode", {
        get: function () {
            return this._editMode;
        },
        set: function (value) {
            this._editMode = value;
        },
        enumerable: true,
        configurable: true
    });
    return TSAbstractBemerkungEntity;
}(TSAbstractEntity_1.default));
exports.default = TSAbstractBemerkungEntity;


/***/ }),

/***/ "Nx9a":
/***/ (function(module, exports) {

module.exports = " <div dv-scroll-nav> <dv-versicherung-navigation title=\"{{vm.getViewTitle()}}\" vers-beitrag-id=\"{{vm.model.id}}\" status=\"{{vm.model.status}}\" sticky=\"sticky\"></dv-versicherung-navigation> <div ng-class=\"['versicherungsbeitrag-versicherter-view', 'container', {'container-sticky':sticky}]\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <fieldset ng-disabled=\"vm.readonly\"> <dv-gesuchsteller model=\"vm.model.gesuchsteller\" name=\"gesuchsteller\" erfassungsart=\"vm.model.erfassungsart\" versicherungsmode=\"true\" email-not-required=\"true\" phone-required=\"false\" ermittelter-schaden=\"vm.model.ermittelterSchaden\" ng-if=\"vm.model.gesuchsteller.eigentumsverhaeltnis\"> </dv-gesuchsteller> </fieldset> <div class=\"col-sm-12\"> <div class=\"row mainbuttons\"> <div> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.cancelVersicherungsbeitrag()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> <div ng-if=\"!vm.readonly\"> <dv-loading-button type=\"submit\" button-click=\"vm.saveVersicherungsbeitrag()\" button-class=\"btn btn-serf\"> <span data-translate=\"SAVE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </div> </form> </div> </div> ";

/***/ }),

/***/ "O2FA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var template = __webpack_require__("HgSf");
var DVValueinput = /** @class */ (function () {
    function DVValueinput() {
        this.restrict = 'E';
        this.require = { ngModelCtrl: 'ngModel', dvValueInputCtrl: 'dvValueinput' };
        this.scope = {
            ngModel: '=',
            inputId: '@',
            ngRequired: '<',
            ngDisabled: '<',
            allowNegative: '<',
            float: '<',
            fixedDecimals: '@',
            alwaysFormatWithTwoDecimals: '<',
            dvOnBlur: '&?',
            inputName: '@?',
        };
        this.controller = ValueinputController;
        this.controllerAs = 'vm';
        this.bindToController = true;
        this.template = template;
    }
    DVValueinput.factory = function () {
        var directive = function () { return new DVValueinput(); };
        directive.$inject = [];
        return directive;
    };
    return DVValueinput;
}());
exports.DVValueinput = DVValueinput;
var ValueinputController = /** @class */ (function () {
    function ValueinputController($timeout) {
        this.$timeout = $timeout;
    }
    // beispiel wie man auf changes eines attributes von aussen reagieren kann
    ValueinputController.prototype.$onChanges = function (changes) {
        if (changes.ngRequired && !changes.ngRequired.isFirstChange()) {
            this.valueRequired = changes.ngRequired.currentValue;
        }
    };
    //wird von angular aufgerufen
    ValueinputController.prototype.$onInit = function () {
        var _this = this;
        if (!this.ngModelCtrl) {
            return;
        }
        if (this.ngRequired) {
            this.valueRequired = this.ngRequired;
        }
        if (!this.allowNegative) {
            this.allowNegative = false;
        }
        if (!this.float) {
            this.float = false;
        }
        this.ngModelCtrl.$render = function () {
            _this.valueinput = _this.ngModelCtrl.$viewValue;
        };
        if (this.alwaysFormatWithTwoDecimals) {
            this.ngModelCtrl.$formatters.unshift(ValueinputController.numberToStringWithTwoDecimals);
        }
        else {
            this.ngModelCtrl.$formatters.unshift(ValueinputController.numberToString);
        }
        this.ngModelCtrl.$parsers.push(ValueinputController.stringToNumber);
        this.ngModelCtrl.$validators['valueinput'] = function (modelValue, viewValue) {
            // if not required and view value empty, it's ok...
            if (!_this.valueRequired && !viewValue) {
                return true;
            }
            var value = modelValue || ValueinputController.stringToNumber(viewValue);
            return !isNaN(Number(value)) && (Number(value) < 999999999999) && _this.allowNegative ? true : Number(value) >= 0;
        };
    };
    /**
     * on blur setzen wir den formatierten "string" ins feld
     */
    ValueinputController.prototype.updateModelValueBlur = function () {
        this.updateModelValue();
        this.ngModelCtrl.$setTouched();
    };
    /**
     * onFocus schreiben wir den string als zahl ins feld und setzen den cursor ans ende des inputs
     * @param event
     */
    ValueinputController.prototype.handleFocus = function (event) {
        this.valueinput = this.sanitizeInputString();
        if (event) {
            var angEle = angular.element(event.target); //read raw html element
            var element_1 = angEle[0];
            this.$timeout(function () {
                // If this function exists...
                if (element_1.setSelectionRange) {
                    // ... then use it
                    element_1.setSelectionRange(999999, 999999);
                }
                else {
                    // ... otherwise replace the contents with itself
                    // (Doesn't work in Google Chrome)
                    element_1.val(element_1.val());
                }
            });
        }
    };
    ValueinputController.prototype.updateModelValue = function () {
        //set the number as formatted string to the model
        if (this.valueinput) {
            //if a number of fixed decimals are requested make the transformation on blur
            if (this.float === true && !isNaN(this.fixedDecimals)) {
                this.valueinput = parseFloat(this.valueinput).toFixed(this.fixedDecimals);
            }
            this.valueinput = ValueinputController.formatToNumberString(ValueinputController.formatFromNumberString(this.valueinput));
        }
        this.ngModelCtrl.$setViewValue(this.valueinput);
        if (this.dvOnBlur) { // userdefined onBlur event
            this.dvOnBlur();
        }
    };
    ;
    ValueinputController.numberToString = function (num) {
        return ValueinputController.formatNumber(num.toString());
    };
    ValueinputController.numberToStringWithTwoDecimals = function (num) {
        var param = (num) ? num.toFixed(2) : num.toString();
        return ValueinputController.formatNumber(param);
    };
    ValueinputController.formatNumber = function (input) {
        if (input) {
            return ValueinputController.formatToNumberString(input);
        }
        return '';
    };
    ValueinputController.stringToNumber = function (string) {
        if (string) {
            return Number(ValueinputController.formatFromNumberString(string));
        }
        return null; // null zurueckgeben und nicht undefined denn sonst wird ein ng-parse error erzeugt
    };
    ValueinputController.formatToNumberString = function (valueString) {
        if (valueString !== null && valueString !== undefined) {
            var parts = valueString.split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\'');
            return parts.join('.');
        }
        return valueString;
    };
    ValueinputController.formatFromNumberString = function (numberString) {
        return numberString.split('\'').join('').split(',').join('');
    };
    ValueinputController.prototype.removeNotDigits = function () {
        var transformedInput = this.sanitizeInputString();
        //neuen wert ins model schreiben
        if (transformedInput !== undefined && transformedInput !== this.ngModelCtrl.$viewValue) {
            //setting the new raw number into the invisible parentmodel
            this.ngModelCtrl.$setViewValue(ValueinputController.formatToNumberString(transformedInput));
            this.ngModelCtrl.$render();
        }
        if (this.valueinput !== transformedInput) {
            this.valueinput = transformedInput;
        }
    };
    ValueinputController.prototype.sanitizeInputString = function () {
        var transformedInput = this.valueinput;
        if (transformedInput) {
            var sign = '';
            if (this.allowNegative === true && this.valueinput && this.valueinput.indexOf('-') === 0) { // if negative allowed, get sign
                sign = '-';
                transformedInput.substr(1); // get just the number part
            }
            if (!this.float) {
                transformedInput = this.sanitizeIntString(transformedInput, sign);
            }
            else {
                transformedInput = this.sanitizeFloatString(transformedInput, sign);
            }
        }
        return transformedInput;
    };
    ValueinputController.prototype.sanitizeFloatString = function (transformedInput, sign) {
        // removes all chars that are not a digit or a point
        transformedInput = transformedInput.replace(/([^0-9|\.])+/g, '');
        if (transformedInput) {
            var pointIndex = transformedInput.indexOf('.');
            //only parse if there is either no floating point or the floating point is not at the end. Also dont parse
            // if 0 at end
            if (pointIndex === -1 || (pointIndex !== (transformedInput.length - 1) && transformedInput.lastIndexOf('0') !== (transformedInput.length - 1))) {
                // parse to float to remove unwanted  digits like leading zeros and then back to string
                transformedInput = parseFloat(transformedInput).toString();
            }
        }
        transformedInput = sign + transformedInput; // add sign to raw number
        return transformedInput;
    };
    ValueinputController.prototype.sanitizeIntString = function (transformedInput, sign) {
        transformedInput = transformedInput.replace(/\D+/g, ''); // removes all "not digit"
        if (transformedInput) {
            // parse to int to remove not wanted digits like leading zeros and then back to string
            transformedInput = parseInt(transformedInput).toString();
        }
        transformedInput = sign + transformedInput; // add sign to raw number
        return transformedInput;
    };
    ValueinputController.$inject = ['$timeout'];
    return ValueinputController;
}());
exports.ValueinputController = ValueinputController;


/***/ }),

/***/ "O4UL":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("I486");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./vorleistungView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./vorleistungView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "O5jG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
__webpack_require__("fjOH");
var core_module_1 = __webpack_require__("u87A");
__webpack_require__("LcGa");
var anlaufstelleverwaltung_route_1 = __webpack_require__("0P1y");
var anlaufstelleverwaltungView_1 = __webpack_require__("vzQ5");
var anlaufstelleView_1 = __webpack_require__("u79U");
var anlaufstelleRegistrierungView_1 = __webpack_require__("1zRb");
exports.SerfWebAnlaufstelleverwaltung = angular.module('serfWeb.anlaufstelleverwaltung', [core_module_1.SerfWebCore.name])
    .component('dvAnlaufstelleverwaltungView', new anlaufstelleverwaltungView_1.AnlaufstelleverwaltungViewComponentConfig())
    .component('dvAnlaufstelleView', new anlaufstelleView_1.AnlaufstelleViewComponentConfig())
    .component('dvAnlaufstelleRegistrierungView', new anlaufstelleRegistrierungView_1.AnlaufstelleRegistrierungViewComponentConfig())
    .run(anlaufstelleverwaltung_route_1.anlaufstelleverwaltungRun);
exports.default = exports.SerfWebAnlaufstelleverwaltung;


/***/ }),

/***/ "OKZ8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSRole_1 = __webpack_require__("MleR");
var TSAnlaufstelle_1 = __importDefault(__webpack_require__("B4Ew"));
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
var TSInspektorat_1 = __importDefault(__webpack_require__("6bjF"));
/**
 * Service zum verwalten von Benutzerdaten. Beinhaltet KEINE Informationen ueber den aktuellen eingeloggten Benutzer
 * Dafuer ist der AuthServiceRS zustaendig. Auch um Logins oder Logouts durchzufuehren ist der AuthService zu gebrauchen
 */
var BenutzerRS = /** @class */ (function () {
    /* @ngInject */
    function BenutzerRS($http, CONSTANTS, $q, $rootScope, $log) {
        this.$http = $http;
        this.CONSTANTS = CONSTANTS;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$log = $log;
    }
    BenutzerRS.prototype.createAndSendPasswordResetToken = function (userEmail) {
        var _this = this;
        if (userEmail) {
            return this.$http.post(this.CONSTANTS.REST_API + 'benutzer/public/passwordreset', userEmail, {
                headers: {
                    'Content-Type': 'text/plain'
                }
            }).then(function (response) {
                return _this.$q.defer().resolve(); //void promise zurueckgeben
            }).catch(function () {
                return _this.$q.defer().resolve();
            });
        }
        this.$log.error('passed no email, no reset request sent');
        return this.$q.when(undefined);
    };
    ;
    BenutzerRS.prototype.resetPassword = function (pwData) {
        var _this = this;
        if (pwData) {
            return this.$http.post(this.CONSTANTS.REST_API + 'benutzer/public/changepw', pwData.serialize({}))
                .then(function (response) {
                return _this.$q.defer().resolve();
            });
        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    };
    ;
    BenutzerRS.prototype.possibleVerantwortliche = function () {
        return this.$http.get(this.CONSTANTS.REST_API + 'benutzer/verantworltiche/possible')
            .then(function (response) {
            var converter = function (jsonString) {
                return new TSBenutzer_1.default().deserialize(jsonString);
            };
            if (angular.isArray(response.data)) {
                return response.data.map(converter);
            }
        });
    };
    BenutzerRS.prototype.possibleZahlungsauftragBesitzer = function () {
        return this.$http.get(this.CONSTANTS.REST_API + 'benutzer/zahlungsauftrag/possible')
            .then(function (response) {
            var converter = function (jsonString) {
                return new TSBenutzer_1.default().deserialize(jsonString);
            };
            if (angular.isArray(response.data)) {
                return response.data.map(converter);
            }
        });
    };
    BenutzerRS.prototype.allBenutzerForRole = function (role) {
        return this.$http.get(this.CONSTANTS.REST_API + 'benutzer/alle/' + role)
            .then(function (response) {
            var converter = function (jsonString) {
                return new TSBenutzer_1.default().deserialize(jsonString);
            };
            if (angular.isArray(response.data)) {
                return response.data.map(converter);
            }
        });
    };
    BenutzerRS.prototype.createNewBasicBenutzeraccount = function (benutzer) {
        if (benutzer) {
            var restBenutzer = benutzer.serialize({});
            return this.$http.put(this.CONSTANTS.REST_API + 'benutzer/public/basicAccount', benutzer.serialize({}))
                .then(function (response) {
                if (response.data !== undefined) {
                    return new TSBenutzer_1.default().deserialize(response.data);
                }
                else {
                    return undefined;
                }
            });
        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    };
    BenutzerRS.prototype.createOrUpdateBenutzeraccount = function (benutzer) {
        if (benutzer) {
            var restBenutzer = benutzer.serialize({});
            //prepare callback
            var successCallback = function (response) {
                if (response.data !== undefined) {
                    return new TSBenutzer_1.default().deserialize(response.data);
                }
                else {
                    return undefined;
                }
            };
            //call persist or merge methods
            if (benutzer.isNew()) {
                return this.$http.post(this.CONSTANTS.REST_API + 'benutzer/advancedAccount', benutzer.serialize({}))
                    .then(successCallback);
            }
            else {
                //update
                return this.$http.put(this.CONSTANTS.REST_API + 'benutzer/advancedAccount', benutzer.serialize({}))
                    .then(successCallback);
            }
        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    };
    BenutzerRS.prototype.updateOwnUser = function (benutzer, tokenLogin) {
        if (tokenLogin === void 0) { tokenLogin = false; }
        if (benutzer) {
            var restBenutzer = benutzer.serialize({});
            var url = this.CONSTANTS.REST_API + 'benutzer/ownAccount';
            url = url + (tokenLogin ? '/token' : '');
            //call persist or merge methods
            if (!benutzer.isNew() || benutzer.passwordData && benutzer.passwordData.resetToken) {
                //update
                return this.$http.put(url, benutzer.serialize({}))
                    .then(function (response) {
                    if (response.data !== undefined) {
                        return new TSBenutzer_1.default().deserialize(response.data);
                    }
                    else {
                        return undefined;
                    }
                });
            }
            else {
                this.$log.error('user must not be new or rest token must be set');
            }
        }
        this.$log.error('passed no updatable data, no reset request sent');
        return this.$q.when(undefined);
    };
    BenutzerRS.prototype.verify = function (benutzerid) {
        return this.$http.get(this.CONSTANTS.REST_API + 'benutzer/public/verify/' + encodeURIComponent(benutzerid))
            .then(function (response) {
            if (response.data !== undefined) {
                return new TSBenutzer_1.default().deserialize(response.data);
            }
            else {
                return undefined;
            }
        });
    };
    BenutzerRS.prototype.getAnlaufstellenForBenutzer = function (benutzerId) {
        var _this = this;
        return this.$http.get(this.CONSTANTS.REST_API + 'benutzer/' + encodeURIComponent(benutzerId) + '/anlaufstellen')
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING Anlaufstellen REST  object', response.data);
                return TSAnlaufstelle_1.default.deserializeArray(response.data);
            }
            else {
                return [];
            }
        });
    };
    BenutzerRS.prototype.getAnlaufstellenForSachbearbeiter = function (benutzerId) {
        var _this = this;
        return this.$http.get(this.CONSTANTS.REST_API + 'benutzer/' + encodeURIComponent(benutzerId) + '/sachbearbeiter/anlaufstellen')
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING Anlaufstellen REST  object', response.data);
                return TSAnlaufstelle_1.default.deserializeArray(response.data);
            }
            else {
                return _this.$q.when([]);
            }
        });
    };
    BenutzerRS.prototype.getInspektoratForBenutzer = function (benutzerId) {
        var _this = this;
        return this.$http.get(this.CONSTANTS.REST_API + 'benutzer/' + encodeURIComponent(benutzerId) + '/inspektorat')
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING Anlaufstellen REST  object', response.data);
                return TSInspektorat_1.default.deserializeArray(response.data);
            }
            else {
                return [];
            }
        });
    };
    BenutzerRS.prototype.readBenutzerSuggestion = function (searchString) {
        var _this = this;
        return this.$http.get(this.CONSTANTS.REST_API + 'benutzer/search', {
            params: {
                queryString: searchString,
                rolesToExclude: [TSRole_1.TSRole[TSRole_1.TSRole.BETROFFENER], TSRole_1.TSRole[TSRole_1.TSRole.SUPER_ADMIN]]
            }
        })
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING Benutzer REST  object', response.data);
                return TSBenutzer_1.default.deserializeArray(response.data);
            }
            else {
                return [];
            }
        });
    };
    BenutzerRS.prototype.loadAdvancedBenutzer = function () {
        var _this = this;
        return this.$http.get(this.CONSTANTS.REST_API + 'benutzer/list', {
            params: {}
        })
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING Benutzer REST  object', response.data);
                return TSBenutzer_1.default.deserializeArray(response.data);
            }
            else {
                return [];
            }
        });
    };
    BenutzerRS.prototype.findBenutzerInRole = function (rolesToSearch, rolesToExclude) {
        var _this = this;
        return this.$http.get(this.CONSTANTS.REST_API + 'benutzer/listusers', {
            params: {
                rolesToFind: rolesToSearch,
                rolesToExclude: rolesToExclude,
                allowInactive: false //keine inaktiven
            }
        })
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING Benutzer REST  object', response.data);
                return TSBenutzer_1.default.deserializeArray(response.data);
            }
            else {
                return [];
            }
        });
    };
    BenutzerRS.prototype.findBenutzer = function (benutzerId) {
        var _this = this;
        return this.$http.get(this.CONSTANTS.REST_API + 'benutzer/user/' + encodeURIComponent(benutzerId), {
            params: {}
        })
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING Benutzer REST  object', response.data);
                return new TSBenutzer_1.default().deserialize(response.data);
            }
            else {
                return undefined;
            }
        });
    };
    BenutzerRS.prototype.inviteAdvancedBenutzer = function (userEmail, anlaufstelleId, role) {
        if (!userEmail) {
            console.log('userEmail must be given');
            return this.$q.when(undefined);
        }
        var url = this.CONSTANTS.REST_API + 'benutzer/' + encodeURIComponent(userEmail) + '/anlaufstelle/' + encodeURI(anlaufstelleId);
        return this.$http.post(url, role, {
            headers: {
                'Content-Type': 'text/plain'
            }
        }).then(function (response) {
            console.log('invite success ', response);
            return new TSAnlaufstelle_1.default().deserialize(response.data);
        });
    };
    BenutzerRS.prototype.resetUserRoles = function (userEmail) {
        var _this = this;
        if (userEmail) {
            return this.$http.delete(this.CONSTANTS.REST_API + 'benutzer/resetRoles/' + encodeURIComponent(userEmail))
                .then(function (response) {
                return _this.$q.defer().resolve();
            });
        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    };
    BenutzerRS.prototype.removeBetroffeneRole = function (userEmail) {
        var _this = this;
        if (userEmail) {
            return this.$http.delete(this.CONSTANTS.REST_API + 'benutzer/removeBetroffeneRole/' + encodeURIComponent(userEmail))
                .then(function (response) {
                return _this.$q.defer().resolve();
            });
        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    };
    BenutzerRS.$inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];
    return BenutzerRS;
}());
exports.default = BenutzerRS;


/***/ }),

/***/ "OQQl":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.dv-anlaufstelle-typeahead__no-results-msg{margin-top:30px}", ""]);

// exports


/***/ }),

/***/ "OS2/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BerechnungsdetailController = /** @class */ (function () {
    function BerechnungsdetailController($uibModalInstance, $translate, einkommensabzug, vermoegensabzug, anrechenbarerschaden, minimalschaden, steuerbaresvermoegen, steuerbareseinkommen) {
        this.$uibModalInstance = $uibModalInstance;
        this.einkommensabzug = einkommensabzug;
        this.vermoegensabzug = vermoegensabzug;
        this.anrechenbarerschaden = anrechenbarerschaden;
        this.minimalschaden = minimalschaden;
        this.steuerbaresvermoegen = steuerbaresvermoegen;
        this.steuerbareseinkommen = steuerbareseinkommen;
    }
    BerechnungsdetailController.prototype.ok = function () {
        this.$uibModalInstance.close();
    };
    ;
    BerechnungsdetailController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    ;
    BerechnungsdetailController.$inject = ['$uibModalInstance', '$translate', 'einkommensabzug',
        'vermoegensabzug', 'anrechenbarerschaden', 'minimalschaden', 'steuerbaresvermoegen', 'steuerbareseinkommen'];
    return BerechnungsdetailController;
}());
exports.BerechnungsdetailController = BerechnungsdetailController;


/***/ }),

/***/ "OUBf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".anlaufstelle-view .add-gemeinde-button{margin-top:22px;float:none;min-width:40px}", ""]);

// exports


/***/ }),

/***/ "ObPT":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("6ZDT");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-tooltip.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-tooltip.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Oh5v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSBemerkungScope;
(function (TSBemerkungScope) {
    TSBemerkungScope[TSBemerkungScope["SCHADENFALL"] = 'SCHADENFALL'] = "SCHADENFALL";
    TSBemerkungScope[TSBemerkungScope["AUFWAENDE"] = 'AUFWAENDE'] = "AUFWAENDE";
    TSBemerkungScope[TSBemerkungScope["BEMERKUNG_VIEW"] = 'BEMERKUNG_VIEW'] = "BEMERKUNG_VIEW";
    TSBemerkungScope[TSBemerkungScope["SYSTEM"] = 'SYSTEM'] = "SYSTEM";
})(TSBemerkungScope = exports.TSBemerkungScope || (exports.TSBemerkungScope = {}));
function getTSBemerkungScopeValues() {
    return [
        TSBemerkungScope.SCHADENFALL,
        TSBemerkungScope.AUFWAENDE,
        TSBemerkungScope.SYSTEM,
        TSBemerkungScope.BEMERKUNG_VIEW,
    ];
}
exports.getTSBemerkungScopeValues = getTSBemerkungScopeValues;


/***/ }),

/***/ "P/EH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSApplicationProperty = /** @class */ (function (_super) {
    __extends(TSApplicationProperty, _super);
    function TSApplicationProperty(name, value) {
        var _this = _super.call(this) || this;
        _this._name = name;
        _this._value = value;
        return _this;
    }
    Object.defineProperty(TSApplicationProperty.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (name) {
            this._name = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSApplicationProperty.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    TSApplicationProperty.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.value = restObject.value;
        this.name = restObject.name;
        return this;
    };
    TSApplicationProperty.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.name = this.name;
        restObject.value = this.value;
        return restObject;
    };
    return TSApplicationProperty;
}(TSAbstractEntity_1.default));
exports.default = TSApplicationProperty;


/***/ }),

/***/ "P/jU":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("gpFF");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./dv-versicherungsbeitragBeitrag.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./dv-versicherungsbeitragBeitrag.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "P3Wf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var template = __webpack_require__("s3ia");
__webpack_require__("SzTv");
var InspektoratverwaltungViewComponentConfig = /** @class */ (function () {
    function InspektoratverwaltungViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = InspektoratverwaltungViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            inspektorat: '<',
        };
    }
    return InspektoratverwaltungViewComponentConfig;
}());
exports.InspektoratverwaltungViewComponentConfig = InspektoratverwaltungViewComponentConfig;
var InspektoratverwaltungViewController = /** @class */ (function () {
    /* @ngInject */
    function InspektoratverwaltungViewController(inspektoratRS, $state, roleUtilService, $translate, applicationPropertyRS) {
        this.inspektoratRS = inspektoratRS;
        this.$state = $state;
        this.roleUtilService = roleUtilService;
        this.$translate = $translate;
        this.applicationPropertyRS = applicationPropertyRS;
    }
    InspektoratverwaltungViewController.prototype.$onInit = function () {
    };
    InspektoratverwaltungViewController.prototype.editInspektorat = function (inspektorat, event) {
        var params;
        params = { createNew: false, inspektoratId: inspektorat.id, inspektorat: inspektorat };
        this.$state.go('inspektorat', params);
    };
    InspektoratverwaltungViewController.prototype.addInspektorat = function () {
        var params;
        params = { createNew: true, inspektoratId: '', inspektorat: undefined };
        this.$state.go('inspektorat', params);
    };
    InspektoratverwaltungViewController.$inject = ['InspektoratRS', '$state', 'RoleUtilService', '$translate', 'ApplicationPropertyRS'];
    return InspektoratverwaltungViewController;
}());
exports.InspektoratverwaltungViewController = InspektoratverwaltungViewController;


/***/ }),

/***/ "P6Xd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var TSBerechtigung_1 = __webpack_require__("ErVO");
var TSRole_1 = __webpack_require__("MleR");
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var TSBerechtigungInView_1 = __importDefault(__webpack_require__("xPFQ"));
var BerechtigungsService = /** @class */ (function () {
    /* @ngInject */
    function BerechtigungsService($log, pageNames) {
        /** wurde mit FS-706 mit schaetzung: TSBerechtigung erweitert
         * siehe auch:
         * dv-gesuch-navigation.ts
         * TSBerechtigungview.ts
         */
        this.$log = $log;
        this.pageNames = pageNames;
        this._map = new Map();
        /*Berechtigungen für Betroffener*/
        var berechBetroffener = new Map();
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        this._map.set(TSRole_1.TSRole.BETROFFENER, berechBetroffener);
        /*Berechtigungen für Anlaufstelle Verwalter*/
        var berechAnlaufstVerw = new Map();
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        this._map.set(TSRole_1.TSRole.ANLAUFSTELLE_VERWALTER, berechAnlaufstVerw);
        /*Berechtigungen für Anlaufstelle Sachbearbeiter*/
        var berechAnlaufstSachbe = new Map();
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        this._map.set(TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER, berechAnlaufstSachbe);
        /*Berechtigungen für Schätzer*/
        var berechAnlaufstSchae = new Map();
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechAnlaufstSchae.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        this._map.set(TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER, berechAnlaufstSchae);
        /*Berechtigungen für FS Sachbearbeiter*/
        var berechFSSachbe = new Map();
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSSachbe.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        this._map.set(TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER, berechFSSachbe);
        /*Berechtigungen für FS Admin*/
        var berechFSAdmin = new Map();
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        this._map.set(TSRole_1.TSRole.FONDSSUISSE_ADMIN, berechFSAdmin);
        /*Berechtigungen für Super Admin*/
        var berechSuperAdmin = new Map();
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechFSAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechSuperAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        this._map.set(TSRole_1.TSRole.SUPER_ADMIN, berechSuperAdmin);
        /*Berechtigungen für Kanton Verwalter*/
        var berechKantonVerw = new Map();
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        this._map.set(TSRole_1.TSRole.KANTON_VERWALTER, berechKantonVerw);
        /*Berechtigungen für Kanton Inspektor*/
        var berechKantonInsp = new Map();
        berechKantonInsp.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonVerw.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, pageNames));
        berechKantonInsp.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechKantonInsp.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechKantonInsp.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechKantonInsp.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechKantonInsp.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechKantonInsp.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechKantonInsp.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechKantonInsp.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechKantonInsp.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.EDIT, pageNames));
        berechKantonInsp.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechKantonInsp.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechKantonInsp.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechKantonInsp.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.READONLY, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        berechKantonInsp.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, new TSBerechtigungInView_1.default(TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.NO_ACCESS, TSBerechtigung_1.TSBerechtigung.READONLY, pageNames));
        this._map.set(TSRole_1.TSRole.KANTON_INSPEKTOR, berechKantonInsp);
    }
    BerechtigungsService.prototype.isStatusReadonlyForRole = function (role, status, pageName) {
        if (role) {
            return this.getBerechtigung(role, status, pageName) !== TSBerechtigung_1.TSBerechtigung.EDIT;
        }
        else {
            this.$log.warn('no role passed. read-only access to ' + pageName);
            return true;
        }
    };
    BerechtigungsService.prototype.isStatusVisibleForRole = function (role, status, pageName) {
        if (role) {
            return this.getBerechtigung(role, status, pageName) !== TSBerechtigung_1.TSBerechtigung.NO_ACCESS;
        }
        else {
            this.$log.warn('no role passed. deny access to ' + pageName);
            return false;
        }
    };
    BerechtigungsService.prototype.getBerechtigung = function (role, status, pageName) {
        if (role) {
            var berechtigungenForRole = this._map.get(role);
            if (berechtigungenForRole) {
                var biv = berechtigungenForRole.get(status);
                if (biv) {
                    return biv.getTSBerechtigung(pageName);
                }
            }
            else {
                this.$log.error('no Access definitions for role ' + role);
            }
        }
        return TSBerechtigung_1.TSBerechtigung.NO_ACCESS;
    };
    BerechtigungsService.$inject = ['$log', 'PAGE_NAMES'];
    return BerechtigungsService;
}());
exports.default = BerechtigungsService;


/***/ }),

/***/ "PCJn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractModelController_1 = __importDefault(__webpack_require__("VDYy"));
var TSRole_1 = __webpack_require__("MleR");
__webpack_require__("fu9Z");
var template = __webpack_require__("a2OR");
var BenutzerEditComponentConfig = /** @class */ (function () {
    function BenutzerEditComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = BenutzerEditViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            benutzer: '<',
        };
    }
    return BenutzerEditComponentConfig;
}());
exports.BenutzerEditComponentConfig = BenutzerEditComponentConfig;
var BenutzerEditViewController = /** @class */ (function (_super) {
    __extends(BenutzerEditViewController, _super);
    /* @ngInject */
    function BenutzerEditViewController($stateParams, $log, errorService, $window, $state, passwordStrengthService, $scope, roleUtilService, $translate, benutzerRS) {
        var _this = _super.call(this, $scope) || this;
        _this.$stateParams = $stateParams;
        _this.$log = $log;
        _this.errorService = errorService;
        _this.$window = $window;
        _this.$state = $state;
        _this.passwordStrengthService = passwordStrengthService;
        _this.roleUtilService = roleUtilService;
        _this.$translate = $translate;
        _this.benutzerRS = benutzerRS;
        _this.viewReadonly = false;
        return _this;
    }
    BenutzerEditViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        this.initialModel = this.benutzer;
        this.model = angular.copy(this.benutzer);
    };
    BenutzerEditViewController.prototype.initModel = function () {
        //unused
        var benutzer = this.initialModel;
        if (benutzer && benutzer.roles.length === 0) {
            //wenn wir keine rollen haben setzen wir mal eine
            benutzer.roles.push(TSRole_1.TSRole.UNASSIGNED_ROLE);
        }
    };
    BenutzerEditViewController.prototype.submit = function () {
        var _this = this;
        if (this.form.$valid && this.benutzer && this.checkEmailRepeated()) {
            this.benutzerRS.createOrUpdateBenutzeraccount(this.benutzer).then(function (storedBenutzer) {
                if (storedBenutzer !== undefined) {
                    if (_this.benutzer.isNew()) {
                        // this.benutzer.passwordData = new TSPasswordData(this.benutzer.email);
                        _this.errorService.addMesageAsInfoWithArgs('BENUTZER_REC_SUCCESS', _this.benutzer.email);
                    }
                    else {
                        if (_this.benutzer.email !== storedBenutzer.email) {
                            _this.errorService.addMesageAsInfoWithArgs('BENUTZER_UPDATE_EMAIL_INFO', _this.benutzer.email);
                        }
                    }
                    _this.benutzer = storedBenutzer;
                    _this.form.$setPristine();
                    _this.form.$setUntouched();
                    _this.$state.go('benutzerverwaltung');
                }
                else {
                    _this.$log.error('could not save new benutzer ' + _this.benutzer);
                }
            });
        }
        else {
            this.$log.debug('Form was not valid');
        }
    };
    BenutzerEditViewController.prototype.cancelBenutzeredit = function () {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('benutzerverwaltung');
    };
    BenutzerEditViewController.prototype.getRoles = function () {
        return this.roleUtilService.getAnlaufstelleSubuserRolesOnly();
    };
    BenutzerEditViewController.prototype.translateRole = function (val) {
        return this.$translate.instant(TSRole_1.rolePrefix() + val);
    };
    BenutzerEditViewController.prototype.checkEmailRepeated = function () {
        var repeatValid = this.benutzer.checkEmailRepeated();
        if (!repeatValid) {
            this.errorService.addMesageAsError('ERROR_EMAIL_SAME');
            return false;
        }
        return true;
    };
    BenutzerEditViewController.$inject = ['$stateParams', '$log', 'ErrorService', '$window', '$state',
        'PasswordStrengthService', '$scope', 'RoleUtilService', '$translate', 'BenutzerRS'];
    return BenutzerEditViewController;
}(abstractModelController_1.default));
exports.BenutzerEditViewController = BenutzerEditViewController;


/***/ }),

/***/ "PJzB":
/***/ (function(module, exports) {

module.exports = " <div class=\"cockpit-view\"> <div ng-class=\"['cockpit-chart-view', 'container', {'container-sticky':sticky}]\"> <div dv-show-allowed-roles=\"vm.roleUtilService.getRolesForCockpit()\" dv-show-element> <div class=\"row cockpit-form\"> <div class=\"col-sm-12\"> <h2 data-translate=\"COCKPIT\"></h2> </div> <form name=\"vm.form\" ng-submit=\"vm.changedCockpitSelect()\" novalidate> <div class=\"row\"> <div class=\"col-sm-12\"> <h3 class=\"marginTop0\"> <span data-translate=\"ZEITBEREICH\"></span> </h3> </div> <div class=\"col-sm-4\"> <dv-input-container> <div class=\"dv-select-style\"> <select class=\"form-control\" id=\"{{vm.prefix}}_cockpitselect\" name=\"cockpitselect\" ng-change=\"vm.changedCockpitSelect()\" ng-model=\"vm.cockpitTypeDTO.cockpitSelect\" ng-options=\"vm.translateCockpitSelectForSelect(cockpitselect) for cockpitselect in vm.getTSCockpitSelect() \" ng-required=\"true\"> </select> </div> </dv-input-container> </div> </div> <div class=\"row\" ng-if=\"vm.displayDatum()\"> <div class=\"col-sm-4\"> <dv-input-container> <label class=\"md-no-float text-capitalize\" data-translate=\"DATUM_VON\" for=\"datumVon\"></label> <dv-datepicker check-future=\"true\" input-id=\"datumVon\" name=\"datumVon\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" ng-model=\"vm.cockpitTypeDTO.datumVon\" ng-required=\"(vm.datumBis!==undefined && vm.datumBis !== null)\"> </dv-datepicker> <dv-error-messages for=\"vm.form.datumVon\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-4\"> <dv-input-container> <label class=\"md-no-float text-capitalize\" data-translate=\"DATUM_BIS\" for=\"datumBis\"></label> <dv-datepicker check-future=\"false\" input-id=\"datumBis\" name=\"datumBis\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" ng-model=\"vm.cockpitTypeDTO.datumBis\" ng-required=\"(vm.datumVon!==undefined && vm.datumVon !== null)\"> </dv-datepicker> <dv-error-messages for=\"vm.form.datumBis\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-xs-3 col-sm-offset-1\"> <dv-loading-button button-class=\"btn btn-serf datum-berich-btn\" type=\"submit\"> <span data-translate=\"ANWENDEN\"></span> </dv-loading-button> </div> </div> </form> </div> <div class=\"cockpit-charts\"> <div class=\"row\"> <div class=\"col-sm-6\"> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3><span data-translate=\"COCKPIT_STATUS_TITLE\"></span></h3> </div> <div class=\"panel-body\"> <dv-pie-charts chartid=\"'statusdataset'\" dataset=\"vm.statusDataset\"></dv-pie-charts> </div> </div> </div> <div class=\"col-sm-6\"> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3><span data-translate=\"COCKPIT_KANTON_TITLE\"></span></h3> </div> <div class=\"panel-body\"> <dv-pie-charts chartid=\"'gesuchekanton'\" dataset=\"vm.gesucheKantonDataset\"></dv-pie-charts> </div> </div> </div> </div> <div class=\"row\"> <div class=\"col-sm-6\"> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3><span data-translate=\"COCKPIT_ERFASSUNGSART_TITLE\"></span></h3> </div> <div class=\"panel-body\"> <dv-pie-charts chartid=\"'gesucheerfassungsart'\" dataset=\"vm.gesucheErfassungsArtDataset\"></dv-pie-charts> </div> </div> </div> <div class=\"col-sm-6\"> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3><span data-translate=\"COCKPIT_ANZAHL_NEUE_GESUCHE\"></span></h3> </div> <div class=\"panel-body\"> <dv-text-value dataset=\"vm.neueGesucheDataset\"></dv-text-value> </div> </div> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3><span data-translate=\"COCKPIT_ANZAHL_GESUCHE\"></span></h3> </div> <div class=\"panel-body\"> <dv-bar-charts chartid=\"'anzahlGesuch'\" dataset=\"vm.anzahlGesucheDataset\"></dv-bar-charts> </div> </div> </div> </div> <div class=\"row\"> <div class=\"col-sm-6\"> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3><span data-translate=\"COCKPIT_SCHADENART_TITLE\"></span></h3> </div> <div class=\"panel-body\"> <dv-pie-charts chartid=\"'schadenartDataset'\" dataset=\"vm.schadenartDataset\"></dv-pie-charts> </div> </div> </div> <div class=\"col-sm-6\"> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3><span data-translate=\"COCKPIT_GESCHAETZTE_KOSTEN_TITLE\"></span></h3> </div> <div class=\"panel-body\"> <dv-pie-charts chartid=\"'geschaetzteKosten'\" dataset=\"vm.geschaetzteKostenDataset\"></dv-pie-charts> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "PQ0J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BemerkungDialogController_1 = __webpack_require__("AtDi");
var OkCancelController_1 = __webpack_require__("r+7B");
var RemoveDialogController_1 = __webpack_require__("92sy");
var TSBeitragStatus_1 = __webpack_require__("RtaT");
var TSBemerkungScope_1 = __webpack_require__("Oh5v");
var TSSchadenfallEvent_1 = __webpack_require__("cKO2");
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var TSBeitrag_1 = __importDefault(__webpack_require__("Bftz"));
var abstractModelManagerController_1 = __importDefault(__webpack_require__("S1yE"));
var styles = __webpack_require__("yEyN");
var template = __webpack_require__("GZC1");
var removeDialogTemplate = __webpack_require__("YTLw");
var bemerkungDialogTemplate = __webpack_require__("APRe");
var okCancelTemplate = __webpack_require__("CYbW");
var EntschaedigungViewComponentConfig = /** @class */ (function () {
    function EntschaedigungViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = EntschaedigungViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            schadenfall: '<'
        };
    }
    return EntschaedigungViewComponentConfig;
}());
exports.EntschaedigungViewComponentConfig = EntschaedigungViewComponentConfig;
var EntschaedigungViewController = /** @class */ (function (_super) {
    __extends(EntschaedigungViewController, _super);
    /* @ngInject */
    function EntschaedigungViewController(dvBernUtil, schadenfallModelManager, $q, $scope, $translate, $log, $state, dvDialog, beitragRS, roleUtilService, statuswechselService, authServiceRS, errorService) {
        var _this = _super.call(this, schadenfallModelManager, $scope, $state.current.name) || this;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$translate = $translate;
        _this.$log = $log;
        _this.$state = $state;
        _this.dvDialog = dvDialog;
        _this.beitragRS = beitragRS;
        _this.roleUtilService = roleUtilService;
        _this.statuswechselService = statuswechselService;
        _this.authServiceRS = authServiceRS;
        _this.errorService = errorService;
        return _this;
    }
    EntschaedigungViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        if (!this.schadenfall.beitraege) {
            this.schadenfall.beitraege = [];
        }
        if (!this.schadenfall) {
            this.$log.error('no schadenfall passed to view');
        }
        else {
            this.initialModel = this.schadenfall;
            this.model = angular.copy(this.schadenfall);
            this.isErmittelterSchadenSet = this.model.ermittelterSchaden !== 0;
        }
        this.statuswechsel = this.statuswechselService.getStatuswechselMetadata(this.schadenfall.status, this.schadenfall.erfassungsart);
    };
    EntschaedigungViewController.prototype.getSchadenName = function (index) {
        return this.$translate.instant('SCHADEN') + ' ' + index;
    };
    EntschaedigungViewController.prototype.resetView = function () {
        this.form.$setPristine();
        this.form.$setUntouched();
    };
    EntschaedigungViewController.prototype.addBeitrag = function () {
        var newBeitrag = new TSBeitrag_1.default();
        var params;
        params = {
            schadenfall: this.schadenfall,
            beitrag: newBeitrag,
            schadenfallId: this.schadenfall.id,
            beitragId: undefined
        };
        this.$state.go('beitrag', params);
    };
    EntschaedigungViewController.prototype.hasBeitraege = function () {
        if (this.schadenfall && this.schadenfall.beitraege && this.schadenfall.beitraege.length > 0) {
            return true;
        }
        return false;
    };
    EntschaedigungViewController.prototype.deleteBeitrag = function (beitrag, event) {
        var _this = this;
        this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController_1.RemoveDialogController, {
            text: '',
            title: 'BEITRAG_LOESCHEN'
        }).then(function () {
            _this.schadenfallModelManager.removeBeitrag(beitrag);
        }).catch(function () {
        });
    };
    EntschaedigungViewController.prototype.getTotal = function () {
        var val = 0;
        this.schadenfall.beitraege.forEach(function (beitrag) {
            val += beitrag.beitrag;
        });
        return val;
    };
    EntschaedigungViewController.prototype.getViewTitle = function () {
        return this.dvBernUtil.getViewTitle(this.schadenfall);
    };
    EntschaedigungViewController.prototype.isFreigabeVisible = function () {
        //maybe extract this out into service?
        if (this.statuswechsel !== undefined) {
            var hasAllowedRole = this.authServiceRS.isOneOfRoles(this.statuswechsel.allowedRoles);
            var isOnRelevantPage = this.statuswechsel.visibleOnPage === this.$state.current.name;
            return hasAllowedRole && isOnRelevantPage && this.getSchadenfallEvents().length !== 0;
        }
        return false;
    };
    EntschaedigungViewController.prototype.getChecklistEntries = function () {
        if (this.statuswechsel !== undefined) {
            return this.statuswechsel.checklistOptions;
        }
        return [];
    };
    EntschaedigungViewController.prototype.getBegrundungscodeOptions = function () {
        if (this.statuswechsel !== undefined) {
            if (this.schadenfallEvent === undefined) {
                console.warn('Should have selected schadenfallEvent to trigger, otherwise allowed begruendugnscodes will not be set)');
                return [];
            }
            else {
                return this.statuswechsel.readBegruendungscodeOptions(this.schadenfallEvent);
            }
        }
        return [];
    };
    EntschaedigungViewController.prototype.getSchadenfallEvents = function () {
        if (this.statuswechsel !== undefined) {
            return this.statuswechsel.possibleEvents;
        }
        return [];
    };
    EntschaedigungViewController.prototype.checklistStatusChanged = function (allchecked) {
        this.checklistValid = allchecked;
        if (!this.checklistValid) {
            this.schadenfallEvent = undefined;
        }
    };
    EntschaedigungViewController.prototype.isFreigabeDisabled = function () {
        return this.checklistValid !== true;
    };
    EntschaedigungViewController.prototype.next = function () {
        this.errorService.clearAll();
        if (this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN) {
            if (this.schadenfall.hasBeitrag() ||
                (!this.schadenfall.hasBeitrag() && this.eventIsRueckweisung())) {
                this.triggerGenericFreigabeDialog();
            }
            else {
                this.errorService.addMesageAsError('ERROR_NO_BEITRAG');
            }
        }
        else {
            this.$log.info('no next state available for this fall in this role');
        }
    };
    EntschaedigungViewController.prototype.eventIsRueckweisung = function () {
        return (this.schadenfallEvent === TSSchadenfallEvent_1.TSSchadenfallEvent.ABRECHNUNG_MANGELHAFT ||
            this.schadenfallEvent === TSSchadenfallEvent_1.TSSchadenfallEvent.ABLEHNUNG);
    };
    EntschaedigungViewController.prototype.triggerGenericFreigabeDialog = function () {
        var _this = this;
        this.dvDialog.showBemerkungDialog(bemerkungDialogTemplate, BemerkungDialogController_1.BemerkungDialogController, {
            text: this.schadenfallEvent,
            begrundungscodeOptions: this.getBegrundungscodeOptions(),
            showBegruendung: true,
            showBemerkung: true
        }).then(function (response) {
            if (response && _this.schadenfallEvent) {
                //todo team mit duncan anschauen wo die bemerkung hin soll
                _this.schadenfallModelManager.handleTransition(_this.schadenfall, TSBemerkungScope_1.TSBemerkungScope.AUFWAENDE, response.begruendung, response.bemerkung, _this.schadenfallEvent)
                    .then(function (response) {
                    //todo wohin denn?
                    _this.$state.go('schadenfaelle');
                });
            }
        }).catch(function () {
        });
    };
    EntschaedigungViewController.prototype.editClicked = function (beitragToView, event) {
        var params;
        params = {
            schadenfall: this.schadenfall,
            beitrag: beitragToView,
            schadenfallId: this.schadenfall.id,
            beitragId: beitragToView.id
        };
        this.$state.go('beitrag', params);
    };
    EntschaedigungViewController.prototype.isAusgefuehrt = function (beitrag) {
        return beitrag.beitragStatus === TSBeitragStatus_1.TSBeitragStatus.AUSGEFUEHRT;
    };
    EntschaedigungViewController.prototype.cannotAddBeitraege = function () {
        return this.isSchadenFallReadonly()
            || !this.isErmittelterSchadenSet
            || this.ermittelterSchadenForm.$invalid
            || this.ermittelterSchadenForm.$dirty;
    };
    EntschaedigungViewController.prototype.saveErmittelterSchaden = function () {
        var _this = this;
        this.errorService.clearAll();
        if (this.ermittelterSchadenForm.$valid && this.model) {
            if (this.model.hasBeitrag() &&
                (this.model.nichtBerechtigterAnteil !== this.initialModel.nichtBerechtigterAnteil ||
                    this.model.ermittelterSchaden !== this.initialModel.nichtBerechtigterAnteil)) {
                this.dvDialog.showDialog(okCancelTemplate, OkCancelController_1.OkCancelController, {
                    title: 'ERMITTELTER_SCHADEN',
                    text: 'ERMITTELTER_SCHADEN_CHANGED_TEXT'
                }).then(function () {
                    // TODO dase
                    // Vielleicht könnte man hier die Beiträge automatisch aktualisieren.
                });
            }
            this.schadenfallModelManager.saveSchadenfall(this.model).then(function (schadResp) {
                _this.initialModel = schadResp;
                _this.model = angular.copy(schadResp);
                _this.schadenfall = schadResp;
                _this.isErmittelterSchadenSet = _this.model.ermittelterSchaden !== 0;
                _this.ermittelterSchadenForm.$setPristine();
            });
        }
    };
    EntschaedigungViewController.$inject = ['DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$log', '$state',
        'DvDialog', 'BeitragRS', 'RoleUtilService', 'StatuswechselService', 'AuthServiceRS', 'ErrorService'];
    return EntschaedigungViewController;
}(abstractModelManagerController_1.default));
exports.EntschaedigungViewController = EntschaedigungViewController;


/***/ }),

/***/ "PSWS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSEigentumsverhaeltnis;
(function (TSEigentumsverhaeltnis) {
    TSEigentumsverhaeltnis[TSEigentumsverhaeltnis["GRUNDEIGENTUEMER"] = 'GRUNDEIGENTUEMER'] = "GRUNDEIGENTUEMER";
    TSEigentumsverhaeltnis[TSEigentumsverhaeltnis["GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER"] = 'GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER'] = "GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER";
    TSEigentumsverhaeltnis[TSEigentumsverhaeltnis["PAECHTER"] = 'PAECHTER'] = "PAECHTER";
    TSEigentumsverhaeltnis[TSEigentumsverhaeltnis["VERSICHERTER"] = 'VERSICHERTER'] = "VERSICHERTER";
    TSEigentumsverhaeltnis[TSEigentumsverhaeltnis["UNBEKANNT"] = 'UNBEKANNT'] = "UNBEKANNT";
})(TSEigentumsverhaeltnis = exports.TSEigentumsverhaeltnis || (exports.TSEigentumsverhaeltnis = {}));
function getTSEigentumsverhaeltnisValues() {
    return [
        TSEigentumsverhaeltnis.GRUNDEIGENTUEMER,
        TSEigentumsverhaeltnis.GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER,
        TSEigentumsverhaeltnis.PAECHTER,
        TSEigentumsverhaeltnis.VERSICHERTER,
        TSEigentumsverhaeltnis.UNBEKANNT,
    ];
}
exports.getTSEigentumsverhaeltnisValues = getTSEigentumsverhaeltnisValues;
function getTSEigentumsverhaeltnisValuesSchadenfall() {
    return [
        TSEigentumsverhaeltnis.GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER,
        TSEigentumsverhaeltnis.PAECHTER,
        TSEigentumsverhaeltnis.GRUNDEIGENTUEMER,
    ];
}
exports.getTSEigentumsverhaeltnisValuesSchadenfall = getTSEigentumsverhaeltnisValuesSchadenfall;
function eigentumsverhaeltnisPrefix() {
    return 'TSEigentumsverhaeltnis_';
}
exports.eigentumsverhaeltnisPrefix = eigentumsverhaeltnisPrefix;


/***/ }),

/***/ "PYvH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2019 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var FilterPersistenceService = /** @class */ (function () {
    /* @ngInject */
    function FilterPersistenceService() {
        this.persistedData = new Map();
    }
    FilterPersistenceService.prototype.persistFilter = function (namespace, filter) {
        this.persistedData.set(namespace, filter);
    };
    FilterPersistenceService.prototype.restoreFilter = function (namespace) {
        return this.persistedData.get(namespace);
    };
    /**
     * Deletes the given namespace from the list if it exists and returns true.
     * If it doesn't exist it returns false
     */
    FilterPersistenceService.prototype.deleteFilter = function (namespace) {
        this.persistedData.delete(namespace);
    };
    FilterPersistenceService.prototype.clearAll = function () {
        this.persistedData = new Map();
    };
    FilterPersistenceService.$inject = [];
    return FilterPersistenceService;
}());
exports.default = FilterPersistenceService;


/***/ }),

/***/ "PaWj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSCockpitResult = /** @class */ (function () {
    function TSCockpitResult() {
    }
    Object.defineProperty(TSCockpitResult.prototype, "label", {
        get: function () {
            return this._label;
        },
        set: function (value) {
            this._label = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSCockpitResult.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    TSCockpitResult.prototype.deserialize = function (restObject) {
        this.label = restObject.label;
        this.value = restObject.value;
        return this;
    };
    return TSCockpitResult;
}());
exports.default = TSCockpitResult;


/***/ }),

/***/ "Pb3x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BemerkungDialogController_1 = __webpack_require__("AtDi");
var OkCancelController_1 = __webpack_require__("r+7B");
var RemoveDialogController_1 = __webpack_require__("92sy");
var TSBemerkungScope_1 = __webpack_require__("Oh5v");
var TSRechtsform_1 = __webpack_require__("EUJE");
var TSRole_1 = __webpack_require__("MleR");
var TSSchadenfallEvent_1 = __webpack_require__("cKO2");
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var TSSchaden_1 = __importDefault(__webpack_require__("k04f"));
var TSSchadenDaten_1 = __importDefault(__webpack_require__("4Vie"));
var TSSchadenfallDaten_1 = __importDefault(__webpack_require__("GUZW"));
var TSSchadenObjektDaten_1 = __importDefault(__webpack_require__("ivjz"));
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
var abstractModelManagerController_1 = __importDefault(__webpack_require__("S1yE"));
var template = __webpack_require__("BCxF");
var removeDialogTemplate = __webpack_require__("YTLw");
var bemerkungDialogTemplate = __webpack_require__("APRe");
var okCancelTemplate = __webpack_require__("CYbW");
var SchadenfallViewComponentConfig = /** @class */ (function () {
    function SchadenfallViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = SchadenfallViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            schadenfall: '<',
        };
    }
    return SchadenfallViewComponentConfig;
}());
exports.SchadenfallViewComponentConfig = SchadenfallViewComponentConfig;
var SchadenfallViewController = /** @class */ (function (_super) {
    __extends(SchadenfallViewController, _super);
    /* @ngInject */
    function SchadenfallViewController(dvBernUtil, schadenfallModelManager, $q, $scope, $translate, $window, $state, dvDialog, authServiceRS, roleUtilService, benutzerRS, anlaufstelleRS, $log, statuswechselService, errorService, dokumenteRS) {
        var _this = _super.call(this, schadenfallModelManager, $scope, $state.current.name) || this;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$translate = $translate;
        _this.$window = $window;
        _this.$state = $state;
        _this.dvDialog = dvDialog;
        _this.authServiceRS = authServiceRS;
        _this.roleUtilService = roleUtilService;
        _this.benutzerRS = benutzerRS;
        _this.anlaufstelleRS = anlaufstelleRS;
        _this.$log = $log;
        _this.statuswechselService = statuswechselService;
        _this.errorService = errorService;
        _this.dokumenteRS = dokumenteRS;
        _this.forms = {};
        _this.scopeToShow = [];
        _this.scope = TSBemerkungScope_1.TSBemerkungScope.SCHADENFALL;
        _this.checklistValid = false;
        _this.ereignisWasSaved = false;
        return _this;
    }
    SchadenfallViewController.prototype.resetView = function () {
        this.form.$setPristine();
        this.form.$setUntouched();
    };
    SchadenfallViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        this.loadSchaden();
        if (!this.schadenfall) {
            console.error('no schadenfall passed to view');
        }
        else {
            this.initialModel = this.schadenfall;
            this.model = angular.copy(this.schadenfall);
        }
        if (!this.model.schadenfallDatenFS) {
            this.model.schadenfallDatenFS = new TSSchadenfallDaten_1.default();
        }
        if (this.model.schadenfallDatenFS.titel != null &&
            this.model.schadenfallDatenFS.gemeinde.name != null) {
            this.ereignisWasSaved = true;
        }
        // Show only Bemerkungen from Scope SCHADENFALL
        this.scopeToShow.push(TSBemerkungScope_1.TSBemerkungScope.SCHADENFALL);
        this.statuswechsel = this.statuswechselService.getStatuswechselMetadata(this.model.status, this.model.erfassungsart);
        this.loadPossibleSchaetzer();
    };
    SchadenfallViewController.prototype.loadSchaden = function () {
        if (!this.hasSchaeden()) {
            this.schadenfall.schaeden[0] = this.createSchaden();
        }
    };
    SchadenfallViewController.prototype.getSchadenName = function (index) {
        return this.$translate.instant('SCHADEN') + ' ' + index;
    };
    SchadenfallViewController.prototype.selectSchaden = function (selected) {
        this.selectedSchaden = this.schadenfall.schaeden[selected];
    };
    SchadenfallViewController.prototype.isSchadenActive = function (index) {
        return true;
    };
    SchadenfallViewController.prototype.getSelectedSchaden = function () {
        return this.selectedSchaden;
    };
    SchadenfallViewController.prototype.createSchaden = function () {
        var schaden = new TSSchaden_1.default();
        schaden.schadenDatenFS = new TSSchadenDaten_1.default();
        schaden.schadenDatenFS.schadenObjektDaten = new TSSchadenObjektDaten_1.default();
        return schaden;
    };
    SchadenfallViewController.prototype.hasSchaeden = function () {
        return this.schadenfall.schaeden && this.schadenfall.schaeden.length > 0;
    };
    /**
     * todo: homa aulsagern
     * Diese Methode prueft ob das Form valid ist. Sollte es nicht valid sein wird das erste fehlende Element gesucht
     * und fokusiert, damit der Benutzer nicht scrollen muss, um den Fehler zu finden.
     * Am Ende wird this.form.$valid zurueckgegeben
     */
    SchadenfallViewController.prototype.isGesuchValid = function () {
        if (this.isSchadenformValid()) {
            if (!this.form.$valid) {
                DVBernUtil_1.default.focusFirstInvalidInput();
            }
            return this.form.$valid;
        }
        return false;
    };
    SchadenfallViewController.prototype.isSchadenformValid = function () {
        //check validity of form and show error messages if invalid
        var form = this.form;
        if (!form.$valid) {
            form.$getControls().forEach(function (control) {
                if ('$validate' in control) {
                    control.$validate();
                }
            });
            form.$setSubmitted();
            DVBernUtil_1.default.focusFirstInvalidInput();
            return false;
        }
        return true;
    };
    SchadenfallViewController.prototype.deleteSchaden = function (schaden, event) {
        var _this = this;
        if (schaden && this.schadenfall) {
            this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController_1.RemoveDialogController, {
                text: '',
                title: 'SCHADEN_LOESCHEN',
            }).then(function () {
                _this.schadenfallModelManager.deleteSchaden(_this.schadenfall, schaden);
            }).catch(function () {
                console.error('error could not delete schaden');
            });
        }
    };
    SchadenfallViewController.prototype.editSchaden = function (schaden, event) {
        var params;
        params = { schadenfallId: this.schadenfall.id, schadenId: schaden.id, schaden: schaden };
        this.$state.go('schaden', params);
    };
    SchadenfallViewController.prototype.isSchadenFallNeuOnline = function (initialModel) {
        var model = initialModel ? this.initialModel : this.model;
        if (model.status) {
            return model.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU; //papier hat neu_papier
        }
        return false;
    };
    SchadenfallViewController.prototype.isSchadenFallNeu = function () {
        if (this.model.status) {
            return TSSchadenfallStatus_1.getTSSchadenfallStatusNeu().includes(this.model.status);
        }
        return false;
    };
    SchadenfallViewController.prototype.beenden = function () {
        var _this = this;
        this.errorService.clearAll();
        if (this.isGesuchValid() && this.model) {
            if (this.isSchadenFallNeuOnline(false)) {
                this.dvDialog.showDialog(okCancelTemplate, OkCancelController_1.OkCancelController, {
                    text: 'SCHADENFALL_BEENDEN_SPEICHERN_TEXT',
                    title: 'SCHADENFALL_BEENDEN_SPEICHERN_TITLE',
                }).then(function () {
                    _this.save();
                });
            }
            else {
                this.save();
            }
        }
    };
    SchadenfallViewController.prototype.save = function () {
        var _this = this;
        this.schadenfallModelManager.saveSchadenfall(this.model).then(function () {
            _this.schadenfallModelManager.saveSchaden(_this.model.schaeden[0]).then(function () {
                _this.resetView();
            });
        });
    };
    SchadenfallViewController.prototype.canLoeschen = function () {
        return (this.authServiceRS.isOneOfRoles(this.roleUtilService.getGesuchstellerOnlyRoles()) &&
            this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU) ||
            (this.authServiceRS.isOneOfRoles(this.roleUtilService.getAnlaufstelleRoleWithAdmins()) &&
                this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE) ||
            (this.authServiceRS.isOneOfRoles(this.roleUtilService.getFondssuisseRoles()) &&
                this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS);
    };
    SchadenfallViewController.prototype.schadenfallloeschen = function () {
        var _this = this;
        if (this.schadenfall) {
            this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController_1.RemoveDialogController, {
                text: 'SCHADENFALL_LOESCHEN_TEXT',
                title: 'SCHADENFALL_LOESCHEN',
            }).then(function () {
                _this.schadenfallModelManager.handleTransition(_this.schadenfall, TSBemerkungScope_1.TSBemerkungScope.SCHADENFALL, undefined, '', TSSchadenfallEvent_1.TSSchadenfallEvent.LOESCHEN)
                    .then(function (response) {
                    _this.$state.go('schadenfaelle');
                });
            }).catch(function () {
                console.error('error could not delete schadenfall');
            });
        }
    };
    SchadenfallViewController.prototype.next = function () {
        this.errorService.clearAll();
        if (this.isGesuchValid() && this.model) {
            if (this.hasSchaeden()) {
                if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getRolesAllowedForAnlaufstellenPruefung()) && this.inBearbeitungAnlaufstelle()) {
                    this.triggerBearbeitungASDialog();
                }
                else if (this.freigebenGS()) {
                    //Freigabe Gesuchsteller
                    this.triggerFreigabedialogGesuchsteller();
                }
                else if (this.freigebenFS()) {
                    //Freigabe FS
                    this.triggerFreigabedialogFS();
                }
                else if (this.freigebenAnlaufstelle()) {
                    //Freigabe Anlaufstelle
                    this.triggerFreigabedialogAnlaufstelle();
                }
                else if (this.isInBearbeitungFSAblehnung()) {
                    //Ablehnung FS fuer Ablehnung
                    this.triggerFreigabedialogFSAblehnung();
                }
                else {
                    this.$log.info('no next state available for this fall in this role');
                }
            }
        }
    };
    SchadenfallViewController.prototype.triggerBearbeitungASDialog = function () {
        //check mindestens ein schaetzer bevor wir dialog oeffnen ,ausserdem sollten die steuerdaten geprueft sein
        if (this.schadenfallEvent === TSSchadenfallEvent_1.TSSchadenfallEvent.ANLAUFSTELLE_BASISPRUEFUNG_OK) {
            if (!this.isSteuerdatenUndSchaetzerSet()) {
                return; //stop
            }
        }
        this.triggerGenericFreigabeDialog();
    };
    SchadenfallViewController.prototype.isSteuerdatenUndSchaetzerSet = function () {
        if (this.schadenfall && (this.schadenfall.schaetzer === undefined || this.schadenfall.schaetzer.length === 0)) {
            this.$log.warn('showing error message because no schaetzer is assigned');
            this.errorService.addMesageAsError('ERROR_NO_SCHAETZER');
            return false;
        }
        else if (this.schadenfall && this.schadenfall.gesuchsteller &&
            this.schadenfall.gesuchsteller.rechtsform !== TSRechtsform_1.TSRechtsform.MEHRPERSONENGESELLSCHAFT &&
            this.schadenfall.gesuchsteller.finanzangaben &&
            !this.schadenfall.gesuchsteller.finanzangaben.steuerdatenGeprueft) {
            //wenn pruefung der steuerdaten nicht ok war
            this.errorService.addMesageAsError('ERROR_NO_STEUERDATENPRUEFUNG');
            return false;
        }
        return true;
    };
    SchadenfallViewController.prototype.triggerAuftragSchaetzerDialog = function () {
        this.triggerGenericFreigabeDialog();
    };
    SchadenfallViewController.prototype.triggerGenericFreigabeDialog = function (params) {
        var _this = this;
        //use passed params or init default
        var dialogParams = params || {
            text: this.schadenfallEvent,
            begrundungscodeOptions: this.getBegrundungscodeOptions(),
            showBegruendung: true,
            showBemerkung: true,
        };
        this.dvDialog.showBemerkungDialog(bemerkungDialogTemplate, BemerkungDialogController_1.BemerkungDialogController, dialogParams).then(function (response) {
            if (response && _this.schadenfallEvent) {
                _this.schadenfallModelManager.handleTransition(_this.model, TSBemerkungScope_1.TSBemerkungScope.SCHADENFALL, response.begruendung, response.bemerkung, _this.schadenfallEvent)
                    .then(function (response) {
                    _this.resetView();
                    var schadenfallIdParam = { schadenfallId: _this.model.id };
                    _this.$state.go('schaetzung', schadenfallIdParam);
                });
            }
        }).catch(function () {
        });
    };
    SchadenfallViewController.prototype.triggerFreigabedialogGesuchsteller = function () {
        var _this = this;
        this.dvDialog.showBemerkungDialog(bemerkungDialogTemplate, BemerkungDialogController_1.BemerkungDialogController, {
            text: 'FREIGABE_BEMERKUNG_GESUCHSTELLER_TEXT',
            begrundungscodeOptions: this.getBegrundungscodeOptions(),
            showBegruendung: false,
            showBemerkung: false,
        }).then(function (response) {
            if (response) {
                _this.schadenfallModelManager.handleTransition(_this.model, TSBemerkungScope_1.TSBemerkungScope.SCHADENFALL, response.begruendung, response.bemerkung, TSSchadenfallEvent_1.TSSchadenfallEvent.GESUCH_DURCH_BEROFFENER_FREIGEGEBEN)
                    .then(function (response) {
                    _this.resetView();
                    _this.$state.go('abschluss', { schadenfallId: _this.model.id });
                });
            }
        }).catch(function () {
        });
    };
    SchadenfallViewController.prototype.triggerFreigabedialogAnlaufstelle = function () {
        var _this = this;
        this.dvDialog.showBemerkungDialog(bemerkungDialogTemplate, BemerkungDialogController_1.BemerkungDialogController, {
            text: 'FREIGABE_BEMERKUNG_ANLAUFSTELLE_TEXT',
            showBegruendung: false,
            showBemerkung: false,
        }).then(function (response) {
            if (response) {
                _this.schadenfallModelManager.handleTransition(_this.model, TSBemerkungScope_1.TSBemerkungScope.SCHADENFALL, response.begruendung, response.bemerkung, TSSchadenfallEvent_1.TSSchadenfallEvent.PAPIERGESUCH_DURCH_ANLAUFSTELLE_FREIGEGEBEN)
                    .then(function (response) {
                    _this.resetView();
                    _this.$state.go('schadenfaelle');
                });
            }
        }).catch(function () {
        });
    };
    SchadenfallViewController.prototype.triggerFreigabedialogFS = function () {
        //check mindestens ein schaetzer bevor wir dialog oeffnen ,ausserdem sollten die steuerdaten geprueft sein
        if (this.schadenfallEvent === TSSchadenfallEvent_1.TSSchadenfallEvent.FREIGABE_PAPIER_FS_6) {
            if (!this.isSteuerdatenUndSchaetzerSet()) {
                return; //stop
            }
        }
        this.triggerGenericFreigabeDialog({
            text: this.schadenfallEvent,
            showBegruendung: false,
            showBemerkung: false,
        });
    };
    SchadenfallViewController.prototype.triggerFreigabedialogFSAblehnung = function () {
        this.triggerGenericFreigabeDialog();
    };
    SchadenfallViewController.prototype.getViewTitle = function () {
        return this.dvBernUtil.getViewTitle(this.model);
    };
    SchadenfallViewController.prototype.inBearbeitungAnlaufstelle = function () {
        //ANLAUFSTELLE_BASISPRUEFUNG_OK
        return this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE;
    };
    SchadenfallViewController.prototype.getChecklistEntries = function () {
        if (this.statuswechsel !== undefined) {
            return this.statuswechsel.checklistOptions;
        }
        return [];
    };
    SchadenfallViewController.prototype.getBegrundungscodeOptions = function () {
        if (this.statuswechsel !== undefined) {
            if (this.schadenfallEvent === undefined) {
                console.warn('Should have selected schadenfallEvent to trigger, otherwise allowed begruendugnscodes will not be set)');
                return [];
            }
            else {
                return this.statuswechsel.readBegruendungscodeOptions(this.schadenfallEvent);
            }
        }
        return [];
    };
    SchadenfallViewController.prototype.getSchadenfallEvents = function () {
        if (this.statuswechsel !== undefined) {
            return this.statuswechsel.possibleEvents;
        }
        return [];
    };
    SchadenfallViewController.prototype.isFreigabeVisible = function () {
        //this could maybe be extracted to the service
        if (this.statuswechsel !== undefined) {
            var hasAllowedRole = this.authServiceRS.isOneOfRoles(this.statuswechsel.allowedRoles);
            var isOnRelevantPage = this.statuswechsel.visibleOnPage === this.$state.current.name;
            return hasAllowedRole && isOnRelevantPage && this.getSchadenfallEvents().length !== 0;
        }
        return false;
    };
    SchadenfallViewController.prototype.isFreigabeDisabled = function () {
        return this.checklistValid !== true;
    };
    SchadenfallViewController.prototype.freigebenGS = function () {
        return this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU;
    };
    SchadenfallViewController.prototype.freigebenAnlaufstelle = function () {
        return this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE;
    };
    SchadenfallViewController.prototype.freigebenFS = function () {
        return this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS;
    };
    SchadenfallViewController.prototype.isInBearbeitungFSAblehnung = function () {
        return this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS;
    };
    SchadenfallViewController.prototype.checklistStatusChanged = function (allchecked) {
        this.checklistValid = allchecked;
        if (!this.checklistValid) {
            this.schadenfallEvent = undefined;
        }
    };
    SchadenfallViewController.prototype.showManuelleAnlaufstellenZuweisungFS = function () {
        return this.model.status === TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS;
    };
    SchadenfallViewController.prototype.showSchaetzerZuweisung = function () {
        return (this.schadenfall.status !== TSSchadenfallStatus_1.TSSchadenfallStatus.NEU && this.schadenfall.status !== TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE) &&
            this.isSchadenFallVisible() && this.isEreignisSaved();
    };
    SchadenfallViewController.prototype.loadPossibleSchaetzer = function () {
        var _this = this;
        if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getAllowedToCreatePapierSchadenfallRoles())) {
            if (this.schadenfall && this.schadenfall.anlaufstelle) {
                this.anlaufstelleRS.getBenutzerOfAnlaufstelle(this.schadenfall.anlaufstelle.id, TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER).then(function (response) {
                    _this.possibleSchaetzer = response;
                });
            }
            else {
                this.$log.debug('Not loading possible schaetzer because there is no anlaufstelle set', this.schadenfall);
            }
        }
    };
    SchadenfallViewController.prototype.getAvailableSchaezter = function () {
        var _this = this;
        if (this.possibleSchaetzer !== undefined) {
            return this.possibleSchaetzer.filter(function (user) {
                if (_this.schadenfall.schaetzer && _this.schadenfall.schaetzer.length !== 0) {
                    var index = DVBernUtil_1.default.getIndexOfElementwithID(user, _this.schadenfall.schaetzer);
                    return index === -1;
                }
                return true;
            });
        }
        return [];
    };
    SchadenfallViewController.prototype.getSchadenfallStatusList = function () {
        return TSSchadenfallStatus_1.getTSSchadenfallStatusalues();
    };
    SchadenfallViewController.prototype.addSchaetzer = function () {
        var _this = this;
        if (this.selectedSchaetzer !== undefined) {
            this.schadenfallModelManager.addSchaetzer(this.selectedSchaetzer).then(function (response) {
                _this.selectedSchaetzer = undefined;
            });
        }
    };
    SchadenfallViewController.prototype.removeSchaetzer = function (benutzer, event) {
        if (this.schadenfall.schaetzer && this.schadenfall.schaetzer.length !== 0) {
            this.schadenfallModelManager.removeSchaetzer(benutzer).then(function (response) {
            });
        }
    };
    SchadenfallViewController.prototype.updateStatus = function () {
        var _this = this;
        this.errorService.clearAll();
        this.dvDialog.showDialog(okCancelTemplate, OkCancelController_1.OkCancelController, {
            title: 'STATUS_AKTUALISIEREN',
            text: 'STATUS_AKTUALISIEREN_TEXT',
        }).then(function () {
            _this.schadenfallModelManager.updateStatus(_this.model.status).then(function (schadResp) {
                _this.initialModel = schadResp;
                _this.model = angular.copy(schadResp);
                _this.schadenfall = schadResp;
            });
        });
    };
    SchadenfallViewController.prototype.displayEreignisButtonForFS = function () {
        return !(this.authServiceRS.isOneOfRoles(this.roleUtilService.getGesuchstellerOnlyRoles()));
    };
    SchadenfallViewController.prototype.displayEreignisButtonForGesuchsteller = function () {
        return (this.authServiceRS.isOneOfRoles(this.roleUtilService.getGesuchstellerOnlyRoles()));
    };
    SchadenfallViewController.prototype.isEreignisSaved = function () {
        return this.ereignisWasSaved;
    };
    SchadenfallViewController.prototype.isOnlyOneSchadenVorhanden = function () {
        return this.model.schaeden.length <= 1;
    };
    SchadenfallViewController.$inject = [
        'DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$window', '$state',
        'DvDialog', 'AuthServiceRS', 'RoleUtilService', 'BenutzerRS', 'AnlaufstelleRS', '$log', 'StatuswechselService', 'ErrorService', 'DokumenteRS',
    ];
    return SchadenfallViewController;
}(abstractModelManagerController_1.default));
exports.SchadenfallViewController = SchadenfallViewController;


/***/ }),

/***/ "Pbbb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAdresse_1 = __importDefault(__webpack_require__("aL5m"));
var TSInspektorat_1 = __importDefault(__webpack_require__("6bjF"));
var TSPasswordData_1 = __importDefault(__webpack_require__("3CBU"));
inspektoratverwaltungRun.$inject = ['RouterHelper'];
/* @ngInject */
function inspektoratverwaltungRun(routerHelper) {
    routerHelper.configureStates(getStates());
}
exports.inspektoratverwaltungRun = inspektoratverwaltungRun;
function getStates() {
    return [
        new SerfInspektoratVerwaltungState(),
        new SerfInspektoratState()
    ];
}
var SerfInspektoratVerwaltungState = /** @class */ (function () {
    function SerfInspektoratVerwaltungState() {
        this.name = 'inspektoratverwaltung';
        this.template = '<dv-inspektoratverwaltung-view inspektorat="$resolve.inspektoratList"></dv-inspektoratverwaltung-view>';
        this.url = '/inspektoratverwaltung/';
        this.resolve = {
            inspektoratList: loadInspektorat,
        };
        this.params = {};
    }
    return SerfInspektoratVerwaltungState;
}());
exports.SerfInspektoratVerwaltungState = SerfInspektoratVerwaltungState;
var SerfInspektoratState = /** @class */ (function () {
    function SerfInspektoratState() {
        this.name = 'inspektorat';
        this.template = '<dv-inspektorat-view inspektorat="$resolve.inspektorat"></dv-inspektorat-view>';
        this.url = '/inspektorat/:inspektoratId';
        this.resolve = {
            inspektorat: getInspektorat
        };
        this.params = { createNew: null, inspektorat: null, inspektoratId: null };
    }
    return SerfInspektoratState;
}());
exports.SerfInspektoratState = SerfInspektoratState;
var IInspektoratStateParams = /** @class */ (function () {
    function IInspektoratStateParams() {
    }
    return IInspektoratStateParams;
}());
exports.IInspektoratStateParams = IInspektoratStateParams;
var IInspektoratVerwaltungParams = /** @class */ (function () {
    function IInspektoratVerwaltungParams() {
    }
    return IInspektoratVerwaltungParams;
}());
exports.IInspektoratVerwaltungParams = IInspektoratVerwaltungParams;
loadSiteKey.$inject = ['ApplicationPropertyRS'];
function loadSiteKey(ApplicationPropertyRS) {
    return ApplicationPropertyRS.getRecaptchaSiteKey();
}
exports.loadSiteKey = loadSiteKey;
loadInspektorat.$inject = ['InspektoratRS', 'AuthServiceRS', 'BenutzerRS', 'RoleUtilService', '$q'];
function loadInspektorat(InspektoratRS, AuthServiceRS, BenutzerRS, RoleUtilService, $q) {
    if (AuthServiceRS.isOneOfRoles(RoleUtilService.getAdministratorRoles())) {
        return InspektoratRS.getAllInspektorat();
    }
    else if (AuthServiceRS.isOneOfRoles(RoleUtilService.getInspektoratVerwalterRoles())) {
        var principal = AuthServiceRS.getPrincipal();
        if (principal) {
            return BenutzerRS.getInspektoratForBenutzer(principal.id);
        }
    }
    return $q.when([]);
}
exports.loadInspektorat = loadInspektorat;
getInspektorat.$inject = ['$stateParams', '$q', 'InspektoratRS', '$log'];
var createInspektorat = function () {
    var inspektorat = new TSInspektorat_1.default();
    inspektorat.adresse = new TSAdresse_1.default();
    inspektorat.verwalter = undefined;
    inspektorat.anlaufstellen = [];
    inspektorat.inspektoren = [];
    return inspektorat;
};
function getInspektorat($stateParams, $q, inspektoratRS, log) {
    var _this = this;
    if ($stateParams) {
        var inspektoratIdParam = $stateParams.inspektoratId;
        var passedInspektorat = $stateParams.inspektorat;
        var createNew = $stateParams.createNew;
        if (createNew) {
            return $q.when(createInspektorat());
        }
        if (passedInspektorat) {
            return $q.when(passedInspektorat);
        }
        if (inspektoratIdParam) {
            return inspektoratRS.findInspektorat(inspektoratIdParam).then(function (response) {
                if (response !== undefined && response.verwalter !== undefined) {
                    response.verwalter.passwordData = new TSPasswordData_1.default(response.verwalter.email);
                    return response;
                }
                else {
                    return _this.$q.when(createInspektorat());
                }
            });
        }
    }
    log.error('Can`t open requested inspektorat. Creating a new inspektorat object' + $stateParams);
    var deferred = $q.defer();
    deferred.resolve(createInspektorat());
    return deferred.promise;
}
exports.getInspektorat = getInspektorat;


/***/ }),

/***/ "Pcuo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("bjNA");
var DvTextValueComponentConfig = /** @class */ (function () {
    function DvTextValueComponentConfig() {
        this.transclude = false;
        this.bindings = {
            dataset: '<'
        };
        this.template = __webpack_require__("rFzF");
        this.controller = DvTextValueController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return DvTextValueComponentConfig;
}());
exports.DvTextValueComponentConfig = DvTextValueComponentConfig;
var DvTextValueController = /** @class */ (function () {
    function DvTextValueController() {
    }
    DvTextValueController.prototype.$onInit = function () {
    };
    DvTextValueController.$inject = [];
    return DvTextValueController;
}());
exports.DvTextValueController = DvTextValueController;


/***/ }),

/***/ "PnIR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSErrorLevel_1 = __webpack_require__("92KJ");
var TSErrorType_1 = __webpack_require__("NSBJ");
var TSExceptionReport = /** @class */ (function () {
    /**
     *
     * @param type Type of the Error
     * @param severity Severity of the Error
     * @param msgKey This is the message key of the error. can also be the message itself
     * @param args
     */
    function TSExceptionReport(type, severity, msgKey, args) {
        this._type = type || undefined;
        this._severity = severity || undefined;
        this._msgKey = msgKey;
        this._argumentList = args || [];
    }
    TSExceptionReport.prototype.isConstantValue = function (constant, value) {
        var keys = Object.keys(constant);
        for (var i = 0; i < keys.length; i++) {
            if (value === constant[keys[i]]) {
                return true;
            }
        }
        return false;
    };
    TSExceptionReport.prototype.isValid = function () {
        var validType = this.isConstantValue(TSErrorType_1.TSErrorType, this.type);
        var validSeverity = this.isConstantValue(TSErrorLevel_1.TSErrorLevel, this.severity);
        var validMsgKey = typeof this.msgKey === 'string' && this.msgKey.length > 0;
        return validType && validSeverity && validMsgKey;
    };
    ;
    TSExceptionReport.prototype.isInternal = function () {
        return this.type === TSErrorType_1.TSErrorType.INTERNAL;
    };
    ;
    Object.defineProperty(TSExceptionReport.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (value) {
            this._type = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSExceptionReport.prototype, "severity", {
        get: function () {
            return this._severity;
        },
        set: function (value) {
            this._severity = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSExceptionReport.prototype, "msgKey", {
        get: function () {
            return this._msgKey;
        },
        set: function (value) {
            this._msgKey = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSExceptionReport.prototype, "exceptionName", {
        get: function () {
            return this._exceptionName;
        },
        set: function (value) {
            this._exceptionName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSExceptionReport.prototype, "methodName", {
        get: function () {
            return this._methodName;
        },
        set: function (value) {
            this._methodName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSExceptionReport.prototype, "translatedMessage", {
        get: function () {
            return this._translatedMessage;
        },
        set: function (value) {
            this._translatedMessage = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSExceptionReport.prototype, "customMessage", {
        get: function () {
            return this._customMessage;
        },
        set: function (value) {
            this._customMessage = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSExceptionReport.prototype, "errorCodeEnum", {
        get: function () {
            return this._errorCodeEnum;
        },
        set: function (value) {
            this._errorCodeEnum = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSExceptionReport.prototype, "stackTrace", {
        get: function () {
            return this._stackTrace;
        },
        set: function (value) {
            this._stackTrace = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSExceptionReport.prototype, "argumentList", {
        get: function () {
            return this._argumentList;
        },
        set: function (value) {
            this._argumentList = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSExceptionReport.prototype, "path", {
        get: function () {
            return this._path;
        },
        set: function (value) {
            this._path = value;
        },
        enumerable: true,
        configurable: true
    });
    TSExceptionReport.createFromViolation = function (constraintType, message, path, value) {
        var report = new TSExceptionReport(TSErrorType_1.TSErrorType.VALIDATION, TSErrorLevel_1.TSErrorLevel.SEVERE, message, value);
        report.path = path;
        //hint: here we could also pass along the path to the Exception Report
        return report;
    };
    TSExceptionReport.createClientSideError = function (severity, msgKey, args) {
        var report = new TSExceptionReport(TSErrorType_1.TSErrorType.CLIENT_SIDE, severity, msgKey, args);
        return report;
    };
    /**
     * takes a data Object that matches the fields of a ExceptionReport and transforms them to a TSExceptionReport.
     * @param data
     * @returns {TSExceptionReport}
     */
    TSExceptionReport.createFromExceptionReport = function (data) {
        var msgToDisp = data.translatedMessage || data.customMessage || 'ERROR_UNEXPECTED_DVB_RUNTIME';
        if (data.translatedMessage && data.customMessage) {
            msgToDisp = msgToDisp + ' - ' + data.customMessage;
        }
        var exceptionReport = new TSExceptionReport(TSErrorType_1.TSErrorType.BADREQUEST, TSErrorLevel_1.TSErrorLevel.SEVERE, msgToDisp, data.argumentList);
        exceptionReport.errorCodeEnum = data.errorCodeEnum;
        exceptionReport.exceptionName = data.exceptionName;
        exceptionReport.methodName = data.methodName;
        exceptionReport.stackTrace = data.stackTrace;
        exceptionReport.translatedMessage = msgToDisp;
        exceptionReport.customMessage = data.customMessage;
        exceptionReport.argumentList = data.argumentList;
        return exceptionReport;
    };
    return TSExceptionReport;
}());
exports.default = TSExceptionReport;


/***/ }),

/***/ "Q+7X":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2020 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */", ""]);

// exports


/***/ }),

/***/ "Q2bv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSCockpitType;
(function (TSCockpitType) {
    TSCockpitType[TSCockpitType["STATUS"] = 'STATUS'] = "STATUS";
    TSCockpitType[TSCockpitType["ANZAHL_GESUCHE"] = 'ANZAHL_GESUCHE'] = "ANZAHL_GESUCHE";
    TSCockpitType[TSCockpitType["NEUE_GESUCHE"] = 'NEUE_GESUCHE'] = "NEUE_GESUCHE";
    TSCockpitType[TSCockpitType["GESUCHE_KANTON"] = 'GESUCHE_KANTON'] = "GESUCHE_KANTON";
    TSCockpitType[TSCockpitType["GESUCHE_ERFASSUNGSART"] = 'GESUCHE_ERFASSUNGSART'] = "GESUCHE_ERFASSUNGSART";
    TSCockpitType[TSCockpitType["SCHADENART"] = 'SCHADENART'] = "SCHADENART";
    TSCockpitType[TSCockpitType["GESCHAETZTE_KOSTEN"] = 'GESCHAETZTE_KOSTEN'] = "GESCHAETZTE_KOSTEN";
})(TSCockpitType = exports.TSCockpitType || (exports.TSCockpitType = {}));
function getTSCockpitSelectValues() {
    return [
        TSCockpitType.STATUS,
        TSCockpitType.ANZAHL_GESUCHE,
        TSCockpitType.NEUE_GESUCHE,
        TSCockpitType.GESUCHE_KANTON,
        TSCockpitType.GESUCHE_ERFASSUNGSART,
        TSCockpitType.SCHADENART,
        TSCockpitType.GESCHAETZTE_KOSTEN,
    ];
}
exports.getTSCockpitSelectValues = getTSCockpitSelectValues;
function cockpitSelectPrefix() {
    return 'TSCockpitSelect_';
}
exports.cockpitSelectPrefix = cockpitSelectPrefix;


/***/ }),

/***/ "Q2lU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DVRoleElementController_1 = __webpack_require__("JWBy");
/**
 * Attribute Directive um Elementen aus- und einblenden.
 * Die Direktive muss folgendermasse benutzt werden:
 *     dv-show-element - diese Attribute muss in jedem Element gesetzt werden, das die Direktive braucht
 *     dv-show-allowed-roles="[vm.TSRole.X, vm.TSRole.Y, ...]" - Array mit allen Rollen, für die das Element eingeblendet werden muss. Um diese Syntax
 *                                                          zu verwenden, muss der Kontroller eine Subklasse von AbstractGesuchViewController sein.
 *                                                          Diese Attribute ist pflicht, darf aber auch auch ein leeres Array sein. Man kann auch eine
 *                                                          Methode oder eine Variable uebergeben
 *     dv-show-expression - optionale Attribute, mit der man einen extra boolean Wert uebergeben kann. Man kann auch eine
 *                          Methode oder eine Variable uebergeben
 *
 * ACHTUNG! Diese Direktive darf nicht mit ng-if zusammen benutzt werden
 */
var DVShowElement = /** @class */ (function () {
    /* @ngInject */
    function DVShowElement(ngIfDirective) {
        var _this = this;
        this.ngIfDirective = ngIfDirective;
        this.restrict = 'A';
        this.controller = DVRoleElementController_1.DVRoleElementController;
        this.replace = true;
        this.link = function (scope, element, attributes, controller, $transclude) {
            // Copy arguments to new array to avoid: The 'arguments' object cannot be referenced in an arrow function in ES3 and ES5.
            // Consider using a standard function expression.
            var arguments2 = [scope, element, attributes, controller, $transclude];
            _this.callNgIfThrough(attributes, controller, arguments2);
            // Die Version mit attributes.$observe funktioniert nicht. Als Wert bekommen wir immer ein string mit dem Namen der Variable, den wir
            // danach evaluieren muessen. Da dieser String sich nie aendert (sondern eher seine evaluation), wird das observe nie aufgerufen. Mit scope.$watch
            // funktioniert es weil die Variable immer transcluded wird und somit der Wert aendert sich.
            scope.$watch(attributes['dvShowAllowedRoles'], function (newValue, oldValue, scope) {
                controller.dvAllowedRoles = newValue;
            }, true);
            scope.$watch(attributes['dvShowExpression'], function (newValue, oldValue) {
                controller.dvExpression = newValue;
            }, true);
        };
        this.ngIf = ngIfDirective[0];
        this.transclude = this.ngIf.transclude;
        this.priority = this.ngIf.priority;
        this.terminal = this.ngIf.terminal;
    }
    /**
     * Diese Methode darf nur einmal aufgerufen werden.
     * VORSICHT. Sollte diese Methode X-Mal aufgerufen werden, wird das Element dann X-Mall angezeigt
     * @param attributes
     * @param controller
     * @param arguments2
     */
    DVShowElement.prototype.callNgIfThrough = function (attributes, controller, arguments2) {
        attributes.ngIf = function () {
            return (controller.checkValidity());
        };
        this.ngIf.link.apply(this.ngIf, arguments2);
    };
    DVShowElement.factory = function () {
        var directive = function (ngIfDirective) { return new DVShowElement(ngIfDirective); };
        directive.$inject = ['ngIfDirective'];
        return directive;
    };
    DVShowElement.$inject = ['ngIfDirective'];
    return DVShowElement;
}());
exports.DVShowElement = DVShowElement;


/***/ }),

/***/ "QJYW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSVersionCheckEvent;
(function (TSVersionCheckEvent) {
    TSVersionCheckEvent[TSVersionCheckEvent["VERSION_MATCH"] = 'VERSION_MATCH'] = "VERSION_MATCH";
    TSVersionCheckEvent[TSVersionCheckEvent["VERSION_MISMATCH"] = 'VERSION_MISMATCH'] = "VERSION_MISMATCH";
})(TSVersionCheckEvent = exports.TSVersionCheckEvent || (exports.TSVersionCheckEvent = {}));


/***/ }),

/***/ "QKwI":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "QMRd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Constants class mit den Namen der States der verschiedenen pages (mehrheitlich des Gesuchswizard).
 */
var PageNameConstants = /** @class */ (function () {
    function PageNameConstants() {
        this.BEMERKUNG = 'bemerkung';
        this.GESUCHERSTELLEN = 'gesucherstellen';
        this.SCHADENMELDUNG = 'schadenmeldung';
        this.SCHADEN = 'schaden';
        this.ABSCHLUSS = 'abschluss';
        this.AUFWAENDE = 'aufwaende';
        this.SCHAETZUNG = 'schaetzung';
        this.EIGENLEISTUNGEN = 'eigenleistungen';
        this.VORLEISTUNG = 'vorleistung';
        this.FREMDKOSTEN = 'fremdkosten';
        this.ENTSCHAEDIGUNG = 'entschaedigung';
        this.BEITRAG = 'beitrag';
        this.VERSICHERUNGSBEITRAGSCHADEN = 'versicherungsbeitragschaden';
        this.BANKKONTO = 'bankkonto';
    }
    return PageNameConstants;
}());
exports.PageNameConstants = PageNameConstants;


/***/ }),

/***/ "QbT7":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "dv-zahlungen-list .header-row{white-space:nowrap}dv-zahlungen-list:focus{outline:none}dv-zahlungen-list .beitraggrundrow{border:none;background-color:#dfdfdf;height:16px}dv-zahlungen-list .beitraggrundrow>td{height:16px!important;line-height:16px!important}dv-zahlungen-list .checkbox-alle{min-width:65px;margin-top:-11px}dv-zahlungen-list .checkbox-alle label input[type=checkbox]+span:before{margin-right:-49px}dv-zahlungen-list .checkbox-alle label input[type=checkbox]+span{padding:24px}dv-zahlungen-list .checkbox-alle label input[type=checkbox]:checked+span:after{left:28px;top:28px}dv-zahlungen-list .right{text-align:right}dv-zahlungen-list .checkbox-intable{margin-top:-2px;margin-right:-8px}", ""]);

// exports


/***/ }),

/***/ "Qf4C":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("DVWU");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-input-container.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-input-container.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Qj30":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "Qm3r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
benutzerverwaltungRun.$inject = ['RouterHelper'];
/* @ngInject */
function benutzerverwaltungRun(routerHelper) {
    routerHelper.configureStates(getStates());
}
exports.benutzerverwaltungRun = benutzerverwaltungRun;
function getStates() {
    return [
        {
            //deprecated
            name: 'benutzerverwaltunganlaufstelle',
            template: '<dv-benutzerverwaltung-anlaufstelle-view benutzer-to-show="$resolve.benutzerList" allowed-anlaufstellen="$resolve.anlaufstelleList"></dv-benutzerverwaltung-anlaufstelle-view>',
            url: '/benutzerverwaltunganlaufstelle',
            resolve: {
                anlaufstelleList: loadAnlaufstellen,
                benutzerList: loadBenutzerOfAnlaufstelle
            }
        },
        {
            name: 'benutzereditanlaufstelle',
            template: '<dv-benutzeredit-anlaufstelle-view  anlaufstelle="$resolve.anlaufstelle" '
                + 'benutzer="$resolve.benutzer" '
                + 'sachbearbeiter-list="$resolve.sachbearbeiterList" schaetzer-list="$resolve.schaetzerList"></dv-benutzeredit-anlaufstelle-view>',
            url: '/anlaufstelle/:anlaufstelleId/benutzeredit/:benutzerId',
            resolve: {
                anlaufstelle: loadAnlaufstelle,
                benutzer: loadAnlaufstelleBenutzer,
            },
            params: { benutzer: null, benutzerId: null, anlaufstelleId: null }
        },
        {
            name: 'benutzerverwaltung',
            template: '<dv-benutzer-list-view  benutzer-to-show="$resolve.benutzer" </dv-benutzer-list-view>',
            url: '/benutzerverwaltung',
            resolve: {
                benutzer: loadAdvancedBenutzers,
            },
        },
        {
            name: 'benutzeredit',
            template: '<dv-benutzeredit-view  benutzer="$resolve.benutzer" </dv-benutzeredit-view>',
            url: '/benutzerverwaltung/:benutzerId',
            resolve: {
                benutzer: loadBenutzerToEdit,
            },
            params: { benutzer: null, benutzerId: null }
        },
        {
            name: 'benutzerregistrierung',
            template: '<benutzer-reg-view site-key="$resolve.siteKey"></benutzer-reg-view>',
            url: '/benutzerregistrierung',
            resolve: {
                siteKey: loadSiteKey
            }
        },
        {
            name: 'profile',
            template: '<dv-benutzerprofil-view  benutzer="$resolve.benutzer" </dv-benutzeredit-view>',
            url: '/profile',
            resolve: {
                benutzer: loadBenutzerForProfile,
            }
        },
    ];
}
loadSiteKey.$inject = ['ApplicationPropertyRS'];
function loadSiteKey(ApplicationPropertyRS) {
    return ApplicationPropertyRS.getRecaptchaSiteKey();
}
exports.loadSiteKey = loadSiteKey;
loadAnlaufstellen.$inject = ['BenutzerRS', 'AnlaufstelleRS', 'AuthServiceRS', 'RoleUtilService', '$q'];
function loadAnlaufstellen(BenutzerRS, AnlaufstelleRS, AuthServiceRS, RoleUtilService, $q) {
    //admins may view all anlaufstellen
    if (AuthServiceRS.isOneOfRoles(RoleUtilService.getAdministratorRoles())) {
        return AnlaufstelleRS.getAllAnlaufstellen();
        //anlaufstellenuser may view just one
    }
    else if (AuthServiceRS.isOneOfRoles(RoleUtilService.getAnlaufstelleVerwalterOnlyRole())) {
        var principal = AuthServiceRS.getPrincipal();
        if (principal) {
            return BenutzerRS.getAnlaufstellenForBenutzer(principal.id);
        }
    }
    return $q.when([]);
}
exports.loadAnlaufstellen = loadAnlaufstellen;
loadAnlaufstelle.$inject = ['$stateParams', 'AnlaufstelleRS', '$q'];
function loadAnlaufstelle($stateParams, AnlaufstelleRS, $q) {
    if ($stateParams.anlaufstelleId) {
        return AnlaufstelleRS.findAnlaufstelle($stateParams.anlaufstelleId);
    }
    return $q.when(undefined);
}
exports.loadAnlaufstelle = loadAnlaufstelle;
loadBenutzerOfAnlaufstelle.$inject = ['BenutzerRS', 'AnlaufstelleRS', 'AuthServiceRS', 'RoleUtilService', '$q'];
function loadBenutzerOfAnlaufstelle(BenutzerRS, AnlaufstelleRS, AuthServiceRS, RoleUtilService, $q) {
    //load the list of users of the first anlaufstelle we are permitted to view
    return loadAnlaufstellen(BenutzerRS, AnlaufstelleRS, AuthServiceRS, RoleUtilService, $q).then(function (allowedAnlaufstellen) {
        if (allowedAnlaufstellen.length !== 0) {
            return AnlaufstelleRS.getBenutzerOfAnlaufstelle(allowedAnlaufstellen[0].id);
        }
        else {
            return $q.when([]);
        }
    });
}
exports.loadBenutzerOfAnlaufstelle = loadBenutzerOfAnlaufstelle;
loadAdvancedBenutzers.$inject = ['BenutzerRS', 'AuthServiceRS', 'RoleUtilService', '$q'];
function loadAdvancedBenutzers(BenutzerRS, AuthServiceRS, RoleUtilService, $q) {
    //load the list of users
    return BenutzerRS.loadAdvancedBenutzer();
}
exports.loadAdvancedBenutzers = loadAdvancedBenutzers;
loadAnlaufstelleBenutzer.$inject = ['$stateParams', 'AnlaufstelleRS', '$q', '$log'];
function loadAnlaufstelleBenutzer($stateParams, AnlaufstelleRS, $q, $log) {
    if ($stateParams) {
        var anlaufstelleId = $stateParams.anlaufstelleId;
        var benutzerId_1 = $stateParams.benutzerId;
        var passedBenutzer = $stateParams.benutzer;
        if (passedBenutzer) {
            return $q.when(passedBenutzer);
        }
        if (anlaufstelleId && benutzerId_1) {
            var benutzerPromise = void 0;
            //wir haben aktuell keine methode mit der direkt der Benutzer geladen werden kann, daher laden wir mal alle und filtern danach
            benutzerPromise = AnlaufstelleRS.getBenutzerOfAnlaufstelle(anlaufstelleId);
            return benutzerPromise.then(function (allBenutzerOfAnlaufstelle) {
                var benutzer;
                var i = DVBernUtil_1.default.getIndexOfElementwithIDById(benutzerId_1, allBenutzerOfAnlaufstelle);
                if (i >= 0) {
                    return $q.when(allBenutzerOfAnlaufstelle[i]);
                }
                else {
                    $log.error('Can`t open requested Benutzer of anlaufstelle. creating a new one...');
                    return $q.when(new TSBenutzer_1.default());
                }
            });
        }
    }
    //no infos about existing user passed, assume we need a new one
    return $q.when(new TSBenutzer_1.default());
}
exports.loadAnlaufstelleBenutzer = loadAnlaufstelleBenutzer;
loadBenutzerToEdit.$inject = ['$stateParams', 'BenutzerRS', '$q', '$log'];
function loadBenutzerToEdit($stateParams, BenutzerRS, $q, $log) {
    if ($stateParams) {
        var benutzerId = $stateParams.benutzerId;
        var passedBenutzer = $stateParams.benutzer;
        if (passedBenutzer) {
            return $q.when(passedBenutzer);
        }
        if (benutzerId) {
            var benutzerPromise = void 0;
            benutzerPromise = BenutzerRS.findBenutzer(benutzerId);
            return benutzerPromise.then(function (foundBenutzer) {
                if (foundBenutzer) {
                    return foundBenutzer;
                }
                else {
                    $log.error('Can`t find requested Benutzer. Creating a new one...');
                    return $q.when(new TSBenutzer_1.default());
                }
            });
        }
    }
    //no infos about existing user passed, assume we need a new one
    return $q.when(new TSBenutzer_1.default());
}
exports.loadBenutzerToEdit = loadBenutzerToEdit;
loadBenutzerForProfile.$inject = ['$stateParams', 'BenutzerRS', '$q', '$log', 'AuthServiceRS'];
function loadBenutzerForProfile($stateParams, BenutzerRS, $q, $log, AuthServiceRS) {
    var currentPrincipal = AuthServiceRS.getPrincipal();
    if (currentPrincipal) {
        var benutzerId = currentPrincipal.id;
        if (benutzerId) {
            var benutzerPromise = void 0;
            benutzerPromise = BenutzerRS.findBenutzer(benutzerId);
            return benutzerPromise.then(function (foundBenutzer) {
                if (foundBenutzer) {
                    return foundBenutzer;
                }
                else {
                    $log.error('Can`t find requested Benutzer. Creating a new one...');
                    return $q.when(new TSBenutzer_1.default());
                }
            });
        }
    }
    //no infos about existing user passed, assume we need a new one
    return $q.when(new TSBenutzer_1.default());
}
exports.loadBenutzerForProfile = loadBenutzerForProfile;
//PARAMS
var IBenutzerEditStateParams = /** @class */ (function () {
    function IBenutzerEditStateParams() {
    }
    return IBenutzerEditStateParams;
}());
exports.IBenutzerEditStateParams = IBenutzerEditStateParams;
var IAnlaufstelleBenutzerEditStateParams = /** @class */ (function () {
    function IAnlaufstelleBenutzerEditStateParams() {
    }
    return IAnlaufstelleBenutzerEditStateParams;
}());
exports.IAnlaufstelleBenutzerEditStateParams = IAnlaufstelleBenutzerEditStateParams;


/***/ }),

/***/ "QsPS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(__webpack_require__("PJh5"));
var OkHtmlDialogController_1 = __webpack_require__("U0eN");
var TSDokumentType_1 = __webpack_require__("/gTe");
var TSEigenleistungArt_1 = __webpack_require__("EWa8");
var TSErfassungsArt_1 = __webpack_require__("X/T9");
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var TSEigenleistungKubikmeterDaten_1 = __importDefault(__webpack_require__("++Dq"));
var TSEigenleistungLiterDaten_1 = __importDefault(__webpack_require__("h81c"));
var TSEigenleistungStundenDaten_1 = __importDefault(__webpack_require__("mzmr"));
var styles = __webpack_require__("YJT7");
var okHtmlDialogTemplate = __webpack_require__("ncnt");
var DVEigenleistungenComponentConfig = /** @class */ (function () {
    function DVEigenleistungenComponentConfig() {
        this.transclude = false;
        this.bindings = {
            eigenleistung: '=',
            name: '@',
            readonly: '<',
            schadenfallStatus: '<',
            schadenfall: '<',
            saveDisabled: '=',
        };
        this.template = __webpack_require__("Z8Dy");
        this.controller = DVEigenleistungenController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return DVEigenleistungenComponentConfig;
}());
exports.DVEigenleistungenComponentConfig = DVEigenleistungenComponentConfig;
var TSEigenleistungArtWithFlag = /** @class */ (function () {
    function TSEigenleistungArtWithFlag(art) {
        this.art = art;
        this.disabled = false;
    }
    return TSEigenleistungArtWithFlag;
}());
var DVEigenleistungenController = /** @class */ (function () {
    /* @ngInject */
    function DVEigenleistungenController(CONSTANTS, $log, roleUtilService, $translate, dvDialog) {
        this.CONSTANTS = CONSTANTS;
        this.$log = $log;
        this.roleUtilService = roleUtilService;
        this.$translate = $translate;
        this.dvDialog = dvDialog;
        this.MIN_AGE = 13;
        this.doctype = TSDokumentType_1.TSDocumentType.EIGENLEISTUNG_DOC;
        this.$log.debug('initializing eigenleistung componente');
    }
    DVEigenleistungenController.prototype.$onInit = function () {
        if (this.eigenleistung === undefined || this.eigenleistung === null) {
            this.$log.error('"eigenleistung" attribute is required for this component');
        }
        this.halfHourValues = this.initHalfHourValues();
        if (this.eigenleistung && this.eigenleistung.eigenleistungKubikmeterDaten) {
            this.kubikmeter = this.eigenleistung.eigenleistungKubikmeterDaten.kubikmeter;
        }
        if (this.eigenleistung && this.eigenleistung.eigenleistungLiterDaten) {
            this.liter = this.eigenleistung.eigenleistungLiterDaten.liter;
        }
        if (this.isHandarbeitPauschal() || this.isMaschinenarbeitPauschal()) {
            this.setStundenansatz();
        }
        var relevanteEigenleistungen = this.schadenfall.getRelevanteEigenleistungen(this.isSchaetzung());
        //  this.vorname + ' ' + this.name + ' (' + this.jahrgang + ')'
        this.savedHandarbeiters = relevanteEigenleistungen
            .filter(function (eigen) { return eigen.eigenleistungDatenFS.eigenleistungArt === TSEigenleistungArt_1.TSEigenleistungArt.HANDARBEIT; })
            .map(function (eigenleistung) { return eigenleistung.eigenleistungDatenFS.displayName; });
        this.savedEntries = relevanteEigenleistungen
            .filter(function (eigen) { return eigen.eigenleistungDatenFS.eigenleistungArt !== TSEigenleistungArt_1.TSEigenleistungArt.HANDARBEIT; })
            .map(function (eigenleistung) { return eigenleistung.eigenleistungDatenFS.eigenleistungArt; });
        this.initSelectableLeistungsarten();
    };
    DVEigenleistungenController.prototype.getModel = function () {
        return this.eigenleistung;
    };
    DVEigenleistungenController.prototype.getTSLeistungsartenValues = function () {
        var eigenleistung = this.getModel();
        var schadendatum = (this.schadenfall &&
            this.schadenfall.schaeden &&
            this.schadenfall.schaeden.length > 0 &&
            this.schadenfall.schaeden[0] &&
            this.schadenfall.schaeden[0].schadenDatenFS) ?
            this.schadenfall.schaeden[0].schadenDatenFS.schadendatum : undefined;
        var values = TSEigenleistungArt_1.getEigenleistungsArtValues(schadendatum);
        if (this.schadenfall.erfassungsart === TSErfassungsArt_1.TSErfassungsArt.ONLINE && !this.isSchaetzung()) {
            this.removeHandarbeitPauschalElement(values);
        }
        if (eigenleistung && eigenleistung.eigenleistungDatenFS.eigenleistungArt) {
            var currentArt = eigenleistung.eigenleistungDatenFS.eigenleistungArt;
            if (!values.includes(currentArt)) {
                values.push(currentArt);
            }
        }
        return values;
    };
    DVEigenleistungenController.prototype.removeHandarbeitPauschalElement = function (values) {
        values.splice(values.indexOf(TSEigenleistungArt_1.TSEigenleistungArt.HANDARBEIT_PAUSCHAL), 1);
    };
    DVEigenleistungenController.prototype.initSelectableLeistungsarten = function () {
        var result = new Array();
        if (this.isSchaetzung()) {
            this.getSchaetzungLeistungsarten(result);
        }
        else {
            this.getActualLeistungsarten(result);
        }
        this.selectableLeistungsarten = result;
    };
    DVEigenleistungenController.prototype.getSchaetzungLeistungsarten = function (result) {
        result.push(new TSEigenleistungArtWithFlag(TSEigenleistungArt_1.TSEigenleistungArt.HANDARBEIT_PAUSCHAL));
        result.push(new TSEigenleistungArtWithFlag(TSEigenleistungArt_1.TSEigenleistungArt.HOLZ));
        result.push(new TSEigenleistungArtWithFlag(TSEigenleistungArt_1.TSEigenleistungArt.ANDERE));
    };
    DVEigenleistungenController.prototype.getActualLeistungsarten = function (result) {
        var _this = this;
        if (!this.eigenleistung) {
            return;
        }
        var editedEntryArt = this.eigenleistung.eigenleistungDatenFS.eigenleistungArt;
        this.getTSLeistungsartenValues().forEach(function (value) {
            var elemWithFlag = new TSEigenleistungArtWithFlag();
            elemWithFlag.art = value;
            elemWithFlag.disabled = _this.savedEntries.includes(value) && value !== editedEntryArt;
            result.push(elemWithFlag);
        });
    };
    DVEigenleistungenController.prototype.getJahrgangValues = function () {
        var allowedJahrgaenge = [];
        var maxJahrgang = new Date().getFullYear() - this.MIN_AGE;
        for (var i = 1900; i <= maxJahrgang; i++) {
            allowedJahrgaenge.push(i);
        }
        allowedJahrgaenge.reverse();
        return allowedJahrgaenge;
    };
    DVEigenleistungenController.prototype.translateEigenleistung = function (art) {
        var prefix = TSEigenleistungArt_1.eigenleistungPrefix();
        return this.$translate.instant(prefix + TSEigenleistungArt_1.TSEigenleistungArt[art]);
    };
    DVEigenleistungenController.prototype.changedEigenleistungsart = function () {
        this.parentForm.$setPristine();
        this.parentForm.$setUntouched();
        if (this.eigenleistung) {
            //empty array
            this.eigenleistung.eigenleistungStundenDaten.splice(0);
        }
        this.initKubikmeter();
        this.initLiter();
        this.initPauschaleLeistungsarten();
    };
    DVEigenleistungenController.prototype.initKubikmeter = function () {
        if (this.eigenleistung) {
            if (this.showKubikmeter()) {
                this.eigenleistung.eigenleistungKubikmeterDaten = new TSEigenleistungKubikmeterDaten_1.default();
                this.eigenleistung.eigenleistungStundenDaten = [];
            }
            else {
                this.eigenleistung.eigenleistungKubikmeterDaten = undefined;
            }
        }
    };
    DVEigenleistungenController.prototype.initLiter = function () {
        if (this.eigenleistung) {
            if (this.showLiter()) {
                this.eigenleistung.eigenleistungLiterDaten = new TSEigenleistungLiterDaten_1.default();
                this.eigenleistung.eigenleistungStundenDaten = [];
            }
            else {
                this.eigenleistung.eigenleistungLiterDaten = undefined;
            }
        }
    };
    DVEigenleistungenController.prototype.initPauschaleLeistungsarten = function () {
        if (this.isHandarbeitPauschal() || this.isMaschinenarbeitPauschal()) {
            var eigenleistung = this.getModel();
            if (eigenleistung && eigenleistung.eigenleistungDatenFS) {
                // StundenDaten will not be added with the button, but manually
                // (only one StundenDaten entry is made for handarbeit pauschal)
                var eigenleistungStundenDaten = new TSEigenleistungStundenDaten_1.default();
                eigenleistungStundenDaten.datum = moment_1.default();
                eigenleistung.eigenleistungStundenDaten.push(eigenleistungStundenDaten);
                this.setStundenansatz();
            }
        }
    };
    DVEigenleistungenController.prototype.setStundenansatz = function () {
        if (this.isHandarbeitPauschal()) {
            this.stundenansatz = TSEigenleistungArt_1.getEigenleistungsAnsatz(TSEigenleistungArt_1.TSEigenleistungArt.HANDARBEIT, this.schadenfall.schaeden[0].schadenDatenFS.schadendatum);
        }
        else {
            this.stundenansatz = 0;
        }
    };
    DVEigenleistungenController.prototype.calculateBetrag = function (inputValue) {
        var eigenleistung = this.getModel();
        if (eigenleistung && eigenleistung.eigenleistungDatenFS && eigenleistung.eigenleistungDatenFS.eigenleistungArt) {
            var ansatz = this.isAndereLeistungArt() ? this.stundenansatz :
                TSEigenleistungArt_1.getEigenleistungsAnsatz(eigenleistung.eigenleistungDatenFS.eigenleistungArt, this.schadenfall.schaeden[0].schadenDatenFS.schadendatum);
            if (!isNaN(inputValue)) {
                return inputValue * ansatz;
            }
        }
        return 0;
    };
    DVEigenleistungenController.prototype.addStunden = function () {
        if (this.isHandarbeit() && this.isDuplicatedHandarbeiter()) {
            this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController_1.OkHtmlDialogController, {
                title: 'TITLE_DUPLICATED_HANDARBEITER',
                text: 'DUPLICATED_HANDARBEITER_MESSAGE',
            });
            this.saveDisabled = true;
            return;
        }
        this.saveDisabled = false;
        var eigenleistung = this.getModel();
        if (eigenleistung && eigenleistung.eigenleistungDatenFS && eigenleistung.eigenleistungDatenFS.eigenleistungArt && this.datum && this.arbeitsstunden) {
            var newStunden = new TSEigenleistungStundenDaten_1.default();
            newStunden.datum = this.datum;
            newStunden.arbeitsstunden = this.arbeitsstunden;
            newStunden.betrag = this.calculateBetrag(this.arbeitsstunden);
            this.datum = undefined;
            this.arbeitsstunden = undefined;
            this.betragForAndere = 0;
            eigenleistung.eigenleistungStundenDaten.push(newStunden);
        }
    };
    DVEigenleistungenController.prototype.getBetragHandarbeitPauschal = function () {
        var eigenleistung = this.getModel();
        if (eigenleistung) {
            return eigenleistung.eigenleistungStundenDaten[0].betrag = eigenleistung.eigenleistungStundenDaten[0].arbeitsstunden * this.stundenansatz;
        }
        return 0;
    };
    DVEigenleistungenController.prototype.isDuplicatedHandarbeiter = function () {
        //if id is defined, then this person is already saved => we are in edit mode
        if (!this.eigenleistung) {
            return false;
        }
        var editMode = !!this.eigenleistung.id;
        // it is not a duplicate if we are in edit mode
        if (editMode) {
            return false;
        }
        //  this.vorname + ' ' + this.name + ' (' + this.jahrgang + ')'
        var actualArbeiter = this.eigenleistung.eigenleistungDatenFS;
        var actualArbeiterName = actualArbeiter.vorname + ' ' + actualArbeiter.name + ' (' + actualArbeiter.jahrgang + ')';
        return this.savedHandarbeiters.some(function (handarbeiter) { return actualArbeiterName === handarbeiter; });
    };
    DVEigenleistungenController.prototype.addKubikmeter = function () {
        var eigenleistung = this.getModel();
        if (eigenleistung && eigenleistung.eigenleistungDatenFS && eigenleistung.eigenleistungDatenFS.eigenleistungArt && this.kubikmeter) {
            var newKubikmeter = new TSEigenleistungKubikmeterDaten_1.default();
            newKubikmeter.kubikmeter = this.kubikmeter;
            newKubikmeter.betrag = this.calculateBetrag(this.kubikmeter);
            this.datum = undefined;
            eigenleistung.eigenleistungKubikmeterDaten = newKubikmeter;
        }
    };
    DVEigenleistungenController.prototype.addLiter = function () {
        var eigenleistung = this.getModel();
        if (eigenleistung && eigenleistung.eigenleistungDatenFS && eigenleistung.eigenleistungDatenFS.eigenleistungArt && this.liter) {
            var newLiter = new TSEigenleistungLiterDaten_1.default();
            newLiter.liter = this.liter;
            newLiter.betrag = this.calculateBetrag(this.liter);
            this.datum = undefined;
            eigenleistung.eigenleistungLiterDaten = newLiter;
        }
    };
    DVEigenleistungenController.prototype.showPersonendaten = function () {
        var eigenleistung = this.getModel();
        if (eigenleistung && eigenleistung.eigenleistungDatenFS && eigenleistung.eigenleistungDatenFS.eigenleistungArt) {
            return eigenleistung.eigenleistungDatenFS.eigenleistungArt === TSEigenleistungArt_1.TSEigenleistungArt.HANDARBEIT;
        }
        return false;
    };
    DVEigenleistungenController.prototype.initHalfHourValues = function () {
        var items = [];
        for (var i = 0; i <= 20; i++) {
            var numVal = i * 0.5;
            var halfstring = i % 2 === 0 ? '0' : '5';
            var label = '' + Math.floor(i / 2) + '.' + halfstring + 'h';
            items.push({ label: label, value: numVal });
        }
        return items;
    };
    DVEigenleistungenController.prototype.getPrefix = function () {
        return TSEigenleistungArt_1.eigenleistungPrefix();
    };
    DVEigenleistungenController.prototype.calcTotalELHours = function () {
        var total = 0;
        if (this.eigenleistung !== undefined) {
            return this.eigenleistung.getArbeitsstundenTotal();
        }
        return total;
    };
    DVEigenleistungenController.prototype.calcTotalELBetrag = function () {
        var total = 0;
        if (this.eigenleistung !== undefined) {
            return this.eigenleistung.getBetragTotal();
        }
        return total;
    };
    DVEigenleistungenController.prototype.deleteClicked = function (eigenleistungDatenToDelete, event, index) {
        var eigenleistung = this.getModel();
        if (eigenleistung) {
            if (!this.markAsdeleteMode(eigenleistungDatenToDelete)) {
                if (index > -1) {
                    if (eigenleistungDatenToDelete instanceof TSEigenleistungStundenDaten_1.default) {
                        eigenleistung.eigenleistungStundenDaten.splice(index, 1); //remove from list
                    }
                }
            }
            else {
                eigenleistungDatenToDelete.deleted = true; //only mark as deleted
            }
        }
    };
    DVEigenleistungenController.prototype.markAsdeleteMode = function (eigenleistungDatenToDelete) {
        if (this.schadenfallStatus === TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG) {
            // immer direckt löschen wenn Status = WIEDERHERSTELLUNG
            return false;
        }
        else if (eigenleistungDatenToDelete.timestampErstellt === undefined) {
            // Noch nicht gespeicherte daten können gelöscht werden.
            return false;
        }
        // ansonsten markieren wir nur als gelöscht
        return true;
    };
    DVEigenleistungenController.prototype.showKubikmeter = function () {
        var eigenleistung = this.getModel();
        if (eigenleistung && eigenleistung.eigenleistungDatenFS && eigenleistung.eigenleistungDatenFS.eigenleistungArt) {
            return eigenleistung.eigenleistungDatenFS.eigenleistungArt === TSEigenleistungArt_1.TSEigenleistungArt.HOLZ ||
                eigenleistung.eigenleistungDatenFS.eigenleistungArt === TSEigenleistungArt_1.TSEigenleistungArt.HOLZ_AUF_PLATZ;
        }
        return false;
    };
    DVEigenleistungenController.prototype.showLiter = function () {
        var eigenleistung = this.getModel();
        if (eigenleistung && eigenleistung.eigenleistungDatenFS && eigenleistung.eigenleistungDatenFS.eigenleistungArt) {
            return eigenleistung.eigenleistungDatenFS.eigenleistungArt === TSEigenleistungArt_1.TSEigenleistungArt.TREIBSTOFF;
        }
        return false;
    };
    DVEigenleistungenController.prototype.isAndereLeistungArt = function () {
        var eigenleistung = this.getModel();
        if (eigenleistung && eigenleistung.eigenleistungDatenFS && eigenleistung.eigenleistungDatenFS.eigenleistungArt) {
            return eigenleistung.eigenleistungDatenFS.eigenleistungArt === TSEigenleistungArt_1.TSEigenleistungArt.ANDERE;
        }
        return false;
    };
    DVEigenleistungenController.prototype.isHandarbeit = function () {
        var eigenleistung = this.getModel();
        if (eigenleistung && eigenleistung.eigenleistungDatenFS && eigenleistung.eigenleistungDatenFS.eigenleistungArt) {
            return eigenleistung.eigenleistungDatenFS.eigenleistungArt === TSEigenleistungArt_1.TSEigenleistungArt.HANDARBEIT;
        }
        return false;
    };
    DVEigenleistungenController.prototype.isHandarbeitPauschal = function () {
        var eigenleistung = this.getModel();
        if (eigenleistung && eigenleistung.eigenleistungDatenFS && eigenleistung.eigenleistungDatenFS.eigenleistungArt) {
            return eigenleistung.eigenleistungDatenFS.eigenleistungArt === TSEigenleistungArt_1.TSEigenleistungArt.HANDARBEIT_PAUSCHAL;
        }
        return false;
    };
    DVEigenleistungenController.prototype.getRequiredDocs = function () {
        if (this.isSchaetzung()) {
            return 0;
        }
        return 1;
    };
    DVEigenleistungenController.prototype.isSchaetzung = function () {
        var eigenleistung = this.getModel();
        return !!(eigenleistung && eigenleistung.schaetzung);
    };
    DVEigenleistungenController.prototype.isMaschinenarbeitPauschal = function () {
        return this.isAndereLeistungArt() && this.isSchaetzung();
    };
    DVEigenleistungenController.$inject = ['CONSTANTS', '$log', 'RoleUtilService', '$translate', 'DvDialog'];
    return DVEigenleistungenController;
}());
exports.DVEigenleistungenController = DVEigenleistungenController;


/***/ }),

/***/ "Qseh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
__webpack_require__("fjOH");
var core_module_1 = __webpack_require__("u87A");
__webpack_require__("/jrf");
var statistikView_1 = __webpack_require__("DZJ0");
var statistik_route_1 = __webpack_require__("507y");
exports.SerfWebStatistik = angular.module('serfWeb.statistik', [core_module_1.SerfWebCore.name])
    .component('dvStatistikView', new statistikView_1.StatistikViewComponentConfig())
    .run(statistik_route_1.statistikRun);
exports.default = exports.SerfWebStatistik;


/***/ }),

/***/ "QwOf":
/***/ (function(module, exports) {

module.exports = {"LOGIN_REGISTER_GS":"Registrare come sinistrato","LOGIN_REGISTER_GEMEINDE":"Registrare i Comuni","MENU_SCHADENFAELLE":"Casi di danno","VORNAME":"Nome","NAME":"Cognome","BERECHNUNGSDETAIL":"Dettaglio del calcolo","BERECHNUNGSDETAIL_EXPLANATION":"Se la data del sinistro è precedente al 1° maggio 2026, si applicano regole di calcolo diverse. \nNon appena sarà disponibile la data del sinistro determinante, le deduzioni saranno ricalcolate e aggiornate automaticamente in base alle regole valide per tale data. \n\nSulla base delle indicazioni da voi fornite riguardo alla situazione finanziaria, si applica il seguente schema di calcolo:","IHRE_ANGABEN":"Le vostre indicazioni","EINKOMMEN":"Reddito","VERMOEGEN":"Sostanza","SCHADENMINIMUM":"Danno accertato (al minimo)","MINDESTAUSZAHLUNG":"Pagamento minimo","ABZUEGE_EINKOMMEN":"Deduzioni reddito","ABZUEGE_VERMOEGEN":"Deduzioni sostanza","ABSCHLUSS_TITLE":"Grazie mille","ABSCHLUSS_BUTTON_TEXT":"Alla panoramica","ABSCHLUSS_TEXT":"Il suo caso di danno è stato trasmesso con successo. Provvederemo alla verifica e all'inoltro al corrispondente punto di riferimento.","ABSCHLUSS_TITLE_ANLAUFSTELLE_REG":"La ringraziamo per la sua registrazione!","ABSCHLUSS_TEXT_ANLAUFSTELLE_REG":"Riceverà a breve un e-mail con le indicazioni per l'attivazione del suo conto utente. Ulteriori indicazioni per l'attivazione del suo conto le saranno trasmesse dopo che avrà effettuato con successo il login.","EIGENLEISTUNG_ADD":"Aggiungere voce prestazione propria","SCHAETZUNG_ADD":"Aggiungere una stima","VORLEISTUNG_ADD":"Aggiungere voce prestazione anticipata","AUFWAND_VORLEISTUNGEN_UPLOAD_TXT":"Registri qui i documenti giustificativi concernenti le prestazioni anticipate.","ALLE":"tutto","ALLE_TITLE":"Tutto","AKTIV":"attivo","ADMIN":"Amm.","BANK":"Banca","ARBEITSSTUNDEN":"Ore di lavoro","ANLAUFSTELLE_TO_EDIT":"Selezioni qui il punto di riferimento da amministrare.","ANLAUFSTELLE_ADD":"Aggiungere punto di riferimento","ANLAUFSTELLENVERWALTUNG_ANLAUFSTELLE":"Punti di riferimento","AUFWAND_FREMDKOSTEN_ADD":"Aggiungere voce spese di terzi","AUFWAND_FREMDKOSTEN_CREATE":"Aggiungere una offerta","AUFWAND_FREMDKOSTEN_REMOVE":"Siete certi di voler cancellare le spese di terzi?","AUFWAND_FREMDKOSTEN_UPLOAD_TXT":"Voglia registrare qui le fatture e le ricevute di pagamento (Banca, Posta).","AUFWAND_EIGENLEISTUNGEN_UPLOAD_TXT":"Voglia onserire la ricevuta del proprio lavoro (rapporto orario).","AKTION":"Azione","BENUTZER_REC_SUCCESS":"Il conto utente è stato creato. È stato inviato un e-mail con la descrizione delle modalità per l'attivazione del conto utente.","VERWALTER_REC_SUCCESS":"Il conto utente per l'amministratore del punto di riferimento è stato creato. Voglia comunicare la password all'amministratore.","BENUTZERVERWALTUNG_ANLAUFSTELLE_VERWALTER":"Amministrazione utenti punto di riferimento","BENUTZERROLLE":"Ruolo utente","BENUTZERVERWALTUNG_ADD":"Aggiungere utente","BENUTZER_SPEICHERN":"Memorizzare utente","BENUTZERPROFIL":"Profilo utente","BENUTZER_ERSTELLEN":"Creare nuovo utente","BENUTZER_DEAKTIVIEREN":"Disattivare utente","BETRAG_BERECHTIGT":"Importo giustificato","CONFIRM_VERWALTERCHANGE":"Attenzione: se lei è la persona responsabile, dopo che avrà effettuato la modifica del responsabile probabilmente non potrà più avere accesso al punto di riferimento.","DELETE":"Cancellare","JAHRGANG":"Anno","BETRAG":"Importo","BETRAG_CHF":"Importo in CHF","ANZAHL_STUNDEN":"Numero di ore","EDIT":"Modificare","PROPERTY_NAME":"Nominativo","PROPERTY_TEXT":"Testo","TIMEERSTELLT":"Data di creazione","TIMEMUTIERT":"Modificato","SIZE":"Dimensione","Land_AD":"Andorra","Land_AE":"Emirati Arabi Uniti","Land_AF":"Afghanistan","Land_AG":"Antigua e Barbuda","Land_AI":"Anguilla","Land_AL":"Albania","Land_AM":"Armenia","Land_AN":"Antille olandesi","Land_AQ":"Antartico","Land_AR":"Argentina","Land_AS":"Samoa americane","Land_AT":"Austria","Land_AU":"Australia","Land_AX":"Isole Åland","Land_AZ":"Azerbaigian","Land_BA":"Bosnia ed Erzegovina","Land_BE":"Belgio","Land_BG":"Bulgaria","Land_BO":"Bolivia","Land_BR":"Brasile","Land_BV":"Isola Bouvet","Land_BY":"Bielorussia","Land_CA":"Canada","Land_CC":"Isole Cocos","Land_CD":"Congo, Rep. Dem.","Land_CF":"Repubblica Centrafricana","Land_CG":"Congo","Land_CH":"Svizzera","Land_CI":"Costa d'Avorio","Land_CK":"Isole Cook","Land_CL":"Cile","Land_CM":"Camerun","Land_CN":"Cina","Land_CO":"Colombia","Land_CS":"Serbia e Montenegro","Land_CU":"Cuba","Land_CV":"Capo Verde","Land_CX":"Isola di Natale","Land_CY":"Cipro","Land_CZ":"Repubblica Ceca","Land_DE":"Germania","Land_DK":"Danimarca","Land_DO":"Repubblica Dominicana","Land_DZ":"Algeria","Land_EC":"Ecuador","Land_EE":"Estonia","Land_EG":"Egitto","Land_EH":"Sahara Occidentale","Land_ES":"Spagna","Land_ET":"Etiopia","Land_FI":"Finlandia","Land_FJ":"Fiji","Land_FK":"Isole Falkland","Land_FM":"Micronesia","Land_FO":"Fær Øer","Land_FR":"Francia","Land_GA":"Gabon","Land_GB":"Regno Unito","Land_GE":"Georgia","Land_GF":"Guyana francese","Land_GI":"Gibilterra","Land_GL":"Groenlandia","Land_GP":"Guadalupa","Land_GQ":"Guinea Equatoriale","Land_GR":"Grecia","Land_GS":"Georgia del Sud e Isole Sandwich Australi","Land_HK":"Hong Kong","Land_HM":"Isole Heard e McDonald","Land_HR":"Croazia","Land_HU":"Ungheria","Land_ID":"Indonesia","Land_IE":"Irlanda","Land_IL":"Israele","Land_IM":"Isola di Man","Land_IN":"India","Land_IO":"Territorio britannico dell'Oceano Indiano","Land_IR":"Iran, Rep. Islam.","Land_IS":"Islanda","Land_IT":"Italia","Land_JM":"Giamaica","Land_JO":"Giordania","Land_JP":"Giappone","Land_KE":"Kenya","Land_KG":"Kirghizistan","Land_KH":"Cambogia","Land_KM":"Comore","Land_KN":"St. Kitts e Nevis","Land_KP":"Corea del Nord; Rep. Pop. Dem.","Land_KR":"Corea del Sud, Rep.","Land_KY":"Isole Cayman","Land_KZ":"Kazakistan","Land_LA":"Laos, Rep. Pop. Dem.","Land_LB":"Libano","Land_LT":"Lituania","Land_LU":"Lussemburgo","Land_LV":"Lettonia","Land_LY":"Libia, Stato della","Land_MA":"Marocco","Land_MD":"Moldavia","Land_MG":"Madagascar","Land_MH":"Isole Marshall","Land_MK":"Macedonia, ex Repubblica Jugoslava","Land_MN":"Mongolia","Land_MP":"Marianne Settentrionali","Land_MQ":"Martinica","Land_AO":"Angola","Land_AW":"Aruba","Land_BB":"Barbados","Land_BD":"Bangladesch","Land_BF":"Burkina Faso","Land_BH":"Bahrain","Land_BI":"Burundi","Land_BJ":"Benin","Land_BL":"St. Barthélemy","Land_BM":"Bermuda","Land_BN":"Brunei, Stato del","Land_BS":"Bahamas","Land_BT":"Bhutan","Land_BW":"Botswana","Land_BZ":"Belize","Land_CR":"Costa Rica","Land_DJ":"Dschibuti","Land_DM":"Dominica","Land_ER":"Eritrea","Land_GD":"Grenada","Land_GG":"Guernsey","Land_GH":"Ghana","Land_GM":"Gambia","Land_GN":"Guinea","Land_GT":"Guatemala","Land_GU":"Guam","Land_GW":"Guinea-Bissau","Land_GY":"Guyana","Land_HN":"Honduras","Land_HT":"Haiti","Land_IQ":"Irak","Land_JE":"Jersey","Land_KI":"Kiribati","Land_KW":"Kuwait","Land_LC":"St. Lucia","Land_LI":"Liechtenstein","Land_LK":"Sri Lanka","Land_LR":"Liberia","Land_LS":"Lesotho","Land_MC":"Monaco","Land_ME":"Montenegro","Land_MF":"St. Martin","Land_ML":"Mali","Land_MM":"Myanmar","Land_MO":"Macao","Land_MR":"Mauritania","Land_MS":"Montserrat","Land_MT":"Malta","Land_MU":"Mauritius","Land_MV":"Maldive","Land_MW":"Malawi","Land_MX":"Messico","Land_MY":"Malesia","Land_MZ":"Mozambico","Land_NA":"Namibia","Land_NC":"Nuova Caledonia","Land_NE":"Niger","Land_NF":"Isola Norfolk","Land_NG":"Nigeria","Land_NI":"Nicaragua","Land_NICHTAERKANNT":"Non riconosciuto","Land_NL":"Paesi Bassi","Land_NO":"Norvegia","Land_NP":"Nepal","Land_NR":"Nauru","Land_NU":"Niue","Land_NZ":"Nuova Zelanda","Land_OM":"Oman","Land_PA":"Panama","Land_PE":"Perù","Land_PF":"Polinesia Francese","Land_PG":"Papua Nuova Guinea","Land_PH":"Filippine","Land_PK":"Pakistan","Land_PL":"Polonia","Land_PM":"St. Pierre e Miquelon","Land_PN":"Isole Pitcairn","Land_PR":"Porto Rico","Land_PS":"Palestina, Territori","Land_PT":"Portogallo","Land_PW":"Palau","Land_PY":"Paraguay","Land_QA":"Qatar","Land_RE":"Réunion","Land_RO":"Romania","Land_RS":"Serbia","Land_RU":"Federazione Russa","Land_RW":"Ruanda","Land_SA":"Arabia Saudita","Land_SB":"Isole Salomone","Land_SC":"Seychelles","Land_SD":"Sudan","Land_SE":"Svezia","Land_SG":"Singapore","Land_SH":"Sant'Elena","Land_SI":"Slovenia","Land_SJ":"Svalbard e Jan Mayen","Land_SK":"Slovacchia","Land_SL":"Sierra Leone","Land_SM":"San Marino","Land_SN":"Senegal","Land_SO":"Somalia","Land_SR":"Suriname","Land_ST":"São Tomé e Príncipe","Land_STAATENLOS":"Apolide","Land_SV":"El Salvador","Land_SY":"Siria, Rep. Araba","Land_SZ":"Swasiland","Land_TC":"Turcs e Caicos","Land_TD":"Ciad","Land_TF":"Terre Australi e Antartiche Francesi","Land_TG":"Togo","Land_TH":"Thailandia","Land_TJ":"Tagikistan","Land_TK":"Tokelau","Land_TL":"Timor Est","Land_TM":"Turkmenistan","Land_TN":"Tunisia","Land_TO":"Tonga","Land_TR":"Turchia","Land_TT":"Trinidad e Tobago","Land_TV":"Tuvalu","Land_TW":"Taiwan","Land_TZ":"Tanzania, Rep. Unita","Land_UA":"Ucraina","Land_UG":"Uganda","Land_UM":"Oceania","Land_UNBEKANNT":"Sconosciuto","Land_US":"Stati Uniti d'America","Land_UY":"Uruguay","Land_UZ":"Uzbekistan","Land_VA":"Città del Vaticano","Land_VC":"St. Vincent e Grenadine","Land_VE":"Venezuela","Land_VG":"Isole Vergini britanniche","Land_VI":"Isole Vergini americane","Land_VN":"Vietnam","Land_VU":"Vanuatu","Land_WF":"Wallis e Futuna","Land_WS":"Samoa","Land_XZ":"Kosovo","Land_YE":"Yemen","Land_YT":"Mayotte","Land_ZA":"Sudafrica","Land_ZM":"Sambia","Land_ZW":"Zimbabwe","MENU_LOGOUT":"Annullare","SAVE":"Memorizzare","WEITER":"Continua","CANCEL":"Interrompere","LOGIN_REGISTER_ANLAUFSTELLE":"Registrare nuovo punto di riferimento","LOGIN_BACK_TOANMELDUNG":"ritorna alla registrazione","LOGIN_BTN":"Login","LOGIN_BTN_ANFORDERN":"Richiedere","LOGIN_CHANGED":"La password è stata modificata.","LOGIN_EMAIL":"E-mail","LOGIN_EMAIL_REPEAT":"Ripetere l'e-mail","LOGIN_EXISTING_USER":"Effettuare il login con il conto utente registrato","LOGIN_DAMAGE_NOTICE_TITLE":"Nota:","LOGIN_DAMAGE_NOTICE_TEXT":"Per i danni avvenuti nei Cantoni (AR, GR, NW), la notifica del danno deve essere inoltrata direttamente al Cantone competente. Ulteriori informazioni sono disponibili ","LOGIN_DAMAGE_NOTICE_LINK":"qui","LOGIN_DAMAGE_NOTICE_URL":"https://www.fondssuisse.ch/it/richieste-contributi/competenze","LOGING_FORGOT_PASSWORT":"Password dimenticata","LOGIN_PASSWD":"Password","LOGIN_PASSWD_REP":"Ripetere la password","LOGIN_PW_REST_SENT":"È stata inviata un'e-mail all'indirizzo indicato.","LOGIN_RESET_PW_TITLE":"Problemi con la registrazione?","LOGIN_RESET_PW_TEXT":"Indicate l'indirizzo e-mail con cui vi siete registrati a fondssuisse. Vi invieremo delle istruzioni affinché tutto funzioni nuovamente.","LOGIN_RESET_PW_BUTTON":"Modificare la password","LOGIN_SET_NEW_PASSWORD_TITLE":"Impostare la password utente","LOGIN_SET_NEW_PASSWORD_TEXT":"Inserite la nuova password (min. 8 caratteri, di cui almeno 1 numero).","MAX_ERFASSUNGS_BETRAG":"Importo massimo della registrazione","REGISTER":"Registrare","LOGIN_USERNAME":"Nome utente","ERROR_REQUIRED":"È necessario compilare il campo","ERROR_COORDINATES":"Vogliate selezionare un punto sulla mappa.","ERROR_DOCCOUNT":"Sono necessari i documenti. Vogliate caricare almeno {{count}} documento(i).","ERROR_REQUIRED_ONE_OF_THEM":"È necessario compilare uno dei campi.","ERROR_VERTRAG_REQUIRED":"Per richiedere una conferma del posto, dovete aver stipulato un contratto con l'istituzione in esame.","ERROR_MIN":"Valore minimo non raggiunto.","ERROR_MIN_LENG":"Inserimento troppo corto.","ERROR_MAX_LENG":"Inserimento troppo lungo.","ERROR_EMAIL":"Nessun indirizzo e-mail valido.","ERROR_EMAIL_SAME":"Il medesimo indirizzo e-mail deve essere inserito due volte.","ERROR_FORMAT":"Formato non corretto","ERROR_IBAN_FORMAT":"IBAN non valido","ERROR_DATE":"Formato della data non corretto","ERROR_MAX":"Valore massimo superato.","ERROR_NUMBER":"Formato del numero non corretto","ERROR_NO_LEISTUNG_ENTERED":"Non è stata inserita alcuna spesa / prestazione. Volete davvero rilasciare?","ERROR_LEISTUNG_COMPULSORY":"Non è stata inserita alcuna spesa / prestazione. Si prega di inserire almeno una spesa / prestazione.","ERROR_NO_BANKKONTO_ENTERED":"È necessario inserire le coordinate bancarie.","ERROR_NO_FUNCTIONAL_ROLE":"A questo utente non è ancora stata attribuita nessuna funzione.","ERROR_NO_SCHAETZER":"Per poter inoltrare la richiesta, dovete assegnarla perlomeno a un perito.","ERROR_NO_SCHAETZUNG":"Non è ancora stata registrata alcuna stima. Vuole veramente trasmettere il danno?","ERROR_NO_STEUERDATENPRUEFUNG":"Vogliate confermare alla pagina precedente di aver verificato le informazioni finanziarie.","ERROR_NO_BEITRAG":"Deve essere registrato perlomeno un importo.","ERROR_VALUE":"Valore troppo elevato o formattazione errata.","ERROR_FUTURE":"La data è nel futuro.","ERROR_PAST":"La data è nel passato.","ERROR_UNEXPECTED":"Si è inaspettatamente verificato un errore.","ERROR_LOGIN":"Inserire un indirizzo e-mail e una password validi.","ERROR_PW_CHANGE":"La password non ha potuto essere modificata.","ERROR_PW_SAME":"Inserite due volte la nuova password.","ERROR_PW_RESTRICTIONS":"La password deve contenere perlomeno 8 caratteri e almeno un numero e una lettera.","ERROR_UNAUTHORIZED":"Azione non consentita!","ERROR_NO_BEITRAEGE":"Non è ancora stato selezionato nessun contributo.","ERROR_NO_SUBVENTIONIERT_FLAG":"Sovvenzionato sì/no manca","ERROR_WALD":"Deve essere indicata la superficie interessata o la quantità di legname","FIRMA":"Ditta","BESCHREIBUNG":"Descrizione","FREIGEBEN":"Inviare la richiesta","FREIGEBEN_PAPIER":"Inviare la richiesta","FIRMENSITZ":"Sede della ditta","LEISTUNGSART":"Genere di prestazione","RECHNUNGSNUMMER":"Fattura no.","RECHNUNGSDATUM":"Data della fattura","RECHNUNGSBETRAG":"Importo della fattura in CHF","DATE_PLACEHOLDER":"gg.mm.aaaa","DATEPICKER_EXAMPLE":"Esempio Datepicker","KEIN_EINTRAG":"Nessun inserimento presente","VALUEINPUT_EXAMPLE":"Esempio inserimento valore","TOOLTIP_HELP_TITLE":"titolo tooltip help","TOOLTIP_HELP_TEXT":"Titolo tooltip help","MENU_ARCHIV":"Archivio","MENU_BENUTZERVERWALTUNG":"Amministrazione utenti","MENU_ANLAUFSTELLE":"Punto di riferimento","MENU_ZAHLUNGEN":"Pagamenti","MENU_STATISTIK":"Statistica","MENU_GESUCH_ERFASSEN":"Registrare la richiesta","NAV_GESUCH_ERFASSEN":"Persona interessata","NAV_SCHADENMELDUNG":"Notifica del danno","NAV_AUFWAENDE":"Spese","NAV_SCHAETZUNG":"Stima del danno","SACHBEARBEITER_ZUTEILEN":"Assegnare l'incaricato","SCHAETZER_ADD":"Aggiungere perito","DIE_SCHAETZER":"I periti","SCHAETZER_ZUTEILEN":"Assegnare il perito","TESTFALL_ERSTELLEN":"Inserire test caso di danno {{gsname}}","TESTPAGE":"Pagina test","TSEigenleistungArt_HANDARBEIT":"Lavoro manuale","TSEigenleistungArt_HANDARBEIT_PAUSCHAL":"Rapporto delle ore di lavoro manuale","TSEigenleistungArt_TERRA_TRAC_SUB44KW":"Terra Trac 30 a 44 kW (41 - 60 CV)","TSEigenleistungArt_TERRA_TRAC_SUB74KW":"Terra Trac 45 a 73 kW (61 - 100 CV)","TSEigenleistungArt_TELESKOPLADER":"Sollevatore telescopico (attrezzatura inclusa)","TSEigenleistungArt_KLEINBAGGER_1_5T_BIS_3T":"Miniescavatore 1.5t a 3t","TSEigenleistungArt_KLEINBAGGER_3_5T_BIS_6T":"Miniescavatore 3.5t a 6t","TSEigenleistungArt_KLEINBAGGER_7T_BIS_10T_SCHREITBAGGER":"Miniescavatore 7t a 10t / Escavatore a ragno","TSEigenleistungArt_RAUPENKARETTE":"Motocarriola cingolata","TSEigenleistungArt_RAUPENTRANSPORTER_1_5T_BIS_4T":"Trasportatore cingolato 1.5t a 4t","TSEigenleistungArt_TREIBSTOFF":"Piccoli macchinari (Consumo effettivo di carburante per litro)","TSEigenleistungArt_TRAKTOR_SUB44KW":"Trattore 30 a 44 kW (41 - 60 CV)","TSEigenleistungArt_TRAKTOR_SUB74KW":"Trattore 45 a 73 kW (61 - 100 CV)","TSEigenleistungArt_TRAKTOR_AB74KW":"Trattore più di 74 kW (da 100 PS)","TSEigenleistungArt_TRAKTOR_AB74KW_KIPPER":"Trattore oltre 74 kW (oltre 100 CV) con ribaltabile idr.","TSEigenleistungArt_TRAKTOR":"Trattore più di 44 kW (da 61 PS)","TSEigenleistungArt_TRAKTOR_4WD_SUB44KW":"Trattore, trazione su 4 ruote, da 30 a 44 kW (41 - 60 PS)","TSEigenleistungArt_TRAKTOR_4WD":"Trattore, trazione su 4 ruote più di 44 kW (da 61 PS)","TSEigenleistungArt_TRANSPORTER":"Carro per trasporti, con porte","TSEigenleistungArt_TRANSPORTER_KIPPBRUECKE":"Trasportatore oltre 74 kW (oltre 100 CV) con cassone ribaltabile","TSEigenleistungArt_ANHAENGER":"Rimorchio al trattore","TSEigenleistungArt_FRONTLADER":"Pala caricatrice frontale","TSEigenleistungArt_HECKSCHAUFEL_PLANIERSCHILD":"Livellatore","TSEigenleistungArt_ANBAUSEILWINDE":"Argano aggiuntivo","TSEigenleistungArt_HOLZ":"Legano dal proprio magazino al m3","TSEigenleistungArt_HOLZ_AUF_PLATZ":"Legname dal proprio bosco consegnato in loco per m3","TSEigenleistungArt_BAGGER_1500":"Scavatore a 1.5t","TSEigenleistungArt_BAGGER_BIS5000":"Scavatore 2t a 5t","TSEigenleistungArt_BAGGER_AB5000":"Scavatore da 5-6t","TSEigenleistungArt_RAUPENTRANSPORTER":"Veicolo cingolato","TSEigenleistungArt_KETTENSAEGE":"Motosega","TSEigenleistungArt_ANDERE":"Altro","TSLeistugnsart_MATERIAL":"Materiale","TSLeistugnsart_UNTERNEHMERRECHNUNG":"Fattura di un'impresa","TSLeistugnsart_MIETE":"Locazione","TSLeistugnsart_OFFERTE":"Offerta","TSLeistugnsart_HOLZ":"Legno","TSLeistugnsart_PAUSCHAL":"Stima forfettaria","TSRole_SUPER_ADMIN":"Superadmin","TSRole_FONDSSUISSE_ADMIN":"Amm. fondssuisse","TSRole_FONDSSUISSE_SACHBEARBEITER":"Incaricato fondssuisse","TSRole_KANTON_VERWALTER":"Amministratore Cantone","TSRole_KANTON_INSPEKTOR":"Ispettore Cantone","TSRole_ANLAUFSTELLE_SACHBEARBEITER":"Incaricato punto di riferimento","TSRole_ANLAUFSTELLE_VERWALTER":"Amministratore punto di riferimento","TSRole_ANLAUFSTELLE_SCHAETZER":"Perito punto di riferimento","TSRole_BETROFFENER":"Persona interessata","BETROFFENE":"Persona interessata","TSRole_UNASSIGNED_ROLE":"N/A","TSVorleistungArt_HAGELVERSICHERUNG":"Assicurazione contro i danni della grandine","TSVorleistungArt_GEBAEUDEVERSICHERUNG":"Assicurazione stabili","TSVorleistungArt_PRIVATVERSICHERUNG":"Assicurazione privata","TSVorleistungArt_SUBVENTION":"Sussidi","TSVorleistungArt_SPENDE":"Donazione","TSVorleistungArt_ANDERE":"Altro","TOTAL_EIGENLEISTUNGEN":"Totale spese a carico del richiedente CHF {{totale | numero : 0}}","NEU":"Richiesta nuova (online)","NEU_PAPIER_ANLAUFSTELLE":"Richiesta nuova (cartaceo)","NEU_PAPIER_FS":"Richiesta nuova (cartaceo; FS)","IMPORTIERT":"Importato","IN_BEARBEITUNG_ANLAUFSTELLE":"In elaborazione presso il punto di riferimento","IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS":"In elaborazione presso fondssuisse per rifiuto","AUFTRAG_SCHAETZER":"Mandato al perito","SCHAETZUNG_DURCHGEFUEHRT":"Stima ultimata","IN_BEARBEITUNG_FS":"In elaborazione presso fondssuisse","INAKTIV":"inattivo","UEBERPRUEFUNG_ANLAUFSTELLE":"Verifica presso i punti di riferimento","UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS":"In elaborazione presso fondssuisse per rifiuto","UEBERPRUEFUNG_FONDSSUISSE":"Verifica presso fondssuisse","WIEDERHERSTELLUNG":"Ripristino","UEBERPRUEFUNG_SCHAETZER":"Verifica presso il perito","SCHADEN_BEHOBEN_ABRECHNEN":"Danno eliminato, liquidare.","ABGELEHNT_ANLAUFSTELLE":"Respinto dal punto di riferimento","ABGELEHNT_FONDSSUISSE":"Respinto da fondssuisse","EIGENLEISTUNG_LOESCHEN":"Siete certi di voler cancellare la prestazione propria?","EIGENLEISTUNG_BETRAG_BERECHTIGT":"Importo calc.","SCHADEN_BEHOBEN":"Danno eliminato","ABRECHNEN":"Liquidare","AUSZAHLUNG":"Pronto per il pagamento pagamento","ABGESCHLOSSEN":"Concluso","ABGELEHNT":"Respinto","GRUNDEIGENTUEMER":"Proprietario del fondo","PAECHTER":"Affittuario","GENOSSENSCHAFT":"Società cooperativa","TSEigentumsverhaeltnis_PAECHTER":"Affittuario","TSEigentumsverhaeltnis_GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER":"Proprietario del fondo quale coltivatore diretto","TSEigentumsverhaeltnis_GRUNDEIGENTUEMER":"Proprietario del fondo con affittuario","ANDERE_KOERPERSCHAFT":"Altra corporazione","NATUERLICHE_PERSON":"Persona fisica","MEHRPERSONENGESELLSCHAFT":"Società pluripersonale","MEINE_SCHADENFAELLE":"I miei casi di danno","NICHT_ZUGETEILT":"Non assegnato","OFFENE":"Pendenti","ABGESCHLOSSENE":"Chiusi","FALL":"Caso","GESUCHSTELLER":"Richiedente","EREIGNIS":"Evento","ANLAUFSTELLE":"Punto di riferimento","ORT":"Luogo","DATUM":"Data","STATUS":"Stato","VERANTWORTLICHER":"Responsabile","EIGENTUMSVERHAELTNISSE_GESUCHSTELLER":"Assetto proprietario del richiedente","EIGENTUMSVERHAELTNISSE_VERSICHERTER":"Assetto proprietario dell'assicuratore","EIGENTUMSVERHAELTNISSE_TITLE":"Assetto proprietario","KONTAKTANGABEN_GESUCHSTELLER":"Dati di contatto del richiedente","KONTAKTANGABEN_TITLE":"Dati di contatto","KORRESPONDENZSPRACHE":"Lingua di corrispondenza","SPRACHE":"Lingua","STRASSE":"Via","PLZ":"NPA","EMAIL":"E-mail","EMAIL_VERIFIED":"Il vostro conto utente è stato attivato. Ora potete effettuare il log in.","ADRESSE_STRASSE":"Via","ADRESSE_HAUSNUMMER":"Numero civico","ADRESSE_PLZ":"NPA","ADRESSE_ORT":"Luogo","ADRESSE_ZUSATZ":"Recapito supplementare","TELEFON":"Telefono (cellulare o fisso)","ANREDE":"Appellativo","HERR":"Signor","FRAU":"Signora","FINANZIELLE_VERHAELTNISSE":"Situazione finanziaria","STEUERJAHR":"Anno fiscale","STEUERBARES_EINKOMMEN":"Reddito imponibile","STEUERBARES_VERMOEGEN":"Sostanza imponibile","GEWINN":"Utile","KAPITAL":"Capitale","ZUSTIMMUNG_STEUERPRUEFUNG":"Autorizzo il Comune / il Cantone a controllare i fattori di tassazione, risp. a integrarli nella richiesta a fondssuisse e memorizzarli nel portale per la notifica dei danni.","ZUSTIMMUNG_PRUEFUNG_FONDSUISSE":"Accetto che le dichiarazioni e le informazioni in relazione alla domanda di finanziamento possano essere raccolti, verificati e trasmessi a fondssuisse da tutti gli enti / uffici coinvolti.","ZUSTIMMUNG_PRUEFUNG_FONDSUISSE_GENOSSENSCHAFT":"Accetto che le dichiarazioni e le informazioni in relazione alla domanda di finanziamento possano essere raccolti, verificati e trasmessi a fondssuisse da tutti gli enti / uffici coinvolti.","BANKANGABEN":"Coordinate bancari","KONTAKTANGABEN_EIGENTUEMER":"Dati di contatto del proprietario","NEUER_SCHADENFALL":"Nuovo caso di danno","ANGABEN_ZUR_GENOSSENSCHAFT":"Dati concernenti la società cooperativa","ANGABEN_ZUR_GESELLSCHAFT":"Dati concernenti la società","ANGABEN_ZUR_TITLE":"Dati concernenti {{title}}","KONTAKTANGABEN_GENOSSENSCHAFT":"Dati di contatto della società cooperativa","KONTAKTANGABEN_KOERPERSCHAFT":"Dati di contatto della corporazione","STEUERPFLICHT_GESELLSCHAFT":"La società è imponibile fiscalmente","NICHT_STEUERPFLICHT_GESELLSCHAFT":"La società non è imponibile fiscalmente","STEUERPFLICHT_GENOSSENSCHAFT":"La società cooperativa è imponibile fiscalmente","NICHT_STEUERPFLICHT_GENOSSENSCHAFT":"La società cooperativa non è imponibile fiscalmente","GENOSSENSCHAFT_NAME":"Nome della società cooperativa","GESELLSCHAFT_NAME":"Nome della società","ANGABEN_ZUR_KOERPERSCHAFT":"Indicazioni concernenti la corporazione","ART_DER_KOERPERSCHAFT":"Tipo di corporazione","EINZELNE_STEUERPLICHTGE_PERSONEN":"La corporazione è composta da singole persone imponibili fiscalmente.","KOLLEKTIVE_STEUERPFLICHT":"La corporazione è un ente collettivo ed è imponibile fiscalmente.","KOERPERSCHAFT_NICHT_STEUERPFLICHTIG":"La corporazione non è imponibile fiscalmente.","MINIMAL_SCHADEN":"Sulla base della situazione reddituale e patrimoniale sono effettuate delle deduzioni sul danno. La vostra deduzione ammonta a CHF {{abzug}}.-","MINIMAL_SCHADEN_EINKOMMEN":"In caso di reddito superiore a CHF 200'000.-, il diritto all'indennizzo decade.","MINIMAL_SCHADEN_VERMOEGEN":"In caso di sostanza superiore a CHF 2'000'000.-, il diritto all'indennizzo decade.","MINIMAL_SCHADEN_VERMOEGEN_2026":"In caso di sostanza superiore a CHF 2'500'000.-, il diritto all'indennizzo decade.","FRUEHERER_SCHADENFALL":"Ho già annunciato in precedenza un caso di danno.","FRUEHERER_SCHADENFALL_PAPIER":"La persona interessata ha già annunciato in precedenza un caso di danno?","DAS_GESUCH":"Il danno","DIE_SCHAETZUNG":"La stima del danno","DIE_AUFWAENDE":"Le spese","SCHADENEREIGNIS":"Evento dannoso","SCHADENORT":"Luogo del danno (Comune)","START_TYPING":"Se avete delle proposte ... segnalatecele qui.","NEUER_SCHADEN":"Nuovo danno","DIE_SCHAEDEN":"I danni","SCHADEN_NAME":"Danno concernente {{objekt}} del {{datum}}","BEITRAG_READONLY":"Importo {{art}} del {{datum}}","SCHADEN":"Danni","GENAUER_ORT":"Luogo esatto del danno","VERSICHERUNG_VORHANDEN":"Ho un'assicurazione per questa parcella.","VERSICHERUNG_GEMELDET":"Ho già annunciato il danno alla mia assicurazione.","DATUM_STICHTAG":"Data del danno","PARZELLENNUMMER":"Parcella no.","ART_DES_SCHADENDS":"Genere del danno","SCHADEND_OBJEKT":"Oggetto danneggiato","SCHADEN_VORGESEHENE_MASSNAHMEN":"Breve descrizione, misure previste","ERROR_NO_SCHADEN_VORGESEHENE_MASSNAHMEN":"Breve descrizione, misure previste manca","BESCHRIEB":"Descrizione","GESCHAETZTE_KOSTEN":"Costi stimati in CHF","GESCHAETZTER_MEHRWERT":"Valore aggiunto stimato / deduzione non imponibile [%]","BERECHNUNGSDETAIL_ANSCHAUEN":"Visualizzare il dettaglio del calcolo","HINZUFUEGEN":"Aggiungere allegato","LABEL_JA":"sì","LABEL_OK":"OK","LABEL_NEIN":"no","FILE_LOESCHEN":"Siete certi di voler cancellare il documento?","FILE_ZU_GROSS":"File troppo grande. La dimensione massima consentita è di 10 MB.","FILETYPE_NICHT_ERLAUBT":"Questo tipo di file non è consentito.","SCHADEN_HINZUFUEGEN":"Aggiungere danno","SCHADEN_ERSTELLEN":"Aggiungere descrizione danno","SCHADEN_LOESCHEN":"Cancellare danno","SCHADEN_SPEICHERN":"Memorizzare danno","BERECHNUNGSDETAIL_TOTAL":"Totale deduzioni","VORLEISTUNGEN":"Prestazioni anticipate","VORLEISTUNG_ART":"Genere/Tipo","VORLEISTUNG_POLICE_NR":"Polizza no.","VORLEISTUNG_LOESCHEN":"Siete certi di voler cancellare questa prestazione anticipata?","BILDER_DOKUMENTE":"Immagini & documenti","BILDER_DOKUMENTE_WIEDERHERSTELLUNG":"Immagini & documenti - Costi di ripristino","UPLOAD_TEXT":"Per favore caricare foto, rapporti e offerte.","KULTURLAND":"Terre coltivabili","OBSTBAUM_REBSTOECKE":"Alberi fruttiferi, ceppi di vite","STRASSEN_WEGE":"Strade, sentieri","BRUECKEN_DURCHLAESSE":"Ponti, tombini e travacconi","UFER_BACHBAUTEN":"Argini e opere di consolidamento dei letti dei torrenti","STUETZMAUER_REBMAUERN":"Muri di sostegno, muri nei vigneti","STEUERDATEN_GEPRUEFT":"I dati fiscali del richiedente sono corretti e verificati.","HAUSUMSCHWUNG":"Spazio circostante la casa","EINFRIEDUNG":"Recinzione","LEITUNGEN_AUSSERHALB_DER_GEBAEUDE":"Condotte esterne agli edifici","WALD":"Bosco","KULTURART":"Genere di coltivazione","FLAECHE_ARE":"Superfici colpite (are)","HOLZ_MENGE":"Quantitativo legname (m3)","FLAECHE_M2":"Superficie (m2)","ANZAHL":"Numero","SORTE":"Specie","ALTER":"Altezza (ca.)","LETZTEINSTANDSTELLUNG":"Ultimo ripristino (anno)","LAENGE":"Lunghezza (m)","BREITE":"Larghezza (m)","HOEHE":"Altezza (m)","KOORDINATEN":"Coordinate","BAUART":"Genere di costruzione","SCHADEN_MATERIAL":"Materiale (m3)","ART":"Genere","AUFWAENDE":"Spese","SCHADENFALL":"Caso di danno","ZURUECK":"indietro","SCHAETZUNG":"Stima","EIGENLEISTUNGEN":"Prestazioni proprie","EIGENLEISTUNG":"Prestazione propria","TOTAL":"Totale","OFFERTEN":"Offerte","FREMDKOSTEN":"Spese di terzi","BEZEICHNUNG":"Indicazione","POSITION_AUF_KARTE":"Posizione sulla mappa","SET_MARKER":"Vogliate indicare il luogo esatto del danno sulla mappa.","SET_MARKER_READONLY":"Luogo del danno sulla mappa (non può essere modificato)","CREATE_PROFIL":"Allestire profilo utente","IHR_ABZUG":"La vostra deduzione","MAP_HELPTEXT":"Per visualizzare più dettagli sulla mappa, vogliate attivare lo zoom. Per indicare la posizione del danno, è possibile inserire un marker cliccando sulla mappa.","SCHADENFALL_STATUS_CHANGED":"Lo stato è cambiato","SCHADENFALL_CREATED":"Il caso di danno è stato creato nel sistema.","SYSTEM_MELDUNG":"Notifica dal sistema","BEMERKUNGEN":"Osservazioni","BEMERKUNG":"Osservazione","BEMERKUNG_ERFASSEN":"Registrare l'osservazione","BEMERKUNG_UPDATE":"Aggiornare l'osservazione","NEUE_BEMERKUNG_ERFASSEN":"Registrare nuova osservazione","BEMERKUNG_REMOVE":"Siete certi di voler cancellare l'osservazione?","STATUS_CHANGE_HISTORY":"Incaricati","MITTEILUNGEN_NOCH_KEINE":"Non è ancora stata registrata nessuna osservazione.","ABBRECHEN":"interrompere","AUSFUEHREN":"Eseguire","FREIGABE_BEMERKUNG_TEXT":"Il caso di danno adempie tutti i criteri. Accettare e comunicare l'approvazione per il ripristino al richiedente.","FREIGABE_BEMERKUNG_GESUCHSTELLER_TEXT":"Se avete approvato il caso di danno, la fattispecie sarà inoltrata al punto di riferimento competente per l'ulteriore elaborazione. In seguito non potrete più apportare nessuna modifica. Siete certi di voler approvare?","FREIGABE_BEMERKUNG_ANLAUFSTELLE_TEXT":"Il caso di danno è stato approvato e sarà in seguito reperibile nell'elenco dei casi di danno per l'ulteriore elaborazione.","BEGRUENDUNG":"Motivazione","STATUSUEBERGANG_VON":"Modifica dello stato da","NACH":"a","TSBegruendungsCode_BG_1_kurz":"Considerare la richiesta","TSBegruendungsCode_BG_1_lang":"Considerare la richiesta","TSBegruendungsCode_BG_10_kurz":"pagato","TSBegruendungsCode_BG_10_lang":"pagato","TSBegruendungsCode_BG_11_kurz":"Pagamento in acconto, il resto secondo liquidazione.","TSBegruendungsCode_BG_11_lang":"Pagamento in acconto. La parte rimanente dell'indennizzo sarà pagata alla presentazione del conteggio.","TSBegruendungsCode_BG_12_kurz":"Parte coperta dal'Assicurazione Grandine Svizzera","TSBegruendungsCode_BG_12_lang":"Una parte è coperta dalla Società Svizzera d'Assicurazione contro la Grandine, società cooperativa.","TSBegruendungsCode_BG_13_kurz":"Parte coperta da prestazioni assicurative","TSBegruendungsCode_BG_13_lang":"Una parte del danno è coperta dalle prestazioni assicurative.","TSBegruendungsCode_BG_14_kurz":"Indennizzo ridotto, in parte assicurabile","TSBegruendungsCode_BG_14_lang":"Indennizzo ridotto, si tratta di un danno in parte assicurabile.","TSBegruendungsCode_BG_15_kurz":"Indennizzo a favore dell'affittuario, parte residua a carico del proprietario","TSBegruendungsCode_BG_15_lang":"Indennizzo a favore dell'affittuario. A nostro parere, il proprietario deve farsi carico della parte residua del danno.","TSBegruendungsCode_BG_16_kurz":"Non tutte le persone interessate hanno diritto a un contributo","TSBegruendungsCode_BG_16_lang":"Secondo le nostre direttive, non tutti le persone interessate o assoggettate ai contributi perimetrali possono essere presi in considerazione.","TSBegruendungsCode_BG_17_kurz":"Eccezione, la deduzione R/S escluderebbe il contributo","TSBegruendungsCode_BG_17_lang":"Preso in considerazione quale eccezione, poiché in considerazione del reddito e/o della sostanza non potrebbe essere concesso nessun contributo.","TSBegruendungsCode_BG_18_kurz":"Eccezione, il danno non sarà più considerato in futuro.","TSBegruendungsCode_BG_18_lang":"Ai sensi di un'eccezione; in futuro danni del genere non saranno più presi in considerazione.","TSBegruendungsCode_BG_19_kurz":"Eccezione senza valore di precedente per futuri casi analoghi","TSBegruendungsCode_BG_19_lang":"Ai sensi di un'eccezione e senza valore di precedente per futuri casi analoghi.","TSBegruendungsCode_BG_20_kurz":"Danni non aventi diritto al contributo","TSBegruendungsCode_BG_20_lang":"Danni non aventi diritto al contributo.","TSBegruendungsCode_BG_21_kurz":"Danni non considerati","TSBegruendungsCode_BG_21_lang":"Danni non considerati (\"Direttive\" art. 11 - 13).","TSBegruendungsCode_BG_22_kurz":"Danni assicurabili","TSBegruendungsCode_BG_22_lang":"Si tratta di un danno assicurabile (\"Direttive\" art. 11).","TSBegruendungsCode_BG_23_kurz":"Danni insignificanti (nessun LR o da parte di terzi)","TSBegruendungsCode_BG_23_lang":"Il danno è insignificante (non è stato eseguito nessun lavoro di ripristino) oppure è stato eliminato da terzi.","TSBegruendungsCode_BG_24_kurz":"Non causato da un evento naturale o da un terzo.","TSBegruendungsCode_BG_24_lang":"Il danno non è stato causato da un evento naturale o da un terzo.","TSBegruendungsCode_BG_25_kurz":"Coperto da altri contributi o dall'assicurazione","TSBegruendungsCode_BG_25_lang":"Il danno è coperto da sussidi o da altri contributi.","TSBegruendungsCode_BG_26_kurz":"Movimenti artificiali del terreno/intervento dell'uomo","TSBegruendungsCode_BG_26_lang":"Danni conseguenti a movimenti artificiali del terreno, impianti difettosi o altri interventi diretti o indiretti da parte dell'uomo.","TSBegruendungsCode_BG_27_kurz":"Danni a carico di un manufatto in costruzione","TSBegruendungsCode_BG_27_lang":"Danno a carico di un manufatto in costruzione.","TSBegruendungsCode_BG_28_kurz":"Danni che si ripetono a intervalli ravvicinati","TSBegruendungsCode_BG_28_lang":"Danni che si ripetono a intervalli ravvicinati (\"Direttive\" art. 12, capoverso 3).","TSBegruendungsCode_BG_29_kurz":"Danni prevedibili","TSBegruendungsCode_BG_29_lang":"Il danno era prevedibile, avrebbe potuto essere evitato adottando per tempo misure ragionevoli (manutenzione insufficiente o cura carente).","TSBegruendungsCode_BG_30_kurz":"Fenomeni atmosferici che si protraggono nel tempo","TSBegruendungsCode_BG_30_lang":"Danni non riconducibili a fenomeni atmosferici di violenza straordinario o riconducibili a fenomeni atmosferici che si protraggono nel tempo.","TSBegruendungsCode_BG_31_kurz":"Organismi nocivi animali o vegetali","TSBegruendungsCode_BG_31_lang":"Danni provocati da organismi nocivi animali o vegetali.","TSBegruendungsCode_BG_32_kurz":"Bosco: pressione della neve, grandine o incendi","TSBegruendungsCode_BG_32_lang":"I danni al bosco causati dalla pressione della neve, dalla grandine o dagli incendi non vengono considerati (\"Direttive\", art. 12, capoverso 7).","TSBegruendungsCode_BG_33_kurz":"Singole piante forestali non vengono indennizzate","TSBegruendungsCode_BG_33_lang":"Singole piante forestali non vengono indennizzate.","TSBegruendungsCode_BG_34_kurz":"Siccità, umidità (rigurgito d'acqua dalle canalizzazioni), gelo","TSBegruendungsCode_BG_34_lang":"I danni che insorgono a seguito di siccità, umidità (rigurgito d'acqua dalle canalizzazioni) o gelo non vengono considerati (\"Direttive\" art. 12)","TSBegruendungsCode_BG_35_kurz":"Slittamento di ghiaia su strade e piazze","TSBegruendungsCode_BG_35_lang":"Lo slittamento di ghiaia su strade e piazze non è indennizzato.","TSBegruendungsCode_BG_36_kurz":"Deprezzamento gen. / perdita di salario e guadagno","TSBegruendungsCode_BG_36_lang":"Il deprezzamento generale di un fondo, nonché la perdita di salario e guadagno che sono in relazione a un evento dannoso non possono essere indennizzati.","TSBegruendungsCode_BG_37_kurz":"Normale manutenzione / esclusivamente preventivo","TSBegruendungsCode_BG_37_lang":"La normale manutenzione e le misure puramente preventive non possono essere sostenute.","TSBegruendungsCode_BG_38_kurz":"Sostituito da un'altra notifica dei danni","TSBegruendungsCode_BG_38_lang":"Sostituito da un'altra notifica dei danni.","TSBegruendungsCode_BG_39_kurz":"Inoltrata dopo la decorrenza del termine di notifica di 3 mesi","TSBegruendungsCode_BG_39_lang":"La notifica dei danni è stata inoltrata dopo la decorrenza del termine di notifica di 3 mesi (\"Direttive\" art. 16).","TSBegruendungsCode_BG_40_kurz":"Sinistrati esclusi dai contributi","TSBegruendungsCode_BG_40_lang":"Sinistrati esclusi dai contributi (\"Direttive\" art. 7).","TSBegruendungsCode_BG_41_kurz":"Deduzione R/S superiore al danno accertato","TSBegruendungsCode_BG_41_lang":"La deduzione in base al reddito e/o alla sostanza è superiore all'importo accertato del danno (\"Direttive\" art. 23).","TSBegruendungsCode_BG_42_kurz":"Non avente diritto al contributo poiché R/S troppo elevato(i)","TSBegruendungsCode_BG_42_lang":"Non avente diritto al contributo poiché il reddito e/o la sostanza sono troppo elevati (\"Direttive\" art. 23).","TSBegruendungsCode_BG_45_kurz":"Non avente diritto al contr.; indennizziamo l'affittuario","TSBegruendungsCode_BG_45_lang":"Non avente diritto al contributo; indennizziamo l'affittuario.","TSBegruendungsCode_BG_46_kurz":"Il proprietario deve farsi carico del danno","TSBegruendungsCode_BG_46_lang":"Il proprietario deve farsi carico del danno.","TSBegruendungsCode_BG_47_kurz":"Conteggio/Doc. non ricevuto entro il termine assegnato.","TSBegruendungsCode_BG_47_lang":"Non abbiamo ricevuto il conteggio entro il termine assegnato.","TSBegruendungsCode_BG_48_kurz":"Il danno non raggiunge l'importo minimo","TSBegruendungsCode_BG_48_lang":"Il danno non raggiunge l'importo minimo (\"Direttive\" art. 22).","TSBegruendungsCode_BG_49_kurz":"ammortizzato","TSBegruendungsCode_BG_49_lang":"La superficie danneggiata proiettata su un grado di danno del 100% è inferiore a 25 are.","TSBegruendungsCode_BG_50_kurz":"Fattori di tassazione mancanti","TSBegruendungsCode_BG_50_lang":"Ci occorrono i fattori di tassazione (reddito e sostanza, previa deduzione dei contributi sociali).","TSBegruendungsCode_BG_52_kurz":"Solo ripartizione fiscale / ci occorrono i fattori del domicilio","TSBegruendungsCode_BG_52_lang":"È stata indicata solo la ripartizione fiscale. Ci occorrono i fattori di tassazione del domicilio.","TSBegruendungsCode_BG_54_kurz":"Nomi/fattori di tassazione di ogni fratello/sorella","TSBegruendungsCode_BG_54_lang":"Ci occorrono i nominativi e i fattori di tassazione di ogni fratello / sorella.","TSBegruendungsCode_BG_55_kurz":"Nomi / fattori di tassazione dei singoli eredi","TSBegruendungsCode_BG_55_lang":"Ci occorrono i nominativi e i fattori di tassazione dei singoli eredi.","TSBegruendungsCode_BG_56_kurz":"Fattori di tassazione degli eredi o dell'usufruttuario","TSBegruendungsCode_BG_56_lang":"Ci occorrono i fattori di tassazione dei singoli eredi o dell'usufruttuario, se quest'ultimo deve farsi carico da solo del danno.","TSBegruendungsCode_BG_57_kurz":"Fattori di tassazione dei singoli interessati","TSBegruendungsCode_BG_57_lang":"Ci occorrono i fattori di tassazione dei singoli interessati / soggetti ai contributi perimetrali.","TSBegruendungsCode_BG_58_kurz":"Notificare i fattori al passaggio in giudicato della nuova tassazione","TSBegruendungsCode_BG_58_lang":"Vogliate notificare i fattori di tassazione non appena la nuova tassazione sarà passata in giudicato.","TSBegruendungsCode_BG_59_kurz":"Inversione nella registrazione dei fattori di tassazione?","TSBegruendungsCode_BG_59_lang":"A nostro parere, nella notifica dei danni, c'è stata un'inversione nella registrazione dei fattori di tassazione. Vogliate notificarli nuovamente.","TSBegruendungsCode_BG_62_kurz":"Ci occorre una stima approssimativa dei danni","TSBegruendungsCode_BG_62_lang":"Ci occorre una stima approssimativa dei danni ai sensi dell'art. 18 delle \"Direttive\" (descrizione dettagliata del danno, ev. schizzo o fotografie, presumibili spese di ripristino).","TSBegruendungsCode_BG_66_kurz":"Progetto di sussidio, attendiamo il conteggio finale","TSBegruendungsCode_BG_66_lang":"Progetto di sussidio. Alla conclusione dei lavori, attendiamo il conteggio finale. Se i costi residui saranno assunti da più interessati, si deve allegare la chiave di ripartizione dei costi.","TSBegruendungsCode_BG_69_kurz":"Deve essere trattato dal servizio forestale","TSBegruendungsCode_BG_69_lang":"Il danno deve essere trattato dal servizio forestale. Saranno considerati solo i casi di rigore (se i costi di preparazione e sgombero non possono essere coperti dai sussidi e dal ricavo dalla vendita del legname).","TSBegruendungsCode_BG_70_kurz":"Ci occorre il conteggio con i documenti giustificativi","TSBegruendungsCode_BG_70_lang":"Per la fissazione dell'indennizzo, successivamente all'esecuzione dei lavori, attendiamo un conteggio dettagliato: elenco delle ore di lavoro manuale e di impiego di macchinari, copia delle fatture e dei giustificativi di pagamento. Questi dettagli e documenti vi preghiamo d’inserirli nella voce di menu sotto “Spese” e vi preghiamo di caricare i documenti necessari. Se i costi rimanenti vengono sostenuti da più parti, vi preghiamo di caricare anche un documento con l’appropriato ripartitore di costi. Nel caso di progetti di sussidi, abbiamo bisogno della garanzia di contribuzione e del regolamento dei contributi. I lavori di ripristino, devono essere eseguiti dal danneggiato con mezzi propri, nella misura in cui ciò è ragionevole e sensato. Ulteriori informazioni e modulo su: <a href='https://www.fondssuisse.ch' target='_blank'>www.fondssuisse.ch</a>","TSBegruendungsCode_BG_71_kurz":"Ci occorrono le fatture / i giustificativi di pagamento","TSBegruendungsCode_BG_71_lang":"Per la fissazione dell'indennizzo ci occorrono le fatture quietanzate dell'impresa e/o del materiale, risp. i giustificativi di pagamento della fattura.","TSBegruendungsCode_BG_72_kurz":"Ci occorrono il conteggio (prestazione propria, spese di terzi)","TSBegruendungsCode_BG_72_lang":"Per la fissazione dell'indennizzo ci occorre un conteggio dettagliato concernente i lavori di ripristino eseguiti: elenco delle ore di lavoro manuale e di impiego di macchinari, copie di fatture e giustificativi di pagamento. Informazioni e modulo \"Rapporto di lavoro\": www.fondssuisse.ch","TSBegruendungsCode_BG_73_kurz":"Ci occorre il conteggio dei sussidi","TSBegruendungsCode_BG_73_lang":"Per la fissazione dell'indennizzo ci occorre un conteggio dettagliato con i documenti giustificativi: costi totali, sussidi della Confederazione, del Cantone e/o del Comune / costi residui a carico degli interessati.","TSBegruendungsCode_BG_74_kurz":"Ci occorre il conteggio dell'assicurazione contro i danni della grandine","TSBegruendungsCode_BG_74_lang":"Per la fissazione dell'indennizzo ci serve un conteggio dettagliato (costi totali e prestazione dell'assicurazione contro i danni della grandine, allegate anche il conteggio dell'assicurazione contro i danni della grandine).","TSBegruendungsCode_BG_75_kurz":"Attendiamo di ricevere il conteggio.","TSBegruendungsCode_BG_75_lang":"Attendiamo di ricevere il conteggio.","TSBegruendungsCode_BG_76_kurz":"Ci occorre l'offerta concernente il ripristino","TSBegruendungsCode_BG_76_lang":"Vi preghiamo di trasmetterci un'offerta concernente il ripristino.","TSBegruendungsCode_BG_79_kurz":"Impossibilità di fissare l'importo, chiarimenti","TSBegruendungsCode_BG_79_lang":"Sulla base delle indicazioni / della documentazione in nostro possesso non è ancora possibile fissare l'indennizzo.","TSBegruendungsCode_BG_80_kurz":"Parte del danno è coperta dall'assicurazione?","TSBegruendungsCode_BG_80_lang":"Vogliate chiarire se perlomeno una parte del danno sarà coperta da prestazioni assicurative.","TSBegruendungsCode_BG_81_kurz":"Deve essere annunciato all'assicurazione contro i danni della grandine","TSBegruendungsCode_BG_81_lang":"Il danno deve essere annunciato all'assicurazione contro i danni della grandine.","TSBegruendungsCode_BG_82_kurz":"Deve essere annunciato all'assicurazione mobiliare.","TSBegruendungsCode_BG_82_lang":"Il danno deve essere annunciato all'assicurazione mobiliare.","TSBegruendungsCode_BG_83_kurz":"Deve essere annunciato all'assicurazione stabili","TSBegruendungsCode_BG_83_lang":"Il danno deve essere annunciato all'assicurazione stabili.","TSBegruendungsCode_BG_84_kurz":"Danno coperto dall'assicurazione contro i danni della grandine?","TSBegruendungsCode_BG_84_lang":"Il danno sarà coperto (perlomeno parzialmente) dalla Società Svizzera d'Assicurazione contro la Grandine?","TSBegruendungsCode_BG_85_kurz":"Ripristino sussidiabile?","TSBegruendungsCode_BG_85_lang":"I lavori di ripristino possono essere sussidiati dalla Confederazione, dal Cantone e/o dal Comune?","TSBegruendungsCode_BG_86_kurz":"Notificare il danno all'ufficio delle bon. fond., ev. sussidiabile","TSBegruendungsCode_BG_86_lang":"Vogliate notificare il danno all'ufficio delle bonifiche fondiarie, eventuale sussidiabilità dei lavori di ripristino.","TSBegruendungsCode_BG_87_kurz":"A nostro avviso, il Comune dovrebbe partecipare ai LR","TSBegruendungsCode_BG_87_lang":"A nostro avviso, il Comune dovrebbe partecipare ai lavori di ripristino. Vi preghiamo di farci avere la vostra presa di posizione.","TSBegruendungsCode_BG_90_kurz":"Parte a carico del proprietario, -> comunicare i fattori di tassazione","TSBegruendungsCode_BG_90_lang":"Abbiamo verificato la richiesta e attendiamo il conteggio. Costi max. computabili: 1'000.-.","TSBegruendungsCode_BG_91_kurz":"Parte a carico del proprietario -> nominativo e fattori di tassazione","TSBegruendungsCode_BG_91_lang":"A nostro avviso, il danno deve essere assunto perlomeno parzialmente dal proprietario. Vi preghiamo di indicare il suo nominativo, l'indirizzo e i fattori di tassazione.","TSBegruendungsCode_BG_92_kurz":"Parte a carico del proprietario, -> presa di posizione","TSBegruendungsCode_BG_92_lang":"A nostro avviso, il danno deve essere assunto perlomeno parzialmente dal proprietario (ad. es. lavori eseguiti da un'impresa, perdita di terre coltivabili). Vi preghiamo di trasmetterci la vostra presa di posizione.","TSBegruendungsCode_BG_93_kurz":"Termine di 3 mesi per il conteggio","TSBegruendungsCode_BG_93_lang":"A tutt'oggi non abbiamo ricevuto il conteggio. In assenza di una vostra contro-relazione entro tre mesi, riterremo evasa la richiesta.","TSBegruendungsCode_BG_95_kurz":"Attendiamo la vostra relazione","TSBegruendungsCode_BG_95_lang":"Attendiamo la vostra relazione.","TSBegruendungsCode_BG_98_kurz":"Alberi da frutto distrutti -> conferma del nuovo impianto.","TSBegruendungsCode_BG_98_lang":"Gli alberi da frutto distrutti saranno indennizzati quando sarà avvenuto il nuovo impianto. Attendiamo la relativa conferma.","TSBegruendungsCode_BGN_10_kurz":"10 - Nomi e dati fiscali di ogni proprietario interessato","TSBegruendungsCode_BGN_10_lang":"Ci occorrono i fattori di tassazione dei singoli  \n- fratelli o sorelle. \n- eredi. \n- eredi o dell’usufruttuario, se quest’ultimo deve farsi carico da solo del danno. \n- interessati / soggetti ai contributi perimetrali. \n\nVi preghiamo di caricare i documenti menzionati nel portale dei danni.","TSBegruendungsCode_BGN_11_kurz":"11 - In parte a carico del proprietario, comunicare i fattori di tassazione / presa di posizione","TSBegruendungsCode_BGN_11_lang":"A nostro avviso, il danno deve essere assunto perlomeno parzialmente dal proprietario. Vi preghiamo di indicare il suo nominativo, l’indirizzo e i fattori di tassazione e di caricare i documenti menzionati nel portale dei danni.\n\nA nostro avviso, il danno deve essere assunto perlomeno parzialmente dal proprietario (ad. es. lavori eseguiti da un’impresa, perdita di terre coltivabili.) Vi preghiamo di trasmetterci la vostra presa di posizione.","TSBegruendungsCode_BGN_12_kurz":"12 - Distinta degli interessati con la loro quota percentuale","TSBegruendungsCode_BGN_12_lang":"Necessità farci avere la distinta degli interessati con la loro quota percentuale.\n\nNecessità farci avere lo statuto e la distinta degli interessati con la loro quota percentuale. Chi è responsabile per la manutenzione della strada di accesso?\n\nPer la decisione al contributo da versare occorrerà presentare la distinta delle ripartizioni con la quota percentuale come anche dopo l'esecuzione dei lavori il conto finale dettagliato.","TSBegruendungsCode_BGN_20_kurz":"20 - Stima incompleta, occorrono ulteriori informazioni / offerta","TSBegruendungsCode_BGN_20_lang":"Abbiamo bisogno di ulteriori informazioni / documenti: descrizione più dettagliata del danno, foto, valutazione del danno.\n\nVi preghiamo di trasmetterci un’offerta concernente il ripristino. \n\nVi preghiamo di caricare i documenti menzionati nel portale dei danni.","TSBegruendungsCode_BGN_21_kurz":"21 - Stima alta, soluzione meno costosa possibile?","TSBegruendungsCode_BGN_21_lang":"I costi di restauro stimati sono troppo alti. Non sarebbe possibile una soluzione meno costosa?\n\nLe misure di ripristino devono – per quanto ragionevoli – essere eseguite dall’ interessato, con i mezzi propri.\n\nI costi stimati appaiono molto elevati per l’area specificata (valore degli utili). Vi preghiamo di giustificarlo. Senza una motivazione valida, utilizzeremo i valori empirici per quest’ area.\n\nI costi di ripristino stimati sono troppo elevati in relazione al valore di rendimento dell’area danneggiata. Possiamo contare solo la metà dell’importo stimato. Sarebbe possibile una soluzione più economica?\n\nVi consigliamo di richiedere ulteriori offerte / una seconda offerta.\n\n…i costi di ripristino stimati, sembrano essere troppo elevati rispetto al valore reddituale del suolo (superfice danneggiata).\n\n…troppo alto, rispetto al valore degli utili danneggiati.\n\n…in nessun modo in relazione all’ area danneggiata o al percorso danneggiato.\n\n…troppo elevato rispetto alle dimensioni della terra culturale perduta.\n\n…è necessario trovare una soluzione meno costosa.\n\n…eventualmente solo una riparazione parziale?\n\n…In determinate circostanze, il richiedente può partecipare ai lavori e quindi ridurre i costi totali mediante lavori ausiliari.","TSBegruendungsCode_BGN_22_kurz":"22 - Parte coperta dall’ Assicurazione?","TSBegruendungsCode_BGN_22_lang":"Vi preghiamo di chiarire, se almeno una parte del danno é coperta dalle prestazioni assicurative.\n\nIl danno deve essere annunciato presso l’ Assicurazione Grandine Svizzera / Assicurazione Privata / della casa / mobiliare.\n\nIl danno è coperto (almeno in parte) dall’ Assicurazione Grandine Svizzera?","TSBegruendungsCode_BGN_23_kurz":"23 - Ripristino sovvenzionabile? / Partecipazione del Comune?","TSBegruendungsCode_BGN_23_lang":"I lavori di ripristino possono essere sovvenzionati dalla Confederazione, dal Cantone e/o dal Comune?\n\nVogliate notificare il danno all’ufficio delle bonifiche fondiarie, eventuale sussidiabilità dei lavori di ripristino.\n\nA nostro avviso, il Comune dovrebbe partecipare ai lavori di ripristino. Vi preghiamo di farci avere la vostra presa di posizione.","TSBegruendungsCode_BGN_30_kurz":"30 - Ci occorre il conteggio con i documenti giustificativi","TSBegruendungsCode_BGN_30_lang":"I lavori di ripristino possono essere eseguiti. Il danno accertato è determinato sulla base dei costi effettivi (conteggio). (Di regola il contributo del fondssuisse ammonta al 80% del danno computabile.) I costi aggiuntivi rispetto al preventivo non possono essere presi in considerazione, se non vengono giustificati.\n\nPer la fissazione dell’indennizzo, successivamente all'esecuzione dei lavori, attendiamo un conteggio dettagliato: elenco delle ore di lavoro manuale e di impiego di macchinari, copia delle fatture e dei giustificativi di pagamento. Questi dettagli e documenti vi preghiamo d’inserirli nella voce di menu sotto Spese e vi preghiamo di caricare i documenti necessari.\n\nSe i costi rimanenti vengono sostenuti da più parti, vi preghiamo di caricare anche un documento con l’appropriato ripartitore di costi. Nel caso di progetti di sussidi, abbiamo bisogno della garanzia di contribuzione e del regolamento dei contributi. I lavori di ripristino devono essere eseguiti dal danneggiato con mezzi propri, nella misura in cui ciò è ragionevole e sensato. Ulteriori informazioni su: www.fondssuisse.ch","TSBegruendungsCode_BGN_31_kurz":"31 - Ci occorre il conteggio dell’assicurazione","TSBegruendungsCode_BGN_31_lang":"Per la fissazione dell’indennizzo, abbiamo bisogno di un conteggio dettagliato (costi totali e prestazione dell’assicurazione contro i danni della grandine, allegate anche il conteggio dell’assicurazione contro i danni della grandine).\nQuesti dettagli e documenti vi preghiamo d’inserirli nella voce di menu sotto Spese e vi preghiamo di caricare i documenti necessari.","TSBegruendungsCode_BGN_34_kurz":"34 - Benötigen Abrechnung – teilweise versicherbar","TSBegruendungsCode_BGN_34_lang":"","TSBegruendungsCode_BGN_32_kurz":"32 - Progetto sovvenzionato, attendiamo il conteggio finale dei sussidi","TSBegruendungsCode_BGN_32_lang":"Progetto sovvenzionato. Alla conclusione dei lavori, attendiamo il conteggio finale con i documenti giustificativi: costi totali, sovvenzionamento della Confederazione, del Cantone e/o del Comune / costi residui a carico degli interessati. Se i costi rimanenti vanno a carico di più interessati, vogliate inviarci la distinta delle ripartizioni dei costi.\nQuesti dettagli e documenti vi preghiamo d’inserirli nella voce di menu sotto Spese e vi preghiamo di caricare i documenti necessari.","TSBegruendungsCode_BGN_33_kurz":"33 - Stima alta, dovrebbe diventare più economica (non pienamente ammissibile)","TSBegruendungsCode_BGN_33_lang":"I costi di ripristino stimati sono molto elevati rispetto all'area di danno specificata. Nell'ambito della nostra pratica contributiva (valori empirici), possiamo pagare un massimo di CHF XXX—per are, cioè riconoscere un massimo di XXX come importo del danno. Al termine dei lavori, attendiamo la fatturazione.\n\n …È improbabile che siamo in grado di riconoscere i costi interi.\n\n…A nostro avviso, i lavori di riparazione dovrebbero essere minimo un quarto in meno.\n\n…Possiamo supportare solo una riparazione con mezzi semplici.\n\n…Valori aggiuntivi rispetto alla condizione precedente (come nuove fondamenta in cemento, retro muri) non possono essere presi pienamente in considerazione\n\n…Miglioramenti e misure precauzionali, non possono essere prese in considerazione dal Fondo.\n\n…Per i danni stagionali ai muri delle vite (gelo e scongelo, vecchiaia) calcoliamo massimo CHF 350.00/m2. L’indennità comprensiva delle prestazioni del Cantone è del 70% o CHF 245.00/m2. \n…Per i danni naturali imprevedibili ai muri delle vite (temporale, frana) calcoliamo massimo Fr.500.00/m2. L’indennità comprensiva delle prestazioni del Cantone è del 70% o CHF 350.00/m2.\n\n…Troppo caro. In relazione al valore di rendimento dell’area interessata, nessuna misura costosa può essere giustificata (vedi direttive fondssuisse art. 19, paragrafi 4 e 9). Potremmo riconoscere al massimo CHF 9'000.00 (contributo del 60% = CHF 5'640.00). \n\n…Sulla base del valore degli utili delle are trasferite, possiamo riconoscere un massimo di CHF 18'000.00 di spese di ripristino, meno CHF 8'600.00 di detrazione del reddito, ammissibili per un massimo di CHF 9'400.00 (contributo 60% = CHF 5'640.00).\n\n…Data l’età e le condizioni della recinzione distrutta, probabilmente possiamo riconoscere al massimo la metà del costo del restauro come danno.\n…Sulla base della descrizione del danno e delle offerte presentate, possiamo consentire al massimo CHF 24'000.00 come danno (contributo 70% incluso Cantone = massimo CHF 16'800.00 ).\n\nQuesti dettagli e documenti vi preghiamo d’inserirli nella voce di menu sotto Spese e vi preghiamo di caricare i documenti necessari.","TSBegruendungsCode_BGN_40_kurz":"40 - Si prega di registrare le spese (fatturazione non registrata / incompleta)","TSBegruendungsCode_BGN_40_lang":"Per determinare il risarcimento, si prega di registrare il costo del ripristino sotto spese. Abbiamo bisogno delle ricevute di pagamento dell’imprenditore e/ o delle fatture del materiale comprato.","TSBegruendungsCode_BGN_41_kurz":"41 - Ci occorrono le fatture / i giustificativi di pagamento","TSBegruendungsCode_BGN_41_lang":"Per la fissazione dell’indennizzo ci occorrono le fatture saldate dell’impresario e/o del materiale, risp. i giustificativi di pagamento della fattura.","TSBegruendungsCode_BGN_42_kurz":"42 - Costo alto / superiore alla stima","TSBegruendungsCode_BGN_42_lang":"I costi di ripristino sono molto elevati, rispetto al valore del reddito.\n\nI costi dichiarati sono molto più elevati della stima originale.\n\nVi preghiamo di darci spiegazioni. Senza giustificazione, baseremo i nostri calcoli alla stima.","TSBegruendungsCode_BGN_43_kurz":"43 - Il contributo non può essere determinato, chiarimento.","TSBegruendungsCode_BGN_43_lang":"Sulla base delle informazioni / dei documenti disponibili, il contributo non può essere ancora determinato. \n… \nVi preghiamo di caricare i documenti necessari nel portale dei danni.","TSBegruendungsCode_BGN_60_kurz":"60 - Escluso dal contributo / Criteri non adempiati","TSBegruendungsCode_BGN_60_lang":"Sinistrato / danno escluso dal contributo.\n\nRichiesta da non considerare.\n\nAlcuni criteri per adempire al danno non sono stati soddisfatti.","TSBegruendungsCode_BGN_61_kurz":"61 - Danni assicurabili","TSBegruendungsCode_BGN_61_lang":"Si tratta di un danno assicurabile (direttive fondssuisse art. 11).","TSBegruendungsCode_BGN_62_kurz":"62 - Danni insignificanti (nessun LR o da parte di terzi)","TSBegruendungsCode_BGN_62_lang":"Il danno è insignificante (non è stato eseguito nessun lavoro di ripristino) oppure è stato eliminato da terzi.","TSBegruendungsCode_BGN_63_kurz":"63 - Danno non causato da un evento naturale o da un terzo","TSBegruendungsCode_BGN_63_lang":"Il danno non è stato causato da un evento naturale o da un terzo.","TSBegruendungsCode_BGN_64_kurz":"64 - Coperto da altri contributi o dall'assicurazione","TSBegruendungsCode_BGN_64_lang":"Il danno è coperto da sussidi o da altri contributi. \n\nIl danno è coperto dai sussidi dell’Assicurazione Grandine Svizzera.\n\n… La franchigia non viene presa in considerazione (non può essere conteggiato in aggiunta) / Non possiamo accettare la franchigia (direttive fondssuisse art. 11 paragrafo 1, danni assicurabili).\n\nI costi sono coperti quasi al 90% dalle prestazioni assicurative Grandine Svizzera e dal contributo al miglioramento strutturale (vedi direttive fondssuisse art. 19 paragrafo 7) I costi rimanenti sono accettabili, dato il gran numero dei membri.\n\nIl danno è dovuto ai benefici di \n- Conferenza dei capi dei servizi della protezione dell’ambiente della Svizzera (CCA)\n- assicurazione fabbricato\n- coperto dai contributi della Confederazione, del Cantone e del Comune.","TSBegruendungsCode_BGN_65_kurz":"65 - Danni non considerati (art. 12) e ulteriori esclusioni (art. 13)","TSBegruendungsCode_BGN_65_lang":"Danni conseguenti  a movimenti artificiali del terreno, impianti difettosi o altri interventi diretti da parte dell’uomo, come da art. 12 paragrafo 4 direttive fondssuisse, non vengono considerati.\n\nDanno a carico di un manufatto in costruzione non viene considerato (direttive fondssuisse art. 13 paragrafo 2).\n\nIl danno era prevedibile, avrebbe potuto essere evitato adottando per tempo misure ragionevoli (manutenzione insufficiente o cura carente) (direttive fondssuisse art. 12 paragrafo 1).\n\nDanni provocati da organismi nocivi animali o vegetali non vengono considerati (direttive fondssuisse art. 12 paragrafo 5).\n\nI danni al bosco causati dalla pressione della neve, dalla grandine o dagli incendi non vengono considerati (direttive fondssuisse art. 12, paragrafo 7).\n\nSingole piante forestali non vengono indennizzate.\n\nI danni che insorgono a seguito di siccità, umidità (rigurgito d’acqua dalle canalizzazioni) o gelo, non vengono considerati (direttive fondssuisse art. 12 paragrafo 6).\n\nIl deprezzamento generale di un bene immobiliare, come anche la perdita di salario e guadagno che sono in rapporto con danni causati dalla natura, non entrano in considerazione per un contributo (direttive fondssuisse art. 13 paragrafo 1).","TSBegruendungsCode_BGN_66_kurz":"66 - Danni che si ripetono ad intervalli ravvicinati","TSBegruendungsCode_BGN_66_lang":"Danni che si ripetono ad intervalli ravvicinati, direttive fondssuisse art. 12, paragrafo 3, non possono essere considerati.","TSBegruendungsCode_BGN_67_kurz":"67 - Fenomeni che si protraggono nel tempo","TSBegruendungsCode_BGN_67_lang":"Danni non riconducibili a fenomeni atmosferici di violenza straordinario o riconducibili a fenomeni atmosferici che si protraggono nel tempo (direttive fondssuisse art. 12, paragrafo 2).","TSBegruendungsCode_BGN_68_kurz":"68 - Slittamento di ghiaia su strade e piazze","TSBegruendungsCode_BGN_68_lang":"Lo slittamento di ghiaia su strade e piazze non è indennizzato (direttive fondssuisse art. 13, paragrafo 4).","TSBegruendungsCode_BGN_69_kurz":"69 - Normale manutenzione / esclusivamente preventivo","TSBegruendungsCode_BGN_69_lang":"La normale manutenzione e le misure puramente preventive non possono essere sostenute (direttive fondssuisse art. 13).\n\nLa condotta di drenaggio è una misura puramente precauzionale e una nuova installazione, che non possiamo prendere in considerazione (direttive fondssuisse art. 13 paragrafo 6).","TSBegruendungsCode_BGN_70_kurz":"70 - Sinistrati esclusi dai contributi","TSBegruendungsCode_BGN_70_lang":"Sinistrati esclusi dai contributi, vedi direttive fondssuisse art. 7","TSBegruendungsCode_BGN_71_kurz":"71 - Deduzione reddito/sostanza superiore al danno accertato","TSBegruendungsCode_BGN_71_lang":"La deduzione in base al reddito e/o alla sostanza, è superiore all’importo accertato del danno (direttive fondssuisse art. 23).","TSBegruendungsCode_BGN_72_kurz":"72 - Escluso dal contributo causa reddito e/o sostanza troppo elevate","TSBegruendungsCode_BGN_72_lang":"Escluso dal contributo causa reddito e/o sostanza troppo elevata (vedi direttive fondssuisse art. 23).","TSBegruendungsCode_BGN_73_kurz":"73 - Il danno è inferiore all’ammontare minimo stabilito","TSBegruendungsCode_BGN_73_lang":"Il danno è inferiore all’ammontare minimo stabilito di CHF 600.00 rispettivamente di CHF 1’000.00, secondo le direttive fondssuisse art. 22 non ha diritto al contributo.","TSBegruendungsCode_BGN_80_kurz":"80 - Inoltrata dopo la decorrenza del termine di notifica","TSBegruendungsCode_BGN_80_lang":"La notifica dei danni è stata inoltrata dopo la decorrenza del termine di notifica di 3 mesi. Secondo le direttive fondssuisse art. 16 non ha diritto al contributo.","TSBegruendungsCode_BGN_81_kurz":"81 - Sostituita da un’altra notifica dei danni","TSBegruendungsCode_BGN_81_lang":"Sostituita da un’altra notifica di danni. \n\nViene liquidato tramite il caso di danno ...","TSBegruendungsCode_BGN_82_kurz":"82 - Conteggio/Documento non ricevuto","TSBegruendungsCode_BGN_82_lang":"Non abbiamo ricevuto il conteggio e/o i documenti richiesti entro il termine assegnato.","TSBegruendungsCode_BGN_90_kurz":"90 - Contributo ridotto, si tratta di un danno in parte assicurabile","TSBegruendungsCode_BGN_90_lang":"Una parte del danno è coperta dalle prestazioni assicurative.\n\nContributo ridotto, si tratta di und anno in parte assicurabile.","TSBegruendungsCode_BGN_91_kurz":"91 - Contributo ridotto, deduzione valore aggiunto / manutenzione / precauzione","TSBegruendungsCode_BGN_91_lang":"Contributo al ripristino dello stato precedente, meno l’ammontare di\n- precauzione\n- normale manutenzione\n- miglioramento  \n- valore aggiunto/nuovo valore\n(ca. XX%).\n\nDeduzione di ca. il 20% per valore aggiunto / valore nuovo, secondo la nostra conferma.","TSBegruendungsCode_BGN_92_kurz":"92 - Non tutte le persone interessate hanno diritto a un contributo","TSBegruendungsCode_BGN_92_lang":"Secondo le nostre direttive, non tutte le persone interessate o assoggettate ai contributi perimetrali possono essere presi in considerazione. Riceverete un contributo ridotto da parte di fondssuisse. (Non considerato: … con …% quota di costi / Verranno considerate persone private con una quota del …%).","TSBegruendungsCode_BGN_93_kurz":"93 - A titolo eccezionale e senza pregiudizio per futuri casi analoghi","TSBegruendungsCode_BGN_93_lang":"A titolo eccezionale e senza pregiudizio per futuri casi analoghi.","TSBegruendungsCode_BGN_94_kurz":"94 - Conteggio parziale, inserire la seconda richiesta","TSBegruendungsCode_BGN_94_lang":"Inserire una seconda richiesta per questo caso (con riferimento) per le ulteriori spese / prestazioni proprie e il conteggio finale.","NAV_ENTSCHAEDIGUNG":"Indennizzo","BEITRAG_CREATE":"Allestire importo","BEITRAG_ADD":"Aggiungere importo","TSBeitragArt_FONDSSUISSE":"fondssuisse","TSBeitragArt_FONDSSUISSE_2023":"fondssuisse","TSBeitragArt_KANTON":"Cantone","TSBeitragArt_HOCHGEBIRGE":"Regione d'alta montagna","TSBeitragArt_VERSICHERUNG":"Assicurazione","TSBeitragStatus_AUSGEFUEHRT":"Eseguito","TSBeitragStatus_PENDENT":"In sospeso","TSBeitragStatus_NICHT_FREIGEGEBEN":"Non approvato","BEITRAG_ART":"Tipo di contributo","BANKNAME":"Banca","BEITRAEGE":"Contributi","BEITRAG_LOESCHEN":"Siete certi di voler cancellare questo contributo?","BEITRAG_LOESCHEN_BUTTON":"Cancellare il contributo","ERMITTELTER_SCHADEN":"Danno accertato","ERMITTELTER_SCHADEN_SPEICHERN":"Memorizzare il danno accertato","ERMITTELTER_SCHADEN_CHANGED_TEXT":"Il contributo deve essere aggiornato, perché i valori dei danni rilevati sono stati aggiornati.","NICHT_BERECHTIGTER_ANTEIL":"Quota non giustificata (%)","ABRECHNUNGS_BETRAG":"Importo del conteggio","TOTAL_SCHAETZUNG":"Totale stima","ABRECHNUNG":"Conteggio","ABZUG_EINKOMMEN":"Deduzione per reddito / utile","ABZUG_VERMOEGEN":"Deduzione per sostanza / capitale","ABZUG_ANTEIL":"deduzione della quota non giustificata","ABZUG_VORLEISTUNG":"Deduzione per prestazione anticipata","ANRECHENBARER_SCHADEN":"Danno computabile","ENTSCHAEDIGEN":"Indennizzare","CHECKLISTE":"Lista di controllo","LEISTUNGSEMPFAENGER":"Beneficiario della prestazione","GESCHAEDIGTER":"Danneggiato","BETRAG_BESTIMMEN":"Stabilire l'importo","CHECK_SCHADENBEHOBEN_ABR_1":"Il danno è stato ripristinato (lavori eseguiti)?","CHECK_SCHADENBEHOBEN_ABR_2":"Il ripristino corrisponde alla notifica? Maggior / minor lavoro?","CHECK_SCHADENBEHOBEN_ABR_3":"Conteggio completo? Plausibile?","CHECK_SCHADENBEHOBEN_ABR_4":"Prestazioni anticipate? Donazioni? (tutto dichiarato?)","PROZENTSATZ_BEITRAG":"{{prozentsatz}} %","LABEL_KEINE_ANGABE":"Nessuna indicazione","MIGRATION":"Migrazione","ERROR_PARSE":"Non è stato trovato","NO_RESULTS_FOUND":"Nessun risultato trovato","GEMEINDE":"Comune","KANTON":"Cantone","ART_ANLAUFSTELLE":"Tipo di punto di riferimento","TYPE":"Tipo","VEREINBARUNG_AKZEPTIERT":"Accordo accettato","NEUE_ANLAUFSTELLE":"Nuovo punto di riferimento","NUR_LESEBERECHTIGT":"Autorizzato solo alla lettura","ANLAUFSTELLE_DEAKTIVIEREN":"Disattivare il punto di riferimento","VERSION_INFO":"Versione: Cliente {{frontendVersion}} / Server: {{backendVersion}}","VERSION_INFO_SINGLE":"Versione {{version}}","ANLAUFSTELLE_EDITIEREN":"Modificare punto di riferimento","NAME_DER_ANLAUFSTELLE":"Nome del punto di riferimento","NAME_ZUSATZ":"Supplemento","VERANTWORTLICHE_PERSON":"Persona responsabile","GEMEINDE_HINZUFUEGEN":"Aggiungere Comune","GEMEINDE_FUER_ANLAUFSTELLE":"Comune per il punto di riferimento","VEREINBARUNG":"Accordo","KANTONALER_BEITRAG":"Importo cantonale","FS_UEBERPRUEFUNG_OK":"Il caso di danno adempie tutti i criteri. Accettare e approvare per il ripristino al richiedente.","FS_UEBERPRUEFUNG_OK_PAPIER":"Il caso di danno adempie tutti i criteri. Accettare e approvare per il ripristino al perito.","FS_UEBERPRUEFUNG_MANGELHAFT":"Il caso di danno è incompleto. Inoltrare un messaggio al perito per il completamento.","ABLEHNUNG":"Il caso di danno non adempie le condizioni per la concessione del contributo. Respingere e informare il richiedente.","ANLAUFSTELLE_BASISPRUEFUNG_OK":"Avente diritto: inoltrare come accettato al perito.","ANLAUFSTELLE_SCHAETZUNG_OK":"Avente diritto: inoltrare come accettato a fondssuisse.","ZURUECK_AN_SCHAETZER":"Ritornare indietro al perito.","STICHENTSCHEID_ANGEFORDERT":"Non avente diritto: inoltrare a fondssuisse per il rifiuto","STICHENTSCHEID_OK":"La richiesta soddisfa le condizioni contributive","CHECK_IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS_1":"Verificato","CHECK_AUFTRAG_SCHAETZER_1":"Danno accertato.","CHECK_UEBERPRUEFUNG_FS_1":"Richiedente avente diritto? (Direttive, art. 6/7) Proprietario / affittuario?","CHECK_UEBERPRUEFUNG_FS_2":"Situazione finanziaria? (art. 23)","CHECK_UEBERPRUEFUNG_FS_3":"Perimetrali/Persone interesssate?","CHECK_UEBERPRUEFUNG_FS_4":"Evento dannoso (causa / oggetto)? (art. 9/10)?","CHECK_UEBERPRUEFUNG_FS_5":"Danni assicurabili? (art. 11)","CHECK_UEBERPRUEFUNG_FS_6":"Eventi non considerati? (art. 12) Altre esclusioni? (art. 13)","CHECK_UEBERPRUEFUNG_FS_7":"Altre possibilità di contribuzione?","CHECK_UEBERPRUEFUNG_FS_8":"La documentazione del danno è comprensibile?","CHECK_UEBERPRUEFUNG_FS_9":"Indicazioni mancanti?","CHECK_UEBERPRUEFUNG_FS_10":"Dimensioni del danno, misure proposte e stima plausibili?","CHECK_UEBERPRUEFUNG_FS_11":"Punti in sospeso, domande?","CHECK_UEBERPRUEFUNG_FS_12":"Concedere il sostegno sì/no?","CHECK_UEBERPRUEFUNG_FS_13":"Limitazioni, tetto dei costi? Avvertenze?","CHECK_BEARBEITUNG_AS_1":"I dati personali del richiedente sono stati controllati (identificato).","CHECK_BEARBEITUNG_AS_2":"Reddito e sostanza per l'anno fiscale (al domicilio) sono stati controllati.","CHECK_BEARBEITUNG_AS_3":"Il fondo (luogo del danno) nel Comune è stato controllato.","CHECK_BEARBEITUNG_AS_4":"Perito assegnato?","CHECK_UEBERPRUEFUNG_AS_1":"Le indicazioni dell'interessato sono complete.","CHECK_UEBERPRUEFUNG_AS_2":"Le indicazioni del danno sono complete / corrette.","CHECK_UEBERPRUEFUNG_AS_3":"Il richiedente è il danneggiato (rapporti di proprietà).","CHECK_UEBERPRUEFUNG_AS_4":"Ci sono altre / ulteriori possibilità di sostegno (sussidi, contributi, donazioni)?","CHECK_UEBERPRUEFUNG_AS_STICHENTSCHEID_FS_1":"Verificato","CHECK_UEBERPRUEFUNG_SCHAETZER_1":"Il danno è stato ripristinato (lavori eseguiti)?","CHECK_UEBERPRUEFUNG_SCHAETZER_2":"Il ripristino corrisponde alla notifica? Maggior / minor lavoro?","CHECK_UEBERPRUEFUNG_SCHAETZER_3":"Conteggio completo? Plausibile?","CHECK_UEBERPRUEFUNG_SCHAETZER_4":"Prestazioni anticipatei? Donazioni? (tutto dichiarato?)","CHECK_UEBERPRUEFUNG_SCHAETZER_5":"Correzioni, commenti?","CHECK_WIEDERHERSTELLUG_1":"Ripristino dello stato precedente","CHECK_WIEDERHERSTELLUG_2":"Possibilmente con mezzi propri e con la minor spesa possibile.","CHECK_WIEDERHERSTELLUG_3":"Fare rapporto delle prestazioni proprie","CHECK_WIEDERHERSTELLUG_4":"Prestazioni di terzi, pagare le fatture, registrare le ricevute di pagamento","CHECK_WIEDERHERSTELLUG_5":"Lavori ultimati?","CHECK_AUSZAHLUNG_1":"Testi di motivazione / commenti letti","CHECK_AUSZAHLUNG_2":"Indirizzo / conto di pagamento controllato (presente)","CHECK_AUSZAHLUNG_3":"Conto di pagamento? Liquidità presente?","WIEDERHERSTELLUNG_AUSGEFUEHRT":"Tutti i lavori di ripristino sono ultimati, le spese sono state integralmente registrate e verificate. Assegnare al perito per la verifica.","VEREINBARUNG_HOCHLADEN":"Caricare l'accordo","APPLICATION_PROPERTIES":"Proprietà applicazione","SERF_PROPERTIES":"Proprietà fondssuisse","TESTDATEN":"Dati del test","DEUTSCH":"Tedesco","FRANZOESISCH":"Francese","ITALIENISCH":"Italiano","WIEDERHERSTELLUNG_GEPRUEFT":"Tutti i lavori di ripristino sono ultimati, le spese sono state integralmente registrate e verificate. Assegnare a fondssuisse per la verifica.","WIEDERHERSTELLUNG_GEPRUEFT_PAPIER":"Tutti i lavori di ripristino sono ultimati, le spese sono state integralmente registrate e verificate. Assegnare a fondssuisse per la verifica.","WIEDERHERSTELLUNG_MANGELHAFT":"Ritornare al richiedente con richiesta di completamento.","ALLES_KONTOLLIERT":"Ho controllato tutti i punti summenzionati.","ABTEILUNG":"Dipartimento","ABRECHNUNG_OK":"Conteggio OK","ABRECHNUNG_MANGELHAFT":"Conteggio con supplemento","TSSchadenArt_ERDRUTSCH":"Frane","TSSchadenArt_UEBERSCHWEMMUNG":"Alluvioni","TSSchadenArt_UEBERFUEHRUNG":"Immissioni / straripamenti","TSSchadenArt_RUEFE":"Smottamenti","TSSchadenArt_LAWINE":"Valanghe","TSSchadenArt_SCHNEEDRUCK":"Pressione della neve","TSSchadenArt_STURMWIND":"Tempeste","TSSchadenArt_FELSSTURZ":"Scoscendimenti","TSSchadenArt_STEINSCHLAG":"Caduta di rocce","TSSchadenArt_TROCKENHEIT":"Siccità","TSSchadenArt_ANDERE":"Altro","ART_DES_SCHADENDS_ANDERE":"Tipo di danno - testo libero","GEMEINDEN":"Comuni","VEREINBARUNG_STEPTS_TITLE":"Prossimo passo per l'attivazione del vostro punto di riferimento:","CHECK_AUFTRAG_SCHAETZER_2":"Descrizione verificata/completata.","CHECK_AUFTRAG_SCHAETZER_3":"Stima dei danni allestita.","CHECK_AUFTRAG_SCHAETZER_4":"Il danno è sovvenzionato?","VEREIBARUNG_STEP1":"1° passo","VEREIBARUNG_STEP1_TEXT":"Scaricare il documento \"Autenticazione punto di riferimento\" (<a href='https://fondssuisse.cmsbox.ch/download/pictures/7f/a47y45twtm2ywb221wohdb04jovo7p/autentificazione_quale_punto_di_riferimento.pdf'>pdf</a>) e stamparlo.","VEREIBARUNG_STEP2":"2° passo","VEREIBARUNG_STEP2_TEXT":"Firmare il documento e spedirlo per posta a fondssuisse.","VEREIBARUNG_STEP3":"3° passo","VEREIBARUNG_STEP3_TEXT":"Amministrare gli utenti.","VEREINBARUNG_ABGELAUFEN_WARNUNG":"I punti di riferimento evidenziati in rosso non sono attualmente validi. Vogliate caricare l'accordo (<a href='https://www.fondssuisse.ch/download/pictures/d5/5wkylpa9ai7j97tofa91wufswklvh8/authentifizierung_anlaufstelle.pdf'>pdf</a>) e dopo averlo firmato spedirlo a fondssuisse.","NICHT_FREIGEGEBEN":"Contributi non approvati","PENDENT":"Contributi in sospeso","AUSGEFUEHRT":"Pagamenti eseguiti","BEITRAG":"Contributo","EMPFAENGER":"Destinatario","FREIGEBEN_DIALOG":"Siete certi di voler approvare {{anzahl | number : 0}} contributi selezionati?","AUSFUEHREN_DIALOG":"Siete certi di voler eseguire {{anzahl | number : 0}} contributi selezionati?","REF_BUCHHALTUNG":"Rif# Contabilità","DATUM_FAELLIG":"Scadenza","LINK_ANLAUFSTELLE":"Selezionare punto di riferimento","ANLAUFSTELLE_WECHSELN":"Cambiare punto di riferimento","BENUTZER_ERSTELLT":"Creare utente","ANZ_EMPFAENGER":"No. di destinatari","ZAHLUNGEN_AUSGEFUEHRT":"Pagamenti eseguiti","ISO_DATEI":"File ISO","BEITRAEGELISTE":"Elenco dei contributi","DOWNLOAD_ISO":"Download file ISO","DOWNLOAD_BEITRAEGE":"Download elenco dei contributi","NAV_BEMERKUNG":"Osservazioni","MELDUNGEN_DURCH_SYSTEM":"Notifiche del sistema","STATUS_MELDUNGEN":"Notifiche cambiamento di stato","INTERNE_BEMERKUNG":"Osservazione interna","BEITRAG_EFFEKTIV":"Contributo effettivo","ERSTELLT_VON":"Allestito da","ERSTELLT_AM":"Allestito il","BERECHNUNG_BETRAG":"Calcolo importo","SYSTEM_KONFIGURATION":"Configurazione sistema","KONFIGURATION":"Configurazione","FS_SACHBEARBEITER_ZUTEILEN":"Amministrare incaricato fondssuisse","FS_ADMIN_ZUTEILEN":"Gestire amministratori fondssuisse","FS_BETROFFENE_ROLLE_ENTFERNEN":"Fondsuisse Betroffene Rolle entfernen","FS_ROLLE_ENTFERNEN":"Rolle entfernen","BETROFFENE_ROLLE_ENTFERNT":"Die Betroffene Rolle konnte erfolgreich entfernt werden.","EMAIL_UNGUELTIG":"E-Mail Adresse ist ungültig","BITTE_EMAIL":"Bitte eine gültige E-Mail Adresse angeben.","CONFIRM_ROLE_REMOVAL":"Siete certi di voler abbandonare la carica di amm.? In seguito non potrete più utilizzare la configurazione.","SENDABLEHNUNGMAIL":"invia e-mail di rifiuto","SENDSCHADENFALLFREIGEGEBENMESSAGE":"invia messaggio caso di danno approvato","SENDBETROFFENEWIEDERHERSTELLUNGBEWILLIGTMAIL":"invia e-mail ripristino approvato all'interessato","SENDAUSZAHLUNGSMAIL":"invia e-mail di pagamento","SENDSCHADENFALLFREIGEGEBENFORANLAUFSTELLEMESSAGE":"invia messaggio caso di dannoapprovato al punto di riferimento","SENDSCHAETZERABRECHNUNGMANGELHAFTMAIL":"invia e-mail conteggio carente al perito","SENDSCHAETZERAUFWAENDEREADYFORVERIFICATIONMAIL":"invia e-mail costi pronti per la verifica al perito","SENDSCHAETZERWIEDERHERSTELLUNGBEWILLIGTMAIL":"invia e-mail ripristino approvato al perito","SENDUEBERPRUEFUNGMANGELHAFTMAIL":"invia e-mail recensione insufficiente","SENDWIEDERHERSTELLUNGANGABENMANGELHAFTMAIL":"invia e-mail indicazioni carenti concernenti il ripristino","SENDSCHAETZERZUGEWIESENMAIL":"invia e-mail perito assegnato","SENDSCHADENFALLUEBERPRUEFUNGFSFORINSPEKTORATMESSAGE":"invia verifica caso di danno all'ispettorato FS","SENDSCHADENFALLSCHADENBEHOBENFORINSPEKTORATMESSAGE":"invia caso di danno rimosso all'ispettorato","TESTMAIL":"Test e-mail","NEUES_INSPEKTORAT":"Nuovo ispettorato","INSPEKTORAT_EDITIEREN":"Modificare ispettorato","INSPEKTORAT_DEAKTIVIEREN":"Disattivare ispettorato","NAME_DES_INSPEKTORAT":"Nome dell'ispettorato","ANLAUFSTELLE_HINZUFUEGEN":"Aggiungere punto di riferimento","INSPEKTOREN_ZUTEILEN":"Assegnare ispettorato","ANLAUFSTELLEN_FUER_INSPEKTORAT":"Punto di riferimento per l'ispettorato","INSPEKTORAT_ADD":"Aggiungere ispettorato","INSPEKTORAT":"Ispettorato","MENU_INSPEKTORAT":"Ispettorato","MENU_VERSICHERUNGSBEITRAEGE":"Contributi dell'assicurazione","SUBVENTIONIERT_DURCH":"I costi di ripristino possono essere sussidiati dalla Confederazione, dal Cantone e/o dal Comune?","OFFERTE":"È stata richiesta un’offerta.","ARBEITEN":"Ilavori sono già stati avviati.","BEENDEN_SPEICHERN":"Memorizzare","NOCH_NICHT_GESCHAETZT":"non ancora stimato","GESUCH_SPEICHERN":"Memorizzare evento dannoso","UNSAVED_WARNING":"Attenzione: ci sono ancora modifiche non salvate che andranno perse se uscite dalla pagina.","VORHERIGER_WERT":"valore originariamente inserito","UNSAVED_WARNING_RELOAD":"Attenzione: ci sono ancora modifiche non salvate che andranno perse se caricherete nuovamente la pagina.","STUNDEN_HINZUFUEGEN":"Aggiungere ore","TSKulturart_WIESEWEIDE":"Prato / Pascolo","TSKulturart_ACKERLAND":"Terreno coltivo","TSKulturart_ANDERE":"Altro","VERSICHERUNGSBEITRAEGE":"Contributi dell'assicurazione","VERSICHERUNGSBEITRAG_CREATE":"Aggiungere contributo dell'assicurazione","VERSICHERUNGSBEITRAG_ERFASSEN":"Registrare contributo dell'assicurazione","VERS_BEITR_EXT_SCHADENNR":"Numero di danno est.","VERSICHERUNG":"Assicurazione","VERSICHERUNG_ART":"Tipo di assicurazione","SCHADENDATUM":"Data del danno","NAV_VERSICHERUNG_ERFASSEN":"Danno","NAV_VERSICHERUNG_BEITRAG":"Contributo","NAV_VERSICHERUNG_VERSICHERTER":"Assicurato","EXTERNAL_SCHADEN_NR":"Numero est. del danno","POLICE_NUMMER":"Numero di polizza","SCHADEN_GEMEINDE":"Danno Comune","PROZENTSATZ":"Tasso percentuale","WIEDERHERSTELLUNGSKOSTEN":"Costi di ripristino","ERMITTELTERSCHADEN":"Danno accertato","BEITRAG_BERECHTIGT":"Contributo giustificato","BEITRAG_HINZUFUEGEN":"Aggiungere contributo","VERSICHERUNGSBEITRAG_KOSTEN":"Costi","VERSICHERUNGSBEITRAG_SCHADENABRECHNUNG":"Computo del danno","RECHTSFORM":"Forma giuridica","GESUCHSTELLER_TITLE":"Indicazioni concernenti {{eigentumsverhaeltnis}}","RECHTSFORM_TITLE":"Forma giuridica","VERSICHERUNGSBEITRAG_FALL_ERSTELLEN":"Inserire test contributo dell'assicurazione","BITTE_HOCHLADEN":"Vogliate caricare i documenti seguenti","REQUIRED":"Obbligatorio","OPTIONAL":"Opzionale","MITGLIEDERVERZEICHNIS":"Elenco dei membri","JAHRESRECHNUNG":"Conto annuale","IMPORTIERTE":"Importati","PACHTVERTRAG":"Contratto d'affitto","BENUTZERROLLEN_HINWEIS":"Per attribuire dei ruoli all'utente, selezionate dapprima l'utente. In seguito, nella pagina del punto di riferimento, aggiungetelo ai periti o agli incaricati.","BENUTZERROLLEN_ANLAUFSTELLE_HINWEIS":"Per attribuire dei ruoli all'utente, selezionate dapprima l'utente. In seguito, nella pagina del punto di riferimento, aggiungetelo ai periti o agli incaricati.","VON":"da","BIS":"a","BENUTZER_CREATED_SUCCESS":"L'account è fatto e verificato. Vi puo collegare.","INIVTATION_EMAIL":"e-mail della persona aggiunta","FREIGABE_PAPIER_FS_6":"Sbloccare la richiesta cartaceo dopo la verifica","FREIGABE_PAPIER_FS_9":"Sbloccare la richiesta cartaceo dopo il danno","KONTO_INHABER":"beneficiario","KONTO_INHABER_PLZ":"NPA","KONTO_INHABER_ORT":"località","JAHR":"anno","STEUERFAKTOREN":"Nome e fattori fiscali","ZUSTIMMUNG_STEUERPRUEFUNG_GENOSSENSCHAFT":"Autorizziamo il comune, di controllare i date finanziarie delle richiesta.","FILTER_ZURUECKSETZEN":"Eliminare il filtro","TS_REPORTYPE_AUSZAHLUNG":"Statistica sui pagamenti","TS_REPORTYPE_SCHADEN":"Statistica dei danni","TS_REPORTYPE_ALLE":"Tutti i dati richiesti","TS_REPORTYPE_AUSZAHLUNG_KANTON":"Statistica sui pagamenti","DATUM_AUSZAHLUNG_VON":"Data di pagamento dal","DATUM_AUSZAHLUNG_BIS":"Data di pagamento fino al","DATUM_GESUCH_VON":"Data della richiesta dal","DATUM_GESUCH_BIS":"Data della richiesta fino al","DATUM_EREIGNIS_VON":"Data dell'evento dal","DATUM_EREIGNIS_BIS":"Data dell'evento fino al","DATUM_AUSZAHLUNG_PARAM":"Data di pagamento: ","DATUM_GESUCH_PARAM":"Data della richiesta: ","DATUM_EREIGNIS_PARAM":"Data dell'evento: ","LOGIN_NO_ACCOUNT_YET":"Nessun account utente per persona interessata?","LOGIN_GEMEINDE":"Registrazione per i Comuni cliccare qui: ","IMPORTIERT_VERSICHERUNG":"Evento assicurato importato - ","IMPORTIERT_FONDSSUISSE":"Caso importato - ","DECKBLATT":"PDF","ADRESSE_1":"Indirizzo 1","ADRESSE_2":"Indirizzo 2","ADRESSE_3":"Indirizzo 3","NUR_EIN_SCHADEN":"Può essere registrato solo un danno","SCHADENFALL_LOESCHEN":"Elimina richiesta","SCHADENFALL_LOESCHEN_TEXT":"Eliminare la richiesta? Quest'operazione non può più essere annullata.","SCHADENFALL_BEENDEN_SPEICHERN_TEXT":"Attenzione! La richiesta è stata salvata, non è tuttavia ancora stata inviata e inoltrata. Per fare ciò vi preghiamo di cliccare su “inviare richiesta”.","SCHADENFALL_BEENDEN_SPEICHERN_TITLE":"Memorizzare caso di danno?","ABZUG_EV":"Detrazione per entrata / abilità","FONDSSUISSE_DOKUMENTE":"Documenti fondssuisse","SCHADENFALL_PDF":"Sinistri PDF","DOWNLOAD_DECKBLATT":"Download PDF","NUR_FONDSSUISSE":"Qui si possono caricare i documenti, che possono essere visti solo da fondssuisse","MANUELL_ERFASSTE_MELDUNG":"Messaggi registrati manualmente","BENUTZER_ROLLEN_LOESCHEN":"Elimina i ruoli utenti","BETROFFENE_ROLLE":"Ruolo del danneggiato","STATISTIK":"Statistica","BatchJobStatus_REQUESTED":"Richiesta statistica","BatchJobStatus_RUNNING":"Elaborazione statistica","BatchJobStatus_FINISHED":"Pronto per il download","BatchJobStatus_FAILED":"Non completato con successo","STARTED_GENERATION":"Il riporto viene generato","ERROR_DATE_BEFORE_TO":"Errore: la data \"fino\"- a viene prima della data \"dal\"","ERSTELLT":"Emesso","BEENDET":"Completato","TYP":"Tipo","PARAMETER":"Parametro","GESTARTET":"Inizializzato","SHOW_JOBS":"Mostra tutti i batchjobs","GENERIEREN":"Generare","PDF_GENERIEREN":"Generare PDF","ReportType_beitragReport":"Rapporto di contributo","DEV_FUNCTIONS":"Mostra le funzioni dello sviluppatore software","RECREATE_ZAHLUNGSAUFTR_EXCEL_REPORT":"Genera l'ordine di pagamento Excel","DOKUMENT_DOWNLOAD":" Scarica documento","ZH":"Zurigo","BE":"Berna","LU":"Lucerna","UR":"Uri","SZ":"Svitto","OW":"Obvaldo","NW":"Nidvaldo","GL":"Glarona","ZG":"Zugo","FR":"Friburgo","SO":"Soletta","BS":"Basilea-Città","BL":"Basilea-Campagna","SH":"Sciaffusa","AR":"Appenzello Interno","AI":"Appenzello Esterno","SG":"San Gallo","GR":"Grigioni","AG":"Argovia","TG":"Turgovia","TI":"Ticino","VD":"Vaud","VS":"Vallese","NE":"Neuchatel","GE":"Ginevra","JU":"Giura","KOSTEN_GESCH":"Stima","SICHTBARKEIT":"Visibilità","INTERN":"interno","FONDSSUISSE":"fondssuisse","ANZAHL_KUBIKMETER":"No. m3","BETRAG_HOLZ_CHF":"Importo per legno in CHF","KUBIKMETER":"mc Metri cubici","KUBIKMETER_ERFASSEN":"registrare mc Metro cubo","KUBIKMETER_HINZUFUEGEN":"Calcolo somma m3","LITER":"Litri","LITER_ERFASSEN":"Registrare i litri","BETRAG_TREIBSTOFF_CHF":"Importo per carburante in CHF","STATUS_AKTUALISIEREN":"Attualizzare stato","STATUS_AKTUALISIEREN_TEXT":"State attualizzando manualmente lo stato del caso.","MENU_COCKPIT":"Cockpit","ZEITBEREICH":"selezionare l’intervallo di tempo","TSCockpitSelect_":"selezionare l’intervallo di tempo","TSCockpitSelect_LETZER_MONAT":"mese scorso","TSCockpitSelect_DATUM_BEREICH":"data dell’intervallo","DATUM_VON":"data dal","DATUM_BIS":"data fino","ANWENDEN":"applicare","COCKPIT_STATUS_TITLE":"stato dei casi di danni","COCKPIT_KANTON_TITLE":"richieste per Cantone","COCKPIT_ERFASSUNGSART_TITLE":"Domanda per tipo di registrazione","COCKPIT_SCHADENART_TITLE":"tipi di danni","COCKPIT_GESCHAETZTE_KOSTEN_TITLE":"Costi stimati in CHF","COCKPIT_ANZAHL_GESUCHE":"numero di richieste","COCKPIT_ANZAHL_NEUE_GESUCHE":"numero di nuove richieste","short_DEUTSCH":"DE","short_FRANZOESISCH":"FR","short_ITALIENISCH":"IT","AUFAWENDE_DOC_BEGLEITTEXT":"Si prega di caricare qui documenti e immagini per il ripristino","TITLE_DUPLICATED_HANDARBEITER":"Persona duplicata","DUPLICATED_HANDARBEITER_MESSAGE":"Si prega di utilizzare la voce di contributo personale precedentemente inserita per questa persona.","EIGENLEISTUNG_DESCRIPTION":"Descrizione del servizio / del dispositivo","STUNDENANSATZ":"Tariffa oraria","ANZAHL_STUNDEN_":"Numero di ore","BANKKONTO_EDITIEREN":"Modificare le coordinate bancarie","BEITRAG_SCHON_ERFASST":"Attenzione, contributo già inserito, questo deve essere rigenerato"}

/***/ }),

/***/ "R/YX":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("j1to");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./migrationView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./migrationView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "RFsg":
/***/ (function(module, exports) {

module.exports = " <ul ng-class=\"['nav', 'nav-tabs', 'dv-gesuch-navigation', {'navbar-sticky':vm.sticky}]\" role=\"navigation\"> <li class=\"dv-gesuch-navigation__li\"> <h1 ng-bind=\"vm.title\" class=\"dv-gesuch-navigation__title\" ng-class=\"{'dv-gesuch-navigation__stickytitle':vm.sticky}\"></h1> <span class=\"dv-gesuch-navigation__status\" ng-class=\"{'dv-gesuch-navigation__status-scale':vm.sticky}\"> <span ng-bind=\"vm.herkunft | translate\"></span> <span ng-bind=\"vm.status | translate\"></span> </span> </li> <li ui-sref-active=\"active\" ng-if=\"!vm.schadenfallId\"> <a class=\"dv-gesuch-navigation__a\" ui-sref=\"gesucherstellen({createNew: 'true'})\" translate=\"NAV_GESUCH_ERFASSEN\"> </a> </li> <li ui-sref-active=\"active\" ng-if=\"vm.schadenfallId\"> <a class=\"dv-gesuch-navigation__a\" ui-sref=\"gesucherstellen({schadenfallId: vm.schadenfallId,createNew: 'false'})\" translate=\"NAV_GESUCH_ERFASSEN\"> </a> </li> <li ui-sref-active=\"active\" ng-if=\"vm.schadenfallId\"> <a class=\"dv-gesuch-navigation__a\" ui-sref=\"schadenmeldung({schadenfallId: vm.schadenfallId})\" translate=\"NAV_SCHADENMELDUNG\"> </a> </li> <li ui-sref-active=\"active\" ng-if=\"vm.showSchaetzung()\"> <a class=\"dv-gesuch-navigation__a\" ui-sref=\"schaetzung({schadenfallId: vm.schadenfallId})\" translate=\"NAV_SCHAETZUNG\"> </a> </li> <li ui-sref-active=\"active\" ng-if=\"vm.showAufwaende()\"> <a class=\"dv-gesuch-navigation__a\" ui-sref=\"aufwaende({schadenfallId: vm.schadenfallId})\" translate=\"NAV_AUFWAENDE\"> </a> </li> <li ui-sref-active=\"active\" ng-if=\"vm.showEntschaedigung()\"> <a class=\"dv-gesuch-navigation__a\" ui-sref=\"entschaedigung({schadenfallId: vm.schadenfallId})\" translate=\"NAV_ENTSCHAEDIGUNG\"> </a> </li> <li ui-sref-active=\"active\" ng-if=\"vm.showBemerkung()\"> <a class=\"dv-gesuch-navigation__a\" ui-sref=\"bemerkung({schadenfallId: vm.schadenfallId})\" translate=\"NAV_BEMERKUNG\"> </a> </li> </ul> ";

/***/ }),

/***/ "RFuZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var template = __webpack_require__("+4Yc");
var DvAccordionTabComponentConfig = /** @class */ (function () {
    function DvAccordionTabComponentConfig() {
        this.transclude = {
            title: '?tabTitle',
            body: '?tabBody'
        };
        this.template = template;
        this.controller = DvAccordionTabController;
        this.controllerAs = 'vmt';
        this.bindings = {
            tabid: '@',
        };
        this.require = { vma: '^dvAccordion' };
    }
    return DvAccordionTabComponentConfig;
}());
exports.DvAccordionTabComponentConfig = DvAccordionTabComponentConfig;
var DvAccordionTabController = /** @class */ (function () {
    /* @ngInject */
    function DvAccordionTabController() {
    }
    DvAccordionTabController.$inject = [];
    return DvAccordionTabController;
}());
exports.DvAccordionTabController = DvAccordionTabController;


/***/ }),

/***/ "RJX8":
/***/ (function(module, exports) {

module.exports = " <div class=\"dv-benutzerprofil\" ng-form=\"vm.form\"> <fieldset ng-disabled=\"vm.readonly\"> <div class=\"row\"> <div class=\"col-sm-10\"> <div class=\"row\"> <div class=\"col-sm-12\"> <dv-input-container> <div> <label class=\"md-no-float\" data-translate=\"ANREDE\"></label> </div> <div class=\"radio\" ng-repeat=\"anrede in vm.getTSAnredeValues()\"> <label> <input ng-value=\"anrede\" aria-label=\"{{anrede}}\" ng-model=\"vm.getModel().anrede\" type=\"radio\" name=\"anrede\" ng-required=\"true\" class=\"input-element\"> <span>{{anrede | translate}}</span> <dv-error-messages ng-show=\"!$first\" for=\"vm.form.anrede\"></dv-error-messages> </label> </div> </dv-input-container> </div> </div> <div class=\"row\"> <dv-string-input model=\"vm.getModel().nachname\" name=\"nachname\" label=\"NAME\" clazz=\"col-sm-6\"> </dv-string-input> <dv-string-input model=\"vm.getModel().vorname\" name=\"vorname\" label=\"VORNAME\" clazz=\"col-sm-6\"> </dv-string-input> <dv-string-input ng-if=\"vm.readonly\" model=\"vm.getModel().email\" name=\"email\" label=\"EMAIL\" clazz=\"col-sm-6\"> </dv-string-input> <dv-string-input model=\"vm.getModel().telefon\" name=\"telefon\" input-pattern=\"{{vm.pattern}}\" label=\"TELEFON\" ng-required=\"vm.phoneRequired\" clazz=\"col-sm-6\"> </dv-string-input> </div> <div class=\"row\" ng-if=\"!vm.readonly && vm.doubleEmailEntry && !vm.noEmailEntry\"> <div class=\"col-sm-6\"> <dv-input-container> <label for=\"email_ID\" class=\"col-form-label text\" translate=\"LOGIN_EMAIL\"></label> <input id=\"email_ID\" type=\"email\" name=\"email\" ng-model=\"vm.getModel().email\" dv-max-length class=\"form-control\" required placeholder=\"hans.muster@example.com\" ng-pattern=\"vm.CONSTANTS.PATTERN_EMAIL\"> <dv-error-messages for=\"vm.form.email\" class=\"error\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-6\"> <dv-input-container> <label for=\"email_ID2\" class=\"col-form-label text\" translate=\"LOGIN_EMAIL_REPEAT\"></label> <input id=\"email_ID2\" type=\"email\" name=\"email2\" ng-model=\"vm.getModel().emailRepeat\" dv-max-length class=\"form-control\" required placeholder=\"hans.muster@example.com\" ng-pattern=\"vm.CONSTANTS.PATTERN_EMAIL\"> <dv-error-messages for=\"vm.form.email2\" class=\"error\"></dv-error-messages> </dv-input-container> </div> </div> <div class=\"row\" ng-if=\"!vm.readonly && !vm.hidePasswordEntry && !vm.pwChangeWithButton\"> <div class=\"col-sm-12\"> <dv-password-changer passworddata=\"vm.getModel().passwordData\" email-enabled=\"true\" email-visible=\"vm.pwChangerEmailVisible\"></dv-password-changer> </div> </div> <div class=\"row\" ng-if=\"vm.pwChangeWithButton\"> <div class=\"col-sm-12 dv-animated dv-animated--slide\" style=\"margin-bottom:27px;margin-top:27px\" ng-if=\"vm.pwChangeWithButton && !vm.pressedChangePassword\"> <button ng-click=\"vm.changePassword($event)\" type=\"button\" class=\"btn btn-serf\"> <span data-translate=\"LOGIN_RESET_PW_BUTTON\"></span> </button> </div> <div class=\"col-sm-12 dv-animated dv-animated--slide\" ng-if=\"vm.pwChangeWithButton && vm.pressedChangePassword\"> <dv-password-changer passworddata=\"vm.getModel().passwordData\" email-enabled=\"true\" email-visible=\"vm.pwChangerEmailVisible\"></dv-password-changer> </div> </div> <div class=\"row\"> <div class=\"col-sm-6\"> <dv-input-container> <div> <label class=\"md-no-float\" data-translate=\"KORRESPONDENZSPRACHE\" for=\"korrespondenzsprache\"></label> </div> <div> <select name=\"korrespondenzsprache\" id=\"korrespondenzsprache\" ng-model=\"vm.getModel().korrespondenzsprache\" class=\"form-control\" ng-options=\"(sprache| translate) for sprache in vm.getTSSpracheValues() \" ng-required=\"true\"> </select> <dv-error-messages for=\"vm.form.korrespondenzsprache\"></dv-error-messages> </div> </dv-input-container> </div> </div> </div> </div> </fieldset> </div> ";

/***/ }),

/***/ "ROEt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSFremdkosten_1 = __importDefault(__webpack_require__("csNn"));
/**
 * Service zum verwalten von Fremdkosten
 *
 * */
var FremdkostenRS = /** @class */ (function () {
    /* @ngInject */
    function FremdkostenRS($http, CONSTANTS, $q, $rootScope, $log) {
        this.$http = $http;
        this.CONSTANTS = CONSTANTS;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$log = $log;
    }
    FremdkostenRS.prototype.saveFremdkosten = function (schadenfallId, fremdkosten) {
        if (fremdkosten) {
            var restFremdkosten = fremdkosten.serialize({});
            return this.$http.put(this.CONSTANTS.REST_API + 'fremdkosten/' + encodeURIComponent(schadenfallId), restFremdkosten)
                .then(function (response) {
                if (response.data !== undefined) {
                    return new TSFremdkosten_1.default().deserialize(response.data);
                }
                else {
                    return undefined;
                }
            });
        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    };
    FremdkostenRS.prototype.deleteFremdkosten = function (fremdkosten) {
        return this.$http.delete(this.CONSTANTS.REST_API + 'fremdkosten/' + encodeURIComponent(fremdkosten.id))
            .then(function (response) {
            return response;
        });
    };
    FremdkostenRS.$inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];
    return FremdkostenRS;
}());
exports.default = FremdkostenRS;


/***/ }),

/***/ "RZXW":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.vereinbarung-steps h4{font-weight:700}", ""]);

// exports


/***/ }),

/***/ "Rf7t":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.vereinbarung-steps h4{font-weight:700}", ""]);

// exports


/***/ }),

/***/ "RhHQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright © 2019 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var template = __webpack_require__("NmJP");
var DvPagination = /** @class */ (function () {
    function DvPagination() {
        this.restrict = 'E';
        this.template = template;
        this.link = function (scope, element, attrs) {
            scope.$watch('currentPage', function (c) {
                scope.inputPage = c;
            });
            scope.$watch('inputPage', function (c) {
                if (scope.inputPage > scope.numPages) {
                    scope.inputPage = scope.numPages;
                    if (scope.currentPage !== scope.numPages) {
                        scope.selectPage(scope.numPages);
                    }
                }
                if (scope.inputPage < 1) {
                    scope.inputPage = 1;
                    if (scope.currentPage !== 1) {
                        scope.selectPage(1);
                    }
                }
            });
        };
    }
    DvPagination.factory = function () {
        var directive = function () { return new DvPagination(); };
        directive.$inject = [];
        return directive;
    };
    return DvPagination;
}());
exports.DvPagination = DvPagination;


/***/ }),

/***/ "RmK+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSDokumentType_1 = __webpack_require__("/gTe");
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
var OkHtmlDialogController_1 = __webpack_require__("U0eN");
var RemoveDialogController_1 = __webpack_require__("92sy");
var okCancelTemplate = __webpack_require__("CYbW");
var okHtmlDialogTempl = __webpack_require__("ncnt");
var removeDialogTemplate = __webpack_require__("YTLw");
__webpack_require__("plYF");
var DVDokumentuploadComponentConfig = /** @class */ (function () {
    function DVDokumentuploadComponentConfig() {
        this.transclude = false;
        this.bindings = {
            schadenfallid: '=',
            parentid: '=',
            documentType: '<',
            requiredDocs: '<',
            onDocAdded: '&',
            onDocRemoved: '&',
            readonly: '<',
            disableBegleittext: '<?',
            begleitText: '@?',
            buttonSymbol: '@?',
            buttonText: '@?',
            prefix: '@',
            formParent: '<?',
        };
        this.template = __webpack_require__("fkRl");
        this.controller = DVDokumentuploadController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return DVDokumentuploadComponentConfig;
}());
exports.DVDokumentuploadComponentConfig = DVDokumentuploadComponentConfig;
var DVDokumentuploadController = /** @class */ (function () {
    /* @ngInject */
    function DVDokumentuploadController(dvDialog, $log, $translate, uploadRS, dokumenteRS, downloadRS, $q, REST_API, $scope) {
        this.dvDialog = dvDialog;
        this.$log = $log;
        this.$translate = $translate;
        this.uploadRS = uploadRS;
        this.dokumenteRS = dokumenteRS;
        this.downloadRS = downloadRS;
        this.$q = $q;
        this.REST_API = REST_API;
        this.$scope = $scope;
        this.documentType = TSDokumentType_1.TSDocumentType.VORLEISTUNG_DOC;
    }
    DVDokumentuploadController.prototype.$onInit = function () {
        var _this = this;
        if (this.begleitText === undefined || this.begleitText === null) {
            this.begleitText = 'UPLOAD_TEXT';
        }
        this.$scope.$watch(function () {
            return _this.schadenfallid;
        }, function (newValue, oldValue) {
            if ((newValue !== oldValue)) {
                _this.loadDokumente();
            }
        });
        this.$scope.$watch(function () {
            return _this.requiredDocs;
        }, function (newValue, oldValue) {
            if ((newValue !== oldValue)) {
                _this.checkDocCountValid();
            }
        });
        this.loadDokumente();
        if (this.formParent) {
            this.parentForm = this.formParent;
        }
    };
    DVDokumentuploadController.prototype.uploadAnhaenge = function (files) {
        this.uploadAnhaengeWithType(files, this.documentType);
    };
    DVDokumentuploadController.prototype.uploadAnhaengeWithType = function (files, doctype) {
        var _this = this;
        if (this.documentType) {
            var parentid_1 = this.parentid;
            var filesTooBig = [];
            var filesNotAllowed = [];
            var filesOk = [];
            this.$log.debug('Uploading files for Schadenfall ' + parentid_1);
            try {
                for (var files_1 = __values(files), files_1_1 = files_1.next(); !files_1_1.done; files_1_1 = files_1.next()) {
                    var file = files_1_1.value;
                    this.$log.debug('File: ' + file.name + ' size: ' + file.size);
                    if (!this.dokumenteRS.isFileTypeAllowedForDocumentType(file.type, this.documentType)) {
                        // Nur bestimmte FileTypes erlaubt
                        filesNotAllowed.push(file);
                    }
                    else if (file.size > 10000000) {
                        // Maximale Filegrösse ist 10MB
                        filesTooBig.push(file);
                    }
                    else {
                        filesOk.push(file);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (files_1_1 && !files_1_1.done && (_a = files_1.return)) _a.call(files_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (filesTooBig.length > 0 || filesNotAllowed.length > 0) {
                // DialogBox anzeigen für Files, welche zu gross sind!
                var returnString = '';
                returnString += this.addErrorsForArray(filesTooBig, 'FILE_ZU_GROSS');
                returnString += '</br></br>';
                returnString += this.addErrorsForArray(filesNotAllowed, 'FILETYPE_NICHT_ERLAUBT');
                this.dvDialog.showDialog(okHtmlDialogTempl, OkHtmlDialogController_1.OkHtmlDialogController, {
                    title: returnString,
                    text: ''
                });
            }
            if (filesOk.length > 0) {
                this.uploadRS.uploadFile(filesOk, this.schadenfallid, parentid_1, doctype).then(function (response) {
                    try {
                        for (var response_1 = __values(response), response_1_1 = response_1.next(); !response_1_1.done; response_1_1 = response_1.next()) {
                            var obj = response_1_1.value;
                            _this.dokumente.push(obj);
                            _this.checkDocCountValid();
                            _this.notifyOnAdd(obj, parentid_1);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (response_1_1 && !response_1_1.done && (_a = response_1.return)) _a.call(response_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    return response;
                    var e_2, _a;
                });
            }
        }
        else {
            this.$log.warn('No type found to store file');
        }
        var e_1, _a;
    };
    DVDokumentuploadController.prototype.addErrorsForArray = function (array, translateKey) {
        if (array.length > 0) {
            var returnString = this.$translate.instant(translateKey) + '<br/><br/>';
            returnString += '<ul>';
            try {
                for (var array_1 = __values(array), array_1_1 = array_1.next(); !array_1_1.done; array_1_1 = array_1.next()) {
                    var file = array_1_1.value;
                    returnString += '<li>';
                    returnString += file.name;
                    returnString += '</li>';
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (array_1_1 && !array_1_1.done && (_a = array_1.return)) _a.call(array_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
            returnString += '</ul>';
            return returnString;
        }
        return '';
        var e_3, _a;
    };
    DVDokumentuploadController.prototype.loadDokumente = function () {
        var _this = this;
        this.getDokumente().then(function (response) {
            _this.dokumente = response;
            _this.checkDocCountValid();
        });
    };
    DVDokumentuploadController.prototype.checkDocCountValid = function () {
        if (!this.isDocCountValid()) {
            this.dokumentuploadForm['doccountvalidation'].$setValidity('doccount', false);
            this.dokumentuploadForm['doccountvalidation'].$setValidity('required', false);
        }
        else {
            this.dokumentuploadForm['doccountvalidation'].$setValidity('doccount', true);
            this.dokumentuploadForm['doccountvalidation'].$setValidity('required', true);
        }
    };
    DVDokumentuploadController.prototype.isDocCountValid = function () {
        var mindocs = parseInt(this.requiredDocs);
        if (isNaN(mindocs)) {
            return true;
        }
        if (this.dokumente && this.dokumente.length >= mindocs) {
            return true;
        }
        return false;
    };
    DVDokumentuploadController.prototype.getDokumente = function () {
        if (this.documentType) {
            return this.dokumenteRS.findDocuments(this.schadenfallid, this.documentType, this.parentid);
        }
        return this.$q.when([]);
    };
    DVDokumentuploadController.prototype.download = function (dokument) {
        var _this = this;
        var attachment = false;
        this.$log.debug('download dokument ' + dokument.filename);
        var win = this.downloadRS.prepareDownloadWindow();
        this.downloadRS.getAccessTokenDocument(this.schadenfallid, this.documentType, dokument.id, this.parentid).then(function (downloadFile) {
            _this.$log.debug('accessToken: ' + downloadFile.accessToken);
            _this.downloadRS.startDownload(downloadFile.accessToken, downloadFile.filename, attachment, win);
        });
    };
    DVDokumentuploadController.prototype.getThumbnailPath = function (dokument) {
        var fallId = this.schadenfallid ? encodeURIComponent(this.schadenfallid) : undefined;
        var doctype = encodeURIComponent(TSDokumentType_1.TSDocumentType[this.documentType]);
        var documentId = dokument.id ? encodeURIComponent(dokument.id) : '';
        var parentID = this.parentid ? encodeURIComponent(this.parentid) : undefined;
        var url = this.REST_API + 'blobs/temp/thumbnail/fall/' + fallId + '/typ/' + doctype + '/doc/' + documentId;
        if (parentID !== undefined) {
            url = url += '?parentId=' + parentID;
        }
        return url;
    };
    DVDokumentuploadController.prototype.hasThumbnail = function (dokument) {
        return dokument.filetype.lastIndexOf('image/', 0) === 0;
    };
    DVDokumentuploadController.prototype.deleteDokument = function (dokument) {
        var _this = this;
        this.$log.debug('component -> remove dokument ' + dokument.filename);
        this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController_1.RemoveDialogController, {
            text: '',
            title: 'FILE_LOESCHEN'
        })
            .then(function () {
            _this.dokumenteRS.deleteDocument(_this.schadenfallid, _this.documentType, dokument.id, _this.parentid).then(function () {
                // replace existing object in table with returned if returned not null
                var index = DVBernUtil_1.default.getIndexOfElementwithID(dokument, _this.dokumente);
                if (index > -1) {
                    _this.dokumente.splice(index, 1);
                    _this.$log.debug('removed dokument in list');
                    _this.checkDocCountValid();
                    _this.notifyOnDelete(dokument);
                }
            });
        })
            .catch(function () {
        });
    };
    DVDokumentuploadController.prototype.notifyOnDelete = function (dokument) {
        if (angular.isFunction(this.onDocRemoved)) {
            this.onDocRemoved({ document: dokument }); //callback for already stored dokument that was
            // removed
        }
    };
    DVDokumentuploadController.prototype.notifyOnAdd = function (doc, parentid) {
        if (angular.isFunction(this.onDocAdded)) {
            this.onDocAdded({ document: doc, parentId: parentid });
        }
    };
    DVDokumentuploadController.prototype.hasDoc = function () {
        if (this.dokumente && this.dokumente.length > 0) {
            return true;
        }
        return false;
    };
    DVDokumentuploadController.$inject = ['DvDialog', '$log', '$translate', 'UploadRS', 'DokumenteRS', 'DownloadRS', '$q', 'REST_API', '$scope'];
    return DVDokumentuploadController;
}());
exports.DVDokumentuploadController = DVDokumentuploadController;


/***/ }),

/***/ "RtaT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright © 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSBeitragStatus;
(function (TSBeitragStatus) {
    TSBeitragStatus[TSBeitragStatus["NICHT_FREIGEGEBEN"] = 'NICHT_FREIGEGEBEN'] = "NICHT_FREIGEGEBEN";
    TSBeitragStatus[TSBeitragStatus["PENDENT"] = 'PENDENT'] = "PENDENT";
    TSBeitragStatus[TSBeitragStatus["AUSGEFUEHRT"] = 'AUSGEFUEHRT'] = "AUSGEFUEHRT";
})(TSBeitragStatus = exports.TSBeitragStatus || (exports.TSBeitragStatus = {}));
function getTSBeitragStatusValues() {
    return [
        TSBeitragStatus.NICHT_FREIGEGEBEN,
        TSBeitragStatus.PENDENT,
        TSBeitragStatus.AUSGEFUEHRT
    ];
}
exports.getTSBeitragStatusValues = getTSBeitragStatusValues;
function beitragStatusPrefix() {
    return 'TSBeitragStatus_';
}
exports.beitragStatusPrefix = beitragStatusPrefix;


/***/ }),

/***/ "RuPF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSAdresse_1 = __importDefault(__webpack_require__("aL5m"));
var TSGenossenschaftDaten = /** @class */ (function (_super) {
    __extends(TSGenossenschaftDaten, _super);
    function TSGenossenschaftDaten() {
        var _this = _super.call(this) || this;
        _this._isSteuerpflichtig = true;
        _this._adresse = new TSAdresse_1.default();
        return _this;
    }
    ;
    Object.defineProperty(TSGenossenschaftDaten.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGenossenschaftDaten.prototype, "adresse", {
        get: function () {
            return this._adresse;
        },
        set: function (value) {
            this._adresse = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGenossenschaftDaten.prototype, "isSteuerpflichtig", {
        get: function () {
            return this._isSteuerpflichtig;
        },
        set: function (value) {
            this._isSteuerpflichtig = value;
        },
        enumerable: true,
        configurable: true
    });
    TSGenossenschaftDaten.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.adresse = this.deserializeOrCreate(restObject.adresse, new TSAdresse_1.default());
        this.name = restObject.name;
        this.isSteuerpflichtig = restObject.isSteuerpflichtig;
        return this;
    };
    TSGenossenschaftDaten.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.adresse = this.serializeOrInit(this.adresse, restObject.adresse);
        restObject.name = this.name;
        restObject.isSteuerpflichtig = this.isSteuerpflichtig;
        return restObject;
    };
    return TSGenossenschaftDaten;
}(TSAbstractEntity_1.default));
exports.default = TSGenossenschaftDaten;


/***/ }),

/***/ "RxTB":
/***/ (function(module, exports) {

module.exports = " <div class=\"container versicherungsbeitraege-list-view\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate> <div class=\"row add-button-buffer\"> <div class=\"col-md-12\"> <button type=\"button\" ng-click=\"vm.addVersicherungsbeitrag()\" class=\"btn btn-serf-red\"> <span class=\"fa fa-plus btn-ico\"></span> <span data-translate=\"VERSICHERUNGSBEITRAG_CREATE\"></span> </button> </div> </div> <div class=\"row\"> <diV class=\"col-sm-12\"> <div dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\"> <dv-versicherungsbeitrag-list on-edit=\"vm.editVersicherungsbeitrag(versicherungsbeitrag, event)\" on-filter-change=\"vm.passVersicherungsbeitragFallFilterToServer(tableState, prefilter)\"> </dv-versicherungsbeitrag-list> </div> </diV> </div> </form> </div> ";

/***/ }),

/***/ "S1yE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSErfassungsArt_1 = __webpack_require__("X/T9");
var abstractModelController_1 = __importDefault(__webpack_require__("VDYy"));
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var AbstractModelManagerController = /** @class */ (function (_super) {
    __extends(AbstractModelManagerController, _super);
    function AbstractModelManagerController(schadenfallModelManager, $scope, pageName) {
        var _this = _super.call(this, $scope) || this;
        _this.schadenfallModelManager = schadenfallModelManager;
        _this.pageName = pageName;
        return _this;
    }
    AbstractModelManagerController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
    };
    AbstractModelManagerController.prototype.isSchadenFallReadonly = function () {
        if (this.pageName) {
            return this.schadenfallModelManager.isSchadenReadonly(this.pageName);
        }
        console.warn('No page name');
        return false;
    };
    AbstractModelManagerController.prototype.isSchadenFallVisible = function () {
        if (this.pageName) {
            return this.schadenfallModelManager.isSchadenVisible(this.pageName);
        }
        console.warn('No page name');
        return false;
    };
    AbstractModelManagerController.prototype.isSchadenFallVisibleAndNotNew = function () {
        if (this.pageName) {
            return this.schadenfallModelManager.isSchadenVisibleAndNotNew(this.pageName);
        }
        console.warn('No page name');
        return false;
    };
    AbstractModelManagerController.prototype.isPapiergesuch = function () {
        var schadenfall = this.schadenfallModelManager.getSchadenfall();
        if (schadenfall) {
            return schadenfall.erfassungsart === TSErfassungsArt_1.TSErfassungsArt.PAPIER;
        }
        else {
            return undefined;
        }
    };
    AbstractModelManagerController.prototype.isPhoneRequired = function () {
        var schadenfall = this.schadenfallModelManager.getSchadenfall();
        if (schadenfall) {
            return schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU;
        }
        else {
            return undefined;
        }
    };
    return AbstractModelManagerController;
}(abstractModelController_1.default));
exports.default = AbstractModelManagerController;


/***/ }),

/***/ "S2P7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("ITlK");
var DVPasswordChangerComponentConfig = /** @class */ (function () {
    function DVPasswordChangerComponentConfig() {
        this.transclude = false;
        this.bindings = {
            passworddata: '<',
            emailEnabled: '=',
            emailVisible: '='
        };
        this.template = __webpack_require__("Fvau");
        this.controller = DVPasswordChangerController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return DVPasswordChangerComponentConfig;
}());
exports.DVPasswordChangerComponentConfig = DVPasswordChangerComponentConfig;
var DVPasswordChangerController = /** @class */ (function () {
    /* @ngInject */
    function DVPasswordChangerController($translate) {
        this.required = true;
        this.$translate = $translate;
    }
    DVPasswordChangerController.prototype.$onInit = function () {
    };
    DVPasswordChangerController.prototype.getModel = function () {
        return this.passworddata;
    };
    DVPasswordChangerController.prototype.isEmaildisabled = function () {
        return this.emailEnabled === undefined && this.emailEnabled !== true;
    };
    DVPasswordChangerController.prototype.isEmailVisible = function () {
        return this.emailVisible === undefined || this.emailVisible === true;
    };
    DVPasswordChangerController.$inject = ['$translate'];
    return DVPasswordChangerController;
}());
exports.DVPasswordChangerController = DVPasswordChangerController;


/***/ }),

/***/ "SHSa":
/***/ (function(module, exports) {

module.exports = " <div class=\"fremdkosten-view container\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <fieldset ng-disabled=\"vm.isFremdkostenReadonly()\" ng-if=\"vm.isSchadenFallVisible()\"> <div class=\"row\"> <div class=\"col-sm-12\"> <h2> <span data-translate=\"AUFWAND_FREMDKOSTEN_ADD\" ng-if=\"!vm.schaetzung\"></span> <span data-translate=\"SCHAETZUNG_ADD\" ng-if=\"vm.schaetzung\"></span> <span>&nbsp;</span> <span ng-bind=\"vm.getModel().fremdkostenDatenFS.firma\"></span> </h2> </div> <div class=\"col-sm-12\"> <dv-fremdkosten fremdkosten=\"vm.getModel()\"></dv-fremdkosten> </div> <div class=\"col-sm-12\"> <h2> <span data-translate=\"BILDER_DOKUMENTE\"></span> </h2> <dv-dokumentupload schadenfallid=\"vm.schadenfallId\" parentid=\"vm.getModel().id\" document-type=\"vm.doctype\" on-doc-removed=\"vm.onDocRemoved(document)\" on-doc-added=\"vm.onDocAdded(document)\" required-docs=\"vm.getRequiredDocs()\" readonly=\"vm.isFremdkostenReadonly()\" begleit-text=\"AUFWAND_FREMDKOSTEN_UPLOAD_TXT\"> </dv-dokumentupload> </div> </div> </fieldset> <div class=\"col-sm-12\"> <div class=\"row mainbuttons\"> <div> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.cancelFremdkosten()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> <div> <dv-loading-button type=\"submit\" button-click=\"vm.saveFremdkosten()\" button-class=\"btn btn-serf\"> <span data-translate=\"SAVE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </div> </form> </div> ";

/***/ }),

/***/ "SOKL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DVScrollNav = /** @class */ (function () {
    /* @ngInject */
    function DVScrollNav($window) {
        this.restrict = 'A';
        this.link = function (scope, element, attrs, ctrl) {
            angular.element('.serf-body__content').bind('scroll', function () {
                var top = angular.element('.serf-body__content').scrollTop();
                if (top >= 40) {
                    scope.sticky = true;
                }
                else {
                    scope.sticky = false;
                }
                scope.$apply();
            });
            // For whatever reason firefox does scroll on window and not on content!
            // This is for firefox browsers:
            angular.element($window).bind('scroll', function () {
                var top = angular.element($window).scrollTop();
                if (top >= 40) {
                    scope.sticky = true;
                }
                else {
                    scope.sticky = false;
                }
                scope.$apply();
            });
        };
    }
    DVScrollNav.factory = function () {
        var directive = function ($window) { return new DVScrollNav($window); };
        directive.$inject = ['$window'];
        return directive;
    };
    DVScrollNav.$inject = ['$window'];
    return DVScrollNav;
}());
exports.default = DVScrollNav;


/***/ }),

/***/ "SUmS":
/***/ (function(module, exports) {

module.exports = " <div class=\"map\" id=\"map\"></div> <div id=\"mouse-position\"></div> ";

/***/ }),

/***/ "SX6k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BemerkungDialogController_1 = __webpack_require__("AtDi");
var RemoveDialogController_1 = __webpack_require__("92sy");
var YesNoController_1 = __webpack_require__("Um7h");
var TSBemerkungScope_1 = __webpack_require__("Oh5v");
var TSDokumentType_1 = __webpack_require__("/gTe");
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var TSEigenleistung_1 = __importDefault(__webpack_require__("/GH9"));
var TSEigenleistungDaten_1 = __importDefault(__webpack_require__("xwY2"));
var TSFremdkosten_1 = __importDefault(__webpack_require__("csNn"));
var TSFremdkostenDaten_1 = __importDefault(__webpack_require__("u0Wo"));
var TSVorleistung_1 = __importDefault(__webpack_require__("3494"));
var TSVorleistungDaten_1 = __importDefault(__webpack_require__("3Ly2"));
var abstractModelManagerController_1 = __importDefault(__webpack_require__("S1yE"));
var styles = __webpack_require__("2zEh");
var template = __webpack_require__("2oh6");
var removeDialogTemplate = __webpack_require__("YTLw");
var bemerkungDialogTemplate = __webpack_require__("APRe");
var yesNoTemplate = __webpack_require__("8KBA");
var AufwaendeViewComponentConfig = /** @class */ (function () {
    function AufwaendeViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = AufwaendeViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            schadenfall: '<',
            schaetzung: '<',
        };
    }
    return AufwaendeViewComponentConfig;
}());
exports.AufwaendeViewComponentConfig = AufwaendeViewComponentConfig;
var AufwaendeViewController = /** @class */ (function (_super) {
    __extends(AufwaendeViewController, _super);
    /* @ngInject */
    function AufwaendeViewController(dvBernUtil, schadenfallModelManager, $q, $scope, $translate, $log, $state, dvDialog, statuswechselService, authServiceRS, roleUtilService, errorService) {
        var _this = _super.call(this, schadenfallModelManager, $scope, $state.current.name) || this;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$translate = $translate;
        _this.$log = $log;
        _this.$state = $state;
        _this.dvDialog = dvDialog;
        _this.statuswechselService = statuswechselService;
        _this.authServiceRS = authServiceRS;
        _this.roleUtilService = roleUtilService;
        _this.errorService = errorService;
        _this.scopeToShow = [];
        _this.scope = TSBemerkungScope_1.TSBemerkungScope.AUFWAENDE;
        _this.relevanteEigenleistungen = [];
        _this.relevanteFremdkosten = [];
        _this.relevanteVorleistungen = [];
        return _this;
    }
    AufwaendeViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        if (!this.schadenfall) {
            console.error('no schadenfall passed to view');
        }
        else {
            this.initialModel = this.schadenfall;
            this.model = angular.copy(this.schadenfall);
        }
        if (!this.schadenfall.fremdkosten) {
            this.schadenfall.fremdkosten = [];
        }
        // Show only Bemerkungen from Scope Aufwände
        this.scopeToShow.push(TSBemerkungScope_1.TSBemerkungScope.AUFWAENDE);
        this.statuswechsel = this.statuswechselService.getStatuswechselMetadata(this.schadenfall.status, this.schadenfall.erfassungsart);
        this.initRelevantCollections();
        this.setShowSubventioniert();
        this.doctype = this.schaetzung ? TSDokumentType_1.TSDocumentType.SCHAETZUNG_DOC : TSDokumentType_1.TSDocumentType.AUFWAENDE_DOC;
    };
    AufwaendeViewController.prototype.getSchadenName = function (index) {
        return this.$translate.instant('SCHADEN') + ' ' + index;
    };
    AufwaendeViewController.prototype.cancelFremdkosten = function () {
        this.resetView();
    };
    AufwaendeViewController.prototype.addFremdkosten = function () {
        var newFremdkosten = this.createFremdkosten();
        var params;
        params = {
            schadenfallId: this.schadenfall.id,
            fremdkostenId: '',
            fremdkosten: newFremdkosten,
            schaetzung: String(this.schaetzung)
        };
        this.$state.go('fremdkosten', params);
    };
    AufwaendeViewController.prototype.deleteFremdkosten = function (fremdkosten, event) {
        var _this = this;
        this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController_1.RemoveDialogController, {
            text: '',
            title: 'AUFWAND_FREMDKOSTEN_REMOVE',
        }).then(function () {
            _this.schadenfallModelManager.removeFremdkosten(fremdkosten).then(function () {
                _this.initRelevantCollections();
            });
        }).catch(function () {
        });
    };
    AufwaendeViewController.prototype.editFremdkosten = function (fremdkosten, event) {
        var params;
        params = {
            schadenfallId: this.schadenfall.id,
            fremdkostenId: fremdkosten.id,
            fremdkosten: fremdkosten,
            schaetzung: String(this.schaetzung)
        };
        this.$state.go('fremdkosten', params);
    };
    AufwaendeViewController.prototype.deleteEigenleistung = function (eigenleistung, event) {
        var _this = this;
        this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController_1.RemoveDialogController, {
            text: '',
            title: 'EIGENLEISTUNG_LOESCHEN',
        }).then(function () {
            _this.schadenfallModelManager.removeEigenleistung(eigenleistung).then(function () {
                _this.initRelevantCollections();
            });
        }).catch(function () {
        });
    };
    AufwaendeViewController.prototype.editEigenleistung = function (eigenleistung, event) {
        var params;
        params = {
            schadenfallId: this.schadenfall.id,
            eigenleistungId: eigenleistung.id,
            eigenleistung: eigenleistung,
            schaetzung: String(this.schaetzung)
        };
        this.$state.go('eigenleistungen', params);
    };
    AufwaendeViewController.prototype.addEigenleistung = function () {
        var newEL = this.createEigenleistungen();
        var params;
        params = {
            schadenfallId: this.schadenfall.id,
            eigenleistungId: '',
            eigenleistung: newEL,
            schaetzung: String(this.schaetzung)
        };
        this.$state.go('eigenleistungen', params);
    };
    AufwaendeViewController.prototype.initRelevantCollections = function () {
        this.relevanteEigenleistungen = this.schadenfall.getRelevanteEigenleistungen(this.schaetzung);
        this.relevanteFremdkosten = this.schadenfall.getRelevanteFremdkosten(this.schaetzung);
        this.relevanteVorleistungen = this.schadenfall.getRelevanteVorleistungen(this.schaetzung);
    };
    AufwaendeViewController.prototype.deleteVorleistung = function (vorleistung, event) {
        var _this = this;
        this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController_1.RemoveDialogController, {
            text: '',
            title: 'VORLEISTUNG_LOESCHEN',
        }).then(function () {
            _this.schadenfallModelManager.removeVorleistung(vorleistung).then(function () {
                _this.initRelevantCollections();
            });
        }).catch(function () {
        });
    };
    AufwaendeViewController.prototype.editVorleistung = function (vorleistung, event) {
        var params;
        params = {
            schadenfallId: this.schadenfall.id,
            vorleistungId: vorleistung.id,
            vorleistung: vorleistung,
            schaetzung: String(this.schaetzung)
        };
        this.$state.go('vorleistung', params);
    };
    AufwaendeViewController.prototype.addVorleistung = function () {
        var newVorleistung = this.createVorleistung();
        var params;
        params = {
            schadenfallId: this.schadenfall.id,
            vorleistungId: '',
            vorleistung: newVorleistung,
            schaetzung: String(this.schaetzung)
        };
        this.$state.go('vorleistung', params);
    };
    AufwaendeViewController.prototype.getViewTitle = function () {
        return this.dvBernUtil.getViewTitle(this.schadenfall);
    };
    AufwaendeViewController.prototype.isFreigabeVisible = function () {
        //maybe extract this out into service?
        if (this.statuswechsel !== undefined) {
            var hasAllowedRole = this.authServiceRS.isOneOfRoles(this.statuswechsel.allowedRoles);
            var isOnRelevantPage = this.statuswechsel.visibleOnPage === this.$state.current.name;
            return hasAllowedRole && isOnRelevantPage && this.getSchadenfallEvents().length !== 0;
        }
        return false;
    };
    AufwaendeViewController.prototype.getChecklistEntries = function () {
        if (this.statuswechsel !== undefined) {
            return this.statuswechsel.checklistOptions;
        }
        return [];
    };
    AufwaendeViewController.prototype.getBegrundungscodeOptions = function () {
        if (this.statuswechsel !== undefined) {
            if (this.schadenfallEvent === undefined) {
                console.warn('Should have selected schadenfallEvent to trigger, otherwise allowed begruendugnscodes will not be set)');
                return [];
            }
            else {
                return this.statuswechsel.readBegruendungscodeOptions(this.schadenfallEvent);
            }
        }
        return [];
    };
    AufwaendeViewController.prototype.getSchadenfallEvents = function () {
        if (this.statuswechsel !== undefined) {
            return this.statuswechsel.possibleEvents;
        }
        return [];
    };
    AufwaendeViewController.prototype.checklistStatusChanged = function (allchecked) {
        this.checklistValid = allchecked;
        if (!this.checklistValid) {
            this.schadenfallEvent = undefined;
        }
    };
    AufwaendeViewController.prototype.isFreigabeDisabled = function () {
        return this.checklistValid !== true;
    };
    AufwaendeViewController.prototype.getRolesAllowedForBankdaten = function () {
        return this.dvBernUtil.getRolesAllowedForBankdaten();
    };
    AufwaendeViewController.prototype.isShowTitlePrefix = function () {
        return this.dvBernUtil.isShowTitlePrefix(this.schadenfall.gesuchsteller);
    };
    AufwaendeViewController.prototype.isSchadenFallAbrechnenAuszahlen = function () {
        if (this.schadenfall.status) {
            return this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN ||
                this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG;
        }
        return false;
    };
    AufwaendeViewController.prototype.saveAufwaendeSchaden = function () {
        var _this = this;
        this.errorService.clearAll();
        if (this.schadenfall) {
            this.schadenfallModelManager.saveSchaden(this.model.schaeden[0]).then(function (schadenResp) {
                _this.initialModel.schaeden[0] = schadenResp;
                _this.model.schaeden[0] = angular.copy(schadenResp);
                _this.schadenfall.schaeden[0] = schadenResp;
            });
        }
    };
    AufwaendeViewController.prototype.editBankkonto = function () {
        var params = { schadenfallId: this.schadenfall.id };
        this.$state.go('bankkonto', params);
    };
    AufwaendeViewController.prototype.getBegleitTextCode = function () {
        return this.schaetzung ? 'UPLOAD_TEXT' : 'AUFAWENDE_DOC_BEGLEITTEXT';
    };
    AufwaendeViewController.prototype.isGeschaetzteMassnahmenRequired = function () {
        return this.schadenfallModelManager.isStatusAbAuftragSchaetzer() || this.schadenfallModelManager.isStatusNeuPapierFS();
    };
    AufwaendeViewController.prototype.resetView = function () {
        this.form.$setPristine();
        this.form.$setUntouched();
    };
    AufwaendeViewController.prototype.createFremdkosten = function () {
        var fremdkosten = new TSFremdkosten_1.default();
        fremdkosten.schaetzung = this.schaetzung;
        fremdkosten.fremdkostenDatenFS = new TSFremdkostenDaten_1.default();
        return fremdkosten;
    };
    AufwaendeViewController.prototype.createEigenleistungen = function () {
        var eigenleistungen = new TSEigenleistung_1.default();
        eigenleistungen.schaetzung = this.schaetzung;
        eigenleistungen.eigenleistungDatenFS = new TSEigenleistungDaten_1.default();
        return eigenleistungen;
    };
    AufwaendeViewController.prototype.createVorleistung = function () {
        var vorleistung = new TSVorleistung_1.default();
        vorleistung.schaetzung = this.schaetzung;
        vorleistung.vorleistungDatenFS = new TSVorleistungDaten_1.default();
        return vorleistung;
    };
    AufwaendeViewController.prototype.isInWiederherstellung = function () {
        return this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG;
    };
    AufwaendeViewController.prototype.isInUeberpruefungSchaetzer = function () {
        return this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER;
    };
    AufwaendeViewController.prototype.isInAuftragOrUeberpruefungSchaetzer = function () {
        return this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER ||
            this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER;
    };
    AufwaendeViewController.prototype.isInUeberpruefungAnlaufstelle = function () {
        return this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE;
    };
    AufwaendeViewController.prototype.next = function () {
        this.errorService.clearAll();
        if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getSchaetzerRolesOnly()) && this.isInAuftragOrUeberpruefungSchaetzer()) {
            this.triggerSchaetzerFreigabe();
        }
        else if (this.isInWiederherstellung()) {
            this.transitWiederherstellung();
        }
        else if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getFondssuisseRoles()) &&
            (this.ueberpruefungFS() || this.isInStichentscheidFS() || this.isInBearbeitungASStichentscheidFS())) {
            //Ueberpruefung FS abschliessen
            this.triggerUeberpruefungFSDialog();
        }
        else if (this.isInUeberpruefungAnlaufstelle()) {
            this.triggerUeberpruefungAnlaufstelleDialog();
        }
        else {
            this.$log.info('no next state available for this fall in this role');
        }
    };
    AufwaendeViewController.prototype.triggerSchaetzerFreigabe = function () {
        if (!this.areSchaedenValid()) {
            return;
        }
        if (this.isInUeberpruefungSchaetzer()) {
            // Aufwand vorhanden, aber kein Bankkonto
            if (this.hasAufwand() && !this.hasBankkonto()) {
                this.errorService.addMesageAsError('ERROR_NO_BANKKONTO_ENTERED');
                return;
            }
            // Fall: in Überprüfung, Aufwand vorhanden, Bankkonto vorhanden
            this.triggerSchaetzerFreigabeDialog();
            return;
        }
        // Fall: nicht in Überprüfung
        this.triggerSchaetzerFreigabeDialog();
    };
    AufwaendeViewController.prototype.transitWiederherstellung = function () {
        var _this = this;
        if (!this.hasAufwand()) {
            var message = this.$translate.instant('ERROR_NO_LEISTUNG_ENTERED');
            this.dvDialog.showDialog(yesNoTemplate, YesNoController_1.YesNoController, {
                text: message,
                title: '',
            }).then(function () {
                _this.triggerBetroffenerFreigabeDialog();
            });
            return;
        }
        if (!this.hasBankkonto()) {
            this.errorService.addMesageAsError('ERROR_NO_BANKKONTO_ENTERED');
            return;
        }
        this.triggerBetroffenerFreigabeDialog();
    };
    AufwaendeViewController.prototype.hasAufwand = function () {
        return this.schadenfall.hasEigenleistungen() || this.schadenfall.hasFremdkosten() || this.schadenfall.hasVorleistungen();
    };
    AufwaendeViewController.prototype.hasBankkonto = function () {
        var finanz = this.schadenfall.gesuchsteller.finanzangaben;
        return !!finanz &&
            !!finanz.finanzangabenDatenFS.bankverbindung &&
            !!finanz.finanzangabenDatenFS.bankverbindung.iban;
    };
    AufwaendeViewController.prototype.hasNoSchaetzung = function () {
        //wenn keine Schaetzung vorhanden ist
        if (this.schadenfall.getAbrechnungsbetrag(true) === null ||
            this.schadenfall.getAbrechnungsbetrag(true) === undefined ||
            this.schadenfall.getAbrechnungsbetrag(true) === 0) {
            return true;
        }
        return false;
    };
    AufwaendeViewController.prototype.areSchaedenValid = function () {
        if (this.schadenfall.schaeden.filter(function (schaden) { return schaden.schadenDatenFS.vorgeseheneMassnahmen === null ||
            schaden.schadenDatenFS.vorgeseheneMassnahmen === undefined; }).length > 0) {
            //wenn min ein Schaden keinen Beschrieb hat Fehler anzeigen
            this.errorService.addMesageAsError('ERROR_NO_SCHADEN_VORGESEHENE_MASSNAHMEN');
            return false;
        }
        if (this.schadenfall.schaeden.filter(function (schaden) { return schaden.schadenDatenFS.otherwieseSubventionierbar === null ||
            schaden.schadenDatenFS.otherwieseSubventionierbar === undefined; }).length > 0) {
            //wenn min ein Schaden kein subventioniert flag hat Fehler anzeigen
            this.errorService.addMesageAsError('ERROR_NO_SUBVENTIONIERT_FLAG');
            return false;
        }
        // further checks are removed, see FS-653
        return true;
    };
    AufwaendeViewController.prototype.triggerSchaetzerFreigabeDialog = function () {
        if (this.hasNoSchaetzung()) {
            //Warnung, wenn keine Schaetzung (Abrechnungsbetrag) vorhanden ist
            this.freigabeDialogWithWarning();
        }
        else {
            this.freigabeDialogWithoutWarning();
        }
    };
    AufwaendeViewController.prototype.freigabeDialogWithoutWarning = function () {
        var _this = this;
        this.dvDialog.showBemerkungDialog(bemerkungDialogTemplate, BemerkungDialogController_1.BemerkungDialogController, {
            text: this.schadenfallEvent,
            begrundungscodeOptions: this.getBegrundungscodeOptions(),
            showBegruendung: true,
            showBemerkung: true,
        }).then(function (response) {
            if (response && _this.schadenfallEvent) {
                _this.saveAufwaendeSchaden();
                _this.schadenfallModelManager.handleTransition(_this.schadenfall, TSBemerkungScope_1.TSBemerkungScope.AUFWAENDE, response.begruendung, response.bemerkung, _this.schadenfallEvent)
                    .then(function () {
                    _this.$state.go('schadenfaelle');
                });
            }
        }).catch(function () {
        });
    };
    AufwaendeViewController.prototype.freigabeDialogWithWarning = function () {
        var _this = this;
        var message = this.$translate.instant('ERROR_NO_SCHAETZUNG');
        this.dvDialog.showDialog(yesNoTemplate, YesNoController_1.YesNoController, {
            text: message,
            title: '',
        }).then(function () {
            if (_this.schadenfallEvent) {
                _this.saveAufwaendeSchaden();
                _this.schadenfallModelManager.handleTransition(_this.schadenfall, TSBemerkungScope_1.TSBemerkungScope.AUFWAENDE, undefined, '', _this.schadenfallEvent)
                    .then(function () {
                    _this.$state.go('schadenfaelle');
                });
            }
        }).catch(function () {
        });
    };
    AufwaendeViewController.prototype.triggerBetroffenerFreigabeDialog = function () {
        var _this = this;
        this.dvDialog.showBemerkungDialog(bemerkungDialogTemplate, BemerkungDialogController_1.BemerkungDialogController, {
            text: 'FREIGABE_BEMERKUNG_GESUCHSTELLER_TEXT',
            showBegruendung: false,
            showBemerkung: false,
        }).then(function (response) {
            if (response && _this.schadenfallEvent) {
                _this.saveAufwaendeSchaden();
                _this.schadenfallModelManager.handleTransition(_this.schadenfall, TSBemerkungScope_1.TSBemerkungScope.AUFWAENDE, response.begruendung, response.bemerkung, _this.schadenfallEvent)
                    .then(function (response) {
                    _this.$state.go('schadenfaelle');
                });
            }
        }).catch(function () {
        });
    };
    AufwaendeViewController.prototype.triggerUeberpruefungAnlaufstelleDialog = function () {
        this.triggerGenericFreigabeDialog();
    };
    AufwaendeViewController.prototype.triggerUeberpruefungFSDialog = function () {
        this.triggerGenericFreigabeDialog();
    };
    AufwaendeViewController.prototype.triggerGenericFreigabeDialog = function (params) {
        var _this = this;
        //use passed params or init default
        var dialogParams = params || {
            text: this.schadenfallEvent,
            begrundungscodeOptions: this.getBegrundungscodeOptions(),
            showBegruendung: true,
            showBemerkung: true,
        };
        this.dvDialog.showBemerkungDialog(bemerkungDialogTemplate, BemerkungDialogController_1.BemerkungDialogController, dialogParams).then(function (response) {
            if (response && _this.schadenfallEvent) {
                _this.saveAufwaendeSchaden();
                _this.schadenfallModelManager.handleTransition(_this.schadenfall, TSBemerkungScope_1.TSBemerkungScope.AUFWAENDE, response.begruendung, response.bemerkung, _this.schadenfallEvent)
                    .then(function (response) {
                    _this.resetView();
                    _this.$state.go('schadenfaelle');
                });
            }
        }).catch(function () {
        });
    };
    AufwaendeViewController.prototype.setShowSubventioniert = function () {
        this.showSubventioniert =
            this.schaetzung &&
                (this.schadenfallModelManager.isStatusAbAuftragSchaetzer() || this.schadenfallModelManager.isStatusNeuPapierFS());
    };
    AufwaendeViewController.prototype.ueberpruefungFS = function () {
        return this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE;
    };
    AufwaendeViewController.prototype.isInStichentscheidFS = function () {
        return this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS;
    };
    AufwaendeViewController.prototype.isInBearbeitungASStichentscheidFS = function () {
        return this.schadenfall.status === TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS;
    };
    AufwaendeViewController.$inject = [
        'DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$log', '$state',
        'DvDialog', 'StatuswechselService', 'AuthServiceRS', 'RoleUtilService', 'ErrorService',
    ];
    return AufwaendeViewController;
}(abstractModelManagerController_1.default));
exports.AufwaendeViewController = AufwaendeViewController;


/***/ }),

/***/ "SbSG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var authentication_route_1 = __webpack_require__("xmie");
__webpack_require__("XrDZ");
var template = __webpack_require__("fqwK");
var VerifyComponentConfig = /** @class */ (function () {
    function VerifyComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = VerifyViewController;
        this.controllerAs = 'vm';
    }
    return VerifyComponentConfig;
}());
exports.VerifyComponentConfig = VerifyComponentConfig;
var VerifyViewController = /** @class */ (function () {
    function VerifyViewController($state, $stateParams, benutzerRS, $log, errorService, CONSTANTS, $translate, $timeout, authService) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.benutzerRS = benutzerRS;
        this.$log = $log;
        this.errorService = errorService;
        this.CONSTANTS = CONSTANTS;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.authService = authService;
    }
    VerifyViewController.prototype.$onInit = function () {
        var _this = this;
        var benutzerid = this.$stateParams.verifyBenutzer || '';
        this.$log.debug('verifying benutzer with id ' + benutzerid);
        this.benutzerRS.verify(benutzerid).then(function (response) {
            _this.errorService.addMesageAsInfo('EMAIL_VERIFIED');
            if (_this.authService.isLoggedId()) {
                //wenn schon eingeloggt auf startseite weiterlieten (sollte wohl nicht vorkommen)
                _this.authService.logoutRequest().then(function () {
                    _this.$log.debug('logout successfull');
                    _this.loginWithResponse(response);
                });
            }
            _this.loginWithResponse(response);
        }).catch(function (reason) {
            _this.$log.debug('Email verification failed');
        });
        this.errorService.clearAll();
    };
    VerifyViewController.prototype.loginWithResponse = function (response) {
        //auf loginseite weiterleiten
        var params = new authentication_route_1.IAuthenticationStateParams();
        params.userID = (response && response.email) ? response.email : '';
        this.$state.go('login', params);
    };
    VerifyViewController.prototype.back = function () {
        this.$state.go('start'); // going back to start
    };
    VerifyViewController.$inject = ['$state', '$stateParams', 'BenutzerRS',
        '$log', 'ErrorService', 'CONSTANTS', '$translate', '$timeout', 'AuthServiceRS'];
    return VerifyViewController;
}());
exports.VerifyViewController = VerifyViewController;


/***/ }),

/***/ "Sckn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSCockpitResultDTO_1 = __importDefault(__webpack_require__("I7ot"));
var CockpitRS = /** @class */ (function () {
    /* @ngInject */
    function CockpitRS($http, REST_API, $log, $translate) {
        this.$log = $log;
        this.$translate = $translate;
        this.serviceURL = REST_API + 'cockpit';
        this.http = $http;
    }
    CockpitRS.prototype.searchCockpitResult = function (cockpitTypeDTO) {
        var _this = this;
        cockpitTypeDTO.locale = this.$translate.use();
        var sentDto = {};
        sentDto = cockpitTypeDTO.serialize(sentDto);
        return this.http.post(this.serviceURL + '/search/', sentDto, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            _this.$log.debug('PARSING result REST array object', response.data);
            return new TSCockpitResultDTO_1.default().deserialize(response.data);
        });
    };
    CockpitRS.$inject = ['$http', 'REST_API', '$log', '$translate'];
    return CockpitRS;
}());
exports.default = CockpitRS;


/***/ }),

/***/ "SzTv":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("Rf7t");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./inspektoratverwaltungView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./inspektoratverwaltungView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "T5Im":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSDokumentType_1 = __webpack_require__("/gTe");
var TSFremdkosten_1 = __importDefault(__webpack_require__("csNn"));
var TSFremdkostenDaten_1 = __importDefault(__webpack_require__("u0Wo"));
var abstractModelManagerController_1 = __importDefault(__webpack_require__("S1yE"));
var TSLeistungsart_1 = __webpack_require__("LBP/");
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var styles = __webpack_require__("w8D+");
var template = __webpack_require__("SHSa");
var FremdkostenEditViewComponentConfig = /** @class */ (function () {
    function FremdkostenEditViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = FremdkostenViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            fremdkosten: '<',
            schadenfallId: '<',
            schaetzung: '<',
        };
    }
    return FremdkostenEditViewComponentConfig;
}());
exports.FremdkostenEditViewComponentConfig = FremdkostenEditViewComponentConfig;
var FremdkostenViewController = /** @class */ (function (_super) {
    __extends(FremdkostenViewController, _super);
    /* @ngInject */
    function FremdkostenViewController(dvBernUtil, schadenfallModelManager, $q, $scope, $translate, $log, $state, $stateParams) {
        var _this = _super.call(this, schadenfallModelManager, $scope, $state.current.name) || this;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$translate = $translate;
        _this.$log = $log;
        _this.$state = $state;
        _this.$stateParams = $stateParams;
        _this.doctype = TSDokumentType_1.TSDocumentType.FREMDKOSTEN_DOC;
        return _this;
    }
    FremdkostenViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        if (!this.fremdkosten) {
            this.fremdkosten = new TSFremdkosten_1.default();
            this.fremdkosten.schaetzung = this.schaetzung;
            this.fremdkosten.fremdkostenDatenFS = new TSFremdkostenDaten_1.default();
            this.$log.warn('initialized fremdkosten to edit directly in view, should pass fremdkosten to edit along');
        }
        else {
            this.initialModel = this.fremdkosten;
            this.model = angular.copy(this.fremdkosten);
        }
    };
    FremdkostenViewController.prototype.saveFremdkosten = function () {
        var _this = this;
        if (this.isModelValid() && this.fremdkosten) {
            this.schadenfallModelManager.saveFremdkosten(this.getModel()).then(function (result) {
                _this.navigateAway();
            });
        }
        else {
            this.$log.debug('Form was not valid');
        }
    };
    FremdkostenViewController.prototype.cancelFremdkosten = function () {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.navigateAway();
    };
    FremdkostenViewController.prototype.navigateAway = function () {
        var nextPage = this.schaetzung ? 'schaetzung' : 'aufwaende';
        this.$state.go(nextPage, { schadenfallId: this.schadenfallId });
    };
    FremdkostenViewController.prototype.isFremdkostenReadonly = function () {
        //FIXME FS-706 temporary hack. Solve with separate view
        return (this.schaetzung &&
            !(this.schadenfallModelManager.isSchadenfallStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER) ||
                this.schadenfallModelManager.isSchadenfallStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE)));
    };
    FremdkostenViewController.prototype.getRequiredDocs = function () {
        var required = 1; //1: mandatory, 0: optional
        var fremdkosten = this.getModel();
        if (fremdkosten && fremdkosten.fremdkostenDatenFS && fremdkosten.fremdkostenDatenFS.leistungsart) {
            if (fremdkosten.fremdkostenDatenFS.leistungsart === TSLeistungsart_1.TSLeistungsart.MATERIAL) {
                required = 0;
            }
        }
        if (this.schaetzung) {
            required = 0;
        }
        return required;
    };
    FremdkostenViewController.$inject = ['DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$log', '$state'];
    return FremdkostenViewController;
}(abstractModelManagerController_1.default));
exports.FremdkostenViewController = FremdkostenViewController;


/***/ }),

/***/ "TA1E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSVersicherungsbeitragDTO_1 = __importDefault(__webpack_require__("17QL"));
var TSVersicherungsbeitraegeSearchresultDTO = /** @class */ (function () {
    function TSVersicherungsbeitraegeSearchresultDTO() {
        this._versicherungsbeitragDTOs = [];
        this._totalResultSize = 0;
    }
    Object.defineProperty(TSVersicherungsbeitraegeSearchresultDTO.prototype, "versicherungsbeitragDTOs", {
        get: function () {
            return this._versicherungsbeitragDTOs;
        },
        set: function (value) {
            this._versicherungsbeitragDTOs = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitraegeSearchresultDTO.prototype, "totalResultSize", {
        get: function () {
            return this._totalResultSize;
        },
        set: function (value) {
            this._totalResultSize = value;
        },
        enumerable: true,
        configurable: true
    });
    TSVersicherungsbeitraegeSearchresultDTO.prototype.parseSchadenfallDTOs = function (data) {
        var pendenzen = [];
        if (data && Array.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                pendenzen[i] = new TSVersicherungsbeitragDTO_1.default().deserialize(data[i]);
            }
        }
        else {
            pendenzen[0] = new TSVersicherungsbeitragDTO_1.default().deserialize(data);
        }
        return pendenzen;
    };
    TSVersicherungsbeitraegeSearchresultDTO.prototype.deserialize = function (restObject) {
        this.versicherungsbeitragDTOs = this.parseSchadenfallDTOs(restObject.versicherungsbeitragDTOs);
        this.totalResultSize = restObject.paginationDTO.totalItemCount;
        return this;
    };
    return TSVersicherungsbeitraegeSearchresultDTO;
}());
exports.default = TSVersicherungsbeitraegeSearchresultDTO;


/***/ }),

/***/ "TfvN":
/***/ (function(module, exports) {

module.exports = " <div class=\"container benutzerverwaltung-view\"> <div class=\"row add-button-buffer\"> <div class=\"col-md-12\"> <button ng-click=\"vm.addBenutzer()\" ui-sref=\"benutzeredit\" class=\"btn btn-serf-red\"> <span class=\"fa fa-plus btn-ico\"></span> <span data-translate=\"BENUTZERVERWALTUNG_ADD\"> </span> </button> </div> </div> <div class=\"row\"> <div class=\"col-md-12\"> <dv-benutzer-list benutzerlist=\"vm.benutzerToShow\" show-actions=\"false\" show-anlaufstelle-and-kanton=\"true\" on-edit=\"vm.editBenutzer(benutzer, event)\"> </dv-benutzer-list> </div> </div> </div> ";

/***/ }),

/***/ "TkjQ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.dv-gemeinde-typeahead__no-results-msg{margin-top:30px}", ""]);

// exports


/***/ }),

/***/ "TnNA":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.dv-fremdkosten-list .rowHeader-schaetzung{width:0}.dv-fremdkosten-list .rowHeader-berechtigterBetrag,.dv-fremdkosten-list .rowHeader-betrag,.dv-fremdkosten-list .rowHeader-leistungsart,.dv-fremdkosten-list .rowHeader-rechnungsdatum,.dv-fremdkosten-list .rowHeader-rechnungsnummer{width:15%}.dv-fremdkosten-list .rowHeader-actions{width:130px}.dv-fremdkosten-list .rowBody-actions{text-align:center}.dv-fremdkosten-list .rowBody-actions button{width:30px}", ""]);

// exports


/***/ }),

/***/ "TvPS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Ki-Tax: System for the management of external childcare subsidies
 * Copyright (C) 2017 City of Bern Switzerland
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSStatistikParameterType;
(function (TSStatistikParameterType) {
    TSStatistikParameterType["TEST"] = "TEST";
})(TSStatistikParameterType = exports.TSStatistikParameterType || (exports.TSStatistikParameterType = {}));


/***/ }),

/***/ "U0eN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OkHtmlDialogController = /** @class */ (function () {
    function OkHtmlDialogController($uibModalInstance, $translate, title, text) {
        this.$uibModalInstance = $uibModalInstance;
        if (text !== undefined && text !== null) {
            this.text = $translate.instant(text);
        }
        else {
            this.text = 'text';
        }
        if (title !== undefined && title !== null) {
            this.title = $translate.instant(title);
        }
        else {
            this.title = 'Confirmation';
        }
    }
    OkHtmlDialogController.prototype.ok = function () {
        this.$uibModalInstance.close();
    };
    ;
    OkHtmlDialogController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    ;
    OkHtmlDialogController.$inject = ['$uibModalInstance', '$translate', 'title', 'text'];
    return OkHtmlDialogController;
}());
exports.OkHtmlDialogController = OkHtmlDialogController;


/***/ }),

/***/ "U22j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSRole_1 = __webpack_require__("MleR");
var TSAuthLoginElement_1 = __importDefault(__webpack_require__("63CK"));
var AuthenticationUtil_1 = __importDefault(__webpack_require__("BH0P"));
var template = __webpack_require__("NRA0");
__webpack_require__("vxUb");
var AuthenticationComponentConfig = /** @class */ (function () {
    function AuthenticationComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = AuthenticationListViewController;
        this.controllerAs = 'vm';
        this.bindings = { mode: '@' };
    }
    return AuthenticationComponentConfig;
}());
exports.AuthenticationComponentConfig = AuthenticationComponentConfig;
var AuthenticationListViewController = /** @class */ (function () {
    function AuthenticationListViewController($state, $stateParams, $window, $httpParamSerializer, $timeout, authService, $location, $log, errorService, $translate) {
        var _this = this;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$window = $window;
        this.$httpParamSerializer = $httpParamSerializer;
        this.$timeout = $timeout;
        this.authService = authService;
        this.$location = $location;
        this.$log = $log;
        this.errorService = errorService;
        this.$translate = $translate;
        this.redirectionUrl = '/serf/saml2/jsp/fedletSSOInit.jsp';
        this.countdown = 0;
        this.redirect = function () {
            var urlToGoTo = _this.redirectionHref;
            console.log('redirecting to login', urlToGoTo);
            _this.$window.open(urlToGoTo, '_self');
        };
        this.relayString = angular.copy(this.$stateParams.relayPath ? (this.$stateParams.relayPath) : '');
    }
    AuthenticationListViewController.prototype.$onInit = function () {
        this.loginCedentials = new TSAuthLoginElement_1.default();
        //makes it possible to log out using a link
        if (this.$stateParams.type !== undefined && this.$stateParams.type === 'logout') {
            this.doLogout();
        }
        if (this.$stateParams.userID) {
            this.loginCedentials.username = this.$stateParams.userID;
        }
        this.gsBackgroundClass = this.randomGSBackg(); //only do this once
    };
    AuthenticationListViewController.prototype.getBaseURL = function () {
        //let port = (this.$location.port() === 80 || this.$location.port() === 443) ? '' : ':' + this.$location.port();
        var absURL = this.$location.absUrl();
        var index = absURL.indexOf(this.$location.url());
        var result = absURL;
        if (index !== -1) {
            result = absURL.substr(0, index);
            var hashindex = result.indexOf('#');
            if (hashindex !== -1) {
                result = absURL.substr(0, hashindex);
            }
        }
        return result;
    };
    AuthenticationListViewController.prototype.singlelogout = function () {
        var _this = this;
        this.authService.logoutRequest().then(function () {
            if (_this.logoutHref !== '' || _this.logoutHref === undefined) {
                _this.$window.open(_this.logoutHref, '_self');
            }
            else {
                _this.$state.go('start'); // wenn wir nicht in iam ausloggen gehen wir auf start
            }
        });
    };
    AuthenticationListViewController.prototype.isLoggedId = function () {
        console.log('logged in principal', this.authService.getPrincipal());
        return this.authService.getPrincipal() ? true : false;
    };
    AuthenticationListViewController.prototype.loginClicked = function () {
        var _this = this;
        this.errorService.clearError('ERROR_LOGIN');
        if (this.form.$valid) {
            this.errorService.clearAll();
            this.authService.loginRequest(this.loginCedentials)
                .then(function (response) {
                _this.$log.debug('Successfully logged in');
                // todo homa: wir sollten uns merken wo wir vorher waren und wenn noetig dahin zurueck
                if (_this.relayString) {
                    console.log(_this.relayString);
                }
                if (response && response.roles) {
                    var mostPrivilegedRole = _this.authService.getHighestRoleOfBenutzer(response.roles);
                    if (mostPrivilegedRole === TSRole_1.TSRole.UNASSIGNED_ROLE) { //if no role assigned also warn the user about it
                        _this.errorService.addMesageAsError('ERROR_NO_FUNCTIONAL_ROLE');
                    }
                    AuthenticationUtil_1.default.navigateToStartPageForRole(mostPrivilegedRole, _this.$state);
                }
            }).catch(function (err) {
                // Error handling
                _this.$log.debug('error: invalid login');
                _this.errorService.addValidationError('ERROR_LOGIN');
                //wenn wir eine spezifische meldung haben zeigen wir die auch noch an
                if (err.data && err.data.errorCodeEnum) {
                    var msg = err.data.translatedMessage || err.data.errorCodeEnum;
                    _this.errorService.addValidationError(msg);
                }
            });
        }
        else {
            this.$log.debug('Login form was not valid');
        }
    };
    /**
     * triggered einen logout, fuer iam user sowohl in iam als auch in ebegu,
     * bei lokalen benutzern wird auch nur bei uns ausgeloggt
     */
    AuthenticationListViewController.prototype.doLogout = function () {
        if (this.authService.getPrincipal()) { // wenn logged in
            this.authService.logoutRequest();
        }
    };
    AuthenticationListViewController.prototype.isBenutzerRegVisible = function () {
        return this.mode !== 'anlaufstellepruefer';
    };
    AuthenticationListViewController.prototype.isAnlaufstellenRegVisible = function () {
        return this.mode === 'anlaufstellepruefer';
    };
    AuthenticationListViewController.prototype.getBackground = function () {
        if (this.isBenutzerRegVisible()) {
            return this.gsBackgroundClass;
        }
        else if (this.isAnlaufstellenRegVisible()) {
            return 'background-as';
        }
        return 'background-gs-1';
    };
    AuthenticationListViewController.prototype.randomGSBackg = function () {
        var items = ['background-gs-1', 'background-gs-2', 'background-gs-3', 'background-gs-4', 'background-gs-5'];
        var item = items[Math.floor(Math.random() * items.length)];
        return item;
    };
    AuthenticationListViewController.prototype.getCurrentLang = function () {
        return this.$translate.use();
    };
    AuthenticationListViewController.prototype.isLangActive = function (lang) {
        return this.getCurrentLang() === lang;
    };
    AuthenticationListViewController.$inject = ['$state', '$stateParams', '$window', '$httpParamSerializer', '$timeout', 'AuthServiceRS',
        '$location', '$log', 'ErrorService', '$translate'];
    return AuthenticationListViewController;
}());
exports.AuthenticationListViewController = AuthenticationListViewController;


/***/ }),

/***/ "UB4u":
/***/ (function(module, exports) {

module.exports = " <div class=\"dv-bemerkungen-erfassen\"> <div class=\"row\"> <div class=\"col-sm-12\"> <textarea title=\"{{NEUE_BEMERKUNG_ERFASSEN | translate}}\" name=\"newBemerkung\" class=\"form-control input-element\" rows=\"6\" ng-model=\"vm.bemerkung\" maxlength=\"4000\">\n            </textarea> </div> <div class=\"col-sm-12 marginTop20\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getAllRolesButGesuchsteller()\"> <dv-input-container> <div> <label class=\"md-no-float\" data-translate=\"SICHTBARKEIT\"></label> </div> <div class=\"radio-inline\" ng-repeat=\"sichtbarkeit in vm.getTSBemerkungSichtbarkeitValues()\"> <label ng-if=\"vm.isSichtbarkeitVisible(sichtbarkeit)\"> <input ng-value=\"sichtbarkeit\" aria-label=\"{{sichtbarkeit}}\" ng-model=\"vm.sichtbarkeit\" type=\"radio\" name=\"sichtbarkeit\" ng-required=\"true\" class=\"input-element\"> <span>{{sichtbarkeit | translate}}</span> <dv-error-messages ng-show=\"$last\" for=\"vm.form.sichtbarkeit\"></dv-error-messages> </label> </div> </dv-input-container> </div> <div class=\"col-sm-12 marginTop20\"> <dv-loading-button type=\"submit\" button-click=\"vm.saveBemerkung()\" button-class=\"btn btn-serf-red\"> <span data-translate=\"BEMERKUNG_ERFASSEN\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </div> ";

/***/ }),

/***/ "UBcp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSAnrede_1 = __webpack_require__("h+M8");
var TSSprache_1 = __webpack_require__("3oUo");
var KontaktPersonComponentConfig = /** @class */ (function () {
    function KontaktPersonComponentConfig() {
        this.transclude = false;
        this.bindings = {
            model: '=',
            name: '@',
            dontShowAdresse: '<',
            dontShowKorrespondenzsprache: '<',
            emailNotRequired: '<?',
            dontShowEmail: '<?',
            phoneRequired: '<?',
            angabe: '@',
        };
        this.template = __webpack_require__("MQFV");
        this.controller = DvKontaktPersonController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return KontaktPersonComponentConfig;
}());
exports.KontaktPersonComponentConfig = KontaktPersonComponentConfig;
var DvKontaktPersonController = /** @class */ (function () {
    /* @ngInject */
    function DvKontaktPersonController(CONSTANTS, $translate) {
        this.CONSTANTS = CONSTANTS;
        this.$translate = $translate;
    }
    DvKontaktPersonController.prototype.$onInit = function () {
        var tmpmodel = this.getModel();
        if (tmpmodel) {
            tmpmodel.gesuchsPersonDatenFS.korrespondenzsprache = TSSprache_1.getLanguageByKey(this.getCurrentLang());
        }
        tmpmodel = null;
    };
    DvKontaktPersonController.prototype.getModel = function () {
        return this.model;
    };
    DvKontaktPersonController.prototype.getTSAnredeValues = function () {
        return TSAnrede_1.getTSAnredeValues();
    };
    DvKontaktPersonController.prototype.getTSSpracheValues = function () {
        return TSSprache_1.getTSSpracheValues();
    };
    DvKontaktPersonController.prototype.getCurrentLang = function () {
        return this.$translate.use();
    };
    DvKontaktPersonController.$inject = ['CONSTANTS', '$translate'];
    return DvKontaktPersonController;
}());
exports.DvKontaktPersonController = DvKontaktPersonController;


/***/ }),

/***/ "UD8l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSEigentumsverhaeltnis_1 = __webpack_require__("PSWS");
var TSRechtsform_1 = __webpack_require__("EUJE");
var TSRole_1 = __webpack_require__("MleR");
/**
 * Klasse die allgemeine utils Methoden implementiert
 */
var DVBernUtil = /** @class */ (function () {
    /* @ngInject */
    function DVBernUtil($filter, CONSTANTS, $translate, roleUtilService) {
        this.$filter = $filter;
        this.CONSTANTS = CONSTANTS;
        this.$translate = $translate;
        this.roleUtilService = roleUtilService;
    }
    /**
     * Translates the given string using the angular-translate filter
     * @param toTranslate word to translate
     * @returns {any} translated word
     */
    DVBernUtil.prototype.translateString = function (toTranslate) {
        return this.$filter('translate')(toTranslate).toString();
    };
    /**
     * Translates the given list using the angular translate filter
     * @param translationList list of words that will be translated
     * @returns {any} A List of Objects with key and value, where value is the translated word.
     */
    DVBernUtil.prototype.translateStringList = function (translationList) {
        var _this = this;
        var listResult = [];
        translationList.forEach(function (item) {
            listResult.push({ key: item, value: _this.translateString(item) });
        });
        return listResult;
    };
    DVBernUtil.prototype.getJahrtext = function (rechtsform) {
        if (rechtsform === TSRechtsform_1.TSRechtsform.GENOSSENSCHAFT) {
            return this.$translate.instant('JAHR');
        }
        else {
            return this.$translate.instant('STEUERJAHR');
        }
    };
    DVBernUtil.prototype.getEinkommenGewinnText = function (rechtsform) {
        if (rechtsform === TSRechtsform_1.TSRechtsform.GENOSSENSCHAFT) {
            return this.$translate.instant('GEWINN');
        }
        else {
            return this.$translate.instant('STEUERBARES_EINKOMMEN');
        }
    };
    DVBernUtil.prototype.getVermoegenKapitalText = function (rechtsform) {
        if (rechtsform === TSRechtsform_1.TSRechtsform.GENOSSENSCHAFT) {
            return this.$translate.instant('KAPITAL');
        }
        else {
            return this.$translate.instant('STEUERBARES_VERMOEGEN');
        }
    };
    DVBernUtil.getIndexOfElementwithID = function (entityToSearch, listToSearchIn) {
        return DVBernUtil.getIndexOfElementwithIDById(entityToSearch.id, listToSearchIn);
    };
    DVBernUtil.getIndexOfElementwithIDById = function (idToSearch, listToSearchIn) {
        if (idToSearch) {
            for (var i = 0; i < listToSearchIn.length; i++) {
                if (listToSearchIn[i].id === idToSearch) {
                    return i;
                }
            }
        }
        return -1;
    };
    // set Bankverbindung undefined when IBAN is not available in order to avoid mapping and (storing) Bankverbindung
    // (bean validation would throw an error in case of an invalid / missing IBAN)
    DVBernUtil.setBankverbindungUndefinedIfNoIban = function (model) {
        if (this.isBankverbindungDefined(model)) {
            if (!this.isIbanDefined(model)) {
                model.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung = undefined;
            }
        }
    };
    DVBernUtil.isIbanDefined = function (model) {
        return model.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung.iban;
    };
    DVBernUtil.isBankverbindungDefined = function (model) {
        return model.gesuchsteller.finanzangaben && model.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung;
    };
    DVBernUtil.prototype.getRolesAllowedForBankdaten = function () {
        return this.getRolesAllowedForSteuerdaten().concat(TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER);
    };
    DVBernUtil.prototype.getRolesAllowedForSteuerdaten = function () {
        // Betroffenen, die Anlaufstelle und den Fondssuisse. Für der Kanton und Schätzer sind diese Daten nicht sichtbar
        var allowedRoles = [];
        allowedRoles = allowedRoles.concat(this.roleUtilService.getGesuchstellerRoles());
        allowedRoles = allowedRoles.concat(this.roleUtilService.getAnlaufstelleRoles());
        allowedRoles = allowedRoles.concat(this.roleUtilService.getFondssuisseRoles());
        // FS-493 Kantonsexperte (Inspektor) soll finanzielle Verhältnisse und Kontoangaben sehen können
        allowedRoles = allowedRoles.concat(TSRole_1.TSRole.KANTON_INSPEKTOR);
        return allowedRoles;
    };
    /**
     * Erzeugt einen random String mit einer Laenge von numberOfCharacters
     * @param numberOfCharacters
     * @returns {string}
     */
    DVBernUtil.generateRandomName = function (numberOfCharacters) {
        var text = '';
        var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < numberOfCharacters; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    };
    DVBernUtil.focusFirstInvalidInput = function () {
        var firstInvalid = angular.element('form .ng-invalid').first();
        if (firstInvalid && firstInvalid.get(0)) {
            var loopcount = 0;
            // sollten wir in einem div sein, suchen wir den ersten subelement
            while ((firstInvalid.get(0).tagName === 'FORM' || firstInvalid.get(0).tagName === 'DIV') && loopcount < 5) {
                firstInvalid = firstInvalid.find('.ng-invalid').first();
                loopcount++;
            }
            if (firstInvalid.get(0).getAttribute('type') === 'hidden') { //Fuer versteckte Elemente geht es mit dem parent weiter da man sie nicht focusen kann
                firstInvalid = firstInvalid.parent();
            }
            if (firstInvalid.get(0).tagName !== 'INPUT') { // Fuer alle Elemente die kein INPUT sind, muessen wir den tabindex setzen, damit focus() funktioniert
                firstInvalid.attr('tabindex', -1).focus();
                console.debug('could not find input element for invalid focus? -> ' + firstInvalid.get(0).tagName);
            }
            else {
                firstInvalid.focus();
            }
        }
    };
    DVBernUtil.prototype.getViewTitle = function (schadenfall) {
        if (!(schadenfall && schadenfall.isNew())) {
            return this.$translate.instant('SCHADENFALL') + ' - ' + schadenfall.getFallnummerWithZeros();
        }
        else {
            return this.$translate.instant('NEUER_SCHADENFALL');
        }
    };
    DVBernUtil.prototype.getVersicherungsbeitragViewTitle = function (versicherungsbeitrag) {
        if (!(versicherungsbeitrag && versicherungsbeitrag.isNew()) && versicherungsbeitrag.externalSchadenNr !== undefined) {
            return versicherungsbeitrag.externalSchadenNr;
        }
        else {
            return this.$translate.instant('VERSICHERUNGSBEITRAG');
        }
    };
    DVBernUtil.isNullOrUndefined = function (data) {
        return data === null || data === undefined;
    };
    DVBernUtil.isNotNullOrUndefined = function (data) {
        return !DVBernUtil.isNullOrUndefined(data);
    };
    DVBernUtil.prototype.isShowTitlePrefix = function (gesuchsteller) {
        return gesuchsteller.eigentumsverhaeltnis !== TSEigentumsverhaeltnis_1.TSEigentumsverhaeltnis.GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER
            && gesuchsteller.eigentumsverhaeltnis !== TSEigentumsverhaeltnis_1.TSEigentumsverhaeltnis.VERSICHERTER;
    };
    DVBernUtil.$inject = ['$filter', 'CONSTANTS', '$translate', 'RoleUtilService'];
    return DVBernUtil;
}());
exports.default = DVBernUtil;


/***/ }),

/***/ "ULxs":
/***/ (function(module, exports) {

module.exports = "<div class=\"table-responsive dv-versicherungsbeitrag-list\" ng-class=\"vm.getClass()\"> <table st-table=\"vm.displayedCollection\" st-delay=\"20\" st-pipe=\"vm.callServer\" class=\"table fixedtable table-hover\" id=\"{{vm.tableId}}\" title=\"{{vm.tableTitle}}\" dv-st-table-refresh> <thead> <tr class=\"header-row\"> <th st-sort=\"externalSchadenNr\" class=\"sortable row-ext-schadennr\" data-translate=\"VERS_BEITR_EXT_SCHADENNR\"></th> <th st-sort=\"versicherung\" class=\"sortable row-versicherung\" data-translate=\"VERSICHERUNG\"></th> <th st-sort=\"schadendatum\" class=\"sortable row-schadendatum\" data-translate=\"SCHADENDATUM\"></th> <th st-sort=\"status\" class=\"sortable row-status text-center\" data-translate=\"STATUS\"></th> <th st-sort=\"beitrag\" class=\"sortable row-beitrag text-right\" data-translate=\"BEITRAG\"></th> <th class=\"row-actions\"></th> </tr> <tr> <th> <input st-search=\"externalSchadenNr\" class=\"form-control dv-table__input\" type=\"text\"/> </th> <th> <input st-search=\"versicherungName\" class=\"form-control dv-table__input\" type=\"text\"/> </th> <th> <div> <input st-search=\"schadenDatumVon\" class=\"form-control dv-table__input dateinputtable\" type=\"text\" placeholder=\"{{'VON' | translate}}\"/> <input st-search=\"schadenDatumBis\" class=\"form-control dv-table__input dateinputtable\" type=\"text\" placeholder=\"{{'BIS' | translate}}\"/> </div> </th> <th> <div class=\"dv-select-style\"> <select st-input-event=\"change\" name=\"status\" id=\"status\" st-search=\"status\" class=\"form-control dv-table__input\" ng-options=\"status | translate for status in vm.getVersicherungsbeitraegeStatus() track by status\" ng-model=\"vm.selectedStatus\"> <option value=\"\">{{\"ALLE\" | translate}}</option> </select> </div> </th> <th></th> <th></th> </tr> </thead> <tbody> <tr class=\"dateientable\" ng-repeat=\"row in vm.displayedCollection\" ng-click=\"vm.editClicked(row, $event)\"> <td class=\"ellipsis mono\" title=\"{{row.externalSchadenNr }}\" ng-bind=\"row.externalSchadenNr\"></td> <td class=\"ellipsis\" title=\"{{row.versicherungName }}\" ng-bind=\"row.versicherungName\"> </td> <td class=\"ellipsis mono\" title=\"{{row.schadendatum | amDateFormat : 'DD.MM.YYYY'}}\" ng-bind=\"row.schadendatum | amDateFormat : 'DD.MM.YYYY'\"></td> <td class=\"ellipsis text-center\" title=\"{{row.status  | translate}}\" ng-bind=\"row.status  | translate\"></td> <td class=\"ellipsis mono text-right\" title=\"{{row.betrag}}\" ng-bind=\"row.betrag | number: 2\"></td> <td class=\"clearfix text-right\"> <button ng-click=\"vm.edit(row.versicherungsbeitragId)\" class=\"btn-link pull-right\"> <span class=\"fa fa-edit\" title=\"{{'EDIT' | translate}}\"></span> </button> </td> </tr> <tr ng-if=\"vm.displayedCollection.length === 0\"> <td colspan=\"{{vm.getColumnsNumber()}}\" class=\"empty-table\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> <tfoot> <tr> <td colspan=\"{{vm.getColumnsNumber()}}\" class=\"text-center\"> <div st-pagination=\"\" st-items-by-page=\"30\" st-displayed-pages=\"10\"></div> </td> </tr> </tfoot> </table> </div> ";

/***/ }),

/***/ "Ua0Y":
/***/ (function(module, exports) {

module.exports = "<div class=\"dvb-error-messages-panel\" uib-collapse=\"vm.errors.length === 0\" ng-class=\"vm.messageStyle()\"> <div class=\"dvb-error-messages-panel__container\"> <div class=\"dvb-error-messages-panel__icon dvb-error-messages-panel__icon--alert\"> <i ng-show=\"vm.errors.length > 0\" class=\"fa\" ng-class=\"vm.messageStyle()+'__icon'\"></i> </div> <div> <div ng-repeat=\"error in vm.errors | orderBy:'severity'\"> <div data-translate=\"{{error.msgKey}}\" role=\"alert\"></div> </div> </div> <div ng-show=\"vm.errors.length > 0\" ng-click=\"vm.clear()\" class=\"dvb-error-messages-panel__icon dvb-error-messages-panel__icon--close\" ng-class=\"vm.messageStyle()+'__icon--close'\"> <i class=\"fa fa-times\"></i> </div> </div> </div> ";

/***/ }),

/***/ "Uj2y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSRefreshEvent_1 = __webpack_require__("va1a");
/**
 * Direktive zum refreshen von SmartTable von ausserhalb
 */
var DVStTableRefresh = /** @class */ (function () {
    /* @ngInject */
    function DVStTableRefresh() {
        this.restrict = 'A';
        this.require = 'stTable';
        this.link = function (scope, element, attrs, ctrl) {
            if (!ctrl) {
                return;
            }
            scope.$on(TSRefreshEvent_1.TSRefreshEvent[TSRefreshEvent_1.TSRefreshEvent.REFRESH_ST_TABLE], function () {
                ctrl.pipe(ctrl.tableState());
            });
        };
    }
    DVStTableRefresh.factory = function () {
        return function () { return new DVStTableRefresh(); };
    };
    return DVStTableRefresh;
}());
exports.default = DVStTableRefresh;


/***/ }),

/***/ "Um7h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var YesNoController = /** @class */ (function () {
    function YesNoController($uibModalInstance, $translate, title, text) {
        this.$uibModalInstance = $uibModalInstance;
        if (text !== undefined && text !== null) {
            this.text = $translate.instant(text);
        }
        else {
            this.text = 'test';
        }
        if (title !== undefined && title !== null) {
            this.title = $translate.instant(title);
        }
        else {
            this.title = 'Confirmation';
        }
    }
    YesNoController.prototype.yes = function () {
        this.$uibModalInstance.close();
    };
    ;
    YesNoController.prototype.no = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    ;
    YesNoController.$inject = ['$uibModalInstance', '$translate', 'title', 'text'];
    return YesNoController;
}());
exports.YesNoController = YesNoController;


/***/ }),

/***/ "UmtK":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("cg+K");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-gesuchsteller.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-gesuchsteller.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "UorB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StringInputComponentConfig = /** @class */ (function () {
    function StringInputComponentConfig() {
        this.transclude = false;
        this.bindings = {
            model: '=',
            name: '@',
            inputPattern: '@?',
            label: '@',
            clazz: '@',
            placeholder: '@',
            ngRequired: '<',
            bisherFs: '<?',
            bisherGs: '<?',
            bisherProperty: '@?'
        };
        this.template = __webpack_require__("+MRX");
        this.controller = DvStringInputController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return StringInputComponentConfig;
}());
exports.StringInputComponentConfig = StringInputComponentConfig;
var DvStringInputController = /** @class */ (function () {
    function DvStringInputController() {
        this.valueRequired = true; // default required
    }
    DvStringInputController.prototype.$onInit = function () {
        if (this.ngRequired !== undefined) {
            this.valueRequired = this.ngRequired;
        }
    };
    DvStringInputController.prototype.showBisher = function () {
        return (this.bisherGs !== undefined && this.bisherFs !== undefined && this.bisherProperty !== undefined);
    };
    return DvStringInputController;
}());
exports.DvStringInputController = DvStringInputController;


/***/ }),

/***/ "Uq6U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ShowTooltipController = /** @class */ (function () {
    function ShowTooltipController($uibModalInstance, $translate, text) {
        this.$uibModalInstance = $uibModalInstance;
        if (text !== undefined && text !== null) {
            this.text = $translate.instant(text);
        }
        else {
            this.text = 'test';
        }
    }
    ShowTooltipController.prototype.ok = function () {
        this.$uibModalInstance.close();
    };
    ;
    ShowTooltipController.$inject = ['$uibModalInstance', '$translate', 'text'];
    return ShowTooltipController;
}());
exports.ShowTooltipController = ShowTooltipController;


/***/ }),

/***/ "V0kl":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("CcdS");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-versicherungsbeitrag-list.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-versicherungsbeitrag-list.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "V2/k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
var TSDokument_1 = __importDefault(__webpack_require__("DdPR"));
var UploadRS = /** @class */ (function () {
    /* @ngInject */
    function UploadRS($http, REST_API, $log, upload, $q, base64) {
        this.upload = upload;
        this.base64 = base64;
        this.serviceURL = REST_API + 'upload/typed';
        this.http = $http;
        this.log = $log;
        this.q = $q;
    }
    UploadRS.prototype.uploadFile = function (files, fallId, parentId, doctype) {
        var _this = this;
        var names = [];
        try {
            for (var files_1 = __values(files), files_1_1 = files_1.next(); !files_1_1.done; files_1_1 = files_1.next()) {
                var file = files_1_1.value;
                if (file) {
                    var encodedFilename = this.base64.encode(file.name);
                    names.push(encodedFilename);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (files_1_1 && !files_1_1.done && (_a = files_1.return)) _a.call(files_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return this.upload.upload({
            url: this.serviceURL,
            method: 'POST',
            headers: {
                'x-filename': names.join(';'),
            },
            data: {
                file: files,
                fallId: fallId,
                parentId: parentId,
                doctype: doctype,
            }
        }).then(function (response) {
            _this.log.debug('PARSING dokumentDTO REST object ', response.data);
            var converter = function (jsonString) {
                return new TSDokument_1.default().deserialize(jsonString);
            };
            if (angular.isArray(response.data)) {
                return response.data.map(converter);
            }
            return [];
        }, function (response) {
            console.log('Upload File: NOT SUCCESS');
            return _this.q.reject();
        }, function (evt) {
            var loaded = evt.loaded;
            var total = evt.total;
            var progressPercentage = 100.0 * loaded / total;
            console.log('progress: ' + progressPercentage + '% ');
            return _this.q.defer().notify();
        });
        var e_1, _a;
    };
    UploadRS.prototype.getServiceName = function () {
        return 'UploadRS';
    };
    UploadRS.$inject = ['$http', 'REST_API', '$log', 'Upload', '$q', 'base64'];
    return UploadRS;
}());
exports.UploadRS = UploadRS;


/***/ }),

/***/ "VCRP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var template = __webpack_require__("MGBK");
__webpack_require__("H9WF");
var removeDialogTemplate = __webpack_require__("YTLw");
var DVZahlungsauftragListConfig = /** @class */ (function () {
    function DVZahlungsauftragListConfig() {
        this.transclude = false;
        this.bindings = {
            onFilterChange: '&',
            tabindex: '@',
            selectedtab: '=',
            moeglicheBesitzer: '<',
        };
        this.template = template;
        this.controller = DVZahlungsauftragListController;
        this.controllerAs = 'vm';
    }
    return DVZahlungsauftragListConfig;
}());
exports.DVZahlungsauftragListConfig = DVZahlungsauftragListConfig;
var DVZahlungsauftragListController = /** @class */ (function () {
    /* @ngInject */
    function DVZahlungsauftragListController($filter, $log, CONSTANTS, $scope, $window, $translate, beitragRS, dvDialog, errorService, downloadRS) {
        var _this = this;
        this.$filter = $filter;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.$scope = $scope;
        this.$window = $window;
        this.$translate = $translate;
        this.beitragRS = beitragRS;
        this.dvDialog = dvDialog;
        this.errorService = errorService;
        this.downloadRS = downloadRS;
        this.moeglicheBesitzerForFilter = [];
        this.displayedCollection = []; //Liste die im Gui angezeigt wird
        this.defaultTableFilterState = {
            sort: {},
            search: {},
            pagination: { start: 0, totalItemCount: 0, number: 30 }
        };
        this.callServer = function (tableFilterState) {
            _this.tableFilterState = tableFilterState;
            //wenn aktuelles tab nicht gewaehltes ist machen wir nichts
            if (_this.selectedtab !== parseInt(_this.tabindex)) {
                return;
            }
            _this.pagination = tableFilterState.pagination;
            if (_this.onFilterChange && angular.isFunction(_this.onFilterChange)) {
                _this.onFilterChange({
                    tableState: tableFilterState
                }).then(function (result) {
                    if (result) {
                        tableFilterState.pagination.totalItemCount = result.totalResultSize;
                        tableFilterState.pagination.numberOfPages = Math.ceil(result.totalResultSize / tableFilterState.pagination.number);
                        _this.displayedCollection = new Array().concat(result.zahlungsauftragDTOs);
                    }
                });
            }
            else {
                _this.$log.info('no callback function spcified for filtering');
            }
        };
        this.initViewModel();
    }
    DVZahlungsauftragListController.prototype.initViewModel = function () {
    };
    DVZahlungsauftragListController.prototype.$onInit = function () {
        if (this.moeglicheBesitzer === undefined || this.moeglicheBesitzer === null) {
            this.$log.debug('list of moeglicheBesitzer is empty');
            this.moeglicheBesitzer = [];
        }
        // this creates a dummy element for the filter header; this could be done using ng-repeat on the option element but that is slow in ie.
        if (this.moeglicheBesitzer) {
            angular.copy(this.moeglicheBesitzer, this.moeglicheBesitzerForFilter);
        }
    };
    DVZahlungsauftragListController.prototype.getColumnsNumber = function () {
        var element = angular.element('.dv-zahlungsauftrag-list.' + this.getClass() + ' .header-row').first();
        if (element && element.get(0)) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 7;
    };
    DVZahlungsauftragListController.prototype.getClass = function () {
        return 'tab-nr-' + this.tabindex;
    };
    DVZahlungsauftragListController.prototype.downloadIso = function (dokumentId) {
        var _this = this;
        var attachment = true;
        this.$log.debug('download dokument with id ' + dokumentId);
        var win = this.downloadRS.prepareDownloadWindow();
        this.downloadRS.getAccessTokenDocumentById(dokumentId).then(function (downloadFile) {
            _this.$log.debug('accessToken: ' + downloadFile.accessToken);
            _this.downloadRS.startDownload(downloadFile.accessToken, downloadFile.filename, attachment, win);
        });
    };
    DVZahlungsauftragListController.prototype.downloadExcel = function (dokumentId) {
        var _this = this;
        this.$log.debug('download dokument with id ' + dokumentId);
        var win = this.downloadRS.prepareDownloadWindow();
        this.downloadRS.getAccessTokenDocumentById(dokumentId).then(function (downloadFile) {
            _this.$log.debug('accessToken: ' + downloadFile.accessToken);
            _this.downloadRS.startDownload(downloadFile.accessToken, downloadFile.filename, false, win);
        });
    };
    DVZahlungsauftragListController.$inject = ['$filter', '$log', 'CONSTANTS', '$scope', '$window', '$translate', 'BeitragRS', 'DvDialog', 'ErrorService', 'DownloadRS'];
    return DVZahlungsauftragListController;
}());
exports.DVZahlungsauftragListController = DVZahlungsauftragListController;


/***/ }),

/***/ "VD7B":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2020 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.modal-header--map{padding:25px 58px}.modal-header--map h2:after{border:none}.modal-header--map span{font-size:16px;line-height:25px;letter-spacing:1px}.modal-body--map{padding:0 58px}.modal-body--map .map{width:100%;height:350px}.modal-footer--map{text-align:center;padding:30px}@media(min-width:1025px){.map-modal-window .modal-dialog{width:60%;height:700px;left:50%;top:50%;transform:translate(-50%,-50%)!important;margin:0}}.map-modal-window ng-map{height:450px!important}", ""]);

// exports


/***/ }),

/***/ "VDYy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var TSErrorEvent_1 = __webpack_require__("NVeR");
var IHasUnconnectedDocuments_1 = __webpack_require__("3irw");
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
var AbstractGesuchViewController = /** @class */ (function () {
    function AbstractGesuchViewController($scope) {
        this.$scope = $scope;
    }
    AbstractGesuchViewController.prototype.$onInit = function () {
        var _this = this;
        /**
         * Wichtig: in SERF speichern wir auch Forms die nicht dirty sind. Daher ist dieses verhalten nicht relevant
         * und kann allenfalls ausgeschaltet werden.
         * Grund fuer diesen Code ist:
         * Wenn der Server einen Validation-Fehler zurueckgibt, wird der DirtyPlugin nicht informiert und setzt das Form
         * auf !dirty. Dann kann der Benutzer nochmal auf Speichern klicken und die Page wechselt ohne Fehler da der Client
         * glaubt, dass es nichts zu speichern gibt weil ja gar nichts dirty ist.
         * Damit dies nicht passiert, hoeren wir in allen Views auf diesen Event und setzen das Form auf dirty
         */
        this.$scope.$on(TSErrorEvent_1.TSMessageEvent[TSErrorEvent_1.TSMessageEvent.ERROR_UPDATE], function (event, errors) {
            console.debug('setting dirty because of ERROR_UPDATE event');
            _this.form.$dirty = true;
            _this.form.$pristine = false;
        });
    };
    /**
     * Diese Methode prueft ob das Form valid ist. Sollte es nicht valid sein wird das erste fehlende Element gesucht
     * und fokusiert, damit der Benutzer nicht scrollen muss, um den Fehler zu finden.
     * Am Ende wird this.form.$valid zurueckgegeben
     */
    AbstractGesuchViewController.prototype.isModelValid = function () {
        if (!this.form.$valid) {
            DVBernUtil_1.default.focusFirstInvalidInput();
        }
        return this.form.$valid;
    };
    AbstractGesuchViewController.prototype.onDocAdded = function (document) {
        //wenn entity noch nicht gespeichert ist
        var modelWithDocs = this.getModel();
        if (IHasUnconnectedDocuments_1.isInstanceOfHasUnconnectedDocuments(modelWithDocs) && this.getModel().isNew()) {
            modelWithDocs.documentIdsToConnect.push(document.id);
        }
    };
    AbstractGesuchViewController.prototype.onDocRemoved = function (document) {
        //wenn entity noch nicht gespeichert ist
        var modelWithDocs = this.getModel();
        if (IHasUnconnectedDocuments_1.isInstanceOfHasUnconnectedDocuments(modelWithDocs)) {
            if (modelWithDocs.documentIdsToConnect && this.getModel().isNew() && document.id) {
                var index = modelWithDocs.documentIdsToConnect.indexOf(document.id);
                if (index > -1) {
                    modelWithDocs.documentIdsToConnect.splice(index, 1);
                }
            }
        }
    };
    Object.defineProperty(AbstractGesuchViewController.prototype, "model", {
        get: function () {
            return this._model;
        },
        set: function (value) {
            this._model = value;
        },
        enumerable: true,
        configurable: true
    });
    AbstractGesuchViewController.prototype.getModel = function () {
        return this._model;
    };
    Object.defineProperty(AbstractGesuchViewController.prototype, "initialModel", {
        get: function () {
            return this._initialModel;
        },
        set: function (value) {
            this._initialModel = value;
        },
        enumerable: true,
        configurable: true
    });
    return AbstractGesuchViewController;
}());
exports.default = AbstractGesuchViewController;


/***/ }),

/***/ "VN0d":
/***/ (function(module, exports) {

module.exports = " <dv-input-container> <label data-translate=\"GENAUER_ORT\" for=\"ort\"></label> <input class=\"form-control\" dv-max-length id=\"ort\" name=\"ort\" ng-disabled=\"vm.readonly\" ng-model=\"vm.asyncSelected\" ng-required=\"true\" typeahead-loading=\"loadingLocations\" typeahead-no-results=\"noResults\" uib-typeahead=\"address as address.name for address in vm.loadSuggestElements($viewValue)\"/> <dv-error-messages for=\"vm.formschaden.ort\"></dv-error-messages> <dv-bisher for=\"vm.formschaden.ort\" fs=\"vm.getModel().schadenDatenFS\" gs=\"vm.getModel().schadenDatenGS\" property=\"ort\"></dv-bisher> </dv-input-container> ";

/***/ }),

/***/ "VPnH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
var template = __webpack_require__("/8We");
/**
 * Diese Komponente diente dazu Benutzer einer bestimmten Anlaufstelle zu editieren, wahrscheinlich ist dies
 * nun gar nicht mehr noetig da wir die Benutzerverwaltung separat fuehren.
 * Diese component kann somit erstmal als deprecated betrachtet werden. Allenfalls koennen wir sie spaeter auch loeschen
 * @deprecated
 */
var BenutzerverwaltungAnlaufstelleViewComponentConfig = /** @class */ (function () {
    function BenutzerverwaltungAnlaufstelleViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = BenutzerverwaltungAnlaufstelleViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            benutzerToShow: '<',
            allowedAnlaufstellen: '<'
        };
    }
    return BenutzerverwaltungAnlaufstelleViewComponentConfig;
}());
exports.BenutzerverwaltungAnlaufstelleViewComponentConfig = BenutzerverwaltungAnlaufstelleViewComponentConfig;
var BenutzerverwaltungAnlaufstelleViewController = /** @class */ (function () {
    /* @ngInject */
    function BenutzerverwaltungAnlaufstelleViewController(anlaufstelleRS, $state) {
        this.anlaufstelleRS = anlaufstelleRS;
        this.$state = $state;
    }
    BenutzerverwaltungAnlaufstelleViewController.prototype.$onInit = function () {
        if (this.allowedAnlaufstellen && this.allowedAnlaufstellen.length !== 0) {
            this.selectedAnlaufstelle = this.allowedAnlaufstellen[0];
            this.loadedAnlaufstelleId = this.selectedAnlaufstelle.id;
        }
    };
    BenutzerverwaltungAnlaufstelleViewController.prototype.changedAnlaufstelle = function () {
        var _this = this;
        if (this.loadedAnlaufstelleId !== this.selectedAnlaufstelle.id) {
            this.anlaufstelleRS.getBenutzerOfAnlaufstelle(this.selectedAnlaufstelle.id)
                .then(function (result) {
                _this.loadedAnlaufstelleId = _this.selectedAnlaufstelle.id;
                _this.benutzerToShow = result;
            });
        }
    };
    BenutzerverwaltungAnlaufstelleViewController.prototype.hasExactlyOneAllowedAnnahmestelle = function () {
        if (this.allowedAnlaufstellen && this.allowedAnlaufstellen.length === 1) {
            return true;
        }
        return false;
    };
    BenutzerverwaltungAnlaufstelleViewController.prototype.editBenutzer = function (benutzer, event) {
        var params = {
            anlaufstelleId: this.selectedAnlaufstelle.id,
            benutzerId: benutzer.id,
            benutzer: benutzer
        };
        this.$state.go('benutzereditanlaufstelle', params);
    };
    BenutzerverwaltungAnlaufstelleViewController.prototype.addBenutzer = function () {
        var createdBenutzer = new TSBenutzer_1.default();
        var params = { anlaufstelleId: this.selectedAnlaufstelle.id, benutzerId: undefined, benutzer: createdBenutzer };
        this.$state.go('benutzereditanlaufstelle', params);
    };
    BenutzerverwaltungAnlaufstelleViewController.$inject = ['AnlaufstelleRS', '$state'];
    return BenutzerverwaltungAnlaufstelleViewController;
}());
exports.BenutzerverwaltungAnlaufstelleViewController = BenutzerverwaltungAnlaufstelleViewController;


/***/ }),

/***/ "VmqX":
/***/ (function(module, exports) {

module.exports = " <div class=\"row\" ng-form=\"fremdkostenForm\"> <div class=\"col-sm-12\"> <div class=\"row\"> <div class=\"col-sm-6 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"FIRMA\" for=\"{{vm.name}}_firma_ID\" ng-if=\"!vm.getModel().schaetzung\"> </label> <label data-translate=\"BESCHREIBUNG\" for=\"{{vm.name}}_firma_ID\" ng-if=\"vm.getModel().schaetzung\"> </label> <input id=\"{{vm.name}}_firma_ID\" name=\"{{vm.name}}_firma\" ng-model=\"vm.getModel().fremdkostenDatenFS.firma\" dv-max-length class=\"form-control\" required> <dv-bisher gs=\"vm.getModel().fremdkostenDatenGS\" fs=\"vm.getModel().fremdkostenDatenFS\" for=\"fremdkostenForm[vm.name + '_firma']\" property=\"firma\"></dv-bisher> <dv-error-messages for=\"fremdkostenForm[vm.name + '_firma']\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-4 dv-input-container-medium\" ng-if=\"!vm.getModel().schaetzung\"> <dv-input-container> <label data-translate=\"FIRMENSITZ\" for=\"{{vm.name}}_firmensitz_ID\"> </label> <input id=\"{{vm.name}}_firmensitz_ID\" name=\"{{vm.name}}_firmensitz\" ng-model=\"vm.getModel().fremdkostenDatenFS.firmensitz\" dv-max-length class=\"form-control\" required> <dv-bisher gs=\"vm.getModel().fremdkostenDatenGS\" fs=\"vm.getModel().fremdkostenDatenFS\" for=\"fremdkostenForm[vm.name + '_firmensitz']\" property=\"firmensitz\"></dv-bisher> <dv-error-messages for=\"fremdkostenForm[vm.name + '_firmensitz']\"></dv-error-messages> </dv-input-container> </div> </div> <div class=\"row\"> <div class=\"col-sm-3 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"LEISTUNGSART\" for=\"{{vm.name}}_leistungsart_ID\"> </label> <select name=\"{{vm.name}}_leistungsart\" id=\"{{vm.name}}_leistungsart_ID\" ng-model=\"vm.getModel().fremdkostenDatenFS.leistungsart\" class=\"form-control\" ng-options=\"vm.translateLeistungsart(leistungsart) for leistungsart in vm.getTSLeistungsartenValues()\" ng-required=\"true\"> </select> <dv-bisher gs=\"vm.getModel().fremdkostenDatenGS\" fs=\"vm.getModel().fremdkostenDatenFS\" for=\"fremdkostenForm[vm.name + '_leistungsart']\" property=\"leistungsart\" prefix=\"vm.getPrefix()\"></dv-bisher> <dv-error-messages for=\"fremdkostenForm[vm.name + '_leistungsart']\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-3 dv-input-container-medium\" ng-if=\"!vm.getModel().schaetzung\"> <dv-input-container> <label data-translate=\"RECHNUNGSNUMMER\" for=\"{{vm.name}}_rechnungsnummer_ID\"> </label> <input name=\"{{vm.name}}_rechnungsnummer\" id=\"{{vm.name}}_rechnungsnummer_ID\" ng-model=\"vm.getModel().fremdkostenDatenFS.rechnungsnummer\" class=\"form-control\" dv-max-length required>  <dv-bisher gs=\"vm.getModel().fremdkostenDatenGS\" fs=\"vm.getModel().fremdkostenDatenFS\" for=\"fremdkostenForm[vm.name + '_rechnungsnummer']\" property=\"rechnungsnummer\"></dv-bisher> <dv-error-messages for=\"fremdkostenForm[vm.name + '_rechnungsnummer']\"></dv-error-messages> </dv-input-container> </div> <div class=\"form-group col-sm-3\" ng-if=\"!vm.getModel().schaetzung\"> <dv-input-container> <label class=\"md-no-float\" for=\"{{vm.name}}_rechnungsdatum_ID\"> <span ng-if=\"!vm.getModel().schaetzung\" data-translate=\"RECHNUNGSDATUM\"></span> </label> <dv-datepicker input-id=\"{{vm.name}}_rechnungsdatum_ID\" name=\"{{vm.name}}_rechnungsdatum\" ng-model=\"vm.getModel().fremdkostenDatenFS.rechnungsdatum\" ng-required=\"true\" class=\"input-element\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" check-future=\"true\"> </dv-datepicker> <dv-error-messages for=\"fremdkostenForm[vm.name + '_rechnungsdatum']\" class=\"error\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().fremdkostenDatenGS\" fs=\"vm.getModel().fremdkostenDatenFS\" for=\"fremdkostenForm[vm.name + '_rechnungsdatum']\" property=\"rechnungsdatum\"></dv-bisher> </dv-input-container> </div> <div class=\"form-group col-sm-3\"> <dv-input-container> <label for=\"{{vm.name}}_rechnungsbetrag_ID\"> <span ng-if=\"vm.getModel().schaetzung\" data-translate=\"BETRAG_CHF\"></span> <span ng-if=\"!vm.getModel().schaetzung\" data-translate=\"RECHNUNGSBETRAG\"></span> </label> <dv-valueinput input-id=\"{{vm.name}}_rechnungsbetrag_ID\" name=\"{{vm.name}}_rechnungsbetrag\" input-name=\"{{vm.name}}_rechnungsbetrag\" ng-model=\"vm.getModel().fremdkostenDatenFS.rechnungsbetrag\" ng-required=\"true\" float=\"true\" fixed-decimals=\"2\" allow-negative=\"false\" class=\"input-element\"> </dv-valueinput> <dv-error-messages for=\"fremdkostenForm[vm.name + '_rechnungsbetrag']\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().fremdkostenDatenGS\" fs=\"vm.getModel().fremdkostenDatenFS\" for=\"fremdkostenForm[vm.name + '_rechnungsbetrag']\" property=\"rechnungsbetrag\"></dv-bisher> </dv-input-container> </div> </div> </div> </div> ";

/***/ }),

/***/ "VptV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
__webpack_require__("nqh5");
/**
 * Komponente fuer die Bestimmung des Anrechenbaren Schadens
 */
var BetragComponentConfig = /** @class */ (function () {
    function BetragComponentConfig() {
        this.transclude = false;
        this.bindings = {
            readonly: '<',
            ermittelterSchaden: '<',
            einkommensabzug: '<',
            vermoegenssabzug: '<',
            nichtBerechtigterAnteil: '<',
            anrechenbarerSchaden: '<',
            prozentsatz: '<',
            betragVorschlag: '<',
            beitrag: '<',
            importiertAbzugEV: '<',
            schadenfallherkunft: '<',
        };
        this.template = __webpack_require__("LG2F");
        this.controller = DvBetragController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return BetragComponentConfig;
}());
exports.BetragComponentConfig = BetragComponentConfig;
var DvBetragController = /** @class */ (function () {
    /* @ngInject */
    function DvBetragController() {
    }
    DvBetragController.prototype.useImportiertAbzugEV = function () {
        return DVBernUtil_1.default.isNotNullOrUndefined(this.schadenfallherkunft) && DVBernUtil_1.default.isNotNullOrUndefined(this.importiertAbzugEV) && this.importiertAbzugEV !== 0;
    };
    DvBetragController.$inject = [];
    return DvBetragController;
}());
exports.DvBetragController = DvBetragController;


/***/ }),

/***/ "W+go":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright © 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt\n * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n */.navbar-sticky{padding-top:0;background-color:#fff;position:fixed;margin-top:-11px!important;width:99.02%;z-index:10}.navbar-sticky+div{padding-bottom:100px;margin-bottom:100px}.dv-versicherung-navigation{margin:-8px;margin-top:27px;margin-bottom:40px}.dv-versicherung-navigation__li{width:100%}.dv-versicherung-navigation__a{margin-left:8px!important;margin-right:8px!important}.dv-versicherung-navigation__a:first-of-type{margin-left:30px!important}.dv-versicherung-navigation__title{margin:0;margin-left:30px}.dv-versicherung-navigation__stickytitle,.dv-versicherung-navigation__title{display:block;width:315px;-webkit-transition:all .4s ease;transition:all .4s ease;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.dv-versicherung-navigation__stickytitle{margin-top:15px;margin-left:30px;font-size:18px}.dv-versicherung-navigation__status{display:block;margin:0;margin-left:30px;margin-bottom:10px;font-style:italic;font-size:small}@media(min-width:1275px){.dv-versicherung-navigation{margin:-8px;margin-top:27px;margin-bottom:40px}.dv-versicherung-navigation__li{width:unset}.dv-versicherung-navigation__stickytitle,.dv-versicherung-navigation__title{display:block;margin:-15px 100px 0 200px;width:315px;-webkit-transition:all .4s ease;transition:all .4s ease}.dv-versicherung-navigation__stickytitle{padding-top:28px;font-size:18px}.dv-versicherung-navigation__status{display:block;margin:0 100px 0 200px;font-style:italic;font-size:small}}", ""]);

// exports


/***/ }),

/***/ "W/h3":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".dv-checklist .checkbox{margin-top:50px;margin-bottom:20px}", ""]);

// exports


/***/ }),

/***/ "W/s/":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("nQtD");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-benutzer-list.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-benutzer-list.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "W4Ch":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("Qj30");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-inspektorat-list.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-inspektorat-list.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "WDU8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSVorleistungArt_1 = __webpack_require__("B37a");
var DVVorleistungComponentConfig = /** @class */ (function () {
    function DVVorleistungComponentConfig() {
        this.transclude = false;
        this.bindings = {
            vorleistung: '=',
            name: '@',
        };
        this.template = __webpack_require__("svkO");
        this.controller = DVVorleistungenController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return DVVorleistungComponentConfig;
}());
exports.DVVorleistungComponentConfig = DVVorleistungComponentConfig;
var DVVorleistungenController = /** @class */ (function () {
    /* @ngInject */
    function DVVorleistungenController(CONSTANTS, $log, roleUtilService, $translate) {
        this.CONSTANTS = CONSTANTS;
        this.$log = $log;
        this.roleUtilService = roleUtilService;
        this.$translate = $translate;
        this.$log.debug('initializing vorleistung componente');
    }
    DVVorleistungenController.prototype.$onInit = function () {
        if (this.vorleistung === undefined || this.vorleistung === null) {
            this.$log.error('"vorleistung" attribute is required for this component');
        }
    };
    DVVorleistungenController.prototype.getModel = function () {
        return this.vorleistung;
    };
    DVVorleistungenController.prototype.getTSVorleistungArtValues = function () {
        return TSVorleistungArt_1.getTSVorleistungArten();
    };
    DVVorleistungenController.prototype.translateVorleistungArt = function (art) {
        var prefix = TSVorleistungArt_1.vorleistungArtPrefix();
        return this.$translate.instant(prefix + TSVorleistungArt_1.TSVorleistungArt[art]);
    };
    DVVorleistungenController.prototype.getPrefix = function () {
        return TSVorleistungArt_1.vorleistungArtPrefix();
    };
    DVVorleistungenController.prototype.isPoliceNrVisible = function () {
        var vorleistung = this.getModel();
        if (vorleistung !== undefined && vorleistung.vorleistungDatenFS && vorleistung.vorleistungDatenFS.vorleistungenArt) {
            var art = vorleistung.vorleistungDatenFS.vorleistungenArt;
            return (art === TSVorleistungArt_1.TSVorleistungArt.HAGELVERSICHERUNG || art === TSVorleistungArt_1.TSVorleistungArt.GEBAEUDEVERSICHERUNG || art === TSVorleistungArt_1.TSVorleistungArt.PRIVATVERSICHERUNG);
        }
        return false;
    };
    DVVorleistungenController.$inject = ['CONSTANTS', '$log', 'RoleUtilService', '$translate'];
    return DVVorleistungenController;
}());
exports.DVVorleistungenController = DVVorleistungenController;


/***/ }),

/***/ "WFK3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSGesuchsPersonDaten_1 = __importDefault(__webpack_require__("fiK7"));
var TSGesuchsPerson = /** @class */ (function (_super) {
    __extends(TSGesuchsPerson, _super);
    function TSGesuchsPerson() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSGesuchsPerson.prototype, "gesuchsPersonDatenFS", {
        get: function () {
            return this._gesuchsPersonDatenFS;
        },
        set: function (value) {
            this._gesuchsPersonDatenFS = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGesuchsPerson.prototype, "gesuchsPersonDatenGS", {
        get: function () {
            return this._gesuchsPersonDatenGS;
        },
        set: function (value) {
            this._gesuchsPersonDatenGS = value;
        },
        enumerable: true,
        configurable: true
    });
    TSGesuchsPerson.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        if (restObject.gesuchsPersonDatenFS) {
            this.gesuchsPersonDatenFS = new TSGesuchsPersonDaten_1.default().deserialize(restObject.gesuchsPersonDatenFS);
        }
        if (restObject.gesuchsPersonDatenGS) {
            this.gesuchsPersonDatenGS = new TSGesuchsPersonDaten_1.default().deserialize(restObject.gesuchsPersonDatenGS);
        }
        return this;
    };
    TSGesuchsPerson.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.gesuchsPersonDatenFS = this.serializeOrInit(this.gesuchsPersonDatenFS, restObject.gesuchsPersonDatenFS);
        restObject.gesuchsPersonDatenGS = this.serializeOrInit(this.gesuchsPersonDatenGS, restObject.gesuchsPersonDatenGS);
        return restObject;
    };
    return TSGesuchsPerson;
}(TSAbstractEntity_1.default));
exports.default = TSGesuchsPerson;


/***/ }),

/***/ "WMNn":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */", ""]);

// exports


/***/ }),

/***/ "WPVT":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("JaKC");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-dialog.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-dialog.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "WRab":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.rowBody-betrag{width:15%}.rowBody-actions{width:130px}dv-input-container.no-margin div.form-group{margin-bottom:0}dv-input-container.no-margin div.form-group .bigger-font .form-control{font-size:16px;padding:6px}", ""]);

// exports


/***/ }),

/***/ "WbgF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSGenossenschaftDaten_1 = __importDefault(__webpack_require__("RuPF"));
var TSGenossenschaft = /** @class */ (function (_super) {
    __extends(TSGenossenschaft, _super);
    function TSGenossenschaft() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSGenossenschaft.prototype, "genossenschaftDatenFS", {
        get: function () {
            return this._genossenschaftDatenFS;
        },
        set: function (value) {
            this._genossenschaftDatenFS = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGenossenschaft.prototype, "genossenschaftDatenGS", {
        get: function () {
            return this._genossenschaftDatenGS;
        },
        set: function (value) {
            this._genossenschaftDatenGS = value;
        },
        enumerable: true,
        configurable: true
    });
    TSGenossenschaft.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.genossenschaftDatenFS = this.deserializeOrCreate(restObject.genossenschaftDatenFS, new TSGenossenschaftDaten_1.default());
        this.genossenschaftDatenGS = this.deserializeOrNull(restObject.genossenschaftDatenGS, new TSGenossenschaftDaten_1.default());
        return this;
    };
    TSGenossenschaft.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.genossenschaftDatenFS = this.serializeOrInit(this.genossenschaftDatenFS, restObject.genossenschaftDatenFS);
        restObject.genossenschaftDatenGS = this.serializeOrInit(this.genossenschaftDatenGS, restObject.genossenschaftDatenGS);
        return restObject;
    };
    return TSGenossenschaft;
}(TSAbstractEntity_1.default));
exports.default = TSGenossenschaft;


/***/ }),

/***/ "WdgM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSBenutzerBemerkung_1 = __importDefault(__webpack_require__("3/Vo"));
var TSTransitionBemerkung_1 = __importDefault(__webpack_require__("7eCW"));
var BemerkungRS = /** @class */ (function () {
    /* @ngInject */
    function BemerkungRS($http, REST_API, $log) {
        this.$log = $log;
        this.serviceURL = REST_API + 'bemerkung';
        this.http = $http;
    }
    BemerkungRS.prototype.deleteBenutzerBemerkung = function (benutzerBemerkungId) {
        return this.http.delete(this.serviceURL + '/deleteBenutzerBemerkung/' + encodeURIComponent(benutzerBemerkungId), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    };
    BemerkungRS.prototype.deleteTransitionBemerkung = function (transitionBemerkungId) {
        return this.http.delete(this.serviceURL + '/deleteTransitionBemerkung/' + encodeURIComponent(transitionBemerkungId), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    };
    BemerkungRS.prototype.saveBenutzerBemerkung = function (schadenfallId, benutzerBemerkung) {
        var _this = this;
        var sentBenutzerBemerkung = {};
        sentBenutzerBemerkung = benutzerBemerkung.serialize(sentBenutzerBemerkung);
        this.$log.debug('sending TSBenutzerBemerkung:');
        this.$log.debug(sentBenutzerBemerkung);
        return this.http.put(this.serviceURL + '/saveBenutzerBemerkung/' + encodeURIComponent(schadenfallId), sentBenutzerBemerkung, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            _this.$log.debug('PARSING BenutzerBemerkung REST array object', response.data);
            return new TSBenutzerBemerkung_1.default().deserialize(response.data);
        });
    };
    BemerkungRS.prototype.saveTransitionBemerkung = function (schadenfallId, benutzerBemerkung) {
        var _this = this;
        var sentTransitionBemerkung = {};
        sentTransitionBemerkung = benutzerBemerkung.serialize(sentTransitionBemerkung);
        this.$log.debug('sending TSTransitionBemerkung:');
        this.$log.debug(sentTransitionBemerkung);
        return this.http.put(this.serviceURL + '/saveTransitionBemerkung/' + encodeURIComponent(schadenfallId), sentTransitionBemerkung, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            _this.$log.debug('PARSING TransitionBemerkung REST array object', response.data);
            return new TSTransitionBemerkung_1.default().deserialize(response.data);
        });
    };
    BemerkungRS.$inject = ['$http', 'REST_API', '$log'];
    return BemerkungRS;
}());
exports.default = BemerkungRS;


/***/ }),

/***/ "WjXM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSSchadenfallDTO_1 = __importDefault(__webpack_require__("XdCm"));
var TSSchadenfaelleSearchresultDTO = /** @class */ (function () {
    function TSSchadenfaelleSearchresultDTO() {
        this._schadenfallDTOs = [];
        this._totalResultSize = 0;
    }
    Object.defineProperty(TSSchadenfaelleSearchresultDTO.prototype, "schadenfallDTOs", {
        get: function () {
            return this._schadenfallDTOs;
        },
        set: function (value) {
            this._schadenfallDTOs = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfaelleSearchresultDTO.prototype, "totalResultSize", {
        get: function () {
            return this._totalResultSize;
        },
        set: function (value) {
            this._totalResultSize = value;
        },
        enumerable: true,
        configurable: true
    });
    TSSchadenfaelleSearchresultDTO.prototype.parseSchadenfallDTOs = function (data) {
        var pendenzen = [];
        if (data && Array.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                pendenzen[i] = new TSSchadenfallDTO_1.default().deserialize(data[i]);
            }
        }
        else {
            pendenzen[0] = new TSSchadenfallDTO_1.default().deserialize(data);
        }
        return pendenzen;
    };
    TSSchadenfaelleSearchresultDTO.prototype.deserialize = function (restObject) {
        this.schadenfallDTOs = this.parseSchadenfallDTOs(restObject.schadenfallDTOs);
        this.totalResultSize = restObject.paginationDTO.totalItemCount;
        return this;
    };
    return TSSchadenfaelleSearchresultDTO;
}());
exports.default = TSSchadenfaelleSearchresultDTO;


/***/ }),

/***/ "Wqd1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("2nkm");
var errTemplate = __webpack_require__("jLEA");
var DvErrorMessagesComponentConfig = /** @class */ (function () {
    function DvErrorMessagesComponentConfig() {
        this.transclude = false;
        this.bindings = {
            requiredText: '@',
            errorObject: '<for'
        };
        this.template = errTemplate;
        this.controller = DvErrorMessages;
        this.controllerAs = 'vm';
    }
    return DvErrorMessagesComponentConfig;
}());
exports.DvErrorMessagesComponentConfig = DvErrorMessagesComponentConfig;
var DvErrorMessages = /** @class */ (function () {
    function DvErrorMessages($attrs) {
        this.$attrs = $attrs;
    }
    DvErrorMessages.prototype.$onInit = function () {
        this.isOpaque = 'opaque' in this.$attrs;
        if (this.requiredText === undefined) {
            this.requiredText = 'ERROR_REQUIRED'; //default required key
        }
    };
    DvErrorMessages.$inject = ['$attrs'];
    return DvErrorMessages;
}());
exports.DvErrorMessages = DvErrorMessages;


/***/ }),

/***/ "WsA+":
/***/ (function(module, exports) {

module.exports = " <div class=\"dv-vorleistungen-list\"> <div class=\"table-responsive\"> <table st-table=\"displayedCollection\" st-safe-src=\"vm.vorleistungen\" st-delay=\"20\" class=\"table fixedtable table-hover\" id=\"{{vm.tableId}}\" title=\"{{vm.tableTitle}}\" dv-st-table-refresh> <thead> <tr class=\"header-row\"> <th data-translate=\"VORLEISTUNG_ART\"> </th> <th data-translate=\"VORLEISTUNG_POLICE_NR\"> </th> <th class=\"rowHeader-empty1\"></th> <th class=\"rowHeader-empty2\"></th> <th class=\"text-right rowHeader-betrag\" data-translate=\"BETRAG\"> </th> <th st-sort=\"vorleistungDatenFS.berechtigterBetrag\" class=\"text-right rowHeader-berechtigterBetrag\"> <span dv-show-element dv-show-expression=\"!vm.schaetzung\" dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\" data-translate=\"EIGENLEISTUNG_BETRAG_BERECHTIGT\"> </span> </th> <th class=\"rowHeader-actions\"> </th> </tr> </thead> <tbody> <tr ng-repeat=\"row in displayedCollection\" st-select-row=\"row\" st-select-mode=\"single\"> <td class=\"ellipsis\" title=\"{{vm.translateVorleistungArt(row.vorleistungDatenFS.vorleistungenArt)}}\" ng-bind=\"vm.translateVorleistungArt(row.vorleistungDatenFS.vorleistungenArt)\"> </td> <td class=\"ellipsis\" title=\"{{row.vorleistungDatenFS.policeNr}}\" ng-bind=\"row.vorleistungDatenFS.policeNr\"> </td> <td></td> <td></td> <td class=\"ellipsis text-right mono\" title=\"{{row.vorleistungDatenFS.betrag | currency: 'CHF'}}\" ng-bind=\"row.vorleistungDatenFS.betrag | currency: 'CHF'\"></td> <td></td> <td ng-if=\"!vm.readonly\" class=\"clearfix rowBody-actions\"> <button ng-click=\"vm.editClicked(row, $event)\" class=\"btn-link\"> <span class=\"fa fa-edit\" title=\"{{'EDIT' | translate}}\"></span> </button> <button ng-click=\"vm.deleteClicked(row, $event)\" class=\"btn-link\"> <span class=\"fa fa-trash-o\" title=\"{{'DELETE' | translate}}\"></span> </button> </td> <td ng-if=\"vm.readonly\" class=\"clearfix rowBody-actions\"> <button ng-click=\"vm.editClicked(row, $event)\" class=\"btn-link\"> <span class=\"fa fa-eye\" title=\"{{'VIEW' | translate}}\"></span> </button> </td> </tr> <tr ng-if=\"displayedCollection === undefined || displayedCollection.length === 0\"> <td colspan=\"{{vm.getColumnsNumber()}}\" class=\"empty-table\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> <tfoot> <tr class=\"tr-highlight\"> <td colspan=\"4\" data-translate=\"TOTAL\"></td> <td class=\"text-right mono\" ng-bind=\"vm.calcTotalBetrag() |  currency: 'CHF'\"></td> <td class=\"text-right mono\"> <div dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\" dv-show-expression=\"!vm.schaetzung\"> <dv-input-container class=\"no-margin\"> <dv-valueinput input-id=\"vorleistungen_berechtigterbetrag_ID\" name=\"vorleistungen_berechtigterbetrag\" input-name=\"vorleistungen_berechtigterbetrag\" ng-model=\"vm.schadenfall.berechtigterBetragVorleistungen\" ng-required=\"true\" float=\"true\" fixed-decimals=\"2\" allow-negative=\"false\" class=\"input-element bigger-font\"> </dv-valueinput> </dv-input-container> </div> </td> <td colspan=\"1\"> <div dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\" dv-show-element dv-show-expression=\"!vm.schaetzung\"> <dv-loading-button type=\"submit\" button-click=\"vm.speichernGesuch()\" button-class=\"btn btn-serf pull-right\"> <span data-translate=\"SAVE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </td> </tr> </tfoot> </table> </div> </div> ";

/***/ }),

/***/ "WyAS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright © 2019 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This directive allows a filter and sorting configuration to be saved after leaving the table.
 * The information will be stored in an angular-service, whi
 */
var DvSchadenfaelleListPersist = /** @class */ (function () {
    function DvSchadenfaelleListPersist(filterPersistenceService, $timeout) {
        var _this = this;
        this.filterPersistenceService = filterPersistenceService;
        this.$timeout = $timeout;
        this.restrict = 'A';
        this.require = ['^stTable', '^dvSchadenfaelleList'];
        this.link = function (scope, _element, attrs, ctrlArray) {
            var nameSpace = attrs.dvSchadenfaelleListPersist;
            var ctrl = _this;
            var stTableCtrl = ctrlArray[0];
            var schadenfaelleListController = ctrlArray[1];
            $timeout(function () {
                ctrl.restoreData(nameSpace, stTableCtrl, schadenfaelleListController);
            }, 0);
            $timeout(function () {
                ctrl.addWatcher(scope, stTableCtrl, nameSpace, schadenfaelleListController);
            }, 0);
        };
    }
    DvSchadenfaelleListPersist.prototype.addWatcher = function (scope, stTableCtrl, nameSpace, schadenfaelleListController) {
        var _this = this;
        scope.$watch(function () { return stTableCtrl.tableState(); }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                _this.filterPersistenceService.persistFilter(nameSpace, newValue);
                schadenfaelleListController.showResetFilter =
                    newValue.search.predicateObject !== undefined ||
                        newValue.sort.predicate !== 'ereignisdatum' ||
                        newValue.sort.reverse;
            }
        }, true);
        scope.$watch(function () { return _this.filterPersistenceService.restoreFilter(nameSpace); }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                if (newValue === undefined) {
                    _this.restoreData(nameSpace, stTableCtrl, schadenfaelleListController);
                }
            }
        }, true);
    };
    DvSchadenfaelleListPersist.prototype.restoreData = function (nameSpace, stTableCtrl, schadenfaelleListController) {
        var savedState = this.filterPersistenceService.restoreFilter(nameSpace);
        if (!savedState) {
            var defaultSort = {
                sort: {
                    predicate: 'ereignisdatum',
                    reverse: false,
                },
            };
            var tableState = stTableCtrl.tableState();
            delete tableState.search.predicateObject;
            schadenfaelleListController.selectedFallNummer = '';
            schadenfaelleListController.selectedGesuchstellerName = '';
            schadenfaelleListController.selectedEreignis = '';
            schadenfaelleListController.selectedOrt = '';
            schadenfaelleListController.selectedGesuchsdatumVon = '';
            schadenfaelleListController.selectedGesuchsdatumBis = '';
            schadenfaelleListController.selectedStatus = '';
            schadenfaelleListController.selectedVerantworlticher = '';
            schadenfaelleListController.selectedKostenVon = undefined;
            schadenfaelleListController.selectedKostenBis = undefined;
            schadenfaelleListController.selectedKanton = undefined;
            schadenfaelleListController.selectedSprache = undefined;
            angular.extend(tableState, defaultSort);
            stTableCtrl.pipe();
            return;
        }
        angular.extend(stTableCtrl.tableState(), savedState);
        if (savedState.search && savedState.search.predicateObject) {
            schadenfaelleListController.selectedFallNummer
                = savedState.search.predicateObject.fallNummer;
            schadenfaelleListController.selectedGesuchstellerName
                = savedState.search.predicateObject.gesuchstellerName;
            schadenfaelleListController.selectedEreignis
                = savedState.search.predicateObject.ereignis;
            schadenfaelleListController.selectedOrt
                = savedState.search.predicateObject.ort;
            schadenfaelleListController.selectedGesuchsdatumVon
                = savedState.search.predicateObject.gesuchsdatumVon;
            schadenfaelleListController.selectedGesuchsdatumBis
                = savedState.search.predicateObject.gesuchsdatumBis;
            schadenfaelleListController.selectedStatus
                = savedState.search.predicateObject.status;
            schadenfaelleListController.selectedVerantworlticher
                = savedState.search.predicateObject.verantwortlicher;
            schadenfaelleListController.selectedKostenVon
                = savedState.search.predicateObject.selectedKostenVon;
            schadenfaelleListController.selectedKostenBis
                = savedState.search.predicateObject.selectedKostenBis;
            schadenfaelleListController.selectedKanton
                = savedState.search.predicateObject.selectedKanton;
            schadenfaelleListController.selectedSprache
                = savedState.search.predicateObject.selectedSprache;
        }
        schadenfaelleListController.showResetFilter =
            savedState.search.predicateObject !== undefined ||
                savedState.sort.predicate !== 'ereignisdatum' ||
                savedState.sort.reverse;
        stTableCtrl.pipe();
    };
    DvSchadenfaelleListPersist.factory = function () {
        var directive = function (filterPersistenceService, $timeout) { return new DvSchadenfaelleListPersist(filterPersistenceService, $timeout); };
        directive.$inject = ['FilterPersistenceService', '$timeout'];
        return directive;
    };
    DvSchadenfaelleListPersist.$inject = ['FilterPersistenceService', '$timeout'];
    return DvSchadenfaelleListPersist;
}());
exports.default = DvSchadenfaelleListPersist;


/***/ }),

/***/ "X/T9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright © 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSErfassungsArt;
(function (TSErfassungsArt) {
    TSErfassungsArt[TSErfassungsArt["ONLINE"] = 'ONLINE'] = "ONLINE";
    TSErfassungsArt[TSErfassungsArt["PAPIER"] = 'PAPIER'] = "PAPIER";
})(TSErfassungsArt = exports.TSErfassungsArt || (exports.TSErfassungsArt = {}));
function getTSErfassungsArtValues() {
    return [
        TSErfassungsArt.ONLINE,
        TSErfassungsArt.PAPIER,
    ];
}
exports.getTSErfassungsArtValues = getTSErfassungsArtValues;


/***/ }),

/***/ "X9l8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSRole_1 = __webpack_require__("MleR");
var template = __webpack_require__("ztPi");
__webpack_require__("jFBa");
var DVEigenleistungenListComponentConfig = /** @class */ (function () {
    function DVEigenleistungenListComponentConfig() {
        this.transclude = false;
        this.bindings = {
            eigenleistungen: '=',
            schadenfall: '<',
            onEdit: '&',
            onDelete: '&',
            readonly: '<',
            schaetzung: '<',
        };
        this.template = template;
        this.controller = DVEigenleistungenListController;
        this.controllerAs = 'vm';
    }
    return DVEigenleistungenListComponentConfig;
}());
exports.DVEigenleistungenListComponentConfig = DVEigenleistungenListComponentConfig;
var DVEigenleistungenListController = /** @class */ (function () {
    /* @ngInject */
    function DVEigenleistungenListController($filter, $log, CONSTANTS, $scope, roleUtilService, $window, $translate, $timeout, schadenfallModelManager) {
        this.$filter = $filter;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.$scope = $scope;
        this.roleUtilService = roleUtilService;
        this.$window = $window;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.schadenfallModelManager = schadenfallModelManager;
        this.colnumber = undefined;
        this.eigenleistungen = []; //Liste die im Gui angezeigt wird
        this.initViewModel();
    }
    DVEigenleistungenListController.prototype.initViewModel = function () {
    };
    DVEigenleistungenListController.prototype.$onInit = function () {
        var _this = this;
        this.$timeout(function () {
            //can only initialize real value after view is stable (ng-ifs are done)
            _this.initColNumber();
        });
        this.calculateBerechtigterBetragForOldCases();
    };
    DVEigenleistungenListController.prototype.calculateBerechtigterBetragForOldCases = function () {
        // the following calculation is for handling old cases, where Berechtigter Betrag belongs to each Eigenleistung, not to the Schadenfall
        if (this.schadenfall.berechtigterBetragEigenleistungen === null || this.schadenfall.berechtigterBetragEigenleistungen === 0) {
            this.schadenfall.berechtigterBetragEigenleistungen = this.eigenleistungen.reduce(function (accumulator, currentValue) { return accumulator + currentValue.berechtigterBetrag; }, 0);
        }
    };
    DVEigenleistungenListController.prototype.calcTotalEL = function () {
        var total = 0;
        if (this.eigenleistungen !== undefined) {
            try {
                for (var _a = __values(this.eigenleistungen), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var obj = _b.value;
                    if (obj.eigenleistungStundenDaten !== undefined) {
                        total += obj.getBetragTotal();
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return total;
        var e_1, _c;
    };
    DVEigenleistungenListController.prototype.calcTotalELHours = function () {
        var total = 0;
        if (this.eigenleistungen !== undefined) {
            try {
                for (var _a = __values(this.eigenleistungen), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var obj = _b.value;
                    if (obj.eigenleistungStundenDaten !== undefined) {
                        total += obj.getArbeitsstundenTotal();
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return total;
        var e_2, _c;
    };
    DVEigenleistungenListController.prototype.getFilterroles = function () {
        return this.roleUtilService.getAllRolesButGesuchstellerArray();
    };
    DVEigenleistungenListController.prototype.editClicked = function (eigenleistungToEdit, event) {
        this.onEdit({ eigenleistung: eigenleistungToEdit, event: event });
    };
    DVEigenleistungenListController.prototype.deleteClicked = function (eigenleistungToDelete, event) {
        this.onDelete({ eigenleistung: eigenleistungToDelete, event: event });
    };
    DVEigenleistungenListController.prototype.translateAktiv = function (inaktiv) {
        return inaktiv ? (this.$translate.instant('INAKTIV')) : (this.$translate.instant('AKTIV'));
    };
    DVEigenleistungenListController.prototype.translateRoles = function (roles) {
        var _this = this;
        var prefix = TSRole_1.rolePrefix();
        return roles.map(function (element) {
            return _this.$translate.instant(prefix + TSRole_1.TSRole[element]);
        }).join(', ');
    };
    DVEigenleistungenListController.prototype.translateRole = function (role) {
        var prefix = TSRole_1.rolePrefix();
        return this.$translate.instant(prefix + TSRole_1.TSRole[role]);
    };
    DVEigenleistungenListController.prototype.getColumnsNumber = function () {
        if (this.colnumber === undefined) {
            this.initColNumber();
        }
        return this.colnumber;
    };
    DVEigenleistungenListController.prototype.initColNumber = function () {
        var element = angular.element('.dv-eigenleistungen-list .header-row').first();
        if (element) {
            this.colnumber = element.get(0).childElementCount;
        }
        else {
            //could not determine actual number, just returing an approximation
            this.colnumber = 7;
        }
    };
    DVEigenleistungenListController.prototype.speichernGesuch = function () {
        if (this.schadenfall) {
            this.schadenfallModelManager.saveSchadenfall(this.schadenfall);
        }
    };
    DVEigenleistungenListController.$inject = [
        '$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', '$translate',
        '$timeout', 'SchadenfallModelManager',
    ];
    return DVEigenleistungenListController;
}());
exports.DVEigenleistungenListController = DVEigenleistungenListController;


/***/ }),

/***/ "XOsk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * spricht die reportAsync resourec an welce die reports async generiert
 */
var ReportAsyncRS = /** @class */ (function () {
    function ReportAsyncRS(httpParamSerializer, REST_API, log, http) {
        this.httpParamSerializer = httpParamSerializer;
        this.log = log;
        this.http = http;
        this.reportingTimeout = 240000;
        this.serviceURL = REST_API + "reporting/async";
    }
    ReportAsyncRS.prototype.getReport = function (reportDTO) {
        var _this = this;
        var reportTypeDTOToSend = {};
        reportTypeDTOToSend = reportDTO.serialize(reportTypeDTOToSend);
        return this.http.put(this.serviceURL + "/statistik/report", reportTypeDTOToSend, {
            timeout: this.reportingTimeout,
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(function (response) {
            _this.log.debug('Queued Job returned ', response.data);
            return response.data;
        });
    };
    ReportAsyncRS.prototype.getServiceName = function () {
        return 'ReportAsyncRS';
    };
    ReportAsyncRS.$inject = ['$httpParamSerializer', 'REST_API', '$log', '$http'];
    return ReportAsyncRS;
}());
exports.ReportAsyncRS = ReportAsyncRS;


/***/ }),

/***/ "XRVF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAnlaufstelleType_1 = __webpack_require__("hYoR");
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSAnlaufstelle_1 = __importDefault(__webpack_require__("B4Ew"));
var TSBenutzer = /** @class */ (function (_super) {
    __extends(TSBenutzer, _super);
    function TSBenutzer(vorname, nachname, username, password, email, roles, anlaufstellen) {
        var _this = _super.call(this) || this;
        _this._inaktiv = undefined;
        _this._maxErfassungsbetrag = 0; //this is default on server anyway
        _this._vorname = vorname || '';
        _this._nachname = nachname || '';
        _this._email = email || '';
        _this._roles = roles || [];
        _this._anlaufstellen = anlaufstellen || [];
        return _this;
    }
    Object.defineProperty(TSBenutzer.prototype, "anlaufstelleList", {
        get: function () {
            return this._anlaufstellen.map(function (x) { return x.name; }).join(', ');
        },
        enumerable: true,
        configurable: true
    });
    //it creates a comma separated list with the abbreviations of the cantons concerned
    //   - in case of a TSAnlaufstelleType.KANTON the canton is taken directly from the Anlaufstelle
    //   - in case of a TSAnlaufstelleType.GEMEINDE the canton is taken from the Gemeinde which belongs to the Anlaufstelle
    TSBenutzer.prototype.initKantonList = function () {
        var gemeinden = this.getGemeindenFromAnlaufstellen();
        var kantonArray = new Array();
        kantonArray.push.apply(kantonArray, __spread(gemeinden.map(function (x) { return x.kanton; })));
        kantonArray.push.apply(kantonArray, __spread((this.getKantoneFromAnlaufstellen())));
        this._kantonen = TSBenutzer.removeDuplicates(kantonArray).join(', ');
    };
    Object.defineProperty(TSBenutzer.prototype, "kantonList", {
        get: function () {
            if (!this._kantonen) {
                this.initKantonList();
            }
            return this._kantonen;
        },
        enumerable: true,
        configurable: true
    });
    TSBenutzer.removeDuplicates = function (kantonArray) {
        return Array.from(new Set(kantonArray));
    };
    TSBenutzer.prototype.getKantoneFromAnlaufstellen = function () {
        var kantonaleAnlaufstellen = this.getAnlaufstellenForType(TSAnlaufstelleType_1.TSAnlaufstelleType.KANTON);
        var kantone = new Array();
        kantonaleAnlaufstellen.forEach(function (anlaufstelle) {
            if (anlaufstelle.kanton) {
                //no undefined will be added
                kantone.push(anlaufstelle.kanton);
            }
        });
        return kantone;
    };
    TSBenutzer.prototype.getAnlaufstellenForType = function (type) {
        return this._anlaufstellen.filter(function (x) { return x.anlaufstelleType === type; });
    };
    TSBenutzer.prototype.getGemeindenFromAnlaufstellen = function () {
        var gemeindeAnlaufstellen = this.getAnlaufstellenForType(TSAnlaufstelleType_1.TSAnlaufstelleType.GEMEINDE);
        var gemeinden = [];
        //no flatMap in ES5, so DIY
        gemeindeAnlaufstellen.forEach(function (anlaufstelle) { return gemeinden = gemeinden.concat(anlaufstelle.gemeinden); });
        return gemeinden;
    };
    Object.defineProperty(TSBenutzer.prototype, "nachname", {
        get: function () {
            return this._nachname;
        },
        set: function (value) {
            this._nachname = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBenutzer.prototype, "vorname", {
        get: function () {
            return this._vorname;
        },
        set: function (value) {
            this._vorname = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBenutzer.prototype, "email", {
        get: function () {
            return this._email;
        },
        set: function (value) {
            this._email = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBenutzer.prototype, "emailRepeat", {
        get: function () {
            return this._emailRepeat;
        },
        set: function (value) {
            this._emailRepeat = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBenutzer.prototype, "telefon", {
        get: function () {
            return this._telefon;
        },
        set: function (value) {
            this._telefon = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBenutzer.prototype, "roles", {
        get: function () {
            return this._roles;
        },
        set: function (value) {
            this._roles = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBenutzer.prototype, "korrespondenzsprache", {
        get: function () {
            return this._korrespondenzsprache;
        },
        set: function (value) {
            this._korrespondenzsprache = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBenutzer.prototype, "anrede", {
        get: function () {
            return this._anrede;
        },
        set: function (value) {
            this._anrede = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBenutzer.prototype, "inaktiv", {
        get: function () {
            return this._inaktiv;
        },
        set: function (value) {
            this._inaktiv = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBenutzer.prototype, "passwordData", {
        get: function () {
            return this._passwordData;
        },
        set: function (value) {
            this._passwordData = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBenutzer.prototype, "anlaufstellen", {
        get: function () {
            return this._anlaufstellen;
        },
        set: function (value) {
            this._anlaufstellen = value;
        },
        enumerable: true,
        configurable: true
    });
    TSBenutzer.prototype.getFullName = function () {
        return (this.vorname ? this.vorname : '') + ' ' + (this.nachname ? this.nachname : '');
    };
    Object.defineProperty(TSBenutzer.prototype, "recaptchaResponse", {
        get: function () {
            return this._recaptchaResponse;
        },
        set: function (value) {
            this._recaptchaResponse = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBenutzer.prototype, "maxErfassungsbetrag", {
        get: function () {
            return this._maxErfassungsbetrag;
        },
        set: function (value) {
            this._maxErfassungsbetrag = value;
        },
        enumerable: true,
        configurable: true
    });
    TSBenutzer.deserializeArray = function (data) {
        var benutzerArray = [];
        if (data && Array.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                benutzerArray[i] = new TSBenutzer().deserialize(data[i]);
            }
        }
        else {
            benutzerArray[0] = new TSBenutzer().deserialize(data);
        }
        return benutzerArray;
    };
    TSBenutzer.prototype.checkEmailRepeated = function () {
        if (this.email) {
            return this.email === this._emailRepeat;
        }
        return true;
    };
    TSBenutzer.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.vorname = restObject.vorname;
        this.nachname = restObject.nachname;
        this.korrespondenzsprache = restObject.korrespondenzsprache;
        this.anrede = restObject.anrede;
        this.email = restObject.email;
        this.telefon = restObject.telefon;
        this.roles = restObject.roles;
        if (restObject.anlaufstellen) {
            this.anlaufstellen = restObject.anlaufstellen.map(function (anlaufstelle) {
                return (new TSAnlaufstelle_1.default()).deserialize(anlaufstelle);
            });
        }
        this.inaktiv = restObject.inaktiv;
        this.maxErfassungsbetrag = restObject.maxErfassungsbetrag;
        return this;
    };
    TSBenutzer.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.vorname = this.vorname;
        restObject.nachname = this.nachname;
        restObject.korrespondenzsprache = this.korrespondenzsprache;
        restObject.anrede = this.anrede;
        if (this.passwordData) {
            restObject.passwordData = this.passwordData.serialize({});
        }
        restObject.email = this.email;
        restObject.telefon = this.telefon;
        restObject.roles = this.roles;
        restObject.anlaufstellen = this.arrayToRestObject(this.anlaufstellen);
        restObject.inaktiv = this.inaktiv;
        restObject.recaptchaResponse = this.recaptchaResponse;
        restObject.maxErfassungsbetrag = this.maxErfassungsbetrag;
        return restObject;
    };
    TSBenutzer.getDeserializer = function (benutzer) {
        return new TSBenutzer().deserialize(benutzer);
    };
    return TSBenutzer;
}(TSAbstractEntity_1.default));
exports.default = TSBenutzer;
;


/***/ }),

/***/ "XTXf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSRole_1 = __webpack_require__("MleR");
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
/**
 * Service zum verwalten von Fondssuisse.
 */
var FondssuisseRS = /** @class */ (function () {
    /* @ngInject */
    function FondssuisseRS($http, CONSTANTS, $q, $rootScope, $log) {
        this.$http = $http;
        this.CONSTANTS = CONSTANTS;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$log = $log;
    }
    FondssuisseRS.prototype.getBenutzerOfFondssuisse = function (roleToLimitTo) {
        var _this = this;
        var configObject;
        if (roleToLimitTo === undefined) {
            configObject = {
                params: {
                    rolesToLimitTo: [TSRole_1.TSRole[TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER], TSRole_1.TSRole[TSRole_1.TSRole.FONDSSUISSE_ADMIN]]
                }
            };
        }
        else {
            configObject = {
                params: {
                    rolesToLimitTo: [TSRole_1.TSRole[roleToLimitTo]]
                }
            };
        }
        return this.$http.get(this.CONSTANTS.REST_API + 'fondssuisse/benutzer', configObject)
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING Benutzer REST  object', response.data);
                return TSBenutzer_1.default.deserializeArray(response.data);
            }
            else {
                return [];
            }
        });
    };
    FondssuisseRS.prototype.addFSSachbearbeiterRole = function (benutzerId) {
        var _this = this;
        return this.$http.put(this.CONSTANTS.REST_API + 'fondssuisse/benutzer/sachbearbeiter/' + encodeURIComponent(benutzerId), undefined)
            .then(function (response) {
            if (response.data !== undefined && response.data !== null && response.data !== '') {
                _this.$log.debug('added role to benutzer ', response.data);
                return TSBenutzer_1.default.getDeserializer(response.data);
            }
            else {
                _this.$log.debug('role was already present on benutzer ', benutzerId);
                return undefined;
            }
        });
    };
    FondssuisseRS.prototype.addFSAdminRole = function (benutzerId) {
        var _this = this;
        return this.$http.put(this.CONSTANTS.REST_API + 'fondssuisse/benutzer/admin/' + encodeURIComponent(benutzerId), undefined)
            .then(function (response) {
            if (response.data !== undefined && response.data !== null && response.data !== '') {
                _this.$log.debug('added role to benutzer ', response.data);
                return TSBenutzer_1.default.getDeserializer(response.data);
            }
            else {
                _this.$log.debug('role was already present on benutzer ', benutzerId);
                return undefined;
            }
        });
    };
    FondssuisseRS.prototype.removeFSSachbearbeiterRole = function (benutzerId) {
        var _this = this;
        return this.$http.delete(this.CONSTANTS.REST_API + 'fondssuisse/benutzer/sachbearbeiter/' + encodeURIComponent(benutzerId))
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('removed role from benutzer ' + benutzerId);
            }
        });
    };
    FondssuisseRS.prototype.removeFSAdminRole = function (benutzerId) {
        var _this = this;
        return this.$http.delete(this.CONSTANTS.REST_API + 'fondssuisse/benutzer/admin/' + encodeURIComponent(benutzerId))
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('removed FS_ADMIN role from benutzer');
            }
        });
    };
    FondssuisseRS.$inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];
    return FondssuisseRS;
}());
exports.default = FondssuisseRS;


/***/ }),

/***/ "Xat7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractModelController_1 = __importDefault(__webpack_require__("VDYy"));
var TSDokumentType_1 = __webpack_require__("/gTe");
var TSEigentumsverhaeltnis_1 = __webpack_require__("PSWS");
var TSErfassungsArt_1 = __webpack_require__("X/T9");
var TSRechtsform_1 = __webpack_require__("EUJE");
var TSRole_1 = __webpack_require__("MleR");
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var TSSprache_1 = __webpack_require__("3oUo");
var TSAdresse_1 = __importDefault(__webpack_require__("aL5m"));
var TSGenossenschaft_1 = __importDefault(__webpack_require__("WbgF"));
var TSGenossenschaftDaten_1 = __importDefault(__webpack_require__("RuPF"));
var TSGesuchsPerson_1 = __importDefault(__webpack_require__("WFK3"));
var TSGesuchsPersonDaten_1 = __importDefault(__webpack_require__("fiK7"));
var TSGesuchsteller_1 = __importDefault(__webpack_require__("o8Fj"));
var TSKoerperschaft_1 = __importDefault(__webpack_require__("c9dM"));
var TSKoerperschaftDaten_1 = __importDefault(__webpack_require__("XeJg"));
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
var BerechnungsdetailController_1 = __webpack_require__("OS2/");
var berechnungsTemplate = __webpack_require__("lL5G");
__webpack_require__("UmtK");
var GesuchstellerComponentConfig = /** @class */ (function () {
    function GesuchstellerComponentConfig() {
        this.transclude = false;
        this.bindings = {
            model: '=',
            eigentumsverhaeltnis: '=',
            name: '@',
            prefix: '@',
            erfassungsart: '<',
            versicherungsmode: '<',
            status: '<',
            schadenfallId: '<',
            schadendatum: '<',
            ermittelterSchaden: '<',
            emailNotRequired: '<?',
            phoneRequired: '<?',
            importiert: '<',
        };
        this.template = __webpack_require__("uQ8n");
        this.controller = DvGesuchstellerController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return GesuchstellerComponentConfig;
}());
exports.GesuchstellerComponentConfig = GesuchstellerComponentConfig;
var DvGesuchstellerController = /** @class */ (function (_super) {
    __extends(DvGesuchstellerController, _super);
    /* @ngInject */
    function DvGesuchstellerController(authServiceRS, dvDialog, roleUtilService, $translate, $scope, dvBernUtil) {
        var _this = _super.call(this, $scope) || this;
        _this.authServiceRS = authServiceRS;
        _this.dvDialog = dvDialog;
        _this.roleUtilService = roleUtilService;
        _this.$translate = $translate;
        _this.dvBernUtil = dvBernUtil;
        _this.doctype = TSDokumentType_1.TSDocumentType.GESUCHSTELLER_DOC;
        _this.dokumentNeededMap = {};
        _this.importiert = false;
        _this.currentYear = DateUtil_1.default.currentYear();
        return _this;
    }
    DvGesuchstellerController.prototype.$onInit = function () {
        var _this = this;
        this.changedEigentumsverhaeltinis();
        this.$scope.$watch(function () { return _this.model.eigentumsverhaeltnis; }, function (val) {
            _this.changedEigentumsverhaeltinis();
        });
        if (this.model.isZweitperson) {
            this.doctype = TSDokumentType_1.TSDocumentType.ZWEITPERSON_DOC;
        }
        this.loadDokumentNeededMap();
    };
    DvGesuchstellerController.prototype.loadDokumentNeededMap = function () {
        // Bei Versicherungsbeitrag nie Dokumente hochladen!
        if (!this.versicherungsmode) {
            // second parameter is if required
            var isSteuerpflichtig = this.isSteuerpflichtigeRechtsform(this.model);
            if (!this.model.isZweitperson) {
                // Gesuchsteller paechter
                if (this.model.eigentumsverhaeltnis === TSEigentumsverhaeltnis_1.TSEigentumsverhaeltnis.PAECHTER) {
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.NATUERLICHE_PERSON] = [['PACHTVERTRAG', false]];
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.GENOSSENSCHAFT] = [['MITGLIEDERVERZEICHNIS', true], ['JAHRESRECHNUNG', false], ['PACHTVERTRAG', false]];
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.ANDERE_KOERPERSCHAFT] = [];
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.MEHRPERSONENGESELLSCHAFT] = [['STEUERFAKTOREN', true], ['PACHTVERTRAG', false]];
                }
                else {
                    // gesuchsteller grundeigentuemer
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.NATUERLICHE_PERSON] = [];
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.GENOSSENSCHAFT] = [['MITGLIEDERVERZEICHNIS', true], ['JAHRESRECHNUNG', false]];
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.ANDERE_KOERPERSCHAFT] = [];
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.MEHRPERSONENGESELLSCHAFT] = [['STEUERFAKTOREN', true]];
                }
            }
            else {
                // zweitperson paechter
                if (this.model.eigentumsverhaeltnis === TSEigentumsverhaeltnis_1.TSEigentumsverhaeltnis.PAECHTER) {
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.NATUERLICHE_PERSON] = [['PACHTVERTRAG', false]];
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.GENOSSENSCHAFT] = [['PACHTVERTRAG', false]];
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.ANDERE_KOERPERSCHAFT] = [];
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.MEHRPERSONENGESELLSCHAFT] = [['PACHTVERTRAG', false]];
                }
                else { //zweitperson grundeigentuemer
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.NATUERLICHE_PERSON] = [];
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.GENOSSENSCHAFT] = [];
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.ANDERE_KOERPERSCHAFT] = [];
                    this.dokumentNeededMap[TSRechtsform_1.TSRechtsform.MEHRPERSONENGESELLSCHAFT] = [];
                }
            }
        }
    };
    /**
     * gibt moegliche rechtsfromen zurueck
     */
    DvGesuchstellerController.prototype.getTSRechtsformen = function () {
        if ((this.model.isZweitperson && this.model.eigentumsverhaeltnis === TSEigentumsverhaeltnis_1.TSEigentumsverhaeltnis.GRUNDEIGENTUEMER)
            || this.importiert) {
            return TSRechtsform_1.getTSRechtsformValuesForZweitpersonGrundeigentuemer();
        }
        else {
            return TSRechtsform_1.getTSRechtsformValues();
        }
    };
    DvGesuchstellerController.prototype.changedEigentumsverhaeltinis = function () {
        if (this.model && this.model && this.model.eigentumsverhaeltnis) {
            this.loadDokumentNeededMap();
        }
        this.resetErrors();
    };
    DvGesuchstellerController.prototype.resetErrors = function () {
        if (this.form) {
            this.form.$setPristine();
            this.form.$setUntouched();
        }
    };
    DvGesuchstellerController.prototype.changedRechtsform = function () {
        if (this.model && this.model && this.model.rechtsform) {
            this.initGesuchsteller(this.model);
            this.loadDokumentNeededMap();
        }
        this.resetErrors();
    };
    DvGesuchstellerController.prototype.initGesuchsteller = function (gesuchsteller) {
        switch (gesuchsteller.rechtsform) {
            case TSRechtsform_1.TSRechtsform.NATUERLICHE_PERSON:
                this.createGesuchsPersonDaten(gesuchsteller);
                //adresse wird hier benoetigt
                if (this.model.kontaktperson && !this.model.kontaktperson.gesuchsPersonDatenFS.adresse) {
                    this.model.kontaktperson.gesuchsPersonDatenFS.adresse = new TSAdresse_1.default();
                }
                break;
            case TSRechtsform_1.TSRechtsform.MEHRPERSONENGESELLSCHAFT:
            case TSRechtsform_1.TSRechtsform.GENOSSENSCHAFT:
                this.createGesuchsPersonDaten(gesuchsteller);
                if (!gesuchsteller.genossenschaft) {
                    gesuchsteller.genossenschaft = new TSGenossenschaft_1.default();
                    gesuchsteller.genossenschaft.genossenschaftDatenFS = new TSGenossenschaftDaten_1.default();
                }
                break;
            case TSRechtsform_1.TSRechtsform.ANDERE_KOERPERSCHAFT:
                this.createGesuchsPersonDaten(gesuchsteller);
                if (!gesuchsteller.koerperschaft) {
                    gesuchsteller.koerperschaft = new TSKoerperschaft_1.default();
                    gesuchsteller.koerperschaft.koerperschaftDatenFS = new TSKoerperschaftDaten_1.default();
                }
                break;
            default:
        }
    };
    DvGesuchstellerController.prototype.createGesuchsPersonDaten = function (gesuchsteller) {
        if (!gesuchsteller.kontaktperson) {
            gesuchsteller.kontaktperson = new TSGesuchsPerson_1.default();
            gesuchsteller.kontaktperson.gesuchsPersonDatenFS = new TSGesuchsPersonDaten_1.default();
            // set default email if Role is Betroffener
            if (this.isFillingOwnData()) {
                this.preFillDataOfPrincipal(gesuchsteller.kontaktperson.gesuchsPersonDatenFS);
            }
        }
    };
    // die ausfuellende Person ist der Gesuchsteller selber
    DvGesuchstellerController.prototype.isFillingOwnData = function () {
        return this.authServiceRS.isRole(TSRole_1.TSRole.BETROFFENER) && this.prefix === 'gesuchsteller';
    };
    DvGesuchstellerController.prototype.preFillDataOfPrincipal = function (gesuchsPersonDatenFS) {
        var principal = this.authServiceRS.getPrincipal();
        if (principal) {
            if (principal.email) {
                gesuchsPersonDatenFS.mail = principal.email;
            }
            if (principal.vorname) {
                gesuchsPersonDatenFS.vorname = principal.vorname;
            }
            if (principal.nachname) {
                gesuchsPersonDatenFS.nachname = principal.nachname;
            }
        }
    };
    DvGesuchstellerController.prototype.checkRechtsform = function (rechtsform) {
        return rechtsform === this.model.rechtsform;
    };
    DvGesuchstellerController.prototype.getTSSpracheValues = function () {
        return TSSprache_1.getTSSpracheValues();
    };
    DvGesuchstellerController.prototype.getMinimalSchaden = function (ermittelterSchaden, schadendatum) {
        return Math.round(this.getEinkommensabzug() + this.getVermoegenssabzug(ermittelterSchaden, schadendatum) + this.getAnrechenbarerSchaden());
    };
    DvGesuchstellerController.prototype.getEinkommensabzug = function () {
        return this.model.getEinkommensabzug();
    };
    DvGesuchstellerController.prototype.getVermoegenssabzug = function (ermittelterSchaden, schadendatum) {
        return this.model.getVermoegenssabzug(schadendatum, ermittelterSchaden);
    };
    DvGesuchstellerController.prototype.getGesamtAbzug = function (ermittelterSchaden) {
        return this.getVermoegenssabzug(ermittelterSchaden, this.schadendatum) + this.getEinkommensabzug();
    };
    DvGesuchstellerController.prototype.MRound = function (number, roundto) {
        return roundto * Math.round(number / roundto);
    };
    DvGesuchstellerController.prototype.isBerechtigtEinkommen = function () {
        if (this.model.hasFinanzangaben() &&
            DVBernUtil_1.default.isNotNullOrUndefined(this.model.finanzangaben.finanzangabenDatenFS.einkommenGewinn)) {
            if (this.model.finanzangaben.finanzangabenDatenFS.einkommenGewinn < 200000) {
                return true;
            }
        }
        return false;
    };
    DvGesuchstellerController.prototype.getMinimalSchadenVermoegenText = function () {
        if (this.schadendatum === null || this.schadendatum === undefined || this.schadendatum.isAfter(TSGesuchsteller_1.default.POST_2025_START_DATE, 'day')) {
            return 'MINIMAL_SCHADEN_VERMOEGEN_2026';
        }
        else {
            return 'MINIMAL_SCHADEN_VERMOEGEN';
        }
    };
    DvGesuchstellerController.prototype.isBerechtigtVermoegen = function () {
        var wealthThreshold = this.schadendatum === null ||
            this.schadendatum === undefined ||
            this.schadendatum.isAfter(TSGesuchsteller_1.default.POST_2025_START_DATE, 'day') ?
            TSGesuchsteller_1.default.MAX_VERMOEGEN_KAPITAL_POST_2025 :
            TSGesuchsteller_1.default.MAX_VERMOEGEN_KAPITAL_PRE_2026;
        if (this.model.hasFinanzangaben() &&
            DVBernUtil_1.default.isNotNullOrUndefined(this.model.finanzangaben.finanzangabenDatenFS.vermoegenKapital)) {
            if (this.model.finanzangaben.finanzangabenDatenFS.vermoegenKapital < wealthThreshold) {
                return true;
            }
        }
        return false;
    };
    DvGesuchstellerController.prototype.getAnrechenbarerSchaden = function () {
        if (this.model && this.model &&
            (this.model.rechtsform === TSRechtsform_1.TSRechtsform.GENOSSENSCHAFT ||
                this.model.rechtsform === TSRechtsform_1.TSRechtsform.ANDERE_KOERPERSCHAFT)) {
            return 1000;
        }
        return 300;
    };
    DvGesuchstellerController.prototype.openBerechnungsdetail = function () {
        var vermoegenKapital = this.model.hasFinanzangaben() ? this.model.finanzangaben.finanzangabenDatenFS.vermoegenKapital : undefined;
        var einkommenGewinn = this.model.hasFinanzangaben() ? this.model.finanzangaben.finanzangabenDatenFS.einkommenGewinn : undefined;
        this.dvDialog.showBerechnungsDetail(berechnungsTemplate, BerechnungsdetailController_1.BerechnungsdetailController, {
            einkommensabzug: this.getEinkommensabzug(),
            vermoegensabzug: this.getVermoegenssabzug(this.ermittelterSchaden, this.schadendatum),
            anrechenbarerschaden: this.getAnrechenbarerSchaden(),
            minimalschaden: this.getMinimalSchaden(this.ermittelterSchaden, this.schadendatum),
            steuerbaresvermoegen: vermoegenKapital,
            steuerbareseinkommen: einkommenGewinn,
        }).then(function () {
            //do nothing
        }).catch(function () {
        });
    };
    DvGesuchstellerController.prototype.getRolesAllowedForSteuerdaten = function () {
        return this.dvBernUtil.getRolesAllowedForSteuerdaten();
    };
    DvGesuchstellerController.prototype.getRolesAllowedForSteuerdatenPruefung = function () {
        //FS Admin und Anlaufstelle (nicht aber FS Sachbearbeiter, Schaetzer oder Betroffene)
        return this.roleUtilService.getRolesAllowedForAnlaufstellenPruefung();
    };
    DvGesuchstellerController.prototype.getZustimmungGesuchstellerReadonly = function () {
        return !this.authServiceRS.isOneOfRoles(this.roleUtilService.getGesuchstellerOnlyRoles()) && !(this.erfassungsart === TSErfassungsArt_1.TSErfassungsArt.PAPIER);
    };
    DvGesuchstellerController.prototype.showZustimmungSteuerpruefung = function () {
        return !(this.erfassungsart === TSErfassungsArt_1.TSErfassungsArt.PAPIER);
    };
    DvGesuchstellerController.prototype.getZustimmungSteuerpruefungText = function () {
        if (this.model.rechtsform === TSRechtsform_1.TSRechtsform.GENOSSENSCHAFT) {
            return this.$translate.instant('ZUSTIMMUNG_STEUERPRUEFUNG_GENOSSENSCHAFT');
        }
        else {
            return this.$translate.instant('ZUSTIMMUNG_STEUERPRUEFUNG');
        }
    };
    DvGesuchstellerController.prototype.getZustimmungPruefungFondsuisseText = function () {
        if (this.model.rechtsform === TSRechtsform_1.TSRechtsform.GENOSSENSCHAFT) {
            return this.$translate.instant('ZUSTIMMUNG_PRUEFUNG_FONDSUISSE_GENOSSENSCHAFT');
        }
        else {
            return this.$translate.instant('ZUSTIMMUNG_PRUEFUNG_FONDSUISSE');
        }
    };
    DvGesuchstellerController.prototype.clearSteuerdatenGeprueft = function () {
        if (this.model.finanzangaben) {
            this.model.finanzangaben.steuerdatenGeprueft = false;
        }
    };
    DvGesuchstellerController.prototype.isSchadenFallNeuOnlineOderNeuPapier = function () {
        if (this.status) {
            return this.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU || this.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS ||
                this.status === TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE; //papier hat neu_papier
        }
        return false;
    };
    DvGesuchstellerController.prototype.translateRechtsform = function (rechtsform) {
        return this.$translate.instant('' + rechtsform);
    };
    DvGesuchstellerController.prototype.showFinanzVerhaeltnisse = function () {
        var benutzer = this.authServiceRS.getPrincipal();
        // @ts-ignore
        if (benutzer.email === 'cnav@ne.ch' && !isInStatus(this.status, TSSchadenfallStatus_1.getTSSchadenfallStatusNeu())) {
            //FIXME FS-751: Temporary hack
            //Für das Unwetter in La Chaux-de-Fonds soll ein Benutzer als Drittperson Gesuche für andere erfassen können.
            //Die Steuerfaktoren sollen in diesem Fall ausgeblendet werden. Soll mit FS-750 generell gelöst werden.
            return false;
        }
        var notZweitperson = !this.model.isZweitperson;
        var isSteuerpflichtigeRechtsfrom = this.isSteuerpflichtigeRechtsform(this.model);
        return notZweitperson && isSteuerpflichtigeRechtsfrom;
    };
    DvGesuchstellerController.prototype.isSteuerpflichtigeRechtsform = function (gesuchsteller) {
        return gesuchsteller.rechtsform === TSRechtsform_1.TSRechtsform.NATUERLICHE_PERSON ||
            (gesuchsteller.rechtsform === TSRechtsform_1.TSRechtsform.GENOSSENSCHAFT
                && gesuchsteller.genossenschaft !== undefined
                && gesuchsteller.genossenschaft.genossenschaftDatenFS.isSteuerpflichtig);
    };
    DvGesuchstellerController.prototype.getJahrtext = function (rechtsform) {
        return this.dvBernUtil.getJahrtext(rechtsform);
    };
    DvGesuchstellerController.prototype.getEinkommenGewinnText = function (rechtsform) {
        return this.dvBernUtil.getEinkommenGewinnText(rechtsform);
    };
    DvGesuchstellerController.prototype.getVermoegenKapitalText = function (rechtsform) {
        return this.dvBernUtil.getVermoegenKapitalText(rechtsform);
    };
    DvGesuchstellerController.prototype.getAngabenTitle = function () {
        switch (this.model.rechtsform) {
            case TSRechtsform_1.TSRechtsform.NATUERLICHE_PERSON:
                return this.$translate.instant(this.model.eigentumsverhaeltnis.toString());
            default:
                return this.$translate.instant(this.model.eigentumsverhaeltnis.toString()) + ' ' + this.$translate.instant(this.model.rechtsform.toString());
        }
    };
    DvGesuchstellerController.prototype.needDokuments = function () {
        return !!(this.model && this.dokumentNeededMap[this.model.rechtsform] && this.dokumentNeededMap[this.model.rechtsform].length > 0);
    };
    DvGesuchstellerController.prototype.countRequiredDocs = function () {
        var requiredDocs = 0;
        if (this.needDokuments()) {
            try {
                for (var _a = __values(this.dokumentNeededMap[this.model.rechtsform]), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var dokumentNeeded = _b.value;
                    if (dokumentNeeded[1]) {
                        requiredDocs++;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return '' + requiredDocs;
        var e_1, _c;
    };
    DvGesuchstellerController.prototype.isShowTitlePrefix = function () {
        return this.dvBernUtil.isShowTitlePrefix(this.model);
    };
    DvGesuchstellerController.prototype.steuerpflichtChanged = function (event) {
        this.loadDokumentNeededMap();
    };
    DvGesuchstellerController.$inject = ['AuthServiceRS', 'DvDialog', 'RoleUtilService', '$translate', '$scope', 'DVBernUtil'];
    return DvGesuchstellerController;
}(abstractModelController_1.default));
exports.DvGesuchstellerController = DvGesuchstellerController;


/***/ }),

/***/ "XdCm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var TSSchadenfall_1 = __importDefault(__webpack_require__("mUaf"));
var TSSchadenfallDTO = /** @class */ (function () {
    function TSSchadenfallDTO() {
    }
    Object.defineProperty(TSSchadenfallDTO.prototype, "fallNummer", {
        get: function () {
            return this._fallNummer;
        },
        set: function (value) {
            this._fallNummer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDTO.prototype, "schadenfallHerkunft", {
        get: function () {
            return this._schadenfallHerkunft;
        },
        set: function (value) {
            this._schadenfallHerkunft = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDTO.prototype, "gesuchstellerName", {
        get: function () {
            return this._gesuchstellerName;
        },
        set: function (value) {
            this._gesuchstellerName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDTO.prototype, "ereignis", {
        get: function () {
            return this._ereignis;
        },
        set: function (value) {
            this._ereignis = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDTO.prototype, "amtsstelleName", {
        get: function () {
            return this._amtsstelleName;
        },
        set: function (value) {
            this._amtsstelleName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDTO.prototype, "ort", {
        get: function () {
            return this._ort;
        },
        set: function (value) {
            this._ort = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDTO.prototype, "gesuchsdatum", {
        get: function () {
            return this._gesuchsdatum;
        },
        set: function (value) {
            this._gesuchsdatum = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDTO.prototype, "ereignisdatum", {
        get: function () {
            return this._ereignisdatum;
        },
        set: function (value) {
            this._ereignisdatum = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDTO.prototype, "status", {
        get: function () {
            return this._status;
        },
        set: function (value) {
            this._status = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDTO.prototype, "verantwortlicher", {
        get: function () {
            return this._verantwortlicher;
        },
        set: function (value) {
            this._verantwortlicher = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDTO.prototype, "schadenfallId", {
        get: function () {
            return this._schadenfallId;
        },
        set: function (value) {
            this._schadenfallId = value;
        },
        enumerable: true,
        configurable: true
    });
    TSSchadenfallDTO.prototype.getFallnummerWithZeros = function () {
        return TSSchadenfall_1.default.calculateFallnummerWithZeros(this._fallNummer);
    };
    Object.defineProperty(TSSchadenfallDTO.prototype, "kanton", {
        get: function () {
            return this._kanton;
        },
        set: function (value) {
            this._kanton = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDTO.prototype, "geschaetzteKosten", {
        get: function () {
            return this._geschaetzteKosten;
        },
        set: function (value) {
            this._geschaetzteKosten = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDTO.prototype, "totalSchaetzung", {
        get: function () {
            return this._totalSchaetzung;
        },
        set: function (value) {
            this._totalSchaetzung = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDTO.prototype, "korrespondenzsprache", {
        get: function () {
            return this._korrespondenzsprache;
        },
        set: function (value) {
            this._korrespondenzsprache = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDTO.prototype, "newInStatus", {
        get: function () {
            return this._newInStatus;
        },
        set: function (value) {
            this._newInStatus = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfallDTO.prototype, "isOverdue", {
        get: function () {
            return this._isOverdue;
        },
        set: function (value) {
            this._isOverdue = value;
        },
        enumerable: true,
        configurable: true
    });
    TSSchadenfallDTO.prototype.deserialize = function (restObject) {
        this.schadenfallId = restObject.schadenfallId;
        this.fallNummer = restObject.fallNummer;
        this.gesuchstellerName = restObject.gesuchstellerName;
        this.ereignis = restObject.ereignis;
        this.amtsstelleName = restObject.amtsstelleName;
        this.ort = restObject.ort;
        this.kanton = restObject.kanton;
        this.korrespondenzsprache = restObject.korrespondenzsprache;
        this.gesuchsdatum = DateUtil_1.default.localDateToMoment(restObject.gesuchsdatum);
        this.ereignisdatum = DateUtil_1.default.localDateToMoment(restObject.ereignisdatum);
        this.status = restObject.status;
        this.verantwortlicher = restObject.verantwortlicher;
        this.geschaetzteKosten = restObject.geschaetzteKosten;
        this.isOverdue = restObject.isOverdue;
        this.newInStatus = restObject.newInStatus;
        return this;
    };
    return TSSchadenfallDTO;
}());
exports.default = TSSchadenfallDTO;


/***/ }),

/***/ "Xdl5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "XeJg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSKoerperschaftDaten = /** @class */ (function (_super) {
    __extends(TSKoerperschaftDaten, _super);
    function TSKoerperschaftDaten() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSKoerperschaftDaten.prototype, "koerperschaftArt", {
        get: function () {
            return this._koerperschaftArt;
        },
        set: function (value) {
            this._koerperschaftArt = value;
        },
        enumerable: true,
        configurable: true
    });
    TSKoerperschaftDaten.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.koerperschaftArt = restObject.koerperschaftArt;
        return this;
    };
    TSKoerperschaftDaten.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.koerperschaftArt = this.koerperschaftArt;
        return restObject;
    };
    return TSKoerperschaftDaten;
}(TSAbstractEntity_1.default));
exports.default = TSKoerperschaftDaten;


/***/ }),

/***/ "XeaR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("7K99");
var MapComponentConfig = /** @class */ (function () {
    function MapComponentConfig() {
        this.transclude = false;
        this.bindings = {
            lon: '=',
            lat: '=',
        };
        this.template = __webpack_require__("+CD4");
        this.controller = DvMapController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return MapComponentConfig;
}());
exports.MapComponentConfig = MapComponentConfig;
var DvMapController = /** @class */ (function () {
    function DvMapController($log, NgMap, $window) {
        this.$log = $log;
        this.NgMap = NgMap;
        this.$window = $window;
        this.positions = [];
    }
    DvMapController.prototype.$onInit = function () {
        if (this.lon && this.lat) {
            this.positions.push({ pos: [this.lat, this.lon] });
        }
    };
    DvMapController.prototype.addMarker = function (event, that) {
        var ll = event.latLng;
        that.positions = [];
        that.positions.push({ pos: [ll.lat(), ll.lng()] });
        that.lon = that.getLonFromPosition();
        that.lat = that.getLatFromPosition();
    };
    DvMapController.prototype.getCenter = function () {
        //Wenn marker vorhanden auf Marker zentieren
        if (this.lon && this.lat) {
            return [this.lat, this.lon];
        }
        //Sonst auf Schweiz zentieren
        return '[46.83389, 8.16833]';
    };
    DvMapController.prototype.getZoom = function () {
        //Wenn marker vorhanden auf Marker zoomen
        if (this.lon && this.lat) {
            return 12;
        }
        //Sonst auf Schweiz zentieren
        return 7;
    };
    DvMapController.prototype.getLonFromPosition = function () {
        if (this.positions && this.positions[0]) {
            return this.positions[0].pos[1];
        }
        return '';
    };
    DvMapController.prototype.getLatFromPosition = function () {
        if (this.positions && this.positions[0]) {
            return this.positions[0].pos[0];
        }
        return '';
    };
    // This is needen bacause there are gray ares in map
    // see: https://github.com/allenhwkim/angularjs-google-maps#grey-area-in-google-maps
    DvMapController.prototype.onMapLoaded = function () {
        // There is a bug in angular 1.6: Possibly unhandled rejection: could not find map
        // see: https://github.com/allenhwkim/angularjs-google-maps/issues/614
        var self = this;
        this.NgMap.getMap().then(function (map) {
            self.gMap = map;
            var center = map.getCenter();
            self.$window.google.maps.event.trigger(self.gMap, 'resize');
            map.setCenter(center);
        });
    };
    DvMapController.$inject = ['$log', 'NgMap', '$window'];
    return DvMapController;
}());
exports.DvMapController = DvMapController;


/***/ }),

/***/ "Xeva":
/***/ (function(module, exports) {

module.exports = "<div ng-form=\"adresseForm\"> <fieldset> <div ng-if=\"vm.displayLegacyAdresse()\" class=\"dv-adresse row\"> <div class=\"col-sm-4 dv-input-container-small\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"ADRESSE_STRASSE\" for=\"{{vm.prefix}}-strasse\"> </label> <input id=\"{{vm.prefix}}-strasse\" type=\"text\" name=\"adresseStrasse\" ng-model=\"vm.getModel().strasse\" dv-max-length class=\"form-control\" required> <dv-error-messages for=\"adresseForm.adresseStrasse\" class=\"error\"></dv-error-messages> <dv-bisher ng-if=\"vm.showBisher()\" gs=\"vm.bisherGs.adresse\" fs=\"vm.bisherFs.adresse\" for=\"adresseForm.adresseStrasse\" property=\"strasse\"></dv-bisher> </dv-input-container> </div> <div class=\"col-sm-2 dv-input-container-small\"> <dv-input-container class=\"secondColumn\"> <label class=\"md-no-float\" data-translate=\"ADRESSE_HAUSNUMMER\" for=\"{{vm.prefix}}-hausnummer\"> </label> <input id=\"{{vm.prefix}}-hausnummer\" type=\"text\" name=\"adresseHausnummer\" ng-model=\"vm.getModel().hausnummer\" dv-max-length dv-trim-empty class=\"form-control\"> <dv-error-messages for=\"adresseForm.adresseHausnummer\" class=\"error\"></dv-error-messages> <dv-bisher ng-if=\"vm.showBisher()\" gs=\"vm.bisherGs.adresse\" fs=\"vm.bisherFs.adresse\" for=\"adresseForm.adresseHausnummer\" property=\"hausnummer\" forcestring></dv-bisher> </dv-input-container> </div> </div> <div ng-if=\"vm.displayLegacyAdresse()\" class=\"row\"> <div class=\"col-sm-4 dv-input-container-small\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"ADRESSE_ZUSATZ\" for=\"{{vm.prefix}}-zusatzzeile\"> </label> <input id=\"{{vm.prefix}}-zusatzzeile\" type=\"text\" name=\"adresseZusatzzeile\" ng-model=\"vm.getModel().zusatzzeile\" dv-max-length class=\"form-control\"> <dv-error-messages for=\"adresseForm.adresseZusatzzeile\" class=\"error\"></dv-error-messages> <dv-bisher ng-if=\"vm.showBisher()\" gs=\"vm.bisherGs.adresse\" fs=\"vm.bisherFs.adresse\" for=\"adresseForm.adresseZusatzzeile\" property=\"zusatzzeile\"></dv-bisher> </dv-input-container> </div> </div> <div ng-if=\"!vm.displayLegacyAdresse()\" class=\"row\"> <div class=\"col-sm-4 dv-input-container-small\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"ADRESSE_1\" for=\"{{vm.prefix}}-adresse1\"> </label> <input id=\"{{vm.prefix}}-adresse1\" type=\"text\" name=\"adresse1\" ng-model=\"vm.getModel().adresse1\" dv-max-length class=\"form-control\"> <dv-error-messages for=\"adresseForm.adresse1\" class=\"error\"></dv-error-messages> <dv-bisher ng-if=\"vm.showBisher()\" gs=\"vm.bisherGs.adresse\" fs=\"vm.bisherFs.adresse\" for=\"adresseForm.adresse1\" property=\"adresse1\"></dv-bisher> </dv-input-container> </div> </div> <div ng-if=\"!vm.displayLegacyAdresse()\" class=\"row\"> <div class=\"col-sm-4 dv-input-container-small\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"ADRESSE_2\" for=\"{{vm.prefix}}-adresse2\"> </label> <input id=\"{{vm.prefix}}-adresse2\" type=\"text\" name=\"adresse2\" ng-model=\"vm.getModel().adresse2\" dv-max-length class=\"form-control\"> <dv-error-messages for=\"adresseForm.adresse2\" class=\"error\"></dv-error-messages> <dv-bisher ng-if=\"vm.showBisher()\" gs=\"vm.bisherGs.adresse\" fs=\"vm.bisherFs.adresse\" for=\"adresseForm.adresse2\" property=\"adresse2\"></dv-bisher> </dv-input-container> </div> </div> <div ng-if=\"!vm.displayLegacyAdresse()\" class=\"row\"> <div class=\"col-sm-4 dv-input-container-small\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"ADRESSE_3\" for=\"{{vm.prefix}}-adresse3\"> </label> <input id=\"{{vm.prefix}}-adresse3\" type=\"text\" name=\"adresse3\" ng-model=\"vm.getModel().adresse3\" dv-max-length class=\"form-control\"> <dv-error-messages for=\"adresseForm.adresse3\" class=\"error\"></dv-error-messages> <dv-bisher ng-if=\"vm.showBisher()\" gs=\"vm.bisherGs.adresse\" fs=\"vm.bisherFs.adresse\" for=\"adresseForm.adresse3\" property=\"adresse3\"></dv-bisher> </dv-input-container> </div> </div> <div class=\"row\"> <div class=\"col-sm-2 dv-input-container-small\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"ADRESSE_PLZ\" for=\"{{vm.prefix}}-plz\"> </label> <input id=\"{{vm.prefix}}-plz\" type=\"text\" name=\"adressePlz\" ng-model=\"vm.getModel().plz\" dv-max-length class=\"form-control\" required> <dv-error-messages for=\"adresseForm.adressePlz\" class=\"error\"></dv-error-messages> <dv-bisher ng-if=\"vm.showBisher()\" gs=\"vm.bisherGs.adresse\" fs=\"vm.bisherFs.adresse\" for=\"adresseForm.adressePlz\" property=\"plz\" forcestring></dv-bisher> </dv-input-container> </div> <div class=\"col-sm-4 dv-input-container-small\"> <dv-input-container class=\"secondColumn\"> <label class=\"md-no-float\" data-translate=\"ADRESSE_ORT\" for=\"{{vm.prefix}}-ort\"> </label> <input id=\"{{vm.prefix}}-ort\" type=\"text\" name=\"adresseOrt\" ng-model=\"vm.getModel().ort\" dv-max-length class=\"form-control\" required> <dv-error-messages for=\"adresseForm.adresseOrt\" class=\"error\"></dv-error-messages> <dv-bisher ng-if=\"vm.showBisher()\" gs=\"vm.bisherGs.adresse\" fs=\"vm.bisherFs.adresse\" for=\"adresseForm.adresseOrt\" property=\"ort\"></dv-bisher> </dv-input-container> </div> </div> </fieldset> </div> ";

/***/ }),

/***/ "Xkfc":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("W/h3");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-checklist.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-checklist.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "XrDZ":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("6l5m");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./verifyView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./verifyView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "XyUR":
/***/ (function(module, exports) {

module.exports = " <div class=\"statistik-view\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getStatistikRoles()\"> <h1 class=\"row\"> <span class=\"col-md-10 col-md-offset-1\" data-translate=\"STATISTIK\"> </span> </h1> <div> <form name=\"vm.form\" ng-submit=\"vm.generateStatistik(vm.TSStatistikParameterType.TEST)\" novalidate> <div class=\"row marginBottom20\"> <div class=\"col-sm-3 col-sm-offset-1\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getAdministratorRoles()\"> <div class=\"dv-select-style\"> <select name=\"reportType\" id=\"reportType\" class=\"form-control\" ng-options=\"'TS_REPORTYPE_'+reportType | translate for reportType in vm.getTSReportTypeValues() track by reportType\" ng-model=\"vm.reportTypeDTO.reportType\"> </select> </div> </div> <div class=\"col-xs-3 col-sm-offset-1 statistik-button statistik-no-fields\"> <dv-loading-button type=\"submit\" button-class=\"btn btn-serf\"> <span data-translate=\"GENERIEREN\"></span> </dv-loading-button> </div> </div> <div class=\"row\" ng-if=\"vm.displayAuszahlungsDatum()\"> <div class=\"col-sm-4 col-sm-offset-1\"> <dv-input-container> <label class=\"md-no-float text-capitalize\" data-translate=\"DATUM_AUSZAHLUNG_VON\" for=\"auszahlungsDatumVon\"></label> <dv-datepicker input-id=\"auszahlungsDatumVon\" name=\"auszahlungsDatumVon\" ng-model=\"vm.reportTypeDTO.auszahlungsDatumVon\" ng-required=\"(vm.reportTypeDTO.auszahlungsDatumBis!==undefined && vm.reportTypeDTO.auszahlungsDatumBis !== null)\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" check-future=\"true\"> </dv-datepicker> <dv-error-messages for=\"vm.form.auszahlungsDatumVon\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-4\"> <dv-input-container> <label class=\"md-no-float text-capitalize\" data-translate=\"DATUM_AUSZAHLUNG_BIS\" for=\"auszahlungsDatumBis\"></label> <dv-datepicker input-id=\"auszahlungsDatumBis\" name=\"auszahlungsDatumBis\" ng-model=\"vm.reportTypeDTO.auszahlungsDatumBis\" ng-required=\"(vm.reportTypeDTO.auszahlungsDatumVon!==undefined && vm.reportTypeDTO.auszahlungsDatumVon !== null)\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" check-future=\"false\"> </dv-datepicker> <dv-error-messages for=\"vm.form.auszahlungsDatumBis\"></dv-error-messages> </dv-input-container> </div> </div> <div class=\"row\" ng-if=\"vm.displayEreignisDatum()\"> <div class=\"col-sm-4 col-sm-offset-1\"> <dv-input-container> <label class=\"md-no-float text-capitalize\" data-translate=\"DATUM_EREIGNIS_VON\" for=\"ereignisDatumVon\"></label> <dv-datepicker input-id=\"ereignisDatumVon\" name=\"ereignisDatumVon\" ng-model=\"vm.reportTypeDTO.ereignisDatumVon\" ng-required=\"(vm.reportTypeDTO.ereignisDatumBis!==undefined && vm.reportTypeDTO.ereignisDatumBis !== null)\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" check-future=\"true\"> </dv-datepicker> <dv-error-messages for=\"vm.form.ereignisDatumVon\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-4\"> <dv-input-container> <label class=\"md-no-float text-capitalize\" data-translate=\"DATUM_EREIGNIS_BIS\" for=\"ereignisDatumBis\"></label> <dv-datepicker input-id=\"ereignisDatumBis\" name=\"ereignisDatumBis\" ng-model=\"vm.reportTypeDTO.ereignisDatumBis\" ng-required=\"(vm.reportTypeDTO.ereignisDatumVon!==undefined && vm.reportTypeDTO.ereignisDatumVon !== null)\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" check-future=\"false\"> </dv-datepicker> <dv-error-messages for=\"vm.form.ereignisDatumBis\"></dv-error-messages> </dv-input-container> </div> </div> <div class=\"row\" ng-if=\"vm.displayGesuchsDatum()\"> <div class=\"col-sm-4 col-sm-offset-1\"> <dv-input-container> <label class=\"md-no-float text-capitalize\" data-translate=\"DATUM_GESUCH_VON\" for=\"gesuchDatumVon\"></label> <dv-datepicker input-id=\"datumVon\" name=\"gesuchDatumVon\" ng-model=\"vm.reportTypeDTO.gesuchDatumVon\" ng-required=\"(vm.reportTypeDTO.gesuchDatumBis!==undefined && vm.reportTypeDTO.gesuchDatumBis !== null)\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" check-future=\"true\"> </dv-datepicker> <dv-error-messages for=\"vm.form.gesuchDatumVon\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-4\"> <dv-input-container> <label class=\"md-no-float text-capitalize\" data-translate=\"DATUM_GESUCH_BIS\" for=\"gesuchDatumBis\"></label> <dv-datepicker input-id=\"datumBis\" name=\"gesuchDatumBis\" ng-model=\"vm.reportTypeDTO.gesuchDatumBis\" ng-required=\"(vm.reportTypeDTO.gesuchDatumVon!==undefined && vm.reportTypeDTO.gesuchDatumVon !== null)\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" check-future=\"false\"> </dv-datepicker> <dv-error-messages for=\"vm.form.gesuchDatumBis\"></dv-error-messages> </dv-input-container> </div> </div> </form> </div> <div class=\"row marginTop40\"> <div class=\"col-md-10 col-md-offset-1\"> <h2> <span data-translate=\"Letzte Reports\"></span> {{vm.titleValue}} </h2> <table st-table=\"displayedCollection\" st-safe-src=\"vm.userjobs\" class=\"table table-hover ebegu-table\" id=\"{{vm.tableId}}\" title=\"{{vm.tableTitle}}\"> <thead> <tr> <th data-translate=\"TYP\"></th> <th data-translate=\"PARAMETER\"></th> <th data-translate=\"STATUS\"></th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"row in displayedCollection\" st-select-row=\"row\" st-select-mode=\"single\" role=\"row\" tabindex=\"-1\"> <td> <span ng-if=\"row.params.RT && row.params.RT !== ''\" ng-bind=\"'TS_REPORTYPE_'+row.params.RT | translate\" title=\"{{row.requestURI}}\"></span> </td> <td class=\"w-50\"> <span class=\"mono white-space-pre\" ng-bind=\"vm.getParams(row.params)\"></span> </td> <td ng-bind=\"'BatchJobStatus_' + row.batchJobStatus | translate\"></td> <td class=\"dateientable-td symbol\"> <span ng-if=\"row.execution && row.execution.batchStatus === 'COMPLETED'\" class=\"fa fa-download\" title=\"{{'DOKUMENT_DOWNLOAD' | translate}}\" aria-label=\"{{'DOKUMENT_DOWNLOAD' | translate}}\" style=\"color:#000\" ng-click=\"vm.downloadClicked(row)\"></span> </td> </tr><tr ng-if=\"vm.userjobs.length === 0\"> <td colspan=\"6\" class=\"empty-table\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> </table> </div> </div> </div> ";

/***/ }),

/***/ "Y+TE":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "Y2Uj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSBeitragDTO_1 = __importDefault(__webpack_require__("DO1Y"));
var TSBeitraegeSearchresultDTO = /** @class */ (function () {
    function TSBeitraegeSearchresultDTO() {
        this._schadenfallBeitragDTOs = [];
        this._totalResultSize = 0;
    }
    Object.defineProperty(TSBeitraegeSearchresultDTO.prototype, "schadenfallBeitragDTOs", {
        get: function () {
            return this._schadenfallBeitragDTOs;
        },
        set: function (value) {
            this._schadenfallBeitragDTOs = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBeitraegeSearchresultDTO.prototype, "totalResultSize", {
        get: function () {
            return this._totalResultSize;
        },
        set: function (value) {
            this._totalResultSize = value;
        },
        enumerable: true,
        configurable: true
    });
    TSBeitraegeSearchresultDTO.prototype.parseBeitragDTOs = function (data) {
        var schadenfallBeitragDTO = [];
        if (data && Array.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                schadenfallBeitragDTO[i] = new TSBeitragDTO_1.default().deserialize(data[i]);
            }
        }
        else {
            schadenfallBeitragDTO[0] = new TSBeitragDTO_1.default().deserialize(data);
        }
        return schadenfallBeitragDTO;
    };
    TSBeitraegeSearchresultDTO.prototype.deserialize = function (restObject) {
        this.schadenfallBeitragDTOs = this.parseBeitragDTOs(restObject.schadenfallBeitragDTOs);
        this.totalResultSize = restObject.paginationDTO.totalItemCount;
        return this;
    };
    return TSBeitraegeSearchresultDTO;
}());
exports.default = TSBeitraegeSearchresultDTO;


/***/ }),

/***/ "Y71P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSRefreshEvent_1 = __webpack_require__("va1a");
var TSBeitragStatus_1 = __webpack_require__("RtaT");
var TSBeitragType_1 = __webpack_require__("sOyJ");
var TSBeitragPreFilterDTO_1 = __importDefault(__webpack_require__("/atl"));
var template = __webpack_require__("bsYH");
var ZahlungenListViewComponentConfig = /** @class */ (function () {
    function ZahlungenListViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = ZahlungenListViewController;
        this.controllerAs = 'vm';
        this.bindToController = true;
        this.bindings = {
            besitzer: '<'
        };
    }
    return ZahlungenListViewComponentConfig;
}());
exports.ZahlungenListViewComponentConfig = ZahlungenListViewComponentConfig;
var ZahlungenListViewController = /** @class */ (function () {
    function ZahlungenListViewController($filter, $state, $log, CONSTANTS, $q, beitragRS, $scope, authService, roleUtilService, zahlungsauftragRS, pageNames) {
        var _this = this;
        this.$filter = $filter;
        this.$state = $state;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.$q = $q;
        this.beitragRS = beitragRS;
        this.$scope = $scope;
        this.authService = authService;
        this.roleUtilService = roleUtilService;
        this.zahlungsauftragRS = zahlungsauftragRS;
        this.pageNames = pageNames;
        this.totalResultCount = '-';
        this.tabs = [];
        this.selectedTab = 0;
        this.passBeitragFilterToServer = function (tableFilterState, prefilter) {
            _this.$log.debug('Triggering ServerFiltering with Filter Object', tableFilterState);
            return _this.beitragRS.searchBeitraege(tableFilterState, prefilter).then(function (response) {
                _this.totalResultCount = response.totalResultSize ? response.totalResultSize.toString() : '-';
                _this.zahlungenList = response.schadenfallBeitragDTOs;
                return response;
            });
        };
        this.passZahlungsauftragFilterToServer = function (tableFilterState) {
            _this.$log.debug('Triggering ServerFiltering with Filter Object', tableFilterState);
            return _this.zahlungsauftragRS.searchZahlungsauftraege(tableFilterState).then(function (response) {
                _this.totalResultCount = response.totalResultSize ? response.totalResultSize.toString() : '-';
                _this.zahlungsauftragList = response.zahlungsauftragDTOs;
                return response;
            });
        };
    }
    ZahlungenListViewController.prototype.$onInit = function () {
        this.currentPrincipal = this.authService.getPrincipal();
        this.currentUsername = (this.currentPrincipal !== undefined) ? this.currentPrincipal.email : undefined;
        this.emptyFilter = new TSBeitragPreFilterDTO_1.default(undefined);
        this.initViewModel();
    };
    ZahlungenListViewController.prototype.initViewModel = function () {
        this.tabs.push({
            title: 'NICHT_FREIGEGEBEN',
            prefilter: new TSBeitragPreFilterDTO_1.default(TSBeitragStatus_1.TSBeitragStatus.NICHT_FREIGEGEBEN),
            freigeben: true,
            ausfuehren: false
        });
        this.tabs.push({
            title: 'PENDENT',
            prefilter: new TSBeitragPreFilterDTO_1.default(TSBeitragStatus_1.TSBeitragStatus.PENDENT),
            freigeben: false,
            ausfuehren: true
        });
        this.selectedPrefilter = this.tabs[this.selectedTab].prefilter;
    };
    ZahlungenListViewController.prototype.getZahlungenList = function () {
        return this.zahlungenList;
    };
    ZahlungenListViewController.prototype.selectTab = function (selected) {
        this.selectedPrefilter = this.tabs[selected] ? this.tabs[selected].prefilter : undefined;
        this.selectedTab = selected;
        // trigger refresh of smartTable
        this.$scope.$broadcast(TSRefreshEvent_1.TSRefreshEvent[TSRefreshEvent_1.TSRefreshEvent.REFRESH_ST_TABLE]);
    };
    ZahlungenListViewController.prototype.editFall = function (beitragDTO, event) {
        if (beitragDTO.beitragType === TSBeitragType_1.TSBeitragType.SCHADENFALL) {
            this.$state.go(this.pageNames.SCHADENMELDUNG, { schadenfallId: beitragDTO.schadenfallId });
        }
        else {
            this.$state.go('versicherungsbeitragschaden', { versicherungsbeitragId: beitragDTO.schadenfallId, createNew: false });
        }
    };
    ZahlungenListViewController.prototype.editBeitrag = function (beitragDTO, beitrag, event) {
        if (beitragDTO.beitragType === TSBeitragType_1.TSBeitragType.SCHADENFALL) {
            this.$state.go(this.pageNames.ENTSCHAEDIGUNG, { schadenfallId: beitragDTO.schadenfallId });
        }
        else {
            this.$state.go('versicherungbeitragbeitrag', { versicherungsbeitragId: beitragDTO.schadenfallId });
        }
    };
    ZahlungenListViewController.$inject = ['$filter', '$state', '$log', 'CONSTANTS', '$q', 'BeitragRS', '$scope', 'AuthServiceRS', 'RoleUtilService',
        'ZahlungsauftragRS', 'PAGE_NAMES'];
    return ZahlungenListViewController;
}());
exports.ZahlungenListViewController = ZahlungenListViewController;


/***/ }),

/***/ "YJT7":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("vn5p");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-eigenleistungen.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-eigenleistungen.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "YKbT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/comp-AS.7029e1e114530173f09e504695a49f0b.jpg";

/***/ }),

/***/ "YTLw":
/***/ (function(module, exports) {

module.exports = "<div> <div class=\"modal-header\"> <h3 class=\"modal-title\" ng-bind-html=\"vm.title\"></h3> </div> <div class=\"modal-body\"> <p ng-bind-html=\"vm.text\"></p> </div> <div class=\"modal-footer\"> <button class=\"btn btn-serf\" type=\"button\" ng-click=\"vm.cancel()\" aria-label=\"{{'LABEL_NEIN' | translate}}\" style=\"\"> <span class=\"ng-binding ng-scope\" data-translate=\"LABEL_NEIN\"></span> </button> <button type=\"button\" class=\"btn btn-serf\" ng-click=\"vm.hide()\" aria-label=\"{{'LABEL_JA' | translate}}\"> <span class=\"ng-binding ng-scope\" data-translate=\"LABEL_JA\"></span> </button> </div> </div> ";

/***/ }),

/***/ "Yg+e":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "dvb-error-messages-panel{z-index:100}", ""]);

// exports


/***/ }),

/***/ "Z1HC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSRole_1 = __webpack_require__("MleR");
var TSUser_1 = __importDefault(__webpack_require__("9qK+"));
var TSAuthLoginElement_1 = __importDefault(__webpack_require__("63CK"));
var AuthenticationUtil_1 = __importDefault(__webpack_require__("BH0P"));
var template = __webpack_require__("+agi");
__webpack_require__("jvKN");
var DummyAuthenticationComponentConfig = /** @class */ (function () {
    function DummyAuthenticationComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = DummyAuthenticationListViewController;
        this.controllerAs = 'vm';
    }
    return DummyAuthenticationComponentConfig;
}());
exports.DummyAuthenticationComponentConfig = DummyAuthenticationComponentConfig;
var DummyAuthenticationListViewController = /** @class */ (function () {
    function DummyAuthenticationListViewController($state, authServiceRS, $timeout, applicationPropertyRS, $rootScope) {
        var _this = this;
        this.$state = $state;
        this.authServiceRS = authServiceRS;
        this.$timeout = $timeout;
        this.applicationPropertyRS = applicationPropertyRS;
        this.$rootScope = $rootScope;
        this.usersList = [];
        applicationPropertyRS.isDevMode().then(function (response) {
            _this.devMode = response;
        });
        this.usersList.push(new TSUser_1.default('Markus', 'Hofstetter', 'password10', 'markus.hofstetter@mailbucket.dvbern.ch', [TSRole_1.TSRole.SUPER_ADMIN]));
        this.usersList.push(new TSUser_1.default('Pascal', 'Gatschet', 'password10', 'pascal.gatschet@mailbucket.dvbern.ch', [TSRole_1.TSRole.SUPER_ADMIN]));
        this.usersList.push(new TSUser_1.default('Fritz', 'Fondssuissse', 'password10', 'fritz.fondssuissse@mailbucket.dvbern.ch', [TSRole_1.TSRole.FONDSSUISSE_ADMIN]));
        this.usersList.push(new TSUser_1.default('Frieda', 'Fondssuissse', 'password10', 'frieda.fondssuissse@mailbucket.dvbern.ch', [TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER]));
        this.usersList.push(new TSUser_1.default('Veronique', 'Verwalter', 'password10', 'veronique.verwalter@mailbucket.dvbern.ch', [TSRole_1.TSRole.ANLAUFSTELLE_VERWALTER]));
        this.usersList.push(new TSUser_1.default('Anton', 'Anlaufstelle', 'password10', 'anton.anlaufstelle@mailbucket.dvbern.ch', [TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER]));
        this.usersList.push(new TSUser_1.default('Sarah', 'Schaetzer', 'password10', 'sarah.schaetzer@mailbucket.dvbern.ch', [TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER]));
        this.usersList.push(new TSUser_1.default('Karl', 'Kantonsverwalter', 'password10', 'karl.kanton@mailbucket.dvbern.ch', [TSRole_1.TSRole.KANTON_VERWALTER]));
        this.usersList.push(new TSUser_1.default('Kunigunde', 'Kantonsinspektor', 'password10', 'kunigunde.kantoninspektor@mailbucket.dvbern.ch', [TSRole_1.TSRole.KANTON_INSPEKTOR]));
        this.usersList.push(new TSUser_1.default('Gottfried', 'Gesuchsteller', 'password10', 'gottfried.gesuchsteller@mailbucket.dvbern.ch', [TSRole_1.TSRole.BETROFFENER]));
        this.usersList.push(new TSUser_1.default('Gabi', 'Gesuchsteller', 'password10', 'gabi.gesuchsteller@mailbucket.dvbern.ch', [TSRole_1.TSRole.BETROFFENER]));
        this.superadmin = new TSUser_1.default('Serfuser', 'Superuser', 'password10', 'hallo@dvbern.ch', [TSRole_1.TSRole.SUPER_ADMIN]);
    }
    /**
     * Die Institution wird direkt gegeben. Diese Daten und die Daten der DB muessen uebereinstimmen
     */
    DummyAuthenticationListViewController.prototype.getAnlaufstelle = function () {
    };
    DummyAuthenticationListViewController.prototype.logIn = function (user) {
        var _this = this;
        if (user) {
            var loginCredentials = new TSAuthLoginElement_1.default();
            loginCredentials.password = user.password;
            loginCredentials.username = user.email;
            this.authServiceRS.loginRequest(loginCredentials).then(function (response) {
                if (response && response.roles) {
                    var mostPrivilegedRole = _this.authServiceRS.getHighestRoleOfBenutzer(response.roles);
                    AuthenticationUtil_1.default.navigateToStartPageForRole(mostPrivilegedRole, _this.$state);
                }
            });
        }
    };
    DummyAuthenticationListViewController.$inject = ['$state', 'AuthServiceRS', '$timeout', 'ApplicationPropertyRS', '$rootScope'];
    return DummyAuthenticationListViewController;
}());
exports.DummyAuthenticationListViewController = DummyAuthenticationListViewController;


/***/ }),

/***/ "Z8Dy":
/***/ (function(module, exports) {

module.exports = " <div class=\"dveigenleistungen row\" ng-form=\"eigenleistungForm\"> <div class=\"col-sm-12\"> <div class=\"row\"> <div class=\"col-sm-3 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"LEISTUNGSART\" for=\"{{vm.name}}__eigenleistungArt_ID\"> </label> <select class=\"form-control\" id=\"{{vm.name}}__eigenleistungArt_ID\" name=\"{{vm.name}}__eigenleistungArt\" ng-change=\"vm.changedEigenleistungsart()\" ng-model=\"vm.getModel().eigenleistungDatenFS.eigenleistungArt\" ng-options=\"leistungsart.art as vm.translateEigenleistung(leistungsart.art)\n                            disable when leistungsart.disabled\n                            for leistungsart in vm.selectableLeistungsarten\" ng-required=\"true\"> </select> <dv-bisher for=\"eigenleistungForm[vm.name + '__eigenleistungArt']\" fs=\"vm.getModel().eigenleistungDatenFS\" gs=\"vm.getModel().eigenleistungDatenGS\" prefix=\"vm.getPrefix()\" property=\"eigenleistungArt\"> </dv-bisher> <dv-error-messages for=\"eigenleistungForm[vm.name + '__eigenleistungArt']\"></dv-error-messages> </dv-input-container> </div> </div> <fieldset ng-if=\"vm.getModel().eigenleistungDatenFS.eigenleistungArt\"> <div class=\"row\" ng-if=\"vm.isAndereLeistungArt()\"> <div class=\"col-sm-4 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"EIGENLEISTUNG_DESCRIPTION\" for=\"{{vm.name}}_description_ID\"> </label> <input class=\"form-control\" dv-max-length id=\"{{vm.name}}_description_ID\" name=\"{{vm.name}}_name\" ng-model=\"vm.getModel().eigenleistungDatenFS.description\" required> <dv-error-messages for=\"eigenleistungForm[vm.name + '_description']\"></dv-error-messages> </dv-input-container> </div> </div> <div class=\"row\" ng-if=\"vm.showPersonendaten()\"> <div class=\"col-sm-4 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"NAME\" for=\"{{vm.name}}_name_ID\"> </label> <input class=\"form-control\" dv-max-length id=\"{{vm.name}}_name_ID\" name=\"{{vm.name}}_name\" ng-model=\"vm.getModel().eigenleistungDatenFS.name\" required> <dv-bisher for=\"eigenleistungForm[vm.name + '_name']\" fs=\"vm.getModel().eigenleistungDatenFS\" gs=\"vm.getModel().eigenleistungDatenGS\" property=\"name\"></dv-bisher> <dv-error-messages for=\"eigenleistungForm[vm.name + '_name']\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-4 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"VORNAME\" for=\"{{vm.name}}_vorname_ID\"> </label> <input class=\"form-control\" dv-max-length id=\"{{vm.name}}_vorname_ID\" name=\"{{vm.name}}_vorname\" ng-model=\"vm.getModel().eigenleistungDatenFS.vorname\" required> <dv-bisher for=\"eigenleistungForm[vm.name + '_vorname']\" fs=\"vm.getModel().eigenleistungDatenFS\" gs=\"vm.getModel().eigenleistungDatenGS\" property=\"vorname\"></dv-bisher> <dv-error-messages for=\"eigenleistungForm[vm.name + '_vorname']\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-4\"> <dv-input-container> <label data-translate=\"JAHRGANG\" for=\"{{vm.name}}_jahrgang_ID\"></label> <select class=\"form-control\" id=\"{{vm.name}}_jahrgang_ID\" name=\"{{vm.name}}_jahrgang\" ng-model=\"vm.getModel().eigenleistungDatenFS.jahrgang\" ng-options=\"jahrgang for jahrgang in vm.getJahrgangValues()\" ng-required=\"true\"> <option value=\"\"></option> </select> <dv-error-messages for=\"eigenleistungForm[vm.name + '_jahrgang']\"></dv-error-messages> <dv-bisher for=\"eigenleistungForm[vm.name + '_jahrgang']\" forcestring fs=\"vm.getModel().eigenleistungDatenFS\" gs=\"vm.getModel().eigenleistungDatenGS\" property=\"jahrgang\"></dv-bisher> </dv-input-container> </div> </div> <div class=\"row\" ng-if=\"vm.showKubikmeter()\"> <div class=\"col-sm-12\"> <h3 data-translate=\"KUBIKMETER_ERFASSEN\"></h3> </div> <div class=\"col-sm-3\"> <dv-input-container> <label data-translate=\"KUBIKMETER\" for=\"{{vm.name}}_kubikmeter_ID\"></label> <dv-valueinput allow-negative=\"false\" class=\"input-element\" dv-on-blur=\"vm.addKubikmeter()\" fixed-decimals=\"2\" float=\"true\" input-id=\"{{vm.name}}_kubikmeter_ID\" input-name=\"{{vm.name}}_kubikmeter\" name=\"{{vm.name}}_kubikmeter\" ng-model=\"vm.kubikmeter\" ng-required=\"true\"> </dv-valueinput> </dv-input-container> </div> </div> <div class=\"row\" ng-if=\"vm.showLiter()\"> <div class=\"col-sm-12\"> <h3 data-translate=\"LITER_ERFASSEN\"></h3> </div> <div class=\"col-sm-3\"> <dv-input-container> <label data-translate=\"LITER\" for=\"{{vm.name}}_liter_ID\"></label> <dv-valueinput allow-negative=\"false\" class=\"input-element\" dv-on-blur=\"vm.addLiter()\" fixed-decimals=\"2\" float=\"true\" input-id=\"{{vm.name}}_liter_ID\" input-name=\"{{vm.name}}_liter\" name=\"{{vm.name}}_liter\" ng-model=\"vm.liter\" ng-required=\"true\"> </dv-valueinput> </dv-input-container> </div> </div> <div class=\"row\" ng-show=\"!vm.showKubikmeter() && !vm.showLiter()\"> <div ng-show=\"!vm.isHandarbeitPauschal() && !vm.isMaschinenarbeitPauschal()\"> <div class=\"col-sm-3\"> <dv-input-container> <label data-translate=\"ARBEITSSTUNDEN\" for=\"{{vm.name}}_arbeitsstunden_ID\"></label> <select class=\"form-control\" id=\"{{vm.name}}_arbeitsstunden_ID\" name=\"{{vm.name}}_arbeitsstunden\" ng-model=\"vm.arbeitsstunden\" ng-options=\"item.value as item.label for item in vm.halfHourValues\"></select> <dv-error-messages for=\"eigenleistungForm[vm.name + '_arbeitsstunden']\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-3\" ng-if=\"!vm.isMaschinenarbeitPauschal()\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"DATUM\" for=\"{{vm.name}}_datum_ID\"></label> <dv-datepicker check-future=\"true\" class=\"input-element\" input-id=\"{{vm.name}}_datum_ID\" name=\"{{vm.name}}_datum\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" ng-model=\"vm.datum\"> </dv-datepicker> <dv-error-messages class=\"error\" for=\"eigenleistungForm[vm.name + '_datum']\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-3\" ng-if=\"vm.isAndereLeistungArt()\"> <dv-input-container> <label data-translate=\"STUNDENANSATZ\" for=\"{{vm.name}}_stundenansatz_ID\"></label> <dv-valueinput allow-negative=\"false\" class=\"input-element\" fixed-decimals=\"2\" float=\"true\" input-id=\"{{vm.name}}_stundenansatz_ID\" input-name=\"{{vm.name}}_stundenansatz\" name=\"{{vm.name}}_stundenansatz\" ng-model=\"vm.stundenansatz\" ng-required=\"false\"> </dv-valueinput> </dv-input-container> </div> <div class=\"col-sm-3\"> <button class=\"btn btn-serf-red stundenhinzufuegen\" ng-click=\"vm.addStunden()\" type=\"submit\"> <span class=\"fa fa-clock-o btn-ico\"></span> <span data-translate=\"STUNDEN_HINZUFUEGEN\"></span> </button> </div> </div> </div> <div class=\"table-responsive\" ng-show=\"!vm.showKubikmeter() && !vm.showLiter() && !vm.isHandarbeitPauschal() && !vm.isMaschinenarbeitPauschal()\"> <table class=\"table fixedtable table-hover\" dv-st-table-refresh id=\"eigenleistungStundenDaten\" st-delay=\"20\" st-safe-src=\"vm.getModel().eigenleistungStundenDaten\" st-table=\"displayedCollection\" title=\"eigenleistungStundenDaten\"> <thead> <tr class=\"header-row\"> <th class=\"row-datum\" data-translate=\"DATUM\"></th> <th class=\"row-arbeitsstunden text-right\" data-translate=\"ANZAHL_STUNDEN\"></th> <th class=\"row-betrag text-right\" data-translate=\"BETRAG\"></th> <th class=\"row-actions\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"row in displayedCollection\" st-select-row=\"row\"> <td class=\"ellipsis mono\" ng-bind=\"row.datum | amDateFormat : 'DD.MM.YYYY'\" ng-class=\"{'delete-row' :row.deleted}\" title=\"{{row.datum | amDateFormat : 'DD.MM.YYYY'}}\"></td> <td class=\"ellipsis mono text-right\" ng-bind=\"row.arbeitsstunden | currency :'':1\" ng-class=\"{'delete-row' :row.deleted}\" title=\"{{row.arbeitsstunden}}\"></td> <td class=\"ellipsis mono text-right\" ng-bind=\"row.betrag | currency: 'CHF'\" ng-class=\"{'delete-row' :row.deleted}\" title=\"{{row.betrag | currency: 'CHF'}}\"></td> <td class=\"clearfix\"> <button class=\"btn-link pull-right\" ng-click=\"vm.deleteClicked(row, $event, $index)\" ng-if=\"!row.deleted && !vm.readonly\" type=\"reset\"> <span class=\"fa fa-trash-o\" title=\"{{'DELETE' | translate}}\"></span> </button> </td> </tr> <tr> </tr><tr ng-if=\"displayedCollection === undefined || displayedCollection.length === 0\"> <td class=\"empty-table\" colspan=\"4\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> <tfoot> <tr class=\"tr-highlight\"> <td data-translate=\"TOTAL\"></td> <td class=\"text-right mono\" ng-bind=\"vm.calcTotalELHours()| currency :'':1\"></td> <td class=\"text-right mono\" ng-bind=\"vm.calcTotalELBetrag() |  currency: 'CHF'\"></td> <td></td> </tr> </tfoot> </table> </div> <div ng-if=\"vm.showKubikmeter()\"> <div class=\"row\"> <div class=\"col-sm-3\"> <dv-input-container> <label data-translate=\"BETRAG_HOLZ_CHF\" for=\"beitrag_holz_ID\"></label> <dv-valueinput class=\"input-element\" input-id=\"beitrag_holz_ID\" input-name=\"beitrag\" name=\"beitrag\" ng-disabled=\"true\" ng-model=\"vm.calcTotalELBetrag() |  currency: 'CHF'\" ng-required=\"true\"> </dv-valueinput> </dv-input-container> </div> </div> </div> <div ng-if=\"vm.showLiter()\"> <div class=\"row\"> <div class=\"col-sm-3\"> <dv-input-container> <label data-translate=\"BETRAG_TREIBSTOFF_CHF\" for=\"beitrag_treibstoff_ID\"></label> <dv-valueinput class=\"input-element\" input-id=\"beitrag_treibstoff_ID\" input-name=\"beitrag\" name=\"beitrag\" ng-disabled=\"true\" ng-model=\"vm.calcTotalELBetrag() |  currency: 'CHF'\" ng-required=\"true\"> </dv-valueinput> </dv-input-container> </div> </div> </div> </fieldset> </div> <div ng-if=\"vm.isHandarbeitPauschal() || vm.isMaschinenarbeitPauschal()\"> <div class=\"row col-sm-12\"> <div class=\"col-sm-3\"> <dv-input-container> <label data-translate=\"ANZAHL_STUNDEN_\" for=\"{{vm.name}}_anzahl_stunden_ID\"></label> <dv-valueinput input-id=\"{{vm.name}}_anzahl_stunden_ID\" name=\"{{vm.name}}_anzahl_stunden\" input-name=\"{{vm.name}}_anzahl_stunden\" ng-model=\"vm.getModel().eigenleistungStundenDaten[0].arbeitsstunden\" ng-required=\"true\" float=\"true\" fixed-decimals=\"0\" allow-negative=\"false\" class=\"input-element\"> </dv-valueinput> <dv-error-messages for=\"eigenleistungForm[vm.name + '_anzahl_stunden']\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-3\"> <dv-input-container> <label data-translate=\"STUNDENANSATZ\" for=\"{{vm.name}}_stundenansatz_handarbeit_ID\"></label> <dv-valueinput allow-negative=\"false\" class=\"input-element\" fixed-decimals=\"2\" float=\"true\" input-id=\"{{vm.name}}_stundenansatz_handarbeit_ID\" input-name=\"{{vm.name}}_stundenansatz_handarbeit\" name=\"{{vm.name}}_stundenansatz_handarbeit\" ng-model=\"vm.stundenansatz\" ng-disabled=\"vm.isHandarbeitPauschal()\"> </dv-valueinput> </dv-input-container> </div> <div class=\"col-sm-3\"> <dv-input-container> <label data-translate=\"BETRAG\" for=\"{{vm.name}}_betrag_handarbeit_ID\"></label> <dv-valueinput allow-negative=\"false\" class=\"input-element\" fixed-decimals=\"2\" float=\"true\" input-id=\"{{vm.name}}_betrag_handarbeit_ID\" input-name=\"{{vm.name}}_betrag_handarbeit\" name=\"{{vm.name}}_betrag_handarbeit\" ng-model=\"vm.getBetragHandarbeitPauschal()\" ng-model-options=\"{ getterSetter: true }\" ng-disabled=\"true\"> </dv-valueinput> </dv-input-container> </div> </div> <h2> <span data-translate=\"BILDER_DOKUMENTE\"></span> </h2> <dv-dokumentupload schadenfallid=\"vm.schadenfall.id\" parentid=\"vm.getModel().id\" document-type=\"vm.doctype\" on-doc-removed=\"vm.onDocRemoved(document)\" on-doc-added=\"vm.onDocAdded(document)\" required-docs=\"vm.getRequiredDocs()\" readonly=\"vm.isSchadenFallReadonly()\" begleit-text=\"AUFWAND_EIGENLEISTUNGEN_UPLOAD_TXT\"> </dv-dokumentupload> </div> </div> ";

/***/ }),

/***/ "ZH1W":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "ZJws":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("WPVT");
var DvDialog = /** @class */ (function () {
    /* @ngInject */
    function DvDialog($uibModal) {
        this.$uibModal = $uibModal;
    }
    DvDialog.prototype.showDialog = function (template, controller, params) {
        var options = {
            template: template,
            controller: controller,
            bindToController: false,
            controllerAs: 'vm',
            resolve: {
                title: function () { return params.title; },
                text: function () { return params.text; },
            }
        };
        return this.$uibModal.open(options).result;
    };
    ;
    DvDialog.prototype.showBerechnungsDetail = function (template, controller, params) {
        var options = {
            template: template,
            controller: controller,
            bindToController: false,
            controllerAs: 'vm',
            resolve: {
                einkommensabzug: function () { return params.einkommensabzug; },
                vermoegensabzug: function () { return params.vermoegensabzug; },
                anrechenbarerschaden: function () { return params.anrechenbarerschaden; },
                minimalschaden: function () { return params.minimalschaden; },
                steuerbaresvermoegen: function () { return params.steuerbaresvermoegen; },
                steuerbareseinkommen: function () { return params.steuerbareseinkommen; }
            }
        };
        return this.$uibModal.open(options).result;
    };
    ;
    DvDialog.prototype.showMapDialog = function (template, controller, params) {
        var options = {
            template: template,
            controller: controller,
            bindToController: false,
            controllerAs: 'vm',
            windowClass: 'map-modal-window',
            resolve: {
                lat: function () { return params.lat; },
                lon: function () { return params.lon; },
                reado: function () { return params.readonly; }
            }
        };
        return this.$uibModal.open(options).result;
    };
    ;
    DvDialog.prototype.showBemerkungDialog = function (template, controller, params) {
        var options = {
            template: template,
            controller: controller,
            bindToController: false,
            controllerAs: 'vm',
            windowClass: 'bemerkung-modal-window',
            resolve: {
                text: function () { return params.text; },
                begrundungscodeOptions: function () { return params.begrundungscodeOptions; },
                showBegruendung: function () { return params.showBegruendung; },
                showBemerkung: function () { return params.showBemerkung; },
            }
        };
        return this.$uibModal.open(options).result;
    };
    DvDialog.$inject = ['$uibModal'];
    return DvDialog;
}());
exports.DvDialog = DvDialog;


/***/ }),

/***/ "ZQAi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var TSVersionCheckEvent_1 = __webpack_require__("QJYW");
var template = __webpack_require__("3nXf");
__webpack_require__("JlIQ");
var DVVersionComponentConfig = /** @class */ (function () {
    function DVVersionComponentConfig() {
        this.transclude = false;
        this.bindings = {
            dontShowAllDetails: '=?',
        };
        this.template = template;
        this.controller = DVVersionController;
        this.controllerAs = 'vm';
    }
    return DVVersionComponentConfig;
}());
exports.DVVersionComponentConfig = DVVersionComponentConfig;
var DVVersionController = /** @class */ (function () {
    function DVVersionController($rootScope, httpVersionInterceptor, $q, $window, $log) {
        this.$rootScope = $rootScope;
        this.httpVersionInterceptor = httpVersionInterceptor;
        this.$q = $q;
        this.$window = $window;
        this.$log = $log;
        this.showSingleVersion = true;
    }
    DVVersionController.prototype.$onInit = function () {
        var _this = this;
        this.backendVersion = this.httpVersionInterceptor.getBackendVersion();
        this.frontendVersion = this.httpVersionInterceptor.frontendVersion();
        this.buildTime = this.httpVersionInterceptor.getBuildTime();
        this.currentYear = DateUtil_1.default.currentYear();
        this.clientEnvironment = this.httpVersionInterceptor.getClientEnv();
        this.$rootScope.$on(TSVersionCheckEvent_1.TSVersionCheckEvent[TSVersionCheckEvent_1.TSVersionCheckEvent.VERSION_MISMATCH], function () {
            _this.backendVersion = _this.httpVersionInterceptor.getBackendVersion();
            _this.updateDisplayVersion();
            _this.$window.alert('Der Client hat eine andere Version als der Server. Bitte laden sie die Seite komplett neu');
        });
    };
    DVVersionController.prototype.updateDisplayVersion = function () {
        this.showSingleVersion = this.frontendVersion === this.backendVersion || this.backendVersion === null;
    };
    DVVersionController.$inject = ['$rootScope', 'HttpVersionInterceptor', '$q', '$window', '$log'];
    return DVVersionController;
}());
exports.DVVersionController = DVVersionController;


/***/ }),

/***/ "ZXnB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSFile_1 = __importDefault(__webpack_require__("bB+v"));
var TSDownloadFile = /** @class */ (function (_super) {
    __extends(TSDownloadFile, _super);
    function TSDownloadFile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSDownloadFile.prototype, "accessToken", {
        get: function () {
            return this._accessToken;
        },
        set: function (value) {
            this._accessToken = value;
        },
        enumerable: true,
        configurable: true
    });
    TSDownloadFile.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.accessToken = restObject.accessToken;
        return this;
    };
    TSDownloadFile.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.accessToken = this.accessToken;
        return restObject;
    };
    return TSDownloadFile;
}(TSFile_1.default));
exports.default = TSDownloadFile;


/***/ }),

/***/ "Zc7H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("/jXN");
__webpack_require__("mWUN");
__webpack_require__("Sj5W");
__webpack_require__("5/fh");
__webpack_require__("4iJm");
__webpack_require__("QX3n");
__webpack_require__("XnNc");
__webpack_require__("TMzs");
__webpack_require__("AFu3");
__webpack_require__("fjOH");
__webpack_require__("jbtZ");
__webpack_require__("c7yF");
__webpack_require__("xELU");
__webpack_require__("nKby");
__webpack_require__("hA9B");
__webpack_require__("jUXO");
__webpack_require__("PAPg");
__webpack_require__("RgsW");
__webpack_require__("t/VM");
__webpack_require__("UMfk");
__webpack_require__("/Hyb");
__webpack_require__("BY2X");
__webpack_require__("x+N3");


/***/ }),

/***/ "Zfe6":
/***/ (function(module, exports) {

module.exports = "<input type=\"text\" id=\"{{vm.inputId}}\" ng-model=\"vm.date\" ng-model-options=\"{debounce: 100}\" ng-change=\"vm.updateModelValue()\" placeholder=\"{{vm.placeholder}}\" class=\"form-control dvDatepicker\" ng-blur=\"vm.onBlur()\" ng-required=\"vm.dateRequired\" ng-disabled=\"vm.ngDisabled\"> ";

/***/ }),

/***/ "ZgkC":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */", ""]);

// exports


/***/ }),

/***/ "ZhGZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
__webpack_require__("fjOH");
var core_module_1 = __webpack_require__("u87A");
__webpack_require__("vHmm");
var inspektoratverwaltung_route_1 = __webpack_require__("Pbbb");
var inspektoratverwaltungView_1 = __webpack_require__("P3Wf");
var inspektoratView_1 = __webpack_require__("vui+");
exports.SerfWebInspektoratverwaltung = angular.module('serfWeb.inspektoratverwaltung', [core_module_1.SerfWebCore.name])
    .component('dvInspektoratverwaltungView', new inspektoratverwaltungView_1.InspektoratverwaltungViewComponentConfig())
    .component('dvInspektoratView', new inspektoratView_1.InspektoratViewComponentConfig())
    .run(inspektoratverwaltung_route_1.inspektoratverwaltungRun);
exports.default = exports.SerfWebInspektoratverwaltung;


/***/ }),

/***/ "ZnYd":
/***/ (function(module, exports) {

module.exports = " <div class=\"dv-status-change-history-list\"> <div class=\"row\"> <div class=\"col-sm-12\"> <ul ng-repeat=\"statusChange in vm.sachbearbeiter track by $index\"> <li> <span> {{statusChange.getBesitzerName() | translate}}, </span> <span> {{statusChange.getBesitzer().email}}, </span> <span> {{statusChange.getBesitzer().telefon}} </span> </li> </ul> </div> </div> </div> ";

/***/ }),

/***/ "Zw0f":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("9+RF");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./benutzerListView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./benutzerListView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "a2OR":
/***/ (function(module, exports) {

module.exports = "<div class=\"benutzer-edit-view container\"> <form name=\"vm.form\" novalidate unsaved-warning-form> <div class=\"row marginTop20\"> <div class=\"col-sm-12\"> <h1> <span data-translate=\"BENUTZER_ERSTELLEN\" ng-if=\"vm.benutzer.isNew()\"></span> <span data-translate=\"BENUTZERPROFIL\" ng-if=\"!vm.benutzer.isNew()\"></span> </h1> </div> </div> <div class=\"row marginTop20\" ng-if=\"!vm.benutzer.isNew()\"> <div class=\"col-sm-12\"> <dv-input-container> <div class=\"checkbox\"> <label> <input ng-true-value=\"true\" ng-false-value=\"false\" ng-model=\"vm.benutzer.inaktiv\" type=\"checkbox\" name=\"inactive\" class=\"input-element\"> <span class=\"md-no-float\" data-translate=\"BENUTZER_DEAKTIVIEREN\"></span> <dv-error-messages for=\"vm.form.inactive\"></dv-error-messages> </label> </div> </dv-input-container> </div> </div> <dv-benutzerprofil benutzer=\"vm.benutzer\" hide-password-entry=\"true\" double-email-entry=\"true\"> </dv-benutzerprofil> <div class=\"row\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getAdministratorRoles()\"> <div class=\"col-sm-10\"> <div class=\"row\"> <div class=\"col-sm-6\"> <dv-input-container> <label data-translate=\"MAX_ERFASSUNGS_BETRAG\" for=\"max_beitrag_ID\"></label> <dv-valueinput input-id=\"max_beitrag_ID\" name=\"max_beitrag\" input-name=\"max_beitrag\" ng-model=\"vm.benutzer.maxErfassungsbetrag\" ng-required=\"false\" float=\"false\" allow-negative=\"false\" class=\"input-element\"> </dv-valueinput> <dv-error-messages for=\"vm.form.max_beitrag\"></dv-error-messages> </dv-input-container> </div> </div> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <p data-translate=\"BENUTZERROLLEN_HINWEIS\"></p> </div> </div> <div class=\"row\" ng-if=\"vm.benutzer.roles.length > 0\"> <div class=\"col-sm-2\"> <label>{{'BENUTZERROLLE' | translate}}:</label> </div> <span class=\"col-sm-10\"> <span ng-repeat=\"role in vm.benutzer.roles\">{{vm.translateRole(role) + ($last ? '': ', ')}}</span> </span> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <div class=\"row mainbuttons\"> <div> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.cancelBenutzeredit()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> <div ng-disabled=\"vm.viewReadonly\"> <dv-loading-button type=\"submit\" button-click=\"vm.submit()\" button-class=\"btn btn-serf\"> <span data-translate=\"BENUTZER_SPEICHERN\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </div> </div> </form> </div> ";

/***/ }),

/***/ "aL5m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSAdresse = /** @class */ (function (_super) {
    __extends(TSAdresse, _super);
    function TSAdresse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSAdresse.prototype, "adresse1", {
        get: function () {
            return this._adresse1;
        },
        set: function (value) {
            this._adresse1 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAdresse.prototype, "adresse2", {
        get: function () {
            return this._adresse2;
        },
        set: function (value) {
            this._adresse2 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAdresse.prototype, "adresse3", {
        get: function () {
            return this._adresse3;
        },
        set: function (value) {
            this._adresse3 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAdresse.prototype, "strasse", {
        get: function () {
            return this._strasse;
        },
        set: function (value) {
            this._strasse = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAdresse.prototype, "hausnummer", {
        get: function () {
            return this._hausnummer;
        },
        set: function (value) {
            this._hausnummer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAdresse.prototype, "zusatzzeile", {
        get: function () {
            return this._zusatzzeile;
        },
        set: function (value) {
            this._zusatzzeile = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAdresse.prototype, "plz", {
        get: function () {
            return this._plz;
        },
        set: function (value) {
            this._plz = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAdresse.prototype, "ort", {
        get: function () {
            return this._ort;
        },
        set: function (value) {
            this._ort = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAdresse.prototype, "gemeinde", {
        get: function () {
            return this._gemeinde;
        },
        set: function (value) {
            this._gemeinde = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAdresse.prototype, "kanton", {
        get: function () {
            return this._kanton;
        },
        set: function (value) {
            this._kanton = value;
        },
        enumerable: true,
        configurable: true
    });
    TSAdresse.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.strasse = restObject.strasse;
        this.hausnummer = restObject.hausnummer;
        this.zusatzzeile = restObject.zusatzzeile;
        this.plz = restObject.plz;
        this.ort = restObject.ort;
        this.gemeinde = restObject.gemeinde;
        this.kanton = restObject.kanton;
        this.adresse1 = restObject.adresse1;
        this.adresse2 = restObject.adresse2;
        this.adresse3 = restObject.adresse3;
        return this;
    };
    TSAdresse.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.strasse = this.strasse;
        restObject.hausnummer = this.hausnummer;
        restObject.zusatzzeile = this.zusatzzeile;
        restObject.plz = this.plz;
        restObject.ort = this.ort;
        restObject.gemeinde = this.gemeinde;
        restObject.kanton = this.kanton;
        restObject.adresse1 = this.adresse1;
        restObject.adresse2 = this.adresse2;
        restObject.adresse3 = this.adresse3;
        return restObject;
    };
    return TSAdresse;
}(TSAbstractEntity_1.default));
exports.default = TSAdresse;


/***/ }),

/***/ "aRbG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSRefreshEvent_1 = __webpack_require__("va1a");
var TSBemerkungScope_1 = __webpack_require__("Oh5v");
var TSDokumentType_1 = __webpack_require__("/gTe");
var TSSchadenfallEvent_1 = __webpack_require__("cKO2");
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var TSSchadenfallPreFilterDTO_1 = __importDefault(__webpack_require__("i5TL"));
var template = __webpack_require__("nhwJ");
var SchadenfaelleListViewComponentConfig = /** @class */ (function () {
    function SchadenfaelleListViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = SchadenfaelleListViewController;
        this.controllerAs = 'vm';
        this.bindToController = true;
        this.bindings = {
            verantwortliche: '<',
        };
    }
    return SchadenfaelleListViewComponentConfig;
}());
exports.SchadenfaelleListViewComponentConfig = SchadenfaelleListViewComponentConfig;
var SchadenfaelleListViewController = /** @class */ (function () {
    function SchadenfaelleListViewController($filter, $state, $log, CONSTANTS, $q, schadenfallRS, $scope, authService, roleUtilService, downloadRS, schadenfallModelManager) {
        var _this = this;
        this.$filter = $filter;
        this.$state = $state;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.$q = $q;
        this.schadenfallRS = schadenfallRS;
        this.$scope = $scope;
        this.authService = authService;
        this.roleUtilService = roleUtilService;
        this.downloadRS = downloadRS;
        this.schadenfallModelManager = schadenfallModelManager;
        this.totalResultCount = '-';
        this.tabs = [];
        this.passFilterToServer = function (tableFilterState, prefilter) {
            _this.$log.debug('Triggering ServerFiltering with Filter Object', tableFilterState);
            return _this.schadenfallRS.searchSchadenfaelle(tableFilterState, prefilter).then(function (response) {
                _this.totalResultCount = response.totalResultSize ? response.totalResultSize.toString() : '-';
                _this.schadenfaelleList = response.schadenfallDTOs;
                return response;
            });
        };
    }
    SchadenfaelleListViewController.prototype.$onInit = function () {
        this.currentPrincipal = this.authService.getPrincipal();
        this.currentUsername = (this.currentPrincipal !== undefined) ? this.currentPrincipal.email : undefined;
        this.emptyFilter = new TSSchadenfallPreFilterDTO_1.default(false, undefined, false, undefined);
        this.initViewModel();
    };
    SchadenfaelleListViewController.prototype.initViewModel = function () {
        this.tabs.push({
            title: 'OFFENE',
            prefilter: new TSSchadenfallPreFilterDTO_1.default(false, undefined, true, TSSchadenfallStatus_1.getTSSchadenfallStatusOffen()),
            showVerantwortlicherFilter: true,
            changeVerantwortlicherEnabled: true,
        });
        if (this.authService.isOneOfRoles(this.roleUtilService.getFondssuisseRoles())) {
            this.tabs.push({
                title: 'NICHT_ZUGETEILT',
                prefilter: new TSSchadenfallPreFilterDTO_1.default(true, undefined, true, TSSchadenfallStatus_1.getTSSchadenfallStatusOffen()),
                showVerantwortlicherFilter: true,
                changeVerantwortlicherEnabled: true,
            });
            this.tabs.push({
                title: 'MEINE_SCHADENFAELLE',
                prefilter: new TSSchadenfallPreFilterDTO_1.default(true, this.currentUsername, true, TSSchadenfallStatus_1.getTSSchadenfallStatusOffen()),
                showVerantwortlicherFilter: false,
                changeVerantwortlicherEnabled: true,
            });
        }
        this.tabs.push({
            title: 'ALLE_TITLE',
            prefilter: new TSSchadenfallPreFilterDTO_1.default(false, undefined, true, TSSchadenfallStatus_1.getTSSchadenfallStatusalues()),
            showVerantwortlicherFilter: true,
            changeVerantwortlicherEnabled: false,
        });
        this.selectedPrefilter = this.tabs[0].prefilter;
    };
    SchadenfaelleListViewController.prototype.createTabsForUsers = function () {
        try {
            for (var _a = __values(this.verantwortliche), _b = _a.next(); !_b.done; _b = _a.next()) {
                var verantwortlicher = _b.value;
                // aktueller benutzer kommt nicht in den tabs
                if (verantwortlicher.email !== this.currentUsername) {
                    this.tabs.push({
                        title: verantwortlicher.getFullName(),
                        prefilter: new TSSchadenfallPreFilterDTO_1.default(true, verantwortlicher.email, false, undefined),
                        showVerantwortlicherFilter: true,
                        changeVerantwortlicherEnabled: true,
                    });
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var e_1, _c;
    };
    SchadenfaelleListViewController.prototype.getSchadenfaelleList = function () {
        return this.schadenfaelleList;
    };
    SchadenfaelleListViewController.prototype.editFall = function (schadenfall, event) {
        if (schadenfall) {
            var isCtrlKeyPressed = (event && event.ctrlKey);
            this.openFall(schadenfall.schadenfallId, 'gesucherstellen', isCtrlKeyPressed);
        }
    };
    SchadenfaelleListViewController.prototype.updateVerantwortlicher = function (schadenfallId, verantwortlicher) {
        this.schadenfallRS.updateVerantwortlicher(schadenfallId, verantwortlicher);
    };
    SchadenfaelleListViewController.prototype.selectTab = function (selected) {
        this.selectedPrefilter = this.tabs[selected].prefilter;
        this.selectedTab = selected;
        // trigger refresh of smartTable
        this.$scope.$broadcast(TSRefreshEvent_1.TSRefreshEvent[TSRefreshEvent_1.TSRefreshEvent.REFRESH_ST_TABLE]);
    };
    SchadenfaelleListViewController.prototype.openFall = function (schadenfallId, urlToGoTo, isCtrlKeyPressed) {
        if (schadenfallId) {
            if (isCtrlKeyPressed) {
                var url = this.$state.href(urlToGoTo, { createNew: false, schadenfallId: schadenfallId });
                window.open(url, '_blank');
            }
            else {
                this.$state.go(urlToGoTo, { createNew: false, schadenfallId: schadenfallId });
            }
        }
    };
    SchadenfaelleListViewController.prototype.downloadDeckblatt = function (schadenfall, event) {
        var _this = this;
        this.schadenfallRS.generateDeckblatt(schadenfall.schadenfallId).then(function (result) {
            console.log(result);
            _this.downloadRS.getAccessTokenDocument(schadenfall.schadenfallId, TSDokumentType_1.TSDocumentType.TMP_DECKBLATT, result.id).then(function (result) {
                var win = _this.downloadRS.prepareDownloadWindow();
                _this.downloadRS.startDownload(result.accessToken, result.filename, false, win);
            });
        });
    };
    SchadenfaelleListViewController.prototype.deleteSchadenfall = function (schadenfallId, event) {
        var _this = this;
        this.schadenfallModelManager.handleTransitionForId(schadenfallId, TSBemerkungScope_1.TSBemerkungScope.SCHADENFALL, undefined, '', TSSchadenfallEvent_1.TSSchadenfallEvent.LOESCHEN)
            .then(function (response) {
            _this.$state.reload();
        });
    };
    SchadenfaelleListViewController.$inject = ['$filter', '$state', '$log', 'CONSTANTS', '$q', 'SchadenfallRS', '$scope', 'AuthServiceRS', 'RoleUtilService', 'DownloadRS', 'SchadenfallModelManager'];
    return SchadenfaelleListViewController;
}());
exports.SchadenfaelleListViewController = SchadenfaelleListViewController;


/***/ }),

/***/ "aT8p":
/***/ (function(module, exports) {

module.exports = "<div class=\"dv-checklist row notRequiredForFreigabe\" ng-form=\"vm.checklistForm\"> <div class=\"col-sm-12\"> <li ng-repeat=\"checkpoint in vm.checklistPoints\"> <span class=\"md-no-float\" ng-bind=\"checkpoint | translate\"></span> </li> </div> <div class=\"col-sm-12\"> <dv-input-container> <div class=\"checkbox\"> <label> <input ng-model=\"vm.allChecked\" id=\"allChecked\" type=\"checkbox\" name=\"allChecked\" ng-change=\"vm.checkmarkSet()\" ng-required=\"true\" class=\"input-element notRequiredForFreigabe\"> <span class=\"md-no-float\" data-translate=\"ALLES_KONTOLLIERT\"></span> <dv-error-messages for=\"vm.checklistForm.allChecked\"></dv-error-messages> </label> </div> </dv-input-container> </div> </div> ";

/***/ }),

/***/ "aiEq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
var TSSerfProperty_1 = __importDefault(__webpack_require__("MbEi"));
var SerfPropertyRS = /** @class */ (function () {
    /* @ngInject */
    function SerfPropertyRS($http, REST_API) {
        this.serviceURL = REST_API + 'serf-properties';
        this.http = $http;
    }
    SerfPropertyRS.prototype.getByName = function (name) {
        return this.http.get(this.serviceURL + '/key/' + encodeURIComponent(name), { cache: true }).then(function (response) {
            return response.data;
        });
    };
    SerfPropertyRS.prototype.create = function (name, value) {
        return this.http.post(this.serviceURL + '/' + encodeURIComponent(name), value, {
            headers: {
                'Content-Type': 'text/plain'
            }
        }).then(function (response) {
            return new TSSerfProperty_1.default().deserialize(response.data);
        });
    };
    SerfPropertyRS.prototype.update = function (name, value) {
        return this.http.post(this.serviceURL + '/' + encodeURIComponent(name), value, {
            headers: {
                'Content-Type': 'text/plain'
            }
        }).then(function (response) {
            return new TSSerfProperty_1.default().deserialize(response.data);
        });
    };
    SerfPropertyRS.prototype.remove = function (name) {
        return this.http.delete(this.serviceURL + '/' + encodeURIComponent(name));
    };
    SerfPropertyRS.prototype.getAllSerfProperties = function () {
        return this.http.get(this.serviceURL + '/', { cache: true }).then(function (response) {
            var converter = function (jsonString) {
                return new TSSerfProperty_1.default().deserialize(jsonString);
            };
            if (angular.isArray(response.data)) {
                return response.data.map(converter);
            }
            return [];
        });
    };
    SerfPropertyRS.$inject = ['$http', 'REST_API'];
    return SerfPropertyRS;
}());
exports.SerfPropertyRS = SerfPropertyRS;


/***/ }),

/***/ "aku3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSBankverbindung_1 = __importDefault(__webpack_require__("iMHU"));
var TSVersicherung = /** @class */ (function (_super) {
    __extends(TSVersicherung, _super);
    function TSVersicherung() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSVersicherung.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherung.prototype, "prozentsatz", {
        get: function () {
            return this._prozentsatz;
        },
        set: function (value) {
            this._prozentsatz = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherung.prototype, "bankverbindung", {
        get: function () {
            return this._bankverbindung;
        },
        set: function (value) {
            this._bankverbindung = value;
        },
        enumerable: true,
        configurable: true
    });
    TSVersicherung.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.name = restObject.name;
        this.prozentsatz = restObject.prozentsatz;
        if (restObject.bankverbindung) {
            this.bankverbindung = new TSBankverbindung_1.default().deserialize(restObject.bankverbindung);
        }
        return this;
    };
    TSVersicherung.deserializeArray = function (data) {
        var anlaufstelleArray = [];
        if (data && Array.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                anlaufstelleArray[i] = new TSVersicherung().deserialize(data[i]);
            }
        }
        else {
            anlaufstelleArray[0] = new TSVersicherung().deserialize(data);
        }
        return anlaufstelleArray;
    };
    TSVersicherung.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        /*not needed*/ //wir brauchen nur die id da nicht anpassbar auf client
        return restObject;
    };
    TSVersicherung.getDeserializer = function (versicherung) {
        return new TSVersicherung().deserialize(versicherung);
    };
    return TSVersicherung;
}(TSAbstractEntity_1.default));
exports.default = TSVersicherung;


/***/ }),

/***/ "b+vT":
/***/ (function(module, exports) {

module.exports = " <div class=\"dv-bemerkungen-list\"> <div class=\"row\"> <div class=\"col-sm-12\"> <dv-accordion class=\"mitteilungenList\" allow-multiple-sections=\"true\" selected-tab-ids=\"vm.selectedTabIds\"> <div ng-if=\"vm.allBemerkungen.length === 0\"> <span data-translate=\"MITTEILUNGEN_NOCH_KEINE\"></span> </div> <dv-accordion-tab ng-repeat=\"mitteilung in vm.allBemerkungen track by $index\" ng-value=\"mitteilung.username\" tabid=\"{{mitteilung.id}}\"> <tab-title> <div class=\"message-header\"> <div> <span ng-bind=\"mitteilung.getBesitzerName() | translate\"></span><span>, </span> <span ng-bind=\"mitteilung.timestampErstellt | amDateFormat : 'DD.MM.YYYY / HH:mm'\"></span> <span ng-if=\"mitteilung.sichtbarkeit && !vm.isInStatusALLE(mitteilung.sichtbarkeit)\" class=\"fa fa-lock intern\"></span> <span ng-if=\"mitteilung.sichtbarkeit && vm.isInStatusALLE(mitteilung.sichtbarkeit)\" class=\"fa fa-unlock-alt intern\"></span> <span>{{mitteilung.sichtbarkeit | translate}}</span> </div> <button ng-if=\"vm.isMine(mitteilung) && !vm.readonly\" ng-click=\"vm.editBemerkung(mitteilung, $event); $event.stopPropagation();\" class=\"btn-link button-edit\"> <span class=\"fa fa-pencil\" title=\"{{'EDIT' | translate}}\"></span> </button> <button ng-if=\"vm.isMine(mitteilung) && vm.isDeleteAllowed(mitteilung) && !vm.readonly\" ng-click=\"vm.deleteBemerkung(mitteilung, $event); $event.stopPropagation();\" class=\"btn-link button-delete\"> <span class=\"fa fa-trash-o\" title=\"{{'DELETE' | translate}}\"></span> </button> </div> <div class=\"arrow\"> <i class=\"fa fa-angle-down\" title=\"open/close\"></i> </div> </tab-title> <tab-body> <div class=\"message\"> <div ng-if=\"mitteilung.getPreStatus() && mitteilung.getPostStatus()\"> <span class=\"message-body-bold\">{{'STATUSUEBERGANG_VON' | translate}}</span> <span class=\"message-body-bold\">&quot;{{mitteilung.getPreStatus() | translate}}&quot;</span> <span class=\"message-body-bold\">{{'NACH' | translate}}</span> <span class=\"message-body-bold\">&quot;{{mitteilung.getPostStatus() | translate}}&quot;</span> </div> <div class=\"begruendung\" ng-if=\"mitteilung.getBegruendung()\"> <span class=\"message-body-bold\">{{'BEGRUENDUNG' | translate}}:</span> <span class=\"formatted\" ng-bind=\"mitteilung.getBegruendung() | translate\"></span> </div> <div ng-if=\"!mitteilung.editMode\"> <span class=\"message-body-text\" ng-bind=\"mitteilung.bemerkung | translate\"></span> </div> <div ng-if=\"mitteilung.editMode\"> <textarea name=\"editBemerkung\" class=\"form-control input-element\" rows=\"8\" ng-model=\"mitteilung.bemerkung\" maxlength=\"4000\">\n                                </textarea> <div dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getAllRolesButGesuchsteller()\" dv-show-expression=\"vm.displayScopeForType(mitteilung)\"> <dv-input-container> <div class=\"radio-inline\" ng-repeat=\"sichtbarkeit in vm.getTSBemerkungSichtbarkeitValues()\"> <label ng-if=\"vm.isSichtbarkeitVisible(sichtbarkeit)\"> <input aria-label=\"{{sichtbarkeit}}\" ng-model=\"mitteilung.sichtbarkeit\" ng-value=\"sichtbarkeit\" type=\"radio\" name=\"{{mitteilung.id}}\" ng-required=\"true\" class=\"input-element\"> <span>{{sichtbarkeit | translate}}</span> <dv-error-messages ng-show=\"$last\" for=\"vm.form.sichtbarkeit\"></dv-error-messages> </label> </div> </dv-input-container> </div> <div class=\"marginTop20\"> <dv-loading-button type=\"submit\" button-click=\"vm.saveBemerkung(mitteilung)\" button-class=\"btn btn-serf-red\"> <span data-translate=\"BEMERKUNG_UPDATE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </div> </tab-body> </dv-accordion-tab> </dv-accordion> </div> </div> </div> ";

/***/ }),

/***/ "b2pk":
/***/ (function(module, exports) {

module.exports = "<div class=\"dv-schaden\" ng-form=\"vm.formschaden\"> <fieldset ng-disabled=\"vm.readonly\"> <div class=\"row\"> <div class=\"col-sm-4\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"DATUM_STICHTAG\" for=\"schadendatum\"></label> <dv-datepicker input-id=\"schadendatum\" name=\"schadendatum\" ng-model=\"vm.getModel().schadenDatenFS.schadendatum\" ng-required=\"true\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" check-future=\"true\"> </dv-datepicker> <dv-error-messages for=\"vm.formschaden.schadendatum\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS\" fs=\"vm.getModel().schadenDatenFS\" for=\"vm.formschaden.schadendatum\" property=\"schadendatum\"></dv-bisher> </dv-input-container> </div> <div class=\"col-sm-4\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"ART_DES_SCHADENDS\" for=\"schadenArt\"></label> <select name=\"schadenArt\" id=\"schadenArt\" ng-model=\"vm.getModel().schadenDatenFS.schadenArt\" class=\"form-control\" ng-options=\"vm.translateSchadenArt(art) for art in vm.getTSSchadenArtValues() \" ng-required=\"true\"> </select> <dv-error-messages for=\"vm.formschaden.schadenArt\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS\" fs=\"vm.getModel().schadenDatenFS\" for=\"vm.formschaden.schadenArt\" property=\"schadenArt\" prefix=\"vm.getSchadenArtPrefix()\"></dv-bisher> </dv-input-container> </div> <dv-string-input ng-if=\"vm.showAndere()\" model=\"vm.getModel().schadenDatenFS.schadenArtAndere\" name=\"schadenArtAndere\" label=\"ART_DES_SCHADENDS_ANDERE\" clazz=\"col-sm-4\" bisher-fs=\"vm.getModel().schadenDatenFS\" bisher-gs=\"vm.getModel().schadenDatenGS\" bisher-property=\"schadenArtAndere\"> </dv-string-input> </div> </fieldset> <div class=\"row\"> <div class=\"col-sm-6\"> <dv-geoadmin-search formschaden=\"vm.formschaden\" readonly=\"vm.readonly\" schaden=\"vm.getModel()\"></dv-geoadmin-search> </div> <div class=\"col-sm-4\"> <dv-input-container> <label data-translate=\"KOORDINATEN\"></label> <input name=\"mapLatitude\" type=\"hidden\" ng-model=\"vm.getModel().schadenDatenFS.mapLatitude\" ng-required=\"true\"/> <div class=\"form-control noselect mono map-control\" ng-class=\"{'ng-invalid' : vm.formschaden.mapLatitude.$invalid}\"> <button type=\"button\" ng-click=\"vm.addPosition()\" class=\"btn btn-serf map-button\"> <span class=\"fa fa-map-marker\"></span> </button> <div class=\"map-button-div\"> <span class=\"lat-long\">{{vm.getModel() .schadenDatenFS.coordinatesAsLV95String}}</span> </div> </div> <dv-error-messages for=\"vm.formschaden.mapLatitude\" required-text=\"ERROR_COORDINATES\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS\" fs=\"vm.getModel().schadenDatenFS\" for=\"vm.formschaden.mapLatitude\" property=\"coordinatesAsLV95String\"></dv-bisher> </dv-input-container> </div> </div> <fieldset ng-disabled=\"vm.readonly\"> <div class=\"row\"> <dv-string-input model=\"vm.getModel().schadenDatenFS.parzellennummer\" name=\"parzellennummer\" label=\"PARZELLENNUMMER\" clazz=\"col-sm-4\" bisher-fs=\"vm.getModel().schadenDatenFS\" bisher-gs=\"vm.getModel().schadenDatenGS\" bisher-property=\"parzellennummer\" ng-required=\"false\"> </dv-string-input> <div class=\"col-sm-4\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"SCHADEND_OBJEKT\" for=\"schadenObjekt\"></label> <select name=\"schadenObjekt\" id=\"schadenObjekt\" ng-model=\"vm.getModel().schadenDatenFS.schadenObjekt\" class=\"form-control\" ng-options=\"(obj| translate) for obj in vm.getTSSchadenObjektValues() \" ng-required=\"true\"> </select> <dv-error-messages for=\"vm.formschaden.schadenObjekt\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS\" fs=\"vm.getModel().schadenDatenFS\" for=\"vm.formschaden.schadenObjekt\" property=\"schadenObjekt\"></dv-bisher> </dv-input-container> </div> <div class=\"col-sm-12\"> <div class=\"row\"> <div class=\"col-sm-12\" ng-if=\"vm.showForSchadenObjekt('versicherung')\"> <div class=\"row\"> <div class=\"col-sm-6\"> <span data-translate=\"VERSICHERUNG_VORHANDEN\"></span> <dv-input-container> <div class=\"radio-inline\"> <label> <input type=\"radio\" ng-value=\"true\" name=\"versicherungVorhandenja\" ng-model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.versicherungVorhanden\" ng-required=\"true\"> <span data-translate=\"LABEL_JA\"></span> </label> </div> <div class=\"radio-inline\"> <label> <input type=\"radio\" name=\"versicherungVorhanden\" ng-value=\"false\" ng-model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.versicherungVorhanden\" ng-required=\"true\"> <span data-translate=\"LABEL_NEIN\"></span> </label> </div> <dv-error-messages for=\"vm.formschaden.versicherungVorhandenja\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS.schadenObjektDaten\" fs=\"vm.getModel().schadenDatenFS.schadenObjektDaten\" for=\"vm.formschaden.versicherungVorhandenja\" property=\"versicherungVorhanden\"></dv-bisher> </dv-input-container> </div> <dv-string-input ng-if=\"vm.showForSchadenObjekt('versicherung') && vm.getModel().schadenDatenFS.schadenObjektDaten.versicherungVorhanden\" model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.versicherungArt\" name=\"versicherungArt\" label=\"VERSICHERUNG_ART\" clazz=\"col-sm-4\" bisher-fs=\"vm.getModel().schadenDatenFS.schadenObjektDaten\" bisher-gs=\"vm.getModel().schadenDatenGS.schadenObjektDaten\" bisher-property=\"versicherungArt\" ng-required=\"true\"> </dv-string-input> </div> </div> <div class=\"col-sm-12\" ng-if=\"vm.showForSchadenObjekt('versicherung') && vm.getModel().schadenDatenFS.schadenObjektDaten.versicherungVorhanden\"> <div class=\"row\"> <div class=\"col-sm-12\"> <span data-translate=\"VERSICHERUNG_GEMELDET\"></span> </div> <div class=\"col-sm-12\"> <dv-input-container> <div class=\"radio-inline\"> <label> <input type=\"radio\" ng-value=\"true\" name=\"versicherungGemeldetja\" ng-model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.versicherungGemeldet\" ng-required=\"true\"> <span data-translate=\"LABEL_JA\"></span> </label> </div> <div class=\"radio-inline\"> <label> <input type=\"radio\" name=\"versicherungGemeldet\" ng-value=\"false\" ng-model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.versicherungGemeldet\" ng-required=\"true\"> <span data-translate=\"LABEL_NEIN\"></span> </label> </div> <dv-error-messages for=\"vm.formschaden.versicherungGemeldetja\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS.schadenObjektDaten\" fs=\"vm.getModel().schadenDatenFS.schadenObjektDaten\" for=\"vm.formschaden.versicherungGemeldetja\" property=\"versicherungGemeldet\"></dv-bisher> </dv-input-container> </div> </div> </div> <div class=\"col-sm-4\" ng-if=\"vm.showForSchadenObjekt('kulturart')\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"KULTURART\" for=\"kulturart\"></label> <select name=\"kulturart\" id=\"kulturart\" ng-model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.kulturart\" class=\"form-control\" ng-options=\"vm.translateKulturart(art) for art in vm.getTSKulturartValues() \" ng-required=\"true\"> </select> <dv-error-messages for=\"vm.formschaden.kulturart\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS.schadenObjektDaten\" fs=\"vm.getModel().schadenDatenFS.schadenObjektDaten\" for=\"vm.formschaden.kulturart\" property=\"kulturart\"></dv-bisher> </dv-input-container> </div> <div class=\"col-sm-4\" ng-if=\"vm.showForSchadenObjekt('flaecheAre')\"> <dv-input-container> <label data-translate=\"FLAECHE_ARE\" for=\"flaecheAre\"></label> <dv-valueinput input-id=\"flaecheAre\" name=\"flaecheAre\" input-name=\"flaecheAre\" ng-model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.flaecheAre\" allow-negative=\"false\" ng-required=\"!vm.isWald()\" dv-on-blur=\"vm.onBlur()\"> </dv-valueinput> <dv-error-messages for=\"vm.formschaden.flaecheAre\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS.schadenObjektDaten\" fs=\"vm.getModel().schadenDatenFS.schadenObjektDaten\" property=\"flaecheAre\" for=\"vm.formschaden.flaecheAre\" decimal=\"0\"> </dv-bisher> </dv-input-container> </div> <div class=\"col-sm-4\" ng-if=\"vm.showForSchadenObjekt('holzMenge')\"> <dv-input-container> <label data-translate=\"HOLZ_MENGE\" for=\"flaecheAre\"></label> <dv-valueinput input-id=\"holzMenge\" name=\"holzMenge\" input-name=\"holzMenge\" ng-model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.holzMenge\" allow-negative=\"false\" ng-required=\"!vm.isWald()\" dv-on-blur=\"vm.onBlur()\"> </dv-valueinput> <dv-error-messages for=\"vm.formschaden.holzMenge\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS.schadenObjektDaten\" fs=\"vm.getModel().schadenDatenFS.schadenObjektDaten\" property=\"holzMenge\" for=\"vm.formschaden.holzMenge\" decimal=\"0\"> </dv-bisher> </dv-input-container> </div> <div class=\"col-sm-8 walderror\" ng-if=\"vm.isWald()\"> <input type=\"hidden\" name=\"waldvalidation\" ng-model=\"vm.wald\"/> <div title=\"{{'ERROR_WALD' | translate}}\" ng-messages=\"vm.formschaden.waldvalidation.$error\" ng-show=\"vm.parentForm.$submitted\" class=\"dv-alert-box dv-alert-box--error dv-alert-box--input-alert\"> <div class=\"dv-alert-box__message\"> <span ng-message=\"wald\" role=\"alert\" data-translate=\"ERROR_WALD\"></span> </div> </div> </div> <div class=\"col-sm-4\" ng-if=\"vm.showForSchadenObjekt('anzahl')\"> <dv-input-container> <label data-translate=\"ANZAHL\" for=\"anzahl\"></label> <dv-valueinput input-id=\"anzahl\" name=\"anzahl\" input-name=\"anzahl\" ng-model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.anzahl\" allow-negative=\"false\" ng-required=\"true\"> </dv-valueinput> <dv-error-messages for=\"vm.formschaden.anzahl\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS.schadenObjektDaten\" fs=\"vm.getModel().schadenDatenFS.schadenObjektDaten\" property=\"anzahl\" for=\"vm.formschaden.anzahl\" decimal=\"0\"> </dv-bisher> </dv-input-container> </div> <dv-string-input ng-if=\"vm.showForSchadenObjekt('sorte')\" model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.sorte\" name=\"sorte\" label=\"SORTE\" clazz=\"col-sm-8\" bisher-fs=\"vm.getModel().schadenDatenFS.schadenObjektDaten\" bisher-gs=\"vm.getModel().schadenDatenGS.schadenObjektDaten\" bisher-property=\"sorte\"> </dv-string-input> <div class=\"col-sm-4\" ng-if=\"vm.showForSchadenObjekt('laenge')\"> <dv-input-container> <label data-translate=\"LAENGE\" for=\"laenge\"></label> <dv-valueinput input-id=\"laenge\" name=\"laenge\" input-name=\"laenge\" ng-model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.laenge\" allow-negative=\"false\" float=\"true\" fixed-decimals=\"2\" ng-required=\"true\"> </dv-valueinput> <dv-error-messages for=\"vm.formschaden.laenge\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS.schadenObjektDaten\" fs=\"vm.getModel().schadenDatenFS.schadenObjektDaten\" property=\"laenge\" for=\"vm.formschaden.laenge\" decimal=\"2\"> </dv-bisher> </dv-input-container> </div> <div class=\"col-sm-4\" ng-if=\"vm.showForSchadenObjekt('breite')\"> <dv-input-container> <label data-translate=\"BREITE\" for=\"breite\"></label> <dv-valueinput input-id=\"breite\" name=\"breite\" input-name=\"breite\" ng-model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.breite\" allow-negative=\"false\" float=\"true\" fixed-decimals=\"2\" ng-required=\"true\"> </dv-valueinput> <dv-error-messages for=\"vm.formschaden.breite\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS.schadenObjektDaten\" fs=\"vm.getModel().schadenDatenFS.schadenObjektDaten\" property=\"breite\" for=\"vm.formschaden.breite\" decimal=\"2\"> </dv-bisher> </dv-input-container> </div> <div class=\"col-sm-4\" ng-if=\"vm.showForSchadenObjekt('hoehe')\"> <dv-input-container> <label data-translate=\"HOEHE\" for=\"hoehe\"></label> <dv-valueinput input-id=\"hoehe\" name=\"hoehe\" input-name=\"hoehe\" ng-model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.hoehe\" allow-negative=\"false\" float=\"true\" fixed-decimals=\"2\" ng-required=\"true\"> </dv-valueinput> <dv-error-messages for=\"vm.formschaden.hoehe\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS.schadenObjektDaten\" fs=\"vm.getModel().schadenDatenFS.schadenObjektDaten\" property=\"hoehe\" for=\"vm.formschaden.hoehe\" decimal=\"2\"> </dv-bisher> </dv-input-container> </div> <div class=\"col-sm-4\" ng-if=\"vm.showForSchadenObjekt('alter')\"> <dv-input-container> <label data-translate=\"ALTER\" for=\"alter\"></label> <dv-valueinput input-id=\"alter\" name=\"alter\" input-name=\"alter\" ng-model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.alter\" allow-negative=\"false\" ng-required=\"true\"> </dv-valueinput> <dv-error-messages for=\"vm.formschaden.alter\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS.schadenObjektDaten\" fs=\"vm.getModel().schadenDatenFS.schadenObjektDaten\" property=\"alter\" for=\"vm.formschaden.alter\" decimal=\"0\"> </dv-bisher> </dv-input-container> </div> <div class=\"col-sm-4\" ng-if=\"vm.showForSchadenObjekt('letzteInstandstellung')\"> <dv-input-container> <label data-translate=\"LETZTEINSTANDSTELLUNG\" for=\"letzteInstandstellung\"></label> <input name=\"letzteInstandstellung\" id=\"letzteInstandstellung\" ng-model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.letzteInstandstellung\" class=\"form-control\" dv-max-length min=\"1900\" max=\"{{vm.currentYear}}\" type=\"number\" ng-required=\"false\"/> <dv-error-messages for=\"vm.formschaden.letzteInstandstellung\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS.schadenObjektDaten\" fs=\"vm.getModel().schadenDatenFS.schadenObjektDaten\" property=\"letzteInstandstellung\" for=\"vm.formschaden.letzteInstandstellung\" decimal=\"0\"> </dv-bisher> </dv-input-container> </div> <dv-string-input ng-if=\"vm.showForSchadenObjekt('bauart')\" model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.bauart\" name=\"bauart\" label=\"BAUART\" clazz=\"col-sm-8\" bisher-fs=\"vm.getModel().schadenDatenFS.schadenObjektDaten\" bisher-gs=\"vm.getModel().schadenDatenGS.schadenObjektDaten\" bisher-property=\"bauart\"> </dv-string-input> <dv-string-input ng-if=\"vm.showForSchadenObjekt('art')\" model=\"vm.getModel().schadenDatenFS.schadenObjektDaten.art\" name=\"art\" label=\"ART\" clazz=\"col-sm-8\" bisher-fs=\"vm.getModel().schadenDatenFS.schadenObjektDaten\" bisher-gs=\"vm.getModel().schadenDatenGS.schadenObjektDaten\" bisher-property=\"art\"> </dv-string-input> </div> </div> <div class=\"col-sm-9\"> <dv-input-container class=\"kommentar-feld\"> <label class=\"md-no-float\" for=\"beschrieb\" data-translate=\"BESCHRIEB\"></label> <textarea name=\"beschrieb\" class=\"form-control input-element\" rows=\"6\" id=\"beschrieb\" ng-model=\"vm.getModel().schadenDatenFS.beschrieb\" ng-required=\"true\" maxlength=\"4000\">\n                    </textarea> <dv-error-messages for=\"vm.formschaden.beschrieb\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS\" fs=\"vm.getModel().schadenDatenFS\" property=\"beschrieb\" for=\"vm.formschaden.beschrieb\" textarea> </dv-bisher> </dv-input-container> </div> <div class=\"col-sm-4\" ng-if=\"vm.showGeschaetztekosten\"> <dv-input-container> <label data-translate=\"GESCHAETZTE_KOSTEN\" for=\"geschaetzteKosten\"></label> <dv-valueinput input-id=\"geschaetzteKosten\" name=\"geschaetzteKosten\" input-name=\"geschaetzteKosten\" ng-model=\"vm.getModel().schadenDatenFS.geschaetzteKosten\" ng-required=\"false\" allow-negative=\"false\"> </dv-valueinput> <dv-error-messages for=\"vm.formschaden.geschaetzteKosten\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().schadenDatenGS\" fs=\"vm.getModel().schadenDatenFS\" property=\"geschaetzteKosten\" for=\"vm.formschaden.geschaetzteKosten\" decimal=\"0\"> </dv-bisher> </dv-input-container> </div> <div class=\"col-sm-12 row\"> <div class=\"col-sm-12\"> <span data-translate=\"OFFERTE\"></span> </div> <div class=\"col-sm-12\"> <dv-input-container> <div class=\"radio-inline\"> <label> <input type=\"radio\" ng-value=\"true\" name=\"offerteja\" ng-model=\"vm.getModel().schadenDatenFS.offerte\" ng-required=\"true\"> <span data-translate=\"LABEL_JA\"> </span> </label> </div> <div class=\"radio-inline\"> <label> <input type=\"radio\" name=\"offerte\" ng-value=\"false\" ng-model=\"vm.getModel().schadenDatenFS.offerte\" ng-required=\"true\"> <span data-translate=\"LABEL_NEIN\"></span> </label> </div> <dv-error-messages for=\"vm.formschaden.offerte\"></dv-error-messages> </dv-input-container> </div> </div> <div class=\"col-sm-12 row\"> <div class=\"col-sm-12\"> <span data-translate=\"ARBEITEN\"></span> </div> <div class=\"col-sm-12\"> <dv-input-container> <div class=\"radio-inline\"> <label> <input type=\"radio\" ng-value=\"true\" name=\"arbeitenja\" ng-model=\"vm.getModel().schadenDatenFS.arbeiten\" ng-required=\"true\"> <span data-translate=\"LABEL_JA\"></span> </label> </div> <div class=\"radio-inline\"> <label> <input type=\"radio\" name=\"arbeiten\" ng-value=\"false\" ng-model=\"vm.getModel().schadenDatenFS.arbeiten\" ng-required=\"true\"> <span data-translate=\"LABEL_NEIN\"></span> </label> </div> <dv-error-messages for=\"vm.formschaden.arbeiten\"></dv-error-messages> </dv-input-container> </div> </div> </div> </fieldset> </div> ";

/***/ }),

/***/ "bB+v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSFile = /** @class */ (function (_super) {
    __extends(TSFile, _super);
    function TSFile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSFile.prototype, "filename", {
        get: function () {
            return this._filename;
        },
        set: function (value) {
            this._filename = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFile.prototype, "filesize", {
        get: function () {
            return this._filesize;
        },
        set: function (value) {
            this._filesize = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFile.prototype, "filetype", {
        get: function () {
            return this._filetype;
        },
        set: function (value) {
            this._filetype = value;
        },
        enumerable: true,
        configurable: true
    });
    TSFile.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.filename = restObject.filename;
        this.filesize = restObject.filesize;
        this.filetype = restObject.filetype;
        return this;
    };
    TSFile.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.filename = this.filename;
        restObject.filesize = this.filesize;
        restObject.filetype = this.filetype;
        return restObject;
    };
    return TSFile;
}(TSAbstractEntity_1.default));
exports.default = TSFile;


/***/ }),

/***/ "bCl4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSVersicherungsbeitragStatus_1 = __webpack_require__("jJP+");
__webpack_require__("nNMk");
var template = __webpack_require__("29W2");
var DvVersicherungNavigationComponentConfig = /** @class */ (function () {
    function DvVersicherungNavigationComponentConfig() {
        this.transclude = true;
        this.bindings = {
            versBeitragId: '@',
            title: '@?',
            status: '@',
            sticky: '<'
        };
        this.template = template;
        this.controller = DvVersicherungNavigationController;
        this.controllerAs = 'vm';
    }
    return DvVersicherungNavigationComponentConfig;
}());
exports.DvVersicherungNavigationComponentConfig = DvVersicherungNavigationComponentConfig;
var DvVersicherungNavigationController = /** @class */ (function () {
    function DvVersicherungNavigationController() {
    }
    DvVersicherungNavigationController.prototype.$onInit = function () {
    };
    DvVersicherungNavigationController.prototype.isInBearbeitung = function () {
        return this.status !== TSVersicherungsbeitragStatus_1.TSVersicherungsbeitragStatus.NEU;
    };
    DvVersicherungNavigationController.$inject = [];
    return DvVersicherungNavigationController;
}());
exports.DvVersicherungNavigationController = DvVersicherungNavigationController;


/***/ }),

/***/ "bKPl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAuthEvent_1 = __webpack_require__("L0QB");
var AuthenticationUtil_1 = __importDefault(__webpack_require__("BH0P"));
var template = __webpack_require__("vl73");
__webpack_require__("mEth");
var StartComponentConfig = /** @class */ (function () {
    function StartComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = StartViewController;
        this.controllerAs = 'vm';
    }
    return StartComponentConfig;
}());
exports.StartComponentConfig = StartComponentConfig;
var StartViewController = /** @class */ (function () {
    function StartViewController($state, $rootScope, authService) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.authService = authService;
    }
    StartViewController.prototype.$onInit = function () {
        var user = this.authService.getPrincipal();
        if (user) { // wenn logged in
            if (user.roles !== undefined) {
                var mostPrivilegedRole = this.authService.getHighestRoleOfBenutzer(user.roles);
                AuthenticationUtil_1.default.navigateToStartPageForRole(mostPrivilegedRole, this.$state);
            }
            else {
                console.warn('User ' + user + ' has no role ');
                this.$rootScope.$broadcast(TSAuthEvent_1.TSAuthEvent[TSAuthEvent_1.TSAuthEvent.NOT_AUTHENTICATED], 'no role');
            }
        }
        else {
            //wenn wir noch nicht eingeloggt sind werden wir das event welches das login prozedere anstoesst
            this.$rootScope.$broadcast(TSAuthEvent_1.TSAuthEvent[TSAuthEvent_1.TSAuthEvent.NOT_AUTHENTICATED], 'not logged in on startpage');
        }
    };
    StartViewController.$inject = ['$state', '$rootScope', 'AuthServiceRS'];
    return StartViewController;
}());
exports.StartViewController = StartViewController;


/***/ }),

/***/ "bOI/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TestFaelleRS = /** @class */ (function () {
    /* @ngInject */
    function TestFaelleRS($http, REST_API) {
        this.serviceURL = REST_API + 'testfaelle';
        this.http = $http;
    }
    TestFaelleRS.prototype.getServiceName = function () {
        return 'TestFaelleRS';
    };
    TestFaelleRS.prototype.createTestFall = function (testFall, tsSchadenfallStatus, anlaufstelleId, anzahl, besitzerId) {
        return this.http.get(this.serviceURL + '/testfall/' + encodeURIComponent(testFall) + '/'
            + tsSchadenfallStatus + '/' + anzahl + '/' + encodeURIComponent(anlaufstelleId) + '/' + encodeURIComponent(besitzerId));
    };
    TestFaelleRS.prototype.createTestFallVersicherungsbeitrag = function (testVersBeitragStatus, anzahl) {
        return this.http.get(this.serviceURL + '/testfall/versicherungsbeitrag/'
            + testVersBeitragStatus + '/' + anzahl);
    };
    TestFaelleRS.prototype.sendTestMail = function (schadenfallNummer, mail) {
        return this.http.get(this.serviceURL + '/testmail/' + encodeURIComponent(mail) + '/' + schadenfallNummer);
    };
    TestFaelleRS.$inject = ['$http', 'REST_API'];
    return TestFaelleRS;
}());
exports.TestFaelleRS = TestFaelleRS;


/***/ }),

/***/ "baAg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSKantonCode_1 = __webpack_require__("vEoF");
var TSRole_1 = __webpack_require__("MleR");
var template = __webpack_require__("1mB+");
__webpack_require__("W4Ch");
var DVInspektoratListComponentConfig = /** @class */ (function () {
    function DVInspektoratListComponentConfig() {
        this.transclude = false;
        this.bindings = {
            inspektorat: '=',
            itemsByPage: '<',
            onEdit: '&',
        };
        this.template = template;
        this.controller = DVInspektoratListController;
        this.controllerAs = 'vm';
    }
    return DVInspektoratListComponentConfig;
}());
exports.DVInspektoratListComponentConfig = DVInspektoratListComponentConfig;
var DVInspektoratListController = /** @class */ (function () {
    /* @ngInject */
    function DVInspektoratListController($filter, $log, CONSTANTS, $scope, roleUtilService, $window, $translate, applicationPropertyRS) {
        this.$filter = $filter;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.$scope = $scope;
        this.roleUtilService = roleUtilService;
        this.$window = $window;
        this.$translate = $translate;
        this.applicationPropertyRS = applicationPropertyRS;
        this.inspektorat = []; //Liste die im Gui angezeigt wird
        this.initViewModel();
    }
    DVInspektoratListController.prototype.initViewModel = function () {
    };
    DVInspektoratListController.prototype.$onInit = function () {
    };
    DVInspektoratListController.prototype.getFilterroles = function () {
        return this.roleUtilService.getAllRolesButGesuchstellerArray();
    };
    DVInspektoratListController.prototype.editClicked = function (inspektoratToEdit, event) {
        this.onEdit({ inspektorat: inspektoratToEdit, event: event });
    };
    DVInspektoratListController.prototype.translateAktiv = function (inaktiv) {
        return inaktiv ? (this.$translate.instant('INAKTIV')) : (this.$translate.instant('AKTIV'));
    };
    DVInspektoratListController.prototype.translateRoles = function (roles) {
        var _this = this;
        var prefix = TSRole_1.rolePrefix();
        return roles.map(function (element) {
            return _this.$translate.instant(prefix + TSRole_1.TSRole[element]);
        }).join(', ');
    };
    DVInspektoratListController.prototype.translateRole = function (role) {
        var prefix = TSRole_1.rolePrefix();
        return this.$translate.instant(prefix + TSRole_1.TSRole[role]);
    };
    DVInspektoratListController.prototype.getColumnsNumber = function () {
        var element = angular.element('.dv-inspektorat-list .header-row').first();
        if (element) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 12;
    };
    /**
     * Alle TSKantonCode fuer das Filterdropdown
     * @returns {Array<key: string; code: TSKantonCode>}
     */
    DVInspektoratListController.prototype.getKantone = function () {
        var _this = this;
        var kantonCodes = TSKantonCode_1.getKantonCodeList();
        var kantonNamesAndCodes = [];
        kantonCodes.forEach(function (code) {
            kantonNamesAndCodes.push({
                key: _this.$translate.instant(code.toString()),
                code: code,
            });
        });
        kantonNamesAndCodes.sort(function (a, b) { return a.code.toString().localeCompare(b.code.toString()); });
        return kantonNamesAndCodes;
    };
    DVInspektoratListController.$inject = ['$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', '$translate', 'ApplicationPropertyRS'];
    return DVInspektoratListController;
}());
exports.DVInspektoratListController = DVInspektoratListController;


/***/ }),

/***/ "bb2W":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("jUP6");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-auszahlung.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-auszahlung.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "bjNA":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("7L/8");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-text-value.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-text-value.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "bsYH":
/***/ (function(module, exports) {

module.exports = "<div class=\"zahlungen-list-view\"> <div dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getAdministratorRoles()\"> <uib-tabset active=\"vm.selectedTab\" class=\"zahlungentabs\"> <uib-tab index=\"$index\" ng-repeat=\"tab in vm.tabs\" heading=\"{{tab.title | translate}}\" select=\"vm.selectTab($index)\"> <dv-zahlungen-list on-filter-change=\"vm.passBeitragFilterToServer(tableState, prefilter)\" on-edit=\"vm.editFall(beitragDTO, event)\" on-edit-beitrag=\"vm.editBeitrag(beitragDTO, beitrag, event)\" prefilter=\"vm.selectedPrefilter\" tabindex=\"{{$index}}\" selectedtab=\"vm.selectedTab\" freigeben-mode=\"tab.freigeben\" ausfuehren-mode=\"tab.ausfuehren\"> </dv-zahlungen-list> </uib-tab> <uib-tab index=\"2\" heading=\"{{'ZAHLUNGEN_AUSGEFUEHRT' | translate}}\" select=\"vm.selectTab(2)\"> <dv-zahlungsauftrag-list on-filter-change=\"vm.passZahlungsauftragFilterToServer(tableState)\" selectedtab=\"vm.selectedTab\" tabindex=\"2\" moegliche-besitzer=\"vm.besitzer\"> </dv-zahlungsauftrag-list> </uib-tab> </uib-tabset> </div> </div> ";

/***/ }),

/***/ "bydc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
var Raven = __webpack_require__("/Hyb");
var TSAuthEvent_1 = __webpack_require__("L0QB");
var TSErrorLevel_1 = __webpack_require__("92KJ");
appRun.$inject = ['angularMomentConfig', 'RouterHelper', '$injector', '$rootScope',
    '$timeout', '$state', '$location', '$window', '$log', 'AuthServiceRS', 'ErrorService',
    'VereinbarungAkzeptiertService', 'ApplicationPropertyRS', 'PiwikService', 'NavigationLogger'];
/* @ngInject */
function appRun(angularMomentConfig, routerHelper, $injector, $rootScope, $timeout, $state, $location, $window, $log, authServiceRS, errorService, vereinbarungAkzeptiertService, applicationPropertyRS, piwikService) {
    // navigationLogger.toggle();
    // Fehler beim Navigieren ueber ui-route ins Log schreiben
    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
        $log.error('Fehler beim Navigieren');
        $log.error('$stateChangeError --- event, toState, toParams, fromState, fromParams, error');
        $log.error(event, toState, toParams, fromState, fromParams, error);
    });
    //$rootScope.$on('$locationChangeSuccess', updatePiwikStateChange); //Piwik site change marks are disabled as this feature has not been paid for
    //Normale Benutzer duefen nicht auf admin Seite
    // $rootScope.$on('$stateChangeStart',
    //     (event, toState, toParams, fromState, fromParams, options) => {
    //         let principal: TSUser = authServiceRS.getPrincipal();
    //         let forbiddenPlaces = ['admin', 'institution', 'parameter', 'traegerschaft'];
    //         let isAdmin: boolean = authServiceRS.isOneOfRoles(TSRoleUtil.getAdministratorRoles());
    //         if (toState && forbiddenPlaces.indexOf(toState.name) !== -1 && authServiceRS.getPrincipal() && !isAdmin)
    // { errorService.addMesageAsError('ERROR_UNAUTHORIZED'); $log.debug('prevented navigation to page because user is
    // not admin'); event.preventDefault(); } });
    routerHelper.configureStates(getStates(), '/start');
    angularMomentConfig.format = 'DD.MM.YYYY';
    // dieser call macht mit tests probleme, daher wird er fuer test auskommentiert
    $rootScope.$on(TSAuthEvent_1.TSAuthEvent[TSAuthEvent_1.TSAuthEvent.LOGIN_SUCCESS], function () {
        //do stuff if needed
        if (true) {
            setUserIdToPiwik();
            captureUserInSentry();
        }
    });
    $rootScope.$on(TSAuthEvent_1.TSAuthEvent[TSAuthEvent_1.TSAuthEvent.LOGOUT_SUCCESS], function () {
        //do stuff if needed
        if (true) {
            setUserIdToPiwik();
            captureUserInSentry();
        }
    });
    $rootScope.$on(TSAuthEvent_1.TSAuthEvent[TSAuthEvent_1.TSAuthEvent.NOT_AUTHENTICATED], function () {
        //user is not yet authenticated, show loginpage
        var currentPath = angular.copy($location.absUrl());
        $log.debug('not authenticated, going to login page wiht current path ', currentPath);
        //wenn wir schon auf der lognseite oder im redirect sind redirecten wir nicht
        if (($state.current !== undefined && $state.current.name !== 'login')
            && ($state.current !== undefined && $state.current.name !== 'loginanlaufstelle')
            && ($state.current !== undefined && $state.current.name !== 'locallogin')) {
            $log.debug('user is not logged in, redirecting to login page from ', currentPath);
            $state.go('login', { relayPath: currentPath, type: 'login' });
        }
        else {
            $log.info('suppressing redirect to ', currentPath);
        }
    });
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        errorService.clearAllOfSeverity(TSErrorLevel_1.TSErrorLevel.SEVERE);
    });
    //     Attempt to restore a user session upon startup
    if (authServiceRS.initWithCookie()) {
        $log.debug('logged in from cookie');
    }
    if (true) {
        //Hintergrundfarbe anpassen (user-acceptance-test system kann zB andere Farbe haben)
        var applicationPropertyRS_1 = $injector.get('ApplicationPropertyRS');
        applicationPropertyRS_1.getBackgroundColor().then(function (prop) {
            if (prop && prop.value && prop.value !== '#FFFFFF') {
                angular.element('.navbar-serf').css('background', prop.value);
            }
        });
        //if we are doing a 'npm run test run' we do not need to track phantom-js
        applicationPropertyRS_1.getPiwikSiteId().then(function (piwikAppProp) {
            var siteID = piwikAppProp.value !== undefined ? piwikAppProp.value : undefined;
            initPiwik(siteID);
        });
        applicationPropertyRS_1.getSentryEnvName().then(function (sentryEnvName) {
            if (sentryEnvName && sentryEnvName.value) {
                Raven.setEnvironment(sentryEnvName.value);
            }
            else {
                Raven.setEnvironment('unspecified');
            }
        });
    }
    function initPiwik(siteId) {
        if (!siteId) {
            $log.debug('tracker not started');
            return;
        }
        var piwikUrl = piwikService.getPiwikUrl();
        piwikService.push(['setTrackerUrl', piwikUrl + 'piwik.php']);
        piwikService.push(['setSiteId', siteId]);
        setUserIdToPiwik();
        captureUserInSentry();
        updatePiwikStateChange(null, $window.location.href, ''); //inital entry to tracking, call again on page-state change
        var scriptElement = document.createElement('script');
        var firstScript = document.getElementsByTagName('script')[0];
        scriptElement.type = 'text/javascript';
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.src = piwikUrl + 'piwik.js';
        if (firstScript !== undefined && firstScript.parentNode !== undefined && firstScript.parentNode !== null) {
            firstScript.parentNode.insertBefore(scriptElement, firstScript);
        }
        else {
            $log.warn('could not start piwik tracking because no script tag was found on page');
        }
    }
    function setUserIdToPiwik() {
        // get username, not using null as this produces an error in the piwik script
        var currPrincipal = authServiceRS.getPrincipal();
        var username = currPrincipal && currPrincipal.email ? currPrincipal.email : '';
        piwikService.push(['setUserId', username]);
    }
    function captureUserInSentry() {
        var currPrincipal = authServiceRS.getPrincipal();
        var username = currPrincipal && currPrincipal.email ? currPrincipal.email : undefined;
        var maxRole;
        maxRole = authServiceRS.getHighestRoleOfBenutzer(currPrincipal && currPrincipal.roles ? currPrincipal.roles : []);
        Raven.setUserContext({
            email: username,
            maxRole: maxRole,
        });
    }
    /**
     * Update the piwik super global variable to track page changes without actually routing.
     *
     * @see https://piwik.org/blog/2017/02/how-to-track-single-page-websites-using-piwik-analytics
     * @param {?angular.IAngularEvent} event
     * @param {string} newUrl
     * @param {string} oldUrl
     */
    function updatePiwikStateChange(event, newUrl, oldUrl) {
        piwikService.push(['setReferrerUrl', oldUrl]);
        piwikService.push(['setCustomUrl', newUrl]);
        // as our document title is useless we just use part of the url as title
        var hashPrefix = newUrl.indexOf('#/');
        var documentTitle = hashPrefix === -1 ? window.document.title : newUrl.substr(hashPrefix + 2);
        piwikService.push(['setDocumentTitle', documentTitle]);
        // remove all previously assigned custom variables, requires Piwik 3.0.2
        piwikService.push(['deleteCustomVariables', 'page']);
        piwikService.push(['setGenerationTimeMs', 0]);
        piwikService.push(['trackPageView']);
    }
}
exports.appRun = appRun;
function getStates() {
    return [
    /* Add New States Above */
    ];
}


/***/ }),

/***/ "bzk6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/dokument.d683c78e60f5d3bafe1355f288ea8077.png";

/***/ }),

/***/ "c9dM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSKoerperschaftDaten_1 = __importDefault(__webpack_require__("XeJg"));
var TSKoerperschaft = /** @class */ (function (_super) {
    __extends(TSKoerperschaft, _super);
    function TSKoerperschaft() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSKoerperschaft.prototype, "koerperschaftDatenFS", {
        get: function () {
            return this._koerperschaftDatenFS;
        },
        set: function (value) {
            this._koerperschaftDatenFS = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSKoerperschaft.prototype, "koerperschaftDatenGS", {
        get: function () {
            return this._koerperschaftDatenGS;
        },
        set: function (value) {
            this._koerperschaftDatenGS = value;
        },
        enumerable: true,
        configurable: true
    });
    TSKoerperschaft.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.koerperschaftDatenFS = this.deserializeOrCreate(restObject.koerperschaftDatenFS, new TSKoerperschaftDaten_1.default());
        this.koerperschaftDatenGS = this.deserializeOrNull(restObject.koerperschaftDatenGS, new TSKoerperschaftDaten_1.default());
        return this;
    };
    TSKoerperschaft.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.koerperschaftDatenFS = this.serializeOrInit(this.koerperschaftDatenFS, restObject.koerperschaftDatenFS);
        restObject.koerperschaftDatenGS = this.serializeOrInit(this.koerperschaftDatenGS, restObject.koerperschaftDatenGS);
        return restObject;
    };
    return TSKoerperschaft;
}(TSAbstractEntity_1.default));
exports.default = TSKoerperschaft;


/***/ }),

/***/ "cAJG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSBeitragArt_1 = __webpack_require__("HbSP");
var RemoveDialogController_1 = __webpack_require__("92sy");
var template = __webpack_require__("IlcK");
__webpack_require__("pL33");
var removeDialogTemplate = __webpack_require__("YTLw");
var DVZahlungenListConfig = /** @class */ (function () {
    function DVZahlungenListConfig() {
        this.transclude = false;
        this.bindings = {
            onEdit: '&',
            onEditBeitrag: '&',
            onFilterChange: '&',
            prefilter: '=',
            tabindex: '@',
            selectedtab: '=',
            freigebenMode: '<',
            ausfuehrenMode: '<'
        };
        this.template = template;
        this.controller = DVZahlungenListController;
        this.controllerAs = 'vm';
    }
    return DVZahlungenListConfig;
}());
exports.DVZahlungenListConfig = DVZahlungenListConfig;
var DVZahlungenListController = /** @class */ (function () {
    /* @ngInject */
    function DVZahlungenListController($filter, $log, CONSTANTS, $scope, $window, $translate, beitragRS, dvDialog, errorService) {
        var _this = this;
        this.$filter = $filter;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.$scope = $scope;
        this.$window = $window;
        this.$translate = $translate;
        this.beitragRS = beitragRS;
        this.dvDialog = dvDialog;
        this.errorService = errorService;
        this.displayedCollection = []; //Liste die im Gui angezeigt wird
        this.nichtZugeteiltMarker = 'NICHT_ZUGETEILT';
        this.defaultTableFilterState = {
            sort: {},
            search: {},
            pagination: { start: 0, totalItemCount: 0, number: 30 }
        };
        this.checklistEntries = ['CHECK_AUSZAHLUNG_1', 'CHECK_AUSZAHLUNG_2', 'CHECK_AUSZAHLUNG_3'];
        this.allChecked = false;
        this.callServer = function (tableFilterState) {
            _this.tableFilterState = tableFilterState;
            //wenn aktuelles tab nicht gewaehltes ist machen wir nichts
            if (_this.selectedtab !== parseInt(_this.tabindex)) {
                return;
            }
            _this.pagination = tableFilterState.pagination;
            if (_this.onFilterChange && angular.isFunction(_this.onFilterChange)) {
                _this.onFilterChange({
                    tableState: tableFilterState,
                    prefilter: _this.prefilter
                }).then(function (result) {
                    if (result) {
                        tableFilterState.pagination.totalItemCount = result.totalResultSize;
                        tableFilterState.pagination.numberOfPages = Math.ceil(result.totalResultSize / tableFilterState.pagination.number);
                        _this.displayedCollection = new Array().concat(result.schadenfallBeitragDTOs);
                        _this.alleCheckbox = false;
                    }
                });
            }
            else {
                _this.$log.info('no callback function spcified for filtering');
            }
        };
        this.initViewModel();
    }
    DVZahlungenListController.prototype.initViewModel = function () {
    };
    DVZahlungenListController.prototype.$onInit = function () {
    };
    DVZahlungenListController.prototype.editClicked = function (beitragDTO, event) {
        this.onEdit({ beitragDTO: beitragDTO, event: event });
    };
    DVZahlungenListController.prototype.editClickedBeitrag = function (beitragDTO, beitrag, event) {
        if (angular.isFunction(this.onEditBeitrag)) {
            this.onEditBeitrag({ beitragDTO: beitragDTO, beitrag: beitrag, event: event });
        }
    };
    /**
     * Alle TSZahlungenStatus fuer das Filterdropdown
     * @returns {Array<TSBeitragArt>}
     */
    DVZahlungenListController.prototype.getTSBeitragArtValues = function () {
        return TSBeitragArt_1.getTSBeitragArtValues();
    };
    DVZahlungenListController.prototype.getColumnsNumber = function () {
        var element = angular.element('.dv-zahlungen-list.' + this.getClass() + ' .header-row').first();
        if (element && element.get(0)) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 8;
    };
    DVZahlungenListController.prototype.getClass = function () {
        return 'tab-nr-' + this.tabindex;
    };
    DVZahlungenListController.prototype.alleChanged = function () {
        var _this = this;
        this.displayedCollection.forEach(function (schadenfallBeitragDTO) {
            schadenfallBeitragDTO.beitraege.forEach(function (beitrag) {
                beitrag.selected = _this.alleCheckbox;
            });
        });
    };
    DVZahlungenListController.prototype.doFreigeben = function () {
        var _this = this;
        var ids = this.getSelectedIds();
        if (ids.length > 0) {
            this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController_1.RemoveDialogController, {
                text: '',
                title: this.$translate.instant('FREIGEBEN_DIALOG', { anzahl: ids.length })
            }).then(function () {
                _this.beitragRS.beitraegeFreigeben(ids).then(function () {
                    //success --> reload table
                    _this.errorService.clearAll();
                    _this.callServer(_this.tableFilterState);
                });
            }).catch(function () {
            });
        }
        else {
            this.errorService.addMesageAsError('ERROR_NO_BEITRAEGE');
            this.$log.debug('Form was not valid');
        }
    };
    DVZahlungenListController.prototype.getSelectedIds = function () {
        var ids = [];
        this.displayedCollection.forEach(function (schadenfallBeitragDTO) {
            schadenfallBeitragDTO.beitraege.forEach(function (beitrag) {
                if (beitrag.selected) {
                    ids.push(beitrag.id);
                }
            });
        });
        return ids;
    };
    DVZahlungenListController.prototype.doAusfuehren = function () {
        var _this = this;
        if (this.disabledAusfuehren()) {
            this.$log.error('Checklist not valid or ref undefined');
            return;
        }
        var ids = this.getSelectedIds();
        if (ids.length > 0) {
            this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController_1.RemoveDialogController, {
                text: '',
                title: this.$translate.instant('AUSFUEHREN_DIALOG', { anzahl: ids.length })
            }).then(function () {
                if (_this.ref && _this.datumFaellig) {
                    _this.beitragRS.beitraegeAusfuehren(ids, _this.ref, _this.datumFaellig).then(function () {
                        _this.ref = undefined;
                        _this.datumFaellig = undefined;
                        _this.allChecked = false;
                        _this.form.$setPristine();
                        _this.form.$setUntouched();
                        _this.errorService.clearAll();
                        _this.callServer(_this.tableFilterState);
                    });
                }
                else {
                    _this.$log.warn('ref and datumFaellig are not set, do nothing');
                }
            }).catch(function () {
            });
        }
        else {
            this.errorService.addMesageAsError('ERROR_NO_BEITRAEGE');
            this.$log.debug('Form was not valid');
        }
    };
    DVZahlungenListController.prototype.getChecklistEntries = function () {
        return this.checklistEntries;
    };
    DVZahlungenListController.prototype.checklistStatusChanged = function (allchecked) {
        this.checklistValid = allchecked;
    };
    DVZahlungenListController.prototype.disabledAusfuehren = function () {
        return !this.checklistValid || this.ref === undefined || this.datumFaellig === undefined;
    };
    DVZahlungenListController.prototype.getTSBeitragArtTranslate = function (beitragArt) {
        var prefix = TSBeitragArt_1.beitragArtPrefix();
        return this.$translate.instant(prefix + TSBeitragArt_1.TSBeitragArt[beitragArt]);
    };
    DVZahlungenListController.$inject = ['$filter', '$log', 'CONSTANTS', '$scope', '$window', '$translate', 'BeitragRS', 'DvDialog', 'ErrorService'];
    return DVZahlungenListController;
}());
exports.DVZahlungenListController = DVZahlungenListController;


/***/ }),

/***/ "cIbT":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("RZXW");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./anlaufstelleverwaltungView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./anlaufstelleverwaltungView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "cKO2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSSchadenfallEvent;
(function (TSSchadenfallEvent) {
    TSSchadenfallEvent[TSSchadenfallEvent["GESUCH_DURCH_BEROFFENER_FREIGEGEBEN"] = 'GESUCH_DURCH_BEROFFENER_FREIGEGEBEN'] = "GESUCH_DURCH_BEROFFENER_FREIGEGEBEN";
    TSSchadenfallEvent[TSSchadenfallEvent["PAPIERGESUCH_DURCH_ANLAUFSTELLE_FREIGEGEBEN"] = 'PAPIERGESUCH_DURCH_ANLAUFSTELLE_FREIGEGEBEN'] = "PAPIERGESUCH_DURCH_ANLAUFSTELLE_FREIGEGEBEN";
    TSSchadenfallEvent[TSSchadenfallEvent["ANLAUFSTELLE_BASISPRUEFUNG_OK"] = 'ANLAUFSTELLE_BASISPRUEFUNG_OK'] = "ANLAUFSTELLE_BASISPRUEFUNG_OK";
    TSSchadenfallEvent[TSSchadenfallEvent["STICHENTSCHEID_ANGEFORDERT"] = 'STICHENTSCHEID_ANGEFORDERT'] = "STICHENTSCHEID_ANGEFORDERT";
    TSSchadenfallEvent[TSSchadenfallEvent["ABLEHNUNG"] = 'ABLEHNUNG'] = "ABLEHNUNG";
    TSSchadenfallEvent[TSSchadenfallEvent["SCHAETZUNG_DURCHGEFUEHRT"] = 'SCHAETZUNG_DURCHGEFUEHRT'] = "SCHAETZUNG_DURCHGEFUEHRT";
    TSSchadenfallEvent[TSSchadenfallEvent["ANLAUFSTELLE_SCHAETZUNG_OK"] = 'ANLAUFSTELLE_SCHAETZUNG_OK'] = "ANLAUFSTELLE_SCHAETZUNG_OK";
    TSSchadenfallEvent[TSSchadenfallEvent["ZURUECK_AN_SCHAETZER"] = 'ZURUECK_AN_SCHAETZER'] = "ZURUECK_AN_SCHAETZER";
    TSSchadenfallEvent[TSSchadenfallEvent["FS_UEBERPRUEFUNG_OK"] = 'FS_UEBERPRUEFUNG_OK'] = "FS_UEBERPRUEFUNG_OK";
    TSSchadenfallEvent[TSSchadenfallEvent["FS_UEBERPRUEFUNG_OK_PAPIER"] = 'FS_UEBERPRUEFUNG_OK_PAPIER'] = "FS_UEBERPRUEFUNG_OK_PAPIER";
    TSSchadenfallEvent[TSSchadenfallEvent["FS_UEBERPRUEFUNG_MANGELHAFT"] = 'FS_UEBERPRUEFUNG_MANGELHAFT'] = "FS_UEBERPRUEFUNG_MANGELHAFT";
    TSSchadenfallEvent[TSSchadenfallEvent["WIEDERHERSTELLUNG_AUSGEFUEHRT"] = 'WIEDERHERSTELLUNG_AUSGEFUEHRT'] = "WIEDERHERSTELLUNG_AUSGEFUEHRT";
    TSSchadenfallEvent[TSSchadenfallEvent["WIEDERHERSTELLUNG_MANGELHAFT"] = 'WIEDERHERSTELLUNG_MANGELHAFT'] = "WIEDERHERSTELLUNG_MANGELHAFT";
    TSSchadenfallEvent[TSSchadenfallEvent["WIEDERHERSTELLUNG_GEPRUEFT"] = 'WIEDERHERSTELLUNG_GEPRUEFT'] = "WIEDERHERSTELLUNG_GEPRUEFT";
    TSSchadenfallEvent[TSSchadenfallEvent["WIEDERHERSTELLUNG_GEPRUEFT_PAPIER"] = 'WIEDERHERSTELLUNG_GEPRUEFT_PAPIER'] = "WIEDERHERSTELLUNG_GEPRUEFT_PAPIER";
    TSSchadenfallEvent[TSSchadenfallEvent["ABRECHNUNG_MANGELHAFT"] = 'ABRECHNUNG_MANGELHAFT'] = "ABRECHNUNG_MANGELHAFT";
    TSSchadenfallEvent[TSSchadenfallEvent["ABRECHNUNG_OK"] = 'ABRECHNUNG_OK'] = "ABRECHNUNG_OK";
    TSSchadenfallEvent[TSSchadenfallEvent["ZAHLUNG_AUSGELOEST"] = 'ZAHLUNG_AUSGELOEST'] = "ZAHLUNG_AUSGELOEST";
    TSSchadenfallEvent[TSSchadenfallEvent["STICHENTSCHEID_OK"] = 'STICHENTSCHEID_OK'] = "STICHENTSCHEID_OK";
    TSSchadenfallEvent[TSSchadenfallEvent["FREIGABE_PAPIER_FS_6"] = 'FREIGABE_PAPIER_FS_6'] = "FREIGABE_PAPIER_FS_6";
    TSSchadenfallEvent[TSSchadenfallEvent["FREIGABE_PAPIER_FS_9"] = 'FREIGABE_PAPIER_FS_9'] = "FREIGABE_PAPIER_FS_9";
    TSSchadenfallEvent[TSSchadenfallEvent["LOESCHEN"] = 'LOESCHEN'] = "LOESCHEN";
})(TSSchadenfallEvent = exports.TSSchadenfallEvent || (exports.TSSchadenfallEvent = {}));
function getTSSchadenfallEventValues() {
    return [
        TSSchadenfallEvent.GESUCH_DURCH_BEROFFENER_FREIGEGEBEN,
        TSSchadenfallEvent.PAPIERGESUCH_DURCH_ANLAUFSTELLE_FREIGEGEBEN,
        TSSchadenfallEvent.ANLAUFSTELLE_BASISPRUEFUNG_OK,
        TSSchadenfallEvent.STICHENTSCHEID_ANGEFORDERT,
        TSSchadenfallEvent.ABLEHNUNG,
        TSSchadenfallEvent.SCHAETZUNG_DURCHGEFUEHRT,
        TSSchadenfallEvent.ANLAUFSTELLE_SCHAETZUNG_OK,
        TSSchadenfallEvent.FS_UEBERPRUEFUNG_OK,
        TSSchadenfallEvent.FS_UEBERPRUEFUNG_OK_PAPIER,
        TSSchadenfallEvent.FS_UEBERPRUEFUNG_MANGELHAFT,
        TSSchadenfallEvent.WIEDERHERSTELLUNG_AUSGEFUEHRT,
        TSSchadenfallEvent.WIEDERHERSTELLUNG_MANGELHAFT,
        TSSchadenfallEvent.WIEDERHERSTELLUNG_GEPRUEFT,
        TSSchadenfallEvent.WIEDERHERSTELLUNG_GEPRUEFT_PAPIER,
        TSSchadenfallEvent.ABRECHNUNG_MANGELHAFT,
        TSSchadenfallEvent.ABRECHNUNG_OK,
        TSSchadenfallEvent.ZAHLUNG_AUSGELOEST,
        TSSchadenfallEvent.ABLEHNUNG,
        TSSchadenfallEvent.STICHENTSCHEID_OK,
        TSSchadenfallEvent.FREIGABE_PAPIER_FS_6,
        TSSchadenfallEvent.FREIGABE_PAPIER_FS_9,
        TSSchadenfallEvent.LOESCHEN,
    ];
}
exports.getTSSchadenfallEventValues = getTSSchadenfallEventValues;


/***/ }),

/***/ "cRnY":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("7ibs");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./versicherungsbeitragSchadenView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./versicherungsbeitragSchadenView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "cXjS":
/***/ (function(module, exports) {

module.exports = " <div dv-scroll-nav> <dv-versicherung-navigation title=\"{{vm.getViewTitle()}}\" vers-beitrag-id=\"{{vm.model.id}}\" status=\"{{vm.model.status}}\" sticky=\"sticky\"></dv-versicherung-navigation> <div ng-class=\"['versicherungsbeitrag-schaden-view', 'container', {'container-sticky':sticky}]\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <fieldset ng-disabled=\"vm.readonly\"> <div class=\"row\"> <div class=\"col-sm-4\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"VERSICHERUNG\" for=\"versicherungSelect\"></label> <select name=\"versicherungSelect\" id=\"versicherungSelect\" class=\"form-control\" ng-model=\"vm.getModel().versicherung\" ng-options=\"versicherung.name for versicherung in vm.possibleVersicherungen track by  versicherung.id\" ng-required=\"true\"> </select> <dv-error-messages for=\"vm.form.versicherungSelect\"></dv-error-messages> </dv-input-container> </div> </div> <div class=\"row\"> <div class=\"col-sm-4\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"DATUM_STICHTAG\" for=\"schadendatum\"></label> <dv-datepicker input-id=\"schadendatum\" name=\"schadendatum\" ng-model=\"vm.getModel().schadendatum\" ng-required=\"true\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" check-future=\"true\"> </dv-datepicker> <dv-error-messages for=\"vm.form.schadendatum\"></dv-error-messages> </dv-input-container> </div> <dv-string-input model=\"vm.getModel().externalSchadenNr\" name=\"externalSchadenNr\" label=\"EXTERNAL_SCHADEN_NR\" clazz=\"col-sm-4\"> </dv-string-input> </div> <div class=\"row\"> <dv-string-input model=\"vm.getModel().policeNummer\" name=\"policeNummer\" label=\"POLICE_NUMMER\" clazz=\"col-sm-4\" ng-required=\"false\"> </dv-string-input> <div class=\"col-xs-4\"> <div class=\"gemeinde\"> <dv-gemeinde-typeahead selected-gemeinde=\"vm.getModel().gemeinde\" input-name=\"gemeindeName\" input-placeholder=\"START_TYPING\" label=\"SCHADEN_GEMEINDE\" ng-required=\"true\"> </dv-gemeinde-typeahead> </div> </div> </div> <div class=\"row\"> <div class=\"col-sm-4\"> <dv-input-container> <label class=\"md-no-float\" data-translate=\"ART_DES_SCHADENDS\" for=\"schadenArt\"></label> <select name=\"schadenArt\" id=\"schadenArt\" ng-model=\"vm.getModel().schadenArt\" class=\"form-control\" ng-options=\"vm.translateSchadenArt(art) for art in vm.getTSSchadenArtValues() \" ng-required=\"true\"> </select> <dv-error-messages for=\"vm.form.schadenArt\"></dv-error-messages> </dv-input-container> </div> <dv-string-input ng-if=\"vm.showAndere()\" model=\"vm.getModel().schadenArtAndere\" name=\"schadenArtAndere\" label=\"ART_DES_SCHADENDS_ANDERE\" clazz=\"col-sm-4\"> </dv-string-input> </div> <div class=\"col-sm-12\"> <h2> <span data-translate=\"BILDER_DOKUMENTE\"></span> </h2> <dv-dokumentupload on-doc-removed=\"vm.onDocRemoved(document)\" on-doc-added=\"vm.onDocAdded(document)\" parentid=\"vm.getModel().id\" document-type=\"vm.doctype\" readonly=\"false\"> </dv-dokumentupload> </div> </fieldset> <div class=\"col-sm-12\"> <div class=\"row mainbuttons\"> <div> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.cancelVersicherungsbeitrag()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> <div ng-if=\"!vm.readonly\"> <dv-loading-button type=\"submit\" button-click=\"vm.saveVersicherungsbeitrag()\" button-class=\"btn btn-serf\"> <span data-translate=\"SAVE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </div> </form> </div> </div> ";

/***/ }),

/***/ "cg+K":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".dv-gesuchsteller .gesuchsteller-title:after{line-height:45px;display:block;margin-top:10px;margin-bottom:24px;border:0;border-top:1px solid #bc2500;content:\"\"}.dv-gesuchsteller .h2-gesuchsteller .h2-prefix{font-size:14px;display:block;margin-bottom:5px;font-weight:400;font-style:italic}.dv-gesuchsteller input[type=number].no-step-arrow{-moz-appearance:textfield}.dv-gesuchsteller input[type=number].no-step-arrow::-webkit-inner-spin-button,.dv-gesuchsteller input[type=number].no-step-arrow::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}", ""]);

// exports


/***/ }),

/***/ "cixw":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".schadenfaelletabs .nav-tabs{padding-left:18px;margin-top:10px;margin-left:-8px;margin-right:-8px}@media(min-width:992px){.schadenfaelletabs .nav-tabs{padding-left:245px;margin-top:27px}.schadenfaelletabs .tab-pane{padding:30px}}@media(min-width:1025px){.schadenfaelle-list-view__betroffene{padding:30px 150px}}", ""]);

// exports


/***/ }),

/***/ "cr0T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
versicherungsbeitraegeRun.$inject = ['RouterHelper'];
/* @ngInject */
function versicherungsbeitraegeRun(routerHelper) {
    routerHelper.configureStates(getStates());
}
exports.versicherungsbeitraegeRun = versicherungsbeitraegeRun;
function getStates() {
    return [
        {
            name: 'versicherungsbeitraege',
            template: '<versicherungsbeitraege-list-view flex="auto" class="overflow-scroll"></versicherungsbeitraege-list-view>',
            url: '/versicherungsbeitraege',
        },
        {
            name: 'versicherungsbeitragschaden',
            template: '<versicherungsbeitrag-schaden-view flex="auto" class="overflow-scroll" versicherungsbeitrag="$resolve.versicherungsbeitrag"></versicherungsbeitrag-schaden-view>',
            url: '/versicherungsbeitragschaden/:createNew/:versicherungsbeitragId',
            resolve: { versicherungsbeitrag: getOrCreateVersicherungsbeitrag },
        },
        {
            name: 'versicherungbeitragversicherter',
            template: '<versicherungsbeitrag-versicherter-view flex="auto" class="overflow-scroll" versicherungsbeitrag="$resolve.versicherungsbeitrag"></versicherungsbeitrag-versicherter-view>',
            url: '/versicherungbeitragversicherter/:versicherungsbeitragId',
            resolve: { versicherungsbeitrag: getVersicherungsbeitrag },
        },
        {
            name: 'versicherungbeitragbeitrag',
            template: '<versicherungsbeitrag-beitrag-view flex="auto" class="overflow-scroll" versicherungsbeitrag="$resolve.versicherungsbeitrag"></versicherungsbeitrag-beitrag-view>',
            url: '/versicherungbeitragbeitrag/:versicherungsbeitragId',
            resolve: { versicherungsbeitrag: getVersicherungsbeitrag },
        },
    ];
}
var INewFallStateParams = /** @class */ (function () {
    function INewFallStateParams() {
    }
    return INewFallStateParams;
}());
exports.INewFallStateParams = INewFallStateParams;
var IFallStateParams = /** @class */ (function () {
    function IFallStateParams() {
    }
    return IFallStateParams;
}());
exports.IFallStateParams = IFallStateParams;
getOrCreateVersicherungsbeitrag.$inject = ['$stateParams', '$q', 'VersicherungsbeitragModelManager'];
/* @ngInject */
function getOrCreateVersicherungsbeitrag($stateParams, $q, versicherungsbeitragModelManager) {
    if ($stateParams) {
        var versicherungsbeitragIdParam = $stateParams.versicherungsbeitragId;
        var createNewParam = $stateParams.createNew;
        if (createNewParam === 'false' && versicherungsbeitragIdParam) {
            return versicherungsbeitragModelManager.openVersicherungsbeitrag(versicherungsbeitragIdParam);
        }
    }
    return versicherungsbeitragModelManager.initNewVersicherungsbeitrag();
}
exports.getOrCreateVersicherungsbeitrag = getOrCreateVersicherungsbeitrag;
getVersicherungsbeitrag.$inject = ['$stateParams', '$q', 'VersicherungsbeitragModelManager', '$log'];
/* @ngInject */
function getVersicherungsbeitrag($stateParams, $q, versicherungsbeitragModelManager, log) {
    if ($stateParams) {
        var versicherungsbeitragIdParam = $stateParams.versicherungsbeitragId;
        if (versicherungsbeitragIdParam) {
            if (versicherungsbeitragModelManager.isVersicherungsbeitrag(versicherungsbeitragIdParam)) {
                return $q.when(versicherungsbeitragModelManager.getVersicherungsbeitrag()); //we already checked for null, hence !
            }
            else {
                return versicherungsbeitragModelManager.openVersicherungsbeitrag(versicherungsbeitragIdParam);
            }
        }
    }
    log.error('Can`t open versicherungsbeitrag on view!!! createOrUpdate a new one...');
    return versicherungsbeitragModelManager.initNewVersicherungsbeitrag();
}
exports.getVersicherungsbeitrag = getVersicherungsbeitrag;


/***/ }),

/***/ "csNn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSFremdkostenDaten_1 = __importDefault(__webpack_require__("u0Wo"));
var TSFremdkosten = /** @class */ (function (_super) {
    __extends(TSFremdkosten, _super);
    function TSFremdkosten() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._documentIdsToConnect = [];
        return _this;
    }
    TSFremdkosten.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.schaetzung = restObject.schaetzung;
        this.fremdkostenDatenFS = this.deserializeOrCreate(restObject.fremdkostenDatenFS, new TSFremdkostenDaten_1.default());
        this.fremdkostenDatenGS = this.deserializeOrNull(restObject.fremdkostenDatenGS, new TSFremdkostenDaten_1.default());
        return this;
    };
    TSFremdkosten.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.schaetzung = this.schaetzung;
        restObject.fremdkostenDatenGS = this.serializeOrInit(this.fremdkostenDatenGS, restObject.fremdkostenDatenGS);
        restObject.fremdkostenDatenFS = this.serializeOrInit(this.fremdkostenDatenFS, restObject.fremdkostenDatenFS);
        return restObject;
    };
    Object.defineProperty(TSFremdkosten.prototype, "fremdkostenDatenGS", {
        get: function () {
            return this._fremdkostenDatenGS;
        },
        set: function (value) {
            this._fremdkostenDatenGS = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFremdkosten.prototype, "fremdkostenDatenFS", {
        get: function () {
            return this._fremdkostenDatenFS;
        },
        set: function (value) {
            this._fremdkostenDatenFS = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFremdkosten.prototype, "documentIdsToConnect", {
        get: function () {
            return this._documentIdsToConnect;
        },
        set: function (value) {
            this._documentIdsToConnect = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFremdkosten.prototype, "schaetzung", {
        get: function () {
            return this._schaetzung;
        },
        set: function (value) {
            this._schaetzung = value;
        },
        enumerable: true,
        configurable: true
    });
    TSFremdkosten.getDeserializer = function (fremdkosten) {
        return new TSFremdkosten().deserialize(fremdkosten);
    };
    TSFremdkosten.getSerializer = function (fremdkosten) {
        return fremdkosten.serialize(fremdkosten);
    };
    return TSFremdkosten;
}(TSAbstractEntity_1.default));
exports.default = TSFremdkosten;


/***/ }),

/***/ "d0qO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(__webpack_require__("PJh5"));
var template = __webpack_require__("Zfe6");
var DVDatepicker = /** @class */ (function () {
    function DVDatepicker() {
        this.restrict = 'E';
        this.require = { ngModelCtrl: 'ngModel' };
        this.scope = {
            ngModel: '=',
            inputId: '@',
            ngRequired: '<',
            checkFuture: '<',
            checkPast: '<',
            placeholder: '@',
            ngDisabled: '<',
            dvOnBlur: '&?'
        };
        this.controller = DatepickerController;
        this.controllerAs = 'vm';
        this.bindToController = true;
        this.template = template;
    }
    /* constructor() { this.link = this.unboundLink.bind(this); }*/
    DVDatepicker.factory = function () {
        var directive = function () { return new DVDatepicker(); };
        directive.$inject = [];
        return directive;
    };
    return DVDatepicker;
}());
exports.DVDatepicker = DVDatepicker;
var DatepickerController = /** @class */ (function () {
    function DatepickerController() {
    }
    // beispiel wie man auf changes eines attributes von aussen reagieren kann
    DatepickerController.prototype.$onChanges = function (changes) {
        if (changes.ngRequired && !changes.ngRequired.isFirstChange()) {
            this.dateRequired = changes.ngRequired.currentValue;
        }
    };
    //wird von angular aufgerufen
    DatepickerController.prototype.$onInit = function () {
        var _this = this;
        if (!this.ngModelCtrl) {
            return;
        }
        //wenn kein Placeholder gesetzt wird wird der standardplaceholder verwendet. kann mit placeholder="" ueberscrieben werden
        if (this.placeholder === undefined) {
            this.placeholder = 'tt.mm.jjjj';
        }
        else if (this.placeholder === '') {
            this.placeholder = undefined;
        }
        if (this.ngRequired) {
            this.dateRequired = this.ngRequired;
        }
        this.ngModelCtrl.$render = function () {
            _this.date = _this.ngModelCtrl.$viewValue;
        };
        this.ngModelCtrl.$formatters.unshift(DatepickerController.momentToString);
        this.ngModelCtrl.$parsers.push(DatepickerController.stringToMoment);
        this.ngModelCtrl.$validators['moment'] = function (modelValue, viewValue) {
            // if not required and view value empty, it's ok...
            if (!_this.dateRequired && !viewValue) {
                return true;
            }
            var value = modelValue || DatepickerController.stringToMoment(viewValue);
            return moment_1.default(value, DatepickerController.allowedFormats, true).isValid();
        };
        this.ngModelCtrl.$validators['future'] = function (modelValue, viewValue) {
            // if no check do nothing
            if (!_this.checkFuture) {
                return true;
            }
            // if not required and view value empty, it's ok...
            if (!viewValue) {
                return true;
            }
            // as longn not valid, don't check future
            var value = modelValue || DatepickerController.stringToMoment(viewValue);
            var date = moment_1.default(value, DatepickerController.allowedFormats, true);
            if (!date.isValid()) {
                return true;
            }
            return moment_1.default.now() > date.valueOf();
        };
        this.ngModelCtrl.$validators['past'] = function (modelValue, viewValue) {
            // if no check do nothing
            if (!_this.checkPast) {
                return true;
            }
            // if not required and view value empty, it's ok...
            if (!viewValue) {
                return true;
            }
            // as longn not valid, don't check past
            var value = modelValue || DatepickerController.stringToMoment(viewValue);
            var date = moment_1.default(value, DatepickerController.allowedFormats, true);
            if (!date.isValid()) {
                return true;
            }
            return moment_1.default().startOf('day').unix() <= date.valueOf() / 1000;
        };
    };
    DatepickerController.prototype.onBlur = function () {
        if (this.dvOnBlur) { // userdefined onBlur event
            this.dvOnBlur();
        }
        this.ngModelCtrl.$setTouched();
    };
    DatepickerController.prototype.updateModelValue = function () {
        this.ngModelCtrl.$setViewValue(this.date);
    };
    ;
    DatepickerController.momentToString = function (mom) {
        if (mom && mom.isValid()) {
            return mom.format(DatepickerController.defaultFormat);
        }
        return '';
    };
    DatepickerController.stringToMoment = function (date) {
        if (moment_1.default(date, DatepickerController.allowedFormats, true).isValid()) {
            return moment_1.default(date, DatepickerController.allowedFormats, true);
        }
        return null;
    };
    DatepickerController.$inject = [];
    DatepickerController.allowedFormats = ['D.M.YYYY', 'DD.MM.YYYY'];
    DatepickerController.defaultFormat = 'DD.MM.YYYY';
    return DatepickerController;
}());
exports.DatepickerController = DatepickerController;


/***/ }),

/***/ "d4Zy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(__webpack_require__("PJh5"));
var DateUtil = /** @class */ (function () {
    function DateUtil() {
    }
    /**
     * @param {string} localDateTimeString string with format YYYY-MM-DDTHH:mm:ss.SSS
     * @returns {?Moment}
     */
    DateUtil.localDateTimeToMoment = function (localDateTimeString) {
        if (!localDateTimeString) {
            return undefined;
        }
        var theMoment = moment_1.default(localDateTimeString, ['YYYY-MM-DDTHH:mm:ss.SSS', 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DDTHH:mm:ss.SSSZ'], true);
        return theMoment.isValid() ? theMoment : undefined;
    };
    /**
     * Calls momentToLocalDateFormat with the format by default 'YYYY-MM-DD'
     * @param aMoment
     * @returns {string}
     */
    DateUtil.momentToLocalDate = function (aMoment) {
        return DateUtil.momentToLocalDateFormat(aMoment, 'YYYY-MM-DD');
    };
    /**
     * @param {Moment} aMoment time instance
     * @param format format to use
     * @returns {?string} a Date (YYYY-MM-DD) representation of the given moment. NULL when aMoment is invalid
     */
    DateUtil.momentToLocalDateFormat = function (aMoment, format) {
        if (!aMoment) {
            return undefined;
        }
        return moment_1.default(aMoment).startOf('day').format(format);
    };
    /**
     * @param {Moment} aMoment time instance
     * @param format format for the time
     * @returns {?string} a Date (YYYY-MM-DD) representation of the given moment. undefined when aMoment is invalid
     */
    DateUtil.momentToLocalDateTimeFormat = function (aMoment, format) {
        if (!aMoment) {
            return undefined;
        }
        return moment_1.default(aMoment).format(format);
    };
    /**
     * @param {Moment} aMoment time instance
     * @returns {?string} a Date (YYYY-MM-DD) representation of the given moment. NULL when aMoment is invalid
     */
    DateUtil.momentToLocalDateTime = function (aMoment) {
        return DateUtil.momentToLocalDateTimeFormat(aMoment, 'YYYY-MM-DDTHH:mm:ss.SSS');
    };
    /**
     * @param {string} localDateString string with format YYYY-MM-DD
     * @returns {?moment}
     */
    DateUtil.localDateToMoment = function (localDateString) {
        var theMoment = moment_1.default(localDateString, 'YYYY-MM-DD', true);
        return theMoment.isValid() ? theMoment : undefined;
    };
    DateUtil.today = function () {
        return moment_1.default().startOf('day');
    };
    DateUtil.now = function () {
        return moment_1.default();
    };
    DateUtil.currentYear = function () {
        return moment_1.default().year();
    };
    return DateUtil;
}());
exports.default = DateUtil;


/***/ }),

/***/ "dI/G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSFinanzangabenDaten_1 = __importDefault(__webpack_require__("E8BN"));
var TSFinanzangaben = /** @class */ (function (_super) {
    __extends(TSFinanzangaben, _super);
    function TSFinanzangaben() {
        var _this = _super.call(this) || this;
        _this._finanzangabenDatenFS = new TSFinanzangabenDaten_1.default;
        return _this;
    }
    Object.defineProperty(TSFinanzangaben.prototype, "finanzangabenDatenFS", {
        get: function () {
            return this._finanzangabenDatenFS;
        },
        set: function (value) {
            this._finanzangabenDatenFS = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFinanzangaben.prototype, "finanzangabenDatenGS", {
        get: function () {
            return this._finanzangabenDatenGS;
        },
        set: function (value) {
            this._finanzangabenDatenGS = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFinanzangaben.prototype, "zustimmungSteuerpruefung", {
        get: function () {
            return this._zustimmungSteuerpruefung;
        },
        set: function (value) {
            this._zustimmungSteuerpruefung = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFinanzangaben.prototype, "zustimmungPruefungFondsuisse", {
        get: function () {
            return this._zustimmungPruefungFondsuisse;
        },
        set: function (value) {
            this._zustimmungPruefungFondsuisse = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFinanzangaben.prototype, "steuerdatenGeprueft", {
        get: function () {
            return this._steuerdatenGeprueft;
        },
        set: function (value) {
            this._steuerdatenGeprueft = value;
        },
        enumerable: true,
        configurable: true
    });
    TSFinanzangaben.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.finanzangabenDatenFS = this.deserializeOrCreate(restObject.finanzangabenDatenFS, new TSFinanzangabenDaten_1.default());
        this.finanzangabenDatenGS = this.deserializeOrNull(restObject.finanzangabenDatenGS, new TSFinanzangabenDaten_1.default());
        this.zustimmungSteuerpruefung = restObject.zustimmungSteuerpruefung;
        this.zustimmungPruefungFondsuisse = restObject.zustimmungPruefungFondsuisse;
        this.steuerdatenGeprueft = restObject.steuerdatenGeprueft;
        return this;
    };
    TSFinanzangaben.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.zustimmungSteuerpruefung = this.zustimmungSteuerpruefung;
        restObject.zustimmungPruefungFondsuisse = this.zustimmungPruefungFondsuisse;
        restObject.finanzangabenDatenFS = this.serializeOrInit(this.finanzangabenDatenFS, restObject.finanzangabenDatenFS);
        restObject.finanzangabenDatenGS = this.serializeOrInit(this.finanzangabenDatenGS, restObject.finanzangabenDatenGS);
        restObject.steuerdatenGeprueft = this.steuerdatenGeprueft;
        return restObject;
    };
    return TSFinanzangaben;
}(TSAbstractEntity_1.default));
exports.default = TSFinanzangaben;


/***/ }),

/***/ "dfPH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright © 2019 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var TSCockpitSelect_1 = __webpack_require__("qGSx");
var TSCockpitType_1 = __webpack_require__("Q2bv");
var TSCockpitTypeDTO = /** @class */ (function () {
    function TSCockpitTypeDTO() {
        this._cockpitSelect = TSCockpitSelect_1.TSCockpitSelect.LETZER_MONAT;
        this._cockpitType = TSCockpitType_1.TSCockpitType.GESUCHE_KANTON;
    }
    Object.defineProperty(TSCockpitTypeDTO.prototype, "datumVon", {
        get: function () {
            return this._datumVon;
        },
        set: function (value) {
            this._datumVon = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSCockpitTypeDTO.prototype, "datumBis", {
        get: function () {
            return this._datumBis;
        },
        set: function (value) {
            this._datumBis = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSCockpitTypeDTO.prototype, "cockpitSelect", {
        get: function () {
            return this._cockpitSelect;
        },
        set: function (value) {
            this._cockpitSelect = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSCockpitTypeDTO.prototype, "cockpitType", {
        get: function () {
            return this._cockpitType;
        },
        set: function (value) {
            this._cockpitType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSCockpitTypeDTO.prototype, "locale", {
        get: function () {
            return this._locale;
        },
        set: function (value) {
            this._locale = value;
        },
        enumerable: true,
        configurable: true
    });
    TSCockpitTypeDTO.prototype.serialize = function (restObject) {
        if (this.datumVon && this.datumBis) {
            restObject.datumVon = DateUtil_1.default.momentToLocalDateTime(this.datumVon);
            restObject.datumBis = DateUtil_1.default.momentToLocalDateTime(this.datumBis);
        }
        restObject.cockpitSelect = this.cockpitSelect;
        restObject.cockpitType = this.cockpitType;
        restObject.locale = this.locale;
        return restObject;
    };
    return TSCockpitTypeDTO;
}());
exports.default = TSCockpitTypeDTO;


/***/ }),

/***/ "dzCK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSVersicherungsbeitraegeSearchresultDTO_1 = __importDefault(__webpack_require__("TA1E"));
var TSVersicherungsbeitrag_1 = __importDefault(__webpack_require__("fGC3"));
var VersicherungsbeitragRS = /** @class */ (function () {
    /* @ngInject */
    function VersicherungsbeitragRS($http, REST_API, $log, $q) {
        this.$log = $log;
        this.$q = $q;
        this.serviceURL = REST_API + 'versicherungsbeitraege';
        this.http = $http;
    }
    VersicherungsbeitragRS.prototype.searchVersicherungsbeitraege = function (versicherungsbeitragSearch) {
        var _this = this;
        return this.http.post(this.serviceURL + '/search/', versicherungsbeitragSearch, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            _this.$log.debug('PARSING versicherungsbeitragDTO REST array object', response.data);
            return new TSVersicherungsbeitraegeSearchresultDTO_1.default().deserialize(response.data);
        });
    };
    VersicherungsbeitragRS.prototype.findVersicherungsbeitrag = function (versicherungsbeitragID) {
        var _this = this;
        return this.http.get(this.serviceURL + '/' + encodeURIComponent(versicherungsbeitragID))
            .then(function (response) {
            _this.$log.debug('PARSING versicherungsbeitrag REST object ', response.data);
            return new TSVersicherungsbeitrag_1.default().deserialize(response.data);
        });
    };
    VersicherungsbeitragRS.prototype.update = function (versicherungsbeitrag) {
        var vsToSend = {};
        vsToSend = versicherungsbeitrag.serialize(vsToSend);
        this.$log.debug('sending Versicherungsbeitrag:');
        this.$log.debug(vsToSend);
        return this.http.put(this.serviceURL, vsToSend, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            return new TSVersicherungsbeitrag_1.default().deserialize(response.data);
        });
    };
    VersicherungsbeitragRS.prototype.deleteBeitrag = function (versicherungsbeitragId) {
        return this.http.delete(this.serviceURL + '/deleteBeitrag/' + encodeURIComponent(versicherungsbeitragId), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    };
    VersicherungsbeitragRS.$inject = ['$http', 'REST_API', '$log', '$q'];
    return VersicherungsbeitragRS;
}());
exports.default = VersicherungsbeitragRS;


/***/ }),

/***/ "e606":
/***/ (function(module, exports) {

module.exports = "<div class=\"dv-anlaufstelle-list\"> <div class=\"table-responsive\"> <table st-table=\"displayedCollection\" st-safe-src=\"vm.anlaufstellen\" st-delay=\"20\" class=\"table fixedtable table-hover\" id=\"{{vm.tableId}}\" title=\"{{vm.tableTitle}}\" dv-st-table-refresh> <thead> <tr class=\"header-row\"> <th st-sort-default=\"true\" st-sort=\"name\" class=\"sortable\" data-translate=\"NAME\"></th> <th st-sort=\"kanton\" class=\"sortable\" data-translate=\"KANTON\"></th> <th st-sort=\"anlaufstelleArt\" class=\"sortable\" data-translate=\"ART_ANLAUFSTELLE\"></th> <th st-sort=\"gemeinden\" class=\"sortable row-gemeinden\" data-translate=\"GEMEINDEN\"></th> <th st-sort=\"verwalter.email\" class=\"sortable row-amtsstelleName\" data-translate=\"EMAIL\"></th> <th st-sort=\"vereinbarungAkzeptiert\" class=\"sortable row-ort\" data-translate=\"VEREINBARUNG_AKZEPTIERT\"></th> </tr> <tr> <th> <input st-search=\"name\" class=\"form-control dv-table__input\" type=\"text\"/> </th> <th> <div class=\"dv-select-style\"> <select st-input-event=\"change\" name=\"kanton\" id=\"kanton\" st-search=\"kantonOrKantoneFromGemeinden\" class=\"form-control dv-table__input\" ng-options=\"kanton.code.toString() for kanton in vm.getKantone() track by kanton.code\" ng-model=\"vm.selectedKanton\"> <option value=\"\">{{\"ALLE\" | translate}}</option> </select> </div> </th> <th> <div class=\"dv-select-style\"> <select st-input-event=\"change\" name=\"anlaufstelleType\" id=\"anlaufstelleType\" st-search=\"anlaufstelleType\" class=\"form-control dv-table__input\" ng-options=\"anlaufstelleType | translate for anlaufstelleType in vm.getAnlaufstelleTypes() track by anlaufstelleType\" ng-model=\"vm.selectedAnlaufstelleType\"> <option value=\"\">{{\"ALLE\" | translate}}</option> </select> </div> </th> <th> <input st-search=\"gemeinden.name\" class=\"form-control dv-table__input\" type=\"text\"/> </th> <th> <input st-search=\"verwalter.email\" class=\"form-control dv-table__input\" type=\"text\"/> </th> <th> </th> </tr> </thead> <tbody> <tr ng-repeat=\"row in displayedCollection\" st-select-row=\"row\" st-select-mode=\"single\" ng-click=\"vm.editClicked(row, $event)\" ng-class=\"{'marked-row' : vm.isInvalidVereinbarung(row)}\"> <td class=\"ellipsis\" title=\"{{row.name}}\" ng-bind=\"row.name\"></td> <td class=\"ellipsis\" title=\"{{row.kanton  | translate}}\" ng-bind=\"row.kantonOrKantoneFromGemeinden\"></td> <td class=\"ellipsis\" title=\"{{row.anlaufstelleType | translate}}\" ng-bind=\"row.anlaufstelleType | translate\"></td> <td class=\"ellipsis ellipsis-pre\" title=\"vm.getGemeinden(row.gemeinden)\" ng-bind=\"vm.getGemeinden(row.gemeinden)\"> </td> <td class=\"ellipsis\" title=\"{{row.verwalter.email}}\" ng-bind=\"row.verwalter.email\"></td> <td class=\"ellipsis\" title=\"{{row.vereinbarungAkzeptiert | amDateFormat : 'DD.MM.YYYY'}}\" ng-bind=\"row.vereinbarungAkzeptiert | amDateFormat : 'DD.MM.YYYY'\"></td> </tr> <tr> </tr><tr ng-if=\"displayedCollection === undefined || displayedCollection.length === 0\"> <td colspan=\"{{vm.getColumnsNumber()}}\" class=\"empty-table\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> <tfoot> <tr> <td colspan=\"{{vm.getColumnsNumber()}}\" class=\"text-center\"> <div st-pagination=\"\" st-items-by-page=\"30\" st-displayed-pages=\"10\"></div> </td> </tr> </tfoot> </table> </div> </div> ";

/***/ }),

/***/ "eHYE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var TSZahlungsauftragDTO = /** @class */ (function () {
    function TSZahlungsauftragDTO() {
    }
    Object.defineProperty(TSZahlungsauftragDTO.prototype, "zahlungsauftragId", {
        get: function () {
            return this._zahlungsauftragId;
        },
        set: function (value) {
            this._zahlungsauftragId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSZahlungsauftragDTO.prototype, "ref", {
        get: function () {
            return this._ref;
        },
        set: function (value) {
            this._ref = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSZahlungsauftragDTO.prototype, "timestampErstellt", {
        get: function () {
            return this._timestampErstellt;
        },
        set: function (value) {
            this._timestampErstellt = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSZahlungsauftragDTO.prototype, "empfaenger", {
        get: function () {
            return this._empfaenger;
        },
        set: function (value) {
            this._empfaenger = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSZahlungsauftragDTO.prototype, "beitrag", {
        get: function () {
            return this._beitrag;
        },
        set: function (value) {
            this._beitrag = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSZahlungsauftragDTO.prototype, "besitzerName", {
        get: function () {
            return this._besitzerName;
        },
        set: function (value) {
            this._besitzerName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSZahlungsauftragDTO.prototype, "painfileId", {
        get: function () {
            return this._painfileId;
        },
        set: function (value) {
            this._painfileId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSZahlungsauftragDTO.prototype, "excelExportId", {
        get: function () {
            return this._excelExportId;
        },
        set: function (value) {
            this._excelExportId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSZahlungsauftragDTO.prototype, "datumFaellig", {
        get: function () {
            return this._datumFaellig;
        },
        set: function (value) {
            this._datumFaellig = value;
        },
        enumerable: true,
        configurable: true
    });
    TSZahlungsauftragDTO.prototype.deserialize = function (restObject) {
        this.zahlungsauftragId = restObject.zahlungsauftragId;
        this.ref = restObject.ref;
        this.timestampErstellt = DateUtil_1.default.localDateTimeToMoment(restObject.timestampErstellt);
        this.datumFaellig = DateUtil_1.default.localDateToMoment(restObject.datumFaellig);
        this.empfaenger = restObject.empfaenger;
        this.besitzerName = restObject.besitzerName;
        this.beitrag = restObject.beitrag;
        this.painfileId = restObject.painfileId;
        this.excelExportId = restObject.excelExportId;
        return this;
    };
    return TSZahlungsauftragDTO;
}());
exports.default = TSZahlungsauftragDTO;


/***/ }),

/***/ "eLUI":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright © 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt\n * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n */.modal-header--map{padding:25px 58px}.modal-header--map h2:after{border:none}.modal-header--map span{font-size:16px;line-height:25px;letter-spacing:1px}.modal-body--map{padding:0 58px}.modal-footer--map{text-align:center;padding:30px}@media(min-width:1025px){.map-modal-window .modal-dialog{width:60%;height:700px;left:50%;top:50%;transform:translate(-50%,-50%)!important;margin:0}}.map-modal-window ng-map{height:450px!important}", ""]);

// exports


/***/ }),

/***/ "eUxz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSSchadenObjektTyp;
(function (TSSchadenObjektTyp) {
    TSSchadenObjektTyp[TSSchadenObjektTyp["KULTURLAND"] = 'KULTURLAND'] = "KULTURLAND";
    TSSchadenObjektTyp[TSSchadenObjektTyp["OBSTBAUM_REBSTOECKE"] = 'OBSTBAUM_REBSTOECKE'] = "OBSTBAUM_REBSTOECKE";
    TSSchadenObjektTyp[TSSchadenObjektTyp["STRASSEN_WEGE"] = 'STRASSEN_WEGE'] = "STRASSEN_WEGE";
    TSSchadenObjektTyp[TSSchadenObjektTyp["BRUECKEN_DURCHLAESSE"] = 'BRUECKEN_DURCHLAESSE'] = "BRUECKEN_DURCHLAESSE";
    TSSchadenObjektTyp[TSSchadenObjektTyp["UFER_BACHBAUTEN"] = 'UFER_BACHBAUTEN'] = "UFER_BACHBAUTEN";
    TSSchadenObjektTyp[TSSchadenObjektTyp["STUETZMAUER_REBMAUERN"] = 'STUETZMAUER_REBMAUERN'] = "STUETZMAUER_REBMAUERN";
    TSSchadenObjektTyp[TSSchadenObjektTyp["HAUSUMSCHWUNG"] = 'HAUSUMSCHWUNG'] = "HAUSUMSCHWUNG";
    TSSchadenObjektTyp[TSSchadenObjektTyp["EINFRIEDUNG"] = 'EINFRIEDUNG'] = "EINFRIEDUNG";
    TSSchadenObjektTyp[TSSchadenObjektTyp["LEITUNGEN_AUSSERHALB_DER_GEBAEUDE"] = 'LEITUNGEN_AUSSERHALB_DER_GEBAEUDE'] = "LEITUNGEN_AUSSERHALB_DER_GEBAEUDE";
    TSSchadenObjektTyp[TSSchadenObjektTyp["WALD"] = 'WALD'] = "WALD";
})(TSSchadenObjektTyp = exports.TSSchadenObjektTyp || (exports.TSSchadenObjektTyp = {}));
function getTSSchadenObjektValues() {
    return [
        TSSchadenObjektTyp.KULTURLAND,
        TSSchadenObjektTyp.OBSTBAUM_REBSTOECKE,
        TSSchadenObjektTyp.STRASSEN_WEGE,
        TSSchadenObjektTyp.BRUECKEN_DURCHLAESSE,
        TSSchadenObjektTyp.UFER_BACHBAUTEN,
        TSSchadenObjektTyp.STUETZMAUER_REBMAUERN,
        TSSchadenObjektTyp.HAUSUMSCHWUNG,
        TSSchadenObjektTyp.EINFRIEDUNG,
        TSSchadenObjektTyp.LEITUNGEN_AUSSERHALB_DER_GEBAEUDE,
        TSSchadenObjektTyp.WALD
    ];
}
exports.getTSSchadenObjektValues = getTSSchadenObjektValues;


/***/ }),

/***/ "em2S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
var TSAnlaufstelle_1 = __importDefault(__webpack_require__("B4Ew"));
var TSAnlaufstelleWithUsers = /** @class */ (function (_super) {
    __extends(TSAnlaufstelleWithUsers, _super);
    function TSAnlaufstelleWithUsers() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._sachbearbeiter = [];
        _this._schaetzer = [];
        return _this;
    }
    Object.defineProperty(TSAnlaufstelleWithUsers.prototype, "sachbearbeiter", {
        get: function () {
            return this._sachbearbeiter;
        },
        set: function (value) {
            this._sachbearbeiter = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSAnlaufstelleWithUsers.prototype, "schaetzer", {
        get: function () {
            return this._schaetzer;
        },
        set: function (value) {
            this._schaetzer = value;
        },
        enumerable: true,
        configurable: true
    });
    TSAnlaufstelleWithUsers.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        if (restObject.sachbearbeiter) {
            this.sachbearbeiter = restObject.sachbearbeiter.map(TSBenutzer_1.default.getDeserializer);
        }
        if (restObject.schaetzer) {
            this.schaetzer = restObject.schaetzer.map(TSBenutzer_1.default.getDeserializer);
        }
        return this;
    };
    TSAnlaufstelleWithUsers.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.sachbearbeiter = this.arrayToRestObject(this.sachbearbeiter);
        restObject.schaetzer = this.arrayToRestObject(this.schaetzer);
        return restObject;
    };
    return TSAnlaufstelleWithUsers;
}(TSAnlaufstelle_1.default));
exports.default = TSAnlaufstelleWithUsers;


/***/ }),

/***/ "en8u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ew9Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSDokumentType_1 = __webpack_require__("/gTe");
var TSVorleistung_1 = __importDefault(__webpack_require__("3494"));
var TSVorleistungDaten_1 = __importDefault(__webpack_require__("3Ly2"));
var abstractModelManagerController_1 = __importDefault(__webpack_require__("S1yE"));
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var styles = __webpack_require__("O4UL");
var template = __webpack_require__("74j4");
var VorleistungEditViewComponentConfig = /** @class */ (function () {
    function VorleistungEditViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = VorleistungViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            vorleistung: '<',
            schadenfallId: '<',
            schaetzung: '<',
        };
    }
    return VorleistungEditViewComponentConfig;
}());
exports.VorleistungEditViewComponentConfig = VorleistungEditViewComponentConfig;
var VorleistungViewController = /** @class */ (function (_super) {
    __extends(VorleistungViewController, _super);
    /* @ngInject */
    function VorleistungViewController(dvBernUtil, schadenfallModelManager, $q, $scope, $translate, $log, $state, $stateParams) {
        var _this = _super.call(this, schadenfallModelManager, $scope, $state.current.name) || this;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$translate = $translate;
        _this.$log = $log;
        _this.$state = $state;
        _this.$stateParams = $stateParams;
        _this.doctype = TSDokumentType_1.TSDocumentType.VORLEISTUNG_DOC;
        return _this;
    }
    VorleistungViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        if (this.vorleistung) {
            this.initialModel = this.vorleistung;
            this.model = angular.copy(this.vorleistung);
        }
        else {
            this.vorleistung = new TSVorleistung_1.default();
            this.vorleistung.schaetzung = this.schaetzung;
            this.vorleistung.vorleistungDatenFS = new TSVorleistungDaten_1.default();
            this.$log.warn('initialized vorleistung to edit directly in view, should pass vorleistung to edit along');
        }
    };
    VorleistungViewController.prototype.saveVorleistung = function () {
        var _this = this;
        if (this.isModelValid() && this.vorleistung) {
            this.schadenfallModelManager.saveVorleistung(this.getModel()).then(function (result) {
                _this.navigateAway();
            });
        }
        else {
            this.$log.debug('Form was not valid');
        }
    };
    VorleistungViewController.prototype.cancelVorleistung = function () {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.navigateAway();
    };
    VorleistungViewController.prototype.navigateAway = function () {
        var nextPage = this.schaetzung ? 'schaetzung' : 'aufwaende';
        this.$state.go(nextPage, { schadenfallId: this.schadenfallId });
    };
    VorleistungViewController.prototype.isVorleistungReadonly = function () {
        //FIXME FS-706 temporary hack. Solve with separate view
        return (this.schaetzung &&
            !(this.schadenfallModelManager.isSchadenfallStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER) ||
                this.schadenfallModelManager.isSchadenfallStatus(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE)));
    };
    VorleistungViewController.$inject = ['DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$log', '$state'];
    return VorleistungViewController;
}(abstractModelManagerController_1.default));
exports.VorleistungViewController = VorleistungViewController;


/***/ }),

/***/ "f17n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DVLanguageSelectComponentConfig = /** @class */ (function () {
    function DVLanguageSelectComponentConfig() {
        this.transclude = false;
        this.template = __webpack_require__("gtL8");
        this.controller = DVLanguageSelectController;
        this.controllerAs = 'vm';
    }
    return DVLanguageSelectComponentConfig;
}());
exports.DVLanguageSelectComponentConfig = DVLanguageSelectComponentConfig;
var DVLanguageSelectController = /** @class */ (function () {
    /* @ngInject */
    function DVLanguageSelectController(CONSTANTS, $translate) {
        this.CONSTANTS = CONSTANTS;
        this.$translate = $translate;
    }
    DVLanguageSelectController.prototype.langDe = function () {
        this.$translate.use('de');
    };
    DVLanguageSelectController.prototype.langFr = function () {
        this.$translate.use('fr');
    };
    DVLanguageSelectController.prototype.langIt = function () {
        this.$translate.use('it');
    };
    DVLanguageSelectController.prototype.changeLang = function (lang) {
        this.$translate.use(lang);
    };
    DVLanguageSelectController.$inject = ['CONSTANTS', '$translate'];
    return DVLanguageSelectController;
}());
exports.DVLanguageSelectController = DVLanguageSelectController;


/***/ }),

/***/ "fE7S":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("uvcM");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./gesuch.module.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./gesuch.module.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "fFyF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
testpageRun.$inject = ['RouterHelper'];
/* @ngInject */
function testpageRun(routerHelper) {
    routerHelper.configureStates(getStates());
}
exports.testpageRun = testpageRun;
function getStates() {
    return [
        {
            name: 'testpage',
            template: '<dv-testpage-view flex="auto" class="overflow-scroll"></dv-testpage-view>',
            url: '/testpage',
        },
    ];
}


/***/ }),

/***/ "fGC3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var TSVersicherungsbeitragStatus_1 = __webpack_require__("jJP+");
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSBeitrag_1 = __importDefault(__webpack_require__("Bftz"));
var TSGemeinde_1 = __importDefault(__webpack_require__("nKms"));
var TSGesuchsteller_1 = __importDefault(__webpack_require__("o8Fj"));
var TSVersicherung_1 = __importDefault(__webpack_require__("aku3"));
var TSVersicherungsbeitrag = /** @class */ (function (_super) {
    __extends(TSVersicherungsbeitrag, _super);
    function TSVersicherungsbeitrag() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._documentIdsToConnect = [];
        return _this;
    }
    Object.defineProperty(TSVersicherungsbeitrag.prototype, "schadendatum", {
        get: function () {
            return this._schadendatum;
        },
        set: function (value) {
            this._schadendatum = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitrag.prototype, "bemerkung", {
        get: function () {
            return this._bemerkung;
        },
        set: function (value) {
            this._bemerkung = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitrag.prototype, "status", {
        get: function () {
            return this._status;
        },
        set: function (value) {
            this._status = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitrag.prototype, "policeNummer", {
        get: function () {
            return this._policeNummer;
        },
        set: function (value) {
            this._policeNummer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitrag.prototype, "externalSchadenNr", {
        get: function () {
            return this._externalSchadenNr;
        },
        set: function (value) {
            this._externalSchadenNr = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitrag.prototype, "schadenArt", {
        get: function () {
            return this._schadenArt;
        },
        set: function (value) {
            this._schadenArt = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitrag.prototype, "gemeinde", {
        get: function () {
            return this._gemeinde;
        },
        set: function (value) {
            this._gemeinde = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitrag.prototype, "versicherung", {
        get: function () {
            return this._versicherung;
        },
        set: function (value) {
            this._versicherung = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitrag.prototype, "gesuchsteller", {
        get: function () {
            return this._gesuchsteller;
        },
        set: function (value) {
            this._gesuchsteller = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitrag.prototype, "schadenArtAndere", {
        get: function () {
            return this._schadenArtAndere;
        },
        set: function (value) {
            this._schadenArtAndere = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitrag.prototype, "documentIdsToConnect", {
        get: function () {
            return this._documentIdsToConnect;
        },
        set: function (value) {
            this._documentIdsToConnect = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitrag.prototype, "beitrag", {
        get: function () {
            return this._beitrag;
        },
        set: function (value) {
            this._beitrag = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitrag.prototype, "wiederherstellungskosten", {
        get: function () {
            return this._wiederherstellungskosten;
        },
        set: function (value) {
            this._wiederherstellungskosten = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSVersicherungsbeitrag.prototype, "ermittelterSchaden", {
        get: function () {
            return this._ermittelterSchaden;
        },
        set: function (value) {
            this._ermittelterSchaden = value;
        },
        enumerable: true,
        configurable: true
    });
    TSVersicherungsbeitrag.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.schadendatum = DateUtil_1.default.localDateToMoment(restObject.schadendatum);
        this.bemerkung = restObject.bemerkung;
        this.schadenArt = restObject.schadenArt;
        this.externalSchadenNr = restObject.externalSchadenNr;
        this.policeNummer = restObject.policeNummer;
        this.status = restObject.status;
        this.schadenArtAndere = restObject.schadenArtAndere;
        this.wiederherstellungskosten = restObject.wiederherstellungskosten;
        this.ermittelterSchaden = restObject.ermittelterSchaden;
        if (restObject.gesuchsteller) {
            this.gesuchsteller = new TSGesuchsteller_1.default().deserialize(restObject.gesuchsteller);
        }
        if (restObject.gemeinde) {
            this.gemeinde = new TSGemeinde_1.default().deserialize(restObject.gemeinde);
        }
        if (restObject.versicherung) {
            this.versicherung = new TSVersicherung_1.default().deserialize(restObject.versicherung);
        }
        if (restObject.beitrag) {
            this.beitrag = new TSBeitrag_1.default().deserialize(restObject.beitrag);
        }
        return this;
    };
    TSVersicherungsbeitrag.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.bemerkung = this.bemerkung;
        if (this.schadendatum) {
            restObject.schadendatum = DateUtil_1.default.momentToLocalDate(this.schadendatum);
        }
        restObject.bemerkung = this.bemerkung;
        restObject.schadenArt = this.schadenArt;
        restObject.externalSchadenNr = this.externalSchadenNr;
        restObject.policeNummer = this.policeNummer;
        restObject.status = this.status;
        restObject.wiederherstellungskosten = this.wiederherstellungskosten;
        restObject.gesuchsteller = this.serializeOrInit(this.gesuchsteller, restObject.gesuchsteller);
        restObject.gemeinde = this.serializeOrInit(this.gemeinde, restObject.gemeinde);
        restObject.versicherung = this.serializeOrInit(this.versicherung, restObject.versicherung);
        restObject.schadenArtAndere = this.schadenArtAndere;
        restObject.beitrag = this.serializeOrInit(this.beitrag, restObject.beitrag);
        restObject.ermittelterSchaden = this.ermittelterSchaden;
        return restObject;
    };
    TSVersicherungsbeitrag.prototype.init = function () {
        this.status = TSVersicherungsbeitragStatus_1.TSVersicherungsbeitragStatus.NEU;
        return this;
    };
    TSVersicherungsbeitrag.prototype.getAnrechenbarerSchaden = function (prozentsatz) {
        if (prozentsatz === void 0) { prozentsatz = 100; }
        var schaden = this.ermittelterSchaden || 0;
        return (schaden - (this.gesuchsteller.getEinkommensabzug() + this.gesuchsteller.getVermoegenssabzug(this.schadendatum, schaden))) * (prozentsatz / 100);
    };
    return TSVersicherungsbeitrag;
}(TSAbstractEntity_1.default));
exports.default = TSVersicherungsbeitrag;


/***/ }),

/***/ "fctY":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "fiK7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAdresse_1 = __importDefault(__webpack_require__("aL5m"));
var TSAbstractPersonEntity_1 = __importDefault(__webpack_require__("0jch"));
var TSGesuchsPersonDaten = /** @class */ (function (_super) {
    __extends(TSGesuchsPersonDaten, _super);
    function TSGesuchsPersonDaten() {
        var _this = _super.call(this) || this;
        _this._adresse = new TSAdresse_1.default();
        return _this;
    }
    Object.defineProperty(TSGesuchsPersonDaten.prototype, "adresse", {
        get: function () {
            return this._adresse;
        },
        set: function (value) {
            this._adresse = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGesuchsPersonDaten.prototype, "mail", {
        get: function () {
            return this._mail;
        },
        set: function (value) {
            this._mail = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGesuchsPersonDaten.prototype, "telefon", {
        get: function () {
            return this._telefon;
        },
        set: function (value) {
            this._telefon = value;
        },
        enumerable: true,
        configurable: true
    });
    TSGesuchsPersonDaten.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.mail = restObject.mail;
        this.telefon = restObject.telefon;
        this.adresse = this.deserializeOrNull(restObject.adresse, new TSAdresse_1.default);
        return this;
    };
    TSGesuchsPersonDaten.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.mail = this.mail === '' ? null : this.mail;
        restObject.telefon = this.telefon;
        restObject.adresse = this.serializeOrInit(this.adresse, restObject.adresse);
        return restObject;
    };
    return TSGesuchsPersonDaten;
}(TSAbstractPersonEntity_1.default));
exports.default = TSGesuchsPersonDaten;


/***/ }),

/***/ "fkRl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"dv-dokumentupload row\" ng-form=\"vm.dokumentuploadForm\"> <div class=\"col-sm-12\"> <a ngf-select=\"vm.uploadAnhaenge($files)\" ngf-multiple=\"true\" class=\"dv-dokumentupload__link btn btn-serf-red\" aria-hidden=\"true\"> <span class=\"btn-ico fa {{vm.buttonSymbol}}\" ng-class=\"{'fa-camera': !vm.buttonSymbol}\"></span> <span ng-if=\"!vm.buttonText\" data-translate=\"HINZUFUEGEN\"></span> <span ng-if=\"vm.buttonText\" ng-bind=\"vm.buttonText\"></span> </a> </div> <div class=\"col-sm-12 begleittext\" ng-if=\"!vm.hasDoc() && !vm.disableBegleittext\"> <span data-translate=\"{{vm.begleitText}}\"></span> </div> <div class=\"col-sm-12 dv-dokumentupload__thumbs begleittext\"> <div ng-repeat=\"dokument in vm.dokumente\" class=\"dv-dokumentupload__thumbelement\"> <div class=\"dv-dokumentupload__thumbcontent\"> <img ng-click=\"vm.download(dokument)\" ng-if=\"vm.hasThumbnail(dokument)\" ng-src=\"{{vm.getThumbnailPath(dokument)}}\" class=\"dv-dokumentupload__thumbimage\" alt=\"thumbnail\"> <img ng-click=\"vm.download(dokument)\" ng-if=\"!vm.hasThumbnail(dokument)\" src=\"" + __webpack_require__("bzk6") + "\" class=\"dv-dokumentupload__thumbnoimage\" alt=\"thumbnail\"> <div class=\"dv-dokumentupload__thumbfilename\">{{dokument.filename}}</div> <div ng-if=\"!vm.readonly\"> <span class=\"dv-dokumentupload__thumbfilesize\">{{dokument.filesize}}</span> <span ng-click=\"vm.deleteDokument(dokument)\" class=\"dv-dokumentupload__thumbdelete fa fa-trash-o\"></span> </div> </div> </div> </div> <div class=\"col-sm-12\"> <input type=\"hidden\" name=\"doccountvalidation\" ng-model=\"vm.doccountvalid\"/> <div ng-messages=\"vm.dokumentuploadForm.doccountvalidation.$error\" ng-show=\"vm.parentForm.$submitted\" class=\"dv-dokumentalert dv-alert-box dv-alert-box--small dv-alert-box--error dv-alert-box--input-alert\"> <div class=\"dv-alert-box__message\"> <span ng-message=\"doccount\" role=\"alert\" data-translate=\"ERROR_DOCCOUNT\" data-translate-value-count=\"{{vm.requiredDocs | number :0}}\"></span> </div> </div> </div> </div> ";

/***/ }),

/***/ "fqwK":
/***/ (function(module, exports) {

module.exports = "<div class=\"password-change row\"> <div class=\"col-sm-12\"> <div class=\"row mainbuttons\"> <div class=\"col-sm-2 col-sm-offset-6\"> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.back()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> </div> </div> </div> ";

/***/ }),

/***/ "ftfs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSHTTPEvent_1 = __webpack_require__("DQJl");
/**
 * this interceptor boradcasts a REQUEST_FINISHED event whenever a rest service responds
 */
var HttpResponseInterceptor = /** @class */ (function () {
    /* @ngInject */
    function HttpResponseInterceptor($rootScope, $q) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.responseError = function (response) {
            _this.$rootScope.$broadcast(TSHTTPEvent_1.TSHTTPEvent[TSHTTPEvent_1.TSHTTPEvent.REQUEST_FINISHED], response);
            return _this.$q.reject(response);
        };
        this.response = function (response) {
            _this.$rootScope.$broadcast(TSHTTPEvent_1.TSHTTPEvent[TSHTTPEvent_1.TSHTTPEvent.REQUEST_FINISHED], response);
            return response;
        };
    }
    HttpResponseInterceptor.$inject = ['$rootScope', '$q'];
    return HttpResponseInterceptor;
}());
exports.default = HttpResponseInterceptor;


/***/ }),

/***/ "fu9Z":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("hwXT");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./benutzerEditView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./benutzerEditView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "fz+m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSSchadenArt;
(function (TSSchadenArt) {
    TSSchadenArt[TSSchadenArt["ERDRUTSCH"] = 'ERDRUTSCH'] = "ERDRUTSCH";
    TSSchadenArt[TSSchadenArt["UEBERSCHWEMMUNG"] = 'UEBERSCHWEMMUNG'] = "UEBERSCHWEMMUNG";
    TSSchadenArt[TSSchadenArt["UEBERFUEHRUNG"] = 'UEBERFUEHRUNG'] = "UEBERFUEHRUNG";
    TSSchadenArt[TSSchadenArt["RUEFE"] = 'RUEFE'] = "RUEFE";
    TSSchadenArt[TSSchadenArt["LAWINE"] = 'LAWINE'] = "LAWINE";
    TSSchadenArt[TSSchadenArt["SCHNEEDRUCK"] = 'SCHNEEDRUCK'] = "SCHNEEDRUCK";
    TSSchadenArt[TSSchadenArt["STURMWIND"] = 'STURMWIND'] = "STURMWIND";
    TSSchadenArt[TSSchadenArt["FELSSTURZ"] = 'FELSSTURZ'] = "FELSSTURZ";
    TSSchadenArt[TSSchadenArt["STEINSCHLAG"] = 'STEINSCHLAG'] = "STEINSCHLAG";
    TSSchadenArt[TSSchadenArt["TROCKENHEIT"] = 'TROCKENHEIT'] = "TROCKENHEIT";
    TSSchadenArt[TSSchadenArt["ANDERE"] = 'ANDERE'] = "ANDERE";
})(TSSchadenArt = exports.TSSchadenArt || (exports.TSSchadenArt = {}));
function getTSSchadenArtValues() {
    return [
        TSSchadenArt.ERDRUTSCH,
        TSSchadenArt.UEBERSCHWEMMUNG,
        TSSchadenArt.UEBERFUEHRUNG,
        TSSchadenArt.RUEFE,
        TSSchadenArt.LAWINE,
        TSSchadenArt.SCHNEEDRUCK,
        TSSchadenArt.STURMWIND,
        TSSchadenArt.FELSSTURZ,
        TSSchadenArt.STEINSCHLAG,
        TSSchadenArt.TROCKENHEIT,
        TSSchadenArt.ANDERE
    ];
}
exports.getTSSchadenArtValues = getTSSchadenArtValues;
function schadenartPrefix() {
    return 'TSSchadenArt_';
}
exports.schadenartPrefix = schadenartPrefix;


/***/ }),

/***/ "g/Yr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var abstractModelController_1 = __importDefault(__webpack_require__("VDYy"));
var TSBeitragStatus_1 = __webpack_require__("RtaT");
var TSVersicherungsbeitragStatus_1 = __webpack_require__("jJP+");
var TSBeitrag_1 = __importDefault(__webpack_require__("Bftz"));
var TSVersicherungsbeitrag_1 = __importDefault(__webpack_require__("fGC3"));
var styles = __webpack_require__("sMzP");
var template = __webpack_require__("GOMC");
var BeitragViewComponentConfig = /** @class */ (function () {
    function BeitragViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = BeitragViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            versicherungsbeitrag: '<',
        };
    }
    return BeitragViewComponentConfig;
}());
exports.BeitragViewComponentConfig = BeitragViewComponentConfig;
var BeitragViewController = /** @class */ (function (_super) {
    __extends(BeitragViewController, _super);
    /* @ngInject */
    function BeitragViewController(dvBernUtil, $q, $scope, $translate, $log, $state, versicherungsbeitragModelManager, zahlungsauftragRS) {
        var _this = _super.call(this, $scope) || this;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$translate = $translate;
        _this.$log = $log;
        _this.$state = $state;
        _this.versicherungsbeitragModelManager = versicherungsbeitragModelManager;
        _this.zahlungsauftragRS = zahlungsauftragRS;
        return _this;
    }
    BeitragViewController.prototype.$onInit = function () {
        var _this = this;
        _super.prototype.$onInit.call(this);
        if (!this.versicherungsbeitrag) {
            this.versicherungsbeitrag = new TSVersicherungsbeitrag_1.default();
            this.$log.warn('initialized versicherungsbeitrag to edit directly in view, should pass versicherungsbeitrag to edit along');
        }
        else {
            this.initialModel = this.versicherungsbeitrag;
            this.model = angular.copy(this.versicherungsbeitrag);
        }
        this.readonly = !TSVersicherungsbeitragStatus_1.isStatusInBearbeitung(this.model.status);
        if (this.model.status === TSVersicherungsbeitragStatus_1.TSVersicherungsbeitragStatus.AUSZAHLUNG && this.model.beitrag === undefined) {
            this.model.beitrag = new TSBeitrag_1.default();
        }
        if (this.model.beitrag && this.model.beitrag.beitragStatus === TSBeitragStatus_1.TSBeitragStatus.AUSGEFUEHRT) {
            this.zahlungsauftragRS.getZahlungsauftraegeForBeitrag(this.model.beitrag.id).then(function (response) {
                _this.zahlungsauftrag = response;
            });
        }
    };
    BeitragViewController.prototype.cancelVersicherungsbeitrag = function () {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
    };
    BeitragViewController.prototype.getViewTitle = function () {
        return this.dvBernUtil.getVersicherungsbeitragViewTitle(this.model);
    };
    BeitragViewController.prototype.saveVersicherungsbeitrag = function () {
        var _this = this;
        if (this.isModelValid() && this.model) {
            this.versicherungsbeitragModelManager.saveVersicherungsbeitrag(this.model).then(function (result) {
                _this.initialModel = result;
                _this.model = angular.copy(_this.initialModel);
            });
        }
        else {
            this.$log.debug('Form was not valid when saving versicherungsbeitrag');
        }
    };
    BeitragViewController.prototype.saveVersicherungsBeitragBeitrag = function () {
        var _this = this;
        if (this.isModelValid() && this.model && this.model.beitrag) {
            this.versicherungsbeitragModelManager.saveVersicherungsbeitragBeitrag(this.model.beitrag).then(function (result) {
                _this.$state.go('versicherungsbeitraege');
            });
        }
        else {
            this.$log.debug('Form was not valid when saving versicherungsbeitragbeitrag');
        }
    };
    BeitragViewController.prototype.cancelVersicherungsbeitragbeitrag = function () {
        this.model.beitrag = undefined;
    };
    BeitragViewController.prototype.addAllowed = function () {
        //ist der ermittelte schaden gespeichert? nur dann koennen wir einen Beitrag erfassen
        var isErmittelterSchadenSet = this.initialModel.ermittelterSchaden !== undefined && this.initialModel.ermittelterSchaden !== null;
        return isErmittelterSchadenSet && !this.getModel().beitrag;
    };
    BeitragViewController.prototype.addBeitrag = function () {
        if (this.isModelValid() && this.model) {
            this.model.beitrag = new TSBeitrag_1.default();
        }
    };
    BeitragViewController.prototype.deleteBeitrag = function () {
        var _this = this;
        if (this.model.beitrag && !this.model.beitrag.isNew()) {
            //gespeicherten Beitrag loeschen
            this.versicherungsbeitragModelManager.deleteBeitrag().then(function (result) {
                _this.initialModel = result;
                _this.model = angular.copy(_this.initialModel);
                _this.readonly = false;
            });
            return;
        }
        else {
            //    ungespeicherten Beitrag zuruecksetzen (entweder aus initial model wenn vorhanden oder sonst neues leeres
            if (this.initialModel.beitrag) {
                this.model.beitrag = angular.copy(this.initialModel.beitrag);
            }
        }
        this.model = this.versicherungsbeitragModelManager.clearBeitrag();
        this.readonly = false;
    };
    BeitragViewController.prototype.isBeitragReadonly = function () {
        return !!this.model.beitrag && this.model.beitrag.beitragStatus !== TSBeitragStatus_1.TSBeitragStatus.NICHT_FREIGEGEBEN;
    };
    BeitragViewController.$inject = ['DVBernUtil', '$q', '$scope', '$translate', '$log', '$state', 'VersicherungsbeitragModelManager',
        'ZahlungsauftragRS'];
    return BeitragViewController;
}(abstractModelController_1.default));
exports.BeitragViewController = BeitragViewController;


/***/ }),

/***/ "g0B/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var moment_1 = __importDefault(__webpack_require__("PJh5"));
var template = __webpack_require__("l/Tn");
/**
 * Verwendung:
 * - gs: Wert, den der Gesuchsteller eingegeben hat
 * - fs: Wert, der von fondssuisse angepasst wurde
 *
 * Attribute fuer Eingaben-Blocks (zusammengehoerende Felder):
 * - specificBisherText: Falls einfach der GS-Wert als Bisher angezeigt werden soll. Z.B. Checkbox "Fachstelle": Wir
 *      wollen als Bisher-Text nicht "Fs", sondern "Fachstelle X, mit 50%, vom 01.01.2015 bis 31.12.2015"
 * - blockExisted: Gibt an, ob der Block ueberhaupt vom GS ausgefuellt wurde. Falls nein, muss *jede* Eingabe von FS
 *      als Korrektur angezeigt werden
 * - showIfBisherNone: Zeigt, ob "Keine Eingabe" angezeigt werden soll, wenn es keinen Bisher-Wert
 *      gibt. Normalerweise wollen wir das. Ausnahme sind Blocks, wo wir das "Keine Eingabe" *pro Block* anzeigen wollen
 *      und nicht unter jedem Feld.
 */
var DvBisherComponentConfig = /** @class */ (function () {
    function DvBisherComponentConfig() {
        this.transclude = false;
        this.bindings = {
            gs: '<',
            fs: '<',
            errorObject: '<for',
            specificBisherText: '<?',
            prefix: '<?',
            decimal: '<?',
            unit: '@?',
            blockExisted: '<?',
            showIfBisherNone: '<?',
            property: '@',
        };
        this.template = template;
        this.controller = DvBisherController;
        this.controllerAs = 'vm';
    }
    return DvBisherComponentConfig;
}());
exports.DvBisherComponentConfig = DvBisherComponentConfig;
var DvBisherController = /** @class */ (function () {
    /* @ngInject */
    function DvBisherController($translate, $log, $filter, $attrs) {
        this.$translate = $translate;
        this.$log = $log;
        this.$filter = $filter;
        this.$attrs = $attrs;
    }
    DvBisherController.prototype.$onInit = function () {
        this.hasMargin = 'hasMargin' in this.$attrs;
        this.forcestring = 'forcestring' in this.$attrs;
        this.isTextarea = 'textarea' in this.$attrs;
        this.forcefloor = 'forcefloor' in this.$attrs;
        if (this.showIfBisherNone === undefined) { //wenn nicht von aussen gesetzt auf true
            this.showIfBisherNone = true;
        }
        this.GSContainerDefined = this.gs !== undefined;
        this.FSContainerDefined = this.fs !== undefined;
        this.propertyDefined = this.property !== undefined;
        if (this.GSContainerDefined && this.propertyDefined) {
            if (Object.getOwnPropertyNames(this.gs).indexOf('_' + this.property) < 0) {
                this.$log.error('dv-bisher error \nproperty: "' + this.property + '" doesn\'t exist on container');
            }
        }
        else {
            this.$log.debug('dv-bisher error \nproperty: ' + this.property + '\ncontainer: ' + this.gs);
        }
    };
    DvBisherController.prototype.getBisher = function () {
        switch (true) {
            case this.specificBisherText !== undefined:
                this.bisherText = this.specificBisherText ? this.specificBisherText.split('\n') : [''];
                return this.hasBisher() ? this.bisherText : [this.$translate.instant('LABEL_KEINE_ANGABE')];
            case this.getGSProperty() instanceof moment_1.default:
                var tmpTime = DateUtil_1.default.momentToLocalDateFormat(this.getGSProperty(), 'DD.MM.YYYY');
                return tmpTime === undefined ? [''] : [tmpTime];
            case this.getGSProperty() === true:
                return [this.$translate.instant('LABEL_JA')];
            case this.getGSProperty() === false:
                return [this.$translate.instant('LABEL_NEIN')];
            case !this.hasBisher():
                return [this.$translate.instant('LABEL_KEINE_ANGABE')];
            case (this.isNumber(this.getGSProperty()) && !this.forcestring):
                this.decimal = ((this.forcefloor && Math.floor(this.getGSProperty()) === this.getGSProperty()) ? 0 : this.decimal);
                return [this.$filter('number')(this.getGSProperty(), (this.decimal === undefined ? 2 : this.decimal)) + (this.unit === undefined ? '' : this.unit)];
            default:
                return [this.$translate.instant((this.prefix === undefined ? '' : this.prefix) + this.getGSProperty())];
        }
    };
    DvBisherController.prototype.isNumber = function (n) {
        return isFinite(n) && +n === n;
    };
    ;
    DvBisherController.prototype.hasBisher = function () {
        return !this.isEmpty(this.getGSProperty());
    };
    DvBisherController.prototype.showBisher = function () {
        if (this.GSContainerDefined) {
            return ((this.showIfBisherNone || this.blockExisted === true) || this.hasBisher());
        }
        else {
            return false;
        }
    };
    DvBisherController.prototype.equals = function (gs, fs) {
        if (gs instanceof moment_1.default) {
            return this.equals(DateUtil_1.default.momentToLocalDateFormat(gs, 'DD.MM.YYYY'), DateUtil_1.default.momentToLocalDateFormat(fs, 'DD.MM.YYYY'));
        }
        return gs === fs || (this.isEmpty(gs) && this.isEmpty(fs)); //either they are equal or both are a form of empty
    };
    DvBisherController.prototype.getGSProperty = function () {
        if (this.GSContainerDefined && this.propertyDefined) {
            return this.gs[this.property];
        }
        else {
            return null;
        }
    };
    DvBisherController.prototype.getFSProperty = function () {
        if (this.FSContainerDefined && this.propertyDefined) {
            return this.fs[this.property];
        }
        else {
            return null;
        }
    };
    DvBisherController.prototype.isEmpty = function (val) {
        return val === undefined || val === null || val === '';
    };
    DvBisherController.$inject = ['$translate', '$log', '$filter', '$attrs'];
    return DvBisherController;
}());
exports.DvBisherController = DvBisherController;


/***/ }),

/***/ "g1Ku":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractModelController_1 = __importDefault(__webpack_require__("VDYy"));
var TSDokumentType_1 = __webpack_require__("/gTe");
var TSSchadenArt_1 = __webpack_require__("fz+m");
var TSVersicherungsbeitragStatus_1 = __webpack_require__("jJP+");
var TSVersicherungsbeitrag_1 = __importDefault(__webpack_require__("fGC3"));
var styles = __webpack_require__("cRnY");
var template = __webpack_require__("cXjS");
var VersicherungsbeitragSchadenViewComponentConfig = /** @class */ (function () {
    function VersicherungsbeitragSchadenViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = VersicherungsbeitragSchadenViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            versicherungsbeitrag: '<'
        };
    }
    return VersicherungsbeitragSchadenViewComponentConfig;
}());
exports.VersicherungsbeitragSchadenViewComponentConfig = VersicherungsbeitragSchadenViewComponentConfig;
var VersicherungsbeitragSchadenViewController = /** @class */ (function (_super) {
    __extends(VersicherungsbeitragSchadenViewController, _super);
    /* @ngInject */
    function VersicherungsbeitragSchadenViewController(dvBernUtil, $q, $scope, $translate, $log, $state, versicherungsbeitragModelManager, versicherungRS) {
        var _this = _super.call(this, $scope) || this;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$translate = $translate;
        _this.$log = $log;
        _this.$state = $state;
        _this.versicherungsbeitragModelManager = versicherungsbeitragModelManager;
        _this.versicherungRS = versicherungRS;
        _this.possibleVersicherungen = [];
        _this.doctype = TSDokumentType_1.TSDocumentType.VERSICHERUNGSBEITRAG_DOC;
        return _this;
    }
    VersicherungsbeitragSchadenViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        if (!this.versicherungsbeitrag) {
            this.versicherungsbeitrag = new TSVersicherungsbeitrag_1.default();
            // this.versicherungsbeitrag.versicherungsbeitragDatenFS = new TSVersicherungsbeitragDaten();
            // this.versicherungsbeitrag.versicherungsbeitragStundenDaten = [];
            this.$log.warn('initialized versicherungsbeitrag to edit directly in view, should pass versicherungsbeitrag to edit along');
        }
        else {
            this.initialModel = this.versicherungsbeitrag;
            this.model = angular.copy(this.versicherungsbeitrag);
        }
        this.readonly = !TSVersicherungsbeitragStatus_1.isStatusInBearbeitung(this.model.status);
        this.loadAvailableAnlaufstellen();
    };
    VersicherungsbeitragSchadenViewController.prototype.loadAvailableAnlaufstellen = function () {
        var _this = this;
        this.versicherungRS.findActiveVersicherungen().then(function (response) {
            _this.possibleVersicherungen = _this.possibleVersicherungen.concat(response);
        });
    };
    VersicherungsbeitragSchadenViewController.prototype.saveVersicherungsbeitrag = function () {
        var _this = this;
        if (this.isModelValid() && this.model) {
            this.versicherungsbeitragModelManager.saveVersicherungsbeitrag(this.getModel()).then(function (result) {
                _this.$state.go('versicherungbeitragversicherter', { versicherungsbeitragId: result.id });
            });
        }
        else {
            this.$log.debug('Form was not valid');
        }
    };
    VersicherungsbeitragSchadenViewController.prototype.cancelVersicherungsbeitrag = function () {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('versicherungsbeitraege');
    };
    VersicherungsbeitragSchadenViewController.prototype.getViewTitle = function () {
        return this.dvBernUtil.getVersicherungsbeitragViewTitle(this.model);
    };
    VersicherungsbeitragSchadenViewController.prototype.getTSSchadenArtValues = function () {
        return TSSchadenArt_1.getTSSchadenArtValues();
    };
    VersicherungsbeitragSchadenViewController.prototype.getSchadenArtPrefix = function () {
        return TSSchadenArt_1.schadenartPrefix();
    };
    VersicherungsbeitragSchadenViewController.prototype.translateSchadenArt = function (art) {
        var prefix = this.getSchadenArtPrefix();
        return this.$translate.instant(prefix + TSSchadenArt_1.TSSchadenArt[art]);
    };
    VersicherungsbeitragSchadenViewController.prototype.showAndere = function () {
        return this.getModel().schadenArt === TSSchadenArt_1.TSSchadenArt.ANDERE;
    };
    VersicherungsbeitragSchadenViewController.$inject = ['DVBernUtil', '$q', '$scope', '$translate', '$log', '$state', 'VersicherungsbeitragModelManager', 'VersicherungRS'];
    return VersicherungsbeitragSchadenViewController;
}(abstractModelController_1.default));
exports.VersicherungsbeitragSchadenViewController = VersicherungsbeitragSchadenViewController;


/***/ }),

/***/ "g6Z3":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("QKwI");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./errors.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./errors.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "gClk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/comp-4.afc8c9cc401553058b4185953cbdf6c0.jpg";

/***/ }),

/***/ "gcTH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSGemeinde_1 = __importDefault(__webpack_require__("nKms"));
/**
 * Service zum verwalten von Gemeinden.
 */
var GemeindeRS = /** @class */ (function () {
    /* @ngInject */
    function GemeindeRS($http, CONSTANTS, $q, $rootScope, $log) {
        this.$http = $http;
        this.CONSTANTS = CONSTANTS;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$log = $log;
    }
    GemeindeRS.prototype.readGemeindeSuggestion = function (searchString, exlcudeKantonGR) {
        var _this = this;
        return this.$http.get(this.CONSTANTS.REST_API + 'gemeinden/public/', {
            params: {
                gemeindeName: searchString,
                excludeKantonGR: exlcudeKantonGR
            }
        })
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING Gemeinden REST  object', response.data);
                return TSGemeinde_1.default.deserializeArray(response.data);
            }
            else {
                return [];
            }
        });
    };
    GemeindeRS.$inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];
    return GemeindeRS;
}());
exports.default = GemeindeRS;


/***/ }),

/***/ "gekR":
/***/ (function(module, exports) {

module.exports = " <div> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <fieldset ng-if=\"vm.versicherungsbeitrag.beitrag\" class=\"beitragadd\"> <div class=\"row marginTop20\"> <div class=\"col-sm-12\"> <h1> <span data-translate=\"VERSICHERUNGSBEITRAG_SCHADENABRECHNUNG\"></span> </h1> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <dv-leistungsempfaenger inhaber-name=\"vm.versicherungsbeitrag.versicherung.bankverbindung.inhaberName\" bank-name=\"vm.versicherungsbeitrag.versicherung.bankverbindung.bankName\" iban=\"vm.versicherungsbeitrag.versicherung.bankverbindung.iban\"></dv-leistungsempfaenger> </div> <div class=\"col-sm-12\"> <dv-betrag readonly=\"vm.isBeitragReadonly()\" ermittelter-schaden=\"vm.versicherungsbeitrag.ermittelterSchaden\" einkommensabzug=\"vm.versicherungsbeitrag.gesuchsteller.getEinkommensabzug()\" vermoegenssabzug=\"vm.versicherungsbeitrag.gesuchsteller.getVermoegenssabzug(vm.versicherungsbeitrag.schadendatum, vm.versicherungsbeitrag.ermittelterSchaden)\" anrechenbarer-schaden=\"vm.versicherungsbeitrag.getAnrechenbarerSchaden()\" betrag-vorschlag=\"vm.betragVorschlag\" prozentsatz=\"vm.prozentsatz\" beitrag=\"vm.getModel().beitrag.beitrag\"></dv-betrag> </div> <div class=\"col-sm-4 marginTop20\" ng-if=\"!vm.isBeitragReadonly()\"> <dv-input-container> <label data-translate=\"BEITRAG_BERECHTIGT\" for=\"beitrag\"></label> <dv-valueinput input-id=\"beitrag\" name=\"beitrag\" input-name=\"beitrag\" ng-model=\"vm.versicherungsbeitrag.beitrag.beitrag\" ng-required=\"true\" allow-negative=\"false\" class=\"input-element\"> </dv-valueinput> <dv-error-messages for=\"vm.form.beitrag\"></dv-error-messages> </dv-input-container> </div> <div class=\"col-sm-12 marginTop20\" ng-if=\"vm.readonly && vm.zahlungsauftrag\"> <dv-auszahlung zahlungsauftrag=\"vm.zahlungsauftrag\"></dv-auszahlung> </div> <div class=\"col-sm-12\"> <h2 data-translate=\"BEMERKUNG\" aria-hidden> </h2> <div class=\"row\"> <div class=\"col-sm-9\"> <dv-input-container> <textarea name=\"bemerkung\" class=\"form-control input-element\" rows=\"6\" id=\"bemerkung_ID\" ng-model=\"vm.versicherungsbeitrag.beitrag.bemerkung\" ng-required=\"false\" maxlength=\"4000\" aria-labelledby=\"{{'BEMERKUNG' | translate}}\" ng-readonly=\"vm.isBeitragReadonly()\"></textarea> <dv-error-messages for=\"vm.form.bemerkung\"></dv-error-messages> </dv-input-container> </div> </div> </div> <div class=\"col-sm-12\"> <div class=\"row mainbuttons\"> <div> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.cancel()\"> <span data-translate=\"CANCEL\"></span> </button> </div> <div ng-if=\"!vm.isBeitragReadonly()\"> <dv-loading-button type=\"submit\" button-click=\"vm.save()\" button-class=\"btn btn-serf\"> <span data-translate=\"SAVE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </div> </div> </fieldset> </form> </div> ";

/***/ }),

/***/ "gpFF":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.versicherungsbeitrag-beitrag-view .btn-beitrag-loeschen{margin-top:24px}.versicherungsbeitrag-beitrag-view .beitragadd.ng-enter,.versicherungsbeitrag-beitrag-view .beitragadd.ng-leave{-webkit-transition:opacity .4s ease-in-out;transition:opacity .4s ease-in-out}.versicherungsbeitrag-beitrag-view .beitragadd.ng-enter,.versicherungsbeitrag-beitrag-view .beitragadd.ng-leave.ng-leave-active{opacity:0}.versicherungsbeitrag-beitrag-view .beitragadd.ng-enter.ng-enter-active,.versicherungsbeitrag-beitrag-view .beitragadd.ng-leave{opacity:1}", ""]);

// exports


/***/ }),

/***/ "grUW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var TSRole_1 = __webpack_require__("MleR");
var RoleUtilService = /** @class */ (function () {
    /* @ngInject */
    function RoleUtilService() {
    }
    RoleUtilService.prototype.getAllRolesButGesuchsteller = function () {
        return this.getAllRoles().filter(function (element) {
            return element !== TSRole_1.TSRole[TSRole_1.TSRole.BETROFFENER];
        });
    };
    RoleUtilService.prototype.getAllRolesButGesuchstellerArray = function () {
        return this.removeRoles(TSRole_1.getTSRoleValues(), [TSRole_1.TSRole.BETROFFENER, TSRole_1.TSRole.UNASSIGNED_ROLE]);
    };
    RoleUtilService.prototype.getAllRolesButGesuchstellerAndKanton = function () {
        return this.removeRoles(this.getAllRolesButGesuchstellerArray(), [TSRole_1.TSRole.KANTON_VERWALTER, TSRole_1.TSRole.KANTON_INSPEKTOR]);
    };
    RoleUtilService.prototype.getAllRolesWithNAButGesuchstellerArray = function () {
        return this.removeRole(TSRole_1.getTSRoleValues(), TSRole_1.TSRole.BETROFFENER);
    };
    RoleUtilService.prototype.getRolesForSchadenfaelle = function () {
        return [TSRole_1.TSRole.SUPER_ADMIN, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER, TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER,
            TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER, TSRole_1.TSRole.BETROFFENER, TSRole_1.TSRole.KANTON_INSPEKTOR];
    };
    RoleUtilService.prototype.getRolesForCockpit = function () {
        return [TSRole_1.TSRole.SUPER_ADMIN, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER];
    };
    RoleUtilService.prototype.getAllRoles = function () {
        var result = [];
        for (var prop in TSRole_1.TSRole) {
            if ((isNaN(parseInt(prop)))) {
                result.push(prop);
            }
        }
        return result;
    };
    RoleUtilService.prototype.getSuperAdminRoles = function () {
        return [TSRole_1.TSRole.SUPER_ADMIN];
    };
    RoleUtilService.prototype.getAdministratorRoles = function () {
        return [TSRole_1.TSRole.SUPER_ADMIN, TSRole_1.TSRole.FONDSSUISSE_ADMIN];
    };
    RoleUtilService.prototype.getStatistikRoles = function () {
        return [TSRole_1.TSRole.SUPER_ADMIN, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.KANTON_INSPEKTOR];
    };
    RoleUtilService.prototype.getAnlaufstelleRoles = function () {
        return [TSRole_1.TSRole.SUPER_ADMIN, TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER];
    };
    RoleUtilService.prototype.getAnlaufstelleRoleWithAdmins = function () {
        return [TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.SUPER_ADMIN, TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER];
    };
    RoleUtilService.prototype.getFondssuisseRoles = function () {
        return [TSRole_1.TSRole.SUPER_ADMIN, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER];
    };
    RoleUtilService.prototype.getGesuchstellerRoles = function () {
        return [TSRole_1.TSRole.SUPER_ADMIN, TSRole_1.TSRole.BETROFFENER];
    };
    RoleUtilService.prototype.getGesuchstellerOnlyRoles = function () {
        return [TSRole_1.TSRole.BETROFFENER];
    };
    RoleUtilService.prototype.getAnlaufstelleVerwalterRoles = function () {
        return [TSRole_1.TSRole.SUPER_ADMIN, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.ANLAUFSTELLE_VERWALTER];
    };
    RoleUtilService.prototype.getVerwalterRoles = function () {
        return [TSRole_1.TSRole.SUPER_ADMIN, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.ANLAUFSTELLE_VERWALTER, TSRole_1.TSRole.KANTON_VERWALTER];
    };
    RoleUtilService.prototype.getAnlaufstelleVerwalterOnlyRole = function () {
        return [TSRole_1.TSRole.ANLAUFSTELLE_VERWALTER];
    };
    RoleUtilService.prototype.getAnlaufstelleSubuserRoles = function () {
        return [TSRole_1.TSRole.SUPER_ADMIN, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER, TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER];
    };
    RoleUtilService.prototype.getAnlaufstelleSubuserRolesOnly = function () {
        return [TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER, TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER];
    };
    RoleUtilService.prototype.getInspektoratVerwalterRoles = function () {
        return [TSRole_1.TSRole.SUPER_ADMIN, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.KANTON_VERWALTER];
    };
    RoleUtilService.prototype.getSchaetzerRolesOnly = function () {
        return [TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER];
    };
    RoleUtilService.prototype.getAllowedToCreateSchadenfallRoles = function () {
        return [TSRole_1.TSRole.BETROFFENER, TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER, TSRole_1.TSRole.SUPER_ADMIN,
            TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER];
    };
    RoleUtilService.prototype.getAllowedToCreatePapierSchadenfallRoles = function () {
        return [TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER, TSRole_1.TSRole.SUPER_ADMIN,
            TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER];
    };
    RoleUtilService.prototype.getAllowedToDeleteSchadenfallRoles = function () {
        return [TSRole_1.TSRole.SUPER_ADMIN, TSRole_1.TSRole.FONDSSUISSE_ADMIN, TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER,
            TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER, TSRole_1.TSRole.KANTON_INSPEKTOR, TSRole_1.TSRole.BETROFFENER];
    };
    RoleUtilService.prototype.getRolesAllowedForAnlaufstellenPruefung = function () {
        var allowedRoles = [];
        allowedRoles = allowedRoles.concat(this.getAnlaufstelleRoles());
        allowedRoles = allowedRoles.concat(this.getAdministratorRoles());
        allowedRoles = allowedRoles.concat(this.getFondssuisseRoles());
        return allowedRoles;
    };
    RoleUtilService.prototype.getRolesAllowedForSchaetzer = function () {
        var allowedRoles = [];
        allowedRoles = allowedRoles.concat(this.getAnlaufstelleRoles());
        allowedRoles = allowedRoles.concat(this.getAdministratorRoles());
        allowedRoles = allowedRoles.concat(this.getFondssuisseRoles());
        allowedRoles = allowedRoles.concat(this.getSchaetzerRolesOnly());
        return allowedRoles;
    };
    RoleUtilService.prototype.removeRole = function (roles, role) {
        var index = roles.indexOf(role, 0);
        if (index > -1) {
            roles.splice(index, 1);
        }
        return roles;
    };
    RoleUtilService.prototype.removeRoles = function (roles, rolesToRemove) {
        try {
            for (var rolesToRemove_1 = __values(rolesToRemove), rolesToRemove_1_1 = rolesToRemove_1.next(); !rolesToRemove_1_1.done; rolesToRemove_1_1 = rolesToRemove_1.next()) {
                var role = rolesToRemove_1_1.value;
                roles = this.removeRole(roles, role);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (rolesToRemove_1_1 && !rolesToRemove_1_1.done && (_a = rolesToRemove_1.return)) _a.call(rolesToRemove_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return roles;
        var e_1, _a;
    };
    RoleUtilService.$inject = [];
    return RoleUtilService;
}());
exports.default = RoleUtilService;


/***/ }),

/***/ "gs8D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSGeoadminSearchResponse_1 = __importDefault(__webpack_require__("rS+W"));
__webpack_require__("3Bji");
var GeoAdminSearchComponentConfig = /** @class */ (function () {
    function GeoAdminSearchComponentConfig() {
        this.transclude = false;
        this.bindings = {
            schaden: '=',
            readonly: '<',
            formschaden: '=',
        };
        this.template = __webpack_require__("VN0d");
        this.controller = DvGeoAdminSearchController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return GeoAdminSearchComponentConfig;
}());
exports.GeoAdminSearchComponentConfig = GeoAdminSearchComponentConfig;
var DvGeoAdminSearchController = /** @class */ (function () {
    function DvGeoAdminSearchController($log, $http, $scope) {
        this.$log = $log;
        this.$http = $http;
        this.$scope = $scope;
    }
    DvGeoAdminSearchController.prototype.$onInit = function () {
        var _this = this;
        this.asyncSelected = new TSGeoadminSearchResponse_1.default();
        if (this.schaden.schadenDatenFS && this.schaden.schadenDatenFS.ort) {
            // @ts-ignore
            this.asyncSelected = this.schaden.schadenDatenFS.ort;
        }
        else {
            // @ts-ignore
            this.asyncSelected = '';
        }
        /*set position if value has changed*/
        this.$scope.$watch(function () {
            return _this.asyncSelected;
        }, function (newValue, oldValue) {
            if (newValue && newValue.lat && newValue.lon && (newValue !== oldValue)) {
                _this.getModel().schadenDatenFS.mapLatitude = Number(newValue.lat);
                _this.getModel().schadenDatenFS.mapLongitude = Number(newValue.lon);
                _this.getModel().schadenDatenFS.ort = newValue.name;
            }
            else {
                // @ts-ignore
                _this.getModel().schadenDatenFS.ort = _this.asyncSelected;
                console.log(_this.getModel().schadenDatenFS.ort);
            }
        });
    };
    DvGeoAdminSearchController.prototype.loadSuggestElements = function (searchString) {
        return this.$http.get("https://api3.geo.admin.ch/rest/services/api/SearchServer?sr=2056&searchText=" + encodeURIComponent(searchString) + "&type=locations").then(function (response) {
            // @ts-ignore
            return response.data.results.map(function (res) {
                return new TSGeoadminSearchResponse_1.default().deserialize(res.attrs);
            });
        });
    };
    DvGeoAdminSearchController.prototype.getModel = function () {
        return this.schaden;
    };
    DvGeoAdminSearchController.$inject = ['$log', '$http', '$scope'];
    return DvGeoAdminSearchController;
}());
exports.DvGeoAdminSearchController = DvGeoAdminSearchController;


/***/ }),

/***/ "gtL8":
/***/ (function(module, exports) {

module.exports = " <div class=\"languageselect\"> <li><a ng-click=\"vm.langDe()\" class=\"btn-link\">De</a></li> <li><a ng-click=\"vm.langFr()\" class=\"btn-link\">Fr</a></li> <li><a ng-click=\"vm.langIt()\" class=\"btn-link\">It</a></li> </div> ";

/***/ }),

/***/ "h+M8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSAnrede;
(function (TSAnrede) {
    TSAnrede[TSAnrede["HERR"] = 'HERR'] = "HERR";
    TSAnrede[TSAnrede["FRAU"] = 'FRAU'] = "FRAU";
})(TSAnrede = exports.TSAnrede || (exports.TSAnrede = {}));
function getTSAnredeValues() {
    return [
        TSAnrede.HERR,
        TSAnrede.FRAU,
    ];
}
exports.getTSAnredeValues = getTSAnredeValues;


/***/ }),

/***/ "h/3A":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "h/iD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var OkHtmlDialogController_1 = __webpack_require__("U0eN");
var TSRole_1 = __webpack_require__("MleR");
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var TSApplicationProperty_1 = __importDefault(__webpack_require__("P/EH"));
var TSSerfProperty_1 = __importDefault(__webpack_require__("MbEi"));
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
__webpack_require__("9/Ng");
var template = __webpack_require__("JACS");
var okHtmlDialogTemplate = __webpack_require__("ncnt");
var AdminViewComponentConfig = /** @class */ (function () {
    function AdminViewComponentConfig() {
        this.transclude = false;
        this.bindings = {
            applicationProperties: '<',
            serfProperties: '<'
        };
        this.template = template;
        this.controller = AdminViewController;
        this.controllerAs = 'vm';
    }
    return AdminViewComponentConfig;
}());
exports.AdminViewComponentConfig = AdminViewComponentConfig;
var AdminViewController = /** @class */ (function () {
    /* @ngInject */
    function AdminViewController(applicationPropertyRS, MAX_LENGTH, dvDialog, testFaelleRS, anlaufstelleRS, benutzerRS, serfPropertyRS, $log, zahlungsauftragRS) {
        this.dvDialog = dvDialog;
        this.testFaelleRS = testFaelleRS;
        this.anlaufstelleRS = anlaufstelleRS;
        this.benutzerRS = benutzerRS;
        this.serfPropertyRS = serfPropertyRS;
        this.$log = $log;
        this.zahlungsauftragRS = zahlungsauftragRS;
        this.applicationProperty = new TSApplicationProperty_1.default();
        this.schadenfallStatus = TSSchadenfallStatus_1.TSSchadenfallStatus.NEU;
        this.anzahl = 1;
        this.serfProperty = new TSSerfProperty_1.default();
        this.length = MAX_LENGTH;
        this.applicationPropertyRS = applicationPropertyRS;
    }
    AdminViewController.prototype.$onInit = function () {
        var _this = this;
        this.anlaufstelleRS.getAllAnlaufstellen().then(function (response) {
            _this.anlaufstellen = response;
        });
        this.benutzerRS.allBenutzerForRole(TSRole_1.TSRole.BETROFFENER).then(function (response) {
            _this.besitzerListe = response;
        });
    };
    AdminViewController.prototype.submit = function () {
        var _this = this;
        //testen ob aktuelles property schon gespeichert ist
        if (this.applicationProperty && this.applicationProperty.name) {
            if (!this.applicationProperty.isNew()) {
                this.applicationPropertyRS.update(this.applicationProperty.name, this.applicationProperty.value)
                    .then(function (response) {
                    var index = DVBernUtil_1.default.getIndexOfElementwithIDById(response.id, _this.applicationProperties);
                    _this.applicationProperties[index] = response;
                });
            }
            else {
                this.applicationPropertyRS.create(this.applicationProperty.name, this.applicationProperty.value)
                    .then(function (response) {
                    _this.applicationProperties = _this.applicationProperties.concat(response);
                });
            }
            this.resetForm();
        }
    };
    AdminViewController.prototype.submitSerfProperty = function () {
        var _this = this;
        //testen ob aktuelles property schon gespeichert ist
        if (this.serfProperty && this.serfProperty.name) {
            if (!this.serfProperty.isNew()) {
                this.serfPropertyRS.update(this.serfProperty.name, this.serfProperty.value)
                    .then(function (response) {
                    var index = DVBernUtil_1.default.getIndexOfElementwithIDById(response.id, _this.serfProperties);
                    _this.serfProperties[index] = response;
                });
            }
            else {
                this.serfPropertyRS.create(this.serfProperty.name, this.serfProperty.value)
                    .then(function (response) {
                    _this.serfProperties = _this.serfProperties.concat(response);
                });
            }
            this.resetForm();
        }
    };
    AdminViewController.prototype.removeRow = function (row) {
        var _this = this;
        if (row.name) {
            this.applicationPropertyRS.remove(row.name).then(function (reponse) {
                var index = _this.applicationProperties.indexOf(row);
                if (index !== -1) {
                    _this.applicationProperties.splice(index, 1);
                    _this.resetForm();
                }
            });
        }
    };
    AdminViewController.prototype.removeSerfProperty = function (serfProperty) {
        var _this = this;
        if (serfProperty.name) {
            this.serfPropertyRS.remove(serfProperty.name).then(function (reponse) {
                var index = _this.serfProperties.indexOf(serfProperty);
                if (index !== -1) {
                    _this.serfProperties.splice(index, 1);
                    _this.resetForm();
                }
            });
        }
    };
    AdminViewController.prototype.createItem = function () {
        this.applicationProperty = new TSApplicationProperty_1.default('', '');
    };
    AdminViewController.prototype.editRow = function (row) {
        this.applicationProperty = row;
    };
    AdminViewController.prototype.editSerfProperty = function (serfProperty) {
        this.serfProperty = serfProperty;
    };
    AdminViewController.prototype.resetForm = function () {
        this.applicationProperty = new TSApplicationProperty_1.default();
        this.serfProperty = new TSSerfProperty_1.default();
    };
    AdminViewController.prototype.getVersion = function () {
        return "2.7.0";
    };
    AdminViewController.prototype.getBuildtimestamp = function () {
        return "2026-09-21T12:06:11.057Z";
    };
    AdminViewController.prototype.getSchadenfallStatusList = function () {
        return TSSchadenfallStatus_1.getTSSchadenfallStatusalues();
    };
    AdminViewController.prototype.createTestFallType = function (testFall) {
        var _this = this;
        var anlaufstelleId = 'undefined';
        var besitzerId = 'undefined';
        if (this.anlaufstelle) {
            anlaufstelleId = this.anlaufstelle.id;
        }
        if (this.besitzer) {
            besitzerId = this.besitzer.id;
        }
        return this.testFaelleRS.createTestFall(testFall, this.schadenfallStatus, anlaufstelleId, this.anzahl, besitzerId).then(function (response) {
            return _this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController_1.OkHtmlDialogController, {
                title: 'Testfall created',
                text: response.data
            }).then(function () {
                //do nothin
            });
        });
    };
    AdminViewController.prototype.createVersicherungsbeitragFallTest = function () {
        var _this = this;
        return this.testFaelleRS.createTestFallVersicherungsbeitrag(this.schadenfallStatus, this.anzahl).then(function (response) {
            return _this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController_1.OkHtmlDialogController, {
                title: 'Testfall created',
                text: response.data
            }).then(function () {
                //do nothin
            });
        });
    };
    AdminViewController.prototype.sendTestMail = function (mail) {
        var _this = this;
        if (this.schadenfallnummer) {
            this.testFaelleRS.sendTestMail(this.schadenfallnummer, mail).then(function (response) {
                return _this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController_1.OkHtmlDialogController, {
                    title: 'Test email',
                    text: response.data
                }).then(function () {
                    //do nothin
                });
            });
        }
    };
    AdminViewController.prototype.getAnlaufstelleList = function () {
        return this.anlaufstellen;
    };
    AdminViewController.prototype.getBesitzerList = function () {
        return this.besitzerListe;
    };
    AdminViewController.prototype.resetUserRoles = function () {
        var _this = this;
        if (this.benutzerEmail) {
            this.benutzerRS.resetUserRoles(this.benutzerEmail).then(function (response) {
                return _this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController_1.OkHtmlDialogController, {
                    title: 'Benutzer-Rollen zurücksetzen',
                    text: response
                }).then(function () {
                    //do nothin
                });
            });
        }
    };
    AdminViewController.prototype.removeBetroffeneRole = function () {
        var _this = this;
        if (this.benutzerEmail) {
            this.benutzerRS.removeBetroffeneRole(this.benutzerEmail).then(function (response) {
                return _this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController_1.OkHtmlDialogController, {
                    title: 'Benutzer-Rollen zurücksetzen',
                    text: response
                }).then(function () {
                    //do nothin
                });
            });
        }
    };
    AdminViewController.prototype.recreateZahlungsauftragExcel = function () {
        var _this = this;
        // special case, workaround so we can correct wrongly generated excels
        if (this.zahlungsAuftragId) {
            this.$log.debug('recreating Zahlungsauftrag excel, regenerating for Zahlungsauftrag ' + this.zahlungsAuftragId);
            this.zahlungsauftragRS.regenerateExcel(this.zahlungsAuftragId).then(function (dokId) {
                _this.$log.info('created new document with id ' + dokId);
                _this.zahlungsAuftragId = '';
            });
        }
    };
    AdminViewController.$inject = ['ApplicationPropertyRS', 'MAX_LENGTH', 'DvDialog', 'TestFaelleRS', 'AnlaufstelleRS', 'BenutzerRS', 'SerfPropertyRS', '$log', 'ZahlungsauftragRS'];
    return AdminViewController;
}());
exports.AdminViewController = AdminViewController;


/***/ }),

/***/ "h81B":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("wvMN");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./schadenView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./schadenView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "h81c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSEigenleistungLiterDaten = /** @class */ (function (_super) {
    __extends(TSEigenleistungLiterDaten, _super);
    function TSEigenleistungLiterDaten() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._deleted = false;
        return _this;
    }
    Object.defineProperty(TSEigenleistungLiterDaten.prototype, "liter", {
        get: function () {
            return this._liter;
        },
        set: function (value) {
            this._liter = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistungLiterDaten.prototype, "betrag", {
        get: function () {
            return this._betrag;
        },
        set: function (value) {
            this._betrag = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistungLiterDaten.prototype, "deleted", {
        get: function () {
            return this._deleted;
        },
        set: function (value) {
            this._deleted = value;
        },
        enumerable: true,
        configurable: true
    });
    TSEigenleistungLiterDaten.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.liter = restObject.liter;
        this.betrag = restObject.betrag;
        this.deleted = restObject.deleted;
        return this;
    };
    TSEigenleistungLiterDaten.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.liter = this.liter;
        restObject.betrag = this.betrag;
        restObject.deleted = this.deleted;
        return restObject;
    };
    TSEigenleistungLiterDaten.getDeserializer = function (eigenleistung) {
        return new TSEigenleistungLiterDaten().deserialize(eigenleistung);
    };
    TSEigenleistungLiterDaten.getSerializer = function (eigenleistung) {
        return eigenleistung.serialize(eigenleistung);
    };
    return TSEigenleistungLiterDaten;
}(TSAbstractEntity_1.default));
exports.default = TSEigenleistungLiterDaten;


/***/ }),

/***/ "hF3f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var GenossenschaftComponentConfig = /** @class */ (function () {
    function GenossenschaftComponentConfig() {
        this.transclude = false;
        this.bindings = {
            model: '=',
            name: '@',
            angabe: '@',
            zweitperson: '<',
            gesellschaft: '<',
            onSteuerpflichtChanged: '&',
        };
        this.template = __webpack_require__("/PKM");
        this.controller = DvGenossenschaftController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return GenossenschaftComponentConfig;
}());
exports.GenossenschaftComponentConfig = GenossenschaftComponentConfig;
var DvGenossenschaftController = /** @class */ (function () {
    function DvGenossenschaftController() {
    }
    DvGenossenschaftController.prototype.getModel = function () {
        return this.model;
    };
    DvGenossenschaftController.prototype.getName = function () {
        if (this.gesellschaft) {
            return 'GESELLSCHAFT_NAME';
        }
        else {
            return 'GENOSSENSCHAFT_NAME';
        }
    };
    DvGenossenschaftController.prototype.getSteuerpflichtName = function () {
        if (this.gesellschaft) {
            return 'STEUERPFLICHT_GESELLSCHAFT';
        }
        else {
            return 'STEUERPFLICHT_GENOSSENSCHAFT';
        }
    };
    DvGenossenschaftController.prototype.getNichtSteuerpflichtName = function () {
        if (this.gesellschaft) {
            return 'NICHT_STEUERPFLICHT_GESELLSCHAFT';
        }
        else {
            return 'NICHT_STEUERPFLICHT_GENOSSENSCHAFT';
        }
    };
    DvGenossenschaftController.prototype.steuerpflichtChanged = function (event) {
        this.onSteuerpflichtChanged({ event: event });
    };
    return DvGenossenschaftController;
}());
exports.DvGenossenschaftController = DvGenossenschaftController;


/***/ }),

/***/ "hYoR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSAnlaufstelleType;
(function (TSAnlaufstelleType) {
    TSAnlaufstelleType[TSAnlaufstelleType["KANTON"] = 'KANTON'] = "KANTON";
    TSAnlaufstelleType[TSAnlaufstelleType["GEMEINDE"] = 'GEMEINDE'] = "GEMEINDE";
})(TSAnlaufstelleType = exports.TSAnlaufstelleType || (exports.TSAnlaufstelleType = {}));
function getTSAnlaufstelleTypeValues() {
    return [
        TSAnlaufstelleType.KANTON,
        TSAnlaufstelleType.GEMEINDE,
    ];
}
exports.getTSAnlaufstelleTypeValues = getTSAnlaufstelleTypeValues;


/***/ }),

/***/ "hgNu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSRole_1 = __webpack_require__("MleR");
adminRun.$inject = ['RouterHelper'];
/* @ngInject */
function adminRun(routerHelper) {
    routerHelper.configureStates(getStates());
}
exports.adminRun = adminRun;
function getStates() {
    return [
        {
            name: 'admin',
            template: '<dv-admin-view flex="auto" class="overflow-scroll" application-properties="$resolve.applicationProperties" serf-properties="$resolve.serfProperties"></dv-admin-view>',
            url: '/admin',
            resolve: {
                applicationProperties: getApplicationProperties,
                serfProperties: getSerfProperties
            }
        },
        {
            name: 'konfiguration',
            template: '<dv-konfiguration-view flex="auto" class="overflow-scroll" serf-properties="$resolve.serfProperties" '
                + 'sachbearbeiter-list="$resolve.sachbearbeiterList" admin-list="$resolve.adminList"></dv-konfiguration-view>',
            url: '/konfiguration',
            resolve: {
                serfProperties: getSerfProperties,
                sachbearbeiterList: loadFSSachbearbeiter,
                adminList: loadFSAdmin
            }
        },
        {
            name: 'migration',
            template: '<dv-migration-view></dv-migration-view>',
            url: '/migration',
            resolve: {}
        },
    ];
}
// FIXME dieses $inject wird ignoriert, d.h, der Parameter der Funktion muss exact dem Namen des Services entsprechen
getApplicationProperties.$inject = ['ApplicationPropertyRS'];
/* @ngInject */
function getApplicationProperties(ApplicationPropertyRS) {
    return ApplicationPropertyRS.getAllApplicationProperties();
}
getSerfProperties.$inject = ['SerfPropertyRS'];
/* @ngInject */
function getSerfProperties(SerfPropertyRS) {
    return SerfPropertyRS.getAllSerfProperties();
}
loadFSSachbearbeiter.$inject = ['FondssuisseRS', '$q'];
function loadFSSachbearbeiter(FondssuisseRS, $q) {
    return FondssuisseRS.getBenutzerOfFondssuisse(TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER);
}
exports.loadFSSachbearbeiter = loadFSSachbearbeiter;
loadFSAdmin.$inject = ['FondssuisseRS', '$q'];
function loadFSAdmin(FondssuisseRS, $q) {
    return FondssuisseRS.getBenutzerOfFondssuisse(TSRole_1.TSRole.FONDSSUISSE_ADMIN);
}
exports.loadFSAdmin = loadFSAdmin;


/***/ }),

/***/ "hw4h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("Xkfc");
var DVChecklistComponentConfig = /** @class */ (function () {
    function DVChecklistComponentConfig() {
        this.transclude = false;
        this.bindings = {
            checklistPoints: '=',
            onCheckstatusChaged: '&',
            allChecked: '=?' // optional kann das 'model' auch ausserhalb der component gemapped werden
        };
        this.template = __webpack_require__("aT8p");
        this.controller = DVChecklistController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return DVChecklistComponentConfig;
}());
exports.DVChecklistComponentConfig = DVChecklistComponentConfig;
var DVChecklistController = /** @class */ (function () {
    /* @ngInject */
    function DVChecklistController($log, $translate, $q, $scope) {
        this.$log = $log;
        this.$translate = $translate;
        this.$q = $q;
        this.$scope = $scope;
        this.checklistPoints = [];
        this.allChecked = false;
    }
    DVChecklistController.prototype.$onInit = function () {
        if (this.checklistPoints === undefined) {
            this.$log.warn('no checkpoints defined, use checklist-points to pass checkpoints');
        }
    };
    DVChecklistController.prototype.checkmarkSet = function () {
        if (this.onCheckstatusChaged) {
            this.onCheckstatusChaged({ allchecked: this.allChecked });
        }
    };
    DVChecklistController.prototype.getName = function (index) {
        return 'check' + index;
    };
    DVChecklistController.$inject = ['$log', '$translate', '$q', '$scope'];
    return DVChecklistController;
}());
exports.DVChecklistController = DVChecklistController;


/***/ }),

/***/ "hwXT":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".benutzer-edit-view .captcha-error{color:#ff2b59}.benutzer-edit-view form:not(.ng-submitted) .captcha-error{display:none}", ""]);

// exports


/***/ }),

/***/ "hx2R":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2020 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.mychart{height:auto;width:auto}.chart-container{position:relative;margin:auto}", ""]);

// exports


/***/ }),

/***/ "i/zj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSBemerkungSichtbarkeit_1 = __webpack_require__("2uqJ");
var TSBenutzerBemerkung_1 = __importDefault(__webpack_require__("3/Vo"));
var template = __webpack_require__("UB4u");
__webpack_require__("vwnX");
var removeDialogTemplate = __webpack_require__("YTLw");
var DVBemerkungErfassenComponentConfig = /** @class */ (function () {
    function DVBemerkungErfassenComponentConfig() {
        this.transclude = false;
        this.bindings = {
            schadenfallId: '<',
            onSuccess: '&',
            scope: '<',
        };
        this.template = template;
        this.controller = DVBemerkungErfassenController;
        this.controllerAs = 'vm';
    }
    return DVBemerkungErfassenComponentConfig;
}());
exports.DVBemerkungErfassenComponentConfig = DVBemerkungErfassenComponentConfig;
var DVBemerkungErfassenController = /** @class */ (function () {
    /* @ngInject */
    function DVBemerkungErfassenController($filter, $log, CONSTANTS, $scope, roleUtilService, $window, schadenfallModelManager, authServiceRS) {
        this.$filter = $filter;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.$scope = $scope;
        this.roleUtilService = roleUtilService;
        this.$window = $window;
        this.schadenfallModelManager = schadenfallModelManager;
        this.authServiceRS = authServiceRS;
        this.sichtbarkeit = this.getDefaultSichtbarkeit();
        this.initViewModel();
    }
    DVBemerkungErfassenController.prototype.initViewModel = function () {
    };
    DVBemerkungErfassenController.prototype.$onInit = function () {
    };
    DVBemerkungErfassenController.prototype.saveBemerkung = function () {
        var _this = this;
        if (this.bemerkung && this.schadenfallId) {
            var newBemerkung = new TSBenutzerBemerkung_1.default();
            newBemerkung.bemerkung = this.bemerkung;
            newBemerkung.scope = this.scope;
            newBemerkung.sichtbarkeit = this.sichtbarkeit;
            this.schadenfallModelManager.saveBemerkung(newBemerkung, this.schadenfallId).then(function (bemerkungResp) {
                _this.bemerkung = '';
                _this.onSuccess({ bemerkung: bemerkungResp });
            });
        }
        else {
            this.$log.debug('bemerkung or schadenfallId was empty');
        }
    };
    DVBemerkungErfassenController.prototype.getTSBemerkungSichtbarkeitValues = function () {
        return TSBemerkungSichtbarkeit_1.getTSBemerkungSichtbarkeitValues();
    };
    DVBemerkungErfassenController.prototype.getDefaultSichtbarkeit = function () {
        if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getFondssuisseRoles())) {
            return TSBemerkungSichtbarkeit_1.TSBemerkungSichtbarkeit.FONDSSUISSE;
        }
        else if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getAnlaufstelleRoles())) {
            return TSBemerkungSichtbarkeit_1.TSBemerkungSichtbarkeit.INTERN;
        }
        return TSBemerkungSichtbarkeit_1.TSBemerkungSichtbarkeit.ALLE;
    };
    DVBemerkungErfassenController.prototype.isSichtbarkeitVisible = function (sichtbarkeit) {
        if (sichtbarkeit === TSBemerkungSichtbarkeit_1.TSBemerkungSichtbarkeit.FONDSSUISSE) {
            return this.authServiceRS.isOneOfRoles(this.roleUtilService.getFondssuisseRoles());
        }
        return true;
    };
    DVBemerkungErfassenController.$inject = ['$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', 'SchadenfallModelManager', 'AuthServiceRS'];
    return DVBemerkungErfassenController;
}());
exports.DVBemerkungErfassenController = DVBemerkungErfassenController;


/***/ }),

/***/ "i1EG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAnlaufstelleType_1 = __webpack_require__("hYoR");
var TSBeitragArt_1 = __webpack_require__("HbSP");
var TSBeitragStatus_1 = __webpack_require__("RtaT");
var TSBeitrag_1 = __importDefault(__webpack_require__("Bftz"));
var TSGesuchsPersonDaten_1 = __importDefault(__webpack_require__("fiK7"));
var abstractModelManagerController_1 = __importDefault(__webpack_require__("S1yE"));
var template = __webpack_require__("MEsq");
var BeitragEditViewComponentConfig = /** @class */ (function () {
    function BeitragEditViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = BeitragViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            beitrag: '<',
            schadenfall: '<',
        };
    }
    return BeitragEditViewComponentConfig;
}());
exports.BeitragEditViewComponentConfig = BeitragEditViewComponentConfig;
var BeitragViewController = /** @class */ (function (_super) {
    __extends(BeitragViewController, _super);
    /* @ngInject */
    function BeitragViewController(dvBernUtil, schadenfallModelManager, $q, $scope, $translate, $log, $state, serfPropertyRS, zahlungsauftragRS) {
        var _this = _super.call(this, schadenfallModelManager, $scope, $state.current.name) || this;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$translate = $translate;
        _this.$log = $log;
        _this.$state = $state;
        _this.serfPropertyRS = serfPropertyRS;
        _this.zahlungsauftragRS = zahlungsauftragRS;
        _this.prozentsatzArray = new Map(); //array das kein array ist? -> map machen
        _this.readonly = false;
        return _this;
    }
    BeitragViewController.prototype.$onInit = function () {
        var _this = this;
        _super.prototype.$onInit.call(this);
        this.schadenfallModelManager.openSchadenfall(this.schadenfall.id);
        if (!this.beitrag) {
            this.beitrag = new TSBeitrag_1.default();
            this.$log.warn('initialized beitrag to edit directly in view, should pass beitrag to edit along');
        }
        else {
            this.initialModel = this.beitrag;
            this.model = angular.copy(this.beitrag);
        }
        if (this.beitrag.id) {
            this.readonly = true;
            if (this.beitrag.beitragStatus === TSBeitragStatus_1.TSBeitragStatus.AUSGEFUEHRT) {
                this.zahlungsauftragRS.getZahlungsauftraegeForBeitrag(this.beitrag.id).then(function (response) {
                    _this.zahlungsauftrag = response;
                });
            }
        }
        this.extractKanton();
        this.prepareProzentsatzMap();
    };
    BeitragViewController.prototype.prepareProzentsatzMap = function () {
        var _this = this;
        TSBeitragArt_1.getTSBeitragArtSchadenfallValues().forEach(function (art) {
            //Konstruiert den Search String, falls Kanton wird der Kantons kürzel verwendet anstatt KANTON
            var key = art.toString();
            var searchString = (art === TSBeitragArt_1.TSBeitragArt.KANTON ? _this.kanton.toString() : key) + TSBeitragArt_1.beitragPropertySuffix();
            _this.serfPropertyRS.getByName(searchString).then(function (serfProperty) {
                if (serfProperty && serfProperty.value) {
                    _this.prozentsatzArray.set(key, parseFloat(serfProperty.value));
                    _this.updateBeitragArt();
                }
            });
        });
    };
    BeitragViewController.prototype.extractKanton = function () {
        var anlaufstelle = this.schadenfall.anlaufstelle;
        var tmpKanton;
        if (anlaufstelle) {
            switch (anlaufstelle.anlaufstelleType) {
                case TSAnlaufstelleType_1.TSAnlaufstelleType.KANTON:
                    tmpKanton = anlaufstelle.kanton;
                    break;
                case TSAnlaufstelleType_1.TSAnlaufstelleType.GEMEINDE:
                    this.checkAllGemeindenHaveSameKanton(anlaufstelle);
                    tmpKanton = anlaufstelle.gemeinden[0].kanton;
                    break;
            }
            if (tmpKanton) {
                this.kanton = tmpKanton;
            }
        }
    };
    /**
     * pruefe dass alle gemeinden den gleichen kanton haben
     */
    BeitragViewController.prototype.checkAllGemeindenHaveSameKanton = function (anlaufstelle) {
        if (!anlaufstelle || anlaufstelle.gemeinden === undefined || anlaufstelle.gemeinden.length === 0) {
            this.$log.error('anlaufstelle must have gemeinden if it has type gemeinde', anlaufstelle);
            throw new Error('Illegal State, anlaufstelle should be defined and have assigned at least one gemeinde');
        }
        var tmpGemeinden = anlaufstelle.gemeinden;
        var tmpgemeindekanton = tmpGemeinden[0].kanton;
        var kantonConflict = false;
        tmpGemeinden.forEach(function (gemeinde) {
            if (tmpgemeindekanton !== gemeinde.kanton) {
                kantonConflict = true;
            }
        });
        if (kantonConflict) {
            this.$log.warn('Not all Gemeinden share the same Kanton!\nThis must not happen!\nContinue'
                + ' using Kanton of first Gemeinde of anlaufstelle.gemeinden', tmpGemeinden);
        }
    };
    BeitragViewController.prototype.saveBeitrag = function () {
        var _this = this;
        if (this.isModelValid() && this.beitrag) {
            this.schadenfallModelManager.saveBeitrag(this.getModel()).then(function () {
                _this.$state.go('entschaedigung', { schadenfallId: _this.schadenfall.id });
            });
        }
        else {
            this.$log.debug('Form was not valid');
        }
    };
    BeitragViewController.prototype.cancelBeitrag = function () {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('entschaedigung', { schadenfallId: this.schadenfall.id });
    };
    BeitragViewController.prototype.getAvailableTSBeitragArtValues = function () {
        var date = this.schadenfall.schaeden[0].schadenDatenFS.schadendatum;
        return date ? TSBeitragArt_1.getTSBeitragArtValuesByYear(date.year()) : TSBeitragArt_1.getDefaultTSBeitragArtValues();
    };
    BeitragViewController.prototype.translateBeitragArt = function (art) {
        var prefix = TSBeitragArt_1.beitragArtPrefix();
        return this.$translate.instant(prefix + TSBeitragArt_1.TSBeitragArt[art]);
    };
    BeitragViewController.prototype.getModel = function () {
        return this.beitrag;
    };
    BeitragViewController.prototype.getBankVerbindung = function () {
        if (this.beitrag.bankverbindung) {
            return this.beitrag.bankverbindung;
        }
        return this.schadenfall.gesuchsteller.finanzangaben.finanzangabenDatenFS.bankverbindung; // bei erstperson sind finanzangaben da
    };
    BeitragViewController.prototype.getGesuchsteller = function () {
        var gesuchsteller = this.schadenfall.gesuchsteller.kontaktperson;
        if (gesuchsteller) {
            return gesuchsteller.gesuchsPersonDatenFS;
        }
        return new TSGesuchsPersonDaten_1.default();
    };
    BeitragViewController.prototype.updateBeitragArt = function () {
        if (this.getModel().beitragArt) {
            this.prozentsatz = this.prozentsatzArray.get(this.getModel().beitragArt.toString());
            this.betragVorschlag = parseFloat(this.schadenfall.getAnrechenbarerSchaden(this.prozentsatz).toFixed(2));
            this.betragVorschlag = Math.max(this.betragVorschlag, 0); //vorschlag kann nicht kleiner 0 sein
            if (!this.readonly) {
                this.beitrag.beitrag = this.betragVorschlag;
            }
        }
    };
    BeitragViewController.$inject = ['DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$log', '$state', 'SerfPropertyRS', 'ZahlungsauftragRS'];
    return BeitragViewController;
}(abstractModelManagerController_1.default));
exports.BeitragViewController = BeitragViewController;


/***/ }),

/***/ "i5TL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSSchadenfallPreFilterDTO = /** @class */ (function () {
    function TSSchadenfallPreFilterDTO(filterUsername, username, filterStatus, status) {
        this.filterUsername = filterUsername;
        this.username = username;
        this.filterStatus = filterStatus;
        this.status = status;
    }
    return TSSchadenfallPreFilterDTO;
}());
exports.default = TSSchadenfallPreFilterDTO;


/***/ }),

/***/ "i6dW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSZahlungsauftragDTO_1 = __importDefault(__webpack_require__("eHYE"));
var TSZahlungsauftraegeSearchresultDTO = /** @class */ (function () {
    function TSZahlungsauftraegeSearchresultDTO() {
        this._zahlungsauftragDTOs = [];
        this._totalResultSize = 0;
    }
    Object.defineProperty(TSZahlungsauftraegeSearchresultDTO.prototype, "zahlungsauftragDTOs", {
        get: function () {
            return this._zahlungsauftragDTOs;
        },
        set: function (value) {
            this._zahlungsauftragDTOs = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSZahlungsauftraegeSearchresultDTO.prototype, "totalResultSize", {
        get: function () {
            return this._totalResultSize;
        },
        set: function (value) {
            this._totalResultSize = value;
        },
        enumerable: true,
        configurable: true
    });
    TSZahlungsauftraegeSearchresultDTO.prototype.parseZahlungsauftragDTOs = function (data) {
        var zahlungsauftragDTO = [];
        if (data && Array.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                zahlungsauftragDTO[i] = new TSZahlungsauftragDTO_1.default().deserialize(data[i]);
            }
        }
        else {
            zahlungsauftragDTO[0] = new TSZahlungsauftragDTO_1.default().deserialize(data);
        }
        return zahlungsauftragDTO;
    };
    TSZahlungsauftraegeSearchresultDTO.prototype.deserialize = function (restObject) {
        this.zahlungsauftragDTOs = this.parseZahlungsauftragDTOs(restObject.zahlungsauftragDTOs);
        this.totalResultSize = restObject.paginationDTO.totalItemCount;
        return this;
    };
    return TSZahlungsauftraegeSearchresultDTO;
}());
exports.default = TSZahlungsauftraegeSearchresultDTO;


/***/ }),

/***/ "i9ei":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MapController = /** @class */ (function () {
    function MapController($uibModalInstance, $translate, lat, lon, reado, $log) {
        this.$uibModalInstance = $uibModalInstance;
        this.lat = lat;
        this.lon = lon;
        this.reado = reado;
        this.$log = $log;
        if (!lat) {
            lat = '';
        }
        if (!lon) {
            lon = '';
        }
    }
    MapController.prototype.ok = function () {
        this.$uibModalInstance.close({ lat: this.lat, lon: this.lon });
    };
    ;
    MapController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    ;
    MapController.prototype.positionChanged = function (lon, lat) {
        this.lat = lat;
        this.lon = lon;
    };
    MapController.$inject = ['$uibModalInstance', '$translate', 'lat', 'lon', 'reado', '$log'];
    return MapController;
}());
exports.MapController = MapController;


/***/ }),

/***/ "iGoB":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("jMwA");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./konfigurationView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./konfigurationView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "iLJJ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */", ""]);

// exports


/***/ }),

/***/ "iMHU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSBankverbindung = /** @class */ (function (_super) {
    __extends(TSBankverbindung, _super);
    function TSBankverbindung() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSBankverbindung.prototype, "bankName", {
        get: function () {
            return this._bankName;
        },
        set: function (value) {
            this._bankName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBankverbindung.prototype, "bankPLZ", {
        get: function () {
            return this._bankPLZ;
        },
        set: function (value) {
            this._bankPLZ = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBankverbindung.prototype, "bankOrt", {
        get: function () {
            return this._bankOrt;
        },
        set: function (value) {
            this._bankOrt = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBankverbindung.prototype, "iban", {
        get: function () {
            return this._iban;
        },
        set: function (value) {
            this._iban = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBankverbindung.prototype, "inhaberName", {
        get: function () {
            return this._inhaberName;
        },
        set: function (value) {
            this._inhaberName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBankverbindung.prototype, "inhaberPLZ", {
        get: function () {
            return this._inhaberPLZ;
        },
        set: function (value) {
            this._inhaberPLZ = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSBankverbindung.prototype, "inhaberOrt", {
        get: function () {
            return this._inhaberOrt;
        },
        set: function (value) {
            this._inhaberOrt = value;
        },
        enumerable: true,
        configurable: true
    });
    TSBankverbindung.prototype.deserialize = function (restObject) {
        this.bankName = restObject.bankName;
        this.bankPLZ = restObject.bankPLZ;
        this.bankOrt = restObject.bankOrt;
        this.inhaberName = restObject.inhaberName;
        this.inhaberPLZ = restObject.inhaberPLZ;
        this.inhaberOrt = restObject.inhaberOrt;
        this.iban = restObject.iban;
        return this;
    };
    TSBankverbindung.prototype.serialize = function (restObject) {
        restObject.bankName = this.getOptionalString(this.bankName);
        restObject.bankPLZ = this.getOptionalString(this.bankPLZ);
        restObject.bankOrt = this.getOptionalString(this.bankOrt);
        restObject.inhaberName = this.inhaberName;
        restObject.inhaberPLZ = this.inhaberPLZ;
        restObject.inhaberOrt = this.inhaberOrt;
        restObject.iban = this.iban;
        return restObject;
    };
    return TSBankverbindung;
}(TSAbstractEntity_1.default));
exports.default = TSBankverbindung;


/***/ }),

/***/ "iN5/":
/***/ (function(module, exports) {

module.exports = " <div class=\"eigenleistung-view container\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <fieldset ng-disabled=\"vm.isSchadenFallReadonly()\" ng-if=\"vm.isSchadenFallVisible()\"> <div class=\"row\"> <div class=\"col-sm-12\"> <h2> <span data-translate=\"EIGENLEISTUNG_ADD\" ng-if=\"!vm.schaetzung\"></span> <span data-translate=\"SCHAETZUNG_ADD\" ng-if=\"vm.schaetzung\"></span> </h2> </div> <div class=\"col-sm-12\"> <dv-eigenleistungen eigenleistung=\"vm.getModel()\" readonly=\"vm.readonly\" schadenfall=\"vm.schadenfall\" save-disabled=\"vm.saveDisabled\" schadenfall-status=\"vm.schadenfallStatus\"> </dv-eigenleistungen> </div> </div> </fieldset> <div class=\"col-sm-12\"> <div class=\"row mainbuttons\"> <div> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.cancelEigenleistungen()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> <div ng-if=\"!vm.isSchadenFallReadonly()\"> <dv-loading-button type=\"submit\" button-click=\"vm.saveEigenleistungen()\" button-class=\"btn btn-serf\" button-disabled=\"vm.saveDisabled\"> <span data-translate=\"SAVE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </div> </form> </div> ";

/***/ }),

/***/ "ivjz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSSchadenObjektDaten = /** @class */ (function (_super) {
    __extends(TSSchadenObjektDaten, _super);
    function TSSchadenObjektDaten() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSSchadenObjektDaten.prototype, "kulturart", {
        get: function () {
            return this._kulturart;
        },
        set: function (value) {
            this._kulturart = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenObjektDaten.prototype, "flaecheAre", {
        get: function () {
            return this._flaecheAre;
        },
        set: function (value) {
            this._flaecheAre = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenObjektDaten.prototype, "holzMenge", {
        get: function () {
            return this._holzMenge;
        },
        set: function (value) {
            this._holzMenge = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenObjektDaten.prototype, "anzahl", {
        get: function () {
            return this._anzahl;
        },
        set: function (value) {
            this._anzahl = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenObjektDaten.prototype, "sorte", {
        get: function () {
            return this._sorte;
        },
        set: function (value) {
            this._sorte = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenObjektDaten.prototype, "alter", {
        get: function () {
            return this._alter;
        },
        set: function (value) {
            this._alter = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenObjektDaten.prototype, "laenge", {
        get: function () {
            return this._laenge;
        },
        set: function (value) {
            this._laenge = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenObjektDaten.prototype, "breite", {
        get: function () {
            return this._breite;
        },
        set: function (value) {
            this._breite = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenObjektDaten.prototype, "hoehe", {
        get: function () {
            return this._hoehe;
        },
        set: function (value) {
            this._hoehe = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenObjektDaten.prototype, "bauart", {
        get: function () {
            return this._bauart;
        },
        set: function (value) {
            this._bauart = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenObjektDaten.prototype, "art", {
        get: function () {
            return this._art;
        },
        set: function (value) {
            this._art = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenObjektDaten.prototype, "versicherungVorhanden", {
        get: function () {
            return this._versicherungVorhanden;
        },
        set: function (value) {
            this._versicherungVorhanden = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenObjektDaten.prototype, "versicherungArt", {
        get: function () {
            return this._versicherungArt;
        },
        set: function (value) {
            this._versicherungArt = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenObjektDaten.prototype, "versicherungGemeldet", {
        get: function () {
            return this._versicherungGemeldet;
        },
        set: function (value) {
            this._versicherungGemeldet = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenObjektDaten.prototype, "letzteInstandstellung", {
        get: function () {
            return this._letzteInstandstellung;
        },
        set: function (value) {
            this._letzteInstandstellung = value;
        },
        enumerable: true,
        configurable: true
    });
    TSSchadenObjektDaten.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.kulturart = restObject.kulturart;
        this.flaecheAre = restObject.flaecheAre;
        this.anzahl = restObject.anzahl;
        this.sorte = restObject.sorte;
        this.alter = restObject.alter;
        this.letzteInstandstellung = restObject.letzteInstandstellung;
        this.laenge = restObject.laenge;
        this.breite = restObject.breite;
        this.hoehe = restObject.hoehe;
        this.bauart = restObject.bauart;
        this.art = restObject.art;
        this.versicherungVorhanden = restObject.versicherungVorhanden;
        this.versicherungArt = restObject.versicherungArt;
        this.versicherungGemeldet = restObject.versicherungGemeldet;
        this.holzMenge = restObject.holzMenge;
        return this;
    };
    TSSchadenObjektDaten.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.kulturart = this.kulturart;
        restObject.flaecheAre = this.flaecheAre;
        restObject.anzahl = this.anzahl;
        restObject.sorte = this.sorte;
        restObject.alter = this.alter;
        restObject.letzteInstandstellung = this.letzteInstandstellung;
        restObject.laenge = this.laenge;
        restObject.breite = this.breite;
        restObject.hoehe = this.hoehe;
        restObject.bauart = this.bauart;
        restObject.art = this.art;
        restObject.versicherungVorhanden = this.versicherungVorhanden;
        restObject.versicherungArt = this.versicherungArt;
        restObject.versicherungGemeldet = this.versicherungGemeldet;
        restObject.holzMenge = this.holzMenge;
        return restObject;
    };
    return TSSchadenObjektDaten;
}(TSAbstractEntity_1.default));
exports.default = TSSchadenObjektDaten;


/***/ }),

/***/ "j1to":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "j2/v":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".password-reset{overflow-y:auto;background-image:url(" + escape(__webpack_require__("LYXy")) + ");background-size:cover}.password-reset h1{font-size:20pt}.password-reset .text{color:#fff}.password-reset .loginbox{background:rgba(184,52,56,.9);margin-bottom:50px;color:#fff;max-width:750px}.password-reset .loginbox .error{color:#ff8a1b}.password-reset .loginbox a{color:#fff;font-style:italic}.password-reset .regbox{font-size:18px;font-weight:600;background-color:#789;opacity:.9;margin-top:200px;max-width:750px;text-align:center}", ""]);

// exports


/***/ }),

/***/ "jFBa":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("FldB");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-eigenleistungen-list.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-eigenleistungen-list.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "jJP+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSVersicherungsbeitragStatus;
(function (TSVersicherungsbeitragStatus) {
    TSVersicherungsbeitragStatus[TSVersicherungsbeitragStatus["NEU"] = 'NEU'] = "NEU";
    TSVersicherungsbeitragStatus[TSVersicherungsbeitragStatus["IN_BEARBEITUNG_FS"] = 'IN_BEARBEITUNG_FS'] = "IN_BEARBEITUNG_FS";
    TSVersicherungsbeitragStatus[TSVersicherungsbeitragStatus["AUSZAHLUNG"] = 'AUSZAHLUNG'] = "AUSZAHLUNG";
    TSVersicherungsbeitragStatus[TSVersicherungsbeitragStatus["ABGESCHLOSSEN"] = 'ABGESCHLOSSEN'] = "ABGESCHLOSSEN";
    TSVersicherungsbeitragStatus[TSVersicherungsbeitragStatus["ABGELEHNT_FONDSSUISSE"] = 'ABGELEHNT_FONDSSUISSE'] = "ABGELEHNT_FONDSSUISSE";
})(TSVersicherungsbeitragStatus = exports.TSVersicherungsbeitragStatus || (exports.TSVersicherungsbeitragStatus = {}));
function getTSVersicherungsbeitragStatusalues() {
    return [
        TSVersicherungsbeitragStatus.NEU,
        TSVersicherungsbeitragStatus.IN_BEARBEITUNG_FS,
        TSVersicherungsbeitragStatus.AUSZAHLUNG,
        TSVersicherungsbeitragStatus.ABGESCHLOSSEN,
        TSVersicherungsbeitragStatus.ABGELEHNT_FONDSSUISSE,
    ];
}
exports.getTSVersicherungsbeitragStatusalues = getTSVersicherungsbeitragStatusalues;
function getTSVersicherungsbeitragStatusInBearbeitung() {
    return [
        TSVersicherungsbeitragStatus.NEU,
        TSVersicherungsbeitragStatus.IN_BEARBEITUNG_FS,
    ];
}
exports.getTSVersicherungsbeitragStatusInBearbeitung = getTSVersicherungsbeitragStatusInBearbeitung;
/**
 * Returns true when the status of the Gesuch is Geschlossen
 * @returns {boolean}
 */
function isStatusInBearbeitung(status) {
    return isInStatus(status, getTSVersicherungsbeitragStatusInBearbeitung());
}
exports.isStatusInBearbeitung = isStatusInBearbeitung;
function isInStatus(status, statusArray) {
    try {
        for (var statusArray_1 = __values(statusArray), statusArray_1_1 = statusArray_1.next(); !statusArray_1_1.done; statusArray_1_1 = statusArray_1.next()) {
            var istatus = statusArray_1_1.value;
            if (istatus === status) {
                return true;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (statusArray_1_1 && !statusArray_1_1.done && (_a = statusArray_1.return)) _a.call(statusArray_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
    var e_1, _a;
}
exports.isInStatus = isInStatus;


/***/ }),

/***/ "jLEA":
/***/ (function(module, exports) {

module.exports = "<div ng-messages=\"vm.errorObject.$error\" class=\"dv-alert-box dv-alert-box--error dv-alert-box--input-alert\" ng-class=\"{'dv-alert-box--clean': (!vm.errorObject.$touched ||!vm.errorObject.$dirty || vm.errorObject.$valid),\n     'dv-alert-box--error': (!vm.isOpaque),\n     'dv-alert-box--error--opaque': (vm.isOpaque)}\"> <div class=\"dv-alert-box__message\"> <span ng-message=\"required\" role=\"alert\" data-translate=\"{{vm.requiredText}}\"></span> <span ng-message=\"min\" role=\"alert\" data-translate=\"ERROR_MIN\"></span> <span ng-message=\"minlength\" role=\"alert\" data-translate=\"ERROR_MIN_LENG\"></span> <span ng-message=\"maxlength\" role=\"alert\" data-translate=\"ERROR_MAX_LENG\"></span> <span ng-message=\"number\" role=\"alert\" data-translate=\"ERROR_NUMBER\"></span> <span ng-message=\"dvMaxLength\" role=\"alert\" data-translate=\"ERROR_MAX_LENG\"></span> <span ng-message=\"email\" role=\"alert\" data-translate=\"ERROR_EMAIL\"></span> <span ng-message=\"pattern\" role=\"alert\" data-translate=\"ERROR_FORMAT\"></span> <span ng-message=\"date\" role=\"alert\" data-translate=\"ERROR_DATE\"></span> <span ng-message=\"moment\" role=\"alert\" data-translate=\"ERROR_DATE\"></span> <span ng-message=\"max\" role=\"alert\" data-translate=\"ERROR_MAX\"></span> <span ng-message=\"valueinput\" role=\"alert\" data-translate=\"ERROR_VALUE\"></span> <div ng-message=\"future\" role=\"alert\" data-translate=\"ERROR_FUTURE\"></div> <div ng-message=\"past\" role=\"alert\" data-translate=\"ERROR_PAST\"></div> <div ng-message=\"parse\" role=\"alert\" data-translate=\"ERROR_PARSE\"></div> </div> </div> ";

/***/ }),

/***/ "jLGy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright © 2019 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSReportType;
(function (TSReportType) {
    TSReportType[TSReportType["AUSZAHLUNG_KANTON"] = 'AUSZAHLUNG_KANTON'] = "AUSZAHLUNG_KANTON";
    TSReportType[TSReportType["AUSZAHLUNG"] = 'AUSZAHLUNG'] = "AUSZAHLUNG";
    TSReportType[TSReportType["SCHADEN"] = 'SCHADEN'] = "SCHADEN";
    TSReportType[TSReportType["ALLE"] = 'ALLE'] = "ALLE";
})(TSReportType = exports.TSReportType || (exports.TSReportType = {}));
function getTSReportTypeValues() {
    return [
        TSReportType.AUSZAHLUNG_KANTON,
        TSReportType.AUSZAHLUNG,
        TSReportType.SCHADEN,
        TSReportType.ALLE,
    ];
}
exports.getTSReportTypeValues = getTSReportTypeValues;
function getTSReportTypeValuesWhitoutKanton() {
    return [
        TSReportType.AUSZAHLUNG,
        TSReportType.SCHADEN,
        TSReportType.ALLE,
    ];
}
exports.getTSReportTypeValuesWhitoutKanton = getTSReportTypeValuesWhitoutKanton;
exports.displayAuszahlungsDatumMap = new Map()
    .set(TSReportType.AUSZAHLUNG_KANTON, true)
    .set(TSReportType.AUSZAHLUNG, true)
    .set(TSReportType.SCHADEN, false)
    .set(TSReportType.ALLE, false);
exports.displayEreignisDatumMap = new Map()
    .set(TSReportType.AUSZAHLUNG_KANTON, true)
    .set(TSReportType.AUSZAHLUNG, true)
    .set(TSReportType.SCHADEN, true)
    .set(TSReportType.ALLE, true);
exports.displayGesuchsDatumMap = new Map()
    .set(TSReportType.AUSZAHLUNG_KANTON, true)
    .set(TSReportType.AUSZAHLUNG, true)
    .set(TSReportType.SCHADEN, true)
    .set(TSReportType.ALLE, true);


/***/ }),

/***/ "jMwA":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".add-person-button{margin-top:22px;float:none;min-width:40px}", ""]);

// exports


/***/ }),

/***/ "jUP6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "jXFx":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "jqji":
/***/ (function(module, exports) {

module.exports = " <div class=\"dv-fremdkosten-list\"> <div class=\"table-responsive\"> <table st-table=\"displayedCollection\" st-safe-src=\"vm.fremdkosten\" st-delay=\"20\" class=\"table fixedtable table-hover\" id=\"{{vm.tableId}}\" title=\"{{vm.tableTitle}}\" dv-st-table-refresh> <thead> <tr class=\"header-row\"> <th ng-class=\"vm.schaetzung ? 'rowHeader-leistungsart' : ''\" data-translate=\"LEISTUNGSART\"></th> <th ng-if=\"!vm.schaetzung\" data-translate=\"FIRMA\"></th> <th ng-if=\"vm.schaetzung\" data-translate=\"BESCHREIBUNG\"></th> <th class=\"text-right ellipsis rowHeader-rechnungsdatum\" ng-if=\"!vm.schaetzung\"> <span data-translate=\"RECHNUNGSDATUM\"></span> </th> <th class=\"text-right ellipsis\" ng-if=\"vm.schaetzung\" ng-class=\"vm.schaetzung ? 'rowHeader-schaetzung' : ''\"> </th> <th class=\"text-right ellipsis rowHeader-rechnungsnummer\" ng-if=\"!vm.schaetzung\"> <span data-translate=\"RECHNUNGSNUMMER\"></span> </th> <th class=\"text-right ellipsis\" ng-if=\"vm.schaetzung\" ng-class=\"vm.schaetzung ? 'rowHeader-schaetzung' : ''\"> </th> <th class=\"text-right rowHeader-betrag\" data-translate=\"BETRAG\"></th> <th class=\"text-right rowHeader-berechtigterBetrag\" ng-class=\"vm.schaetzung ? 'schaetzung' : ''\"> <span dv-show-expression=\"!vm.schaetzung\" data-translate=\"EIGENLEISTUNG_BETRAG_BERECHTIGT\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\"> </span> </th> <th class=\"rowHeader-actions\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"row in displayedCollection\" st-select-row=\"row\" st-select-mode=\"single\"> <td class=\"ellipsis\" title=\"{{vm.translateLeistungsart(row.fremdkostenDatenFS.leistungsart)}}\" ng-bind=\"vm.translateLeistungsart(row.fremdkostenDatenFS.leistungsart)\"> </td> <td class=\"ellipsis\" title=\"{{row.fremdkostenDatenFS.firma}}\" ng-bind=\"row.fremdkostenDatenFS.firma\"> </td> <td class=\"ellipsis mono\"> <span ng-if=\"!vm.schaetzung\" title=\"{{row.fremdkostenDatenFS.rechnungsdatum | amDateFormat : 'DD.MM.YYYY'}}\" ng-bind=\"row.fremdkostenDatenFS.rechnungsdatum | amDateFormat : 'DD.MM.YYYY'\"> </span> </td> <td class=\"ellipsis mono text-right\" title=\"{{row.fremdkostenDatenFS.rechnungsnummer}}\" ng-bind=\"row.fremdkostenDatenFS.rechnungsnummer\"> </td> <td class=\"ellipsis mono text-right\" title=\"{{row.fremdkostenDatenFS.rechnungsbetrag | currency: 'CHF'}}\" ng-bind=\"row.fremdkostenDatenFS.rechnungsbetrag | currency: 'CHF'\"> </td> <td> </td> <td class=\"clearfix rowBody-actions\" ng-if=\"!vm.readonly\"> <button ng-click=\"vm.editClicked(row, $event)\" class=\"btn-link\"> <span class=\"fa fa-edit\" title=\"{{'EDIT' | translate}}\"></span> </button> <button ng-click=\"vm.deleteClicked(row, $event)\" class=\"btn-link\"> <span class=\"fa fa-trash-o\" title=\"{{'DELETE' | translate}}\"></span> </button> </td> <td ng-if=\"vm.readonly\" class=\"clearfix rowBody-actions\"> <button ng-click=\"vm.editClicked(row, $event)\" class=\"btn-link\"> <span class=\"fa fa-eye\" title=\"{{'VIEW' | translate}}\"></span> </button> </td> </tr> <tr ng-if=\"!displayedCollection || displayedCollection.length === 0\"> <td colspan=\"{{vm.getColumnsNumber()}}\" class=\"empty-table\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> <tfoot> <tr class=\"tr-highlight\"> <td colspan=\"4\" data-translate=\"TOTAL\"></td> <td class=\"text-right mono\" ng-bind=\"vm.calcTotalBetrag() |  currency: 'CHF'\"></td> <td class=\"text-right mono\"> <div dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\" dv-show-expression=\"!vm.schaetzung\"> <dv-input-container class=\"no-margin\"> <dv-valueinput input-id=\"fremdkosten_berechtigerbetrag_ID\" name=\"fremdkosten_berechtigerbetrag\" input-name=\"fremdkosten_berechtigerbetrag\" ng-model=\"vm.schadenfall.berechtigterBetragFremdkosten\" ng-required=\"true\" float=\"true\" fixed-decimals=\"2\" allow-negative=\"false\" class=\"input-element bigger-font\"> </dv-valueinput> </dv-input-container> </div> </td> <td colspan=\"1\"> <div dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\" dv-show-expression=\"!vm.schaetzung\"> <dv-loading-button type=\"submit\" button-click=\"vm.speichernGesuch()\" button-class=\"btn btn-serf pull-right\"> <span data-translate=\"SAVE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </td> </tr> </tfoot> </table> </div> </div> ";

/***/ }),

/***/ "jvKN":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("LP7T");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dummyAuthentication.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dummyAuthentication.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "k04f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSSchadenObjekt_1 = __webpack_require__("eUxz");
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSSchadenDaten_1 = __importDefault(__webpack_require__("4Vie"));
var TSSchaden = /** @class */ (function (_super) {
    __extends(TSSchaden, _super);
    function TSSchaden() {
        var _this = _super.call(this) || this;
        _this._documentIdsToConnect = [];
        _this._schadenObjektEnabledMap = {};
        _this._schadenObjektEnabledMap[TSSchadenObjekt_1.TSSchadenObjektTyp.KULTURLAND] = ['versicherung', 'kulturart', 'flaecheAre'];
        _this._schadenObjektEnabledMap[TSSchadenObjekt_1.TSSchadenObjektTyp.OBSTBAUM_REBSTOECKE] = ['flaecheAre', 'anzahl', 'sorte', 'alter'];
        _this._schadenObjektEnabledMap[TSSchadenObjekt_1.TSSchadenObjektTyp.STRASSEN_WEGE] = ['laenge', 'breite', 'bauart', 'letzteInstandstellung'];
        _this._schadenObjektEnabledMap[TSSchadenObjekt_1.TSSchadenObjektTyp.BRUECKEN_DURCHLAESSE] = ['laenge', 'breite', 'alter', 'bauart'];
        _this._schadenObjektEnabledMap[TSSchadenObjekt_1.TSSchadenObjektTyp.UFER_BACHBAUTEN] = ['laenge', 'alter', 'bauart'];
        _this._schadenObjektEnabledMap[TSSchadenObjekt_1.TSSchadenObjektTyp.STUETZMAUER_REBMAUERN] = ['laenge', 'breite', 'hoehe', 'alter', 'bauart'];
        _this._schadenObjektEnabledMap[TSSchadenObjekt_1.TSSchadenObjektTyp.HAUSUMSCHWUNG] = ['versicherung'];
        _this._schadenObjektEnabledMap[TSSchadenObjekt_1.TSSchadenObjektTyp.EINFRIEDUNG] = ['laenge', 'bauart'];
        _this._schadenObjektEnabledMap[TSSchadenObjekt_1.TSSchadenObjektTyp.LEITUNGEN_AUSSERHALB_DER_GEBAEUDE] = ['art', 'laenge'];
        _this._schadenObjektEnabledMap[TSSchadenObjekt_1.TSSchadenObjektTyp.WALD] = ['flaecheAre', 'holzMenge'];
        return _this;
    }
    Object.defineProperty(TSSchaden.prototype, "schadenDatenGS", {
        get: function () {
            return this._schadenDatenGS;
        },
        set: function (value) {
            this._schadenDatenGS = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchaden.prototype, "schadenDatenFS", {
        get: function () {
            return this._schadenDatenFS;
        },
        set: function (value) {
            this._schadenDatenFS = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchaden.prototype, "schadenObjektEnabledMap", {
        get: function () {
            return this._schadenObjektEnabledMap;
        },
        enumerable: true,
        configurable: true
    });
    /*Nicht benoetigte Felder werden vor dem speichern geloescht*/
    TSSchaden.prototype.cleanSchadenObjekt = function () {
        if (this.schadenDatenFS && this.schadenDatenFS.schadenObjektDaten) {
            if (!this.propertyExistsForSchadenObjektType('versicherung')) {
                this.schadenDatenFS.schadenObjektDaten.versicherungVorhanden = undefined;
                this.schadenDatenFS.schadenObjektDaten.versicherungGemeldet = undefined;
            }
            else {
                if (this.schadenDatenFS.schadenObjektDaten.versicherungVorhanden === false) {
                    this.schadenDatenFS.schadenObjektDaten.versicherungGemeldet = undefined;
                }
            }
            if (!this.propertyExistsForSchadenObjektType('kulturart')) {
                this.schadenDatenFS.schadenObjektDaten.kulturart = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('flaecheAre')) {
                this.schadenDatenFS.schadenObjektDaten.flaecheAre = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('anzahl')) {
                this.schadenDatenFS.schadenObjektDaten.anzahl = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('letzteInstandstellung')) {
                this.schadenDatenFS.schadenObjektDaten.letzteInstandstellung = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('sorte')) {
                this.schadenDatenFS.schadenObjektDaten.sorte = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('alter')) {
                this.schadenDatenFS.schadenObjektDaten.alter = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('laenge')) {
                this.schadenDatenFS.schadenObjektDaten.laenge = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('breite')) {
                this.schadenDatenFS.schadenObjektDaten.breite = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('hoehe')) {
                this.schadenDatenFS.schadenObjektDaten.hoehe = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('bauart')) {
                this.schadenDatenFS.schadenObjektDaten.bauart = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('art')) {
                this.schadenDatenFS.schadenObjektDaten.art = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('holzMenge')) {
                this.schadenDatenFS.schadenObjektDaten.holzMenge = undefined;
            }
        }
    };
    TSSchaden.prototype.propertyExistsForSchadenObjektType = function (what) {
        if (this.schadenDatenFS && this.schadenDatenFS.schadenObjekt) {
            var list = this.schadenObjektEnabledMap[this.schadenDatenFS.schadenObjekt];
            if (list && what) {
                for (var i = 0; i < list.length; i++) {
                    if (list[i] === what) {
                        return true;
                    }
                }
            }
        }
        return false;
    };
    TSSchaden.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.schadenDatenFS = this.deserializeOrCreate(restObject.schadenDatenFS, new TSSchadenDaten_1.default());
        this.schadenDatenGS = this.deserializeOrNull(restObject.schadenDatenGS, new TSSchadenDaten_1.default());
        return this;
    };
    TSSchaden.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.schadenDatenGS = this.serializeOrInit(this.schadenDatenGS, restObject.schadenDatenGS);
        restObject.schadenDatenFS = this.serializeOrInit(this.schadenDatenFS, restObject.schadenDatenFS);
        restObject.documentIdsToConnect = this.documentIdsToConnect;
        return restObject;
    };
    Object.defineProperty(TSSchaden.prototype, "documentIdsToConnect", {
        get: function () {
            return this._documentIdsToConnect;
        },
        set: function (value) {
            this._documentIdsToConnect = value;
        },
        enumerable: true,
        configurable: true
    });
    TSSchaden.getDeserializer = function (schaden) {
        return new TSSchaden().deserialize(schaden);
    };
    TSSchaden.getSerializer = function (schaden) {
        return schaden.serialize(schaden);
    };
    return TSSchaden;
}(TSAbstractEntity_1.default));
exports.default = TSSchaden;


/***/ }),

/***/ "k1nX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSRole_1 = __webpack_require__("MleR");
var TSAnlaufstelle_1 = __importDefault(__webpack_require__("B4Ew"));
var TSAnlaufstelleWithUsers_1 = __importDefault(__webpack_require__("em2S"));
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
/**
 * Service zum verwalten von Anlaufstellen.
 */
var AnlaufstelleRS = /** @class */ (function () {
    /* @ngInject */
    function AnlaufstelleRS($http, CONSTANTS, $q, $rootScope, $log) {
        this.$http = $http;
        this.CONSTANTS = CONSTANTS;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$log = $log;
    }
    AnlaufstelleRS.prototype.getAllAnlaufstellen = function () {
        var _this = this;
        return this.$http.get(this.CONSTANTS.REST_API + 'anlaufstellen/')
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING Anlaufstellen REST  object', response.data);
                return TSAnlaufstelle_1.default.deserializeArray(response.data);
            }
            else {
                return [];
            }
        });
    };
    AnlaufstelleRS.prototype.getBenutzerOfAnlaufstelle = function (anlaufstelleId, roleToLimitTo) {
        var _this = this;
        var configObject;
        if (roleToLimitTo === undefined) {
            configObject = {
                params: {
                    rolesToLimitTo: [TSRole_1.TSRole[TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER], TSRole_1.TSRole[TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER]]
                }
            };
        }
        else {
            configObject = {
                params: {
                    rolesToLimitTo: [TSRole_1.TSRole[roleToLimitTo]]
                }
            };
        }
        return this.$http.get(this.CONSTANTS.REST_API + 'anlaufstellen/' + encodeURIComponent(anlaufstelleId) + '/benutzer', configObject)
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING Benutzer REST  object', response.data);
                return TSBenutzer_1.default.deserializeArray(response.data);
            }
            else {
                return [];
            }
        });
    };
    AnlaufstelleRS.prototype.findAnlaufstelle = function (anlaufstelleId) {
        var _this = this;
        return this.$http.get(this.CONSTANTS.REST_API + 'anlaufstellen/' + encodeURIComponent(anlaufstelleId))
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING TSAnlaufstelle REST  object', response.data);
                return new TSAnlaufstelle_1.default().deserialize(response.data);
            }
            else {
                return undefined;
            }
        });
    };
    AnlaufstelleRS.prototype.findAnlaufstelleWithUsers = function (anlaufstelleId) {
        var _this = this;
        return this.$http.get(this.CONSTANTS.REST_API + 'anlaufstellen/' + encodeURIComponent(anlaufstelleId) + '/full')
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING TSAnlaufstelleWithUsers REST  object', response.data);
                return new TSAnlaufstelleWithUsers_1.default().deserialize(response.data);
            }
            else {
                return undefined;
            }
        });
    };
    AnlaufstelleRS.prototype.createOrUpdate = function (anlaufstelle) {
        if (anlaufstelle) {
            var restAnlaufstelle = anlaufstelle.serialize({});
            return this.$http.put(this.CONSTANTS.REST_API + 'anlaufstellen/', restAnlaufstelle)
                .then(function (response) {
                if (response.data !== undefined) {
                    return new TSAnlaufstelleWithUsers_1.default().deserialize(response.data);
                }
                else {
                    return undefined;
                }
            });
        }
        this.$log.error('passed no data, no createOrUpdate request sent');
        return this.$q.when(undefined);
    };
    AnlaufstelleRS.prototype.createAnlaufstelleRegistration = function (anlaufstelle) {
        if (anlaufstelle) {
            var restAnlaufstelle = anlaufstelle.serialize({});
            return this.$http.post(this.CONSTANTS.REST_API + 'anlaufstellen/public/registration', restAnlaufstelle)
                .then(function (response) {
                if (response.data !== undefined) {
                    return new TSAnlaufstelleWithUsers_1.default().deserialize(response.data);
                }
                else {
                    return undefined;
                }
            });
        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    };
    AnlaufstelleRS.prototype.readAnlaufstellenSuggestion = function (searchString) {
        var _this = this;
        return this.$http.get(this.CONSTANTS.REST_API + 'anlaufstellen/search/', {
            params: {
                queryString: searchString,
            }
        })
            .then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING Anlaufstellen REST  object', response.data);
                return TSAnlaufstelle_1.default.deserializeArray(response.data);
            }
            else {
                return [];
            }
        });
    };
    AnlaufstelleRS.$inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];
    return AnlaufstelleRS;
}());
exports.default = AnlaufstelleRS;


/***/ }),

/***/ "kEdQ":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("ZgkC");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./versicherungsbeitragVersicherterView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./versicherungsbeitragVersicherterView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "keDS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Chart = __webpack_require__("ikxi");
__webpack_require__("CbzH");
var DvPieChartsComponentConfig = /** @class */ (function () {
    function DvPieChartsComponentConfig() {
        this.transclude = false;
        this.bindings = {
            chartid: '<',
            dataset: '<'
        };
        this.template = __webpack_require__("Etn9");
        this.controller = DvPieChartsController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return DvPieChartsComponentConfig;
}());
exports.DvPieChartsComponentConfig = DvPieChartsComponentConfig;
var DvPieChartsController = /** @class */ (function () {
    function DvPieChartsController($log, $window, $timeout, $scope) {
        this.$log = $log;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.data = [];
        this.label = [];
    }
    DvPieChartsController.prototype.$onInit = function () {
        var _this = this;
        this.$scope.$watch(function () {
            return _this.dataset;
        }, function (newValue, oldValue) {
            _this.update(newValue);
        });
        this.$timeout(function () {
            var ctx = document.getElementById(_this.chartid);
            // @ts-ignore
            _this.myPieChart = new Chart(ctx, {
                type: 'pie',
                data: {
                    datasets: [{
                            label: 'Colors',
                            data: [],
                            backgroundColor: ['#0074D9', '#FF4136', '#2ECC40', '#FF851B',
                                '#7FDBFF', '#B10DC9', '#FFDC00', '#001f3f', '#39CCCC',
                                '#01FF70', '#AAAAAA', '#F012BE', '#3D9970', '#111111',
                                '#FF6633', '#FFB399', '#F133FF', '#FFFF99', '#00B3E6',
                                '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
                                '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
                                '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
                                '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
                                '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
                                '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
                                '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
                                '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
                                '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF']
                        }],
                    labels: []
                },
                options: {
                    responsive: true,
                    title: {
                        display: true,
                        text: _this.name
                    },
                    legend: false,
                    legendCallback: _this.getLegendCallback(),
                }
            });
            _this.generateLegend();
            _this.updateDataset(_this.dataset.cockpitResult);
        });
    };
    DvPieChartsController.prototype.generateLegend = function () {
        $('#' + this.chartid + '-legend').html(this.myPieChart.generateLegend());
    };
    DvPieChartsController.prototype.getLegendCallback = function () {
        return function (chart) {
            var legendHtml = [];
            legendHtml.push('<ul>');
            var item = chart.data.datasets[0];
            for (var i = 0; i < item.data.length; i++) {
                if (item.data[i] !== 0) {
                    legendHtml.push('<li>');
                    legendHtml.push('<span class="chart-legend" style="background-color:' + item.backgroundColor[i] + '"></span>');
                    legendHtml.push('<span class="chart-legend-label-text">' + chart.data.labels[i] + ' = ' + item.data[i] + '</span>');
                    legendHtml.push('</li>');
                }
            }
            legendHtml.push('</ul>');
            return legendHtml.join('');
        };
    };
    DvPieChartsController.prototype.update = function (newValue) {
        console.debug('result has changed, update chart...');
        this.updateDataset(newValue.cockpitResult);
        this.name = newValue.name;
        if (this.myPieChart) {
            this.myPieChart.options.title.text = newValue.name;
            this.myPieChart.update();
            this.generateLegend();
        }
    };
    DvPieChartsController.prototype.updateDataset = function (cockpitResults) {
        if (cockpitResults && this.myPieChart) {
            this.myPieChart.data.labels = [];
            this.myPieChart.data.datasets[0].data = [];
            try {
                for (var cockpitResults_1 = __values(cockpitResults), cockpitResults_1_1 = cockpitResults_1.next(); !cockpitResults_1_1.done; cockpitResults_1_1 = cockpitResults_1.next()) {
                    var cockpitResult = cockpitResults_1_1.value;
                    this.myPieChart.data.labels.push(cockpitResult.label);
                    this.myPieChart.data.datasets[0].data.push(cockpitResult.value);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (cockpitResults_1_1 && !cockpitResults_1_1.done && (_a = cockpitResults_1.return)) _a.call(cockpitResults_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var e_1, _a;
    };
    DvPieChartsController.$inject = ['$log', '$window', '$timeout', '$scope'];
    return DvPieChartsController;
}());
exports.DvPieChartsController = DvPieChartsController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "kgXo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
var template = __webpack_require__("TfvN");
var styles = __webpack_require__("Zw0f");
var BenutzerListViewComponentConfig = /** @class */ (function () {
    function BenutzerListViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = BenutzerListViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            benutzerToShow: '<',
        };
    }
    return BenutzerListViewComponentConfig;
}());
exports.BenutzerListViewComponentConfig = BenutzerListViewComponentConfig;
var BenutzerListViewController = /** @class */ (function () {
    /* @ngInject */
    function BenutzerListViewController(anlaufstelleRS, $state) {
        this.anlaufstelleRS = anlaufstelleRS;
        this.$state = $state;
    }
    BenutzerListViewController.prototype.$onInit = function () {
    };
    BenutzerListViewController.prototype.editBenutzer = function (benutzer, event) {
        var params = { benutzerId: benutzer.id, benutzer: benutzer };
        this.$state.go('benutzeredit', params);
    };
    BenutzerListViewController.prototype.addBenutzer = function () {
        var createdBenutzer = new TSBenutzer_1.default();
        var params = { benutzerId: undefined, benutzer: createdBenutzer };
        this.$state.go('benutzeredit', params);
    };
    BenutzerListViewController.$inject = ['AnlaufstelleRS', '$state'];
    return BenutzerListViewController;
}());
exports.BenutzerListViewController = BenutzerListViewController;


/***/ }),

/***/ "kufV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kwWi":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "@media(min-width:1025px){.benutzerverwaltung-view{width:1400px}}", ""]);

// exports


/***/ }),

/***/ "l/Tn":
/***/ (function(module, exports) {

module.exports = "<div ng-form=\"bisherForm\" title=\"{{'VORHERIGER_WERT' | translate}}\" ng-if=\"vm.showBisher() && !vm.equals(vm.getGSProperty(), vm.getFSProperty()) && (vm.errorObject.$pristine || vm.errorObject.$valid)\" class=\"dv-alert-box dv-alert-box--history dv-alert-box--input-alert\" ng-class=\"{'dv-alert-box--has-margin' : vm.hasMargin, 'dv-alert-box--is-textarea' : vm.isTextarea}\"> <div class=\"dv-alert-box__message\"> <span ng-repeat=\"line in vm.getBisher() track by $index\">{{line}}</span> </div> </div> ";

/***/ }),

/***/ "l1kH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Chart = __webpack_require__("ikxi");
__webpack_require__("nhQo");
var DvBarChartsComponentConfig = /** @class */ (function () {
    function DvBarChartsComponentConfig() {
        this.transclude = false;
        this.bindings = {
            chartid: '<',
            dataset: '<'
        };
        this.template = __webpack_require__("Gh6o");
        this.controller = DvBarChartsController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return DvBarChartsComponentConfig;
}());
exports.DvBarChartsComponentConfig = DvBarChartsComponentConfig;
var DvBarChartsController = /** @class */ (function () {
    function DvBarChartsController($log, $window, $timeout, $scope) {
        this.$log = $log;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.data = [];
        this.label = [];
    }
    DvBarChartsController.prototype.$onInit = function () {
        var _this = this;
        this.$scope.$watch(function () {
            return _this.dataset;
        }, function (newValue, oldValue) {
            _this.update(newValue);
        });
        this.$timeout(function () {
            var ctx = document.getElementById(_this.chartid);
            // @ts-ignore
            _this.myBarChart = new Chart(ctx, {
                type: 'bar',
                data: {
                    datasets: [{
                            label: ' ',
                            data: [],
                            backgroundColor: ['#0074D9', '#FF4136', '#2ECC40', '#FF851B',
                                '#7FDBFF', '#B10DC9', '#FFDC00', '#001f3f', '#39CCCC',
                                '#01FF70', '#AAAAAA', '#F012BE', '#3D9970', '#111111',
                                '#FF6633', '#FFB399', '#F133FF', '#FFFF99', '#00B3E6',
                                '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
                                '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
                                '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
                                '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
                                '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
                                '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
                                '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
                                '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
                                '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF']
                        }],
                    labels: []
                },
                options: {
                    responsive: true,
                    title: {
                        display: true,
                        text: _this.name
                    },
                    legend: false,
                }
            });
            _this.updateDataset(_this.dataset.cockpitResult);
        });
    };
    DvBarChartsController.prototype.update = function (newValue) {
        console.debug('result has changed, update chart...');
        this.updateDataset(newValue.cockpitResult);
        this.name = newValue.name;
        this.myBarChart.options.title.text = newValue.name;
        this.myBarChart.update();
    };
    DvBarChartsController.prototype.updateDataset = function (cockpitResults) {
        if (cockpitResults && this.myBarChart) {
            this.myBarChart.data.labels = [];
            this.myBarChart.data.datasets[0].data = [];
            try {
                for (var cockpitResults_1 = __values(cockpitResults), cockpitResults_1_1 = cockpitResults_1.next(); !cockpitResults_1_1.done; cockpitResults_1_1 = cockpitResults_1.next()) {
                    var cockpitResult = cockpitResults_1_1.value;
                    this.myBarChart.data.labels.push(cockpitResult.label);
                    this.myBarChart.data.datasets[0].data.push(cockpitResult.value);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (cockpitResults_1_1 && !cockpitResults_1_1.done && (_a = cockpitResults_1.return)) _a.call(cockpitResults_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var e_1, _a;
    };
    DvBarChartsController.$inject = ['$log', '$window', '$timeout', '$scope'];
    return DvBarChartsController;
}());
exports.DvBarChartsController = DvBarChartsController;


/***/ }),

/***/ "l6pO":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".benutzer-reg-view .captcha-error{color:#ff2b59}.benutzer-reg-view form:not(.ng-submitted) .captcha-error{display:none}", ""]);

// exports


/***/ }),

/***/ "lAb2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
__webpack_require__("fjOH");
var core_module_1 = __webpack_require__("u87A");
var testpageView_1 = __webpack_require__("wKwq");
var testpage_route_1 = __webpack_require__("fFyF");
exports.SerfWebTestpage = angular.module('serfWeb.testpage', [core_module_1.SerfWebCore.name, 'smart-table', 'ui.bootstrap'])
    .component('dvTestpageView', new testpageView_1.TestpageViewComponentConfig())
    .run(testpage_route_1.testpageRun);
exports.default = exports.SerfWebTestpage;


/***/ }),

/***/ "lDyE":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "lKR4":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.dv-bemerkungen-list dv-accordion{overflow:hidden;display:flex;flex-direction:column}.dv-bemerkungen-list dv-accordion dv-accordion-tab{width:100%;display:block;margin-bottom:2rem}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title{opacity:1;width:100%}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title:focus{outline:none}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title>*{display:flex;flex-direction:row}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title .message-header{flex:1;display:flex;flex-direction:row;flex-wrap:wrap;font-weight:700}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title .message-header .intern{margin-left:10px}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title .message-header .button-edit{margin-left:9px}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title .message-header .btn-link{margin-top:-4px}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title:after{display:block;border:0;border-top:1px solid #f0f0f0;content:\"\"}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title .arrow{color:#000;min-height:2rem;height:auto;width:auto;vertical-align:middle;text-align:center;display:flex;align-items:center;justify-content:center}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title .arrow i{font-size:2.4rem;transition:all .2s ease}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title.tab-open:after{width:100%}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title.tab-open .arrow{color:#000}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title.tab-open .arrow i{transform:rotate(-180deg)}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title.tab-open .button-delete,.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title.tab-open .button-edit{visibility:visible;opacity:1;transition:opacity .2s linear}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title.tab-close .button-delete,.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-title.tab-close .button-edit{visibility:hidden;opacity:0;transition:visibility 0s .2s,opacity .2s linear}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-content{overflow:hidden;overflow-y:auto;opacity:1;display:block;width:100%;height:auto;max-height:60rem}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-content>tab-body>*{margin:1rem 0 3rem}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-content .message{display:flex;flex-direction:column}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-content .message .begruendung{margin-bottom:1rem}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-content .message .message-body-text{white-space:pre-line}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-content.ng-hide-add{overflow:hidden;max-height:60rem;transition:all .2s ease}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-content.ng-hide-add.ng-hide-add-active{overflow:hidden;max-height:0}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-content.ng-hide-remove{overflow:hidden;transition:all 1s ease;max-height:0}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-content.ng-hide-remove.ng-hide-remove-active{overflow:hidden;max-height:60rem}.dv-bemerkungen-list dv-accordion dv-accordion-tab .dv-accordion-tab-content .message-body-bold{font-style:italic;font-weight:700}", ""]);

// exports


/***/ }),

/***/ "lL5G":
/***/ (function(module, exports) {

module.exports = "<div style=\"padding:40px\"> <div class=\"modal-header\"> <h1 data-translate=\"BERECHNUNGSDETAIL\"></h1> <h3 data-translate=\"BERECHNUNGSDETAIL_EXPLANATION\" style=\"white-space:pre-line\"></h3> </div> <div class=\"modal-body\"> <h2 data-translate=\"IHRE_ANGABEN\"></h2> <table class=\"table table-alt\"> <tr> <td data-translate=\"EINKOMMEN\"> </td> <td class=\"text-right berechnungsdetail--currency\"> {{vm.steuerbareseinkommen | number: 2}} </td> </tr> <tr> <td data-translate=\"VERMOEGEN\"> </td> <td class=\"text-right berechnungsdetail--currency\"> {{vm.steuerbaresvermoegen | number: 2}} </td> </tr> </table> <h2 data-translate=\"IHR_ABZUG\" style=\"margin-top:55px\"></h2> <table class=\"table table-alt\"> <tbody> <tr> <td data-translate=\"ABZUEGE_EINKOMMEN\"></td> <td class=\"text-right berechnungsdetail--currency\"> {{vm.einkommensabzug | number: 2}} </td> </tr> <tr> <td data-translate=\"ABZUEGE_VERMOEGEN\"></td> <td class=\"text-right berechnungsdetail--currency\"> {{vm.vermoegensabzug | number: 2}} </td> </tr> </tbody> <tfoot> <tr class=\"tr-highlight\"> <td data-translate=\"BERECHNUNGSDETAIL_TOTAL\"></td> <td class=\"text-right berechnungsdetail--currency\"> {{vm.einkommensabzug + vm.vermoegensabzug| number: 2}} </td> </tr> </tfoot> </table> </div> <div class=\"modal-footer\"> <button class=\"btn btn-serf\" ng-click=\"vm.ok()\">OK</button> </div> </div> ";

/***/ }),

/***/ "lRDB":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("h/3A");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-benutzerprofil.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-benutzerprofil.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "lTSD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ng = __importStar(__webpack_require__("/jXN"));
var template = __webpack_require__("wU/Z");
/* TODO: Copied from https://plnkr.co/edit/Idbc1JNHKylHuX6mNwZ6?p=info to filter dateRange in Anlaufstelle. Is is not working at the moment and will
 /* be fixed in FS-183
 */
var DvDateRange = /** @class */ (function () {
    function DvDateRange() {
        this.restrict = 'E';
        this.require = { ngModelCtrl: '^stTable' };
        this.scope = {
            before: '=',
            after: '='
        };
        this.controller = DvDateRangeController;
        this.controllerAs = 'vm';
        this.bindToController = true;
        this.template = template;
        this.link = function (scope, element, attributes, controller) {
            var inputs = element.find('input');
            var inputBefore = ng.element(inputs[0]);
            var inputAfter = ng.element(inputs[1]);
            var predicateName = attributes.predicate;
            [inputBefore, inputAfter].forEach(function (input) {
                input.bind('blur', function () {
                    var query = {};
                    if (scope.before) {
                        query.before = scope.before;
                    }
                    if (scope.after) {
                        query.after = scope.after;
                    }
                    scope.$apply(function () {
                        controller.ngModelCtrl.search(query, predicateName);
                    });
                });
            });
        };
    }
    DvDateRange.factory = function () {
        var directive = function () { return new DvDateRange(); };
        directive.$inject = [];
        return directive;
    };
    return DvDateRange;
}());
exports.DvDateRange = DvDateRange;
var DvDateRangeController = /** @class */ (function () {
    /* @ngInject */
    function DvDateRangeController($http) {
        this.$http = $http;
    }
    DvDateRangeController.$inject = ['$http'];
    return DvDateRangeController;
}());
exports.DvDateRangeController = DvDateRangeController;


/***/ }),

/***/ "lquy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
__webpack_require__("fjOH");
var core_module_1 = __webpack_require__("u87A");
var dv_versicherungsbeitragBeitrag_1 = __webpack_require__("zPZ8");
var versicherungsbeitragBeitragView_1 = __webpack_require__("g/Yr");
var versicherungsbeitraegeListView_1 = __webpack_require__("r5a4");
var versicherungsbeitragSchadenView_1 = __webpack_require__("g1Ku");
var versicherungsbeitragVersicherterView_1 = __webpack_require__("2Swo");
__webpack_require__("zv8m");
var versicherungsbeitraege_route_1 = __webpack_require__("cr0T");
exports.SerfWebversicherungsbeitraege = angular.module('serfWeb.versicherungsbeitraege', [core_module_1.SerfWebCore.name])
    .component('versicherungsbeitraegeListView', new versicherungsbeitraegeListView_1.VersicherungsbeitraegeListViewComponentConfig())
    .component('versicherungsbeitragSchadenView', new versicherungsbeitragSchadenView_1.VersicherungsbeitragSchadenViewComponentConfig())
    .component('versicherungsbeitragBeitragView', new versicherungsbeitragBeitragView_1.BeitragViewComponentConfig())
    .component('versicherungsbeitragVersicherterView', new versicherungsbeitragVersicherterView_1.VersicherungsbeitragVersicherterViewComponentConfig())
    .component('dvVersicherungsbeitragBeitrag', new dv_versicherungsbeitragBeitrag_1.DvVersicherungsbeitragBeitragComponentConfig())
    .run(versicherungsbeitraege_route_1.versicherungsbeitraegeRun);
exports.default = exports.SerfWebversicherungsbeitraege;


/***/ }),

/***/ "m4lS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSHTTPEvent_1 = __webpack_require__("DQJl");
var template = __webpack_require__("1iG2");
var DVLoadingButton = /** @class */ (function () {
    function DVLoadingButton() {
        this.transclude = true;
        this.restrict = 'E';
        this.require = { dvLoadingButtonCtrl: 'dvLoadingButton', formCtrl: '^?form' };
        this.replace = true;
        this.scope = {
            type: '@',
            delay: '@',
            buttonClass: '@',
            forceWaitService: '@',
            buttonDisabled: '<',
            ariaLabel: '@',
            buttonClick: '&'
        };
        this.template = template;
        this.controller = DVLoadingButtonController;
        this.controllerAs = 'vm';
        this.bindToController = true;
    }
    DVLoadingButton.factory = function () {
        var directive = function () { return new DVLoadingButton(); };
        // directive.$inject = [];
        return directive;
    };
    return DVLoadingButton;
}());
exports.DVLoadingButton = DVLoadingButton;
/**
 * Button that disables itself after clicking to prevent multiclicks. If embedded in a form-controller it will check if
 * the form is valid first. If not it will not disable itself.
 * By default the button will be disabled till the next REST servicecall returns (not neceserally the one that was triggered
 * by this button) or till 400 ms have expired
 * @example:
 *
 <dv-loading-button type="submit"
 button-click="vm.mySaveFunction()"
 button-class="btn btn-sm btn-success"
 button-disabled="!vm.isButtonDisabled()">
 <i class="glyphicon glyphicon-plus"></i>
 <span data-translate="SAVE"></span>
 </dv-loading-button>

 *
 */
var DVLoadingButtonController = /** @class */ (function () {
    /* @ngInject */
    function DVLoadingButtonController($http, $scope, $timeout, $attrs, $log) {
        this.$http = $http;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$attrs = $attrs;
        this.$log = $log;
    }
    //wird von angular aufgerufen
    DVLoadingButtonController.prototype.$onInit = function () {
        var _this = this;
        if ('ngClick' in this.$attrs) {
            this.$log.error('must not use ng-click on dv-loading-button', this);
        }
        if ('ngDisabled' in this.$attrs) {
            this.$log.error('must not use ng-disabled on dv-loading-button', this);
        }
        if (!this.type) {
            this.type = 'button'; //wenn kein expliziter type angegeben wurde nehmen wir default button
        }
        this.buttonClicked = function () {
            //wenn der button disabled ist machen wir mal gar nichts
            if (_this.buttonDisabled || _this.isDisabled) {
                return;
            }
            _this.buttonClick(); //falls ein button-click callback uebergeben wurde ausfuehren
            //timeout wird gebraucht damit der request nach dem disablen ueberhaupt uebermittelt wird
            _this.$timeout(function () {
                if (!_this.forceWaitService) {
                    if (_this.formCtrl) { //wenn form-controller existiert
                        //button wird nur disabled wenn form valid
                        if (_this.formCtrl.$valid) {
                            _this.disableForDelay();
                        }
                    }
                    else { //wenn kein form einfach mal disablen fuer delay ms
                        _this.disableForDelay();
                    }
                }
                else {
                    //wir warten auf naechsten service return, egal wie lange es dauert
                    _this.isDisabled = true;
                }
            }, 0);
        };
        this.$scope.$on(TSHTTPEvent_1.TSHTTPEvent.REQUEST_FINISHED, function (event) {
            _this.isDisabled = false;
        });
    };
    // beispiel wie man auf changes eines attributes von aussen reagieren kann
    DVLoadingButtonController.prototype.$onChanges = function (changes) {
        if (changes.buttonDisabled && !changes.buttonDisabled.isFirstChange()) {
            this.buttonDisabled = changes.buttonDisabled.currentValue;
        }
    };
    DVLoadingButtonController.prototype.getDelay = function () {
        if (this.delay) {
            var parsedNum = parseInt(this.delay);
            if (parsedNum) {
                return parsedNum;
            }
        }
        return 4000; //default delay = 400 MS
    };
    /**
     * disabled den Button fuer "delay" millisekunden
     */
    DVLoadingButtonController.prototype.disableForDelay = function () {
        var _this = this;
        this.isDisabled = true;
        this.$timeout(function () {
            _this.isDisabled = false;
        }, this.getDelay());
    };
    DVLoadingButtonController.$inject = ['$http', '$scope', '$timeout', '$attrs', '$log'];
    return DVLoadingButtonController;
}());
exports.DVLoadingButtonController = DVLoadingButtonController;


/***/ }),

/***/ "m6Fg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("HEVe");
var GeoAdminMapComponentConfig = /** @class */ (function () {
    function GeoAdminMapComponentConfig() {
        this.transclude = false;
        this.bindings = {
            lon: '=',
            lat: '=',
            onEdit: '&',
            readonly: '<'
        };
        this.template = __webpack_require__("SUmS");
        this.controller = DvGeoAdminMapController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return GeoAdminMapComponentConfig;
}());
exports.GeoAdminMapComponentConfig = GeoAdminMapComponentConfig;
var DvGeoAdminMapController = /** @class */ (function () {
    function DvGeoAdminMapController($log, $window, $timeout) {
        this.$log = $log;
        this.$window = $window;
        this.$timeout = $timeout;
        this.positions = [];
    }
    DvGeoAdminMapController.prototype.$onInit = function () {
        var _this = this;
        // we need a timout here to load map after the modal!
        this.$timeout(function () {
            _this.initMyMap();
            if (_this.lon && _this.lat) {
                _this.addMarkerOnPosition(_this.lon, _this.lat);
            }
        });
    };
    DvGeoAdminMapController.prototype.addMarkerOnPosition = function (lon, lat) {
        // umrechnen in lv95 Schweizer-Koordinaten
        // @ts-ignore
        var swissCoordLV95 = ol.proj.transform([lon, lat], 'EPSG:4326', 'EPSG:2056');
        // Zoom on the position
        this.map.getView().setCenter(swissCoordLV95);
        this.map.getView().setResolution(10);
        this.createMarkerLayerWithPosition(swissCoordLV95);
    };
    DvGeoAdminMapController.prototype.createMarkerLayerWithPosition = function (swissCoordLV95) {
        // @ts-ignore
        this.point = new ol.geom.Point(swissCoordLV95);
        // Create the layer with the icon
        // @ts-ignore
        var vectorLayer = new ol.layer.Vector({
            // @ts-ignore
            source: new ol.source.Vector({
                // @ts-ignore
                features: [new ol.Feature({
                        // @ts-ignore
                        geometry: this.point
                    })]
            }),
            // @ts-ignore
            style: new ol.style.Style({
                // @ts-ignore
                image: new ol.style.Icon({
                    anchor: [0.5, 0.5],
                    anchorXUnits: 'fraction',
                    anchorYUnits: 'fraction',
                    // tslint:disable-next-line:max-line-length
                    src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAVCAYAAABPPm7SAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH5AYFCSYdVpYi1AAAASZJREFUOMudkzFrAkEQhb/zYmNlYXtgYSkkkN60/p6ktkwq0/sL0til8AeYKhBEQQ6s06SyCFiIwZfCMWyGvctdHgwcM++9nZ3ZAwdBX3AvWAv2FmvBg6BPDIJEkAqeTaCC2BsnFSShQVMwLxH6eBE0Q4NZDfE5ZnBq/RJ4Ay7czd6BpX1fAZmrfwHXCB4j7k+CNOgwtZznjRFsXPJD0A6HZENuWy3kbhAcXHJBAQQLxz00gKPjpRTD144IVs71U9CNnN61WshdIbiLDCcXDALxjeU87xZBJtj+4x1sBVkjOe17Qn1MTPvTZl7j9Dy2op5gV0G8E/SK9jyqYDAqvZhgWiKe/jkZQSfyZM9PvFNpvIJhxGBYa0eC8a+/ri4ELcGrRauI9w0wDGhbq0LnFwAAAABJRU5ErkJggg=='
                })
            })
        });
        this.map.addLayer(vectorLayer);
    };
    DvGeoAdminMapController.prototype.initMyMap = function () {
        var _this = this;
        // @ts-ignore
        var mousePositionControl = new ol.control.MousePosition({
            // @ts-ignore
            coordinateFormat: ol.coordinate.createStringXY(0),
            projection: 'EPSG:2056',
            // comment the following two lines to have the mouse position
            // be placed within the map.
            className: 'custom-mouse-position',
            target: document.getElementById('mouse-position'),
            undefinedHTML: '&nbsp;'
        });
        // @ts-ignore
        this.view = new ol.View({
            // projection: projection,
            // Define the default resolution
            // 10 means that one pixel is 10m width and height
            // List of resolution of the WMTS layers:
            // 650, 500, 250, 100, 50, 20, 10, 5, 2.5, 2, 1, 0.5, 0.25, 0.1
            resolution: 500,
            // Define a coordinate CH1903+ (EPSG:2056) for the center of the view
            center: [2660000, 1190000]
        });
        // @ts-ignore
        this.map = new ga.Map({
            // @ts-ignore
            controls: ol.control.defaults({
                attributionOptions: /** @type {olx.control.AttributionOptions} */ ({
                    collapsible: false
                })
            }).extend([mousePositionControl]),
            // Define the div where the map is placed
            target: 'map',
            // Create a view
            // @ts-ignore
            view: this.view
        });
        // Create a background layer
        // @ts-ignore
        var lyr1 = ga.layer.create('ch.swisstopo.pixelkarte-farbe');
        // Add the background layer in the map
        this.map.addLayer(lyr1);
        if (!this.readonly) {
            this.map.on('singleclick', function (evt) {
                var swissCoordinate = evt.coordinate;
                if (!_this.point) {
                    _this.createMarkerLayerWithPosition(swissCoordinate);
                }
                else {
                    // if we have already a position, just change point
                    _this.point.setCoordinates(swissCoordinate);
                }
                // @ts-ignore
                var gpsCoord = ol.proj.transform(swissCoordinate, 'EPSG:2056', 'EPSG:4326');
                _this.positionChanged(gpsCoord[0], gpsCoord[1]);
            });
        }
    };
    DvGeoAdminMapController.prototype.positionChanged = function (lon, lat) {
        this.onEdit({ lon: lon, lat: lat });
    };
    DvGeoAdminMapController.$inject = ['$log', '$window', '$timeout'];
    return DvGeoAdminMapController;
}());
exports.DvGeoAdminMapController = DvGeoAdminMapController;


/***/ }),

/***/ "mDSf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
zahlungenRun.$inject = ['RouterHelper'];
/* @ngInject */
function zahlungenRun(routerHelper) {
    routerHelper.configureStates(getStates());
}
exports.zahlungenRun = zahlungenRun;
function getStates() {
    return [
        {
            name: 'zahlungen',
            template: '<zahlungen-view flex="auto" class="overflow-scroll" besitzer="$resolve.besitzer"></zahlungen-view>',
            url: '/zahlungen',
            resolve: {
                besitzer: getPossibleBesitzer
            }
        },
    ];
}
getPossibleBesitzer.$inject = ['BenutzerRS'];
/* @ngInject */
function getPossibleBesitzer(benutzerRS) {
    return benutzerRS.possibleZahlungsauftragBesitzer();
}
exports.getPossibleBesitzer = getPossibleBesitzer;


/***/ }),

/***/ "mEth":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("njUM");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./startView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./startView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "mPIz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
var TSDokumentType_1 = __webpack_require__("/gTe");
var TSDokument_1 = __importDefault(__webpack_require__("DdPR"));
var DokumenteRS = /** @class */ (function () {
    /* @ngInject */
    function DokumenteRS($http, REST_API, $log) {
        var _this = this;
        this.serviceURL = REST_API + 'dokumente';
        this.http = $http;
        this.log = $log;
        this._fileTypeMap = new Map();
        TSDokumentType_1.getDocumentTypes().forEach(function (docType) {
            _this._fileTypeMap.set(docType, new Set([
                'image/jpeg',
                'image/png',
                'image/svg+xml',
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ]));
        });
    }
    DokumenteRS.prototype.findDocuments = function (fallId, doctype, parentId) {
        var _this = this;
        //parentId is not always set > pass as query param
        var url = this.serviceURL + '/' + encodeURIComponent(fallId) + '/typ/' + encodeURIComponent(TSDokumentType_1.TSDocumentType[doctype]);
        if (parentId !== undefined) {
            url = url += '?parentId=' + parentId;
        }
        return this.http.get(url)
            .then(function (response) {
            _this.log.debug('PARSING documentDTO REST object ', response.data);
            var converter = function (jsonString) {
                return new TSDokument_1.default().deserialize(jsonString);
            };
            if (angular.isArray(response.data)) {
                return response.data.map(converter);
            }
            return [];
        });
    };
    DokumenteRS.prototype.deleteDocument = function (fallId, doctype, documentId, parentId) {
        var url = this.serviceURL + '/' + encodeURIComponent(fallId) + '/typ/'
            + encodeURIComponent(TSDokumentType_1.TSDocumentType[doctype]) + '/doc/' + encodeURIComponent(documentId);
        if (parentId) {
            url = url + '?parentId=' + encodeURIComponent(parentId);
        }
        return this.http.delete(url)
            .then(function (response) {
            return response;
        });
    };
    DokumenteRS.prototype.isFileTypeAllowedForDocumentType = function (fileType, docType) {
        var docTypeSet = this._fileTypeMap.get(docType);
        if (docTypeSet !== undefined) {
            return docTypeSet.has(fileType);
        }
        return false;
    };
    DokumenteRS.$inject = ['$http', 'REST_API', '$log'];
    return DokumenteRS;
}());
exports.default = DokumenteRS;


/***/ }),

/***/ "mUaf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var TSEigentumsverhaeltnis_1 = __webpack_require__("PSWS");
var TSRechtsform_1 = __webpack_require__("EUJE");
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSAdresse_1 = __importDefault(__webpack_require__("aL5m"));
var TSAnlaufstelle_1 = __importDefault(__webpack_require__("B4Ew"));
var TSBeitrag_1 = __importDefault(__webpack_require__("Bftz"));
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
var TSBenutzerBemerkung_1 = __importDefault(__webpack_require__("3/Vo"));
var TSEigenleistung_1 = __importDefault(__webpack_require__("/GH9"));
var TSFremdkosten_1 = __importDefault(__webpack_require__("csNn"));
var TSGesuchsteller_1 = __importDefault(__webpack_require__("o8Fj"));
var TSSchaden_1 = __importDefault(__webpack_require__("k04f"));
var TSSchadenfallDaten_1 = __importDefault(__webpack_require__("GUZW"));
var TSSystemBemerkung_1 = __importDefault(__webpack_require__("qfs+"));
var TSTransitionBemerkung_1 = __importDefault(__webpack_require__("7eCW"));
var TSVorleistung_1 = __importDefault(__webpack_require__("3494"));
var TSSchadenfall = /** @class */ (function (_super) {
    __extends(TSSchadenfall, _super);
    function TSSchadenfall() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._ermittelterSchaden = 0;
        _this._nichtBerechtigterAnteil = 0;
        _this._berechtigterBetragEigenleistungen = 0;
        _this._berechtigterBetragFremdkosten = 0;
        _this._berechtigterBetragVorleistungen = 0;
        return _this;
    }
    Object.defineProperty(TSSchadenfall.prototype, "schadenfallHerkunft", {
        get: function () {
            return this._schadenfallHerkunft;
        },
        set: function (value) {
            this._schadenfallHerkunft = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "erfassungsart", {
        get: function () {
            return this._erfassungsart;
        },
        set: function (value) {
            this._erfassungsart = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "gesuchsdatum", {
        get: function () {
            return this._gesuchsdatum;
        },
        set: function (value) {
            this._gesuchsdatum = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "bemerkung", {
        get: function () {
            return this._bemerkung;
        },
        set: function (value) {
            this._bemerkung = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "fallNummer", {
        get: function () {
            return this._fallNummer;
        },
        set: function (value) {
            this._fallNummer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "status", {
        get: function () {
            return this._status;
        },
        set: function (value) {
            this._status = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "anlaufstelle", {
        get: function () {
            return this._anlaufstelle;
        },
        set: function (value) {
            this._anlaufstelle = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "besitzer", {
        get: function () {
            return this._besitzer;
        },
        set: function (value) {
            this._besitzer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "schadenfallDatenFS", {
        get: function () {
            return this._schadenfallDatenFS;
        },
        set: function (value) {
            this._schadenfallDatenFS = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "schadenfallDatenGS", {
        get: function () {
            return this._schadenfallDatenGS;
        },
        set: function (value) {
            this._schadenfallDatenGS = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "schaeden", {
        get: function () {
            return this._schaeden;
        },
        set: function (value) {
            this._schaeden = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "schaetzer", {
        get: function () {
            return this._schaetzer;
        },
        set: function (value) {
            this._schaetzer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "gesuchsteller", {
        get: function () {
            return this._gesuchsteller;
        },
        set: function (value) {
            this._gesuchsteller = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "zweitperson", {
        get: function () {
            return this._zweitperson;
        },
        set: function (value) {
            this._zweitperson = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "fremdkosten", {
        get: function () {
            return this._fremdkosten;
        },
        set: function (value) {
            this._fremdkosten = value;
        },
        enumerable: true,
        configurable: true
    });
    TSSchadenfall.prototype.getFinalFremdkosten = function () {
        return this._fremdkosten.filter(function (e) { return !e.schaetzung; });
    };
    TSSchadenfall.prototype.getSchaetzungFremdkosten = function () {
        return this._fremdkosten.filter(function (e) { return e.schaetzung; });
    };
    Object.defineProperty(TSSchadenfall.prototype, "vorleistungen", {
        get: function () {
            return this._vorleistungen;
        },
        set: function (value) {
            this._vorleistungen = value;
        },
        enumerable: true,
        configurable: true
    });
    TSSchadenfall.prototype.getFinalVorleistungen = function () {
        return this.vorleistungen.filter(function (e) { return !e.schaetzung; });
    };
    TSSchadenfall.prototype.getSchaetzungVorleistungen = function () {
        return this.vorleistungen.filter(function (e) { return e.schaetzung; });
    };
    Object.defineProperty(TSSchadenfall.prototype, "eigenleistungen", {
        get: function () {
            return this._eigenleistungen;
        },
        set: function (value) {
            this._eigenleistungen = value;
        },
        enumerable: true,
        configurable: true
    });
    TSSchadenfall.prototype.getFinalEigenleistungen = function () {
        return this._eigenleistungen.filter(function (e) { return !e.schaetzung; });
    };
    TSSchadenfall.prototype.getSchaetzungEigenleistungen = function () {
        return this._eigenleistungen.filter(function (e) { return e.schaetzung; });
    };
    Object.defineProperty(TSSchadenfall.prototype, "beitraege", {
        get: function () {
            return this._beitraege;
        },
        set: function (value) {
            this._beitraege = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "ermittelterSchaden", {
        get: function () {
            return this._ermittelterSchaden;
        },
        set: function (value) {
            this._ermittelterSchaden = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "nichtBerechtigterAnteil", {
        get: function () {
            return this._nichtBerechtigterAnteil;
        },
        set: function (value) {
            this._nichtBerechtigterAnteil = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "berechtigterBetragEigenleistungen", {
        get: function () {
            return this._berechtigterBetragEigenleistungen;
        },
        set: function (value) {
            this._berechtigterBetragEigenleistungen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "berechtigterBetragFremdkosten", {
        get: function () {
            return this._berechtigterBetragFremdkosten;
        },
        set: function (value) {
            this._berechtigterBetragFremdkosten = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "berechtigterBetragVorleistungen", {
        get: function () {
            return this._berechtigterBetragVorleistungen;
        },
        set: function (value) {
            this._berechtigterBetragVorleistungen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "systemBemerkungen", {
        get: function () {
            return this._systemBemerkungen;
        },
        set: function (value) {
            this._systemBemerkungen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "benutzerBemerkungen", {
        get: function () {
            return this._benutzerBemerkungen;
        },
        set: function (value) {
            this._benutzerBemerkungen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSchadenfall.prototype, "transitionBemerkungen", {
        get: function () {
            return this._transitionBemerkungen;
        },
        set: function (value) {
            this._transitionBemerkungen = value;
        },
        enumerable: true,
        configurable: true
    });
    TSSchadenfall.prototype.init = function () {
        this.gesuchsteller = new TSGesuchsteller_1.default();
        return this;
    };
    TSSchadenfall.prototype.getFallnummerWithZeros = function () {
        return TSSchadenfall.calculateFallnummerWithZeros(this._fallNummer);
    };
    TSSchadenfall.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.gesuchsdatum = DateUtil_1.default.localDateToMoment(restObject.gesuchsdatum);
        this.schadenfallHerkunft = restObject.schadenfallHerkunft;
        this.bemerkung = restObject.bemerkung;
        this.fallNummer = restObject.fallNummer;
        this.status = restObject.status;
        this.erfassungsart = restObject.erfassungsArt;
        this.anlaufstelle = this.deserializeOrNull(restObject.anlaufstelle, new TSAnlaufstelle_1.default());
        this.schadenfallDatenFS = this.deserializeOrNull(restObject.schadenfallDatenFS, new TSSchadenfallDaten_1.default());
        this.schadenfallDatenGS = this.deserializeOrNull(restObject.schadenfallDatenGS, new TSSchadenfallDaten_1.default());
        this.besitzer = this.deserializeOrNull(restObject.besitzer, new TSBenutzer_1.default());
        this.ermittelterSchaden = restObject.ermittelterSchaden;
        this.nichtBerechtigterAnteil = restObject.nichtBerechtigterAnteil;
        this.berechtigterBetragEigenleistungen = restObject.berechtigterBetragEigenleistungen;
        this.berechtigterBetragFremdkosten = restObject.berechtigterBetragFremdkosten;
        this.berechtigterBetragVorleistungen = restObject.berechtigterBetragVorleistungen;
        if (restObject.schaeden) {
            this.schaeden = restObject.schaeden.map(TSSchaden_1.default.getDeserializer);
        }
        if (restObject.fremdkosten) {
            this.fremdkosten = restObject.fremdkosten.map(TSFremdkosten_1.default.getDeserializer);
        }
        if (restObject.vorleistungen) {
            this.vorleistungen = restObject.vorleistungen.map(TSVorleistung_1.default.getDeserializer);
        }
        if (restObject.eigenleistungen) {
            this.eigenleistungen = restObject.eigenleistungen.map(TSEigenleistung_1.default.getDeserializer);
        }
        if (restObject.beitraege) {
            this.beitraege = restObject.beitraege.map(TSBeitrag_1.default.getDeserializer);
        }
        if (restObject.systemBemerkungen) {
            this.systemBemerkungen = restObject.systemBemerkungen.map(TSSystemBemerkung_1.default.getDeserializer);
        }
        if (restObject.benutzerBemerkungen) {
            this.benutzerBemerkungen = restObject.benutzerBemerkungen.map(TSBenutzerBemerkung_1.default.getDeserializer);
        }
        if (restObject.transitionBemerkungen) {
            this.transitionBemerkungen = restObject.transitionBemerkungen.map(TSTransitionBemerkung_1.default.getDeserializer);
        }
        if (restObject.schaetzer) {
            this.schaetzer = restObject.schaetzer.map(TSBenutzer_1.default.getDeserializer);
        }
        this.gesuchsteller = this.deserializeOrCreate(restObject.gesuchsteller, new TSGesuchsteller_1.default());
        if (restObject.zweitperson) {
            this.zweitperson = this.deserializeOrCreate(restObject.zweitperson, new TSGesuchsteller_1.default());
            this.zweitperson.isZweitperson = true; // beim serialisieren der Zweitperson flag setzen (wird für cleanup gebraucht!)
        }
        return this;
    };
    TSSchadenfall.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.bemerkung = this.bemerkung;
        restObject.schadenfallHerkunft = this.schadenfallHerkunft;
        restObject.anlaufstelle = this.serializeOrInit(this.anlaufstelle, restObject.anlaufstelle);
        restObject.schadenfallDatenFS = this.serializeOrInit(this.schadenfallDatenFS, restObject.schadenfallDatenFS);
        restObject.schadenfallDatenGS = this.serializeOrInit(this.schadenfallDatenGS, restObject.schadenfallDatenGS);
        restObject.gesuchsteller = this.serializeOrInit(this.gesuchsteller, restObject.gesuchsteller);
        restObject.zweitperson = this.serializeOrInit(this.zweitperson, restObject.zweitperson);
        restObject.schaetzer = this.arrayToRestObject(this.schaetzer);
        restObject.ermittelterSchaden = this.ermittelterSchaden;
        restObject.nichtBerechtigterAnteil = this.nichtBerechtigterAnteil;
        restObject.berechtigterBetragEigenleistungen = this.berechtigterBetragEigenleistungen;
        restObject.berechtigterBetragFremdkosten = this.berechtigterBetragFremdkosten;
        restObject.berechtigterBetragVorleistungen = this.berechtigterBetragVorleistungen;
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        // don't send schaeden, fremdkosten, vorleistungen, eigenleistungen
        // and bemerkungen to server because this is not the way to persist them!
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        return restObject;
    };
    TSSchadenfall.calculateFallnummerWithZeros = function (fallnummer) {
        var fallnummerString = '' + fallnummer;
        while (fallnummerString.length < TSSchadenfall.FALLNUMMER_LENGTH) {
            fallnummerString = '0' + fallnummerString;
        }
        return fallnummerString;
    };
    TSSchadenfall.prototype.getErmittelterSchaden = function () {
        return this.ermittelterSchaden;
    };
    /**
     * /!\
     * Die Summen werden im Backend und Frontend getrennt kalkuliert.
     * Falls nötig, müssen sie immer an beiden Stellen synchron geändert werden.
     * Siehe auch FinanzCalculatorUtil.java
     */
    TSSchadenfall.prototype.getCalculatedNichtBerechtigterAnteil = function () {
        return (this.ermittelterSchaden * (this.nichtBerechtigterAnteil / 100));
    };
    TSSchadenfall.prototype.hasEigenleistungen = function () {
        if (this.eigenleistungen !== undefined && this.eigenleistungen !== null) {
            return this.getFinalEigenleistungen().length > 0;
        }
        return false;
    };
    TSSchadenfall.prototype.hasFremdkosten = function () {
        if (this.fremdkosten !== undefined && this.fremdkosten !== null) {
            return this.getFinalFremdkosten().length > 0;
        }
        return false;
    };
    TSSchadenfall.prototype.hasVorleistungen = function () {
        if (this.vorleistungen !== undefined && this.vorleistungen !== null) {
            return this.getFinalVorleistungen().length > 0;
        }
        return false;
    };
    TSSchadenfall.prototype.hasBeitrag = function () {
        if (this.beitraege !== undefined && this.beitraege !== null) {
            return this.beitraege.length > 0;
        }
        return false;
    };
    TSSchadenfall.prototype.getAbrechnungsbetrag = function (schaetzung) {
        var val = 0;
        val += this.getEigenleistungenTotal(schaetzung);
        val += this.getFremdkostenTotal(schaetzung);
        val -= this.getVorleistungenTotal(schaetzung);
        if (schaetzung && val === 0) {
            if (this.schaeden[0] !== undefined && this.schaeden[0].schadenDatenFS !== undefined &&
                this.schaeden[0].schadenDatenFS.geschaetzteKosten !== undefined) {
                // @ts-ignore
                val += this.schaeden[0].schadenDatenFS.geschaetzteKosten;
            }
        }
        return val;
    };
    TSSchadenfall.prototype.getAnrechenbarerSchaden = function (prozentsatz) {
        if (prozentsatz === void 0) { prozentsatz = 100; }
        var schadendatum = undefined;
        if (this.schaeden !== undefined && this.schaeden.length > 0 && this.schaeden[0].schadenDatenFS !== undefined) {
            schadendatum = this.schaeden[0].schadenDatenFS.schadendatum;
        }
        var abzuege = this.gesuchsteller.getEinkommensabzug()
            + this.gesuchsteller.getVermoegenssabzug(schadendatum, this.ermittelterSchaden)
            + this.getCalculatedNichtBerechtigterAnteil();
        return (this.ermittelterSchaden - abzuege) * (prozentsatz / 100);
    };
    TSSchadenfall.prototype.getEigenleistungenTotal = function (schaetzung) {
        return schaetzung ? this.getSchaetzungEigenleistungenTotal() : this.getFinalEigenleistungenTotal();
    };
    TSSchadenfall.prototype.getFinalEigenleistungenTotal = function () {
        return this.berechtigterBetragEigenleistungen !== undefined ? this.berechtigterBetragEigenleistungen : 0;
    };
    TSSchadenfall.prototype.getSchaetzungEigenleistungenTotal = function () {
        var val = 0;
        this.getSchaetzungEigenleistungen().forEach(function (eigenleistung) {
            val += eigenleistung.eigenleistungStundenDaten.reduce(function (accumulator, currentValue) { return accumulator + currentValue.betrag; }, 0);
            if (eigenleistung.eigenleistungKubikmeterDaten !== undefined) {
                val += eigenleistung.eigenleistungKubikmeterDaten.betrag;
            }
            if (eigenleistung.eigenleistungLiterDaten !== undefined) {
                val += eigenleistung.eigenleistungLiterDaten.betrag;
            }
        });
        return val;
    };
    TSSchadenfall.prototype.getFremdkostenTotal = function (schaetzung) {
        return schaetzung ? this.getSchaetzungFremdkostenTotal() : this.getFinalFremdkostenTotal();
    };
    TSSchadenfall.prototype.getFinalFremdkostenTotal = function () {
        return this.berechtigterBetragFremdkosten;
    };
    TSSchadenfall.prototype.getSchaetzungFremdkostenTotal = function () {
        var val = 0;
        this.getSchaetzungFremdkosten().forEach(function (fremdkosten) {
            val += fremdkosten.fremdkostenDatenFS.rechnungsbetrag;
        });
        return val;
    };
    TSSchadenfall.prototype.getVorleistungenTotal = function (schaetzung) {
        return schaetzung ? this.getSchaetzungVorleistungenTotal() : this.getFinalVorleistungenTotal();
    };
    TSSchadenfall.prototype.getFinalVorleistungenTotal = function () {
        return this.berechtigterBetragVorleistungen;
    };
    TSSchadenfall.prototype.getSchaetzungVorleistungenTotal = function () {
        var val = 0;
        this.getSchaetzungVorleistungen().forEach(function (vorleistung) {
            val += vorleistung.vorleistungDatenFS.betrag;
        });
        return val;
    };
    TSSchadenfall.prototype.cleanupGesuchsteller = function () {
        this.gesuchsteller.cleanup();
        if (this.gesuchsteller.eigentumsverhaeltnis === TSEigentumsverhaeltnis_1.TSEigentumsverhaeltnis.GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER) {
            this.zweitperson = undefined;
        }
        else {
            if (this.zweitperson !== undefined) {
                this.zweitperson.cleanup();
            }
        }
    };
    TSSchadenfall.prototype.setEmptyStringsIfNotSet = function () {
        var person = this.gesuchsteller;
        this.check(person);
        var zweitperson = this.zweitperson;
        if (zweitperson) {
            this.check(zweitperson);
        }
    };
    TSSchadenfall.prototype.check = function (person) {
        if (person.rechtsform === TSRechtsform_1.TSRechtsform.GENOSSENSCHAFT) {
            var genossenschaftAdresse = person.genossenschaft.genossenschaftDatenFS.adresse;
            if (person.genossenschaft) {
                this.checkGenossenName(person.genossenschaft);
            }
            this.handleAddress(genossenschaftAdresse);
        }
        if (person.kontaktperson) {
            var kontaktaAdresse = person.kontaktperson.gesuchsPersonDatenFS.adresse;
            this.handleAddress(kontaktaAdresse);
        }
    };
    TSSchadenfall.prototype.handleAddress = function (adresse) {
        if (!adresse) {
            adresse = new TSAdresse_1.default();
        }
        this.initFieldIfNecessary(adresse, 'strasse');
        this.initFieldIfNecessary(adresse, 'ort');
        this.initFieldIfNecessary(adresse, 'plz');
    };
    TSSchadenfall.prototype.initFieldIfNecessary = function (address, field) {
        if (!address[field]) {
            address[field] = '';
        }
    };
    TSSchadenfall.prototype.checkGenossenName = function (genossen) {
        if (!genossen.genossenschaftDatenFS.name) {
            genossen.genossenschaftDatenFS.name = '';
        }
    };
    TSSchadenfall.prototype.getRelevanteEigenleistungen = function (schaetzung) {
        return schaetzung ? this.getSchaetzungEigenleistungen() : this.getFinalEigenleistungen();
    };
    TSSchadenfall.prototype.getRelevanteFremdkosten = function (schaetzung) {
        return schaetzung ? this.getSchaetzungFremdkosten() : this.getFinalFremdkosten();
    };
    TSSchadenfall.prototype.getRelevanteVorleistungen = function (schaetzung) {
        return schaetzung ? this.getSchaetzungVorleistungen() : this.getFinalVorleistungen();
    };
    TSSchadenfall.FALLNUMMER_LENGTH = 8;
    return TSSchadenfall;
}(TSAbstractEntity_1.default));
exports.default = TSSchadenfall;


/***/ }),

/***/ "mezm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSEigenleistung_1 = __importDefault(__webpack_require__("/GH9"));
/**
 * Service zum verwalten von Eigenleistungsdaten.
 */
var EigenleistungenRS = /** @class */ (function () {
    /* @ngInject */
    function EigenleistungenRS($http, CONSTANTS, $q, $rootScope, $log) {
        this.$http = $http;
        this.CONSTANTS = CONSTANTS;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$log = $log;
    }
    EigenleistungenRS.prototype.saveEigenleistungen = function (schadenfallId, eigenleistungen) {
        if (eigenleistungen) {
            var restEigenleistungen = eigenleistungen.serialize({});
            return this.$http.put(this.CONSTANTS.REST_API + 'eigenleistungen/' + encodeURIComponent(schadenfallId), restEigenleistungen)
                .then(function (response) {
                if (response.data !== undefined) {
                    return new TSEigenleistung_1.default().deserialize(response.data);
                }
                else {
                    return undefined;
                }
            });
        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    };
    EigenleistungenRS.prototype.deleteEigenleistung = function (eigenleistung) {
        return this.$http.delete(this.CONSTANTS.REST_API + 'eigenleistungen/' + encodeURIComponent(eigenleistung.id))
            .then(function (response) {
            return response;
        });
    };
    EigenleistungenRS.$inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];
    return EigenleistungenRS;
}());
exports.default = EigenleistungenRS;
;


/***/ }),

/***/ "mhZf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".zahlungentabs .nav-tabs{padding-left:18px;margin-top:10px;margin-left:-8px;margin-right:-8px}.zahlungen-list-view__betroffene{padding:30px 150px}@media(min-width:992px){.zahlungentabs{margin-left:10px;margin-right:10px}.zahlungentabs .nav-tabs{padding-left:245px;margin-top:27px}.zahlungentabs .tab-pane{padding-left:30px;padding-right:30px;padding-bottom:0}}", ""]);

// exports


/***/ }),

/***/ "mxiP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DVHTTPLoading = /** @class */ (function () {
    function DVHTTPLoading() {
        this.restrict = 'A';
        this.controller = DVHTTPLoadingController;
        this.controllerAs = 'vm';
        this.link = function (scope, element, attributes, controller) {
            var promise;
            scope.$watch(controller.isLoading, function (v) {
                if (v) {
                    controller.$timeout.cancel(promise);
                    element.show();
                }
                else {
                    promise = controller.$timeout(function () {
                        element.hide();
                    }, 500);
                }
            });
        };
    }
    DVHTTPLoading.factory = function () {
        var directive = function () { return new DVHTTPLoading(); };
        directive.$inject = [];
        return directive;
    };
    return DVHTTPLoading;
}());
exports.DVHTTPLoading = DVHTTPLoading;
/**
 * Direktive  die ein Element ein oder ausblendet jenachdem ob ein http request pending ist
 */
var DVHTTPLoadingController = /** @class */ (function () {
    /* @ngInject */
    function DVHTTPLoadingController($http, $timeout) {
        var _this = this;
        this.$http = $http;
        this.$timeout = $timeout;
        this.isLoading = function () {
            return _this.$http.pendingRequests.length > 0;
        };
    }
    DVHTTPLoadingController.$inject = ['$http', '$timeout'];
    return DVHTTPLoadingController;
}());
exports.DVHTTPLoadingController = DVHTTPLoadingController;


/***/ }),

/***/ "mzmr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSEigenleistungStundenDaten = /** @class */ (function (_super) {
    __extends(TSEigenleistungStundenDaten, _super);
    function TSEigenleistungStundenDaten() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._deleted = false;
        return _this;
    }
    Object.defineProperty(TSEigenleistungStundenDaten.prototype, "arbeitsstunden", {
        get: function () {
            return this._arbeitsstunden;
        },
        set: function (value) {
            this._arbeitsstunden = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistungStundenDaten.prototype, "betrag", {
        get: function () {
            return this._betrag;
        },
        set: function (value) {
            this._betrag = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistungStundenDaten.prototype, "datum", {
        get: function () {
            return this._datum;
        },
        set: function (value) {
            this._datum = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistungStundenDaten.prototype, "deleted", {
        get: function () {
            return this._deleted;
        },
        set: function (value) {
            this._deleted = value;
        },
        enumerable: true,
        configurable: true
    });
    TSEigenleistungStundenDaten.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.arbeitsstunden = restObject.arbeitsstunden;
        this.betrag = restObject.betrag;
        this.datum = DateUtil_1.default.localDateToMoment(restObject.datum);
        this.deleted = restObject.deleted;
        return this;
    };
    TSEigenleistungStundenDaten.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.arbeitsstunden = this.arbeitsstunden;
        restObject.betrag = this.betrag;
        restObject.deleted = this.deleted;
        if (this.datum) {
            restObject.datum = DateUtil_1.default.momentToLocalDate(this.datum);
        }
        return restObject;
    };
    TSEigenleistungStundenDaten.getDeserializer = function (eigenleistung) {
        return new TSEigenleistungStundenDaten().deserialize(eigenleistung);
    };
    TSEigenleistungStundenDaten.getSerializer = function (eigenleistung) {
        return eigenleistung.serialize(eigenleistung);
    };
    return TSEigenleistungStundenDaten;
}(TSAbstractEntity_1.default));
exports.default = TSEigenleistungStundenDaten;


/***/ }),

/***/ "n/H1":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2020 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.mychart{height:auto;width:auto}.chart-container{position:relative;margin:auto}.legend-con{font-family:FontAwesome,sans-serif;display:inline-block}.legend-con ul{list-style:none}.legend-con li{display:flex;align-items:center;margin-bottom:4px}.legend-con li span{display:inline-block}.legend-con li span.chart-legend{width:25px;height:25px;margin-right:10px}", ""]);

// exports


/***/ }),

/***/ "n2BN":
/***/ (function(module, exports) {

module.exports = {"LOGIN_REGISTER_GS":"Enregistrement comme personne sinistrée","LOGIN_REGISTER_GEMEINDE":"Enregistrement pour communes","MENU_SCHADENFAELLE":"Sinistres","VORNAME":"Prénom","NAME":"Nom","BERECHNUNGSDETAIL":"Détails du calcul","BERECHNUNGSDETAIL_EXPLANATION":"Si la date du sinistre est antérieure au 1er mai 2026, d'autres règles de calcul s’appliquent. \nLes déductions sont automatiquement recalculées sur la base de la date du sinistre et mises à jour conformément aux règles applicables à cette date. \n\nSur la base de vos données concernant la situation financière, le schéma de calcul suivant est applicable:","IHRE_ANGABEN":"Vos données","EINKOMMEN":"Revenu","VERMOEGEN":"Fortune","SCHADENMINIMUM":"Dommage calculé au minimum","MINDESTAUSZAHLUNG":"Versement minimal","ABZUEGE_EINKOMMEN":"Déductions en raison du revenu","ABZUEGE_VERMOEGEN":"Déductions en raison de la fortune","ABSCHLUSS_TITLE":"Merci","ABSCHLUSS_TEXT":"Votre sinistre a été transmis avec succès. Nous allons l'examiner et le transmettre à l'interlocuteur correspondant.","ABSCHLUSS_TITLE_ANLAUFSTELLE_REG":"Merci pour votre inscription !","ABSCHLUSS_TEXT_ANLAUFSTELLE_REG":"Vous recevrez prochainement un e-mail vous indiquant comment activer votre compte utilisateur. Une fois la connexion effectuée avec succès, vous recevrez d'autres informations concernant l'activation de votre compte.","ABSCHLUSS_BUTTON_TEXT":"Vers l'aperçu","EIGENLEISTUNG_ADD":"Ajouter une prestation propre","SCHAETZUNG_ADD":"Ajouter une estimation","VORLEISTUNG_ADD":"Ajouter une prestation préalable","AUFWAND_VORLEISTUNGEN_UPLOAD_TXT":"Veuillez saisir ici les justificatifs des contributions préalables.","ALLE":"tous","ALLE_TITLE":"Tous","AKTIV":"actif","ADMIN":"Admin","BANK":"Banque","ARBEITSSTUNDEN":"Heures de travail","ANLAUFSTELLE_TO_EDIT":"Sélectionnez l'interlocuteur à administrer.","ANLAUFSTELLE_ADD":"Ajouter un interlocuteur","ANLAUFSTELLENVERWALTUNG_ANLAUFSTELLE":"Interlocuteurs","AUFWAND_FREMDKOSTEN_ADD":"Ajouter des coûts externes","AUFWAND_FREMDKOSTEN_CREATE":"Ajouter une offre","AUFWAND_FREMDKOSTEN_REMOVE":"Voulez-vous vraiment supprimer les coûts externes ?","AUFWAND_FREMDKOSTEN_UPLOAD_TXT":"Veuillez saisir les factures et justificatifs de paiement (Banque, Poste).","AUFWAND_EIGENLEISTUNGEN_UPLOAD_TXT":"Veuillez saisir le justificatif pour les prestations propres (rapport d'heures).","AKTION":"Action","BENUTZER_REC_SUCCESS":"Le compte d'utilisateur a été créé. Un e-mail décrivant comment activer le compte d'utilisateur a été envoyé.","VERWALTER_REC_SUCCESS":"Le compte d'utlilisateur pour l'administrateur de l'interlocuteur a été créé. Veuillez communiquer le mot de passe à l'administrateur.","BENUTZERVERWALTUNG_ANLAUFSTELLE_VERWALTER":"Administration des utilisateurs de interlocuteur","BENUTZERROLLE":"Rôle de l'utilisateur","BENUTZERVERWALTUNG_ADD":"Ajouter un utilisateur","BENUTZER_SPEICHERN":"Enregistrer un utilisateur","BENUTZERPROFIL":"Profil d'utilisateur","BENUTZER_ERSTELLEN":"Créer un nouvel utilisateur","BENUTZER_DEAKTIVIEREN":"Désactiver l'utilisateur","BETRAG_BERECHTIGT":"Montant justifié","CONFIRM_VERWALTERCHANGE":"Attention: si vous êtes la personne responsable, il est possible que vous n'ayez plus accès à l'interlocuteur après la modification.","DELETE":"Supprimer","JAHRGANG":"Année de naissance","BETRAG":"Montant","BETRAG_CHF":"Montant en CHF","ANZAHL_STUNDEN":"Nbre heures","EDIT":"Editer","PROPERTY_NAME":"Nom","PROPERTY_TEXT":"Texte","TIMEERSTELLT":"Date de création","TIMEMUTIERT":"Modifié","SIZE":"Taille","Land_AD":"Andorre","Land_AE":"Emirats arabes unis","Land_AF":"Afghanistan","Land_AG":"Antigua-et-Barbuda","Land_AI":"Anguilla","Land_AL":"Albanie","Land_AM":"Arménie","Land_AN":"Antilles néerlandaises","Land_AO":"Angola","Land_AQ":"Antarctique","Land_AR":"Argentine","Land_AS":"Samoa américaines","Land_AT":"Autriche","Land_AU":"Australie","Land_AW":"Aruba","Land_AX":"Îles Aland","Land_AZ":"Azerbaïdjan","Land_BA":"Bosnie-Herzégovine","Land_BB":"Barbade","Land_BD":"Bangladesh","Land_BE":"Belgique","Land_BF":"Burkina Faso","Land_BG":"Bulgarie","Land_BH":"Bahreïn","Land_BI":"Burundi","Land_BJ":"Bénin","Land_BL":"Saint-Barthélémy","Land_BM":"Bermudes","Land_BN":"Brunei Darussalam","Land_BO":"Bolivie","Land_BR":"Brésil","Land_BS":"Bahamas","Land_BT":"Bhoutan","Land_BV":"Île Bouvet","Land_BW":"Botswana","Land_BY":"Biélorussie","Land_BZ":"Belize","Land_CA":"Canada","Land_CC":"Îles Coco","Land_CI":"Côte d'Ivoire","Land_CG":"Congo","Land_CD":"Congo, Rép. dém.","Land_CF":"République centrafricaine","Land_CH":"Suisse","Land_CK":"Îles Cook","Land_CL":"Chili","Land_CM":"Cameroun","Land_CN":"Chine","Land_CO":"Colombie","Land_CR":"Costa Rica","Land_CS":"Serbie et Monténégro","Land_CU":"Cuba","Land_CV":"Cap-Vert","Land_CX":"Île Christmas","Land_CY":"Chypre","Land_CZ":"République tchèque","Land_DE":"Allemagne","Land_DJ":"Djibouti","Land_DK":"Danemark","Land_DM":"Dominique","Land_DO":"République dominicaine","Land_DZ":"Algérie","Land_EC":"Equateur","Land_EE":"Estonie","Land_EG":"Egypte","Land_EH":"Sahara occidental","Land_ER":"Erythrée","Land_ES":"Espagne","Land_ET":"Ethiopie","Land_FI":"Finlande","Land_FJ":"Fidji","Land_FK":"Îles Malouines","Land_FM":"Micronésie","Land_FO":"Îles Féroé","Land_FR":"France","Land_GA":"Gabon","Land_GB":"Royaume-Uni","Land_GD":"Grenade","Land_GE":"Géorgie","Land_GF":"Guyane française","Land_GG":"Guernesey","Land_GH":"Ghana","Land_GI":"Gibraltar","Land_GL":"Groenland","Land_GM":"Gambie","Land_GN":"Guinée","Land_GP":"Guadeloupe","Land_GQ":"Guinée équatoriale","Land_GR":"Grèce","Land_GS":"Géorgie du Sud et les Îles Sandwich du Sud","Land_GT":"Guatemala","Land_GU":"Guam","Land_GW":"Guinée-Bissau","Land_GY":"Guyane","Land_HK":"Hong Kong","Land_HM":"Heard et Îles McDonald","Land_HN":"Honduras","Land_HR":"Croatie","Land_HT":"Haïti","Land_HU":"Hongrie","Land_ID":"Indonésie","Land_IE":"Irlande","Land_IL":"Israël","Land_IM":"Île de Man","Land_IN":"Inde","Land_IO":"Territoire britannique dans l'Océan Indien","Land_IQ":"Irak","Land_IR":"Iran, Rép. islam.","Land_IS":"Islande","Land_IT":"Italie","Land_JE":"Jersey","Land_JM":"Jamaïque","Land_JO":"Jordanie","Land_JP":"Japon","Land_KE":"Kenya","Land_KG":"Kirghizistan","Land_KH":"Cambodge","Land_KI":"Kiribati","Land_KM":"Comores","Land_KN":"Saint Kitts et Nevis","Land_KP":"Corée, Rép. pop. dém.","Land_KR":"Corée, Rép.","Land_KW":"Koweït","Land_KY":"Îles Caïman","Land_KZ":"Kazakhstan","Land_LA":"Laos, Rép. pop. dém.","Land_LB":"Liban","Land_LC":"Sainte-Lucie","Land_LI":"Liechtenstein","Land_LK":"Sri Lanka","Land_LR":"Liberia","Land_LS":"Lesotho","Land_LT":"Lituanie","Land_LU":"Luxembourg","Land_LV":"Lettonie","Land_LY":"Jamahiriya arabe libyenne","Land_MA":"Maroc","Land_MC":"Monaco","Land_MD":"Moldavie","Land_ME":"Monténégro","Land_MF":"Saint Martin","Land_MG":"Madagascar","Land_MH":"Îles Marshall","Land_MK":"Macédoine, ancienne République yougoslave","Land_ML":"Mali","Land_MM":"Myanmar","Land_MN":"Mongolie","Land_MO":"Macao","Land_MP":"Îles Mariannes du Nord","Land_MQ":"Martinique","Land_MR":"Mauritanie","Land_MS":"Montserrat","Land_MT":"Malte","Land_MU":"Île Maurice","Land_MV":"Maldives","Land_MW":"Malawi","Land_MX":"Mexique","Land_MY":"Malaisie","Land_MZ":"Mosambique","Land_NA":"Namibie","Land_NC":"Nouvelle-Calédonie","Land_NE":"Niger","Land_NF":"Île Norfolk","Land_NG":"Nigéria","Land_NI":"Nicaragua","Land_NICHTAERKANNT":"Non reconnu","Land_NL":"Pays-Bas","Land_NO":"Norvège","Land_NP":"Népal","Land_NR":"Nauru","Land_NU":"Niue","Land_NZ":"Nouvelle-Zélande","Land_OM":"Oman","Land_PA":"Panama","Land_PE":"Pérou","Land_PF":"Polynésie française","Land_PG":"Papouasie-Nouvelle-Guinée","Land_PH":"Philippines","Land_PK":"Pakistan","Land_PL":"Pologne","Land_PM":"Saint-Pierre-et-Miquelon","Land_PN":"Îles Pitcairn","Land_PR":"Puerto Rico","Land_PT":"Portugal","Land_PS":"Territoires autonomes palestiniens","Land_PW":"Palaos","Land_PY":"Paraguay","Land_QA":"Qatar","Land_RE":"Réunion","Land_RO":"Roumanie","Land_RS":"Serbie","Land_RU":"Fédération russe","Land_RW":"Rwanda","Land_SA":"Arabie Saoudite","Land_SB":"Salomon","Land_SC":"Seychelles","Land_SD":"Soudan","Land_SE":"Suède","Land_SG":"Singapour","Land_SH":"Sainte-Hélène","Land_SI":"Slovénie","Land_SJ":"Svalbard et Île Jan Mayen","Land_SK":"Slovaquie","Land_SL":"Sierra Leone","Land_SM":"Saint-Marin","Land_SN":"Sénégal","Land_SO":"Somalie","Land_SR":"Suriname","Land_ST":"Sao Tomé et Principe","Land_STAATENLOS":"Apatride","Land_SV":"Salvador","Land_SY":"Syrie, Rép. arab.","Land_SZ":"Swaziland","Land_TC":"Îles Turques-et-Caïques","Land_TD":"Tchad","Land_TF":"Terres australes et antarctiques françaises","Land_TG":"Togo","Land_TH":"Thaïlande","Land_TJ":"Tadjikistan","Land_TK":"Tokelau","Land_TL":"Timor-Leste","Land_TM":"Turkménistan","Land_TN":"Tunisie","Land_TO":"Tonga","Land_TR":"Turquie","Land_TT":"Trinidad-et-Tobago","Land_TV":"Tuvalu","Land_TW":"Taïwan","Land_TZ":"Tansanie, Rép. unie","Land_UA":"Ukraine","Land_UG":"Ouganda","Land_UM":"Océanie américaine","Land_UNBEKANNT":"Inconnu","Land_US":"Etats-Unis d'Amérique","Land_UY":"Uruguay","Land_UZ":"Ouzbékistan","Land_VA":"Vatican","Land_VC":"Saint-Vincent-et-les-Grenadines","Land_VE":"Venezuela","Land_VG":"Îles Vierges britanniques","Land_VI":"Îles Vierges américaines","Land_VN":"Vietnam","Land_VU":"Vanuatu","Land_WF":"Wallis et Futuna","Land_WS":"Samoa","Land_XZ":"Kosovo","Land_YE":"Yémen","Land_YT":"Mayotte","Land_ZA":"Afrique du Sud","Land_ZM":"Zambie","Land_ZW":"Zimbabwe","MENU_LOGOUT":"Se déconnecter","SAVE":"Sauvegarder","WEITER":"Continuer","CANCEL":"Interrompre","LOGIN_REGISTER_ANLAUFSTELLE":"Enregistrer un nouvel interlocuteur","LOGIN_BACK_TOANMELDUNG":"Retour à la connexion","LOGIN_BTN":"Connexion","LOGIN_BTN_ANFORDERN":"Demander","LOGIN_CHANGED":"Le mot de passe a été modifié.","LOGIN_EMAIL":"E-mail","LOGIN_EMAIL_REPEAT":"Répéter l'e-mail","LOGIN_EXISTING_USER":"Se connecter avec le compte d'utilisateur enregistré","LOGIN_DAMAGE_NOTICE_TITLE":"Remarque :","LOGIN_DAMAGE_NOTICE_TEXT":"Pour les dommages survenus dans les cantons de (AR, GR, NW), la déclaration de sinistre doit être adressée directement au canton concerné. Vous trouverez de plus amples informations ","LOGIN_DAMAGE_NOTICE_LINK":"ici","LOGIN_DAMAGE_NOTICE_URL":"https://www.fondssuisse.ch/fr/demandes-et-contributions/competences","LOGING_FORGOT_PASSWORT":"Mot de passe oublié","LOGIN_PASSWD":"Mot de passe","LOGIN_PASSWD_REP":"Répéter le mot de passe","LOGIN_PW_REST_SENT":"Un e-mail contenant les indications nécessaires a été envoyé à l'adresse e-mail mentionnée.","LOGIN_RESET_PW_TITLE":"Problème lors de la connexion?","LOGIN_RESET_PW_TEXT":"Veuillez saisir l'adresse e-mail que vous avez enregistrée chez fondssuisse. Nous vous enverrons ensuite les instructions pour que tout fonctionne à nouveau.","LOGIN_RESET_PW_BUTTON":"Modifier le mot de passe","LOGIN_SET_NEW_PASSWORD_TITLE":"Saisir le mot de passe","LOGIN_SET_NEW_PASSWORD_TEXT":"Veuillez saisir le nouveau mot de passe (min. 8 signes, dont au moins 1 chiffre).","MAX_ERFASSUNGS_BETRAG":"Montant de saisie maximal","REGISTER":"Enregistrer","LOGIN_USERNAME":"Nom d'utilisateur","ERROR_REQUIRED":"Le champ est obligatoire.","ERROR_COORDINATES":"Veuillez définir un point sur la carte.","BENUTZERROLLEN_HINWEIS":"Pour attribuer des rôles à l'utilisateur, saisissez d'abord l'utilisateur puis ajoutez-le sur la page de l'interlocuteur avec les experts ou collaborateurs spécialisés.","BENUTZERROLLEN_ANLAUFSTELLE_HINWEIS":"Pour attribuer des rôles à l'utilisateur, saisissez d'abord l'utilisateur puis ajoutez-le sur la page de l'interlocuteur avec les experts ou collaborateurs spécialisés.","ERROR_DOCCOUNT":"Des documents sont nécessaires. Veuillez télécharger au moins {{count}} document(s).","ERROR_REQUIRED_ONE_OF_THEM":"L'un des champs est obligatoire.","ERROR_VERTRAG_REQUIRED":"Pour exiger une confirmation de place, vous devez avoir conclu un contrat avec l'institution concernée.","ERROR_MIN":"Valeur minimale non atteinte.","ERROR_MIN_LENG":"Saisie trop courte.","ERROR_MAX_LENG":"Saisie trop longue.","ERROR_EMAIL":"Adresse e-mail non valable.","ERROR_EMAIL_SAME":"La même adresse e-mail doit être saisie à deux reprises.","ERROR_FORMAT":"Format erroné","ERROR_IBAN_FORMAT":"IBAN non valable","ERROR_DATE":"Format de date erroné","ERROR_MAX":"Valeur maximale dépassée.","ERROR_NUMBER":"Format de chiffres erroné","ERROR_NO_LEISTUNG_ENTERED":"Aucune dépense / prestation n'a été saisie. Voulez-vous vraiment valider ?","ERROR_LEISTUNG_COMPULSORY":"Aucune dépense / prestation n'a été saisie. Veuillez saisir au moins une dépense / prestation.","ERROR_NO_BANKKONTO_ENTERED":"Les coordonnées bancaires doivent être saisies.","ERROR_NO_FUNCTIONAL_ROLE":"Aucune fonction n'a encore été attribuée à cet utilisateur.","ERROR_NO_SCHAETZER":"Vous devez attribuer au moins un expert à la demande pour pouvoir la transmettre.","ERROR_NO_SCHAETZUNG":"Il n'y a pas encore d'estimation saisie. Êtes-vous sûr de vouloir transmettre la demande ?","ERROR_NO_STEUERDATENPRUEFUNG":"Veuillez confirmer sur la page précédente que les données financières ont été vérifiées.","ERROR_NO_BEITRAG":"Au moins une contribution doit être saisie.","ERROR_VALUE":"Valeur trop élevée ou mal formatée.","ERROR_FUTURE":"Il s'agit d'une date ultérieure.","ERROR_PAST":"La date est située dans le passé.","ERROR_UNEXPECTED":"Une erreur inattendue est survenue.","ERROR_LOGIN":"Saisir une adresse e-mail et un mot de passe valables.","ERROR_PW_CHANGE":"Le mot de passe n'a pas pu être modifié.","ERROR_PW_SAME":"Veuillez saisir deux fois le nouveau mot de passe.","ERROR_PW_RESTRICTIONS":"Le mot de passe doit contenir au minimum 8 signes, dont au moins un chiffre et une lettre.","ERROR_UNAUTHORIZED":"Action non autorisée!","ERROR_NO_BEITRAEGE":"Aucune contribution n'a encore été sélectionnée.","ERROR_NO_SUBVENTIONIERT_FLAG":"Subventionné oui/non manque","ERROR_WALD":"La surface concernée ou la quantité de bois doit être saisie","FIRMA":"Entreprise","BESCHREIBUNG":"Description","FREIGEBEN":"Transmettre la demande","FREIGEBEN_PAPIER":"Transmettre la demande","FIRMENSITZ":"Siège de l'entreprise","LEISTUNGSART":"Type de prestation","RECHNUNGSNUMMER":"No de facture","RECHNUNGSDATUM":"Date de facturation","RECHNUNGSBETRAG":"Montant de la facture en CHF","DATE_PLACEHOLDER":"jj.mm.aaaa","DATEPICKER_EXAMPLE":"Exemple de calendrier","KEIN_EINTRAG":"Pas de saisie disponible","VALUEINPUT_EXAMPLE":"Exemple de valueinput","TOOLTIP_HELP_TITLE":"tooltip help title","TOOLTIP_HELP_TEXT":"Tooltip help title","MENU_ARCHIV":"Archives","MENU_BENUTZERVERWALTUNG":"Gestions des utilisateurs","MENU_ANLAUFSTELLE":"Interlocuteur","MENU_ZAHLUNGEN":"Paiements","MENU_STATISTIK":"Statistiques","MENU_GESUCH_ERFASSEN":"Saisir une demande","NAV_GESUCH_ERFASSEN":"Personnes concernées","NAV_SCHADENMELDUNG":"Annonce du sinistre","NAV_AUFWAENDE":"Coûts","NAV_SCHAETZUNG":"Estimation du sinistre","SACHBEARBEITER_ZUTEILEN":"Attribuer un collaborateur spécialisé","SCHAETZER_ADD":"Ajouter l'expert","DIE_SCHAETZER":"Les experts","SCHAETZER_ZUTEILEN":"Attribuer un expert","TESTFALL_ERSTELLEN":"Ajouter test sinistre {{gsname}}","TESTPAGE":"Page de test","TSEigenleistungArt_HANDARBEIT":"Travail manuel","TSEigenleistungArt_HANDARBEIT_PAUSCHAL":"Décompte des heures de travail manuel","TSEigenleistungArt_TERRA_TRAC_SUB44KW":"Terra Trac 30 à 44 kW (41 - 60 CV)","TSEigenleistungArt_TERRA_TRAC_SUB74KW":"Terra Trac 45 à 73 kW (61 - 100 CV)","TSEigenleistungArt_TELESKOPLADER":"Chargeur télescopique (accessoires inclus)","TSEigenleistungArt_KLEINBAGGER_1_5T_BIS_3T":"Mini-pelle 1.5t à 3t","TSEigenleistungArt_KLEINBAGGER_3_5T_BIS_6T":"Pelle rétro 3.5t à 6t","TSEigenleistungArt_KLEINBAGGER_7T_BIS_10T_SCHREITBAGGER":"Pelle rétro 7t à 10t / Pelle araignée","TSEigenleistungArt_RAUPENKARETTE":"Chenillette","TSEigenleistungArt_RAUPENTRANSPORTER_1_5T_BIS_4T":"Chenillette 1.5t à 4t","TSEigenleistungArt_TREIBSTOFF":"Petits appareils (consommation effective de carburant, par litre)","TSEigenleistungArt_TRAKTOR_SUB44KW":"Tracteur 30 à 44 kW (41 - 60 CV)","TSEigenleistungArt_TRAKTOR_SUB74KW":"Tracteur 45 à 73 kW (61 - 100 CV)","TSEigenleistungArt_TRAKTOR_AB74KW":"Tracteur plus de 74 kW (dès 100 CV)","TSEigenleistungArt_TRAKTOR_AB74KW_KIPPER":"Tracteur de plus de 74 kW (plus de 100 CV) avec benne hydr.","TSEigenleistungArt_TRAKTOR":"Tracteur de plus de 44 kW (dès 61 CV)","TSEigenleistungArt_TRAKTOR_4WD_SUB44KW":"Tracteur, 4 roues motrices, 30 à 44 kW (41 à 60 CV)","TSEigenleistungArt_TRAKTOR_4WD":"Tracteur, 4 roues motrices, plus de 44 kW (dès 61 CV)","TSEigenleistungArt_TRANSPORTER":"Transporteur avec pont","TSEigenleistungArt_TRANSPORTER_KIPPBRUECKE":"Transporter plus de 74 kW (plus de 100 CV) avec benne basculante","TSEigenleistungArt_ANHAENGER":"Remorque","TSEigenleistungArt_FRONTLADER":"Chargeur frontal avec benne à terre","TSEigenleistungArt_HECKSCHAUFEL_PLANIERSCHILD":"Pelle basculante / lame nivelleuse","TSEigenleistungArt_ANBAUSEILWINDE":"Treuil portatif","TSEigenleistungArt_HOLZ":"Bois de l'exploitation par m3","TSEigenleistungArt_HOLZ_AUF_PLATZ":"Bois de sa propre forêt livré sur place, par m3","TSEigenleistungArt_BAGGER_1500":"Pelle mécanique jusqu'à 1.5t","TSEigenleistungArt_BAGGER_BIS5000":"Pelle mécanique 2t à 5t","TSEigenleistungArt_BAGGER_AB5000":"Pelle mécanique à partir de 5-6t","TSEigenleistungArt_RAUPENTRANSPORTER":"Transporteur à chenilles","TSEigenleistungArt_KETTENSAEGE":"Tronçonneuse","TSEigenleistungArt_ANDERE":"Autres","TSLeistugnsart_MATERIAL":"Matériel","TSLeistugnsart_UNTERNEHMERRECHNUNG":"Facture d'entreprise","TSLeistugnsart_MIETE":"Location","TSLeistugnsart_OFFERTE":"Offre","TSLeistugnsart_HOLZ":"Bois","TSLeistugnsart_PAUSCHAL":"Estimation forfaitaire","TSRole_SUPER_ADMIN":"Superadmin","TSRole_FONDSSUISSE_ADMIN":"fondssuisse admin","TSRole_FONDSSUISSE_SACHBEARBEITER":"collaborateur spécialisé de fondssuisse","TSRole_KANTON_VERWALTER":"Canton administrateur","TSRole_KANTON_INSPEKTOR":"Canton expert","TSRole_ANLAUFSTELLE_SACHBEARBEITER":"Collaborateur spécialisé de l'interlocuteur","TSRole_ANLAUFSTELLE_VERWALTER":"Administrateur de l'interlocuteur","TSRole_ANLAUFSTELLE_SCHAETZER":"Expert de l'interlocuteur","TSRole_BETROFFENER":"Personne concernée","BETROFFENE":"Personne concernée","TSRole_UNASSIGNED_ROLE":"N/A","TSVorleistungArt_HAGELVERSICHERUNG":"Assurance grêle","TSVorleistungArt_GEBAEUDEVERSICHERUNG":"Assurance bâtiment","TSVorleistungArt_PRIVATVERSICHERUNG":"Assurance privée","TSVorleistungArt_SUBVENTION":"Subventions","TSVorleistungArt_SPENDE":"Dons","TSVorleistungArt_ANDERE":"Autres","TOTAL_EIGENLEISTUNGEN":"Total des coûts à charge du requérant CHF {{totalel | number : 0}}","NEU":"Nouvelle demande (en ligne)","NEU_PAPIER_ANLAUFSTELLE":"Nouvelle demande (papier)","NEU_PAPIER_FS":"Nouvelle demande (papier; FS)","IMPORTIERT":"Importé","IN_BEARBEITUNG_ANLAUFSTELLE":"En traitement auprès de l'interlocuteur","IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS":"En traitement auprès de fondssuisse pour refus","AUFTRAG_SCHAETZER":"Mandat attribué à l'expert","SCHAETZUNG_DURCHGEFUEHRT":"L'expertise est terminée","IN_BEARBEITUNG_FS":"En traitement auprès de fondssuisse","INAKTIV":"Inactif","UEBERPRUEFUNG_ANLAUFSTELLE":"En examen auprès des interlocuteurs","UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS":"En examen auprès de fondssuisse pour refus","UEBERPRUEFUNG_FONDSSUISSE":"En examen auprès de fondssuisse","WIEDERHERSTELLUNG":"Remise en état en cours","UEBERPRUEFUNG_SCHAETZER":"En examen auprès de l'expert","SCHADEN_BEHOBEN_ABRECHNEN":"Remise en état effectuée, prêt pour le décompte.","ABGELEHNT_ANLAUFSTELLE":"Refusé par l'interlocuteur","ABGELEHNT_FONDSSUISSE":"Refusé par fondssuisse","EIGENLEISTUNG_LOESCHEN":"Voulez-vous vraiment supprimer la prestation propre?","EIGENLEISTUNG_BETRAG_BERECHTIGT":"Montant calc.","SCHADEN_BEHOBEN":"Dommages remis en état","ABRECHNEN":"Prêt pour le décompte","AUSZAHLUNG":"Prêt pour le versement","ABGESCHLOSSEN":"Clôturé","ABGELEHNT":"Refusé","GRUNDEIGENTUEMER":"propriétaire foncier","PAECHTER":"fermier","GENOSSENSCHAFT":"Société coopérative","TSEigentumsverhaeltnis_PAECHTER":"Fermier","TSEigentumsverhaeltnis_GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER":"propriétaire foncier en tant qu'exploitant à titre personnel","TSEigentumsverhaeltnis_GRUNDEIGENTUEMER":"Propriétaire foncier avec fermier","ANDERE_KOERPERSCHAFT":"Autre corporation","NATUERLICHE_PERSON":"Personne physique","MEHRPERSONENGESELLSCHAFT":"Société à plusieurs personnes","MEINE_SCHADENFAELLE":"Mes sinistres","NICHT_ZUGETEILT":"Non attribué","OFFENE":"Ouvert","ABGESCHLOSSENE":"Clôturés","FALL":"Cas","GESUCHSTELLER":"Requérant","EREIGNIS":"Evénement","ANLAUFSTELLE":"Interlocuteur","ORT":"Localité","DATUM":"Date","STATUS":"Statut","VERANTWORTLICHER":"Responsable","EIGENTUMSVERHAELTNISSE_GESUCHSTELLER":"Rapport de propriété du requérant","EIGENTUMSVERHAELTNISSE_VERSICHERTER":"Rapport de propriété de l'assuré","EIGENTUMSVERHAELTNISSE_TITLE":"Rapport de propriété","KONTAKTANGABEN_GESUCHSTELLER":"Coordonnées du requérant","KONTAKTANGABEN_TITLE":"Coordonnées","KORRESPONDENZSPRACHE":"Langue de correspondance","SPRACHE":"Langue","STRASSE":"Rue","PLZ":"NPA","EMAIL":"E-mail","EMAIL_VERIFIED":"Votre compte d'utilisateur a été activé. Vous pouvez maintenant vous connecter.","ADRESSE_STRASSE":"Rue","ADRESSE_HAUSNUMMER":"Numéro","ADRESSE_PLZ":"NPA","ADRESSE_ORT":"Localité","ADRESSE_ZUSATZ":"Complément d'adresse","TELEFON":"Téléphone (mobile ou fixe)","ANREDE":"Titre","HERR":"Monsieur","FRAU":"Madame","FINANZIELLE_VERHAELTNISSE":"Situation financière","STEUERJAHR":"Année fiscale","STEUERBARES_EINKOMMEN":"Revenu imposable","STEUERBARES_VERMOEGEN":"Fortune imposable","GEWINN":"Bénéfice","KAPITAL":"Capital","ZUSTIMMUNG_STEUERPRUEFUNG":"J'autorise la commune / le canton à contrôler les éléments fiscaux, resp. à les compléter dans la demande pour fondssuisse et à les enregistrer dans le portail des dommages.","ZUSTIMMUNG_PRUEFUNG_FONDSUISSE":"J'accepte que les données et les informations transmises et examinées par les services/offices concernés dans le cadre de ma demande soient transmises à fondssuisse.","ZUSTIMMUNG_PRUEFUNG_FONDSUISSE_GENOSSENSCHAFT":"J'accepte que les données et les informations transmises et examinées par les services/offices concernés dans le cadre de ma demande soient transmises à fondssuisse.","BANKANGABEN":"Coordonnées bancaires","KONTAKTANGABEN_EIGENTUEMER":"Coordonnées du propriétaire","NEUER_SCHADENFALL":"Nouveau sinistre","ANGABEN_ZUR_GENOSSENSCHAFT":"Données concernant la société coopérative","ANGABEN_ZUR_GESELLSCHAFT":"Données concernant la société","ANGABEN_ZUR_TITLE":"Données concernant le {{title}}","KONTAKTANGABEN_GENOSSENSCHAFT":"Coordonnées de la société coopérative","KONTAKTANGABEN_KOERPERSCHAFT":"Coordonnées de la corporation","STEUERPFLICHT_GESELLSCHAFT":"La société est assujettie à l'impôt","NICHT_STEUERPFLICHT_GESELLSCHAFT":"La société n'est pas assujettie à l'impôt","STEUERPFLICHT_GENOSSENSCHAFT":"La société coopérative est assujettie à l'impôt","NICHT_STEUERPFLICHT_GENOSSENSCHAFT":"La société coopérative n'est pas assujettie à l'impôt","GENOSSENSCHAFT_NAME":"Nom de la société coopérative","GESELLSCHAFT_NAME":"Nom de la société","ANGABEN_ZUR_KOERPERSCHAFT":"Données concernant la corporation","ART_DER_KOERPERSCHAFT":"Type de corporation","EINZELNE_STEUERPLICHTGE_PERSONEN":"La corporation est composée de différentes personnes assujetties à l'impôt.","KOLLEKTIVE_STEUERPFLICHT":"La corporation est un collectif et est assujettie à l'impôt.","KOERPERSCHAFT_NICHT_STEUERPFLICHTIG":"La corporation n'est pas assujettie à l'impôt.","MINIMAL_SCHADEN":"En raison de la situation du revenu et de la fortune, des déductions sont calculées sur le montant du dommage. Votre déduction s'élève à CHF {{abzug}}.-","MINIMAL_SCHADEN_EINKOMMEN":"En cas de revenu supérieur à 200'000.-, le droit à une indemnité tombe.","MINIMAL_SCHADEN_VERMOEGEN":"En cas de fortune supérieure à 2'000'000.-, le droit à une indemnité tombe.","MINIMAL_SCHADEN_VERMOEGEN_2026":"En cas de fortune supérieure à 2'500'000.-, le droit à une indemnité tombe.","FRUEHERER_SCHADENFALL":"J'ai déjà annoncé un sinistre par le passé.","FRUEHERER_SCHADENFALL_PAPIER":"La personne concernée a-t-elle déjà annoncé un sinistre par le passé?","DAS_GESUCH":"Le sinistre","DIE_SCHAETZUNG":"L'estimation du sinistre","DIE_AUFWAENDE":"Les coûts","SCHADENEREIGNIS":"Sinistre","SCHADENORT":"Lieu du dommage (commune)","START_TYPING":"Pour faire des propositions, commencez à appuyez sur les touches.","NEUER_SCHADEN":"Nouveau dommage","DIE_SCHAEDEN":"Les dommages","SCHADEN_NAME":"Dommage sur {{objekt}} du {{datum}}","BEITRAG_READONLY":"Contribution {{art}} du {{datum}}","SCHADEN":"Dommage","GENAUER_ORT":"Lieu exact du dommage","VERSICHERUNG_VORHANDEN":"J'ai une assurance pour cette parcelle.","VERSICHERUNG_GEMELDET":"J'ai déjà annoncé le dommage à mon assurance.","DATUM_STICHTAG":"Date du dommage","PARZELLENNUMMER":"No de(s) parcelle(s)","ART_DES_SCHADENDS":"Type du dommage","SCHADEND_OBJEKT":"Objet endommagé","SCHADEN_VORGESEHENE_MASSNAHMEN":"Brève description, mesures prévues","ERROR_NO_SCHADEN_VORGESEHENE_MASSNAHMEN":"Brève description, mesures prévues manque","BESCHRIEB":"Descriptif","GESCHAETZTE_KOSTEN":"Coûts estimés en CHF","GESCHAETZTER_MEHRWERT":"Plus-value estimée / déduction non imputable [%]","BERECHNUNGSDETAIL_ANSCHAUEN":"Consulter les détails du calcul","HINZUFUEGEN":"Ajouter une annexe","LABEL_JA":"oui","LABEL_OK":"OK","LABEL_NEIN":"non","FILE_LOESCHEN":"Voulez-vous vraiment supprimer le document?","FILE_ZU_GROSS":"Le fichier est trop gros. La taille maximale est de 10 MB.","FILETYPE_NICHT_ERLAUBT":"Ce type de fichier n'est pas autorisé.","SCHADEN_HINZUFUEGEN":"Ajouter un dommage","SCHADEN_ERSTELLEN":"Ajouter un dommage","SCHADEN_LOESCHEN":"Supprimer un dommage","SCHADEN_SPEICHERN":"Enregistrer le dommage","BERECHNUNGSDETAIL_TOTAL":"Total des déductions","VORLEISTUNGEN":"Prestations préalables","VORLEISTUNG_ART":"Type","VORLEISTUNG_POLICE_NR":"No de police","VORLEISTUNG_LOESCHEN":"Voulez-vous vraiment supprimer cette prestation préalable?","BILDER_DOKUMENTE":"Photos & documents","BILDER_DOKUMENTE_WIEDERHERSTELLUNG":"Photos & documents - Remise en état en cours","UPLOAD_TEXT":"SVP télécharger ici vos photos, rapports et offres.","KULTURLAND":"Terres arables","OBSTBAUM_REBSTOECKE":"Arbres fruitiers, vignes","STRASSEN_WEGE":"Routes, chemins","BRUECKEN_DURCHLAESSE":"Ponts, passages","UFER_BACHBAUTEN":"Digues, ouvrages de protection des rives","STUETZMAUER_REBMAUERN":"Murs de soutènement, murs de vigne","STEUERDATEN_GEPRUEFT":"Les données fiscales du demandeur sont correctes et vérifiées.","HAUSUMSCHWUNG":"Alentours d'immeuble","EINFRIEDUNG":"Clôtures","LEITUNGEN_AUSSERHALB_DER_GEBAEUDE":"Conduites à l'extérieur des bâtiments","WALD":"Forêts","KULTURART":"Type de culture","FLAECHE_ARE":"Surface concernée (ares)","HOLZ_MENGE":"Quantité de bois (m3)","FLAECHE_M2":"Surface (m2)","ANZAHL":"Nombre","SORTE":"Sorte","ALTER":"Âge (env.)","LETZTEINSTANDSTELLUNG":"Dernière remise en état (année)","LAENGE":"Longueur (m)","BREITE":"Largeur (m)","HOEHE":"Hauteur (m)","KOORDINATEN":"Coordonnées","BAUART":"Type de construction","SCHADEN_MATERIAL":"Matériel (m3)","ART":"Type","AUFWAENDE":"Coûts","SCHADENFALL":"Sinistre","ZURUECK":"retour","SCHAETZUNG":"Estimation","EIGENLEISTUNGEN":"Prestations personnelles","EIGENLEISTUNG":"Prestation personnelle","TOTAL":"Total","OFFERTEN":"Offres","FREMDKOSTEN":"Coûts externes","BEZEICHNUNG":"Désignation","POSITION_AUF_KARTE":"Position sur la carte","SET_MARKER":"Veuillez marquer l'endroit précis du dommage sur la carte.","SET_MARKER_READONLY":"Endroit du dommage sur la carte (ne peut pas être édité)","CREATE_PROFIL":"Créer un profil d'utilisateur","IHR_ABZUG":"Votre déduction","MAP_HELPTEXT":"Pour afficher plus de détails sur la carte, veuillez zoomer. Pour marquer la position du dommage, un marqueur peut être placé en cliquant sur la carte.","SCHADENFALL_STATUS_CHANGED":"Le statut a changé","SCHADENFALL_CREATED":"Le sinistre a été créé dans le système.","SYSTEM_MELDUNG":"Message par le système","BEMERKUNGEN":"Remarques","BEMERKUNG":"Remarque","BEMERKUNG_ERFASSEN":"Enregistrer la remarque","BEMERKUNG_UPDATE":"Actualiser une remarque","NEUE_BEMERKUNG_ERFASSEN":"Saisir une nouvelle remarque","BEMERKUNG_REMOVE":"Voulez-vous vraiment effacer la remarque?","MITTEILUNGEN_NOCH_KEINE":"Aucune remarque n'a encore été saisie.","STATUS_CHANGE_HISTORY":"Les collaboratuers spécialisés","ABBRECHEN":"interrompre","AUSFUEHREN":"Exécuter","FREIGABE_BEMERKUNG_TEXT":"Le sinistre remplit toutes les conditions de contribution. Accepter et valider à l'attention du requérant pour la remise en état.","FREIGABE_BEMERKUNG_GESUCHSTELLER_TEXT":"Si vous validez le sinistre, il sera transmis à l'interlocuteur compétent pour la suite du traitement. Vous ne pourrez ensuite plus procéder à des modifications. Voulez-vous vraiment valider ?","FREIGABE_BEMERKUNG_ANLAUFSTELLE_TEXT":"Vous validez la demande. Elle sera ensuite disponible dans la liste de vos sinistres.","BEGRUENDUNG":"Motif","STATUSUEBERGANG_VON":"Transition de statut de","NACH":"à","TSBegruendungsCode_BG_1_kurz":"Prendre en compte la demande","TSBegruendungsCode_BG_1_lang":"Prendre en compte la demande","TSBegruendungsCode_BG_10_kurz":"payé","TSBegruendungsCode_BG_10_lang":"payé","TSBegruendungsCode_BG_11_kurz":"Versement d'un acompte. Le reste sera versé après le décompte final.","TSBegruendungsCode_BG_11_lang":"Versement d'un acompte. L'indemnité restante sera versée après la présentation du décompte final.","TSBegruendungsCode_BG_12_kurz":"Une partie du dommage est couverte par l'assurance suisse contre la grêle","TSBegruendungsCode_BG_12_lang":"Une partie du dommage a été couverte par la Société suisse d'assurance contre la grêle.","TSBegruendungsCode_BG_13_kurz":"Une partie du dommage est couverte par des prestations d'assurance","TSBegruendungsCode_BG_13_lang":"Une partie du dommage est couverte par des prestations d'assurance.","TSBegruendungsCode_BG_14_kurz":"Indemnité réduite car le dommage est en partie assurable","TSBegruendungsCode_BG_14_lang":"Indemnité réduite car il s'agit d'un dommage partiellement assurable.","TSBegruendungsCode_BG_15_kurz":"Indem. en faveur du fermier, reste à charge du propriétaire","TSBegruendungsCode_BG_15_lang":"Indemnité en faveur du fermier. Le dommage restant doit à notre avis être pris en charge par le propriétaire.","TSBegruendungsCode_BG_16_kurz":"Toutes les personnes concernées ne sont pas ayants droit","TSBegruendungsCode_BG_16_lang":"Conformément à nos directives, toutes les personnes concernées ou les personnes soumises à l'obligation de périmètre ne peuvent pas être prises en compte.","TSBegruendungsCode_BG_17_kurz":"Il s'agit d'une exception car la déduction R/F exclurait la contribution","TSBegruendungsCode_BG_17_lang":"Exceptionnellement pris en compte car en raison du revenu et/ou de la fortune, aucune contribution ne serait accordée.","TSBegruendungsCode_BG_18_kurz":"Il s'agit d'une exception. Ce dommage ne sera plus pris en compte à l'avenir","TSBegruendungsCode_BG_18_lang":"Exceptionnellement pris en compte. À l'avenir de tels dommages ne seront plus pris en compte.","TSBegruendungsCode_BG_19_kurz":"Exception sans préjudice pour de futurs cas semblables","TSBegruendungsCode_BG_19_lang":"Exceptionnellement pris en compte, sans préjudice pour les futurs cas semblables.","TSBegruendungsCode_BG_20_kurz":"Dommages ne donnant pas droit à des contributions","TSBegruendungsCode_BG_20_lang":"Dommages ne donnant pas droit à des contributions.","TSBegruendungsCode_BG_21_kurz":"Dommages n'entrant pas en considération","TSBegruendungsCode_BG_21_lang":"Dommages n'entrant pas en considération (\"Directives\" art. 11 à 13).","TSBegruendungsCode_BG_22_kurz":"Dommages assurables","TSBegruendungsCode_BG_22_lang":"Il s'agit d'un dommage assurable (\"Directives\" art. 11).","TSBegruendungsCode_BG_23_kurz":"Dommages insignifiants (pas de remise en état ou par des tiers)","TSBegruendungsCode_BG_23_lang":"Le dommage est insignifiant (aucun travail de remise en état n'a été effectué) ou il a été remis en état par des tiers.","TSBegruendungsCode_BG_24_kurz":"Non causé par un événement naturel ou causé par des tiers","TSBegruendungsCode_BG_24_lang":"Le dommage n'a pas été causé par un événement naturel ou a été causé par des tiers.","TSBegruendungsCode_BG_25_kurz":"Couvert par d'autres contributions ou assurances","TSBegruendungsCode_BG_25_lang":"Le dommage est couvert par d'autres subventions ou contributions.","TSBegruendungsCode_BG_26_kurz":"Mouvements du sol provoqués artificiellement ou par des actions de l'homme","TSBegruendungsCode_BG_26_lang":"Dommages causés par des mouvements du sol provoqués artificiellement, par des installations défectueuses, un entretien négligé ou une action directe ou indirecte de l'homme.","TSBegruendungsCode_BG_27_kurz":"Dommages causés à des ouvrages d'art en construction","TSBegruendungsCode_BG_27_lang":"Dommages causés à des ouvrages d'art en construction.","TSBegruendungsCode_BG_28_kurz":"Dommages qui se reproduisent à de brefs intervalles","TSBegruendungsCode_BG_28_lang":"Dommages qui se reproduisent à de brefs intervalles (Directives\" art. 12, al. 3).","TSBegruendungsCode_BG_29_kurz":"Dommages prévisibles","TSBegruendungsCode_BG_29_lang":"Le dommage était prévisible, il aurait pu être empêché par des mesures raisonnables prises à temps (entretien déficient, manque de diligence).","TSBegruendungsCode_BG_30_kurz":"Effet continu","TSBegruendungsCode_BG_30_lang":"Dommages qui ne sont pas dus à des phénomènes d'une violence extraordinaire ou à des effets continus.","TSBegruendungsCode_BG_31_kurz":"Parasites animaux ou végétaux","TSBegruendungsCode_BG_31_lang":"Dommages causés par des parasites animaux ou végétaux.","TSBegruendungsCode_BG_32_kurz":"Pression de la neige, grêle, feu en forêt","TSBegruendungsCode_BG_32_lang":"Les dommages causés aux forêts par la pression de la neige, par la grêle ou par le feu ne sont pas pris en considération (\"Directives\" art. 12, al. 7).","TSBegruendungsCode_BG_33_kurz":"Certains arbres forestiers ne sont pas indemnisés","TSBegruendungsCode_BG_33_lang":"Certains arbres forestiers ne sont pas indemnisés.","TSBegruendungsCode_BG_34_kurz":"Sécheresse, humidité (reflux de canalisations), gel","TSBegruendungsCode_BG_34_lang":"Les dommages causés par la sécheresse, l'humidité (reflux de canalisations) ou le gel ne peuvent pas être pris en considération (\"Directives\" art 12)","TSBegruendungsCode_BG_35_kurz":"Entraînement de gravier sur des routes et des places","TSBegruendungsCode_BG_35_lang":"L'entraînement de gravier par les eaux sur des routes et des places n'est pas indemnisé.","TSBegruendungsCode_BG_36_kurz":"Diminution générale de la valeur/perte de salaire et de gain","TSBegruendungsCode_BG_36_lang":"La diminution générale de valeur d'un immeuble ou les pertes de salaire et de gain en lien avec un sinistre ne peuvent pas être indemnisées.","TSBegruendungsCode_BG_37_kurz":"Entretien normal/purement préventif","TSBegruendungsCode_BG_37_lang":"L'entretien courant ou les mesures purement préventives ne peuvent pas être soutenues.","TSBegruendungsCode_BG_38_kurz":"Remplacé par un autre avis de dommage","TSBegruendungsCode_BG_38_lang":"Remplacé par un autre avis de dommage.","TSBegruendungsCode_BG_39_kurz":"Remis après l'écoulement du délai de déclaration de 3 mois","TSBegruendungsCode_BG_39_lang":"L'avis de dommage a été remis après l'écoulement du délai de déclaration de 3 mois (\"Directives\" art. 16).","TSBegruendungsCode_BG_40_kurz":"Sinistré non ayant droit","TSBegruendungsCode_BG_40_lang":"Sinistré non ayant droit (\"Directives\" art. 7).","TSBegruendungsCode_BG_41_kurz":"Déduction R/F supérieure au dommage calculé","TSBegruendungsCode_BG_41_lang":"La déduction à imputer pour cause de revenu et/ou de fortune dépasse le montant du dommage calculé (\"Directives\" art. 23).","TSBegruendungsCode_BG_42_kurz":"Non ayant droit en raison de R/F trop élevés","TSBegruendungsCode_BG_42_lang":"Non ayant droit pour cause de revenu et/ou de fortune trop élevés (\"Directives\" art. 23).","TSBegruendungsCode_BG_45_kurz":"Non ayant droit, nous indemnisons le fermier","TSBegruendungsCode_BG_45_lang":"Non ayant droit, nous indemnisons le fermier.","TSBegruendungsCode_BG_46_kurz":"Le dommage doit être pris en charge par le propriétaire","TSBegruendungsCode_BG_46_lang":"Le dommage doit être pris en charge par le propriétaire.","TSBegruendungsCode_BG_47_kurz":"Décompte/documents non reçus dans le délai fixé","TSBegruendungsCode_BG_47_lang":"Nous n'avons pas reçu le décompte dans le délai fixé.","TSBegruendungsCode_BG_48_kurz":"Le dommage n'atteint pas le montant minimal","TSBegruendungsCode_BG_48_lang":"Le dommage n'atteint pas le montant minimal (\"Directives\" art. 22).","TSBegruendungsCode_BG_49_kurz":"amorti","TSBegruendungsCode_BG_49_lang":"La surface endommagée convertie en degré de dommage de 100% est inférieure à 25 ares.","TSBegruendungsCode_BG_50_kurz":"Eléments fiscaux manquants","TSBegruendungsCode_BG_50_lang":"Nous avons besoin des éléments fiscaux (revenu et fortune, après déductions sociales).","TSBegruendungsCode_BG_52_kurz":"Uniquement répartition fiscale/besoin des éléments domicile","TSBegruendungsCode_BG_52_lang":"Seule la répartition fiscale a été mentionnée. Nous avons besoin des éléments fiscaux du domicile.","TSBegruendungsCode_BG_54_kurz":"Noms et éléments fiscaux des frères et soeurs","TSBegruendungsCode_BG_54_lang":"Nous avons besoin des noms et des éléments fiscaux des frères et soeurs.","TSBegruendungsCode_BG_55_kurz":"Noms et éléments fiscaux des héritiers","TSBegruendungsCode_BG_55_lang":"Nous avons besoin des noms et des éléments fiscaux des héritiers.","TSBegruendungsCode_BG_56_kurz":"Eléments fiscaux des héritiers ou de l'usufruitier","TSBegruendungsCode_BG_56_lang":"Nous avons besoin des éléments fiscaux des héritiers ou de l'usufruitier si celui-ci doit assumer seul le dommage.","TSBegruendungsCode_BG_57_kurz":"Eléments fiscaux des personnes concernées","TSBegruendungsCode_BG_57_lang":"Nous avons besoin des éléments fiscaux des personnes concernées/personnes soumises à l'obligation de périmètre.","TSBegruendungsCode_BG_58_kurz":"Annoncer les éléments fiscaux quand la nouvelle taxation sera définitive","TSBegruendungsCode_BG_58_lang":"Veuillez annoncer les éléments fiscaux dès que la nouvelle taxation est définitive.","TSBegruendungsCode_BG_59_kurz":"Eléments fiscaux permutés?","TSBegruendungsCode_BG_59_lang":"A notre avis, les éléments fiscaux dans l'avis du dommage ont été permutés. Veuillez les annoncer à nouveau.","TSBegruendungsCode_BG_62_kurz":"Besoin d'une estimation approx. des dommages","TSBegruendungsCode_BG_62_lang":"Nous avons besoin d'une estimation approximative des dommages selon art. 18 des \"Directives\" (description détaillée du dommage, év. esquisses ou photos, frais probables de remise en état).","TSBegruendungsCode_BG_66_kurz":"Projet de subvention, attente du décompte final","TSBegruendungsCode_BG_66_lang":"Projet de subvention. Après la fin des travaux, nous attendons le décompte final. Si les coûts restants doivent être assumés par plusieurs personnes concernées, la répartition des frais doit être annexée.","TSBegruendungsCode_BG_69_kurz":"Doit être traité par le Service des forêts","TSBegruendungsCode_BG_69_lang":"Le dommage doit être traité par le Service des forêts. Seuls les cas de rigueur sont pris en compte (lorsque les frais d'équipement et d'évacuation ne peuvent pas être couverts par les subventions et le produit de la vente du bois).","TSBegruendungsCode_BG_70_kurz":"Besoin du décompte avec justificatifs","TSBegruendungsCode_BG_70_lang":"Afin de déterminer notre indemnité, nous avons besoin après les travaux de remise en état effectués d’un décompte détaillé : prestations propres, coûts externes, prestations préalables, y compris les copies des factures et des justificatifs de paiement. Veuillez saisir ces informations dans l’onglet « Coûts » et y télécharger les documents nécessaires. Si les coûts restants sont pris en charge par plusieurs personnes concernées, merci d’également télécharger un document avec la répartition des coûts. Dans le cas d’un projet subventionné, la décision de subventionnement et le décompte de subventionnement sont également requis. Les travaux de remise en état doivent dans la mesure du possible et lorsque cela paraît judicieux être effectués par les propres moyens du sinistré. Pour plus d’information : <a href='https://www.fondssuisse.ch' target='_blank'>www.fondssuisse.ch</a>","TSBegruendungsCode_BG_71_kurz":"Besoin des factures et des justificatifs de paiement","TSBegruendungsCode_BG_71_lang":"Pour fixer l'indemnité, nous avons besoin des factures d'entreprise et/ou de matériel acquittée ou des justificatifs de paiement de la facture.","TSBegruendungsCode_BG_72_kurz":"Besoin du décompte (prestations propres, coûts externes)","TSBegruendungsCode_BG_72_lang":"Pour fixer l'indemnité, nous avons besoin d'un décompte détaillé sur les travaux de remise en état effectué: liste des travaux à la main et heures de machines, copie des factures et justificatifs de paiement. Informations et formulaire \"Rapport d'heures\": www.fondssuisse.ch","TSBegruendungsCode_BG_73_kurz":"Besoin du décompte de subvention","TSBegruendungsCode_BG_73_lang":"Pour fixer l'indemnité, nous avons besoin d'un décompte détaillé avec justificatifs: frais totaux / subventions de la Confédération, du canton et/ou de la commune / coûts restants à charge des personnes concernées.","TSBegruendungsCode_BG_74_kurz":"Besoin du décompte de l'assurance grêle","TSBegruendungsCode_BG_74_lang":"Pour fixer l'indemnité, nous avons besoin d'un décompte détaillé (coûts totaux et prestation de l'assurance grêle, merci d'annexer également le décompte de l'assurance grêle).","TSBegruendungsCode_BG_75_kurz":"En attente du décompte.","TSBegruendungsCode_BG_75_lang":"Nous attendons le décompte.","TSBegruendungsCode_BG_76_kurz":"Besoin d'une offre de remise en état","TSBegruendungsCode_BG_76_lang":"Nous vous prions de bien vouloir nous faire parvenir une offre de remise en état.","TSBegruendungsCode_BG_79_kurz":"Une contribution ne peut pas encore être fixée, éclaircissements nécessaires","TSBegruendungsCode_BG_79_lang":"L'indemnité ne peut pas encore être fixée sur la base des données/documents à disposition.","TSBegruendungsCode_BG_80_kurz":"Une partie du dommage est couverte par l'assurance?","TSBegruendungsCode_BG_80_lang":"Veuillez clarifier si au moins une partie du dommage est couverte par des prestations d'assurance.","TSBegruendungsCode_BG_81_kurz":"Doit être annoncé à l'assurance grêle","TSBegruendungsCode_BG_81_lang":"Le dommage doit être annoncé à l'assurance grêle.","TSBegruendungsCode_BG_82_kurz":"Doit être annoncé à la Mobilière Assurance.","TSBegruendungsCode_BG_82_lang":"Le dommage doit être annoncé à la Mobilière Assurance.","TSBegruendungsCode_BG_83_kurz":"Doit être annoncé à l'assurance bâtiment","TSBegruendungsCode_BG_83_lang":"Le dommage doit être annoncé à l'assurance bâtiment.","TSBegruendungsCode_BG_84_kurz":"Dommage couvert par l'assurance grêle?","TSBegruendungsCode_BG_84_lang":"Le dommage est-il (au moins partiellement) couvert par la Société suisse d'assurance contre la grêle?","TSBegruendungsCode_BG_85_kurz":"Remise en état subventionnable?","TSBegruendungsCode_BG_85_lang":"Les travaux de remise en état sont-ils être subventionnés par la Confédération, le canton et/ou la commune ?","TSBegruendungsCode_BG_86_kurz":"Annoncer le dommage à l'Off. amél., év. subventionnable","TSBegruendungsCode_BG_86_lang":"Veuillez annoncer le dommage à l'Office des améliorations foncières, les travaux de remise en état sont peut-être subventionnables.","TSBegruendungsCode_BG_87_kurz":"Selon nous, la commune devrait participer aux FRE","TSBegruendungsCode_BG_87_lang":"A notre avis, la commune devrait participer aux frais de remise en état. Nous vous prions de bien vouloir prendre position.","TSBegruendungsCode_BG_90_kurz":"Partie à charge du propriétaire -> annoncer éléments fiscaux","TSBegruendungsCode_BG_90_lang":"Nous avons examiné la demande et attendons le décompte. Frais max. imputables 1'000.-.","TSBegruendungsCode_BG_91_kurz":"Partie à charge du propriétaire -> nom et éléments imposables","TSBegruendungsCode_BG_91_lang":"A notre avis, le dommage doit au moins en partie être assumé par le propriétaire. Nous vous prions de bien vouloir nous communiquer son nom, l'adresse et les éléments fiscaux.","TSBegruendungsCode_BG_92_kurz":"Partie à du charge propriétaire -> prise de position","TSBegruendungsCode_BG_92_lang":"A notre avis, le dommage doit au moins en partie être assumé par le propriétaire (p. ex. travaux d'entreprise, perte de terres arables). Nous vous prions de bien vouloir prendre position.","TSBegruendungsCode_BG_93_kurz":"Délai 3 mois pour le décompte","TSBegruendungsCode_BG_93_lang":"A ce jour, nous n'avons pas reçu le décompte. Sans avis contraire dans les trois mois, nous considérerons la demande comme clôturée.","TSBegruendungsCode_BG_95_kurz":"Nous attendons votre rapport","TSBegruendungsCode_BG_95_lang":"Nous attendons votre rapport.","TSBegruendungsCode_BG_98_kurz":"Arbres fruitiers détruits -> confirmation de reconstitution de la plantation.","TSBegruendungsCode_BG_98_lang":"Les arbres fruitiers détruits sont indemnisés qu'après la reconstitution de la plantation. Nous attendons une confirmation dans ce sens.","TSBegruendungsCode_BGN_10_kurz":"10 - Noms et éléments imposables de chacun des intéressés","TSBegruendungsCode_BGN_10_lang":"Nous avons besoin des éléments imposables de\n- chaque frère et soeur\n- chaque héritier\n- chaque héritier ou de l’usufruitier si celui-ci supporte seul le dommage.\n\nNous avons besoin des éléments imposables de chaque propriétaire intéressé / de chaque propriétaire foncier du périmètre soumis à obligation.\n\nVeuillez télécharger ces informations dans le portail des dommages.","TSBegruendungsCode_BGN_11_kurz":"11 - En partie à charge du propriétaire - Annoncer les éléments imposables","TSBegruendungsCode_BGN_11_lang":"Le dommage doit, à notre avis, au moins en partie être supporté par le propriétaire. Nous vous prions de nous indiquer son nom, son adresse et ses éléments imposables (revenu et fortune). Veuillez saisir/télécharger ces informations dans le portail des dommages. \n\n Le dommage doit, à notre avis, au moins en partie être supporté par le propriétaire (par ex. travaux d’entreprises, pertes de terres agricoles). Veuillez nous tenir informé.","TSBegruendungsCode_BGN_12_kurz":"12 - En attente des pourcentages de la répartition des frais","TSBegruendungsCode_BGN_12_lang":"Nous avons besoin de la liste des membres avec les pourcentages de la répartition des frais (liste des propriétaires du périmètre soumis à obligation).  \n\n En attente des statuts et …  / …. ainsi que des statuts.\n\n…. ainsi que des éléments imposables lorsqu’ils sont peu nombreux.\n\nAfin de déterminer notre contribution aux coûts restants, nous avons besoin de la liste des membres avec les pourcentages de la répartition des frais (liste des propriétaires du périmètre).\n\nNous vous remercions pour ces précisions. Afin de déterminer notre indemnité,  nous avons besoin, en lieu et place de la liste confidentielle des membres, du nombre de membres, avec la répartition des personnes physiques, des collectivités de droit privé et de droit public, ainsi que des statuts.","TSBegruendungsCode_BGN_20_kurz":"20 - Estimation incomplète - Informations/documents manquants","TSBegruendungsCode_BGN_20_lang":"Nous avons besoin des informations/documents suivants : description précise du dommage, photos, estimation des coûts du dommage.\n\nVeuillez nous faire parvenir un ou deux devis pour les travaux de remise en état prévus.\n\n Nous vous recommandons d’obtenir d’autres devis.\n\n Veuillez télécharger ces documents dans le portail des dommages.","TSBegruendungsCode_BGN_21_kurz":"21 - Estimation élevée. Y aurait-il une solution meilleure marché ?","TSBegruendungsCode_BGN_21_lang":"Les frais de remise en état estimés semblent élevés. Y aurait-il une solution meilleure marché ?\n\nLe sinistré doit procéder, dans la mesure du possible et lorsque cela parait judicieux, aux travaux de remises en état par ses propres moyens.\n\nLes frais de remise en état estimés semblent élevés par rapport à la surface endommagée (valeur de rendement). Veuillez les justifier. Le cas contraire, les valeurs de références de fondssuisse seront appliquées pour cette surface.\n\nLes frais de remise en état estimés sont trop élevés par rapport à la valeur de rendement de la surface endommagée. Au maximum la moitié des coûts estimés seront pris en considération. Y aurait-il une solution meilleure marché? \n\nNous vous recommandons d’obtenir d’autres devis / un deuxième devis.\n\nLes frais de remise en état sont disproportionnellement élevés par rapport à la surface endommagée.\n\n Les frais de remise en état ne correspondent pas à la surface endommagée, respectivement la longueur du chemin endommagé.\n\nLes frais de remise en état estimés semblent élevés par rapport à la surface agricole perdue.  \n\nUne solution meilleure marché doit être trouvée.\n\n Une remise en état partielle serait-elle éventuellement judicieuse ?\n\nLe sinistré peut éventuellement être en mesure de participer aux travaux et de réduire ainsi les coûts de remise en état.","TSBegruendungsCode_BGN_22_kurz":"22 - Une partie du dommage est-elle couverte par des prestations d’assurance ?","TSBegruendungsCode_BGN_22_lang":"Veuillez clarifier, si au moins une partie du dommage est couverte par des prestations d’assurance.\n\nLe dommage doit être annoncé auprès de l’assurance grêle / l’assurance bâtiment / l’assurance mobilière / l’assurance privée. \n\nLe dommage est-il au moins en partie couvert par Suisse Grêle ?","TSBegruendungsCode_BGN_23_kurz":"23 - La remise en état est-elle subventionnable? / Participation de la commune ?","TSBegruendungsCode_BGN_23_lang":"Les travaux de remise en état peuvent-ils être subventionnés par la Confédération, le canton et/ou la commune ?\n\n\nVeuillez annoncer ce dommage au service des améliorations structurelles/foncières de votre canton. Les travaux de remise en état sont éventuellement subventionnables. \n\n La commune devrait à notre avis participer aux frais de remise en état. Veuillez nous tenir informé.","TSBegruendungsCode_BGN_30_kurz":"30 - En attente du décompte avec justificatifs une fois les travaux de remise en état effectués","TSBegruendungsCode_BGN_30_lang":"Les travaux de remise en état peuvent être entrepris. Le montant du dommage est déterminé sur la base des coûts effectifs (factures). (En règle générale, les prestations de fondssuisse se montent à 80% du dommage pouvant être porté en compte.) Les frais qui dépassent l’estimation ne peuvent être pris en considération que s’ils sont valablement justifiés.\n\nAfin de déterminer notre indemnité, nous avons besoin d’un décompte détaillé une fois les travaux de remise en état effectués : prestations propres, coûts externes, prestations préalables, y compris les copies des factures et des justificatifs de paiement correspondants.\n\nVeuillez saisir ces informations dans l’onglet \\Coûts\\ et y télécharger les documents nécessaires.\n\nSi les coûts restants sont pris en charge par plusieurs personnes concernées, veuillez également télécharger un document avec la répartition des coûts. Dans le cas d’un projet subventionné, les décisions et les décomptes de subventionnement sont également requis. Dans la mesure du possible et lorsque cela paraît judicieux, le sinistré doit procéder par ses propres moyens aux travaux de remise en état. Pour plus d’informations : www.fondssuisse.ch","TSBegruendungsCode_BGN_31_kurz":"31 - En attente du décompte avec justificatifs, y compris le décompte de l’assurance","TSBegruendungsCode_BGN_31_lang":"Afin de déterminer notre indemnité, nous avons besoin d’un décompte détaillé une fois les travaux de remise en état effectués : prestations propres, coûts externes (y compris les copies des factures et des justificatifs de paiement correspondants), prestations préalables (y compris les prestations et décomptes d’assurance). Veuillez saisir ces informations dans l’onglet  Coûts et y télécharger les documents nécessaires. \nSi les coûts restants sont pris en charge par plusieurs personnes concernées, veuillez également télécharger un document avec la répartition des coûts. Les travaux de remise en état doivent dans la mesure du possible et lorsque cela paraît judicieux être effectués par le sinistré et ses propres moyens. Pour plus d’informations : www.fondssuisse.ch","TSBegruendungsCode_BGN_32_kurz":"32 - Projet subventionné, en attente du décompte final avec justificatifs","TSBegruendungsCode_BGN_32_lang":"Projet subventionné. Afin de déterminer notre indemnité, nous avons besoin d’un décompte détaillé une fois les travaux de remise en état effectués : prestations propres, coûts externes, prestations préalables (subventions, y compris les décisions et les décomptes de subventionnement (Confédération, canton, commune) et les coûts restants à charge du sinistré. \nVeuillez saisir ces informations dans l’onglet  Coûts et y télécharger les documents nécessaires. Si les coûts restants sont pris en charge par plusieurs personnes concernées, veuillez également télécharger un document avec la répartition des coûts. Pour plus d’informations: www.fondssuisse.ch","TSBegruendungsCode_BGN_33_kurz":"33 - Estimation élevée - Une solution meilleure marché devrait être trouvée","TSBegruendungsCode_BGN_33_lang":"Les frais de remise en état estimés semblent élevés en comparaison avec la surface endommagée. Selon notre pratique (valeurs de référence), un montant maximum de CHF XXX.- de dégâts par are peut être pris en considération.\n\nUne fois les travaux de remise en état effectués, nous avons besoin d’un décompte détaillé afin de déterminer notre indemnité: prestations propres, coûts externes, prestations préalables, y compris les copies des factures et des justificatifs de paiement correspondants. Veuillez saisir ces informations dans l’onglet Coûts et y télécharger les documents nécessaires. \nSi les coûts restants sont pris en charge par plusieurs personnes concernées, veuillez également télécharger un document avec la répartition des coûts. Dans le cas d’un projet subventionné, les décisions et les décomptes de subventionnement sont également requis. Les travaux de remise en état doivent dans la mesure du possible et lorsque cela paraît judicieux être effectués par le sinistré et ses propres moyens. Pour plus d’informations: www.fondssuisse.ch\n\nNous ne pourrons probablement pas accepter la totalité des coûts. \n\nÀ notre avis, les frais de remise en état devraient être réduits d’au moins un tiers. \n\nUniquement une réparation simple par les propres moyens du sinistré peut être prise en considération.\n\nLes plus-values/améliorations par rapport à l’état antérieur (par ex. une nouvelle fondation en béton, un mur de soutènement, un nouveau drainage) ne peuvent pas être totalement pris en considération. \n\nLes améliorations par rapport à l’état antérieur et les mesures préventives ne sont pas prises en considération. \n\nPour les dégâts saisonniers aux murs de vigne (gel et dégel, vieillesse), un dommage de CHF 350.-/m2 au maximum est pris en considération, avec une indemnité de 70 %, soit CHF 245.-/m2, prestation du canton incluse. \nPour les dégâts naturels imprévisibles aux murs de vigne (intempéries, glissement de terrain), un dommage de CHF 500.-/m2 au maximum est pris en considération, avec une indemnité de 70 %, soit CHF 350.-/m2, prestation du canton incluse.\n\n Les coûts de remise en état estimés sont trop élevé. En comparaison avec la valeur de rendement des surfaces endommagées, une mesure coûteuse ne se justifie pas (art. 19, al. 4 et 9 des directives de fondssuisse). Un montant maximum de CHF 9'000.- de dégâts peut être pris en considération (avec une contribution de 60%, soit CHF 5'400.- au maximum). \n\nSur la base de la valeur de rendement des surfaces endommagées, un montant maximum de CHF 18’000.- de frais de remise en état sera pris en considération, avec une déduction de CHF 8'600.- en raison du revenu, soit un maximum de CHF 9 ‘400.- (avec une contribution de 60 %, soit CHF 5'640.- au maximum). \n\nEn raison de l'âge et de l'état de la clôture détruite, uniquement la moitié des coûts de remise en état peuvent être pris en considération. \n\n  Sur la base de la description du dommage et des devis transmis, nous pourrons accepter un montant maximum de CHF 24’000.-  de dégâts (avec une contribution de 70%, prestation du canton incluse, soit CHF 16’800.- au maximum).","TSBegruendungsCode_BGN_34_kurz":"34 - Benötigen Abrechnung – teilweise versicherbar","TSBegruendungsCode_BGN_34_lang":"","TSBegruendungsCode_BGN_40_kurz":"40 - Veuillez saisir les coûts et télécharger les documents requis (décompte manquant ou incomplet)","TSBegruendungsCode_BGN_40_lang":"Afin de déterminer notre indemnité, nous avons besoin du décompte des heures de travail/machine, des copies des factures d’entreprises et /ou des factures de matériel, ainsi que des justificatifs de paiement correspondants. Veuillez saisir ces informations dans l’onglet  Coûts et y télécharger les documents nécessaires. \nSi les coûts restants sont pris en charge par plusieurs personnes concernées, veuillez également télécharger un document avec la répartition des coûts. Dans le cas d’un projet subventionné, les décisions et les décomptes de subventionnement sont également requis. \nSans nouvelles de votre part dans les trois mois, le sinistré perdra son droit à une indemnité.","TSBegruendungsCode_BGN_41_kurz":"41 - En attente des factures et des justifcatifs de paiement correspondants","TSBegruendungsCode_BGN_41_lang":"Afin de déterminer notre indemnité, nous avons besoin des copies des factures d’entreprises et/ou des factures de matériel, ainsi que des justificatifs de paiement correspondants. Veuillez télécharger ces documents dans le portail des dommages.","TSBegruendungsCode_BGN_42_kurz":"42 - Coûts élevés / coûts plus élevés que l’estimation","TSBegruendungsCode_BGN_42_lang":"Les frais de remise en état sont élevés par rapport à la valeur de rendement de la surface endommagée.\n\nLes frais de remise en état effectifs sont considérablement plus élevés qu’annoncés dans l’estimation.\n\nVeuillez justifier l’augmentation des coûts. Sans justification, l’indemnité sera fixée sur la base de l’estimation.","TSBegruendungsCode_BGN_43_kurz":"43 - L’indemnité de ne peut pas être déterminée - précisions nécessaires","TSBegruendungsCode_BGN_43_lang":"L’indemnité ne peut pas être déterminée sur la base des informations/documents disponibles. \n\nVeuillez saisir les informations et télécharger les documents nécessaires dans le portail des dommages.","TSBegruendungsCode_BGN_60_kurz":"60 - Conditions de contribution non remplies","TSBegruendungsCode_BGN_60_lang":"le sinistré est non ayant droit.  Le dommage n’entre pas en considération.  \nL’avis de dommage ne peut pas être pris en considération. \nCertaines conditions de contribution ne sont pas remplies.","TSBegruendungsCode_BGN_61_kurz":"61 - Dommage assurable","TSBegruendungsCode_BGN_61_lang":"Il s’agit d’un dommage assurable (art. 11 al. 1 des directives de fondssuisse).","TSBegruendungsCode_BGN_62_kurz":"62 - Dommage insignifiant ou réparé par des tiers","TSBegruendungsCode_BGN_62_lang":"Le dommage est insignifiant (pas de travaux de remise en état effectués) ou a été réparé par des tiers.","TSBegruendungsCode_BGN_63_kurz":"63 - Non causé par un phénomène naturel ou causé par des tiers","TSBegruendungsCode_BGN_63_lang":"Le dommage n'a pas été causé par un phénomène naturel ou a été causé par des tiers.","TSBegruendungsCode_BGN_64_kurz":"64 - Couvert par d'autres contributions ou par des prestations d’assurance","TSBegruendungsCode_BGN_64_lang":"Le dommage est couvert par des prestations d’assurance, des subventions ou d’autres contributions.\n\nLe dommage est couvert par des prestations d’assurance de Suisse Grêle.\n\n\nLes franchises ne sont pas prises en considération et ne peuvent pas être comptabilisées (art. 11 al. 1 des directives de fondssuisse). \n\nLes frais de remise en état sont couvert à presque 90% par les prestations d’assurance contre la grêle et les contributions pour les améliorations structurelles/foncières (art. 19, al. 6 des directives de fondssuisse). Les coûts restants semblent supportables compte tenu du nombre de membres.\nLe dommage est couvert par : \n- des contributions pour les améliorations structurelles/foncières\n- l’assurance immobilière/bâtiment\n- des subventions de la Confédération, du canton et/ou de la commune.","TSBegruendungsCode_BGN_65_kurz":"65 - Dommage n’entrant pas en considération et autres exclusions (art. 12 et 13)","TSBegruendungsCode_BGN_65_lang":"Les dommages imputables à des mouvements du sol provoqués artificiellement, à des installations défectueuses, à un entretien déficient ou à d'autres actions directes ou indirectes de l'homme ne sont pas prises en considération (art. 12, al. 4 des directives de fondssuisse).\n\n Les dommage causés à des œuvres d'art en construction ne sont pas pris en considération (art. 13, al. 2 des directives de fondssuisse).\n\n\nLe dommage était prévisible et sa survenance aurait pu être évitée si des mesures appropriées avaient été prises à temps (manque de soins ou entretien déficient) (art.12, al.1 des directives de fondssuisse).\n\nLes dommages causés par des parasites animaux ou végétaux ne sont pas pris en considération (art. 12, al. 5 des directives de fondssuisse).\n\nLes dommages causés aux forêts par le poids de la neige, par la grêle ou par le feu ne sont pas pris en considération (art. 12, al. 7 des directives de fondssuisse).\n\n\n Les dommages causés à des arbres isolés en forêt ne sont pas pris en considération. \n\nLes dommages résultant de la sécheresse, d'un excès d'humidité (reflux d'eau dans des canalisations) ou du gel ne sont pas pris en considération (art 12., al. 6 des directives de fondssuisse).\n\nLa dépréciation générale d'un bien-fonds ainsi que les pertes de salaire et de revenu en rapport avec un phénomène naturel ne sont pas prises en considération (art. 13, al. 1 des directives de fondssuisse).","TSBegruendungsCode_BGN_66_kurz":"66 - Dommages se reproduisant à de brefs intervalles","TSBegruendungsCode_BGN_66_lang":"Les dommages qui se reproduisent à de brefs intervalles ne sont pas pris en considération (art. 12, al. 3 des directives de fondssuisse).","TSBegruendungsCode_BGN_67_kurz":"67 - Effets continus","TSBegruendungsCode_BGN_67_lang":"Les dommages qui ne sont pas dûs à des phénomènes d’une violence extraordinaire ou dûs à des effets continus ne sont pas pris en considération (art. 12, al.2 des directives de fondssuisse).","TSBegruendungsCode_BGN_68_kurz":"68 - Entraînement de gravier par les eaux sur des routes et des places","TSBegruendungsCode_BGN_68_lang":"L’entraînement de gravier par les eaux sur des routes et des places ne sont pas pris en considération (art. 13, al. 4 des directives de fondssuisse).","TSBegruendungsCode_BGN_69_kurz":"69 - Entretiens périodiques / mesures préventives","TSBegruendungsCode_BGN_69_lang":"Les entretiens périodiques et les mesures préventives ne sont pas prises en considération (art 13, al.6 des directives de fondssuisse).\n\nLes drainages en tant que mesure purement préventive et nouvelle installation ne peuvent pas être pris en considération (art. 13, al. 6 des directives de fondssuisse).","TSBegruendungsCode_BGN_70_kurz":"70 - Sinistré non ayant droit","TSBegruendungsCode_BGN_70_lang":"Le sinistré est non ayant droit (art. 7 des directives de fondssuisse).","TSBegruendungsCode_BGN_71_kurz":"71 - Déduction en raison du revenu et/ou de la fortune","TSBegruendungsCode_BGN_71_lang":"La déduction calculée en raison du revenu et/ou de la fortune dépasse le montant du dommage à porter en compte (art. 23 des directives de fondssuisse).","TSBegruendungsCode_BGN_72_kurz":"72 - Revenu et/ou fortune trop élevés","TSBegruendungsCode_BGN_72_lang":"Le sinistré n’a pas le droit à une indemnité en raison d’un revenu et/ou d’une fortune trop élevés (art. 23).","TSBegruendungsCode_BGN_73_kurz":"73 - Le dommage à porter en compte n’atteint pas le montant minimum","TSBegruendungsCode_BGN_73_lang":"Le dommage n’atteint pas le montant minimum de CHF 600.- et n’est ainsi pas pris en considération (art. 22 des directives de fondssuisse).\nrespectivement CHF 1000.- pour des coopératives et autres collectivités\nrespectivement CHF 300.- en dessus de 1000 mètres d’altitude","TSBegruendungsCode_BGN_80_kurz":"80 - Le dommage a été annoncé/saisi après l'échéance du délai","TSBegruendungsCode_BGN_80_lang":"Le dommage a été annoncé/saisi après l'échéance du délai de trois mois et ne peut plus être pris en considération (art. 16 des directives de fondssuisse).","TSBegruendungsCode_BGN_81_kurz":"81 - Remplacé par un autre avis de dommage.","TSBegruendungsCode_BGN_81_lang":"Cet avis de dommage est remplacé par un autre avis de dommage.\nCet avis de dommage est pris en considération avec le sinistre n°……","TSBegruendungsCode_BGN_82_kurz":"82 - Décompte/documents non-reçus","TSBegruendungsCode_BGN_82_lang":"Le décompte/ les documents n’ont pas été saisis/téléchargés dans le portail des dommages dans les délais.","TSBegruendungsCode_BGN_90_kurz":"90 - Indemnité réduite, dommage en partie assurable/couvert par des prestations d‘assurance","TSBegruendungsCode_BGN_90_lang":"Une partie du dommage est couverte par des prestations d'assurance.\nou\n\nL’indemnité est réduite car il s'agit d'un dommage en partie assurable.","TSBegruendungsCode_BGN_91_kurz":"91 - Indemnité réduite, déduction pour plus-value/entretien périodique/ mesure à titre purement préventif","TSBegruendungsCode_BGN_91_lang":"Une indemnité pour la remise en état par rapport à l’état antérieur est versée avec une déduction pour :\n- mesure à titre purement préventif\n- entretien périodique\n- amélioration\n- plus-value/valeur à neuf \n(environ XX%)\n\nou\n\nUne déduction de 20% est effectuée pour la plus-value/valeur à neuf.","TSBegruendungsCode_BGN_92_kurz":"92 - Une partie seulement des intéressés peut être prise en considération","TSBegruendungsCode_BGN_92_lang":"L’indemnité est réduite car seulement une partie des intéressés peut être prise en considération (non ayants droit: ….. avec une part de …% des coûts / Les propriétaires privés uniquement sont pris en considération avec une part de …. % des coûts).","TSBegruendungsCode_BGN_93_kurz":"93 - À titre exceptionnel et sans préjudice pour de futurs cas semblables","TSBegruendungsCode_BGN_93_lang":"Une indemnité est versée à titre exceptionnel et sans préjudice pour de futurs cas semblables.","TSBegruendungsCode_BGN_94_kurz":"94 - Décompte partiel, en attente d’un second avis de dommage","TSBegruendungsCode_BGN_94_lang":"Veuillez saisir un second avis de dommage pour les éventuels travaux et coûts supplémentaires engendrés pour ce sinistre (avec référence à ce n° de sinistre).","NAV_ENTSCHAEDIGUNG":"Indemnisation","BEITRAG_CREATE":"Ajouter une contribution","BEITRAG_ADD":"Ajouter une contribution","TSBeitragArt_FONDSSUISSE":"fondssuisse","TSBeitragArt_FONDSSUISSE_2023":"fondssuisse","TSBeitragArt_KANTON":"Canton","TSBeitragArt_HOCHGEBIRGE":"Haute montagne","TSBeitragArt_VERSICHERUNG":"Assurance","TSBeitragStatus_AUSGEFUEHRT":"Exécuté","TSBeitragStatus_PENDENT":"Pendant","TSBeitragStatus_NICHT_FREIGEGEBEN":"Non validé","BEITRAG_ART":"Type de contribution","BANKNAME":"Banque","BEITRAEGE":"Contributions","BEITRAG_LOESCHEN":"Voulez-vous supprimer cette contribution?","BEITRAG_LOESCHEN_BUTTON":"Supprimer la contribution","ERMITTELTER_SCHADEN":"Dommage calculé","ERMITTELTER_SCHADEN_SPEICHERN":"Enregistrer le dommage calculé","ERMITTELTER_SCHADEN_CHANGED_TEXT":"Comme les valeurs du dommage déterminés ont été actualisées, le montant de la contribution doit également être actualisé.","NICHT_BERECHTIGTER_ANTEIL":"Part non prise en compte [%]","ABRECHNUNGS_BETRAG":"Montant du décompte","TOTAL_SCHAETZUNG":"Total estimation","ABRECHNUNG":"Décompte","ABZUG_EINKOMMEN":"Déduction pour revenu / bénéfice","ABZUG_VERMOEGEN":"Déduction pour fortune / capital","ABZUG_ANTEIL":"Déduction de la part non prise en compte","ABZUG_VORLEISTUNG":"Déduction pour prestation préalable","ANRECHENBARER_SCHADEN":"Dommage pouvant être porté en compte","ENTSCHAEDIGEN":"Indemniser","CHECKLISTE":"Check-list","LEISTUNGSEMPFAENGER":"Bénéficiaire de prestations","GESCHAEDIGTER":"Sinistré","BETRAG_BESTIMMEN":"Définir le montant","CHECK_SCHADENBEHOBEN_ABR_1":"Le dommage a été remis en état (travaux effectués)?","CHECK_SCHADENBEHOBEN_ABR_2":"La remise en état correspond-elle à la déclaration? Travaux supplémentaires/en moins?","CHECK_SCHADENBEHOBEN_ABR_3":"Décompte complet? Plausible?","CHECK_SCHADENBEHOBEN_ABR_4":"Des contributions préalables ont-elles été versées (assurance, subventions, dons)?","PROZENTSATZ_BEITRAG":"{{prozentsatz}} %","LABEL_KEINE_ANGABE":"Pas de donnée","MIGRATION":"Migration","ERROR_PARSE":"introuvable","NO_RESULTS_FOUND":"pas de résultat trouvé","GEMEINDE":"Commune","KANTON":"Canton","ART_ANLAUFSTELLE":"Type de l'interlocuteur","TYPE":"Type","VEREINBARUNG_AKZEPTIERT":"Convention acceptée","NEUE_ANLAUFSTELLE":"Nouvel interlocuteur","NUR_LESEBERECHTIGT":"Seulement autorisé à lire","ANLAUFSTELLE_DEAKTIVIEREN":"Désactiver l'interlocuteur","VERSION_INFO":"Version : client {{frontendVersion}} / serveur: {{backendVersion}}","VERSION_INFO_SINGLE":"Version {{version}}","ANLAUFSTELLE_EDITIEREN":"Editer un interlocuteur","NAME_DER_ANLAUFSTELLE":"Nom de l'interlocuteur (p.ex. Commune de xyz)","NAME_ZUSATZ":"Complément","VERANTWORTLICHE_PERSON":"Personne responsable","GEMEINDE_HINZUFUEGEN":"Ajouter une commune","GEMEINDE_FUER_ANLAUFSTELLE":"Commune pour l'interlocuteur","VEREINBARUNG":"Convention","KANTONALER_BEITRAG":"Contribution cantonale","FS_UEBERPRUEFUNG_OK":"Le sinistre remplit tous les critères. Accepter et valider à l'attention du requérant pour la remise en état.","FS_UEBERPRUEFUNG_OK_PAPIER":"Le sinistre remplit tous les critères. Accepter et valider à l'attention de l'expert pour la remise en état.","FS_UEBERPRUEFUNG_MANGELHAFT":"Le sinistre est incomplet. Transférer à  l'expert pour complément avec message.","ABLEHNUNG":"Le sinistre ne remplit pas les conditions de contribution. Refuser et informer le requérant.","ANLAUFSTELLE_BASISPRUEFUNG_OK":"Les conditions de contribution sont remplies: transmettre à l'expert.","ANLAUFSTELLE_SCHAETZUNG_OK":"Les conditions de contribution sont remplies: transmettre à fondssuisse.","ZURUECK_AN_SCHAETZER":"Retourner à l’expert.","STICHENTSCHEID_ANGEFORDERT":"Les conditions de contribution ne sont pas remplies : transmettre à fondssuisse pour refus","STICHENTSCHEID_OK":"Le sinistre remplit les conditions de contribution","CHECK_IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS_1":"Vérifié","CHECK_AUFTRAG_SCHAETZER_1":"Le dommage a été constaté.","CHECK_AUFTRAG_SCHAETZER_2":"La description a été vérifiée/complétée.","CHECK_AUFTRAG_SCHAETZER_3":"L'estimation a été établie.","CHECK_AUFTRAG_SCHAETZER_4":"Le dommage est-il subventionné?","CHECK_UEBERPRUEFUNG_FS_1":"Requérant ayant droit? (Directives art. 6/7) Propriétaire/fermier?","CHECK_UEBERPRUEFUNG_FS_2":"Situation financière? (art. 23)","CHECK_UEBERPRUEFUNG_FS_3":"Périmètre/personne concernée?","CHECK_UEBERPRUEFUNG_FS_4":"Sinistre (cause/objet) (art. 9/10) entrant en consideration ?","CHECK_UEBERPRUEFUNG_FS_5":"Dommage assurable? (art. 11)","CHECK_UEBERPRUEFUNG_FS_6":"Dommage n'entrant pas en considération? (art. 12) Autres exclusions? (art. 13)","CHECK_UEBERPRUEFUNG_FS_7":"Autres possibilités de contribution?","CHECK_UEBERPRUEFUNG_FS_8":"Documentation du dommage compréhensible?","CHECK_UEBERPRUEFUNG_FS_9":"Données manquantes?","CHECK_UEBERPRUEFUNG_FS_10":"Dimension du dommage, mesures proposées, estimation plausible?","CHECK_UEBERPRUEFUNG_FS_11":"Points ouverts, questions?","CHECK_UEBERPRUEFUNG_FS_12":"Soutien oui/non?","CHECK_UEBERPRUEFUNG_FS_13":"Restrictions, plafond de coûts? Remarques?","CHECK_BEARBEITUNG_AS_1":"Les données personnelles du requérant ont été contrôlées (identifié).","CHECK_BEARBEITUNG_AS_2":"Le revenu et la fortune pour l'année fiscale (au domicile) ont été contrôlés.","CHECK_BEARBEITUNG_AS_3":"Le terrain (lieu du dommage) se trouve dans la commune.","CHECK_BEARBEITUNG_AS_4":"Un expert a-t-il été attribué?","CHECK_UEBERPRUEFUNG_AS_1":"Les données de la personne concernée sont complètes.","CHECK_UEBERPRUEFUNG_AS_2":"Les données du dommage sont complètes/correctes.","CHECK_UEBERPRUEFUNG_AS_3":"Le requérant est le sinistré (rapport de propriété).","CHECK_UEBERPRUEFUNG_AS_4":"Y a-t-il d'autres possibilités de soutien (subventions, contributions, dons)?","CHECK_UEBERPRUEFUNG_AS_STICHENTSCHEID_FS_1":"Vérifié","CHECK_UEBERPRUEFUNG_SCHAETZER_1":"Le dommage a-t-il été remis en état (travaux effectués)?","CHECK_UEBERPRUEFUNG_SCHAETZER_2":"La remise en état correspond-elle à la déclaration? Travaux supplémentaires/en moins?","CHECK_UEBERPRUEFUNG_SCHAETZER_3":"Décompte complet? Plausible?","CHECK_UEBERPRUEFUNG_SCHAETZER_4":"Contributions préalables? Dons? (tout déclaré?)","CHECK_UEBERPRUEFUNG_SCHAETZER_5":"Corrections, commentaires?","CHECK_WIEDERHERSTELLUG_1":"Rétablissement de l'état antérieur","CHECK_WIEDERHERSTELLUG_2":"Si possible avec ses propres moyens, de manière aussi avantageuse que possible.","CHECK_WIEDERHERSTELLUG_3":"Rapporter prestations propres","CHECK_WIEDERHERSTELLUG_4":"Prestations externes, payer les factures, saisir les justificatifs de paiement","CHECK_WIEDERHERSTELLUG_5":"Travaux terminés?","CHECK_AUSZAHLUNG_1":"Textes de motivation/commentaires lus","CHECK_AUSZAHLUNG_2":"Adresse/compte de paiement contrôlé (disponible)","CHECK_AUSZAHLUNG_3":"Compte de paiement? Liquidités disponibles?","WIEDERHERSTELLUNG_AUSGEFUEHRT":"Tous les travaux de remise en état sont terminés, les coûts ont été saisis et vérifiés. Transmettre à l'expert pour vérification.","VEREINBARUNG_HOCHLADEN":"Télécharger la convention","APPLICATION_PROPERTIES":"Application Properties","SERF_PROPERTIES":"fondssuisse properties","TESTDATEN":"Données test","DEUTSCH":"Allemand","FRANZOESISCH":"Français","ITALIENISCH":"Italien","WIEDERHERSTELLUNG_GEPRUEFT":"Tous les travaux de remise en état sont terminés, les coûts sont saisis et vérifiés. Transmettre à fondssuisse pour examen.","WIEDERHERSTELLUNG_GEPRUEFT_PAPIER":"Tous les travaux de remise en état sont terminés, les coûts ont été saisis et vérifiés. Transmettre à fondssuisse pour examen.","WIEDERHERSTELLUNG_MANGELHAFT":"A retourner au demandeur en le priant de compléter.","ALLES_KONTOLLIERT":"Tous les points susmentionnés ont été contrôlés.","ABTEILUNG":"Division","ABRECHNUNG_OK":"Décompte OK","ABRECHNUNG_MANGELHAFT":"Décompte lacunaire","TSSchadenArt_ERDRUTSCH":"Glissement de terrain","TSSchadenArt_UEBERSCHWEMMUNG":"Inondation","TSSchadenArt_UEBERFUEHRUNG":"Epandage d'alluvions","TSSchadenArt_RUEFE":"Affaissement de terrain","TSSchadenArt_LAWINE":"Avalanche","TSSchadenArt_SCHNEEDRUCK":"Pression de la neige","TSSchadenArt_STURMWIND":"Bourrasques de vent","TSSchadenArt_FELSSTURZ":"Chutes de rocher","TSSchadenArt_STEINSCHLAG":"Eboulement","TSSchadenArt_TROCKENHEIT":"Sécheresse","TSSchadenArt_ANDERE":"Autres","ART_DES_SCHADENDS_ANDERE":"Type du dommage texte libre","GEMEINDEN":"Communes","VEREINBARUNG_STEPTS_TITLE":"Prochaine étape pour activer votre interlocuteur:","VEREIBARUNG_STEP1":"1ère étape","VEREIBARUNG_STEP1_TEXT":"Télécharger le document \"Authentification de l'interlocuteur\" (<a href='https://fondssuisse.cmsbox.ch/download/pictures/2a/562x9q1sbos4tugwp71ig195upxlc5/authentification_en_tant_quinterlocuteur.pdf'>pdf</a>) et imprimer.","VEREIBARUNG_STEP2":"2e étape","VEREIBARUNG_STEP2_TEXT":"Signer la convention et la renvoyer à fondssuisse par courrier.","VEREIBARUNG_STEP3":"3e étape","VEREIBARUNG_STEP3_TEXT":"Administrer l'utilisateur.","VEREINBARUNG_ABGELAUFEN_WARNUNG":"Les interlocuteurs marqués en rouge ne sont actuellement pas valables. Veuillez télécharger la convention (<a href='https://www.fondssuisse.ch/download/pictures/d5/5wkylpa9ai7j97tofa91wufswklvh8/authentifizierung_anlaufstelle.pdf'> 1pdf</a> 2) et la renvoyer signée à fondssuisse.","NICHT_FREIGEGEBEN":"Contributions non validées","PENDENT":"Contributions pendantes","AUSGEFUEHRT":"Versements effectués","BEITRAG":"Contribution","EMPFAENGER":"Destinataire","FREIGEBEN_DIALOG":"Voulez-vous vraiment valider les contributions choisies {{anzahl | number : 0}}?","AUSFUEHREN_DIALOG":"Voulez-vous vraiment exécuter les contributions choisies {{anzahl | number : 0}}?","REF_BUCHHALTUNG":"Ref# comptabilité","DATUM_FAELLIG":"Echéance","LINK_ANLAUFSTELLE":"Sélectionner un interlocuteur","ANLAUFSTELLE_WECHSELN":"Changer l'interlocuteur","BENUTZER_ERSTELLT":"Utilisateur créé","ANZ_EMPFAENGER":"Nbre de destinataires","ZAHLUNGEN_AUSGEFUEHRT":"Paiements effectués","ISO_DATEI":"Fichier ISO","BEITRAEGELISTE":"Liste des contributions","DOWNLOAD_ISO":"Télécharger le fichier ISO","DOWNLOAD_BEITRAEGE":"Télécharger la liste contributions","NAV_BEMERKUNG":"Remarques","MELDUNGEN_DURCH_SYSTEM":"Généré par le système","STATUS_MELDUNGEN":"Généré par la transition de statut","INTERNE_BEMERKUNG":"Remarque interne","BEITRAG_EFFEKTIV":"Contribution effective","ERSTELLT_VON":"Créé par","ERSTELLT_AM":"Créé le","BERECHNUNG_BETRAG":"Calcul montant","SYSTEM_KONFIGURATION":"Configuration du système","KONFIGURATION":"Configuration","FS_SACHBEARBEITER_ZUTEILEN":"Administrer un collaborateur spécialisé fondssuisse","FS_ADMIN_ZUTEILEN":"Administrer les administrateurs fondssuisse","FS_BETROFFENE_ROLLE_ENTFERNEN":"Fondsuisse Betroffene Rolle entfernen","FS_ROLLE_ENTFERNEN":"Rolle entfernen","BETROFFENE_ROLLE_ENTFERNT":"Die Betroffene Rolle konnte erfolgreich entfernt werden.","EMAIL_UNGUELTIG":"E-Mail Adresse ist ungültig","BITTE_EMAIL":"Bitte eine gültige E-Mail Adresse angeben.","CONFIRM_ROLE_REMOVAL":"Voulez-vous vraiment remettre le rôle admin? Vous ne pourrez alors plus utiliser la configuration.","SENDABLEHNUNGMAIL":"send mail de refus","SENDSCHADENFALLFREIGEGEBENMESSAGE":"send message sinistre validé","SENDBETROFFENEWIEDERHERSTELLUNGBEWILLIGTMAIL":"send mail personne concernée remise en état autorisée","SENDAUSZAHLUNGSMAIL":"send mail paiement","SENDSCHADENFALLFREIGEGEBENFORANLAUFSTELLEMESSAGE":"send message sinistre validé for interlocuteur","SENDSCHAETZERABRECHNUNGMANGELHAFTMAIL":"send mail expert décompte lacunaire","SENDSCHAETZERAUFWAENDEREADYFORVERIFICATIONMAIL":"send mail expert dépenses ready for verification","SENDSCHAETZERWIEDERHERSTELLUNGBEWILLIGTMAIL":"send mail expert remise en état autorisée","SENDUEBERPRUEFUNGMANGELHAFTMAIL":"send mail données contrôle en état lacunaires","SENDWIEDERHERSTELLUNGANGABENMANGELHAFTMAIL":"send mail données remise en état lacunaires","SENDSCHAETZERZUGEWIESENMAIL":"send mail expert attribué","SENDSCHADENFALLUEBERPRUEFUNGFSFORINSPEKTORATMESSAGE":"send sinistre vérification office cantonal FS","SENDSCHADENFALLSCHADENBEHOBENFORINSPEKTORATMESSAGE":"send sinistre dommages réparés inspectorat","TESTMAIL":"Tests mail","NEUES_INSPEKTORAT":"Nouvel office cantonal","INSPEKTORAT_EDITIEREN":"Editer l'office cantonal","INSPEKTORAT_DEAKTIVIEREN":"Désactiver l'office cantonal","NAME_DES_INSPEKTORAT":"Nom de l'office cantonal","ANLAUFSTELLE_HINZUFUEGEN":"Ajouter interlocuteur","INSPEKTOREN_ZUTEILEN":"Attribuer des experts","ANLAUFSTELLEN_FUER_INSPEKTORAT":"Interlocuteurs pour l'office cantonal","INSPEKTORAT_ADD":"Ajouter l'office cantonal","INSPEKTORAT":"Office cantonal","MENU_INSPEKTORAT":"Office cantonal","MENU_VERSICHERUNGSBEITRAEGE":"Contributions d'assurance","SUBVENTIONIERT_DURCH":"Les frais de remise en état peuvent-ils être subventionnés par la Confédération, le canton et/ou la commune ?","OFFERTE":"Une offre a été demandée / établie.","ARBEITEN":"Des travaux ont déjà été initiés / réalisés.","BEENDEN_SPEICHERN":"Sauvegarder","NOCH_NICHT_GESCHAETZT":"pas encore estimé","GESUCH_SPEICHERN":"Enregistrer le sinistre","UNSAVED_WARNING":"Attention: vous avez encore des modifications non enregistrées qui seront perdues si vous quittez la page.","VORHERIGER_WERT":"Valeur initiale saisie","UNSAVED_WARNING_RELOAD":"Attention: vous avez encore des modifications non enregistrées qui seront perdues si vous téléchargez à nouveau la page.","STUNDEN_HINZUFUEGEN":"Ajouter des heures","TSKulturart_WIESEWEIDE":"Champs / prairies","TSKulturart_ACKERLAND":"Terres arables","TSKulturart_ANDERE":"Autres","VERSICHERUNGSBEITRAEGE":"Contributions d'assurance","VERSICHERUNGSBEITRAG_CREATE":"Ajouter une contribution d'assurance","VERSICHERUNGSBEITRAG_ERFASSEN":"Saisir une contribution d'assurance","VERS_BEITR_EXT_SCHADENNR":"Numéro de dommage ext.","VERSICHERUNG":"Assurance","VERSICHERUNG_ART":"Type d'assurance","SCHADENDATUM":"Date du dommage","NAV_VERSICHERUNG_ERFASSEN":"Dommage","NAV_VERSICHERUNG_BEITRAG":"Contribution","NAV_VERSICHERUNG_VERSICHERTER":"Assuré","EXTERNAL_SCHADEN_NR":"Numéro dommage ext.","POLICE_NUMMER":"Numéro police","SCHADEN_GEMEINDE":"Dommage commune","PROZENTSATZ":"Pourcentage","WIEDERHERSTELLUNGSKOSTEN":"Frais de remise en état","ERMITTELTERSCHADEN":"Dommage calculé","BEITRAG_BERECHTIGT":"Contribution autorisée","BEITRAG_HINZUFUEGEN":"Ajouter contribution","VERSICHERUNGSBEITRAG_KOSTEN":"Frais","VERSICHERUNGSBEITRAG_SCHADENABRECHNUNG":"Décompte du dommage","RECHTSFORM":"Forme juridique","GESUCHSTELLER_TITLE":"Données concernant {{eigentumsverhaeltnis}}","RECHTSFORM_TITLE":"Forme juridique","VERSICHERUNGSBEITRAG_FALL_ERSTELLEN":"Ajouter test contribution d'assurance","BITTE_HOCHLADEN":"Veuillez télécharger les documents suivants","REQUIRED":"requis","OPTIONAL":"facultatif","MITGLIEDERVERZEICHNIS":"Liste des membres","JAHRESRECHNUNG":"Comptes annuels","IMPORTIERTE":"Importé","PACHTVERTRAG":"Contrat de bail à ferme","KONTO_INHABER":"Bénéficiaire","KONTO_INHABER_PLZ":"NPA","KONTO_INHABER_ORT":"Localité","VON":"de","BIS":"à","FREIGABE_PAPIER_FS_6":"Validation de la demande (papier) après la vérification par fondssuisse","FREIGABE_PAPIER_FS_9":"Validation de la demande (papier) après \"Remise en état effectuée, prêt pour le décompte\"","BENUTZER_CREATED_SUCCESS":"Le compte d'utilisateur a été créé et vérifié. Vous pouvez désormais vous connectez.","INIVTATION_EMAIL":"E-mail de la personne à ajouter","ZUSTIMMUNG_STEUERPRUEFUNG_GENOSSENSCHAFT":"Nous autorisons la commune à contrôler les éléments imposables, et si nécessaire à les compléter et à les enregistrer dans le portail des dommages.","JAHR":"Année","STEUERFAKTOREN":"Nom et éléments imposables de toutes les personnes concernées","FILTER_ZURUECKSETZEN":"Réinitialiser le filtre","TS_REPORTYPE_AUSZAHLUNG":"Statistique concernant les versements","TS_REPORTYPE_SCHADEN":"Statistique concerant les dommages","TS_REPORTYPE_ALLE":"Toutes les données concernant le sinistre","TS_REPORTYPE_AUSZAHLUNG_KANTON":"Statistique concernant les versements","DATUM_AUSZAHLUNG_VON":"Date du paiement du","DATUM_AUSZAHLUNG_BIS":"Date de paiement jusqu'au","DATUM_GESUCH_VON":"Date de la demande du","DATUM_GESUCH_BIS":"Date de la demande jusqu'au","DATUM_EREIGNIS_VON":"Date de survenance du dommage du","DATUM_EREIGNIS_BIS":"Date de survenance du dommage jusqu'au","DATUM_AUSZAHLUNG_PARAM":"Date du versement: ","DATUM_GESUCH_PARAM":"Date de la demande: ","DATUM_EREIGNIS_PARAM":"Date de la survenance du dommage: ","LOGIN_NO_ACCOUNT_YET":"Pas encore de compte d'utilisateur pour personnes concernées ?","LOGIN_GEMEINDE":"Pour les communes, merci de vous inscrire en cliquant ici : ","IMPORTIERT_VERSICHERUNG":"Cas d'assurance importé ","IMPORTIERT_FONDSSUISSE":"Cas importé ","DECKBLATT":"PDF","ADRESSE_1":"Adresse 1","ADRESSE_2":"Adresse 2","ADRESSE_3":"Adresse 3","NUR_EIN_SCHADEN":"Un seul dommage peut être saisi","SCHADENFALL_LOESCHEN":"Supprimer le sinistre","SCHADENFALL_LOESCHEN_TEXT":"Voulez-vous supprimer définitivement le sinistre ?","SCHADENFALL_BEENDEN_SPEICHERN_TEXT":"Attention! La demande sera enregistrée, mais ne sera pas transmise et soumise. Pour ce faire, veuillez cliquer sur « Transmettre la demande ».","SCHADENFALL_BEENDEN_SPEICHERN_TITLE":"Enregistrer le sinistre?","ABZUG_EV":"Déduction en raison du revenu/fortune","FONDSSUISSE_DOKUMENTE":"Documents de fondssuisse","SCHADENFALL_PDF":"Sinistre PDF","DOWNLOAD_DECKBLATT":"Télécharger le PDF","NUR_FONDSSUISSE":"Les documents téléchargés ici peuvent être consultés uniquement par fondssuisse","MANUELL_ERFASSTE_MELDUNG":"Généré manuellement","BENUTZER_ROLLEN_LOESCHEN":"Supprimer les rôles attribués à l'utilisateur","BETROFFENE_ROLLE":"Rôle de la personne concernée","STATISTIK":"Statistique","BatchJobStatus_REQUESTED":"Statistique demandée","BatchJobStatus_RUNNING":"La statistique est en train d'être générée","BatchJobStatus_FINISHED":"Prêt à télécharger","BatchJobStatus_FAILED":"N'a pas été finalisé avec succès","STARTED_GENERATION":"Le rapport est en train d'être généré","ERROR_DATE_BEFORE_TO":"ERREUR: la date \"jusqu'au\" est antérieure à la date \"du\"","ERSTELLT":"Généré","BEENDET":"Terminé","TYP":"Type","PARAMETER":"Paramètre","GESTARTET":"Activé","GENERIEREN":"Générer","PDF_GENERIEREN":"Générer le PDF","ReportType_beitragReport":"Rapport de contribution","DEV_FUNCTIONS":"Afficher les fonctions des développeurs de logiciels","RECREATE_ZAHLUNGSAUFTR_EXCEL_REPORT":"Générer l'ordre de paiement Excel","DOKUMENT_DOWNLOAD":" Télécharger le document","ZH":"Zürich","BE":"Berne","LU":"Lucerne","UR":"Uri","SZ":"Schwyz","OW":"Obwald","NW":"Nidwald","GL":"Glaris","ZG":"Zoug","FR":"Fribourg","SO":"Soleure","BS":"Bâle-Ville","BL":"Bâle-Campagne","SH":"Schaffouse","AR":"Appenzell Rhodes-Intérieures","AI":"Appenzell Rhodes-Extérieures","SG":"Saint-Gall","GR":"Grisons","AG":"Argovie","TG":"Thurgovie","TI":"Tessin","VD":"Vaud","VS":"Valais","NE":"Neuchâtel","GE":"Genève","JU":"Jura","KOSTEN_GESCH":"Coûts estimés","SICHTBARKEIT":"Visibilité","INTERN":"interne","FONDSSUISSE":"fondssuisse","SHOW_JOBS":"Montre tous batchjobs","ANZAHL_KUBIKMETER":"Nb de m3","BETRAG_HOLZ_CHF":"Montant pour le bois en CHF","KUBIKMETER":"Mètres cubes","KUBIKMETER_ERFASSEN":"Saisir les mètres cubes","KUBIKMETER_HINZUFUEGEN":"Calculer le montant pour les m3","LITER":"Litres","LITER_ERFASSEN":"Saisir les litres","BETRAG_TREIBSTOFF_CHF":"Montant pour le carburant en CHF","STATUS_AKTUALISIEREN":"Actualiser le statut","STATUS_AKTUALISIEREN_TEXT":"Vous vous apprêtez à modifier manuellement le statut de ce sinistre.","MENU_COCKPIT":"Cockpit","ZEITBEREICH":"Sélectionner une période","TSCockpitSelect_":"Sélectionner une période","TSCockpitSelect_LETZER_MONAT":"Mois dernier","TSCockpitSelect_DATUM_BEREICH":"Période","DATUM_VON":"Date du","DATUM_BIS":"Jusqu‘au","ANWENDEN":"Appliquer","COCKPIT_STATUS_TITLE":"Statuts des sinistres","COCKPIT_KANTON_TITLE":"Avis de dommages par canton","COCKPIT_ERFASSUNGSART_TITLE":"Demande selon le type de saisie","COCKPIT_SCHADENART_TITLE":"Types de dommages","COCKPIT_GESCHAETZTE_KOSTEN_TITLE":"Coûts estimés en CHF","COCKPIT_ANZAHL_GESUCHE":"Nombre de demandes","COCKPIT_ANZAHL_NEUE_GESUCHE":"Nombre de nouvelles demandes","short_DEUTSCH":"DE","short_FRANZOESISCH":"FR","short_ITALIENISCH":"IT","AUFAWENDE_DOC_BEGLEITTEXT":"Pour la remise en état, merci de télécharger vos documents et photos ici.","TITLE_DUPLICATED_HANDARBEITER":"Personne dupliquée","DUPLICATED_HANDARBEITER_MESSAGE":"Veuillez utiliser l'entrée de prestation propre saisie précédemment au sujet de cette personne.","EIGENLEISTUNG_DESCRIPTION":"Description de la prestation / de l'appareil","STUNDENANSATZ":"Taux horaire","ANZAHL_STUNDEN_":"Nombre d'heures","BANKKONTO_EDITIEREN":"Éditer les coordonnées bancaires","BEITRAG_SCHON_ERFASST":"Attention, la contribution a déjà été saisie, elle doit être regénérée"}

/***/ }),

/***/ "n4cP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "nHss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "nKms":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSGemeinde = /** @class */ (function (_super) {
    __extends(TSGemeinde, _super);
    function TSGemeinde() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSGemeinde.prototype, "kanton", {
        get: function () {
            return this._kanton;
        },
        set: function (value) {
            this._kanton = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGemeinde.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    TSGemeinde.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.name = restObject.name;
        this.kanton = restObject.kanton;
        return this;
    };
    TSGemeinde.deserializeArray = function (data) {
        var anlaufstelleArray = [];
        if (data && Array.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                anlaufstelleArray[i] = new TSGemeinde().deserialize(data[i]);
            }
        }
        else {
            anlaufstelleArray[0] = new TSGemeinde().deserialize(data);
        }
        return anlaufstelleArray;
    };
    TSGemeinde.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.name = this.name;
        return restObject;
    };
    TSGemeinde.getDeserializer = function (gemeinde) {
        return new TSGemeinde().deserialize(gemeinde);
    };
    return TSGemeinde;
}(TSAbstractEntity_1.default));
exports.default = TSGemeinde;


/***/ }),

/***/ "nNMk":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("W+go");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-versicherung-navigation.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-versicherung-navigation.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "nQtD":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".dv-benutzer-list.table-responsive tr.header-row th.row-nachname,.dv-benutzer-list.table-responsive tr.header-row th.row-vorname{width:14%}.dv-benutzer-list.table-responsive tr.header-row th.row-benutzerrolle{width:17%}.dv-benutzer-list.table-responsive tr.header-row th.row-email{width:18%}.dv-benutzer-list.table-responsive tr.header-row th.row-telefon{width:10%}.dv-benutzer-list.table-responsive tr.header-row th.row-status{width:7%}.dv-benutzer-list.table-responsive tr.header-row th.row-sprache{width:5%}.dv-benutzer-list.table-responsive tr.header-row th.row-action{width:4%}", ""]);

// exports


/***/ }),

/***/ "ncnt":
/***/ (function(module, exports) {

module.exports = "<div> <div class=\"modal-header\"> <h3 class=\"modal-title\" ng-bind-html=\"vm.title\"></h3> </div> <div class=\"modal-body\"> {{ vm.text }} </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok()\">OK</button> </div> </div> ";

/***/ }),

/***/ "nhQo":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("hx2R");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-bar-charts.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-bar-charts.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "nhwJ":
/***/ (function(module, exports) {

module.exports = "<div class=\"schadenfaelle-list-view\"> <div dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getGesuchstellerOnlyRoles()\" class=\"schadenfaelle-list-view__betroffene\"> <h2 data-translate=\"MEINE_SCHADENFAELLE\"></h2> <dv-schadenfaelle-list on-filter-change=\"vm.passFilterToServer(tableState, prefilter)\" on-edit=\"vm.editFall(schadenfall, event)\" on-deckblatt=\"vm.downloadDeckblatt(schadenfall, event)\" on-delete=\"vm.deleteSchadenfall(schadenfallId, event)\" prefilter=\"vm.emptyFilter\" tabindex=\"0\" selectedtab=\"0\" show-verantwortlicher-filter=\"false\"> </dv-schadenfaelle-list> </div> <div dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getAllRolesButGesuchsteller()\"> <uib-tabset active=\"active\" class=\"schadenfaelletabs\"> <uib-tab index=\"$index\" ng-repeat=\"tab in vm.tabs\" heading=\"{{tab.title | translate}}\" select=\"vm.selectTab($index)\"> <dv-schadenfaelle-list on-filter-change=\"vm.passFilterToServer(tableState, prefilter)\" on-edit=\"vm.editFall(schadenfall, event)\" on-delete=\"vm.deleteSchadenfall(schadenfallId, event)\" on-deckblatt=\"vm.downloadDeckblatt(schadenfall, event)\" prefilter=\"vm.selectedPrefilter\" tabindex=\"{{$index}}\" selectedtab=\"vm.selectedTab\" verantwortliche=\"vm.verantwortliche\" on-verantwortlicher-change=\"vm.updateVerantwortlicher(schadenfallId, verantwortlicher)\" show-verantwortlicher-filter=\"tab.showVerantwortlicherFilter\" change-verantwortlicher-enabled=\"tab.changeVerantwortlicherEnabled\"> </dv-schadenfaelle-list> </uib-tab> </uib-tabset> </div> </div> ";

/***/ }),

/***/ "njUM":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "nqh5":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("0MNX");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-betrag.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-betrag.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "nu1j":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("u72Z");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-gesuch-navigation.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-gesuch-navigation.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "o20y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSStatuswechsel = /** @class */ (function () {
    function TSStatuswechsel(status, begruendungscodeOptions, checklistOptions, possibleEvents, allowedRoles, visibleOnPage, allowedErfassungsArt) {
        this._status = status;
        this._begruendungscodeOptions = begruendungscodeOptions;
        this._checklistOptions = checklistOptions;
        this._possibleEvents = possibleEvents;
        this._allowedRoles = allowedRoles;
        this._visibleOnPage = visibleOnPage;
        this._allowedErfassungsArt = allowedErfassungsArt;
    }
    Object.defineProperty(TSStatuswechsel.prototype, "status", {
        get: function () {
            return this._status;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSStatuswechsel.prototype, "checklistOptions", {
        get: function () {
            return this._checklistOptions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSStatuswechsel.prototype, "possibleEvents", {
        get: function () {
            return this._possibleEvents;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSStatuswechsel.prototype, "allowedRoles", {
        get: function () {
            return this._allowedRoles;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSStatuswechsel.prototype, "visibleOnPage", {
        get: function () {
            return this._visibleOnPage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSStatuswechsel.prototype, "allowedErfassungsArt", {
        get: function () {
            return this._allowedErfassungsArt;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSStatuswechsel.prototype, "begruendungscodeOptions", {
        get: function () {
            return this._begruendungscodeOptions;
        },
        enumerable: true,
        configurable: true
    });
    TSStatuswechsel.prototype.readBegruendungscodeOptions = function (event) {
        var allowedBegruendungscodes = this._begruendungscodeOptions.get(event);
        return allowedBegruendungscodes || [];
    };
    return TSStatuswechsel;
}());
exports.default = TSStatuswechsel;


/***/ }),

/***/ "o8Fj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSRechtsform_1 = __webpack_require__("EUJE");
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSFinanzangaben_1 = __importDefault(__webpack_require__("dI/G"));
var TSGenossenschaft_1 = __importDefault(__webpack_require__("WbgF"));
var TSGesuchsPerson_1 = __importDefault(__webpack_require__("WFK3"));
var TSKoerperschaft_1 = __importDefault(__webpack_require__("c9dM"));
var TSGesuchsteller = /** @class */ (function (_super) {
    __extends(TSGesuchsteller, _super);
    function TSGesuchsteller(isZweitperson) {
        if (isZweitperson === void 0) { isZweitperson = false; }
        var _this = _super.call(this) || this;
        _this._documentIdsToConnect = [];
        if (isZweitperson) {
            _this.isZweitperson = true;
        }
        else {
            _this.finanzangaben = new TSFinanzangaben_1.default(); // zweitperson hat keine finanzangaben
            _this.isZweitperson = false;
        }
        return _this;
    }
    Object.defineProperty(TSGesuchsteller.prototype, "eigentumsverhaeltnis", {
        get: function () {
            return this._eigentumsverhaeltnis;
        },
        set: function (value) {
            this._eigentumsverhaeltnis = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGesuchsteller.prototype, "rechtsform", {
        get: function () {
            return this._rechtsform;
        },
        set: function (value) {
            this._rechtsform = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGesuchsteller.prototype, "kontaktperson", {
        get: function () {
            return this._kontaktperson;
        },
        set: function (value) {
            this._kontaktperson = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGesuchsteller.prototype, "finanzangaben", {
        get: function () {
            return this._finanzangaben;
        },
        set: function (value) {
            this._finanzangaben = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGesuchsteller.prototype, "genossenschaft", {
        get: function () {
            return this._genossenschaft;
        },
        set: function (value) {
            this._genossenschaft = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGesuchsteller.prototype, "koerperschaft", {
        get: function () {
            return this._koerperschaft;
        },
        set: function (value) {
            this._koerperschaft = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGesuchsteller.prototype, "isZweitperson", {
        get: function () {
            return this._isZweitperson;
        },
        set: function (value) {
            this._isZweitperson = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGesuchsteller.prototype, "documentIdsToConnect", {
        get: function () {
            return this._documentIdsToConnect;
        },
        set: function (value) {
            this._documentIdsToConnect = value;
        },
        enumerable: true,
        configurable: true
    });
    TSGesuchsteller.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.eigentumsverhaeltnis = restObject.eigentumsverhaeltnis;
        this.rechtsform = restObject.rechtsform;
        this.kontaktperson = this.deserializeOrCreate(restObject.kontaktperson, new TSGesuchsPerson_1.default());
        this.finanzangaben = this.deserializeOrCreate(restObject.finanzangaben, new TSFinanzangaben_1.default());
        this.genossenschaft = this.deserializeOrNull(restObject.genossenschaft, new TSGenossenschaft_1.default);
        this.koerperschaft = this.deserializeOrNull(restObject.koerperschaft, new TSKoerperschaft_1.default());
        return this;
    };
    TSGesuchsteller.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        this.cleanup(); // wird gebraucht, wenn ein Fall vom Server wieder zum Server geschickt wird
        restObject.eigentumsverhaeltnis = this.eigentumsverhaeltnis;
        restObject.rechtsform = this.rechtsform;
        restObject.kontaktperson = this.serializeOrInit(this.kontaktperson, restObject.kontaktperson);
        restObject.finanzangaben = this.serializeOrInit(this.finanzangaben, restObject.finanzangaben);
        restObject.genossenschaft = this.serializeOrInit(this.genossenschaft, restObject.genossenschaft);
        restObject.koerperschaft = this.serializeOrInit(this.koerperschaft, restObject.koerperschaft);
        if (this.isZweitperson) {
            restObject.finanzangaben = undefined;
        }
        return restObject;
    };
    TSGesuchsteller.prototype.MRound = function (number, roundto) {
        return roundto * Math.round(number / roundto);
    };
    TSGesuchsteller.prototype.getEinkommensabzug = function () {
        if (this.hasFinanzangaben() &&
            this.finanzangaben.finanzangabenDatenFS.einkommenGewinn) {
            // Kein Abzub bis 100'000.- steuerbares Einkommen
            if (this.finanzangaben.finanzangabenDatenFS.einkommenGewinn < 100000) {
                return 0;
            }
            else {
                // 20% des 100'000 übersteigenden Betrages (runden auf 200)
                return this.MRound(((this.finanzangaben.finanzangabenDatenFS.einkommenGewinn - 100000) * 0.2), 200);
            }
        }
        return 0;
    };
    TSGesuchsteller.prototype.getVermoegenssabzug = function (schadendatum, ermittelterSchaden) {
        if (!this.hasFinanzangaben()) {
            return 0;
        }
        var vermoegenKapital = this.finanzangaben.finanzangabenDatenFS.vermoegenKapital;
        if (vermoegenKapital === undefined || vermoegenKapital === null) {
            return 0;
        }
        if (vermoegenKapital > TSGesuchsteller.MAX_VERMOEGEN_KAPITAL_POST_2025) {
            return ermittelterSchaden;
        }
        var isPost2025 = schadendatum === undefined || schadendatum === null ||
            schadendatum.isAfter(TSGesuchsteller.POST_2025_START_DATE, 'day');
        var maxAbzugsfrei = isPost2025
            ? TSGesuchsteller.MAX_ABZUGSFREI_POST_2025
            : TSGesuchsteller.MAX_ABZUGSFREI_PRE_2026;
        var deductionBase = vermoegenKapital - maxAbzugsfrei;
        if (deductionBase <= 0) {
            return 0;
        }
        return this.MRound(deductionBase * TSGesuchsteller.VERMOEGENSABZUG_FACTOR, TSGesuchsteller.VERMOEGENSABZUG_ROUNDING_STEP);
    };
    TSGesuchsteller.prototype.hasFinanzangaben = function () {
        return this.finanzangaben && this.finanzangaben.finanzangabenDatenFS;
    };
    TSGesuchsteller.prototype.cleanup = function () {
        switch (this.rechtsform) {
            case TSRechtsform_1.TSRechtsform.NATUERLICHE_PERSON:
                this.genossenschaft = undefined;
                this.koerperschaft = undefined;
                break;
            case TSRechtsform_1.TSRechtsform.GENOSSENSCHAFT:
                this.koerperschaft = undefined;
                if (this.kontaktperson) {
                    this.kontaktperson.gesuchsPersonDatenFS.adresse = undefined;
                }
                // finazangaben auf 0 setzen fuer berechnung wenn Genossenschaft nicht steuerpflichtig
                if (this.genossenschaft && !this.genossenschaft.genossenschaftDatenFS.isSteuerpflichtig) {
                    this.zeroOutFinanzangaben();
                }
                break;
            case TSRechtsform_1.TSRechtsform.MEHRPERSONENGESELLSCHAFT:
                this.koerperschaft = undefined;
                if (this.kontaktperson) {
                    this.kontaktperson.gesuchsPersonDatenFS.adresse = undefined;
                }
                if (this.isZweitperson) {
                    this.finanzangaben = undefined;
                }
                else {
                    // Mehrpersonengesellschaft hat kein einkommen und Gewinn. Muss für berechnung auf 0 gesetzt werden!
                    // Falls es aber eine Zweitperson ist gibt es hier keine finanzangaben
                    this.zeroOutFinanzangaben();
                }
                break;
            case TSRechtsform_1.TSRechtsform.ANDERE_KOERPERSCHAFT:
                this.genossenschaft = undefined;
                if (this.kontaktperson) {
                    this.kontaktperson.gesuchsPersonDatenFS.adresse = undefined;
                }
                break;
        }
    };
    TSGesuchsteller.prototype.zeroOutFinanzangaben = function () {
        if (!this.finanzangaben || !this.finanzangaben.finanzangabenDatenFS) {
            console.error('error: finanzangaben bei einer erstperson mit rechtsfrom mehrpersonengesllschaft oder genossenschaft muessen gesetzt sein');
        }
        else {
            this.finanzangaben.finanzangabenDatenFS.einkommenGewinn = 0;
            this.finanzangaben.finanzangabenDatenFS.vermoegenKapital = 0;
            this.finanzangaben.steuerdatenGeprueft = true;
        }
    };
    TSGesuchsteller.POST_2025_START_DATE = '2026-04-30';
    TSGesuchsteller.MAX_ABZUGSFREI_PRE_2026 = 1000000;
    TSGesuchsteller.MAX_ABZUGSFREI_POST_2025 = 1500000;
    TSGesuchsteller.MAX_VERMOEGEN_KAPITAL_PRE_2026 = 2000000;
    TSGesuchsteller.MAX_VERMOEGEN_KAPITAL_POST_2025 = 2500000;
    TSGesuchsteller.VERMOEGENSABZUG_FACTOR = 0.05;
    TSGesuchsteller.VERMOEGENSABZUG_ROUNDING_STEP = 50;
    return TSGesuchsteller;
}(TSAbstractEntity_1.default));
exports.default = TSGesuchsteller;


/***/ }),

/***/ "oGEB":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("851e");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./bemerkungDialog.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./bemerkungDialog.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "oH1F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright © 2019 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var TSReportType_1 = __webpack_require__("jLGy");
var TSReportTypeDTO = /** @class */ (function () {
    function TSReportTypeDTO() {
        this._reportType = TSReportType_1.TSReportType.AUSZAHLUNG;
    }
    Object.defineProperty(TSReportTypeDTO.prototype, "auszahlungsDatumVon", {
        get: function () {
            return this._auszahlungsDatumVon;
        },
        set: function (value) {
            this._auszahlungsDatumVon = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSReportTypeDTO.prototype, "auszahlungsDatumBis", {
        get: function () {
            return this._auszahlungsDatumBis;
        },
        set: function (value) {
            this._auszahlungsDatumBis = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSReportTypeDTO.prototype, "ereignisDatumVon", {
        get: function () {
            return this._ereignisDatumVon;
        },
        set: function (value) {
            this._ereignisDatumVon = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSReportTypeDTO.prototype, "ereignisDatumBis", {
        get: function () {
            return this._ereignisDatumBis;
        },
        set: function (value) {
            this._ereignisDatumBis = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSReportTypeDTO.prototype, "gesuchDatumVon", {
        get: function () {
            return this._gesuchDatumVon;
        },
        set: function (value) {
            this._gesuchDatumVon = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSReportTypeDTO.prototype, "gesuchDatumBis", {
        get: function () {
            return this._gesuchDatumBis;
        },
        set: function (value) {
            this._gesuchDatumBis = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSReportTypeDTO.prototype, "reportType", {
        get: function () {
            return this._reportType;
        },
        set: function (value) {
            this._reportType = value;
        },
        enumerable: true,
        configurable: true
    });
    TSReportTypeDTO.prototype.serialize = function (restObject) {
        if (this.auszahlungsDatumVon && this.auszahlungsDatumBis) {
            restObject.auszahlungsDatumVon = DateUtil_1.default.momentToLocalDateTime(this.auszahlungsDatumVon);
            restObject.auszahlungsDatumBis = DateUtil_1.default.momentToLocalDateTime(this.auszahlungsDatumBis);
        }
        if (this.ereignisDatumVon && this.ereignisDatumBis) {
            restObject.ereignisDatumVon = DateUtil_1.default.momentToLocalDate(this.ereignisDatumVon);
            restObject.ereignisDatumBis = DateUtil_1.default.momentToLocalDate(this.ereignisDatumBis);
        }
        if (this.gesuchDatumVon && this.gesuchDatumBis) {
            restObject.gesuchDatumVon = DateUtil_1.default.momentToLocalDateTime(this.gesuchDatumVon);
            restObject.gesuchDatumBis = DateUtil_1.default.momentToLocalDateTime(this.gesuchDatumBis);
        }
        restObject.reportType = this.reportType;
        return restObject;
    };
    return TSReportTypeDTO;
}());
exports.default = TSReportTypeDTO;


/***/ }),

/***/ "oMHv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/fondssuisse.36240bfd79b73cd1fca381604ea23495.png";

/***/ }),

/***/ "oPJU":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("OQQl");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./dv-anlaufstelle-typeahead.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./dv-anlaufstelle-typeahead.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ob86":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSLeistungsart_1 = __webpack_require__("LBP/");
var TSFremdkosten_1 = __importDefault(__webpack_require__("csNn"));
var TSFremdkostenDaten_1 = __importDefault(__webpack_require__("u0Wo"));
var DVFremdkostenComponentConfig = /** @class */ (function () {
    function DVFremdkostenComponentConfig() {
        this.transclude = false;
        this.bindings = {
            fremdkosten: '=',
            name: '@',
        };
        this.template = __webpack_require__("VmqX");
        this.controller = DVFremdkostenController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return DVFremdkostenComponentConfig;
}());
exports.DVFremdkostenComponentConfig = DVFremdkostenComponentConfig;
var DVFremdkostenController = /** @class */ (function () {
    /* @ngInject */
    function DVFremdkostenController(CONSTANTS, $log, roleUtilService, $translate) {
        this.CONSTANTS = CONSTANTS;
        this.$log = $log;
        this.roleUtilService = roleUtilService;
        this.$translate = $translate;
        this.$log.debug('initializing fremdkosten componente');
    }
    DVFremdkostenController.prototype.$onInit = function () {
        if (this.fremdkosten === undefined || this.fremdkosten === null) {
            this.fremdkosten = new TSFremdkosten_1.default();
            this.fremdkosten.fremdkostenDatenFS = new TSFremdkostenDaten_1.default();
        }
    };
    DVFremdkostenController.prototype.getModel = function () {
        return this.fremdkosten;
    };
    DVFremdkostenController.prototype.getTSLeistungsartenValues = function () {
        return TSLeistungsart_1.getLeistungsartValues(this.fremdkosten.schaetzung);
    };
    DVFremdkostenController.prototype.translateLeistungsart = function (leistugnsart) {
        var translationKey = TSLeistungsart_1.leistungsartPrefix() + TSLeistungsart_1.TSLeistungsart[leistugnsart];
        return this.$translate.instant(translationKey);
    };
    DVFremdkostenController.prototype.getPrefix = function () {
        return TSLeistungsart_1.leistungsartPrefix();
    };
    DVFremdkostenController.$inject = ['CONSTANTS', '$log', 'RoleUtilService', '$translate'];
    return DVFremdkostenController;
}());
exports.DVFremdkostenController = DVFremdkostenController;


/***/ }),

/***/ "olHO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Dieser Service soll helfen die Events die vom angular-ui-route Service geworfen werden zu debuggen
 */
var NavigationLogger = /** @class */ (function () {
    /* @ngInject */
    function NavigationLogger($rootScope, $log) {
        var _this = this;
        this.$log = $log;
        this.active = false;
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            if (_this.active) {
                $log.debug('$stateChangeStart --- event, toState, toParams, fromState, fromParams');
                $log.debug(event, toState, toParams, fromState, fromParams);
            }
        });
        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            if (_this.active) {
                $log.debug('$stateChangeError --- event, toState, toParams, fromState, fromParams, error');
                $log.debug(event, toState, toParams, fromState, fromParams, error);
            }
        });
        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            if (_this.active) {
                $log.debug('$stateChangeSuccess --- event, toState, toParams, fromState, fromParams');
                $log.debug(event, toState, toParams, fromState, fromParams);
            }
        });
        $rootScope.$on('$viewContentLoading', function (event, viewConfig) {
            if (_this.active) {
                $log.debug('$viewContentLoading --- event, viewConfig');
                $log.debug(event, viewConfig);
            }
        });
        $rootScope.$on('$viewContentLoaded', function (event) {
            if (_this.active) {
                $log.debug('$viewContentLoaded --- event');
                $log.debug(event);
            }
        });
        $rootScope.$on('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
            if (_this.active) {
                $log.debug('$stateNotFound --- event, unfoundState, fromState, fromParams');
                $log.debug(event, unfoundState, fromState, fromParams);
            }
        });
    }
    NavigationLogger.prototype.toggle = function () {
        this.active = !this.active;
    };
    NavigationLogger.$inject = ['$rootScope', '$log'];
    return NavigationLogger;
}());
exports.NavigationLogger = NavigationLogger;


/***/ }),

/***/ "pL33":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("QbT7");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-zahlungen-list.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-zahlungen-list.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "plYF":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("6Ppe");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-dokumentupload.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-dokumentupload.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "pukv":
/***/ (function(module, exports) {

module.exports = "<div class=\"container testpage-view\"> <div class=\"row\"> <div class=\"col-md-10 col-md-offset-1\"> <div class=\"page-header\"> <h1 data-translate=\"TESTPAGE\"></h1> </div> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3> Checkboxes</h3> </div> <div class=\"panel-body\"> <form class=\"form-horizontal\" name=\"vm.form\" novalidate role=\"form\"> <div class=\"checkbox\"> <label> <input type=\"checkbox\" value=\"\"> <span> Checkbox </span> </label> </div> <div class=\"checkbox\"> <label> <input checked=\"checked\" type=\"checkbox\" value=\"\"> <span> Checkbox checked </span> </label> </div> <div class=\"checkbox\"> <label> <input disabled=\"disabled\" type=\"checkbox\" value=\"\"> <span> Checkbox disabled </span> </label> </div> <div class=\"checkbox\"> <label> <input checked=\"checked\" disabled=\"disabled\" type=\"checkbox\" value=\"\"> <span> Checkbox checked & disabled </span> </label> </div> <br> <div class=\"checkbox\"> <label> <input type=\"checkbox\" value=\"\"> <span> Checkbox error </span> </label> </div> <dv-alert-box alert-type=\"error\" size=\"small\"> <span>Test Error</span> </dv-alert-box> </form> </div> </div> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3>Radio</h3> </div> <div class=\"panel-body\"> <form class=\"form-horizontal\" name=\"vm.form\" novalidate role=\"form\"> <div class=\"radio\"> <label> <input name=\"formProperty\" type=\"radio\" value=\"option1\"> <span>Radio</span> </label> </div> <div class=\"radio\"> <label> <input checked=\"checked\" name=\"formProperty\" type=\"radio\" value=\"option1\"> <span>Radio checked</span> </label> </div> <div class=\"radio\"> <label> <input disabled=\"disabled\" name=\"formProperty\" type=\"radio\" value=\"option1\"> <span>Radio disabled</span> </label> </div> <div class=\"radio\"> <label> <input checked=\"checked\" disabled=\"disabled\" name=\"formProperty2\" type=\"radio\" value=\"option1\"> <span>Radio checked & disabled</span> </label> </div> <div class=\"radio-inline\"> <label> <input name=\"formProperty3\" type=\"radio\" value=\"option1\"> <span>Radio inline</span> </label> </div> <div class=\"radio-inline\"> <label> <input name=\"formProperty3\" type=\"radio\" value=\"option1\"> <span>Radio inline </span> </label> </div> <br><br> <div class=\"radio\"> <label> <input name=\"formProperty3\" type=\"radio\" value=\"option1\"> <span>Radio group with error </span> </label> </div> <div class=\"radio\"> <label> <input name=\"formProperty3\" type=\"radio\" value=\"option1\"> <span>Radio group with error </span> </label> </div> <dv-alert-box alert-type=\"error\" size=\"small\"> <span> radio group error</span> </dv-alert-box> </form> </div> </div> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3>Input</h3> </div> <div class=\"panel-body\"> <div class=\"form-group\"> <form class=\"\" name=\"vm.form\" novalidate role=\"form\"> <div class=\"form-group\"> <label for=\"\">Input</label> <input class=\"form-control\" type=\"text\" value=\"Input\"> </div> <div class=\"form-group\"> <label for=\"\">Input focus</label> <input class=\"form-control focus\" type=\"text\" value=\"Input focus\"> </div> <div class=\"form-group\"> <label for=\"\">Input disbled</label> <input class=\"form-control\" disabled=\"disabled\" type=\"text\" value=\"Input disabled\"> </div> <div class=\"form-group\"> <label for=\"\">Input Error</label> <input class=\"form-control error-test\" type=\"text\" value=\"Input error\"> <dv-alert-box alert-type=\"error\" size=\"small\"> <span> test error</span> </dv-alert-box> </div> <div class=\"form-group\"> <label for=\"\">Input error</label> <input class=\"form-control focus error-test\" type=\"text\" value=\"Input error & focus\"> <dv-alert-box alert-type=\"error\" size=\"small\"> <span> test error</span> </dv-alert-box> </div> </form> </div> </div> </div> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3>Input horizontal</h3> </div> <div class=\"panel-body\"> <form class=\"form-horizontal\" name=\"vm.form\" novalidate role=\"form\"> <div class=\"form-group\"> <label class=\"col-sm-2 control-label\" for=\"\">Input horizontal</label> <div class=\"col-sm-10\"> <input class=\"form-control\" type=\"text\" value=\"Input horizontal\"> </div> </div> </form> </div> </div> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3>Alert box</h3> </div> <div class=\"panel-body\"> <dv-alert-box alert-type=\"error\"> <span> I am a Error message</span> </dv-alert-box> <dv-alert-box alert-type=\"info\"> <span> I am a Info message</span> </dv-alert-box> <dv-alert-box alert-type=\"warning\"> <span> I am a Warning message</span> </dv-alert-box> <dv-alert-box alert-type=\"success\"> <span> I am a Success message</span> </dv-alert-box> <dv-alert-box alert-type=\"error\" size=\"small\"> <span> I am also available in small</span> </dv-alert-box> <dv-alert-box alert-type=\"info\" size=\"small\"> <span> I am also available in small</span> </dv-alert-box> <dv-alert-box alert-type=\"warning\" size=\"small\"> <span> I am also available in small</span> </dv-alert-box> <dv-alert-box alert-type=\"success\" size=\"small\"> <span> I am also available in small</span> </dv-alert-box> </div> </div> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3>Buttons</h3> </div> <div class=\"panel-body\"> <button class=\"btn btn-serf\" ng-click=\"\" type=\"button\">Button</button> <br> <br> <button class=\"btn btn-serf\" disabled=\"disabled\" ng-click=\"\" type=\"button\">Button disabled</button> </div> </div> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3>Buttons</h3> </div> <div class=\"panel-body\"> <button class=\"btn btn-sub-serf\" ng-click=\"\" type=\"submit\"> <span> Sub-Button</span> <span class=\"fa fa-plus\"></span> </button> <br> <br> <button class=\"btn btn-sub-serf\" disabled=\"disabled\" ng-click=\"\" type=\"submit\"> <span> Sub-Button disabled</span> <span class=\"fa fa-plus\"></span> </button> </div> </div> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3>Diverses</h3> </div> <div class=\"panel-body\"> <div class=\"form-group\"> <form class=\"\" name=\"vm.exampleForm\" novalidate role=\"form\"> <div class=\"form-group\"> <label class=\"md-no-float\" data-translate=\"DATEPICKER_EXAMPLE\" for=\"datepicker\"></label> <dv-datepicker class=\"input-element\" input-id=\"datepicker\" name=\"datepicker\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" ng-model=\"vm.datepickerValue\" ng-required=\"false\"> </dv-datepicker> <dv-error-messages class=\"error\" for=\"vm.exampleForm.datepicker\"></dv-error-messages> </div> <div class=\"form-group\"> <label class=\"md-no-float\" for=\"valueinput\"> <span data-translate=\"VALUEINPUT_EXAMPLE\"></span> <dv-tooltip text=\"'TOOLTIP_HELP_TEXT' | translate\"></dv-tooltip> </label> <dv-valueinput aria-label=\"{{'FINANZIELLE_SITUATION_VERMOEGEN_GS_1'|translate}}\" class=\"input-element\" input-id=\"valueinput\" input-name=\"valueinput\" name=\"valueinput\" ng-model=\"vm.valueinput\" ng-required=\"true\"> </dv-valueinput> <dv-error-messages class=\"error\" for=\"vm.exampleForm.valueinput\"></dv-error-messages> </div> <div class=\"form-group\"> <button class=\"btn btn-serf\" ng-click=\"vm.openModal('TOOLTIP_HELP_TITLE','TOOLTIP_HELP_TEXT')\" title=\"Open Modal\">Open Modal </button> </div> </form> </div> </div> </div> <div class=\"panel -panel-default\"> <div> <div class=\"form-group\"> <form class=\"\" name=\"vm.exampleForm\" novalidate role=\"form\"> <div class=\"form-group\"> <button class=\"btn btn-serf\" ng-click=\"vm.sentrytest()\" title=\"throws an error that sentry should catch\">Sentrytest </button> </div> </form> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "pxZP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DVLoading = /** @class */ (function () {
    function DVLoading() {
        this.restrict = 'A';
        this.controller = DVLoadingController;
        this.controllerAs = 'vm';
        this.link = function (scope, element, attributes, controller) {
            var promise;
            scope.$watch(function () {
                return controller.isLoading;
            }, function (newValue, oldValue) {
                if ((newValue !== oldValue)) {
                    if (newValue) {
                        controller.$timeout.cancel(promise);
                        element.show();
                    }
                    else {
                        promise = controller.$timeout(function () {
                            element.hide();
                        }, 500);
                    }
                }
            });
        };
    }
    DVLoading.factory = function () {
        var directive = function () { return new DVLoading(); };
        directive.$inject = [];
        return directive;
    };
    return DVLoading;
}());
exports.DVLoading = DVLoading;
/**
 * Direktive  die ein Element ein oder ausblendet jenachdem ob ein http request pending ist
 */
var DVLoadingController = /** @class */ (function () {
    /* @ngInject */
    function DVLoadingController($timeout, $rootScope) {
        var _this = this;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        $rootScope.$on('$viewContentLoading', function (event, toState, toParams, fromState, fromParams, options) {
            _this.isLoading = true;
        });
        $rootScope.$on('$viewContentLoaded', function (event, toState, toParams, fromState, fromParams) {
            _this.isLoading = false;
        });
        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            _this.isLoading = false;
        });
        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams) {
            _this.isLoading = false;
        });
        $rootScope.$on('$stateNotFound', function (event, toState, toParams, fromState, fromParams) {
            _this.isLoading = false;
        });
    }
    DVLoadingController.$inject = ['$timeout', '$rootScope'];
    return DVLoadingController;
}());
exports.DVLoadingController = DVLoadingController;


/***/ }),

/***/ "q4oK":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("HCMu");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./anlaufstelleView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./anlaufstelleView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "qGSx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSCockpitSelect;
(function (TSCockpitSelect) {
    TSCockpitSelect[TSCockpitSelect["LETZER_MONAT"] = 'LETZER_MONAT'] = "LETZER_MONAT";
    TSCockpitSelect[TSCockpitSelect["DATUM_BEREICH"] = 'DATUM_BEREICH'] = "DATUM_BEREICH";
})(TSCockpitSelect = exports.TSCockpitSelect || (exports.TSCockpitSelect = {}));
function getTSCockpitSelectValues() {
    return [
        TSCockpitSelect.LETZER_MONAT,
        TSCockpitSelect.DATUM_BEREICH,
    ];
}
exports.getTSCockpitSelectValues = getTSCockpitSelectValues;
function cockpitSelectPrefix() {
    return 'TSCockpitSelect_';
}
exports.cockpitSelectPrefix = cockpitSelectPrefix;


/***/ }),

/***/ "qfs+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSAbstractBemerkungEntity_1 = __importDefault(__webpack_require__("NwLi"));
var moment_1 = __importDefault(__webpack_require__("PJh5"));
var TSSystemBemerkung = /** @class */ (function (_super) {
    __extends(TSSystemBemerkung, _super);
    function TSSystemBemerkung() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSSystemBemerkung.prototype, "preStatus", {
        get: function () {
            return this._preStatus;
        },
        set: function (value) {
            this._preStatus = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSSystemBemerkung.prototype, "postStatus", {
        get: function () {
            return this._postStatus;
        },
        set: function (value) {
            this._postStatus = value;
        },
        enumerable: true,
        configurable: true
    });
    TSSystemBemerkung.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.preStatus = restObject.preStatus;
        this.postStatus = restObject.postStatus;
        return this;
    };
    TSSystemBemerkung.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        // Don't send them down...
        restObject.preStatus = undefined;
        restObject.postStatus = undefined;
        return restObject;
    };
    TSSystemBemerkung.prototype.getBesitzerName = function () {
        return 'SYSTEM_MELDUNG';
    };
    TSSystemBemerkung.prototype.getTimestampErstellt = function () {
        if (this.timestampErstellt) {
            return this.timestampErstellt;
        }
        return moment_1.default();
    };
    TSSystemBemerkung.prototype.getPreStatus = function () {
        return this.preStatus;
    };
    TSSystemBemerkung.prototype.getPostStatus = function () {
        return this.postStatus;
    };
    TSSystemBemerkung.getDeserializer = function (systemBemerkung) {
        return new TSSystemBemerkung().deserialize(systemBemerkung);
    };
    TSSystemBemerkung.getSerializer = function (systemBemerkung) {
        return systemBemerkung.serialize(systemBemerkung);
    };
    return TSSystemBemerkung;
}(TSAbstractBemerkungEntity_1.default));
exports.default = TSSystemBemerkung;


/***/ }),

/***/ "qqH2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
var Raven = __webpack_require__("/Hyb");
var app_module_1 = __importDefault(__webpack_require__("Iksp"));
__webpack_require__("kufV");
__webpack_require__("en8u");
__webpack_require__("8xVf");
__webpack_require__("Zc7H");
var ravenPlugin = __webpack_require__("BY2X");
// perform initializations that must be done before angular is started
/**
 * @param {?string} sentryDsn
 */
function initSentry(sentryDsn) {
    if (sentryDsn === null || sentryDsn === undefined || sentryDsn === '') {
        console.info('No sentry_dsn configured; sentry will be disabled (frontend)');
        return;
    }
    Raven.config(sentryDsn)
        .addPlugin(ravenPlugin, angular)
        .install();
    Raven.setEnvironment("production");
    Raven.setRelease("2.7.0");
    console.log('sentry was isntalled with key ', sentryDsn);
}
initSentry("https://fafe13006c4d4aca81e7551e8cc8f487@sentry.dvbern.ch/4");
//Start Angular application
angular.element(document).ready(function () {
    angular.bootstrap(document, [app_module_1.default.name], {
        strictDi: true
    });
});


/***/ }),

/***/ "r+7B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OkCancelController = /** @class */ (function () {
    function OkCancelController($uibModalInstance, $translate, title, text) {
        this.$uibModalInstance = $uibModalInstance;
        if (text !== undefined && text !== null) {
            this.text = $translate.instant(text);
        }
        else {
            this.text = 'test';
        }
        if (title !== undefined && title !== null) {
            this.title = $translate.instant(title);
        }
        else {
            this.title = 'Confirmation';
        }
    }
    OkCancelController.prototype.ok = function () {
        this.$uibModalInstance.close();
    };
    ;
    OkCancelController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    ;
    OkCancelController.$inject = ['$uibModalInstance', '$translate', 'title', 'text'];
    return OkCancelController;
}());
exports.OkCancelController = OkCancelController;


/***/ }),

/***/ "r5a4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var template = __webpack_require__("RxTB");
var VersicherungsbeitraegeListViewComponentConfig = /** @class */ (function () {
    function VersicherungsbeitraegeListViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = VersicherungsbeitraegeListViewController;
        this.controllerAs = 'vm';
        this.bindToController = true;
        this.bindings = {
            besitzer: '<'
        };
    }
    return VersicherungsbeitraegeListViewComponentConfig;
}());
exports.VersicherungsbeitraegeListViewComponentConfig = VersicherungsbeitraegeListViewComponentConfig;
var VersicherungsbeitraegeListViewController = /** @class */ (function () {
    function VersicherungsbeitraegeListViewController($filter, $state, $log, CONSTANTS, $q, $scope, authService, roleUtilService, versicherungsbeitragRS, pageNames) {
        var _this = this;
        this.$filter = $filter;
        this.$state = $state;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.$q = $q;
        this.$scope = $scope;
        this.authService = authService;
        this.roleUtilService = roleUtilService;
        this.versicherungsbeitragRS = versicherungsbeitragRS;
        this.pageNames = pageNames;
        this.totalResultCount = '-';
        this.versicherungsbeitraegeList = [];
        this.passVersicherungsbeitragFallFilterToServer = function (tableFilterState) {
            _this.$log.debug('Triggering ServerFiltering with Filter Object', tableFilterState);
            return _this.versicherungsbeitragRS.searchVersicherungsbeitraege(tableFilterState).then(function (response) {
                _this.totalResultCount = response.totalResultSize ? response.totalResultSize.toString() : '-';
                _this.versicherungsbeitraegeList = response.versicherungsbeitragDTOs;
                return response;
            });
        };
    }
    VersicherungsbeitraegeListViewController.prototype.$onInit = function () {
        this.currentPrincipal = this.authService.getPrincipal();
        this.currentUsername = (this.currentPrincipal !== undefined) ? this.currentPrincipal.email : undefined;
    };
    VersicherungsbeitraegeListViewController.prototype.editVersicherungsbeitrag = function (versicherungsbeitragDTO, event) {
        this.$state.go(this.pageNames.VERSICHERUNGSBEITRAGSCHADEN, {
            createNew: false,
            versicherungsbeitragId: versicherungsbeitragDTO.versicherungsbeitragId
        });
    };
    VersicherungsbeitraegeListViewController.prototype.addVersicherungsbeitrag = function () {
        this.$state.go(this.pageNames.VERSICHERUNGSBEITRAGSCHADEN, { createNew: true, versicherungsbeitragId: undefined });
    };
    VersicherungsbeitraegeListViewController.$inject = ['$filter', '$state', '$log', 'CONSTANTS', '$q', '$scope', 'AuthServiceRS', 'RoleUtilService',
        'VersicherungsbeitragRS', 'PAGE_NAMES'];
    return VersicherungsbeitraegeListViewController;
}());
exports.VersicherungsbeitraegeListViewController = VersicherungsbeitraegeListViewController;


/***/ }),

/***/ "r5mD":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("7xmh");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-schaden-list.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-schaden-list.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "rFzF":
/***/ (function(module, exports) {

module.exports = " <div class=\"text-value-title\">{{vm.dataset.name}}</div> <div class=\"text-value-value\">{{vm.dataset.cockpitResult[0].value}}</div> ";

/***/ }),

/***/ "rS+W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSGeoadminSearchResponse = /** @class */ (function () {
    function TSGeoadminSearchResponse() {
    }
    Object.defineProperty(TSGeoadminSearchResponse.prototype, "origin", {
        get: function () {
            return this._origin;
        },
        set: function (value) {
            this._origin = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGeoadminSearchResponse.prototype, "layerBodId", {
        get: function () {
            return this._layerBodId;
        },
        set: function (value) {
            this._layerBodId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGeoadminSearchResponse.prototype, "featureId", {
        get: function () {
            return this._featureId;
        },
        set: function (value) {
            this._featureId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGeoadminSearchResponse.prototype, "detail", {
        get: function () {
            return this._detail;
        },
        set: function (value) {
            this._detail = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGeoadminSearchResponse.prototype, "rank", {
        get: function () {
            return this._rank;
        },
        set: function (value) {
            this._rank = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGeoadminSearchResponse.prototype, "geom_st_box2d", {
        get: function () {
            return this._geom_st_box2d;
        },
        set: function (value) {
            this._geom_st_box2d = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGeoadminSearchResponse.prototype, "num", {
        get: function () {
            return this._num;
        },
        set: function (value) {
            this._num = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGeoadminSearchResponse.prototype, "y", {
        get: function () {
            return this._y;
        },
        set: function (value) {
            this._y = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGeoadminSearchResponse.prototype, "x", {
        get: function () {
            return this._x;
        },
        set: function (value) {
            this._x = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGeoadminSearchResponse.prototype, "lat", {
        get: function () {
            return this._lat;
        },
        set: function (value) {
            this._lat = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGeoadminSearchResponse.prototype, "lon", {
        get: function () {
            return this._lon;
        },
        set: function (value) {
            this._lon = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGeoadminSearchResponse.prototype, "label", {
        get: function () {
            return this._label;
        },
        set: function (value) {
            this._label = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSGeoadminSearchResponse.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    TSGeoadminSearchResponse.prototype.deserialize = function (restObject) {
        this.origin = restObject.origin;
        this.layerBodId = restObject.layerBodId;
        this.featureId = restObject.featureId;
        this.detail = restObject.detail;
        this.rank = restObject.rank;
        this.geom_st_box2d = restObject.geom_st_box2d;
        this.num = restObject.num;
        this.y = restObject.y;
        this.x = restObject.x;
        this.lat = restObject.lat;
        this.lon = restObject.lon;
        this.label = restObject.label;
        this.name = this.label.replace('<b>', '').replace('</b>', '')
            .replace('<i>', '').replace('</i>', '');
        return this;
    };
    TSGeoadminSearchResponse.prototype.serialize = function (restObject) {
        return restObject;
    };
    return TSGeoadminSearchResponse;
}());
exports.default = TSGeoadminSearchResponse;


/***/ }),

/***/ "rnKj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("xUjB");
var DVBenutzerTypeaheadComponentConfig = /** @class */ (function () {
    function DVBenutzerTypeaheadComponentConfig() {
        this.transclude = false;
        this.bindings = {
            selectedBenutzer: '=',
            inputName: '@?',
            inputPlaceholder: '@?',
            inputDisabled: '<?',
            label: '@',
            clazz: '@',
            ngRequired: '<',
        };
        this.template = __webpack_require__("CVPs");
        this.controller = DvBenutzerTypeaheadController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return DVBenutzerTypeaheadComponentConfig;
}());
exports.DVBenutzerTypeaheadComponentConfig = DVBenutzerTypeaheadComponentConfig;
var DvBenutzerTypeaheadController = /** @class */ (function () {
    function DvBenutzerTypeaheadController($log, $q, benutzerRS) {
        this.$log = $log;
        this.$q = $q;
        this.benutzerRS = benutzerRS;
        this.valueRequired = true; // default required
    }
    DvBenutzerTypeaheadController.prototype.$onInit = function () {
        if (this.ngRequired !== undefined) {
            this.valueRequired = this.ngRequired;
        }
        if (this.inputDisabled === undefined) {
            this.inputDisabled = false;
        }
    };
    DvBenutzerTypeaheadController.prototype.loadSuggestElements = function (searchString) {
        return this.benutzerRS.readBenutzerSuggestion(searchString).then(function (response) {
            return response;
        });
    };
    DvBenutzerTypeaheadController.$inject = ['$log', '$q', 'BenutzerRS'];
    return DvBenutzerTypeaheadController;
}());
exports.DvBenutzerTypeaheadController = DvBenutzerTypeaheadController;


/***/ }),

/***/ "rzx8":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("j2/v");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./passwordResetView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./passwordResetView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "s031":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
var TSApplicationProperty_1 = __importDefault(__webpack_require__("P/EH"));
var ApplicationPropertyRS = /** @class */ (function () {
    /* @ngInject */
    function ApplicationPropertyRS($http, REST_API) {
        this.serviceURL = REST_API + 'application-properties';
        this.http = $http;
    }
    ApplicationPropertyRS.prototype.getByName = function (name) {
        return this.http.get(this.serviceURL + '/key/' + encodeURIComponent(name), { cache: true }).then(function (response) {
            return response.data;
            //(response: any) => this.ebeguRestUtil.parseApplicationProperty(new TSApplicationProperty(), response.data)
        });
    };
    ApplicationPropertyRS.prototype.isDevMode = function () {
        return this.http.get(this.serviceURL + '/public/devmode', { cache: true }).then(function (response) {
            return response.data;
        });
    };
    ApplicationPropertyRS.prototype.getVereinbarungValidYears = function () {
        return this.http.get(this.serviceURL + '/public/vereinbarungvalidyears', { cache: true }).then(function (response) {
            return response.data;
        });
    };
    ApplicationPropertyRS.prototype.isDummyMode = function () {
        return this.http.get(this.serviceURL + '/public/dummy', { cache: true }).then(function (response) {
            return response.data;
        });
    };
    ApplicationPropertyRS.prototype.getBackgroundColor = function () {
        return this.http.get(this.serviceURL + '/public/background', { cache: true }).then(function (response) {
            return response.data;
        });
    };
    ApplicationPropertyRS.prototype.getPiwikSiteId = function () {
        return this.http.get(this.serviceURL + '/public/piwik', { cache: true }).then(function (response) {
            return response.data;
        });
    };
    ApplicationPropertyRS.prototype.getSentryEnvName = function () {
        return this.http.get(this.serviceURL + '/public/sentryenv', { cache: true }).then(function (response) {
            return response.data;
        });
    };
    ApplicationPropertyRS.prototype.getRecaptchaSiteKey = function () {
        return this.http.get(this.serviceURL + '/public/captchakey').then(function (response) {
            return (response && response.data.value) ? response.data.value : undefined;
        });
    };
    ApplicationPropertyRS.prototype.create = function (name, value) {
        return this.http.post(this.serviceURL + '/' + encodeURIComponent(name), value, {
            headers: {
                'Content-Type': 'text/plain'
            }
        }).then(function (response) {
            return new TSApplicationProperty_1.default().deserialize(response.data);
        });
    };
    ApplicationPropertyRS.prototype.update = function (name, value) {
        return this.http.post(this.serviceURL + '/' + encodeURIComponent(name), value, {
            headers: {
                'Content-Type': 'text/plain'
            }
        }).then(function (response) {
            return new TSApplicationProperty_1.default().deserialize(response.data);
        });
    };
    ApplicationPropertyRS.prototype.remove = function (name) {
        return this.http.delete(this.serviceURL + '/' + encodeURIComponent(name));
    };
    ApplicationPropertyRS.prototype.getAllApplicationProperties = function () {
        return this.http.get(this.serviceURL + '/', { cache: true }).then(function (response) {
            var converter = function (jsonString) {
                return new TSApplicationProperty_1.default().deserialize(jsonString);
            };
            if (angular.isArray(response.data)) {
                return response.data.map(converter);
            }
            return [];
        });
    };
    ApplicationPropertyRS.$inject = ['$http', 'REST_API'];
    return ApplicationPropertyRS;
}());
exports.ApplicationPropertyRS = ApplicationPropertyRS;


/***/ }),

/***/ "s3ia":
/***/ (function(module, exports) {

module.exports = "<div class=\"container inspektoratverwaltung-view\"> <div class=\"row add-button-buffer\"> <div class=\"col-md-12\"> <button ng-click=\"vm.addInspektorat()\" class=\"btn btn-serf-red\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getAdministratorRoles()\"> <span class=\"fa fa-plus btn-ico\"></span> <span data-translate=\"INSPEKTORAT_ADD\"> </span> </button> </div> </div> <div class=\"row\"> <div class=\"col-md-12\"> <dv-inspektorat-list inspektorat=\"vm.inspektorat\" on-edit=\"vm.editInspektorat(inspektorat, event)\"> </dv-inspektorat-list> </div> </div> </div> ";

/***/ }),

/***/ "s8fB":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".authentication-view,authentication-view,password-reset-view{display:flex;flex-direction:column;flex:1 100%;margin-bottom:-92px}.authentication-view{background-repeat:no-repeat;background-position:50%;background-attachment:fixed;background-size:cover;justify-content:center;align-items:center;margin:-8px}.authentication-view__text{width:630px;text-align:center;font-size:16px;letter-spacing:.5px;line-height:25px;margin-top:35px;margin-bottom:15px}.authentication-view__button{margin-top:auto;min-width:154px}.authentication-view__login_button{color:#fff;background-color:#bc2500;border-color:#bc2500}.authentication-view__login_button.focus,.authentication-view__login_button:focus,.authentication-view__login_button:hover{color:#fff;background-color:#a82200;border-color:#a82200}.authentication-view__login_button.active,.authentication-view__login_button.active.focus,.authentication-view__login_button.active:focus,.authentication-view__login_button.active:hover,.authentication-view__login_button:active,.authentication-view__login_button:active.focus,.authentication-view__login_button:active:focus,.authentication-view__login_button:active:hover,.open>.authentication-view__login_button.dropdown-toggle,.open>.authentication-view__login_button.dropdown-toggle.focus,.open>.authentication-view__login_button.dropdown-toggle:focus,.open>.authentication-view__login_button.dropdown-toggle:hover{color:#fff;background-color:#e0927e;border-color:#e0927e}.authentication-view__login-hinweis{width:480px;margin:20px 0 0}.authentication-view__login-hinweis .dv-alert-box__message{display:block}.authentication-view__login-hinweis a{color:inherit;text-decoration:underline}.authentication-view__link,.authentication-view__link:hover{color:#4b565c;font-weight:700}.authentication-view__link--italic{font-size:14px;font-style:italic;margin:-12px 160px 25px auto}.authentication-view__infotext{margin-top:40px;margin-bottom:10px;color:#4b565c;font-weight:700}.authentication-view__infotext_gemeinde{margin-top:20px;margin-bottom:10px;color:#4b565c;font-weight:700}.authentication-view__gemeinde{color:#4b565c;font-weight:700}.authentication-view__gemeinde>p>span{text-align:center}.authentication-view__gemeinde>p>a{margin:auto!important}.authentication-view__loginbox,.authentication-view__regbox{width:800px}.authentication-view__loginbox{height:auto;background:hsla(0,0%,100%,.87);color:#4b565c}.authentication-view__regbox{height:60px;line-height:60px;font-size:18px;font-weight:600;background-color:#4b565c;opacity:.9;text-align:center;margin-bottom:20px}.authentication-view__regbox__content{line-height:65px}.authentication-view__regbox--transparent{background:transparent;margin-bottom:0;width:480px;text-align:left}.authentication-view__regbox--reset{font-size:24px;font-weight:700;text-align:center;vertical-align:bottom;line-height:normal;height:auto;margin-top:55px}.authentication-view__loginbox-input{font-size:14px;height:50px;width:480px;font-weight:700}.authentication-view__loginbox-center{display:flex;flex-direction:column;flex:1 100%;height:100%;align-items:center;justify-content:space-between;flex-wrap:nowrap;padding-top:0}.authentication-view__loginbox-form-group{margin-bottom:37px}@media(max-width:520px){.authentication-view__login-hinweis{width:100%}}.background-gs-1{background-image:url(" + escape(__webpack_require__("LYXy")) + ")}.background-gs-2{background-image:url(" + escape(__webpack_require__("KuoJ")) + ")}.background-gs-3{background-image:url(" + escape(__webpack_require__("HVSw")) + ")}.background-gs-4{background-image:url(" + escape(__webpack_require__("gClk")) + ")}.background-gs-5{background-image:url(" + escape(__webpack_require__("CuBj")) + ")}.background-as{background-image:url(" + escape(__webpack_require__("YKbT")) + ")}", ""]);

// exports


/***/ }),

/***/ "sMzP":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("3px/");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./versicherungsbeitragBeitragView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./versicherungsbeitragBeitragView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "sOyJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright © 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSBeitragType;
(function (TSBeitragType) {
    TSBeitragType[TSBeitragType["SCHADENFALL"] = 'SCHADENFALL'] = "SCHADENFALL";
    TSBeitragType[TSBeitragType["VERSICHERUNG"] = 'VERSICHERUNG'] = "VERSICHERUNG";
})(TSBeitragType = exports.TSBeitragType || (exports.TSBeitragType = {}));
function getTSBeitragTypeValues() {
    return [
        TSBeitragType.SCHADENFALL,
        TSBeitragType.VERSICHERUNG
    ];
}
exports.getTSBeitragTypeValues = getTSBeitragTypeValues;
function beitragArtPrefix() {
    return 'TSBeitragType_';
}
exports.beitragArtPrefix = beitragArtPrefix;
function beitragPropertySuffix() {
    return '_BEITRAG';
}
exports.beitragPropertySuffix = beitragPropertySuffix;


/***/ }),

/***/ "sX8E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSCockpitSelect_1 = __webpack_require__("qGSx");
var TSCockpitTypeDTO_1 = __importDefault(__webpack_require__("dfPH"));
var TSCockpitResultDTO_1 = __importDefault(__webpack_require__("I7ot"));
var TSCockpitType_1 = __webpack_require__("Q2bv");
var template = __webpack_require__("PJzB");
var CockpitViewComponentConfig = /** @class */ (function () {
    function CockpitViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = CockpitViewController;
        this.controllerAs = 'vm';
        this.bindToController = true;
    }
    return CockpitViewComponentConfig;
}());
exports.CockpitViewComponentConfig = CockpitViewComponentConfig;
var CockpitViewController = /** @class */ (function () {
    function CockpitViewController($log, CONSTANTS, roleUtilService, $translate, errorService, cockpitRS) {
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.roleUtilService = roleUtilService;
        this.$translate = $translate;
        this.errorService = errorService;
        this.cockpitRS = cockpitRS;
        this.cockpitTypeDTO = new TSCockpitTypeDTO_1.default();
        this.statusDataset = new TSCockpitResultDTO_1.default();
        this.anzahlGesucheDataset = new TSCockpitResultDTO_1.default();
        this.gesucheKantonDataset = new TSCockpitResultDTO_1.default();
        this.gesucheErfassungsArtDataset = new TSCockpitResultDTO_1.default();
        this.schadenartDataset = new TSCockpitResultDTO_1.default();
        this.geschaetzteKostenDataset = new TSCockpitResultDTO_1.default();
        this.neueGesucheDataset = new TSCockpitResultDTO_1.default();
    }
    CockpitViewController.prototype.$onInit = function () {
        this.loadCockpitData();
    };
    CockpitViewController.prototype.translateCockpitSelectForSelect = function (etv) {
        var prefix = TSCockpitSelect_1.cockpitSelectPrefix();
        return this.$translate.instant(prefix + TSCockpitSelect_1.TSCockpitSelect[etv]);
    };
    CockpitViewController.prototype.getTSCockpitSelect = function () {
        return TSCockpitSelect_1.getTSCockpitSelectValues();
    };
    CockpitViewController.prototype.changedCockpitSelect = function () {
        if (!this.form.$valid) {
            return;
        }
        if (this.cockpitTypeDTO.cockpitSelect === TSCockpitSelect_1.TSCockpitSelect.DATUM_BEREICH && (!this.cockpitTypeDTO.datumVon || !this.cockpitTypeDTO.datumBis)) {
            return;
        }
        if ((this.cockpitTypeDTO.datumVon && this.cockpitTypeDTO.datumBis) &&
            (this.cockpitTypeDTO.datumBis < this.cockpitTypeDTO.datumVon)) {
            this.errorService.addMesageAsError('ERROR_DATE_BEFORE_TO');
            throw new Error("to cannot be behind from " + this.cockpitTypeDTO.datumVon + " > " + this.cockpitTypeDTO.datumBis);
        }
        this.loadCockpitData();
    };
    CockpitViewController.prototype.loadCockpitData = function () {
        var _this = this;
        this.cockpitTypeDTO.cockpitType = TSCockpitType_1.TSCockpitType.STATUS;
        this.cockpitRS.searchCockpitResult(this.cockpitTypeDTO).then(function (response) {
            _this.statusDataset = response;
        });
        this.cockpitTypeDTO.cockpitType = TSCockpitType_1.TSCockpitType.GESUCHE_KANTON;
        this.cockpitRS.searchCockpitResult(this.cockpitTypeDTO).then(function (response) {
            _this.gesucheKantonDataset = response;
        });
        this.cockpitTypeDTO.cockpitType = TSCockpitType_1.TSCockpitType.GESUCHE_ERFASSUNGSART;
        this.cockpitRS.searchCockpitResult(this.cockpitTypeDTO).then(function (response) {
            _this.gesucheErfassungsArtDataset = response;
        });
        this.cockpitTypeDTO.cockpitType = TSCockpitType_1.TSCockpitType.NEUE_GESUCHE;
        this.cockpitRS.searchCockpitResult(this.cockpitTypeDTO).then(function (response) {
            _this.neueGesucheDataset = response;
        });
        this.cockpitTypeDTO.cockpitType = TSCockpitType_1.TSCockpitType.SCHADENART;
        this.cockpitRS.searchCockpitResult(this.cockpitTypeDTO).then(function (response) {
            _this.schadenartDataset = response;
        });
        this.cockpitTypeDTO.cockpitType = TSCockpitType_1.TSCockpitType.GESCHAETZTE_KOSTEN;
        this.cockpitRS.searchCockpitResult(this.cockpitTypeDTO).then(function (response) {
            _this.geschaetzteKostenDataset = response;
        });
        this.cockpitTypeDTO.cockpitType = TSCockpitType_1.TSCockpitType.ANZAHL_GESUCHE;
        this.cockpitRS.searchCockpitResult(this.cockpitTypeDTO).then(function (response) {
            _this.anzahlGesucheDataset = response;
        });
    };
    CockpitViewController.prototype.displayDatum = function () {
        return this.cockpitTypeDTO.cockpitSelect === TSCockpitSelect_1.TSCockpitSelect.DATUM_BEREICH;
    };
    CockpitViewController.$inject = ['$log', 'CONSTANTS', 'RoleUtilService', '$translate', 'ErrorService', 'CockpitRS'];
    return CockpitViewController;
}());
exports.CockpitViewController = CockpitViewController;


/***/ }),

/***/ "sXLq":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.entschaedigung-view .row-actions{min-width:100px;width:10%}.entschaedigung-view .td-padding0{padding-bottom:0;padding-top:0}", ""]);

// exports


/***/ }),

/***/ "stLe":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.dv-vorleistungen-list .rowHeader-berechtigterBetrag,.dv-vorleistungen-list .rowHeader-betrag,.dv-vorleistungen-list .rowHeader-empty1,.dv-vorleistungen-list .rowHeader-empty2{width:15%}.dv-vorleistungen-list .rowHeader-actions{width:130px}.dv-vorleistungen-list .rowBody-actions{text-align:center}.dv-vorleistungen-list .rowBody-actions button{width:30px}", ""]);

// exports


/***/ }),

/***/ "svkO":
/***/ (function(module, exports) {

module.exports = " <div class=\"row\" ng-form=\"vorleistungForm\"> <div class=\"col-sm-12\"> <div class=\"row\"> <div class=\"col-sm-3 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"VORLEISTUNG_ART\" for=\"{{vm.name}}_vorleistungenArt_ID\"> </label> <select name=\"{{vm.name}}_vorleistungenArt\" id=\"{{vm.name}}_vorleistungenArt_ID\" ng-model=\"vm.getModel().vorleistungDatenFS.vorleistungenArt\" class=\"form-control\" ng-options=\"vm.translateVorleistungArt(art) for art in vm.getTSVorleistungArtValues() track by art\" ng-required=\"true\"> </select> <dv-error-messages for=\"vorleistungForm[vm.name + '_vorleistungenArt']\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().vorleistungDatenGS\" fs=\"vm.getModel().vorleistungDatenFS\" property=\"vorleistungenArt\" for=\"vorleistungForm[vm.name + '_vorleistungenArt']\" prefix=\"vm.getPrefix()\"></dv-bisher> </dv-input-container> </div> <div class=\"col-sm-2\"> <dv-input-container> <label data-translate=\"BETRAG_CHF\" for=\"{{vm.name}}_betrag_ID\"></label> <dv-valueinput input-id=\"{{vm.name}}_betrag_ID\" name=\"{{vm.name}}_betrag\" input-name=\"{{vm.name}}_betrag\" ng-model=\"vm.getModel().vorleistungDatenFS.betrag\" ng-required=\"true\" float=\"true\" fixed-decimals=\"2\" allow-negative=\"false\" class=\"input-element\"> </dv-valueinput> <dv-error-messages for=\"vorleistungForm[vm.name + '_betrag']\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().vorleistungDatenGS\" fs=\"vm.getModel().vorleistungDatenFS\" property=\"betrag\" for=\"vorleistungForm[vm.name + '_betrag']\"></dv-bisher> </dv-input-container> </div> <div class=\"col-sm-4 dv-input-container-medium\" ng-if=\"vm.isPoliceNrVisible()\"> <dv-input-container> <label data-translate=\"VORLEISTUNG_POLICE_NR\" for=\"{{vm.name}}_policeNr_ID\"> </label> <input id=\"{{vm.name}}_policeNr_ID\" name=\"{{vm.name}}_policeNr\" ng-model=\"vm.getModel().vorleistungDatenFS.policeNr\" dv-max-length class=\"form-control\"> <dv-error-messages for=\"vorleistungForm[vm.name + '_policeNr']\"></dv-error-messages> <dv-bisher gs=\"vm.getModel().vorleistungDatenGS\" fs=\"vm.getModel().vorleistungDatenFS\" property=\"policeNr\" for=\"vorleistungForm[vm.name + '_policeNr']\"></dv-bisher> </dv-input-container> </div> </div> </div> </div> ";

/***/ }),

/***/ "tG31":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright © 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("+wrW");
var alertTemplate = __webpack_require__("1Gel");
var DvAlertBoxComponentConfig = /** @class */ (function () {
    function DvAlertBoxComponentConfig() {
        this.transclude = true;
        this.bindings = {
            alertType: '@',
            size: '@?',
        };
        this.template = alertTemplate;
        this.controller = DvAlertBoxController;
        this.controllerAs = 'vm';
    }
    return DvAlertBoxComponentConfig;
}());
exports.DvAlertBoxComponentConfig = DvAlertBoxComponentConfig;
var DvAlertBoxController = /** @class */ (function () {
    function DvAlertBoxController() {
    }
    DvAlertBoxController.prototype.$onInit = function () {
        this.sizeClass = 'dv-alert-box--' + (this.size ? this.size : 'normal');
        this.alertTypeClass = 'dv-alert-box--' + (this.alertType ? this.alertType : 'info');
    };
    return DvAlertBoxController;
}());
exports.DvAlertBoxController = DvAlertBoxController;


/***/ }),

/***/ "tOSr":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("3UQ6");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./core.module.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./core.module.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "tfhF":
/***/ (function(module, exports) {

module.exports = "<div class=\"benutzer-profil-view container\"> <form name=\"vm.form\" novalidate unsaved-warning-form> <div class=\"row marginTop20\"> <div class=\"col-sm-12\"> <h1> <span data-translate=\"BENUTZERPROFIL\"></span> </h1> </div> </div> <dv-benutzerprofil benutzer=\"vm.model\" pw-change-with-button=\"!vm.forcePasswordChange\" double-email-entry=\"vm.forcePasswordChange\" hide-password-entry=\"false\" on-change-password=\"vm.onChangePasswd(event)\" no-email-entry=\"vm.noEmailEntry\" phone-required=\"vm.phoneRequired\"> </dv-benutzerprofil> <div class=\"row\" dv-show-expression=\"vm.model.roles.length > 0\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getAllRolesButGesuchsteller()\"> <div class=\"col-sm-2\"> <label>{{'BENUTZERROLLE' | translate}}:</label> </div> <span class=\"col-sm-10\"> <span ng-repeat=\"role in vm.model.roles\">{{vm.translateRole(role) + ($last ? '': ', ')}}</span> </span> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <div class=\"row mainbuttons\"> <div class=\"col-sm-2 col-sm-offset-4\"> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.cancelBenutzeredit()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> <fieldset ng-disabled=\"vm.viewReadonly\"> <div class=\"col-sm-2\"> <dv-loading-button type=\"submit\" button-click=\"vm.submit()\" button-class=\"btn btn-serf\"> <span data-translate=\"BENUTZER_SPEICHERN\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </fieldset> </div> </div> </div> </form> </div> ";

/***/ }),

/***/ "tgNv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RouterHelper = /** @class */ (function () {
    /* @ngInject */
    function RouterHelper($stateProvider, $urlRouterProvider) {
        this.hasOtherwise = false;
        this.stateProvider = $stateProvider;
        this.urlRouterProvider = $urlRouterProvider;
    }
    RouterHelper.prototype.configureStates = function (states, otherwisePath) {
        var _this = this;
        states.forEach(function (state) {
            _this.stateProvider.state(state);
        });
        if (otherwisePath && !this.hasOtherwise) {
            this.hasOtherwise = true;
            this.urlRouterProvider.otherwise(otherwisePath);
        }
    };
    RouterHelper.prototype.getStates = function () {
        return this.stateProvider.$get();
    };
    RouterHelper.$inject = ['$stateProvider', '$urlRouterProvider'];
    return RouterHelper;
}());
exports.RouterHelper = RouterHelper;
var RouterHelperProvider = /** @class */ (function () {
    /* @ngInject */
    function RouterHelperProvider($locationProvider, $stateProvider, $urlRouterProvider) {
        $locationProvider.html5Mode(false);
        this.routerHelper = new RouterHelper($stateProvider, $urlRouterProvider);
    }
    RouterHelperProvider.prototype.$get = function () {
        return this.routerHelper;
    };
    RouterHelperProvider.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider'];
    return RouterHelperProvider;
}());
exports.default = RouterHelperProvider;


/***/ }),

/***/ "tiG2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSExceptionReport_1 = __importDefault(__webpack_require__("PnIR"));
var TSErrorLevel_1 = __webpack_require__("92KJ");
var TSErrorType_1 = __webpack_require__("NSBJ");
var HttpErrorInterceptor = /** @class */ (function () {
    /* @ngInject */
    function HttpErrorInterceptor($rootScope, $q, errorService, $log) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.errorService = errorService;
        this.$log = $log;
        this.responseError = function (response) {
            if (response.status === 403) {
                _this.errorService.addMesageAsError('ERROR_UNAUTHORIZED');
                return _this.$q.reject(response);
            }
            //here we handle all errorcodes except 401 and 403, 401 is handeld in HttpAuthInterceptor
            if (response.status !== 401) {
                //here we could analyze the http status of the response. But instead we check if the  response has the format
                // of a known response such as errortypes such as violationReport or ExceptionReport and transform it
                //as such. If the response matches know expected format we createOrUpdate an unexpected error.
                var errors = _this.handleErrorResponse(response);
                _this.errorService.handleErrors(errors);
                return _this.$q.reject(errors);
            }
            return _this.$q.reject(response);
        };
    }
    /**
     * Tries to determine what kind of response data the error-response retunred and  handles the data object
     * of the response accordingly.
     *
     * The expected types are ViolationReport objects from JAXRS if there was a beanValidation error
     * or EbeguExceptionReports in case there was some other application exception
     *
     * @param response
     */
    HttpErrorInterceptor.prototype.handleErrorResponse = function (response) {
        var errors;
        // Alle daten loggen um das Debuggen zu vereinfachen
        if (this.isDataViolationResponse(response.data)) {
            errors = this.convertViolationReport(response.data);
        }
        else if (this.isDataDvbExceptionReport(response.data)) {
            errors = this.convertEbeguExceptionReport(response.data);
        }
        else {
            this.$log.error('ErrorStatus: "' + response.status + '" StatusText: "' + response.statusText + '"');
            this.$log.error('ResponseData:' + JSON.stringify(response.data));
            //the error objects is neither a ViolationReport nor a ExceptionReport. Create a generic error msg
            errors = [];
            errors.push(new TSExceptionReport_1.default(TSErrorType_1.TSErrorType.INTERNAL, TSErrorLevel_1.TSErrorLevel.SEVERE, 'ERROR_UNEXPECTED', response.data));
            /* else if (this.isFileUploadException(response.data)) {
             errors = [];
             errors.push(new TSExceptionReport(TSErrorType.INTERNAL, TSErrorLevel.SEVERE, 'ERROR_FILE_TOO_LARGE', response.data));
             } */
        }
        return errors;
    };
    HttpErrorInterceptor.prototype.convertViolationReport = function (data) {
        var aggregatedExceptionReports = [];
        return aggregatedExceptionReports.concat(this.convertToExceptionReport(data.parameterViolations))
            .concat(this.convertToExceptionReport(data.classViolations))
            .concat(this.convertToExceptionReport(data.fieldViolations))
            .concat(this.convertToExceptionReport(data.propertyViolations))
            .concat(this.convertToExceptionReport(data.returnValueViolations));
    };
    HttpErrorInterceptor.prototype.convertToExceptionReport = function (violations) {
        var exceptionReports = [];
        if (violations) {
            try {
                for (var violations_1 = __values(violations), violations_1_1 = violations_1.next(); !violations_1_1.done; violations_1_1 = violations_1.next()) {
                    var violationEntry = violations_1_1.value;
                    var constraintType = violationEntry.constraintType;
                    var message = violationEntry.message;
                    var path = violationEntry.path;
                    var value = violationEntry.value;
                    var report = TSExceptionReport_1.default.createFromViolation(constraintType, message, path, value);
                    exceptionReports.push(report);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (violations_1_1 && !violations_1_1.done && (_a = violations_1.return)) _a.call(violations_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return exceptionReports;
        var e_1, _a;
    };
    HttpErrorInterceptor.prototype.convertEbeguExceptionReport = function (data) {
        var exceptionReport = TSExceptionReport_1.default.createFromExceptionReport(data);
        var exceptionReports = [];
        exceptionReports.push(exceptionReport);
        return exceptionReports;
    };
    /**
     *
     * checks if response data json-object has the keys required to be a violationReport (from jaxRS)
     * @param data object whose keys are checked
     * @returns {boolean} true if fields of violationReport are present
     */
    HttpErrorInterceptor.prototype.isDataViolationResponse = function (data) {
        //hier pruefen wir ob wir die Felder von org.jboss.resteasy.api.validation.ViolationReport.ViolationReport() bekommen
        if (data !== null && data !== undefined) {
            var hasParamViol = data.hasOwnProperty('parameterViolations');
            var hasClassViol = data.hasOwnProperty('classViolations');
            var hasfieldViol = data.hasOwnProperty('fieldViolations');
            var hasPropViol = data.hasOwnProperty('propertyViolations');
            var hasRetViol = data.hasOwnProperty('returnValueViolations');
            return hasParamViol && hasClassViol && hasfieldViol && hasPropViol && hasRetViol;
        }
        return false;
    };
    HttpErrorInterceptor.prototype.isDataDvbExceptionReport = function (data) {
        if (data !== null && data !== undefined) {
            var hassErrorCodeEnum = data.hasOwnProperty('errorCodeEnum');
            var hasExceptionName = data.hasOwnProperty('exceptionName');
            var hasMethodName = data.hasOwnProperty('methodName');
            var hasStackTrace = data.hasOwnProperty('stackTrace');
            var hasTranslatedMessage = data.hasOwnProperty('translatedMessage');
            var hasCustomMessage = data.hasOwnProperty('customMessage');
            var hasArgumentList = data.hasOwnProperty('argumentList');
            return hassErrorCodeEnum && hasExceptionName && hasMethodName && hasStackTrace
                && hasTranslatedMessage && hasCustomMessage && hasArgumentList;
        }
        return false;
    };
    HttpErrorInterceptor.prototype.extractArgs = function (data) {
        if (!data) {
            return undefined;
        }
        if (Array.isArray(data.args)) {
            return data.args.filter(function (arg) {
                return arg;
            });
        }
        return [data];
    };
    HttpErrorInterceptor.$inject = ['$rootScope', '$q', 'ErrorService', '$log'];
    return HttpErrorInterceptor;
}());
exports.default = HttpErrorInterceptor;


/***/ }),

/***/ "u0Wo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var TSFremdkostenDaten = /** @class */ (function (_super) {
    __extends(TSFremdkostenDaten, _super);
    function TSFremdkostenDaten() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSFremdkostenDaten.prototype, "firma", {
        get: function () {
            return this._firma;
        },
        set: function (value) {
            this._firma = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFremdkostenDaten.prototype, "firmensitz", {
        get: function () {
            return this._firmensitz;
        },
        set: function (value) {
            this._firmensitz = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFremdkostenDaten.prototype, "leistungsart", {
        get: function () {
            return this._leistungsart;
        },
        set: function (value) {
            this._leistungsart = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFremdkostenDaten.prototype, "rechnungsdatum", {
        get: function () {
            return this._rechnungsdatum;
        },
        set: function (value) {
            this._rechnungsdatum = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFremdkostenDaten.prototype, "rechnungsnummer", {
        get: function () {
            return this._rechnungsnummer;
        },
        set: function (value) {
            this._rechnungsnummer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFremdkostenDaten.prototype, "rechnungsbetrag", {
        get: function () {
            return this._rechnungsbetrag;
        },
        set: function (value) {
            this._rechnungsbetrag = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSFremdkostenDaten.prototype, "berechtigterBetrag", {
        get: function () {
            return this._berechtigterBetrag;
        },
        set: function (value) {
            this._berechtigterBetrag = value;
        },
        enumerable: true,
        configurable: true
    });
    TSFremdkostenDaten.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.firma = restObject.firma;
        this.firmensitz = restObject.firmensitz;
        this.leistungsart = restObject.leistungsart;
        this.rechnungsdatum = DateUtil_1.default.localDateToMoment(restObject.rechnungsdatum);
        this.rechnungsnummer = restObject.rechnungsnummer;
        this.rechnungsbetrag = restObject.rechnungsbetrag;
        this.berechtigterBetrag = restObject.berechtigterBetrag;
        return this;
    };
    TSFremdkostenDaten.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.firma = this.firma;
        restObject.firmensitz = this.firmensitz;
        restObject.leistungsart = this.leistungsart;
        restObject.rechnungsnummer = this.rechnungsnummer;
        restObject.rechnungsbetrag = this.rechnungsbetrag;
        restObject.berechtigterBetrag = this.berechtigterBetrag;
        if (this.rechnungsdatum) {
            restObject.rechnungsdatum = DateUtil_1.default.momentToLocalDate(this.rechnungsdatum);
        }
        return restObject;
    };
    return TSFremdkostenDaten;
}(TSAbstractEntity_1.default));
exports.default = TSFremdkostenDaten;


/***/ }),

/***/ "u72Z":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright © 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt\n * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n */.navbar-sticky{padding-top:0;background-color:#fff;position:fixed;margin-top:-11px!important;width:99.02%;z-index:10}.navbar-sticky+div{padding-bottom:100px;margin-bottom:100px}.dv-gesuch-navigation{margin:-8px;margin-top:27px;margin-bottom:40px}.dv-gesuch-navigation__li{width:100%}.dv-gesuch-navigation__a{margin-left:8px!important;margin-right:8px!important}.dv-gesuch-navigation__a:first-of-type{margin-left:30px!important}.dv-gesuch-navigation__title{margin:0;margin-left:30px}.dv-gesuch-navigation__stickytitle,.dv-gesuch-navigation__title{display:block;-webkit-transition:all .4s ease;transition:all .4s ease}.dv-gesuch-navigation__stickytitle{margin-top:15px;margin-left:30px;font-size:18px;width:300px}.dv-gesuch-navigation__status{display:block;margin:0;margin-left:30px;margin-bottom:10px;font-style:italic;font-size:small;transition:all .4s ease}.dv-gesuch-navigation__status-scale{transform:scaleY(0);height:0;margin:0}.dv-gesuch-navigation__status-scale+.dv-gesuch-navigation__status-scale{display:none}@media(min-width:1275px){.dv-gesuch-navigation{margin:-8px;margin-top:27px;margin-bottom:40px}.dv-gesuch-navigation__li{width:unset}.dv-gesuch-navigation__stickytitle,.dv-gesuch-navigation__title{display:block;margin:-15px 100px 0 200px;width:300px;-webkit-transition:all .4s ease;transition:all .4s ease}.dv-gesuch-navigation__stickytitle{padding-top:28px;font-size:18px}.dv-gesuch-navigation__status{display:block;margin:0 100px 0 200px;font-style:italic;font-size:small}}", ""]);

// exports


/***/ }),

/***/ "u79U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var OkCancelController_1 = __webpack_require__("r+7B");
var abstractModelManagerController_1 = __importDefault(__webpack_require__("S1yE"));
var TSAnlaufstelleType_1 = __webpack_require__("hYoR");
var TSDokumentType_1 = __webpack_require__("/gTe");
var TSKantonCode_1 = __webpack_require__("vEoF");
var TSSprache_1 = __webpack_require__("3oUo");
var TSBenutzer_1 = __importDefault(__webpack_require__("XRVF"));
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
var template = __webpack_require__("NkuY");
var okCancelTemplate = __webpack_require__("CYbW");
__webpack_require__("q4oK");
var AnlaufstelleViewComponentConfig = /** @class */ (function () {
    function AnlaufstelleViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = AnlaufstelleViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            anlaufstelle: '<'
        };
    }
    return AnlaufstelleViewComponentConfig;
}());
exports.AnlaufstelleViewComponentConfig = AnlaufstelleViewComponentConfig;
var AnlaufstelleViewController = /** @class */ (function (_super) {
    __extends(AnlaufstelleViewController, _super);
    /* @ngInject */
    function AnlaufstelleViewController(dvBernUtil, $q, $scope, $log, $state, anlaufstelleRS, passwordStrengthService, errorService, schadenfallModelManager, roleUtilService, authService, dvDialog, CONSTANTS) {
        var _this = _super.call(this, schadenfallModelManager, $scope, $state.current.name) || this;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$log = $log;
        _this.$state = $state;
        _this.anlaufstelleRS = anlaufstelleRS;
        _this.passwordStrengthService = passwordStrengthService;
        _this.errorService = errorService;
        _this.roleUtilService = roleUtilService;
        _this.authService = authService;
        _this.dvDialog = dvDialog;
        _this.CONSTANTS = CONSTANTS;
        _this.sachbearbeiterToAdd = new TSBenutzer_1.default();
        _this.schaetzerToAdd = new TSBenutzer_1.default();
        _this.createNew = true;
        _this.doctype = TSDokumentType_1.TSDocumentType.ANLAUFSTELLE_DOC;
        return _this;
        // super();
    }
    AnlaufstelleViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        if (this.anlaufstelle.id) {
            this.createNew = false;
        }
        if (this.authService.isOneOfRoles(this.roleUtilService.getAdministratorRoles()) || this.anlaufstelle.verwalter === undefined) {
            this.disableVerwalterselection = false;
        }
        else {
            this.disableVerwalterselection = true;
        }
        this.initialModel = this.anlaufstelle;
        this.model = angular.copy(this.anlaufstelle);
    };
    AnlaufstelleViewController.prototype.getTSAnlaufstelleTypeValues = function () {
        return TSAnlaufstelleType_1.getTSAnlaufstelleTypeValues();
    };
    AnlaufstelleViewController.prototype.save = function () {
        var _this = this;
        this.cleanUnnecessaryFields();
        if (this.isModelValid() && this.model) {
            this.anlaufstelleRS.createOrUpdate(this.model).then(function (response) {
                _this.$state.go('anlaufstelleverwaltung');
            });
        }
        this.$log.debug('Form was not valid');
    };
    AnlaufstelleViewController.prototype.cleanUnnecessaryFields = function () {
        if (this.isKantonType()) {
            this.model.gemeinden = [];
        }
        else {
            this.model.kanton = undefined; //wenn wir den Kanton nicht brauchen nullen wir ihn
        }
        // entfernen von moeglicherweise invaliden emails fuer schaeter und sachbearbeiter
        this.sachbearbeiterToAdd = new TSBenutzer_1.default();
        this.schaetzerToAdd = new TSBenutzer_1.default();
    };
    /**
     * Diese Methode prueft ob das Form valid ist. Sollte es nicht valid sein wird das erste fehlende Element gesucht
     * und fokusiert, damit der Benutzer nicht scrollen muss, um den Fehler zu finden.
     * Am Ende wird this.form.$valid zurueckgegeben
     */
    AnlaufstelleViewController.prototype.isModelValid = function () {
        if (!this.form.$valid) {
            DVBernUtil_1.default.focusFirstInvalidInput();
        }
        return this.form.$valid;
    };
    AnlaufstelleViewController.prototype.addGemeinde = function () {
        if (this.gemeindeToAdd) {
            this.model.gemeinden.push(this.gemeindeToAdd);
        }
        this.gemeindeToAdd = undefined;
    };
    AnlaufstelleViewController.prototype.deleteClicked = function (gemeindeToDelete, event) {
        var index = DVBernUtil_1.default.getIndexOfElementwithID(gemeindeToDelete, this.model.gemeinden);
        if (index > -1) {
            this.model.gemeinden.splice(index, 1);
        }
    };
    AnlaufstelleViewController.prototype.isKantonType = function () {
        return this.model.anlaufstelleType !== undefined && this.model.anlaufstelleType === TSAnlaufstelleType_1.TSAnlaufstelleType.KANTON;
    };
    AnlaufstelleViewController.prototype.cancel = function () {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('anlaufstelleverwaltung');
    };
    AnlaufstelleViewController.prototype.kantonList = function () {
        return TSKantonCode_1.getKantonCodeList();
    };
    AnlaufstelleViewController.prototype.translateKanton = function (kantonCode) {
        return TSKantonCode_1.TSKantonCode[kantonCode];
    };
    AnlaufstelleViewController.prototype.getSchaetzer = function () {
        return this.getModel().schaetzer;
    };
    AnlaufstelleViewController.prototype.setSchaetzer = function (collectionOfSB) {
        this.getModel().schaetzer = collectionOfSB;
    };
    AnlaufstelleViewController.prototype.getSachbearbeiter = function () {
        return this.getModel().sachbearbeiter;
    };
    AnlaufstelleViewController.prototype.setSachbearbeiter = function (collectionOfSB) {
        this.getModel().sachbearbeiter = collectionOfSB;
    };
    AnlaufstelleViewController.prototype.addSchaetzer = function () {
        if (this.form.schaetzerEmail.$invalid ||
            !this.schaetzerToAdd || !this.schaetzerToAdd.email
            || this.alreadyPresent(this.getSchaetzer(), this.schaetzerToAdd.email)) {
            return;
        }
        this.schaetzerToAdd.korrespondenzsprache = this.anlaufstelle.verwalter ? this.anlaufstelle.verwalter.korrespondenzsprache : TSSprache_1.TSSprache.DEUTSCH;
        this.getSchaetzer().push(this.schaetzerToAdd);
        this.schaetzerToAdd = new TSBenutzer_1.default();
    };
    AnlaufstelleViewController.prototype.addSachbearbeiter = function () {
        if (this.form.sachbearbeiterEmail.$invalid
            || !this.sachbearbeiterToAdd || !this.sachbearbeiterToAdd.email
            || this.alreadyPresent(this.getSachbearbeiter(), this.sachbearbeiterToAdd.email)) {
            return;
        }
        this.sachbearbeiterToAdd.korrespondenzsprache = this.anlaufstelle.verwalter ? this.anlaufstelle.verwalter.korrespondenzsprache : TSSprache_1.TSSprache.DEUTSCH;
        this.getSachbearbeiter().push(this.sachbearbeiterToAdd);
        this.sachbearbeiterToAdd = new TSBenutzer_1.default();
    };
    AnlaufstelleViewController.prototype.removeSchaetzer = function (benutzer, event) {
        if (benutzer) {
            var arrWithoutEle = this.getSchaetzer().filter(function (currentBen) { return currentBen !== benutzer; });
            this.setSchaetzer(arrWithoutEle);
        }
    };
    AnlaufstelleViewController.prototype.removeSachbearbeiter = function (benutzer, event) {
        if (benutzer) {
            var arrWithoutEle = this.getSachbearbeiter().filter(function (currentBen) { return currentBen !== benutzer; });
            this.setSachbearbeiter(arrWithoutEle);
        }
    };
    AnlaufstelleViewController.prototype.enableVerwalterselection = function () {
        var _this = this;
        var text = 'CONFIRM_VERWALTERCHANGE';
        this.dvDialog.showDialog(okCancelTemplate, OkCancelController_1.OkCancelController, { text: text })
            .then(function () {
            _this.disableVerwalterselection = false;
        })
            .catch(function () {
        });
    };
    AnlaufstelleViewController.prototype.alreadyPresent = function (sachbearbeiter, email) {
        return sachbearbeiter.find(function (value) { return value.email === email; }) !== undefined;
    };
    AnlaufstelleViewController.$inject = ['DVBernUtil', '$q', '$scope', '$log', '$state', 'AnlaufstelleRS', 'PasswordStrengthService',
        'ErrorService', 'SchadenfallModelManager', 'RoleUtilService', 'AuthServiceRS', 'DvDialog', 'CONSTANTS'];
    return AnlaufstelleViewController;
}(abstractModelManagerController_1.default));
exports.AnlaufstelleViewController = AnlaufstelleViewController;


/***/ }),

/***/ "u87A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
var applicationPropertyRS_rest_1 = __webpack_require__("s031");
var serfPropertyRS_rest_1 = __webpack_require__("aiEq");
var authentication_module_1 = __webpack_require__("Lcj6");
var router_module_1 = __importDefault(__webpack_require__("xtsM"));
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
var dv_accordion_1 = __webpack_require__("4wPR");
var dv_accordion_tab_1 = __webpack_require__("RFuZ");
var dv_adresse_1 = __webpack_require__("5MYH");
var dv_alert_box_1 = __webpack_require__("tG31");
var dv_anlaufstelle_list_1 = __webpack_require__("/PRC");
var dv_auszahlung_1 = __webpack_require__("7UW1");
var dv_bar_charts_1 = __webpack_require__("l1kH");
var dv_bemerkung_erfassen_1 = __webpack_require__("i/zj");
var dv_bemerkung_list_1 = __webpack_require__("wPJl");
var dv_benutzer_list_1 = __webpack_require__("MHRu");
var dv_benutzerprofil_1 = __webpack_require__("C9tV");
var dv_betrag_1 = __webpack_require__("VptV");
var dv_bisher_1 = __webpack_require__("g0B/");
var dv_checklist_1 = __webpack_require__("hw4h");
var dv_dokumentupload_1 = __webpack_require__("RmK+");
var dv_eigenleistungen_list_1 = __webpack_require__("X9l8");
var dv_error_messages_1 = __webpack_require__("Wqd1");
var dv_fremdkosten_list_1 = __webpack_require__("xqA5");
var dv_genossenschaft_1 = __webpack_require__("hF3f");
var dv_geoadmin_map_1 = __webpack_require__("m6Fg");
var dv_geoadmin_search_1 = __webpack_require__("gs8D");
var dv_gesuch_navigation_1 = __webpack_require__("K7pJ");
var dv_gesuchsteller_1 = __webpack_require__("Xat7");
var dv_home_icon_1 = __webpack_require__("8Mxj");
var dv_iban_input_1 = __webpack_require__("9Qvs");
var dv_input_container_1 = __webpack_require__("+E2v");
var dv_inspektorat_list_1 = __webpack_require__("baAg");
var dv_koerperschaft_1 = __webpack_require__("DkCC");
var dv_kontakt_person_1 = __webpack_require__("UBcp");
var dv_languageselect_1 = __webpack_require__("f17n");
var dv_leistungsempfaenger_1 = __webpack_require__("EBY0");
var dv_map_1 = __webpack_require__("XeaR");
var dv_password_changer_1 = __webpack_require__("S2P7");
var dv_pie_charts_1 = __webpack_require__("keDS");
var dv_schaden_list_1 = __webpack_require__("97eG");
var dv_schaden_1 = __webpack_require__("zQEh");
var dv_schadenfaelle_list_1 = __webpack_require__("9rlH");
var dv_status_change_history_list_1 = __webpack_require__("J/Xo");
var dv_string_input_1 = __webpack_require__("UorB");
var dv_text_value_1 = __webpack_require__("Pcuo");
var dv_tooltip_1 = __webpack_require__("JRTc");
var dv_anlaufstelle_typeahead_1 = __webpack_require__("M07A");
var dv_benutzer_typeahead_1 = __webpack_require__("rnKj");
var dv_gemeinde_typeahead_1 = __webpack_require__("+iIj");
var dv_versicherung_navigation_1 = __webpack_require__("bCl4");
var dv_versicherungsbeitrag_list_1 = __webpack_require__("Lpwx");
var dv_version_1 = __webpack_require__("ZQAi");
var dv_vorleistungen_list_1 = __webpack_require__("AFTI");
var dv_zahlungen_list_1 = __webpack_require__("cAJG");
var dv_zahlungsauftrag_list_1 = __webpack_require__("VCRP");
var config_1 = __webpack_require__("Mnzi");
__webpack_require__("tOSr");
var core_route_1 = __webpack_require__("bydc");
var dv_date_range_1 = __webpack_require__("lTSD");
var dv_datepicker_1 = __webpack_require__("d0qO");
var dv_dialog_1 = __webpack_require__("ZJws");
var dv_loading_button_1 = __webpack_require__("m4lS");
var dv_http_loading_1 = __webpack_require__("mxiP");
var dv_loading_1 = __webpack_require__("pxZP");
var dv_max_length_1 = __importDefault(__webpack_require__("wurJ"));
var dv_pagination_1 = __webpack_require__("RhHQ");
var dv_schadenfaelle_list_persist_1 = __importDefault(__webpack_require__("WyAS"));
var dv_scroll_nav_1 = __importDefault(__webpack_require__("SOKL"));
var dv_show_ement_1 = __webpack_require__("Q2lU");
var DVRoleElementController_1 = __webpack_require__("JWBy");
var dv_st_table_refresh_1 = __importDefault(__webpack_require__("Uj2y"));
var dv_valueinput_1 = __webpack_require__("O2FA");
var errors_1 = __webpack_require__("vWWF");
var HttpResponseInterceptor_1 = __importDefault(__webpack_require__("ftfs"));
var AnlaufstelleRS_rest_1 = __importDefault(__webpack_require__("k1nX"));
var batchRS_rest_1 = __importDefault(__webpack_require__("vAzW"));
var BegruendungscodeMapperService_1 = __importDefault(__webpack_require__("KDKC"));
var BeitragRS_1 = __importDefault(__webpack_require__("GbIU"));
var bemerkungRS_rest_1 = __importDefault(__webpack_require__("WdgM"));
var BenutzerRS_rest_1 = __importDefault(__webpack_require__("OKZ8"));
var BerechtigungsService_1 = __importDefault(__webpack_require__("P6Xd"));
var cockpitRS_rest_1 = __importDefault(__webpack_require__("Sckn"));
var dokumenteRS_rest_1 = __importDefault(__webpack_require__("mPIz"));
var downloadRS_rest_1 = __webpack_require__("xioF");
var EigenleistungenRS_1 = __importDefault(__webpack_require__("mezm"));
var FilterPersistenceService_1 = __importDefault(__webpack_require__("PYvH"));
var FondssuisseRS_rest_1 = __importDefault(__webpack_require__("XTXf"));
var FremdkostenRS_1 = __importDefault(__webpack_require__("ROEt"));
var GemeindeRS_rest_1 = __importDefault(__webpack_require__("gcTH"));
var HttpVersionInterceptor_1 = __importDefault(__webpack_require__("HsPv"));
var InspektoratRS_rest_1 = __importDefault(__webpack_require__("Gbao"));
var isNeuInStatusService_1 = __importDefault(__webpack_require__("8/Tw"));
var NavigationLogger_1 = __webpack_require__("olHO");
var OverdueService_1 = __importDefault(__webpack_require__("vom2"));
var PageNameConstants_1 = __webpack_require__("QMRd");
var PasswordStrengthService_1 = __importDefault(__webpack_require__("Adl6"));
var PiwikService_1 = __importDefault(__webpack_require__("GJ89"));
var reportAsyncRS_rest_1 = __webpack_require__("XOsk");
var RoleUtilService_1 = __importDefault(__webpack_require__("grUW"));
var SchadenfallModelManager_1 = __importDefault(__webpack_require__("GoBd"));
var schadenfallRS_rest_1 = __importDefault(__webpack_require__("HXt9"));
var schadenRS_rest_1 = __importDefault(__webpack_require__("yoYn"));
var StatuswechselService_1 = __importDefault(__webpack_require__("4NcG"));
var uploadRS_rest_1 = __webpack_require__("V2/k");
var VereinbarungAkzeptiertService_1 = __importDefault(__webpack_require__("D/ui"));
var versicherungRS_rest_1 = __importDefault(__webpack_require__("IGio"));
var VersicherungsbeitragModelManager_1 = __importDefault(__webpack_require__("5kWG"));
var versicherungsbeitragRS_rest_1 = __importDefault(__webpack_require__("dzCK"));
var VorleistungenRS_1 = __importDefault(__webpack_require__("3wrz"));
var ZahlungsauftragRS_rest_1 = __importDefault(__webpack_require__("ARKx"));
var menubar_1 = __webpack_require__("uh5A");
var dynamicDependencies = function () {
    var dynDep = [];
    //hier kommen plugins die wir fuer dev disablen wollen
    if (true) {
        return ['ngRaven'];
    }
    if (false) {
        return [];
    }
    return dynDep;
};
var dependencies = [
    /* Angular modules */
    'ngAnimate',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ngCookies',
    /* shared DVBern modules */
    router_module_1.default.name,
    errors_1.DVBernErrors.name,
    authentication_module_1.SerfWebAuthentication.name,
    /* 3rd-party modules */
    'ui.bootstrap',
    'smart-table',
    'ngMessages',
    'pascalprecht.translate',
    'angularMoment',
    'vcRecaptcha',
    'ngSanitize',
    'ui.select',
    'ngFileUpload',
    'ngMap',
    'ngMapAutocomplete',
    'unsavedChanges',
];
exports.SerfWebCore = angular
    .module('serfWeb.core', dependencies.concat(dynamicDependencies()))
    .run(core_route_1.appRun)
    .config(config_1.configure)
    .constant('REST_API', '/serf/api/v1/')
    .constant('MAX_LENGTH', 255)
    .constant('CONSTANTS', {
    name: 'SERF',
    REST_API: '/serf/api/v1/',
    MAX_LENGTH: 255,
    PATTERN_BETRAG: '([0-9]{0,12})',
    PATTERN_PERCENTAGE: '^[0-9][0-9]?$|^100$',
    PATTERN_PHONE: '(0|\\+41|0041)\\s?([\\d]{2})\\s?([\\d]{3})\\s?([\\d]{2})\\s?([\\d]{2})',
    PATTERN_PHONE_OPTIONAL: '(^$|^(0|\\+41|0041)\\s?([\\d]{2})\\s?([\\d]{3})\\s?([\\d]{2})\\s?([\\d]{2})$)',
    PATTERN_MOBILE: '(0|\\+41|0041)\\s?(74|75|76|77|78|79)\\s?([\\d]{3})\\s?([\\d]{2})\\s?([\\d]{2})',
    PATTERN_EMAIL: '[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}',
})
    .constant('PAGE_NAMES', new PageNameConstants_1.PageNameConstants())
    .directive('dvLoading', dv_loading_1.DVLoading.factory())
    .directive('dvHttpLoading', dv_http_loading_1.DVHTTPLoading.factory())
    .directive('dvLoadingButton', dv_loading_button_1.DVLoadingButton.factory())
    .directive('dvMaxLength', dv_max_length_1.default.factory())
    .directive('dvScrollNav', dv_scroll_nav_1.default.factory())
    .directive('dvStTableRefresh', dv_st_table_refresh_1.default.factory())
    .directive('dvDatepicker', dv_datepicker_1.DVDatepicker.factory())
    .directive('dvShowElement', dv_show_ement_1.DVShowElement.factory())
    .directive('dvValueinput', dv_valueinput_1.DVValueinput.factory())
    .directive('dvDateRange', dv_date_range_1.DvDateRange.factory())
    .directive('dvPagination', dv_pagination_1.DvPagination.factory())
    .directive('dvSchadenfaelleListPersist', dv_schadenfaelle_list_persist_1.default.factory())
    .component('dvBenutzerList', new dv_benutzer_list_1.DVBenutzerListComponentConfig())
    .component('dvAnlaufstelleList', new dv_anlaufstelle_list_1.DVAnlaufstelleListComponentConfig())
    .component('dvInspektoratList', new dv_inspektorat_list_1.DVInspektoratListComponentConfig)
    .component('dvEigenleistungenList', new dv_eigenleistungen_list_1.DVEigenleistungenListComponentConfig())
    .component('dvSchadenList', new dv_schaden_list_1.DVSchadenListComponentConfig())
    .component('dvBemerkungList', new dv_bemerkung_list_1.DVBemerkungListComponentConfig())
    .component('dvStatusChangeHistoryList', new dv_status_change_history_list_1.DVStatusChangeHistoryComponentConfig())
    .component('dvBemerkungErfassen', new dv_bemerkung_erfassen_1.DVBemerkungErfassenComponentConfig())
    .component('dvChecklist', new dv_checklist_1.DVChecklistComponentConfig())
    .component('dvFremdkostenList', new dv_fremdkosten_list_1.DVFremdkostenListComponentConfig())
    .component('dvVorleistungenList', new dv_vorleistungen_list_1.DVVorleistungenListComponentConfig())
    .component('dvBenutzerprofil', new dv_benutzerprofil_1.DVBenutzerprofilComponentConfig())
    .component('dvErrorMessages', new dv_error_messages_1.DvErrorMessagesComponentConfig())
    .component('dvAlertBox', new dv_alert_box_1.DvAlertBoxComponentConfig())
    .component('dvGesuchNavigation', new dv_gesuch_navigation_1.DvGesuchNavigationComponentConfig())
    .component('dvVersicherungNavigation', new dv_versicherung_navigation_1.DvVersicherungNavigationComponentConfig())
    .component('dvPasswordChanger', new dv_password_changer_1.DVPasswordChangerComponentConfig())
    .component('dvTooltip', new dv_tooltip_1.DvTooltipComponentConfig())
    .component('dvHomeIcon', new dv_home_icon_1.DvHomeIconComponentConfig())
    .component('dvSchadenfaelleList', new dv_schadenfaelle_list_1.DVSchadenfaelleListConfig())
    .component('dvZahlungenList', new dv_zahlungen_list_1.DVZahlungenListConfig())
    .component('dvZahlungsauftragList', new dv_zahlungsauftrag_list_1.DVZahlungsauftragListConfig())
    .component('dvInputContainer', new dv_input_container_1.DvInputContainerComponentConfig())
    .component('menubar', new menubar_1.MenubarComponentConfig)
    .component('dvLanguageselect', new dv_languageselect_1.DVLanguageSelectComponentConfig)
    .component('dvAdresse', new dv_adresse_1.AdresseComponentConfig())
    .component('dvLeistungsempfaenger', new dv_leistungsempfaenger_1.LeistungsempfaengerComponentConfig())
    .component('dvBetrag', new dv_betrag_1.BetragComponentConfig())
    .component('dvAuszahlung', new dv_auszahlung_1.AuszahlungComponentConfig())
    .component('dvStringInput', new dv_string_input_1.StringInputComponentConfig())
    .component('dvIbanInput', new dv_iban_input_1.IbanInputComponentConfig())
    .component('dvKontaktPerson', new dv_kontakt_person_1.KontaktPersonComponentConfig())
    .component('dvGenossenschaft', new dv_genossenschaft_1.GenossenschaftComponentConfig())
    .component('dvGesuchsteller', new dv_gesuchsteller_1.GesuchstellerComponentConfig)
    .component('dvKoerperschaft', new dv_koerperschaft_1.KoerperschaftComponentConfig())
    .component('dvSchaden', new dv_schaden_1.SchadenComponentConfig())
    .component('dvMap', new dv_map_1.MapComponentConfig())
    .component('dvGeoadminMap', new dv_geoadmin_map_1.GeoAdminMapComponentConfig())
    .component('dvGeoadminSearch', new dv_geoadmin_search_1.GeoAdminSearchComponentConfig())
    .component('dvPieCharts', new dv_pie_charts_1.DvPieChartsComponentConfig())
    .component('dvBarCharts', new dv_bar_charts_1.DvBarChartsComponentConfig())
    .component('dvTextValue', new dv_text_value_1.DvTextValueComponentConfig())
    .component('dvAnlaufstelleTypeahead', new dv_anlaufstelle_typeahead_1.DVAnlaufstelleTypeaheadComponentConfig())
    .component('dvGemeindeTypeahead', new dv_gemeinde_typeahead_1.DVGemeindeTypeaheadComponentConfig())
    .component('dvBenutzerTypeahead', new dv_benutzer_typeahead_1.DVBenutzerTypeaheadComponentConfig())
    .component('dvDokumentupload', new dv_dokumentupload_1.DVDokumentuploadComponentConfig())
    .component('dvAccordion', new dv_accordion_1.DvAccordionComponentConfig())
    .component('dvAccordionTab', new dv_accordion_tab_1.DvAccordionTabComponentConfig())
    .component('dvBisher', new dv_bisher_1.DvBisherComponentConfig())
    .component('dvVersion', new dv_version_1.DVVersionComponentConfig())
    .component('dvVersicherungsbeitragList', new dv_versicherungsbeitrag_list_1.DVVersicherungsbeitragListConfig())
    .controller('DVElementController', DVRoleElementController_1.DVRoleElementController)
    .service('ApplicationPropertyRS', applicationPropertyRS_rest_1.ApplicationPropertyRS)
    .service('SerfPropertyRS', serfPropertyRS_rest_1.SerfPropertyRS)
    .service('SchadenfallModelManager', SchadenfallModelManager_1.default)
    .service('VersicherungsbeitragModelManager', VersicherungsbeitragModelManager_1.default)
    .service('DVBernUtil', DVBernUtil_1.default)
    .service('PasswordStrengthService', PasswordStrengthService_1.default)
    .service('FilterPersistenceService', FilterPersistenceService_1.default)
    .service('BegruendungscodeMapperService', BegruendungscodeMapperService_1.default)
    .service('VereinbarungAkzeptiertService', VereinbarungAkzeptiertService_1.default)
    .service('RoleUtilService', RoleUtilService_1.default)
    .service('PiwikService', PiwikService_1.default)
    .service('StatuswechselService', StatuswechselService_1.default)
    .service('BerechtigungsService', BerechtigungsService_1.default)
    .service('OverdueService', OverdueService_1.default)
    .service('IsNeuInStatusService', isNeuInStatusService_1.default)
    .service('BenutzerRS', BenutzerRS_rest_1.default)
    .service('AnlaufstelleRS', AnlaufstelleRS_rest_1.default)
    .service('InspektoratRS', InspektoratRS_rest_1.default)
    .service('FondssuisseRS', FondssuisseRS_rest_1.default)
    .service('GemeindeRS', GemeindeRS_rest_1.default)
    .service('DvDialog', dv_dialog_1.DvDialog)
    .service('HttpResponseInterceptor', HttpResponseInterceptor_1.default)
    .service('HttpVersionInterceptor', HttpVersionInterceptor_1.default)
    .service('SchadenfallRS', schadenfallRS_rest_1.default)
    .service('VersicherungsbeitragRS', versicherungsbeitragRS_rest_1.default)
    .service('VersicherungRS', versicherungRS_rest_1.default)
    .service('UploadRS', uploadRS_rest_1.UploadRS)
    .service('FremdkostenRS', FremdkostenRS_1.default)
    .service('EigenleistungenRS', EigenleistungenRS_1.default)
    .service('NavigationLogger', NavigationLogger_1.NavigationLogger)
    .service('VorleistungenRS', VorleistungenRS_1.default)
    .service('BeitragRS', BeitragRS_1.default)
    .service('ZahlungsauftragRS', ZahlungsauftragRS_rest_1.default)
    .service('DokumenteRS', dokumenteRS_rest_1.default)
    .service('DownloadRS', downloadRS_rest_1.DownloadRS)
    .service('SchadenRS', schadenRS_rest_1.default)
    .service('BemerkungRS', bemerkungRS_rest_1.default)
    .service('ReportAsyncRS', reportAsyncRS_rest_1.ReportAsyncRS)
    .service('BatchJobRS', batchRS_rest_1.default)
    .service('CockpitRS', cockpitRS_rest_1.default)
    .filter('arrayToString', function () {
    return function (input) {
        return input.join(', ');
    };
});


/***/ }),

/***/ "uAg/":
/***/ (function(module, exports) {

module.exports = "<div class=\"migration-view container\"> <div class=\"row\"> <div class=\"col-md-12\"> <div class=\"page-header\"> <h1 data-translate=\"MIGRATION\"></h1> </div> </div> </div> <div class=\"row\"> <div class=\"col-md-12\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <div class=\"row\"> <div class=\"col-sm-12\"> <span data-translate=\"MIGRATION_IMPORT_DESCRIPTION\"></span> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <button type=\"button\" ng-click=\"vm.importPersonen()\" class=\"btn btn-serf\">Import Personen</button> </div> </div> <div class=\"row\"> <div class=\"col-sm-12 marginTop20\"> <button type=\"button\" ng-click=\"vm.importGemeinden()\" class=\"btn btn-serf\">Import Gemeinden</button> </div> </div> <div class=\"row marginTop20\"> <div class=\"col-sm-12\"> <button type=\"button\" ng-click=\"vm.importschadenfaelle()\" class=\"btn btn-serf\">Import Schadenfaelle</button> </div> </div> <div class=\"row marginTop20\"> <div class=\"col-sm-2\"> <input ng-model=\"vm.personId\" placeholder=\"personId\"> </div> <div class=\"col-sm-10\"> <button type=\"button\" ng-click=\"vm.importGesuchsteller()\" class=\"btn btn-serf\">Import Gesuchsteller</button> </div> </div> <div class=\"row marginTop20\"> <div class=\"col-sm-2\"> <input ng-model=\"vm.schadenId\" placeholder=\"schadenId\"> </div> <div class=\"col-sm-10\"> <button type=\"button\" ng-click=\"vm.importBeitragForSchaden()\" class=\"btn btn-serf\">Import Beitrag fuer Schaden</button> </div> </div> </form> </div> </div> </div> ";

/***/ }),

/***/ "uQ8n":
/***/ (function(module, exports) {

module.exports = " <form class=\"dv-gesuchsteller\" name=\"vm.form\" novalidate role=\"form\" unsaved-warning-form> <div class=\"row\" ng-if=\"vm.showTitlePrefix()\"> <div class=\"col-sm-12\"> <h1 class=\"gesuchsteller-title\"> <span data-translate=\"GESUCHSTELLER_TITLE\" data-translate-value-eigentumsverhaeltnis=\"{{vm.model.eigentumsverhaeltnis | translate}}\"></span> </h1> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <h2 class=\"marginTop0 h2-gesuchsteller\"> <span class=\"h2-prefix\" ng-if=\"vm.showTitlePrefix()\">{{vm.model.eigentumsverhaeltnis | translate}}</span> <span data-translate=\"RECHTSFORM_TITLE\"></span> </h2> </div> <div class=\"col-sm-4 dv-input-container-medium\"> <div class=\"form-group\"> <div class=\"dv-select-style\"> <select class=\"form-control\" id=\"{{vm.prefix}}_rechtsform_id\" name=\"rechtsform\" ng-change=\"vm.changedRechtsform()\" ng-model=\"vm.model.rechtsform\" ng-options=\"(vm.translateRechtsform(rechtsform)) for rechtsform in vm.getTSRechtsformen() track by rechtsform\" ng-required=\"true\"> </select> <dv-error-messages for=\"vm.form.rechtsform\"></dv-error-messages> </div> </div> </div> </div> <dv-genossenschaft angabe=\"{{vm.showTitlePrefix() ? vm.model.eigentumsverhaeltnis : ''}}\" gesellschaft=\"vm.checkRechtsform('MEHRPERSONENGESELLSCHAFT')\" model=\"vm.model.genossenschaft\" name=\"{{vm.prefix}}-genossenschaft\" ng-if=\"vm.checkRechtsform('GENOSSENSCHAFT') || vm.checkRechtsform('MEHRPERSONENGESELLSCHAFT')\" on-steuerpflicht-changed=\"vm.steuerpflichtChanged(event)\" zweitperson=\"vm.model.isZweitperson\"> </dv-genossenschaft> <dv-koerperschaft angabe=\"{{vm.showTitlePrefix() ? vm.model.eigentumsverhaeltnis : ''}}\" model=\"vm.model.koerperschaft\" name=\"{{vm.prefix}}-koerperschaft\" ng-if=\"vm.checkRechtsform('ANDERE_KOERPERSCHAFT')\"> </dv-koerperschaft> <div class=\"row\" ng-if=\"vm.checkRechtsform('NATUERLICHE_PERSON')\"> <div class=\"col-sm-12\"> <h2 class=\"h2-gesuchsteller\"> <span class=\"h2-prefix\" ng-if=\"vm.showTitlePrefix()\">{{vm.model.eigentumsverhaeltnis | translate}}</span> <span data-translate=\"KONTAKTANGABEN_TITLE\"></span> </h2> </div> <div class=\"dv-input-container-medium\"> <div class=\"col-sm-12\"> <dv-kontakt-person dont-show-adresse=\"false\" email-not-required=\"vm.emailNotRequired\" dont-show-email=\"vm.emailNotRequired\" model=\"vm.model.kontaktperson\" name=\"{{vm.prefix}}-gesuchsteller\" phone-required=\"vm.phoneRequired\"></dv-kontakt-person> </div> </div> </div> <fieldset dv-show-allowed-roles=\"vm.getRolesAllowedForSteuerdaten()\" dv-show-element dv-show-expression=\"vm.showFinanzVerhaeltnisse()\"> <div class=\"row\"> <div class=\"col-sm-12\"> <h2 class=\"h2-gesuchsteller\"> <span class=\"h2-prefix\" ng-if=\"vm.showTitlePrefix()\">{{vm.model.eigentumsverhaeltnis | translate}}</span> <span data-translate=\"FINANZIELLE_VERHAELTNISSE\"></span> </h2> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\"> <div class=\"form-group\"> <div class=\"row\"> <div class=\"col-sm-4\"> <dv-input-container> <label for=\"{{vm.prefix}}-steuerjahrId\" ng-bind=\"vm.getJahrtext(vm.model.rechtsform)\"></label> <input class=\"form-control no-step-arrow\" dv-max-length id=\"{{vm.prefix}}-steuerjahrId\" max=\"{{vm.currentYear}}\" min=\"1950\" name=\"steuerjahr\" ng-change=\"vm.clearSteuerdatenGeprueft()\" ng-model=\"vm.model.finanzangaben.finanzangabenDatenFS.steuerjahr\" ng-required=\"!vm.isSchadenFallNeuOnlineOderNeuPapier() && !vm.versicherungsmode\" type=\"number\"/> <dv-error-messages for=\"vm.form.steuerjahr\"></dv-error-messages> <dv-bisher for=\"vm.form.steuerjahr\" forcestring fs=\"vm.model.finanzangaben.finanzangabenDatenFS\" gs=\"vm.model.finanzangaben.finanzangabenDatenGS\" property=\"steuerjahr\"></dv-bisher> </dv-input-container> </div> <div class=\"col-sm-4\"> <dv-input-container> <label for=\"{{vm.prefix}}-einkommenGewinnId\" ng-bind=\"vm.getEinkommenGewinnText()\"></label> <dv-valueinput allow-negative=\"true\" class=\"input-element\" input-id=\"{{vm.prefix}}-einkommenGewinnId\" input-name=\"einkommenGewinn\" name=\"einkommenGewinn\" ng-change=\"vm.clearSteuerdatenGeprueft()\" ng-model=\"vm.model.finanzangaben.finanzangabenDatenFS.einkommenGewinn\" ng-required=\"!vm.isSchadenFallNeuOnlineOderNeuPapier() && !vm.versicherungsmode\"> </dv-valueinput> <dv-error-messages for=\"vm.form.einkommenGewinn\"></dv-error-messages> <dv-bisher decimal=\"0\" for=\"vm.form.einkommenGewinn\" fs=\"vm.model.finanzangaben.finanzangabenDatenFS\" gs=\"vm.model.finanzangaben.finanzangabenDatenGS\" property=\"einkommenGewinn\"></dv-bisher> </dv-input-container> </div> <div class=\"col-sm-4\"> <dv-input-container> <label for=\"{{vm.prefix}}-vermoegenKapitalId\" ng-bind=\"vm.getVermoegenKapitalText()\"></label> <dv-valueinput allow-negative=\"true\" class=\"input-element\" input-id=\"{{vm.prefix}}-vermoegenKapitalId\" input-name=\"vermoegenKapital\" name=\"vermoegenKapital\" ng-change=\"vm.clearSteuerdatenGeprueft()\" ng-model=\"vm.model.finanzangaben.finanzangabenDatenFS.vermoegenKapital\" ng-required=\"!vm.isSchadenFallNeuOnlineOderNeuPapier() && !vm.versicherungsmode\"> </dv-valueinput> <dv-error-messages for=\"vm.form.vermoegenKapital\"></dv-error-messages> <dv-bisher decimal=\"0\" for=\"vm.form.vermoegenKapital\" fs=\"vm.model.finanzangaben.finanzangabenDatenFS\" gs=\"vm.model.finanzangaben.finanzangabenDatenGS\" property=\"vermoegenKapital\"></dv-bisher> </dv-input-container> </div> </div> </div> </div> </div> <div class=\"row\" ng-if=\"!vm.versicherungsmode  && !vm.model.isZweitperson\"> <div class=\"col-sm-12\"> <dv-alert-box alert-type=\"info\" ng-if=\"(vm.model.finanzangaben.finanzangabenDatenFS.einkommenGewinn !== undefined) &&\n                                        (vm.model.finanzangaben.finanzangabenDatenFS.vermoegenKapital !== undefined)\"> <span data-translate=\"MINIMAL_SCHADEN_EINKOMMEN\" ng-if=\"!vm.isBerechtigtEinkommen()\"></span> <span data-translate=\"{{vm.getMinimalSchadenVermoegenText()}}\" ng-if=\"!vm.isBerechtigtVermoegen()\"></span> <span data-translate=\"MINIMAL_SCHADEN\" data-translate-value-abzug=\"{{vm.getGesamtAbzug() | number :0}}\" ng-if=\"vm.isBerechtigtEinkommen() && vm.isBerechtigtVermoegen()\"></span> <button class=\"btn-link\" ng-click=\"vm.openBerechnungsdetail()\" ng-if=\"vm.isBerechtigtEinkommen() && vm.isBerechtigtVermoegen()\" style=\"flex-grow:0;margin-right:auto;padding-left:0;border-left:0\" type=\"button\"> <span data-translate=\"BERECHNUNGSDETAIL_ANSCHAUEN\"></span> </button> </dv-alert-box> </div> <div class=\"col-sm-12\" ng-if=\"vm.showZustimmungSteuerpruefung() && !vm.versicherungsmode\"> <dv-input-container> <div class=\"checkbox\"> <label> <input class=\"input-element\" id=\"{{vm.prefix}}-zustimmungSteuerpruefung\" name=\"zustimmungSteuerpruefung\" ng-disabled=\"vm.getZustimmungGesuchstellerReadonly()\" ng-model=\"vm.model.finanzangaben.zustimmungSteuerpruefung\" ng-required=\"true\" ng-value=\"zustimmungSteuerpruefung\" type=\"checkbox\"> <span class=\"md-no-float\" ng-bind=\"vm.getZustimmungSteuerpruefungText()\"></span> <dv-error-messages for=\"vm.form.zustimmungSteuerpruefung\"></dv-error-messages> </label> </div> </dv-input-container> </div> <div class=\"col-sm-12\" dv-show-allowed-roles=\"vm.getRolesAllowedForSteuerdatenPruefung()\" dv-show-element dv-show-expression=\"!vm.versicherungsmode\"> <dv-input-container> <div class=\"checkbox\"> <label> <input class=\"input-element\" id=\"{{vm.prefix}}-steuerdatenGeprueft\" name=\"steuerdatenGeprueft\" ng-model=\"vm.model.finanzangaben.steuerdatenGeprueft\" ng-required=\"!vm.isSchadenFallNeuOnlineOderNeuPapier()\" ng-value=\"steuerdatenGeprueft\" type=\"checkbox\"> <span class=\"md-no-float\" data-translate=\"STEUERDATEN_GEPRUEFT\"></span> <dv-error-messages for=\"vm.form.steuerdatenGeprueft\"></dv-error-messages> </label> </div> </dv-input-container> </div> </div> </fieldset> <div class=\"row\" ng-if=\"vm.checkRechtsform('GENOSSENSCHAFT') || vm.checkRechtsform('ANDERE_KOERPERSCHAFT') || vm.checkRechtsform('MEHRPERSONENGESELLSCHAFT')\"> <div class=\"dv-input-container-medium\"> <div class=\"form-group\"> <div class=\"col-sm-12\"> <h2 class=\"marginTop0 h2-gesuchsteller\"> <span class=\"h2-prefix\" ng-if=\"vm.showTitlePrefix()\">{{vm.model.eigentumsverhaeltnis | translate}}</span> <span data-translate=\"KONTAKTANGABEN_TITLE\"></span> </h2> </div> <div class=\"col-sm-12\"> <dv-kontakt-person dont-show-adresse=\"true\" email-not-required=\"vm.emailNotRequired\" dont-show-email=\"vm.emailNotRequired\" model=\"vm.model.kontaktperson\" name=\"{{vm.prefix}}-gesuchsteller\" phone-required=\"vm.phoneRequired\"></dv-kontakt-person> </div> </div> </div> </div> <div class=\"row\"> <div class=\"col-sm-12\" ng-if=\"vm.model.rechtsform && vm.needDokuments()\"> <h2 class=\"h2-gesuchsteller\"> <span class=\"h2-prefix\" ng-if=\"vm.showTitlePrefix()\">{{vm.model.eigentumsverhaeltnis | translate}}</span> <span data-translate=\"BITTE_HOCHLADEN\"></span> </h2> <div class=\"col-sm-12\"> <li ng-repeat=\"dokumentNeeded in vm.dokumentNeededMap[vm.model.rechtsform]\"> <span class=\"md-no-float\" ng-bind=\"dokumentNeeded[0] | translate\"></span> <span class=\"md-no-float\" ng-if=\"dokumentNeeded[1]\">({{'REQUIRED' | translate }})</span> <span class=\"md-no-float\" ng-if=\"!dokumentNeeded[1]\">({{'OPTIONAL' | translate }})</span> </li> </div> <div class=\"col-sm-12 marginTop20\"> <dv-dokumentupload begleit-text=\"\" document-type=\"vm.doctype\" form-parent=\"vm.parentForm\" on-doc-added=\"vm.onDocAdded(document)\" on-doc-removed=\"vm.onDocRemoved(document)\" parentid=\"vm.getModel().id\" readonly=\"false\" required-docs=\"vm.countRequiredDocs()\" schadenfallid=\"vm.schadenfallId\"> </dv-dokumentupload> </div> </div> </div> </form> ";

/***/ }),

/***/ "uemi":
/***/ (function(module, exports) {

module.exports = "<div class=\"password-change row\"> <dv-benutzerprofil-view benutzer=\"vm.benutzerToEdit\" force-password-change=\"true\" no-email-entry=\"true\" phone-required=\"true\"> </dv-benutzerprofil-view> </div> ";

/***/ }),

/***/ "uh5A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSAuthEvent_1 = __webpack_require__("L0QB");
var template = __webpack_require__("HI9D");
__webpack_require__("A3+6");
var MenubarComponentConfig = /** @class */ (function () {
    function MenubarComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = MenuBarController;
        this.controllerAs = 'vm';
    }
    return MenubarComponentConfig;
}());
exports.MenubarComponentConfig = MenubarComponentConfig;
var MenuBarController = /** @class */ (function () {
    function MenuBarController(authServiceRS, $log, $rootScope, $state, roleUtilService, $translate) {
        this.authServiceRS = authServiceRS;
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.roleUtilService = roleUtilService;
        this.$translate = $translate;
        this.isNavOpen = false;
    }
    MenuBarController.prototype.$onInit = function () {
        var _this = this;
        this.$rootScope.$on(TSAuthEvent_1.TSAuthEvent[TSAuthEvent_1.TSAuthEvent.LOGIN_SUCCESS], function () {
            _this.displayName = _this.getCurrentUserName();
        });
        this.$rootScope.$on(TSAuthEvent_1.TSAuthEvent[TSAuthEvent_1.TSAuthEvent.LOGOUT_SUCCESS], function () {
            _this.displayName = undefined;
        });
    };
    MenuBarController.prototype.logout = function () {
        var _this = this;
        this.authServiceRS.logoutRequest().then(function () {
            _this.$log.debug('logout successfull');
            _this.$state.go('start'); // going back to start should show us the login form
        });
    };
    MenuBarController.prototype.isLoggedIn = function () {
        if (this.$state.current.name === 'login'
            || this.$state.current.name === 'loginanlaufstelle'
            || this.$state.current.name === 'locallogin') {
            return false;
        }
        return this.authServiceRS.getPrincipal() !== undefined && this.authServiceRS.getPrincipal() !== null;
    };
    MenuBarController.prototype.getCurrentUserName = function () {
        var principal = this.authServiceRS.getPrincipal();
        if (principal) {
            return principal.getFullName();
        }
        return undefined;
    };
    MenuBarController.prototype.changeLang = function (langstring) {
        this.$translate.use(langstring);
    };
    MenuBarController.prototype.getCurrentLang = function () {
        return this.$translate.use();
    };
    MenuBarController.prototype.isLangActive = function (lang) {
        return this.getCurrentLang() === lang;
    };
    MenuBarController.$inject = ['AuthServiceRS', '$log', '$rootScope', '$state', 'RoleUtilService', '$translate'];
    return MenuBarController;
}());
exports.MenuBarController = MenuBarController;


/***/ }),

/***/ "urnA":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "uuxi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Code from Kita-Projekt, den wir in Typescript geschrieben haben
 * Adapted from https://github.com/witoldsz/angular-http-auth
 */
var HttpBuffer = /** @class */ (function () {
    function HttpBuffer($injector) {
        this.$injector = $injector;
        /** Holds all the requests, so they can be re-requested in future. */
        this.buffer = [];
    }
    HttpBuffer.prototype.retryHttpRequest = function (config, deferred) {
        function successCallback(response) {
            deferred.resolve(response);
        }
        function errorCallback(response) {
            deferred.reject(response);
        }
        this.$http = this.$http || this.$injector.get('$http');
        this.$http(config).then(successCallback, errorCallback);
    };
    /**
     * Appends HTTP request configuration object with deferred response attached to buffer.
     */
    HttpBuffer.prototype.append = function (config, deferred) {
        this.buffer.push({
            config: config,
            deferred: deferred
        });
    };
    /**
     * Abandon or reject (if reason provided) all the buffered requests.
     */
    HttpBuffer.prototype.rejectAll = function (reason) {
        if (reason) {
            for (var i = 0; i < this.buffer.length; ++i) {
                this.buffer[i].deferred.reject(reason);
            }
        }
        this.buffer = [];
    };
    /**
     * Retries all the buffered requests clears the buffer.
     */
    HttpBuffer.prototype.retryAll = function (updater) {
        for (var i = 0; i < this.buffer.length; ++i) {
            this.retryHttpRequest(updater(this.buffer[i].config), this.buffer[i].deferred);
        }
        this.buffer = [];
    };
    HttpBuffer.$inject = ['$injector'];
    return HttpBuffer;
}());
exports.default = HttpBuffer;


/***/ }),

/***/ "uvcM":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".schadenevents{margin-top:20px;display:flex;align-items:center;justify-content:center}.mainbuttons{margin-top:8rem}.mainbuttons,.mainbuttons-freigeben{display:flex;align-items:center;justify-content:center;width:50%;margin-left:auto;margin-right:auto}.mainbuttons-freigeben>div,.mainbuttons>div{display:inline-block;margin-left:10px;margin-right:10px}.checklist{width:80%;background-color:#bc2500;position:relative;display:table;margin-left:auto;margin-right:auto}.checklist .h2{margin-left:40px;color:#f0f0f0}.checklist .h2:after{border:none}.checklist li{color:#f0f0f0;margin-left:40px}.checklist li span{color:#f0f0f0}.checklist label input[type=checkbox]{color:#f0f0f0;margin-left:40px}.checklist label input[type=checkbox]+span{color:#f0f0f0}.checklist .checkbox label input[type=checkbox]+span{margin-left:40px}.checklist .checkbox label input[type=checkbox]+span:before{border-color:#f0f0f0;background:#bc2500}.checklist .dv-alert-box--input-alert.ng-active{margin-left:40px;background-color:#f0f0f0}.freigebenfs{position:absolute;left:15px;right:15px;background-color:#4b565c;height:210px;margin-bottom:-100px}.freigebenfs .radio label input[type=radio]+span{color:#f0f0f0}.freigebenfs .radio label input[type=radio]+span:before{border-color:#f0f0f0}.freigebenfs .radio label input[type=radio]:disabled+span{color:#9ca2a5}.freigebenfs .radio label input[type=radio]:disabled+span:before{border-color:#9ca2a5}.freigebenfs .btn[disabled]{color:#4b565c;background:#9ca2a5;border-color:#9ca2a5}.freigebenfs .btn-serf{color:#4b565c;background:#f0f0f0}.freigebenfs .btn-zurueck{color:#f0f0f0;background:#4b565c;border-color:#f0f0f0}@media(min-width:1025px){.checklist{width:800px}}", ""]);

// exports


/***/ }),

/***/ "v/cP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".cockpit-view .container{width:auto}.cockpit-view .container .cockpit-form{margin-left:50px}.cockpit-view .container .cockpit-charts{margin-top:50px}.cockpit-view .datum-berich-btn{margin-top:20px}", ""]);

// exports


/***/ }),

/***/ "vAzW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSWorkJob_1 = __importDefault(__webpack_require__("EVhI"));
/**
 * liest information ueber batch jobs aus
 */
var BatchJobRS = /** @class */ (function () {
    function BatchJobRS(http, REST_API, $log) {
        this.http = http;
        this.$log = $log;
        this.serviceURL = REST_API + "admin/batch";
    }
    BatchJobRS.prototype.getAllJobs = function () {
        return this.getInfo(this.serviceURL + "/jobs");
    };
    BatchJobRS.prototype.getBatchJobsOfUser = function () {
        return this.getInfo(this.serviceURL + "/userjobs/notokenrefresh");
    };
    BatchJobRS.prototype.getBatchJobInformation = function (executionId) {
        return this.getInfo(this.serviceURL + "/jobs/" + encodeURI(executionId));
    };
    BatchJobRS.prototype.getInfo = function (url) {
        var _this = this;
        return this.http.get(url).then(function (response) {
            if (response.data !== undefined) {
                _this.$log.debug('PARSING WorkJob REST  object', response.data);
                return TSWorkJob_1.default.deserializeArray(response.data.jobs);
            }
            else {
                return [];
            }
        });
    };
    BatchJobRS.$inject = ['$http', 'REST_API', '$log'];
    return BatchJobRS;
}());
exports.default = BatchJobRS;


/***/ }),

/***/ "vEoF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TSKantonCode;
(function (TSKantonCode) {
    TSKantonCode[TSKantonCode["ZH"] = 'ZH'] = "ZH";
    TSKantonCode[TSKantonCode["BE"] = 'BE'] = "BE";
    TSKantonCode[TSKantonCode["LU"] = 'LU'] = "LU";
    TSKantonCode[TSKantonCode["UR"] = 'UR'] = "UR";
    TSKantonCode[TSKantonCode["SZ"] = 'SZ'] = "SZ";
    TSKantonCode[TSKantonCode["OW"] = 'OW'] = "OW";
    TSKantonCode[TSKantonCode["NW"] = 'NW'] = "NW";
    TSKantonCode[TSKantonCode["GL"] = 'GL'] = "GL";
    TSKantonCode[TSKantonCode["ZG"] = 'ZG'] = "ZG";
    TSKantonCode[TSKantonCode["FR"] = 'FR'] = "FR";
    TSKantonCode[TSKantonCode["SO"] = 'SO'] = "SO";
    TSKantonCode[TSKantonCode["BS"] = 'BS'] = "BS";
    TSKantonCode[TSKantonCode["BL"] = 'BL'] = "BL";
    TSKantonCode[TSKantonCode["SH"] = 'SH'] = "SH";
    TSKantonCode[TSKantonCode["AR"] = 'AR'] = "AR";
    TSKantonCode[TSKantonCode["AI"] = 'AI'] = "AI";
    TSKantonCode[TSKantonCode["SG"] = 'SG'] = "SG";
    TSKantonCode[TSKantonCode["GR"] = 'GR'] = "GR";
    TSKantonCode[TSKantonCode["AG"] = 'AG'] = "AG";
    TSKantonCode[TSKantonCode["TG"] = 'TG'] = "TG";
    TSKantonCode[TSKantonCode["TI"] = 'TI'] = "TI";
    TSKantonCode[TSKantonCode["VD"] = 'VD'] = "VD";
    TSKantonCode[TSKantonCode["VS"] = 'VS'] = "VS";
    TSKantonCode[TSKantonCode["NE"] = 'NE'] = "NE";
    TSKantonCode[TSKantonCode["GE"] = 'GE'] = "GE";
    TSKantonCode[TSKantonCode["JU"] = 'JU'] = "JU";
    TSKantonCode[TSKantonCode["UNBEKANNT"] = 'UNBEKANNT'] = "UNBEKANNT";
})(TSKantonCode = exports.TSKantonCode || (exports.TSKantonCode = {}));
function getKantonCodeList() {
    return [
        TSKantonCode.ZH,
        TSKantonCode.BE,
        TSKantonCode.LU,
        TSKantonCode.UR,
        TSKantonCode.SZ,
        TSKantonCode.OW,
        TSKantonCode.NW,
        TSKantonCode.GL,
        TSKantonCode.ZG,
        TSKantonCode.FR,
        TSKantonCode.SO,
        TSKantonCode.BS,
        TSKantonCode.BL,
        TSKantonCode.SH,
        TSKantonCode.AR,
        TSKantonCode.AI,
        TSKantonCode.SG,
        TSKantonCode.GR,
        TSKantonCode.AG,
        TSKantonCode.TG,
        TSKantonCode.TI,
        TSKantonCode.VD,
        TSKantonCode.VS,
        TSKantonCode.NE,
        TSKantonCode.GE,
        TSKantonCode.JU,
    ];
}
exports.getKantonCodeList = getKantonCodeList;


/***/ }),

/***/ "vHmm":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("urnA");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./inspektoratverwaltung.module.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./inspektoratverwaltung.module.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vTTU":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "vWOL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(__webpack_require__("/jXN"));
__webpack_require__("fjOH");
var core_module_1 = __webpack_require__("u87A");
__webpack_require__("2EdY");
var benutzerverwaltung_route_1 = __webpack_require__("Qm3r");
var benutzerRegView_1 = __webpack_require__("6BF3");
var benutzerverwaltungAnlaufstelleView_1 = __webpack_require__("VPnH");
var benutzerEditAnlaufstelleView_1 = __webpack_require__("DlJU");
var benutzerListView_1 = __webpack_require__("kgXo");
var benutzerEditView_1 = __webpack_require__("PCJn");
var benutzerProfilView_1 = __webpack_require__("LSA/");
exports.SerfWebBenutzerverwaltung = angular.module('serfWeb.benutzerverwaltung', [core_module_1.SerfWebCore.name])
    .component('dvBenutzereditAnlaufstelleView', new benutzerEditAnlaufstelleView_1.BenutzerEditAnlaufstelleComponentConfig())
    .component('dvBenutzereditView', new benutzerEditView_1.BenutzerEditComponentConfig())
    .component('dvBenutzerListView', new benutzerListView_1.BenutzerListViewComponentConfig())
    .component('dvBenutzerverwaltungAnlaufstelleView', new benutzerverwaltungAnlaufstelleView_1.BenutzerverwaltungAnlaufstelleViewComponentConfig())
    .component('benutzerRegView', new benutzerRegView_1.BenutzerRegViewComponentConfig())
    .component('dvBenutzerprofilView', new benutzerProfilView_1.BenutzerProfilViewComponentConfig())
    .run(benutzerverwaltung_route_1.benutzerverwaltungRun);
exports.default = exports.SerfWebBenutzerverwaltung;


/***/ }),

/***/ "vWWF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var HttpErrorInterceptor_1 = __importDefault(__webpack_require__("tiG2"));
var ErrorService_1 = __importDefault(__webpack_require__("Gj8C"));
var dvb_error_messages_panel_1 = __webpack_require__("Hyp1");
var style = __webpack_require__("g6Z3");
/***
 * Modul fuer Errordarstellung
 * @type {angular.IModule}
 */
exports.DVBernErrors = angular.module('dvbAngular.errors', ['ui.bootstrap', 'ui.router', 'ngAnimate'])
    .service('ErrorService', ErrorService_1.default)
    .service('HttpErrorInterceptor', HttpErrorInterceptor_1.default)
    .component('dvbErrorMessagesPanel', new dvb_error_messages_panel_1.DvErrorMessagesPanelComponentConfig());


/***/ }),

/***/ "va1a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSRefreshEvent;
(function (TSRefreshEvent) {
    TSRefreshEvent[TSRefreshEvent["REFRESH_ST_TABLE"] = 'refreshDvStTable'] = "REFRESH_ST_TABLE";
})(TSRefreshEvent = exports.TSRefreshEvent || (exports.TSRefreshEvent = {}));


/***/ }),

/***/ "vl73":
/***/ (function(module, exports) {

module.exports = "<div class=\"start-view coreModule\"> <div class=\"row\"> <div class=\"col-sm-10 col-sm-offset-1\"> <h1>This is the generic start/landing page for the SERF application</h1> <p>From here you should be redirected to the starting page configured for yor role. In case that you are not redirected appropriately, please select the desired page from the menu</p> </div> </div> </div> ";

/***/ }),

/***/ "vn5p":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.dveigenleistungen .delete-row{text-decoration:line-through}.dveigenleistungen .stundenhinzufuegen{margin-top:23px}.dveigenleistungen .row-actions{width:50px}", ""]);

// exports


/***/ }),

/***/ "vom2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSRole_1 = __webpack_require__("MleR");
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var TSSchadenfallStatus_1 = __webpack_require__("CiKD");
var OverdueService = /** @class */ (function () {
    /* @ngInject */
    function OverdueService($log) {
        this.$log = $log;
        this._map = new Map();
        /*Overdue für Superadmin*/
        var overdueSuperadmin = new Map();
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overdueSuperadmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole_1.TSRole.SUPER_ADMIN, overdueSuperadmin);
        var overduefsAdmin = new Map();
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, true);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, true);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, true);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, true);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, true);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, true);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, true);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overduefsAdmin.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole_1.TSRole.FONDSSUISSE_ADMIN, overduefsAdmin);
        var overduefsSachbearbeiter = new Map();
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overduefsSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole_1.TSRole.FONDSSUISSE_SACHBEARBEITER, overduefsSachbearbeiter);
        var overdueAnlaufstelleSachbearbeiter = new Map();
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, true);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole_1.TSRole.ANLAUFSTELLE_SACHBEARBEITER, overdueAnlaufstelleSachbearbeiter);
        var overdueAnlaufstelleVerwalter = new Map();
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, true);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole_1.TSRole.ANLAUFSTELLE_VERWALTER, overdueAnlaufstelleVerwalter);
        var overdueAnlaufstelleSchaetzer = new Map();
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, true);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, true);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole_1.TSRole.ANLAUFSTELLE_SCHAETZER, overdueAnlaufstelleSchaetzer);
        var overdueKantonInspektor = new Map();
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overdueKantonInspektor.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole_1.TSRole.KANTON_INSPEKTOR, overdueKantonInspektor);
        var overdueKantonVerwalter = new Map();
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole_1.TSRole.KANTON_VERWALTER, overdueKantonVerwalter);
        var overdueBetroffener = new Map();
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IMPORTIERT, false);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU, true);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.NEU_PAPIER_FS, false);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.AUSZAHLUNG, false);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overdueBetroffener.set(TSSchadenfallStatus_1.TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole_1.TSRole.BETROFFENER, overdueBetroffener);
    }
    OverdueService.prototype.isOverdueVisibleForStatusAndRole = function (role, status) {
        if (role) {
            return this.getOverdue(role, status);
        }
        else {
            this.$log.warn('no role passed');
            return false;
        }
    };
    OverdueService.prototype.getOverdue = function (role, status) {
        if (role) {
            var overdueForRole = this._map.get(role);
            if (overdueForRole) {
                var o = overdueForRole.get(status);
                if (o) {
                    return o;
                }
                return false;
            }
            else {
                this.$log.error('no overdue definitions for role ' + role);
            }
        }
        return false;
    };
    OverdueService.$inject = ['$log'];
    return OverdueService;
}());
exports.default = OverdueService;


/***/ }),

/***/ "vui+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var OkCancelController_1 = __webpack_require__("r+7B");
var abstractModelManagerController_1 = __importDefault(__webpack_require__("S1yE"));
var TSDokumentType_1 = __webpack_require__("/gTe");
var TSKantonCode_1 = __webpack_require__("vEoF");
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
var template = __webpack_require__("z0jn");
var okCancelTemplate = __webpack_require__("CYbW");
__webpack_require__("D882");
var InspektoratViewComponentConfig = /** @class */ (function () {
    function InspektoratViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = InspektoratViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            inspektorat: '<'
        };
    }
    return InspektoratViewComponentConfig;
}());
exports.InspektoratViewComponentConfig = InspektoratViewComponentConfig;
var InspektoratViewController = /** @class */ (function (_super) {
    __extends(InspektoratViewController, _super);
    /* @ngInject */
    function InspektoratViewController(dvBernUtil, $q, $scope, $log, $state, inspektoratRS, passwordStrengthService, errorService, schadenfallModelManager, roleUtilService, authService, dvDialog) {
        var _this = _super.call(this, schadenfallModelManager, $scope, $state.current.name) || this;
        _this.dvBernUtil = dvBernUtil;
        _this.$q = $q;
        _this.$log = $log;
        _this.$state = $state;
        _this.inspektoratRS = inspektoratRS;
        _this.passwordStrengthService = passwordStrengthService;
        _this.errorService = errorService;
        _this.roleUtilService = roleUtilService;
        _this.authService = authService;
        _this.dvDialog = dvDialog;
        _this.createNew = true;
        _this.doctype = TSDokumentType_1.TSDocumentType.ANLAUFSTELLE_DOC;
        return _this;
        // super();
    }
    InspektoratViewController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        if (this.inspektorat.id) {
            this.createNew = false;
        }
        if (this.authService.isOneOfRoles(this.roleUtilService.getAdministratorRoles()) || this.inspektorat.verwalter === undefined) {
            this.disableVerwalterselection = false;
        }
        else {
            this.disableVerwalterselection = true;
        }
        this.initialModel = this.inspektorat;
        this.model = angular.copy(this.inspektorat);
    };
    InspektoratViewController.prototype.save = function () {
        var _this = this;
        if (this.isModelValid() && this.model) {
            this.inspektoratRS.createOrUpdate(this.model).then(function (response) {
                _this.$state.go('inspektoratverwaltung');
            });
        }
        else {
            this.$log.debug('Form was not valid');
        }
    };
    /**
     * Diese Methode prueft ob das Form valid ist. Sollte es nicht valid sein wird das erste fehlende Element gesucht
     * und fokusiert, damit der Benutzer nicht scrollen muss, um den Fehler zu finden.
     * Am Ende wird this.form.$valid zurueckgegeben
     */
    InspektoratViewController.prototype.isModelValid = function () {
        if (!this.form.$valid) {
            DVBernUtil_1.default.focusFirstInvalidInput();
        }
        return this.form.$valid;
    };
    InspektoratViewController.prototype.addAnlaufstelle = function () {
        if (this.anlaufstelleToAdd) {
            this.model.anlaufstellen.push(this.anlaufstelleToAdd);
        }
        this.anlaufstelleToAdd = undefined;
    };
    InspektoratViewController.prototype.deleteClicked = function (anlaufstelleToDelete, event) {
        var index = DVBernUtil_1.default.getIndexOfElementwithID(anlaufstelleToDelete, this.model.anlaufstellen);
        if (index > -1) {
            this.model.anlaufstellen.splice(index, 1);
        }
    };
    InspektoratViewController.prototype.cancel = function () {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('inspektoratverwaltung');
    };
    InspektoratViewController.prototype.kantonList = function () {
        return TSKantonCode_1.getKantonCodeList();
    };
    InspektoratViewController.prototype.translateKanton = function (kantonCode) {
        return TSKantonCode_1.TSKantonCode[kantonCode];
    };
    InspektoratViewController.prototype.getInspektoren = function () {
        return this.getModel().inspektoren;
    };
    InspektoratViewController.prototype.setInspektoren = function (collectionOfSB) {
        this.getModel().inspektoren = collectionOfSB;
    };
    InspektoratViewController.prototype.addInspektor = function () {
        if (this.inspektorToAdd) {
            this.getInspektoren().push(this.inspektorToAdd);
        }
        this.inspektorToAdd = undefined;
    };
    InspektoratViewController.prototype.removeInspektor = function (benutzer, event) {
        if (benutzer) {
            var arrWithoutEle = this.getInspektoren().filter(function (currentBen) { return currentBen !== benutzer; });
            this.setInspektoren(arrWithoutEle);
        }
    };
    InspektoratViewController.prototype.enableVerwalterselection = function () {
        var _this = this;
        var text = 'CONFIRM_VERWALTERCHANGE';
        this.dvDialog.showDialog(okCancelTemplate, OkCancelController_1.OkCancelController, { text: text })
            .then(function () {
            _this.disableVerwalterselection = false;
        })
            .catch(function () {
        });
    };
    InspektoratViewController.$inject = ['DVBernUtil', '$q', '$scope', '$log', '$state', 'InspektoratRS', 'PasswordStrengthService',
        'ErrorService', 'SchadenfallModelManager', 'RoleUtilService', 'AuthServiceRS', 'DvDialog'];
    return InspektoratViewController;
}(abstractModelManagerController_1.default));
exports.InspektoratViewController = InspektoratViewController;


/***/ }),

/***/ "vwnX":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("0OWN");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-bemerkung-erfassen.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./dv-bemerkung-erfassen.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vxUb":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("s8fB");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./authentication.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./authentication.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vzQ5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var template = __webpack_require__("AxEI");
__webpack_require__("cIbT");
var AnlaufstelleverwaltungViewComponentConfig = /** @class */ (function () {
    function AnlaufstelleverwaltungViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = AnlaufstelleverwaltungViewController;
        this.controllerAs = 'vm';
        this.bindings = {
            anlaufstellen: '<',
            vereinbarungMissing: '<' //eigentlich unused jetzt
        };
    }
    return AnlaufstelleverwaltungViewComponentConfig;
}());
exports.AnlaufstelleverwaltungViewComponentConfig = AnlaufstelleverwaltungViewComponentConfig;
var AnlaufstelleverwaltungViewController = /** @class */ (function () {
    /* @ngInject */
    function AnlaufstelleverwaltungViewController(anlaufstelleRS, $state, roleUtilService, $translate, applicationPropertyRS) {
        this.anlaufstelleRS = anlaufstelleRS;
        this.$state = $state;
        this.roleUtilService = roleUtilService;
        this.$translate = $translate;
        this.applicationPropertyRS = applicationPropertyRS;
        this.vereinbarungValid = 0;
    }
    AnlaufstelleverwaltungViewController.prototype.$onInit = function () {
        var _this = this;
        this.checkIfHasNeverHadVereinbarung();
        this.applicationPropertyRS.getVereinbarungValidYears().then(function (response) {
            _this.vereinbarungValid = response;
        });
    };
    AnlaufstelleverwaltungViewController.prototype.checkIfHasNeverHadVereinbarung = function () {
        if (this.anlaufstellen === null || this.anlaufstellen === undefined || this.anlaufstellen.length === 0) {
            return false;
        }
        else {
            var anlaufstellenWithoutVereinbarung = this.anlaufstellen.filter(function (anlaufstelle) { return anlaufstelle.vereinbarungAkzeptiert === undefined; });
            return anlaufstellenWithoutVereinbarung.length === this.anlaufstellen.length;
        }
    };
    AnlaufstelleverwaltungViewController.prototype.hasAnlaufstelleWithInvalidVereinbarung = function () {
        var _this = this;
        if (this.anlaufstellen === null || this.anlaufstellen === undefined || this.anlaufstellen.length === 0) {
            return false;
        }
        return this.anlaufstellen.filter(function (anlaufstelle) { return anlaufstelle.isInvalidVereinbarung(_this.vereinbarungValid); }).length !== 0;
    };
    AnlaufstelleverwaltungViewController.prototype.editAnlaufstelle = function (anlaufstelle, event) {
        var params;
        params = { createNew: false, anlaufstelleId: anlaufstelle.id, anlaufstelle: anlaufstelle };
        this.$state.go('anlaufstelle', params);
    };
    AnlaufstelleverwaltungViewController.prototype.addAnlaufstelle = function () {
        var params;
        params = { createNew: true, anlaufstelleId: '', anlaufstelle: undefined };
        this.$state.go('anlaufstelle', params);
    };
    AnlaufstelleverwaltungViewController.prototype.getVereinbarungText = function () {
        return this.$translate.instant('VEREINBARUNG_ABGELAUFEN_WARNUNG', undefined, undefined, 'none');
    };
    AnlaufstelleverwaltungViewController.prototype.getVereinbarungStep1Text = function () {
        var text = this.$translate.instant('VEREIBARUNG_STEP1_TEXT');
        console.log(text);
        return text;
    };
    AnlaufstelleverwaltungViewController.$inject = ['AnlaufstelleRS', '$state', 'RoleUtilService', '$translate', 'ApplicationPropertyRS'];
    return AnlaufstelleverwaltungViewController;
}());
exports.AnlaufstelleverwaltungViewController = AnlaufstelleverwaltungViewController;


/***/ }),

/***/ "w8D+":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("MeFL");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./fremdkostenView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./fremdkostenView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "wKwq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OkHtmlDialogController_1 = __webpack_require__("U0eN");
var template = __webpack_require__("pukv");
var okHtmlDialogTemplate = __webpack_require__("ncnt");
var TestpageViewComponentConfig = /** @class */ (function () {
    function TestpageViewComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = TestpageViewController;
        this.controllerAs = 'vm';
    }
    return TestpageViewComponentConfig;
}());
exports.TestpageViewComponentConfig = TestpageViewComponentConfig;
var TestpageViewController = /** @class */ (function () {
    /* @ngInject */
    function TestpageViewController(MAX_LENGTH, dvDialog) {
        this.dvDialog = dvDialog;
        this.length = MAX_LENGTH;
    }
    TestpageViewController.prototype.$onInit = function () {
        console.log('Version: ' + this.getVersion());
        console.log('buildtime: ' + this.getBuildtimestamp());
        console.log('env: ' + this.getClientenv());
    };
    TestpageViewController.prototype.openModal = function (title, text) {
        this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController_1.OkHtmlDialogController, {
            title: title,
            text: text
        }).then(function () {
            //do nothing
        });
    };
    TestpageViewController.prototype.getVersion = function () {
        return "2.7.0";
    };
    TestpageViewController.prototype.getBuildtimestamp = function () {
        return "2026-09-21T12:06:11.057Z";
    };
    TestpageViewController.prototype.getClientenv = function () {
        return "production";
    };
    TestpageViewController.prototype.sentrytest = function () {
        throw new Error('This is a sentry test SERF frontend');
    };
    TestpageViewController.$inject = ['MAX_LENGTH', 'DvDialog'];
    return TestpageViewController;
}());
exports.TestpageViewController = TestpageViewController;


/***/ }),

/***/ "wMVE":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "dv-schadenfaelle-list:focus{outline:none}.dateinputtable{float:left;width:50%;font-size:x-small;padding-left:1px;padding-right:1px;text-align:center}.setverantwortlicher{-webkit-appearance:none;-moz-appearance:none;border:none;padding:5px 0 0;height:30px;white-space:nowrap}", ""]);

// exports


/***/ }),

/***/ "wP+2":
/***/ (function(module, exports) {

module.exports = " <div class=\"dv-schaeden-list\"> <div class=\"table-responsive\"> <table st-table=\"displayedCollection\" st-safe-src=\"vm.schaeden\" st-delay=\"20\" class=\"table fixedtable table-hover\" id=\"{{vm.tableId}}\" title=\"{{vm.tableTitle}}\" dv-st-table-refresh> <thead> <tr id=\"header-row\"> <th class=\"row-schadend-objekt\" data-translate=\"SCHADEND_OBJEKT\"></th> <th class=\"row-genauer-ort\" data-translate=\"GENAUER_ORT\"></th> <th class=\"row-datum-stichtag\" data-translate=\"DATUM_STICHTAG\"></th> <th class=\"row-geschaetzte-kosten text-right\" data-translate=\"GESCHAETZTE_KOSTEN\"></th> <th class=\"row-actions\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"row in displayedCollection\" st-select-row=\"row\" st-select-mode=\"single\"> <td class=\"ellipsis\" title=\"{{row.schadenDatenFS.schadenObjekt}}\" ng-bind=\"row.schadenDatenFS.schadenObjekt | translate\"></td> <td class=\"ellipsis\" title=\"{{row.schadenDatenFS.ort}}\" ng-bind=\"row.schadenDatenFS.ort\"></td> <td class=\"ellipsis\" title=\"{{row.schadenDatenFS.schadendatum}}\" ng-bind=\"row.schadenDatenFS.schadendatum | amDateFormat : 'DD.MM.YYYY'\"></td> <td ng-if=\"row.schadenDatenFS.geschaetzteKosten\" class=\"ellipsis mono text-right\" title=\"{{row.schadenDatenFS.geschaetzteKosten | currency: 'CHF':0}}\"> <span>{{(row.schadenDatenFS.geschaetzteKosten | currency: 'CHF': 0) +\".-\"}}</span> </td> <td ng-if=\"!row.schadenDatenFS.geschaetzteKosten\" class=\"ellipsis mono text-right\" data-translate=\"NOCH_NICHT_GESCHAETZT\"> </td> <td ng-if=\"!vm.readonly\" class=\"clearfix\"> <button ng-click=\"vm.deleteClicked(row, $event)\" class=\"btn-link pull-right\"> <span class=\"fa fa-trash-o\" title=\"{{'DELETE' | translate}}\"></span> </button> <button ng-click=\"vm.editClicked(row, $event)\" class=\"btn-link pull-right\"> <span class=\"fa fa-edit\" title=\"{{'EDIT' | translate}}\"></span> </button> </td> <td ng-if=\"vm.readonly\" class=\"clearfix\"> <button ng-click=\"vm.editClicked(row, $event)\" class=\"btn-link pull-right\"> <span class=\"fa fa-eye\" title=\"{{'EDIT' | translate}}\"></span> </button> </td> </tr> <tr> </tr><tr ng-if=\"displayedCollection === undefined || displayedCollection.length === 0\"> <td colspan=\"{{vm.getColumnsNumber()}}\" class=\"empty-table\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> <tfoot ng-if=\"displayedCollection !== undefined && displayedCollection.length > 1\"> <tr class=\"tr-highlight\"> <td colspan=\"3\" data-translate=\"TOTAL\"></td> <td class=\"text-right mono\"> <span>{{(vm.calcTotalSchaden() | currency: 'CHF': 0) +\".-\"}}</span> </td> <td></td> </tr> </tfoot> </table> </div> </div> ";

/***/ }),

/***/ "wPJl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSBemerkungSichtbarkeit_1 = __webpack_require__("2uqJ");
var TSBenutzerBemerkung_1 = __importDefault(__webpack_require__("3/Vo"));
var TSTransitionBemerkung_1 = __importDefault(__webpack_require__("7eCW"));
var RemoveDialogController_1 = __webpack_require__("92sy");
var template = __webpack_require__("b+vT");
__webpack_require__("AwNx");
var removeDialogTemplate = __webpack_require__("YTLw");
var DVBemerkungListComponentConfig = /** @class */ (function () {
    function DVBemerkungListComponentConfig() {
        this.transclude = false;
        this.bindings = {
            systemBemerkungen: '=',
            benutzerBemerkungen: '=',
            transitionBemerkungen: '=',
            scopeToShow: '<',
            schadenfallId: '<',
            readonly: '<',
            disableSystemBemerkung: '<',
            disableTransitionBemerkung: '<',
            disableBenutzerBemerkung: '<',
        };
        this.template = template;
        this.controller = DVBemerkungListController;
        this.controllerAs = 'vm';
    }
    return DVBemerkungListComponentConfig;
}());
exports.DVBemerkungListComponentConfig = DVBemerkungListComponentConfig;
var DVBemerkungListController = /** @class */ (function () {
    /* @ngInject */
    function DVBemerkungListController($filter, $log, CONSTANTS, $scope, roleUtilService, $window, authServiceRS, dvDialog, schadenfallModelManager) {
        this.$filter = $filter;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.$scope = $scope;
        this.roleUtilService = roleUtilService;
        this.$window = $window;
        this.authServiceRS = authServiceRS;
        this.dvDialog = dvDialog;
        this.schadenfallModelManager = schadenfallModelManager;
        this.systemBemerkungen = [];
        this.benutzerBemerkungen = [];
        this.transitionBemerkungen = [];
        this.scopeToShow = [];
        this.allBemerkungen = []; //Liste die im Gui angezeigt wird
        this.selectedTabIds = [];
    }
    DVBemerkungListController.prototype.$onInit = function () {
        var _this = this;
        this.initView();
        this.$scope.$watchCollection(function () {
            return _this.benutzerBemerkungen;
        }, function (newValue, oldValue) {
            if ((newValue.length !== oldValue.length)) {
                _this.initView();
            }
        });
        this.$scope.$watchCollection(function () {
            return _this.systemBemerkungen;
        }, function (newValue, oldValue) {
            if ((newValue.length !== oldValue.length)) {
                _this.initView();
            }
        });
        this.$scope.$watchCollection(function () {
            return _this.transitionBemerkungen;
        }, function (newValue, oldValue) {
            if ((newValue.length !== oldValue.length)) {
                _this.initView();
            }
        });
        this.$scope.$watch(function () {
            return _this.disableTransitionBemerkung;
        }, function (newValue, oldValue) {
            if ((newValue !== oldValue)) {
                _this.initView();
            }
        });
        this.$scope.$watch(function () {
            return _this.disableSystemBemerkung;
        }, function (newValue, oldValue) {
            if ((newValue !== oldValue)) {
                _this.initView();
            }
        });
        this.$scope.$watch(function () {
            return _this.disableBenutzerBemerkung;
        }, function (newValue, oldValue) {
            if ((newValue !== oldValue)) {
                _this.initView();
            }
        });
    };
    DVBemerkungListController.prototype.initView = function () {
        var _this = this;
        // Bemerkungen zusammenführen
        this.allBemerkungen = [];
        if (!this.disableSystemBemerkung && this.systemBemerkungen && this.systemBemerkungen.length > 0) {
            this.allBemerkungen = this.allBemerkungen.concat(this.systemBemerkungen);
        }
        if (!this.disableBenutzerBemerkung && this.benutzerBemerkungen && this.benutzerBemerkungen.length > 0) {
            this.allBemerkungen = this.allBemerkungen.concat(this.benutzerBemerkungen);
        }
        if (!this.disableTransitionBemerkung && this.transitionBemerkungen && this.transitionBemerkungen.length > 0) {
            this.allBemerkungen = this.allBemerkungen.concat(this.transitionBemerkungen);
        }
        this.allBemerkungen = this.allBemerkungen.sort(function (n1, n2) {
            if (n1.timestampErstellt && n2.timestampErstellt) {
                if (n1.timestampErstellt > n2.timestampErstellt) {
                    return -1;
                }
                if (n1.timestampErstellt < n2.timestampErstellt) {
                    return 1;
                }
            }
            return 0;
        });
        if (this.scopeToShow && this.scopeToShow.length > 0) {
            this.allBemerkungen = this.allBemerkungen.filter(function (n1) {
                return _this.scopeToShow.indexOf(n1.getBemerkungScope()) > -1;
            });
        }
        // show two messages as default
        this.selectedTabIds = [];
        this.allBemerkungen.forEach(function (bm) { return _this.selectedTabIds.push(bm.id); });
    };
    DVBemerkungListController.prototype.getTSBemerkungSichtbarkeitValues = function () {
        return TSBemerkungSichtbarkeit_1.getTSBemerkungSichtbarkeitValues();
    };
    DVBemerkungListController.prototype.isSichtbarkeitVisible = function (sichtbarkeit) {
        if (sichtbarkeit === TSBemerkungSichtbarkeit_1.TSBemerkungSichtbarkeit.FONDSSUISSE) {
            return this.authServiceRS.isOneOfRoles(this.roleUtilService.getFondssuisseRoles());
        }
        return true;
    };
    DVBemerkungListController.prototype.isMine = function (bemerkung) {
        var principal = this.authServiceRS.getPrincipal();
        var besitzer = bemerkung.getBesitzer();
        if (besitzer && principal && principal.email) {
            return principal.email === besitzer.email;
        }
        return false;
    };
    DVBemerkungListController.prototype.isDeleteAllowed = function (bemerkung) {
        return bemerkung instanceof TSBenutzerBemerkung_1.default;
    };
    DVBemerkungListController.prototype.isInStatusALLE = function (status) {
        return status === TSBemerkungSichtbarkeit_1.TSBemerkungSichtbarkeit.ALLE;
    };
    DVBemerkungListController.prototype.deleteBemerkung = function (bemerkung, event) {
        var _this = this;
        this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController_1.RemoveDialogController, {
            text: '',
            title: 'BEMERKUNG_REMOVE',
        }).then(function () {
            _this.schadenfallModelManager.removeBemerkung(bemerkung, _this.schadenfallId);
            _this.initView();
        }).catch(function () {
        });
    };
    DVBemerkungListController.prototype.editBemerkung = function (bemerkung, event) {
        bemerkung.editMode = true;
    };
    DVBemerkungListController.prototype.saveBemerkung = function (bemerkung) {
        if (bemerkung && this.schadenfallId) {
            this.schadenfallModelManager.saveBemerkung(bemerkung, this.schadenfallId).then(function (schadResp) {
                bemerkung.editMode = false;
            });
        }
        else {
            this.$log.debug('bemerkung or schadenfallId was not found');
        }
    };
    DVBemerkungListController.prototype.displayScopeForType = function (message) {
        return !(message instanceof TSTransitionBemerkung_1.default);
    };
    DVBemerkungListController.$inject = ['$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', 'AuthServiceRS', 'DvDialog', 'SchadenfallModelManager'];
    return DVBemerkungListController;
}());
exports.DVBemerkungListController = DVBemerkungListController;


/***/ }),

/***/ "wU/Z":
/***/ (function(module, exports) {

module.exports = "<div> <dv-datepicker input-id=\"before\" name=\"before\" ng-model=\"before\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" class=\"dv-table__input dateinputtable\" placeholder=\"{{'VON' | translate}}\"> </dv-datepicker> <dv-datepicker input-id=\"after\" name=\"after\" ng-model=\"after\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" class=\"dv-table__input dateinputtable\" placeholder=\"{{'BIS' | translate}}\"> </dv-datepicker> </div> ";

/***/ }),

/***/ "wurJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DVMaxLength = /** @class */ (function () {
    /* @ngInject */
    function DVMaxLength(CONSTANTS) {
        var _this = this;
        this.restrict = 'A';
        this.require = 'ngModel';
        this.length = CONSTANTS.MAX_LENGTH;
        this.link = function (scope, element, attrs, ctrl) {
            if (!ctrl) {
                return;
            }
            ctrl.$validators.dvMaxLength = function (modelValue, viewValue) {
                return ctrl.$isEmpty(viewValue) || (viewValue.length <= _this.length);
            };
        };
    }
    DVMaxLength.factory = function () {
        var directive = function (CONSTANTS) { return new DVMaxLength(CONSTANTS); };
        directive.$inject = ['CONSTANTS'];
        return directive;
    };
    DVMaxLength.$inject = ['CONSTANTS'];
    return DVMaxLength;
}());
exports.default = DVMaxLength;


/***/ }),

/***/ "wvMN":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */", ""]);

// exports


/***/ }),

/***/ "xFtX":
/***/ (function(module, exports) {

module.exports = "<div class=\"password-change row\"> <div class=\"col-sm-10 col-sm-offset-1\"> <div class=\"row\"> <form name=\"vm.form\" role=\"form\" novalidate> <div class=\"col-sm-12\"> <div class=\"row text\"> <h1 translate=\"LOGIN_SET_NEW_PASSWORD_TITLE\"></h1> </div> <div class=\"row text marginTop20\" translate=\"LOGIN_SET_NEW_PASSWORD_TEXT\"></div> <dv-password-changer passworddata=\"vm.model\" class=\"marginTop20\"></dv-password-changer> </div> <div class=\"form-group row\"> <div class=\"offset-sm-0 col-sm-10\"> <button type=\"submit\" ng-click=\"vm.saveClicked()\" class=\"btn btn-primary text-uppercase\" translate=\"SAVE\"></button> </div> </div> </form> </div> </div> </div> ";

/***/ }),

/***/ "xPFQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSBerechtigung_1 = __webpack_require__("ErVO");
/**
 * Berechtigungsmap fuer alle Pages. Es gibt jeweils verschiedene maps fuer die verschiedenen Rollen in den verschiedenen status
 */
var TSBerechtigungInView = /** @class */ (function () {
    function TSBerechtigungInView(gesucherstellen, schaetzung, aufwaende, auszahlung, bemerkung, pageNames) {
        /** wurde mit FS-706 mit schaetzung: TSBerechtigung erweitert
         * siehe auch:
         * dv-gesuch-navigation.ts
         * Berechtigungsservice.ts
         */
        this._map = new Map();
        this._map.set(pageNames.GESUCHERSTELLEN, gesucherstellen);
        this._map.set(pageNames.SCHADENMELDUNG, gesucherstellen);
        this._map.set(pageNames.SCHAETZUNG, schaetzung);
        this._map.set(pageNames.EIGENLEISTUNGEN, aufwaende);
        this._map.set(pageNames.VORLEISTUNG, aufwaende);
        this._map.set(pageNames.VORLEISTUNG, schaetzung);
        this._map.set(pageNames.FREMDKOSTEN, aufwaende);
        this._map.set(pageNames.FREMDKOSTEN, schaetzung);
        this._map.set(pageNames.AUFWAENDE, aufwaende);
        this._map.set(pageNames.BANKKONTO, aufwaende);
        this._map.set(pageNames.BEITRAG, auszahlung);
        this._map.set(pageNames.ENTSCHAEDIGUNG, auszahlung);
        this._map.set(pageNames.BEMERKUNG, bemerkung);
    }
    TSBerechtigungInView.prototype.getTSBerechtigung = function (pageName) {
        var tsBerechtigung = this._map.get(pageName);
        if (tsBerechtigung) {
            return tsBerechtigung;
        }
        else {
            console.debug('the passed page name has no known Berechtigung: ', pageName);
            return TSBerechtigung_1.TSBerechtigung.NO_ACCESS;
        }
    };
    return TSBerechtigungInView;
}());
exports.default = TSBerechtigungInView;


/***/ }),

/***/ "xQrf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "xUjB":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("AzNd");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./dv-benutzer-typeahead.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./dv-benutzer-typeahead.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "xdej":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("jXFx");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./admin.module.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./admin.module.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "xioF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSDokumentType_1 = __webpack_require__("/gTe");
var TSDownloadFile_1 = __importDefault(__webpack_require__("ZXnB"));
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
var DownloadRS = /** @class */ (function () {
    /* @ngInject */
    function DownloadRS($http, REST_API, $log, $window, $interval) {
        this.$window = $window;
        this.$interval = $interval;
        this.serviceURL = REST_API + 'blobs/temp';
        this.http = $http;
        this.log = $log;
    }
    DownloadRS.prototype.getAccessTokenDocumentById = function (documentId) {
        var _this = this;
        var url = this.serviceURL + '/dokument/' + encodeURIComponent(documentId);
        return this.http.get(url)
            .then(function (response) {
            _this.log.debug('PARSING DownloadFile REST object ', response.data);
            return new TSDownloadFile_1.default().deserialize(response.data);
        });
    };
    DownloadRS.prototype.getAccessTokenDocument = function (fallId, doctype, documentId, parentId) {
        var _this = this;
        //parentId is not always set > pass as query param
        var url = this.serviceURL + '/' + encodeURIComponent(fallId) + '/typ/'
            + encodeURIComponent(TSDokumentType_1.TSDocumentType[doctype]) + '/dokument/' + encodeURIComponent(documentId);
        if (parentId !== undefined) {
            url = url += '?parentId=' + parentId;
        }
        return this.http.get(url)
            .then(function (response) {
            _this.log.debug('PARSING DownloadFile REST object ', response.data);
            return new TSDownloadFile_1.default().deserialize(response.data);
        });
    };
    DownloadRS.prototype.getServiceName = function () {
        return 'DownloadRS';
    };
    /**
     *
     * @param accessToken
     * @param dokumentName
     * @param attachment
     * @param myWindow -> Das Window muss als Parameter mitgegeben werden, damit der Popup Blocker das Oeffnen dieses
     *         Fesnters nicht als Popup identifiziert.
     * @returns {boolean}
     */
    DownloadRS.prototype.startDownload = function (accessToken, dokumentName, attachment, myWindow) {
        if (myWindow) {
            var href = this.serviceURL + '/blobdata/' + accessToken;
            if (attachment) {
                // add MatrixParam for to download file instead of opening it inline
                href = href + ';attachment=true;';
            }
            else {
                myWindow.focus();
            }
            //as soon as the window is ready send it to the download
            this.redirectWindowToDownloadWhenReady(myWindow, href, accessToken);
            //This would be the way to open file in new window (for now it's better to open in new tab)
            //this.$window.open(href, name, 'toolbar=0,location=0,menubar=0');
        }
        else {
            this.log.error('Download popup window was not initialized');
        }
    };
    DownloadRS.prototype.prepareDownloadWindow = function () {
        return this.$window.open('./src/assets/downloadWindow/downloadWindow.html', DVBernUtil_1.default.generateRandomName(5));
    };
    DownloadRS.prototype.redirectWindowToDownloadWhenReady = function (win, href, name) {
        var _this = this;
        //wir pruefen den dokumentstatus alle 100ms, insgesamt maximal 300 mal
        var readyTimer = this.$interval(function () {
            if (win.document.readyState !== 'complete') {
                return;
            }
            _this.$interval.cancel(readyTimer);
            //do stuff
            _this.hideSpinner(win);
            _this.addCloseButtonHandler(win);
            win.open(href, win.name);
        }, 100, 300);
    };
    /**
     * Es kann sein, dass das popup noch gar nicht fertig gerendert ist bevor wir den spinner schon wieder verstecken
     * wollen in diesem fall warten wir noch bis das popup in den readyState 'conplete' wechselt und verstecken den
     * spinner dann
     */
    DownloadRS.prototype.hideSpinner = function (win) {
        this.log.debug('hiding spinner');
        var element = win.document.getElementById('spinnerCont');
        if (element) {
            element.style.display = 'none';
        }
        else {
            console.log('element not found, can not hide spinner');
        }
        var buttonElement = win.document.getElementById('closeButton');
        if (buttonElement) {
            buttonElement.style.display = 'block';
        }
    };
    DownloadRS.prototype.addCloseButtonHandler = function (win) {
        var element = win.document.getElementById('closeButton');
        if (element) {
            element.addEventListener('click', function () {
                win.close();
            }, false);
        }
        else {
            console.log('element not found, can not attach window close handler spinner');
        }
    };
    DownloadRS.$inject = ['$http', 'REST_API', '$log', '$window', '$interval'];
    return DownloadRS;
}());
exports.DownloadRS = DownloadRS;


/***/ }),

/***/ "xj3l":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */", ""]);

// exports


/***/ }),

/***/ "xmie":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
authenticationRun.$inject = ['RouterHelper'];
/* @ngInject */
function authenticationRun(routerHelper) {
    routerHelper.configureStates(getStates(), '/start');
}
exports.authenticationRun = authenticationRun;
function getStates() {
    return [
        new SerfLoginState(),
        new SerfLoginAnlaufstelleState(),
        new SerfVerifyState(),
        new SerfLocalLoginState(),
        new SerfPasswordResetState(),
        new SerfInvitedUserState(),
        new SerfPasswordChangeState(),
        new SerfStartState()
    ];
}
//STATES
var SerfLoginState = /** @class */ (function () {
    function SerfLoginState() {
        this.name = 'login';
        this.template = '<authentication-view>';
        //HINWEIS: Soweit ich sehen kann koennen url navigationen mit mehr als einem einzigen slash am Anfang nicht manuell in der Adressbar aufgerufen werden?
        this.url = '/login?type&relayPath&userID';
    }
    return SerfLoginState;
}());
exports.SerfLoginState = SerfLoginState;
var SerfLoginAnlaufstelleState = /** @class */ (function () {
    function SerfLoginAnlaufstelleState() {
        this.name = 'loginanlaufstelle';
        this.template = '<authentication-view mode="anlaufstellepruefer">';
        this.url = '/loginanlaufstelle?type&relayPath';
    }
    return SerfLoginAnlaufstelleState;
}());
exports.SerfLoginAnlaufstelleState = SerfLoginAnlaufstelleState;
var SerfVerifyState = /** @class */ (function () {
    function SerfVerifyState() {
        this.name = 'verify';
        this.template = '<verify-view>';
        this.url = '/verify?verifyBenutzer';
    }
    return SerfVerifyState;
}());
exports.SerfVerifyState = SerfVerifyState;
var SerfLocalLoginState = /** @class */ (function () {
    function SerfLocalLoginState() {
        this.name = 'locallogin';
        this.template = '<dummy-authentication-view flex="auto" class="overflow-scroll">';
        this.url = '/locallogin';
        this.resolve = {
            dummyLoginEnabled: readDummyLoginEnabled
        };
    }
    return SerfLocalLoginState;
}());
exports.SerfLocalLoginState = SerfLocalLoginState;
var SerfPasswordResetState = /** @class */ (function () {
    function SerfPasswordResetState() {
        this.name = 'passwordreset';
        this.template = '<password-reset-view>';
        this.url = '/passwordreset';
    }
    return SerfPasswordResetState;
}());
exports.SerfPasswordResetState = SerfPasswordResetState;
var SerfInvitedUserState = /** @class */ (function () {
    function SerfInvitedUserState() {
        this.name = 'inviteduser';
        this.template = '<invited-user-profile-view>';
        this.url = '/inviteduser?changetoken&email';
    }
    return SerfInvitedUserState;
}());
exports.SerfInvitedUserState = SerfInvitedUserState;
var SerfPasswordChangeState = /** @class */ (function () {
    function SerfPasswordChangeState() {
        this.name = 'change';
        this.template = '<password-change-view>';
        this.url = '/change?changetoken&email';
    }
    return SerfPasswordChangeState;
}());
exports.SerfPasswordChangeState = SerfPasswordChangeState;
var SerfStartState = /** @class */ (function () {
    function SerfStartState() {
        this.name = 'start';
        this.template = '<start-view>';
        this.url = '/start';
    }
    return SerfStartState;
}());
exports.SerfStartState = SerfStartState;
var IAuthenticationStateParams = /** @class */ (function () {
    function IAuthenticationStateParams() {
    }
    return IAuthenticationStateParams;
}());
exports.IAuthenticationStateParams = IAuthenticationStateParams;
//PARAMS
var IChangePasswordParams = /** @class */ (function () {
    function IChangePasswordParams() {
    }
    return IChangePasswordParams;
}());
exports.IChangePasswordParams = IChangePasswordParams;
var IVerfivyParams = /** @class */ (function () {
    function IVerfivyParams() {
    }
    return IVerfivyParams;
}());
exports.IVerfivyParams = IVerfivyParams;
readDummyLoginEnabled.$inject = ['ApplicationPropertyRS', '$state', '$q', '$log'];
/* @ngInject */
function readDummyLoginEnabled(applicationPropertyRS, $state, $q, $log) {
    return applicationPropertyRS.isDummyMode()
        .then(function (response) {
        if (response === false) {
            $log.debug('page is disabled');
            $state.go('start');
        }
        return response;
    }).catch(function () {
        var deferred = $q.defer();
        deferred.resolve(undefined);
        $state.go('login');
        return deferred.promise;
    });
}
exports.readDummyLoginEnabled = readDummyLoginEnabled;


/***/ }),

/***/ "xqA5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSLeistungsart_1 = __webpack_require__("LBP/");
var TSRole_1 = __webpack_require__("MleR");
var template = __webpack_require__("jqji");
__webpack_require__("BawY");
var DVFremdkostenListComponentConfig = /** @class */ (function () {
    function DVFremdkostenListComponentConfig() {
        this.transclude = false;
        this.bindings = {
            fremdkosten: '=',
            schadenfall: '<',
            onEdit: '&',
            onDelete: '&',
            readonly: '<',
            schaetzung: '<',
        };
        this.template = template;
        this.controller = DVFremdkostenListController;
        this.controllerAs = 'vm';
    }
    return DVFremdkostenListComponentConfig;
}());
exports.DVFremdkostenListComponentConfig = DVFremdkostenListComponentConfig;
var DVFremdkostenListController = /** @class */ (function () {
    /* @ngInject */
    function DVFremdkostenListController($filter, $log, CONSTANTS, $scope, roleUtilService, $window, $translate, $timeout, schadenfallModelManager) {
        this.$filter = $filter;
        this.$log = $log;
        this.CONSTANTS = CONSTANTS;
        this.$scope = $scope;
        this.roleUtilService = roleUtilService;
        this.$window = $window;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.schadenfallModelManager = schadenfallModelManager;
        this.colnumber = undefined;
        this.fremdkosten = []; //Liste die im Gui angezeigt wird
        this.initViewModel();
    }
    DVFremdkostenListController.prototype.initViewModel = function () {
    };
    DVFremdkostenListController.prototype.$onInit = function () {
        var _this = this;
        this.$timeout(function () {
            //can only initialize real value after view is stable (ng-ifs are done)
            _this.initColNumber();
        });
        this.calculateBerechtigterBetragForOldCases();
    };
    DVFremdkostenListController.prototype.calculateBerechtigterBetragForOldCases = function () {
        // the following calculation is for handling old cases, where Berechtigter Betrag belongs to each Fremdkosten, not to the Schadenfall
        if (this.schadenfall.berechtigterBetragFremdkosten === null || this.schadenfall.berechtigterBetragFremdkosten === 0) {
            this.schadenfall.berechtigterBetragFremdkosten = this.fremdkosten.reduce(function (accumulator, currentValue) { return accumulator + currentValue.fremdkostenDatenFS.berechtigterBetrag; }, 0);
        }
    };
    DVFremdkostenListController.prototype.calcTotalBetrag = function () {
        var total = 0;
        if (this.fremdkosten !== undefined) {
            try {
                for (var _a = __values(this.fremdkosten), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var obj = _b.value;
                    if (obj && obj.fremdkostenDatenFS && obj.fremdkostenDatenFS.rechnungsbetrag) {
                        total += obj.fremdkostenDatenFS.rechnungsbetrag;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return total;
        var e_1, _c;
    };
    DVFremdkostenListController.prototype.getFilterroles = function () {
        return this.roleUtilService.getAllRolesButGesuchstellerArray();
    };
    DVFremdkostenListController.prototype.editClicked = function (fremdkostenToEdit, event) {
        this.onEdit({ fremdkosten: fremdkostenToEdit, event: event });
    };
    DVFremdkostenListController.prototype.deleteClicked = function (fremdkostenToDelete, event) {
        this.onDelete({ fremdkosten: fremdkostenToDelete, event: event });
    };
    DVFremdkostenListController.prototype.translateAktiv = function (inaktiv) {
        return inaktiv ? (this.$translate.instant('INAKTIV')) : (this.$translate.instant('AKTIV'));
    };
    DVFremdkostenListController.prototype.translateRoles = function (roles) {
        var _this = this;
        var prefix = TSRole_1.rolePrefix();
        return roles.map(function (element) {
            return _this.$translate.instant(prefix + TSRole_1.TSRole[element]);
        }).join(', ');
    };
    DVFremdkostenListController.prototype.translateRole = function (role) {
        var prefix = TSRole_1.rolePrefix();
        return this.$translate.instant(prefix + TSRole_1.TSRole[role]);
    };
    DVFremdkostenListController.prototype.getColumnsNumber = function () {
        if (this.colnumber === undefined) {
            this.initColNumber();
        }
        return this.colnumber;
    };
    DVFremdkostenListController.prototype.initColNumber = function () {
        var element = angular.element('.dv-fremdkosten-list .header-row').first();
        if (element) {
            this.colnumber = element.get(0).childElementCount;
        }
        else {
            //coueld not determine actual number, just returing an approximation
            this.colnumber = 7;
        }
    };
    DVFremdkostenListController.prototype.translateLeistungsart = function (leistugnsart) {
        var translationKey = TSLeistungsart_1.leistungsartPrefix() + TSLeistungsart_1.TSLeistungsart[leistugnsart];
        return this.$translate.instant(translationKey);
    };
    DVFremdkostenListController.prototype.speichernGesuch = function () {
        if (this.schadenfall) {
            this.schadenfallModelManager.saveSchadenfall(this.schadenfall);
        }
    };
    DVFremdkostenListController.$inject = [
        '$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', '$translate',
        '$timeout', 'SchadenfallModelManager',
    ];
    return DVFremdkostenListController;
}());
exports.DVFremdkostenListController = DVFremdkostenListController;


/***/ }),

/***/ "xtsM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("/jXN");
__webpack_require__("SfIo");
var route_helper_provider_1 = __importDefault(__webpack_require__("tgNv"));
exports.default = angular.module('dvbAngular.router', [
    'ui.router'
]).provider('RouterHelper', route_helper_provider_1.default);


/***/ }),

/***/ "xwY2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DateUtil_1 = __importDefault(__webpack_require__("d4Zy"));
var TSEigenleistungArt_1 = __webpack_require__("EWa8");
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
var TSAbstractEntity_1 = __importDefault(__webpack_require__("Lr2U"));
var TSEigenleistungDaten = /** @class */ (function (_super) {
    __extends(TSEigenleistungDaten, _super);
    function TSEigenleistungDaten() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TSEigenleistungDaten.prototype, "displayName", {
        get: function () {
            var dispName;
            switch (this.eigenleistungArt) {
                case TSEigenleistungArt_1.TSEigenleistungArt.ANDERE:
                    dispName = this.description;
                    break;
                case TSEigenleistungArt_1.TSEigenleistungArt.HANDARBEIT:
                    dispName = this.vorname + ' ' + this.name + ' (' + this.jahrgang + ')';
                    break;
                default:
                    dispName = TSEigenleistungArt_1.eigenleistungPrefix() + this.eigenleistungArt;
                    break;
            }
            return dispName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistungDaten.prototype, "vorname", {
        get: function () {
            return this._vorname;
        },
        set: function (value) {
            this._vorname = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistungDaten.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistungDaten.prototype, "jahrgang", {
        get: function () {
            return this._jahrgang;
        },
        set: function (value) {
            this._jahrgang = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistungDaten.prototype, "description", {
        get: function () {
            return this._description;
        },
        set: function (value) {
            this._description = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistungDaten.prototype, "eigenleistungArt", {
        get: function () {
            return this._eigenleistungArt;
        },
        set: function (value) {
            this._eigenleistungArt = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistungDaten.prototype, "arbeitsstunden", {
        get: function () {
            return this._arbeitsstunden;
        },
        set: function (value) {
            this._arbeitsstunden = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistungDaten.prototype, "betrag", {
        get: function () {
            return this._betrag;
        },
        set: function (value) {
            this._betrag = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TSEigenleistungDaten.prototype, "datum", {
        get: function () {
            return this._datum;
        },
        set: function (value) {
            this._datum = value;
        },
        enumerable: true,
        configurable: true
    });
    TSEigenleistungDaten.prototype.deserialize = function (restObject) {
        _super.prototype.deserialize.call(this, restObject);
        this.vorname = restObject.vorname;
        this.name = restObject.name;
        this.jahrgang = restObject.jahrgang;
        this.description = restObject.description;
        this.eigenleistungArt = restObject.eigenleistungArt;
        this.arbeitsstunden = restObject.arbeitsstunden;
        this.betrag = restObject.betrag;
        this.datum = DateUtil_1.default.localDateToMoment(restObject.datum);
        return this;
    };
    TSEigenleistungDaten.prototype.serialize = function (restObject) {
        _super.prototype.serialize.call(this, restObject);
        restObject.vorname = this.vorname;
        restObject.name = this.name;
        restObject.jahrgang = this.jahrgang;
        restObject.description = this.description;
        restObject.eigenleistungArt = this.eigenleistungArt;
        restObject.arbeitsstunden = this.arbeitsstunden;
        restObject.betrag = this.betrag;
        if (this.datum) {
            restObject.datum = DateUtil_1.default.momentToLocalDate(this.datum);
        }
        return restObject;
    };
    TSEigenleistungDaten.prototype.isHolz = function () {
        return this.eigenleistungArt === TSEigenleistungArt_1.TSEigenleistungArt.HOLZ ||
            this.eigenleistungArt === TSEigenleistungArt_1.TSEigenleistungArt.HOLZ_AUF_PLATZ;
    };
    TSEigenleistungDaten.prototype.isTreibstoff = function () {
        return this.eigenleistungArt === TSEigenleistungArt_1.TSEigenleistungArt.TREIBSTOFF;
    };
    return TSEigenleistungDaten;
}(TSAbstractEntity_1.default));
exports.default = TSEigenleistungDaten;


/***/ }),

/***/ "yEyN":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("sXLq");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./entschaedigungView.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./entschaedigungView.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "yoYn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSSchaden_1 = __importDefault(__webpack_require__("k04f"));
var SchadenRS = /** @class */ (function () {
    /* @ngInject */
    function SchadenRS($http, REST_API, $log) {
        this.$log = $log;
        this.serviceURL = REST_API + 'schaden';
        this.http = $http;
    }
    SchadenRS.prototype.deleteSchaden = function (schadenfallId, schadenId) {
        return this.http.delete(this.serviceURL + '/deleteSchaden/' + encodeURIComponent(schadenfallId) + '/' + encodeURIComponent(schadenId), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    };
    SchadenRS.prototype.saveSchaden = function (schadenfallId, schaden) {
        var _this = this;
        var sentSchaden = {};
        sentSchaden = schaden.serialize(sentSchaden);
        this.$log.debug('sending Schaden:');
        this.$log.debug(sentSchaden);
        return this.http.post(this.serviceURL + '/saveSchaden/' + encodeURIComponent(schadenfallId), sentSchaden, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            _this.$log.debug('PARSING schaden REST array object', response.data);
            return new TSSchaden_1.default().deserialize(response.data);
        });
    };
    SchadenRS.$inject = ['$http', 'REST_API', '$log'];
    return SchadenRS;
}());
exports.default = SchadenRS;


/***/ }),

/***/ "z0jn":
/***/ (function(module, exports) {

module.exports = "<div class=\"inspektorat-view container\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <div class=\"dv-input-container-medium marginTop20\"> <div class=\"form-group row\"> <div class=\"col-sm-12\"> <h1> <span data-translate=\"NEUES_INSPEKTORAT\" ng-if=\"vm.createNew\"></span> <span data-translate=\"INSPEKTORAT_EDITIEREN\" ng-if=\"!vm.createNew\"></span> </h1> </div> <div class=\"col-sm-12\" dv-show-element dv-show-allowed-roles=\"vm.roleUtilService.getAdministratorRoles()\"> <dv-input-container> <div class=\"checkbox\"> <label> <input ng-true-value=\"false\" ng-false-value=\"true\" ng-model=\"vm.getModel().active\" type=\"checkbox\" name=\"active\" class=\"input-element\"> <span class=\"md-no-float\" data-translate=\"INSPEKTORAT_DEAKTIVIEREN\"></span> <dv-error-messages for=\"vm.form.active\"></dv-error-messages> </label> </div> </dv-input-container> </div> <dv-string-input model=\"vm.getModel().name\" name=\"name\" label=\"NAME_DES_INSPEKTORAT\" clazz=\"col-sm-6\"> </dv-string-input> <dv-string-input model=\"vm.getModel().abteilung\" name=\"abteilung\" label=\"ABTEILUNG\" clazz=\"col-sm-6\" ng-required=\"false\"> </dv-string-input> <div class=\"col-sm-12\"> <dv-adresse adresse=\"vm.getModel().adresse\" prefix=\"inspektorat_adresse\"></dv-adresse> </div> <div class=\"col-sm-6\"> <div class=\"form-group\"> <label data-translate=\"KANTON\" for=\"inspektoratKanton\"> </label> <select name=\"inspektoratKanton\" id=\"inspektoratKanton\" ng-model=\"vm.getModel().kanton\" class=\"form-control dv-table__input\" ng-options=\"vm.translateKanton(currKanton) for currKanton in vm.kantonList()\"> </select> </div> </div> <div class=\"col-sm-12\"> <h2> <span data-translate=\"VERANTWORTLICHE_PERSON\"></span> </h2> </div> <div class=\"col-sm-6\"> <dv-benutzer-typeahead selected-benutzer=\"vm.getModel().verwalter\" input-name=\"verwalterName\" input-placeholder=\"START_TYPING\" label=\"\" input-disabled=\"vm.disableVerwalterselection\" ng-required=\"true\"> </dv-benutzer-typeahead> </div> <div class=\"col-sm-6\" ng-if=\"vm.disableVerwalterselection\"> <button ng-click=\"vm.enableVerwalterselection()\" class=\"btn btn-serf-red add-button\" type=\"button\"> <i class=\"fa fa-pencil\" title=\"Verantwortliche Person anpassen\"></i> </button> </div> <fieldset class=\"col-sm-12\"> <div class=\"row\"> <div class=\"col-sm-12\"> <h2> <span data-translate=\"ANLAUFSTELLE_HINZUFUEGEN\"></span> </h2> </div> <div class=\"col-xs-8\"> <div class=\"gemeinde\"> <dv-anlaufstelle-typeahead selected-anlaufstelle=\"vm.anlaufstelleToAdd\" input-name=\"anlaufstellenSelect\" input-placeholder=\"START_TYPING\" label=\"\" ng-required=\"false\"> </dv-anlaufstelle-typeahead> </div> </div> <div class=\"col-xs-4\"> <button ng-click=\"vm.addAnlaufstelle()\" class=\"btn btn-serf-red add-button\" type=\"button\"> <i class=\"fa fa-plus\"></i> </button> </div> <div class=\"col-sm-12\"> <table st-table=\"displayedCollection\" st-safe-src=\"vm.getModel().anlaufstellen\" st-delay=\"20\" class=\"table fixedtable table-hover\" id=\"anlaufstellen\" title=\"anlaufstellen\" dv-st-table-refresh> <thead> <tr class=\"header-row\"> <th class=\"row-name\" data-translate=\"ANLAUFSTELLEN_FUER_INSPEKTORAT\"></th> <th class=\"row-actions\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"row in displayedCollection\" st-select-row=\"row\" st-select-mode=\"single\"> <td class=\"ellipsis\" title=\"{{row.name}}\" ng-bind=\"row.name\"></td> <td class=\"clearfix\"> <button ng-click=\"vm.deleteClicked(row, $event)\" class=\"btn-link pull-right\"> <span class=\"fa fa-trash-o\" title=\"{{'DELETE' | translate}}\"></span> </button> </td> </tr> <tr> </tr><tr ng-if=\"displayedCollection === undefined || displayedCollection.length === 0\"> <td colspan=\"2\" class=\"empty-table\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> <tfoot> </tfoot> </table> </div> </div> </fieldset> <div class=\"col-sm-12\"> <h2> <span data-translate=\"INSPEKTOREN_ZUTEILEN\"></span> </h2> </div> <div class=\"col-xs-8\"> <div class=\"gemeinde\"> <dv-benutzer-typeahead selected-benutzer=\"vm.inspektorToAdd\" input-name=\"inspektorName\" input-placeholder=\"START_TYPING\" label=\"\" ng-required=\"false\"> </dv-benutzer-typeahead> </div> </div> <div class=\"col-xs-4\"> <button ng-click=\"vm.addInspektor()\" class=\"btn btn-serf-red add-button\" type=\"button\"> <i class=\"fa fa-plus\"></i> </button> </div> <div class=\"col-sm-12\"> <dv-benutzer-list benutzerlist=\"vm.getInspektoren()\" show-role=\"false\" show-filter=\"false\" on-delete=\"vm.removeInspektor(benutzer, event)\"></dv-benutzer-list> </div> <div class=\"col-sm-12\"> <div class=\"row mainbuttons\"> <div class=\"col-sm-2 col-sm-offset-4\"> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.cancel()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> <div class=\"col-sm-2\"> <dv-loading-button type=\"submit\" button-click=\"vm.save()\" button-class=\"btn btn-serf\"> <span data-translate=\"SAVE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </div> </div> </div> </div> </form> </div> ";

/***/ }),

/***/ "z6rp":
/***/ (function(module, exports) {

module.exports = "<div class=\"table-responsive dv-schadenfaelle-list\" ng-class=\"vm.getClass()\"> <button class=\"btn btn-xs btn-serf-red\" ng-click=\"vm.resetFilter()\" ng-disabled=\"!vm.showResetFilter\" type=\"button\"> <span class=\"fa fa-sync btn-ico\"></span> <span data-translate=\"FILTER_ZURUECKSETZEN\"></span> </button> <table class=\"table fixedtable table-hover\" dv-schadenfaelle-list-persist=\"{{'st-table-'+vm.tabindex}}\" dv-st-table-refresh id=\"st-table-{{vm.tabindex}}\" st-delay=\"20\" st-pipe=\"vm.callServer\" st-table=\"vm.displayedCollection\" title=\"{{vm.tableTitle}}\"> <thead> <tr class=\"header-row\" dv-show-allowed-roles=\"vm.roleUtilService.getAllRolesButGesuchsteller()\" dv-show-element> <th class=\"sortable row-fallnr\" data-translate=\"FALL\" st-sort=\"fallNummer\"></th> <th class=\"sortable row-gesuchstellerName\" data-translate=\"GESUCHSTELLER\" dv-show-allowed-roles=\"vm.roleUtilService.getAllRolesButGesuchsteller()\" dv-show-element st-sort=\"gesuchstellerName\"></th> <th class=\"sortable row-ereignis\" data-translate=\"EREIGNIS\" st-sort=\"ereignis\"></th> <th class=\"sortable row-ort\" data-translate=\"ORT\" st-sort=\"ort\"></th> <th class=\"sortable row-kanton\" data-translate=\"KANTON\" st-sort=\"kanton\"></th> <th class=\"sortable row-kosten\" data-translate=\"KOSTEN_GESCH\" st-sort=\"kosten\"></th> <th class=\"sortable row-datum\" data-translate=\"DATUM\" st-sort=\"ereignisdatum\"></th> <th class=\"sortable row-status\" data-translate=\"STATUS\" st-sort=\"status\"></th> <th class=\"sortable row-sprache\" data-translate=\"SPRACHE\" st-sort=\"sprache\"></th> <th class=\"sortable row-verantwortlicher\" data-translate=\"VERANTWORTLICHER\" dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\" dv-show-element dv-show-expression=\"vm.showVerantwortlicherFilter\" st-sort=\"verantwortlicher\"></th> <th class=\"row-icon\" dv-show-allowed-roles=\"vm.roleUtilService.getAllowedToDeleteSchadenfallRoles()\" dv-show-element></th> <th class=\"row-icon\" dv-show-allowed-roles=\"vm.roleUtilService.getAllowedToDeleteSchadenfallRoles()\" dv-show-element></th> </tr> <tr class=\"single-header header-row\" dv-show-allowed-roles=\"vm.roleUtilService.getGesuchstellerOnlyRoles()\" dv-show-element> <th class=\"sortable row-fallnr\" data-translate=\"FALL\" st-sort=\"fallNummer\"></th> <th class=\"sortable row-ereignis\" data-translate=\"EREIGNIS\" st-sort=\"ereignis\"></th> <th class=\"sortable row-ort\" data-translate=\"ORT\" st-sort=\"ort\"></th> <th class=\"sortable row-datum\" data-translate=\"DATUM\" st-sort=\"ereignisdatum\"></th> <th class=\"sortable row-status\" data-translate=\"STATUS\" st-sort=\"status\"></th> <th class=\"row-deckblatt\" data-translate=\"DECKBLATT\"></th> <th class=\"row-delete\" data-translate=\"DELETE\"></th> </tr> <tr dv-show-allowed-roles=\"vm.roleUtilService.getAllRolesButGesuchsteller()\" dv-show-element> <th><input class=\"form-control dv-table__input\" max=\"999999\" ng-model=\"vm.selectedFallNummer\" st-search=\"fallNummer\" type=\"text\"/></th> <th dv-show-allowed-roles=\"vm.roleUtilService.getAllRolesButGesuchsteller()\" dv-show-element> <input class=\"form-control dv-table__input\" ng-model=\"vm.selectedGesuchstellerName\" st-search=\"gesuchstellerName\" type=\"text\"/> </th> <th><input class=\"form-control dv-table__input\" ng-model=\"vm.selectedEreignis\" st-search=\"ereignis\" type=\"text\"/></th> <th><input class=\"form-control dv-table__input\" ng-model=\"vm.selectedOrt\" st-search=\"ort\" type=\"text\"/></th> <th> <div class=\"dv-select-style\"> <select class=\"form-control dv-table__input\" id=\"kanton\" name=\"kanton\" ng-model=\"vm.selectedKanton\" ng-options=\"kanton.code.toString() for kanton in vm.getKantone() track by kanton.code\" st-input-event=\"change\" st-search=\"kanton\"> <option value=\"\">{{\"ALLE\" | translate}}</option> </select> </div> </th> <th> <input class=\"form-control dv-table__input dateinputtable\" ng-model=\"vm.selectedKostenVon\" placeholder=\"{{'VON' | translate}}\" st-search=\"kostenVon\" type=\"number\"/> <input class=\"form-control dv-table__input dateinputtable\" ng-model=\"vm.selectedKostenBis\" placeholder=\"{{'BIS' | translate}}\" st-search=\"kostenBis\" type=\"number\"/> </th> <th> <div> <input class=\"form-control dv-table__input dateinputtable\" ng-model=\"vm.selectedGesuchsdatumVon\" placeholder=\"{{'VON' | translate}}\" st-search=\"gesuchsdatumVon\" type=\"text\"/> <input class=\"form-control dv-table__input dateinputtable\" ng-model=\"vm.selectedGesuchsdatumBis\" placeholder=\"{{'BIS' | translate}}\" st-search=\"gesuchsdatumBis\" type=\"text\"/> </div> </th> <th> <div class=\"dv-select-style\"> <select class=\"form-control dv-table__input\" id=\"status\" name=\"status\" ng-model=\"vm.selectedStatus\" ng-options=\"status | translate for status in vm.getSchadenfaelleStatus() track by status\" st-input-event=\"change\" st-search=\"status\"> <option value=\"\">{{\"ALLE\" | translate}}</option> </select> </div> </th> <th> <div class=\"dv-select-style\"> <select class=\"form-control dv-table__input\" id=\"korrespondenzsprache\" name=\"korrespondenzsprache\" ng-model=\"vm.selectedSprache\" ng-options=\"vm.translateTSSpracheShort(korrespondenzsprache) for korrespondenzsprache in vm.getTSSpracheValues() track by korrespondenzsprache\" st-input-event=\"change\" st-search=\"korrespondenzsprache\"> <option value=\"\">{{\"ALLE\" | translate}}</option> </select> </div> </th> <th dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\" dv-show-element dv-show-expression=\"vm.showVerantwortlicherFilter\"> <div class=\"dv-select-style\"> <select class=\"form-control dv-table__input\" name=\"verantwortlicherSelect\" ng-model=\"vm.selectedVerantworlticher\" ng-options=\"benutzer.email as benutzer.getFullName() for benutzer in vm.verantwortlicheForFilter track by benutzer.email\" st-input-event=\"change\" st-search=\"verantwortlicher\"> <option value=\"\">{{\"ALLE\" | translate}}</option> </select> </div> </th> </tr> </thead> <tbody> <tr ng-class=\"{danger:vm.shouldHighlightOverdueSchadenfall(row), info:vm.shouldHighlightIsNeuInStatusSchadenfall(row)}\" ng-click=\"vm.editClicked(row, $event)\" ng-repeat=\"row in vm.displayedCollection\" st-select-mode=\"single\" st-select-row=\"row\"> <td class=\"ellipsis\" ng-bind=\"row.getFallnummerWithZeros()\" title=\"{{row.getFallnummerWithZeros()}}\"></td> <td class=\"ellipsis\" dv-show-allowed-roles=\"vm.roleUtilService.getAllRolesButGesuchsteller()\" dv-show-element ng-bind=\"row.gesuchstellerName\" title=\"{{row.gesuchstellerName}}\"></td> <td class=\"ellipsis\" ng-bind=\"row.ereignis\" title=\"{{row.ereignis}}\"></td> <td class=\"ellipsis\" ng-bind=\"row.ort\" title=\"{{row.ort}}\"></td> <td class=\"ellipsis\" dv-show-allowed-roles=\"vm.roleUtilService.getAllRolesButGesuchsteller()\" dv-show-element ng-bind=\"row.kanton\" title=\"{{row.kanton | translate}}\"></td> <td class=\"ellipsis mono text-right\" dv-show-allowed-roles=\"vm.roleUtilService.getAllRolesButGesuchsteller()\" dv-show-element title=\"{{row.totalSchaetzung | currency: 'CHF':0}}\"> <span>{{(row.totalSchaetzung | currency: '': 0) + \".-\"}}</span> </td> <td class=\"ellipsis\" ng-bind=\"row.ereignisdatum | amDateFormat : 'DD.MM.YYYY'\" title=\"{{row.ereignisdatum | amDateFormat : 'DD.MM.YYYY'}}\"></td> <td class=\"ellipsis\" ng-bind=\"row.status  | translate\" title=\"{{row.status  | translate}}\"></td> <td class=\"ellipsis\" dv-show-allowed-roles=\"vm.roleUtilService.getAllRolesButGesuchsteller()\" dv-show-element ng-bind=\"vm.translateTSSpracheShort(row.korrespondenzsprache)\" title=\"{{vm.translateSprache(row.korrespondenzsprache)}}\"></td> <td class=\"ellipsis\" dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\" dv-show-element dv-show-expression=\"vm.showVerantwortlicherFilter && vm.changeVerantwortlicherEnabled\" ng-click=\"$event.stopPropagation();\" title=\"{{row.verantwortlicher}}\"> <select class=\"form-control setverantwortlicher\" name=\"setVerantwortlicher\" ng-change=\"vm.updateVerantwortlicher(row.schadenfallId, row.verantwortlicher)\" ng-model=\"row.verantwortlicher\" ng-options=\"benutzer.email as benutzer.getFullName() for benutzer in vm.getAlleVerantwortliche()\" title=\"{{row.verantwortlicher}}\"> <option value=\"\">{{vm.nichtZugeteiltMarker | translate}}</option> </select> </td> <td class=\"ellipsis\" dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\" dv-show-element dv-show-expression=\"vm.showVerantwortlicherFilter && !vm.changeVerantwortlicherEnabled\" ng-bind=\"vm.getVerantwortlicher(row.verantwortlicher)\" title=\"{{vm.getVerantwortlicher(row.verantwortlicher)}}\"></td> <td align=\"center\" class=\"clearfix\" dv-show-allowed-roles=\"vm.roleUtilService.getAllowedToDeleteSchadenfallRoles()\" dv-show-element> <button class=\"btn-link\" ng-click=\"vm.deckblattClicked(row, $event);$event.stopPropagation();\"> <span class=\"fa fa-download\" title=\"{{'DOWNLOAD_DECKBLATT' | translate}}\"></span> </button> </td> <td align=\"center\" class=\"clearfix\" dv-show-allowed-roles=\"vm.roleUtilService.getAllowedToDeleteSchadenfallRoles()\" dv-show-element> <button class=\"btn-link\" ng-click=\"vm.deleteSchadenfallClicked(row, $event);$event.stopPropagation();\" ng-if=\"vm.isInStatusNEU(row.status)\"> <span class=\"fa fa-trash\" title=\"{{'SCHADENFALL_LOESCHEN' | translate}}\"></span> </button> </td> </tr> <tr ng-if=\"vm.displayedCollection.length === 0\"> <td class=\"empty-table\" colspan=\"{{vm.getColumnsNumber()}}\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> <tfoot> <tr> <td class=\"text-center\" colspan=\"{{vm.getColumnsNumber()}}\"> <div st-displayed-pages=\"10\" st-items-by-page=\"30\" st-pagination=\"\" st-template=\"./src/assets/pagination.dv-schadenfaelle-list.html\"></div> </td> </tr> </tfoot> </table> </div> ";

/***/ }),

/***/ "zPZ8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TSVersicherungsbeitragStatus_1 = __webpack_require__("jJP+");
var TSVersicherungsbeitrag_1 = __importDefault(__webpack_require__("fGC3"));
var DVBernUtil_1 = __importDefault(__webpack_require__("UD8l"));
var styles = __webpack_require__("P/jU");
var template = __webpack_require__("gekR");
var DvVersicherungsbeitragBeitragComponentConfig = /** @class */ (function () {
    function DvVersicherungsbeitragBeitragComponentConfig() {
        this.transclude = false;
        this.template = template;
        this.controller = DvVersicherungsbeitragBeitragController;
        this.controllerAs = 'vm';
        this.bindings = {
            versicherungsbeitrag: '<',
            zahlungsauftrag: '<',
            beitragReadonly: '<',
            onBeitragSave: '&',
            onBeitragCancel: '&'
        };
        this.require = { parentForm: '?^form' };
    }
    return DvVersicherungsbeitragBeitragComponentConfig;
}());
exports.DvVersicherungsbeitragBeitragComponentConfig = DvVersicherungsbeitragBeitragComponentConfig;
var DvVersicherungsbeitragBeitragController = /** @class */ (function () {
    /* @ngInject */
    function DvVersicherungsbeitragBeitragController(dvBernUtil, $q, $scope, $translate, $log) {
        this.dvBernUtil = dvBernUtil;
        this.$q = $q;
        this.$scope = $scope;
        this.$translate = $translate;
        this.$log = $log;
    }
    DvVersicherungsbeitragBeitragController.prototype.$onInit = function () {
        var _this = this;
        if (!this.versicherungsbeitrag) {
            this.versicherungsbeitrag = new TSVersicherungsbeitrag_1.default();
            this.$log.warn('initialized versicherungsbeitrag to edit directly in view, should pass versicherungsbeitrag to edit along');
        }
        this.readonly = !TSVersicherungsbeitragStatus_1.isStatusInBearbeitung(this.versicherungsbeitrag.status);
        this.updateBeitrag();
        // wenn ermittelter schaden oder der beitrag selber aendert muessen wir neu berechnen
        this.$scope.$watch(function () {
            return _this.versicherungsbeitrag.ermittelterSchaden;
        }, function (newValue, oldValue) {
            _this.updateBeitrag();
        });
        this.$scope.$watch(function () {
            return _this.versicherungsbeitrag.beitrag;
        }, function (newValue, oldValue) {
            _this.updateBeitrag();
        });
    };
    DvVersicherungsbeitragBeitragController.prototype.updateBeitrag = function () {
        this.updateVorschlag();
        // vorschlag wird nur bei neuen versBeitr.beitrag gesetzt
        if (!this.readonly && this.versicherungsbeitrag.beitrag && this.versicherungsbeitrag.beitrag.isNew()) {
            this.versicherungsbeitrag.beitrag.beitrag = this.betragVorschlag;
        }
    };
    DvVersicherungsbeitragBeitragController.prototype.updateVorschlag = function () {
        this.prozentsatz = parseFloat(this.versicherungsbeitrag.versicherung.prozentsatz);
        var betragVorschl = parseFloat(this.versicherungsbeitrag.getAnrechenbarerSchaden(this.prozentsatz).toFixed(2));
        this.betragVorschlag = Math.max(betragVorschl, 0); //vorschlag kann nicht kleiner 0 sein
    };
    DvVersicherungsbeitragBeitragController.prototype.cancel = function () {
        if (angular.isFunction(this.onBeitragCancel)) {
            this.onBeitragCancel();
        }
        else {
            this.$log.warn('no cancel function was passed, doing nothing');
        }
    };
    DvVersicherungsbeitragBeitragController.prototype.save = function () {
        if (this.isModelValid()) {
            if (angular.isFunction(this.onBeitragSave())) {
                this.onBeitragSave();
            }
            else {
                this.$log.warn('no save function was passed, doing nothing');
            }
        }
        else {
            this.$log.warn('beitrag form is not valid');
        }
    };
    DvVersicherungsbeitragBeitragController.prototype.isModelValid = function () {
        if (!this.form.$valid) {
            DVBernUtil_1.default.focusFirstInvalidInput();
        }
        return this.form.$valid;
    };
    DvVersicherungsbeitragBeitragController.prototype.isBeitragReadonly = function () {
        return this.beitragReadonly;
    };
    DvVersicherungsbeitragBeitragController.$inject = ['DVBernUtil', '$q', '$scope', '$translate', '$log'];
    return DvVersicherungsbeitragBeitragController;
}());
exports.DvVersicherungsbeitragBeitragController = DvVersicherungsbeitragBeitragController;


/***/ }),

/***/ "zQEh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TSKulturart_1 = __webpack_require__("/fjL");
var TSSchadenArt_1 = __webpack_require__("fz+m");
var TSSchadenObjekt_1 = __webpack_require__("eUxz");
var MapController_1 = __webpack_require__("i9ei");
var mapTemplate = __webpack_require__("+Rne");
__webpack_require__("0YHJ");
var SchadenComponentConfig = /** @class */ (function () {
    function SchadenComponentConfig() {
        this.transclude = false;
        this.bindings = {
            schaden: '=',
            schadenfallId: '<',
            readonly: '<',
            showGeschaetztekosten: '<',
        };
        this.template = __webpack_require__("b2pk");
        this.controller = DvSchadenController;
        this.controllerAs = 'vm';
        this.require = { parentForm: '?^form' };
    }
    return SchadenComponentConfig;
}());
exports.SchadenComponentConfig = SchadenComponentConfig;
var DvSchadenController = /** @class */ (function () {
    /* @ngInject */
    function DvSchadenController(dvDialog, $log, schadenfallModelManager, $scope, $translate) {
        this.dvDialog = dvDialog;
        this.$log = $log;
        this.schadenfallModelManager = schadenfallModelManager;
        this.$scope = $scope;
        this.$translate = $translate;
        this.currentYear = new Date().getFullYear();
    }
    DvSchadenController.prototype.$onInit = function () {
        var _this = this;
        if (!this.schadenfallId) {
            console.warn('No schadenfallId!');
            var schadenfall = this.schadenfallModelManager.getSchadenfall();
            this.schadenfallId = schadenfall ? schadenfall.id : '';
        }
        /*Options for autocomplete*/
        this.options = {
            types: 'geocode',
            country: 'ch',
        };
        /*set marker position if autocomplete has changed*/
        this.$scope.$watch(function () {
            return _this.details;
        }, function (newValue, oldValue) {
            if ((newValue !== oldValue)) {
                _this.getModel().schadenDatenFS.mapLatitude = newValue.geometry.location.lat();
                _this.getModel().schadenDatenFS.mapLongitude = newValue.geometry.location.lng();
            }
        });
    };
    DvSchadenController.prototype.getModel = function () {
        return this.schaden;
    };
    DvSchadenController.prototype.getTSSchadenArtValues = function () {
        return TSSchadenArt_1.getTSSchadenArtValues();
    };
    DvSchadenController.prototype.getTSSchadenObjektValues = function () {
        return TSSchadenObjekt_1.getTSSchadenObjektValues();
    };
    DvSchadenController.prototype.getTSKulturartValues = function () {
        return TSKulturart_1.getTSKulturartValues();
    };
    DvSchadenController.prototype.showForSchadenObjekt = function (what) {
        var schaden = this.getModel();
        if (schaden) {
            return schaden.propertyExistsForSchadenObjektType(what);
        }
        return false;
    };
    DvSchadenController.prototype.addPosition = function () {
        var _this = this;
        var lat = '';
        var lon = '';
        var schaden = this.getModel();
        if (schaden && schaden.schadenDatenFS) {
            if (schaden.schadenDatenFS.mapLatitude) {
                lat = schaden.schadenDatenFS.mapLatitude.toString();
            }
            if (schaden.schadenDatenFS.mapLongitude) {
                lon = schaden.schadenDatenFS.mapLongitude.toString();
            }
            this.dvDialog.showMapDialog(mapTemplate, MapController_1.MapController, {
                lat: lat,
                lon: lon,
                readonly: this.readonly,
            }).then(function (response) {
                if (response) {
                    if (!_this.readonly && schaden && schaden.schadenDatenFS) {
                        schaden.schadenDatenFS.mapLatitude = response.lat;
                        schaden.schadenDatenFS.mapLongitude = response.lon;
                    }
                }
            }).catch(function () {
                // do nothing
            });
        }
    };
    DvSchadenController.prototype.getSchadenArtPrefix = function () {
        return TSSchadenArt_1.schadenartPrefix();
    };
    DvSchadenController.prototype.translateSchadenArt = function (art) {
        var prefix = this.getSchadenArtPrefix();
        return this.$translate.instant(prefix + TSSchadenArt_1.TSSchadenArt[art]);
    };
    DvSchadenController.prototype.translateKulturart = function (art) {
        var prefix = TSKulturart_1.kulturartPrefix();
        return this.$translate.instant(prefix + TSKulturart_1.TSKulturart[art]);
    };
    DvSchadenController.prototype.showAndere = function () {
        return this.getModel().schadenDatenFS.schadenArt === TSSchadenArt_1.TSSchadenArt.ANDERE;
    };
    DvSchadenController.prototype.isWald = function () {
        return this.getModel().schadenDatenFS.schadenObjekt === TSSchadenObjekt_1.TSSchadenObjektTyp.WALD;
    };
    DvSchadenController.$inject = ['DvDialog', '$log', 'SchadenfallModelManager', '$scope', '$translate', 'RoleUtilService'];
    return DvSchadenController;
}());
exports.DvSchadenController = DvSchadenController;


/***/ }),

/***/ "ztPi":
/***/ (function(module, exports) {

module.exports = " <div class=\"dv-eigenleistungen-list\"> <div class=\"table-responsive\"> <table class=\"table fixedtable table-hover\" dv-st-table-refresh id=\"{{vm.tableId}}\" st-delay=\"20\" st-safe-src=\"vm.eigenleistungen\" st-table=\"displayedCollection\" title=\"{{vm.tableTitle}}\"> <thead class=\"header-row\"> <tr> <th data-translate=\"BEZEICHNUNG\"> </th> <th data-translate=\"DATUM\" class=\"rowHeader-datum\" ng-if=\"!vm.schaetzung\"> </th> <th class=\"text-right rowHeader-anzahl\" data-translate=\"ANZAHL\"> </th> <th class=\"text-right rowHeader-betrag\" data-translate=\"BETRAG\"> </th> <th class=\"text-right rowHeader-berechtigterBetrag\"> <span dv-show-expression=\"!vm.schaetzung\" data-translate=\"EIGENLEISTUNG_BETRAG_BERECHTIGT\" dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\" dv-show-element> </span> </th> <th class=\"rowHeader-actions\"> </th> </tr> </thead> <tbody> <tr ng-repeat=\"row in displayedCollection\" st-select-mode=\"single\" st-select-row=\"row\"> <td class=\"ellipsis\" ng-bind=\"row.eigenleistungDatenFS.displayName | translate\" title=\"{{row.eigenleistungDatenFS.displayName}}\"> </td> <td class=\"ellipsis mono\" ng-if=\"!vm.schaetzung\" ng-bind=\"row.getDateRange()\" title=\"{{row.getDateRange()}}\"> </td> <td class=\"ellipsis mono text-right\" ng-bind=\"row.getArbeitsstundenTotal() | currency :'[h]':1\" ng-if=\"!row.isHolz() && !row.isTreibstoff()\" title=\"{{row.getArbeitsstundenTotal()}}\"> </td> <td class=\"ellipsis mono text-right\" ng-bind=\"row.getMengeTotal() | currency :'[m3]':1\" ng-if=\"row.isHolz()\" title=\"{{row.getMengeTotal()}}\"> </td> <td class=\"ellipsis mono text-right\" ng-bind=\"row.getMengeTotal() | currency :'[l]':1\" ng-if=\"row.isTreibstoff()\" title=\"{{row.getMengeTotal()}}\"> </td> <td class=\"ellipsis mono text-right\" ng-bind=\"row.getBetragTotal() | currency: 'CHF'\" title=\"{{row.getBetragTotal() | currency: 'CHF'}}\"> </td> <td></td> <td class=\"clearfix rowBody-actions\" ng-if=\"!vm.readonly\"> <button class=\"btn-link\" ng-click=\"vm.editClicked(row, $event)\"> <span class=\"fa fa-edit\" title=\"{{'EDIT' | translate}}\"></span> </button> <button class=\"btn-link\" ng-click=\"vm.deleteClicked(row, $event)\"> <span class=\"fa fa-trash-o\" title=\"{{'DELETE' | translate}}\"></span> </button> </td> <td class=\"clearfix rowBody-actions\" ng-if=\"vm.readonly\"> <button class=\"btn-link\" ng-click=\"vm.editClicked(row, $event)\"> <span class=\"fa fa-eye\" title=\"{{'VIEW' | translate}}\"></span> </button> </td> </tr> <tr ng-if=\"displayedCollection === undefined || displayedCollection.length === 0\"> <td class=\"empty-table\" colspan=\"{{vm.getColumnsNumber()}}\" data-translate=\"KEIN_EINTRAG\">...</td> </tr> </tbody> <tfoot> <tr class=\"tr-highlight\"> <td colspan=\"3\" data-translate=\"TOTAL\"></td> <td class=\"text-right mono\" ng-bind=\"vm.calcTotalEL() | currency: 'CHF'\"></td> <td class=\"text-right mono\"> <div dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\" dv-show-element dv-show-expression=\"!vm.schaetzung\"> <dv-input-container class=\"no-margin\"> <dv-valueinput allow-negative=\"false\" class=\"input-element bigger-font\" fixed-decimals=\"2\" float=\"true\" input-id=\"eigenleistungen_berechtigerbetrag_ID\" input-name=\"eigenleistungen_berechtigerbetrag\" name=\"eigenleistungen_berechtigerbetrag\" ng-model=\"vm.schadenfall.berechtigterBetragEigenleistungen\" ng-required=\"true\"> </dv-valueinput> </dv-input-container> </div> </td> <td colspan=\"1\"> <div dv-show-allowed-roles=\"vm.roleUtilService.getFondssuisseRoles()\" dv-show-element dv-show-expression=\"!vm.schaetzung\"> <dv-loading-button type=\"submit\" button-click=\"vm.speichernGesuch()\" button-class=\"btn btn-serf pull-right\"> <span data-translate=\"SAVE\" class=\"text-uppercase\"></span> </dv-loading-button> </div> </td> </tr> </tfoot> </table> </div> </div> ";

/***/ }),

/***/ "zv8m":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("n4cP");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./versicherungsbeitraege.module.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./versicherungsbeitraege.module.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ })

},["qqH2"]);


// WEBPACK FOOTER //
// main.62cf2188444d5bf7ba8a.bundle.js